webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('grafana.core', ['ngRoute']));


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_emitter__ = __webpack_require__(125);

var appEvents = new __WEBPACK_IMPORTED_MODULE_0__utils_emitter__["a" /* Emitter */]();
/* harmony default export */ __webpack_exports__["a"] = (appEvents);


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

var Settings = /** @class */ (function () {
    function Settings(options) {
        var defaults = {
            datasources: {},
            window_title_prefix: 'Grafana - ',
            panels: {},
            new_panel_title: 'Panel Title',
            playlist_timespan: '1m',
            unsaved_changes_warning: true,
            appSubUrl: '',
        };
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend(this, defaults, options);
    }
    return Settings;
}());
var bootData = window.grafanaBootData || { settings: {} };
var options = bootData.settings;
options.bootData = bootData;
var config = new Settings(options);
/* harmony default export */ __webpack_exports__["a"] = (config);


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export User */
/* unused harmony export ContextSrv */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contextSrv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_store__ = __webpack_require__(109);




var User = /** @class */ (function () {
    function User() {
        if (__WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].bootData.user) {
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.extend(this, __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].bootData.user);
        }
    }
    return User;
}());

var ContextSrv = /** @class */ (function () {
    function ContextSrv() {
        this.sidemenuSmallBreakpoint = false;
        this.sidemenu = __WEBPACK_IMPORTED_MODULE_3_app_core_store__["a" /* default */].getBool('grafana.sidemenu', true);
        if (!__WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].buildInfo) {
            __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].buildInfo = {};
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].bootData) {
            __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].bootData = { user: {}, settings: {} };
        }
        this.version = __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].buildInfo.version;
        this.user = new User();
        this.isSignedIn = this.user.isSignedIn;
        this.isGrafanaAdmin = this.user.isGrafanaAdmin;
        this.isEditor = this.hasRole('Editor') || this.hasRole('Admin');
    }
    ContextSrv.prototype.hasRole = function (role) {
        return this.user.orgRole === role;
    };
    ContextSrv.prototype.isGrafanaVisible = function () {
        return !!(document.visibilityState === undefined || document.visibilityState === 'visible');
    };
    ContextSrv.prototype.toggleSideMenu = function () {
        this.sidemenu = !this.sidemenu;
        __WEBPACK_IMPORTED_MODULE_3_app_core_store__["a" /* default */].set('grafana.sidemenu', this.sidemenu);
    };
    return ContextSrv;
}());

var contextSrv = new ContextSrv();

__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["a" /* default */].factory('contextSrv', function () {
    return contextSrv;
});


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RootStore_RootStore__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config__ = __webpack_require__(22);


var store;
function createStore(backendSrv) {
    store = __WEBPACK_IMPORTED_MODULE_0__RootStore_RootStore__["a" /* RootStore */].create({}, {
        backendSrv: backendSrv,
        navTree: __WEBPACK_IMPORTED_MODULE_1_app_core_config__["a" /* default */].bootData.navTree,
    });
    return store;
}


/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return permissionOptions; });
/* unused harmony export aclTypeValues */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return aclTypes; });
/* unused harmony export NewPermissionsItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermissionsStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PermissionsStoreItem__ = __webpack_require__(964);
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var permissionOptions = [
    { value: 1, label: 'View', description: 'Can view dashboards.' },
    { value: 2, label: 'Edit', description: 'Can add, edit and delete dashboards.' },
    {
        value: 4,
        label: 'Admin',
        description: 'Can add/remove permissions and can add, edit and delete dashboards.',
    },
];
var aclTypeValues = {
    GROUP: { value: 'Group', text: 'Team' },
    USER: { value: 'User', text: 'User' },
    VIEWER: { value: 'Viewer', text: 'Everyone With Viewer Role' },
    EDITOR: { value: 'Editor', text: 'Everyone With Editor Role' },
};
var aclTypes = Object.keys(aclTypeValues).map(function (item) { return aclTypeValues[item]; });
var defaultNewType = aclTypes[0].value;
var NewPermissionsItem = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('NewPermissionsItem', {
    type: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].enumeration(Object.keys(aclTypeValues).map(function (item) { return aclTypeValues[item].value; })), defaultNewType),
    userId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number),
    userLogin: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    userAvatarUrl: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    teamAvatarUrl: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    teamId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number),
    team: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    permission: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number, 1),
})
    .views(function (self) { return ({
    isValid: function () {
        switch (self.type) {
            case aclTypeValues.GROUP.value:
                return self.teamId && self.team;
            case aclTypeValues.USER.value:
                return !!self.userId && !!self.userLogin;
            case aclTypeValues.VIEWER.value:
            case aclTypeValues.EDITOR.value:
                return true;
            default:
                return false;
        }
    },
}); })
    .actions(function (self) { return ({
    setUser: function (userId, userLogin, userAvatarUrl) {
        self.userId = userId;
        self.userLogin = userLogin;
        self.userAvatarUrl = userAvatarUrl;
        self.teamId = null;
        self.team = null;
    },
    setTeam: function (teamId, team, teamAvatarUrl) {
        self.userId = null;
        self.userLogin = null;
        self.teamId = teamId;
        self.team = team;
        self.teamAvatarUrl = teamAvatarUrl;
    },
    setPermission: function (permission) {
        self.permission = permission;
    },
}); });
var PermissionsStore = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('PermissionsStore', {
    fetching: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean,
    isFolder: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean),
    dashboardId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number),
    items: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(__WEBPACK_IMPORTED_MODULE_1__PermissionsStoreItem__["a" /* PermissionsStoreItem */]), []),
    originalItems: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(__WEBPACK_IMPORTED_MODULE_1__PermissionsStoreItem__["a" /* PermissionsStoreItem */]), []),
    newType: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, defaultNewType),
    newItem: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(NewPermissionsItem),
    isAddPermissionsVisible: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean, false),
    isInRoot: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean),
})
    .views(function (self) { return ({
    isValid: function (item) {
        var dupe = self.items.find(function (it) {
            return isDuplicate(it, item);
        });
        if (dupe) {
            return false;
        }
        return true;
    },
}); })
    .actions(function (self) {
    var resetNewTypeInternal = function () {
        self.newItem = NewPermissionsItem.create();
    };
    return {
        load: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function load(dashboardId, isFolder, isInRoot) {
            var backendSrv, res, items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        backendSrv = Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["getEnv"])(self).backendSrv;
                        self.fetching = true;
                        self.isFolder = isFolder;
                        self.isInRoot = isInRoot;
                        self.dashboardId = dashboardId;
                        self.items.clear();
                        return [4 /*yield*/, backendSrv.get("/api/dashboards/id/" + dashboardId + "/permissions")];
                    case 1:
                        res = _a.sent();
                        items = prepareServerResponse(res, dashboardId, isFolder, isInRoot);
                        self.items = items;
                        self.originalItems = items;
                        self.fetching = false;
                        return [2 /*return*/];
                }
            });
        }),
        addStoreItem: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function addStoreItem() {
            var item, updatedItems, newItem, sortedItems, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        item = {
                            type: self.newItem.type,
                            permission: self.newItem.permission,
                            dashboardId: self.dashboardId,
                            team: undefined,
                            teamId: undefined,
                            userLogin: undefined,
                            userId: undefined,
                            userAvatarUrl: undefined,
                            teamAvatarUrl: undefined,
                            role: undefined,
                        };
                        switch (self.newItem.type) {
                            case aclTypeValues.GROUP.value:
                                item.team = self.newItem.team;
                                item.teamId = self.newItem.teamId;
                                item.teamAvatarUrl = self.newItem.teamAvatarUrl;
                                break;
                            case aclTypeValues.USER.value:
                                item.userLogin = self.newItem.userLogin;
                                item.userId = self.newItem.userId;
                                item.userAvatarUrl = self.newItem.userAvatarUrl;
                                break;
                            case aclTypeValues.VIEWER.value:
                            case aclTypeValues.EDITOR.value:
                                item.role = self.newItem.type;
                                break;
                            default:
                                throw Error('Unknown type: ' + self.newItem.type);
                        }
                        updatedItems = self.items.peek();
                        newItem = prepareItem(item, self.dashboardId, self.isFolder, self.isInRoot);
                        updatedItems.push(newItem);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, updateItems(self, updatedItems)];
                    case 2:
                        _b.sent();
                        self.items.push(newItem);
                        sortedItems = self.items.sort(function (a, b) { return b.sortRank - a.sortRank || a.name.localeCompare(b.name); });
                        self.items = sortedItems;
                        resetNewTypeInternal();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, Promise.resolve()];
                    case 5:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }),
        removeStoreItem: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function removeStoreItem(idx) {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self.items.splice(idx, 1);
                        return [4 /*yield*/, updateItems(self, self.items.peek())];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }),
        updatePermissionOnIndex: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function updatePermissionOnIndex(idx, permission, permissionName) {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self.items[idx].updatePermission(permission, permissionName);
                        return [4 /*yield*/, updateItems(self, self.items.peek())];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }),
        setNewType: function (newType) {
            self.newItem = NewPermissionsItem.create({ type: newType });
        },
        resetNewType: function () {
            resetNewTypeInternal();
        },
        toggleAddPermissions: function () {
            self.isAddPermissionsVisible = !self.isAddPermissionsVisible;
        },
        hideAddPermissions: function () {
            self.isAddPermissionsVisible = false;
        },
    };
});
var updateItems = function (self, items) {
    var backendSrv = Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["getEnv"])(self).backendSrv;
    var updated = [];
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (item.inherited) {
            continue;
        }
        updated.push({
            id: item.id,
            userId: item.userId,
            teamId: item.teamId,
            role: item.role,
            permission: item.permission,
        });
    }
    return backendSrv.post("/api/dashboards/id/" + self.dashboardId + "/permissions", {
        items: updated,
    });
};
var prepareServerResponse = function (response, dashboardId, isFolder, isInRoot) {
    return response
        .map(function (item) {
        return prepareItem(item, dashboardId, isFolder, isInRoot);
    })
        .sort(function (a, b) { return b.sortRank - a.sortRank || a.name.localeCompare(b.name); });
};
var prepareItem = function (item, dashboardId, isFolder, isInRoot) {
    item.sortRank = 0;
    if (item.userId > 0) {
        item.name = item.userLogin;
        item.sortRank = 10;
    }
    else if (item.teamId > 0) {
        item.name = item.team;
        item.sortRank = 20;
    }
    else if (item.role) {
        item.icon = 'fa fa-fw fa-street-view';
        item.name = item.role;
        item.sortRank = 30;
        if (item.role === 'Editor') {
            item.sortRank += 1;
        }
    }
    if (item.inherited) {
        item.sortRank += 100;
    }
    return item;
};
var isDuplicate = function (origItem, newItem) {
    if (origItem.inherited) {
        return false;
    }
    return ((origItem.role && newItem.role && origItem.role === newItem.role) ||
        (origItem.userId && newItem.userId && origItem.userId === newItem.userId) ||
        (origItem.teamId && newItem.teamId && origItem.teamId === newItem.teamId));
};


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx__ = __webpack_require__(56);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var SelectNav = function (_a) {
    var main = _a.main, customCss = _a.customCss;
    var defaultSelectedItem = main.children.find(function (navItem) {
        return navItem.active === true;
    });
    var gotoUrl = function (evt) {
        var element = evt.target;
        var url = element.options[element.selectedIndex].value;
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('location-change', { href: url });
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form-select-wrapper width-20 " + customCss },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "gf-form-select-icon " + defaultSelectedItem.icon, htmlFor: "page-header-select-nav" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", { className: "gf-select-nav gf-form-input", value: defaultSelectedItem.url, onChange: gotoUrl, id: "page-header-select-nav" }, main.children.map(function (navItem) {
            if (navItem.hideFromTabs) {
                // TODO: Rename hideFromTabs => hideFromNav
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: navItem.url, value: navItem.url }, navItem.text));
        }))));
};
var Tabs = function (_a) {
    var main = _a.main, customCss = _a.customCss;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { className: "gf-tabs " + customCss }, main.children.map(function (tab, idx) {
        if (tab.hideFromTabs) {
            return null;
        }
        var tabClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
            'gf-tabs-link': true,
            active: tab.active,
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "gf-tabs-item", key: tab.url },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: tabClasses, target: tab.target, href: tab.url },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: tab.icon }),
                tab.text)));
    })));
};
var Navigation = function (_a) {
    var main = _a.main;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectNav, { customCss: "page-header__select-nav", main: main }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tabs, { customCss: "page-header__tabs", main: main })));
};
var PageHeader = /** @class */ (function (_super) {
    __extends(PageHeader, _super);
    function PageHeader(props) {
        return _super.call(this, props) || this;
    }
    PageHeader.prototype.shouldComponentUpdate = function () {
        //Hack to re-render on changed props from angular with the @observer decorator
        return true;
    };
    PageHeader.prototype.renderTitle = function (title, breadcrumbs) {
        if (!title && (!breadcrumbs || breadcrumbs.length === 0)) {
            return null;
        }
        if (!breadcrumbs || breadcrumbs.length === 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "page-header__title" }, title);
        }
        var breadcrumbsResult = [];
        for (var i = 0; i < breadcrumbs.length; i++) {
            var bc = breadcrumbs[i];
            if (bc.url) {
                breadcrumbsResult.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "text-link", key: i, href: bc.url }, bc.title));
            }
            else {
                breadcrumbsResult.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { key: i },
                    " / ",
                    bc.title));
            }
        }
        breadcrumbsResult.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { key: breadcrumbs.length + 1 },
            " / ",
            title));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "page-header__title" }, breadcrumbsResult);
    };
    PageHeader.prototype.renderHeaderTitle = function (main) {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-header__inner" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "page-header__logo" },
                main.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "page-header__icon " + main.icon }),
                main.img && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "page-header__img", src: main.img })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-header__info-block" },
                this.renderTitle(main.text, main.breadcrumbs),
                main.subTitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-header__sub-title" }, main.subTitle),
                main.subType && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-header__stamps" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: main.subType.icon }),
                    main.subType.text)))));
    };
    PageHeader.prototype.render = function () {
        var model = this.props.model;
        if (!model) {
            return null;
        }
        var main = Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(model.main); // Convert to JS if its a mobx observable
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-header-canvas" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-header" },
                    this.renderHeaderTitle(main),
                    main.children && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Navigation, { main: main })))));
    };
    PageHeader = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], PageHeader);
    return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (PageHeader);


/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PALETTE_ROWS */
/* unused harmony export PALETTE_COLUMNS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ANNOTATION_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OK_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERTING_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NO_DATA_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REGION_FILL_ALPHA; });
/* unused harmony export sortColorsByHue */
/* unused harmony export hexToHsl */
/* unused harmony export hslToHex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sortedColors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinycolor2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tinycolor2__);


var PALETTE_ROWS = 4;
var PALETTE_COLUMNS = 14;
var DEFAULT_ANNOTATION_COLOR = 'rgba(0, 211, 255, 1)';
var OK_COLOR = 'rgba(11, 237, 50, 1)';
var ALERTING_COLOR = 'rgba(237, 46, 24, 1)';
var NO_DATA_COLOR = 'rgba(150, 150, 150, 1)';
var REGION_FILL_ALPHA = 0.09;
var colors = [
    '#7EB26D',
    '#EAB839',
    '#6ED0E0',
    '#EF843C',
    '#E24D42',
    '#1F78C1',
    '#BA43A9',
    '#705DA0',
    '#508642',
    '#CCA300',
    '#447EBC',
    '#C15C17',
    '#890F02',
    '#0A437C',
    '#6D1F62',
    '#584477',
    '#B7DBAB',
    '#F4D598',
    '#70DBED',
    '#F9BA8F',
    '#F29191',
    '#82B5D8',
    '#E5A8E2',
    '#AEA2E0',
    '#629E51',
    '#E5AC0E',
    '#64B0C8',
    '#E0752D',
    '#BF1B00',
    '#0A50A1',
    '#962D82',
    '#614D93',
    '#9AC48A',
    '#F2C96D',
    '#65C5DB',
    '#F9934E',
    '#EA6460',
    '#5195CE',
    '#D683CE',
    '#806EB7',
    '#3F6833',
    '#967302',
    '#2F575E',
    '#99440A',
    '#58140C',
    '#052B51',
    '#511749',
    '#3F2B5B',
    '#E0F9D7',
    '#FCEACA',
    '#CFFAFF',
    '#F9E2D2',
    '#FCE2DE',
    '#BADFF4',
    '#F9D9F9',
    '#DEDAF7',
];
function sortColorsByHue(hexColors) {
    var hslColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(hexColors, hexToHsl);
    var sortedHSLColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(hslColors, ['h']);
    sortedHSLColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.chunk(sortedHSLColors, PALETTE_ROWS);
    sortedHSLColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(sortedHSLColors, function (chunk) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(chunk, 'l');
    });
    sortedHSLColors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flattenDeep(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.zip.apply(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a, sortedHSLColors));
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(sortedHSLColors, hslToHex);
}
function hexToHsl(color) {
    return __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default()(color).toHsl();
}
function hslToHex(color) {
    return __WEBPACK_IMPORTED_MODULE_1_tinycolor2___default()(color).toHexString();
}
var sortedColors = sortColorsByHue(colors);
/* harmony default export */ __webpack_exports__["f"] = (colors);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
var Store = /** @class */ (function () {
    function Store() {
    }
    Store.prototype.get = function (key) {
        return window.localStorage[key];
    };
    Store.prototype.set = function (key, value) {
        window.localStorage[key] = value;
    };
    Store.prototype.getBool = function (key, def) {
        if (def !== void 0 && !this.exists(key)) {
            return def;
        }
        return window.localStorage[key] === 'true';
    };
    Store.prototype.exists = function (key) {
        return window.localStorage[key] !== void 0;
    };
    Store.prototype.delete = function (key) {
        window.localStorage.removeItem(key);
    };
    return Store;
}());

var store = new Store();
/* harmony default export */ __webpack_exports__["a"] = (store);


/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Emitter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventemitter3__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventemitter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_eventemitter3__);

var Emitter = /** @class */ (function () {
    function Emitter() {
        this.emitter = new __WEBPACK_IMPORTED_MODULE_0_eventemitter3__["EventEmitter"]();
    }
    Emitter.prototype.emit = function (name, data) {
        this.emitter.emit(name, data);
    };
    Emitter.prototype.on = function (name, handler, scope) {
        var _this = this;
        this.emitter.on(name, handler);
        if (scope) {
            var unbind = scope.$on('$destroy', function () {
                _this.emitter.off(name, handler);
                unbind();
            });
        }
    };
    Emitter.prototype.removeAllListeners = function (evt) {
        this.emitter.removeAllListeners(evt);
    };
    Emitter.prototype.off = function (name, handler) {
        this.emitter.off(name, handler);
    };
    return Emitter;
}());



/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = updateLegendValues;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDataMinMax;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_utils_kbn__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_utils_ticks__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);



function matchSeriesOverride(aliasOrRegex, seriesAlias) {
    if (!aliasOrRegex) {
        return false;
    }
    if (aliasOrRegex[0] === '/') {
        var regex = __WEBPACK_IMPORTED_MODULE_0_app_core_utils_kbn__["a" /* default */].stringToJsRegex(aliasOrRegex);
        return seriesAlias.match(regex) != null;
    }
    return aliasOrRegex === seriesAlias;
}
function translateFillOption(fill) {
    return fill === 0 ? 0.001 : fill / 10;
}
/**
 * Calculate decimals for legend and update values for each series.
 * @param data series data
 * @param panel
 */
function updateLegendValues(data, panel) {
    for (var i = 0; i < data.length; i++) {
        var series = data[i];
        var yaxes = panel.yaxes;
        var seriesYAxis = series.yaxis || 1;
        var axis = yaxes[seriesYAxis - 1];
        var _a = Object(__WEBPACK_IMPORTED_MODULE_1_app_core_utils_ticks__["getFlotTickDecimals"])(data, axis), tickDecimals = _a.tickDecimals, scaledDecimals = _a.scaledDecimals;
        var formater = __WEBPACK_IMPORTED_MODULE_0_app_core_utils_kbn__["a" /* default */].valueFormats[panel.yaxes[seriesYAxis - 1].format];
        // decimal override
        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNumber(panel.decimals)) {
            series.updateLegendValues(formater, panel.decimals, null);
        }
        else {
            // auto decimals
            // legend and tooltip gets one more decimal precision
            // than graph legend ticks
            tickDecimals = (tickDecimals || -1) + 1;
            series.updateLegendValues(formater, tickDecimals, scaledDecimals + 2);
        }
    }
}
function getDataMinMax(data) {
    var datamin = null;
    var datamax = null;
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var series = data_1[_i];
        if (datamax === null || datamax < series.stats.max) {
            datamax = series.stats.max;
        }
        if (datamin === null || datamin > series.stats.min) {
            datamin = series.stats.min;
        }
    }
    return { datamin: datamin, datamax: datamax };
}
var TimeSeries = /** @class */ (function () {
    function TimeSeries(opts) {
        this.datapoints = opts.datapoints;
        this.label = opts.alias;
        this.id = opts.alias;
        this.alias = opts.alias;
        this.aliasEscaped = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.escape(opts.alias);
        this.color = opts.color;
        this.valueFormater = __WEBPACK_IMPORTED_MODULE_0_app_core_utils_kbn__["a" /* default */].valueFormats.none;
        this.stats = {};
        this.legend = true;
        this.unit = opts.unit;
        this.hasMsResolution = this.isMsResolutionNeeded();
    }
    TimeSeries.prototype.applySeriesOverrides = function (overrides) {
        this.lines = {};
        this.dashes = {
            dashLength: [],
        };
        this.points = {};
        this.bars = {};
        this.yaxis = 1;
        this.zindex = 0;
        this.nullPointMode = null;
        delete this.stack;
        for (var i = 0; i < overrides.length; i++) {
            var override = overrides[i];
            if (!matchSeriesOverride(override.alias, this.alias)) {
                continue;
            }
            if (override.lines !== void 0) {
                this.lines.show = override.lines;
            }
            if (override.dashes !== void 0) {
                this.dashes.show = override.dashes;
                this.lines.lineWidth = 0;
            }
            if (override.points !== void 0) {
                this.points.show = override.points;
            }
            if (override.bars !== void 0) {
                this.bars.show = override.bars;
            }
            if (override.fill !== void 0) {
                this.lines.fill = translateFillOption(override.fill);
            }
            if (override.stack !== void 0) {
                this.stack = override.stack;
            }
            if (override.linewidth !== void 0) {
                this.lines.lineWidth = this.dashes.show ? 0 : override.linewidth;
                this.dashes.lineWidth = override.linewidth;
            }
            if (override.dashLength !== void 0) {
                this.dashes.dashLength[0] = override.dashLength;
            }
            if (override.spaceLength !== void 0) {
                this.dashes.dashLength[1] = override.spaceLength;
            }
            if (override.nullPointMode !== void 0) {
                this.nullPointMode = override.nullPointMode;
            }
            if (override.pointradius !== void 0) {
                this.points.radius = override.pointradius;
            }
            if (override.steppedLine !== void 0) {
                this.lines.steps = override.steppedLine;
            }
            if (override.zindex !== void 0) {
                this.zindex = override.zindex;
            }
            if (override.fillBelowTo !== void 0) {
                this.fillBelowTo = override.fillBelowTo;
            }
            if (override.color !== void 0) {
                this.color = override.color;
            }
            if (override.transform !== void 0) {
                this.transform = override.transform;
            }
            if (override.legend !== void 0) {
                this.legend = override.legend;
            }
            if (override.yaxis !== void 0) {
                this.yaxis = override.yaxis;
            }
        }
    };
    TimeSeries.prototype.getFlotPairs = function (fillStyle) {
        var result = [];
        this.stats.total = 0;
        this.stats.max = -Number.MAX_VALUE;
        this.stats.min = Number.MAX_VALUE;
        this.stats.logmin = Number.MAX_VALUE;
        this.stats.avg = null;
        this.stats.current = null;
        this.stats.first = null;
        this.stats.delta = 0;
        this.stats.diff = null;
        this.stats.range = null;
        this.stats.timeStep = Number.MAX_VALUE;
        this.allIsNull = true;
        this.allIsZero = true;
        var ignoreNulls = fillStyle === 'connected';
        var nullAsZero = fillStyle === 'null as zero';
        var currentTime;
        var currentValue;
        var nonNulls = 0;
        var previousTime;
        var previousValue = 0;
        var previousDeltaUp = true;
        for (var i = 0; i < this.datapoints.length; i++) {
            currentValue = this.datapoints[i][0];
            currentTime = this.datapoints[i][1];
            // Due to missing values we could have different timeStep all along the series
            // so we have to find the minimum one (could occur with aggregators such as ZimSum)
            if (previousTime !== undefined) {
                var timeStep = currentTime - previousTime;
                if (timeStep < this.stats.timeStep) {
                    this.stats.timeStep = timeStep;
                }
            }
            previousTime = currentTime;
            if (currentValue === null) {
                if (ignoreNulls) {
                    continue;
                }
                if (nullAsZero) {
                    currentValue = 0;
                }
            }
            if (currentValue !== null) {
                if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNumber(currentValue)) {
                    this.stats.total += currentValue;
                    this.allIsNull = false;
                    nonNulls++;
                }
                if (currentValue > this.stats.max) {
                    this.stats.max = currentValue;
                }
                if (currentValue < this.stats.min) {
                    this.stats.min = currentValue;
                }
                if (this.stats.first === null) {
                    this.stats.first = currentValue;
                }
                else {
                    if (previousValue > currentValue) {
                        // counter reset
                        previousDeltaUp = false;
                        if (i === this.datapoints.length - 1) {
                            // reset on last
                            this.stats.delta += currentValue;
                        }
                    }
                    else {
                        if (previousDeltaUp) {
                            this.stats.delta += currentValue - previousValue; // normal increment
                        }
                        else {
                            this.stats.delta += currentValue; // account for counter reset
                        }
                        previousDeltaUp = true;
                    }
                }
                previousValue = currentValue;
                if (currentValue < this.stats.logmin && currentValue > 0) {
                    this.stats.logmin = currentValue;
                }
                if (currentValue !== 0) {
                    this.allIsZero = false;
                }
            }
            result.push([currentTime, currentValue]);
        }
        if (this.stats.max === -Number.MAX_VALUE) {
            this.stats.max = null;
        }
        if (this.stats.min === Number.MAX_VALUE) {
            this.stats.min = null;
        }
        if (result.length && !this.allIsNull) {
            this.stats.avg = this.stats.total / nonNulls;
            this.stats.current = result[result.length - 1][1];
            if (this.stats.current === null && result.length > 1) {
                this.stats.current = result[result.length - 2][1];
            }
        }
        if (this.stats.max !== null && this.stats.min !== null) {
            this.stats.range = this.stats.max - this.stats.min;
        }
        if (this.stats.current !== null && this.stats.first !== null) {
            this.stats.diff = this.stats.current - this.stats.first;
        }
        this.stats.count = result.length;
        return result;
    };
    TimeSeries.prototype.updateLegendValues = function (formater, decimals, scaledDecimals) {
        this.valueFormater = formater;
        this.decimals = decimals;
        this.scaledDecimals = scaledDecimals;
    };
    TimeSeries.prototype.formatValue = function (value) {
        if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isFinite(value)) {
            value = null; // Prevent NaN formatting
        }
        return this.valueFormater(value, this.decimals, this.scaledDecimals);
    };
    TimeSeries.prototype.isMsResolutionNeeded = function () {
        for (var i = 0; i < this.datapoints.length; i++) {
            if (this.datapoints[i][1] !== null) {
                var timestamp = this.datapoints[i][1].toString();
                if (timestamp.length === 13 && timestamp % 1000 !== 0) {
                    return true;
                }
            }
        }
        return false;
    };
    TimeSeries.prototype.hideFromLegend = function (options) {
        if (options.hideEmpty && this.allIsNull) {
            return true;
        }
        // ignore series excluded via override
        if (!this.legend) {
            return true;
        }
        // ignore zero series
        if (options.hideZero && this.allIsZero) {
            return true;
        }
        return false;
    };
    return TimeSeries;
}());
/* harmony default export */ __webpack_exports__["a"] = (TimeSeries);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
exports.root = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = react2AngularDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);

function react2AngularDirective(name, component, options) {
    __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive(name, [
        'reactDirective',
        function (reactDirective) {
            return reactDirective(component, options);
        },
    ]);
}


/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DescriptionOption__ = __webpack_require__(1030);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var DescriptionPicker = /** @class */ (function (_super) {
    __extends(DescriptionPicker, _super);
    function DescriptionPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    DescriptionPicker.prototype.render = function () {
        var _a = this.props, optionsWithDesc = _a.optionsWithDesc, handlePicked = _a.handlePicked, value = _a.value, disabled = _a.disabled, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "permissions-picker" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["default"], { value: value, valueKey: "value", multi: false, clearable: false, labelKey: "label", options: optionsWithDesc, onChange: handlePicked, className: "width-7 gf-form-input gf-form-input--form-dropdown " + (className || ''), optionComponent: __WEBPACK_IMPORTED_MODULE_2__DescriptionOption__["a" /* default */], placeholder: "Choose", disabled: disabled })));
    };
    return DescriptionPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DescriptionPicker);


/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var kbn = {};
kbn.valueFormats = {};
kbn.regexEscape = function (value) {
    return value.replace(/[\\^$*+?.()|[\]{}\/]/g, '\\$&');
};
///// HELPER FUNCTIONS /////
kbn.round_interval = function (interval) {
    switch (true) {
        // 0.015s
        case interval < 15:
            return 10; // 0.01s
        // 0.035s
        case interval < 35:
            return 20; // 0.02s
        // 0.075s
        case interval < 75:
            return 50; // 0.05s
        // 0.15s
        case interval < 150:
            return 100; // 0.1s
        // 0.35s
        case interval < 350:
            return 200; // 0.2s
        // 0.75s
        case interval < 750:
            return 500; // 0.5s
        // 1.5s
        case interval < 1500:
            return 1000; // 1s
        // 3.5s
        case interval < 3500:
            return 2000; // 2s
        // 7.5s
        case interval < 7500:
            return 5000; // 5s
        // 12.5s
        case interval < 12500:
            return 10000; // 10s
        // 17.5s
        case interval < 17500:
            return 15000; // 15s
        // 25s
        case interval < 25000:
            return 20000; // 20s
        // 45s
        case interval < 45000:
            return 30000; // 30s
        // 1.5m
        case interval < 90000:
            return 60000; // 1m
        // 3.5m
        case interval < 210000:
            return 120000; // 2m
        // 7.5m
        case interval < 450000:
            return 300000; // 5m
        // 12.5m
        case interval < 750000:
            return 600000; // 10m
        // 12.5m
        case interval < 1050000:
            return 900000; // 15m
        // 25m
        case interval < 1500000:
            return 1200000; // 20m
        // 45m
        case interval < 2700000:
            return 1800000; // 30m
        // 1.5h
        case interval < 5400000:
            return 3600000; // 1h
        // 2.5h
        case interval < 9000000:
            return 7200000; // 2h
        // 4.5h
        case interval < 16200000:
            return 10800000; // 3h
        // 9h
        case interval < 32400000:
            return 21600000; // 6h
        // 1d
        case interval < 86400000:
            return 43200000; // 12h
        // 1w
        case interval < 604800000:
            return 86400000; // 1d
        // 3w
        case interval < 1814400000:
            return 604800000; // 1w
        // 6w
        case interval < 3628800000:
            return 2592000000; // 30d
        default:
            return 31536000000; // 1y
    }
};
kbn.secondsToHms = function (seconds) {
    var numyears = Math.floor(seconds / 31536000);
    if (numyears) {
        return numyears + 'y';
    }
    var numdays = Math.floor((seconds % 31536000) / 86400);
    if (numdays) {
        return numdays + 'd';
    }
    var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
    if (numhours) {
        return numhours + 'h';
    }
    var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
    if (numminutes) {
        return numminutes + 'm';
    }
    var numseconds = Math.floor((((seconds % 31536000) % 86400) % 3600) % 60);
    if (numseconds) {
        return numseconds + 's';
    }
    var nummilliseconds = Math.floor(seconds * 1000.0);
    if (nummilliseconds) {
        return nummilliseconds + 'ms';
    }
    return 'less than a millisecond'; //'just now' //or other string you like;
};
kbn.secondsToHhmmss = function (seconds) {
    var strings = [];
    var numhours = Math.floor(seconds / 3600);
    var numminutes = Math.floor((seconds % 3600) / 60);
    var numseconds = Math.floor((seconds % 3600) % 60);
    numhours > 9 ? strings.push('' + numhours) : strings.push('0' + numhours);
    numminutes > 9 ? strings.push('' + numminutes) : strings.push('0' + numminutes);
    numseconds > 9 ? strings.push('' + numseconds) : strings.push('0' + numseconds);
    return strings.join(':');
};
kbn.to_percent = function (nr, outof) {
    return Math.floor(nr / outof * 10000) / 100 + '%';
};
kbn.addslashes = function (str) {
    str = str.replace(/\\/g, '\\\\');
    str = str.replace(/\'/g, "\\'");
    str = str.replace(/\"/g, '\\"');
    str = str.replace(/\0/g, '\\0');
    return str;
};
kbn.interval_regex = /(\d+(?:\.\d+)?)(ms|[Mwdhmsy])/;
// histogram & trends
kbn.intervals_in_seconds = {
    y: 31536000,
    M: 2592000,
    w: 604800,
    d: 86400,
    h: 3600,
    m: 60,
    s: 1,
    ms: 0.001,
};
kbn.calculateInterval = function (range, resolution, lowLimitInterval) {
    var lowLimitMs = 1; // 1 millisecond default low limit
    var intervalMs;
    if (lowLimitInterval) {
        if (lowLimitInterval[0] === '>') {
            lowLimitInterval = lowLimitInterval.slice(1);
        }
        lowLimitMs = kbn.interval_to_ms(lowLimitInterval);
    }
    intervalMs = kbn.round_interval((range.to.valueOf() - range.from.valueOf()) / resolution);
    if (lowLimitMs > intervalMs) {
        intervalMs = lowLimitMs;
    }
    return {
        intervalMs: intervalMs,
        interval: kbn.secondsToHms(intervalMs / 1000),
    };
};
kbn.describe_interval = function (str) {
    var matches = str.match(kbn.interval_regex);
    if (!matches || !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.has(kbn.intervals_in_seconds, matches[2])) {
        throw new Error('Invalid interval string, expecting a number followed by one of "Mwdhmsy"');
    }
    else {
        return {
            sec: kbn.intervals_in_seconds[matches[2]],
            type: matches[2],
            count: parseInt(matches[1], 10),
        };
    }
};
kbn.interval_to_ms = function (str) {
    var info = kbn.describe_interval(str);
    return info.sec * 1000 * info.count;
};
kbn.interval_to_seconds = function (str) {
    var info = kbn.describe_interval(str);
    return info.sec * info.count;
};
kbn.query_color_dot = function (color, diameter) {
    return ('<div class="icon-circle" style="' +
        ['display:inline-block', 'color:' + color, 'font-size:' + diameter + 'px'].join(';') +
        '"></div>');
};
kbn.slugifyForUrl = function (str) {
    return str
        .toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
};
kbn.stringToJsRegex = function (str) {
    if (str[0] !== '/') {
        return new RegExp('^' + str + '$');
    }
    var match = str.match(new RegExp('^/(.*?)/(g?i?m?y?)$'));
    return new RegExp(match[1], match[2]);
};
kbn.toFixed = function (value, decimals) {
    if (value === null) {
        return '';
    }
    var factor = decimals ? Math.pow(10, Math.max(0, decimals)) : 1;
    var formatted = String(Math.round(value * factor) / factor);
    // if exponent return directly
    if (formatted.indexOf('e') !== -1 || value === 0) {
        return formatted;
    }
    // If tickDecimals was specified, ensure that we have exactly that
    // much precision; otherwise default to the value's own precision.
    if (decimals != null) {
        var decimalPos = formatted.indexOf('.');
        var precision = decimalPos === -1 ? 0 : formatted.length - decimalPos - 1;
        if (precision < decimals) {
            return (precision ? formatted : formatted + '.') + String(factor).substr(1, decimals - precision);
        }
    }
    return formatted;
};
kbn.toFixedScaled = function (value, decimals, scaledDecimals, additionalDecimals, ext) {
    if (scaledDecimals === null) {
        return kbn.toFixed(value, decimals) + ext;
    }
    else {
        return kbn.toFixed(value, scaledDecimals + additionalDecimals) + ext;
    }
};
kbn.roundValue = function (num, decimals) {
    if (num === null) {
        return null;
    }
    var n = Math.pow(10, decimals);
    var formatted = (n * num).toFixed(decimals);
    return Math.round(parseFloat(formatted)) / n;
};
///// FORMAT FUNCTION CONSTRUCTORS /////
kbn.formatBuilders = {};
// Formatter which always appends a fixed unit string to the value. No
// scaling of the value is performed.
kbn.formatBuilders.fixedUnit = function (unit) {
    return function (size, decimals) {
        if (size === null) {
            return '';
        }
        return kbn.toFixed(size, decimals) + ' ' + unit;
    };
};
// Formatter which scales the unit string geometrically according to the given
// numeric factor. Repeatedly scales the value down by the factor until it is
// less than the factor in magnitude, or the end of the array is reached.
kbn.formatBuilders.scaledUnits = function (factor, extArray) {
    return function (size, decimals, scaledDecimals) {
        if (size === null) {
            return '';
        }
        var steps = 0;
        var limit = extArray.length;
        while (Math.abs(size) >= factor) {
            steps++;
            size /= factor;
            if (steps >= limit) {
                return 'NA';
            }
        }
        if (steps > 0 && scaledDecimals !== null) {
            decimals = scaledDecimals + 3 * steps;
        }
        return kbn.toFixed(size, decimals) + extArray[steps];
    };
};
// Extension of the scaledUnits builder which uses SI decimal prefixes. If an
// offset is given, it adjusts the starting units at the given prefix; a value
// of 0 starts at no scale; -3 drops to nano, +2 starts at mega, etc.
kbn.formatBuilders.decimalSIPrefix = function (unit, offset) {
    var prefixes = ['n', 'µ', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
    prefixes = prefixes.slice(3 + (offset || 0));
    var units = prefixes.map(function (p) {
        return ' ' + p + unit;
    });
    return kbn.formatBuilders.scaledUnits(1000, units);
};
// Extension of the scaledUnits builder which uses SI binary prefixes. If
// offset is given, it starts the units at the given prefix; otherwise, the
// offset defaults to zero and the initial unit is not prefixed.
kbn.formatBuilders.binarySIPrefix = function (unit, offset) {
    var prefixes = ['', 'Ki', 'Mi', 'Gi', 'Ti', 'Pi', 'Ei', 'Zi', 'Yi'].slice(offset);
    var units = prefixes.map(function (p) {
        return ' ' + p + unit;
    });
    return kbn.formatBuilders.scaledUnits(1024, units);
};
// Currency formatter for prefixing a symbol onto a number. Supports scaling
// up to the trillions.
kbn.formatBuilders.currency = function (symbol) {
    var units = ['', 'K', 'M', 'B', 'T'];
    var scaler = kbn.formatBuilders.scaledUnits(1000, units);
    return function (size, decimals, scaledDecimals) {
        if (size === null) {
            return '';
        }
        var scaled = scaler(size, decimals, scaledDecimals);
        return symbol + scaled;
    };
};
kbn.formatBuilders.simpleCountUnit = function (symbol) {
    var units = ['', 'K', 'M', 'B', 'T'];
    var scaler = kbn.formatBuilders.scaledUnits(1000, units);
    return function (size, decimals, scaledDecimals) {
        if (size === null) {
            return '';
        }
        var scaled = scaler(size, decimals, scaledDecimals);
        return scaled + ' ' + symbol;
    };
};
///// VALUE FORMATS /////
// Dimensionless Units
kbn.valueFormats.none = kbn.toFixed;
kbn.valueFormats.short = kbn.formatBuilders.scaledUnits(1000, [
    '',
    ' K',
    ' Mil',
    ' Bil',
    ' Tri',
    ' Quadr',
    ' Quint',
    ' Sext',
    ' Sept',
]);
kbn.valueFormats.dB = kbn.formatBuilders.fixedUnit('dB');
kbn.valueFormats.percent = function (size, decimals) {
    if (size === null) {
        return '';
    }
    return kbn.toFixed(size, decimals) + '%';
};
kbn.valueFormats.percentunit = function (size, decimals) {
    if (size === null) {
        return '';
    }
    return kbn.toFixed(100 * size, decimals) + '%';
};
/* Formats the value to hex. Uses float if specified decimals are not 0.
 * There are two options, one with 0x, and one without */
kbn.valueFormats.hex = function (value, decimals) {
    if (value == null) {
        return '';
    }
    return parseFloat(kbn.toFixed(value, decimals))
        .toString(16)
        .toUpperCase();
};
kbn.valueFormats.hex0x = function (value, decimals) {
    if (value == null) {
        return '';
    }
    var hexString = kbn.valueFormats.hex(value, decimals);
    if (hexString.substring(0, 1) === '-') {
        return '-0x' + hexString.substring(1);
    }
    return '0x' + hexString;
};
kbn.valueFormats.sci = function (value, decimals) {
    return value.toExponential(decimals);
};
kbn.valueFormats.locale = function (value, decimals) {
    return value.toLocaleString(undefined, { maximumFractionDigits: decimals });
};
// Currencies
kbn.valueFormats.currencyUSD = kbn.formatBuilders.currency('$');
kbn.valueFormats.currencyGBP = kbn.formatBuilders.currency('£');
kbn.valueFormats.currencyEUR = kbn.formatBuilders.currency('€');
kbn.valueFormats.currencyJPY = kbn.formatBuilders.currency('¥');
kbn.valueFormats.currencyRUB = kbn.formatBuilders.currency('₽');
kbn.valueFormats.currencyUAH = kbn.formatBuilders.currency('₴');
kbn.valueFormats.currencyBRL = kbn.formatBuilders.currency('R$');
kbn.valueFormats.currencyDKK = kbn.formatBuilders.currency('kr');
kbn.valueFormats.currencyISK = kbn.formatBuilders.currency('kr');
kbn.valueFormats.currencyNOK = kbn.formatBuilders.currency('kr');
kbn.valueFormats.currencySEK = kbn.formatBuilders.currency('kr');
kbn.valueFormats.currencyCZK = kbn.formatBuilders.currency('czk');
// Data (Binary)
kbn.valueFormats.bits = kbn.formatBuilders.binarySIPrefix('b');
kbn.valueFormats.bytes = kbn.formatBuilders.binarySIPrefix('B');
kbn.valueFormats.kbytes = kbn.formatBuilders.binarySIPrefix('B', 1);
kbn.valueFormats.mbytes = kbn.formatBuilders.binarySIPrefix('B', 2);
kbn.valueFormats.gbytes = kbn.formatBuilders.binarySIPrefix('B', 3);
// Data (Decimal)
kbn.valueFormats.decbits = kbn.formatBuilders.decimalSIPrefix('b');
kbn.valueFormats.decbytes = kbn.formatBuilders.decimalSIPrefix('B');
kbn.valueFormats.deckbytes = kbn.formatBuilders.decimalSIPrefix('B', 1);
kbn.valueFormats.decmbytes = kbn.formatBuilders.decimalSIPrefix('B', 2);
kbn.valueFormats.decgbytes = kbn.formatBuilders.decimalSIPrefix('B', 3);
// Data Rate
kbn.valueFormats.pps = kbn.formatBuilders.decimalSIPrefix('pps');
kbn.valueFormats.bps = kbn.formatBuilders.decimalSIPrefix('bps');
kbn.valueFormats.Bps = kbn.formatBuilders.decimalSIPrefix('B/s');
kbn.valueFormats.KBs = kbn.formatBuilders.decimalSIPrefix('Bs', 1);
kbn.valueFormats.Kbits = kbn.formatBuilders.decimalSIPrefix('bps', 1);
kbn.valueFormats.MBs = kbn.formatBuilders.decimalSIPrefix('Bs', 2);
kbn.valueFormats.Mbits = kbn.formatBuilders.decimalSIPrefix('bps', 2);
kbn.valueFormats.GBs = kbn.formatBuilders.decimalSIPrefix('Bs', 3);
kbn.valueFormats.Gbits = kbn.formatBuilders.decimalSIPrefix('bps', 3);
// Hash Rate
kbn.valueFormats.Hs = kbn.formatBuilders.decimalSIPrefix('H/s');
kbn.valueFormats.KHs = kbn.formatBuilders.decimalSIPrefix('H/s', 1);
kbn.valueFormats.MHs = kbn.formatBuilders.decimalSIPrefix('H/s', 2);
kbn.valueFormats.GHs = kbn.formatBuilders.decimalSIPrefix('H/s', 3);
kbn.valueFormats.THs = kbn.formatBuilders.decimalSIPrefix('H/s', 4);
kbn.valueFormats.PHs = kbn.formatBuilders.decimalSIPrefix('H/s', 5);
kbn.valueFormats.EHs = kbn.formatBuilders.decimalSIPrefix('H/s', 6);
// Throughput
kbn.valueFormats.ops = kbn.formatBuilders.simpleCountUnit('ops');
kbn.valueFormats.rps = kbn.formatBuilders.simpleCountUnit('rps');
kbn.valueFormats.wps = kbn.formatBuilders.simpleCountUnit('wps');
kbn.valueFormats.iops = kbn.formatBuilders.simpleCountUnit('iops');
kbn.valueFormats.opm = kbn.formatBuilders.simpleCountUnit('opm');
kbn.valueFormats.rpm = kbn.formatBuilders.simpleCountUnit('rpm');
kbn.valueFormats.wpm = kbn.formatBuilders.simpleCountUnit('wpm');
// Energy
kbn.valueFormats.watt = kbn.formatBuilders.decimalSIPrefix('W');
kbn.valueFormats.kwatt = kbn.formatBuilders.decimalSIPrefix('W', 1);
kbn.valueFormats.mwatt = kbn.formatBuilders.decimalSIPrefix('W', -1);
kbn.valueFormats.kwattm = kbn.formatBuilders.decimalSIPrefix('W/Min', 1);
kbn.valueFormats.voltamp = kbn.formatBuilders.decimalSIPrefix('VA');
kbn.valueFormats.kvoltamp = kbn.formatBuilders.decimalSIPrefix('VA', 1);
kbn.valueFormats.voltampreact = kbn.formatBuilders.decimalSIPrefix('var');
kbn.valueFormats.kvoltampreact = kbn.formatBuilders.decimalSIPrefix('var', 1);
kbn.valueFormats.watth = kbn.formatBuilders.decimalSIPrefix('Wh');
kbn.valueFormats.kwatth = kbn.formatBuilders.decimalSIPrefix('Wh', 1);
kbn.valueFormats.joule = kbn.formatBuilders.decimalSIPrefix('J');
kbn.valueFormats.ev = kbn.formatBuilders.decimalSIPrefix('eV');
kbn.valueFormats.amp = kbn.formatBuilders.decimalSIPrefix('A');
kbn.valueFormats.kamp = kbn.formatBuilders.decimalSIPrefix('A', 1);
kbn.valueFormats.mamp = kbn.formatBuilders.decimalSIPrefix('A', -1);
kbn.valueFormats.volt = kbn.formatBuilders.decimalSIPrefix('V');
kbn.valueFormats.kvolt = kbn.formatBuilders.decimalSIPrefix('V', 1);
kbn.valueFormats.mvolt = kbn.formatBuilders.decimalSIPrefix('V', -1);
kbn.valueFormats.dBm = kbn.formatBuilders.decimalSIPrefix('dBm');
kbn.valueFormats.ohm = kbn.formatBuilders.decimalSIPrefix('Ω');
kbn.valueFormats.lumens = kbn.formatBuilders.decimalSIPrefix('Lm');
// Temperature
kbn.valueFormats.celsius = kbn.formatBuilders.fixedUnit('°C');
kbn.valueFormats.farenheit = kbn.formatBuilders.fixedUnit('°F');
kbn.valueFormats.kelvin = kbn.formatBuilders.fixedUnit('K');
kbn.valueFormats.humidity = kbn.formatBuilders.fixedUnit('%H');
// Pressure
kbn.valueFormats.pressurebar = kbn.formatBuilders.decimalSIPrefix('bar');
kbn.valueFormats.pressurembar = kbn.formatBuilders.decimalSIPrefix('bar', -1);
kbn.valueFormats.pressurekbar = kbn.formatBuilders.decimalSIPrefix('bar', 1);
kbn.valueFormats.pressurehpa = kbn.formatBuilders.fixedUnit('hPa');
kbn.valueFormats.pressurehg = kbn.formatBuilders.fixedUnit('"Hg');
kbn.valueFormats.pressurepsi = kbn.formatBuilders.scaledUnits(1000, [' psi', ' ksi', ' Mpsi']);
// Force
kbn.valueFormats.forceNm = kbn.formatBuilders.decimalSIPrefix('Nm');
kbn.valueFormats.forcekNm = kbn.formatBuilders.decimalSIPrefix('Nm', 1);
kbn.valueFormats.forceN = kbn.formatBuilders.decimalSIPrefix('N');
kbn.valueFormats.forcekN = kbn.formatBuilders.decimalSIPrefix('N', 1);
// Length
kbn.valueFormats.lengthm = kbn.formatBuilders.decimalSIPrefix('m');
kbn.valueFormats.lengthmm = kbn.formatBuilders.decimalSIPrefix('m', -1);
kbn.valueFormats.lengthkm = kbn.formatBuilders.decimalSIPrefix('m', 1);
kbn.valueFormats.lengthmi = kbn.formatBuilders.fixedUnit('mi');
kbn.valueFormats.lengthft = kbn.formatBuilders.fixedUnit('ft');
// Area
kbn.valueFormats.areaM2 = kbn.formatBuilders.fixedUnit('m²');
kbn.valueFormats.areaF2 = kbn.formatBuilders.fixedUnit('ft²');
kbn.valueFormats.areaMI2 = kbn.formatBuilders.fixedUnit('mi²');
// Mass
kbn.valueFormats.massmg = kbn.formatBuilders.decimalSIPrefix('g', -1);
kbn.valueFormats.massg = kbn.formatBuilders.decimalSIPrefix('g');
kbn.valueFormats.masskg = kbn.formatBuilders.decimalSIPrefix('g', 1);
kbn.valueFormats.masst = kbn.formatBuilders.fixedUnit('t');
// Velocity
kbn.valueFormats.velocityms = kbn.formatBuilders.fixedUnit('m/s');
kbn.valueFormats.velocitykmh = kbn.formatBuilders.fixedUnit('km/h');
kbn.valueFormats.velocitymph = kbn.formatBuilders.fixedUnit('mph');
kbn.valueFormats.velocityknot = kbn.formatBuilders.fixedUnit('kn');
// Acceleration
kbn.valueFormats.accMS2 = kbn.formatBuilders.fixedUnit('m/sec²');
kbn.valueFormats.accFS2 = kbn.formatBuilders.fixedUnit('f/sec²');
kbn.valueFormats.accG = kbn.formatBuilders.fixedUnit('g');
// Volume
kbn.valueFormats.litre = kbn.formatBuilders.decimalSIPrefix('L');
kbn.valueFormats.mlitre = kbn.formatBuilders.decimalSIPrefix('L', -1);
kbn.valueFormats.m3 = kbn.formatBuilders.fixedUnit('m3');
kbn.valueFormats.Nm3 = kbn.formatBuilders.fixedUnit('Nm3');
kbn.valueFormats.dm3 = kbn.formatBuilders.fixedUnit('dm3');
kbn.valueFormats.gallons = kbn.formatBuilders.fixedUnit('gal');
// Flow
kbn.valueFormats.flowgpm = kbn.formatBuilders.fixedUnit('gpm');
kbn.valueFormats.flowcms = kbn.formatBuilders.fixedUnit('cms');
kbn.valueFormats.flowcfs = kbn.formatBuilders.fixedUnit('cfs');
kbn.valueFormats.flowcfm = kbn.formatBuilders.fixedUnit('cfm');
// Angle
kbn.valueFormats.degree = kbn.formatBuilders.fixedUnit('°');
kbn.valueFormats.radian = kbn.formatBuilders.fixedUnit('rad');
kbn.valueFormats.grad = kbn.formatBuilders.fixedUnit('grad');
// Radiation
kbn.valueFormats.radbq = kbn.formatBuilders.decimalSIPrefix('Bq');
kbn.valueFormats.radci = kbn.formatBuilders.decimalSIPrefix('Ci');
kbn.valueFormats.radgy = kbn.formatBuilders.decimalSIPrefix('Gy');
kbn.valueFormats.radrad = kbn.formatBuilders.decimalSIPrefix('rad');
kbn.valueFormats.radsv = kbn.formatBuilders.decimalSIPrefix('Sv');
kbn.valueFormats.radrem = kbn.formatBuilders.decimalSIPrefix('rem');
kbn.valueFormats.radexpckg = kbn.formatBuilders.decimalSIPrefix('C/kg');
kbn.valueFormats.radr = kbn.formatBuilders.decimalSIPrefix('R');
kbn.valueFormats.radsvh = kbn.formatBuilders.decimalSIPrefix('Sv/h');
// Concentration
kbn.valueFormats.ppm = kbn.formatBuilders.fixedUnit('ppm');
kbn.valueFormats.conppb = kbn.formatBuilders.fixedUnit('ppb');
kbn.valueFormats.conngm3 = kbn.formatBuilders.fixedUnit('ng/m3');
kbn.valueFormats.conngNm3 = kbn.formatBuilders.fixedUnit('ng/Nm3');
kbn.valueFormats.conμgm3 = kbn.formatBuilders.fixedUnit('μg/m3');
kbn.valueFormats.conμgNm3 = kbn.formatBuilders.fixedUnit('μg/Nm3');
kbn.valueFormats.conmgm3 = kbn.formatBuilders.fixedUnit('mg/m3');
kbn.valueFormats.conmgNm3 = kbn.formatBuilders.fixedUnit('mg/Nm3');
kbn.valueFormats.congm3 = kbn.formatBuilders.fixedUnit('g/m3');
kbn.valueFormats.congNm3 = kbn.formatBuilders.fixedUnit('g/Nm3');
// Time
kbn.valueFormats.hertz = kbn.formatBuilders.decimalSIPrefix('Hz');
kbn.valueFormats.ms = function (size, decimals, scaledDecimals) {
    if (size === null) {
        return '';
    }
    if (Math.abs(size) < 1000) {
        return kbn.toFixed(size, decimals) + ' ms';
    }
    else if (Math.abs(size) < 60000) {
        // Less than 1 min
        return kbn.toFixedScaled(size / 1000, decimals, scaledDecimals, 3, ' s');
    }
    else if (Math.abs(size) < 3600000) {
        // Less than 1 hour, divide in minutes
        return kbn.toFixedScaled(size / 60000, decimals, scaledDecimals, 5, ' min');
    }
    else if (Math.abs(size) < 86400000) {
        // Less than one day, divide in hours
        return kbn.toFixedScaled(size / 3600000, decimals, scaledDecimals, 7, ' hour');
    }
    else if (Math.abs(size) < 31536000000) {
        // Less than one year, divide in days
        return kbn.toFixedScaled(size / 86400000, decimals, scaledDecimals, 8, ' day');
    }
    return kbn.toFixedScaled(size / 31536000000, decimals, scaledDecimals, 10, ' year');
};
kbn.valueFormats.s = function (size, decimals, scaledDecimals) {
    if (size === null) {
        return '';
    }
    // Less than 1 µs, divide in ns
    if (Math.abs(size) < 0.000001) {
        return kbn.toFixedScaled(size * 1e9, decimals, scaledDecimals - decimals, -9, ' ns');
    }
    // Less than 1 ms, divide in µs
    if (Math.abs(size) < 0.001) {
        return kbn.toFixedScaled(size * 1e6, decimals, scaledDecimals - decimals, -6, ' µs');
    }
    // Less than 1 second, divide in ms
    if (Math.abs(size) < 1) {
        return kbn.toFixedScaled(size * 1e3, decimals, scaledDecimals - decimals, -3, ' ms');
    }
    if (Math.abs(size) < 60) {
        return kbn.toFixed(size, decimals) + ' s';
    }
    else if (Math.abs(size) < 3600) {
        // Less than 1 hour, divide in minutes
        return kbn.toFixedScaled(size / 60, decimals, scaledDecimals, 1, ' min');
    }
    else if (Math.abs(size) < 86400) {
        // Less than one day, divide in hours
        return kbn.toFixedScaled(size / 3600, decimals, scaledDecimals, 4, ' hour');
    }
    else if (Math.abs(size) < 604800) {
        // Less than one week, divide in days
        return kbn.toFixedScaled(size / 86400, decimals, scaledDecimals, 5, ' day');
    }
    else if (Math.abs(size) < 31536000) {
        // Less than one year, divide in week
        return kbn.toFixedScaled(size / 604800, decimals, scaledDecimals, 6, ' week');
    }
    return kbn.toFixedScaled(size / 3.15569e7, decimals, scaledDecimals, 7, ' year');
};
kbn.valueFormats['µs'] = function (size, decimals, scaledDecimals) {
    if (size === null) {
        return '';
    }
    if (Math.abs(size) < 1000) {
        return kbn.toFixed(size, decimals) + ' µs';
    }
    else if (Math.abs(size) < 1000000) {
        return kbn.toFixedScaled(size / 1000, decimals, scaledDecimals, 3, ' ms');
    }
    else {
        return kbn.toFixedScaled(size / 1000000, decimals, scaledDecimals, 6, ' s');
    }
};
kbn.valueFormats.ns = function (size, decimals, scaledDecimals) {
    if (size === null) {
        return '';
    }
    if (Math.abs(size) < 1000) {
        return kbn.toFixed(size, decimals) + ' ns';
    }
    else if (Math.abs(size) < 1000000) {
        return kbn.toFixedScaled(size / 1000, decimals, scaledDecimals, 3, ' µs');
    }
    else if (Math.abs(size) < 1000000000) {
        return kbn.toFixedScaled(size / 1000000, decimals, scaledDecimals, 6, ' ms');
    }
    else if (Math.abs(size) < 60000000000) {
        return kbn.toFixedScaled(size / 1000000000, decimals, scaledDecimals, 9, ' s');
    }
    else {
        return kbn.toFixedScaled(size / 60000000000, decimals, scaledDecimals, 12, ' min');
    }
};
kbn.valueFormats.m = function (size, decimals, scaledDecimals) {
    if (size === null) {
        return '';
    }
    if (Math.abs(size) < 60) {
        return kbn.toFixed(size, decimals) + ' min';
    }
    else if (Math.abs(size) < 1440) {
        return kbn.toFixedScaled(size / 60, decimals, scaledDecimals, 2, ' hour');
    }
    else if (Math.abs(size) < 10080) {
        return kbn.toFixedScaled(size / 1440, decimals, scaledDecimals, 3, ' day');
    }
    else if (Math.abs(size) < 604800) {
        return kbn.toFixedScaled(size / 10080, decimals, scaledDecimals, 4, ' week');
    }
    else {
        return kbn.toFixedScaled(size / 5.25948e5, decimals, scaledDecimals, 5, ' year');
    }
};
kbn.valueFormats.h = function (size, decimals, scaledDecimals) {
    if (size === null) {
        return '';
    }
    if (Math.abs(size) < 24) {
        return kbn.toFixed(size, decimals) + ' hour';
    }
    else if (Math.abs(size) < 168) {
        return kbn.toFixedScaled(size / 24, decimals, scaledDecimals, 2, ' day');
    }
    else if (Math.abs(size) < 8760) {
        return kbn.toFixedScaled(size / 168, decimals, scaledDecimals, 3, ' week');
    }
    else {
        return kbn.toFixedScaled(size / 8760, decimals, scaledDecimals, 4, ' year');
    }
};
kbn.valueFormats.d = function (size, decimals, scaledDecimals) {
    if (size === null) {
        return '';
    }
    if (Math.abs(size) < 7) {
        return kbn.toFixed(size, decimals) + ' day';
    }
    else if (Math.abs(size) < 365) {
        return kbn.toFixedScaled(size / 7, decimals, scaledDecimals, 2, ' week');
    }
    else {
        return kbn.toFixedScaled(size / 365, decimals, scaledDecimals, 3, ' year');
    }
};
kbn.toDuration = function (size, decimals, timeScale) {
    if (size === null) {
        return '';
    }
    if (size === 0) {
        return '0 ' + timeScale + 's';
    }
    if (size < 0) {
        return kbn.toDuration(-size, decimals, timeScale) + ' ago';
    }
    var units = [
        { short: 'y', long: 'year' },
        { short: 'M', long: 'month' },
        { short: 'w', long: 'week' },
        { short: 'd', long: 'day' },
        { short: 'h', long: 'hour' },
        { short: 'm', long: 'minute' },
        { short: 's', long: 'second' },
        { short: 'ms', long: 'millisecond' },
    ];
    // convert $size to milliseconds
    // intervals_in_seconds uses seconds (duh), convert them to milliseconds here to minimize floating point errors
    size *=
        kbn.intervals_in_seconds[units.find(function (e) {
            return e.long === timeScale;
        }).short] * 1000;
    var strings = [];
    // after first value >= 1 print only $decimals more
    var decrementDecimals = false;
    for (var i = 0; i < units.length && decimals >= 0; i++) {
        var interval = kbn.intervals_in_seconds[units[i].short] * 1000;
        var value = size / interval;
        if (value >= 1 || decrementDecimals) {
            decrementDecimals = true;
            var floor = Math.floor(value);
            var unit = units[i].long + (floor !== 1 ? 's' : '');
            strings.push(floor + ' ' + unit);
            size = size % interval;
            decimals--;
        }
    }
    return strings.join(', ');
};
kbn.valueFormats.dtdurationms = function (size, decimals) {
    return kbn.toDuration(size, decimals, 'millisecond');
};
kbn.valueFormats.dtdurations = function (size, decimals) {
    return kbn.toDuration(size, decimals, 'second');
};
kbn.valueFormats.dthms = function (size, decimals) {
    return kbn.secondsToHhmmss(size);
};
kbn.valueFormats.timeticks = function (size, decimals, scaledDecimals) {
    return kbn.valueFormats.s(size / 100, decimals, scaledDecimals);
};
kbn.valueFormats.dateTimeAsIso = function (epoch) {
    var time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(epoch);
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().isSame(epoch, 'day')) {
        return time.format('HH:mm:ss');
    }
    return time.format('YYYY-MM-DD HH:mm:ss');
};
kbn.valueFormats.dateTimeAsUS = function (epoch) {
    var time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(epoch);
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().isSame(epoch, 'day')) {
        return time.format('h:mm:ss a');
    }
    return time.format('MM/DD/YYYY h:mm:ss a');
};
kbn.valueFormats.dateTimeFromNow = function (epoch) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(epoch).fromNow();
};
///// FORMAT MENU /////
kbn.getUnitFormats = function () {
    return [
        {
            text: 'none',
            submenu: [
                { text: 'none', value: 'none' },
                { text: 'short', value: 'short' },
                { text: 'percent (0-100)', value: 'percent' },
                { text: 'percent (0.0-1.0)', value: 'percentunit' },
                { text: 'Humidity (%H)', value: 'humidity' },
                { text: 'decibel', value: 'dB' },
                { text: 'hexadecimal (0x)', value: 'hex0x' },
                { text: 'hexadecimal', value: 'hex' },
                { text: 'scientific notation', value: 'sci' },
                { text: 'locale format', value: 'locale' },
            ],
        },
        {
            text: 'currency',
            submenu: [
                { text: 'Dollars ($)', value: 'currencyUSD' },
                { text: 'Pounds (£)', value: 'currencyGBP' },
                { text: 'Euro (€)', value: 'currencyEUR' },
                { text: 'Yen (¥)', value: 'currencyJPY' },
                { text: 'Rubles (₽)', value: 'currencyRUB' },
                { text: 'Hryvnias (₴)', value: 'currencyUAH' },
                { text: 'Real (R$)', value: 'currencyBRL' },
                { text: 'Danish Krone (kr)', value: 'currencyDKK' },
                { text: 'Icelandic Króna (kr)', value: 'currencyISK' },
                { text: 'Norwegian Krone (kr)', value: 'currencyNOK' },
                { text: 'Swedish Krona (kr)', value: 'currencySEK' },
                { text: 'Czech koruna (czk)', value: 'currencyCZK' },
            ],
        },
        {
            text: 'time',
            submenu: [
                { text: 'Hertz (1/s)', value: 'hertz' },
                { text: 'nanoseconds (ns)', value: 'ns' },
                { text: 'microseconds (µs)', value: 'µs' },
                { text: 'milliseconds (ms)', value: 'ms' },
                { text: 'seconds (s)', value: 's' },
                { text: 'minutes (m)', value: 'm' },
                { text: 'hours (h)', value: 'h' },
                { text: 'days (d)', value: 'd' },
                { text: 'duration (ms)', value: 'dtdurationms' },
                { text: 'duration (s)', value: 'dtdurations' },
                { text: 'duration (hh:mm:ss)', value: 'dthms' },
                { text: 'Timeticks (s/100)', value: 'timeticks' },
            ],
        },
        {
            text: 'date & time',
            submenu: [
                { text: 'YYYY-MM-DD HH:mm:ss', value: 'dateTimeAsIso' },
                { text: 'DD/MM/YYYY h:mm:ss a', value: 'dateTimeAsUS' },
                { text: 'From Now', value: 'dateTimeFromNow' },
            ],
        },
        {
            text: 'data (IEC)',
            submenu: [
                { text: 'bits', value: 'bits' },
                { text: 'bytes', value: 'bytes' },
                { text: 'kibibytes', value: 'kbytes' },
                { text: 'mebibytes', value: 'mbytes' },
                { text: 'gibibytes', value: 'gbytes' },
            ],
        },
        {
            text: 'data (Metric)',
            submenu: [
                { text: 'bits', value: 'decbits' },
                { text: 'bytes', value: 'decbytes' },
                { text: 'kilobytes', value: 'deckbytes' },
                { text: 'megabytes', value: 'decmbytes' },
                { text: 'gigabytes', value: 'decgbytes' },
            ],
        },
        {
            text: 'data rate',
            submenu: [
                { text: 'packets/sec', value: 'pps' },
                { text: 'bits/sec', value: 'bps' },
                { text: 'bytes/sec', value: 'Bps' },
                { text: 'kilobits/sec', value: 'Kbits' },
                { text: 'kilobytes/sec', value: 'KBs' },
                { text: 'megabits/sec', value: 'Mbits' },
                { text: 'megabytes/sec', value: 'MBs' },
                { text: 'gigabytes/sec', value: 'GBs' },
                { text: 'gigabits/sec', value: 'Gbits' },
            ],
        },
        {
            text: 'hash rate',
            submenu: [
                { text: 'hashes/sec', value: 'Hs' },
                { text: 'kilohashes/sec', value: 'KHs' },
                { text: 'megahashes/sec', value: 'MHs' },
                { text: 'gigahashes/sec', value: 'GHs' },
                { text: 'terahashes/sec', value: 'THs' },
                { text: 'petahashes/sec', value: 'PHs' },
                { text: 'exahashes/sec', value: 'EHs' },
            ],
        },
        {
            text: 'throughput',
            submenu: [
                { text: 'ops/sec (ops)', value: 'ops' },
                { text: 'reads/sec (rps)', value: 'rps' },
                { text: 'writes/sec (wps)', value: 'wps' },
                { text: 'I/O ops/sec (iops)', value: 'iops' },
                { text: 'ops/min (opm)', value: 'opm' },
                { text: 'reads/min (rpm)', value: 'rpm' },
                { text: 'writes/min (wpm)', value: 'wpm' },
            ],
        },
        {
            text: 'length',
            submenu: [
                { text: 'millimetre (mm)', value: 'lengthmm' },
                { text: 'meter (m)', value: 'lengthm' },
                { text: 'feet (ft)', value: 'lengthft' },
                { text: 'kilometer (km)', value: 'lengthkm' },
                { text: 'mile (mi)', value: 'lengthmi' },
            ],
        },
        {
            text: 'area',
            submenu: [
                { text: 'Square Meters (m²)', value: 'areaM2' },
                { text: 'Square Feet (ft²)', value: 'areaF2' },
                { text: 'Square Miles (mi²)', value: 'areaMI2' },
            ],
        },
        {
            text: 'mass',
            submenu: [
                { text: 'milligram (mg)', value: 'massmg' },
                { text: 'gram (g)', value: 'massg' },
                { text: 'kilogram (kg)', value: 'masskg' },
                { text: 'metric ton (t)', value: 'masst' },
            ],
        },
        {
            text: 'velocity',
            submenu: [
                { text: 'm/s', value: 'velocityms' },
                { text: 'km/h', value: 'velocitykmh' },
                { text: 'mph', value: 'velocitymph' },
                { text: 'knot (kn)', value: 'velocityknot' },
            ],
        },
        {
            text: 'volume',
            submenu: [
                { text: 'millilitre', value: 'mlitre' },
                { text: 'litre', value: 'litre' },
                { text: 'cubic metre', value: 'm3' },
                { text: 'Normal cubic metre', value: 'Nm3' },
                { text: 'cubic decimetre', value: 'dm3' },
                { text: 'gallons', value: 'gallons' },
            ],
        },
        {
            text: 'energy',
            submenu: [
                { text: 'Watt (W)', value: 'watt' },
                { text: 'Kilowatt (kW)', value: 'kwatt' },
                { text: 'Milliwatt (mW)', value: 'mwatt' },
                { text: 'Volt-ampere (VA)', value: 'voltamp' },
                { text: 'Kilovolt-ampere (kVA)', value: 'kvoltamp' },
                { text: 'Volt-ampere reactive (var)', value: 'voltampreact' },
                { text: 'Kilovolt-ampere reactive (kvar)', value: 'kvoltampreact' },
                { text: 'Watt-hour (Wh)', value: 'watth' },
                { text: 'Kilowatt-hour (kWh)', value: 'kwatth' },
                { text: 'Kilowatt-min (kWm)', value: 'kwattm' },
                { text: 'Joule (J)', value: 'joule' },
                { text: 'Electron volt (eV)', value: 'ev' },
                { text: 'Ampere (A)', value: 'amp' },
                { text: 'Kiloampere (kA)', value: 'kamp' },
                { text: 'Milliampere (mA)', value: 'mamp' },
                { text: 'Volt (V)', value: 'volt' },
                { text: 'Kilovolt (kV)', value: 'kvolt' },
                { text: 'Millivolt (mV)', value: 'mvolt' },
                { text: 'Decibel-milliwatt (dBm)', value: 'dBm' },
                { text: 'Ohm (Ω)', value: 'ohm' },
                { text: 'Lumens (Lm)', value: 'lumens' },
            ],
        },
        {
            text: 'temperature',
            submenu: [
                { text: 'Celsius (°C)', value: 'celsius' },
                { text: 'Farenheit (°F)', value: 'farenheit' },
                { text: 'Kelvin (K)', value: 'kelvin' },
            ],
        },
        {
            text: 'pressure',
            submenu: [
                { text: 'Millibars', value: 'pressurembar' },
                { text: 'Bars', value: 'pressurebar' },
                { text: 'Kilobars', value: 'pressurekbar' },
                { text: 'Hectopascals', value: 'pressurehpa' },
                { text: 'Inches of mercury', value: 'pressurehg' },
                { text: 'PSI', value: 'pressurepsi' },
            ],
        },
        {
            text: 'force',
            submenu: [
                { text: 'Newton-meters (Nm)', value: 'forceNm' },
                { text: 'Kilonewton-meters (kNm)', value: 'forcekNm' },
                { text: 'Newtons (N)', value: 'forceN' },
                { text: 'Kilonewtons (kN)', value: 'forcekN' },
            ],
        },
        {
            text: 'flow',
            submenu: [
                { text: 'Gallons/min (gpm)', value: 'flowgpm' },
                { text: 'Cubic meters/sec (cms)', value: 'flowcms' },
                { text: 'Cubic feet/sec (cfs)', value: 'flowcfs' },
                { text: 'Cubic feet/min (cfm)', value: 'flowcfm' },
            ],
        },
        {
            text: 'angle',
            submenu: [
                { text: 'Degrees (°)', value: 'degree' },
                { text: 'Radians', value: 'radian' },
                { text: 'Gradian', value: 'grad' },
            ],
        },
        {
            text: 'acceleration',
            submenu: [
                { text: 'Meters/sec²', value: 'accMS2' },
                { text: 'Feet/sec²', value: 'accFS2' },
                { text: 'G unit', value: 'accG' },
            ],
        },
        {
            text: 'radiation',
            submenu: [
                { text: 'Becquerel (Bq)', value: 'radbq' },
                { text: 'curie (Ci)', value: 'radci' },
                { text: 'Gray (Gy)', value: 'radgy' },
                { text: 'rad', value: 'radrad' },
                { text: 'Sievert (Sv)', value: 'radsv' },
                { text: 'rem', value: 'radrem' },
                { text: 'Exposure (C/kg)', value: 'radexpckg' },
                { text: 'roentgen (R)', value: 'radr' },
                { text: 'Sievert/hour (Sv/h)', value: 'radsvh' },
            ],
        },
        {
            text: 'concentration',
            submenu: [
                { text: 'parts-per-million (ppm)', value: 'ppm' },
                { text: 'parts-per-billion (ppb)', value: 'conppb' },
                { text: 'nanogram per cubic metre (ng/m3)', value: 'conngm3' },
                { text: 'nanogram per normal cubic metre (ng/Nm3)', value: 'conngNm3' },
                { text: 'microgram per cubic metre (μg/m3)', value: 'conμgm3' },
                { text: 'microgram per normal cubic metre (μg/Nm3)', value: 'conμgNm3' },
                { text: 'milligram per cubic metre (mg/m3)', value: 'conmgm3' },
                { text: 'milligram per normal cubic metre (mg/Nm3)', value: 'conmgNm3' },
                { text: 'gram per cubic metre (g/m3)', value: 'congm3' },
                { text: 'gram per normal cubic metre (g/Nm3)', value: 'congNm3' },
            ],
        },
    ];
};
/* harmony default export */ __webpack_exports__["a"] = (kbn);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_dash_class__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_dropdown_typeahead__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_metric_segment__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_misc__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_ng_model_on_blur__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_tags__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_value_select_dropdown__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_rebuild_on_change__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_give_focus__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_diff_view__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__jquery_extended__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__jquery_extended___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__jquery_extended__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__partials__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__partials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__partials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_jsontree_jsontree__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_code_editor_code_editor__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_outline__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__utils_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_colorpicker_ColorPicker__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_colorpicker_SeriesColorPicker__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_colorpicker_spectrum_picker__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_search_srv__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_ng_react__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_grafana_app__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_sidemenu_sidemenu__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_search_search__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_info_popover__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_navbar_navbar__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__directives_array_join__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__live_live_srv__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_emitter__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_layout_selector_layout_selector__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_switch__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_dashboard_selector__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_query_part_query_part_editor__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_form_dropdown_form_dropdown__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_app_core_controllers_all__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_app_core_services_all__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__filters_filters__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__app_events__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__utils_colors__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__utils_model_utils__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__services_context_srv__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__services_keybindingSrv__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_help_help__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_json_explorer_json_explorer__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__nav_model_srv__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_user_picker__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_team_picker__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_scroll_scroll__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_scroll_page_scroll__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_gf_page__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_org_switcher__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__profiler__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__angular_wrappers__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__time_series2__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_search_search_results__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_manage_dashboards_manage_dashboards__ = __webpack_require__(1040);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_51__profiler__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_52__angular_wrappers__["a"]; });
/* unused harmony reexport arrayJoin */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_36__core_module__["a"]; });
/* unused harmony reexport grafanaAppDirective */
/* unused harmony reexport sideMenuDirective */
/* unused harmony reexport navbarDirective */
/* unused harmony reexport searchDirective */
/* unused harmony reexport liveSrv */
/* unused harmony reexport layoutSelector */
/* unused harmony reexport switchDirective */
/* unused harmony reexport infoPopover */
/* unused harmony reexport Emitter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_37__app_events__["a"]; });
/* unused harmony reexport dashboardSelector */
/* unused harmony reexport queryPartEditorDirective */
/* unused harmony reexport colors */
/* unused harmony reexport formDropdownDirective */
/* unused harmony reexport assignModelProperties */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_40__services_context_srv__["a"]; });
/* unused harmony reexport KeybindingSrv */
/* unused harmony reexport helpModal */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_43__components_json_explorer_json_explorer__["a"]; });
/* unused harmony reexport NavModelSrv */
/* unused harmony reexport NavModel */
/* unused harmony reexport userPicker */
/* unused harmony reexport teamPicker */
/* unused harmony reexport geminiScrollbar */
/* unused harmony reexport pageScrollbar */
/* unused harmony reexport gfPageDirective */
/* unused harmony reexport orgSwitcher */
/* unused harmony reexport manageDashboardsDirective */
/* unused harmony reexport TimeSeries */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_53__time_series2__["c"]; });
/* unused harmony reexport searchResultsDirective */




























































/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(22);

var _stripBaseFromUrl = function (url) {
    var appSubUrl = __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].appSubUrl;
    var stripExtraChars = appSubUrl.endsWith('/') ? 1 : 0;
    var urlWithoutBase = url.length > 0 && url.indexOf(appSubUrl) === 0 ? url.slice(appSubUrl.length - stripExtraChars) : url;
    return urlWithoutBase;
};
/* harmony default export */ __webpack_exports__["a"] = ({
    stripBaseFromUrl: _stripBaseFromUrl,
});


/***/ }),
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GRID_CELL_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GRID_CELL_VMARGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GRID_COLUMN_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REPEAT_DIR_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_PANEL_SPAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ROW_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MIN_PANEL_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LS_PANEL_COPY_KEY; });
var GRID_CELL_HEIGHT = 30;
var GRID_CELL_VMARGIN = 10;
var GRID_COLUMN_COUNT = 24;
var REPEAT_DIR_VERTICAL = 'v';
var DEFAULT_PANEL_SPAN = 4;
var DEFAULT_ROW_HEIGHT = 250;
var MIN_PANEL_HEIGHT = GRID_CELL_HEIGHT * 3;
var LS_PANEL_COPY_KEY = 'panel-copy';


/***/ }),
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(145);
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanelModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_utils_emitter__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);


var notPersistedProperties = {
    events: true,
    fullscreen: true,
    isEditing: true,
};
var PanelModel = /** @class */ (function () {
    function PanelModel(model) {
        this.events = new __WEBPACK_IMPORTED_MODULE_0_app_core_utils_emitter__["a" /* Emitter */]();
        // copy properties from persisted model
        for (var property in model) {
            this[property] = model[property];
        }
        if (!this.gridPos) {
            this.gridPos = { x: 0, y: 0, h: 3, w: 6 };
        }
    }
    PanelModel.prototype.getSaveModel = function () {
        var model = {};
        for (var property in this) {
            if (notPersistedProperties[property] || !this.hasOwnProperty(property)) {
                continue;
            }
            model[property] = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this[property]);
        }
        return model;
    };
    PanelModel.prototype.setViewMode = function (fullscreen, isEditing) {
        this.fullscreen = fullscreen;
        this.isEditing = isEditing;
        this.events.emit('panel-size-changed');
    };
    PanelModel.prototype.updateGridPos = function (newPos) {
        var sizeChanged = false;
        if (this.gridPos.w !== newPos.w || this.gridPos.h !== newPos.h) {
            sizeChanged = true;
        }
        this.gridPos.x = newPos.x;
        this.gridPos.y = newPos.y;
        this.gridPos.w = newPos.w;
        this.gridPos.h = newPos.h;
        if (sizeChanged) {
            console.log('PanelModel sizeChanged event and render events fired');
            this.events.emit('panel-size-changed');
        }
    };
    PanelModel.prototype.resizeDone = function () {
        this.events.emit('panel-size-changed');
    };
    PanelModel.prototype.destroy = function () {
        this.events.removeAllListeners();
    };
    return PanelModel;
}());



/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTagColorsFromName */
var TAG_COLORS = [
    '#E24D42',
    '#1F78C1',
    '#BA43A9',
    '#705DA0',
    '#466803',
    '#508642',
    '#447EBC',
    '#C15C17',
    '#890F02',
    '#757575',
    '#0A437C',
    '#6D1F62',
    '#584477',
    '#629E51',
    '#2F4F4F',
    '#BF1B00',
    '#806EB7',
    '#8a2eb8',
    '#699e00',
    '#000000',
    '#3F6833',
    '#2F575E',
    '#99440A',
    '#E0752D',
    '#0E4AB4',
    '#58140C',
    '#052B51',
    '#511749',
    '#3F2B5B',
];
var TAG_BORDER_COLORS = [
    '#FF7368',
    '#459EE7',
    '#E069CF',
    '#9683C6',
    '#6C8E29',
    '#76AC68',
    '#6AA4E2',
    '#E7823D',
    '#AF3528',
    '#9B9B9B',
    '#3069A2',
    '#934588',
    '#7E6A9D',
    '#88C477',
    '#557575',
    '#E54126',
    '#A694DD',
    '#B054DE',
    '#8FC426',
    '#262626',
    '#658E59',
    '#557D84',
    '#BF6A30',
    '#FF9B53',
    '#3470DA',
    '#7E3A32',
    '#2B5177',
    '#773D6F',
    '#655181',
];
/**
 * Returns tag badge background and border colors based on hashed tag name.
 * @param name tag name
 */
function getTagColorsFromName(name) {
    var hash = djb2(name.toLowerCase());
    var color = TAG_COLORS[Math.abs(hash % TAG_COLORS.length)];
    var borderColor = TAG_BORDER_COLORS[Math.abs(hash % TAG_BORDER_COLORS.length)];
    return { color: color, borderColor: borderColor };
}
function djb2(str) {
    var hash = 5381;
    for (var i = 0; i < str.length; i++) {
        hash = (hash << 5) + hash + str.charCodeAt(i); /* hash * 33 + c */
    }
    return hash;
}
/* harmony default export */ __webpack_exports__["a"] = ({
    getTagColorsFromName: getTagColorsFromName,
});


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonExplorer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
// Based on work https://github.com/mohsen1/json-formatter-js
// Licence MIT, Copyright (c) 2015 Mohsen Azimi


var DATE_STRING_REGEX = /(^\d{1,4}[\.|\\/|-]\d{1,2}[\.|\\/|-]\d{1,4})(\s*(?:0?[1-9]:[0-5]|1(?=[012])\d:[0-5])\d\s*[ap]m)?$/;
var PARTIAL_DATE_REGEX = /\d{2}:\d{2}:\d{2} GMT-\d{4}/;
var JSON_DATE_REGEX = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
// When toggleing, don't animated removal or addition of more than a few items
var MAX_ANIMATED_TOGGLE_ITEMS = 10;
var requestAnimationFrame = window.requestAnimationFrame ||
    function (cb) {
        cb();
        return 0;
    };
var _defaultConfig = {
    animateOpen: true,
    animateClose: true,
    theme: null,
};
/**
 * @class JsonExplorer
 *
 * JsonExplorer allows you to render JSON objects in HTML with a
 * **collapsible** navigation.
 */
var JsonExplorer = /** @class */ (function () {
    /**
     * @param {object} json The JSON object you want to render. It has to be an
     * object or array. Do NOT pass raw JSON string.
     *
     * @param {number} [open=1] his number indicates up to how many levels the
     * rendered tree should expand. Set it to `0` to make the whole tree collapsed
     * or set it to `Infinity` to expand the tree deeply
     *
     * @param {object} [config=defaultConfig] -
     *  defaultConfig = {
     *   hoverPreviewEnabled: false,
     *   hoverPreviewArrayCount: 100,
     *   hoverPreviewFieldCount: 5
     * }
     *
     * Available configurations:
     *  #####Hover Preview
     * * `hoverPreviewEnabled`:  enable preview on hover
     * * `hoverPreviewArrayCount`: number of array items to show in preview Any
     *    array larger than this number will be shown as `Array[XXX]` where `XXX`
     *    is length of the array.
     * * `hoverPreviewFieldCount`: number of object properties to show for object
     *   preview. Any object with more properties that thin number will be
     *   truncated.
     *
     * @param {string} [key=undefined] The key that this object in it's parent
     * context
     */
    function JsonExplorer(json, open, config, key) {
        if (open === void 0) { open = 1; }
        if (config === void 0) { config = _defaultConfig; }
        this.json = json;
        this.open = open;
        this.config = config;
        this.key = key;
        // Hold the open state after the toggler is used
        this._isOpen = null;
        this.skipChildren = false;
    }
    Object.defineProperty(JsonExplorer.prototype, "isOpen", {
        /*
         * is formatter open?
        */
        get: function () {
            if (this._isOpen !== null) {
                return this._isOpen;
            }
            else {
                return this.open > 0;
            }
        },
        /*
         * set open state (from toggler)
        */
        set: function (value) {
            this._isOpen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isDate", {
        /*
         * is this a date string?
        */
        get: function () {
            return (this.type === 'string' &&
                (DATE_STRING_REGEX.test(this.json) || JSON_DATE_REGEX.test(this.json) || PARTIAL_DATE_REGEX.test(this.json)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isUrl", {
        /*
         * is this a URL string?
        */
        get: function () {
            return this.type === 'string' && this.json.indexOf('http') === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isArray", {
        /*
         * is this an array?
        */
        get: function () {
            return Array.isArray(this.json);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isObject", {
        /*
         * is this an object?
         * Note: In this context arrays are object as well
        */
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["f" /* isObject */])(this.json);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isEmptyObject", {
        /*
         * is this an empty object with no properties?
        */
        get: function () {
            return !this.keys.length && !this.isArray;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "isEmpty", {
        /*
         * is this an empty object or array?
        */
        get: function () {
            return this.isEmptyObject || (this.keys && !this.keys.length && this.isArray);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "hasKey", {
        /*
         * did we receive a key argument?
         * This means that the formatter was called as a sub formatter of a parent formatter
        */
        get: function () {
            return typeof this.key !== 'undefined';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "constructorName", {
        /*
         * if this is an object, get constructor function name
        */
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["c" /* getObjectName */])(this.json);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "type", {
        /*
         * get type of this value
         * Possible values: all JavaScript primitive types plus "array" and "null"
        */
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getType */])(this.json);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JsonExplorer.prototype, "keys", {
        /*
         * get object keys
         * If there is an empty key we pad it wit quotes to make it visible
        */
        get: function () {
            if (this.isObject) {
                return Object.keys(this.json).map(function (key) { return (key ? key : '""'); });
            }
            else {
                return [];
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggles `isOpen` state
     *
     */
    JsonExplorer.prototype.toggleOpen = function () {
        this.isOpen = !this.isOpen;
        if (this.element) {
            if (this.isOpen) {
                this.appendChildren(this.config.animateOpen);
            }
            else {
                this.removeChildren(this.config.animateClose);
            }
            this.element.classList.toggle(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('open'));
        }
    };
    /**
     * Open all children up to a certain depth.
     * Allows actions such as expand all/collapse all
     *
     */
    JsonExplorer.prototype.openAtDepth = function (depth) {
        if (depth === void 0) { depth = 1; }
        if (depth < 0) {
            return;
        }
        this.open = depth;
        this.isOpen = depth !== 0;
        if (this.element) {
            this.removeChildren(false);
            if (depth === 0) {
                this.element.classList.remove(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('open'));
            }
            else {
                this.appendChildren(this.config.animateOpen);
                this.element.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('open'));
            }
        }
    };
    JsonExplorer.prototype.isNumberArray = function () {
        return this.json.length > 0 && this.json.length < 4 && (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNumber(this.json[0]) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNumber(this.json[1]));
    };
    JsonExplorer.prototype.renderArray = function () {
        var arrayWrapperSpan = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span');
        arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'bracket', '['));
        // some pretty handling of number arrays
        if (this.isNumberArray()) {
            this.json.forEach(function (val, index) {
                if (index > 0) {
                    arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'array-comma', ','));
                }
                arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'number', val));
            });
            this.skipChildren = true;
        }
        else {
            arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'number', this.json.length));
        }
        arrayWrapperSpan.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'bracket', ']'));
        return arrayWrapperSpan;
    };
    /**
     * Renders an HTML element and installs event listeners
     *
     * @returns {HTMLDivElement}
     */
    JsonExplorer.prototype.render = function (skipRoot) {
        if (skipRoot === void 0) { skipRoot = false; }
        // construct the root element and assign it to this.element
        this.element = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('div', 'row');
        // construct the toggler link
        var togglerLink = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('a', 'toggler-link');
        var togglerIcon = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'toggler');
        // if this is an object we need a wrapper span (toggler)
        if (this.isObject) {
            togglerLink.appendChild(togglerIcon);
        }
        // if this is child of a parent formatter we need to append the key
        if (this.hasKey) {
            togglerLink.appendChild(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'key', this.key + ":"));
        }
        // Value for objects and arrays
        if (this.isObject) {
            // construct the value holder element
            var value = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'value');
            // we need a wrapper span for objects
            var objectWrapperSpan = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span');
            // get constructor name and append it to wrapper span
            var constructorName = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span', 'constructor-name', this.constructorName);
            objectWrapperSpan.appendChild(constructorName);
            // if it's an array append the array specific elements like brackets and length
            if (this.isArray) {
                var arrayWrapperSpan = this.renderArray();
                objectWrapperSpan.appendChild(arrayWrapperSpan);
            }
            // append object wrapper span to toggler link
            value.appendChild(objectWrapperSpan);
            togglerLink.appendChild(value);
            // Primitive values
        }
        else {
            // make a value holder element
            var value = this.isUrl ? Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('a') : Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('span');
            // add type and other type related CSS classes
            value.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])(this.type));
            if (this.isDate) {
                value.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('date'));
            }
            if (this.isUrl) {
                value.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('url'));
                value.setAttribute('href', this.json);
            }
            // Append value content to value element
            var valuePreview = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* getValuePreview */])(this.json, this.json);
            value.appendChild(document.createTextNode(valuePreview));
            // append the value element to toggler link
            togglerLink.appendChild(value);
        }
        // construct a children element
        var children = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* createElement */])('div', 'children');
        // set CSS classes for children
        if (this.isObject) {
            children.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('object'));
        }
        if (this.isArray) {
            children.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('array'));
        }
        if (this.isEmpty) {
            children.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('empty'));
        }
        // set CSS classes for root element
        if (this.config && this.config.theme) {
            this.element.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])(this.config.theme));
        }
        if (this.isOpen) {
            this.element.classList.add(Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('open'));
        }
        // append toggler and children elements to root element
        if (!skipRoot) {
            this.element.appendChild(togglerLink);
        }
        if (!this.skipChildren) {
            this.element.appendChild(children);
        }
        else {
            // remove togglerIcon
            togglerLink.removeChild(togglerIcon);
        }
        // if formatter is set to be open call appendChildren
        if (this.isObject && this.isOpen) {
            this.appendChildren();
        }
        // add event listener for toggling
        if (this.isObject) {
            togglerLink.addEventListener('click', this.toggleOpen.bind(this));
        }
        return this.element;
    };
    /**
     * Appends all the children to children element
     * Animated option is used when user triggers this via a click
     */
    JsonExplorer.prototype.appendChildren = function (animated) {
        var _this = this;
        if (animated === void 0) { animated = false; }
        var children = this.element.querySelector("div." + Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('children'));
        if (!children || this.isEmpty) {
            return;
        }
        if (animated) {
            var index_1 = 0;
            var addAChild_1 = function () {
                var key = _this.keys[index_1];
                var formatter = new JsonExplorer(_this.json[key], _this.open - 1, _this.config, key);
                children.appendChild(formatter.render());
                index_1 += 1;
                if (index_1 < _this.keys.length) {
                    if (index_1 > MAX_ANIMATED_TOGGLE_ITEMS) {
                        addAChild_1();
                    }
                    else {
                        requestAnimationFrame(addAChild_1);
                    }
                }
            };
            requestAnimationFrame(addAChild_1);
        }
        else {
            this.keys.forEach(function (key) {
                var formatter = new JsonExplorer(_this.json[key], _this.open - 1, _this.config, key);
                children.appendChild(formatter.render());
            });
        }
    };
    /**
     * Removes all the children from children element
     * Animated option is used when user triggers this via a click
     */
    JsonExplorer.prototype.removeChildren = function (animated) {
        if (animated === void 0) { animated = false; }
        var childrenElement = this.element.querySelector("div." + Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* cssClass */])('children'));
        if (animated) {
            var childrenRemoved_1 = 0;
            var removeAChild_1 = function () {
                if (childrenElement && childrenElement.children.length) {
                    childrenElement.removeChild(childrenElement.children[0]);
                    childrenRemoved_1 += 1;
                    if (childrenRemoved_1 > MAX_ANIMATED_TOGGLE_ITEMS) {
                        removeAChild_1();
                    }
                    else {
                        requestAnimationFrame(removeAChild_1);
                    }
                }
            };
            requestAnimationFrame(removeAChild_1);
        }
        else {
            if (childrenElement) {
                childrenElement.innerHTML = '';
            }
        }
    };
    return JsonExplorer;
}());



/***/ }),
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPickerPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinycolor2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tinycolor2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColorPalette__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpectrumPicker__ = __webpack_require__(942);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DEFAULT_COLOR = '#000000';
var ColorPickerPopover = /** @class */ (function (_super) {
    __extends(ColorPickerPopover, _super);
    function ColorPickerPopover(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            tab: 'palette',
            color: _this.props.color || DEFAULT_COLOR,
            colorString: _this.props.color || DEFAULT_COLOR
        };
        return _this;
    }
    ColorPickerPopover.prototype.setPickerNavElem = function (elem) {
        this.pickerNavElem = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem);
    };
    ColorPickerPopover.prototype.setColor = function (color) {
        var newColor = __WEBPACK_IMPORTED_MODULE_2_tinycolor2___default()(color);
        if (newColor.isValid()) {
            this.setState({
                color: newColor.toString(),
                colorString: newColor.toString()
            });
            this.props.onColorSelect(color);
        }
    };
    ColorPickerPopover.prototype.sampleColorSelected = function (color) {
        this.setColor(color);
    };
    ColorPickerPopover.prototype.spectrumColorSelected = function (color) {
        var rgbColor = color.toRgbString();
        this.setColor(rgbColor);
    };
    ColorPickerPopover.prototype.onColorStringChange = function (e) {
        var colorString = e.target.value;
        this.setState({
            colorString: colorString
        });
        var newColor = __WEBPACK_IMPORTED_MODULE_2_tinycolor2___default()(colorString);
        if (newColor.isValid()) {
            // Update only color state
            var newColorString = newColor.toString();
            this.setState({
                color: newColorString,
            });
            this.props.onColorSelect(newColorString);
        }
    };
    ColorPickerPopover.prototype.onColorStringBlur = function (e) {
        var colorString = e.target.value;
        this.setColor(colorString);
    };
    ColorPickerPopover.prototype.componentDidMount = function () {
        var _this = this;
        this.pickerNavElem.find('li:first').addClass('active');
        this.pickerNavElem.on('show', function (e) {
            // use href attr (#name => name)
            var tab = e.target.hash.slice(1);
            _this.setState({
                tab: tab
            });
        });
    };
    ColorPickerPopover.prototype.render = function () {
        var paletteTab = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "palette" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ColorPalette__["a" /* ColorPalette */], { color: this.state.color, onColorSelect: this.sampleColorSelected.bind(this) })));
        var spectrumTab = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "spectrum" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SpectrumPicker__["a" /* SpectrumPicker */], { color: this.state.color, onColorSelect: this.spectrumColorSelected.bind(this), options: {} })));
        var currentTab = this.state.tab === 'palette' ? paletteTab : spectrumTab;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-color-picker" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { className: "nav nav-tabs", id: "colorpickernav", ref: this.setPickerNavElem.bind(this) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "gf-tabs-item-colorpicker" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "#palette", "data-toggle": "tab" }, "Colors")),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "gf-tabs-item-colorpicker" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "#spectrum", "data-toggle": "tab" }, "Custom"))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-color-picker__body" }, currentTab),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { className: "gf-form-input gf-form-input--small", value: this.state.colorString, onChange: this.onColorStringChange.bind(this), onBlur: this.onColorStringBlur.bind(this) }))));
    };
    return ColorPickerPopover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Profiler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profiler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);


var Profiler = /** @class */ (function () {
    function Profiler() {
    }
    Profiler.prototype.init = function (config, $rootScope) {
        var _this = this;
        this.enabled = config.buildInfo.env === 'development';
        this.timings = {};
        this.timings.appStart = { loadStart: new Date().getTime() };
        this.$rootScope = $rootScope;
        if (!this.enabled) {
            return;
        }
        $rootScope.$watch(function () {
            _this.digestCounter++;
            return false;
        }, function () { });
        $rootScope.onAppEvent('refresh', this.refresh.bind(this), $rootScope);
        $rootScope.onAppEvent('dashboard-fetch-end', this.dashboardFetched.bind(this), $rootScope);
        $rootScope.onAppEvent('dashboard-initialized', this.dashboardInitialized.bind(this), $rootScope);
        $rootScope.onAppEvent('panel-initialized', this.panelInitialized.bind(this), $rootScope);
    };
    Profiler.prototype.refresh = function () {
        var _this = this;
        this.timings.query = 0;
        this.timings.render = 0;
        setTimeout(function () {
            console.log('panel count: ' + _this.panelsInitCount);
            console.log('total query: ' + _this.timings.query);
            console.log('total render: ' + _this.timings.render);
            console.log('avg render: ' + _this.timings.render / _this.panelsInitCount);
        }, 5000);
    };
    Profiler.prototype.dashboardFetched = function () {
        this.timings.dashboardLoadStart = new Date().getTime();
        this.panelsInitCount = 0;
        this.digestCounter = 0;
        this.panelsInitCount = 0;
        this.panelsRendered = 0;
        this.timings.query = 0;
        this.timings.render = 0;
    };
    Profiler.prototype.dashboardInitialized = function () {
        var _this = this;
        setTimeout(function () {
            console.log('Dashboard::Performance Total Digests: ' + _this.digestCounter);
            console.log('Dashboard::Performance Total Watchers: ' + _this.getTotalWatcherCount());
            console.log('Dashboard::Performance Total ScopeCount: ' + _this.scopeCount);
            var timeTaken = _this.timings.lastPanelInitializedAt - _this.timings.dashboardLoadStart;
            console.log('Dashboard::Performance All panels initialized in ' + timeTaken + ' ms');
            // measure digest performance
            var rootDigestStart = window.performance.now();
            for (var i = 0; i < 30; i++) {
                _this.$rootScope.$apply();
            }
            console.log('Dashboard::Performance Root Digest ' + (window.performance.now() - rootDigestStart) / 30);
        }, 3000);
    };
    Profiler.prototype.getTotalWatcherCount = function () {
        var count = 0;
        var scopes = 0;
        var root = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByTagName('body'));
        var f = function (element) {
            if (element.data().hasOwnProperty('$scope')) {
                scopes++;
                __WEBPACK_IMPORTED_MODULE_1_angular___default.a.forEach(element.data().$scope.$$watchers, function () {
                    count++;
                });
            }
            __WEBPACK_IMPORTED_MODULE_1_angular___default.a.forEach(element.children(), function (childElement) {
                f(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(childElement));
            });
        };
        f(root);
        this.scopeCount = scopes;
        return count;
    };
    Profiler.prototype.renderingCompleted = function (panelId, panelTimings) {
        // add render counter to root scope
        // used by phantomjs render.js to know when panel has rendered
        this.panelsRendered = (this.panelsRendered || 0) + 1;
        this.$rootScope.panelsRendered = this.panelsRendered;
        if (this.enabled) {
            panelTimings.renderEnd = new Date().getTime();
            this.timings.query += panelTimings.queryEnd - panelTimings.queryStart;
            this.timings.render += panelTimings.renderEnd - panelTimings.renderStart;
        }
    };
    Profiler.prototype.panelInitialized = function () {
        if (!this.enabled) {
            return;
        }
        this.panelsInitCount++;
        this.timings.lastPanelInitializedAt = new Date().getTime();
    };
    return Profiler;
}());

var profiler = new Profiler();



/***/ }),
/* 399 */,
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setStateFields;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_features_alerting_alert_def__ = __webpack_require__(518);


function setStateFields(rule, state) {
    var stateModel = __WEBPACK_IMPORTED_MODULE_1_app_features_alerting_alert_def__["a" /* default */].getStateDisplayModel(state);
    rule.state = state;
    rule.stateText = stateModel.text;
    rule.stateIcon = stateModel.iconClass;
    rule.stateClass = stateModel.stateClass;
    rule.stateAge = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rule.newStateDate)
        .fromNow()
        .replace(' ago', '');
}


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagBadge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_utils_tags__ = __webpack_require__(393);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var TagBadge = /** @class */ (function (_super) {
    __extends(TagBadge, _super);
    function TagBadge(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    TagBadge.prototype.onClick = function (event) {
        this.props.onClick(event);
    };
    TagBadge.prototype.render = function () {
        var _a = this.props, label = _a.label, removeIcon = _a.removeIcon, count = _a.count;
        var _b = __WEBPACK_IMPORTED_MODULE_1_app_core_utils_tags__["a" /* default */].getTagColorsFromName(label), color = _b.color, borderColor = _b.borderColor;
        var tagStyle = {
            backgroundColor: color,
            borderColor: borderColor,
        };
        var countLabel = count !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "tag-count-label" }, "(" + count + ")");
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "label label-tag", onClick: this.onClick, style: tagStyle },
            removeIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-remove" }),
            label,
            " ",
            countLabel));
    };
    return TagBadge;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PickerOption__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withPicker__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var UserPicker = /** @class */ (function (_super) {
    __extends(UserPicker, _super);
    function UserPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.search = _this.search.bind(_this);
        _this.debouncedSearch = Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["debounce"])(_this.search, 300, {
            leading: true,
            trailing: true,
        });
        return _this;
    }
    UserPicker.prototype.search = function (query) {
        var _a = this.props, toggleLoading = _a.toggleLoading, backendSrv = _a.backendSrv;
        toggleLoading(true);
        return backendSrv.get("/api/org/users?query=" + query + "&limit=10").then(function (result) {
            var users = result.map(function (user) {
                return {
                    id: user.userId,
                    label: user.login + " - " + user.email,
                    avatarUrl: user.avatarUrl,
                    login: user.login,
                };
            });
            toggleLoading(false);
            return { options: users };
        });
    };
    UserPicker.prototype.render = function () {
        var AsyncComponent = this.state.creatable ? __WEBPACK_IMPORTED_MODULE_1_react_select__["default"].AsyncCreatable : __WEBPACK_IMPORTED_MODULE_1_react_select__["default"].Async;
        var _a = this.props, isLoading = _a.isLoading, handlePicked = _a.handlePicked, value = _a.value, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "user-picker" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AsyncComponent, { valueKey: "id", multi: false, labelKey: "label", cache: false, isLoading: isLoading, loadOptions: this.debouncedSearch, loadingPlaceholder: "Loading...", noResultsText: "No users found", onChange: handlePicked, className: "gf-form-input gf-form-input--form-dropdown " + (className || ''), optionComponent: __WEBPACK_IMPORTED_MODULE_2__PickerOption__["a" /* default */], placeholder: "Choose", value: value, autosize: true })));
    };
    return UserPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__withPicker__["a" /* default */])(UserPicker));


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UserPickerOption = /** @class */ (function (_super) {
    __extends(UserPickerOption, _super);
    function UserPickerOption(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        return _this;
    }
    UserPickerOption.prototype.handleMouseDown = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    };
    UserPickerOption.prototype.handleMouseEnter = function (event) {
        this.props.onFocus(this.props.option, event);
    };
    UserPickerOption.prototype.handleMouseMove = function (event) {
        if (this.props.isFocused) {
            return;
        }
        this.props.onFocus(this.props.option, event);
    };
    UserPickerOption.prototype.render = function () {
        var _a = this.props, option = _a.option, children = _a.children, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onMouseDown: this.handleMouseDown, onMouseEnter: this.handleMouseEnter, onMouseMove: this.handleMouseMove, title: option.title, className: "user-picker-option__button btn btn-link " + className },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: option.avatarUrl, alt: option.label, className: "user-picker-option__avatar" }),
            children));
    };
    return UserPickerOption;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (UserPickerOption);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withPicker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

function withPicker(WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(WithPicker, _super);
        function WithPicker(props) {
            var _this = _super.call(this, props) || this;
            _this.toggleLoading = _this.toggleLoading.bind(_this);
            _this.state = {
                isLoading: false,
            };
            return _this;
        }
        WithPicker.prototype.toggleLoading = function (isLoading) {
            this.setState(function (prevState) {
                return __assign({}, prevState, { isLoading: isLoading });
            });
        };
        WithPicker.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, __assign({ toggleLoading: this.toggleLoading, isLoading: this.state.isLoading }, this.props));
        };
        return WithPicker;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
}


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PermissionsList__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(32);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Permissions = /** @class */ (function (_super) {
    __extends(Permissions, _super);
    function Permissions(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, dashboardId = _a.dashboardId, isFolder = _a.isFolder, folderInfo = _a.folderInfo;
        _this.permissionChanged = _this.permissionChanged.bind(_this);
        _this.typeChanged = _this.typeChanged.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        _this.loadStore(dashboardId, isFolder, folderInfo && folderInfo.id === 0);
        return _this;
    }
    Permissions.prototype.loadStore = function (dashboardId, isFolder, isInRoot) {
        if (isInRoot === void 0) { isInRoot = false; }
        return this.props.permissions.load(dashboardId, isFolder, isInRoot);
    };
    Permissions.prototype.permissionChanged = function (index, permission, permissionName) {
        var permissions = this.props.permissions;
        permissions.updatePermissionOnIndex(index, permission, permissionName);
    };
    Permissions.prototype.removeItem = function (index) {
        var permissions = this.props.permissions;
        permissions.removeStoreItem(index);
    };
    Permissions.prototype.resetNewType = function () {
        var permissions = this.props.permissions;
        permissions.resetNewType();
    };
    Permissions.prototype.typeChanged = function (evt) {
        var value = evt.target.value;
        var _a = this.props, permissions = _a.permissions, dashboardId = _a.dashboardId;
        if (value === 'Viewer' || value === 'Editor') {
            permissions.addStoreItem({ permission: 1, role: value, dashboardId: dashboardId }, dashboardId);
            this.resetNewType();
            return;
        }
        permissions.setNewType(value);
    };
    Permissions.prototype.render = function () {
        var _a = this.props, permissions = _a.permissions, folderInfo = _a.folderInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PermissionsList__["a" /* default */], { permissions: permissions.items, removeItem: this.removeItem, permissionChanged: this.permissionChanged, fetching: permissions.fetching, folderInfo: folderInfo })));
    };
    Permissions = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], Permissions);
    return Permissions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Permissions);


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withTooltip__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_popper__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_popper__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.showTooltip = _this.showTooltip.bind(_this);
        _this.hideTooltip = _this.hideTooltip.bind(_this);
        return _this;
    }
    Tooltip.prototype.showTooltip = function () {
        var tooltipSetState = this.props.tooltipSetState;
        tooltipSetState(function (prevState) {
            return __assign({}, prevState, { show: true });
        });
    };
    Tooltip.prototype.hideTooltip = function () {
        var tooltipSetState = this.props.tooltipSetState;
        tooltipSetState(function (prevState) {
            return __assign({}, prevState, { show: false });
        });
    };
    Tooltip.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_popper__["Target"], { className: "popper__target", onMouseOver: this.showTooltip, onMouseOut: this.hideTooltip }, this.props.children));
    };
    return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__withTooltip__["a" /* default */])(Tooltip));


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5", null, "What are Permissions?"),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "An Access Control List (ACL) model is used to limit access to Dashboard Folders. A user or a Team can be assigned permissions for a folder or for a single dashboard.")));
});;


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_PermissionsStore_PermissionsStore__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_components_Picker_UserPicker__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_components_Picker_TeamPicker__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_components_Picker_DescriptionPicker__ = __webpack_require__(177);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var AddPermissions = /** @class */ (function (_super) {
    __extends(AddPermissions, _super);
    function AddPermissions(props) {
        var _this = _super.call(this, props) || this;
        _this.userPicked = _this.userPicked.bind(_this);
        _this.teamPicked = _this.teamPicked.bind(_this);
        _this.permissionPicked = _this.permissionPicked.bind(_this);
        _this.typeChanged = _this.typeChanged.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }
    AddPermissions.prototype.componentWillMount = function () {
        var permissions = this.props.permissions;
        permissions.resetNewType();
    };
    AddPermissions.prototype.typeChanged = function (evt) {
        var value = evt.target.value;
        var permissions = this.props.permissions;
        permissions.setNewType(value);
    };
    AddPermissions.prototype.userPicked = function (user) {
        var permissions = this.props.permissions;
        if (!user) {
            permissions.newItem.setUser(null, null);
            return;
        }
        return permissions.newItem.setUser(user.id, user.login, user.avatarUrl);
    };
    AddPermissions.prototype.teamPicked = function (team) {
        var permissions = this.props.permissions;
        if (!team) {
            permissions.newItem.setTeam(null, null);
            return;
        }
        return permissions.newItem.setTeam(team.id, team.name, team.avatarUrl);
    };
    AddPermissions.prototype.permissionPicked = function (permission) {
        var permissions = this.props.permissions;
        return permissions.newItem.setPermission(permission.value);
    };
    AddPermissions.prototype.resetNewType = function () {
        var permissions = this.props.permissions;
        return permissions.resetNewType();
    };
    AddPermissions.prototype.handleSubmit = function (evt) {
        evt.preventDefault();
        var permissions = this.props.permissions;
        permissions.addStoreItem();
    };
    AddPermissions.prototype.render = function () {
        var _a = this.props, permissions = _a.permissions, backendSrv = _a.backendSrv;
        var newItem = permissions.newItem;
        var pickerClassName = 'width-20';
        var isValid = newItem.isValid();
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form-inline cta-form" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "cta-form__close btn btn-transparent", onClick: permissions.hideAddPermissions },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", { name: "addPermission", onSubmit: this.handleSubmit },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6", null, "Add Permission For"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form-select-wrapper" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", { className: "gf-form-input gf-size-auto", value: newItem.type, onChange: this.typeChanged }, __WEBPACK_IMPORTED_MODULE_2_app_stores_PermissionsStore_PermissionsStore__["b" /* aclTypes */].map(function (option, idx) {
                                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: idx, value: option.value }, option.text));
                            })))),
                    newItem.type === 'User' ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_core_components_Picker_UserPicker__["a" /* default */], { backendSrv: backendSrv, handlePicked: this.userPicked, value: newItem.userId, className: pickerClassName }))) : null,
                    newItem.type === 'Group' ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_core_components_Picker_TeamPicker__["a" /* default */], { backendSrv: backendSrv, handlePicked: this.teamPicked, value: newItem.teamId, className: pickerClassName }))) : null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_core_components_Picker_DescriptionPicker__["a" /* default */], { optionsWithDesc: __WEBPACK_IMPORTED_MODULE_2_app_stores_PermissionsStore_PermissionsStore__["c" /* permissionOptions */], handlePicked: this.permissionPicked, value: newItem.permission, disabled: false, className: 'gf-form-input--form-dropdown-right' })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { "data-save-permission": true, className: "btn btn-success", type: "submit", disabled: !isValid }, "Save"))))));
    };
    AddPermissions = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], AddPermissions);
    return AddPermissions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AddPermissions);


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_Transition__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_Transition__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var defaultMaxHeight = '200px'; // When animating using max-height we need to use a static value.
// If this is not enough, pass in <SlideDown maxHeight="....
var defaultDuration = 200;
var defaultStyle = {
    transition: "max-height " + defaultDuration + "ms ease-in-out",
    overflow: 'hidden',
};
/* harmony default export */ __webpack_exports__["a"] = (function (_a) {
    var children = _a.children, inProp = _a.in, _b = _a.maxHeight, maxHeight = _b === void 0 ? defaultMaxHeight : _b;
    // There are 4 main states a Transition can be in:
    // ENTERING, ENTERED, EXITING, EXITED
    // https://reactcommunity.org/react-transition-group/
    var transitionStyles = {
        exited: { maxHeight: 0 },
        entering: { maxHeight: maxHeight },
        entered: { maxHeight: maxHeight, overflow: 'visible' },
        exiting: { maxHeight: 0 },
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_Transition___default.a, { in: inProp, timeout: defaultDuration }, function (state) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: __assign({}, defaultStyle, transitionStyles[state]) }, children)); }));
});;


/***/ }),
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(145);
var toSubscriber_1 = __webpack_require__(971);
var observable_1 = __webpack_require__(523);
var pipe_1 = __webpack_require__(974);
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i - 0] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipe_1.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable.prototype.toPromise = function (PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parse"] = parse;
/* harmony export (immutable) */ __webpack_exports__["isValid"] = isValid;
/* harmony export (immutable) */ __webpack_exports__["parseDateMath"] = parseDateMath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var units = ['y', 'M', 'w', 'd', 'h', 'm', 's'];
function parse(text, roundUp, timezone) {
    if (!text) {
        return undefined;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(text)) {
        return text;
    }
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isDate(text)) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(text);
    }
    var time;
    var mathString = '';
    var index;
    var parseString;
    if (text.substring(0, 3) === 'now') {
        if (timezone === 'utc') {
            time = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc();
        }
        else {
            time = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
        }
        mathString = text.substring('now'.length);
    }
    else {
        index = text.indexOf('||');
        if (index === -1) {
            parseString = text;
            mathString = ''; // nothing else
        }
        else {
            parseString = text.substring(0, index);
            mathString = text.substring(index + 2);
        }
        // We're going to just require ISO8601 timestamps, k?
        time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(parseString, __WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601);
    }
    if (!mathString.length) {
        return time;
    }
    return parseDateMath(mathString, time, roundUp);
}
function isValid(text) {
    var date = parse(text);
    if (!date) {
        return false;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(date)) {
        return date.isValid();
    }
    return false;
}
function parseDateMath(mathString, time, roundUp) {
    var dateTime = time;
    var i = 0;
    var len = mathString.length;
    while (i < len) {
        var c = mathString.charAt(i++);
        var type;
        var num;
        var unit;
        if (c === '/') {
            type = 0;
        }
        else if (c === '+') {
            type = 1;
        }
        else if (c === '-') {
            type = 2;
        }
        else {
            return undefined;
        }
        if (isNaN(mathString.charAt(i))) {
            num = 1;
        }
        else if (mathString.length === 2) {
            num = mathString.charAt(i);
        }
        else {
            var numFrom = i;
            while (!isNaN(mathString.charAt(i))) {
                i++;
                if (i > 10) {
                    return undefined;
                }
            }
            num = parseInt(mathString.substring(numFrom, i), 10);
        }
        if (type === 0) {
            // rounding is only allowed on whole, single, units (eg M or 1M, not 0.5M or 2M)
            if (num !== 1) {
                return undefined;
            }
        }
        unit = mathString.charAt(i++);
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(units, unit)) {
            return undefined;
        }
        else {
            if (type === 0) {
                if (roundUp) {
                    dateTime.endOf(unit);
                }
                else {
                    dateTime.startOf(unit);
                }
            }
            else if (type === 1) {
                dateTime.add(num, unit);
            }
            else if (type === 2) {
                dateTime.subtract(num, unit);
            }
        }
    }
    return dateTime;
}


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(401);
var Subscription_1 = __webpack_require__(521);
var Observer_1 = __webpack_require__(403);
var rxSubscriber_1 = __webpack_require__(230);
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 514 */,
/* 515 */,
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["tickStep"] = tickStep;
/* harmony export (immutable) */ __webpack_exports__["getScaledDecimals"] = getScaledDecimals;
/* harmony export (immutable) */ __webpack_exports__["getFlotTickSize"] = getFlotTickSize;
/* harmony export (immutable) */ __webpack_exports__["getFlotRange"] = getFlotRange;
/* harmony export (immutable) */ __webpack_exports__["getFlotTickDecimals"] = getFlotTickDecimals;
/* harmony export (immutable) */ __webpack_exports__["grafanaTimeFormat"] = grafanaTimeFormat;
/* harmony export (immutable) */ __webpack_exports__["logp"] = logp;
/* harmony export (immutable) */ __webpack_exports__["getPrecision"] = getPrecision;
/* harmony export (immutable) */ __webpack_exports__["getStringPrecision"] = getStringPrecision;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_time_series2__ = __webpack_require__(144);

/**
 * Calculate tick step.
 * Implementation from d3-array (ticks.js)
 * https://github.com/d3/d3-array/blob/master/src/ticks.js
 * @param start Start value
 * @param stop End value
 * @param count Ticks count
 */
function tickStep(start, stop, count) {
    var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) {
        step1 *= 10;
    }
    else if (error >= e5) {
        step1 *= 5;
    }
    else if (error >= e2) {
        step1 *= 2;
    }
    return stop < start ? -step1 : step1;
}
function getScaledDecimals(decimals, tick_size) {
    return decimals - Math.floor(Math.log(tick_size) / Math.LN10);
}
/**
 * Calculate tick size based on min and max values, number of ticks and precision.
 * Implementation from Flot.
 * @param min           Axis minimum
 * @param max           Axis maximum
 * @param noTicks       Number of ticks
 * @param tickDecimals  Tick decimal precision
 */
function getFlotTickSize(min, max, noTicks, tickDecimals) {
    var delta = (max - min) / noTicks, dec = -Math.floor(Math.log(delta) / Math.LN10), maxDec = tickDecimals;
    var magn = Math.pow(10, -dec), norm = delta / magn, // norm is between 1.0 and 10.0
    size;
    if (norm < 1.5) {
        size = 1;
    }
    else if (norm < 3) {
        size = 2;
        // special case for 2.5, requires an extra decimal
        if (norm > 2.25 && (maxDec == null || dec + 1 <= maxDec)) {
            size = 2.5;
            ++dec;
        }
    }
    else if (norm < 7.5) {
        size = 5;
    }
    else {
        size = 10;
    }
    size *= magn;
    return size;
}
/**
 * Calculate axis range (min and max).
 * Implementation from Flot.
 */
function getFlotRange(panelMin, panelMax, datamin, datamax) {
    var autoscaleMargin = 0.02;
    var min = +(panelMin != null ? panelMin : datamin);
    var max = +(panelMax != null ? panelMax : datamax);
    var delta = max - min;
    if (delta === 0.0) {
        // Grafana fix: wide Y min and max using increased wideFactor
        // when all series values are the same
        var wideFactor = 0.25;
        var widen = Math.abs(max === 0 ? 1 : max * wideFactor);
        if (panelMin === null) {
            min -= widen;
        }
        // always widen max if we couldn't widen min to ensure we
        // don't fall into min == max which doesn't work
        if (panelMax == null || panelMin != null) {
            max += widen;
        }
    }
    else {
        // consider autoscaling
        var margin = autoscaleMargin;
        if (margin != null) {
            if (panelMin == null) {
                min -= delta * margin;
                // make sure we don't go below zero if all values
                // are positive
                if (min < 0 && datamin != null && datamin >= 0) {
                    min = 0;
                }
            }
            if (panelMax == null) {
                max += delta * margin;
                if (max > 0 && datamax != null && datamax <= 0) {
                    max = 0;
                }
            }
        }
    }
    return { min: min, max: max };
}
/**
 * Calculate tick decimals.
 * Implementation from Flot.
 */
function getFlotTickDecimals(data, axis) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_app_core_time_series2__["b" /* getDataMinMax */])(data), datamin = _a.datamin, datamax = _a.datamax;
    var _b = getFlotRange(axis.min, axis.max, datamin, datamax), min = _b.min, max = _b.max;
    var noTicks = 3;
    var tickDecimals, maxDec;
    var delta = (max - min) / noTicks;
    var dec = -Math.floor(Math.log(delta) / Math.LN10);
    var magn = Math.pow(10, -dec);
    // norm is between 1.0 and 10.0
    var norm = delta / magn;
    var size;
    if (norm < 1.5) {
        size = 1;
    }
    else if (norm < 3) {
        size = 2;
        // special case for 2.5, requires an extra decimal
        if (norm > 2.25 && (maxDec == null || dec + 1 <= maxDec)) {
            size = 2.5;
            ++dec;
        }
    }
    else if (norm < 7.5) {
        size = 5;
    }
    else {
        size = 10;
    }
    size *= magn;
    tickDecimals = Math.max(0, maxDec != null ? maxDec : dec);
    // grafana addition
    var scaledDecimals = tickDecimals - Math.floor(Math.log(size) / Math.LN10);
    return { tickDecimals: tickDecimals, scaledDecimals: scaledDecimals };
}
/**
 * Format timestamp similar to Grafana graph panel.
 * @param ticks Number of ticks
 * @param min Time from (in milliseconds)
 * @param max Time to (in milliseconds)
 */
function grafanaTimeFormat(ticks, min, max) {
    if (min && max && ticks) {
        var range = max - min;
        var secPerTick = range / ticks / 1000;
        var oneDay = 86400000;
        var oneYear = 31536000000;
        if (secPerTick <= 45) {
            return '%H:%M:%S';
        }
        if (secPerTick <= 7200 || range <= oneDay) {
            return '%H:%M';
        }
        if (secPerTick <= 80000) {
            return '%m/%d %H:%M';
        }
        if (secPerTick <= 2419200 || range <= oneYear) {
            return '%m/%d';
        }
        return '%Y-%m';
    }
    return '%H:%M';
}
/**
 * Logarithm of value for arbitrary base.
 */
function logp(value, base) {
    return Math.log(value) / Math.log(base);
}
/**
 * Get decimal precision of number (3.14 => 2)
 */
function getPrecision(num) {
    var str = num.toString();
    return getStringPrecision(str);
}
/**
 * Get decimal precision of number stored as a string ("3.14" => 2)
 */
function getStringPrecision(num) {
    var dot_index = num.indexOf('.');
    if (dot_index === -1) {
        return 0;
    }
    else {
        return num.length - dot_index - 1;
    }
}


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImpressionSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_store__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_config__ = __webpack_require__(22);



var ImpressionSrv = /** @class */ (function () {
    function ImpressionSrv() {
    }
    ImpressionSrv.prototype.addDashboardImpression = function (dashboardId) {
        var impressionsKey = this.impressionKey(__WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */]);
        var impressions = [];
        if (__WEBPACK_IMPORTED_MODULE_0_app_core_store__["a" /* default */].exists(impressionsKey)) {
            impressions = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_app_core_store__["a" /* default */].get(impressionsKey));
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(impressions)) {
                impressions = [];
            }
        }
        impressions = impressions.filter(function (imp) {
            return dashboardId !== imp;
        });
        impressions.unshift(dashboardId);
        if (impressions.length > 50) {
            impressions.pop();
        }
        __WEBPACK_IMPORTED_MODULE_0_app_core_store__["a" /* default */].set(impressionsKey, JSON.stringify(impressions));
    };
    ImpressionSrv.prototype.getDashboardOpened = function () {
        var impressions = __WEBPACK_IMPORTED_MODULE_0_app_core_store__["a" /* default */].get(this.impressionKey(__WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */])) || '[]';
        impressions = JSON.parse(impressions);
        impressions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(impressions, function (el) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNumber(el);
        });
        return impressions;
    };
    ImpressionSrv.prototype.impressionKey = function (config) {
        return 'dashboard_impressions-' + config.bootData.user.orgId;
    };
    return ImpressionSrv;
}());

var impressionSrv = new ImpressionSrv();
/* harmony default export */ __webpack_exports__["a"] = (impressionSrv);


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_components_query_part_query_part__ = __webpack_require__(520);


var alertQueryDef = new __WEBPACK_IMPORTED_MODULE_1_app_core_components_query_part_query_part__["b" /* QueryPartDef */]({
    type: 'query',
    params: [
        { name: 'queryRefId', type: 'string', dynamicLookup: true },
        {
            name: 'from',
            type: 'string',
            options: ['1s', '10s', '1m', '5m', '10m', '15m', '1h', '24h', '48h'],
        },
        { name: 'to', type: 'string', options: ['now'] },
    ],
    defaultParams: ['#A', '15m', 'now', 'avg'],
});
var conditionTypes = [{ text: 'Query', value: 'query' }];
var alertStateSortScore = {
    alerting: 1,
    no_data: 2,
    pending: 3,
    ok: 4,
    paused: 5,
};
var evalFunctions = [
    { text: 'IS ABOVE', value: 'gt' },
    { text: 'IS BELOW', value: 'lt' },
    { text: 'IS OUTSIDE RANGE', value: 'outside_range' },
    { text: 'IS WITHIN RANGE', value: 'within_range' },
    { text: 'HAS NO VALUE', value: 'no_value' },
];
var evalOperators = [{ text: 'OR', value: 'or' }, { text: 'AND', value: 'and' }];
var reducerTypes = [
    { text: 'avg()', value: 'avg' },
    { text: 'min()', value: 'min' },
    { text: 'max()', value: 'max' },
    { text: 'sum()', value: 'sum' },
    { text: 'count()', value: 'count' },
    { text: 'last()', value: 'last' },
    { text: 'median()', value: 'median' },
    { text: 'diff()', value: 'diff' },
    { text: 'percent_diff()', value: 'percent_diff' },
    { text: 'count_non_null()', value: 'count_non_null' },
];
var noDataModes = [
    { text: 'Alerting', value: 'alerting' },
    { text: 'No Data', value: 'no_data' },
    { text: 'Keep Last State', value: 'keep_state' },
    { text: 'Ok', value: 'ok' },
];
var executionErrorModes = [{ text: 'Alerting', value: 'alerting' }, { text: 'Keep Last State', value: 'keep_state' }];
function createReducerPart(model) {
    var def = new __WEBPACK_IMPORTED_MODULE_1_app_core_components_query_part_query_part__["b" /* QueryPartDef */]({ type: model.type, defaultParams: [] });
    return new __WEBPACK_IMPORTED_MODULE_1_app_core_components_query_part_query_part__["a" /* QueryPart */](model, def);
}
function getStateDisplayModel(state) {
    switch (state) {
        case 'ok': {
            return {
                text: 'OK',
                iconClass: 'icon-gf icon-gf-online',
                stateClass: 'alert-state-ok',
            };
        }
        case 'alerting': {
            return {
                text: 'ALERTING',
                iconClass: 'icon-gf icon-gf-critical',
                stateClass: 'alert-state-critical',
            };
        }
        case 'no_data': {
            return {
                text: 'NO DATA',
                iconClass: 'fa fa-question',
                stateClass: 'alert-state-warning',
            };
        }
        case 'paused': {
            return {
                text: 'PAUSED',
                iconClass: 'fa fa-pause',
                stateClass: 'alert-state-paused',
            };
        }
        case 'pending': {
            return {
                text: 'PENDING',
                iconClass: 'fa fa-exclamation',
                stateClass: 'alert-state-warning',
            };
        }
    }
    throw { message: 'Unknown alert state' };
}
function joinEvalMatches(matches, separator) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reduce(matches, function (res, ev) {
        if (ev.metric !== undefined && ev.value !== undefined) {
            res.push(ev.metric + '=' + ev.value);
        }
        // For backwards compatibility . Should be be able to remove this after ~2017-06-01
        if (ev.Metric !== undefined && ev.Value !== undefined) {
            res.push(ev.Metric + '=' + ev.Value);
        }
        return res;
    }, []).join(separator);
}
function getAlertAnnotationInfo(ah) {
    // backward compatibility, can be removed in grafana 5.x
    // old way stored evalMatches in data property directly,
    // new way stores it in evalMatches property on new data object
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(ah.data)) {
        return joinEvalMatches(ah.data, ', ');
    }
    else if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(ah.data.evalMatches)) {
        return joinEvalMatches(ah.data.evalMatches, ', ');
    }
    if (ah.data.error) {
        return 'Error: ' + ah.data.error;
    }
    return '';
}
/* harmony default export */ __webpack_exports__["a"] = ({
    alertQueryDef: alertQueryDef,
    getStateDisplayModel: getStateDisplayModel,
    conditionTypes: conditionTypes,
    evalFunctions: evalFunctions,
    evalOperators: evalOperators,
    noDataModes: noDataModes,
    executionErrorModes: executionErrorModes,
    reducerTypes: reducerTypes,
    createReducerPart: createReducerPart,
    getAlertAnnotationInfo: getAlertAnnotationInfo,
    alertStateSortScore: alertStateSortScore,
});


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getRelativeTimesList;
/* harmony export (immutable) */ __webpack_exports__["a"] = describeTextRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = describeTimeRange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datemath__ = __webpack_require__(512);



var spans = {
    s: { display: 'second' },
    m: { display: 'minute' },
    h: { display: 'hour' },
    d: { display: 'day' },
    w: { display: 'week' },
    M: { display: 'month' },
    y: { display: 'year' },
};
var rangeOptions = [
    { from: 'now/d', to: 'now/d', display: 'Today', section: 2 },
    { from: 'now/d', to: 'now', display: 'Today so far', section: 2 },
    { from: 'now/w', to: 'now/w', display: 'This week', section: 2 },
    { from: 'now/w', to: 'now', display: 'This week so far', section: 2 },
    { from: 'now/M', to: 'now/M', display: 'This month', section: 2 },
    { from: 'now/M', to: 'now', display: 'This month so far', section: 2 },
    { from: 'now/y', to: 'now/y', display: 'This year', section: 2 },
    { from: 'now/y', to: 'now', display: 'This year so far', section: 2 },
    { from: 'now-1d/d', to: 'now-1d/d', display: 'Yesterday', section: 1 },
    {
        from: 'now-2d/d',
        to: 'now-2d/d',
        display: 'Day before yesterday',
        section: 1,
    },
    {
        from: 'now-7d/d',
        to: 'now-7d/d',
        display: 'This day last week',
        section: 1,
    },
    { from: 'now-1w/w', to: 'now-1w/w', display: 'Previous week', section: 1 },
    { from: 'now-1M/M', to: 'now-1M/M', display: 'Previous month', section: 1 },
    { from: 'now-1y/y', to: 'now-1y/y', display: 'Previous year', section: 1 },
    { from: 'now-5m', to: 'now', display: 'Last 5 minutes', section: 3 },
    { from: 'now-15m', to: 'now', display: 'Last 15 minutes', section: 3 },
    { from: 'now-30m', to: 'now', display: 'Last 30 minutes', section: 3 },
    { from: 'now-1h', to: 'now', display: 'Last 1 hour', section: 3 },
    { from: 'now-3h', to: 'now', display: 'Last 3 hours', section: 3 },
    { from: 'now-6h', to: 'now', display: 'Last 6 hours', section: 3 },
    { from: 'now-12h', to: 'now', display: 'Last 12 hours', section: 3 },
    { from: 'now-24h', to: 'now', display: 'Last 24 hours', section: 3 },
    { from: 'now-2d', to: 'now', display: 'Last 2 days', section: 0 },
    { from: 'now-7d', to: 'now', display: 'Last 7 days', section: 0 },
    { from: 'now-30d', to: 'now', display: 'Last 30 days', section: 0 },
    { from: 'now-90d', to: 'now', display: 'Last 90 days', section: 0 },
    { from: 'now-6M', to: 'now', display: 'Last 6 months', section: 0 },
    { from: 'now-1y', to: 'now', display: 'Last 1 year', section: 0 },
    { from: 'now-2y', to: 'now', display: 'Last 2 years', section: 0 },
    { from: 'now-5y', to: 'now', display: 'Last 5 years', section: 0 },
];
var absoluteFormat = 'MMM D, YYYY HH:mm:ss';
var rangeIndex = {};
__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(rangeOptions, function (frame) {
    rangeIndex[frame.from + ' to ' + frame.to] = frame;
});
function getRelativeTimesList(timepickerSettings, currentDisplay) {
    var groups = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(rangeOptions, function (option) {
        option.active = option.display === currentDisplay;
        return option.section;
    });
    // _.each(timepickerSettings.time_options, (duration: string) => {
    //   let info = describeTextRange(duration);
    //   if (info.section) {
    //     groups[info.section].push(info);
    //   }
    // });
    return groups;
}
function formatDate(date) {
    return date.format(absoluteFormat);
}
// handles expressions like
// 5m
// 5m to now/d
// now/d to now
// now/d
// if no to <expr> then to now is assumed
function describeTextRange(expr) {
    var isLast = expr.indexOf('+') !== 0;
    if (expr.indexOf('now') === -1) {
        expr = (isLast ? 'now-' : 'now') + expr;
    }
    var opt = rangeIndex[expr + ' to now'];
    if (opt) {
        return opt;
    }
    if (isLast) {
        opt = { from: expr, to: 'now' };
    }
    else {
        opt = { from: 'now', to: expr };
    }
    var parts = /^now([-+])(\d+)(\w)/.exec(expr);
    if (parts) {
        var unit = parts[3];
        var amount = parseInt(parts[2]);
        var span = spans[unit];
        if (span) {
            opt.display = isLast ? 'Last ' : 'Next ';
            opt.display += amount + ' ' + span.display;
            opt.section = span.section;
            if (amount > 1) {
                opt.display += 's';
            }
        }
    }
    else {
        opt.display = opt.from + ' to ' + opt.to;
        opt.invalid = true;
    }
    return opt;
}
function describeTimeRange(range) {
    var option = rangeIndex[range.from.toString() + ' to ' + range.to.toString()];
    if (option) {
        return option.display;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(range.from) && __WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(range.to)) {
        return formatDate(range.from) + ' to ' + formatDate(range.to);
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(range.from)) {
        var toMoment = __WEBPACK_IMPORTED_MODULE_2__datemath__["parse"](range.to, true);
        return formatDate(range.from) + ' to ' + toMoment.fromNow();
    }
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.isMoment(range.to)) {
        var from = __WEBPACK_IMPORTED_MODULE_2__datemath__["parse"](range.from, false);
        return from.fromNow() + ' to ' + formatDate(range.to);
    }
    if (range.to.toString() === 'now') {
        var res = describeTextRange(range.from);
        return res.display;
    }
    return range.from.toString() + ' to ' + range.to.toString();
}


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QueryPartDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryPart; });
/* harmony export (immutable) */ __webpack_exports__["c"] = functionRenderer;
/* harmony export (immutable) */ __webpack_exports__["d"] = suffixRenderer;
/* unused harmony export identityRenderer */
/* unused harmony export quotedIdentityRenderer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

var QueryPartDef = /** @class */ (function () {
    function QueryPartDef(options) {
        this.type = options.type;
        this.params = options.params;
        this.defaultParams = options.defaultParams;
        this.renderer = options.renderer;
        this.category = options.category;
        this.addStrategy = options.addStrategy;
    }
    return QueryPartDef;
}());

var QueryPart = /** @class */ (function () {
    function QueryPart(part, def) {
        this.part = part;
        this.def = def;
        if (!this.def) {
            throw { message: 'Could not find query part ' + part.type };
        }
        part.params = part.params || __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(this.def.defaultParams);
        this.params = part.params;
        this.updateText();
    }
    QueryPart.prototype.render = function (innerExpr) {
        return this.def.renderer(this, innerExpr);
    };
    QueryPart.prototype.hasMultipleParamsInString = function (strValue, index) {
        if (strValue.indexOf(',') === -1) {
            return false;
        }
        return this.def.params[index + 1] && this.def.params[index + 1].optional;
    };
    QueryPart.prototype.updateParam = function (strValue, index) {
        var _this = this;
        // handle optional parameters
        // if string contains ',' and next param is optional, split and update both
        if (this.hasMultipleParamsInString(strValue, index)) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(strValue.split(','), function (partVal, idx) {
                _this.updateParam(partVal.trim(), idx);
            });
            return;
        }
        if (strValue === '' && this.def.params[index].optional) {
            this.params.splice(index, 1);
        }
        else {
            this.params[index] = strValue;
        }
        this.part.params = this.params;
        this.updateText();
    };
    QueryPart.prototype.updateText = function () {
        if (this.params.length === 0) {
            this.text = this.def.type + '()';
            return;
        }
        var text = this.def.type + '(';
        text += this.params.join(', ');
        text += ')';
        this.text = text;
    };
    return QueryPart;
}());

function functionRenderer(part, innerExpr) {
    var str = part.def.type + '(';
    var parameters = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(part.params, function (value, index) {
        var paramType = part.def.params[index];
        if (paramType.type === 'time') {
            if (value === 'auto') {
                value = '$__interval';
            }
        }
        if (paramType.quote === 'single') {
            return "'" + value + "'";
        }
        else if (paramType.quote === 'double') {
            return '"' + value + '"';
        }
        return value;
    });
    if (innerExpr) {
        parameters.unshift(innerExpr);
    }
    return str + parameters.join(', ') + ')';
}
function suffixRenderer(part, innerExpr) {
    return innerExpr + ' ' + part.params[0];
}
function identityRenderer(part, innerExpr) {
    return part.params[0];
}
function quotedIdentityRenderer(part, innerExpr) {
    return '"' + part.params[0] + '"';
}


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(522);
var isObject_1 = __webpack_require__(527);
var isFunction_1 = __webpack_require__(401);
var tryCatch_1 = __webpack_require__(972);
var errorObject_1 = __webpack_require__(402);
var UnsubscriptionError_1 = __webpack_require__(973);
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(145);
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_constants__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_utils_colors__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_utils_emitter__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_services_context_srv__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_core_utils_sort_by_keys__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__panel_model__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboard_migration__ = __webpack_require__(998);









var DashboardModel = /** @class */ (function () {
    function DashboardModel(data, meta) {
        if (!data) {
            data = {};
        }
        this.events = new __WEBPACK_IMPORTED_MODULE_4_app_core_utils_emitter__["a" /* Emitter */]();
        this.id = data.id || null;
        this.uid = data.uid || null;
        this.revision = data.revision;
        this.title = data.title || 'No Title';
        this.autoUpdate = data.autoUpdate;
        this.description = data.description;
        this.tags = data.tags || [];
        this.style = data.style || 'dark';
        this.timezone = data.timezone || '';
        this.editable = data.editable !== false;
        this.graphTooltip = data.graphTooltip || 0;
        this.time = data.time || { from: 'now-6h', to: 'now' };
        this.timepicker = data.timepicker || {};
        this.templating = this.ensureListExist(data.templating);
        this.annotations = this.ensureListExist(data.annotations);
        this.refresh = data.refresh;
        this.snapshot = data.snapshot;
        this.schemaVersion = data.schemaVersion || 0;
        this.version = data.version || 0;
        this.links = data.links || [];
        this.gnetId = data.gnetId || null;
        this.panels = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(data.panels || [], function (panelData) { return new __WEBPACK_IMPORTED_MODULE_7__panel_model__["a" /* PanelModel */](panelData); });
        this.initMeta(meta);
        this.updateSchema(data);
        this.addBuiltInAnnotationQuery();
        this.sortPanelsByGridPos();
    }
    DashboardModel.prototype.addBuiltInAnnotationQuery = function () {
        var found = false;
        for (var _i = 0, _a = this.annotations.list; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.builtIn === 1) {
                found = true;
                break;
            }
        }
        if (found) {
            return;
        }
        this.annotations.list.unshift({
            datasource: '-- Grafana --',
            name: 'Annotations & Alerts',
            type: 'dashboard',
            iconColor: __WEBPACK_IMPORTED_MODULE_3_app_core_utils_colors__["b" /* DEFAULT_ANNOTATION_COLOR */],
            enable: true,
            hide: true,
            builtIn: 1,
        });
    };
    DashboardModel.prototype.initMeta = function (meta) {
        meta = meta || {};
        meta.canShare = meta.canShare !== false;
        meta.canSave = meta.canSave !== false;
        meta.canStar = meta.canStar !== false;
        meta.canEdit = meta.canEdit !== false;
        meta.showSettings = meta.canEdit;
        meta.canMakeEditable = meta.canSave && !this.editable;
        if (!this.editable) {
            meta.canEdit = false;
            meta.canDelete = false;
            meta.canSave = false;
        }
        this.meta = meta;
    };
    // cleans meta data and other non persistent state
    DashboardModel.prototype.getSaveModelClone = function () {
        // make clone
        var copy = {};
        for (var property in this) {
            if (DashboardModel.nonPersistedProperties[property] || !this.hasOwnProperty(property)) {
                continue;
            }
            copy[property] = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this[property]);
        }
        // get variable save models
        copy.templating = {
            list: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.templating.list, function (variable) { return (variable.getSaveModel ? variable.getSaveModel() : variable); }),
        };
        // get panel save models
        copy.panels = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.chain(this.panels)
            .filter(function (panel) { return panel.type !== 'add-panel'; })
            .map(function (panel) { return panel.getSaveModel(); })
            .value();
        //  sort by keys
        copy = Object(__WEBPACK_IMPORTED_MODULE_6_app_core_utils_sort_by_keys__["a" /* default */])(copy);
        return copy;
    };
    DashboardModel.prototype.setViewMode = function (panel, fullscreen, isEditing) {
        this.meta.fullscreen = fullscreen;
        this.meta.isEditing = isEditing && this.meta.canEdit;
        panel.setViewMode(fullscreen, this.meta.isEditing);
        this.events.emit('view-mode-changed', panel);
    };
    DashboardModel.prototype.ensureListExist = function (data) {
        if (!data) {
            data = {};
        }
        if (!data.list) {
            data.list = [];
        }
        return data;
    };
    DashboardModel.prototype.getNextPanelId = function () {
        var max = 0;
        for (var _i = 0, _a = this.panels; _i < _a.length; _i++) {
            var panel = _a[_i];
            if (panel.id > max) {
                max = panel.id;
            }
            if (panel.collapsed) {
                for (var _b = 0, _c = panel.panels; _b < _c.length; _b++) {
                    var rowPanel = _c[_b];
                    if (rowPanel.id > max) {
                        max = rowPanel.id;
                    }
                }
            }
        }
        return max + 1;
    };
    DashboardModel.prototype.forEachPanel = function (callback) {
        for (var i = 0; i < this.panels.length; i++) {
            callback(this.panels[i], i);
        }
    };
    DashboardModel.prototype.getPanelById = function (id) {
        for (var _i = 0, _a = this.panels; _i < _a.length; _i++) {
            var panel = _a[_i];
            if (panel.id === id) {
                return panel;
            }
        }
        return null;
    };
    DashboardModel.prototype.addPanel = function (panelData) {
        panelData.id = this.getNextPanelId();
        var panel = new __WEBPACK_IMPORTED_MODULE_7__panel_model__["a" /* PanelModel */](panelData);
        this.panels.unshift(panel);
        this.sortPanelsByGridPos();
        this.events.emit('panel-added', panel);
    };
    DashboardModel.prototype.sortPanelsByGridPos = function () {
        this.panels.sort(function (panelA, panelB) {
            if (panelA.gridPos.y === panelB.gridPos.y) {
                return panelA.gridPos.x - panelB.gridPos.x;
            }
            else {
                return panelA.gridPos.y - panelB.gridPos.y;
            }
        });
    };
    DashboardModel.prototype.cleanUpRepeats = function () {
        if (this.snapshot || this.templating.list.length === 0) {
            return;
        }
        this.iteration = (this.iteration || new Date().getTime()) + 1;
        var panelsToRemove = [];
        // cleanup scopedVars
        for (var _i = 0, _a = this.panels; _i < _a.length; _i++) {
            var panel = _a[_i];
            delete panel.scopedVars;
        }
        for (var i = 0; i < this.panels.length; i++) {
            var panel = this.panels[i];
            if ((!panel.repeat || panel.repeatedByRow) && panel.repeatPanelId && panel.repeatIteration !== this.iteration) {
                panelsToRemove.push(panel);
            }
        }
        // remove panels
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pull.apply(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a, [this.panels].concat(panelsToRemove));
        this.sortPanelsByGridPos();
        this.events.emit('repeats-processed');
    };
    DashboardModel.prototype.processRepeats = function () {
        if (this.snapshot || this.templating.list.length === 0) {
            return;
        }
        this.cleanUpRepeats();
        this.iteration = (this.iteration || new Date().getTime()) + 1;
        for (var i = 0; i < this.panels.length; i++) {
            var panel = this.panels[i];
            if (panel.repeat) {
                this.repeatPanel(panel, i);
            }
        }
        this.sortPanelsByGridPos();
        this.events.emit('repeats-processed');
    };
    DashboardModel.prototype.cleanUpRowRepeats = function (rowPanels) {
        var panelsToRemove = [];
        for (var i = 0; i < rowPanels.length; i++) {
            var panel = rowPanels[i];
            if (!panel.repeat && panel.repeatPanelId) {
                panelsToRemove.push(panel);
            }
        }
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pull.apply(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a, [rowPanels].concat(panelsToRemove));
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pull.apply(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a, [this.panels].concat(panelsToRemove));
    };
    DashboardModel.prototype.processRowRepeats = function (row) {
        if (this.snapshot || this.templating.list.length === 0) {
            return;
        }
        var rowPanels = row.panels;
        if (!row.collapsed) {
            var rowPanelIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.panels, function (p) { return p.id === row.id; });
            rowPanels = this.getRowPanels(rowPanelIndex);
        }
        this.cleanUpRowRepeats(rowPanels);
        var _loop_1 = function (i) {
            var panel = rowPanels[i];
            if (panel.repeat) {
                var panelIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this_1.panels, function (p) { return p.id === panel.id; });
                this_1.repeatPanel(panel, panelIndex);
            }
        };
        var this_1 = this;
        for (var i = 0; i < rowPanels.length; i++) {
            _loop_1(i);
        }
    };
    DashboardModel.prototype.getPanelRepeatClone = function (sourcePanel, valueIndex, sourcePanelIndex) {
        // if first clone return source
        if (valueIndex === 0) {
            return sourcePanel;
        }
        var clone = new __WEBPACK_IMPORTED_MODULE_7__panel_model__["a" /* PanelModel */](sourcePanel.getSaveModel());
        clone.id = this.getNextPanelId();
        // insert after source panel + value index
        this.panels.splice(sourcePanelIndex + valueIndex, 0, clone);
        clone.repeatIteration = this.iteration;
        clone.repeatPanelId = sourcePanel.id;
        clone.repeat = null;
        return clone;
    };
    DashboardModel.prototype.getRowRepeatClone = function (sourceRowPanel, valueIndex, sourcePanelIndex) {
        // if first clone return source
        if (valueIndex === 0) {
            if (!sourceRowPanel.collapsed) {
                var rowPanels_1 = this.getRowPanels(sourcePanelIndex);
                sourceRowPanel.panels = rowPanels_1;
            }
            return sourceRowPanel;
        }
        var clone = new __WEBPACK_IMPORTED_MODULE_7__panel_model__["a" /* PanelModel */](sourceRowPanel.getSaveModel());
        // for row clones we need to figure out panels under row to clone and where to insert clone
        var rowPanels, insertPos;
        if (sourceRowPanel.collapsed) {
            rowPanels = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(sourceRowPanel.panels);
            clone.panels = rowPanels;
            // insert copied row after preceding row
            insertPos = sourcePanelIndex + valueIndex;
        }
        else {
            rowPanels = this.getRowPanels(sourcePanelIndex);
            clone.panels = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(rowPanels, function (panel) { return panel.getSaveModel(); });
            // insert copied row after preceding row's panels
            insertPos = sourcePanelIndex + (rowPanels.length + 1) * valueIndex;
        }
        this.panels.splice(insertPos, 0, clone);
        this.updateRepeatedPanelIds(clone);
        return clone;
    };
    DashboardModel.prototype.repeatPanel = function (panel, panelIndex) {
        var variable = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.templating.list, { name: panel.repeat });
        if (!variable) {
            return;
        }
        if (panel.type === 'row') {
            this.repeatRow(panel, panelIndex, variable);
            return;
        }
        var selectedOptions = this.getSelectedVariableOptions(variable);
        var minWidth = panel.minSpan || 6;
        var xPos = 0;
        var yPos = panel.gridPos.y;
        for (var index = 0; index < selectedOptions.length; index++) {
            var option = selectedOptions[index];
            var copy = void 0;
            copy = this.getPanelRepeatClone(panel, index, panelIndex);
            copy.scopedVars = copy.scopedVars || {};
            copy.scopedVars[variable.name] = option;
            if (panel.repeatDirection === __WEBPACK_IMPORTED_MODULE_2_app_core_constants__["h" /* REPEAT_DIR_VERTICAL */]) {
                if (index > 0) {
                    yPos += copy.gridPos.h;
                }
                copy.gridPos.y = yPos;
            }
            else {
                // set width based on how many are selected
                // assumed the repeated panels should take up full row width
                copy.gridPos.w = Math.max(__WEBPACK_IMPORTED_MODULE_2_app_core_constants__["e" /* GRID_COLUMN_COUNT */] / selectedOptions.length, minWidth);
                copy.gridPos.x = xPos;
                copy.gridPos.y = yPos;
                xPos += copy.gridPos.w;
                // handle overflow by pushing down one row
                if (xPos + copy.gridPos.w > __WEBPACK_IMPORTED_MODULE_2_app_core_constants__["e" /* GRID_COLUMN_COUNT */]) {
                    xPos = 0;
                    yPos += copy.gridPos.h;
                }
            }
        }
        // Update gridPos for panels below
        var yOffset = yPos - panel.gridPos.y;
        if (yOffset > 0) {
            var panelBelowIndex = panelIndex + selectedOptions.length;
            for (var i = panelBelowIndex; i < this.panels.length; i++) {
                this.panels[i].gridPos.y += yOffset;
            }
        }
    };
    DashboardModel.prototype.repeatRow = function (panel, panelIndex, variable) {
        var _this = this;
        var selectedOptions = this.getSelectedVariableOptions(variable);
        var yPos = panel.gridPos.y;
        function setScopedVars(panel, variableOption) {
            panel.scopedVars = panel.scopedVars || {};
            panel.scopedVars[variable.name] = variableOption;
        }
        var _loop_2 = function (optionIndex) {
            var option = selectedOptions[optionIndex];
            var rowCopy = this_2.getRowRepeatClone(panel, optionIndex, panelIndex);
            setScopedVars(rowCopy, option);
            var rowHeight = this_2.getRowHeight(rowCopy);
            var rowPanels = rowCopy.panels || [];
            var panelBelowIndex = void 0;
            if (panel.collapsed) {
                // For collapsed row just copy its panels and set scoped vars and proper IDs
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(rowPanels, function (rowPanel, i) {
                    setScopedVars(rowPanel, option);
                    if (optionIndex > 0) {
                        _this.updateRepeatedPanelIds(rowPanel, true);
                    }
                });
                rowCopy.gridPos.y += optionIndex;
                yPos += optionIndex;
                panelBelowIndex = panelIndex + optionIndex + 1;
            }
            else {
                // insert after 'row' panel
                var insertPos_1 = panelIndex + (rowPanels.length + 1) * optionIndex + 1;
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(rowPanels, function (rowPanel, i) {
                    setScopedVars(rowPanel, option);
                    if (optionIndex > 0) {
                        var cloneRowPanel = new __WEBPACK_IMPORTED_MODULE_7__panel_model__["a" /* PanelModel */](rowPanel);
                        _this.updateRepeatedPanelIds(cloneRowPanel, true);
                        // For exposed row additionally set proper Y grid position and add it to dashboard panels
                        cloneRowPanel.gridPos.y += rowHeight * optionIndex;
                        _this.panels.splice(insertPos_1 + i, 0, cloneRowPanel);
                    }
                });
                rowCopy.panels = [];
                rowCopy.gridPos.y += rowHeight * optionIndex;
                yPos += rowHeight;
                panelBelowIndex = insertPos_1 + rowPanels.length;
            }
            // Update gridPos for panels below
            for (var i = panelBelowIndex; i < this_2.panels.length; i++) {
                this_2.panels[i].gridPos.y += yPos;
            }
        };
        var this_2 = this;
        for (var optionIndex = 0; optionIndex < selectedOptions.length; optionIndex++) {
            _loop_2(optionIndex);
        }
    };
    DashboardModel.prototype.updateRepeatedPanelIds = function (panel, repeatedByRow) {
        panel.repeatPanelId = panel.id;
        panel.id = this.getNextPanelId();
        panel.repeatIteration = this.iteration;
        if (repeatedByRow) {
            panel.repeatedByRow = true;
        }
        else {
            panel.repeat = null;
        }
        return panel;
    };
    DashboardModel.prototype.getSelectedVariableOptions = function (variable) {
        var selectedOptions;
        if (variable.current.text === 'All') {
            selectedOptions = variable.options.slice(1, variable.options.length);
        }
        else {
            selectedOptions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(variable.options, { selected: true });
        }
        return selectedOptions;
    };
    DashboardModel.prototype.getRowHeight = function (rowPanel) {
        if (!rowPanel.panels || rowPanel.panels.length === 0) {
            return 0;
        }
        var rowYPos = rowPanel.gridPos.y;
        var positions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(rowPanel.panels, 'gridPos');
        var maxPos = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.maxBy(positions, function (pos) {
            return pos.y + pos.h;
        });
        return maxPos.y + maxPos.h - rowYPos;
    };
    DashboardModel.prototype.removePanel = function (panel) {
        var index = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(this.panels, panel);
        this.panels.splice(index, 1);
        this.events.emit('panel-removed', panel);
    };
    DashboardModel.prototype.removeRow = function (row, removePanels) {
        var needToogle = (!removePanels && row.collapsed) || (removePanels && !row.collapsed);
        if (needToogle) {
            this.toggleRow(row);
        }
        this.removePanel(row);
    };
    DashboardModel.prototype.expandRows = function () {
        for (var i = 0; i < this.panels.length; i++) {
            var panel = this.panels[i];
            if (panel.type !== 'row') {
                continue;
            }
            if (panel.collapsed) {
                this.toggleRow(panel);
            }
        }
    };
    DashboardModel.prototype.collapseRows = function () {
        for (var i = 0; i < this.panels.length; i++) {
            var panel = this.panels[i];
            if (panel.type !== 'row') {
                continue;
            }
            if (!panel.collapsed) {
                this.toggleRow(panel);
            }
        }
    };
    DashboardModel.prototype.setPanelFocus = function (id) {
        this.meta.focusPanelId = id;
    };
    DashboardModel.prototype.updateSubmenuVisibility = function () {
        var _this = this;
        this.meta.submenuEnabled = (function () {
            if (_this.links.length > 0) {
                return true;
            }
            var visibleVars = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this.templating.list, function (variable) { return variable.hide !== 2; });
            if (visibleVars.length > 0) {
                return true;
            }
            var visibleAnnotations = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this.annotations.list, function (annotation) { return annotation.hide !== true; });
            if (visibleAnnotations.length > 0) {
                return true;
            }
            return false;
        })();
    };
    DashboardModel.prototype.getPanelInfoById = function (panelId) {
        for (var i = 0; i < this.panels.length; i++) {
            if (this.panels[i].id === panelId) {
                return {
                    panel: this.panels[i],
                    index: i,
                };
            }
        }
        return null;
    };
    DashboardModel.prototype.duplicatePanel = function (panel) {
        var newPanel = panel.getSaveModel();
        newPanel.id = this.getNextPanelId();
        delete newPanel.repeat;
        delete newPanel.repeatIteration;
        delete newPanel.repeatPanelId;
        delete newPanel.scopedVars;
        if (newPanel.alert) {
            delete newPanel.thresholds;
        }
        delete newPanel.alert;
        // does it fit to the right?
        if (panel.gridPos.x + panel.gridPos.w * 2 <= __WEBPACK_IMPORTED_MODULE_2_app_core_constants__["e" /* GRID_COLUMN_COUNT */]) {
            newPanel.gridPos.x += panel.gridPos.w;
        }
        else {
            // add below
            newPanel.gridPos.y += panel.gridPos.h;
        }
        this.addPanel(newPanel);
        return newPanel;
    };
    DashboardModel.prototype.formatDate = function (date, format) {
        date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(date) ? date : __WEBPACK_IMPORTED_MODULE_0_moment___default()(date);
        format = format || 'YYYY-MM-DD HH:mm:ss';
        var timezone = this.getTimezone();
        return timezone === 'browser' ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(format) : __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(date).format(format);
    };
    DashboardModel.prototype.destroy = function () {
        this.events.removeAllListeners();
        for (var _i = 0, _a = this.panels; _i < _a.length; _i++) {
            var panel = _a[_i];
            panel.destroy();
        }
    };
    DashboardModel.prototype.toggleRow = function (row) {
        var rowIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(this.panels, row);
        if (row.collapsed) {
            row.collapsed = false;
            var hasRepeat = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(row.panels, function (p) { return p.repeat; });
            if (row.panels.length > 0) {
                // Use first panel to figure out if it was moved or pushed
                var firstPanel = row.panels[0];
                var yDiff = firstPanel.gridPos.y - (row.gridPos.y + row.gridPos.h);
                // start inserting after row
                var insertPos = rowIndex + 1;
                // y max will represent the bottom y pos after all panels have been added
                // needed to know home much panels below should be pushed down
                var yMax = row.gridPos.y;
                for (var _i = 0, _a = row.panels; _i < _a.length; _i++) {
                    var panel = _a[_i];
                    // make sure y is adjusted (in case row moved while collapsed)
                    // console.log('yDiff', yDiff);
                    panel.gridPos.y -= yDiff;
                    // insert after row
                    this.panels.splice(insertPos, 0, new __WEBPACK_IMPORTED_MODULE_7__panel_model__["a" /* PanelModel */](panel));
                    // update insert post and y max
                    insertPos += 1;
                    yMax = Math.max(yMax, panel.gridPos.y + panel.gridPos.h);
                }
                var pushDownAmount = yMax - row.gridPos.y - 1;
                // push panels below down
                for (var panelIndex = insertPos; panelIndex < this.panels.length; panelIndex++) {
                    this.panels[panelIndex].gridPos.y += pushDownAmount;
                }
                row.panels = [];
                if (hasRepeat) {
                    this.processRowRepeats(row);
                }
            }
            // sort panels
            this.sortPanelsByGridPos();
            // emit change event
            this.events.emit('row-expanded');
            return;
        }
        var rowPanels = this.getRowPanels(rowIndex);
        // remove panels
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pull.apply(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a, [this.panels].concat(rowPanels));
        // save panel models inside row panel
        row.panels = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(rowPanels, function (panel) { return panel.getSaveModel(); });
        row.collapsed = true;
        // emit change event
        this.events.emit('row-collapsed');
    };
    /**
     * Will return all panels after rowIndex until it encounters another row
     */
    DashboardModel.prototype.getRowPanels = function (rowIndex) {
        var rowPanels = [];
        for (var index = rowIndex + 1; index < this.panels.length; index++) {
            var panel = this.panels[index];
            // break when encountering another row
            if (panel.type === 'row') {
                break;
            }
            // this panel must belong to row
            rowPanels.push(panel);
        }
        return rowPanels;
    };
    DashboardModel.prototype.on = function (eventName, callback) {
        this.events.on(eventName, callback);
    };
    DashboardModel.prototype.off = function (eventName, callback) {
        this.events.off(eventName, callback);
    };
    DashboardModel.prototype.cycleGraphTooltip = function () {
        this.graphTooltip = (this.graphTooltip + 1) % 3;
    };
    DashboardModel.prototype.sharedTooltipModeEnabled = function () {
        return this.graphTooltip > 0;
    };
    DashboardModel.prototype.sharedCrosshairModeOnly = function () {
        return this.graphTooltip === 1;
    };
    DashboardModel.prototype.getRelativeTime = function (date) {
        date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(date) ? date : __WEBPACK_IMPORTED_MODULE_0_moment___default()(date);
        return this.timezone === 'browser' ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).fromNow() : __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(date).fromNow();
    };
    DashboardModel.prototype.getNextQueryLetter = function (panel) {
        var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(letters, function (refId) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.every(panel.targets, function (other) {
                return other.refId !== refId;
            });
        });
    };
    DashboardModel.prototype.isTimezoneUtc = function () {
        return this.getTimezone() === 'utc';
    };
    DashboardModel.prototype.getTimezone = function () {
        return this.timezone ? this.timezone : __WEBPACK_IMPORTED_MODULE_5_app_core_services_context_srv__["a" /* contextSrv */].user.timezone;
    };
    DashboardModel.prototype.updateSchema = function (old) {
        var migrator = new __WEBPACK_IMPORTED_MODULE_8__dashboard_migration__["a" /* DashboardMigrator */](this);
        migrator.updateSchema(old);
    };
    DashboardModel.nonPersistedProperties = {
        events: true,
        meta: true,
        panels: true,
        templating: true,
    };
    return DashboardModel;
}());



/***/ }),
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assignModelProperties;
function assignModelProperties(target, source, defaults, removeDefaults) {
    for (var key in defaults) {
        if (!defaults.hasOwnProperty(key)) {
            continue;
        }
        target[key] = source[key] === undefined ? defaults[key] : source[key];
    }
}


/***/ }),
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(533);

__WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */].init();


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GrafanaApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angular_route__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angular_route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_angular_route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular_sanitize__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular_sanitize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angular_sanitize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_native_dragdrop__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_native_dragdrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular_native_dragdrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_bindonce__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_bindonce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angular_bindonce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vendor_bootstrap_bootstrap__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vendor_bootstrap_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vendor_bootstrap_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vendor_angular_ui_ui_bootstrap_tpls__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vendor_angular_ui_ui_bootstrap_tpls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vendor_angular_ui_ui_bootstrap_tpls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vendor_angular_other_angular_strap__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vendor_angular_other_angular_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vendor_angular_other_angular_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__core_core__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__routes_routes__ = __webpack_require__(1041);



















// add move to lodash for backward compatabiltiy
__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.move = function (array, fromIndex, toIndex) {
    array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
    return array;
};


var GrafanaApp = /** @class */ (function () {
    function GrafanaApp() {
        this.preBootModules = [];
        this.registerFunctions = {};
        this.ngModuleDependencies = [];
    }
    GrafanaApp.prototype.useModule = function (module) {
        if (this.preBootModules) {
            this.preBootModules.push(module);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.extend(module, this.registerFunctions);
        }
        this.ngModuleDependencies.push(module.name);
        return module;
    };
    GrafanaApp.prototype.init = function () {
        var _this = this;
        var app = __WEBPACK_IMPORTED_MODULE_4_angular___default.a.module('grafana', []);
        __WEBPACK_IMPORTED_MODULE_15_moment___default.a.locale(__WEBPACK_IMPORTED_MODULE_14_app_core_config__["a" /* default */].bootData.user.locale);
        app.config(["$locationProvider", "$controllerProvider", "$compileProvider", "$filterProvider", "$httpProvider", "$provide", function ($locationProvider, $controllerProvider, $compileProvider, $filterProvider, $httpProvider, $provide) {
            // pre assing bindings before constructor calls
            $compileProvider.preAssignBindingsEnabled(true);
            if (__WEBPACK_IMPORTED_MODULE_14_app_core_config__["a" /* default */].buildInfo.env !== 'development') {
                $compileProvider.debugInfoEnabled(false);
            }
            $httpProvider.useApplyAsync(true);
            _this.registerFunctions.controller = $controllerProvider.register;
            _this.registerFunctions.directive = $compileProvider.directive;
            _this.registerFunctions.factory = $provide.factory;
            _this.registerFunctions.service = $provide.service;
            _this.registerFunctions.filter = $filterProvider.register;
            $provide.decorator('$http', [
                '$delegate',
                '$templateCache',
                function ($delegate, $templateCache) {
                    var get = $delegate.get;
                    $delegate.get = function (url, config) {
                        if (url.match(/\.html$/)) {
                            // some template's already exist in the cache
                            if (!$templateCache.get(url)) {
                                url += '?v=' + new Date().getTime();
                            }
                        }
                        return get(url, config);
                    };
                    return $delegate;
                },
            ]);
        }]);
        this.ngModuleDependencies = [
            'grafana.core',
            'ngRoute',
            'ngSanitize',
            '$strap.directives',
            'ang-drag-drop',
            'grafana',
            'pasvaz.bindonce',
            'ui.bootstrap',
            'ui.bootstrap.tpls',
            'react',
        ];
        var module_types = ['controllers', 'directives', 'factories', 'services', 'filters', 'routes'];
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(module_types, function (type) {
            var moduleName = 'grafana.' + type;
            _this.useModule(__WEBPACK_IMPORTED_MODULE_4_angular___default.a.module(moduleName, []));
        });
        // makes it possible to add dynamic stuff
        this.useModule(__WEBPACK_IMPORTED_MODULE_16__core_core__["d" /* coreModule */]);
        // register react angular wrappers
        __WEBPACK_IMPORTED_MODULE_16__core_core__["d" /* coreModule */].config(__WEBPACK_IMPORTED_MODULE_17__routes_routes__["a" /* setupAngularRoutes */]);
        Object(__WEBPACK_IMPORTED_MODULE_16__core_core__["f" /* registerAngularDirectives */])();
        var preBootRequires = [__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1463))];
        Promise.all(preBootRequires)
            .then(function () {
            // disable tool tip animation
            __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.fn.tooltip.defaults.animation = false;
            // bootstrap the app
            __WEBPACK_IMPORTED_MODULE_4_angular___default.a.bootstrap(document, _this.ngModuleDependencies).invoke(function () {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this.preBootModules, function (module) {
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.extend(module, _this.registerFunctions);
                });
                _this.preBootModules = null;
            });
        })
            .catch(function (err) {
            console.log('Application boot failed:', err);
        });
    };
    return GrafanaApp;
}());

/* harmony default export */ __webpack_exports__["a"] = (new GrafanaApp());


/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */
/***/ (function(module, exports) {

/* ===================================================
 * bootstrap-transition.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#transitions
 * ===================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


  /* CSS TRANSITION SUPPORT (http://www.modernizr.com/)
   * ======================================================= */

  $(function () {

    $.support.transition = (function () {

      var transitionEnd = (function () {

        var el = document.createElement('bootstrap')
          , transEndEventNames = {
               'WebkitTransition' : 'webkitTransitionEnd'
            ,  'MozTransition'    : 'transitionend'
            ,  'OTransition'      : 'oTransitionEnd otransitionend'
            ,  'transition'       : 'transitionend'
            }
          , name

        for (name in transEndEventNames){
          if (el.style[name] !== undefined) {
            return transEndEventNames[name]
          }
        }

      }())

      return transitionEnd && {
        end: transitionEnd
      }

    })()

  })

}(window.jQuery);/* ==========================================================
 * bootstrap-alert.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#alerts
 * ==========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;

/* ============================================================
 * bootstrap-dropdown.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#dropdowns
 * ============================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


 /* DROPDOWN CLASS DEFINITION
  * ========================= */

  var toggle = '[data-toggle=dropdown]'
    , Dropdown = function (element) {
        var $el = $(element).on('click.dropdown.data-api', this.toggle)
        $('html').on('click.dropdown.data-api', function () {
          $el.parent().removeClass('open')
        })
      }

  Dropdown.prototype = {

    constructor: Dropdown

  , toggle: function (e) {
      var $this = $(this)
        , $parent
        , isActive

      if ($this.is('.disabled, :disabled')) return

      $parent = getParent($this)

      isActive = $parent.hasClass('open')

      clearMenus()

      if (!isActive) {
        if ('ontouchstart' in document.documentElement) {
          // if mobile we we use a backdrop because click events don't delegate
          $('<div class="dropdown-backdrop"/>').insertBefore($(this)).on('click', clearMenus)
        }
        $parent.toggleClass('open')
      }

      $this.focus()

      return false
    }

  , keydown: function (e) {
      var $this
        , $items
        , $active
        , $parent
        , isActive
        , index

      if (!/(38|40|27)/.test(e.keyCode)) return

      $this = $(this)

      e.preventDefault()
      e.stopPropagation()

      if ($this.is('.disabled, :disabled')) return

      $parent = getParent($this)

      isActive = $parent.hasClass('open')

      if (!isActive || (isActive && e.keyCode == 27)) {
        if (e.which == 27) $parent.find(toggle).focus()
        return $this.click()
      }

      $items = $('[role=menu] li:not(.divider):visible a', $parent)

      if (!$items.length) return

      index = $items.index($items.filter(':focus'))

      if (e.keyCode == 38 && index > 0) index--                                        // up
      if (e.keyCode == 40 && index < $items.length - 1) index++                        // down
      if (!~index) index = 0

      $items
        .eq(index)
        .focus()
    }

  }

  function clearMenus() {
    $('.dropdown-backdrop').remove()
    $(toggle).each(function () {
      getParent($(this)).removeClass('open')
    })
  }

  function getParent($this) {
    var selector = $this.attr('data-target')
      , $parent

    if (!selector) {
      selector = $this.attr('href')
      // grafana backport fix from bootstrap 3
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
    }

    $parent = selector && $(selector)

    if (!$parent || !$parent.length) $parent = $this.parent()

    return $parent
  }


  /* DROPDOWN PLUGIN DEFINITION
   * ========================== */

  var old = $.fn.dropdown

  $.fn.dropdown = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('dropdown')
      if (!data) $this.data('dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  $.fn.dropdown.Constructor = Dropdown


 /* DROPDOWN NO CONFLICT
  * ==================== */

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  /* APPLY TO STANDARD DROPDOWN ELEMENTS
   * =================================== */

  $(document)
    .on('click.dropdown.data-api', clearMenus)
    .on('click.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.dropdown.data-api'  , toggle, Dropdown.prototype.toggle)
    .on('keydown.dropdown.data-api', toggle + ', [role=menu]' , Dropdown.prototype.keydown)

}(window.jQuery);
/* =========================================================
 * bootstrap-modal.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#modals
 * =========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */


!function ($) {

  "use strict"; // jshint ;_;


 /* MODAL CLASS DEFINITION
  * ====================== */

  var Modal = function (element, options) {
    this.options = options
    this.$element = $(element)
      .delegate('[data-dismiss="modal"]', 'click.dismiss.modal', $.proxy(this.hide, this))
    this.options.remote && this.$element.find('.modal-body').load(this.options.remote)
  }

  Modal.prototype = {

      constructor: Modal

    , toggle: function () {
        return this[!this.isShown ? 'show' : 'hide']()
      }

    , show: function () {
        var that = this
          , e = $.Event('show')

        this.$element.trigger(e)

        if (this.isShown || e.isDefaultPrevented()) return

        this.isShown = true

        this.escape()

        this.backdrop(function () {
          var transition = $.support.transition && that.$element.hasClass('fade')

          if (!that.$element.parent().length) {
            that.$element.appendTo(document.body) //don't move modals dom position
          }

          that.$element.show()

          if (transition) {
            that.$element[0].offsetWidth // force reflow
          }

          that.$element
            .addClass('in')
            .attr('aria-hidden', false)

          that.enforceFocus()

          transition ?
            that.$element.one($.support.transition.end, function () { that.$element.focus().trigger('shown') }) :
            that.$element.focus().trigger('shown')

        })
      }

    , hide: function (e) {
        e && e.preventDefault()

        var that = this

        e = $.Event('hide')

        this.$element.trigger(e)

        if (!this.isShown || e.isDefaultPrevented()) return

        this.isShown = false

        this.escape()

        $(document).off('focusin.modal')

        this.$element
          .removeClass('in')
          .attr('aria-hidden', true)

        $.support.transition && this.$element.hasClass('fade') ?
          this.hideWithTransition() :
          this.hideModal()
      }

    , enforceFocus: function () {
        var that = this
        $(document).on('focusin.modal', function (e) {
          if (that.$element[0] !== e.target && !that.$element.has(e.target).length) {
            that.$element.focus()
          }
        })
      }

    , escape: function () {
        var that = this
        if (this.isShown && this.options.keyboard) {
          this.$element.on('keyup.dismiss.modal', function ( e ) {
            e.which == 27 && that.hide()
          })
        } else if (!this.isShown) {
          this.$element.off('keyup.dismiss.modal')
        }
      }

    , hideWithTransition: function () {
        var that = this
          , timeout = setTimeout(function () {
              that.$element.off($.support.transition.end)
              that.hideModal()
            }, 500)

        this.$element.one($.support.transition.end, function () {
          clearTimeout(timeout)
          that.hideModal()
        })
      }

    , hideModal: function () {
        var that = this
        this.$element.hide()
        this.backdrop(function () {
          that.removeBackdrop()
          that.$element.trigger('hidden')
        })
      }

    , removeBackdrop: function () {
        this.$backdrop && this.$backdrop.remove()
        this.$backdrop = null
      }

    , backdrop: function (callback) {
        var that = this
          , animate = this.$element.hasClass('fade') ? 'fade' : ''

        if (this.isShown && this.options.backdrop) {
          var doAnimate = $.support.transition && animate

          this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
            .appendTo(document.body)

          this.$backdrop.click(
            this.options.backdrop == 'static' ?
              $.proxy(this.$element[0].focus, this.$element[0])
            : $.proxy(this.hide, this)
          )

          if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

          this.$backdrop.addClass('in')

          if (!callback) return

          doAnimate ?
            this.$backdrop.one($.support.transition.end, callback) :
            callback()

        } else if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass('in')

          $.support.transition && this.$element.hasClass('fade')?
            this.$backdrop.one($.support.transition.end, callback) :
            callback()

        } else if (callback) {
          callback()
        }
      }
  }


 /* MODAL PLUGIN DEFINITION
  * ======================= */

  var old = $.fn.modal

  $.fn.modal = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('modal')
        , options = $.extend({}, $.fn.modal.defaults, $this.data(), typeof option == 'object' && option)
      if (!data) $this.data('modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option]()
      else if (options.show) data.show()
    })
  }

  $.fn.modal.defaults = {
      backdrop: true
    , keyboard: true
    , show: true
  }

  $.fn.modal.Constructor = Modal


 /* MODAL NO CONFLICT
  * ================= */

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


 /* MODAL DATA-API
  * ============== */

  $(document).on('click.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
      , href = $this.attr('href')
      , $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) //strip for ie7
      , option = $target.data('modal') ? 'toggle' : $.extend({ remote:!/#/.test(href) && href }, $target.data(), $this.data())

    e.preventDefault()

    $target
      .modal(option)
      .one('hide', function () {
        $this.focus()
      })
  })

}(window.jQuery);
/* ===========================================================
 * bootstrap-tooltip.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#tooltips
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ===========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* TOOLTIP PUBLIC CLASS DEFINITION
  * =============================== */

  var Tooltip = function (element, options) {
    this.init('tooltip', element, options)
  }

  Tooltip.prototype = {

    constructor: Tooltip

  , init: function (type, element, options) {
      var eventIn
        , eventOut
        , triggers
        , trigger
        , i

      this.type = type
      this.$element = $(element)
      this.options = this.getOptions(options)
      this.enabled = true

      triggers = this.options.trigger.split(' ')

      for (i = triggers.length; i--;) {
        trigger = triggers[i]
        if (trigger == 'click') {
          this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
        } else if (trigger != 'manual') {
          eventIn = trigger == 'hover' ? 'mouseenter' : 'focus'
          eventOut = trigger == 'hover' ? 'mouseleave' : 'blur'
          this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
          this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
        }
      }

      this.options.selector ?
        (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
        this.fixTitle()
    }

  , getOptions: function (options) {
      options = $.extend({}, $.fn[this.type].defaults, this.$element.data(), options)

      if (options.delay && typeof options.delay == 'number') {
        options.delay = {
          show: options.delay
        , hide: options.delay
        }
      }

      return options
    }

  , enter: function (e) {
      var defaults = $.fn[this.type].defaults
        , options = {}
        , self

      this._options && $.each(this._options, function (key, value) {
        if (defaults[key] != value) options[key] = value
      }, this)

      self = $(e.currentTarget)[this.type](options).data(this.type)

      if (!self.options.delay || !self.options.delay.show) return self.show()

      clearTimeout(this.timeout)
      self.hoverState = 'in'
      this.timeout = setTimeout(function() {
        if (self.hoverState == 'in') self.show()
      }, self.options.delay.show)
    }

  , leave: function (e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type)

      if (this.timeout) clearTimeout(this.timeout)
      if (!self.options.delay || !self.options.delay.hide) return self.hide()

      self.hoverState = 'out'
      this.timeout = setTimeout(function() {
        if (self.hoverState == 'out') self.hide()
      }, self.options.delay.hide)
    }

  , show: function () {
      var $tip
        , pos
        , actualWidth
        , actualHeight
        , placement
        , tp
        , e = $.Event('show')

      if (this.hasContent() && this.enabled) {
        this.$element.trigger(e)
        if (e.isDefaultPrevented()) return
        $tip = this.tip()
        this.setContent()

        if (this.options.animation) {
          $tip.addClass('fade')
        }

        placement = typeof this.options.placement == 'function' ?
          this.options.placement.call(this, $tip[0], this.$element[0]) :
          this.options.placement

        $tip
          .detach()
          .css({ top: 0, left: 0, display: 'block' })

        this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

        pos = this.getPosition()

        actualWidth = $tip[0].offsetWidth
        actualHeight = $tip[0].offsetHeight

        switch (placement) {
          case 'bottom':
            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2}
            break
          case 'top':
            tp = {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2}
            break
          case 'left':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth}
            break
          case 'right':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width}
            break

          // extend placements (top)
          case 'topLeft':
            tp = {top: pos.top - actualHeight,  left: pos.left + pos.width / 2 - (actualWidth * .10)};
            break;
          case 'topRight':
            tp = {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - (actualWidth * .90)};
            break;

          // extend placements (right)
          case 'rightTop':
            tp = {top: pos.top + pos.height / 2 - (actualHeight *.10), left: pos.left + pos.width};
            break;
          case 'rightBottom':
            tp = {top: pos.top + pos.height / 2 - (actualHeight * .90), left: pos.left + pos.width};
            break;

          // extend placements (bottom)
          case 'bottomLeft':
            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - (actualWidth * .10)};
            break;
          case 'bottomRight':
            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - (actualWidth * .90)};
            break;

          // extend placements (left)
          case 'leftTop':
            tp = {top: pos.top + pos.height / 2 - (actualHeight *.10), left: pos.left - actualWidth};
            break;
          case 'leftBottom':
            tp = {top: pos.top + pos.height / 2 - (actualHeight * .90), left: pos.left - actualWidth};
            break;


        }

        this.applyPlacement(tp, placement)
        this.$element.trigger('shown')
      }
    }

  , applyPlacement: function(offset, placement){
      var $tip = this.tip()
        , width = $tip[0].offsetWidth
        , height = $tip[0].offsetHeight
        , actualWidth
        , actualHeight
        , delta
        , replace

      $tip
        .offset(offset)
        .addClass(placement)
        .addClass('in')

      actualWidth = $tip[0].offsetWidth
      actualHeight = $tip[0].offsetHeight

      if (placement == 'top' && actualHeight != height) {
        offset.top = offset.top + height - actualHeight
        replace = true
      }

      if (placement == 'bottom' || placement == 'top') {
        delta = 0

        if (offset.left < 0){
          delta = offset.left * -2
          offset.left = 0
          $tip.offset(offset)
          actualWidth = $tip[0].offsetWidth
          actualHeight = $tip[0].offsetHeight
        }

        this.replaceArrow(delta - width + actualWidth, actualWidth, 'left')
      } else {
        this.replaceArrow(actualHeight - height, actualHeight, 'top')
      }

      if (replace) $tip.offset(offset)
    }

  , replaceArrow: function(delta, dimension, position){
      this
        .arrow()
        .css(position, delta ? (50 * (1 - delta / dimension) + "%") : '')
    }

  , setContent: function () {
      var $tip = this.tip()
        , title = this.getTitle()

      $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
      $tip.removeClass('fade in top bottom left right')
    }

  , hide: function () {
      var that = this
        , $tip = this.tip()
        , e = $.Event('hide')

      this.$element.trigger(e)
      if (e.isDefaultPrevented()) return

      $tip.removeClass('in')

      function removeWithAnimation() {
        var timeout = setTimeout(function () {
          $tip.off($.support.transition.end).detach()
        }, 500)

        $tip.one($.support.transition.end, function () {
          clearTimeout(timeout)
          $tip.detach()
        })
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        removeWithAnimation() :
        $tip.detach()

      this.$element.trigger('hidden')

      return this
    }

  , fixTitle: function () {
      var $e = this.$element
      if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
        $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
      }
    }

  , hasContent: function () {
      return this.getTitle()
    }

  , getPosition: function () {
      var el = this.$element[0]
      return $.extend({}, (typeof el.getBoundingClientRect == 'function') ? el.getBoundingClientRect() : {
        width: el.offsetWidth
      , height: el.offsetHeight
      }, this.$element.offset())
    }

  , getTitle: function () {
      var title
        , $e = this.$element
        , o = this.options

      title = $e.attr('data-original-title')
        || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

      return title
    }

  , tip: function () {
      return this.$tip = this.$tip || $(this.options.template)
    }

  , arrow: function(){
      return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
    }

  , validate: function () {
      if (!this.$element[0].parentNode) {
        this.hide()
        this.$element = null
        this.options = null
      }
    }

  , enable: function () {
      this.enabled = true
    }

  , disable: function () {
      this.enabled = false
    }

  , toggleEnabled: function () {
      this.enabled = !this.enabled
    }

  , toggle: function (e) {
      var self = e ? $(e.currentTarget)[this.type](this._options).data(this.type) : this
      self.tip().hasClass('in') ? self.hide() : self.show()
    }

  , destroy: function () {
      this.hide().$element.off('.' + this.type).removeData(this.type)
    }

  }


 /* TOOLTIP PLUGIN DEFINITION
  * ========================= */

  var old = $.fn.tooltip

  $.fn.tooltip = function ( option ) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('tooltip')
        , options = typeof option == 'object' && option
      if (!data) $this.data('tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tooltip.Constructor = Tooltip

  $.fn.tooltip.defaults = {
    animation: true
  , placement: 'top'
  , selector: false
  , template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
  , trigger: 'hover focus'
  , title: ''
  , delay: 0
  , html: false
  , container: false
  }


 /* TOOLTIP NO CONFLICT
  * =================== */

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(window.jQuery);

/* ========================================================
 * bootstrap-tab.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#tabs
 * ========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ======================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* TAB CLASS DEFINITION
  * ==================== */

  var Tab = function (element) {
    this.element = $(element)
  }

  Tab.prototype = {

    constructor: Tab

  , show: function () {
      var $this = this.element
        , $ul = $this.closest('ul:not(.dropdown-menu)')
        , selector = $this.attr('data-target')
        , previous
        , $target
        , e

      if (!selector) {
        selector = $this.attr('href')
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
      }

      if ( $this.parent('li').hasClass('active') ) return

      previous = $ul.find('.active:last a')[0]

      e = $.Event('show', {
        relatedTarget: previous
      })

      $this.trigger(e)

      if (e.isDefaultPrevented()) return

      $target = $(selector)

      this.activate($this.parent('li'), $ul)
      this.activate($target, $target.parent(), function () {
        $this.trigger({
          type: 'shown'
        , relatedTarget: previous
        })
      })
    }

  , activate: function ( element, container, callback) {
      var $active = container.find('> .active')
        , transition = callback
            && $.support.transition
            && $active.hasClass('fade')

      function next() {
        $active
          .removeClass('active')
          .find('> .dropdown-menu > .active')
          .removeClass('active')

        element.addClass('active')

        if (transition) {
          element[0].offsetWidth // reflow for transition
          element.addClass('in')
        } else {
          element.removeClass('fade')
        }

        if ( element.parent('.dropdown-menu') ) {
          element.closest('li.dropdown').addClass('active')
        }

        callback && callback()
      }

      transition ?
        $active.one($.support.transition.end, next) :
        next()

      $active.removeClass('in')
    }
  }


 /* TAB PLUGIN DEFINITION
  * ===================== */

  var old = $.fn.tab

  $.fn.tab = function ( option ) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('tab')
      if (!data) $this.data('tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tab.Constructor = Tab


 /* TAB NO CONFLICT
  * =============== */

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


 /* TAB DATA-API
  * ============ */

  $(document).on('click.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
    e.preventDefault()
    $(this).tab('show')
  })

}(window.jQuery);/* =============================================================
 * bootstrap-typeahead.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#typeahead
 * =============================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function($){

  "use strict"; // jshint ;_;


 /* TYPEAHEAD PUBLIC CLASS DEFINITION
  * ================================= */

  var Typeahead = function (element, options) {
    this.$element = $(element)
    this.options = $.extend({}, $.fn.typeahead.defaults, options)
    this.matcher = this.options.matcher || this.matcher
    this.sorter = this.options.sorter || this.sorter
    this.highlighter = this.options.highlighter || this.highlighter
    this.updater = this.options.updater || this.updater
    this.source = this.options.source
    this.$menu = $(this.options.menu)
    this.shown = false
    this.listen()
  }

  Typeahead.prototype = {

    constructor: Typeahead

  , select: function () {
    // CHANGE (rashidkpc) If nothing is selected, use existing value
      var val = this.$menu.find('.active').attr('data-value') || this.$element.val();
      this.$element
        .val(this.updater(val))
        .change()
      return this.hide()
    }

  , updater: function (item) {
      return item
    }

  , show: function () {
      var pos = $.extend({}, this.$element.position(), {
        height: this.$element[0].offsetHeight
      })

      this.$menu
        .insertAfter(this.$element)
        .css({
          top: pos.top + pos.height
        , left: pos.left
        })
        .show()

      this.shown = true
      return this
    }

  , hide: function () {
      this.$menu.hide()
      this.shown = false
      return this
    }

  , lookup: function (event) {
      var items

      this.query = this.$element.val()

      if (!this.query || this.query.length < this.options.minLength) {
        return this.shown ? this.hide() : this
      }

      items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source

      return items ? this.process(items) : this
    }

    , process: function (items) {
      var that = this

      items = $.grep(items, function (item) {
        return that.matcher(item)
      })

      items = this.sorter(items)

      if (!items.length) {
        return this.shown ? this.hide() : this
      }

      return this.render(items.slice(0, this.options.items)).show()
    }

  , matcher: function (item) {
      return ~item.toLowerCase().indexOf(this.query.toLowerCase())
    }

  , sorter: function (items) {
      var beginswith = []
        , caseSensitive = []
        , caseInsensitive = []
        , item

      while (item = items.shift()) {
        if (!item.toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(item)
        else if (~item.indexOf(this.query)) caseSensitive.push(item)
        else caseInsensitive.push(item)
      }

      return beginswith.concat(caseSensitive, caseInsensitive)
    }

  , highlighter: function (item) {
      var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
      if (!query) {
        return item;
      }
      return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
        return '<strong>' + match + '</strong>'
      });
    }

  , render: function (items) {
      var that = this

      items = $(items).map(function (i, item) {
        i = $(that.options.item).attr('data-value', item)
        i.find('a').html(that.highlighter(item))
        return i[0]
      })

      // CHANGE (rashidpc) Do not select first element by default
      // items.first().addClass('active')
      this.$menu.html(items)
      return this
    }

  , next: function (event) {
      var active = this.$menu.find('.active').removeClass('active')
        , next = active.next()

      if (!next.length) {
        next = $(this.$menu.find('li')[0])
      }

      next.addClass('active')
    }

  , prev: function (event) {
      var active = this.$menu.find('.active').removeClass('active')
        , prev = active.prev()

      if (!prev.length) {
        prev = this.$menu.find('li').last()
      }

      prev.addClass('active')
    }

  , listen: function () {
      this.$element
        .on('focus',    $.proxy(this.focus, this))
        .on('blur',     $.proxy(this.blur, this))
        .on('keypress', $.proxy(this.keypress, this))
        .on('keyup',    $.proxy(this.keyup, this))

      if (this.eventSupported('keydown')) {
        this.$element.on('keydown', $.proxy(this.keydown, this))
      }

      this.$menu
        .on('click', $.proxy(this.click, this))
        .on('mouseenter', 'li', $.proxy(this.mouseenter, this))
        .on('mouseleave', 'li', $.proxy(this.mouseleave, this))
    },

    destroy: function () {
      this.$element.off().removeData('typeahead');
      this.$menu.off();
    }

  , eventSupported: function(eventName) {
      var isSupported = eventName in this.$element
      if (!isSupported) {
        this.$element.setAttribute(eventName, 'return;')
        isSupported = typeof this.$element[eventName] === 'function'
      }
      return isSupported
    }

  , move: function (e) {
      if (!this.shown) return

      // grafana change, shift+left parenthesis
      if (e.shiftKey && e.keyCode === 40) {
        return;
      }

      switch(e.keyCode) {
        case 9: // tab
        case 13: // enter
        case 27: // escape
          e.preventDefault()
          break

        case 38: // up arrow
          e.preventDefault()
          this.prev()
          break

        case 40: // down arrow
          e.preventDefault()
          this.next()
          break
      }

      e.stopPropagation()
    }

  , keydown: function (e) {
      this.suppressKeyPressRepeat = ~$.inArray(e.keyCode, [40,38,9,13,27,57])
      this.move(e)
    }

  , keypress: function (e) {
      if (this.suppressKeyPressRepeat) return
      this.move(e)
    }

  , keyup: function (e) {
      switch(e.keyCode) {
        case 40: // down arrow
        case 38: // up arrow
        case 16: // shift
        case 17: // ctrl
        case 18: // alt
          break

        case 9: // tab
        case 13: // enter
          if (!this.shown) return
          this.select()
          break

        case 27: // escape
          if (!this.shown) return
          this.hide()
          break

        default:
          this.lookup();
      }

      if(e.keyCode === 13 && typeof this.$menu.find('.active').attr('data-value') === 'undefined') {
        // CHANGE (rashidkpc). Enter was hit, nothing was selected from typeahead, submit form
        this.$element.submit();
      } else {
        e.stopPropagation()
        e.preventDefault()
      }

  }

  , focus: function (e) {
      this.focused = true
    }

  , blur: function (e) {
      this.focused = false
      if (!this.mousedover && this.shown) this.hide()
    }

  , click: function (e) {
      e.stopPropagation()
      e.preventDefault()
      this.select()
      this.$element.focus()
    }

  , mouseenter: function (e) {
      this.mousedover = true
      this.$menu.find('.active').removeClass('active')
      $(e.currentTarget).addClass('active')
    }

  , mouseleave: function (e) {
      this.mousedover = false
      if (!this.focused && this.shown) this.hide()
    }

  }


  /* TYPEAHEAD PLUGIN DEFINITION
   * =========================== */

  var old = $.fn.typeahead

  $.fn.typeahead = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('typeahead')
        , options = typeof option == 'object' && option
      if (!data) $this.data('typeahead', (data = new Typeahead(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.typeahead.defaults = {
    source: []
  , items: 8
  , menu: '<ul class="typeahead dropdown-menu"></ul>'
  , item: '<li><a href="#"></a></li>'
  , minLength: 1
  }

  $.fn.typeahead.Constructor = Typeahead


 /* TYPEAHEAD NO CONFLICT
  * =================== */

  $.fn.typeahead.noConflict = function () {
    $.fn.typeahead = old
    return this
  }


 /* TYPEAHEAD DATA-API
  * ================== */

  $(document).on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
    var $this = $(this)
    if ($this.data('typeahead')) return
    $this.typeahead($this.data())
  })

}(window.jQuery);
/* ==========================================================
 * bootstrap-affix.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#affix
 * ==========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* AFFIX CLASS DEFINITION
  * ====================== */

  var Affix = function (element, options) {
    this.options = $.extend({}, $.fn.affix.defaults, options)
    this.$window = $(window)
      .on('scroll.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.affix.data-api',  $.proxy(function () { setTimeout($.proxy(this.checkPosition, this), 1) }, this))
    this.$element = $(element)
    this.checkPosition()
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var scrollHeight = $(document).height()
      , scrollTop = this.$window.scrollTop()
      , position = this.$element.offset()
      , offset = this.options.offset
      , offsetBottom = offset.bottom
      , offsetTop = offset.top
      , reset = 'affix affix-top affix-bottom'
      , affix

    if (typeof offset != 'object') offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function') offsetTop = offset.top()
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom()

    affix = this.unpin != null && (scrollTop + this.unpin <= position.top) ?
      false    : offsetBottom != null && (position.top + this.$element.height() >= scrollHeight - offsetBottom) ?
      'bottom' : offsetTop != null && scrollTop <= offsetTop ?
      'top'    : false

    if (this.affixed === affix) return

    this.affixed = affix
    this.unpin = affix == 'bottom' ? position.top - scrollTop : null

    this.$element.removeClass(reset).addClass('affix' + (affix ? '-' + affix : ''))
  }


 /* AFFIX PLUGIN DEFINITION
  * ======================= */

  var old = $.fn.affix

  $.fn.affix = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('affix')
        , options = typeof option == 'object' && option
      if (!data) $this.data('affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.affix.Constructor = Affix

  $.fn.affix.defaults = {
    offset: 0
  }


 /* AFFIX NO CONFLICT
  * ================= */

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


 /* AFFIX DATA-API
  * ============== */

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
        , data = $spy.data()

      data.offset = data.offset || {}

      data.offsetBottom && (data.offset.bottom = data.offsetBottom)
      data.offsetTop && (data.offset.top = data.offsetTop)

      $spy.affix(data)
    })
  })


}(window.jQuery);


/***/ }),
/* 753 */
/***/ (function(module, exports) {

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.13.4 - 2015-09-03
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.tpls","ui.bootstrap.position","ui.bootstrap.dateparser","ui.bootstrap.datepicker"]);
angular.module("ui.bootstrap.tpls", ["template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html"]);
angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$position', ['$document', '$window', function($document, $window) {
    function getStyle(el, cssprop) {
      if (el.currentStyle) { //IE
        return el.currentStyle[cssprop];
      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssprop];
      }
      // finally try and get inline style
      return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
      return (getStyle(element, 'position') || 'static' ) === 'static';
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function(element) {
      var docDomEl = $document[0];
      var offsetParent = element.offsetParent || docDomEl;
      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docDomEl;
    };

    return {
      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */
      position: function(element) {
        var elBCR = this.offset(element);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = parentOffsetEl(element[0]);
        if (offsetParentEl != $document[0]) {
          offsetParentBCR = this.offset(angular.element(offsetParentEl));
          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: elBCR.top - offsetParentBCR.top,
          left: elBCR.left - offsetParentBCR.left
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */
      offset: function(element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      },

      /**
       * Provides coordinates for the targetEl in relation to hostEl
       */
      positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
        var positionStrParts = positionStr.split('-');
        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';

        var hostElPos,
          targetElWidth,
          targetElHeight,
          targetElPos;

        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

        targetElWidth = targetEl.prop('offsetWidth');
        targetElHeight = targetEl.prop('offsetHeight');

        var shiftWidth = {
          center: function() {
            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
          },
          left: function() {
            return hostElPos.left;
          },
          right: function() {
            return hostElPos.left + hostElPos.width;
          }
        };

        var shiftHeight = {
          center: function() {
            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
          },
          top: function() {
            return hostElPos.top;
          },
          bottom: function() {
            return hostElPos.top + hostElPos.height;
          }
        };

        switch (pos0) {
          case 'right':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: shiftWidth[pos0]()
            };
            break;
          case 'left':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: hostElPos.left - targetElWidth
            };
            break;
          case 'bottom':
            targetElPos = {
              top: shiftHeight[pos0](),
              left: shiftWidth[pos1]()
            };
            break;
          default:
            targetElPos = {
              top: hostElPos.top - targetElHeight,
              left: shiftWidth[pos1]()
            };
            break;
        }

        return targetElPos;
      }
    };
  }]);

angular.module('ui.bootstrap.dateparser', [])

.service('dateParser', ['$log', '$locale', 'orderByFilter', function($log, $locale, orderByFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  this.parsers = {};

  var formatCodeToRegex = {
    'yyyy': {
      regex: '\\d{4}',
      apply: function(value) { this.year = +value; }
    },
    'yy': {
      regex: '\\d{2}',
      apply: function(value) { this.year = +value + 2000; }
    },
    'y': {
      regex: '\\d{1,4}',
      apply: function(value) { this.year = +value; }
    },
    'MMMM': {
      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
    },
    'MMM': {
      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
    },
    'MM': {
      regex: '0[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'M': {
      regex: '[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'dd': {
      regex: '[0-2][0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'd': {
      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'EEEE': {
      regex: $locale.DATETIME_FORMATS.DAY.join('|')
    },
    'EEE': {
      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
    },
    'HH': {
      regex: '(?:0|1)[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'hh': {
      regex: '0[0-9]|1[0-2]',
      apply: function(value) { this.hours = +value; }
    },
    'H': {
      regex: '1?[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'h': {
      regex: '[0-9]|1[0-2]',
      apply: function(value) { this.hours = +value; }
    },
    'mm': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'm': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'sss': {
      regex: '[0-9][0-9][0-9]',
      apply: function(value) { this.milliseconds = +value; }
    },
    'ss': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    's': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    'a': {
      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
      apply: function(value) {
        if (this.hours === 12) {
          this.hours = 0;
        }

        if (value === 'PM') {
          this.hours += 12;
        }
      }
    }
  };

  function createParser(format) {
    var map = [], regex = format.split('');

    angular.forEach(formatCodeToRegex, function(data, code) {
      var index = format.indexOf(code);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + code.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({ index: index, apply: data.apply });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format);
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex);

    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i-1];
        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      if (isValid(fields.year, fields.month, fields.date)) {
        dt = new Date(fields.year, fields.month, fields.date,
          fields.hours, fields.minutes, fields.seconds,
          fields.milliseconds || 0);
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }
}]);

angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])

.value('$datepickerSuppressError', false)

.constant('datepickerConfig', {
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  datepickerMode: 'day',
  minMode: 'day',
  maxMode: 'year',
  showWeeks: true,
  startingDay: 0,
  yearRange: 20,
  minDate: null,
  maxDate: null,
  shortcutPropagation: false
})

.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'datepickerConfig', '$datepickerSuppressError', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  // Configuration attributes
  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
                   'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
  });

  // Watchable date attributes
  angular.forEach(['minDate', 'maxDate'], function(key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = value ? new Date(value) : null;
        self.refreshView();
      });
    } else {
      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
    }
  });

  angular.forEach(['minMode', 'maxMode'], function(key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = angular.isDefined(value) ? value : $attrs[key];
        $scope[key] = self[key];
        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
          $scope.datepickerMode = self[key];
        }
      });
    } else {
      self[key] = datepickerConfig[key] || null;
      $scope[key] = self[key];
    }
  });

  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  if (angular.isDefined($attrs.initDate)) {
    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
    $scope.$parent.$watch($attrs.initDate, function(initDate) {
      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
        self.activeDate = initDate;
        self.refreshView();
      }
    });
  } else {
    this.activeDate = new Date();
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = date;
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      this._refreshView();

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    return {
      date: date,
      label: dateFilter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      current: this.compare(date, new Date()) === 0,
      customClass: this.customClass(date)
    };
  };

  this.isDisabled = function(date) {
    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  // Fix a hard-reprodusible bug with timezones
  // The bug depends on OS, browser, current timezone and current date
  // i.e.
  // var date = new Date(2014, 0, 1);
  // console.log(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
  // can result in "2013 11 31 23" because of the bug.
  this.fixTimeZone = function(date) {
    var hours = date.getHours();
    date.setHours(hours === 23 ? hours + 2 : 0);
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
    }
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
      return;
    }

    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
      focusElement();
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
      focusElement();
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };
}])

.directive('datepicker', function() {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/datepicker/datepicker.html';
    },
    scope: {
      datepickerMode: '=?',
      dateDisabled: '&',
      customClass: '&',
      shortcutPropagation: '&?'
    },
    require: ['datepicker', '^ngModel'],
    controller: 'DatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('daypicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/day.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      scope.showWeeks = ctrl.showWeeks;

      ctrl.step = { months: 1 };
      ctrl.element = element;

      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function getDaysInMonth(year, month) {
        return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
      }

      function getDates(startDate, n) {
        var dates = new Array(n), current = new Date(startDate), i = 0, date;
        while (i < n) {
          date = new Date(current);
          ctrl.fixTimeZone(date);
          dates[i++] = date;
          current.setDate(current.getDate() + 1);
        }
        return dates;
      }

      ctrl._refreshView = function() {
        var year = ctrl.activeDate.getFullYear(),
          month = ctrl.activeDate.getMonth(),
          firstDayOfMonth = new Date(year, month, 1),
          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
          numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
          firstDate = new Date(firstDayOfMonth);

        if (numDisplayedFromPreviousMonth > 0) {
          firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
        }

        // 42 is the number of days on a six-month calendar
        var days = getDates(firstDate, 42);
        for (var i = 0; i < 42; i ++) {
          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
            secondary: days[i].getMonth() !== month,
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.labels = new Array(7);
        for (var j = 0; j < 7; j++) {
          scope.labels[j] = {
            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
            full: dateFilter(days[j].date, 'EEEE')
          };
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
        scope.rows = ctrl.split(days, 7);

        if (scope.showWeeks) {
          scope.weekNumbers = [];
          var thursdayIndex = (4 + 7 - ctrl.startingDay) % 7,
              numWeeks = scope.rows.length;
          for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
            scope.weekNumbers.push(
              getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
          }
        }
      };

      ctrl.compare = function(date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
      };

      function getISO8601WeekNumber(date) {
        var checkDate = new Date(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
        var time = checkDate.getTime();
        checkDate.setMonth(0); // Compare with Jan 1
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
      }

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getDate();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 7;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 7;
        } else if (key === 'pageup' || key === 'pagedown') {
          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setMonth(month, 1);
          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
        } else if (key === 'home') {
          date = 1;
        } else if (key === 'end') {
          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
        }
        ctrl.activeDate.setDate(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('monthpicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/month.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      ctrl.step = { years: 1 };
      ctrl.element = element;

      ctrl._refreshView = function() {
        var months = new Array(12),
            year = ctrl.activeDate.getFullYear(),
            date;

        for (var i = 0; i < 12; i++) {
          date = new Date(year, i, 1);
          ctrl.fixTimeZone(date);
          months[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatMonth), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
        scope.rows = ctrl.split(months, 3);
      };

      ctrl.compare = function(date1, date2) {
        return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
      };

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getMonth();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 3;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 3;
        } else if (key === 'pageup' || key === 'pagedown') {
          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setFullYear(year);
        } else if (key === 'home') {
          date = 0;
        } else if (key === 'end') {
          date = 11;
        }
        ctrl.activeDate.setMonth(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('yearpicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/year.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      var range = ctrl.yearRange;

      ctrl.step = { years: range };
      ctrl.element = element;

      function getStartingYear( year ) {
        return parseInt((year - 1) / range, 10) * range + 1;
      }

      ctrl._refreshView = function() {
        var years = new Array(range), date;

        for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
          date = new Date(start + i, 0, 1);
          ctrl.fixTimeZone(date);
          years[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatYear), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = [years[0].label, years[range - 1].label].join(' - ');
        scope.rows = ctrl.split(years, 5);
      };

      ctrl.compare = function(date1, date2) {
        return date1.getFullYear() - date2.getFullYear();
      };

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getFullYear();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 5;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 5;
        } else if (key === 'pageup' || key === 'pagedown') {
          date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
        } else if (key === 'home') {
          date = getStartingYear(ctrl.activeDate.getFullYear());
        } else if (key === 'end') {
          date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
        }
        ctrl.activeDate.setFullYear(date);
      };

      ctrl.refreshView();
    }
  };
}])

.constant('datepickerPopupConfig', {
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'template/datepicker/popup.html',
  datepickerTemplateUrl: 'template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  currentText: 'Today',
  clearText: 'Clear',
  closeText: 'Done',
  closeOnDateSelection: true,
  appendToBody: false,
  showButtonBar: true,
  onOpenFocus: true
})

.directive('datepickerPopup', ['$compile', '$parse', '$document', '$rootScope', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig', '$timeout',
function($compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout) {
  return {
    restrict: 'EA',
    require: 'ngModel',
    scope: {
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@',
      dateDisabled: '&',
      customClass: '&'
    },
    link: function(scope, element, attrs, ngModel) {
      var dateFormat,
          closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
          appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody,
          onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus,
          datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl,
          datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl,
          cache = {};

      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;

      scope.getText = function(key) {
        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
      };

      scope.isDisabled = function(date) {
        if (date === 'today') {
          date = new Date();
        }

        return ((scope.watchData.minDate && scope.compare(date, cache.minDate) < 0) ||
          (scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0));
      };

      scope.compare = function(date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
      };

      var isHtml5DateInput = false;
      if (datepickerPopupConfig.html5Types[attrs.type]) {
        dateFormat = datepickerPopupConfig.html5Types[attrs.type];
        isHtml5DateInput = true;
      } else {
        dateFormat = attrs.datepickerPopup || datepickerPopupConfig.datepickerPopup;
        attrs.$observe('datepickerPopup', function(value, oldValue) {
            var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
            // Invalidate the $modelValue to ensure that formatters re-run
            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
            if (newDateFormat !== dateFormat) {
              dateFormat = newDateFormat;
              ngModel.$modelValue = null;

              if (!dateFormat) {
                throw new Error('datepickerPopup must have a date format specified.');
              }
            }
        });
      }

      if (!dateFormat) {
        throw new Error('datepickerPopup must have a date format specified.');
      }

      if (isHtml5DateInput && attrs.datepickerPopup) {
        throw new Error('HTML5 date input types do not support custom formats.');
      }

      // popup element used to display calendar
      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
      popupEl.attr({
        'ng-model': 'date',
        'ng-change': 'dateSelection(date)',
        'template-url': datepickerPopupTemplateUrl
      });

      function cameltoDash(string) {
        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
      }

      // datepicker element
      var datepickerEl = angular.element(popupEl.children()[0]);
      datepickerEl.attr('template-url', datepickerTemplateUrl);

      if (isHtml5DateInput) {
        if (attrs.type === 'month') {
          datepickerEl.attr('datepicker-mode', '"month"');
          datepickerEl.attr('min-mode', 'month');
        }
      }

      if (attrs.datepickerOptions) {
        var options = scope.$parent.$eval(attrs.datepickerOptions);
        if (options && options.initDate) {
          scope.initDate = options.initDate;
          datepickerEl.attr('init-date', 'initDate');
          delete options.initDate;
        }
        angular.forEach(options, function(value, option) {
          datepickerEl.attr( cameltoDash(option), value );
        });
      }

      scope.watchData = {};
      angular.forEach(['minMode', 'maxMode', 'minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function(key) {
        if (attrs[key]) {
          var getAttribute = $parse(attrs[key]);
          scope.$parent.$watch(getAttribute, function(value) {
            scope.watchData[key] = value;
            if (key === 'minDate' || key === 'maxDate') {
              cache[key] = new Date(value);
            }
          });
          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

          // Propagate changes from datepicker to outside
          if (key === 'datepickerMode') {
            var setAttribute = getAttribute.assign;
            scope.$watch('watchData.' + key, function(value, oldvalue) {
              if (angular.isFunction(setAttribute) && value !== oldvalue) {
                setAttribute(scope.$parent, value);
              }
            });
          }
        }
      });
      if (attrs.dateDisabled) {
        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
      }

      if (attrs.showWeeks) {
        datepickerEl.attr('show-weeks', attrs.showWeeks);
      }

      if (attrs.customClass) {
        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
      }

      function parseDate(viewValue) {
        if (angular.isNumber(viewValue)) {
          // presumably timestamp to date object
          viewValue = new Date(viewValue);
        }

        if (!viewValue) {
          return null;
        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
          return viewValue;
        } else if (angular.isString(viewValue)) {
          var date = dateParser.parse(viewValue, dateFormat, scope.date);
          if (isNaN(date)) {
            return undefined;
          } else {
            return date;
          }
        } else {
          return undefined;
        }
      }

      function validator(modelValue, viewValue) {
        var value = modelValue || viewValue;

        if (!attrs.ngRequired && !value) {
          return true;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }
        if (!value) {
          return true;
        } else if (angular.isDate(value) && !isNaN(value)) {
          return true;
        } else if (angular.isString(value)) {
          var date = dateParser.parse(value, dateFormat);
          return !isNaN(date);
        } else {
          return false;
        }
      }

      if (!isHtml5DateInput) {
        // Internal API to maintain the correct ng-invalid-[key] class
        ngModel.$$parserName = 'date';
        ngModel.$validators.date = validator;
        ngModel.$parsers.unshift(parseDate);
        ngModel.$formatters.push(function(value) {
          scope.date = value;
          return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
        });
      } else {
        ngModel.$formatters.push(function(value) {
          scope.date = value;
          return value;
        });
      }

      // Inner change
      scope.dateSelection = function(dt) {
        if (angular.isDefined(dt)) {
          scope.date = dt;
        }
        var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
        element.val(date);
        ngModel.$setViewValue(date);

        if (closeOnDateSelection) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      // Detect changes in the view from the text box
      ngModel.$viewChangeListeners.push(function() {
        scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
      });

      var documentClickBind = function(event) {
        if (scope.isOpen && !(element[0].contains(event.target) || popupEl[0].contains(event.target))) {
          scope.$apply(function() {
            scope.isOpen = false;
          });
        }
      };

      var inputKeydownBind = function(evt) {
        if (evt.which === 27 && scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.$apply(function() {
            scope.isOpen = false;
          });
          element[0].focus();
        } else if (evt.which === 40 && !scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.$apply(function() {
            scope.isOpen = true;
          });
        }
      };
      element.bind('keydown', inputKeydownBind);

      scope.keydown = function(evt) {
        if (evt.which === 27) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      scope.$watch('isOpen', function(value) {
        if (value) {
          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
          scope.position.top = scope.position.top + element.prop('offsetHeight');

          $timeout(function() {
            if (onOpenFocus) {
              scope.$broadcast('datepicker.focus');
            }
            $document.bind('click', documentClickBind);
          }, 0, false);
        } else {
          $document.unbind('click', documentClickBind);
        }
      });

      scope.select = function(date) {
        if (date === 'today') {
          var today = new Date();
          if (angular.isDate(scope.date)) {
            date = new Date(scope.date);
            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
          } else {
            date = new Date(today.setHours(0, 0, 0, 0));
          }
        }
        scope.dateSelection(date);
      };

      scope.close = function() {
        scope.isOpen = false;
        element[0].focus();
      };

      var $popup = $compile(popupEl)(scope);
      // Prevent jQuery cache memory leak (template is now redundant after linking)
      popupEl.remove();

      if (appendToBody) {
        $document.find('body').append($popup);
      } else {
        element.after($popup);
      }

      scope.$on('$destroy', function() {
        if (scope.isOpen === true) {
          if (!$rootScope.$$phase) {
            scope.$apply(function() {
              scope.isOpen = false;
            });
          }
        }

        $popup.remove();
        element.unbind('keydown', inputKeydownBind);
        $document.unbind('click', documentClickBind);
      });
    }
  };
}])

.directive('datepickerPopupWrap', function() {
  return {
    restrict:'EA',
    replace: true,
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/datepicker/popup.html';
    }
  };
});


angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
    "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" +
    "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" +
    "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" +
    "</div>");
}]);

angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/popup.html",
    "<ul class=\"dropdown-menu\" ng-if=\"isOpen\" style=\"display: block\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "	<li ng-transclude></li>\n" +
    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
    "		<span class=\"btn-group pull-left\">\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
    "		</span>\n" +
    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);



/***/ }),
/* 754 */
/***/ (function(module, exports) {

/**
 * AngularStrap - Twitter Bootstrap directives for AngularJS
 * @version v0.7.5 - 2013-07-21
 * @link http://mgcrea.github.com/angular-strap
 * @author Olivier Louvignes <olivier@mg-crea.com>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
angular.module('$strap.config', []).value('$strapConfig', {});
angular.module('$strap.filters', ['$strap.config']);
angular.module('$strap.directives', ['$strap.config']);
angular.module('$strap', [
  '$strap.filters',
  '$strap.directives',
  '$strap.config'
]);
'use strict';
angular.module('$strap.directives').factory('$modal', [
  '$rootScope',
  '$compile',
  '$http',
  '$timeout',
  '$q',
  '$templateCache',
  '$strapConfig',
  function ($rootScope, $compile, $http, $timeout, $q, $templateCache, $strapConfig) {
    var ModalFactory = function ModalFactory(config) {
      function Modal(config) {
        var options = angular.extend({ show: true }, $strapConfig.modal, config);
        var scope = options.scope ? options.scope : $rootScope.$new()
        var templateUrl = options.template;
        return $q.when(options.templateHtml || $templateCache.get(templateUrl) || $http.get(templateUrl, { cache: true }).then(function (res) {
          return res.data;
        })).then(function onSuccess(template) {
          var id = scope.$id;
          if (templateUrl) {
            id += templateUrl.replace('.html', '').replace(/[\/|\.|:]/g, '-');
          }
          // grafana change, removed fade
          var $modal = $('<div class="modal hide" tabindex="-1"></div>').attr('id', id).html(template);
          if (options.modalClass)
            $modal.addClass(options.modalClass);
          $('body').append($modal);
          $timeout(function () {
            $compile($modal)(scope);
          });
          scope.$modal = function (name) {
            $modal.modal(name);
          };
          angular.forEach([
            'show',
            'hide'
          ], function (name) {
            scope[name] = function () {
              $modal.modal(name);
            };
          });
          scope.dismiss = scope.hide;
          angular.forEach([
            'show',
            'shown',
            'hide',
            'hidden'
          ], function (name) {
            $modal.on(name, function (ev) {
              scope.$emit('modal-' + name, ev);
            });
          });
          $modal.on('shown', function (ev) {
            $('input[autofocus], textarea[autofocus]', $modal).first().trigger('focus');
          });
          $modal.on('hidden', function (ev) {
            if (!options.persist)
              scope.$destroy();
          });
          scope.$on('$destroy', function () {
            $modal.remove();
          });
          $modal.modal(options);
          return $modal;
        });
      }
      return new Modal(config);
    };
    return ModalFactory;
  }
])

'use strict';
angular.module('$strap.directives').directive('bsTooltip', [
  '$parse',
  '$compile',
  function ($parse, $compile) {
    return {
      restrict: 'A',
      scope: true,
      link: function postLink(scope, element, attrs, ctrl) {
        var getter = $parse(attrs.bsTooltip), setter = getter.assign, value = getter(scope);
        scope.$watch(attrs.bsTooltip, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            value = newValue;
          }
        });
        // Grafana change, always hide other tooltips
        if (true) {
          element.on('show', function (ev) {
            $('.tooltip.in').each(function () {
              var $this = $(this), tooltip = $this.data('tooltip');
              if (tooltip && !tooltip.$element.is(element)) {
                $this.tooltip('hide');
              }
            });
          });
        }
        element.tooltip({
          title: function () {
            return angular.isFunction(value) ? value.apply(null, arguments) : value;
          },
          html: true,
          container: 'body', // Grafana change
        });
        var tooltip = element.data('tooltip');
        tooltip.show = function () {
          var r = $.fn.tooltip.Constructor.prototype.show.apply(this, arguments);
          this.tip().data('tooltip', this);
          return r;
        };
        scope._tooltip = function (event) {
          element.tooltip(event);
        };
        scope.hide = function () {
          element.tooltip('hide');
        };
        scope.show = function () {
          element.tooltip('show');
        };
        scope.dismiss = scope.hide;
      }
    };
  }
]);

'use strict';
angular.module('$strap.directives').directive('bsTypeahead', [
  '$parse',
  function ($parse) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function postLink(scope, element, attrs, controller) {
        var getter = $parse(attrs.bsTypeahead), setter = getter.assign, value = getter(scope);
        scope.$watch(attrs.bsTypeahead, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            value = newValue;
          }
        });
        element.attr('data-provide', 'typeahead');
        element.typeahead({
          source: function (query) {
            return angular.isFunction(value) ? value.apply(null, arguments) : value;
          },
          minLength: attrs.minLength || 1,
          items: attrs.items,
          updater: function (value) {
            if (controller) {
              scope.$apply(function () {
                controller.$setViewValue(value);
              });
            }
            scope.$emit('typeahead-updated', value);
            return value;
          }
        });
        var typeahead = element.data('typeahead');
        typeahead.lookup = function (ev) {
          var items;
          this.query = this.$element.val() || '';
          if (this.query.length < this.options.minLength) {
            return this.shown ? this.hide() : this;
          }
          items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source;
          return items ? this.process(items) : this;
        };
        if (!!attrs.matchAll) {
          typeahead.matcher = function (item) {
            return true;
          };
        }
        if (attrs.minLength === '0') {
          setTimeout(function () {
            element.on('focus', function () {
              element.val().length === 0 && setTimeout(element.typeahead.bind(element, 'lookup'), 200);
            });
          });
        }
      }
    };
  }
]);


/***/ }),
/* 755 */,
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dashClass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


/** @ngInject */
function dashClass() {
    return {
        link: function ($scope, elem) {
            $scope.onAppEvent('panel-fullscreen-enter', function () {
                elem.toggleClass('panel-in-fullscreen', true);
            });
            $scope.onAppEvent('panel-fullscreen-exit', function () {
                elem.toggleClass('panel-in-fullscreen', false);
            });
            $scope.$watch('ctrl.dashboardViewState.state.editview', function (newValue) {
                if (newValue) {
                    elem.toggleClass('dashboard-page--settings-opening', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(newValue));
                    setTimeout(function () {
                        elem.toggleClass('dashboard-page--settings-open', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(newValue));
                    }, 10);
                }
                else {
                    elem.removeClass('dashboard-page--settings-opening');
                    elem.removeClass('dashboard-page--settings-open');
                }
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive('dashClass', dashClass);


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dropdownTypeahead */
/* unused harmony export dropdownTypeahead2 */
/* harmony import */ 
dropdownTypeahead.$inject = ["$compile"];
dropdownTypeahead2.$inject = ["$compile"];var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(3);



/** @ngInject */
function dropdownTypeahead($compile) {
    var inputTemplate = '<input type="text"' +
        ' class="gf-form-input input-medium tight-form-input"' +
        ' spellcheck="false" style="display:none"></input>';
    var buttonTemplate = '<a class="gf-form-label tight-form-func dropdown-toggle"' +
        ' tabindex="1" gf-dropdown="menuItems" data-toggle="dropdown"' +
        ' data-placement="top"><i class="fa fa-plus"></i></a>';
    return {
        scope: {
            menuItems: '=dropdownTypeahead',
            dropdownTypeaheadOnSelect: '&dropdownTypeaheadOnSelect',
            model: '=ngModel',
        },
        link: function ($scope, elem, attrs) {
            var $input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(inputTemplate);
            var $button = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(buttonTemplate);
            $input.appendTo(elem);
            $button.appendTo(elem);
            if (attrs.linkText) {
                $button.html(attrs.linkText);
            }
            if (attrs.ngModel) {
                $scope.$watch('model', function (newValue) {
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each($scope.menuItems, function (item) {
                        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(item.submenu, function (subItem) {
                            if (subItem.value === newValue) {
                                $button.html(subItem.text);
                            }
                        });
                    });
                });
            }
            var typeaheadValues = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reduce($scope.menuItems, function (memo, value, index) {
                if (!value.submenu) {
                    value.click = 'menuItemSelected(' + index + ')';
                    memo.push(value.text);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(value.submenu, function (item, subIndex) {
                        item.click = 'menuItemSelected(' + index + ',' + subIndex + ')';
                        memo.push(value.text + ' ' + item.text);
                    });
                }
                return memo;
            }, []);
            $scope.menuItemSelected = function (index, subIndex) {
                var menuItem = $scope.menuItems[index];
                var payload = { $item: menuItem };
                if (menuItem.submenu && subIndex !== void 0) {
                    payload.$subItem = menuItem.submenu[subIndex];
                }
                $scope.dropdownTypeaheadOnSelect(payload);
            };
            $input.attr('data-provide', 'typeahead');
            $input.typeahead({
                source: typeaheadValues,
                minLength: 1,
                items: 10,
                updater: function (value) {
                    var result = {};
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each($scope.menuItems, function (menuItem) {
                        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(menuItem.submenu, function (submenuItem) {
                            if (value === menuItem.text + ' ' + submenuItem.text) {
                                result.$subItem = submenuItem;
                                result.$item = menuItem;
                            }
                        });
                    });
                    if (result.$item) {
                        $scope.$apply(function () {
                            $scope.dropdownTypeaheadOnSelect(result);
                        });
                    }
                    $input.trigger('blur');
                    return '';
                },
            });
            $button.click(function () {
                $button.hide();
                $input.show();
                $input.focus();
            });
            $input.keyup(function () {
                elem.toggleClass('open', $input.val() === '');
            });
            $input.blur(function () {
                $input.hide();
                $input.val('');
                $button.show();
                $button.focus();
                // clicking the function dropdown menu won't
                // work if you remove class at once
                setTimeout(function () {
                    elem.removeClass('open');
                }, 200);
            });
            $compile(elem.contents())($scope);
        },
    };
}
/** @ngInject */
function dropdownTypeahead2($compile) {
    var inputTemplate = '<input type="text"' + ' class="gf-form-input"' + ' spellcheck="false" style="display:none"></input>';
    var buttonTemplate = '<a class="gf-form-input dropdown-toggle"' +
        ' tabindex="1" gf-dropdown="menuItems" data-toggle="dropdown"' +
        ' data-placement="top"><i class="fa fa-plus"></i></a>';
    return {
        scope: {
            menuItems: '=dropdownTypeahead2',
            dropdownTypeaheadOnSelect: '&dropdownTypeaheadOnSelect',
            model: '=ngModel',
        },
        link: function ($scope, elem, attrs) {
            var $input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(inputTemplate);
            var $button = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(buttonTemplate);
            $input.appendTo(elem);
            $button.appendTo(elem);
            if (attrs.linkText) {
                $button.html(attrs.linkText);
            }
            if (attrs.ngModel) {
                $scope.$watch('model', function (newValue) {
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each($scope.menuItems, function (item) {
                        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(item.submenu, function (subItem) {
                            if (subItem.value === newValue) {
                                $button.html(subItem.text);
                            }
                        });
                    });
                });
            }
            var typeaheadValues = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reduce($scope.menuItems, function (memo, value, index) {
                if (!value.submenu) {
                    value.click = 'menuItemSelected(' + index + ')';
                    memo.push(value.text);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(value.submenu, function (item, subIndex) {
                        item.click = 'menuItemSelected(' + index + ',' + subIndex + ')';
                        memo.push(value.text + ' ' + item.text);
                    });
                }
                return memo;
            }, []);
            $scope.menuItemSelected = function (index, subIndex) {
                var menuItem = $scope.menuItems[index];
                var payload = { $item: menuItem };
                if (menuItem.submenu && subIndex !== void 0) {
                    payload.$subItem = menuItem.submenu[subIndex];
                }
                $scope.dropdownTypeaheadOnSelect(payload);
            };
            $input.attr('data-provide', 'typeahead');
            $input.typeahead({
                source: typeaheadValues,
                minLength: 1,
                items: 10,
                updater: function (value) {
                    var result = {};
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each($scope.menuItems, function (menuItem) {
                        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(menuItem.submenu, function (submenuItem) {
                            if (value === menuItem.text + ' ' + submenuItem.text) {
                                result.$subItem = submenuItem;
                                result.$item = menuItem;
                            }
                        });
                    });
                    if (result.$item) {
                        $scope.$apply(function () {
                            $scope.dropdownTypeaheadOnSelect(result);
                        });
                    }
                    $input.trigger('blur');
                    return '';
                },
            });
            $button.click(function () {
                $button.hide();
                $input.show();
                $input.focus();
            });
            $input.keyup(function () {
                elem.toggleClass('open', $input.val() === '');
            });
            $input.blur(function () {
                $input.hide();
                $input.val('');
                $button.show();
                $button.focus();
                // clicking the function dropdown menu won't
                // work if you remove class at once
                setTimeout(function () {
                    elem.removeClass('open');
                }, 200);
            });
            $compile(elem.contents())($scope);
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('dropdownTypeahead', dropdownTypeahead);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('dropdownTypeahead2', dropdownTypeahead2);


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export metricSegment */
/* unused harmony export metricSegmentModel */
/* harmony import */ 
metricSegment.$inject = ["$compile", "$sce"];
metricSegmentModel.$inject = ["uiSegmentSrv", "$q"];var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(3);



/** @ngInject */
function metricSegment($compile, $sce) {
    var inputTemplate = '<input type="text" data-provide="typeahead" ' +
        ' class="gf-form-input input-medium"' +
        ' spellcheck="false" style="display:none"></input>';
    var linkTemplate = '<a class="gf-form-label" ng-class="segment.cssClass" ' +
        'tabindex="1" give-focus="segment.focus" ng-bind-html="segment.html"></a>';
    var selectTemplate = '<a class="gf-form-input gf-form-input--dropdown" ng-class="segment.cssClass" ' +
        'tabindex="1" give-focus="segment.focus" ng-bind-html="segment.html"></a>';
    return {
        scope: {
            segment: '=',
            getOptions: '&',
            onChange: '&',
            debounce: '@',
        },
        link: function ($scope, elem) {
            var $input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(inputTemplate);
            var segment = $scope.segment;
            var $button = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(segment.selectMode ? selectTemplate : linkTemplate);
            var options = null;
            var cancelBlur = null;
            var linkMode = true;
            var debounceLookup = $scope.debounce;
            $input.appendTo(elem);
            $button.appendTo(elem);
            $scope.updateVariableValue = function (value) {
                if (value === '' || segment.value === value) {
                    return;
                }
                value = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.unescape(value);
                $scope.$apply(function () {
                    var selected = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find($scope.altSegments, { value: value });
                    if (selected) {
                        segment.value = selected.value;
                        segment.html = selected.html || selected.value;
                        segment.fake = false;
                        segment.expandable = selected.expandable;
                        if (selected.type) {
                            segment.type = selected.type;
                        }
                    }
                    else if (segment.custom !== 'false') {
                        segment.value = value;
                        segment.html = $sce.trustAsHtml(value);
                        segment.expandable = true;
                        segment.fake = false;
                    }
                    $scope.onChange();
                });
            };
            $scope.switchToLink = function (fromClick) {
                if (linkMode && !fromClick) {
                    return;
                }
                clearTimeout(cancelBlur);
                cancelBlur = null;
                linkMode = true;
                $input.hide();
                $button.show();
                $scope.updateVariableValue($input.val());
            };
            $scope.inputBlur = function () {
                // happens long before the click event on the typeahead options
                // need to have long delay because the blur
                cancelBlur = setTimeout($scope.switchToLink, 200);
            };
            $scope.source = function (query, callback) {
                $scope.$apply(function () {
                    $scope.getOptions({ $query: query }).then(function (altSegments) {
                        $scope.altSegments = altSegments;
                        options = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map($scope.altSegments, function (alt) {
                            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.escape(alt.value);
                        });
                        // add custom values
                        if (segment.custom !== 'false') {
                            if (!segment.fake && __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.indexOf(options, segment.value) === -1) {
                                options.unshift(segment.value);
                            }
                        }
                        callback(options);
                    });
                });
            };
            $scope.updater = function (value) {
                if (value === segment.value) {
                    clearTimeout(cancelBlur);
                    $input.focus();
                    return value;
                }
                $input.val(value);
                $scope.switchToLink(true);
                return value;
            };
            $scope.matcher = function (item) {
                var str = this.query;
                if (str[0] === '/') {
                    str = str.substring(1);
                }
                if (str[str.length - 1] === '/') {
                    str = str.substring(0, str.length - 1);
                }
                try {
                    return item.toLowerCase().match(str.toLowerCase());
                }
                catch (e) {
                    return false;
                }
            };
            $input.attr('data-provide', 'typeahead');
            $input.typeahead({
                source: $scope.source,
                minLength: 0,
                items: 10000,
                updater: $scope.updater,
                matcher: $scope.matcher,
            });
            var typeahead = $input.data('typeahead');
            typeahead.lookup = function () {
                this.query = this.$element.val() || '';
                var items = this.source(this.query, __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.proxy(this.process, this));
                return items ? this.process(items) : items;
            };
            if (debounceLookup) {
                typeahead.lookup = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(typeahead.lookup, 500, { leading: true });
            }
            $button.keydown(function (evt) {
                // trigger typeahead on down arrow or enter key
                if (evt.keyCode === 40 || evt.keyCode === 13) {
                    $button.click();
                }
            });
            $button.click(function () {
                options = null;
                $input.css('width', Math.max($button.width(), 80) + 16 + 'px');
                $button.hide();
                $input.show();
                $input.focus();
                linkMode = false;
                var typeahead = $input.data('typeahead');
                if (typeahead) {
                    $input.val('');
                    typeahead.lookup();
                }
            });
            $input.blur($scope.inputBlur);
            $compile(elem.contents())($scope);
        },
    };
}
/** @ngInject */
function metricSegmentModel(uiSegmentSrv, $q) {
    return {
        template: '<metric-segment segment="segment" get-options="getOptionsInternal()" on-change="onSegmentChange()"></metric-segment>',
        restrict: 'E',
        scope: {
            property: '=',
            options: '=',
            getOptions: '&',
            onChange: '&',
        },
        link: {
            pre: function postLink($scope, elem, attrs) {
                var cachedOptions;
                $scope.valueToSegment = function (value) {
                    var option = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find($scope.options, { value: value });
                    var segment = {
                        cssClass: attrs.cssClass,
                        custom: attrs.custom,
                        value: option ? option.text : value,
                        selectMode: attrs.selectMode,
                    };
                    return uiSegmentSrv.newSegment(segment);
                };
                $scope.getOptionsInternal = function () {
                    if ($scope.options) {
                        cachedOptions = $scope.options;
                        return $q.when(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map($scope.options, function (option) {
                            return { value: option.text };
                        }));
                    }
                    else {
                        return $scope.getOptions().then(function (options) {
                            cachedOptions = options;
                            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(options, function (option) {
                                if (option.html) {
                                    return option;
                                }
                                return { value: option.text };
                            });
                        });
                    }
                };
                $scope.onSegmentChange = function () {
                    if (cachedOptions) {
                        var option = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(cachedOptions, { text: $scope.segment.value });
                        if (option && option.value !== $scope.property) {
                            $scope.property = option.value;
                        }
                        else if (attrs.custom !== 'false') {
                            $scope.property = $scope.segment.value;
                        }
                    }
                    else {
                        $scope.property = $scope.segment.value;
                    }
                    // needs to call this after digest so
                    // property is synced with outerscope
                    $scope.$$postDigest(function () {
                        $scope.$apply(function () {
                            $scope.onChange();
                        });
                    });
                };
                $scope.segment = $scope.valueToSegment($scope.property);
            },
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('metricSegment', metricSegment);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('metricSegmentModel', metricSegmentModel);


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ 
tip.$inject = ["$compile"];
compile.$inject = ["$compile"];
editorOptBool.$inject = ["$compile"];
editorCheckbox.$inject = ["$compile", "$interpolate"];
gfDropdown.$inject = ["$parse", "$compile", "$timeout"];var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_utils_kbn__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_core__ = __webpack_require__(225);





/** @ngInject */
function tip($compile) {
    return {
        restrict: 'E',
        link: function (scope, elem, attrs) {
            var _t = '<i class="grafana-tip fa fa-' +
                (attrs.icon || 'question-circle') +
                '" bs-tooltip="\'' +
                __WEBPACK_IMPORTED_MODULE_3_app_core_utils_kbn__["a" /* default */].addslashes(elem.text()) +
                '\'"></i>';
            _t = _t.replace(/{/g, '\\{').replace(/}/g, '\\}');
            elem.replaceWith($compile(__WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(_t))(scope));
        },
    };
}
function clipboardButton() {
    return {
        scope: {
            getText: '&clipboardButton',
        },
        link: function (scope, elem) {
            scope.clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a(elem[0], {
                text: function () {
                    return scope.getText();
                },
            });
            scope.clipboard.on('success', function () {
                __WEBPACK_IMPORTED_MODULE_4_app_core_core__["b" /* appEvents */].emit('alert-success', ['Content copied to clipboard']);
            });
            scope.$on('$destroy', function () {
                if (scope.clipboard) {
                    scope.clipboard.destroy();
                }
            });
        },
    };
}
/** @ngInject */
function compile($compile) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(function (scope) {
                return scope.$eval(attrs.compile);
            }, function (value) {
                element.html(value);
                $compile(element.contents())(scope);
            });
        },
    };
}
function watchChange() {
    return {
        scope: { onchange: '&watchChange' },
        link: function (scope, element) {
            element.on('input', function () {
                scope.$apply(function () {
                    scope.onchange({ inputValue: element.val() });
                });
            });
        },
    };
}
/** @ngInject */
function editorOptBool($compile) {
    return {
        restrict: 'E',
        link: function (scope, elem, attrs) {
            var ngchange = attrs.change ? ' ng-change="' + attrs.change + '"' : '';
            var tip = attrs.tip ? ' <tip>' + attrs.tip + '</tip>' : '';
            var showIf = attrs.showIf ? ' ng-show="' + attrs.showIf + '" ' : '';
            var template = '<div class="editor-option gf-form-checkbox text-center"' +
                showIf +
                '>' +
                ' <label for="' +
                attrs.model +
                '" class="small">' +
                attrs.text +
                tip +
                '</label>' +
                '<input class="cr1" id="' +
                attrs.model +
                '" type="checkbox" ' +
                '       ng-model="' +
                attrs.model +
                '"' +
                ngchange +
                '       ng-checked="' +
                attrs.model +
                '"></input>' +
                ' <label for="' +
                attrs.model +
                '" class="cr1"></label>';
            elem.replaceWith($compile(__WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(template))(scope));
        },
    };
}
/** @ngInject */
function editorCheckbox($compile, $interpolate) {
    return {
        restrict: 'E',
        link: function (scope, elem, attrs) {
            var text = $interpolate(attrs.text)(scope);
            var model = $interpolate(attrs.model)(scope);
            var ngchange = attrs.change ? ' ng-change="' + attrs.change + '"' : '';
            var tip = attrs.tip ? ' <tip>' + attrs.tip + '</tip>' : '';
            var label = '<label for="' + scope.$id + model + '" class="checkbox-label">' + text + tip + '</label>';
            var template = '<input class="cr1" id="' +
                scope.$id +
                model +
                '" type="checkbox" ' +
                '       ng-model="' +
                model +
                '"' +
                ngchange +
                '       ng-checked="' +
                model +
                '"></input>' +
                ' <label for="' +
                scope.$id +
                model +
                '" class="cr1"></label>';
            template = template + label;
            elem.addClass('gf-form-checkbox');
            elem.html($compile(__WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(template))(scope));
        },
    };
}
/** @ngInject */
function gfDropdown($parse, $compile, $timeout) {
    function buildTemplate(items, placement) {
        var upclass = placement === 'top' ? 'dropup' : '';
        var ul = ['<ul class="dropdown-menu ' + upclass + '" role="menu" aria-labelledby="drop1">', '</ul>'];
        for (var index = 0; index < items.length; index++) {
            var item = items[index];
            if (item.divider) {
                ul.splice(index + 1, 0, '<li class="divider"></li>');
                continue;
            }
            var li = '<li' +
                (item.submenu && item.submenu.length ? ' class="dropdown-submenu"' : '') +
                '>' +
                '<a tabindex="-1" ng-href="' +
                (item.href || '') +
                '"' +
                (item.click ? ' ng-click="' + item.click + '"' : '') +
                (item.target ? ' target="' + item.target + '"' : '') +
                (item.method ? ' data-method="' + item.method + '"' : '') +
                '>' +
                (item.text || '') +
                '</a>';
            if (item.submenu && item.submenu.length) {
                li += buildTemplate(item.submenu).join('\n');
            }
            li += '</li>';
            ul.splice(index + 1, 0, li);
        }
        return ul;
    }
    return {
        restrict: 'EA',
        scope: true,
        link: function postLink(scope, iElement, iAttrs) {
            var getter = $parse(iAttrs.gfDropdown), items = getter(scope);
            $timeout(function () {
                var placement = iElement.data('placement');
                var dropdown = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(buildTemplate(items, placement).join(''));
                dropdown.insertAfter(iElement);
                $compile(iElement.next('ul.dropdown-menu'))(scope);
            });
            iElement.addClass('dropdown-toggle').attr('data-toggle', 'dropdown');
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('tip', tip);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('clipboardButton', clipboardButton);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('compile', compile);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('watchChange', watchChange);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('editorOptBool', editorOptBool);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('editorCheckbox', editorCheckbox);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('gfDropdown', gfDropdown);


/***/ }),
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_utils_rangeutil__ = __webpack_require__(519);


function ngModelOnBlur() {
    return {
        restrict: 'A',
        priority: 1,
        require: 'ngModel',
        link: function (scope, elm, attr, ngModelCtrl) {
            if (attr.type === 'radio' || attr.type === 'checkbox') {
                return;
            }
            elm.off('input keydown change');
            elm.bind('blur', function () {
                scope.$apply(function () {
                    ngModelCtrl.$setViewValue(elm.val());
                });
            });
        },
    };
}
function emptyToNull() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.push(function (viewValue) {
                if (viewValue === '') {
                    return null;
                }
                return viewValue;
            });
        },
    };
}
function validTimeSpan() {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$validators.integer = function (modelValue, viewValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    return true;
                }
                if (viewValue.indexOf('$') === 0 || viewValue.indexOf('+$') === 0) {
                    return true; // allow template variable
                }
                var info = __WEBPACK_IMPORTED_MODULE_1_app_core_utils_rangeutil__["a" /* describeTextRange */](viewValue);
                return info.invalid !== true;
            };
        },
    };
}
__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].directive('ngModelOnblur', ngModelOnBlur);
__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].directive('emptyToNull', emptyToNull);
__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].directive('validTimeSpan', validTimeSpan);


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_utils_tags__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendor_tagsinput_bootstrap_tagsinput_js__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendor_tagsinput_bootstrap_tagsinput_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vendor_tagsinput_bootstrap_tagsinput_js__);





function setColor(name, element) {
    var _a = __WEBPACK_IMPORTED_MODULE_3_app_core_utils_tags__["a" /* default */].getTagColorsFromName(name), color = _a.color, borderColor = _a.borderColor;
    element.css('background-color', color);
    element.css('border-color', borderColor);
}
function tagColorFromName() {
    return {
        scope: { tagColorFromName: '=' },
        link: function (scope, element) {
            setColor(scope.tagColorFromName, element);
        },
    };
}
function bootstrapTagsinput() {
    function getItemProperty(scope, property) {
        if (!property) {
            return undefined;
        }
        if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(scope.$parent[property])) {
            return scope.$parent[property];
        }
        return function (item) {
            return item[property];
        };
    }
    return {
        restrict: 'EA',
        scope: {
            model: '=ngModel',
            onTagsUpdated: '&',
        },
        template: '<select multiple></select>',
        replace: false,
        link: function (scope, element, attrs) {
            if (!__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isArray(scope.model)) {
                scope.model = [];
            }
            var select = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('select', element);
            if (attrs.placeholder) {
                select.attr('placeholder', attrs.placeholder);
            }
            select.tagsinput({
                typeahead: {
                    source: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(scope.$parent[attrs.typeaheadSource])
                        ? scope.$parent[attrs.typeaheadSource]
                        : null,
                },
                widthClass: attrs.widthClass,
                itemValue: getItemProperty(scope, attrs.itemvalue),
                itemText: getItemProperty(scope, attrs.itemtext),
                tagClass: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(scope.$parent[attrs.tagclass])
                    ? scope.$parent[attrs.tagclass]
                    : function () {
                        return attrs.tagclass;
                    },
            });
            select.on('itemAdded', function (event) {
                if (scope.model.indexOf(event.item) === -1) {
                    scope.model.push(event.item);
                    if (scope.onTagsUpdated) {
                        scope.onTagsUpdated();
                    }
                }
                var tagElement = select
                    .next()
                    .children('span')
                    .filter(function () {
                    return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).text() === event.item;
                });
                setColor(event.item, tagElement);
            });
            select.on('itemRemoved', function (event) {
                var idx = scope.model.indexOf(event.item);
                if (idx !== -1) {
                    scope.model.splice(idx, 1);
                    if (scope.onTagsUpdated) {
                        scope.onTagsUpdated();
                    }
                }
            });
            scope.$watch('model', function () {
                if (!__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isArray(scope.model)) {
                    scope.model = [];
                }
                select.tagsinput('removeAll');
                for (var i = 0; i < scope.model.length; i++) {
                    select.tagsinput('add', scope.model[i]);
                }
            }, true);
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('tagColorFromName', tagColorFromName);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('bootstrapTagsinput', bootstrapTagsinput);


/***/ }),
/* 769 */
/***/ (function(module, exports) {

(function ($) {
  "use strict";

  var defaultOptions = {
    tagClass: function(item) {
      return 'label label-info';
    },
    itemValue: function(item) {
      return item ? item.toString() : item;
    },
    itemText: function(item) {
      return this.itemValue(item);
    },
    freeInput: true,
    maxTags: undefined,
    confirmKeys: [13],
    onTagExists: function(item, $tag) {
      $tag.hide().fadeIn();
    }
  };

  /**
   * Constructor function
   */
  function TagsInput(element, options) {
    this.itemsArray = [];

    this.$element = $(element);
    this.$element.hide();

    this.widthClass = options.widthClass || 'width-9';
    this.isSelect = (element.tagName === 'SELECT');
    this.multiple = (this.isSelect && element.hasAttribute('multiple'));
    this.objectItems = options && options.itemValue;
    this.placeholderText = element.hasAttribute('placeholder') ? this.$element.attr('placeholder') : '';

    this.$container = $('<div class="bootstrap-tagsinput"></div>');
    this.$input = $('<input class="gf-form-input ' + this.widthClass + '" type="text" placeholder="' + this.placeholderText + '"/>').appendTo(this.$container);

    this.$element.after(this.$container);

    this.build(options);
  }

  TagsInput.prototype = {
    constructor: TagsInput,

    /**
     * Adds the given item as a new tag. Pass true to dontPushVal to prevent
     * updating the elements val()
     */
    add: function(item, dontPushVal) {
      var self = this;

      if (self.options.maxTags && self.itemsArray.length >= self.options.maxTags)
        return;

      // Ignore falsey values, except false
      if (item !== false && !item)
        return;

      // Throw an error when trying to add an object while the itemValue option was not set
      if (typeof item === "object" && !self.objectItems)
        throw("Can't add objects when itemValue option is not set");

      // Ignore strings only containg whitespace
      if (item.toString().match(/^\s*$/))
        return;

      // If SELECT but not multiple, remove current tag
      if (self.isSelect && !self.multiple && self.itemsArray.length > 0)
        self.remove(self.itemsArray[0]);

      if (typeof item === "string" && this.$element[0].tagName === 'INPUT') {
        var items = item.split(',');
        if (items.length > 1) {
          for (var i = 0; i < items.length; i++) {
            this.add(items[i], true);
          }

          if (!dontPushVal)
            self.pushVal();
          return;
        }
      }

      var itemValue = self.options.itemValue(item),
          itemText = self.options.itemText(item),
          tagClass = self.options.tagClass(item);

      // Ignore items allready added
      var existing = $.grep(self.itemsArray, function(item) { return self.options.itemValue(item) === itemValue; } )[0];
      if (existing) {
        // Invoke onTagExists
        if (self.options.onTagExists) {
          var $existingTag = $(".tag", self.$container).filter(function() { return $(this).data("item") === existing; });
          self.options.onTagExists(item, $existingTag);
        }
        return;
      }

      // register item in internal array and map
      self.itemsArray.push(item);

      // add a tag element
      var $tag = $('<span class="tag ' + htmlEncode(tagClass) + '">' + htmlEncode(itemText) + '<span data-role="remove"></span></span>');
      $tag.data('item', item);
      self.findInputWrapper().before($tag);
      $tag.after(' ');

      // add <option /> if item represents a value not present in one of the <select />'s options
      if (self.isSelect && !$('option[value="' + escape(itemValue) + '"]',self.$element)[0]) {
        var $option = $('<option selected>' + htmlEncode(itemText) + '</option>');
        $option.data('item', item);
        $option.attr('value', itemValue);
        self.$element.append($option);
      }

      if (!dontPushVal)
        self.pushVal();

      // Add class when reached maxTags
      if (self.options.maxTags === self.itemsArray.length)
        self.$container.addClass('bootstrap-tagsinput-max');

      self.$element.trigger($.Event('itemAdded', { item: item }));
    },

    /**
     * Removes the given item. Pass true to dontPushVal to prevent updating the
     * elements val()
     */
    remove: function(item, dontPushVal) {
      var self = this;

      if (self.objectItems) {
        if (typeof item === "object")
          item = $.grep(self.itemsArray, function(other) { return self.options.itemValue(other) ==  self.options.itemValue(item); } )[0];
        else
          item = $.grep(self.itemsArray, function(other) { return self.options.itemValue(other) ==  item; } )[0];
      }

      if (item) {
        $('.tag', self.$container).filter(function() { return $(this).data('item') === item; }).remove();
        $('option', self.$element).filter(function() { return $(this).data('item') === item; }).remove();
        self.itemsArray.splice($.inArray(item, self.itemsArray), 1);
      }

      if (!dontPushVal)
        self.pushVal();

      // Remove class when reached maxTags
      if (self.options.maxTags > self.itemsArray.length)
        self.$container.removeClass('bootstrap-tagsinput-max');

      self.$element.trigger($.Event('itemRemoved',  { item: item }));
    },

    /**
     * Removes all items
     */
    removeAll: function() {
      var self = this;

      $('.tag', self.$container).remove();
      $('option', self.$element).remove();

      while(self.itemsArray.length > 0)
        self.itemsArray.pop();

      self.pushVal();

      if (self.options.maxTags && !this.isEnabled())
        this.enable();
    },

    /**
     * Refreshes the tags so they match the text/value of their corresponding
     * item.
     */
    refresh: function() {
      var self = this;
      $('.tag', self.$container).each(function() {
        var $tag = $(this),
            item = $tag.data('item'),
            itemValue = self.options.itemValue(item),
            itemText = self.options.itemText(item),
            tagClass = self.options.tagClass(item);

          // Update tag's class and inner text
          $tag.attr('class', null);
          $tag.addClass('tag ' + htmlEncode(tagClass));
          $tag.contents().filter(function() {
            return this.nodeType == 3;
          })[0].nodeValue = htmlEncode(itemText);

          if (self.isSelect) {
            var option = $('option', self.$element).filter(function() { return $(this).data('item') === item; });
            option.attr('value', itemValue);
          }
      });
    },

    /**
     * Returns the items added as tags
     */
    items: function() {
      return this.itemsArray;
    },

    /**
     * Assembly value by retrieving the value of each item, and set it on the
     * element.
     */
    pushVal: function() {
      var self = this,
          val = $.map(self.items(), function(item) {
            return self.options.itemValue(item).toString();
          });

      self.$element.val(val, true).trigger('change');
    },

    /**
     * Initializes the tags input behaviour on the element
     */
    build: function(options) {
      var self = this;

      self.options = $.extend({}, defaultOptions, options);
      var typeahead = self.options.typeahead || {};

      // When itemValue is set, freeInput should always be false
      if (self.objectItems)
        self.options.freeInput = false;

      makeOptionItemFunction(self.options, 'itemValue');
      makeOptionItemFunction(self.options, 'itemText');
      makeOptionItemFunction(self.options, 'tagClass');

      // for backwards compatibility, self.options.source is deprecated
      if (self.options.source)
        typeahead.source = self.options.source;

      if (typeahead.source && $.fn.typeahead) {
        makeOptionFunction(typeahead, 'source');

        self.$input.typeahead({
          source: function (query, process) {
            function processItems(items) {
              var texts = [];

              for (var i = 0; i < items.length; i++) {
                var text = self.options.itemText(items[i]);
                map[text] = items[i];
                texts.push(text);
              }
              process(texts);
            }

            this.map = {};
            var map = this.map,
                data = typeahead.source(query);

            if ($.isFunction(data.success)) {
              // support for Angular promises
              data.success(processItems);
            } else {
              // support for functions and jquery promises
              $.when(data)
               .then(processItems);
            }
          },
          updater: function (text) {
            self.add(this.map[text]);
          },
          matcher: function (text) {
            return (text.toLowerCase().indexOf(this.query.trim().toLowerCase()) !== -1);
          },
          sorter: function (texts) {
            return texts.sort();
          },
          highlighter: function (text) {
            var regex = new RegExp( '(' + this.query + ')', 'gi' );
            return text.replace( regex, "<strong>$1</strong>" );
          }
        });
      }

      self.$container.on('click', $.proxy(function(event) {
        self.$input.focus();
      }, self));

      self.$container.on('blur', 'input', $.proxy(function(event) {
        var $input = $(event.target);
        self.add($input.val());
        $input.val('');
        event.preventDefault();
      }, self));

      self.$container.on('keydown', 'input', $.proxy(function(event) {
        var $input = $(event.target),
            $inputWrapper = self.findInputWrapper();

        switch (event.which) {
          // BACKSPACE
          case 8:
            if (doGetCaretPosition($input[0]) === 0) {
              var prev = $inputWrapper.prev();
              if (prev) {
                self.remove(prev.data('item'));
              }
            }
            break;

          // DELETE
          case 46:
            if (doGetCaretPosition($input[0]) === 0) {
              var next = $inputWrapper.next();
              if (next) {
                self.remove(next.data('item'));
              }
            }
            break;

          // LEFT ARROW
          case 37:
            // Try to move the input before the previous tag
            var $prevTag = $inputWrapper.prev();
            if ($input.val().length === 0 && $prevTag[0]) {
              $prevTag.before($inputWrapper);
              $input.focus();
            }
            break;
          // RIGHT ARROW
          case 39:
            // Try to move the input after the next tag
            var $nextTag = $inputWrapper.next();
            if ($input.val().length === 0 && $nextTag[0]) {
              $nextTag.after($inputWrapper);
              $input.focus();
            }
            break;
         default:
            // When key corresponds one of the confirmKeys, add current input
            // as a new tag
            if (self.options.freeInput && $.inArray(event.which, self.options.confirmKeys) >= 0) {
              self.add($input.val());
              $input.val('');
              event.preventDefault();
            }
        }

        // Reset internal input's size
        $input.attr('size', Math.max(this.inputSize, $input.val().length));
      }, self));

      // Remove icon clicked
      self.$container.on('click', '[data-role=remove]', $.proxy(function(event) {
        self.remove($(event.target).closest('.tag').data('item'));
        // Grafana mod, if tags input used in popover the click event will bubble up and hide popover
        event.stopPropagation();
      }, self));

      // Only add existing value as tags when using strings as tags
      if (self.options.itemValue === defaultOptions.itemValue) {
        if (self.$element[0].tagName === 'INPUT') {
            self.add(self.$element.val());
        } else {
          $('option', self.$element).each(function() {
            self.add($(this).attr('value'), true);
          });
        }
      }
    },

    /**
     * Removes all tagsinput behaviour and unregsiter all event handlers
     */
    destroy: function() {
      var self = this;

      // Unbind events
      self.$container.off('keypress', 'input');
      self.$container.off('click', '[role=remove]');

      self.$container.remove();
      self.$element.removeData('tagsinput');
      self.$element.show();
    },

    /**
     * Sets focus on the tagsinput
     */
    focus: function() {
      this.$input.focus();
    },

    /**
     * Returns the internal input element
     */
    input: function() {
      return this.$input;
    },

    /**
     * Returns the element which is wrapped around the internal input. This
     * is normally the $container, but typeahead.js moves the $input element.
     */
    findInputWrapper: function() {
      var elt = this.$input[0],
          container = this.$container[0];
      while(elt && elt.parentNode !== container)
        elt = elt.parentNode;

      return $(elt);
    }
  };

  /**
   * Register JQuery plugin
   */
  $.fn.tagsinput = function(arg1, arg2) {
    var results = [];

    this.each(function() {
      var tagsinput = $(this).data('tagsinput');

      // Initialize a new tags input
      if (!tagsinput) {
        tagsinput = new TagsInput(this, arg1);
        $(this).data('tagsinput', tagsinput);
        results.push(tagsinput);

        if (this.tagName === 'SELECT') {
          $('option', $(this)).attr('selected', 'selected');
        }

        // Init tags from $(this).val()
        $(this).val($(this).val());
      } else {
        // Invoke function on existing tags input
        var retVal = tagsinput[arg1](arg2);
        if (retVal !== undefined)
          results.push(retVal);
      }
    });

    if ( typeof arg1 == 'string') {
      // Return the results from the invoked function calls
      return results.length > 1 ? results : results[0];
    } else {
      return results;
    }
  };

  $.fn.tagsinput.Constructor = TagsInput;

  /**
   * Most options support both a string or number as well as a function as
   * option value. This function makes sure that the option with the given
   * key in the given options is wrapped in a function
   */
  function makeOptionItemFunction(options, key) {
    if (typeof options[key] !== 'function') {
      var propertyName = options[key];
      options[key] = function(item) { return item[propertyName]; };
    }
  }
  function makeOptionFunction(options, key) {
    if (typeof options[key] !== 'function') {
      var value = options[key];
      options[key] = function() { return value; };
    }
  }
  /**
   * HtmlEncodes the given value
   */
  var htmlEncodeContainer = $('<div />');
  function htmlEncode(value) {
    if (value) {
      return htmlEncodeContainer.text(value).html();
    } else {
      return '';
    }
  }

  /**
   * Returns the position of the caret in the given input field
   * http://flightschool.acylt.com/devnotes/caret-position-woes/
   */
  function doGetCaretPosition(oField) {
    var iCaretPos = 0;
    if (document.selection) {
      oField.focus ();
      var oSel = document.selection.createRange();
      oSel.moveStart ('character', -oField.value.length);
      iCaretPos = oSel.text.length;
    } else if (oField.selectionStart || oField.selectionStart == '0') {
      iCaretPos = oField.selectionStart;
    }
    return (iCaretPos);
  }

  /**
   * Initialize tagsinput behaviour on inputs and selects which have
   * data-role=tagsinput
   */
  $(function() {
    $("input[data-role=tagsinput], select[multiple][data-role=tagsinput]").tagsinput();
  });
})(window.jQuery);


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ValueSelectDropdownCtrl */
/* unused harmony export valueSelectDropdown */
/* harmony import */ 
valueSelectDropdown.$inject = ["$compile", "$window", "$timeout", "$rootScope"];var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(3);



var ValueSelectDropdownCtrl = /** @class */ (function () {
    /** @ngInject */
    ValueSelectDropdownCtrl.$inject = ["$q"];
    function ValueSelectDropdownCtrl($q) {
        this.$q = $q;
    }
    ValueSelectDropdownCtrl.prototype.show = function () {
        var _this = this;
        this.oldVariableText = this.variable.current.text;
        this.highlightIndex = -1;
        this.options = this.variable.options;
        this.selectedValues = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.options, { selected: true });
        this.tags = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.variable.tags, function (value) {
            var tag = { text: value, selected: false };
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this.variable.current.tags, function (tagObj) {
                if (tagObj.text === value) {
                    tag = tagObj;
                }
            });
            return tag;
        });
        this.search = {
            query: '',
            options: this.options.slice(0, Math.min(this.options.length, 1000)),
        };
        this.dropdownVisible = true;
    };
    ValueSelectDropdownCtrl.prototype.updateLinkText = function () {
        var current = this.variable.current;
        if (current.tags && current.tags.length) {
            // filer out values that are in selected tags
            var selectedAndNotInTag = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.variable.options, function (option) {
                if (!option.selected) {
                    return false;
                }
                for (var i = 0; i < current.tags.length; i++) {
                    var tag = current.tags[i];
                    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(tag.values, option.value) !== -1) {
                        return false;
                    }
                }
                return true;
            });
            // convert values to text
            var currentTexts = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(selectedAndNotInTag, 'text');
            // join texts
            this.linkText = currentTexts.join(' + ');
            if (this.linkText.length > 0) {
                this.linkText += ' + ';
            }
        }
        else {
            this.linkText = this.variable.current.text;
        }
    };
    ValueSelectDropdownCtrl.prototype.clearSelections = function () {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.options, function (option) {
            option.selected = false;
        });
        this.selectionsChanged(false);
    };
    ValueSelectDropdownCtrl.prototype.selectTag = function (tag) {
        var _this = this;
        tag.selected = !tag.selected;
        var tagValuesPromise;
        if (!tag.values) {
            tagValuesPromise = this.variable.getValuesForTag(tag.text);
        }
        else {
            tagValuesPromise = this.$q.when(tag.values);
        }
        tagValuesPromise.then(function (values) {
            tag.values = values;
            tag.valuesText = values.join(' + ');
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this.options, function (option) {
                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(tag.values, option.value) !== -1) {
                    option.selected = tag.selected;
                }
            });
            _this.selectionsChanged(false);
        });
    };
    ValueSelectDropdownCtrl.prototype.keyDown = function (evt) {
        if (evt.keyCode === 27) {
            this.hide();
        }
        if (evt.keyCode === 40) {
            this.moveHighlight(1);
        }
        if (evt.keyCode === 38) {
            this.moveHighlight(-1);
        }
        if (evt.keyCode === 13) {
            if (this.search.options.length === 0) {
                this.commitChanges();
            }
            else {
                this.selectValue(this.search.options[this.highlightIndex], {}, true, false);
            }
        }
        if (evt.keyCode === 32) {
            this.selectValue(this.search.options[this.highlightIndex], {}, false, false);
        }
    };
    ValueSelectDropdownCtrl.prototype.moveHighlight = function (direction) {
        this.highlightIndex = (this.highlightIndex + direction) % this.search.options.length;
    };
    ValueSelectDropdownCtrl.prototype.selectValue = function (option, event, commitChange, excludeOthers) {
        var _this = this;
        if (!option) {
            return;
        }
        option.selected = this.variable.multi ? !option.selected : true;
        commitChange = commitChange || false;
        excludeOthers = excludeOthers || false;
        var setAllExceptCurrentTo = function (newValue) {
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this.options, function (other) {
                if (option !== other) {
                    other.selected = newValue;
                }
            });
        };
        // commit action (enter key), should not deselect it
        if (commitChange) {
            option.selected = true;
        }
        if (option.text === 'All' || excludeOthers) {
            setAllExceptCurrentTo(false);
            commitChange = true;
        }
        else if (!this.variable.multi) {
            setAllExceptCurrentTo(false);
            commitChange = true;
        }
        else if (event.ctrlKey || event.metaKey || event.shiftKey) {
            commitChange = true;
            setAllExceptCurrentTo(false);
        }
        this.selectionsChanged(commitChange);
    };
    ValueSelectDropdownCtrl.prototype.selectionsChanged = function (commitChange) {
        var _this = this;
        this.selectedValues = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.options, { selected: true });
        if (this.selectedValues.length > 1) {
            if (this.selectedValues[0].text === 'All') {
                this.selectedValues[0].selected = false;
                this.selectedValues = this.selectedValues.slice(1, this.selectedValues.length);
            }
        }
        // validate selected tags
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.tags, function (tag) {
            if (tag.selected) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(tag.values, function (value) {
                    if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this.selectedValues, { value: value })) {
                        tag.selected = false;
                    }
                });
            }
        });
        this.selectedTags = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.tags, { selected: true });
        this.variable.current.value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.selectedValues, 'value');
        this.variable.current.text = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.selectedValues, 'text').join(' + ');
        this.variable.current.tags = this.selectedTags;
        if (!this.variable.multi) {
            this.variable.current.value = this.selectedValues[0].value;
        }
        if (commitChange) {
            this.commitChanges();
        }
    };
    ValueSelectDropdownCtrl.prototype.commitChanges = function () {
        // if we have a search query and no options use that
        if (this.search.options.length === 0 && this.search.query.length > 0) {
            this.variable.current = { text: this.search.query, value: this.search.query };
        }
        else if (this.selectedValues.length === 0) {
            // make sure one option is selected
            this.options[0].selected = true;
            this.selectionsChanged(false);
        }
        this.dropdownVisible = false;
        this.updateLinkText();
        if (this.variable.current.text !== this.oldVariableText) {
            this.onUpdated();
        }
    };
    ValueSelectDropdownCtrl.prototype.queryChanged = function () {
        var _this = this;
        this.highlightIndex = -1;
        this.search.options = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.options, function (option) {
            return option.text.toLowerCase().indexOf(_this.search.query.toLowerCase()) !== -1;
        });
        this.search.options = this.search.options.slice(0, Math.min(this.search.options.length, 1000));
    };
    ValueSelectDropdownCtrl.prototype.init = function () {
        this.selectedTags = this.variable.current.tags || [];
        this.updateLinkText();
    };
    return ValueSelectDropdownCtrl;
}());

/** @ngInject */
function valueSelectDropdown($compile, $window, $timeout, $rootScope) {
    return {
        scope: { variable: '=', onUpdated: '&' },
        templateUrl: 'public/app/partials/valueSelectDropdown.html',
        controller: 'ValueSelectDropdownCtrl',
        controllerAs: 'vm',
        bindToController: true,
        link: function (scope, elem) {
            var bodyEl = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element($window.document.body);
            var linkEl = elem.find('.variable-value-link');
            var inputEl = elem.find('input');
            function openDropdown() {
                inputEl.css('width', Math.max(linkEl.width(), 80) + 'px');
                inputEl.show();
                linkEl.hide();
                inputEl.focus();
                $timeout(function () {
                    bodyEl.on('click', bodyOnClick);
                }, 0, false);
            }
            function switchToLink() {
                inputEl.hide();
                linkEl.show();
                bodyEl.off('click', bodyOnClick);
            }
            function bodyOnClick(e) {
                if (elem.has(e.target).length === 0) {
                    scope.$apply(function () {
                        scope.vm.commitChanges();
                    });
                }
            }
            scope.$watch('vm.dropdownVisible', function (newValue) {
                if (newValue) {
                    openDropdown();
                }
                else {
                    switchToLink();
                }
            });
            var cleanUp = $rootScope.$on('template-variable-value-updated', function () {
                scope.vm.updateLinkText();
            });
            scope.$on('$destroy', function () {
                cleanUp();
            });
            scope.vm.init();
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].controller('ValueSelectDropdownCtrl', ValueSelectDropdownCtrl);
__WEBPACK_IMPORTED_MODULE_2__core_module__["a" /* default */].directive('valueSelectDropdown', valueSelectDropdown);


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ 
rebuildOnChange.$inject = ["$animate"];var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


function getBlockNodes(nodes) {
    var node = nodes[0];
    var endNode = nodes[nodes.length - 1];
    var blockNodes;
    for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
        if (blockNodes || nodes[i] !== node) {
            if (!blockNodes) {
                blockNodes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()([].slice.call(nodes, 0, i));
            }
            blockNodes.push(node);
        }
    }
    return blockNodes || nodes;
}
/** @ngInject **/
function rebuildOnChange($animate) {
    return {
        multiElement: true,
        terminal: true,
        transclude: true,
        priority: 600,
        restrict: 'E',
        link: function (scope, elem, attrs, ctrl, transclude) {
            var block, childScope, previousElements;
            function cleanUp() {
                if (previousElements) {
                    previousElements.remove();
                    previousElements = null;
                }
                if (childScope) {
                    childScope.$destroy();
                    childScope = null;
                }
                if (block) {
                    previousElements = getBlockNodes(block.clone);
                    $animate.leave(previousElements).then(function () {
                        previousElements = null;
                    });
                    block = null;
                }
            }
            scope.$watch(attrs.property, function rebuildOnChangeAction(value, oldValue) {
                if (childScope && value !== oldValue) {
                    cleanUp();
                }
                if (!childScope && (value || attrs.showNull)) {
                    transclude(function (clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end rebuild on change ');
                        block = { clone: clone };
                        $animate.enter(clone, elem.parent(), elem);
                    });
                }
                else {
                    cleanUp();
                }
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive('rebuildOnChange', rebuildOnChange);


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(3);

__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].directive('giveFocus', function () {
    return function (scope, element, attrs) {
        element.click(function (e) {
            e.stopPropagation();
        });
        scope.$watch(attrs.giveFocus, function (newValue) {
            if (!newValue) {
                return;
            }
            setTimeout(function () {
                element.focus();
                var domEl = element[0];
                if (domEl.setSelectionRange) {
                    var pos = element.val().length * 2;
                    domEl.setSelectionRange(pos, pos);
                }
            }, 200);
        }, true);
    };
});
/* unused harmony default export */ var _unused_webpack_default_export = ({});


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DeltaCtrl */
/* unused harmony export delta */
/* unused harmony export LinkJSONCtrl */
/* unused harmony export linkJson */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


var DeltaCtrl = /** @class */ (function () {
    /** @ngInject */
    DeltaCtrl.$inject = ["$rootScope"];
    function DeltaCtrl($rootScope) {
        var _this = this;
        this.$rootScope = $rootScope;
        var waitForCompile = function (mutations) {
            if (mutations.length === 1) {
                _this.$rootScope.appEvent('json-diff-ready');
            }
        };
        this.observer = new MutationObserver(waitForCompile);
        var observerConfig = {
            attributes: true,
            attributeFilter: ['class'],
            characterData: false,
            childList: true,
            subtree: false,
        };
        this.observer.observe(__WEBPACK_IMPORTED_MODULE_0_angular___default.a.element('.delta-html')[0], observerConfig);
    }
    DeltaCtrl.prototype.$onDestroy = function () {
        this.observer.disconnect();
    };
    return DeltaCtrl;
}());

function delta() {
    return {
        controller: DeltaCtrl,
        replace: false,
        restrict: 'A',
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive('diffDelta', delta);
// Link to JSON line number
var LinkJSONCtrl = /** @class */ (function () {
    /** @ngInject */
    LinkJSONCtrl.$inject = ["$scope", "$rootScope", "$anchorScroll"];
    function LinkJSONCtrl($scope, $rootScope, $anchorScroll) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$anchorScroll = $anchorScroll;
    }
    LinkJSONCtrl.prototype.goToLine = function (line) {
        var _this = this;
        var unbind;
        var scroll = function () {
            _this.$anchorScroll("l" + line);
            unbind();
        };
        this.$scope.switchView().then(function () {
            unbind = _this.$rootScope.$on('json-diff-ready', scroll.bind(_this));
        });
    };
    return LinkJSONCtrl;
}());

function linkJson() {
    return {
        controller: LinkJSONCtrl,
        controllerAs: 'ctrl',
        replace: true,
        restrict: 'E',
        scope: {
            line: '@lineDisplay',
            link: '@lineLink',
            switchView: '&',
        },
        template: "<a class=\"diff-linenum btn btn-inverse btn-small\" ng-click=\"ctrl.goToLine(link)\">Line {{ line }}</a>",
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive('diffLinkJson', linkJson);


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16), __webpack_require__(21), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, _) {
  'use strict';

  var $win = $(window);

  $.fn.place_tt = (function () {
    var defaults = {
      offset: 5,
    };

    return function (x, y, opts) {
      opts = $.extend(true, {}, defaults, opts);

      return this.each(function () {
        var $tooltip = $(this), width, height;

        $tooltip.addClass('grafana-tooltip');

        $("#tooltip").remove();
        $tooltip.appendTo(document.body);

        if (opts.compile) {
          angular.element(document).injector().invoke(["$compile", "$rootScope", function($compile, $rootScope) {
            var tmpScope = $rootScope.$new(true);
            _.extend(tmpScope, opts.scopeData);

            $compile($tooltip)(tmpScope);
            tmpScope.$digest();
            tmpScope.$destroy();
          }]);
        }

        width = $tooltip.outerWidth(true);
        height = $tooltip.outerHeight(true);

        $tooltip.css('left', x + opts.offset + width > $win.width() ? x - opts.offset - width : x + opts.offset);
        $tooltip.css('top', y + opts.offset + height > $win.height() ? y - opts.offset - height : y + opts.offset);
      });
    };
  })();

  return $;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var templates = __webpack_require__(776);
templates.keys().forEach(function (key) {
    templates(key);
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./core/components/help/help.html": 777,
	"./core/components/manage_dashboards/manage_dashboards.html": 778,
	"./core/components/navbar/navbar.html": 779,
	"./core/components/search/search.html": 780,
	"./core/components/search/search_results.html": 781,
	"./core/components/sidemenu/sidemenu.html": 782,
	"./features/admin/partials/admin_home.html": 783,
	"./features/admin/partials/edit_org.html": 784,
	"./features/admin/partials/edit_user.html": 785,
	"./features/admin/partials/new_user.html": 786,
	"./features/admin/partials/orgs.html": 787,
	"./features/admin/partials/settings.html": 788,
	"./features/admin/partials/stats.html": 789,
	"./features/admin/partials/users.html": 790,
	"./features/alerting/partials/alert_howto.html": 791,
	"./features/alerting/partials/alert_tab.html": 792,
	"./features/alerting/partials/notification_edit.html": 793,
	"./features/alerting/partials/notifications_list.html": 794,
	"./features/annotations/partials/editor.html": 795,
	"./features/annotations/partials/event_editor.html": 796,
	"./features/dashboard/dashnav/dashnav.html": 797,
	"./features/dashboard/export/export_modal.html": 798,
	"./features/dashboard/export_data/export_data_modal.html": 799,
	"./features/dashboard/folder_picker/folder_picker.html": 800,
	"./features/dashboard/history/history.html": 801,
	"./features/dashboard/move_to_folder_modal/move_to_folder.html": 802,
	"./features/dashboard/partials/create_folder.html": 803,
	"./features/dashboard/partials/dashboard_import.html": 804,
	"./features/dashboard/partials/dashboard_list.html": 805,
	"./features/dashboard/partials/folder_dashboards.html": 806,
	"./features/dashboard/partials/folder_permissions.html": 807,
	"./features/dashboard/partials/folder_settings.html": 808,
	"./features/dashboard/partials/inspector.html": 809,
	"./features/dashboard/partials/row_options.html": 810,
	"./features/dashboard/partials/shareModal.html": 811,
	"./features/dashboard/settings/settings.html": 812,
	"./features/dashboard/submenu/submenu.html": 813,
	"./features/dashboard/timepicker/settings.html": 814,
	"./features/dashboard/timepicker/timepicker.html": 815,
	"./features/dashlinks/editor.html": 816,
	"./features/org/partials/apikeyModal.html": 817,
	"./features/org/partials/change_password.html": 818,
	"./features/org/partials/create_team.html": 819,
	"./features/org/partials/invite.html": 820,
	"./features/org/partials/newOrg.html": 821,
	"./features/org/partials/orgApiKeys.html": 822,
	"./features/org/partials/orgDetails.html": 823,
	"./features/org/partials/orgUsers.html": 824,
	"./features/org/partials/profile.html": 825,
	"./features/org/partials/select_org.html": 826,
	"./features/org/partials/team_details.html": 827,
	"./features/org/partials/teams.html": 828,
	"./features/panel/partials/metrics_tab.html": 829,
	"./features/panel/partials/panelTime.html": 830,
	"./features/panel/partials/query_editor_row.html": 831,
	"./features/panel/partials/soloPanel.html": 832,
	"./features/panellinks/module.html": 833,
	"./features/playlist/partials/playlist.html": 834,
	"./features/playlist/partials/playlist_search.html": 835,
	"./features/playlist/partials/playlists.html": 836,
	"./features/plugins/import_list/import_list.html": 837,
	"./features/plugins/partials/ds_dashboards.html": 838,
	"./features/plugins/partials/ds_edit.html": 839,
	"./features/plugins/partials/ds_http_settings.html": 840,
	"./features/plugins/partials/ds_list.html": 841,
	"./features/plugins/partials/plugin_edit.html": 842,
	"./features/plugins/partials/plugin_list.html": 843,
	"./features/plugins/partials/plugin_page.html": 844,
	"./features/plugins/partials/update_instructions.html": 845,
	"./features/snapshot/partials/snapshots.html": 846,
	"./features/styleguide/styleguide.html": 847,
	"./features/templating/partials/editor.html": 848,
	"./partials/confirm_modal.html": 849,
	"./partials/dashboard.html": 850,
	"./partials/edit_json.html": 851,
	"./partials/error.html": 852,
	"./partials/login.html": 853,
	"./partials/modal.html": 854,
	"./partials/panelgeneral.html": 855,
	"./partials/reset_password.html": 856,
	"./partials/signup_invited.html": 857,
	"./partials/signup_step2.html": 858,
	"./partials/valueSelectDropdown.html": 859,
	"./plugins/app/testdata/partials/query.editor.html": 860,
	"./plugins/datasource/cloudwatch/partials/annotations.editor.html": 861,
	"./plugins/datasource/cloudwatch/partials/config.html": 862,
	"./plugins/datasource/cloudwatch/partials/query.editor.html": 863,
	"./plugins/datasource/cloudwatch/partials/query.parameter.html": 864,
	"./plugins/datasource/elasticsearch/partials/annotations.editor.html": 865,
	"./plugins/datasource/elasticsearch/partials/bucket_agg.html": 866,
	"./plugins/datasource/elasticsearch/partials/config.html": 867,
	"./plugins/datasource/elasticsearch/partials/metric_agg.html": 868,
	"./plugins/datasource/elasticsearch/partials/query.editor.html": 869,
	"./plugins/datasource/grafana-live/partials/query.editor.html": 870,
	"./plugins/datasource/grafana/partials/annotations.editor.html": 871,
	"./plugins/datasource/grafana/partials/query.editor.html": 872,
	"./plugins/datasource/graphite/partials/annotations.editor.html": 873,
	"./plugins/datasource/graphite/partials/config.html": 874,
	"./plugins/datasource/graphite/partials/query.editor.html": 875,
	"./plugins/datasource/influxdb/partials/annotations.editor.html": 876,
	"./plugins/datasource/influxdb/partials/config.html": 877,
	"./plugins/datasource/influxdb/partials/query.editor.html": 878,
	"./plugins/datasource/mssql/partials/annotations.editor.html": 879,
	"./plugins/datasource/mssql/partials/config.html": 880,
	"./plugins/datasource/mssql/partials/query.editor.html": 881,
	"./plugins/datasource/mysql/partials/annotations.editor.html": 882,
	"./plugins/datasource/mysql/partials/config.html": 883,
	"./plugins/datasource/mysql/partials/query.editor.html": 884,
	"./plugins/datasource/opentsdb/partials/annotations.editor.html": 885,
	"./plugins/datasource/opentsdb/partials/config.html": 886,
	"./plugins/datasource/opentsdb/partials/query.editor.html": 887,
	"./plugins/datasource/postgres/partials/annotations.editor.html": 888,
	"./plugins/datasource/postgres/partials/config.html": 889,
	"./plugins/datasource/postgres/partials/query.editor.html": 890,
	"./plugins/datasource/prometheus/partials/annotations.editor.html": 891,
	"./plugins/datasource/prometheus/partials/config.html": 892,
	"./plugins/datasource/prometheus/partials/query.editor.html": 893,
	"./plugins/panel/alertlist/editor.html": 894,
	"./plugins/panel/alertlist/module.html": 895,
	"./plugins/panel/dashlist/editor.html": 896,
	"./plugins/panel/dashlist/module.html": 897,
	"./plugins/panel/gettingstarted/editor.html": 898,
	"./plugins/panel/gettingstarted/module.html": 899,
	"./plugins/panel/graph/axes_editor.html": 900,
	"./plugins/panel/graph/tab_display.html": 901,
	"./plugins/panel/graph/tab_legend.html": 902,
	"./plugins/panel/heatmap/module.html": 903,
	"./plugins/panel/heatmap/partials/axes_editor.html": 904,
	"./plugins/panel/heatmap/partials/display_editor.html": 905,
	"./plugins/panel/pluginlist/editor.html": 906,
	"./plugins/panel/pluginlist/module.html": 907,
	"./plugins/panel/singlestat/editor.html": 908,
	"./plugins/panel/singlestat/mappings.html": 909,
	"./plugins/panel/singlestat/module.html": 910,
	"./plugins/panel/table/column_options.html": 911,
	"./plugins/panel/table/editor.html": 912,
	"./plugins/panel/table/module.html": 913,
	"./plugins/panel/text/editor.html": 914,
	"./plugins/panel/text/module.html": 915,
	"./plugins/panel/unknown/module.html": 916
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 776;

/***/ }),
/* 777 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/help/help.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-keyboard-o\"></i>\n\t\t\t<span class=p-l-1>Shortcuts</span>\n\t\t</h2>\n\t\t<a class=modal-header-close ng-click=ctrl.dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=\"modal-content help-modal\">\n\n\t\t<p class=small style=position:absolute;top:13px;right:44px>\n\t\t\t<span class=shortcut-table-key>mod</span> =\n\t\t\t<span class=muted>CTRL on windows or linux and CMD key on Mac</span>\n\t\t</p>\n\n\t\t<div ng-repeat=\"(category, shortcuts) in ctrl.shortcuts\" class=shortcut-category>\n\t\t\t<table class=shortcut-table>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=shortcut-table-category-header colspan=2>{{category}}</th>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr ng-repeat=\"shortcut in shortcuts\">\n\t\t\t\t\t\t<td class=shortcut-table-keys>\n              <span class=shortcut-table-key ng-repeat=\"key in shortcut.keys track by $index\" ng-bind-html=key>\n              </span>\n            </td>\n\t\t\t\t\t\t<td class=shortcut-table-description>{{shortcut.description}}</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tbody>\n\t\t\t</tbody></tbody></table>\n\t\t</div>\n\n\t\t<div class=clearfix></div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 778 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/manage_dashboards/manage_dashboards.html';
var html = "<div class=dashboard-list>\n  <div class=\"page-action-bar page-action-bar--narrow\" ng-hide=\"ctrl.folderId && !ctrl.hasFilters && ctrl.sections.length === 0\">\n    <label class=\"gf-form gf-form--grow gf-form--has-input-icon\">\n      <input type=text class=\"gf-form-input max-width-30\" placeholder=\"Find Dashboard by name\" tabindex=1 give-focus=true ng-model=ctrl.query.query ng-model-options=\"{ debounce: 500 }\" spellcheck=false ng-change=ctrl.onQueryChange() />\n      <i class=\"gf-form-input-icon fa fa-search\"></i>\n    </label>\n    <div class=page-action-bar__spacer></div>\n    <a class=\"btn btn-success\" ng-href={{ctrl.createDashboardUrl()}} ng-if=\"ctrl.isEditor || ctrl.canSave\">\n      <i class=\"fa fa-plus\"></i>\n      Dashboard\n    </a>\n    <a class=\"btn btn-success\" href=dashboards/folder/new ng-if=\"!ctrl.folderId && ctrl.isEditor\">\n      <i class=\"fa fa-plus\"></i>\n      Folder\n    </a>\n  </div>\n\n  <div class=\"page-action-bar page-action-bar--narrow\" ng-show=ctrl.hasFilters>\n    <div class=gf-form-inline>\n      <div class=gf-form ng-show=\"ctrl.query.tag.length > 0\">\n        <label class=\"gf-form-label width-4\">\n          Tags\n        </label>\n        <div class=\"gf-form-input gf-form-input--plaintext\" ng-show=\"ctrl.query.tag.length > 0\">\n          <span ng-repeat=\"tagName in ctrl.query.tag\">\n            <a ng-click=\"ctrl.removeTag(tagName, $event)\" tag-color-from-name=tagName class=\"tag label label-tag\">\n              <i class=\"fa fa-remove\"></i>&nbsp;{{tagName}}\n            </a>\n          </span>\n        </div>\n      </div>\n      <div class=gf-form ng-show=ctrl.query.starred>\n        <label class=gf-form-label>\n          <a class=pointer ng-click=ctrl.removeStarred()>\n            <i class=\"fa fa-fw fa-check\"></i> Starred\n          </a>\n        </label>\n      </div>\n      <div class=gf-form>\n        <label class=gf-form-label>\n          <a class=pointer ng-click=ctrl.clearFilters() bs-tooltip=\"'Clear current search query and filters'\">\n            <i class=\"fa fa-remove\"></i>&nbsp;Clear\n          </a>\n        </label>\n      </div>\n    </div>\n  </div>\n\n  <div class=search-results ng-show=\"ctrl.hasFilters && ctrl.sections.length === 0\">\n    <em class=muted>\n      No dashboards matching your query were found.\n    </em>\n  </div>\n\n\t<div class=search-results ng-show=\"!ctrl.folderId && !ctrl.hasFilters && ctrl.sections.length === 0\">\n    <em class=muted>\n        No dashboards found.\n    </em>\n  </div>\n\n  <div class=search-results ng-show=\"ctrl.sections.length > 0\">\n    <div class=search-results-filter-row>\n      <gf-form-switch on-change=ctrl.onSelectAllChanged() checked=ctrl.selectAllChecked switch-class=\"gf-form-switch--transparent gf-form-switch--search-result-filter-row__checkbox\"/>\n      <div class=search-results-filter-row__filters>\n        <div class=gf-form-select-wrapper ng-show=\"!(ctrl.canMove || ctrl.canDelete)\">\n          <select class=\"search-results-filter-row__filters-item gf-form-input\" ng-model=ctrl.selectedStarredFilter ng-options=\"t.text disable when t.disabled for t in ctrl.starredFilterOptions\" ng-change=ctrl.onStarredFilterChange() />\n        </div>\n        <div class=gf-form-select-wrapper ng-show=\"!(ctrl.canMove || ctrl.canDelete)\">\n          <select class=\"search-results-filter-row__filters-item gf-form-input\" ng-model=ctrl.selectedTagFilter ng-options=\"t.term disable when t.disabled for t in ctrl.tagFilterOptions\" ng-change=ctrl.onTagFilterChange() />\n        </div>\n        <div class=gf-form-button-row ng-show=\"ctrl.canMove || ctrl.canDelete\">\n          <button type=button class=\"btn gf-form-button btn-inverse\" ng-disabled=!ctrl.canMove ng-click=ctrl.moveTo() bs-tooltip=\"ctrl.canMove ? '' : 'Select a dashboard to move (cannot move folders)'\" data-placement=bottom>\n          <i class=\"fa fa-exchange\"></i>&nbsp;&nbsp;Move\n          </button>\n          <button type=button class=\"btn gf-form-button btn-danger\" ng-click=ctrl.delete() ng-disabled=!ctrl.canDelete>\n            <i class=\"fa fa-trash\"></i>&nbsp;&nbsp;Delete\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=search-results-container>\n      <dashboard-search-results results=ctrl.sections editable=true on-selection-changed=ctrl.selectionChanged() on-tag-selected=ctrl.filterByTag($tag) />\n    </div>\n  </div>\n\n</div>\n\n<div ng-if=\"ctrl.canSave && ctrl.folderId && !ctrl.hasFilters && ctrl.sections.length === 0\">\n  <empty-list-cta model=\"{\n    title: 'This folder doesn\\'t have any dashboards yet',\n    buttonIcon: 'gicon gicon-dashboard-new',\n    buttonLink: 'dashboard/new?folderId={{ctrl.folderId}}',\n    buttonTitle: 'Create Dashboard',\n    proTip: 'Add/move dashboards to your folder at ->',\n    proTipLink: 'dashboards',\n    proTipLinkTitle: 'Manage dashboards',\n    proTipTarget: ''\n  }\"/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 779 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/navbar/navbar.html';
var html = "<div class=page-nav>\n  <div class=page-breadcrumbs>\n    <a class=\"breadcrumb-item active\" href=/ >\n      <i class=\"fa fa-home\"></i>\n    </a>\n    <a class=breadcrumb-item ng-href={{::item.url}} ng-repeat=\"item in ctrl.model.breadcrumbs\">\n      {{::item.text}}\n    </a>\n  </div>\n</div>\n\n<dashboard-search></dashboard-search>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 780 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/search/search.html';
var html = "\n<div class=search-backdrop ng-if=ctrl.isOpen></div>\n\n<div class=search-container ng-if=ctrl.isOpen>\n\n\t<div class=search-field-wrapper>\n\t\t<div class=\"search-field-icon pointer\" ng-click=ctrl.closeSearch()><i class=\"fa fa-search\"></i></div>\n\n\t\t<input type=text placeholder=\"Find dashboards by name\" give-focus=ctrl.giveSearchFocus tabindex=1 ng-keydown=ctrl.keyDown($event) ng-model=ctrl.query.query ng-model-options=\"{ debounce: 500 }\" spellcheck=false ng-change=ctrl.search() />\n\n\t\t<div class=search-field-spacer></div>\n\t</div>\n\n\t<div class=search-dropdown>\n    <div class=search-dropdown__col_1>\n      <div class=search-results-scroller>\n        <div class=search-results-container grafana-scrollbar>\n          <h6 ng-show=\"!ctrl.isLoading && ctrl.results.length === 0\">No dashboards matching your query were found.</h6>\n          <dashboard-search-results results=ctrl.results on-tag-selected=ctrl.filterByTag($tag) on-folder-expanding=ctrl.folderExpanding() on-folder-expanded=ctrl.folderExpanded($folder) />\n        </div>\n      </div>\n    </div>\n\n    <div class=search-dropdown__col_2>\n      <div class=search-filter-box ng-click=ctrl.onFilterboxClick()>\n        <div class=search-filter-box__header>\n          <i class=\"fa fa-filter\"></i>\n          Filter by:\n          <a class=\"pointer pull-right small\" ng-click=ctrl.clearSearchFilter()>\n            <i class=\"fa fa-remove\"></i> Clear\n          </a>\n        </div>\n\n        <tag-filter tags=ctrl.query.tag tagoptions=ctrl.getTags onselect=ctrl.onTagSelect>\n        </tag-filter>\n      </div>\n\n      <div class=search-filter-box ng-if=ctrl.isEditor>\n        <a href=dashboard/new class=search-filter-box-link>\n          <i class=\"gicon gicon-dashboard-new\"></i> New dashboard\n        </a>\n        <a href=dashboards/folder/new class=search-filter-box-link>\n          <i class=\"gicon gicon-folder-new\"></i> New folder\n        </a>\n        <a href=dashboard/import class=search-filter-box-link>\n          <i class=\"gicon gicon-dashboard-import\"></i> Import dashboard\n        </a>\n        <a class=search-filter-box-link target=_blank href=\"https://grafana.com/dashboards?utm_source=grafana_search\">\n          <img src=public/img/icn-dashboard-tiny.svg width=20 /> Find  dashboards on Grafana.com\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/search/search_results.html';
var html = "<div ng-repeat=\"section in ctrl.results\" class=search-section>\n  <div class=\"search-section__header pointer\" ng-hide=section.hideHeader ng-class=\"{'selected': section.selected}\" ng-click=ctrl.toggleFolderExpand(section)>\n    <div ng-click=\"ctrl.toggleSelection(section, $event)\">\n      <gf-form-switch ng-show=ctrl.editable on-change=ctrl.selectionChanged($event) checked=section.checked switch-class=\"gf-form-switch--transparent gf-form-switch--search-result__section\">\n      </gf-form-switch>\n    </div>\n    <i class=search-section__header__icon ng-class=section.icon></i>\n    <span class=search-section__header__text>{{::section.title}}</span>\n    <a ng-show=section.url href={{section.url}} class=search-section__header__link>\n      <i class=\"fa fa-cog\"></i>\n    </a>\n    <i class=\"fa fa-angle-down search-section__header__toggle\" ng-show=section.expanded></i>\n    <i class=\"fa fa-angle-right search-section__header__toggle\" ng-hide=section.expanded></i>\n  </div>\n\n  <div class=search-section__header ng-show=section.hideHeader></div>\n\n  <div ng-if=section.expanded>\n    <a ng-repeat=\"item in section.items\" class=\"search-item search-item--indent\" ng-class=\"{'selected': item.selected}\" ng-href={{::item.url}}>\n      <div ng-click=\"ctrl.toggleSelection(item, $event)\">\n        <gf-form-switch ng-show=ctrl.editable on-change=ctrl.selectionChanged() checked=item.checked switch-class=\"gf-form-switch--transparent gf-form-switch--search-result__item\">\n        </gf-form-switch>\n      </div>\n      <span class=search-item__icon>\n        <i class=\"gicon mini gicon-dashboard-list\"></i>\n      </span>\n      <span class=search-item__body ng-click=ctrl.onItemClick(item)>\n        <div class=search-item__body-title>{{::item.title}}</div>\n      </span>\n      <span class=search-item__tags>\n        <span ng-click=\"ctrl.selectTag(tag, $event)\" ng-repeat=\"tag in item.tags\" tag-color-from-name=tag class=\"label label-tag\">\n          {{tag}}\n        </span>\n      </span>\n    </a>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 782 */
/***/ (function(module, exports) {

var path = 'public/app/core/components/sidemenu/sidemenu.html';
var html = "<a class=sidemenu__logo ng-click=ctrl.toggleSideMenu()>\n  <img src=public/img/grafana_icon.svg>\n</a>\n\n<a class=sidemenu__logo_small_breakpoint ng-click=ctrl.toggleSideMenuSmallBreakpoint()>\n  <i class=\"fa fa-bars\"></i>\n  <span class=sidemenu__close>\n    <i class=\"fa fa-times\"></i>&nbsp;Close</span>\n</a>\n\n<div class=sidemenu__top>\n  <div ng-repeat=\"item in ::ctrl.mainLinks\" class=\"sidemenu-item dropdown\">\n    <a href={{::item.url}} class=sidemenu-link target={{::item.target}}>\n      <span class=\"icon-circle sidemenu-icon\">\n        <i class={{::item.icon}} ng-show=::item.icon></i>\n        <img ng-src={{::item.img}} ng-show=::item.img>\n      </span>\n    </a>\n    <ul class=\"dropdown-menu dropdown-menu--sidemenu\" role=menu ng-if=::item.children>\n      <li class=side-menu-header>\n        <span class=sidemenu-item-text>{{::item.text}}</span>\n      </li>\n      <li ng-repeat=\"child in ::item.children\" ng-class=\"{divider: child.divider}\">\n        <a href={{::child.url}}>\n          <i class={{::child.icon}} ng-show=::child.icon></i>\n          {{::child.text}}\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n\n<div class=sidemenu__bottom>\n  <div ng-show=::!ctrl.isSignedIn class=sidemenu-item>\n    <a href={{ctrl.loginUrl}} class=sidemenu-link target=_self>\n      <span class=\"icon-circle sidemenu-icon\">\n        <i class=\"fa fa-fw fa-sign-in\"></i>\n      </span>\n    </a>\n    <a href={{ctrl.loginUrl}} target=_self>\n      <ul class=\"dropdown-menu dropdown-menu--sidemenu\" role=menu>\n        <li class=side-menu-header>\n          <span class=sidemenu-item-text>Sign In</span>\n        </li>\n      </ul>\n    </a>\n  </div>\n\n  <div ng-repeat=\"item in ::ctrl.bottomNav\" class=\"sidemenu-item dropdown dropup\">\n    <a href={{::item.url}} class=sidemenu-link target={{::item.target}}>\n      <span class=\"icon-circle sidemenu-icon\">\n        <i class={{::item.icon}} ng-show=::item.icon></i>\n        <img ng-src={{::item.img}} ng-show=::item.img>\n      </span>\n    </a>\n    <ul class=\"dropdown-menu dropdown-menu--sidemenu\" role=menu>\n      <li ng-if=item.subTitle class=sidemenu-subtitle>\n        <span class=sidemenu-item-text>{{::item.subTitle}}</span>\n      </li>\n      <li ng-if=item.showOrgSwitcher class=sidemenu-org-switcher>\n        <a ng-click=ctrl.switchOrg()>\n          <div>\n            <div class=sidemenu-org-switcher__org-name>{{ctrl.contextSrv.user.orgName}}</div>\n            <div class=sidemenu-org-switcher__org-current>Current Org:</div>\n          </div>\n          <div class=sidemenu-org-switcher__switch>\n            <i class=\"fa fa-fw fa-random\"></i>Switch</div>\n        </a>\n      </li>\n      <li ng-repeat=\"child in ::item.children\" ng-class=\"{divider: child.divider}\" ng-hide=::child.hideFromMenu>\n        <a href={{::child.url}} target={{::child.target}} ng-click=\"ctrl.itemClicked(child, $event)\">\n          <i class={{::child.icon}} ng-show=::child.icon></i>\n          {{::child.text}}\n        </a>\n      </li>\n      <li class=side-menu-header>\n        <span class=sidemenu-item-text>{{::item.text}}</span>\n      </li>\n    </ul>\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 783 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/admin_home.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n  <div class=\"grafana-info-box span8\">\n    Grafana is a multi-tenant system where most can be configured per organization. These\n    admin pages are for server admins where you can manage orgs, & all users across all orgs.\n  </div>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 784 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/edit_org.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<h2 class=page-sub-heading>Edit Organization</h2>\n\n\t<form name=orgDetailsForm class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Name</span>\n\t\t\t<input type=text required ng-model=org.name class=\"gf-form-input max-width-14\">\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=update() ng-show=!createMode>Update</button>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Organization Users</h3>\n\n\t<table class=filter-table>\n\t\t<tr>\n\t\t\t<th>Username</th>\n\t\t\t<th>Email</th>\n\t\t\t<th>Role</th>\n\t\t\t<th></th>\n\t\t</tr>\n\t\t<tr ng-repeat=\"orgUser in orgUsers\">\n\t\t\t<td>{{orgUser.login}}</td>\n\t\t\t<td>{{orgUser.email}}</td>\n\t\t\t<td>\n        <div class=gf-form>\n          <span class=gf-form-select-wrapper>\n              <select type=text ng-model=orgUser.role class=\"gf-form-input max-width-8\" ng-options=\"f for f in ['Viewer', 'Editor', 'Admin']\" ng-change=updateOrgUser(orgUser)>\n              </select>\n          </span>\n        </div>\n\t\t\t</td>\n\t\t\t<td style=width:1%>\n\t\t\t\t<a ng-click=removeOrgUser(orgUser) class=\"btn btn-danger btn-mini\">\n\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t</a>\n\t\t\t</td>\n\t\t</tr>\n\t</table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 785 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/edit_user.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n\t<div class=page-sub-heading>\n\t\t<h2>Edit User</h2>\n\t</div>\n\n\t<form name=userForm class=gf-form-group>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Name</span>\n\t\t\t\t<input type=text required ng-model=user.name class=\"gf-form-input max-width-25\">\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Email</span>\n\t\t\t\t<input type=email ng-model=user.email class=\"gf-form-input max-width-25\">\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Username</span>\n\t\t\t\t<input type=text ng-model=user.login class=\"gf-form-input max-width-25\">\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=update() ng-show=!createMode>Update</button>\n\t\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Change password</h3>\n\n\t<form name=passwordForm class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">New password</span>\n\t\t\t\t<input type=password required ng-minlength=4 ng-model=password class=\"gf-form-input max-width-25\">\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=setPassword()>Update</button>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Permissions</h3>\n\n\t<form name=passwordForm class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<gf-form-switch class=gf-form label=\"Grafana Admin\" checked=permissions.isGrafanaAdmin switch-class=max-width-6></gf-form-switch>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=updatePermissions()>Update</button>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Organizations</h3>\n\n\t<form name=addOrgForm class=gf-form-group>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=gf-form-label>Add</span>\n\t\t\t\t<input type=text ng-model=newOrg.name bs-typeahead=searchOrgs required class=\"gf-form-input max-width-20\" placeholder=\"organization name\">\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n        \t<span class=gf-form-label>Role</span>\n        \t<span class=gf-form-select-wrapper>\n            \t<select type=text ng-model=newOrg.role class=\"gf-form-input width-10\" ng-options=\"f for f in ['Viewer', 'Editor', 'Admin']\"></select>\n        \t</span>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button class=\"btn btn-success gf-form-btn\" ng-click=addOrgUser()>Add</button>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n\n\t<table class=filter-table>\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th>Role</th>\n\t\t\t\t<th></th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tr ng-repeat=\"org in orgs\">\n\t\t\t<td>\n\t\t\t\t{{org.name}} <span class=\"label label-info\" ng-show=\"org.orgId === user.orgId\">Current</span>\n\t\t\t</td>\n\t\t\t<td>\n        <div class=gf-form>\n            <span class=gf-form-select-wrapper>\n                <select type=text ng-model=org.role class=\"gf-form-input max-width-12\" ng-options=\"f for f in ['Viewer', 'Editor', 'Admin']\" ng-change=updateOrgUser(org)>\n                </select>\n            </span>\n        </div>\n\t\t\t</td>\n\t\t\t<td style=width:1%>\n\t\t\t\t<a ng-click=removeOrgUser(org) class=\"btn btn-danger btn-mini\">\n\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t</a>\n\t\t\t</td>\n\t\t</tr>\n\t</table>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 786 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/new_user.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<div class=page-sub-heading>\n\t\t<h1>Add new user</h1>\n\t</div>\n\n\t<form name=userForm class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Name</span>\n\t\t\t<input type=text required ng-model=user.name class=\"gf-form-input max-width-20\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Email</span>\n\t\t\t<input type=email ng-model=user.email class=\"gf-form-input max-width-20\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Username</span>\n\t\t\t<input type=text ng-model=user.login class=\"gf-form-input max-width-20\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Password</span>\n\t\t\t<input type=password required ng-model=user.password class=\"gf-form-input max-width-20\">\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=create()>Create</button>\n\t\t</div>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 787 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/orgs.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <div class=page-action-bar>\n    <div class=page-action-bar__spacer></div>\n    <a class=\"page-header__cta btn btn-success\" href=org/new>\n      <i class=\"fa fa-plus\"></i>\n      New Org\n    </a>\n  </div>\n\n  <table class=\"filter-table form-inline filter-table--hover\">\n    <thead>\n      <tr>\n        <th>Id</th>\n        <th>Name</th>\n        <th style=width:1%></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"org in orgs\">\n        <td class=link-td>\n          <a href=admin/orgs/edit/{{org.id}}>\n            {{org.id}}\n          </a>\n        </td>\n        <td class=link-td>\n          <a href=admin/orgs/edit/{{org.id}}>\n            {{org.name}}\n          </a>\n        </td>\n        <td class=text-right>\n          <a ng-click=deleteOrg(org) class=\"btn btn-danger btn-small\">\n            <i class=\"fa fa-remove\"></i>\n          </a>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 788 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/settings.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n\t<div class=\"grafana-info-box span8\" style=\"margin:20px 0 25px 0\">\n\t\tThese system settings are defined in grafana.ini or custom.ini (or overridden in ENV variables).\n\t\tTo change these you currently need to restart grafana.\n\t</div>\n\n\t<table class=filter-table>\n\t\t<tr ng-repeat-start=\"(secName, secValue) in settings\">\n\t\t\t<td class=admin-settings-section>{{secName}}</td>\n\t\t\t<td></td>\n\t\t</tr>\n\t\t<tr ng-repeat=\"(keyName, keyValue) in secValue\" ng-repeat-end>\n\t\t\t<td style=padding-left:25px>{{keyName}}</td>\n\t\t\t<td>{{keyValue}}</td>\n\t\t</tr>\n\t</table>\n</div>\n\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 789 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/stats.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<table class=\"filter-table form-inline\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th>Value</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr>\n\t\t\t\t<td>Total dashboards</td>\n\t\t\t\t<td>{{ctrl.stats.dashboards}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total users</td>\n\t\t\t\t<td>{{ctrl.stats.users}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Active users (seen last 14 days)</td>\n\t\t\t\t<td>{{ctrl.stats.activeUsers}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total organizations</td>\n\t\t\t\t<td>{{ctrl.stats.orgs}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total datasources</td>\n\t\t\t\t<td>{{ctrl.stats.datasources}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total playlists</td>\n\t\t\t\t<td>{{ctrl.stats.playlists}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total snapshots</td>\n\t\t\t\t<td>{{ctrl.stats.snapshots}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total dashboard tags</td>\n\t\t\t\t<td>{{ctrl.stats.tags}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>Total starred dashboards</td>\n\t\t\t\t<td>{{ctrl.stats.stars}}</td>\n\t\t\t</tr>\n      <tr>\n\t\t\t\t<td>Total alerts</td>\n\t\t\t\t<td>{{ctrl.stats.alerts}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 790 */
/***/ (function(module, exports) {

var path = 'public/app/features/admin/partials/users.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<div class=page-action-bar>\n    <label class=\"gf-form gf-form--grow gf-form--has-input-icon\">\n      <input type=text class=\"gf-form-input max-width-30\" placeholder=\"Find user by name/login/email\" tabindex=1 give-focus=true ng-model=ctrl.query ng-model-options=\"{ debounce: 500 }\" spellcheck=false ng-change=ctrl.getUsers() />\n      <i class=\"gf-form-input-icon fa fa-search\"></i>\n    </label>\n    <div class=page-action-bar__spacer></div>\n    <a class=\"btn btn-success\" href=admin/users/create>\n      <i class=\"fa fa-plus\"></i>\n      Add new user\n    </a>\n  </div>\n\n  <div class=admin-list-table>\n    <table class=\"filter-table form-inline filter-table--hover\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>Login</th>\n          <th>Email</th>\n          <th>\n            Seen\n            <tip>Time since user was seen using Grafana</tip>\n          </th>\n          <th></th>\n          <th style=width:1%></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"user in ctrl.users\">\n          <td class=\"width-4 text-center link-td\">\n            <a href=admin/users/edit/{{user.id}}>\n              <img class=filter-table__avatar ng-src={{user.avatarUrl}}>\n            </a>\n          </td>\n          <td class=link-td>\n            <a href=admin/users/edit/{{user.id}}>\n              {{user.login}}\n            </a>\n          </td>\n          <td class=link-td>\n            <a href=admin/users/edit/{{user.id}}>\n              {{user.email}}\n            </a>\n          </td>\n          <td class=link-td>\n            <a href=admin/users/edit/{{user.id}}>\n              {{user.lastSeenAtAge}}\n            </a>\n          </td>\n          <td class=link-td>\n            <a href=admin/users/edit/{{user.id}}>\n              <i class=\"fa fa-shield\" ng-show=user.isAdmin bs-tooltip=\"'Grafana Admin'\"></i>\n            </a>\n          </td>\n          <td class=text-right>\n            <a ng-click=ctrl.deleteUser(user) class=\"btn btn-danger btn-small\">\n              <i class=\"fa fa-remove\"></i>\n            </a>\n          </td>\n        </tr>\n      </tbody>\n\n    </table>\n  </div>\n\n  <div class=admin-list-paging ng-if=ctrl.showPaging>\n    <ol>\n      <li ng-repeat=\"page in ctrl.pages\">\n        <button class=\"btn btn-small\" ng-class=\"{'btn-secondary': page.current, 'btn-inverse': !page.current}\" ng-click=ctrl.navigateToPage(page)>{{page.page}}</button>\n      </li>\n    </ol>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 791 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/alert_howto.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-info-circle\"></i>\n\t\t\t<span class=p-l-1>Adding an Alert</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\n\t<div class=modal-content>\n\t\t<div class=text-center>\n\t\t\t<img src=public/img/alert_howto_new.png>\n\t\t</div>\n\t\t<p class=\"p-a-2 text-center offset-lg-1 col-lg-10\">\n\t\t\tAlerts are added and configured in the <strong>Alert Tab</strong> of any dashboard\n\t\t\tgraph panel, letting you build and visualize an alert using existing queries.\n\t\t\t<br> <br>\n\t\t\tTo persist your alert rule changes remember to save the dashboard.\n\t\t\t<br>\n\t\t\t<br>\n\t\t</p>\n\t</div>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 792 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/alert_tab.html';
var html = "<div class=edit-tab-with-sidemenu ng-if=ctrl.alert>\n\t<aside class=edit-sidemenu-aside>\n\t\t<ul class=edit-sidemenu>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 0}\">\n\t\t\t\t<a ng-click=ctrl.changeTabIndex(0)>Alert Config</a>\n\t\t\t</li>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 1}\">\n\t\t\t\t<a ng-click=ctrl.changeTabIndex(1)>\n\t\t\t\t\tNotifications <span class=muted>({{ctrl.alertNotifications.length}})</span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 2}\">\n\t\t\t\t<a ng-click=ctrl.changeTabIndex(2)>State history</a>\n\t\t\t</li>\n      <li>\n\t\t\t\t<a ng-click=ctrl.delete()>Delete</a>\n\t\t\t</li>\n\t\t</ul>\n\t</aside>\n\n\t<div class=edit-tab-content>\n\t\t<div ng-if=\"ctrl.subTabIndex === 0\">\n\t\t\t<div class=\"alert alert-error m-b-2\" ng-show=ctrl.error>\n\t\t\t\t<i class=\"fa fa-warning\"></i> {{ctrl.error}}\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<h5 class=section-heading>Alert Config</h5>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-6\">Name</span>\n\t\t\t\t\t<input type=text class=\"gf-form-input width-20\" ng-model=ctrl.alert.name>\n\t\t\t\t\t<span class=gf-form-label>Evaluate every</span>\n\t\t\t\t\t<input class=\"gf-form-input max-width-5\" type=text ng-model=ctrl.alert.frequency>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<h5 class=section-heading>Conditions</h5>\n\t\t\t\t<div class=gf-form-inline ng-repeat=\"conditionModel in ctrl.conditionModels\">\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<metric-segment-model css-class=\"query-keyword width-5\" ng-if=$index property=conditionModel.operator.type options=ctrl.evalOperators custom=false></metric-segment-model>\n\t\t\t\t\t\t<span class=\"gf-form-label query-keyword width-5\" ng-if=\"$index===0\">WHEN</span>\n\t\t\t\t\t</div>\n          \t\t\t<div class=gf-form>\n\t\t\t\t\t\t<query-part-editor class=\"gf-form-label query-part width-9\" part=conditionModel.reducerPart handle-event=\"ctrl.handleReducerPartEvent(conditionModel, $event)\">\n\t\t\t\t\t\t</query-part-editor>\n            \t\t\t<span class=\"gf-form-label query-keyword\">OF</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<query-part-editor class=\"gf-form-label query-part\" part=conditionModel.queryPart handle-event=\"ctrl.handleQueryPartEvent(conditionModel, $event)\">\n\t\t\t\t\t\t</query-part-editor>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<metric-segment-model property=conditionModel.evaluator.type options=ctrl.evalFunctions custom=false css-class=query-keyword on-change=ctrl.evaluatorTypeChanged(conditionModel.evaluator)></metric-segment-model>\n\t\t\t\t\t\t<input class=\"gf-form-input max-width-9\" type=number step=any ng-hide=\"conditionModel.evaluator.params.length === 0\" ng-model=conditionModel.evaluator.params[0] ng-change=ctrl.evaluatorParamsChanged()>\n            \t\t\t<label class=\"gf-form-label query-keyword\" ng-show=\"conditionModel.evaluator.params.length === 2\">TO</label>\n            \t\t\t<input class=\"gf-form-input max-width-9\" type=number step=any ng-if=\"conditionModel.evaluator.params.length === 2\" ng-model=conditionModel.evaluator.params[1] ng-change=ctrl.evaluatorParamsChanged()>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=gf-form>\n\t\t\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t\t\t<a class=pointer tabindex=1 ng-click=ctrl.removeCondition($index)>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=\"gf-form-label dropdown\">\n\t\t\t\t\t\t<a class=\"pointer dropdown-toggle\" data-toggle=dropdown>\n\t\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<ul class=dropdown-menu role=menu>\n\t\t\t\t\t\t\t<li ng-repeat=\"ct in ctrl.conditionTypes\" role=menuitem>\n\t\t\t\t\t\t\t\t<a ng-click=ctrl.addCondition(ct.value);>{{ct.text}}</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group>\n\t\t\t\t<div class=gf-form>\n          \t\t\t<span class=\"gf-form-label width-18\">If no data or all values are null</span>\n          \t\t\t<span class=\"gf-form-label query-keyword\">SET STATE TO</span>\n\t\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.alert.noDataState ng-options=\"f.value as f.text for f in ctrl.noDataModes\">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n          \t\t\t<span class=\"gf-form-label width-18\">If execution error or timeout</span>\n          \t\t\t<span class=\"gf-form-label query-keyword\">SET STATE TO</span>\n\t\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.alert.executionErrorState ng-options=\"f.value as f.text for f in ctrl.executionErrorModes\">\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form-button-row>\n\t\t\t\t\t<button class=\"btn btn-inverse\" ng-click=ctrl.test()>\n\t\t\t\t\t\tTest Rule\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group ng-if=ctrl.testing>\n\t\t\t\tEvaluating rule <i class=\"fa fa-spinner fa-spin\"></i>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-group ng-if=ctrl.testResult>\n\t\t\t\t<json-tree root-name=result object=ctrl.testResult start-expanded=true></json-tree>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-group ng-if=\"ctrl.subTabIndex === 1\">\n\t\t\t<h5 class=section-heading>Notifications</h5>\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=\"gf-form max-width-30\">\n\t\t\t\t\t<span class=\"gf-form-label width-8\">Send to</span>\n\t\t\t\t\t<span class=gf-form-label ng-repeat=\"nc in ctrl.alertNotifications\" ng-style=\"{'background-color': nc.bgColor }\">\n\t\t\t\t\t\t<i class={{nc.iconClass}}></i>&nbsp;{{nc.name}}&nbsp;\n\t\t\t\t\t\t<i class=\"fa fa-remove pointer muted\" ng-click=ctrl.removeNotification($index) ng-if=\"nc.isDefault === false\"></i>\n\t\t\t\t\t</span>\n\t\t\t\t\t<metric-segment segment=ctrl.addNotificationSegment get-options=ctrl.getNotifications() on-change=ctrl.notificationAdded()></metric-segment>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form gf-form--v-stretch\">\n\t\t\t\t<span class=\"gf-form-label width-8\">Message</span>\n\t\t\t\t<textarea class=gf-form-input rows=10 ng-model=ctrl.alert.message placeholder=\"Notification message details...\"></textarea>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-group style=max-width:720px ng-if=\"ctrl.subTabIndex === 2\">\n\t\t\t<button class=\"btn btn-mini btn-danger pull-right\" ng-click=ctrl.clearHistory()><i class=\"fa fa-trash\"></i>&nbsp;Clear history</button>\n      \t\t<h5 class=section-heading style=whitespace:nowrap>\n\t\t\t\tState history <span class=\"muted small\">(last 50 state changes)</span>\n\t\t\t</h5>\n\n\t\t\t<div ng-show=\"ctrl.alertHistory.length === 0\">\n\t\t\t\t<br>\n\t\t\t\t<i>No state changes recorded</i>\n\t\t\t</div>\n\n      <ol class=alert-rule-list>\n        <li class=alert-rule-item ng-repeat=\"al in ctrl.alertHistory\">\n          <div class=\"alert-rule-item__icon {{al.stateModel.stateClass}}\">\n            <i class={{al.stateModel.iconClass}}></i>\n          </div>\n          <div class=alert-rule-item__body>\n            <div class=alert-rule-item__header>\n              <div class=alert-rule-item__text>\n                <span class={{al.stateModel.stateClass}}>{{al.stateModel.text}}</span>\n              </div>\n            </div>\n            <span class=alert-list-info>{{al.info}}</span>\n          </div>\n          <div class=alert-rule-item__time>\n            <span>{{al.time}}</span>\n          </div>\n        </li>\n      </ol>\n    </div>\n  </div>\n</div>\n\n<div class=gf-form-group ng-if=!ctrl.alert>\n  <div class=gf-form-button-row>\n    <button class=\"btn btn-inverse\" ng-click=ctrl.enable()>\n      <i class=\"icon-gf icon-gf-alert\"></i>\n      Create Alert\n    </button>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 793 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/notification_edit.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n  <h3 class=page-sub-heading ng-hide=ctrl.isNew>Edit Notification Channel</h3>\n  <h3 class=page-sub-heading ng-show=ctrl.isNew>New Notification Channel</h3>\n\n  <form name=ctrl.theForm ng-if=ctrl.notifiers>\n    <div class=gf-form-group>\n      <div class=gf-form>\n        <span class=\"gf-form-label width-12\">Name</span>\n        <input type=text required class=\"gf-form-input max-width-15\" ng-model=ctrl.model.name required>\n      </div>\n      <div class=gf-form>\n        <span class=\"gf-form-label width-12\">Type</span>\n        <div class=\"gf-form-select-wrapper width-15\">\n          <select class=gf-form-input ng-model=ctrl.model.type ng-options=\"t.type as t.name for t in ctrl.notifiers\" ng-change=\"ctrl.typeChanged(notification, $index)\">\n          </select>\n        </div>\n      </div>\n      <gf-form-switch class=gf-form label=\"Send on all alerts\" label-class=width-12 checked=ctrl.model.isDefault tooltip=\"Use this notification for all alerts\">\n      </gf-form-switch>\n      <gf-form-switch class=gf-form label=\"Include image\" label-class=width-12 checked=ctrl.model.settings.uploadImage tooltip=\"Captures an image and include it in the notification\">\n      </gf-form-switch>\n    </div>\n\n    <div class=gf-form-group ng-include src=ctrl.notifierTemplateId>\n    </div>\n\n    <div class=\"gf-form-group gf-form-button-row\">\n\t\t\t<button type=submit ng-click=ctrl.save() class=\"btn btn-success width-7\">Save</button>\n\t\t\t<button type=submit ng-click=ctrl.testNotification() class=\"btn btn-secondary width-7\">Send Test</button>\n\t\t\t<a href=alerting/notifications class=\"btn btn-inverse\">Back</a>\n    </div>\n  </form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

var path = 'public/app/features/alerting/partials/notifications_list.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n  <div ng-if=ctrl.notifications.length>\n    <div class=page-action-bar>\n      <div class=page-action-bar__spacer>\n      </div>\n\n      <a href=alerting/notification/new class=\"btn btn-success\">\n        <i class=\"fa fa-plus\"></i>\n        New Channel\n      </a>\n    </div>\n\n    <table class=\"filter-table filter-table--hover\">\n      <thead>\n        <th style=min-width:200px>\n          <strong>Name</strong>\n        </th>\n        <th style=min-width:100px>Type</th>\n        <th style=width:1%></th>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"notification in ctrl.notifications\">\n          <td class=link-td>\n            <a href=alerting/notification/{{notification.id}}/edit>\n              {{notification.name}}\n            </a>\n          </td>\n          <td class=link-td>\n            <a href=alerting/notification/{{notification.id}}/edit>\n              {{notification.type}}\n            </a>\n          </td>\n          <td class=text-right>\n            <span class=\"btn btn-secondary btn-small\" ng-show=\"notification.isDefault == true\">\n              default\n            </span>\n            <a ng-click=ctrl.deleteNotification(notification.id) class=\"btn btn-danger btn-small\">\n              <i class=\"fa fa-remove\"></i>\n            </a>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <div ng-if=\"ctrl.notifications.length === 0\">\n    <empty-list-cta model=\"{\n      title: 'There are no notification channels defined yet',\n      buttonIcon: 'gicon gicon-add-alert-notification-channel',\n      buttonLink: 'alerting/notification/new',\n      buttonTitle: 'Add channel',\n      proTip: 'You can include images in your alert notifications.',\n      proTipLink: 'http://docs.grafana.org/alerting/notifications/',\n      proTipLinkTitle: 'Learn more',\n      proTipTarget: '_blank'\n    }\"/>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 795 */
/***/ (function(module, exports) {

var path = 'public/app/features/annotations/partials/editor.html';
var html = "\n<div ng-controller=AnnotationsEditorCtrl>\n\t<h3 class=dashboard-settings__header>\n\t\t<a ng-click=ctrl.backToList()>Annotations</a>\n\t\t<span ng-show=\"ctrl.mode === 'new'\">&gt; New</span>\n\t\t<span ng-show=\"ctrl.mode === 'edit'\">&gt; Edit</span>\n\t</h3>\n\n\t<div ng-if=\"ctrl.mode === 'list'\">\n\t\t<div class=page-action-bar ng-if=\"ctrl.annotations.length > 1\">\n\t\t\t<div class=page-action-bar__spacer></div>\n\t\t\t<a type=button class=\"btn btn-success\" ng-click=ctrl.setupNew();><i class=\"fa fa-plus\"></i> New</a>\n\t\t</div>\n\n\t\t<table class=\"filter-table filter-table--hover\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Query name</th>\n\t\t\t\t\t<th>Data source</th>\n\t\t\t\t\t<th colspan=3></th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"annotation in ctrl.annotations\">\n\t\t\t\t\t<td style=width:90% ng-hide=annotation.builtIn class=pointer ng-click=ctrl.edit(annotation)>\n\t\t\t\t\t\t<i class=\"fa fa-comment\" style=color:{};></i> &nbsp;\n\t\t\t\t\t\t{{annotation.name}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td style=width:90% ng-show=annotation.builtIn class=pointer ng-click=ctrl.edit(annotation)>\n\t\t\t\t\t\t<i class=\"gicon gicon-annotation\"></i> &nbsp;\n\t\t\t\t\t\t<em class=muted>{{annotation.name}} (Built-in)</em>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=pointer ng-click=ctrl.edit(annotation)>\n\t\t\t\t\t\t{{annotation.datasource || 'Default'}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td style=width:1%><i ng-click=_.move(ctrl.annotations,$index,$index-1) ng-hide=$first class=\"pointer fa fa-arrow-up\"></i></td>\n\t\t\t\t\t<td style=width:1%><i ng-click=_.move(ctrl.annotations,$index,$index+1) ng-hide=$last class=\"pointer fa fa-arrow-down\"></i></td>\n\t\t\t\t\t<td style=width:1%>\n\t\t\t\t\t\t<a ng-click=ctrl.removeAnnotation(annotation) class=\"btn btn-danger btn-mini\" ng-hide=annotation.builtIn>\n\t\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\n\t\t<!-- empty list cta, there is always one built in query -->\n\t\t<div ng-if=\"ctrl.annotations.length === 1\" class=p-t-2>\n\t\t\t<div class=empty-list-cta>\n\t\t\t\t<div class=empty-list-cta__title>There are no custom annotation queries added yet</div>\n\t\t\t\t<a ng-click=ctrl.setupNew() class=\"empty-list-cta__button btn btn-xlarge btn-success\">\n\t\t\t\t\t<i class=\"gicon gicon-add-annotation\"></i>\n\t\t\t\t\tAdd Annotation Query\n\t\t\t\t</a>\n\t\t\t\t<div class=grafana-info-box>\n\t\t\t\t\t<h5>What are Annotations?</h5>\n\t\t\t\t\t<p>\n\t\t\t\t\tAnnotations provide a way to integrate event data into your graphs. They are visualized as vertical lines and icons\n\t\t\t\t\ton all graph panels. When you hover over an annotation icon you can get event text &amp; tags for the event. You can add annotation events\n\t\t\t\t\tdirectly from grafana by holding CTRL or CMD + click on graph (or drag region). These will be stored in Grafana's annotation database.\n\t\t\t\t\t</p>\n\t\t\t\t\tCheckout the <a class=external-link target=_blank href=http://docs.grafana.org/reference/annotations/ >Annotations documentation</a> for more information.\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=annotations-basic-settings ng-if=\"ctrl.mode === 'edit' || ctrl.mode === 'new'\">\n\t\t<div class=gf-form-group>\n\t\t\t<h5 class=section-heading>General</h5>\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Name</span>\n\t\t\t\t\t<input type=text class=\"gf-form-input width-20\" ng-model=ctrl.currentAnnotation.name placeholder=name>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Data source</span>\n\t\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.currentAnnotation.datasource ng-options=\"f.name as f.name for f in ctrl.datasources\" ng-change=ctrl.datasourceChanged()></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-group>\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<gf-form-switch class=gf-form label=Enabled checked=ctrl.currentAnnotation.enable label-class=width-7>\n\t\t\t\t</gf-form-switch>\n\t\t\t\t<gf-form-switch class=gf-form label=Hidden tooltip=\"Hides the annotation query toggle from showing at the top of the dashboard\" checked=ctrl.currentAnnotation.hide label-class=width-7>\n\t\t\t\t</gf-form-switch>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=\"gf-form-label width-9\">Color</label>\n\t\t\t\t\t<span class=gf-form-label>\n\t\t\t\t\t\t<color-picker color=ctrl.currentAnnotation.iconColor onchange=ctrl.onColorChange></color-picker>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<h5 class=section-heading>Query</h5>\n\t\t<rebuild-on-change property=ctrl.currentDatasource>\n\t\t\t<plugin-component type=annotations-query-ctrl>\n\t\t\t</plugin-component>\n\t\t</rebuild-on-change>\n\n\t\t<div class=gf-form>\n\t\t\t<div class=\"gf-form-button-row p-y-0\">\n\t\t\t\t<button ng-show=\"ctrl.mode === 'new'\" type=button class=\"btn gf-form-button btn-success\" ng-click=ctrl.add()>Add</button>\n\t\t\t\t<button ng-show=\"ctrl.mode === 'edit'\" type=button class=\"btn btn-success pull-left\" ng-click=ctrl.update()>Update</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 796 */
/***/ (function(module, exports) {

var path = 'public/app/features/annotations/partials/event_editor.html';
var html = "\n<div class=graph-annotation>\n\t<div class=graph-annotation__header>\n\t\t<div class=graph-annotation__user bs-tooltip=\"'Created by {{ctrl.login}}'\">\n\t\t</div>\n\n\t\t<div class=graph-annotation__title>\n\t\t\t<span ng-if=!ctrl.event.id>Add Annotation</span>\n\t\t\t<span ng-if=ctrl.event.id>Edit Annotation</span>\n\t\t</div>\n\n    <div class=graph-annotation__time>{{ctrl.timeFormated}}</div>\n\t</div>\n\n\t<form name=ctrl.form class=\"graph-annotation__body text-center\">\n\t\t<div style=display:inline-block>\n\t\t\t<div class=\"gf-form gf-form--v-stretch\">\n\t\t\t\t<span class=\"gf-form-label width-7\">Description</span>\n\t\t\t\t<textarea class=\"gf-form-input width-20\" rows=2 ng-model=ctrl.event.text placeholder=Description></textarea>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-7\">Tags</span>\n\t\t\t\t<bootstrap-tagsinput ng-model=ctrl.event.tags tagclass=\"label label-tag\" placeholder=\"add tags\">\n\t\t\t\t</bootstrap-tagsinput>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=ctrl.save()>Save</button>\n\t\t\t\t<button ng-if=ctrl.event.id type=submit class=\"btn btn-danger\" ng-click=ctrl.delete()>Delete</button>\n\t\t\t\t<a class=btn-text ng-click=ctrl.close();>Cancel</a>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/dashnav/dashnav.html';
var html = "<div class=navbar>\n\n\t<div>\n\t\t<a class=navbar-page-btn ng-click=ctrl.showSearch()>\n\t\t\t<i class=\"gicon gicon-dashboard\"></i>\n\t\t\t{{ctrl.dashboard.title}}\n\t\t\t<i class=\"fa fa-caret-down\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=\"navbar-buttons navbar-buttons--playlist\" ng-if=ctrl.playlistSrv.isPlaying>\n\t\t<a class=\"navbar-button navbar-button--tight\" ng-click=ctrl.playlistSrv.prev()><i class=\"fa fa-step-backward\"></i></a>\n\t\t<a class=\"navbar-button navbar-button--tight\" ng-click=ctrl.playlistSrv.stop()><i class=\"fa fa-stop\"></i></a>\n\t\t<a class=\"navbar-button navbar-button--tight\" ng-click=ctrl.playlistSrv.next()><i class=\"fa fa-step-forward\"></i></a>\n\t</div>\n\n\t<div class=navbar__spacer></div>\n\n\t<div class=\"navbar-buttons navbar-buttons--actions\">\n\t\t<button class=\"btn navbar-button navbar-button--add-panel\" ng-show=::ctrl.dashboard.meta.canSave bs-tooltip=\"'Add panel'\" data-placement=bottom ng-click=ctrl.addPanel()>\n\t\t\t<i class=\"gicon gicon-add-panel\"></i>\n\t\t</button>\n\n\t\t<button class=\"btn navbar-button navbar-button--star\" ng-show=::ctrl.dashboard.meta.canStar ng-click=ctrl.starDashboard() bs-tooltip=\"'Mark as favorite'\" data-placement=bottom>\n\t\t\t<i class=fa ng-class=\"{'fa-star-o': !ctrl.dashboard.meta.isStarred, 'fa-star': ctrl.dashboard.meta.isStarred}\"></i>\n\t\t</button>\n\n\t\t<button class=\"btn navbar-button navbar-button--share\" ng-show=::ctrl.dashboard.meta.canShare ng-click=ctrl.shareDashboard(0) bs-tooltip=\"'Share dashboard'\" data-placement=bottom>\n\t\t\t<i class=\"fa fa-share-square-o\"></i>\n\t\t</button>\n\n\t\t<button class=\"btn navbar-button navbar-button--save\" ng-show=ctrl.dashboard.meta.canSave ng-click=ctrl.saveDashboard() bs-tooltip=\"'Save dashboard <br> CTRL+S'\" data-placement=bottom>\n\t\t\t<i class=\"fa fa-save\"></i>\n\t\t</button>\n\n\t\t<a class=\"btn navbar-button navbar-button--snapshot-origin\" ng-if=::ctrl.dashboard.snapshot.originalUrl href={{ctrl.dashboard.snapshot.originalUrl}} bs-tooltip=\"'Open original dashboard'\" data-placement=bottom>\n\t\t\t<i class=\"fa fa-link\"></i>\n\t\t</a>\n\n\t\t<button class=\"btn navbar-button navbar-button--settings\" ng-click=ctrl.toggleSettings() bs-tooltip=\"'Settings'\" data-placement=bottom ng-show=ctrl.dashboard.meta.showSettings>\n\t\t\t<i class=\"fa fa-cog\"></i>\n\t\t</button>\n\t</div>\n\n\t<gf-time-picker class=gf-timepicker-nav dashboard=ctrl.dashboard ng-if=!ctrl.dashboard.timepicker.hidden></gf-time-picker>\n\n\t<div class=\"navbar-buttons navbar-buttons--close\">\n\t\t<button class=\"btn navbar-button navbar-button--primary\" ng-click=ctrl.close() bs-tooltip=\"'Back to dashboard'\" data-placement=bottom>\n\t\t\t<i class=\"fa fa-reply\"></i>\n\t\t</button>\n\t</div>\n\n</div>\n\n<dashboard-search></dashboard-search>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 798 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/export/export_modal.html';
var html = "\n<!-- <p> -->\n<!-- \tExporting will export a cleaned sharable dashboard that can be imported -->\n<!-- \tinto another Grafana instance. -->\n<!-- </p> -->\n\n<div class=share-modal-header>\n\t<div class=share-modal-big-icon>\n\t\t<i class=\"fa fa-cloud-upload\"></i>\n\t</div>\n\t<div>\n\t\t<p class=share-modal-info-text>\n\t\t\tExport the dashboard to a JSON file. The exporter will templatize the\n\t\t\tdashboard's data sources to make it easy for others to import and reuse.\n\t\t\tYou can share dashboards on <a class=external-link href=https://grafana.com>Grafana.com</a>\n\t\t</p>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=button class=\"btn gf-form-btn width-10 btn-success\" ng-click=ctrl.save()>\n\t\t\t\t<i class=\"fa fa-save\"></i> Save to file\n\t\t\t</button>\n\t\t\t<button type=button class=\"btn gf-form-btn width-10 btn-secondary\" ng-click=ctrl.saveJson()>\n\t\t\t\t<i class=\"fa fa-file-text-o\"></i> View JSON\n\t\t\t</button>\n\t\t\t<a class=\"btn btn-link\" ng-click=ctrl.dismiss()>Cancel</a>\n\t\t</div>\n\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 799 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/export_data/export_data_modal.html';
var html = "<div class=modal-body>\n  <div class=modal-header>\n    <h2 class=modal-header-title>\n      Export CSV\n    </h2>\n\n    <a class=modal-header-close ng-click=ctrl.dismiss();>\n      <i class=\"fa fa-remove\"></i>\n    </a>\n  </div>\n\n  <div class=modal-content>\n    <div class=p-t-2>\n      <div class=gf-form ng-hide=\"ctrl.panel === 'table'\">\n        <label class=\"gf-form-label width-10\">Mode</label>\n        <div class=gf-form-select-wrapper>\n          <select class=gf-form-input ng-model=ctrl.asRows ng-options=\"f.value as f.text for f in [{text: 'Series as rows', value: true}, {text: 'Series as columns', value: false}]\">\n          </select>\n        </div>\n      </div>\n      <div class=gf-form ng-hide=\"ctrl.panel === 'table'\">\n        <label class=\"gf-form-label width-10\">Date Time Format</label>\n        <input type=text class=gf-form-input ng-model=ctrl.dateTimeFormat>\n      </div>\n      <gf-form-switch class=gf-form label=\"Excel CSV Dialect\" label-class=width-10 switch-class=max-width-6 checked=ctrl.excel>\n      </gf-form-switch>\n    </div>\n\n    <div class=\"gf-form-button-row text-center\">\n      <a class=\"btn btn-success\" ng-click=ctrl.export();>Export</a>\n      <a class=btn-text ng-click=ctrl.dismiss();>Cancel</a>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 800 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/folder_picker/folder_picker.html';
var html = "<div class=gf-form-inline>\n  <div class=gf-form>\n    <label class=\"gf-form-label {{ctrl.labelClass}}\">Folder</label>\n    <div class=dropdown ng-hide=ctrl.createNewFolder>\n      <gf-form-dropdown model=ctrl.folder get-options=ctrl.getOptions($query) on-change=ctrl.onFolderChange($option)>\n      </gf-form-dropdown>\n    </div>\n    <input type=text class=\"gf-form-input max-width-10\" ng-if=ctrl.createNewFolder give-focus=ctrl.createNewFolder ng-model=ctrl.newFolderName ng-model-options=\"{ debounce: 400 }\" ng-change=ctrl.newFolderNameChanged() />\n  </div>\n  <div class=gf-form ng-if=ctrl.createNewFolder>\n    <button class=\"btn btn-inverse\" ng-click=ctrl.createFolder($event) ng-disabled=\"!ctrl.newFolderNameTouched || ctrl.hasValidationError\">\n      <i class=\"fa fa-fw fa-save\"></i>&nbsp;Create\n    </button>\n  </div>\n  <div class=gf-form ng-if=ctrl.createNewFolder>\n    <button class=\"btn btn-inverse\" ng-click=ctrl.cancelCreateFolder($event)>\n      Cancel\n  </button>\n  </div>\n</div>\n<div class=gf-form-inline ng-if=\"ctrl.newFolderNameTouched && ctrl.hasValidationError\">\n  <div class=\"gf-form gf-form--grow\">\n    <label class=\"gf-form-label text-warning gf-form-label--grow\">\n      <i class=\"fa fa-warning\"></i>\n      {{ctrl.validationError}}\n    </label>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 801 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/history/history.html';
var html = "<h3 class=dashboard-settings__header>\n  <a ng-click=\"ctrl.switchMode('list')\">Versions</a>\n  <span ng-show=\"ctrl.mode === 'compare'\">\n    &gt; Comparing {{ctrl.baseInfo.version}}\n    <i class=\"fa fa-arrows-h\"></i>\n    {{ctrl.newInfo.version}}\n    <cite class=muted ng-if=ctrl.isNewLatest>(Latest)</cite>\n  </span>\n</h3>\n\n<div ng-if=\"ctrl.mode === 'list'\">\n  <div ng-if=ctrl.loading>\n    <i class=\"fa fa-spinner fa-spin\"></i>\n    <em>Fetching history list&hellip;</em>\n  </div>\n\n  <div ng-if=!ctrl.loading>\n    <div class=gf-form-group>\n      <table class=filter-table>\n        <thead>\n          <tr>\n            <th class=width-4></th>\n            <th class=width-4>Version</th>\n            <th class=width-14>Date</th>\n            <th class=width-10>Updated By</th>\n            <th>Notes</th>\n            <th></th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"revision in ctrl.revisions\">\n            <td class=filter-table__switch-cell bs-tooltip=\"!revision.checked && ctrl.canCompare ? 'You can only compare 2 versions at a time' : ''\" data-placement=right>\n              <gf-form-switch switch-class=gf-form-switch--table-cell checked=revision.checked on-change=ctrl.revisionSelectionChanged() ng-disabled=\"!revision.checked && ctrl.canCompare\">\n              </gf-form-switch>\n            </td>\n            <td class=text-center>{{revision.version}}</td>\n            <td>{{revision.createdDateString}}</td>\n            <td>{{revision.createdBy}}</td>\n            <td>{{revision.message}}</td>\n            <td class=text-right>\n              <a class=\"btn btn-inverse btn-small\" ng-show=\"revision.version !== ctrl.dashboard.version\" ng-click=ctrl.restore(revision.version)>\n                <i class=\"fa fa-history\"></i>&nbsp;&nbsp;Restore\n              </a>\n              <a class=\"btn btn-outline-disabled btn-small\" ng-show=\"revision.version === ctrl.dashboard.version\">\n                <i class=\"fa fa-check\"></i>&nbsp;&nbsp;Latest\n              </a>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n\n      <div ng-if=ctrl.appending>\n        <i class=\"fa fa-spinner fa-spin\"></i>\n        <em>Fetching more entries&hellip;</em>\n      </div>\n\n      <div class=gf-form-group>\n        <div class=gf-form-button-row>\n          <button type=button class=\"btn gf-form-button btn-inverse\" ng-if=\"ctrl.revisions.length >= ctrl.limit\" ng-click=ctrl.addToLog() ng-disabled=ctrl.isLastPage()>\n            Show more versions\n          </button>\n          <button type=button class=\"btn btn-success\" ng-if=\"ctrl.revisions.length > 1\" ng-disabled=!ctrl.canCompare ng-click=ctrl.getDiff(ctrl.diff) bs-tooltip=\"ctrl.canCompare ? '' : 'Select 2 versions to start comparing'\" data-placement=bottom>\n            <i class=\"fa fa-code-fork\"></i>&nbsp;&nbsp;Compare versions\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div ng-if=\"ctrl.mode === 'compare'\">\n  <div ng-if=ctrl.loading>\n    <i class=\"fa fa-spinner fa-spin\"></i>\n    <em>Fetching changes&hellip;</em>\n  </div>\n\n  <div ng-if=!ctrl.loading>\n    <button type=button class=\"btn btn-danger pull-right\" ng-click=ctrl.restore(ctrl.baseInfo.version) ng-if=ctrl.isNewLatest>\n      <i class=\"fa fa-history\"></i>&nbsp;&nbsp;Restore to version {{ctrl.baseInfo.version}}\n    </button>\n    <section>\n      <p class=\"small muted\">\n      <strong>Version {{ctrl.newInfo.version}}</strong> updated by\n      <span>{{ctrl.newInfo.createdBy}} </span>\n      <span>{{ctrl.newInfo.ageString}}</span>\n      <span> - {{ctrl.newInfo.message}}</span>\n      </p>\n      <p class=\"small muted\">\n      <strong>Version {{ctrl.baseInfo.version}}</strong> updated by\n      <span>{{ctrl.baseInfo.createdBy}} </span>\n      <span>{{ctrl.baseInfo.ageString}}</span>\n      <span> - {{ctrl.baseInfo.message}}</span>\n      </p>\n    </section>\n\n    <div id=delta diff-delta>\n      <div class=delta-basic compile=ctrl.delta.basic></div>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button class=\"btn btn-secondary\" ng-click=\"ctrl.getDiff('json')\">View JSON Diff</button>\n    </div>\n\n    <div class=delta-html ng-show=\"ctrl.diff === 'json'\" compile=ctrl.delta.json></div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 802 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/move_to_folder_modal/move_to_folder.html';
var html = "<div class=modal-body>\n  <div class=modal-header>\n    <h2 class=modal-header-title>\n\t\t\t<i class=\"gicon gicon-folder-new\"></i>\n      <span class=p-l-1>Choose Dashboard Folder</span>\n    </h2>\n\n    <a class=modal-header-close ng-click=ctrl.dismiss();>\n      <i class=\"fa fa-remove\"></i>\n    </a>\n  </div>\n\n  <form name=ctrl.saveForm ng-submit=ctrl.save() class=\"modal-content folder-modal\" novalidate>\n    <p>Move the {{ctrl.dashboards.length}} selected dashboards to the following folder:</p>\n\n    <div class=p-t-2>\n      <div class=gf-form>\n          <folder-picker on-load=ctrl.onFolderChange($folder) on-change=ctrl.onFolderChange($folder) enter-folder-creation=ctrl.onEnterFolderCreation() exit-folder-creation=ctrl.onExitFolderCreation() enable-create-new=true label-class=width-7>\n          </folder-picker>\n      </div>\n    </div>\n    <div class=\"gf-form-button-row text-center\">\n      <button type=submit class=\"btn btn-success\" ng-disabled=\"ctrl.saveForm.$invalid || !ctrl.isValidFolderSelection\">Move</button>\n      <a class=btn-text ng-click=ctrl.dismiss();>Cancel</a>\n    </div>\n  </form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 803 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/create_folder.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\" ng-cloak>\n\n\t<h3 class=page-sub-heading>New Dashboard Folder</h3>\n\n  <form name=ctrl.saveForm ng-submit=ctrl.create() novalidate>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<label class=\"gf-form-label width-10\">Name</label>\n\t\t\t\t<input type=text class=gf-form-input ng-model=ctrl.title give-focus=true ng-change=ctrl.titleChanged() ng-model-options=\"{ debounce: 400 }\" ng-class=\"{'validation-error': ctrl.nameExists || !ctrl.dash.title}\">\n\t\t\t\t<label class=\"gf-form-label text-success\" ng-if=\"ctrl.titleTouched && !ctrl.hasValidationError\">\n\t\t\t\t\t<i class=\"fa fa-check\"></i>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-inline ng-if=ctrl.hasValidationError>\n\t\t\t<div class=\"gf-form offset-width-10 gf-form--grow\">\n\t\t\t\t<label class=\"gf-form-label text-warning gf-form-label--grow\">\n\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t\t{{ctrl.validationError}}\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success width-12\" ng-disabled=\"!ctrl.titleTouched || ctrl.hasValidationError\">\n\t\t\t\t<i class=\"fa fa-save\"></i> Create\n\t\t\t</button>\n\t\t</div>\n\t</form>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 804 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/dashboard_import.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\" ng-cloak>\n  <div ng-if=\"ctrl.step === 1\">\n\n    <form class=page-action-bar>\n      <div class=page-action-bar__spacer></div>\n      <dash-upload on-upload=ctrl.onUpload(dash)></dash-upload>\n    </form>\n\n    <h5 class=section-heading>Grafana.com Dashboard</h5>\n\n    <div class=gf-form-group>\n      <div class=\"gf-form gf-form--grow\">\n        <input type=text class=\"gf-form-input max-width-30\" ng-model=ctrl.gnetUrl placeholder=\"Paste Grafana.com dashboard url or id\" ng-blur=ctrl.checkGnetDashboard()>\n      </div>\n      <div class=gf-form ng-if=ctrl.gnetError>\n        <label class=\"gf-form-label text-warning\">\n          <i class=\"fa fa-warning\"></i>\n          {{ctrl.gnetError}}\n        </label>\n      </div>\n    </div>\n\n    <h5 class=section-heading>Or paste JSON</h5>\n\n    <div class=gf-form-group>\n      <div class=gf-form>\n        <textarea rows=10 data-share-panel-url=\"\" class=gf-form-input ng-model=ctrl.jsonText></textarea>\n      </div>\n      <button type=button class=\"btn btn-secondary\" ng-click=ctrl.loadJsonText()>\n        <i class=\"fa fa-paste\"></i>\n        Load\n      </button>\n      <span ng-if=ctrl.parseError class=\"text-error p-l-1\">\n        <i class=\"fa fa-warning\"></i>\n        {{ctrl.parseError}}\n      </span>\n    </div>\n  </div>\n\n  <div ng-if=\"ctrl.step === 2\">\n    <div class=gf-form-group ng-if=ctrl.dash.gnetId>\n      <h3 class=section-heading>\n        Importing Dashboard from\n        <a href=https://grafana.com/dashboards/{{ctrl.dash.gnetId}} class=external-link target=_blank>Grafana.com</a>\n      </h3>\n\n      <div class=gf-form>\n        <label class=\"gf-form-label width-15\">Published by</label>\n        <label class=\"gf-form-label width-15\">{{ctrl.gnetInfo.orgName}}</label>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-15\">Updated on</label>\n        <label class=\"gf-form-label width-15\">{{ctrl.gnetInfo.updatedAt | date : 'yyyy-MM-dd HH:mm:ss'}}</label>\n      </div>\n    </div>\n\n    <h3 class=section-heading>\n      Options\n    </h3>\n\n    <div class=gf-form-group>\n      <div class=gf-form-inline>\n        <div class=\"gf-form gf-form--grow\">\n          <label class=\"gf-form-label width-15\">Name</label>\n          <input type=text class=gf-form-input ng-model=ctrl.dash.title give-focus=true ng-change=ctrl.titleChanged() ng-class=\"{'validation-error': ctrl.nameExists || !ctrl.dash.title}\">\n          <label class=\"gf-form-label text-success\" ng-if=\"ctrl.titleTouched && !ctrl.hasNameValidationError\">\n            <i class=\"fa fa-check\"></i>\n          </label>\n        </div>\n      </div>\n\n      <div class=gf-form-inline ng-if=ctrl.hasNameValidationError>\n        <div class=\"gf-form offset-width-15 gf-form--grow\">\n          <label class=\"gf-form-label text-warning gf-form-label--grow\">\n            <i class=\"fa fa-warning\"></i>\n            {{ctrl.nameValidationError}}\n          </label>\n        </div>\n      </div>\n\n      <div ng-repeat=\"input in ctrl.inputs\">\n        <div class=gf-form>\n          <label class=\"gf-form-label width-15\">\n            {{input.label}}\n            <info-popover mode=right-normal>\n              {{input.info}}\n            </info-popover>\n          </label>\n          <!-- Data source input -->\n          <div class=gf-form-select-wrapper style=width:100% ng-if=\"input.type === 'datasource'\">\n            <select class=gf-form-input ng-model=input.value ng-options=\"v.value as v.text for v in input.options\" ng-change=ctrl.inputValueChanged()>\n              <option value=\"\" ng-hide=input.value>{{input.info}}</option>\n            </select>\n          </div>\n          <!-- Constant input -->\n          <input ng-if=\"input.type === 'constant'\" type=text class=gf-form-input ng-model=input.value placeholder={{input.default}} ng-change=ctrl.inputValueChanged()>\n          <label class=\"gf-form-label text-success\" ng-show=input.value>\n            <i class=\"fa fa-check\"></i>\n          </label>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button type=button class=\"btn btn-success width-12\" ng-click=ctrl.saveDashboard() ng-hide=ctrl.nameExists ng-disabled=!ctrl.inputsValid>\n        <i class=\"fa fa-save\"></i> Import\n      </button>\n      <button type=button class=\"btn btn-danger width-12\" ng-click=ctrl.saveDashboard() ng-show=ctrl.nameExists ng-disabled=!ctrl.inputsValid>\n        <i class=\"fa fa-save\"></i> Import (Overwrite)\n      </button>\n      <a class=\"btn btn-link\" ng-click=ctrl.back()>Cancel</a>\n    </div>\n\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 805 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/dashboard_list.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <manage-dashboards/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 806 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/folder_dashboards.html';
var html = "<page-header ng-if=ctrl.navModel model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n    <manage-dashboards ng-if=\"ctrl.folderId && ctrl.uid\" folder-id=ctrl.folderId folder-uid=ctrl.uid />\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/folder_permissions.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <dashboard-permissions ng-if=\"ctrl.dashboard && ctrl.meta\" dashboardid=ctrl.dashboard.id />\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 808 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/folder_settings.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<h2 class=page-sub-heading>Folder Settings</h2>\n\n\t<div class=\"section gf-form-group\">\n\t\t<form name=folderSettingsForm ng-submit=ctrl.save()>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-7\">Name</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-30\" ng-model=ctrl.title ng-change=ctrl.titleChanged()>\n\t\t\t</div>\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-disabled=\"!ctrl.canSave || !ctrl.hasChanged\">\n\t\t\t\t\t<i class=\"fa fa-save\"></i>Save\n\t\t\t\t</button>\n\t\t\t\t<button class=\"btn btn-danger\" ng-click=ctrl.delete($event) ng-disabled=!ctrl.canSave>\n\t\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t\t\tDelete\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 809 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/inspector.html';
var html = "<div class=modal-body ng-controller=InspectCtrl ng-init=init()>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-info-circle\"></i>\n\t\t\t<span class=p-l-1>Inspector</span>\n\t\t</h2>\n\n\t\t<ul class=gf-tabs>\n\t\t\t<li class=gf-tabs-item ng-repeat=\"tab in ['Panel Description', 'Request', 'Response', 'JS Error']\">\n\t\t\t\t<a class=gf-tabs-link ng-click=\"editor.index = $index\" ng-class=\"{active: editor.index === $index}\">\n\t\t\t\t\t{{::tab}}\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content>\n\t\t<div ng-if=\"editor.index == 0\" ng-bind-html=panelInfoHtml>\n\t\t</div>\n\n\t\t<div ng-if=\"editor.index == 1\">\n\t\t\t<h5 class=section-heading>Request details</h5>\n\t\t\t<table class=\"filter-table gf-form-group\">\n\t\t\t\t<tr>\n\t\t\t\t\t<td>Url</td>\n\t\t\t\t\t<td>{{inspector.error.config.url}}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<td>Method</td>\n\t\t\t\t\t<td>{{inspector.error.config.method}}</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"(key, value) in inspector.error.config.headers\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{key}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{value}}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\n\t\t\t<h5 class=section-heading>Request parameters</h5>\n\t\t\t<table class=filter-table>\n\t\t\t\t<tr ng-repeat=\"param in request_parameters\">\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{param.key}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t{{param.value}}\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\n\t\t<div ng-if=\"editor.index == 2\">\n\t\t\t<h5 ng-show=message>{{message}}</h5>\n \t\t\t<pre class=small>\n{{response}}\n\t\t\t</pre>\n\t\t</div>\n\n\t\t<div ng-if=\"editor.index == 3\">\n\n\t\t\t<label>Message:</label>\n<pre>\n{{message}}\n</pre>\n\n\t\t\t<label>Stack trace:</label>\n<pre>\n{{stack_trace}}\n</pre>\n\n\t\t</div>\n\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 810 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/row_options.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-copy\"></i>\n\t\t\t<span class=p-l-1>Row Options</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=ctrl.dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<form name=ctrl.saveForm ng-submit=ctrl.save() class=\"modal-content text-center\" novalidate>\n\t\t<div class=section>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-7\">Title</span>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-13\" ng-model=ctrl.row.title>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-7\">Repeat for</span>\n\t\t\t\t<dash-repeat-option panel=ctrl.row></dash-repeat-option>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=ctrl.update()>Update</button>\n\t\t\t\t<button type=button class=\"btn btn-inverse\" ng-click=ctrl.dismiss()>Cancel</button>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 811 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/partials/shareModal.html';
var html = "<div class=modal-body ng-controller=ShareModalCtrl ng-init=init()>\n\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-share-square-o\"></i>\n\t\t\t<span class=p-l-1>{{modalTitle}}</span>\n\t\t</h2>\n\n\t\t<ul class=gf-tabs>\n\t\t\t<li class=gf-tabs-item ng-repeat=\"tab in tabs\">\n\t\t\t\t<a class=gf-tabs-link ng-click=\"editor.index = $index\" ng-class=\"{active: editor.index === $index}\">\n\t\t\t\t\t{{::tab.title}}\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content ng-repeat=\"tab in tabs\" ng-if=\"editor.index == $index\">\n\t\t<div ng-include src=tab.src class=share-modal-body></div>\n\t</div>\n\n</div>\n\n<script type=text/ng-template id=shareEmbed.html>\n\t<div class=\"share-modal-header\">\n\t\t<div class=\"share-modal-big-icon\">\n\t\t\t<i class=\"fa fa-code\"></i>\n\t\t</div>\n\t\t<div class=\"share-modal-content\">\n\t\t\t<p class=\"share-modal-info-text\">\n\t\t\t\tThe html code below can be pasted and included in another web page. Unless anonymous access\n\t\t\t\tis enabled the user viewing that page need to be signed into grafana for the graph to load.\n\t\t\t</p>\n\n\t\t\t<div ng-include src=\"'shareLinkOptions.html'\"></div>\n\n\t\t\t<div class=\"gf-form-group gf-form--grow\">\n\t\t\t\t<div class=\"gf-form\">\n\t\t\t\t\t<textarea rows=\"5\" data-share-panel-url class=\"gf-form-input\" ng-model='iframeHtml'></textarea>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</script>\n\n<script type=text/ng-template id=shareExport.html>\n\t<dash-export-modal dismiss=\"dismiss()\"></dash-export-modal>\n</script>\n\n<script type=text/ng-template id=shareLinkOptions.html>\n\t<div class=\"gf-form-group\">\n\t\t<gf-form-switch class=\"gf-form\"\n\t\t\tlabel=\"Current time range\" label-class=\"width-12\" switch-class=\"max-width-6\"\n\t\t\tchecked=\"options.forCurrent\" on-change=\"buildUrl()\">\n\t\t</gf-form-switch>\n\t\t<gf-form-switch class=\"gf-form\"\n\t\t\tlabel=\"Template variables\" label-class=\"width-12\" switch-class=\"max-width-6\"\n\t\t\tchecked=\"options.includeTemplateVars\" on-change=\"buildUrl()\">\n\t\t</gf-form-switch>\n\t\t<div class=\"gf-form\">\n\t\t\t<span class=\"gf-form-label width-12\">Theme</span>\n\t\t\t<div class=\"gf-form-select-wrapper width-10\">\n\t\t\t\t<select class=\"gf-form-input\" ng-model=\"options.theme\" ng-options=\"f as f for f in ['current', 'dark', 'light']\" ng-change=\"buildUrl()\"></select>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</script>\n\n<script type=text/ng-template id=shareLink.html>\n\t<div class=\"share-modal-header\">\n\t\t<div class=\"share-modal-big-icon\">\n\t\t\t<i class=\"fa fa-link\"></i>\n\t\t</div>\n\t\t<div class=\"share-modal-content\">\n\t\t\t<p class=\"share-modal-info-text\">\n\t\t\t\tCreate a direct link to this dashboard or panel, customized with the options below.\n\t\t\t</p>\n\t\t\t<div ng-include src=\"'shareLinkOptions.html'\"></div>\n\t\t\t<div>\n\t\t\t\t<div class=\"gf-form-group\">\n\t\t\t\t\t<div class=\"gf-form-inline\">\n\t\t\t\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t\t\t\t<input type=\"text\" data-share-panel-url class=\"gf-form-input\" ng-model=\"shareUrl\"></input>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"gf-form\">\n\t\t\t\t\t\t\t<button class=\"btn btn-inverse\" clipboard-button=\"getShareUrl()\"><i class=\"fa fa-clipboard\"></i> Copy</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form\" ng-show=\"modeSharePanel\">\n\t\t\t\t<a href=\"{{imageUrl}}\" target=\"_blank\"><i class=\"fa fa-camera\"></i> Direct link rendered image</a>\n\t\t\t</div>\n\t\t</div>\n</script>\n\n<script type=text/ng-template id=shareSnapshot.html>\n\t<div class=\"ng-cloak\" ng-cloak ng-controller=\"ShareSnapshotCtrl\" ng-init=\"init()\">\n\t\t<div class=\"share-modal-header\">\n\t\t\t<div class=\"share-modal-big-icon\">\n\t\t\t\t<i ng-if=\"loading\" class=\"fa fa-spinner fa-spin\"></i>\n\t\t\t\t<i ng-if=\"!loading\" class=\"icon-gf icon-gf-snapshot\"></i>\n\t\t\t</div>\n      <div class=\"share-modal-content\">\n        <div ng-if=\"step === 1\">\n          <p class=\"share-modal-info-text\">\n            A snapshot is a way to securely share your dashboard with Percona. When created, we strip sensitive data\n            like queries (metrics, template variables, and annotations) along with panel links. The shared dashboard\n            will only be available for viewing by Percona Engineers, and the content on the dashboard will assist Percona Engineers in troubleshooting your case.\n          </p>\n          <p class=\"share-modal-info-text\">\n            You can safely leave the defaults set as they are, but for further information:\n          </p>\n          <p class=\"share-modal-info-text\">\n          <ul>\n            <li>\n              <strong>Snapshot Name:</strong> The name Percona will see when viewing your dashboard.\n            </li>\n            <li>\n              <strong>Expire:</strong> How long before snapshot should expire, configure lower if required. Percona\n              automatically purges\n              shared dashboards after 90 days.\n            </li>\n            <li>\n              <strong>Timeout (seconds):</strong> Duration the dashboard will take to load before the snapshot is\n              generated.\n            </li>\n          </ul>\n\n          </p>\n          <p class=\"share-modal-info-text\">\n            <strong>What to do next:</strong>\n            After clicking Share with Percona, wait for the dashboard to be generated, and you will be provided a\n            unique URL that then needs to be communicated to Percona via your ticket.\n          </p>\n        </div>\n\n\t\t\t\t<div class=\"share-modal-header\" ng-if=\"step === 3\">\n\t\t\t\t\t<p class=\"share-modal-info-text\">\n\t\t\t\t\t\tThe snapshot has now been deleted. If it you have already accessed it once, It might take up to an hour before it is removed from\n\t\t\t\t\t\tbrowser caches or CDN caches.\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"gf-form-group share-modal-options\">\n\t\t\t\t\t<div class=\"gf-form\" ng-if=\"step === 1\">\n\t\t\t\t\t\t<span class=\"gf-form-label width-12\">Snapshot name</span>\n\t\t\t\t\t\t<input type=\"text\" ng-model=\"snapshot.name\" class=\"gf-form-input max-width-15\" >\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"gf-form\" ng-if=\"step === 1\">\n\t\t\t\t\t\t<span class=\"gf-form-label width-12\">Expire</span>\n\t\t\t\t\t\t<div class=\"gf-form-select-wrapper max-width-15\">\n\t\t\t\t\t\t\t<select class=\"gf-form-input\" ng-model=\"snapshot.expires\" ng-options=\"f.value as f.text for f in expireOptions\"></select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n          <div class=\"gf-form\" ng-if=\"step === 1\">\n            <span class=\"gf-form-label width-12\">Timeout (seconds)</span>\n            <input type=\"number\" ng-model=\"snapshot.timeoutSeconds\" class=\"gf-form-input max-width-15\" >\n          </div>\n\t\t\t\t\t<div class=\"gf-form\" ng-if=\"step === 2\" style=\"margin-top: 40px\">\n\t\t\t\t\t\t<div class=\"gf-form-row\">\n\t\t\t\t\t\t\t<a href=\"{{snapshotUrl}}\" class=\"large share-modal-link\" target=\"_blank\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-external-link-square\"></i>\n\t\t\t\t\t\t\t\t{{snapshotUrl}}\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t<button class=\"btn btn-inverse\" clipboard-button=\"getSnapshotUrl()\"><i class=\"fa fa-clipboard\"></i> Copy Link</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if=\"step === 1\" class=\"gf-form-button-row gf-form-button-row-custom\">\n\t\t\t\t\t<button class=\"btn gf-form-btn width-10 btn-success\" ng-click=\"createSnapshot()\" ng-disabled=\"loading\">\n\t\t\t\t\t\t<i class=\"fa fa-save\"></i>\n\t\t\t\t\t\tLocal Snapshot\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn gf-form-btn width-16 btn-secondary\" ng-if=\"externalEnabled\" ng-click=\"createSnapshot(true)\" ng-disabled=\"loading\">\n\t\t\t\t\t\t<i class=\"fa fa-cloud-upload\"></i>\n\t\t\t\t\t\t{{sharingButtonText}}\n\t\t\t\t\t</button>\n\t\t\t\t\t<a class=\"btn btn-link\" ng-click=\"dismiss()\">Cancel</a>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"pull-right\" ng-if=\"step === 2\" style=\"padding: 5px\">\n\t\t\t\t\tDid you make a mistake? <a class=\"pointer\" ng-click=\"deleteSnapshot()\" target=\"_blank\">delete snapshot.</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>\n</script>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 812 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/settings/settings.html';
var html = "<aside class=dashboard-settings__aside>\n\t<h2 class=dashboard-settings__aside-header>\n\t\t<i class=\"fa fa-cog\"></i>\n\t\tSettings\n\t</h2>\n\n\t<a href={{::section.url}} class=dashboard-settings__nav-item ng-class=\"{active: ctrl.viewId === section.id}\" ng-repeat=\"section in ctrl.sections\">\n    <i class={{::section.icon}}></i>\n\t\t{{::section.title}}\n\t</a>\n\n\t<div class=dashboard-settings__aside-actions>\n    <button class=\"btn btn-success\" ng-click=ctrl.saveDashboard() ng-show=ctrl.canSave>\n\t\t\t<i class=\"fa fa-save\"></i> Save\n\t\t</button>\n\t\t<button class=\"btn btn-inverse\" ng-click=ctrl.openSaveAsModal() ng-show=ctrl.canSaveAs>\n\t\t\t<i class=\"fa fa-copy\"></i>\n\t\t\tSave As...\n\t\t</button>\n\t\t<button class=\"btn btn-danger\" ng-click=ctrl.deleteDashboard() ng-show=ctrl.canDelete>\n\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\tDelete\n\t\t</button>\n\t</div>\n</aside>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === 'settings'\">\n\t<h3 class=dashboard-settings__header>\n\t\tGeneral\n\t</h3>\n\n\t<div class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-7\">Name</label>\n\t\t\t<input type=text class=\"gf-form-input width-30\" ng-model=ctrl.dashboard.title>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-7\">Description</label>\n\t\t\t<input type=text class=\"gf-form-input width-30\" ng-model=ctrl.dashboard.description>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-7\">\n\t\t\t\tTags\n\t\t\t\t<info-popover mode=right-normal>Press enter to add a tag</info-popover>\n\t\t\t</label>\n\t\t\t<bootstrap-tagsinput ng-model=ctrl.dashboard.tags tagclass=\"label label-tag\" placeholder=\"add tags\">\n\t\t\t</bootstrap-tagsinput>\n\t\t</div>\n\t\t<folder-picker initial-title=ctrl.dashboard.meta.folderTitle initial-folder-id=ctrl.dashboard.meta.folderId on-change=ctrl.onFolderChange($folder) enable-create-new=true is-valid-selection=true label-class=width-7>\n\t\t</folder-picker>\n\t\t<gf-form-switch class=gf-form label=Editable tooltip=\"Uncheck, then save and reload to disable all dashboard editing\" checked=ctrl.dashboard.editable label-class=width-7>\n\t\t</gf-form-switch>\n\t</div>\n\n\t<gf-time-picker-settings dashboard=ctrl.dashboard></gf-time-picker-settings>\n\n\t<h5 class=section-heading>Panel Options</h5>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label width-11\">\n\t\t\tGraph Tooltip\n\t\t\t<info-popover mode=right-normal>\n\t\t\t\tCycle between options using Shortcut: CTRL+O or CMD+O\n\t\t\t</info-popover>\n\t\t</label>\n\t\t<div class=gf-form-select-wrapper>\n\t\t\t<select ng-model=ctrl.dashboard.graphTooltip class=gf-form-input ng-options=\"f.value as f.text for f in [{value: 0, text: 'Default'}, {value: 1, text: 'Shared crosshair'},{value: 2, text: 'Shared Tooltip'}]\"></select>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === 'annotations'\" ng-include=\"'public/app/features/annotations/partials/editor.html'\">\n</div>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === 'templating'\" ng-include=\"'public/app/features/templating/partials/editor.html'\">\n</div>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === 'links'\">\n\t<dash-links-editor dashboard=ctrl.dashboard></dash-links-editor>\n</div>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === 'versions'\">\n\t<gf-dashboard-history dashboard=dashboard></gf-dashboard-history>\n</div>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === 'view_json'\">\n\t<h3 class=dashboard-settings__header>View JSON</h3>\n\n\t<div class=gf-form>\n\t\t<code-editor content=ctrl.json data-mode=json data-max-lines=30></code-editor>\n\t</div>\n</div>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === 'permissions'\">\n  <dashboard-permissions ng-if=\"ctrl.dashboard && !ctrl.hasUnsavedFolderChange\" dashboardid=ctrl.dashboard.id backendsrv=ctrl.backendSrv folder=ctrl.getFolder() />\n  <div ng-if=ctrl.hasUnsavedFolderChange>\n    <h5>You have changed folder, please save to view permissions.</h5>\n  </div>\n</div>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === '404'\">\n  <h3 class=dashboard-settings__header>Settings view not found</h3>\n\n  <div>\n    <h5>The settings page could not be found or you do not have permission to access it</h5>\n  </div>\n</div>\n\n<div class=dashboard-settings__content ng-if=\"ctrl.viewId === 'make_editable'\">\n  <h3 class=dashboard-settings__header>Make Editable</h3>\n\n  <button class=\"btn btn-success\" ng-click=ctrl.makeEditable()>\n    Make Editable\n  </button>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 813 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/submenu/submenu.html';
var html = "<div class=submenu-controls>\n  <div ng-repeat=\"variable in ctrl.variables\" ng-hide=\"variable.hide === 2\" class=\"submenu-item gf-form-inline\">\n    <div class=gf-form>\n      <label class=\"gf-form-label template-variable\" ng-hide=\"variable.hide === 1\">\n        {{variable.label || variable.name}}\n      </label>\n      <value-select-dropdown ng-if=\"variable.type !== 'adhoc'\" variable=variable on-updated=ctrl.variableUpdated(variable)></value-select-dropdown>\n    </div>\n    <ad-hoc-filters ng-if=\"variable.type === 'adhoc'\" variable=variable></ad-hoc-filters>\n  </div>\n\n  <div ng-if=\"ctrl.dashboard.annotations.list.length > 0\">\n    <div ng-repeat=\"annotation in ctrl.dashboard.annotations.list\" ng-hide=annotation.hide class=submenu-item ng-class=\"{'annotation-disabled': !annotation.enable}\">\n\t\t\t<gf-form-switch class=gf-form label={{annotation.name}} checked=annotation.enable on-change=ctrl.annotationStateChanged()></gf-form-switch>\n    </div>\n  </div>\n\n  <div class=\"gf-form gf-form--grow\">\n  </div>\n\n  <div ng-if=\"ctrl.dashboard.links.length > 0\">\n    <dash-links-container links=ctrl.dashboard.links class=gf-form-inline></dash-links-container>\n  </div>\n\n  <div class=clearfix></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 814 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/timepicker/settings.html';
var html = "<div class=editor-row>\n\t<h5 class=section-heading>Time Options</h5>\n\n  <div class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-10\">Timezone</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select ng-model=ctrl.dashboard.timezone class=gf-form-input ng-options=\"f.value as f.text for f in [{value: '', text: 'Default'}, {value: 'browser', text: 'Local browser time'},{value: 'utc', text: 'UTC'}]\" ng-change=timezoneChanged()></select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Auto-refresh</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-25\" ng-model=ctrl.panel.refresh_intervals array-join>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Now delay now-</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-25\" ng-model=ctrl.panel.nowDelay placeholder=0m valid-time-span bs-tooltip=\"'Enter 1m to ignore the last minute (because it can contain incomplete metrics)'\" data-placement=right>\n\t\t</div>\n\n\t\t<gf-form-switch class=gf-form label=\"Hide time picker\" checked=ctrl.panel.hidden label-class=width-10></gf-form-switch>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 815 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashboard/timepicker/timepicker.html';
var html = "<div class=\"navbar-buttons navbar-buttons--zoom\">\n\t<button class=\"btn navbar-button navbar-button--tight\" ng-click=ctrl.move(-1)>\n\t\t<i class=\"fa fa-chevron-left\"></i>\n\t</button>\n\n\t<button class=\"btn navbar-button\" bs-tooltip=\"'Time range zoom out <br> CTRL+Z'\" data-placement=bottom ng-click=ctrl.zoom(2)>\n\t\t<i class=\"fa fa-search-minus\"></i>\n\t</button>\n\n\t<button class=\"btn navbar-button navbar-button--tight\" ng-click=ctrl.move(1)>\n\t\t<i class=\"fa fa-chevron-right\"></i>\n\t</button>\n</div>\n\n<div class=navbar-buttons>\n\t<button bs-tooltip=ctrl.tooltip data-placement=bottom ng-click=ctrl.openDropdown() class=\"btn navbar-button gf-timepicker-nav-btn\">\n\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t<span ng-bind=ctrl.rangeString></span>\n\t\t<span ng-show=ctrl.isUtc class=gf-timepicker-utc>UTC</span>\n\t\t<span ng-show=ctrl.dashboard.refresh class=text-warning>&nbsp; Refresh every {{ctrl.dashboard.refresh}}</span>\n\t</button>\n\n\t<button class=\"btn navbar-button navbar-button--refresh\" ng-click=ctrl.timeSrv.refreshDashboard()>\n\t\t<i class=\"fa fa-refresh\"></i>\n\t</button>\n</div>\n\n<div ng-if=ctrl.isOpen class=gf-timepicker-dropdown>\n  <form name=timeForm class=gf-timepicker-absolute-section>\n    <h3 class=section-heading>Custom range</h3>\n\n    <label class=small>From:</label>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-28\">\n        <input type=text class=\"gf-form-input input-large\" ng-model=ctrl.editTimeRaw.from input-datetime>\n      </div>\n      <div class=gf-form>\n        <button class=\"btn gf-form-btn btn-primary\" type=button ng-click=\"openFromPicker=!openFromPicker\">\n          <i class=\"fa fa-calendar\"></i>\n        </button>\n      </div>\n    </div>\n\n    <div ng-if=openFromPicker>\n      <datepicker ng-model=ctrl.absolute.fromJs class=gf-timepicker-component show-weeks=false starting-day=ctrl.firstDayOfWeek ng-change=ctrl.absoluteFromChanged()></datepicker>\n    </div>\n\n\n    <label class=small>To:</label>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-28\">\n        <input type=text class=\"gf-form-input input-large\" ng-model=ctrl.editTimeRaw.to input-datetime>\n      </div>\n      <div class=gf-form>\n        <button class=\"btn gf-form-btn btn-primary\" type=button ng-click=\"openToPicker=!openToPicker\">\n          <i class=\"fa fa-calendar\"></i>\n        </button>\n      </div>\n    </div>\n\n    <div ng-if=openToPicker>\n      <datepicker ng-model=ctrl.absolute.toJs class=gf-timepicker-component show-weeks=false starting-day=ctrl.firstDayOfWeek ng-change=ctrl.absoluteToChanged()></datepicker>\n    </div>\n\n    <label class=small>Refreshing every:</label>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-28\">\n        <select ng-model=ctrl.refresh.value class=\"gf-form-input input-medium\" ng-options=\"f.value as f.text for f in ctrl.refresh.options\"></select>\n      </div>\n      <div class=gf-form>\n        <button type=submit class=\"btn gf-form-btn btn-secondary\" ng-click=ctrl.applyCustom(); ng-disabled=!timeForm.$valid>Apply</button>\n      </div>\n    </div>\n  </form>\n\n  <div class=gf-timepicker-relative-section>\n    <h3 class=section-heading>Quick ranges</h3>\n    <ul ng-repeat=\"group in ctrl.timeOptions\">\n      <li bindonce ng-repeat=\"option in group\" ng-class=\"{active: option.active}\">\n        <a ng-click=ctrl.setRelativeFilter(option) bo-text=option.display></a>\n      </li>\n    </ul>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 816 */
/***/ (function(module, exports) {

var path = 'public/app/features/dashlinks/editor.html';
var html = "<h3 class=dashboard-settings__header>\n  <a ng-click=ctrl.backToList()>Dashboard Links</a>\n  <span ng-show=\"ctrl.mode === 'new'\">&gt; New</span>\n  <span ng-show=\"ctrl.mode === 'edit'\">&gt; Edit</span>\n</h3>\n\n<div ng-if=\"ctrl.mode == 'list'\">\n  <div ng-if=\"ctrl.dashboard.links.length === 0\">\n    <div class=empty-list-cta>\n      <div class=empty-list-cta__title>\n        There are no dashboard links added yet\n      </div>\n      <a ng-click=ctrl.setupNew() class=\"empty-list-cta__button btn btn-xlarge btn-success\">\n        <i class=\"gicon gicon-add-link\"></i>\n        Add Dashboard Link\n      </a>\n      <div class=grafana-info-box>\n        <h5>What are Dashboard Links?</h5>\n        <p>\n\t\t\t\t\tDashboard Links allow you to place links to other dashboards and web sites directly in below the dashboard header.\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"ctrl.dashboard.links.length > 0\">\n    <div class=page-action-bar>\n      <div class=page-action-bar__spacer></div>\n      <a type=button class=\"btn btn-success\" ng-click=ctrl.setupNew()>\n        <i class=\"fa fa-plus\"></i> New</a>\n    </div>\n    <table class=\"filter-table filter-table--hover\">\n      <thead>\n        <tr>\n          <th>Type</th>\n          <th>Info</th>\n          <th colspan=3></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"link in ctrl.dashboard.links\">\n          <td class=pointer ng-click=ctrl.editLink(link)>\n            <i class=\"fa fa-fw fa-external-link\"></i>\n            {{link.type}}\n          </td>\n          <td>\n            <div ng-if=link.title>\n              {{link.title}}\n            </div>\n            <div ng-if=\"!link.title && link.url\">\n              {{link.url}}\n            </div>\n            <span ng-if=\"!link.title && link.tags\" ng-repeat=\"tag in link.tags\" tag-color-from-name=tag class=\"label label-tag\" style=margin-right:6px>\n              {{tag}}\n            </span>\n          </td>\n          <td style=width:1%>\n            <i ng-click=\"ctrl.moveLink($index, -1)\" ng-hide=$first class=\"pointer fa fa-arrow-up\"></i>\n          </td>\n          <td style=width:1%>\n            <i ng-click=\"ctrl.moveLink($index, 1)\" ng-hide=$last class=\"pointer fa fa-arrow-down\"></i>\n          </td>\n          <td style=width:1%>\n            <a ng-click=ctrl.deleteLink($index) class=\"btn btn-danger btn-mini\" ng-hide=annotation.builtIn>\n              <i class=\"fa fa-remove\"></i>\n            </a>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n<div ng-if=\"ctrl.mode == 'edit' || ctrl.mode == 'new'\">\n  <div class=gf-form-group>\n    <div class=gf-form-group>\n      <div class=gf-form>\n        <span class=\"gf-form-label width-8\">Type</span>\n        <div class=\"gf-form-select-wrapper width-10\">\n          <select class=gf-form-input ng-model=ctrl.link.type ng-options=\"f for f in ['dashboards','link']\"></select>\n        </div>\n      </div>\n\n      <div class=gf-form ng-show=\"ctrl.link.type === 'dashboards'\">\n        <span class=\"gf-form-label width-8\">With tags</span>\n        <bootstrap-tagsinput ng-model=ctrl.link.tags tagclass=\"label label-tag\" placeholder=\"add tags\" style=margin-right:.25rem></bootstrap-tagsinput>\n      </div>\n\n      <gf-form-switch ng-show=\"ctrl.link.type === 'dashboards'\" class=gf-form label=\"As dropdown\" checked=ctrl.link.asDropdown switch-class=max-width-4 label-class=width-8></gf-form-switch>\n      <div class=gf-form ng-show=\"ctrl.link.type === 'dashboards' && ctrl.link.asDropdown\">\n        <span class=\"gf-form-label width-8\">Title</span>\n        <input type=text ng-model=ctrl.link.title class=\"gf-form-input max-width-10\" ng-model-onblur>\n      </div>\n      <div ng-show=\"ctrl.link.type === 'link'\">\n        <div class=gf-form>\n          <li class=\"gf-form-label width-8\">Url</li>\n          <input type=text ng-model=ctrl.link.url class=\"gf-form-input width-20\" ng-model-onblur>\n        </div>\n\n        <div class=gf-form>\n          <span class=\"gf-form-label width-8\">Title</span>\n          <input type=text ng-model=ctrl.link.title class=\"gf-form-input width-20\" ng-model-onblur>\n        </div>\n\n        <div class=gf-form>\n          <span class=\"gf-form-label width-8\">Tooltip</span>\n          <input type=text ng-model=ctrl.link.tooltip class=\"gf-form-input width-20\" placeholder=\"Open dashboard\" ng-model-onblur>\n        </div>\n\n        <div class=gf-form>\n          <span class=\"gf-form-label width-8\">Icon</span>\n          <div class=\"gf-form-select-wrapper width-20\">\n            <select class=gf-form-input ng-model=ctrl.link.icon ng-options=\"k as k for (k, v) in ctrl.iconMap\"></select>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form-group>\n      <h5 class=section-heading>Include</h5>\n      <div>\n        <gf-form-switch class=gf-form label=\"Time range\" checked=ctrl.link.keepTime switch-class=max-width-6 label-class=width-9></gf-form-switch>\n        <gf-form-switch class=gf-form label=\"Variable values\" checked=ctrl.link.includeVars switch-class=max-width-6 label-class=width-9></gf-form-switch>\n        <gf-form-switch class=gf-form label=\"Open in new tab\" checked=ctrl.link.targetBlank switch-class=max-width-6 label-class=width-9></gf-form-switch>\n      </div>\n    </div>\n  </div>\n  <button class=\"btn btn-success\" ng-if=\"ctrl.mode == 'new'\" ng-click=ctrl.addLink()>\n    Add\n  </button>\n  <button class=\"btn btn-success\" ng-if=\"ctrl.mode == 'edit'\" ng-click=ctrl.saveLink()>\n    Update\n  </button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 817 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/apikeyModal.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-key\"></i>\n\t\t\t<span class=p-l-1>API Key Created</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content>\n\n\t\t<div class=gf-form-group>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=gf-form-label>Key</span>\n\t\t\t\t<span class=gf-form-label>{{key}}</span>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=grafana-info-box style=border:0>\n\t\t\tYou will only be able to view this key here once! It is not stored in this form. So be sure to copy it now.\n\t\t\t<br>\n\t\t\t<br>\n\t\t\tYou can authenticate request using the Authorization HTTP header, example:\n\t\t\t<br>\n\t\t\t<br>\n\t\t\t<pre class=small>\ncurl -H \"Authorization: Bearer {{key}}\" {{rootPath}}/api/dashboards/home\n\t\t\t</pre>\n\t\t</div>\n\n\t</div>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 818 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/change_password.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<h2 class=page-sub-heading>\n\t\tChange your password\n\t</h2>\n\n\t<div ng-if=\"ldapEnabled || authProxyEnabled\">\n\t\tYou cannot change password when ldap or auth proxy authentication is enabled.\n\t</div>\n\n\t<form name=userForm class=gf-form-group ng-hide=\"ldapEnabled || authProxyEnabled\">\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Old Password</span>\n\t\t\t<input class=\"gf-form-input max-width-21\" type=password required ng-model=command.oldPassword>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">New Password</span>\n\t\t\t<input class=\"gf-form-input max-width-21\" type=password required ng-minlength=4 ng-model=command.newPassword>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Confirm Password</span>\n\t\t\t<input class=\"gf-form-input max-width-21\" type=password required ng-minlength=4 ng-model=command.confirmNew>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=changePassword()>Change Password</button>\n\t\t\t<a class=btn-text href=profile>Cancel</a>\n\t\t</div>\n\t</form>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 819 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/create_team.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\" ng-cloak>\n\t<h3 class=page-sub-heading>New Team</h3>\n\n\t<form name=ctrl.saveForm class=gf-form-group ng-submit=ctrl.create()>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-10\">Name</span>\n\t\t\t<input type=text required ng-model=ctrl.name class=\"gf-form-input max-width-22\" give-focus=true>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-10\">\n\t\t\t\tEmail\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\tThis is optional and is primarily used for allowing custom team avatars.\n\t\t\t\t</info-popover>\n\t\t\t</span>\n\t\t\t<input class=\"gf-form-input max-width-22\" type=email ng-model=ctrl.email placeholder=email@test.com>\n\t\t</div>\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success width-12\">\n\t\t\t\t<i class=\"fa fa-save\"></i> Create\n\t\t\t</button>\n\t\t</div>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 820 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/invite.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\" ng-cloak>\n\n\t<h2 class=page-sub-heading>Invite User</h2>\n\n\t<div class=p-b-2>\n\t\tSend invite or add existing Grafana user to the organization\n\t\t<span class=highlight-word>{{contextSrv.user.orgName}}</span>\n\t</div>\n\n\t<form name=ctrl.inviteForm>\n\t\t<div class=gf-form-group>\n\t\t\t<div class=\"gf-form max-width-30\">\n\t\t\t\t<span class=\"gf-form-label width-10\">Email or Username</span>\n\t\t\t\t<input type=text ng-model=ctrl.invite.loginOrEmail required class=gf-form-input placeholder=email@test.com>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form max-width-30\">\n\t\t\t\t<span class=\"gf-form-label width-10\">Name</span>\n\t\t\t\t<input type=text ng-model=ctrl.invite.name class=gf-form-input placeholder=\"name (optional)\">\n\t\t\t</div>\n\t\t\t<div class=\"gf-form max-width-30\">\n        <span class=\"gf-form-label width-10\">Role</span>\n\t\t\t\t<select ng-model=ctrl.invite.role class=gf-form-input ng-options=\"f for f in ['Viewer', 'Editor', 'Admin']\">\n\t\t\t\t</select>\n\t\t\t</div>\n\n\t\t\t<gf-form-switch class=gf-form label=\"Send invite email\" checked=ctrl.invite.sendEmail label-class=width-10></gf-form-switch>\n\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=ctrl.sendInvite();>Invite</button>\n\t\t\t\t<a class=\"btn btn-inverse\" href=org/users>Back</a>\n\t\t\t</div>\n\t</div></form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 821 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/newOrg.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\" ng-form=playlistEditForm>\n\t<h2 class=page-sub-heading>\n\t\tNew Organization\n\t</h2>\n\n\t<p class=playlist-description>Each organization contains their own dashboards, data sources and configuration, and cannot be shared between orgs. While users may belong to more than one, multiple organization are most frequently used in multi-tenant deployments. </p>\n\n\t<form>\n\t\t<div class=gf-form-group>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Org. name</span>\n\t\t\t\t<input type=text ng-model=newOrg.name required class=\"gf-form-input max-width-21\" placeholder=\"organization name\">\n\t\t\t</div>\n\t\t\t<br>\n\t\t\t<div class=gf-form-buttons-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=createOrg()>Create</button>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 822 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/orgApiKeys.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n\t<h3 class=page-heading>Add new</h3>\n\n\t<form name=addTokenForm class=gf-form-group>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=\"gf-form max-width-21\">\n\t\t\t\t<span class=gf-form-label>Key name</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=token.name placeholder=Name>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=gf-form-label>Role</span>\n        <span class=gf-form-select-wrapper>\n            <select class=\"gf-form-input gf-size-auto\" ng-model=token.role ng-options=\"r for r in roleTypes\"></select>\n        </span>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button class=\"btn gf-form-btn btn-success\" ng-click=addToken()>Add</button>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n\n\t<h3 class=page-heading>Existing Keys</h3>\n\t<table class=filter-table>\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th>Role</th>\n\t\t\t\t<th style=width:34px></th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"t in tokens\">\n\t\t\t\t<td>{{t.name}}</td>\n\t\t\t\t<td>{{t.role}}</td>\n\t\t\t\t<td>\n\t\t\t\t\t<a ng-click=removeToken(t.id) class=\"btn btn-danger btn-mini\">\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 823 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/orgDetails.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <h3 class=page-sub-heading>Organization profile</h3>\n\n  <form name=orgForm class=gf-form-group>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-28\">\n        <span class=gf-form-label>Organization name</span>\n        <input class=gf-form-input type=text required ng-model=org.name>\n      </div>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button type=submit class=\"btn btn-success\" ng-click=update()>Save</button>\n    </div>\n  </form>\n  <prefs-control mode=org></prefs-control>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 824 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/orgUsers.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <div class=page-action-bar>\n    <label class=\"gf-form gf-form--grow gf-form--has-input-icon\">\n      <input type=text class=\"gf-form-input width-20\" ng-model=ctrl.searchQuery ng-change=ctrl.onQueryUpdated() placeholder=\"Filter by username or email\"/>\n      <i class=\"gf-form-input-icon fa fa-search\"></i>\n    </label>\n\n    <div class=page-action-bar__spacer></div>\n\n    <button class=\"btn btn-inverse\" ng-show=ctrl.pendingInvites.length ng-click=\"ctrl.showInvites = true\">\n      Pending Invites ({{ctrl.pendingInvites.length}})\n    </button>\n\n    <a class=\"btn btn-success\" href=org/users/invite ng-show=ctrl.canInvite>\n      <i class=\"fa fa-plus\"></i>\n      <span>Invite</span>\n    </a>\n\n    <a class=\"btn btn-success\" ng-href={{ctrl.externalUserMngLinkUrl}} target=_blank ng-if=ctrl.externalUserMngLinkUrl>\n      <i class=\"fa fa-external-link-square\"></i>\n      {{ctrl.externalUserMngLinkName}}\n    </a>\n  </div>\n\n  <div class=grafana-info-box ng-if=ctrl.externalUserMngInfo>\n    <span ng-bind-html=ctrl.externalUserMngInfo></span>\n  </div>\n\n  <div ng-hide=ctrl.showInvites>\n    <table class=\"filter-table form-inline\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>Login</th>\n          <th>Email</th>\n          <th>\n            Seen\n            <tip>Time since user was seen using Grafana</tip>\n          </th>\n          <th>Role</th>\n          <th style=width:34px></th>\n        </tr>\n      </thead>\n      <tr ng-repeat=\"user in ctrl.users\">\n        <td class=\"width-4 text-center\">\n          <img class=filter-table__avatar ng-src={{user.avatarUrl}}>\n        </td>\n        <td>{{user.login}}</td>\n        <td><span class=ellipsis>{{user.email}}</span></td>\n        <td>{{user.lastSeenAtAge}}</td>\n        <td>\n          <div class=\"gf-form-select-wrapper width-12\">\n            <select type=text ng-model=user.role class=gf-form-input ng-options=\"f for f in ['Viewer', 'Editor', 'Admin']\" ng-change=ctrl.updateOrgUser(user)>\n            </select>\n          </div>\n        </td>\n        <td>\n          <a ng-click=ctrl.removeUser(user) class=\"btn btn-danger btn-mini\">\n            <i class=\"fa fa-remove\"></i>\n          </a>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div ng-if=ctrl.showInvites>\n    <table class=\"filter-table form-inline\">\n      <thead>\n        <tr>\n          <th>Email</th>\n          <th>Name</th>\n          <th></th>\n          <th style=width:34px></th>\n        </tr>\n      </thead>\n      <tr ng-repeat=\"invite in ctrl.pendingInvites\">\n        <td>{{invite.email}}</td>\n        <td>{{invite.name}}</td>\n        <td class=text-right>\n          <button class=\"btn btn-inverse btn-mini\" clipboard-button=ctrl.getInviteUrl(invite) ng-click=ctrl.copyInviteToClipboard($event)>\n            <i class=\"fa fa-clipboard\"></i> Copy Invite\n          </button>\n          &nbsp;\n        </td>\n        <td>\n          <button class=\"btn btn-danger btn-mini\" ng-click=\"ctrl.revokeInvite(invite, $event)\">\n            <i class=\"fa fa-remove\"></i>\n          </button>\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 825 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/profile.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <h3 class=page-sub-heading>User Profile</h3>\n\n\t<form name=ctrl.userForm class=gf-form-group>\n\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-8\">Name</span>\n\t\t\t<input class=\"gf-form-input max-width-22\" type=text required ng-model=ctrl.user.name>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-8\">Email</span>\n\t\t\t<input class=\"gf-form-input max-width-22\" type=email ng-readonly=ctrl.readonlyLoginFields required ng-model=ctrl.user.email>\n      <i ng-if=ctrl.readonlyLoginFields class=\"fa fa-lock gf-form-icon--right-absolute\" bs-tooltip=\"'Login Details Locked - managed in another system.'\"></i>\n    </div>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-8\">Username</span>\n      <input class=\"gf-form-input max-width-22\" type=text ng-readonly=ctrl.readonlyLoginFields required ng-model=ctrl.user.login>\n      <i ng-if=ctrl.readonlyLoginFields class=\"fa fa-lock gf-form-icon--right-absolute\" bs-tooltip=\"'Login Details Locked - managed in another system.'\"></i>\n    </div>\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=ctrl.update()>Save</button>\n\t\t</div>\n\t</form>\n\n\t<prefs-control mode=user></prefs-control>\n\n\t<h3 class=page-heading ng-show=ctrl.showOrgsList>Organizations</h3>\n  <div class=gf-form-group ng-show=ctrl.showOrgsList>\n\t\t<table class=\"filter-table form-inline\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Name</th>\n\t\t\t\t\t<th>Role</th>\n\t\t\t\t\t<th></th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"org in ctrl.orgs\">\n\t\t\t\t\t<td>{{org.name}}</td>\n\t\t\t\t\t<td>{{org.role}}</td>\n\t\t\t\t\t<td class=text-right>\n\t\t\t\t\t\t<span class=\"btn btn-primary btn-mini\" ng-show=\"org.orgId === contextSrv.user.orgId\">\n\t\t\t\t\t\t\tCurrent\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<a ng-click=ctrl.setUsingOrg(org) class=\"btn btn-inverse btn-mini\" ng-show=\"org.orgId !== contextSrv.user.orgId\">\n\t\t\t\t\t\t\tSelect\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 826 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/select_org.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n\t<div class=signup>\n\t\t<div class=login-form>\n\n\t\t\t<div class=modal-tagline>\n\t\t\t\tYou have been added to another Organization due to an open invitation!\n\n\t\t\t\tPlease select which organization you want to <br>\n\t\t\t\tuse right now (you can change this later at any time).\n\t\t\t</div>\n\n\t\t\t<div style=\"display:inline-block;width:400px;margin:30px 0\">\n\t\t\t\t<div ng-repeat=\"org in orgs\">\n\t\t\t\t\t<a ng-click=setUsingOrg(org) class=\"btn btn-success\">\n\t\t\t\t\t\t{{org.name}} ({{org.role}})\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 827 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/team_details.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<h3 class=page-sub-heading>Team Details</h3>\n\n  <form name=teamDetailsForm class=gf-form-group>\n    <div class=\"gf-form max-width-30\">\n      <span class=\"gf-form-label width-10\">Name</span>\n      <input type=text required ng-model=ctrl.team.name class=\"gf-form-input max-width-22\">\n\t\t</div>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-10\">\n\t\t\t\tEmail\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t\tThis is optional and is primarily used for allowing custom team avatars.\n\t\t\t\t</info-popover>\n\t\t\t</span>\n\t\t\t<input class=\"gf-form-input max-width-22\" type=email ng-model=ctrl.team.email placeholder=email@test.com>\n\t\t</div>\n\n    <div class=gf-form-button-row>\n      <button type=submit class=\"btn btn-success\" ng-click=ctrl.update()>Update</button>\n    </div>\n  </form>\n\n  <div class=gf-form-group>\n\n    <h3 class=page-heading>Team Members</h3>\n\t\t<form name=ctrl.addMemberForm class=gf-form-group>\n      <div class=gf-form>\n        <span class=\"gf-form-label width-10\">Add member</span>\n\t\t\t\t<!--\n\t\t\t\tOld picker\n\t\t\t\t<user-picker user-picked=\"ctrl.userPicked($user)\"></user-picker>\n\t\t\t\t-->\n\t\t\t\t<select-user-picker class=width-7 handlepicked=ctrl.userPicked backendsrv=ctrl.backendSrv></select-user-picker>\n      </div>\n    </form>\n\n    <table class=filter-table ng-show=\"ctrl.teamMembers.length > 0\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th></th>\n\t\t\t\t\t<th>Username</th>\n\t\t\t\t\t<th>Email</th>\n\t\t\t\t\t<th></th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tr ng-repeat=\"member in ctrl.teamMembers\">\n\t\t\t\t<td class=\"width-4 text-center link-td\">\n\t\t\t\t\t<img class=filter-table__avatar ng-src={{member.avatarUrl}}>\n\t\t\t\t</td>\n\t\t\t\t<td>{{member.login}}</td>\n\t\t\t\t<td>{{member.email}}</td>\n\t\t\t\t<td style=width:1%>\n\t\t\t\t\t<a ng-click=ctrl.removeTeamMember(member) class=\"btn btn-danger btn-mini\">\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</table>\n\t\t<div>\n\t\t\t<em class=muted ng-hide=\"ctrl.teamMembers.length > 0\">\n\t\t\t\tThis team has no members yet.\n\t\t\t</em>\n\t\t</div>\n\n</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 828 */
/***/ (function(module, exports) {

var path = 'public/app/features/org/partials/teams.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<div class=page-action-bar>\n    <label class=\"gf-form gf-form--grow gf-form--has-input-icon\">\n      <input type=text class=\"gf-form-input max-width-20\" placeholder=\"Find Team by name\" tabindex=1 ng-model=ctrl.query ng-model-options=\"{ debounce: 500 }\" spellcheck=false ng-change=ctrl.get() />\n      <i class=\"gf-form-input-icon fa fa-search\"></i>\n    </label>\n    <div class=page-action-bar__spacer></div>\n\n    <a class=\"btn btn-success\" href=org/teams/new>\n      <i class=\"fa fa-plus\"></i>\n\t\t\tAdd Team\n    </a>\n  </div>\n\n  <div class=admin-list-table>\n    <table class=\"filter-table filter-table--hover form-inline\" ng-show=\"ctrl.teams.length > 0\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>Name</th>\n          <th>Email</th>\n          <th>Members</th>\n          <th style=width:1%></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"team in ctrl.teams\">\n          <td class=\"width-4 text-center link-td\">\n            <a href=org/teams/edit/{{team.id}}>\n              <img class=filter-table__avatar ng-src={{team.avatarUrl}}>\n            </a>\n          </td>\n          <td class=link-td>\n            <a href=org/teams/edit/{{team.id}}>{{team.name}}</a>\n          </td>\n          <td class=link-td>\n              <a href=org/teams/edit/{{team.id}}>{{team.email}}</a>\n            </td>\n          <td class=link-td>\n            <a href=org/teams/edit/{{team.id}}>{{team.memberCount}}</a>\n          </td>\n          <td class=text-right>\n            <a ng-click=ctrl.deleteTeam(team) class=\"btn btn-danger btn-small\">\n              <i class=\"fa fa-remove\"></i>\n            </a>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n\n  <div class=admin-list-paging ng-if=ctrl.showPaging>\n    <ol>\n      <li ng-repeat=\"page in ctrl.pages\">\n        <button class=\"btn btn-small\" ng-class=\"{'btn-secondary': page.current, 'btn-inverse': !page.current}\" ng-click=ctrl.navigateToPage(page)>{{page.page}}</button>\n      </li>\n    </ol>\n  </div>\n\n  <em class=muted ng-hide=\"ctrl.teams.length > 0\">\n    No Teams found.\n  </em>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 829 */
/***/ (function(module, exports) {

var path = 'public/app/features/panel/partials/metrics_tab.html';
var html = "<div class=gf-form-group>\n  <div class=gf-form-inline>\n    <div class=gf-form>\n\t\t\t<label class=\"gf-form-label gf-query-ds-label\">\n\t\t\t\t<i class=\"icon-gf icon-gf-datasources\"></i>\n\t\t\t</label>\n      <label class=gf-form-label>Data Source</label>\n\n      <gf-form-dropdown model=ctrl.panelDsValue css-class=gf-size-auto lookup-text=true get-options=ctrl.getOptions(true) on-change=ctrl.datasourceChanged($option)>\n      </gf-form-dropdown>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<label class=\"gf-form-label gf-form-label--grow\"></label>\n\t\t</div>\n\t\t<div class=gf-form ng-if=ctrl.queryOptions>\n\t\t\t<a class=gf-form-label ng-click=ctrl.toggleOptions()>\n\t\t\t\t<i class=\"fa fa-fw fa-caret-right\" ng-hide=ctrl.optionsOpen></i><i class=\"fa fa-fw fa-caret-down\" ng-show=ctrl.optionsOpen></i>Options\n\t\t\t</a>\n\t\t</div>\n\t\t<div class=gf-form ng-if=ctrl.hasQueryHelp>\n\t\t\t<button class=gf-form-label ng-click=ctrl.toggleHelp()>\n\t\t\t\t<i class=\"fa fa-fw fa-caret-right\" ng-hide=ctrl.helpOpen></i><i class=\"fa fa-fw fa-caret-down\" ng-show=ctrl.helpOpen></i>Help\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<button class=gf-form-label ng-click=ctrl.toggleQueryTroubleshooter() bs-tooltip=\"'Display query request & response'\">\n\t\t\t\t<i class=\"fa fa-fw fa-caret-right\" ng-hide=ctrl.queryTroubleshooterOpen></i><i class=\"fa fa-fw fa-caret-down\" ng-show=ctrl.queryTroubleshooterOpen></i>Query Inspector\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\n\t<div>\n\t\t<div ng-if=ctrl.optionsOpen>\n\t\t\t<div class=\"gf-form gf-form--flex-end\" ng-if=ctrl.queryOptions.minInterval>\n\t\t\t\t<label class=gf-form-label>Min time interval</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-6\" placeholder={{ctrl.panelCtrl.interval}} ng-model=ctrl.panel.interval spellcheck=false ng-model-onblur ng-change=ctrl.panelCtrl.refresh() />\n\t\t\t\t<info-popover mode=right-absolute>\n\t\t\t\t\tA lower limit for the auto group by time interval. Recommended to be set to write frequency,\n\t\t\t\t\tfor example <code>1m</code> if your data is written every minute. Access auto interval via variable <code>$__interval</code> for time range\n\t\t\t\t\tstring and <code>$__interval_ms</code> for numeric variable that can be used in math expressions.\n\t\t\t\t</info-popover>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form gf-form--flex-end\" ng-if=ctrl.queryOptions.cacheTimeout>\n\t\t\t\t<label class=\"gf-form-label width-9\">Cache timeout</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-6\" placeholder=60 ng-model=ctrl.panel.cacheTimeout ng-model-onblur ng-change=ctrl.panelCtrl.refresh() spellcheck=false />\n\t\t\t\t<info-popover mode=right-absolute>\n\t\t\t\t\tIf your time series store has a query cache this option can override the default\n\t\t\t\t\tcache timeout. Specify a numeric value in seconds.\n\t\t\t\t</info-popover>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form gf-form--flex-end\" ng-if=ctrl.queryOptions.maxDataPoints>\n\t\t\t\t<label class=\"gf-form-label width-9\">Max data points</label>\n\t\t\t\t<input type=text class=\"gf-form-input width-6\" placeholder=auto ng-model-onblur ng-change=ctrl.panelCtrl.refresh() ng-model=ctrl.panel.maxDataPoints spellcheck=false />\n\t\t\t\t<info-popover mode=right-absolute>\n\t\t\t\t\tThe maximum data points the query should return. For graphs this\n\t\t\t\t\tis automatically set to one data point per pixel.\n\t\t\t\t</info-popover>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=grafana-info-box ng-if=ctrl.helpOpen>\n\t\t\t<div class=markdown-html ng-bind-html=ctrl.helpHtml></div>\n\t\t\t<a class=grafana-info-box__close ng-click=ctrl.toggleHelp()>\n\t\t\t\t<i class=\"fa fa-chevron-up\"></i>\n\t\t\t</a>\n\t\t</div>\n\n\t\t<query-troubleshooter panel-ctrl=ctrl.panelCtrl is-open=ctrl.queryTroubleshooterOpen></query-troubleshooter>\n\t</div>\n</div>\n\n<div class=\"query-editor-rows gf-form-group\" ng-if=ctrl.datasourceInstance>\n\t<div ng-repeat=\"target in ctrl.panel.targets\" ng-class=\"{'gf-form-disabled': target.hide}\">\n\t\t<rebuild-on-change property=\"ctrl.panel.datasource || target.datasource\" show-null=true>\n\t\t\t<plugin-component type=query-ctrl>\n\t\t\t</plugin-component>\n\t\t</rebuild-on-change>\n\t</div>\n\n\t<div class=gf-form-query>\n\t\t<div class=\"gf-form gf-form-query-letter-cell\">\n\t\t\t<label class=gf-form-label>\n\t\t\t\t<span class=gf-form-query-letter-cell-carret>\n\t\t\t\t\t<i class=\"fa fa-caret-down\"></i>\n\t\t\t\t</span>\n\t\t\t\t<span class=gf-form-query-letter-cell-letter>{{ctrl.panelCtrl.nextRefId}}</span>\n\t\t\t</label>\n\t\t\t<button class=\"btn btn-secondary gf-form-btn\" ng-click=ctrl.addQuery() ng-hide=ctrl.datasourceInstance.meta.mixed>\n\t\t\t\tAdd Query\n\t\t\t</button>\n\t\t\t<div class=dropdown ng-if=ctrl.datasourceInstance.meta.mixed>\n\t\t\t\t<gf-form-dropdown model=ctrl.addQueryDropdown get-options=ctrl.getOptions(false) on-change=ctrl.addMixedQuery($option)>\n\t\t\t\t</gf-form-dropdown>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 830 */
/***/ (function(module, exports) {

var path = 'public/app/features/panel/partials/panelTime.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<span class=gf-form-label>\n\t\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t</span>\n\n\t\t<span class=\"gf-form-label width-12\">Override relative time</span>\n\t\t<span class=\"gf-form-label width-6\">Last</span>\n\n\t\t<input type=text class=\"gf-form-input max-width-8\" placeholder=1h empty-to-null ng-model=ctrl.panel.timeFrom valid-time-span ng-change=ctrl.refresh() ng-model-onblur>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<span class=gf-form-label>\n\t\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t</span>\n\t\t<span class=\"gf-form-label width-12\">Add time shift</span>\n\t\t<span class=\"gf-form-label width-6\">Amount</span>\n\t\t<input type=text class=\"gf-form-input max-width-8\" placeholder=1h empty-to-null ng-model=ctrl.panel.timeShift valid-time-span ng-change=ctrl.refresh() ng-model-onblur>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>\n\t\t\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t\t</span>\n\t\t</div>\n\t\t<gf-form-switch class=\"gf-form max-width-30\" label=\"Hide time override info\" label-class=width-12 checked=ctrl.panel.hideTimeOverride switch-class=max-width-6 on-change=ctrl.refresh()>\n\t\t</gf-form-switch>\n\t</div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 831 */
/***/ (function(module, exports) {

var path = 'public/app/features/panel/partials/query_editor_row.html';
var html = "\n<div class=gf-form-query>\n\t<div class=\"gf-form gf-form-query-letter-cell\">\n    <label class=gf-form-label>\n      <a class=pointer tabindex=1 ng-click=ctrl.toggleCollapse()>\n        <span ng-class=\"{muted: !ctrl.canCollapse}\" class=gf-form-query-letter-cell-carret>\n          <i class=\"fa fa-caret-down\" ng-hide=ctrl.collapsed></i>\n          <i class=\"fa fa-caret-right\" ng-show=ctrl.collapsed></i>\n        </span>\n        <span class=gf-form-query-letter-cell-letter>{{ctrl.target.refId}}</span>\n        <em class=gf-form-query-letter-cell-ds ng-show=ctrl.target.datasource>({{ctrl.target.datasource}})</em>\n      </a>\n\t\t</label>\n  </div>\n\n\t<div class=\"gf-form-query-content gf-form-query-content--collapsed\" ng-if=ctrl.collapsed>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label pointer gf-form-label--grow\" ng-click=ctrl.toggleCollapse()>\n\t\t\t\t{{ctrl.collapsedText}}\n\t\t\t</label>\n\t\t</div>\n\t</div>\n\n\t<div ng-transclude class=gf-form-query-content ng-if=!ctrl.collapsed>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label dropdown\">\n\t\t\t<a class=\"pointer dropdown-toggle\" data-toggle=dropdown tabindex=1>\n\t\t\t\t<i class=\"fa fa-bars\"></i>\n\t\t\t</a>\n\t\t\t<ul class=\"dropdown-menu pull-right\" role=menu>\n\t\t\t\t<li role=menuitem ng-if=ctrl.hasTextEditMode>\n\t\t\t\t\t<a tabindex=1 ng-click=ctrl.toggleEditorMode()>Toggle Edit Mode</a>\n\t\t\t\t</li>\n\t\t\t\t<li role=menuitem>\n\t\t\t\t\t<a tabindex=1 ng-click=ctrl.duplicateQuery()>Duplicate</a>\n\t\t\t\t</li>\n\t\t\t\t<li role=menuitem>\n\t\t\t\t\t<a tabindex=1 ng-click=ctrl.moveQuery(-1)>Move up</a>\n\t\t\t\t</li>\n\t\t\t\t<li role=menuitem>\n\t\t\t\t\t<a tabindex=1 ng-click=ctrl.moveQuery(1)>Move down</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</label>\n    <label class=gf-form-label>\n\t\t\t<a ng-click=ctrl.toggleHideQuery() role=menuitem>\n\t\t\t\t<i class=\"fa fa-eye\"></i>\n\t\t\t</a>\n\t\t</label>\n\t\t<label class=gf-form-label>\n\t\t\t<a class=pointer tabindex=1 ng-click=ctrl.removeQuery(ctrl.target)>\n\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t</a>\n\t\t</label>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 832 */
/***/ (function(module, exports) {

var path = 'public/app/features/panel/partials/soloPanel.html';
var html = "<div class=\"panel panel--solo\" ng-if=panel style=width:100%>\n\t<plugin-component type=panel>\n\t</plugin-component>\n</div>\n<div class=clearfix></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 833 */
/***/ (function(module, exports) {

var path = 'public/app/features/panellinks/module.html';
var html = "<div class=editor-row>\n\t<h5 class=section-heading>\n\t\tDrilldown / detail link<tip>These links appear in the dropdown menu in the panel menu. </tip></h5>\n\t\n\n\t<div class=gf-form-group ng-repeat=\"link in panel.links\">\n\t\t<div class=section>\n\t\t\t<div class=\"gf-form max-width-25\">\n\t\t\t\t<span class=\"gf-form-label width-7\">Type</span>\n\t\t\t\t<div class=\"gf-form-select-wrapper gf-form--grow\">\n\t\t\t\t\t<select class=gf-form-input ng-model=link.type ng-options=\"f for f in ['dashboard','absolute']\"></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form max-width-25\">\n\t\t\t\t<span class=\"gf-form-label width-7\" ng-show=\"link.type === 'dashboard'\">Dashboard</span>\n\t\t\t\t<input ng-show=\"link.type === 'dashboard'\" type=text ng-model=link.dashboard bs-typeahead=searchDashboards class=gf-form-input ng-blur=dashboardChanged(link)>\n\n\t\t\t\t<span class=\"gf-form-label width-7\" ng-show=\"link.type === 'absolute'\">Url</span>\n\t\t\t\t<input ng-show=\"link.type === 'absolute'\" type=text ng-model=link.url class=\"gf-form-input max-width-14\">\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form max-width-25\">\n\t\t\t\t<div class=\"gf-form-label width-7\">Title</div>\n\t\t\t\t<input type=text ng-model=link.title class=gf-form-input>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class=section>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-10\">Url params</span>\n\t\t\t\t<input type=text ng-model=link.params class=\"gf-form-input width-10\">\n\t\t\t</div>\n\n\t\t\t<gf-form-switch class=gf-form label-class=width-10 label=\"Include time range\" checked=link.keepTime></gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form label-class=width-10 label=\"Include variables\" checked=link.includeVars></gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form label-class=width-10 label=\"Open in new tab \" checked=link.targetBlank></gf-form-switch>\n\t\t</div>\n\n\t\t<div class=section>\n\t\t\t<div class=gf-form>\n\t\t\t\t<button class=\"btn btn-inverse gf-form-btn\" ng-click=deleteLink(link)><i class=\"fa fa-trash\"></i> Remove Link</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=editor-row>\n\t<button class=\"btn btn-inverse\" ng-click=addLink()><i class=\"fa fa-plus\"></i> Add link</button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 834 */
/***/ (function(module, exports) {

var path = 'public/app/features/playlist/partials/playlist.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\" ng-form=playlistEditForm>\n\n  <h3 class=page-sub-heading ng-hide=ctrl.isNew>Edit Playlist</h3>\n  <h3 class=page-sub-heading ng-show=ctrl.isNew>New Playlist</h3>\n\n\t<p class=playlist-description>A playlist rotates through a pre-selected list of Dashboards. A Playlist can be a great way to build situational awareness, or just show off your metrics to your team or visitors.</p>\n\n\t<div class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Name</span>\n\t\t\t<input type=text required ng-model=ctrl.playlist.name class=\"gf-form-input max-width-21\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Interval</span>\n\t\t\t<input type=text required ng-model=ctrl.playlist.interval placeholder=5m class=\"gf-form-input max-width-21\">\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-group>\n\t\t<h3 class=page-headering>Dashboards</h3>\n\t</div>\n\n\t<div class=row>\n\t\t<div class=col-lg-6>\n\t\t\t<div class=playlist-search-containerwrapper>\n\t\t\t\t<div class=max-width-32>\n\t\t\t\t\t<h5 class=\"page-headering playlist-column-header\">Available</h5>\n\t\t\t\t\t<div style=\"\">\n\t\t\t\t\t\t<playlist-search class=playlist-search-container search-started=ctrl.searchStarted(promise)></playlist-search>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div ng-if=\"ctrl.filteredDashboards.length > 0\">\n\t\t\t\t<table class=\"filter-table playlist-available-list\">\n\t\t\t\t\t<tr ng-repeat=\"playlistItem in ctrl.filteredDashboards\">\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<i class=\"icon-gf icon-gf-dashboard\"></i>\n\t\t\t\t\t\t\t&nbsp;&nbsp;{{playlistItem.title}}\n\t\t\t\t\t\t\t<i class=\"fa fa-star\" ng-show=playlistItem.isStarred></i>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td class=add-dashboard>\n\t\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini pull-right\" ng-click=ctrl.addPlaylistItem(playlistItem)>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\t\t\tAdd to playlist\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t\t<div class=playlist-search-results-container ng-if=\"ctrl.filteredTags.length > 0;\">\n\t\t\t\t<table class=\"filter-table playlist-available-list\">\n\t\t\t\t\t<tr ng-repeat=\"tag in ctrl.filteredTags\">\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<a class=\"search-result-tag label label-tag\" tag-color-from-name=tag.term>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-tag\"></i>\n\t\t\t\t\t\t\t\t<span>{{tag.term}} &nbsp;({{tag.count}})</span>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td class=add-dashboard>\n\t\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini pull-right\" ng-click=ctrl.addTagPlaylistItem(tag)>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\t\t\tAdd to playlist\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=col-lg-6>\n\t\t\t<h5 class=\"page headering playlist-column-header\">Selected</h5>\n\t\t\t<table class=\"filter-table playlist-available-list\">\n\t\t\t\t<tr ng-repeat=\"playlistItem in ctrl.playlistItems\">\n\t\t\t\t\t<td ng-if=\"playlistItem.type === 'dashboard_by_id'\">\n\t\t\t\t\t\t<i class=\"icon-gf icon-gf-dashboard\"></i>&nbsp;&nbsp;{{playlistItem.title}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td ng-if=\"playlistItem.type === 'dashboard_by_tag'\">\n\t\t\t\t\t\t<a class=\"search-result-tag label label-tag\" tag-color-from-name=playlistItem.title>\n\t\t\t\t\t\t\t<i class=\"fa fa-tag\"></i>\n\t\t\t\t\t\t\t<span>{{playlistItem.title}}</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\n\t\t\t\t\t<td class=selected-playlistitem-settings>\n\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini\" ng-hide=$first ng-click=ctrl.movePlaylistItemUp(playlistItem)>\n\t\t\t\t\t\t\t<i class=\"fa fa-arrow-up\"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini\" ng-hide=$last ng-click=ctrl.movePlaylistItemDown(playlistItem)>\n\t\t\t\t\t\t\t<i class=\"fa fa-arrow-down\"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-inverse btn-mini\" ng-click=ctrl.removePlaylistItem(playlistItem)>\n\t\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n\n\t<div class=clearfix></div>\n\n\t<div class=gf-form-button-row>\n\t\t<a class=\"btn btn-success\" ng-show=ctrl.isNew ng-disabled=\"ctrl.playlistEditForm.$invalid || ctrl.isPlaylistEmpty()\" ng-click=\"ctrl.savePlaylist(ctrl.playlist, ctrl.playlistItems)\">Create new playlist</a>\n\t\t<a class=\"btn btn-success\" ng-show=!ctrl.isNew() ng-disabled=\"ctrl.playlistEditForm.$invalid || ctrl.isPlaylistEmpty()\" ng-click=\"ctrl.savePlaylist(ctrl.playlist, ctrl.playlistItems)\">Save</a>\n\t\t<a class=btn-text ng-click=ctrl.backToList()>Cancel</a>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 835 */
/***/ (function(module, exports) {

var path = 'public/app/features/playlist/partials/playlist_search.html';
var html = "<div class=playlist-search-field-wrapper>\n  <span style=position:relative>\n    <input type=text placeholder=\"Find dashboards by name\" tabindex=1 ng-keydown=ctrl.keyDown($event) ng-model=ctrl.query.query ng-model-options=\"{ debounce: 500 }\" spellcheck=false ng-change=ctrl.searchDashboards() />\n\t\t<div class=playlist-search-switches>\n\t\t\t<i class=\"fa fa-filter\"></i>\n\t\t\t<a class=pointer href=\"javascript:void 0;\" ng-click=ctrl.showStarred() tabindex=2>\n\t\t\t\t<i class=\"fa fa-remove\" ng-show=ctrl.query.starred></i>\n\t\t\t\tstarred\n\t\t\t</a> |\n\t\t\t<a class=pointer href=\"javascript:void 0;\" ng-click=ctrl.getTags() tabindex=3>\n\t\t\t\t<i class=\"fa fa-remove\" ng-show=ctrl.tagsMode></i>\n\t\t\t\ttags\n\t\t\t</a>\n\t\t\t<span ng-if=ctrl.query.tag.length>\n\t\t\t\t|\n\t\t\t\t<span ng-repeat=\"tagName in ctrl.query.tag\">\n\t\t\t\t\t<a ng-click=\"ctrl.removeTag(tagName, $event)\" tag-color-from-name=ctrl.tagName class=\"label label-tag\">\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t{{tagName}}\n\t\t\t\t\t</a>\n\t\t\t\t</span>\n\t\t\t</span>\n\t\t</div>\n\t</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 836 */
/***/ (function(module, exports) {

var path = 'public/app/features/playlist/partials/playlists.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <div class=page-action-bar>\n    <div class=page-action-bar__spacer></div>\n    <a class=\"btn btn-success pull-right\" href=playlists/create>\n      <i class=\"fa fa-plus\"></i>\n      New Playlist\n    </a>\n  </div>\n\n  <table class=filter-table>\n    <thead>\n      <th><strong>Name</strong></th>\n      <th><strong>Start url</strong></th>\n      <th style=width:78px></th>\n      <th style=width:78px></th>\n      <th style=width:25px></th>\n    </thead>\n    <tr ng-repeat=\"playlist in ctrl.playlists\">\n      <td>\n\t\t\t\t<a href=playlists/edit/{{playlist.id}}>{{playlist.name}}</a>\n      </td>\n      <td>\n\t\t\t\t<a href=playlists/play/{{playlist.id}}>playlists/play/{{playlist.id}}</a>\n      </td>\n      <td class=text-center>\n        <a href=playlists/play/{{playlist.id}} class=\"btn btn-inverse btn-small\">\n          <i class=\"fa fa-play\"></i>\n          Play\n        </a>\n      </td>\n      <td class=text-right>\n        <a href=playlists/edit/{{playlist.id}} class=\"btn btn-inverse btn-small\">\n          <i class=\"fa fa-edit\"></i>\n          Edit\n        </a>\n      </td>\n      <td class=text-right>\n        <a ng-click=ctrl.removePlaylist(playlist) class=\"btn btn-danger btn-small\">\n          <i class=\"fa fa-remove\"></i>\n        </a>\n      </td>\n    </tr>\n  </table>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 837 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/import_list/import_list.html';
var html = "<div class=gf-form-group ng-if=ctrl.dashboards.length>\n\t<table class=filter-table>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"dash in ctrl.dashboards\">\n\t\t\t\t<td class=width-1>\n\t\t\t\t\t<i class=\"icon-gf icon-gf-dashboard\"></i>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<a href={{dash.importedUrl}} ng-show=dash.imported>\n\t\t\t\t\t\t{{dash.title}}\n\t\t\t\t\t</a>\n\t\t\t\t\t<span ng-show=!dash.imported>{{dash.title}}</span>\n\t\t\t\t</td>\n\t\t\t\t<td style=text-align:right>\n\t\t\t\t\t<button class=\"btn btn-secondary btn-small\" ng-click=\"ctrl.import(dash, false)\" ng-show=!dash.imported>\n\t\t\t\t\t\tImport\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-secondary btn-small\" ng-click=\"ctrl.import(dash, true)\" ng-show=dash.imported>\n            <span ng-if=\"dash.revision !== dash.importedRevision\">Update</span>\n            <span ng-if=\"dash.revision === dash.importedRevision\">Re-import</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn-danger btn-small\" ng-click=ctrl.remove(dash) ng-show=dash.imported>\n\t\t\t\t\t\t<i class=\"fa fa-trash\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 838 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/ds_dashboards.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\" ng-if=ctrl.datasourceMeta>\n\n\t<dashboard-import-list plugin=ctrl.datasourceMeta datasource=ctrl.current></dashboard-import-list>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 839 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/ds_edit.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n  <div ng-if=ctrl.current.readOnly class=page-action-bar>\n    <div class=\"grafana-info-box span8\">\n      Disclaimer. This datasource was added by config and cannot be modified using the UI. Please contact your server admin to update this datasource.\n    </div>\n  </div>\n\n  <form name=ctrl.editForm ng-if=ctrl.current>\n    <div class=gf-form-group>\n      <div class=gf-form-inline>\n        <div class=\"gf-form max-width-30\">\n          <span class=\"gf-form-label width-7\">Name</span>\n          <input class=\"gf-form-input max-width-23\" type=text ng-model=ctrl.current.name placeholder=name required>\n          <info-popover offset=\"0px -135px\" mode=right-absolute>\n            The name is used when you select the data source in panels.\n            The <em>Default</em> data source is preselected in new\n            panels.\n          </info-popover>\n        </div>\n        <gf-form-switch class=gf-form label=Default checked=ctrl.current.isDefault switch-class=max-width-6></gf-form-switch>\n      </div>\n\n      <div class=gf-form>\n        <span class=\"gf-form-label width-7\">Type</span>\n        <div class=\"gf-form-select-wrapper max-width-23\">\n          <select class=gf-form-input ng-model=ctrl.current.type ng-options=\"v.id as v.name for v in ctrl.types\" ng-change=ctrl.userChangedType()></select>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"alert alert-info gf-form-group\" ng-if=\"ctrl.datasourceMeta.state === 'alpha'\">\n      This plugin is marked as being in alpha state, which means it is in early development phase and\n      updates will include breaking changes.\n    </div>\n\n    <rebuild-on-change property=ctrl.datasourceMeta.id>\n      <plugin-component type=datasource-config-ctrl>\n      </plugin-component>\n    </rebuild-on-change>\n\n    <div ng-if=ctrl.hasDashboards>\n      <h3 class=section-heading>Bundled Plugin Dashboards</h3>\n      <div class=section>\n        <dashboard-import-list plugin=ctrl.datasourceMeta datasource=ctrl.current></dashboard-import-list>\n      </div>\n    </div>\n\n    <div ng-if=ctrl.testing class=\"gf-form-group section\">\n      <h5 ng-show=!ctrl.testing.done>Testing.... <i class=\"fa fa-spiner fa-spin\"></i></h5>\n      <div class=\"alert-{{ctrl.testing.status}} alert\" ng-show=ctrl.testing.done>\n        <div class=alert-icon>\n          <i class=\"fa fa-exclamation-triangle\" ng-show=\"ctrl.testing.status === 'error'\"></i>\n          <i class=\"fa fa-check\" ng-show=\"ctrl.testing.status !== 'error'\"></i>\n        </div>\n        <div class=alert-body>\n          <div class=alert-title>{{ctrl.testing.message}}</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button type=submit class=\"btn btn-success\" ng-disabled=ctrl.current.readOnly ng-click=ctrl.saveChanges()>Save &amp; Test</button>\n      <button type=submit class=\"btn btn-danger\" ng-disabled=ctrl.current.readOnly ng-show=!ctrl.isNew ng-click=ctrl.delete()>\n        Delete\n      </button>\n      <a class=\"btn btn-inverse\" href=datasources>Back</a>\n    </div>\n\n    <br/>\n    <br/>\n    <br/>\n\n  </form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 840 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/ds_http_settings.html';
var html = "<div class=gf-form-group>\n  <h3 class=page-heading>HTTP</h3>\n  <div class=gf-form-group>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-30\">\n        <span class=\"gf-form-label width-7\">URL</span>\n        <input class=gf-form-input type=text ng-model=current.url placeholder={{suggestUrl}} bs-typeahead=getSuggestUrls min-length=0 ng-pattern=\"/^(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?$/\" required>\n        <info-popover mode=right-absolute>\n          <p>Specify a complete HTTP URL (for example http://your_server:8080)</p>\n          <span ng-show=\"current.access === 'direct'\">\n            Your access method is <em>Browser</em>, this means the URL\n            needs to be accessible from the browser.\n          </span>\n          <span ng-show=\"current.access === 'proxy'\">\n            Your access method is <em>Server</em>, this means the URL\n            needs to be accessible from the grafana backend/server.\n          </span>\n        </info-popover>\n      </div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-30\">\n        <span class=\"gf-form-label width-7\">Access</span>\n        <div class=\"gf-form-select-wrapper max-width-24\">\n          <select class=gf-form-input ng-model=current.access ng-options=\"f.key as f.value for f in [{key: 'proxy', value: 'Server (Default)'}, { key: 'direct', value: 'Browser'}]\"></select>\n        </div>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword pointer\" ng-click=\"ctrl.showAccessHelp = !ctrl.showAccessHelp\">\n          Help&nbsp;\n          <i class=\"fa fa-caret-down\" ng-show=ctrl.showAccessHelp></i>\n          <i class=\"fa fa-caret-right\" ng-hide=ctrl.showAccessHelp>&nbsp;</i>\n        </label>\n      </div>\n    </div>\n\n    <div class=\"alert alert-info\" ng-show=ctrl.showAccessHelp>\n      <div class=alert-body>\n        <p>\n          Access mode controls how requests to the data source will be handled.\n          <strong><i>Server</i></strong> should be the preferred way if nothing else stated.\n        </p>\n        <div class=alert-title>Server access mode (Default):</div>\n        <p>\n          All requests will be made from the browser to Grafana backend/server which in turn will forward the requests to the data source\n          and by that circumvent possible Cross-Origin Resource Sharing (CORS) requirements.\n          The URL needs to be accessible from the grafana backend/server if you select this access mode.\n        </p>\n        <div class=alert-title>Browser access mode:</div>\n        <p>\n          All requests will be made from the browser directly to the data source and may be subject to\n          Cross-Origin Resource Sharing (CORS) requirements. The URL needs to be accessible from the browser if you select this\n          access mode.\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <h3 class=page-heading>Auth</h3>\n  <div class=gf-form-group>\n    <div class=gf-form-inline>\n      <gf-form-switch class=gf-form label=\"Basic Auth\" checked=current.basicAuth label-class=width-8 switch-class=max-width-6></gf-form-switch>\n      <gf-form-switch class=gf-form label=\"With Credentials\" tooltip=\"Whether credentials such as cookies or auth headers should be sent with cross-site requests.\" checked=current.withCredentials label-class=width-11 switch-class=max-width-6></gf-form-switch>\n    </div>\n    <div class=gf-form-inline>\n      <gf-form-switch class=gf-form ng-if=\"current.access=='proxy'\" label=\"TLS Client Auth\" label-class=width-8 checked=current.jsonData.tlsAuth switch-class=max-width-6></gf-form-switch>\n      <gf-form-switch class=gf-form ng-if=\"current.access=='proxy'\" label=\"With CA Cert\" tooltip=\"Needed for verifing self-signed TLS Certs\" checked=current.jsonData.tlsAuthWithCACert label-class=width-11 switch-class=max-width-6></gf-form-switch>\n    </div>\n  </div>\n\n  <div class=gf-form-inline>\n    <gf-form-switch class=gf-form ng-if=\"current.access=='proxy'\" label=\"Skip TLS Verification (Insecure)\" label-class=width-16 checked=current.jsonData.tlsSkipVerify switch-class=max-width-6></gf-form-switch>\n  </div>\n</div>\n\n<div class=gf-form-group ng-if=current.basicAuth>\n  <h6>Basic Auth Details</h6>\n  <div class=gf-form ng-if=current.basicAuth>\n    <span class=\"gf-form-label width-7\">\n      User\n    </span>\n    <input class=\"gf-form-input max-width-21\" type=text ng-model=current.basicAuthUser placeholder=user required>\n  </div>\n\n  <div class=gf-form>\n    <span class=\"gf-form-label width-7\">\n      Password\n    </span>\n    <input class=\"gf-form-input max-width-21\" type=password ng-model=current.basicAuthPassword placeholder=password required>\n  </div>\n</div>\n\n<div class=gf-form-group ng-if=\"(current.jsonData.tlsAuth || current.jsonData.tlsAuthWithCACert) && current.access=='proxy'\">\n  <div class=gf-form>\n    <h6>TLS Auth Details</h6>\n    <info-popover mode=header>TLS Certs are encrypted and stored in the Grafana database.</info-popover>\n  </div>\n  <div ng-if=current.jsonData.tlsAuthWithCACert>\n    <div class=gf-form-inline>\n      <div class=\"gf-form gf-form--v-stretch\">\n        <label class=\"gf-form-label width-7\">CA Cert</label>\n      </div>\n      <div class=\"gf-form gf-form--grow\" ng-if=!current.secureJsonFields.tlsCACert>\n        <textarea rows=7 class=\"gf-form-input gf-form-textarea\" ng-model=current.secureJsonData.tlsCACert placeholder=\"Begins with -----BEGIN CERTIFICATE-----\"></textarea>\n      </div>\n\n      <div class=gf-form ng-if=current.secureJsonFields.tlsCACert>\n        <input type=text class=\"gf-form-input max-width-12\" disabled=disabled value=configured>\n        <a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"current.secureJsonFields.tlsCACert = false\">reset</a>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=current.jsonData.tlsAuth>\n    <div class=gf-form-inline>\n      <div class=\"gf-form gf-form--v-stretch\">\n        <label class=\"gf-form-label width-7\">Client Cert</label>\n      </div>\n      <div class=\"gf-form gf-form--grow\" ng-if=!current.secureJsonFields.tlsClientCert>\n        <textarea rows=7 class=\"gf-form-input gf-form-textarea\" ng-model=current.secureJsonData.tlsClientCert placeholder=\"Begins with -----BEGIN CERTIFICATE-----\" required></textarea>\n      </div>\n      <div class=gf-form ng-if=current.secureJsonFields.tlsClientCert>\n        <input type=text class=\"gf-form-input max-width-12\" disabled=disabled value=configured>\n        <a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"current.secureJsonFields.tlsClientCert = false\">reset</a>\n      </div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=\"gf-form gf-form--v-stretch\">\n        <label class=\"gf-form-label width-7\">Client Key</label>\n      </div>\n      <div class=\"gf-form gf-form--grow\" ng-if=!current.secureJsonFields.tlsClientKey>\n        <textarea rows=7 class=\"gf-form-input gf-form-textarea\" ng-model=current.secureJsonData.tlsClientKey placeholder=\"Begins with -----BEGIN RSA PRIVATE KEY-----\" required></textarea>\n      </div>\n      <div class=gf-form ng-if=current.secureJsonFields.tlsClientKey>\n        <input type=text class=\"gf-form-input max-width-12\" disabled=disabled value=configured>\n        <a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"current.secureJsonFields.tlsClientKey = false\">reset</a>\n      </div>\n    </div>\n  </div>\n</div>\n\n<h3 class=page-heading ng-if=\"current.access=='proxy'\">Advanced HTTP Settings</h3>\n<div class=gf-form-group ng-if=\"current.access=='proxy'\">\n  <div class=gf-form-inline>\n    <div class=gf-form>\n      <span class=\"gf-form-label width-10\">Whitelisted Cookies</span>\n      <bootstrap-tagsinput ng-model=current.jsonData.keepCookies tagclass=\"label label-tag\" placeholder=\"Add Name\">\n      </bootstrap-tagsinput>\n      <info-popover mode=right-absolute>\n        Grafana Proxy deletes forwarded cookies by default. Specify cookies by name that should be forwarded to the data source.\n      </info-popover>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 841 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/ds_list.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<div ng-if=ctrl.unfiltered.length>\n\t\t<div class=page-action-bar>\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<label class=gf-form--has-input-icon>\n\t\t\t\t\t<input type=text class=\"gf-form-input width-20\" ng-model=ctrl.searchQuery ng-change=ctrl.onQueryUpdated() placeholder=\"Filter by name or type\"/>\n\t\t\t\t\t<i class=\"gf-form-input-icon fa fa-search\"></i>\n\t\t\t\t</label>\n\t\t\t\t<layout-selector/>\n\t\t\t</div>\n\t\t\t<div class=page-action-bar__spacer></div>\n\t\t\t<a class=\"page-header__cta btn btn-success\" href=datasources/new>\n\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\tAdd data source\n\t\t\t</a>\n\t\t</div>\n\n\t\t<section class=card-section layout-mode>\n\t\t\t<ol class=card-list>\n\t\t\t\t<li class=card-item-wrapper ng-repeat=\"ds in ctrl.datasources\">\n\t\t\t\t\t<a class=card-item href=datasources/edit/{{ds.id}}/ >\n\t\t\t\t\t\t<div class=card-item-header>\n\t\t\t\t\t\t\t<div class=card-item-type>\n\t\t\t\t\t\t\t\t{{ds.type}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=card-item-body>\n\t\t\t\t\t\t\t<figure class=card-item-figure>\n\t\t\t\t\t\t\t\t<img ng-src={{ds.typeLogoUrl}}>\n\t\t\t\t\t\t\t</figure>\n\t\t\t\t\t\t\t<div class=card-item-details>\n\t\t\t\t\t\t\t\t<div class=card-item-name>\n\t\t\t\t\t\t\t\t\t{{ds.name}}\n\t\t\t\t\t\t\t\t\t<span ng-if=ds.isDefault>\n\t\t\t\t\t\t\t\t\t\t<span class=\"btn btn-secondary btn-mini\">default</span>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=card-item-sub-name>\n\t\t\t\t\t\t\t\t\t{{ds.url}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t</ol>\n\t\t</section>\n\t</div>\n\n\t<div ng-if=\"ctrl.unfiltered.length === 0\">\n\t\t<empty-list-cta model=\"{\n\t\t\ttitle: 'There are no data sources defined yet',\n\t\t\tbuttonIcon: 'gicon gicon-add-datasources',\n\t\t\tbuttonLink: 'datasources/new',\n\t\t\tbuttonTitle: 'Add data source',\n\t\t\tproTip: 'You can also define data sources through configuration files.',\n\t\t\tproTipLink: 'http://docs.grafana.org/administration/provisioning/#datasources?utm_source=grafana_ds_list',\n\t\t\tproTipLinkTitle: 'Learn more',\n\t\t\tproTipTarget: '_blank'\n\t\t}\"/>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/plugin_edit.html';
var html = "<div ng-if=ctrl.navModel>\n  <page-header model=ctrl.navModel></page-header>\n\n  <div class=\"page-container page-body\">\n    <div class=sidebar-container>\n      <div class=\"tab-content sidebar-content\" ng-if=\"ctrl.tab === 'readme'\">\n        <div ng-bind-html=ctrl.readmeHtml class=markdown-html>\n        </div>\n      </div>\n\n      <div class=\"tab-content sidebar-content\" ng-if=\"ctrl.tab === 'config'\">\n        <div ng-if=ctrl.model.id>\n          <plugin-component type=app-config-ctrl></plugin-component>\n\n          <div class=gf-form-button-row>\n            <button type=submit class=\"btn btn-success\" ng-click=ctrl.enable() ng-show=!ctrl.model.enabled>Enable</button>\n            <button type=submit class=\"btn btn-success\" ng-click=ctrl.update() ng-show=ctrl.model.enabled>Update</button>\n            <button type=submit class=\"btn btn-danger\" ng-click=ctrl.disable() ng-show=ctrl.model.enabled>Disable</button>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"tab-content sidebar-content\" ng-if=\"ctrl.tab === 'dashboards'\">\n        <dashboard-import-list plugin=ctrl.model></dashboard-import-list>\n      </div>\n\n      <aside class=page-sidebar>\n        <section class=page-sidebar-section>\n          <h4>Version</h4>\n          <span>{{ctrl.model.info.version}}</span>\n          <div ng-show=ctrl.model.hasUpdate>\n            <a ng-click=ctrl.updateAvailable() bs-tooltip=ctrl.model.latestVersion>Update Available!</a>\n          </div>\n        </section>\n        <section class=page-sidebar-section ng-show=\"ctrl.model.type === 'app'\">\n          <h5>Includes\n          <ul class=\"ui-list plugin-info-list\">\n            <li ng-repeat=\"plug in ctrl.includes\" class=plugin-info-list-item>\n              <i class={{plug.icon}}></i>\n              {{plug.name}}\n            </li>\n          </ul>\n        </h5></section>\n        <section class=page-sidebar-section>\n          <h5>Dependencies\n          <ul class=\"ui-list plugin-info-list\">\n            <li class=plugin-info-list-item>\n              <img src=public/img/grafana_icon.svg>\n              Grafana {{ctrl.model.dependencies.grafanaVersion}}\n            </li>\n            <li ng-repeat=\"plugDep in ctrl.model.dependencies.plugins\" class=plugin-info-list-item>\n              <i class={{plugDep.icon}}></i>\n              {{plugDep.name}} {{plugDep.version}}\n            </li>\n          </ul>\n        </h5></section>\n        <section class=page-sidebar-section>\n          <h5>Links\n          <ul class=ui-list>\n            <li ng-repeat=\"link in ctrl.model.info.links\">\n              <a href={{link.url}} class=external-link target=_blank>{{link.name}}</a>\n            </li>\n          </ul>\n        </h5></section>\n      </aside>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 843 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/plugin_list.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <div class=page-action-bar>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<label class=gf-form--has-input-icon>\n\t\t\t\t<input type=text class=\"gf-form-input width-20\" ng-model=ctrl.searchQuery ng-change=ctrl.onQueryUpdated() placeholder=\"Filter by name or type\"/>\n\t\t\t\t<i class=\"gf-form-input-icon fa fa-search\"></i>\n\t\t\t</label>\n\t\t\t<layout-selector/>\n\t\t</div>\n\t\t<div class=page-action-bar__spacer></div>\n\t\t<a class=\"btn btn-success\" href=\"https://grafana.com/plugins?utm_source=grafana_plugin_list\" target=_blank>\n\t\t\tFind more plugins on Grafana.com\n\t\t</a>\n\t</div>\n\n\t<section class=card-section layout-mode>\n\n\t\t<ol class=card-list>\n\t\t\t<li class=card-item-wrapper ng-repeat=\"plugin in ctrl.plugins\">\n\t\t\t\t<a class=card-item href=plugins/{{plugin.id}}/edit>\n\t\t\t\t\t<div class=card-item-header>\n\t\t\t\t\t\t<div class=card-item-type>\n\t\t\t\t\t\t\t<i class=\"icon-gf icon-gf-{{plugin.type}}\"></i>\n\t\t\t\t\t\t\t{{plugin.type}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=card-item-notice ng-show=plugin.hasUpdate>\n\t\t\t\t\t\t\t<span bs-tooltip=plugin.latestVersion>Update available!</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=card-item-body>\n\t\t\t\t\t\t<figure class=card-item-figure>\n\t\t\t\t\t\t\t<img ng-src={{plugin.info.logos.small}}>\n\t\t\t\t\t\t</figure>\n\t\t\t\t\t\t<div class=card-item-details>\n\t\t\t\t\t\t\t<div class=card-item-name>{{plugin.name}}</div>\n\t\t\t\t\t\t\t<div class=card-item-sub-name>By {{plugin.info.author.name}}</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ol>\n\t</section>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 844 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/plugin_page.html';
var html = "<div ng-if=ctrl.navModel>\n  <page-header model=ctrl.navModel></page-header>\n\n  <div class=page-container>\n    <div ng-if=ctrl.page>\n      <plugin-component type=app-page>\n      </plugin-component>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 845 */
/***/ (function(module, exports) {

var path = 'public/app/features/plugins/partials/update_instructions.html';
var html = "<div class=modal-body>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa fa-cloud-download\"></i>\n\t\t\t<span class=p-l-1>Update Plugin</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=modal-content>\n\t\t<div class=gf-form-group>\n\t\t\t<p>Type the following on the command line to update {{plugin.name}}.</p>\n\t\t\t<pre><code>grafana-cli plugins update {{plugin.id}}</code></pre>\n\t\t\t<span class=small>Check out {{plugin.name}} on <a href=https://grafana.com/plugins/{{plugin.id}}>Grafana.com</a> for README and changelog. If you do not have access to the command line, ask your Grafana administator.</span>\n\t\t</div>\n\t\t<p class=pluginlist-none-installed><img class=pluginlist-inline-logo src=public/img/grafana_icon.svg><strong>Pro tip</strong>: To update all plugins at once, type <code class=code--small>grafana-cli plugins update-all</code> on the command line.</p></div>\n\t</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 846 */
/***/ (function(module, exports) {

var path = 'public/app/features/snapshot/partials/snapshots.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n   <table class=filter-table>\n    <thead>\n      <th><strong>Name</strong></th>\n      <th><strong>Snapshot url</strong></th>\n      <th style=width:70px></th>\n      <th style=width:25px></th>\n\t\t</thead>\n\t\t<tr ng-repeat=\"snapshot in ctrl.snapshots\">\n      <td>\n\t\t\t\t<a href=dashboard/snapshot/{{snapshot.key}}>{{snapshot.name}}</a>\n      </td>\n      <td>\n        <a href=dashboard/snapshot/{{snapshot.key}}>dashboard/snapshot/{{snapshot.key}}</a>\n      </td>\n      <td class=text-center>\n        <a href=dashboard/snapshot/{{snapshot.key}} class=\"btn btn-inverse btn-mini\">\n          <i class=\"fa fa-eye\"></i>\n          View\n        </a>\n      </td>\n      <td class=text-right>\n        <a ng-click=ctrl.removeSnapshot(snapshot) class=\"btn btn-danger btn-mini\">\n          <i class=\"fa fa-remove\"></i>\n        </a>\n      </td>\n    </tr>\n  </table>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 847 */
/***/ (function(module, exports) {

var path = 'public/app/features/styleguide/styleguide.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n\n\t<h3 class=page-heading>Buttons</h3>\n\n\t<div class=tab-pane>\n\t\t<div ng-repeat=\"variant in ctrl.buttonVariants\" class=row>\n\t\t\t<div ng-repeat=\"btnSize in ctrl.buttonSizes\" class=\"style-guide-button-list p-a-2 col-md-4\">\n\t\t\t\t<button ng-repeat=\"buttonName in ctrl.buttonNames\" class=\"btn btn{{variant}}{{buttonName}} {{btnSize}}\">\n\t\t\t\t\tbtn{{variant}}{{buttonName}}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<h3 class=page-heading>Forms</h3>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<label class=gf-form-label>Label</label>\n\t\t\t<input type=text class=gf-form-input />\n\t\t</div>\n\t</div>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 848 */
/***/ (function(module, exports) {

var path = 'public/app/features/templating/partials/editor.html';
var html = "<div ng-controller=VariableEditorCtrl ng-init=init()>\n\n\t<h3 class=dashboard-settings__header>\n\t\t<a ng-click=\"setMode('list')\">Variables</a>\n\t\t<span ng-show=\"mode === 'new'\">&gt; New</span>\n\t\t<span ng-show=\"mode === 'edit'\">&gt; Edit</span>\n\t</h3>\n\n\t<div ng-if=\"mode === 'list'\">\n\n\t\t<div ng-if=\"variables.length === 0\">\n\t\t\t<div class=empty-list-cta>\n\t\t\t\t<div class=empty-list-cta__title>There are no variables added yet</div>\n\t\t\t\t<a ng-click=\"setMode('new')\" class=\"empty-list-cta__button btn btn-xlarge btn-success\">\n\t\t\t\t\t<i class=\"gicon gicon-add-variable\"></i>\n\t\t\t\t\tAdd variable\n\t\t\t\t</a>\n\t\t\t\t<div class=grafana-info-box>\n\t\t\t\t\t<h5>What do variables do?</h5>\n\t\t\t\t\t<p>Variables enable more interactive and dynamic dashboards. Instead of hard-coding things like server or sensor names\n\t\t\t\t\tin your metric queries you can use variables in their place. Variables are shown as dropdown select boxes at the top of\n\t\t\t\t\tthe dashboard. These dropdowns make it easy to change the data being displayed in your dashboard.\n\n\t\t\t\t\tCheck out the\n\t\t\t\t\t<a class=external-link href=http://docs.grafana.org/reference/templating/ target=_blank>\n\t\t\t\t\t\tTemplating documentation\n\t\t\t\t\t</a> for more information.\n\t\t\t\t</p></div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if=variables.length>\n\t\t\t<div class=page-action-bar>\n\t\t\t\t<div class=page-action-bar__spacer></div>\n\t\t\t\t<a type=button class=\"btn btn-success\" ng-click=\"setMode('new');\"><i class=\"fa fa-plus\"></i> New</a>\n\t\t\t</div>\n\n\t\t\t<table class=\"filter-table filter-table--hover\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Variable</th>\n\t\t\t\t\t\t<th>Definition</th>\n\t\t\t\t\t\t<th colspan=5></th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr ng-repeat=\"variable in variables\">\n\t\t\t\t\t\t<td style=width:1%>\n\t\t\t\t\t\t\t<span ng-click=edit(variable) class=\"pointer template-variable\">\n\t\t\t\t\t\t\t\t${{variable.name}}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td style=max-width:200px ng-click=edit(variable) class=\"pointer max-width\">\n\t\t\t\t\t\t\t{{variable.query}}\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td style=width:1%><i ng-click=_.move(variables,$index,$index-1) ng-hide=$first class=\"pointer fa fa-arrow-up\"></i></td>\n\t\t\t\t\t\t<td style=width:1%><i ng-click=_.move(variables,$index,$index+1) ng-hide=$last class=\"pointer fa fa-arrow-down\"></i></td>\n\t\t\t\t\t\t<td style=width:1%>\n\t\t\t\t\t\t\t<a ng-click=duplicate(variable) class=\"btn btn-inverse btn-mini\">\n\t\t\t\t\t\t\t\tDuplicate\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td style=width:1%>\n\t\t\t\t\t\t\t<a ng-click=removeVariable(variable) class=\"btn btn-danger btn-mini\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n\n\t<form ng-if=\"mode === 'edit' || mode === 'new'\" name=ctrl.form>\n\t\t<h5 class=section-heading>General</h5>\n\t\t<div class=gf-form-group>\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=\"gf-form max-width-19\">\n\t\t\t\t\t<span class=\"gf-form-label width-6\">Name</span>\n\t\t\t\t\t<input type=text class=gf-form-input name=name placeholder=name ng-model=current.name required ng-pattern=namePattern>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"gf-form max-width-19\">\n\t\t\t\t\t<span class=\"gf-form-label width-6\">\n\t\t\t\t\t\tType\n\t\t\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t\t\t{{variableTypes[current.type].description}}\n\t\t\t\t\t\t</info-popover>\n\t\t\t\t\t</span>\n\t\t\t\t\t<div class=\"gf-form-select-wrapper max-width-17\">\n\t\t\t\t\t\t<select class=gf-form-input ng-model=current.type ng-options=\"k as v.name for (k, v) in variableTypes\" ng-change=typeChanged()></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form ng-show=ctrl.form.name.$error.pattern>\n\t\t\t\t<span class=\"gf-form-label gf-form-label--error\">Template names cannot begin with '__', that's reserved for Grafana's global variables</span>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=\"gf-form max-width-19\">\n\t\t\t\t\t<span class=\"gf-form-label width-6\">Label</span>\n\t\t\t\t\t<input type=text class=gf-form-input ng-model=current.label placeholder=\"optional display name\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"gf-form max-width-19\">\n\t\t\t\t\t<span class=\"gf-form-label width-6\">Hide</span>\n\t\t\t\t\t<div class=\"gf-form-select-wrapper max-width-15\">\n\t\t\t\t\t\t<select class=gf-form-input ng-model=current.hide ng-options=\"f.value as f.text for f in hideOptions\"></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if=\"current.type === 'interval'\" class=gf-form-group>\n\t\t\t<h5 class=section-heading>Interval Options</h5>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-9\">Values</span>\n\t\t\t\t<input type=text class=gf-form-input placeholder=name ng-model=current.query placeholder=1m,10m,1h,6h,1d,7d ng-model-onblur ng-change=runQuery() required>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<gf-form-switch class=gf-form label=\"Auto Option\" label-class=width-9 checked=current.auto on-change=runQuery()>\n\t\t\t\t</gf-form-switch>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-9\" ng-show=current.auto>\n\t\t\t\t\t\tStep count <tip>How many times should the current time range be divided to calculate the value</tip>\n\t\t\t\t\t</span>\n\t\t\t\t\t<div class=\"gf-form-select-wrapper max-width-10\" ng-show=current.auto>\n\t\t\t\t\t\t<select class=gf-form-input ng-model=current.auto_count ng-options=\"f for f in [1,2,3,4,5,10,20,30,40,50,100,200,300,400,500]\" ng-change=runQuery()></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=gf-form-label ng-show=current.auto>\n\t\t\t\t\t\tMin interval <tip>The calculated value will not go below this threshold</tip>\n\t\t\t\t\t</span>\n\t\t\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-show=current.auto ng-model=current.auto_min ng-change=runQuery() placeholder=10s>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if=\"current.type === 'custom'\" class=gf-form-group>\n\t\t\t<h5 class=section-heading>Custom Options</h5>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-14\">Values separated by comma</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=current.query ng-blur=runQuery() placeholder=\"1, 10, 20, myvalue\" required>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if=\"current.type === 'constant'\" class=gf-form-group>\n\t\t\t<h5 class=section-heading>Constant options</h5>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=gf-form-label>Value</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=current.query ng-blur=runQuery() placeholder=\"your metric prefix\">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if=\"current.type === 'query'\" class=gf-form-group>\n\t\t\t<h5 class=section-heading>Query Options</h5>\n\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=\"gf-form max-width-21\">\n\t\t\t\t\t<span class=\"gf-form-label width-7\">Data source</span>\n\t\t\t\t\t<div class=\"gf-form-select-wrapper max-width-14\">\n\t\t\t\t\t\t<select class=gf-form-input ng-model=current.datasource ng-options=\"f.value as f.name for f in datasources\" required>\n\t\t\t\t\t\t\t<option value=\"\" ng-if=false></option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"gf-form max-width-22\">\n\t\t\t\t\t<span class=\"gf-form-label width-7\">\n\t\t\t\t\t\tRefresh\n\t\t\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t\t\tWhen to update the values of this variable.\n\t\t\t\t\t\t</info-popover>\n\t\t\t\t\t</span>\n\t\t\t\t\t<div class=\"gf-form-select-wrapper width-15\">\n\t\t\t\t\t\t<select class=gf-form-input ng-model=current.refresh ng-options=\"f.value as f.text for f in refreshOptions\"></select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-7\">Query</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=current.query placeholder=\"metric name or tags query\" ng-model-onblur ng-change=runQuery() required>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-7\">\n\t\t\t\t\tRegex\n\t\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t\tOptional, if you want to extract part of a series name or metric node segment.\n\t\t\t\t\t</info-popover>\n\t\t\t\t</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=current.regex placeholder=/.*-(.*)-.*/ ng-model-onblur ng-change=runQuery()>\n\t\t\t</div>\n\t\t\t<div class=\"gf-form max-width-21\">\n\t\t\t\t<span class=\"gf-form-label width-7\">\n\t\t\t\t\tSort\n\t\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t\tHow to sort the values of this variable.\n\t\t\t\t\t</info-popover>\n\t\t\t\t</span>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-14\">\n\t\t\t\t\t<select class=gf-form-input ng-model=current.sort ng-options=\"f.value as f.text for f in sortOptions\" ng-change=runQuery()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-show=\"current.type === 'datasource'\" class=gf-form-group>\n\t\t\t<h5 class=section-heading>Data source options</h5>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-12\">Type</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-18\">\n\t\t\t\t\t<select class=gf-form-input ng-model=current.query ng-options=\"f.value as f.text for f in datasourceTypes\" ng-change=runQuery()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-12\">\n\t\t\t\t\tInstance name filter\n\t\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t\tRegex filter for which data source instances to choose from in\n\t\t\t\t\t\tthe variable value dropdown. Leave empty for all.\n\t\t\t\t\t\t<br><br>\n\t\t\t\t\t\tExample: <code>/^prod/</code>\n\n\t\t\t\t\t</info-popover>\n\t\t\t\t</label>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-18\" ng-model=current.regex placeholder=/.*-(.*)-.*/ ng-model-onblur ng-change=runQuery()>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div ng-if=\"current.type === 'adhoc'\" class=gf-form-group>\n\t\t\t<h5 class=section-heading>Options</h5>\n\t\t\t<div class=\"gf-form max-width-21\">\n\t\t\t\t<span class=\"gf-form-label width-8\">Data source</span>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-14\">\n\t\t\t\t\t<select class=gf-form-input ng-model=current.datasource ng-options=\"f.value as f.name for f in datasources\" required ng-change=validate()>\n\t\t\t\t\t\t<option value=\"\" ng-if=false></option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"section gf-form-group\" ng-show=variableTypes[current.type].supportsMulti>\n\t\t\t<h5 class=section-heading>Selection Options</h5>\n\t\t\t<div class=section>\n\t\t\t\t<gf-form-switch class=gf-form label=Multi-value label-class=width-10 tooltip=\"Enables multiple values to be selected at the same time\" checked=current.multi on-change=runQuery()>\n\t\t\t\t</gf-form-switch>\n\t\t\t\t<gf-form-switch class=gf-form label=\"Include All option\" label-class=width-10 checked=current.includeAll on-change=runQuery()>\n\t\t\t\t</gf-form-switch>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-if=current.includeAll>\n\t\t\t\t<span class=\"gf-form-label width-10\">Custom all value</span>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-15\" ng-model=current.allValue placeholder=\"blank = auto\">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-group ng-if=\"current.type === 'query'\">\n\t\t\t<h5>Value groups/tags (Experimental feature)</h5>\n\t\t\t<gf-form-switch class=gf-form label=Enabled label-class=width-10 checked=current.useTags on-change=runQuery()>\n\t\t\t</gf-form-switch>\n\t\t\t<div class=\"gf-form last\" ng-if=current.useTags>\n\t\t\t\t<span class=\"gf-form-label width-10\">Tags query</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=current.tagsQuery placeholder=\"metric name or tags query\" ng-model-onblur>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-if=current.useTags>\n\t\t\t\t<li class=\"gf-form-label width-10\">Tag values query</li>\n\t\t\t\t<input type=text class=gf-form-input ng-model=current.tagValuesQuery placeholder=apps.$tag.* ng-model-onblur>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-group ng-show=current.options.length>\n\t\t\t<h5>Preview of values</h5>\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=gf-form ng-repeat=\"option in current.options | limitTo: optionsLimit\">\n          <span class=gf-form-label>{{option.text}}</span>\n        </div>\n        <div class=gf-form ng-if=\"current.options.length > optionsLimit\">\n          <a class=\"gf-form-label btn-secondary\" ng-click=showMoreOptions()>Show more</a>\n        </div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"alert alert-info gf-form-group\" ng-if=infoText>\n\t\t\t{{infoText}}\n\t\t</div>\n\n\t\t<div class=\"gf-form-button-row p-y-0\">\n\t\t\t<button type=submit class=\"btn btn-success\" ng-show=\"mode === 'edit'\" ng-click=update();>Update</button>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-show=\"mode === 'new'\" ng-click=add();>Add</button>\n\t\t</div>\n\n\t</form>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 849 */
/***/ (function(module, exports) {

var path = 'public/app/partials/confirm_modal.html';
var html = "<div class=modal-body ng-cloak>\n\t<div class=modal-header>\n\t\t<h2 class=modal-header-title>\n\t\t\t<i class=\"fa {{icon}}\"></i>\n\t\t\t<span class=p-l-1>\n\t\t\t\t{{title}}\n\t\t\t</span>\n\t\t</h2>\n\n\t\t<a class=modal-header-close ng-click=dismiss();>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n\t<div class=\"modal-content text-center\">\n\n\t\t<div class=confirm-modal-text>\n\t\t\t{{text}}\n\t\t\t<div class=confirm-modal-text2 ng-show=text2>\n\t\t\t\t{{text2}}\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=modal-content-confirm-text ng-if=confirmText>\n\t\t\t<input type=text class=\"gf-form-input width-16\" style=display:inline-block placeholder=\"Type {{confirmText}} to confirm\" ng-model=confirmInput ng-change=updateConfirmText(confirmInput)>\n\t\t</div>\n\n\t\t<div class=confirm-modal-buttons>\n\t\t\t<button ng-show=onAltAction type=button class=\"btn btn-success\" ng-click=dismiss();onAltAction();>{{altActionText}}</button>\n\t\t\t<button type=button class=\"btn btn-danger\" ng-click=onConfirm();dismiss(); ng-disabled=!confirmTextValid give-focus=true>{{yesText}}</button>\n\t\t\t<button type=button class=\"btn btn-inverse\" ng-click=dismiss()>{{noText}}</button>\n\t\t</div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 850 */
/***/ (function(module, exports) {

var path = 'public/app/partials/dashboard.html';
var html = "<div dash-class ng-if=ctrl.dashboard>\n\t<dashnav dashboard=ctrl.dashboard></dashnav>\n\n\t<div class=\"scroll-canvas scroll-canvas--dashboard\" page-scrollbar>\n    <dashboard-settings dashboard=ctrl.dashboard ng-if=ctrl.dashboardViewState.state.editview class=dashboard-settings>\n    </dashboard-settings>\n\n    <div class=dashboard-container>\n      <dashboard-submenu ng-if=ctrl.dashboard.meta.submenuEnabled dashboard=ctrl.dashboard>\n      </dashboard-submenu>\n\n      <dashboard-grid get-panel-container=ctrl.getPanelContainer>\n      </dashboard-grid>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 851 */
/***/ (function(module, exports) {

var path = 'public/app/partials/edit_json.html';
var html = "<div ng-controller=JsonEditorCtrl>\n\t<div class=tabbed-view-header>\n\t\t<h2 class=tabbed-view-title>\n\t\t\tJSON\n\t\t</h2>\n\n\t\t<button class=tabbed-view-close-btn ng-click=dismiss()>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</button>\n\t</div>\n\n\t<div class=tabbed-view-body>\n\t\t<div class=gf-form>\n\t\t\t<code-editor content=json data-mode=json data-max-lines=20></code-editor>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=button class=\"btn btn-success\" ng-show=canUpdate ng-click=\"update(); dismiss();\">Update</button>\n\t\t\t<button class=\"btn btn-secondary\" ng-if=canCopy clipboard-button=getContentForClipboard()>\n\t\t\t\t<i class=\"fa fa-clipboard\"></i>&nbsp;Copy to Clipboard\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 852 */
/***/ (function(module, exports) {

var path = 'public/app/partials/error.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <div class=\"panel-container error-container\">\n    <div class=\"error-column graph-box\">\n      <div class=error-row>\n        <div class=\"error-column error-space-between graph-percentage\">\n          <p>100%</p>\n          <p>80%</p>\n          <p>60%</p>\n          <p>40%</p>\n          <p>20%</p>\n          <p>0%</p>\n        </div>\n        <div class=\"error-column image-box\">\n          <img src=public/img/graph404.svg width=100%>\n          <div class=\"error-row error-space-between\">\n            <p class=graph-text>Then</p>\n            <p class=graph-text>Now</p>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"error-column info-box\">\n      <div class=\"error-row current-box\">\n        <p class=current-text>current</p>\n      </div>\n      <div class=error-row style=flex:1>\n        <i class=\"fa fa-minus error-minus\"></i>\n        <div class=\"error-column error-space-between error-full-width\">\n          <div class=\"error-row error-space-between\">\n            <p>Chances you are on the page you are looking for.</p>\n            <p class=left-margin>0%</p>\n          </div>\n          <div>\n            <h3>Sorry for the inconvenience</h3>\n            <p>Please go back to your\n            <a href={{appSubUrl}}/ class=error-link>home dashboard</a> and try again.</p>\n            <p>If the error persists, seek help on the\n            <a href=https://community.grafana.com target=_blank class=error-link>community site</a>.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n    <span class=react-resizable-handle style=cursor:default></span>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 853 */
/***/ (function(module, exports) {

var path = 'public/app/partials/login.html';
var html = "<div class=\"login container\">\n  <div class=login-content>\n    <div class=login-branding>\n      <img class=logo-icon src=public/img/grafana_icon.svg alt=Grafana />\n      <i class=\"icon-gf icon-gf-grafana_wordmark\"></i>\n    </div>\n    <div class=login-inner-box>\n      <form name=loginForm class=\"login-form-group gf-form-group\" ng-hide=disableLoginForm>\n        <div class=login-form>\n          <input type=text name=username class=\"gf-form-input login-form-input\" required ng-model=formModel.user placeholder={{loginHint}} autofocus>\n        </div>\n        <div class=login-form>\n          <input type=password name=password class=\"gf-form-input login-form-input\" required ng-model=formModel.password id=inputPassword placeholder=password>\n        </div>\n        <div class=login-button-group>\n          <button type=submit class=\"btn btn-large p-x-2\" ng-click=submit(); ng-class=\"{'btn-inverse': !loginForm.$valid, 'btn-primary': loginForm.$valid}\">\n            Log In\n          </button>\n            <div class=\"small login-button-forgot-password\">\n              <a href=user/password/send-reset-email>\n                Forgot your password?\n              </a>\n          </div>\n        </div>\n      </form>\n      <div class=\"text-center login-divider\" ng-show=oauthEnabled>\n        <div>\n          <div class=login-divider-line>\n          </div>\n        </div>\n        <div>\n          <span class=login-divider-text>\n            <span ng-hide=disableLoginForm>or</span>\n          </span>\n        </div>\n        <div>\n          <div class=login-divider-line>\n          </div>\n        </div>\n      </div>\n      <div class=clearfix></div>\n      <div class=\"login-oauth text-center\" ng-show=oauthEnabled>\n        <a class=\"btn btn-medium btn-service btn-service--google login-btn\" href=login/google target=_self ng-if=oauth.google>\n          <i class=\"btn-service-icon fa fa-google\"></i>\n          Sign in with Google\n        </a>\n        <a class=\"btn btn-medium btn-service btn-service--github login-btn\" href=login/github target=_self ng-if=oauth.github>\n          <i class=\"btn-service-icon fa fa-github\"></i>\n          Sign in with GitHub\n        </a>\n        <a class=\"btn btn-medium btn-inverse btn-service btn-service--grafanacom login-btn\" href=login/grafana_com target=_self ng-if=oauth.grafana_com>\n          <i class=btn-service-icon></i>\n          Sign in with Grafana.com\n        </a>\n        <a class=\"btn btn-medium btn-inverse btn-service btn-service--oauth login-btn\" href=login/generic_oauth target=_self ng-if=oauth.generic_oauth>\n          <i class=\"btn-service-icon fa fa-sign-in\"></i>\n          Sign in with {{oauth.generic_oauth.name}}\n        </a>\n      </div>\n      <div class=login-signup-box ng-show=!disableUserSignUp>\n        <div class=\"login-signup-title p-r-1\">\n          New to Grafana?\n        </div>\n        <a href=signup class=\"btn btn-medium btn-signup btn-p-x-2\">\n          Sign Up\n        </a>\n      </div>\n    </div>\n    <div class=clearfix></div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

var path = 'public/app/partials/modal.html';
var html = "<div class=modal-header>\n  <button type=button class=close data-dismiss=modal aria-hidden=true>×</button>\n  <h3>{{modal.title}}</h3>\n</div>\n<div class=modal-body>\n\n  <div ng-bind-html=modal.body></div>\n\n</div>\n<div class=modal-footer>\n  <button type=button class=\"btn btn-danger\" ng-click=dismiss()>Close</button>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 855 */
/***/ (function(module, exports) {

var path = 'public/app/partials/panelgeneral.html';
var html = "<div class=editor-row>\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Info</h5>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Title</span>\n\t\t\t<input type=text class=\"gf-form-input width-25\" ng-model=ctrl.panel.title>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--v-stretch\">\n\t\t\t<span class=\"gf-form-label width-7\">Description</span>\n\t\t\t<textarea class=\"gf-form-input width-25\" rows=3 ng-model=ctrl.panel.description placeholder=\"Panel description, supports markdown & links\"></textarea>\n\t\t</div>\n    <gf-form-switch class=gf-form label-class=width-7 switch-class=max-width-6 label=Transparent checked=ctrl.panel.transparent on-change=ctrl.render()></gf-form-switch>\n\t</div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Repeat</h5>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-9\">For each value of</span>\n\t\t\t<dash-repeat-option panel=ctrl.panel></dash-repeat-option>\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.panel.repeat>\n\t\t\t<span class=\"gf-form-label width-9\">Min width</span>\n\t\t\t<select class=gf-form-input ng-model=ctrl.panel.minSpan ng-options=\"f for f in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]\">\n\t\t\t\t<option value=\"\"></option>\n\t\t\t</select>\n\t\t</div>\n    <div class=gf-form ng-show=ctrl.panel.repeat>\n\t\t\t<span class=\"gf-form-label width-9\">Direction</span>\n\t\t\t<select class=gf-form-input ng-model=ctrl.panel.repeatDirection ng-options=\"f.value as f.text for f in [{value: 'v', text: 'Vertical'}, {value: 'h', text: 'Horizontal'}]\">\n\t\t\t\t<option value=\"\"></option>\n\t\t\t</select>\n\t\t</div>\n\t</div>\n\n\t<panel-links-editor panel=ctrl.panel></panel-links-editor>\n\n\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 856 */
/***/ (function(module, exports) {

var path = 'public/app/partials/reset_password.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<div class=signup>\n\t\t<h3 class=p-b-1>Reset password</h3>\n\t\t<form name=sendResetForm class=\"login-form gf-form-group\" ng-show=\"mode === 'send'\">\n\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t\t\t<input type=text name=username class=\"gf-form-input max-width-14\" required ng-model=formModel.userOrEmail placeholder=\"email or username\">\n\t\t\t</div>\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=sendResetEmail(); ng-disabled=!sendResetForm.$valid>\n\t\t\t\t\tReset Password\n\t\t\t\t</button>\n\t\t\t\t<a href=login class=\"btn btn-inverse\">\n\t\t\t\t\tBack\n\t\t\t\t</a>\n\n\t\t\t</div>\n\t\t</form>\n\t\t<div ng-show=\"mode === 'email-sent'\">\n\t\t\tAn email with a reset link as been sent to the email address. <br>\n\t\t\tYou should receive it shortly.\n\t\t\t<div class=p-t-1>\n\t\t\t\t<a href=login class=\"btn btn-success p-t-1\">\n\t\t\t\t\tLogin\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t\t<form name=resetForm class=\"login-form gf-form-group\" ng-show=\"mode === 'reset'\">\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-9\">New Password</span>\n\t\t\t\t<input type=password name=NewPassword class=\"gf-form-input max-width-14\" required ng-minlength=4 ng-model=formModel.newPassword placeholder=password watch-change=\"formModel.newPassword = inputValue;\">\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-9\">Confirm Password</span>\n\t\t\t\t<input type=password name=ConfirmPassword class=\"gf-form-input max-width-14\" required ng-minlength=4 ng-model=formModel.confirmPassword placeholder=\"confirm password\">\n\t\t\t</div>\n\t\t\t<div class=signup__password-strength>\n\t\t\t\t<password-strength password=formModel.newPassword></password-strength>\n\t\t\t</div>\n\t\t\t<div class=gf-form-button-row>\n\t\t\t\t<button type=submit class=\"btn btn-success\" ng-click=submitReset(); ng-disabled=!resetForm.$valid>\n\t\t\t\t\tReset Password\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 857 */
/***/ (function(module, exports) {

var path = 'public/app/partials/signup_invited.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n\t<h3 class=page-sub-heading>Hello {{greeting}}.</h3>\n\n\t<div class=\"modal-tagline p-b-2\">\n\t\t<em>{{invitedBy}}</em> has invited you to join Grafana and the organization <span class=highlight-word>{{contextSrv.user.orgName}}</span><br>Please complete the following to accept your invitation and continue:\n\t</div>\n\n\t<form name=inviteForm class=\"login-form gf-form-group\">\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Email</span>\n\t\t\t<input type=email name=email class=\"gf-form-input max-width-21\" required ng-model=formModel.email placeholder=Email>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Name</span>\n\t\t\t<input type=text name=name class=\"gf-form-input max-width-21\" ng-model=formModel.name placeholder=\"Name (optional)\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Username</span>\n\t\t\t<input type=text name=username class=\"gf-form-input max-width-21\" required ng-model=formModel.username placeholder=Username>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=password name=password class=\"gf-form-input max-width-21\" required ng-model=formModel.password id=inputPassword placeholder=password>\n\t\t</div>\n\n\t\t<div style=margin-left:7.5rem;width:254px>\n\t\t\t<password-strength password=formModel.password></password-strength>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=submit class=\"btn btn-success\" ng-click=submit(); ng-disable=!inviteForm.$valid>\n\t\t\t\tSign Up\n\t\t\t</button>\n\t\t</div>\n\t</form>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 858 */
/***/ (function(module, exports) {

var path = 'public/app/partials/signup_step2.html';
var html = "<page-header model=navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <div class=signup>\n    <h3 class=p-b-1>You're almost there.</h3>\n    <div class=p-b-1>\n      We just need a couple of more bits of<br> information to finish creating your account.\n    </div>\n    <form name=signUpForm class=\"login-form gf-form-group\">\n      <div class=gf-form ng-if=verifyEmailEnabled>\n        <span class=\"gf-form-label width-9\">\n          Email code<tip>Email verification code (sent to your email)</tip>\n        </span>\n        <input type=text class=\"gf-form-input max-width-14\" ng-model=formModel.code required>\n      </div>\n\n      <div class=gf-form ng-if=!autoAssignOrg>\n        <span class=\"gf-form-label width-9\">Org. name</span>\n        <input type=text name=orgName class=\"gf-form-input max-width-14\" ng-model=formModel.orgName placeholder=\"Name your organization\">\n      </div>\n\n      <div class=gf-form>\n        <span class=\"gf-form-label width-9\">Your name</span>\n        <input type=text name=name class=\"gf-form-input max-width-14\" ng-model=formModel.name placeholder=(optional)>\n      </div>\n      <div class=gf-form>\n        <span class=\"gf-form-label width-9\">Email</span>\n        <input type=text class=\"gf-form-input max-width-14\" required ng-model=formModel.username placeholder=Email autocomplete=off>\n      </div>\n      <div class=gf-form>\n        <span class=\"gf-form-label width-9\">Password</span>\n        <input type=password class=\"gf-form-input max-width-14\" required ng-model=formModel.password id=inputPassword placeholder=password autocomplete=off>\n      </div>\n\n      <div class=signup__password-strength>\n        <password-strength password=formModel.password></password-strength>\n      </div>\n\n      <div class=\"gf-form-button-row p-t-3\">\n        <button type=submit class=\"btn btn-success\" ng-click=ctrl.submit(); ng-disabled=!signUpForm.$valid>\n          Sign Up\n        </button>\n        <a href=login class=\"btn btn-inverse\">\n            Back\n        </a>\n      </div>\n    </form>\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 859 */
/***/ (function(module, exports) {

var path = 'public/app/partials/valueSelectDropdown.html';
var html = "<div class=variable-link-wrapper>\n\t<a ng-click=vm.show() class=variable-value-link>\n\t\t{{vm.linkText}}\n\t\t<span ng-repeat=\"tag in vm.selectedTags\" bs-tooltip=tag.valuesText data-placement=bottom>\n\t\t\t<span class=label-tag tag-color-from-name=tag.text>\n\t\t\t\t&nbsp;&nbsp;<i class=\"fa fa-tag\"></i>&nbsp;\n\t\t\t\t{{tag.text}}\n\t\t\t</span>\n\t\t</span>\n\t\t<i class=\"fa fa-caret-down\" style=font-size:12px></i>\n\t</a>\n\n\t<input type=text class=gf-form-input style=display:none ng-keydown=vm.keyDown($event) ng-model=vm.search.query ng-change=vm.queryChanged()>\n\n\t<div class=variable-value-dropdown ng-if=vm.dropdownVisible ng-class=\"{'multi': vm.variable.multi, 'single': !vm.variable.multi}\">\n\t\t<div class=variable-options-wrapper>\n\t\t\t<div class=variable-options-column>\n\t\t\t\t<a class=variable-options-column-header ng-if=vm.variable.multi ng-class=\"{'many-selected': vm.selectedValues.length > 1}\" bs-tooltip=\"'Clear selections'\" data-placement=top ng-click=vm.clearSelections()>\n\t\t\t\t\t<span class=variable-option-icon></span>\n\t\t\t\t\tSelected ({{vm.selectedValues.length}})\n\t\t\t\t</a>\n\t\t\t\t<a class=\"variable-option pointer\" ng-repeat=\"option in vm.search.options\" ng-class=\"{'selected': option.selected, 'highlighted': $index === vm.highlightIndex}\" ng-click=\"vm.selectValue(option, $event)\">\n\t\t\t\t\t<span class=variable-option-icon></span>\n\t\t\t\t\t<span>{{option.text}}</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<div class=variable-options-column ng-if=vm.tags.length>\n\t\t\t\t<div class=\"variable-options-column-header text-center\">\n\t\t\t\t\tTags\n\t\t\t\t</div>\n\t\t\t\t<a class=\"variable-option-tag pointer\" ng-repeat=\"tag in vm.tags\" ng-click=\"vm.selectTag(tag, $event)\" ng-class=\"{'selected': tag.selected}\">\n\t\t\t\t\t<span class=\"fa fa-fw variable-option-icon\"></span>\n\t\t\t\t\t<span class=label-tag tag-color-from-name=tag.text>{{tag.text}}&nbsp;&nbsp;<i class=\"fa fa-tag\"></i>&nbsp;</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 860 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/app/testdata/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl has-text-edit-mode=false>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword width-7\">Scenario</label>\n\t\t\t<div class=\"gf-form-select-wrapper width-15\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.target.scenarioId ng-options=\"v.id as v.name for v in ctrl.scenarioList\" ng-change=ctrl.scenarioChanged()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form gf-form--grow\" ng-if=ctrl.scenario.stringInput>\n\t\t\t<label class=\"gf-form-label query-keyword\">String Input</label>\n      <input type=text class=gf-form-input placeholder={{ctrl.scenario.stringInput}} ng-model=ctrl.target.stringInput ng-change=ctrl.refresh() ng-model-onblur>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Alias</label>\n\t\t\t<input type=text class=\"gf-form-input max-width-7\" placeholder=optional ng-model=ctrl.target.alias ng-change=ctrl.refresh() ng-model-onblur>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\t<div class=gf-form-inline ng-if=\"ctrl.scenario.id === 'manual_entry'\">\n\t\t<div class=\"gf-form gf-form\">\n\t\t\t<label class=\"gf-form-label query-keyword width-7\">New value</label>\n      <input type=number class=\"gf-form-input width-15\" placeholder=value ng-model=ctrl.newPointValue>\n\t\t\t<label class=\"gf-form-label query-keyword\">Time</label>\n      <input type=string class=\"gf-form-input width-12\" placeholder=time ng-model=ctrl.newPointTime input-datetime>\n\t\t\t<button class=\"btn btn-secondary gf-form-btn\" ng-click=ctrl.addPoint()>Add</button>\n\t\t\t<label class=\"gf-form-label query-keyword\">All values</label>\n\t\t\t<gf-form-dropdown css-class=width-12 model=ctrl.selectedPoint get-options=ctrl.getPoints() on-change=ctrl.pointSelected($option)>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form\" ng-if=\"ctrl.selectedPoint.value !== null\">\n\t\t\t<button class=\"btn btn-danger gf-form-btn\" ng-click=ctrl.deletePoint()>Delete</button>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n</query-editor-row>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 861 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/cloudwatch/partials/annotations.editor.html';
var html = "<cloudwatch-query-parameter target=ctrl.annotation datasource=ctrl.datasource></cloudwatch-query-parameter>\n\n<div class=editor-row style=\"padding:2rem 0\">\n\t<div class=section>\n\t\t<h5>Prefix matching</h5>\n\t\t<div class=gf-form-inline>\n\t\t\t<gf-form-switch class=gf-form label=Enable checked=ctrl.annotation.prefixMatching switch-class=max-width-6></gf-form-switch>\n\t\t\t<div class=gf-form ng-if=ctrl.annotation.prefixMatching>\n\t\t\t\t<span class=gf-form-label>Action</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.actionPrefix>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-if=ctrl.annotation.prefixMatching>\n\t\t\t\t<span class=gf-form-label>Alarm Name</span>\n\t\t\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.alarmNamePrefix>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 862 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/cloudwatch/partials/config.html';
var html = "<h3 class=page-heading>CloudWatch details</h3>\n\n<div class=\"gf-form-group max-width-30\">\n  <div class=\"gf-form gf-form-select-wrapper\">\n    <label class=\"gf-form-label width-13\">Auth Provider</label>\n    <select class=\"gf-form-input gf-max-width-13\" ng-model=ctrl.current.jsonData.authType ng-options=\"f.value as f.name for f in ctrl.authTypes\"></select>\n  </div>\n\n  <div class=gf-form ng-show='ctrl.current.jsonData.authType == \"credentials\"'>\n    <label class=\"gf-form-label width-13\">Credentials profile name</label>\n    <input type=text class=\"gf-form-input max-width-18\" ng-model=ctrl.current.database placeholder=default>\n    <info-popover mode=right-absolute>\n      Credentials profile name, as specified in ~/.aws/credentials, leave blank for default\n    </info-popover>\n  </div>\n\n  <div class=gf-form ng-show='ctrl.current.jsonData.authType == \"keys\"'>\n    <label class=\"gf-form-label width-13\">Access key ID </label>\n    <label class=\"gf-form-label width-13\" ng-show=ctrl.accessKeyExist>Configured</label>\n    <a class=\"btn btn-secondary gf-form-btn\" type=submit ng-click=ctrl.resetAccessKey() ng-show=ctrl.accessKeyExist>Reset</a>\n    <input type=text class=\"gf-form-input max-width-18\" ng-hide=ctrl.accessKeyExist ng-model=ctrl.current.secureJsonData.accessKey>\n  </div>\n\n  <div class=gf-form ng-show='ctrl.current.jsonData.authType == \"keys\"'>\n    <label class=\"gf-form-label width-13\">Secret access key</label>\n    <label class=\"gf-form-label width-13\" ng-show=ctrl.secretKeyExist>Configured</label>\n    <a class=\"btn btn-secondary gf-form-btn\" type=submit ng-click=ctrl.resetSecretKey() ng-show=ctrl.secretKeyExist>Reset</a>\n    <input type=text class=\"gf-form-input max-width-18\" ng-hide=ctrl.secretKeyExist ng-model=ctrl.current.secureJsonData.secretKey>\n  </div>\n\n  <div class=gf-form ng-show='ctrl.current.jsonData.authType == \"arn\"'>\n    <label class=\"gf-form-label width-13\">Assume Role ARN</label>\n    <input type=text class=\"gf-form-input max-width-18\" ng-model=ctrl.current.jsonData.assumeRoleArn placeholder=arn:aws:iam:*>\n    <info-popover mode=right-absolute>\n      ARN of Assume Role\n    </info-popover>\n  </div>\n\n  <div class=gf-form>\n    <label class=\"gf-form-label width-13\">Default Region</label>\n    <div class=\"gf-form-select-wrapper max-width-18 gf-form-select-wrapper--has-help-icon\">\n      <select class=gf-form-input ng-model=ctrl.current.jsonData.defaultRegion ng-options=\"region for region in ['ap-northeast-1', 'ap-northeast-2', 'ap-southeast-1', 'ap-southeast-2', 'ap-south-1', 'ca-central-1', 'cn-north-1', 'cn-northwest-1', 'eu-central-1', 'eu-west-1', 'eu-west-2', 'eu-west-3', 'sa-east-1', 'us-east-1', 'us-east-2', 'us-gov-west-1', 'us-west-1', 'us-west-2']\"></select>\n      <info-popover mode=right-absolute>\n        Specify the region, such as for US West (Oregon) use ` us-west-2 ` as the region.\n      </info-popover>\n    </div>\n  </div>\n  <div class=gf-form>\n    <label class=\"gf-form-label width-13\">Custom Metrics</label>\n    <input type=text class=\"gf-form-input max-width-18\" ng-model=ctrl.current.jsonData.customMetricsNamespaces placeholder=Namespace1,Namespace2>\n    <info-popover mode=right-absolute>\n      Namespaces of Custom Metrics\n    </info-popover>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 863 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/cloudwatch/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<cloudwatch-query-parameter target=ctrl.target datasource=ctrl.datasource on-change=ctrl.refresh()></cloudwatch-query-parameter>\n</query-editor-row>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 864 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/cloudwatch/partials/query.parameter.html';
var html = "<div class=gf-form-inline>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-8\">Metric</label>\n\n\t\t<metric-segment segment=regionSegment get-options=getRegions() on-change=regionChanged()></metric-segment>\n\t\t<metric-segment segment=namespaceSegment get-options=getNamespaces() on-change=namespaceChanged()></metric-segment>\n\t\t<metric-segment segment=metricSegment get-options=getMetrics() on-change=metricChanged()></metric-segment>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword\">Stats</label>\n\t</div>\n\n\t<div class=gf-form ng-repeat=\"segment in statSegments\">\n\t\t<metric-segment segment=segment get-options=\"getStatSegments(segment, $index)\" on-change=\"statSegmentChanged(segment, $index)\"></metric-segment>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t</div>\n</div>\n\n<div class=gf-form-inline>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-8\">Dimensions</label>\n\t\t<metric-segment ng-repeat=\"segment in dimSegments\" segment=segment get-options=\"getDimSegments(segment, $index)\" on-change=\"dimSegmentChanged(segment, $index)\"></metric-segment>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t</div>\n</div>\n\n<div class=gf-form-inline>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-8\">\n\t\t\tMin period\n\t\t\t<info-popover mode=right-normal>Minimum interval between points in seconds</info-popover>\n\t\t</label>\n\t\t<input type=text class=gf-form-input ng-model=target.period spellcheck=false placeholder=auto ng-model-onblur ng-change=onChange() />\n\t</div>\n\t<div class=\"gf-form max-width-30\">\n\t\t<label class=\"gf-form-label query-keyword width-7\">Alias</label>\n\t\t<input type=text class=gf-form-input ng-model=target.alias spellcheck=false ng-model-onblur ng-change=onChange()>\n\t\t<info-popover mode=right-absolute>\n\t\t\tAlias replacement variables:\n\t\t\t<ul ng-non-bindable>\n\t\t\t\t<li>{{metric}}</li>\n\t\t\t\t<li>{{stat}}</li>\n\t\t\t\t<li>{{namespace}}</li>\n\t\t\t\t<li>{{region}}</li>\n\t\t\t\t<li>{{period}}</li>\n\t\t\t\t<li>{{YOUR_DIMENSION_NAME}}</li>\n\t\t\t</ul>\n\t\t</info-popover>\n\t</div>\n\t<div class=gf-form>\n\t\t<gf-form-switch class=gf-form label=HighRes label-class=width-5 checked=target.highResolution on-change=onChange()>\n\t\t</gf-form-switch>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 865 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form ng-if=ctrl.annotation.index>\n\t\t<span class=\"gf-form-label width-14\">Index name</span>\n\t\t<input type=text class=\"gf-form-input max-width-20\" ng-model=ctrl.annotation.index placeholder=events-*>\n\t</div>\n\t<div class=gf-form-group>\n\t\t<div class=gf-form>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.query placeholder=\"Elasticsearch lucene query\">\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<h6>Field mappings</h6>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Time</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-14\" ng-model=ctrl.annotation.timeField placeholder=@timestamp>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Text</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-14\" ng-model=ctrl.annotation.textField placeholder=\"\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Tags</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-model=ctrl.annotation.tagsField placeholder=tags>\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.annotation.titleField>\n\t\t\t<span class=gf-form-label>Title <em class=muted>(deprecated)</em></span>\n\t\t\t<input type=text class=\"gf-form-input max-width-16\" ng-model=ctrl.annotation.titleField placeholder=desc>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 866 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/bucket_agg.html';
var html = "<div class=gf-form-inline>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\t<span ng-show=isFirst>Group by</span>\n\t\t\t<span ng-hide=isFirst>Then by</span>\n\t\t</label>\n\n\t\t<gf-form-dropdown model=agg.type lookup-text=true get-options=getBucketAggTypes() on-change=onTypeChanged() allow-custom=false label-mode=true css-class=width-10>\n\t\t</gf-form-dropdown>\n\t\t<gf-form-dropdown ng-if=agg.field model=agg.field get-options=getFieldsInternal() on-change=onChange() allow-custom=false label-mode=true css-class=width-12>\n\t\t</gf-form-dropdown>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<label class=\"gf-form-label gf-form-label--grow\">\n\t\t\t<a ng-click=toggleOptions()>\n\t\t\t\t<i class=\"fa fa-caret-down\" ng-show=showOptions></i>\n\t\t\t\t<i class=\"fa fa-caret-right\" ng-hide=showOptions></i>\n\t\t\t\t{{settingsLinkText}}\n\t\t\t</a>\n\t\t</label>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<label class=gf-form-label ng-if=isFirst>\n\t\t\t<a class=pointer ng-click=addBucketAgg()><i class=\"fa fa-plus\"></i></a>\n\t\t</label>\n\t\t<label class=gf-form-label ng-if=\"bucketAggCount > 1\">\n\t\t\t<a class=pointer ng-click=removeBucketAgg()><i class=\"fa fa-minus\"></i></a>\n\t\t</label>\n\t</div>\n</div>\n\n<div class=gf-form-group ng-if=showOptions>\n\t<div ng-if=\"agg.type === 'date_histogram'\">\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Interval</label>\n\t\t\t<gf-form-dropdown model=agg.settings.interval get-options=getIntervalOptions() on-change=onChangeInternal() allow-custom=true label-mode=true css-class=width-12>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Min Doc Count</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.min_doc_count ng-blur=onChangeInternal()>\n\t\t</div>\n\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">\n\t\t\t\tTrim edges\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\tTrim the edges on the timeseries datapoints\n\t\t\t\t</info-popover>\n\t\t\t</label>\n\t\t\t<input class=\"gf-form-input max-width-12\" type=number ng-model=agg.settings.trimEdges ng-change=onChangeInternal()>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"agg.type === 'histogram'\">\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Interval</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.interval ng-blur=onChangeInternal()>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Min Doc Count</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.min_doc_count ng-blur=onChangeInternal()>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"agg.type === 'terms'\">\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Order</label>\n\t\t\t<gf-form-dropdown model=agg.settings.order lookup-text=true get-options=getOrderOptions() on-change=onChangeInternal() label-mode=true css-class=width-12>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Size</label>\n\t\t\t<gf-form-dropdown model=agg.settings.size lookup-text=true get-options=getSizeOptions() on-change=onChangeInternal() label-mode=true allow-custom=true css-class=width-12>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Min Doc Count</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.min_doc_count ng-blur=onChangeInternal()>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Order By</label>\n\t\t\t<gf-form-dropdown model=agg.settings.orderBy lookup-text=true get-options=getOrderByOptions() on-change=onChangeInternal() label-mode=true css-class=width-12>\n\t\t\t</gf-form-dropdown>\n\t\t</div>\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">\n\t\t\t\tMissing\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\tThe missing parameter defines how documents that are missing a value should be treated. By default they will be ignored but it is also possible to treat them as if they had a value\n\t\t\t\t</info-popover>\n\t\t\t</label>\n\t\t\t<input type=text class=\"gf-form-input max-width-12\" empty-to-null ng-model=agg.settings.missing ng-blur=onChangeInternal() spellcheck=false>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"agg.type === 'filters'\">\n\t\t<div class=\"gf-form-inline offset-width-7\" ng-repeat=\"filter in agg.settings.filters\">\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-10\">Query {{$index + 1}}</label>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-12\" ng-model=filter.query spellcheck=false placeholder=\"Lucene query\" ng-blur=onChangeInternal()>\n\t\t\t\t<label class=\"gf-form-label width-10\">Label {{$index + 1}}</label>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-12\" ng-model=filter.label spellcheck=false placeholder=Label ng-blur=onChangeInternal()>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=gf-form-label ng-if=$first>\n\t\t\t\t\t<a class=pointer ng-click=addFiltersQuery()><i class=\"fa fa-plus\"></i></a>\n\t\t\t\t</label>\n\t\t\t\t<label class=gf-form-label ng-if=!$first>\n\t\t\t\t\t<a class=pointer ng-click=removeFiltersQuery(filter)><i class=\"fa fa-minus\"></i></a>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"agg.type === 'geohash_grid'\">\n\t\t<div class=\"gf-form offset-width-7\">\n\t\t\t<label class=\"gf-form-label width-10\">Precision</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.precision spellcheck=false placeholder=3 ng-blur=onChangeInternal()>\n\t\t</div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 867 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:9200>\n</datasource-http-settings>\n\n<h3 class=page-heading>Elasticsearch details</h3>\n\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-25\">\n\t\t\t<span class=\"gf-form-label width-9\">Index name</span>\n\t\t\t<input class=gf-form-input type=text ng-model=ctrl.current.database placeholder=\"\" required>\n\t\t</div>\n\n\t\t<div class=\"gf-form width-14\">\n      <span class=\"gf-form-label width-9\">Pattern</span>\n      <span class=gf-form-select-wrapper>\n          <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.interval ng-options=\"f.value as f.name for f in ctrl.indexPatternTypes\" ng-change=ctrl.indexPatternTypeChanged()></select>\n      </span>\n\t\t</div>\n\t</div>\n\n\t<div class=\"gf-form max-width-25\">\n\t\t<span class=\"gf-form-label width-9\">Time field name</span>\n\t\t<input class=gf-form-input type=text ng-model=ctrl.current.jsonData.timeField placeholder=\"\" required ng-init=\"\">\n\t</div>\n\n\t<div class=gf-form>\n    <span class=\"gf-form-label width-9\">Version</span>\n    <span class=gf-form-select-wrapper>\n        <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.esVersion ng-options=\"f.value as f.name for f in ctrl.esVersions\"></select>\n    </span>\n\t</div>\n    <div class=\"gf-form max-width-30\" ng-if=\"ctrl.current.jsonData.esVersion>=56\">\n        <span class=\"gf-form-label width-15\">Max concurrent Shard Requests</span>\n        <input class=gf-form-input type=text ng-model=ctrl.current.jsonData.maxConcurrentShardRequests placeholder=\"\" required>\n    </div>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-9\">Min time interval</span>\n\t\t\t<input type=text class=\"gf-form-input width-6\" ng-model=ctrl.current.jsonData.timeInterval spellcheck=false placeholder=10s>\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tA lower limit for the auto group by time interval. Recommended to be set to write frequency,\n\t\t\t\tfor example <code>1m</code> if your data is written every minute.\n\t\t\t</info-popover>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 868 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/metric_agg.html';
var html = "<div class=gf-form-inline ng-class=\"{'gf-form-disabled': agg.hide}\">\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\tMetric\n\t\t\t&nbsp;\n\t\t\t<a ng-click=toggleShowMetric() bs-tooltip=\"'Click to toggle show / hide metric'\">\n\t\t\t\t<i class=\"fa fa-eye\" ng-hide=agg.hide></i>\n\t\t\t\t<i class=\"fa fa-eye-slash\" ng-show=agg.hide></i>\n\t\t\t</a>\n\t\t</label>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<metric-segment-model property=agg.type options=metricAggTypes on-change=onTypeChange() custom=false css-class=width-10></metric-segment-model>\n\t\t<metric-segment-model ng-if=aggDef.requiresField property=agg.field get-options=getFieldsInternal() on-change=onChange() css-class=width-12></metric-segment-model>\n\t\t<metric-segment-model ng-if=aggDef.isPipelineAgg property=agg.pipelineAgg options=pipelineAggOptions on-change=onChangeInternal() custom=false css-class=width-12></metric-segment-model>\n\t</div>\n\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<label class=\"gf-form-label gf-form-label--grow\">\n\t\t\t<a ng-click=toggleOptions() ng-if=settingsLinkText>\n\t\t\t\t<i class=\"fa fa-caret-down\" ng-show=showOptions></i>\n\t\t\t\t<i class=\"fa fa-caret-right\" ng-hide=showOptions></i>\n\t\t\t\t\t{{settingsLinkText}}\n\t\t\t</a>\n\t\t</label>\n\t</div>\n\n\t<div class=gf-form>\n\t\t<label class=gf-form-label ng-if=isFirst>\n\t\t\t<a class=pointer ng-click=addMetricAgg()><i class=\"fa fa-plus\"></i></a>\n\t\t</label>\n\t\t<label class=gf-form-label ng-if=!isSingle>\n\t\t\t<a class=pointer ng-click=removeMetricAgg()><i class=\"fa fa-minus\"></i></a>\n\t\t</label>\n\t</div>\n</div>\n\n<div class=gf-form-group ng-if=showOptions>\n\t<div class=\"gf-form offset-width-7\" ng-if=\"agg.type === 'derivative'\">\n\t\t<label class=\"gf-form-label width-10\">Unit</label>\n\t\t<input type=text class=\"gf-form-input max-width-12\" ng-model=agg.settings.unit ng-blur=onChangeInternal() spellcheck=false>\n\t</div>\n\n  <div ng-if=\"agg.type === 'moving_avg'\">\n    <div class=\"gf-form offset-width-7\">\n      <label class=\"gf-form-label width-10\">Model</label>\n      <metric-segment-model property=agg.settings.model options=movingAvgModelTypes on-change=onChangeClearInternal() custom=false css-class=width-12></metric-segment-model>\n    </div>\n\n    <div class=\"gf-form offset-width-7\">\n      <label class=\"gf-form-label width-10\">Window</label>\n      <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.window ng-blur=onChangeInternal() spellcheck=false>\n    </div>\n\n    <div class=\"gf-form offset-width-7\">\n      <label class=\"gf-form-label width-10\">Predict</label>\n      <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.predict ng-blur=onChangeInternal() spellcheck=false>\n    </div>\n\n\n    <div class=\"gf-form offset-width-7\" ng-repeat=\"setting in modelSettings\">\n      <label class=\"gf-form-label width-10\">{{setting.text}}</label>\n      <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.settings[setting.value] ng-blur=onChangeInternal() spellcheck=false>\n    </div>\n\n    <gf-form-switch ng-if=\"agg.settings.model == 'holt_winters'\" class=\"gf-form offset-width-7\" label=Pad label-class=width-10 checked=agg.settings.settings.pad on-change=onChangeInternal()></gf-form-switch>\n    <gf-form-switch ng-if=\"agg.settings.model.match('ewma|holt_winters|holt') !== null\" class=\"gf-form offset-width-7\" label=Minimize label-class=width-10 checked=agg.settings.minimize on-change=onChangeInternal()></gf-form-switch>\n  </div>\n\n  <div class=\"gf-form offset-width-7\" ng-if=\"agg.type === 'percentiles'\">\n    <label class=\"gf-form-label width-10\">Percentiles</label>\n    <input type=text class=\"gf-form-input max-width-12\" ng-model=agg.settings.percents array-join ng-blur=onChange()>\n  </div>\n  <div class=\"gf-form offset-width-7\" ng-if=\"agg.type === 'raw_document'\">\n    <label class=\"gf-form-label width-10\">Size</label>\n    <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.size ng-blur=onChange()>\n  </div>\n\n\n  <div class=\"gf-form offset-width-7\" ng-if=\"agg.type === 'cardinality'\">\n    <label class=\"gf-form-label width-10\">Precision threshold</label>\n    <input type=number class=\"gf-form-input max-width-12\" ng-model=agg.settings.precision_threshold ng-blur=onChange()>\n  </div>\n\n  <div ng-if=\"agg.type === 'extended_stats'\">\n    <gf-form-switch ng-repeat=\"stat in extendedStats\" class=\"gf-form offset-width-7\" label={{stat.text}} label-class=width-10 checked=agg.meta[stat.value] on-change=onChangeInternal()></gf-form-switch>\n\n    <div class=\"gf-form offset-width-7\">\n      <label class=\"gf-form-label width-10\">Sigma</label>\n      <input type=number class=\"gf-form-input max-width-12\" placeholder=3 ng-model=agg.settings.sigma ng-blur=onChange()>\n    </div>\n  </div>\n\n  <div class=\"gf-form offset-width-7\" ng-if=aggDef.supportsInlineScript>\n    <label class=\"gf-form-label width-10\">Script</label>\n    <input type=text class=\"gf-form-input max-width-12\" empty-to-null ng-model=agg.inlineScript ng-blur=onChangeInternal() spellcheck=false placeholder=\"_value * 1\">\n  </div>\n\n  <div class=\"gf-form offset-width-7\" ng-if=aggDef.supportsMissing>\n\t\t<label class=\"gf-form-label width-10\">\n\t\t\tMissing\n\t\t\t<tip>The missing parameter defines how documents that are missing a value should be treated. By default they will be ignored but it is also possible to treat them as if they had a value</tip>\n\t\t</label>\n\t\t<input type=number class=\"gf-form-input max-width-12\" empty-to-null ng-model=agg.settings.missing ng-blur=onChangeInternal() spellcheck=false>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 869 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/elasticsearch/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=true>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<label class=\"gf-form-label query-keyword width-7\">Query</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.query spellcheck=false placeholder=\"Lucene query\" ng-blur=ctrl.refresh()>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<label class=\"gf-form-label query-keyword\">Alias</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.alias spellcheck=false placeholder=\"alias patterns\" ng-blur=ctrl.refresh()>\n\t\t</div>\n\t</div>\n\n\t<div ng-repeat=\"agg in ctrl.target.metrics\">\n\t\t<elastic-metric-agg target=ctrl.target index=$index get-fields=ctrl.getFields($fieldType) on-change=ctrl.queryUpdated() es-version=ctrl.esVersion>\n\t\t</elastic-metric-agg>\n\t</div>\n\n\t<div ng-repeat=\"agg in ctrl.target.bucketAggs\">\n\t\t<elastic-bucket-agg target=ctrl.target index=$index get-fields=ctrl.getFields($fieldType) on-change=ctrl.queryUpdated()>\n\t\t</elastic-bucket-agg>\n\t</div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 870 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/grafana-live/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<label class=\"gf-form-label width-8\">Stream</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.stream spellcheck=false placeholder=metric>\n\t\t</div>\n\t</div>\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 871 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/grafana/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-8\">\n\t\t\t\tFilter by\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li>Dashboard: This will fetch annotation and alert state changes for whole dashboard and show them only on the event's originating panel.</li>\n\t\t\t\t\t\t<li>All: This will fetch any annotation events that match the tags filter.</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</info-popover>\n\t\t\t</span>\n\t\t\t<div class=\"gf-form-select-wrapper width-9\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.annotation.type ng-options=\"f.value as f.text for f in ctrl.types\">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form ng-if=\"ctrl.annotation.type === 'tags'\">\n\t\t\t<span class=gf-form-label>Tags</span>\n\t\t\t<bootstrap-tagsinput ng-model=ctrl.annotation.tags tagclass=\"label label-tag\" placeholder=\"add tags\">\n\t\t\t</bootstrap-tagsinput>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Max limit</span>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.annotation.limit ng-options=\"f for f in [10,50,100,200,300,500,1000,2000]\">\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 872 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/grafana/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<label class=gf-form-label>Test data: random walk</label>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 873 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/graphite/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n  <div class=gf-form>\n    <span class=\"gf-form-label width-12\">Graphite query</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.target placeholder=\"Example: statsd.application.counters.*.count\">\n  </div>\n\n\t<h5 class=section-heading>Or</h5>\n\n  <div class=gf-form>\n    <span class=\"gf-form-label width-12\">Graphite events tags</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.tags placeholder=\"Example: event_tag_name\">\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 874 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/graphite/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:8080>\n</datasource-http-settings>\n\n<h3 class=page-heading>Graphite details</h3>\n\n<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-8\">\n      Version\n      <info-popover mode=right-normal position=\"top center\">\n        This option controls what functions are available in the Graphite query editor.\n      </info-popover>\n    </span>\n    <span class=gf-form-select-wrapper>\n        <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.graphiteVersion ng-options=\"f.value as f.name for f in ctrl.graphiteVersions\"></select>\n    </span>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 875 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/graphite/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl has-text-edit-mode=true>\n\n  <div class=gf-form ng-show=ctrl.target.textEditor>\n    <input type=text class=gf-form-input ng-model=ctrl.target.target spellcheck=false ng-blur=ctrl.targetTextChanged()>\n  </div>\n\n  <div ng-hide=ctrl.target.textEditor>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-6 query-keyword\">Series</label>\n      </div>\n\n      <div ng-if=ctrl.queryModel.seriesByTagUsed ng-repeat=\"tag in ctrl.queryModel.tags\" class=gf-form>\n        <gf-form-dropdown model=tag.key allow-custom=true label-mode=true debounce=true placeholder=\"Tag key\" css-class=query-segment-key get-options=\"ctrl.getTags($index, $query)\" on-change=\"ctrl.tagChanged(tag, $index)\"/>\n        <gf-form-dropdown model=tag.operator label-mode=true css-class=query-segment-operator get-options=ctrl.getTagOperators() on-change=\"ctrl.tagChanged(tag, $index)\" min-input-width=30 />\n        <gf-form-dropdown model=tag.value allow-custom=true label-mode=true debounce=true css-class=query-segment-value placeholder=\"Tag value\" get-options=\"ctrl.getTagValues(tag, $index, $query)\" on-change=\"ctrl.tagChanged(tag, $index)\"/>\n        <label class=\"gf-form-label query-keyword\" ng-if=ctrl.showDelimiter($index)>AND</label>\n      </div>\n\n      <div ng-if=ctrl.queryModel.seriesByTagUsed ng-repeat=\"segment in ctrl.addTagSegments\" role=menuitem class=gf-form>\n        <metric-segment segment=segment get-options=ctrl.getTagsAsSegments($query) on-change=ctrl.addNewTag(segment) debounce=true />\n      </div>\n\n      <div ng-if=!ctrl.queryModel.seriesByTagUsed ng-repeat=\"segment in ctrl.segments\" role=menuitem class=gf-form>\n        <metric-segment segment=segment get-options=\"ctrl.getAltSegments($index, $query)\" on-change=\"ctrl.segmentValueChanged(segment, $index)\"/>\n      </div>\n\n      <div ng-if=ctrl.paused class=gf-form>\n        <a ng-click=ctrl.unpause() class=\"gf-form-label query-part\"><i class=\"fa fa-play\"></i></a>\n      </div>\n\n      <div class=\"gf-form gf-form--grow\">\n        <div class=\"gf-form-label gf-form-label--grow\"></div>\n      </div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-6 query-keyword\">Functions</label>\n      </div>\n\n      <div ng-repeat=\"func in ctrl.queryModel.functions\" class=gf-form>\n        <span graphite-func-editor class=\"gf-form-label query-part\" ng-hide=func.hidden></span>\n      </div>\n\n      <div class=\"gf-form dropdown\">\n        <span graphite-add-func></span>\n      </div>\n\n      <div class=\"gf-form gf-form--grow\">\n        <div class=\"gf-form-label gf-form-label--grow\"></div>\n      </div>\n    </div>\n  </div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 876 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/influxdb/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.query placeholder=\"select text from events where $timeFilter limit 1000\">\n\t</div>\n</div>\n\n<h5 class=section-heading>Field mappings <tip>If your influxdb query returns more than one field you need to specify the column names below. An annotation event is composed of a title, tags, and an additional text field.</tip></h5>\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-4\">Text</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-model=ctrl.annotation.textColumn placeholder=\"\">\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-4\">Tags</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-model=ctrl.annotation.tagsColumn placeholder=\"\">\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.annotation.titleColumn>\n\t\t\t<span class=\"gf-form-label width-4\">Title <em class=muted>(deprecated)</em></span>\n\t\t\t<input type=text class=\"gf-form-input max-width-10\" ng-model=ctrl.annotation.titleColumn placeholder=\"\">\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 877 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/influxdb/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:8086>\n</datasource-http-settings>\n\n<h3 class=page-heading>InfluxDB Details</h3>\n\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-30\">\n\t\t\t<span class=\"gf-form-label width-7\">Database</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.database placeholder=\"\" required>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.user placeholder=\"\">\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=password class=gf-form-input ng-model=ctrl.current.password placeholder=\"\">\n\t\t</div>\n\t</div>\n</div>\n\n\n<div class=gf-form-group>\n\t<div class=grafana-info-box>\n\t\t<h5>Database Access</h5>\n\t\t<p>\n\t\t\tSetting the database for this datasource does not deny access to other databases.  The InfluxDB query syntax allows\n\t\t\tswitching the database in the query.  For example:\n\t\t\t<code>SHOW MEASUREMENTS ON _internal</code> or <code>SELECT * FROM \"_internal\"..\"database\" LIMIT 10</code>\n\t\t\t<br/><br/>\n\t\t\tTo support data isolation and security, make sure appropriate permissions are configured in InfluxDB.\n\t\t</p>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Min time interval</span>\n\t\t\t<input type=text class=\"gf-form-input width-6\" ng-model=ctrl.current.jsonData.timeInterval spellcheck=false placeholder=10s>\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tA lower limit for the auto group by time interval. Recommended to be set to write frequency,\n\t\t\t\tfor example <code>1m</code> if your data is written every minute.\n\t\t\t</info-popover>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/influxdb/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=true has-text-edit-mode=true>\n\n\t<div ng-if=ctrl.target.rawQuery>\n    <div class=gf-form>\n      <textarea rows=3 class=gf-form-input ng-model=ctrl.target.query spellcheck=false placeholder=\"InfuxDB Query\" ng-model-onblur ng-change=ctrl.refresh()></textarea>\n    </div>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword\">FORMAT AS</label>\n        <div class=gf-form-select-wrapper>\n          <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.resultFormat ng-options=\"f.value as f.text for f in ctrl.resultFormats\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=\"gf-form max-width-25\" ng-hide=\"ctrl.target.resultFormat === 'table'\">\n        <label class=\"gf-form-label query-keyword\">ALIAS BY</label>\n        <input type=text class=gf-form-input ng-model=ctrl.target.alias spellcheck=false placeholder=\"Naming pattern\" ng-blur=ctrl.refresh()>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n        <div class=\"gf-form-label gf-form-label--grow\"></div>\n      </div>\n    </div>\n  </div>\n\n\t<div ng-if=!ctrl.target.rawQuery>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword width-7\">FROM</label>\n\n\t\t\t\t<metric-segment segment=ctrl.policySegment get-options=ctrl.getPolicySegments() on-change=ctrl.policyChanged()></metric-segment>\n\t\t\t\t<metric-segment segment=ctrl.measurementSegment get-options=ctrl.getMeasurements($query) on-change=ctrl.measurementChanged()></metric-segment>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword\">WHERE</label>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form ng-repeat=\"segment in ctrl.tagSegments\">\n\t\t\t\t<metric-segment segment=segment get-options=\"ctrl.getTagsOrValues(segment, $index)\" on-change=\"ctrl.tagSegmentUpdated(segment, $index)\"></metric-segment>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-inline ng-repeat=\"selectParts in ctrl.queryModel.selectModels\">\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\t\t\t<span ng-show=\"$index === 0\">SELECT</span>&nbsp;\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form ng-repeat=\"part in selectParts\">\n\t\t\t\t<query-part-editor class=\"gf-form-label query-part\" part=part handle-event=\"ctrl.handleSelectPartEvent(selectParts, part, $event)\">\n\t\t\t\t</query-part-editor>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=dropdown dropdown-typeahead=ctrl.selectMenu dropdown-typeahead-on-select=\"ctrl.addSelectPart(selectParts, $item, $subItem)\">\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword width-7\">\n\t\t\t\t\t<span>GROUP BY</span>\n\t\t\t\t</label>\n\n\t\t\t\t<query-part-editor ng-repeat=\"part in ctrl.queryModel.groupByParts\" part=part class=\"gf-form-label query-part\" handle-event=\"ctrl.handleGroupByPartEvent(part, $index, $event)\">\n\t\t\t\t</query-part-editor>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<metric-segment segment=ctrl.groupBySegment get-options=ctrl.getGroupByOptions() on-change=\"ctrl.groupByAction(part, $index)\"></metric-segment>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n\t\t</div>\n\n    <div class=gf-form-inline ng-if=\"ctrl.target.orderByTime === 'DESC'\">\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword width-7\">ORDER BY</label>\n        <label class=\"gf-form-label pointer\" ng-click=ctrl.removeOrderByTime()>time <span class=query-keyword>DESC</span> <i class=\"fa fa-remove\"></i></label>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n    </div>\n\n    <div class=gf-form-inline ng-if=ctrl.target.limit>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword width-7\">LIMIT</label>\n        <input type=text class=\"gf-form-input width-9\" ng-model=ctrl.target.limit spellcheck=false placeholder=\"No Limit\" ng-blur=ctrl.refresh()>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n    </div>\n\n    <div class=gf-form-inline ng-if=ctrl.target.slimit>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword width-7\">SLIMIT</label>\n        <input type=text class=\"gf-form-input width-9\" ng-model=ctrl.target.slimit spellcheck=false placeholder=\"No Limit\" ng-blur=ctrl.refresh()>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label query-keyword width-7\">FORMAT AS</label>\n        <div class=gf-form-select-wrapper>\n          <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.resultFormat ng-options=\"f.value as f.text for f in ctrl.resultFormats\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n        <div class=\"gf-form-label gf-form-label--grow\"></div>\n      </div>\n    </div>\n\n    <div class=gf-form-inline ng-hide=\"ctrl.target.resultFormat === 'table'\">\n      <div class=\"gf-form max-width-30\">\n        <label class=\"gf-form-label query-keyword width-7\">ALIAS BY</label>\n        <input type=text class=gf-form-input ng-model=ctrl.target.alias spellcheck=false placeholder=\"Naming pattern\" ng-blur=ctrl.refresh()>\n      </div>\n      <div class=\"gf-form gf-form--grow\">\n        <div class=\"gf-form-label gf-form-label--grow\"></div>\n      </div>\n    </div>\n  </div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 879 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mssql/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n  <div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<textarea rows=10 class=gf-form-input ng-model=ctrl.annotation.rawQuery spellcheck=false placeholder=\"query expression\" data-min-length=0 data-items=100 ng-model-onblur ng-change=ctrl.panelCtrl.refresh()></textarea>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n  </div>\n\n  <div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\"><h6>Annotation Query Format</h6>\nAn annotation is an event that is overlaid on top of graphs. The query can have up to three columns per row, the <b>time</b> column is mandatory. Annotation rendering is expensive so it is important to limit the number of rows returned.\n\n- column with alias: <b>time</b> for the annotation event time. Use epoch time or any native date data type.\n- column with alias: <b>text</b> for the annotation text.\n- column with alias: <b>tags</b> for annotation tags. This is a comma separated string of tags e.g. 'tag1,tag2'.\n\n\nMacros:\n- $__time(column) -&gt; column AS time\n- $__timeEpoch(column) -&gt; DATEDIFF(second, '1970-01-01', column) AS time\n- $__timeFilter(column) -&gt; column &gt;= DATEADD(s, 18446744066914186738, '1970-01-01') AND column &lt;= DATEADD(s, 18446744066914187038, '1970-01-01')\n- $__unixEpochFilter(column) -&gt; column &gt;= 1492750877 AND column &lt;= 1492750877\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt; DATEADD(second, 1492750877, '1970-01-01')\n- $__timeTo() -&gt; DATEADD(second, 1492750877, '1970-01-01')\n- $__unixEpochFrom() -&gt; 1492750877\n- $__unixEpochTo() -&gt; 1492750877\n\t\t</pre>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 880 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mssql/partials/config.html';
var html = "\n<h3 class=page-heading>MSSQL Connection</h3>\n\n<div class=gf-form-group>\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Host</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.url placeholder=localhost:1433 bs-typeahead=\"{{['localhost', 'localhost:1433']}}\" required>\n\t</div>\n\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Database</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.database placeholder=\"database name\" required>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.user placeholder=user>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\" ng-if=!ctrl.current.secureJsonFields.password>\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=password class=gf-form-input ng-model=ctrl.current.secureJsonData.password placeholder=password>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-19\" ng-if=ctrl.current.secureJsonFields.password>\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=text class=gf-form-input disabled=disabled value=configured>\n\t\t\t<a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"ctrl.current.secureJsonFields.password = false\">reset</a>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<div class=grafana-info-box>\n\t\t<h5>User Permission</h5>\n\t\t<p>\n\t\t\tThe database user should only be granted SELECT permissions on the specified database &amp; tables you want to query.\n\t\t\tGrafana does not validate that queries are safe so queries can contain any SQL statement. For example, statements\n\t\t\tlike <code>USE otherdb;</code> and <code>DROP TABLE user;</code> would be executed. To protect against this we\n\t\t\t<strong>Highly</strong> recommmend you create a specific MSSQL user with restricted permissions.\n\t\t</p>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 881 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mssql/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<code-editor content=ctrl.target.rawSql datasource=ctrl.datasource on-change=ctrl.panelCtrl.refresh() data-mode=sqlserver>\n\t\t\t</code-editor>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Format as</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.format ng-options=\"f.value as f.text for f in ctrl.formats\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.lastQueryMeta>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showLastQuerySQL = !ctrl.showLastQuerySQL\">\n        Generated SQL\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showLastQuerySQL></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showLastQuerySQL></i>\n      </label>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showLastQuerySQL>\n\t\t<pre class=gf-form-pre>{{ctrl.lastQueryMeta.sql}}</pre>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\">Time series:\n- return column named time (in UTC), as a unix time stamp or any sql native date data type. You can use the macros below.\n- optional: return column named metric to represent the series names.\n- any other columns returned will be the time point values.\n- if multiple value columns are present and a metric column is provided. the series name will be the combination of \"MetricName - ValueColumnName\".\n\nTable:\n- return any set of columns\n\nMacros:\n- $__time(column) -&gt; column AS time\n- $__timeEpoch(column) -&gt; DATEDIFF(second, '1970-01-01', column) AS time\n- $__timeFilter(column) -&gt; column &gt;= DATEADD(s, 18446744066914186738, '1970-01-01') AND column &lt;= DATEADD(s, 18446744066914187038, '1970-01-01')\n- $__unixEpochFilter(column) -&gt; column &gt;= 1492750877 AND column &lt;= 1492750877\n- $__timeGroup(column, '5m'[, fillvalue]) -&gt; CAST(ROUND(DATEDIFF(second, '1970-01-01', column)/300.0, 0) as bigint)*300. Providing a <i>fillValue</i> of <i>NULL</i> or floating value will automatically fill empty series in timerange with that value.\n\nExample of group by and order by with $__timeGroup:\nSELECT\n  $__timeGroup(date_time_col, '1h') AS time,\n  sum(value) as value\nFROM yourtable\nGROUP BY $__timeGroup(date_time_col, '1h')\nORDER BY 1\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt; DATEADD(second, 1492750877, '1970-01-01')\n- $__timeTo() -&gt; DATEADD(second, 1492750877, '1970-01-01')\n- $__unixEpochFrom() -&gt; 1492750877\n- $__unixEpochTo() -&gt; 1492750877\n\t\t</pre>\n\t</div>\n\n\t\n\n\t<div class=gf-form ng-show=ctrl.lastQueryError>\n\t\t<pre class=\"gf-form-pre alert alert-error\">{{ctrl.lastQueryError}}</pre>\n\t</div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 882 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mysql/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n  <div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<textarea rows=10 class=gf-form-input ng-model=ctrl.annotation.rawQuery spellcheck=false placeholder=\"query expression\" data-min-length=0 data-items=100 ng-model-onblur ng-change=ctrl.panelCtrl.refresh()></textarea>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n  </div>\n\n  <div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\"><h6>Annotation Query Format</h6>\nAn annotation is an event that is overlaid on top of graphs. The query can have up to three columns per row, the <i>time</i> or <i>time_sec</i> column is mandatory. Annotation rendering is expensive so it is important to limit the number of rows returned.\n\n- column with alias: <b>time</b> or <i>time_sec</i> for the annotation event time. Use epoch time or any native date data type.\n- column with alias: <b>text</b> for the annotation text\n- column with alias: <b>tags</b> for annotation tags. This is a comma separated string of tags e.g. 'tag1,tag2'\n\n\nMacros:\n- $__time(column) -&gt; UNIX_TIMESTAMP(column) as time (or as time_sec)\n- $__timeEpoch(column) -&gt; UNIX_TIMESTAMP(column) as time (or as time_sec)\n- $__timeFilter(column) -&gt;  UNIX_TIMESTAMP(time_date_time) &gt; 1492750877 AND UNIX_TIMESTAMP(time_date_time) &lt; 1492750877\n- $__unixEpochFilter(column) -&gt;  time_unix_epoch &gt; 1492750877 AND time_unix_epoch &lt; 1492750877\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt;  FROM_UNIXTIME(1492750877)\n- $__timeTo() -&gt;  FROM_UNIXTIME(1492750877)\n- $__unixEpochFrom() -&gt;  1492750877\n- $__unixEpochTo() -&gt;  1492750877\n\t\t</pre>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 883 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mysql/partials/config.html';
var html = "\n<h3 class=page-heading>MySQL Connection</h3>\n\n<div class=gf-form-group>\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Host</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.url placeholder=localhost:3306 bs-typeahead=\"{{['localhost:3306', 'localhost:3307']}}\" required>\n\t</div>\n\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Database</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.database placeholder=\"database name\" required>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.user placeholder=user>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=password class=gf-form-input ng-model=ctrl.current.password placeholder=password>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<div class=grafana-info-box>\n\t\t<h5>User Permission</h5>\n\t\t<p>\n\t\t\tThe database user should only be granted SELECT permissions on the specified database &amp; tables you want to query.\n\t\t\tGrafana does not validate that queries are safe so queries can contain any SQL statement. For example, statements\n\t\t\tlike <code>USE otherdb;</code> and <code>DROP TABLE user;</code> would be executed. To protect against this we\n\t\t\t<strong>Highly</strong> recommmend you create a specific MySQL user with restricted permissions.\n\n\t\t\tCheckout the <a class=external-link target=_blank href=http://docs.grafana.org/features/datasources/mysql/ >MySQL Data Source Docs</a> for more information.\n\t\t</p>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 884 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/mysql/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<code-editor content=ctrl.target.rawSql datasource=ctrl.datasource on-change=ctrl.panelCtrl.refresh() data-mode=sql>\n\t\t\t</code-editor>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Format as</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.format ng-options=\"f.value as f.text for f in ctrl.formats\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.lastQueryMeta>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showLastQuerySQL = !ctrl.showLastQuerySQL\">\n        Generated SQL\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showLastQuerySQL></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showLastQuerySQL></i>\n      </label>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showLastQuerySQL>\n\t\t<pre class=gf-form-pre>{{ctrl.lastQueryMeta.sql}}</pre>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\">Time series:\n- return column named time or time_sec (in UTC), as a unix time stamp or any sql native date data type. You can use the macros below.\n- return column(s) with numeric datatype as values\n- (Optional: return column named <i>metric</i> to represent the series name. If no column named metric is found the column name of the value column is used as series name)\n\nTable:\n- return any set of columns\n\nMacros:\n- $__time(column) -&gt; UNIX_TIMESTAMP(column) as time_sec\n- $__timeEpoch(column) -&gt; UNIX_TIMESTAMP(column) as time_sec\n- $__timeFilter(column) -&gt;  UNIX_TIMESTAMP(time_date_time) &ge; 1492750877 AND UNIX_TIMESTAMP(time_date_time) &le; 1492750877\n- $__unixEpochFilter(column) -&gt;  time_unix_epoch &gt; 1492750877 AND time_unix_epoch &lt; 1492750877\n- $__timeGroup(column,'5m') -&gt; cast(cast(UNIX_TIMESTAMP(column)/(300) as signed)*300 as signed)\n\nExample of group by and order by with $__timeGroup:\nSELECT\n  $__timeGroup(timestamp_col, '1h') AS time,\n  sum(value_double) as value\nFROM yourtable\nGROUP BY 1\nORDER BY 1\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt;  FROM_UNIXTIME(1492750877)\n- $__timeTo() -&gt;  FROM_UNIXTIME(1492750877)\n- $__unixEpochFrom() -&gt;  1492750877\n- $__unixEpochTo() -&gt;  1492750877\n\t\t</pre>\n\t</div>\n\n\t\n\n\t<div class=gf-form ng-show=ctrl.lastQueryError>\n\t\t<pre class=\"gf-form-pre alert alert-error\">{{ctrl.lastQueryError}}</pre>\n\t</div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 885 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/opentsdb/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n  <div class=gf-form>\n    <span class=\"gf-form-label width-13\">OpenTSDB metrics query</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.target placeholder=events.eventname>\n  </div>\n  <gf-form-switch class=gf-form label=\"Show Global Annotations?\" checked=ctrl.annotation.isGlobal switch-class=max-width-6 label-class=width-13></gf-form-switch>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 886 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/opentsdb/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:4242></datasource-http-settings>\n\n<h5>OpenTSDB settings</h5>\n<div class=gf-form>\n  <span class=\"gf-form-label width-7\">\n    Version\n  </span>\n  <span class=gf-form-select-wrapper>\n    <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.tsdbVersion ng-options=\"v.value as v.name for v in ctrl.tsdbVersions\"></select>\n  </span>\n</div>\n<div class=gf-form>\n  <span class=\"gf-form-label width-7\">\n    Resolution\n  </span>\n  <span class=gf-form-select-wrapper>\n    <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.current.jsonData.tsdbResolution ng-options=\"v.value as v.name for v in ctrl.tsdbResolutions\"></select>\n  </span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 887 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/opentsdb/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-25\">\n\t\t\t<label class=\"gf-form-label query-keyword width-8\">\n\t\t\t\tMetric\n\t\t\t\t<label class=gf-form-label bs-tooltip=ctrl.errors.metric style=color:#e5bd1c ng-show=ctrl.errors.metric>\n\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t</label>\n\t\t\t</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.metric spellcheck=false bs-typeahead=ctrl.suggestMetrics placeholder=\"metric name\" data-min-length=0 data-items=100 ng-blur=ctrl.targetBlur()>\n\t\t\t\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">\n\t\t\t\tAggregator\n\t\t\t\t<a bs-tooltip=ctrl.errors.aggregator style=color:#e5bd1c ng-show=ctrl.errors.aggregator>\n\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-15\">\n\t\t\t\t<select ng-model=ctrl.target.aggregator class=gf-form-input ng-options=\"agg for agg in ctrl.aggregators\" ng-change=ctrl.targetBlur()>\n\t\t \t </select>\n\t\t\t</div>\n\t\t</div>\n\t\t\t<div class=\"gf-form max-width-20\">\n\t\t\t\t<label class=\"gf-form-label query-keyword width-6\">\n\t\t\t\t\tAlias:\n\t\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\t\tUse patterns like $tag_tagname to replace part of the alias for a tag value\n\t\t\t\t\t</info-popover>\n\t\t\t\t</label>\n\t\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.alias spellcheck=false placeholder=\"series alias\" data-min-length=0 data-items=100 ng-blur=ctrl.targetBlur()>\n\t\t\t</div>\n\n\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-25\">\n\t\t\t<label class=\"gf-form-label query-keyword width-8\">Down sample</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.downsampleInterval ng-model-onblur ng-change=ctrl.targetBlur() placeholder=interval>\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tblank for auto, or for example <code>1m</code>\n\t\t\t</info-popover>\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Aggregator</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select ng-model=ctrl.target.downsampleAggregator class=gf-form-input ng-options=\"agg for agg in ctrl.aggregators\" ng-change=ctrl.targetBlur()>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=gf-form ng-if=\"ctrl.tsdbVersion >= 2\">\n\t\t\t<label class=\"gf-form-label query-keyword width-6\">Fill</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select ng-model=ctrl.target.downsampleFillPolicy class=gf-form-input ng-options=\"agg for agg in ctrl.fillPolicies\" ng-change=ctrl.targetBlur()>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<gf-form-switch class=gf-form label=\"Disable downsampling\" label-class=query-keyword checked=ctrl.target.disableDownsampling on-change=ctrl.targetBlur()>\n\t\t</gf-form-switch>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline ng-if=\"ctrl.tsdbVersion >= 2\">\n\t\t<div class=gf-form>\n\n\t\t\t<label class=\"gf-form-label query-keyword width-8\">\n\t\t\t\tFilters\n\t\t\t\t<info-popover mode=right-normal>\n\t\t\t\t\tFilters does not work with tags, either of the two will work but not both.\n\t\t\t\t</info-popover>\n\t\t\t</label>\n\n\t\t\t<div ng-repeat=\"fil in ctrl.target.filters track by $index\" class=gf-form-label>\n\t\t\t\t{{fil.tagk}}&nbsp;=&nbsp;{{fil.type}}&#40;{{fil.filter}}&#41;&nbsp;&#44&nbsp;groupBy&nbsp;=&nbsp;{{fil.groupBy}}\n\t\t\t\t<a ng-click=\"ctrl.editFilter(fil, $index)\">\n\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n\t\t\t\t</a>\n\t\t\t\t<a ng-click=ctrl.removeFilter($index)>\n\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t\t<label class=\"gf-form-label query-keyword\" ng-hide=ctrl.addFilterMode>\n\t\t\t\t<a ng-click=ctrl.addFilter()>\n\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n \t\t</div>\n\n\t\t<div class=gf-form-inline ng-show=ctrl.addFilterMode>\n\t\t\t<div class=gf-form>\n\t\t\t\t<input type=text class=gf-form-input spellcheck=false bs-typeahead=ctrl.suggestTagKeys data-min-length=0 data-items=100 ng-model=ctrl.target.currentFilterKey placeholder=key>\n\t\t\t\t\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label query-keyword\">Type</label>\n\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t<select ng-model=ctrl.target.currentFilterType class=gf-form-input ng-options=\"filType for filType in ctrl.filterTypes\">\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<input type=text class=gf-form-input spellcheck=false bs-typeahead=ctrl.suggestTagValues data-min-length=0 data-items=100 ng-model=ctrl.target.currentFilterValue placeholder=filter>\n\t\t\t\t\n\t\t\t</div>\n\n      <gf-form-switch class=gf-form label=\"Group by\" label-class=query-keyword checked=ctrl.target.currentFilterGroupBy on-change=ctrl.targetBlur()>\n\t\t\t</gf-form-switch>\n\n\t\t\t<div class=gf-form ng-show=ctrl.addFilterMode>\n\t\t\t\t<label class=gf-form-label ng-show=ctrl.errors.filters>\n\t\t\t\t\t<a bs-tooltip=ctrl.errors.filters style=color:#e5bd1c>\n\t\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</label>\n\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t<a ng-click=ctrl.addFilter() ng-hide=ctrl.errors.filters>add filter</a>\n\t\t\t\t\t<a ng-click=ctrl.closeAddFilterMode()>\n\t\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t\t</a>\n\t\t\t\t</label>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword width-8\">\n\t\t\t\tTags\n\t\t\t\t<info-popover mode=right-normal ng-if=\"ctrl.tsdbVersion >= 2\">\n\t\t\t\t\tPlease use filters, tags are deprecated in opentsdb 2.2\n\t\t\t\t</info-popover>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=gf-form ng-repeat=\"(key, value) in ctrl.target.tags track by $index\" class=gf-form>\n\t\t\t<label class=gf-form-label>\n\t\t\t\t{{key}}&nbsp;=&nbsp;{{value}}\n\t\t\t\t<a ng-click=\"ctrl.editTag(key, value)\">\n\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n\t\t\t\t</a>\n\t\t\t\t<a ng-click=ctrl.removeTag(key)>\n\t\t\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=gf-form ng-hide=ctrl.addTagMode>\n\t\t\t<label class=\"gf-form-label query-keyword\">\n\t\t\t\t<a ng-click=ctrl.addTag()><i class=\"fa fa-plus\"></i></a>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=gf-form ng-show=ctrl.addTagMode>\n\t\t\t<input type=text class=gf-form-input spellcheck=false bs-typeahead=ctrl.suggestTagKeys data-min-length=0 data-items=100 ng-model=ctrl.target.currentTagKey placeholder=key>\n\t\t\t\n\n\t\t\t<input type=text class=gf-form-input spellcheck=false bs-typeahead=ctrl.suggestTagValues data-min-length=0 data-items=100 ng-model=ctrl.target.currentTagValue placeholder=value>\n\t\t\t\n\n\t\t\t<label class=gf-form-label ng-show=ctrl.errors.tags>\n\t\t\t\t<a bs-tooltip=ctrl.errors.tags style=color:#e5bd1c>\n\t\t\t\t\t<i class=\"fa fa-warning\"></i>\n\t\t\t\t</a>\n\t\t\t</label>\n\t\t\t<label class=gf-form-label>\n\t\t\t\t<a ng-click=ctrl.addTag() ng-hide=ctrl.errors.tags>add tag</a>\n\t\t\t\t<a ng-click=ctrl.closeAddTagMode()><i class=\"fa fa-remove\"></i></a>\n\t\t\t</label>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<gf-form-switch class=gf-form label=Rate label-class=\"width-8 query-keyword\" checked=ctrl.target.shouldComputeRate on-change=ctrl.targetBlur()>\n\t\t</gf-form-switch>\n\n\t\t<gf-form-switch ng-hide=!ctrl.target.shouldComputeRate class=gf-form label=Counter label-class=query-keyword checked=ctrl.target.isCounter on-change=ctrl.targetBlur()>\n\t\t</gf-form-switch>\n\n\n\t\t<div class=gf-form ng-hide=\"!ctrl.target.isCounter || !ctrl.target.shouldComputeRate\">\n\t\t\t<label class=\"gf-form-label query-keyword\">Counter Max</label>\n\t\t\t<input type=text class=gf-form-input ng-disabled=!ctrl.target.shouldComputeRate ng-model=ctrl.target.counterMax spellcheck=false placeholder=\"max value\" ng-model-onblur ng-blur=ctrl.targetBlur()>\n\t\t\t\n\n\t\t\t<label class=\"gf-form-label query-keyword\">Reset Value</label>\n\t\t\t<input type=text class=\"tight-form-input input-small\" ng-disabled=!ctrl.target.shouldComputeRate ng-model=ctrl.target.counterResetValue spellcheck=false placeholder=\"reset value\" ng-model-onblur ng-blur=ctrl.targetBlur()>\n\t\t\t\n\t\t</div>\n\n\t\t<div class=gf-form ng-if=\"ctrl.tsdbVersion > 2\">\n\t\t\t<gf-form-switch class=gf-form label=\"Explicit tags\" label-class=\"width-8 query-keyword\" checked=ctrl.target.explicitTags on-change=ctrl.targetBlur()>\n\t\t\t</gf-form-switch>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n</query-editor-row>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 888 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/postgres/partials/annotations.editor.html';
var html = "\n<div class=gf-form-group>\n  <div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<textarea rows=10 class=gf-form-input ng-model=ctrl.annotation.rawQuery spellcheck=false placeholder=\"query expression\" data-min-length=0 data-items=100 ng-model-onblur ng-change=ctrl.panelCtrl.refresh()></textarea>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n  </div>\n\n  <div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\"><h6>Annotation Query Format</h6>\nAn annotation is an event that is overlaid on top of graphs. The query can have up to three columns per row, the time column is mandatory. Annotation rendering is expensive so it is important to limit the number of rows returned.\n\n- column with alias: <b>time</b> for the annotation event time. Use epoch time or any native date data type.\n- column with alias: <b>text</b> for the annotation text\n- column with alias: <b>tags</b> for annotation tags. This is a comma separated string of tags e.g. 'tag1,tag2'\n\n\nMacros:\n- $__time(column) -&gt; column as \"time\"\n- $__timeEpoch -&gt; extract(epoch from column) as \"time\"\n- $__timeFilter(column) -&gt; column BETWEEN '2017-04-21T05:01:17Z' AND '2017-04-21T05:01:17Z'\n- $__unixEpochFilter(column) -&gt;  column &gt;= 1492750877 AND column &lt;= 1492750877\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt;  '2017-04-21T05:01:17Z'\n- $__timeTo() -&gt;  '2017-04-21T05:01:17Z'\n- $__unixEpochFrom() -&gt;  1492750877\n- $__unixEpochTo() -&gt;  1492750877\n\t\t</pre>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 889 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/postgres/partials/config.html';
var html = "\n<h3 class=page-heading>PostgreSQL Connection</h3>\n\n<div class=gf-form-group>\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Host</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.url placeholder=localhost:5432 bs-typeahead=\"{{['localhost:5432', 'localhost:5433']}}\" required>\n\t</div>\n\n\t<div class=\"gf-form max-width-30\">\n\t\t<span class=\"gf-form-label width-7\">Database</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.current.database placeholder=\"database name\" required>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form max-width-15\">\n\t\t\t<span class=\"gf-form-label width-7\">User</span>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.current.user placeholder=user>\n\t\t</div>\n\t\t<div class=\"gf-form max-width-15\" ng-if=!ctrl.current.secureJsonFields.password>\n\t\t\t<span class=\"gf-form-label width-7\">Password</span>\n\t\t\t<input type=password class=gf-form-input ng-model=ctrl.current.secureJsonData.password placeholder=password>\n    </div>\n    <div class=\"gf-form max-width-19\" ng-if=ctrl.current.secureJsonFields.password>\n      <span class=\"gf-form-label width-7\">Password</span>\n      <input type=text class=gf-form-input disabled=disabled value=configured>\n      <a class=\"btn btn-secondary gf-form-btn\" href=# ng-click=\"ctrl.current.secureJsonFields.password = false\">reset</a>\n    </div>\n\t</div>\n\t<div class=gf-form>\n\t\t<label class=\"gf-form-label width-7\">SSL Mode</label>\n\t\t<div class=\"gf-form-select-wrapper max-width-15 gf-form-select-wrapper--has-help-icon\">\n\t\t\t<select class=gf-form-input ng-model=ctrl.current.jsonData.sslmode ng-options=\"mode for mode in ['disable', 'require', 'verify-ca', 'verify-full']\" ng-init=ctrl.current.jsonData.sslmode></select>\n\t\t\t<info-popover mode=right-absolute>\n\t\t\t\tThis option determines whether or with what priority a secure SSL TCP/IP connection will be negotiated with the server.\n\t\t\t</info-popover>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<div class=grafana-info-box>\n\t\t<h5>User Permission</h5>\n\t\t<p>\n\t\t\tThe database user should only be granted SELECT permissions on the specified database &amp; tables you want to query.\n\t\t\tGrafana does not validate that queries are safe so queries can contain any SQL statement. For example, statements\n\t\t\tlike <code>DELETE FROM user;</code> and <code>DROP TABLE user;</code> would be executed. To protect against this we\n\t\t\t<strong>Highly</strong> recommmend you create a specific PostgreSQL user with restricted permissions.\n\t\t</p>\n\t</div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 890 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/postgres/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<code-editor content=ctrl.target.rawSql datasource=ctrl.datasource on-change=ctrl.panelCtrl.refresh() data-mode=sql>\n\t\t\t</code-editor>\n\t\t</div>\n\t</div>\n\n  <div class=gf-form-inline>\n    <div class=gf-form>\n\t\t\t<label class=\"gf-form-label query-keyword\">Format as</label>\n\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t<select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.format ng-options=\"f.value as f.text for f in ctrl.formats\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showHelp = !ctrl.showHelp\">\n        Show Help\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showHelp></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showHelp></i>\n      </label>\n\t\t</div>\n\t\t<div class=gf-form ng-show=ctrl.lastQueryMeta>\n      <label class=\"gf-form-label query-keyword\" ng-click=\"ctrl.showLastQuerySQL = !ctrl.showLastQuerySQL\">\n        Generated SQL\n        <i class=\"fa fa-caret-down\" ng-show=ctrl.showLastQuerySQL></i>\n        <i class=\"fa fa-caret-right\" ng-hide=ctrl.showLastQuerySQL></i>\n      </label>\n\t\t</div>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showLastQuerySQL>\n\t\t<pre class=gf-form-pre>{{ctrl.lastQueryMeta.sql}}</pre>\n\t</div>\n\n\t<div class=gf-form ng-show=ctrl.showHelp>\n\t\t<pre class=\"gf-form-pre alert alert-info\">Time series:\n- return column named <i>time</i> (UTC in seconds or timestamp)\n- return column(s) with numeric datatype as values\n- (Optional: return column named <i>metric</i> to represent the series name. If no column named metric is found the column name of the value column is used as series name)\n\nTable:\n- return any set of columns\n\nMacros:\n- $__time(column) -&gt; column as \"time\"\n- $__timeEpoch -&gt; extract(epoch from column) as \"time\"\n- $__timeFilter(column) -&gt; column BETWEEN '2017-04-21T05:01:17Z' AND '2017-04-21T05:01:17Z'\n- $__unixEpochFilter(column) -&gt;  column &gt;= 1492750877 AND column &lt;= 1492750877\n- $__timeGroup(column,'5m') -&gt; (extract(epoch from column)/300)::bigint*300 AS time\n\nExample of group by and order by with $__timeGroup:\nSELECT\n  $__timeGroup(date_time_col, '1h'),\n  sum(value) as value\nFROM yourtable\nGROUP BY time\nORDER BY time\n\nOr build your own conditionals using these macros which just return the values:\n- $__timeFrom() -&gt;  '2017-04-21T05:01:17Z'\n- $__timeTo() -&gt;  '2017-04-21T05:01:17Z'\n- $__unixEpochFrom() -&gt;  1492750877\n- $__unixEpochTo() -&gt;  1492750877\n\t\t</pre>\n\t</div>\n\n\t\n\n\t<div class=gf-form ng-show=ctrl.lastQueryError>\n\t\t<pre class=\"gf-form-pre alert alert-error\">{{ctrl.lastQueryError}}</pre>\n\t</div>\n\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 891 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/prometheus/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-10\">Search expression</span>\n\t\t<input type=text class=gf-form-input ng-model=ctrl.annotation.expr placeholder=ALERTS>\n\t</div>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-10\">step</span>\n\t\t<input type=text class=\"gf-form-input max-width-6\" ng-model=ctrl.annotation.step placeholder=60s>\n\t</div>\n</div>\n\n<div class=gf-form-group>\n\t<h5 class=section-heading>Field formats\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-5\">Title</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-9\" ng-model=ctrl.annotation.titleFormat placeholder=alertname>\n\t\t</div>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-5\">Tags</span>\n\t\t\t<input type=text class=\"gf-form-input max-width-9\" ng-model=ctrl.annotation.tagKeys placeholder=label1,label2>\n\t\t</div>\n\t\t<div class=gf-form-inline>\n\t\t\t<div class=gf-form>\n\t\t\t\t<span class=\"gf-form-label width-5\">Text</span>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-9\" ng-model=ctrl.annotation.textFormat placeholder=instance>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</h5></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 892 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/prometheus/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current suggest-url=http://localhost:9090>\n</datasource-http-settings>\n\n<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-8\">Scrape interval</span>\n\t\t\t<input type=text class=\"gf-form-input width-8\" ng-model=ctrl.current.jsonData.timeInterval spellcheck=false placeholder=15s>\n\t\t\t<info-popover mode=right-absolute>\n                Set this to your global scrape interval defined in your Prometheus config file. This will be used as a lower limit for\n                the Prometheus step query parameter.\n\t\t\t</info-popover>\n\t\t</div>\n  </div>\n\n  <div class=gf-form>\n    <label class=\"gf-form-label width-8\">HTTP Method</label>\n    <div class=\"gf-form-select-wrapper width-8 gf-form-select-wrapper--has-help-icon\">\n      <select class=gf-form-input ng-model=ctrl.current.jsonData.httpMethod ng-options=\"method for method in ['GET', 'POST']\"></select>\n      <info-popover mode=right-absolute>\n        Specify the HTTP Method to query Prometheus. (POST is only available in Prometheus >= v2.1.0)\n      </info-popover>\n    </div>\n  </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 893 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/datasource/prometheus/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=true has-text-edit-mode=false>\n  <div class=gf-form-inline>\n    <div class=\"gf-form gf-form--grow\">\n      <code-editor content=ctrl.target.expr datasource=ctrl.datasource on-change=ctrl.refreshMetricData() get-completer=ctrl.getCompleter() data-mode=prometheus code-editor-focus=ctrl.isLastQuery>\n      </code-editor>\n    </div>\n  </div>\n\n  <div class=gf-form-inline>\n    <div class=\"gf-form max-width-26\">\n      <label class=\"gf-form-label width-8\">Legend format</label>\n      <input type=text class=gf-form-input ng-model=ctrl.target.legendFormat spellcheck=false placeholder=\"legend format\" data-min-length=0 data-items=1000 ng-model-onblur ng-change=ctrl.refreshMetricData()>\n      \n      <info-popover mode=right-absolute>\n        Controls the name of the time series, using name or pattern. For example <span ng-non-bindable>{{hostname}}</span> will be replaced with label value for\n        the label hostname.\n      </info-popover>\n    </div>\n\n    <div class=gf-form>\n      <label class=\"gf-form-label width-6\">Min step</label>\n      <input type=text class=\"gf-form-input width-8\" ng-model=ctrl.target.interval data-placement=right spellcheck=false placeholder={{ctrl.panelCtrl.interval}} data-min-length=0 data-items=100 ng-model-onblur ng-change=ctrl.refreshMetricData() />\n      <info-popover mode=right-absolute>\n        Leave blank for auto handling based on time range and panel width\n      </info-popover>\n    </div>\n\n    <div class=gf-form>\n      <label class=gf-form-label>Resolution</label>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select ng-model=ctrl.target.intervalFactor class=gf-form-input ng-options=\"r.factor as r.label for r in ctrl.resolutions\" ng-change=ctrl.refreshMetricData()>\n        </select>\n      </div>\n    </div>\n\n    <div class=gf-form>\n      <label class=\"gf-form-label width-6\">Format as</label>\n      <div class=\"gf-form-select-wrapper width-8\">\n        <select class=\"gf-form-input gf-size-auto\" ng-model=ctrl.target.format ng-options=\"f.value as f.text for f in ctrl.formats\" ng-change=ctrl.refresh()></select>\n      </div>\n      <gf-form-switch class=gf-form label=Instant label-class=width-5 checked=ctrl.target.instant on-change=ctrl.refresh()>\n      </gf-form-switch>\n      <label class=gf-form-label>\n        <a href={{ctrl.linkToPrometheus}} target=_blank bs-tooltip=\"'Link to Graph in Prometheus'\">\n          <i class=\"fa fa-share-square-o\"></i>\n        </a>\n      </label>\n    </div>\n\n    <div class=\"gf-form gf-form--grow\">\n      <div class=\"gf-form-label gf-form-label--grow\"></div>\n    </div>\n  </div>\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 894 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/alertlist/editor.html';
var html = "<div>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Options</h5>\n    <div class=gf-form>\n      <span class=\"gf-form-label width-8\">Show</span>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select class=gf-form-input ng-model=ctrl.panel.show ng-options=\"f.value as f.text for f in ctrl.showOptions\" ng-change=ctrl.onRefresh()></select>\n      </div>\n    </div>\n    <div class=gf-form>\n      <span class=\"gf-form-label width-8\">Max items</span>\n      <input type=text class=\"gf-form-input max-width-15\" ng-model=ctrl.panel.limit ng-change=ctrl.onRefresh() />\n    </div>\n    <div class=gf-form ng-show=\"ctrl.panel.show === 'current'\">\n      <span class=\"gf-form-label width-8\">Sort order</span>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select class=gf-form-input ng-model=ctrl.panel.sortOrder ng-options=\"f.value as f.text for f in ctrl.sortOrderOptions\" ng-change=ctrl.onRefresh()></select>\n      </div>\n    </div>\n    <gf-form-switch class=gf-form label=\"Alerts from this dashboard\" label-class=width-18 checked=ctrl.panel.onlyAlertsOnDashboard on-change=ctrl.updateStateFilter()></gf-form-switch>\n  </div>\n  <div class=\"section gf-form-group\" ng-show=\"ctrl.panel.show === 'current'\">\n    <h5 class=section-heading>State filter</h5>\n    <gf-form-switch class=gf-form label=Ok label-class=width-10 checked=\"ctrl.stateFilter['ok']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n    <gf-form-switch class=gf-form label=Paused label-class=width-10 checked=\"ctrl.stateFilter['paused']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n    <gf-form-switch class=gf-form label=\"No data\" label-class=width-10 checked=\"ctrl.stateFilter['no_data']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n    <gf-form-switch class=gf-form label=\"Execution error\" label-class=width-10 checked=\"ctrl.stateFilter['execution_error']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n    <gf-form-switch class=gf-form label=Alerting label-class=width-10 checked=\"ctrl.stateFilter['alerting']\" on-change=ctrl.updateStateFilter()></gf-form-switch>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 895 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/alertlist/module.html';
var html = "<div class=panel-alert-list>\n  <div class=panel-alert-list__no-alerts ng-show=ctrl.noAlertsMessage>\n    {{ctrl.noAlertsMessage}}\n  </div>\n\n  <section ng-if=\"ctrl.panel.show === 'current'\">\n    <ol class=alert-rule-list>\n      <li class=alert-rule-item ng-repeat=\"alert in ctrl.currentAlerts\">\n        <div class=\"alert-rule-item__icon {{alert.stateModel.stateClass}}\">\n          <i class={{alert.stateModel.iconClass}}></i>\n        </div>\n        <div class=alert-rule-item__body>\n          <div class=alert-rule-item__header>\n            <p class=alert-rule-item__name>\n              <a href=\"{{alert.url}}?panelId={{alert.panelId}}&fullscreen&edit&tab=alert\">\n                {{alert.name}}\n              </a>\n            </p>\n            <div class=alert-rule-item__text>\n              <span class={{alert.stateModel.stateClass}}>{{alert.stateModel.text}}</span>\n              <span class=alert-rule-item__time>for {{alert.newStateDateAgo}}</span>\n            </div>\n          </div>\n        </div>\n      </li>\n    </ol>\n  </section>\n\n  <section ng-if=\"ctrl.panel.show === 'changes'\">\n    <ol class=alert-rule-list>\n      <li class=alert-rule-item ng-repeat=\"al in ctrl.alertHistory\">\n        <div class=\"alert-rule-item__icon {{al.stateModel.stateClass}}\">\n          <i class={{al.stateModel.iconClass}}></i>\n        </div>\n        <div class=alert-rule-item__body>\n          <div class=alert-rule-item__header>\n            <p class=alert-rule-item__name>{{al.alertName}}</p>\n            <div class=alert-rule-item__text>\n              <span class={{al.stateModel.stateClass}}>{{al.stateModel.text}}</span>\n            </div>\n          </div>\n          <span class=alert-rule-item__info>{{al.info}}</span>\n        </div>\n        <div class=alert-rule-item__time>\n          <span>{{al.time}}</span>\n        </div>\n      </li>\n    </ol>\n  </section>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/dashlist/editor.html';
var html = "<div>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Options</h5>\n\n    <gf-form-switch class=gf-form label=Starred label-class=width-9 checked=ctrl.panel.starred on-change=ctrl.refresh()></gf-form-switch>\n    <gf-form-switch class=gf-form label=\"Recently viewed\" label-class=width-9 checked=ctrl.panel.recent on-change=ctrl.refresh()></gf-form-switch>\n    <gf-form-switch class=gf-form label=Search label-class=width-9 checked=ctrl.panel.search on-change=ctrl.refresh()></gf-form-switch>\n\n    <gf-form-switch class=gf-form label=\"Show headings\" label-class=width-9 checked=ctrl.panel.headings on-change=ctrl.refresh()></gf-form-switch>\n\n    <div class=gf-form>\n      <span class=\"gf-form-label width-9\">Max items</span>\n      <input class=\"gf-form-input max-width-5\" type=number ng-model=ctrl.panel.limit ng-model-onblur ng-change=ctrl.refresh()>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Search</h5>\n\n    <div class=gf-form>\n      <span class=\"gf-form-label width-6\">Query</span>\n      <input type=text class=gf-form-input placeholder=\"title query\" ng-model=ctrl.panel.query ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n\n    <div class=gf-form>\n      <folder-picker root-name=All initial-folder-id=ctrl.panel.folderId on-change=ctrl.onFolderChange($folder) label-class=width-6>\n\t\t\t</folder-picker>\n    </div>\n\n    <div class=gf-form>\n      <span class=\"gf-form-label width-6\">Tags</span>\n      <bootstrap-tagsinput ng-model=ctrl.panel.tags tagclass=\"label label-tag\" placeholder=\"add tags\" on-tags-updated=ctrl.refresh()>\n      </bootstrap-tagsinput>\n    </div>\n  </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 897 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/dashlist/module.html';
var html = "<div>\n  <div class=dashlist ng-repeat=\"group in ctrl.groups\">\n    <div class=dashlist-section ng-if=group.show>\n      <h6 class=dashlist-section-header ng-show=ctrl.panel.headings>\n        {{group.header}}\n      </h6>\n      <div class=dashlist-item ng-repeat=\"dash in group.list\">\n        <a class=\"dashlist-link dashlist-link-{{dash.type}}\" href={{dash.url}}>\n          <span class=dashlist-title>\n            {{dash.title}}\n          </span>\n          <span class=dashlist-star ng-click=\"ctrl.starDashboard(dash, $event)\">\n            <i class=fa ng-class=\"{'fa-star': dash.isStarred, 'fa-star-o': dash.isStarred === false}\"></i>\n          </span>\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 898 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/gettingstarted/editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Mode</span>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-10\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.mode ng-options=\"f for f in ctrl.modes\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form ng-show=\"ctrl.panel.mode === 'recently viewed'\">\n\t\t\t<span class=gf-form-label>\n\t\t\t\t<i class=\"grafana-tip fa fa-question-circle ng-scope\" bs-tooltip=\"'WARNING: This list will be cleared when clearing browser cache'\" data-original-title=\"\" title=\"\"></i>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline ng-if=\"ctrl.panel.mode === 'search'\">\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Search options</span>\n\t\t\t<span class=gf-form-label>Query</span>\n\n\t\t\t<input type=text class=gf-form-input placeholder=\"title query\" ng-model=ctrl.panel.query ng-change=ctrl.refresh() ng-model-onblur>\n\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Tags</span>\n\n\t\t\t<bootstrap-tagsinput ng-model=ctrl.panel.tags tagclass=\"label label-tag\" placeholder=\"add tags\" on-tags-updated=ctrl.refresh()>\n\t\t\t</bootstrap-tagsinput>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Limit number to</span>\n\t\t\t<input class=gf-form-input type=number ng-model=ctrl.panel.limit ng-model-onblur ng-change=ctrl.refresh()>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 899 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/gettingstarted/module.html';
var html = "<div class=dashlist ng-if=ctrl.checksDone>\n  <div class=dashlist-section>\n\t\t<button class=dashlist-cta-close-btn ng-click=ctrl.dismiss()>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</button>\n\t\t<ul class=progress-tracker>\n\t\t\t<li class=progress-step ng-repeat=\"step in ctrl.steps\" ng-class=step.cssClass>\n\t\t\t\t<a class=progress-link ng-href={{step.href}} target={{step.target}} title={{step.note}}>\n\t\t\t\t\t<span class=progress-marker ng-class=step.cssClass><i class={{step.icon}}></i></span>\n\t\t\t\t\t<span class=progress-text ng-href={{step.href}} target={{step.target}}>{{step.title}}</span>\n\t\t\t\t</a>\n\t\t\t\t<a class=\"btn progress-step-cta\" ng-href={{step.href}} target={{step.target}}>{{step.cta}}</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 900 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/graph/axes_editor.html';
var html = "<div class=editor-row>\n\t<div class=\"section gf-form-group\" ng-repeat=\"yaxis in ctrl.panel.yaxes\">\n\n\t\t<h5 class=section-heading ng-show=\"$index === 0\">Left Y</h5>\n\t\t<h5 class=section-heading ng-show=\"$index === 1\">Right Y</h5>\n\n\t\t<gf-form-switch class=gf-form label=Show label-class=width-6 checked=yaxis.show on-change=ctrl.render()></gf-form-switch>\n\n\t\t<div ng-if=yaxis.show>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Unit</label>\n\t\t\t\t<div class=\"gf-form-dropdown-typeahead max-width-20\" ng-model=yaxis.format dropdown-typeahead2=ctrl.unitFormats dropdown-typeahead-on-select=\"ctrl.setUnitFormat(yaxis, $subItem)\"></div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Scale</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-20\">\n\t\t\t\t\t<select class=gf-form-input ng-model=yaxis.logBase ng-options=\"v as k for (k, v) in ctrl.logScales\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form-inline>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=\"gf-form-label width-6\">Y-Min</label>\n\t\t\t\t\t<input type=text class=\"gf-form-input width-5\" placeholder=auto empty-to-null ng-model=yaxis.min ng-change=ctrl.render() ng-model-onblur>\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=\"gf-form-label width-6\">Y-Max</label>\n\t\t\t\t\t<input type=text class=\"gf-form-input width-5\" placeholder=auto empty-to-null ng-model=yaxis.max ng-change=ctrl.render() ng-model-onblur>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t<div ng-if=yaxis.show>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Decimals</label>\n\t\t\t\t<input type=number class=\"gf-form-input max-width-20\" placeholder=auto empty-to-null bs-tooltip=\"'Override automatic decimal precision for y-axis'\" data-placement=right ng-model=yaxis.decimals ng-change=ctrl.render() ng-model-onblur>\n\t\t\t</div>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Label</label>\n\t\t\t\t<input type=text class=\"gf-form-input max-width-20\" ng-model=yaxis.label ng-change=ctrl.render() ng-model-onblur>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>X-Axis</h5>\n\t\t<gf-form-switch class=gf-form label=Show label-class=width-6 checked=ctrl.panel.xaxis.show on-change=ctrl.render()></gf-form-switch>\n\n\t\t<div class=gf-form>\n\t\t\t<label class=\"gf-form-label width-6\">Mode</label>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-15\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.xaxis.mode ng-options=\"v as k for (k, v) in ctrl.xAxisModes\" ng-change=ctrl.xAxisModeChanged()> </select>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- Series mode -->\n\t\t<div class=gf-form ng-if=\"ctrl.panel.xaxis.mode === 'series'\">\n\t\t\t<label class=\"gf-form-label width-6\">Value</label>\n      <metric-segment-model property=ctrl.panel.xaxis.values[0] options=ctrl.xAxisStatOptions on-change=ctrl.xAxisValueChanged() custom=false css-class=width-10 select-mode=true></metric-segment-model>\n\t\t</div>\n\n\t\t<!-- Histogram mode -->\n\t\t<div class=gf-form ng-if=\"ctrl.panel.xaxis.mode === 'histogram'\">\n\t\t\t<label class=\"gf-form-label width-6\">Buckets</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-8\" ng-model=ctrl.panel.xaxis.buckets placeholder=auto ng-change=ctrl.render() ng-model-onblur bs-tooltip=\"'Number of buckets'\" data-placement=right>\n\t\t</div>\n\n\t\t<div>\n\t\t\t<br/>\n\t\t\t<h5 class=section-heading>Y-Axes</h5>\n\t\t\t<gf-form-switch class=gf-form label=Align tooltip=\"Align left and right Y-axes\" label-class=width-6 switch-class=width-5 checked=ctrl.panel.yaxis.align on-change=ctrl.render()></gf-form-switch>\n\t\t\t<div class=gf-form ng-show=ctrl.panel.yaxis.align>\n\t\t\t\t<label class=\"gf-form-label width-6\">\n\t\t\t\t\tLevel\n\t\t\t\t</label>\n\t\t\t\t<input type=number class=\"gf-form-input width-5\" placeholder=0 ng-model=ctrl.panel.yaxis.alignLevel ng-change=ctrl.render() ng-model-onblur bs-tooltip=\"'Alignment of Y-axes are based on this value, starting from Y=0'\" data-placement=right>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 901 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/graph/tab_display.html';
var html = "<div class=edit-tab-with-sidemenu>\n\t<aside class=edit-sidemenu-aside>\n\t\t<ul class=edit-sidemenu>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 0}\">\n\t\t\t\t<a ng-click=\"ctrl.subTabIndex = 0\">Draw options</a>\n\t\t\t</li>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 1}\">\n\t\t\t\t<a ng-click=\"ctrl.subTabIndex = 1\">\n\t\t\t\t\tSeries overrides <span class=muted>({{ctrl.panel.seriesOverrides.length}})</span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li ng-class=\"{active: ctrl.subTabIndex === 2}\">\n\t\t\t\t<a ng-click=\"ctrl.subTabIndex = 2\">\n\t\t\t\t\tThresholds <span class=muted>({{ctrl.panel.thresholds.length}})</span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</aside>\n\n\t<div class=edit-tab-content ng-if=\"ctrl.subTabIndex === 0\">\n\t\t<div class=\"section gf-form-group\">\n\t\t\t<h5 class=section-heading>Draw Modes</h5>\n\t\t\t<gf-form-switch class=gf-form label=Bars label-class=width-5 checked=ctrl.panel.bars on-change=ctrl.render()></gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form label=Lines label-class=width-5 checked=ctrl.panel.lines on-change=ctrl.render()></gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form label=Points label-class=width-5 checked=ctrl.panel.points on-change=ctrl.render()></gf-form-switch>\n\t\t</div>\n\t\t<div class=\"section gf-form-group\">\n\t\t\t<h5 class=section-heading>Mode Options</h5>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-8\">Fill</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-5\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.fill ng-options=\"f for f in [0,1,2,3,4,5,6,7,8,9,10]\" ng-change=ctrl.render() ng-disabled=!ctrl.panel.lines></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-8\">Line Width</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-5\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.linewidth ng-options=\"f for f in [0,1,2,3,4,5,6,7,8,9,10]\" ng-change=ctrl.render() ng-disabled=!ctrl.panel.lines></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<gf-form-switch ng-disabled=!ctrl.panel.lines class=gf-form label=Staircase label-class=width-8 checked=ctrl.panel.steppedLine on-change=ctrl.render()>\n\t\t\t</gf-form-switch>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-8\">Point Radius</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-5\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.pointradius ng-options=\"f for f in [0.5,1,2,3,4,5,6,7,8,9,10]\" ng-change=ctrl.render() ng-disabled=!ctrl.panel.points></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"section gf-form-group\">\n\t\t\t<h5 class=section-heading>Hover tooltip</h5>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-9\">Mode</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-8\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.tooltip.shared ng-options=\"f.value as f.text for f in [{text: 'All series', value: true}, {text: 'Single', value: false}]\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-9\">Sort order</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-8\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.tooltip.sort ng-options=\"f.value as f.text for f in [{text: 'None', value: 0}, {text: 'Increasing', value: 1}, {text: 'Decreasing', value: 2}]\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-show=ctrl.panel.stack>\n\t\t\t\t<label class=\"gf-form-label width-9\">Stacked value</label>\n\t\t\t\t<div class=\"gf-form-select-wrapper max-width-8\">\n\t\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.tooltip.value_type ng-options=\"f for f in ['cumulative','individual']\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"section gf-form-group\">\n\t\t\t<h5 class=section-heading>Stacking & Null value</h5>\n\t\t\t<gf-form-switch class=gf-form label=Stack label-class=width-7 checked=ctrl.panel.stack on-change=ctrl.refresh()>\n\t\t\t</gf-form-switch>\n\t\t\t<gf-form-switch class=gf-form ng-show=ctrl.panel.stack label=Percent label-class=width-7 checked=ctrl.panel.percentage on-change=ctrl.render()>\n\t\t\t</gf-form-switch>\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-7\">Null value</label>\n\t\t\t\t<div class=gf-form-select-wrapper>\n\t\t\t\t\t<select class=\"gf-form-input max-width-9\" ng-model=ctrl.panel.nullPointMode ng-options=\"f for f in ['connected', 'null', 'null as zero']\" ng-change=ctrl.render()></select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=edit-tab-content ng-if=\"ctrl.subTabIndex === 1\">\n\t\t<div class=gf-form-group>\n\t\t\t<h5>Series specific overrides <tip>Regex match example: /server[0-3]/i </tip></h5>\n\t\t\t<div class=gf-form-inline ng-repeat=\"override in ctrl.panel.seriesOverrides\" ng-controller=SeriesOverridesCtrl>\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=gf-form-label>alias or regex</label>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"gf-form width-15\">\n\t\t\t\t\t<input type=text ng-model=override.alias bs-typeahead=getSeriesNames ng-blur=ctrl.render() data-min-length=0 data-items=100 class=\"gf-form-input width-15\">\n\t\t\t\t</div>\n\t\t\t\t<div class=gf-form ng-repeat=\"option in currentOverrides\">\n\t\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t\t<i class=\"pointer fa fa-remove\" ng-click=removeOverride(option)></i>\n\t\t\t\t\t\t<span ng-show=\"option.propertyName === 'color'\">\n\t\t\t\t\t\t\tColor: <i class=\"fa fa-circle\" ng-style={color:option.value}></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-show=\"option.propertyName !== 'color'\">\n\t\t\t\t\t\t\t{{option.name}}: {{option.value}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<span class=dropdown dropdown-typeahead=overrideMenu dropdown-typeahead-on-select=\"setOverride($item, $subItem)\">\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=gf-form>\n\t\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t\t<i class=\"fa fa-trash pointer\" ng-click=ctrl.removeSeriesOverride(override)></i>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<button class=\"btn btn-inverse\" ng-click=ctrl.addSeriesOverride()>\n\t\t\t<i class=\"fa fa-plus\"></i>&nbsp;Add override\n\t\t</button>\n\t</div>\n\n\t<div class=edit-tab-content ng-if=\"ctrl.subTabIndex === 2\">\n\t\t<graph-threshold-form panel-ctrl=ctrl></graph-threshold-form>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 902 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/graph/tab_legend.html';
var html = "<div class=editor-row>\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Options</h5>\n\t\t<gf-form-switch class=gf-form label=Show label-class=width-7 checked=ctrl.panel.legend.show on-change=ctrl.refresh()>\n\t\t</gf-form-switch>\n\t\t<gf-form-switch class=gf-form label=\"As Table\" label-class=width-7 checked=ctrl.panel.legend.alignAsTable on-change=ctrl.render()>\n\t\t</gf-form-switch>\n\t\t<gf-form-switch class=gf-form label=\"To the right\" label-class=width-7 checked=ctrl.panel.legend.rightSide on-change=ctrl.render()>\n\t\t</gf-form-switch>\n\t\t<div ng-if=ctrl.panel.legend.rightSide class=gf-form>\n\t\t\t<label class=\"gf-form-label width-7\">Width</label>\n\t\t\t<input type=number class=\"gf-form-input max-width-5\" placeholder=250 bs-tooltip=\"'Set a min-width for the legend side table/block'\" data-placement=right ng-model=ctrl.panel.legend.sideWidth ng-change=ctrl.render() ng-model-onblur>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Values</h5>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<gf-form-switch class=gf-form label=Min label-class=width-4 checked=ctrl.panel.legend.min on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\n\t\t\t<gf-form-switch class=\"gf-form max-width-12\" label=Max label-class=width-6 switch-class=max-width-5 checked=ctrl.panel.legend.max on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\t\t</div>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<gf-form-switch class=gf-form label=Avg label-class=width-4 checked=ctrl.panel.legend.avg on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\n\t\t\t<gf-form-switch class=\"gf-form max-width-12\" label=Current label-class=width-6 switch-class=max-width-5 checked=ctrl.panel.legend.current on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\t\t</div>\n\n\t\t<div class=gf-form-inline>\n\t\t\t<gf-form-switch class=gf-form label=Total label-class=width-4 checked=ctrl.panel.legend.total on-change=ctrl.legendValuesOptionChanged()>\n\t\t\t</gf-form-switch>\n\n\t\t\t<div class=gf-form>\n\t\t\t\t<label class=\"gf-form-label width-6\">Decimals</label>\n\t\t\t\t<input type=number class=\"gf-form-input width-5\" placeholder=auto bs-tooltip=\"'Override automatic decimal precision for legend and tooltips'\" data-placement=right ng-model=ctrl.panel.decimals ng-change=ctrl.render() ng-model-onblur>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Hide series</h5>\n\t\t<gf-form-switch class=gf-form label=\"With only nulls\" label-class=width-10 checked=ctrl.panel.legend.hideEmpty on-change=ctrl.render()>\n\t\t</gf-form-switch>\n\t\t<gf-form-switch class=gf-form label=\"With only zeros\" label-class=width-10 checked=ctrl.panel.legend.hideZero on-change=ctrl.render()>\n\t\t</gf-form-switch>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 903 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/heatmap/module.html';
var html = "<div class=heatmap-wrapper>\n\t<div class=heatmap-canvas-wrapper>\n\n\t\t<div class=datapoints-warning ng-if=ctrl.dataWarning>\n\t\t\t<span class=small bs-tooltip=ctrl.dataWarning.tip>{{ctrl.dataWarning.title}}</span>\n\t\t</div>\n\n\t\t<div class=heatmap-panel ng-dblclick=ctrl.zoomOut()></div>\n\t</div>\n\t<div class=heatmap-legend-wrapper ng-if=ctrl.panel.legend.show>\n\t\t<heatmap-legend></heatmap-legend>\n\t</div>\n</div>\n<div class=clearfix></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 904 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/heatmap/partials/axes_editor.html';
var html = "<div class=editor-row>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Y Axis</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Unit</label>\n      <div class=\"gf-form-dropdown-typeahead width-12\" ng-model=ctrl.panel.yAxis.format dropdown-typeahead2=editor.unitFormats dropdown-typeahead-on-select=editor.setUnitFormat($subItem)>\n      </div>\n    </div>\n    <div ng-if=\"ctrl.panel.dataFormat == 'timeseries'\">\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Scale</label>\n        <div class=\"gf-form-select-wrapper width-12\">\n          <select class=gf-form-input ng-model=ctrl.panel.yAxis.logBase ng-options=\"v as k for (k, v) in editor.logScales\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Y-Min</label>\n        <input type=text class=\"gf-form-input width-12\" placeholder=auto empty-to-null ng-model=ctrl.panel.yAxis.min ng-change=ctrl.render() ng-model-onblur>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Y-Max</label>\n        <input type=text class=\"gf-form-input width-12\" placeholder=auto empty-to-null ng-model=ctrl.panel.yAxis.max ng-change=ctrl.render() ng-model-onblur>\n      </div>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Decimals</label>\n      <input type=number class=\"gf-form-input width-12\" placeholder=auto data-placement=right bs-tooltip=\"'Override automatic decimal precision for axis.'\" ng-model=ctrl.panel.yAxis.decimals ng-change=ctrl.render() ng-model-onblur>\n    </div>\n    <div class=gf-form ng-if=\"ctrl.panel.dataFormat == 'tsbuckets'\">\n      <label class=\"gf-form-label width-8\">Bucket bound</label>\n      <div class=\"gf-form-select-wrapper max-width-12\">\n        <select class=gf-form-input ng-model=ctrl.panel.yBucketBound ng-options=\"v as k for (k, v) in editor.yBucketBoundModes\" ng-change=ctrl.render() data-placement=right bs-tooltip=\"'Use series label as an upper or lower bucket bound.'\">\n        </select>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\" ng-if=\"ctrl.panel.dataFormat == 'timeseries'\">\n    <h5 class=section-heading>Buckets</h5>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-5\">Y Axis</label>\n      </div>\n      <div class=gf-form ng-show=\"ctrl.panel.yAxis.logBase === 1\">\n        <label class=\"gf-form-label width-5\">Buckets</label>\n        <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Number of buckets for Y axis.'\" ng-model=ctrl.panel.yBucketNumber ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n      <div class=gf-form ng-show=\"ctrl.panel.yAxis.logBase === 1\">\n        <label class=\"gf-form-label width-4\">Size</label>\n        <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Size of bucket. Has priority over Buckets option.'\" ng-model=ctrl.panel.yBucketSize ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n      <div class=gf-form ng-show=\"ctrl.panel.yAxis.logBase !== 1\">\n        <label class=\"gf-form-label width-10\">Split Factor</label>\n        <input type=number class=\"gf-form-input width-9\" placeholder=1 data-placement=right bs-tooltip=\"'For log scales only. By default Y values is splitted by integer powers of log base (1, 2, 4, 8, 16, ... for log2). This option allows to split each default bucket into specified number of buckets.'\" ng-model=ctrl.panel.yAxis.splitFactor ng-change=ctrl.refresh() ng-model-onblur>\n        \n      </div>\n    </div>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-5\">X Axis</label>\n        <label class=\"gf-form-label width-5\">Buckets</label>\n        <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Number of buckets for X axis.'\" ng-model=ctrl.panel.xBucketNumber ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-4\">Size</label>\n        <input type=text class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Size of bucket. Number or interval (10s, 5m, 1h, etc). Supported intervals: ms, s, m, h, d, w, M, y. Has priority over Buckets option.'\" ng-model=ctrl.panel.xBucketSize ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Data format</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-5\">Format</label>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select class=gf-form-input ng-model=ctrl.panel.dataFormat ng-options=\"v as k for (k, v) in editor.dataFormats\" ng-change=ctrl.render() data-placement=right bs-tooltip=\"'Time series: create heatmap from regular time series. <br>Time series buckets: use histogram data returned from data source. Each series represents bucket which upper/lower bound is a series label.'\">\n        </select>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 905 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/heatmap/partials/display_editor.html';
var html = "<div class=editor-row>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Colors</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-9\">Mode</label>\n      <div class=\"gf-form-select-wrapper width-8\">\n        <select class=\"input-small gf-form-input\" ng-model=ctrl.panel.color.mode ng-options=\"s for s in ctrl.colorModes\" ng-change=ctrl.render()></select>\n      </div>\n    </div>\n\n    <div ng-show=\"ctrl.panel.color.mode === 'opacity'\">\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Color</label>\n        <span class=gf-form-label>\n          <color-picker color=ctrl.panel.color.cardColor onchange=ctrl.onCardColorChange></color-picker>\n        </span>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Scale</label>\n        <div class=\"gf-form-select-wrapper width-8\">\n          <select class=\"input-small gf-form-input\" ng-model=ctrl.panel.color.colorScale ng-options=\"s for s in ctrl.opacityScales\" ng-change=ctrl.render()></select>\n        </div>\n      </div>\n      <div class=gf-form ng-if=\"ctrl.panel.color.colorScale === 'sqrt'\">\n        <label class=\"gf-form-label width-9\">Exponent</label>\n        <input type=number class=\"gf-form-input width-8\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-model=ctrl.panel.color.exponent ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n    </div>\n\n    <div ng-show=\"ctrl.panel.color.mode === 'spectrum'\">\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Scheme</label>\n        <div class=\"gf-form-select-wrapper width-8\">\n          <select class=\"input-small gf-form-input\" ng-model=ctrl.panel.color.colorScheme ng-options=\"s.value as s.name for s in ctrl.colorSchemes\" ng-change=ctrl.render()></select>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form>\n      <color-legend></color-legend>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Color scale</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Min</label>\n      <input type=number ng-model=ctrl.panel.color.min class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Max</label>\n      <input type=number ng-model=ctrl.panel.color.max class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Legend</h5>\n    <gf-form-switch class=gf-form label-class=width-8 label=\"Show legend\" checked=ctrl.panel.legend.show on-change=ctrl.render()>\n    </gf-form-switch>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Buckets</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Space</label>\n      <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-model=ctrl.panel.cards.cardPadding ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Round</label>\n      <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"''\" ng-model=ctrl.panel.cards.cardRound ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Tooltip</h5>\n    <gf-form-switch class=gf-form label-class=width-8 label=\"Show tooltip\" checked=ctrl.panel.tooltip.show on-change=ctrl.render()>\n    </gf-form-switch>\n    <div ng-if=ctrl.panel.tooltip.show>\n      <gf-form-switch class=gf-form label-class=width-8 label=Histogram checked=ctrl.panel.tooltip.showHistogram on-change=ctrl.render()>\n      </gf-form-switch>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Decimals</label>\n        <input type=number class=\"gf-form-input width-5\" placeholder=auto data-placement=right bs-tooltip=\"'Max decimal precision for tooltip.'\" ng-model=ctrl.panel.tooltipDecimals ng-change=ctrl.render() ng-model-onblur>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 906 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/pluginlist/editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Mode</span>\n\t\t\t<div class=\"gf-form-select-wrapper max-width-10\">\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.mode ng-options=\"f for f in ctrl.modes\" ng-change=ctrl.refresh()></select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=gf-form ng-show=\"ctrl.panel.mode === 'recently viewed'\">\n\t\t\t<span class=gf-form-label>\n\t\t\t\t<i class=\"grafana-tip fa fa-question-circle ng-scope\" bs-tooltip=\"'WARNING: This list will be cleared when clearing browser cache'\" data-original-title=\"\" title=\"\"></i>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline ng-if=\"ctrl.panel.mode === 'search'\">\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Search options</span>\n\t\t\t<span class=gf-form-label>Query</span>\n\n\t\t\t<input type=text class=gf-form-input placeholder=\"title query\" ng-model=ctrl.panel.query ng-change=ctrl.refresh() ng-model-onblur>\n\n\t\t</div>\n\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Tags</span>\n\n\t\t\t<bootstrap-tagsinput ng-model=ctrl.panel.tags tagclass=\"label label-tag\" placeholder=\"add tags\" on-tags-updated=ctrl.refresh()>\n\t\t\t</bootstrap-tagsinput>\n\t\t</div>\n\t</div>\n\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=\"gf-form-label width-10\">Limit number to</span>\n\t\t\t<input class=gf-form-input type=number ng-model=ctrl.panel.limit ng-model-onblur ng-change=ctrl.refresh()>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 907 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/pluginlist/module.html';
var html = "<div class=pluginlist>\n  <div class=pluginlist-section ng-repeat=\"category in ctrl.viewModel\">\n    <h6 class=pluginlist-section-header>\n      {{category.header}}\n    </h6>\n    <div class=pluginlist-item ng-repeat=\"plugin in category.list\">\n      <a class=\"pluginlist-link pluginlist-link-{{plugin.state}} pointer\" href={{plugin.defaultNavUrl}}>\n        <span>\n          <img ng-src={{plugin.info.logos.small}} class=pluginlist-image>\n          <span class=pluginlist-title>{{plugin.name}}</span>\n          <span class=pluginlist-version>v{{plugin.info.version}}</span>\n        </span>\n        <span class=\"pluginlist-message pluginlist-message--update\" ng-show=plugin.hasUpdate ng-click=\"ctrl.updateAvailable(plugin, $event)\" bs-tooltip=\"'New version: ' + plugin.latestVersion\">\n          Update available!\n        </span>\n        <span class=\"pluginlist-message pluginlist-message--enable\" ng-show=\"!plugin.enabled && !plugin.hasUpdate\">\n          Enable now\n        </span>\n        <span class=\"pluginlist-message pluginlist-message--no-update\" ng-show=\"plugin.enabled && !plugin.hasUpdate\">\n          Up to date\n        </span>\n      </a>\n    </div>\n    <div class=pluginlist-item ng-show=\"category.list.length === 0\">\n      <a class=\"pluginlist-link pluginlist-link-{{plugin.state}}\" href=https://grafana.com/plugins>\n        <span class=pluginlist-none-installed>None installed. <span class=pluginlist-emphasis>Browse Grafana.com</span></span>\n      </a>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 908 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/singlestat/editor.html';
var html = "<div class=editor-row>\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Value</h5>\n\n    <div class=gf-form-inline>\n      <div class=gf-form ng-show=\"ctrl.dataType === 'timeseries'\">\n        <label class=\"gf-form-label width-6\">Stat</label>\n        <div class=\"gf-form-select-wrapper width-12\">\n          <select class=gf-form-input ng-model=ctrl.panel.valueName ng-options=\"f.value as f.text for f in ctrl.valueNameOptions\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=gf-form ng-show=\"ctrl.dataType === 'table'\">\n        <label class=\"gf-form-label width-6\">Column</label>\n        <div class=\"gf-form-select-wrapper width-12\">\n          <select class=gf-form-input ng-model=ctrl.panel.tableColumn ng-options=\"f for f in ctrl.tableColumnOptions\" ng-change=ctrl.refresh()></select>\n        </div>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-6\">Font size</label>\n        <div class=gf-form-select-wrapper>\n          <select class=gf-form-input ng-model=ctrl.panel.valueFontSize ng-options=\"f for f in ctrl.fontSizes\" ng-change=ctrl.render()></select>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-6\">Prefix</label>\n        <input type=text class=\"gf-form-input width-12\" ng-model=ctrl.panel.prefix ng-change=ctrl.render() ng-model-onblur>\n        <label class=\"gf-form-label width-6\">Font size</label>\n        <div class=gf-form-select-wrapper>\n          <select class=gf-form-input ng-model=ctrl.panel.prefixFontSize ng-options=\"f for f in ctrl.fontSizes\" ng-change=ctrl.render() ng-disabled=ctrl.canChangeFontSize()></select>\n        </div>\n      </div>\n    </div>\n\n    <div class=gf-form>\n      <label class=\"gf-form-label width-6\">Postfix</label>\n      <input type=text class=\"gf-form-input width-12\" ng-model=ctrl.panel.postfix ng-change=ctrl.render() ng-model-onblur>\n      <label class=\"gf-form-label width-6\">Font size</label>\n      <div class=gf-form-select-wrapper>\n        <select class=\"input-small gf-form-input\" ng-model=ctrl.panel.postfixFontSize ng-options=\"f for f in ctrl.fontSizes\" ng-change=ctrl.render() ng-disabled=ctrl.canChangeFontSize()></select>\n      </div>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-6\">Unit</label>\n      <div class=\"gf-form-dropdown-typeahead width-18\" ng-model=ctrl.panel.format dropdown-typeahead2=ctrl.unitFormats dropdown-typeahead-on-select=ctrl.setUnitFormat($subItem)></div>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-6\">Decimals</label>\n      <input type=number class=\"gf-form-input width-18\" placeholder=auto data-placement=right bs-tooltip=\"'Override automatic decimal precision for legend and tooltips'\" ng-model=ctrl.panel.decimals ng-change=ctrl.refresh() ng-model-onblur>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Coloring</h5>\n    <div class=gf-form-inline>\n      <gf-form-switch class=gf-form label-class=width-8 label=Background checked=ctrl.panel.colorBackground on-change=ctrl.render()></gf-form-switch>\n      <gf-form-switch class=gf-form label-class=width-4 label=Value checked=ctrl.panel.colorValue on-change=ctrl.render()></gf-form-switch>\n    </div>\n    <div class=gf-form-inline>\n      <div class=\"gf-form max-width-21\">\n        <label class=\"gf-form-label width-8\">Thresholds\n          <tip>Define two threshold values&lt;br /&gt; 50,80 will produce: &lt;50 = Green, 50:80 = Yellow, &gt;80 = Red</tip>\n        </label>\n        <input type=text class=gf-form-input ng-model=ctrl.panel.thresholds ng-blur=ctrl.render() placeholder=50,80>\n      </div>\n    </div>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Colors</label>\n      <span class=gf-form-label ng-repeat=\"color in ctrl.panel.colors track by $index\">\n        <color-picker color=color onchange=ctrl.onColorChange($index)></color-picker>\n      </span>\n      <span class=gf-form-label>\n        <a ng-click=ctrl.invertColorOrder()>\n          Invert\n        </a>\n      </span>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Spark lines</h5>\n    <gf-form-switch class=gf-form label-class=width-9 label=Show checked=ctrl.panel.sparkline.show on-change=ctrl.render()></gf-form-switch>\n    <div ng-if=ctrl.panel.sparkline.show>\n      <gf-form-switch class=gf-form label-class=width-9 label=\"Full height\" checked=ctrl.panel.sparkline.full on-change=ctrl.render()></gf-form-switch>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Line Color</label>\n        <span class=gf-form-label>\n          <color-picker color=ctrl.panel.sparkline.lineColor onchange=ctrl.onSparklineColorChange></color-picker>\n        </span>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Fill Color</label>\n        <span class=gf-form-label>\n          <color-picker color=ctrl.panel.sparkline.fillColor onchange=ctrl.onSparklineFillChange></color-picker>\n        </span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"section gf-form-group\">\n    <h5 class=section-heading>Gauge</h5>\n    <gf-form-switch class=gf-form label-class=width-10 switch-class=max-width-6 label=Show checked=ctrl.panel.gauge.show on-change=ctrl.render()></gf-form-switch>\n    <div ng-if=ctrl.panel.gauge.show>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-10\">Min</label>\n        <input type=number class=\"gf-form-input width-6\" placeholder=0 data-placement=right ng-model=ctrl.panel.gauge.minValue ng-change=ctrl.refresh() ng-model-onblur>\n        <label class=\"gf-form-label alert-state-critical\" ng-show=ctrl.invalidGaugeRange>\n          &nbsp; <i class=\"fa fa-warning\"></i>\n          Min value is bigger than max.\n        </label>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-10\">Max</label>\n        <input type=number class=\"gf-form-input width-6\" placeholder=0 data-placement=right ng-model=ctrl.panel.gauge.maxValue ng-change=ctrl.refresh() ng-model-onblur>\n      </div>\n      <gf-form-switch class=gf-form label-class=width-10 switch-class=max-width-6 label=\"Threshold labels\" checked=ctrl.panel.gauge.thresholdLabels on-change=ctrl.render()></gf-form-switch>\n      <gf-form-switch class=gf-form label-class=width-10 switch-class=max-width-6 label=\"Threshold markers\" checked=ctrl.panel.gauge.thresholdMarkers on-change=ctrl.render()></gf-form-switch>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 909 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/singlestat/mappings.html';
var html = "<div class=editor-row>\n  <div class=gf-form-group>\n    <div class=gf-form>\n        <span class=gf-form-label>\n          Type\n        </span>\n        <div class=gf-form-select-wrapper>\n          <select class=gf-form-input ng-model=ctrl.panel.mappingType ng-options=\"f.value as f.name for f in ctrl.panel.mappingTypes\" ng-change=ctrl.render()></select>\n        </div>\n    </div>\n  </div>\n</div>\n<div class=editor-row ng-if=\"ctrl.panel.mappingType==1\">\n  <h5 class=page-heading>Set value mappings</h5>\n  <div class=gf-form-group>\n    <div class=gf-form ng-repeat=\"map in ctrl.panel.valueMaps\">\n      <span class=gf-form-label>\n        <i class=\"fa fa-remove pointer\" ng-click=ctrl.removeValueMap(map)></i>\n      </span>\n      <input type=text ng-model=map.value placeholder=value class=\"gf-form-input max-width-6\" ng-blur=ctrl.render()>\n      <span class=gf-form-label>\n        <i class=\"fa fa-arrow-right\"></i>\n      </span>\n      <input type=text placeholder=text ng-model=map.text class=\"gf-form-input max-width-8\" ng-blur=ctrl.render()>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button class=\"btn btn-inverse\" ng-click=ctrl.addValueMap();>\n        <i class=\"fa fa-plus\"></i>\n        Add a value mapping\n      </button>\n    </div>\n  </div>\n</div>\n<div class=editor-row ng-if=\"ctrl.panel.mappingType==2\">\n  <h5 class=page-heading>Set range mappings</h5>\n  <div class=gf-form-group>\n    <div class=gf-form ng-repeat=\"rangeMap in ctrl.panel.rangeMaps\">\n        <span class=gf-form-label>\n          <i class=\"fa fa-remove pointer\" ng-click=ctrl.removeRangeMap(rangeMap)></i>\n        </span>\n        <span class=gf-form-label>From</span>\n        <input type=text ng-model=rangeMap.from class=\"gf-form-input max-width-6\" ng-blur=ctrl.render()>\n        <span class=gf-form-label>To</span>\n        <input type=text ng-model=rangeMap.to class=\"gf-form-input max-width-6\" ng-blur=ctrl.render()>\n        <span class=gf-form-label>Text</span>\n        <input type=text ng-model=rangeMap.text class=\"gf-form-input max-width-8\" ng-blur=ctrl.render()>\n    </div>\n\n    <div class=gf-form-button-row>\n      <button class=\"btn btn-inverse\" ng-click=ctrl.addRangeMap()>\n        <i class=\"fa fa-plus\"></i>\n        Add a range mapping\n      </button>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 910 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/singlestat/module.html';
var html = "<div class=singlestat-panel>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 911 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/table/column_options.html';
var html = "<div class=edit-tab-with-sidemenu>\n  <aside class=edit-sidemenu-aside>\n    <ul class=edit-sidemenu>\n      <li ng-repeat=\"style in editor.panel.styles\" ng-class=\"{active: editor.activeStyleIndex === $index}\">\n        <a ng-click=\"editor.activeStyleIndex = $index\">{{style.pattern || 'New rule'}}</a>\n      </li>\n      <li>\n        <a class=pointer ng-click=editor.addColumnStyle()>\n          <i class=\"fa fa-plus\"></i>&nbsp;Add\n        </a>\n      </li>\n    </ul>\n  </aside>\n\n  <div class=edit-tab-content ng-repeat=\"style in editor.panel.styles\" ng-if=\"editor.activeStyleIndex === $index\">\n\n    <div class=\"section gf-form-group\">\n      <h5 class=section-heading>Options</h5>\n      <div class=gf-form-inline>\n        <div class=gf-form>\n          <label class=\"gf-form-label width-13\">Apply to columns named</label>\n          <input type=text placeholder=\"Name or regex\" class=\"gf-form-input width-13\" ng-model=style.pattern bs-tooltip=\"'Specify regex using /my.*regex/ syntax'\" bs-typeahead=editor.getColumnNames ng-blur=editor.render() data-min-length=0 data-items=100 ng-model-onblur data-placement=right>\n        </div>\n      </div>\n      <div class=gf-form ng-if=\"style.type !== 'hidden'\">\n        <label class=\"gf-form-label width-13\">Column Header</label>\n        <input type=text class=\"gf-form-input width-13\" ng-model=style.alias ng-change=editor.render() ng-model-onblur placeholder=\"Override header label\">\n      </div>\n      <gf-form-switch class=gf-form label-class=width-13 label=\"Render value as link\" checked=style.link change=editor.render()></gf-form-switch>\n    </div>\n\n    <div class=\"section gf-form-group\">\n      <h5 class=section-heading>Type</h5>\n\n      <div class=gf-form>\n        <label class=\"gf-form-label width-11\">Type</label>\n        <div class=\"gf-form-select-wrapper width-16\">\n          <select class=gf-form-input ng-model=style.type ng-options=\"c.value as c.text for c in editor.columnTypes\" ng-change=editor.render()></select>\n        </div>\n      </div>\n      <div class=gf-form ng-if=\"style.type === 'date'\">\n        <label class=\"gf-form-label width-11\">Date Format</label>\n        <gf-form-dropdown model=style.dateFormat css-class=\"gf-form-input width-16\" lookup-text=true get-options=editor.dateFormats on-change=editor.render() allow-custom=true>\n        </gf-form-dropdown>\n      </div>\n\n      <div ng-if=\"style.type === 'string'\">\n        <gf-form-switch class=gf-form label-class=width-11 ng-if=\"style.type === 'string'\" label=\"Sanitize HTML\" checked=style.sanitize change=editor.render()></gf-form-switch>\n      </div>\n      <div ng-if=\"style.type === 'string'\">\n        <gf-form-switch class=gf-form label-class=width-11 ng-if=\"style.type === 'string'\" label=\"Preserve Formatting\" checked=style.preserveFormat change=editor.render()></gf-form-switch>\n      </div>\n\n      <div ng-if=\"style.type === 'number'\">\n        <div class=gf-form>\n          <label class=\"gf-form-label width-11\">Unit</label>\n          <div class=\"gf-form-dropdown-typeahead width-16\" ng-model=style.unit dropdown-typeahead2=editor.unitFormats dropdown-typeahead-on-select=\"editor.setUnitFormat(style, $subItem)\"></div>\n        </div>\n        <div class=gf-form>\n          <label class=\"gf-form-label width-11\">Decimals</label>\n          <input type=number class=\"gf-form-input width-4\" data-placement=right ng-model=style.decimals ng-change=editor.render() ng-model-onblur>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"section gf-form-group\" ng-if=\"style.type === 'string'\">\n      <h5 class=section-heading>Value Mappings</h5>\n      <div class=editor-row>\n        <div class=gf-form-group>\n          <div class=gf-form>\n            <span class=gf-form-label>\n              Type\n            </span>\n            <div class=gf-form-select-wrapper>\n              <select class=gf-form-input ng-model=style.mappingType ng-options=\"c.value as c.text for c in editor.mappingTypes\" ng-change=editor.render()></select>\n            </div>\n          </div>\n          <div class=gf-form-group ng-if=\"style.mappingType==1\">\n            <div class=gf-form ng-repeat=\"map in style.valueMaps\">\n              <span class=gf-form-label>\n                <i class=\"fa fa-remove pointer\" ng-click=\"editor.removeValueMap(style, $index)\"></i>\n              </span>\n              <input type=text class=\"gf-form-input max-width-6\" ng-model=map.value placeholder=Value ng-blur=editor.render()>\n              <label class=gf-form-label>\n                <i class=\"fa fa-arrow-right\"></i>\n              </label>\n              <input type=text class=\"gf-form-input max-width-8\" ng-model=map.text placeholder=Text ng-blur=editor.render()>\n            </div>\n            <div class=gf-form>\n              <label class=gf-form-label>\n                <a class=pointer ng-click=editor.addValueMap(style)><i class=\"fa fa-plus\"></i></a>\n              </label>\n            </div>\n          </div>\n          <div class=gf-form-group ng-if=\"style.mappingType==2\">\n            <div class=gf-form ng-repeat=\"rangeMap in style.rangeMaps\">\n              <span class=gf-form-label>\n                <i class=\"fa fa-remove pointer\" ng-click=\"editor.removeRangeMap(style, $index)\"></i>\n              </span>\n              <span class=gf-form-label>From</span>\n              <input type=text ng-model=rangeMap.from class=\"gf-form-input max-width-6\" ng-blur=editor.render()>\n              <span class=gf-form-label>To</span>\n              <input type=text ng-model=rangeMap.to class=\"gf-form-input max-width-6\" ng-blur=editor.render()>\n              <span class=gf-form-label>Text</span>\n              <input type=text ng-model=rangeMap.text class=\"gf-form-input max-width-8\" ng-blur=editor.render()>\n            </div>\n            <div class=gf-form>\n              <label class=gf-form-label>\n                <a class=pointer ng-click=editor.addRangeMap(style)><i class=\"fa fa-plus\"></i></a>\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"section gf-form-group\" ng-if=\"['number', 'string'].indexOf(style.type) !== -1\">\n      <h5 class=section-heading>Thresholds</h5>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Thresholds\n          <tip>Comma separated values</tip>\n        </label>\n        <input type=text class=\"gf-form-input width-10\" ng-model=style.thresholds placeholder=50,80 ng-blur=editor.render() array-join>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Color Mode</label>\n        <div class=\"gf-form-select-wrapper width-10\">\n          <select class=gf-form-input ng-model=style.colorMode ng-options=\"c.value as c.text for c in editor.colorModes\" ng-change=editor.render()></select>\n        </div>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-8\">Colors</label>\n        <span class=gf-form-label>\n          <color-picker color=style.colors[0] onchange=editor.onColorChange($index,0)></color-picker>\n        </span>\n        <span class=gf-form-label>\n          <color-picker color=style.colors[1] onchange=editor.onColorChange($index,1)></color-picker>\n        </span>\n        <span class=gf-form-label>\n          <color-picker color=style.colors[2] onchange=editor.onColorChange($index,2)></color-picker>\n        </span>\n        <div class=gf-form-label>\n          <a class=pointer ng-click=editor.invertColorOrder($index)>Invert</a>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"section gf-form-group\" ng-if=style.link>\n      <h5 class=section-heading>Link</h5>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Url</label>\n        <input type=text class=\"gf-form-input width-29\" ng-model=style.linkUrl ng-blur=editor.render() ng-model-onblur data-placement=right>\n        <info-popover mode=right-absolute>\n          <p>Specify an URL (relative or absolute)</p>\n          <span>\n            Use special variables to specify cell values:\n            <br>\n            <em>${__cell}</em> refers to current cell value\n            <br>\n            <em>${__cell_n}</em> refers to Nth column value in current row. Column indexes are started from 0. For instance,\n            <em>${__cell_1}</em> refers to second column's value.\n          </span>\n        </info-popover>\n      </div>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-9\">Tooltip</label>\n        <input type=text class=\"gf-form-input width-29\" ng-model=style.linkTooltip ng-blur=editor.render() ng-model-onblur data-placement=right>\n        <info-popover mode=right-absolute>\n          <p>Specify text for link tooltip.</p>\n          <span>\n            This title appears when user hovers pointer over the cell with link. Use the same variables as for URL.\n          </span>\n        </info-popover>\n      </div>\n      <gf-form-switch class=gf-form label-class=width-9 label=\"Open in new tab\" checked=style.linkTargetBlank></gf-form-switch>\n    </div>\n\n    <div class=clearfix></div>\n\n    <button class=\"btn btn-danger btn-small\" ng-click=editor.removeColumnStyle(style)>\n      <i class=\"fa fa-trash\"></i> Remove Rule\n    </button>\n    <br/>\n    <br/>\n\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 912 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/table/editor.html';
var html = "<div class=editor-row>\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Data</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-10\">Table Transform</label>\n      <div class=\"gf-form-select-wrapper max-width-15\">\n        <select class=gf-form-input ng-model=editor.panel.transform ng-options=\"k as v.description for (k, v) in editor.transformers\" ng-change=editor.transformChanged()></select>\n      </div>\n    </div>\n    <div class=gf-form-inline>\n      <div class=gf-form>\n        <label class=\"gf-form-label width-10\">Columns</label>\n      </div>\n\t\t\t<div class=gf-form ng-repeat=\"column in editor.panel.columns\">\n\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\t<i class=\"pointer fa fa-remove\" ng-click=editor.removeColumn(column)></i>\n\t\t\t\t\t<span>{{column.text}}</span>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-show=editor.canSetColumns>\n\t\t\t\t<metric-segment segment=editor.addColumnSegment get-options=editor.getColumnOptions() on-change=editor.addColumn()></metric-segment>\n\t\t\t</div>\n\t\t\t<div class=gf-form ng-hide=editor.canSetColumns>\n\t\t\t\t<label class=gf-form-label>\n\t\t\t\t\tAuto\n\t\t\t\t\t<info-popover mode=right-normal ng-if=editor.columnsHelpMessage>\n\t\t\t\t\t\t{{editor.columnsHelpMessage}}\n\t\t\t\t\t</info-popover>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"section gf-form-group\">\n\t\t<h5 class=section-heading>Paging</h5>\n    <div class=gf-form>\n      <label class=\"gf-form-label width-8\">Rows per page</label>\n      <input type=number class=\"gf-form-input width-7\" placeholder=100 data-placement=right ng-model=editor.panel.pageSize ng-change=editor.render() ng-model-onblur>\n    </div>\n    <gf-form-switch class=gf-form label-class=width-8 switch-class=max-width-7 label=Scroll checked=editor.panel.scroll on-change=editor.render()></gf-form-switch>\n    <div class=\"gf-form max-width-17\">\n      <label class=\"gf-form-label width-8\">Font size</label>\n      <div class=\"gf-form-select-wrapper width-7\">\n        <select class=gf-form-input ng-model=editor.panel.fontSize ng-options=\"f for f in editor.fontSizes\" ng-change=editor.render()></select>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 913 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/table/module.html';
var html = "\n<div class=table-panel-container>\n\t<div class=table-panel-header-bg ng-show=ctrl.table.rows.length></div>\n\t<div class=table-panel-scroll ng-show=ctrl.table.rows.length>\n\t\t<table class=table-panel-table>\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th ng-repeat=\"col in ctrl.table.columns\" ng-hide=col.hidden>\n\t\t\t\t\t\t<div class=\"table-panel-table-header-inner pointer\" ng-click=\"ctrl.toggleColumnSort(col, $index)\">\n\t\t\t\t\t\t\t{{col.title}}\n\t\t\t\t\t\t\t<span class=table-panel-table-header-controls ng-if=col.sort>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-caret-down\" ng-show=col.desc></i>\n\t\t\t\t\t\t\t\t<i class=\"fa fa-caret-up\" ng-hide=col.desc></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n</div>\n<div class=datapoints-warning ng-show=\"ctrl.table.rows.length===0\">\n\t<span class=small>\n\t\tNo data to show <tip>Nothing returned by data query</tip>\n\t</span>\n</div>\n<div class=table-panel-footer>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 914 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/text/editor.html';
var html = "<div class=gf-form-group>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<span class=gf-form-label>Mode</span>\n\t\t\t<span class=gf-form-select-wrapper>\n\t\t\t\t<select class=gf-form-input ng-model=ctrl.panel.mode ng-options=\"f for f in ['html','markdown']\"></select>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n\n<h3 class=page-heading>Content</h3>\n\n<span ng-show=\"ctrl.panel.mode == 'markdown'\">\n\t(This area uses <a target=_blank href=http://en.wikipedia.org/wiki/Markdown>Markdown</a>. HTML is not supported)\n</span>\n\n<div class=gf-form-inline>\n\t<div class=\"gf-form gf-form--grow\">\n\t\t<code-editor content=ctrl.panel.content on-change=ctrl.render() data-mode=markdown data-max-lines=20 code-editor-focus=true>\n\t\t</code-editor>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 915 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/text/module.html';
var html = "<p class=\"markdown-html panel-text-content\" ng-bind-html=ctrl.content ng-show=ctrl.content>\n</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 916 */
/***/ (function(module, exports) {

var path = 'public/app/plugins/panel/unknown/module.html';
var html = "<div class=text-center style=padding-top:2rem>\n\tUnknown panel type: <strong>{{ctrl.panel.type}}</strong>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_explorer_json_explorer__ = __webpack_require__(394);


__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('jsonTree', [
    function jsonTreeDirective() {
        return {
            restrict: 'E',
            scope: {
                object: '=',
                startExpanded: '@',
                rootName: '@',
            },
            link: function (scope, elem) {
                var jsonExp = new __WEBPACK_IMPORTED_MODULE_1__json_explorer_json_explorer__["a" /* JsonExplorer */](scope.object, 3, {
                    animateOpen: true,
                });
                var html = jsonExp.render(true);
                elem.html(html);
            },
        };
    },
]);


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["c"] = getObjectName;
/* harmony export (immutable) */ __webpack_exports__["d"] = getType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getValuePreview;
/* unused harmony export getPreview */
/* harmony export (immutable) */ __webpack_exports__["b"] = cssClass;
/* harmony export (immutable) */ __webpack_exports__["a"] = createElement;
// Based on work https://github.com/mohsen1/json-formatter-js
// Licence MIT, Copyright (c) 2015 Mohsen Azimi
/*
 * Escapes `"` characters from string
*/
function escapeString(str) {
    return str.replace('"', '"');
}
/*
 * Determines if a value is an object
*/
function isObject(value) {
    var type = typeof value;
    return !!value && type === 'object';
}
/*
 * Gets constructor name of an object.
 * From http://stackoverflow.com/a/332429
 *
*/
function getObjectName(object) {
    if (object === undefined) {
        return '';
    }
    if (object === null) {
        return 'Object';
    }
    if (typeof object === 'object' && !object.constructor) {
        return 'Object';
    }
    var funcNameRegex = /function ([^(]*)/;
    var results = funcNameRegex.exec(object.constructor.toString());
    if (results && results.length > 1) {
        return results[1];
    }
    else {
        return '';
    }
}
/*
 * Gets type of an object. Returns "null" for null objects
*/
function getType(object) {
    if (object === null) {
        return 'null';
    }
    return typeof object;
}
/*
 * Generates inline preview for a JavaScript object based on a value
*/
function getValuePreview(object, value) {
    var type = getType(object);
    if (type === 'null' || type === 'undefined') {
        return type;
    }
    if (type === 'string') {
        value = '"' + escapeString(value) + '"';
    }
    if (type === 'function') {
        // Remove content of the function
        return (object
            .toString()
            .replace(/[\r\n]/g, '')
            .replace(/\{.*\}/, '') + '{…}');
    }
    return value;
}
/*
 * Generates inline preview for a JavaScript object
*/
function getPreview(object) {
    var value = '';
    if (isObject(object)) {
        value = getObjectName(object);
        if (Array.isArray(object)) {
            value += '[' + object.length + ']';
        }
    }
    else {
        value = getValuePreview(object, object);
    }
    return value;
}
/*
 * Generates a prefixed CSS class name
*/
function cssClass(className) {
    return "json-formatter-" + className;
}
/*
  * Creates a new DOM element with given type and class
  * TODO: move me to helpers
*/
function createElement(type, className, content) {
    var el = document.createElement(type);
    if (className) {
        el.classList.add(cssClass(className));
    }
    if (content !== undefined) {
        if (content instanceof Node) {
            el.appendChild(content);
        }
        else {
            el.appendChild(document.createTextNode(String(content)));
        }
    }
    return el;
}


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export codeEditorDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_brace__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_brace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_brace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_grafana_dark__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_grafana_dark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__theme_grafana_dark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_ext_language_tools__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_ext_language_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_brace_ext_language_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_theme_textmate__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_theme_textmate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_brace_theme_textmate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_brace_mode_text__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_brace_mode_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_brace_mode_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_brace_snippets_text__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_brace_snippets_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_brace_snippets_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_brace_mode_sql__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_brace_mode_sql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_brace_mode_sql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_brace_snippets_sql__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_brace_snippets_sql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_brace_snippets_sql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_brace_mode_sqlserver__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_brace_mode_sqlserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_brace_mode_sqlserver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_brace_snippets_sqlserver__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_brace_snippets_sqlserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_brace_snippets_sqlserver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_brace_mode_markdown__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_brace_mode_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_brace_mode_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_brace_snippets_markdown__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_brace_snippets_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_brace_snippets_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_brace_mode_json__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_brace_mode_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_brace_mode_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_brace_snippets_json__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_brace_snippets_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_brace_snippets_json__);
/**
 * codeEditor directive based on Ace code editor
 * https://github.com/ajaxorg/ace
 *
 * Basic usage:
 * <code-editor content="ctrl.target.query" on-change="ctrl.panelCtrl.refresh()"
 *  data-mode="sql" data-show-gutter>
 * </code-editor>
 *
 * Params:
 * content:      Editor content.
 * onChange:     Function called on content change (invoked on editor blur, ctrl+enter, not on every change).
 * getCompleter: Function returned external completer. Completer is an object implemented getCompletions() method,
 *               see Prometheus Data Source implementation for details.
 *
 * Some Ace editor options available via data-* attributes:
 * data-mode               - Language mode (text, sql, javascript, etc.). Default is 'text'.
 * data-theme              - Editor theme (eg 'solarized_dark').
 * data-max-lines          - Max editor height in lines. Editor grows automatically from 1 to maxLines.
 * data-show-gutter        - Show gutter (contains line numbers and additional info).
 * data-tab-size           - Tab size, default is 2.
 * data-behaviours-enabled - Specifies whether to use behaviors or not. "Behaviors" in this case is the auto-pairing of
 *                           special characters, like quotation marks, parenthesis, or brackets.
 * data-snippets-enabled   - Specifies whether to use snippets or not. "Snippets" are small pieces of code that can be
 *                           inserted via the completion box.
 *
 * Keybindings:
 * Ctrl-Enter (Command-Enter): run onChange() function
 */
















var DEFAULT_THEME_DARK = 'ace/theme/grafana-dark';
var DEFAULT_THEME_LIGHT = 'ace/theme/textmate';
var DEFAULT_MODE = 'text';
var DEFAULT_MAX_LINES = 10;
var DEFAULT_TAB_SIZE = 2;
var DEFAULT_BEHAVIOURS = true;
var DEFAULT_SNIPPETS = true;
var editorTemplate = "<div></div>";
function link(scope, elem, attrs) {
    // Options
    var langMode = attrs.mode || DEFAULT_MODE;
    var maxLines = attrs.maxLines || DEFAULT_MAX_LINES;
    var showGutter = attrs.showGutter !== undefined;
    var tabSize = attrs.tabSize || DEFAULT_TAB_SIZE;
    var behavioursEnabled = attrs.behavioursEnabled ? attrs.behavioursEnabled === 'true' : DEFAULT_BEHAVIOURS;
    var snippetsEnabled = attrs.snippetsEnabled ? attrs.snippetsEnabled === 'true' : DEFAULT_SNIPPETS;
    // Initialize editor
    var aceElem = elem.get(0);
    var codeEditor = __WEBPACK_IMPORTED_MODULE_2_brace___default.a.edit(aceElem);
    var editorSession = codeEditor.getSession();
    var editorOptions = {
        maxLines: maxLines,
        showGutter: showGutter,
        tabSize: tabSize,
        behavioursEnabled: behavioursEnabled,
        highlightActiveLine: false,
        showPrintMargin: false,
        autoScrollEditorIntoView: true,
    };
    // Set options
    codeEditor.setOptions(editorOptions);
    // disable depreacation warning
    codeEditor.$blockScrolling = Infinity;
    // Padding hacks
    codeEditor.renderer.setScrollMargin(15, 15);
    codeEditor.renderer.setPadding(10);
    setThemeMode();
    setLangMode(langMode);
    setEditorContent(scope.content);
    // Add classes
    elem.addClass('gf-code-editor');
    var textarea = elem.find('textarea');
    textarea.addClass('gf-form-input');
    if (scope.codeEditorFocus) {
        setTimeout(function () {
            textarea.focus();
            var domEl = textarea[0];
            if (domEl.setSelectionRange) {
                var pos = textarea.val().length * 2;
                domEl.setSelectionRange(pos, pos);
            }
        }, 100);
    }
    // Event handlers
    editorSession.on('change', function (e) {
        scope.$apply(function () {
            var newValue = codeEditor.getValue();
            scope.content = newValue;
        });
    });
    // Sync with outer scope - update editor content if model has been changed from outside of directive.
    scope.$watch('content', function (newValue, oldValue) {
        var editorValue = codeEditor.getValue();
        if (newValue !== editorValue && newValue !== oldValue) {
            scope.$$postDigest(function () {
                setEditorContent(newValue);
            });
        }
    });
    codeEditor.on('blur', function () {
        scope.onChange();
    });
    scope.$on('$destroy', function () {
        codeEditor.destroy();
    });
    // Keybindings
    codeEditor.commands.addCommand({
        name: 'executeQuery',
        bindKey: { win: 'Ctrl-Enter', mac: 'Command-Enter' },
        exec: function () {
            scope.onChange();
        },
    });
    function setLangMode(lang) {
        __WEBPACK_IMPORTED_MODULE_2_brace___default.a.acequire('ace/ext/language_tools');
        codeEditor.setOptions({
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: snippetsEnabled,
        });
        if (scope.getCompleter()) {
            // make copy of array as ace seems to share completers array between instances
            var anyEditor = codeEditor;
            anyEditor.completers = anyEditor.completers.slice();
            anyEditor.completers.push(scope.getCompleter());
        }
        var aceModeName = "ace/mode/" + lang;
        editorSession.setMode(aceModeName);
    }
    function setThemeMode() {
        var theme = DEFAULT_THEME_DARK;
        if (__WEBPACK_IMPORTED_MODULE_1_app_core_config__["a" /* default */].bootData.user.lightTheme) {
            theme = DEFAULT_THEME_LIGHT;
        }
        codeEditor.setTheme(theme);
    }
    function setEditorContent(value) {
        codeEditor.setValue(value);
        codeEditor.clearSelection();
    }
}
function codeEditorDirective() {
    return {
        restrict: 'E',
        template: editorTemplate,
        scope: {
            content: '=',
            datasource: '=',
            codeEditorFocus: '<',
            onChange: '&',
            getCompleter: '&',
        },
        link: link,
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('codeEditor', codeEditorDirective);


/***/ }),
/* 920 */,
/* 921 */
/***/ (function(module, exports) {

/* jshint ignore:start */

ace.define("ace/theme/grafana-dark",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
  "use strict";

  exports.isDark = true;
  exports.cssClass = "gf-code-dark";
  exports.cssText = ".gf-code-dark .ace_gutter {\
  background: #2f3129;\
  color: #8f908a\
  }\
  .gf-code-dark .ace_print-margin {\
  width: 1px;\
  background: #555651\
  }\
  .gf-code-dark {\
  background-color: #111;\
  color: #e0e0e0\
  }\
  .gf-code-dark .ace_cursor {\
  color: #f8f8f0\
  }\
  .gf-code-dark .ace_marker-layer .ace_selection {\
  background: #49483e\
  }\
  .gf-code-dark.ace_multiselect .ace_selection.ace_start {\
  box-shadow: 0 0 3px 0px #272822;\
  }\
  .gf-code-dark .ace_marker-layer .ace_step {\
  background: rgb(102, 82, 0)\
  }\
  .gf-code-dark .ace_marker-layer .ace_bracket {\
  margin: -1px 0 0 -1px;\
  border: 1px solid #49483e\
  }\
  .gf-code-dark .ace_marker-layer .ace_active-line {\
  background: #202020\
  }\
  .gf-code-dark .ace_gutter-active-line {\
  background-color: #272727\
  }\
  .gf-code-dark .ace_marker-layer .ace_selected-word {\
  border: 1px solid #49483e\
  }\
  .gf-code-dark .ace_invisible {\
  color: #52524d\
  }\
  .gf-code-dark .ace_entity.ace_name.ace_tag,\
  .gf-code-dark .ace_keyword,\
  .gf-code-dark .ace_meta.ace_tag,\
  .gf-code-dark .ace_storage {\
  color: #66d9ef\
  }\
  .gf-code-dark .ace_punctuation,\
  .gf-code-dark .ace_punctuation.ace_tag {\
  color: #fff\
  }\
  .gf-code-dark .ace_constant.ace_character,\
  .gf-code-dark .ace_constant.ace_language,\
  .gf-code-dark .ace_constant.ace_numeric,\
  .gf-code-dark .ace_constant.ace_other {\
  color: #fe85fc\
  }\
  .gf-code-dark .ace_invalid {\
  color: #f8f8f0;\
  background-color: #f92672\
  }\
  .gf-code-dark .ace_invalid.ace_deprecated {\
  color: #f8f8f0;\
  background-color: #ae81ff\
  }\
  .gf-code-dark .ace_support.ace_constant,\
  .gf-code-dark .ace_support.ace_function {\
  color: #59e6e3\
  }\
  .gf-code-dark .ace_fold {\
  background-color: #a6e22e;\
  border-color: #f8f8f2\
  }\
  .gf-code-dark .ace_storage.ace_type,\
  .gf-code-dark .ace_support.ace_class,\
  .gf-code-dark .ace_support.ace_type {\
  font-style: italic;\
  color: #66d9ef\
  }\
  .gf-code-dark .ace_entity.ace_name.ace_function,\
  .gf-code-dark .ace_entity.ace_other,\
  .gf-code-dark .ace_entity.ace_other.ace_attribute-name,\
  .gf-code-dark .ace_variable {\
  color: #a6e22e\
  }\
  .gf-code-dark .ace_variable.ace_parameter {\
  font-style: italic;\
  color: #fd971f\
  }\
  .gf-code-dark .ace_string {\
  color: #74e680\
  }\
  .gf-code-dark .ace_paren {\
    color: #f0a842\
  }\
  .gf-code-dark .ace_operator {\
    color: #FFF\
  }\
  .gf-code-dark .ace_comment {\
  color: #75715e\
  }\
  .gf-code-dark .ace_indent-guide {\
  background: url(data:image/png;base64,ivborw0kggoaaaansuheugaaaaeaaaaccayaaaczgbynaaaaekleqvqimwpq0fd0zxbzd/wpaajvaoxesgneaaaaaelftksuqmcc) right repeat-y\
  }";

  var dom = acequire("../lib/dom");
  dom.importCssString(exports.cssText, exports.cssClass);
});

/* jshint ignore:end */


/***/ }),
/* 922 */
/***/ (function(module, exports) {

ace.define("ace/snippets",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/lang","ace/range","ace/anchor","ace/keyboard/hash_handler","ace/tokenizer","ace/lib/dom","ace/editor"], function(acequire, exports, module) {
"use strict";
var oop = acequire("./lib/oop");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var lang = acequire("./lib/lang");
var Range = acequire("./range").Range;
var Anchor = acequire("./anchor").Anchor;
var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
var Tokenizer = acequire("./tokenizer").Tokenizer;
var comparePoints = Range.comparePoints;

var SnippetManager = function() {
    this.snippetMap = {};
    this.snippetNameMap = {};
};

(function() {
    oop.implement(this, EventEmitter);
    
    this.getTokenizer = function() {
        function TabstopToken(str, _, stack) {
            str = str.substr(1);
            if (/^\d+$/.test(str) && !stack.inFormatString)
                return [{tabstopId: parseInt(str, 10)}];
            return [{text: str}];
        }
        function escape(ch) {
            return "(?:[^\\\\" + ch + "]|\\\\.)";
        }
        SnippetManager.$tokenizer = new Tokenizer({
            start: [
                {regex: /:/, onMatch: function(val, state, stack) {
                    if (stack.length && stack[0].expectIf) {
                        stack[0].expectIf = false;
                        stack[0].elseBranch = stack[0];
                        return [stack[0]];
                    }
                    return ":";
                }},
                {regex: /\\./, onMatch: function(val, state, stack) {
                    var ch = val[1];
                    if (ch == "}" && stack.length) {
                        val = ch;
                    }else if ("`$\\".indexOf(ch) != -1) {
                        val = ch;
                    } else if (stack.inFormatString) {
                        if (ch == "n")
                            val = "\n";
                        else if (ch == "t")
                            val = "\n";
                        else if ("ulULE".indexOf(ch) != -1) {
                            val = {changeCase: ch, local: ch > "a"};
                        }
                    }

                    return [val];
                }},
                {regex: /}/, onMatch: function(val, state, stack) {
                    return [stack.length ? stack.shift() : val];
                }},
                {regex: /\$(?:\d+|\w+)/, onMatch: TabstopToken},
                {regex: /\$\{[\dA-Z_a-z]+/, onMatch: function(str, state, stack) {
                    var t = TabstopToken(str.substr(1), state, stack);
                    stack.unshift(t[0]);
                    return t;
                }, next: "snippetVar"},
                {regex: /\n/, token: "newline", merge: false}
            ],
            snippetVar: [
                {regex: "\\|" + escape("\\|") + "*\\|", onMatch: function(val, state, stack) {
                    stack[0].choices = val.slice(1, -1).split(",");
                }, next: "start"},
                {regex: "/(" + escape("/") + "+)/(?:(" + escape("/") + "*)/)(\\w*):?",
                 onMatch: function(val, state, stack) {
                    var ts = stack[0];
                    ts.fmtString = val;

                    val = this.splitRegex.exec(val);
                    ts.guard = val[1];
                    ts.fmt = val[2];
                    ts.flag = val[3];
                    return "";
                }, next: "start"},
                {regex: "`" + escape("`") + "*`", onMatch: function(val, state, stack) {
                    stack[0].code = val.splice(1, -1);
                    return "";
                }, next: "start"},
                {regex: "\\?", onMatch: function(val, state, stack) {
                    if (stack[0])
                        stack[0].expectIf = true;
                }, next: "start"},
                {regex: "([^:}\\\\]|\\\\.)*:?", token: "", next: "start"}
            ],
            formatString: [
                {regex: "/(" + escape("/") + "+)/", token: "regex"},
                {regex: "", onMatch: function(val, state, stack) {
                    stack.inFormatString = true;
                }, next: "start"}
            ]
        });
        SnippetManager.prototype.getTokenizer = function() {
            return SnippetManager.$tokenizer;
        };
        return SnippetManager.$tokenizer;
    };

    this.tokenizeTmSnippet = function(str, startState) {
        return this.getTokenizer().getLineTokens(str, startState).tokens.map(function(x) {
            return x.value || x;
        });
    };

    this.$getDefaultValue = function(editor, name) {
        if (/^[A-Z]\d+$/.test(name)) {
            var i = name.substr(1);
            return (this.variables[name[0] + "__"] || {})[i];
        }
        if (/^\d+$/.test(name)) {
            return (this.variables.__ || {})[name];
        }
        name = name.replace(/^TM_/, "");

        if (!editor)
            return;
        var s = editor.session;
        switch(name) {
            case "CURRENT_WORD":
                var r = s.getWordRange();
            case "SELECTION":
            case "SELECTED_TEXT":
                return s.getTextRange(r);
            case "CURRENT_LINE":
                return s.getLine(editor.getCursorPosition().row);
            case "PREV_LINE": // not possible in textmate
                return s.getLine(editor.getCursorPosition().row - 1);
            case "LINE_INDEX":
                return editor.getCursorPosition().column;
            case "LINE_NUMBER":
                return editor.getCursorPosition().row + 1;
            case "SOFT_TABS":
                return s.getUseSoftTabs() ? "YES" : "NO";
            case "TAB_SIZE":
                return s.getTabSize();
            case "FILENAME":
            case "FILEPATH":
                return "";
            case "FULLNAME":
                return "Ace";
        }
    };
    this.variables = {};
    this.getVariableValue = function(editor, varName) {
        if (this.variables.hasOwnProperty(varName))
            return this.variables[varName](editor, varName) || "";
        return this.$getDefaultValue(editor, varName) || "";
    };
    this.tmStrFormat = function(str, ch, editor) {
        var flag = ch.flag || "";
        var re = ch.guard;
        re = new RegExp(re, flag.replace(/[^gi]/, ""));
        var fmtTokens = this.tokenizeTmSnippet(ch.fmt, "formatString");
        var _self = this;
        var formatted = str.replace(re, function() {
            _self.variables.__ = arguments;
            var fmtParts = _self.resolveVariables(fmtTokens, editor);
            var gChangeCase = "E";
            for (var i  = 0; i < fmtParts.length; i++) {
                var ch = fmtParts[i];
                if (typeof ch == "object") {
                    fmtParts[i] = "";
                    if (ch.changeCase && ch.local) {
                        var next = fmtParts[i + 1];
                        if (next && typeof next == "string") {
                            if (ch.changeCase == "u")
                                fmtParts[i] = next[0].toUpperCase();
                            else
                                fmtParts[i] = next[0].toLowerCase();
                            fmtParts[i + 1] = next.substr(1);
                        }
                    } else if (ch.changeCase) {
                        gChangeCase = ch.changeCase;
                    }
                } else if (gChangeCase == "U") {
                    fmtParts[i] = ch.toUpperCase();
                } else if (gChangeCase == "L") {
                    fmtParts[i] = ch.toLowerCase();
                }
            }
            return fmtParts.join("");
        });
        this.variables.__ = null;
        return formatted;
    };

    this.resolveVariables = function(snippet, editor) {
        var result = [];
        for (var i = 0; i < snippet.length; i++) {
            var ch = snippet[i];
            if (typeof ch == "string") {
                result.push(ch);
            } else if (typeof ch != "object") {
                continue;
            } else if (ch.skip) {
                gotoNext(ch);
            } else if (ch.processed < i) {
                continue;
            } else if (ch.text) {
                var value = this.getVariableValue(editor, ch.text);
                if (value && ch.fmtString)
                    value = this.tmStrFormat(value, ch);
                ch.processed = i;
                if (ch.expectIf == null) {
                    if (value) {
                        result.push(value);
                        gotoNext(ch);
                    }
                } else {
                    if (value) {
                        ch.skip = ch.elseBranch;
                    } else
                        gotoNext(ch);
                }
            } else if (ch.tabstopId != null) {
                result.push(ch);
            } else if (ch.changeCase != null) {
                result.push(ch);
            }
        }
        function gotoNext(ch) {
            var i1 = snippet.indexOf(ch, i + 1);
            if (i1 != -1)
                i = i1;
        }
        return result;
    };

    this.insertSnippetForSelection = function(editor, snippetText) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var tabString = editor.session.getTabString();
        var indentString = line.match(/^\s*/)[0];
        
        if (cursor.column < indentString.length)
            indentString = indentString.slice(0, cursor.column);

        snippetText = snippetText.replace(/\r/g, "");
        var tokens = this.tokenizeTmSnippet(snippetText);
        tokens = this.resolveVariables(tokens, editor);
        tokens = tokens.map(function(x) {
            if (x == "\n")
                return x + indentString;
            if (typeof x == "string")
                return x.replace(/\t/g, tabString);
            return x;
        });
        var tabstops = [];
        tokens.forEach(function(p, i) {
            if (typeof p != "object")
                return;
            var id = p.tabstopId;
            var ts = tabstops[id];
            if (!ts) {
                ts = tabstops[id] = [];
                ts.index = id;
                ts.value = "";
            }
            if (ts.indexOf(p) !== -1)
                return;
            ts.push(p);
            var i1 = tokens.indexOf(p, i + 1);
            if (i1 === -1)
                return;

            var value = tokens.slice(i + 1, i1);
            var isNested = value.some(function(t) {return typeof t === "object"});          
            if (isNested && !ts.value) {
                ts.value = value;
            } else if (value.length && (!ts.value || typeof ts.value !== "string")) {
                ts.value = value.join("");
            }
        });
        tabstops.forEach(function(ts) {ts.length = 0});
        var expanding = {};
        function copyValue(val) {
            var copy = [];
            for (var i = 0; i < val.length; i++) {
                var p = val[i];
                if (typeof p == "object") {
                    if (expanding[p.tabstopId])
                        continue;
                    var j = val.lastIndexOf(p, i - 1);
                    p = copy[j] || {tabstopId: p.tabstopId};
                }
                copy[i] = p;
            }
            return copy;
        }
        for (var i = 0; i < tokens.length; i++) {
            var p = tokens[i];
            if (typeof p != "object")
                continue;
            var id = p.tabstopId;
            var i1 = tokens.indexOf(p, i + 1);
            if (expanding[id]) {
                if (expanding[id] === p)
                    expanding[id] = null;
                continue;
            }
            
            var ts = tabstops[id];
            var arg = typeof ts.value == "string" ? [ts.value] : copyValue(ts.value);
            arg.unshift(i + 1, Math.max(0, i1 - i));
            arg.push(p);
            expanding[id] = p;
            tokens.splice.apply(tokens, arg);

            if (ts.indexOf(p) === -1)
                ts.push(p);
        }
        var row = 0, column = 0;
        var text = "";
        tokens.forEach(function(t) {
            if (typeof t === "string") {
                var lines = t.split("\n");
                if (lines.length > 1){
                    column = lines[lines.length - 1].length;
                    row += lines.length - 1;
                } else
                    column += t.length;
                text += t;
            } else {
                if (!t.start)
                    t.start = {row: row, column: column};
                else
                    t.end = {row: row, column: column};
            }
        });
        var range = editor.getSelectionRange();
        var end = editor.session.replace(range, text);

        var tabstopManager = new TabstopManager(editor);
        var selectionId = editor.inVirtualSelectionMode && editor.selection.index;
        tabstopManager.addTabstops(tabstops, range.start, end, selectionId);
    };
    
    this.insertSnippet = function(editor, snippetText) {
        var self = this;
        if (editor.inVirtualSelectionMode)
            return self.insertSnippetForSelection(editor, snippetText);
        
        editor.forEachSelection(function() {
            self.insertSnippetForSelection(editor, snippetText);
        }, null, {keepOrder: true});
        
        if (editor.tabstopManager)
            editor.tabstopManager.tabNext();
    };

    this.$getScope = function(editor) {
        var scope = editor.session.$mode.$id || "";
        scope = scope.split("/").pop();
        if (scope === "html" || scope === "php") {
            if (scope === "php" && !editor.session.$mode.inlinePhp) 
                scope = "html";
            var c = editor.getCursorPosition();
            var state = editor.session.getState(c.row);
            if (typeof state === "object") {
                state = state[0];
            }
            if (state.substring) {
                if (state.substring(0, 3) == "js-")
                    scope = "javascript";
                else if (state.substring(0, 4) == "css-")
                    scope = "css";
                else if (state.substring(0, 4) == "php-")
                    scope = "php";
            }
        }
        
        return scope;
    };

    this.getActiveScopes = function(editor) {
        var scope = this.$getScope(editor);
        var scopes = [scope];
        var snippetMap = this.snippetMap;
        if (snippetMap[scope] && snippetMap[scope].includeScopes) {
            scopes.push.apply(scopes, snippetMap[scope].includeScopes);
        }
        scopes.push("_");
        return scopes;
    };

    this.expandWithTab = function(editor, options) {
        var self = this;
        var result = editor.forEachSelection(function() {
            return self.expandSnippetForSelection(editor, options);
        }, null, {keepOrder: true});
        if (result && editor.tabstopManager)
            editor.tabstopManager.tabNext();
        return result;
    };
    
    this.expandSnippetForSelection = function(editor, options) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var before = line.substring(0, cursor.column);
        var after = line.substr(cursor.column);

        var snippetMap = this.snippetMap;
        var snippet;
        this.getActiveScopes(editor).some(function(scope) {
            var snippets = snippetMap[scope];
            if (snippets)
                snippet = this.findMatchingSnippet(snippets, before, after);
            return !!snippet;
        }, this);
        if (!snippet)
            return false;
        if (options && options.dryRun)
            return true;
        editor.session.doc.removeInLine(cursor.row,
            cursor.column - snippet.replaceBefore.length,
            cursor.column + snippet.replaceAfter.length
        );

        this.variables.M__ = snippet.matchBefore;
        this.variables.T__ = snippet.matchAfter;
        this.insertSnippetForSelection(editor, snippet.content);

        this.variables.M__ = this.variables.T__ = null;
        return true;
    };

    this.findMatchingSnippet = function(snippetList, before, after) {
        for (var i = snippetList.length; i--;) {
            var s = snippetList[i];
            if (s.startRe && !s.startRe.test(before))
                continue;
            if (s.endRe && !s.endRe.test(after))
                continue;
            if (!s.startRe && !s.endRe)
                continue;

            s.matchBefore = s.startRe ? s.startRe.exec(before) : [""];
            s.matchAfter = s.endRe ? s.endRe.exec(after) : [""];
            s.replaceBefore = s.triggerRe ? s.triggerRe.exec(before)[0] : "";
            s.replaceAfter = s.endTriggerRe ? s.endTriggerRe.exec(after)[0] : "";
            return s;
        }
    };

    this.snippetMap = {};
    this.snippetNameMap = {};
    this.register = function(snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;
        var self = this;
        
        if (!snippets) 
            snippets = [];
        
        function wrapRegexp(src) {
            if (src && !/^\^?\(.*\)\$?$|^\\b$/.test(src))
                src = "(?:" + src + ")";

            return src || "";
        }
        function guardedRegexp(re, guard, opening) {
            re = wrapRegexp(re);
            guard = wrapRegexp(guard);
            if (opening) {
                re = guard + re;
                if (re && re[re.length - 1] != "$")
                    re = re + "$";
            } else {
                re = re + guard;
                if (re && re[0] != "^")
                    re = "^" + re;
            }
            return new RegExp(re);
        }

        function addSnippet(s) {
            if (!s.scope)
                s.scope = scope || "_";
            scope = s.scope;
            if (!snippetMap[scope]) {
                snippetMap[scope] = [];
                snippetNameMap[scope] = {};
            }

            var map = snippetNameMap[scope];
            if (s.name) {
                var old = map[s.name];
                if (old)
                    self.unregister(old);
                map[s.name] = s;
            }
            snippetMap[scope].push(s);

            if (s.tabTrigger && !s.trigger) {
                if (!s.guard && /^\w/.test(s.tabTrigger))
                    s.guard = "\\b";
                s.trigger = lang.escapeRegExp(s.tabTrigger);
            }
            
            if (!s.trigger && !s.guard && !s.endTrigger && !s.endGuard)
                return;
            
            s.startRe = guardedRegexp(s.trigger, s.guard, true);
            s.triggerRe = new RegExp(s.trigger, "", true);

            s.endRe = guardedRegexp(s.endTrigger, s.endGuard, true);
            s.endTriggerRe = new RegExp(s.endTrigger, "", true);
        }

        if (snippets && snippets.content)
            addSnippet(snippets);
        else if (Array.isArray(snippets))
            snippets.forEach(addSnippet);
        
        this._signal("registerSnippets", {scope: scope});
    };
    this.unregister = function(snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;

        function removeSnippet(s) {
            var nameMap = snippetNameMap[s.scope||scope];
            if (nameMap && nameMap[s.name]) {
                delete nameMap[s.name];
                var map = snippetMap[s.scope||scope];
                var i = map && map.indexOf(s);
                if (i >= 0)
                    map.splice(i, 1);
            }
        }
        if (snippets.content)
            removeSnippet(snippets);
        else if (Array.isArray(snippets))
            snippets.forEach(removeSnippet);
    };
    this.parseSnippetFile = function(str) {
        str = str.replace(/\r/g, "");
        var list = [], snippet = {};
        var re = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm;
        var m;
        while (m = re.exec(str)) {
            if (m[1]) {
                try {
                    snippet = JSON.parse(m[1]);
                    list.push(snippet);
                } catch (e) {}
            } if (m[4]) {
                snippet.content = m[4].replace(/^\t/gm, "");
                list.push(snippet);
                snippet = {};
            } else {
                var key = m[2], val = m[3];
                if (key == "regex") {
                    var guardRe = /\/((?:[^\/\\]|\\.)*)|$/g;
                    snippet.guard = guardRe.exec(val)[1];
                    snippet.trigger = guardRe.exec(val)[1];
                    snippet.endTrigger = guardRe.exec(val)[1];
                    snippet.endGuard = guardRe.exec(val)[1];
                } else if (key == "snippet") {
                    snippet.tabTrigger = val.match(/^\S*/)[0];
                    if (!snippet.name)
                        snippet.name = val;
                } else {
                    snippet[key] = val;
                }
            }
        }
        return list;
    };
    this.getSnippetByName = function(name, editor) {
        var snippetMap = this.snippetNameMap;
        var snippet;
        this.getActiveScopes(editor).some(function(scope) {
            var snippets = snippetMap[scope];
            if (snippets)
                snippet = snippets[name];
            return !!snippet;
        }, this);
        return snippet;
    };

}).call(SnippetManager.prototype);


var TabstopManager = function(editor) {
    if (editor.tabstopManager)
        return editor.tabstopManager;
    editor.tabstopManager = this;
    this.$onChange = this.onChange.bind(this);
    this.$onChangeSelection = lang.delayedCall(this.onChangeSelection.bind(this)).schedule;
    this.$onChangeSession = this.onChangeSession.bind(this);
    this.$onAfterExec = this.onAfterExec.bind(this);
    this.attach(editor);
};
(function() {
    this.attach = function(editor) {
        this.index = 0;
        this.ranges = [];
        this.tabstops = [];
        this.$openTabstops = null;
        this.selectedTabstop = null;

        this.editor = editor;
        this.editor.on("change", this.$onChange);
        this.editor.on("changeSelection", this.$onChangeSelection);
        this.editor.on("changeSession", this.$onChangeSession);
        this.editor.commands.on("afterExec", this.$onAfterExec);
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
    };
    this.detach = function() {
        this.tabstops.forEach(this.removeTabstopMarkers, this);
        this.ranges = null;
        this.tabstops = null;
        this.selectedTabstop = null;
        this.editor.removeListener("change", this.$onChange);
        this.editor.removeListener("changeSelection", this.$onChangeSelection);
        this.editor.removeListener("changeSession", this.$onChangeSession);
        this.editor.commands.removeListener("afterExec", this.$onAfterExec);
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.tabstopManager = null;
        this.editor = null;
    };

    this.onChange = function(delta) {
        var changeRange = delta;
        var isRemove = delta.action[0] == "r";
        var start = delta.start;
        var end = delta.end;
        var startRow = start.row;
        var endRow = end.row;
        var lineDif = endRow - startRow;
        var colDiff = end.column - start.column;

        if (isRemove) {
            lineDif = -lineDif;
            colDiff = -colDiff;
        }
        if (!this.$inChange && isRemove) {
            var ts = this.selectedTabstop;
            var changedOutside = ts && !ts.some(function(r) {
                return comparePoints(r.start, start) <= 0 && comparePoints(r.end, end) >= 0;
            });
            if (changedOutside)
                return this.detach();
        }
        var ranges = this.ranges;
        for (var i = 0; i < ranges.length; i++) {
            var r = ranges[i];
            if (r.end.row < start.row)
                continue;

            if (isRemove && comparePoints(start, r.start) < 0 && comparePoints(end, r.end) > 0) {
                this.removeRange(r);
                i--;
                continue;
            }

            if (r.start.row == startRow && r.start.column > start.column)
                r.start.column += colDiff;
            if (r.end.row == startRow && r.end.column >= start.column)
                r.end.column += colDiff;
            if (r.start.row >= startRow)
                r.start.row += lineDif;
            if (r.end.row >= startRow)
                r.end.row += lineDif;

            if (comparePoints(r.start, r.end) > 0)
                this.removeRange(r);
        }
        if (!ranges.length)
            this.detach();
    };
    this.updateLinkedFields = function() {
        var ts = this.selectedTabstop;
        if (!ts || !ts.hasLinkedRanges)
            return;
        this.$inChange = true;
        var session = this.editor.session;
        var text = session.getTextRange(ts.firstNonLinked);
        for (var i = ts.length; i--;) {
            var range = ts[i];
            if (!range.linked)
                continue;
            var fmt = exports.snippetManager.tmStrFormat(text, range.original);
            session.replace(range, fmt);
        }
        this.$inChange = false;
    };
    this.onAfterExec = function(e) {
        if (e.command && !e.command.readOnly)
            this.updateLinkedFields();
    };
    this.onChangeSelection = function() {
        if (!this.editor)
            return;
        var lead = this.editor.selection.lead;
        var anchor = this.editor.selection.anchor;
        var isEmpty = this.editor.selection.isEmpty();
        for (var i = this.ranges.length; i--;) {
            if (this.ranges[i].linked)
                continue;
            var containsLead = this.ranges[i].contains(lead.row, lead.column);
            var containsAnchor = isEmpty || this.ranges[i].contains(anchor.row, anchor.column);
            if (containsLead && containsAnchor)
                return;
        }
        this.detach();
    };
    this.onChangeSession = function() {
        this.detach();
    };
    this.tabNext = function(dir) {
        var max = this.tabstops.length;
        var index = this.index + (dir || 1);
        index = Math.min(Math.max(index, 1), max);
        if (index == max)
            index = 0;
        this.selectTabstop(index);
        if (index === 0)
            this.detach();
    };
    this.selectTabstop = function(index) {
        this.$openTabstops = null;
        var ts = this.tabstops[this.index];
        if (ts)
            this.addTabstopMarkers(ts);
        this.index = index;
        ts = this.tabstops[this.index];
        if (!ts || !ts.length)
            return;
        
        this.selectedTabstop = ts;
        if (!this.editor.inVirtualSelectionMode) {        
            var sel = this.editor.multiSelect;
            sel.toSingleRange(ts.firstNonLinked.clone());
            for (var i = ts.length; i--;) {
                if (ts.hasLinkedRanges && ts[i].linked)
                    continue;
                sel.addRange(ts[i].clone(), true);
            }
            if (sel.ranges[0])
                sel.addRange(sel.ranges[0].clone());
        } else {
            this.editor.selection.setRange(ts.firstNonLinked);
        }
        
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
    };
    this.addTabstops = function(tabstops, start, end) {
        if (!this.$openTabstops)
            this.$openTabstops = [];
        if (!tabstops[0]) {
            var p = Range.fromPoints(end, end);
            moveRelative(p.start, start);
            moveRelative(p.end, start);
            tabstops[0] = [p];
            tabstops[0].index = 0;
        }

        var i = this.index;
        var arg = [i + 1, 0];
        var ranges = this.ranges;
        tabstops.forEach(function(ts, index) {
            var dest = this.$openTabstops[index] || ts;
                
            for (var i = ts.length; i--;) {
                var p = ts[i];
                var range = Range.fromPoints(p.start, p.end || p.start);
                movePoint(range.start, start);
                movePoint(range.end, start);
                range.original = p;
                range.tabstop = dest;
                ranges.push(range);
                if (dest != ts)
                    dest.unshift(range);
                else
                    dest[i] = range;
                if (p.fmtString) {
                    range.linked = true;
                    dest.hasLinkedRanges = true;
                } else if (!dest.firstNonLinked)
                    dest.firstNonLinked = range;
            }
            if (!dest.firstNonLinked)
                dest.hasLinkedRanges = false;
            if (dest === ts) {
                arg.push(dest);
                this.$openTabstops[index] = dest;
            }
            this.addTabstopMarkers(dest);
        }, this);
        
        if (arg.length > 2) {
            if (this.tabstops.length)
                arg.push(arg.splice(2, 1)[0]);
            this.tabstops.splice.apply(this.tabstops, arg);
        }
    };

    this.addTabstopMarkers = function(ts) {
        var session = this.editor.session;
        ts.forEach(function(range) {
            if  (!range.markerId)
                range.markerId = session.addMarker(range, "ace_snippet-marker", "text");
        });
    };
    this.removeTabstopMarkers = function(ts) {
        var session = this.editor.session;
        ts.forEach(function(range) {
            session.removeMarker(range.markerId);
            range.markerId = null;
        });
    };
    this.removeRange = function(range) {
        var i = range.tabstop.indexOf(range);
        range.tabstop.splice(i, 1);
        i = this.ranges.indexOf(range);
        this.ranges.splice(i, 1);
        this.editor.session.removeMarker(range.markerId);
        if (!range.tabstop.length) {
            i = this.tabstops.indexOf(range.tabstop);
            if (i != -1)
                this.tabstops.splice(i, 1);
            if (!this.tabstops.length)
                this.detach();
        }
    };

    this.keyboardHandler = new HashHandler();
    this.keyboardHandler.bindKeys({
        "Tab": function(ed) {
            if (exports.snippetManager && exports.snippetManager.expandWithTab(ed)) {
                return;
            }

            ed.tabstopManager.tabNext(1);
        },
        "Shift-Tab": function(ed) {
            ed.tabstopManager.tabNext(-1);
        },
        "Esc": function(ed) {
            ed.tabstopManager.detach();
        },
        "Return": function(ed) {
            return false;
        }
    });
}).call(TabstopManager.prototype);



var changeTracker = {};
changeTracker.onChange = Anchor.prototype.onChange;
changeTracker.setPosition = function(row, column) {
    this.pos.row = row;
    this.pos.column = column;
};
changeTracker.update = function(pos, delta, $insertRight) {
    this.$insertRight = $insertRight;
    this.pos = pos; 
    this.onChange(delta);
};

var movePoint = function(point, diff) {
    if (point.row == 0)
        point.column += diff.column;
    point.row += diff.row;
};

var moveRelative = function(point, start) {
    if (point.row == start.row)
        point.column -= start.column;
    point.row -= start.row;
};


acequire("./lib/dom").importCssString("\
.ace_snippet-marker {\
    -moz-box-sizing: border-box;\
    box-sizing: border-box;\
    background: rgba(194, 193, 208, 0.09);\
    border: 1px dotted rgba(211, 208, 235, 0.62);\
    position: absolute;\
}");

exports.snippetManager = new SnippetManager();


var Editor = acequire("./editor").Editor;
(function() {
    this.insertSnippet = function(content, options) {
        return exports.snippetManager.insertSnippet(this, content, options);
    };
    this.expandSnippet = function(options) {
        return exports.snippetManager.expandWithTab(this, options);
    };
}).call(Editor.prototype);

});

ace.define("ace/autocomplete/popup",["require","exports","module","ace/virtual_renderer","ace/editor","ace/range","ace/lib/event","ace/lib/lang","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var Renderer = acequire("../virtual_renderer").VirtualRenderer;
var Editor = acequire("../editor").Editor;
var Range = acequire("../range").Range;
var event = acequire("../lib/event");
var lang = acequire("../lib/lang");
var dom = acequire("../lib/dom");

var $singleLineEditor = function(el) {
    var renderer = new Renderer(el);

    renderer.$maxLines = 4;

    var editor = new Editor(renderer);

    editor.setHighlightActiveLine(false);
    editor.setShowPrintMargin(false);
    editor.renderer.setShowGutter(false);
    editor.renderer.setHighlightGutterLine(false);

    editor.$mouseHandler.$focusWaitTimout = 0;
    editor.$highlightTagPending = true;

    return editor;
};

var AcePopup = function(parentNode) {
    var el = dom.createElement("div");
    var popup = new $singleLineEditor(el);

    if (parentNode)
        parentNode.appendChild(el);
    el.style.display = "none";
    popup.renderer.content.style.cursor = "default";
    popup.renderer.setStyle("ace_autocomplete");

    popup.setOption("displayIndentGuides", false);
    popup.setOption("dragDelay", 150);

    var noop = function(){};

    popup.focus = noop;
    popup.$isFocused = true;

    popup.renderer.$cursorLayer.restartTimer = noop;
    popup.renderer.$cursorLayer.element.style.opacity = 0;

    popup.renderer.$maxLines = 8;
    popup.renderer.$keepTextAreaAtCursor = false;

    popup.setHighlightActiveLine(false);
    popup.session.highlight("");
    popup.session.$searchHighlight.clazz = "ace_highlight-marker";

    popup.on("mousedown", function(e) {
        var pos = e.getDocumentPosition();
        popup.selection.moveToPosition(pos);
        selectionMarker.start.row = selectionMarker.end.row = pos.row;
        e.stop();
    });

    var lastMouseEvent;
    var hoverMarker = new Range(-1,0,-1,Infinity);
    var selectionMarker = new Range(-1,0,-1,Infinity);
    selectionMarker.id = popup.session.addMarker(selectionMarker, "ace_active-line", "fullLine");
    popup.setSelectOnHover = function(val) {
        if (!val) {
            hoverMarker.id = popup.session.addMarker(hoverMarker, "ace_line-hover", "fullLine");
        } else if (hoverMarker.id) {
            popup.session.removeMarker(hoverMarker.id);
            hoverMarker.id = null;
        }
    };
    popup.setSelectOnHover(false);
    popup.on("mousemove", function(e) {
        if (!lastMouseEvent) {
            lastMouseEvent = e;
            return;
        }
        if (lastMouseEvent.x == e.x && lastMouseEvent.y == e.y) {
            return;
        }
        lastMouseEvent = e;
        lastMouseEvent.scrollTop = popup.renderer.scrollTop;
        var row = lastMouseEvent.getDocumentPosition().row;
        if (hoverMarker.start.row != row) {
            if (!hoverMarker.id)
                popup.setRow(row);
            setHoverMarker(row);
        }
    });
    popup.renderer.on("beforeRender", function() {
        if (lastMouseEvent && hoverMarker.start.row != -1) {
            lastMouseEvent.$pos = null;
            var row = lastMouseEvent.getDocumentPosition().row;
            if (!hoverMarker.id)
                popup.setRow(row);
            setHoverMarker(row, true);
        }
    });
    popup.renderer.on("afterRender", function() {
        var row = popup.getRow();
        var t = popup.renderer.$textLayer;
        var selected = t.element.childNodes[row - t.config.firstRow];
        if (selected == t.selectedNode)
            return;
        if (t.selectedNode)
            dom.removeCssClass(t.selectedNode, "ace_selected");
        t.selectedNode = selected;
        if (selected)
            dom.addCssClass(selected, "ace_selected");
    });
    var hideHoverMarker = function() { setHoverMarker(-1) };
    var setHoverMarker = function(row, suppressRedraw) {
        if (row !== hoverMarker.start.row) {
            hoverMarker.start.row = hoverMarker.end.row = row;
            if (!suppressRedraw)
                popup.session._emit("changeBackMarker");
            popup._emit("changeHoverMarker");
        }
    };
    popup.getHoveredRow = function() {
        return hoverMarker.start.row;
    };

    event.addListener(popup.container, "mouseout", hideHoverMarker);
    popup.on("hide", hideHoverMarker);
    popup.on("changeSelection", hideHoverMarker);

    popup.session.doc.getLength = function() {
        return popup.data.length;
    };
    popup.session.doc.getLine = function(i) {
        var data = popup.data[i];
        if (typeof data == "string")
            return data;
        return (data && data.value) || "";
    };

    var bgTokenizer = popup.session.bgTokenizer;
    bgTokenizer.$tokenizeRow = function(row) {
        var data = popup.data[row];
        var tokens = [];
        if (!data)
            return tokens;
        if (typeof data == "string")
            data = {value: data};
        if (!data.caption)
            data.caption = data.value || data.name;

        var last = -1;
        var flag, c;
        for (var i = 0; i < data.caption.length; i++) {
            c = data.caption[i];
            flag = data.matchMask & (1 << i) ? 1 : 0;
            if (last !== flag) {
                tokens.push({type: data.className || "" + ( flag ? "completion-highlight" : ""), value: c});
                last = flag;
            } else {
                tokens[tokens.length - 1].value += c;
            }
        }

        if (data.meta) {
            var maxW = popup.renderer.$size.scrollerWidth / popup.renderer.layerConfig.characterWidth;
            var metaData = data.meta;
            if (metaData.length + data.caption.length > maxW - 2) {
                metaData = metaData.substr(0, maxW - data.caption.length - 3) + "\u2026"
            }
            tokens.push({type: "rightAlignedText", value: metaData});
        }
        return tokens;
    };
    bgTokenizer.$updateOnChange = noop;
    bgTokenizer.start = noop;

    popup.session.$computeWidth = function() {
        return this.screenWidth = 0;
    };

    popup.$blockScrolling = Infinity;
    popup.isOpen = false;
    popup.isTopdown = false;

    popup.data = [];
    popup.setData = function(list) {
        popup.setValue(lang.stringRepeat("\n", list.length), -1);
        popup.data = list || [];
        popup.setRow(0);
    };
    popup.getData = function(row) {
        return popup.data[row];
    };

    popup.getRow = function() {
        return selectionMarker.start.row;
    };
    popup.setRow = function(line) {
        line = Math.max(0, Math.min(this.data.length, line));
        if (selectionMarker.start.row != line) {
            popup.selection.clearSelection();
            selectionMarker.start.row = selectionMarker.end.row = line || 0;
            popup.session._emit("changeBackMarker");
            popup.moveCursorTo(line || 0, 0);
            if (popup.isOpen)
                popup._signal("select");
        }
    };

    popup.on("changeSelection", function() {
        if (popup.isOpen)
            popup.setRow(popup.selection.lead.row);
        popup.renderer.scrollCursorIntoView();
    });

    popup.hide = function() {
        this.container.style.display = "none";
        this._signal("hide");
        popup.isOpen = false;
    };
    popup.show = function(pos, lineHeight, topdownOnly) {
        var el = this.container;
        var screenHeight = window.innerHeight;
        var screenWidth = window.innerWidth;
        var renderer = this.renderer;
        var maxH = renderer.$maxLines * lineHeight * 1.4;
        var top = pos.top + this.$borderSize;
        var allowTopdown = top > screenHeight / 2 && !topdownOnly;
        if (allowTopdown && top + lineHeight + maxH > screenHeight) {
            renderer.$maxPixelHeight = top - 2 * this.$borderSize;
            el.style.top = "";
            el.style.bottom = screenHeight - top + "px";
            popup.isTopdown = false;
        } else {
            top += lineHeight;
            renderer.$maxPixelHeight = screenHeight - top - 0.2 * lineHeight;
            el.style.top = top + "px";
            el.style.bottom = "";
            popup.isTopdown = true;
        }

        el.style.display = "";
        this.renderer.$textLayer.checkForSizeChanges();

        var left = pos.left;
        if (left + el.offsetWidth > screenWidth)
            left = screenWidth - el.offsetWidth;

        el.style.left = left + "px";

        this._signal("show");
        lastMouseEvent = null;
        popup.isOpen = true;
    };

    popup.getTextLeftOffset = function() {
        return this.$borderSize + this.renderer.$padding + this.$imageSize;
    };

    popup.$imageSize = 0;
    popup.$borderSize = 1;

    return popup;
};

dom.importCssString("\
.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\
    background-color: #CAD6FA;\
    z-index: 1;\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    border: 1px solid #abbffe;\
    margin-top: -1px;\
    background: rgba(233,233,253,0.4);\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    position: absolute;\
    z-index: 2;\
}\
.ace_editor.ace_autocomplete .ace_scroller {\
   background: none;\
   border: none;\
   box-shadow: none;\
}\
.ace_rightAlignedText {\
    color: gray;\
    display: inline-block;\
    position: absolute;\
    right: 4px;\
    text-align: right;\
    z-index: -1;\
}\
.ace_editor.ace_autocomplete .ace_completion-highlight{\
    color: #000;\
    text-shadow: 0 0 0.01em;\
}\
.ace_editor.ace_autocomplete {\
    width: 280px;\
    z-index: 200000;\
    background: #fbfbfb;\
    color: #444;\
    border: 1px lightgray solid;\
    position: fixed;\
    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\
    line-height: 1.4;\
}");

exports.AcePopup = AcePopup;

});

ace.define("ace/autocomplete/util",["require","exports","module"], function(acequire, exports, module) {
"use strict";

exports.parForEach = function(array, fn, callback) {
    var completed = 0;
    var arLength = array.length;
    if (arLength === 0)
        callback();
    for (var i = 0; i < arLength; i++) {
        fn(array[i], function(result, err) {
            completed++;
            if (completed === arLength)
                callback(result, err);
        });
    }
};

var ID_REGEX = /[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/;

exports.retrievePrecedingIdentifier = function(text, pos, regex) {
    regex = regex || ID_REGEX;
    var buf = [];
    for (var i = pos-1; i >= 0; i--) {
        if (regex.test(text[i]))
            buf.push(text[i]);
        else
            break;
    }
    return buf.reverse().join("");
};

exports.retrieveFollowingIdentifier = function(text, pos, regex) {
    regex = regex || ID_REGEX;
    var buf = [];
    for (var i = pos; i < text.length; i++) {
        if (regex.test(text[i]))
            buf.push(text[i]);
        else
            break;
    }
    return buf;
};

exports.getCompletionPrefix = function (editor) {
    var pos = editor.getCursorPosition();
    var line = editor.session.getLine(pos.row);
    var prefix;
    editor.completers.forEach(function(completer) {
        if (completer.identifierRegexps) {
            completer.identifierRegexps.forEach(function(identifierRegex) {
                if (!prefix && identifierRegex)
                    prefix = this.retrievePrecedingIdentifier(line, pos.column, identifierRegex);
            }.bind(this));
        }
    }.bind(this));
    return prefix || this.retrievePrecedingIdentifier(line, pos.column);
};

});

ace.define("ace/autocomplete",["require","exports","module","ace/keyboard/hash_handler","ace/autocomplete/popup","ace/autocomplete/util","ace/lib/event","ace/lib/lang","ace/lib/dom","ace/snippets"], function(acequire, exports, module) {
"use strict";

var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
var AcePopup = acequire("./autocomplete/popup").AcePopup;
var util = acequire("./autocomplete/util");
var event = acequire("./lib/event");
var lang = acequire("./lib/lang");
var dom = acequire("./lib/dom");
var snippetManager = acequire("./snippets").snippetManager;

var Autocomplete = function() {
    this.autoInsert = false;
    this.autoSelect = true;
    this.exactMatch = false;
    this.gatherCompletionsId = 0;
    this.keyboardHandler = new HashHandler();
    this.keyboardHandler.bindKeys(this.commands);

    this.blurListener = this.blurListener.bind(this);
    this.changeListener = this.changeListener.bind(this);
    this.mousedownListener = this.mousedownListener.bind(this);
    this.mousewheelListener = this.mousewheelListener.bind(this);

    this.changeTimer = lang.delayedCall(function() {
        this.updateCompletions(true);
    }.bind(this));

    this.tooltipTimer = lang.delayedCall(this.updateDocTooltip.bind(this), 50);
};

(function() {

    this.$init = function() {
        this.popup = new AcePopup(document.body || document.documentElement);
        this.popup.on("click", function(e) {
            this.insertMatch();
            e.stop();
        }.bind(this));
        this.popup.focus = this.editor.focus.bind(this.editor);
        this.popup.on("show", this.tooltipTimer.bind(null, null));
        this.popup.on("select", this.tooltipTimer.bind(null, null));
        this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null));
        return this.popup;
    };

    this.getPopup = function() {
        return this.popup || this.$init();
    };

    this.openPopup = function(editor, prefix, keepPopupPosition) {
        if (!this.popup)
            this.$init();

        this.popup.setData(this.completions.filtered);

        editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
        
        var renderer = editor.renderer;
        this.popup.setRow(this.autoSelect ? 0 : -1);
        if (!keepPopupPosition) {
            this.popup.setTheme(editor.getTheme());
            this.popup.setFontSize(editor.getFontSize());

            var lineHeight = renderer.layerConfig.lineHeight;

            var pos = renderer.$cursorLayer.getPixelPosition(this.base, true);
            pos.left -= this.popup.getTextLeftOffset();

            var rect = editor.container.getBoundingClientRect();
            pos.top += rect.top - renderer.layerConfig.offset;
            pos.left += rect.left - editor.renderer.scrollLeft;
            pos.left += renderer.gutterWidth;

            this.popup.show(pos, lineHeight);
        } else if (keepPopupPosition && !prefix) {
            this.detach();
        }
    };

    this.detach = function() {
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.off("changeSelection", this.changeListener);
        this.editor.off("blur", this.blurListener);
        this.editor.off("mousedown", this.mousedownListener);
        this.editor.off("mousewheel", this.mousewheelListener);
        this.changeTimer.cancel();
        this.hideDocTooltip();

        this.gatherCompletionsId += 1;
        if (this.popup && this.popup.isOpen)
            this.popup.hide();

        if (this.base)
            this.base.detach();
        this.activated = false;
        this.completions = this.base = null;
    };

    this.changeListener = function(e) {
        var cursor = this.editor.selection.lead;
        if (cursor.row != this.base.row || cursor.column < this.base.column) {
            this.detach();
        }
        if (this.activated)
            this.changeTimer.schedule();
        else
            this.detach();
    };

    this.blurListener = function(e) {
        if (e.relatedTarget && e.relatedTarget.nodeName == "A" && e.relatedTarget.href) {
            window.open(e.relatedTarget.href, "_blank");
        }
        var el = document.activeElement;
        var text = this.editor.textInput.getElement();
        var fromTooltip = e.relatedTarget && e.relatedTarget == this.tooltipNode;
        var container = this.popup && this.popup.container;
        if (el != text && el.parentNode != container && !fromTooltip
            && el != this.tooltipNode && e.relatedTarget != text
        ) {
            this.detach();
        }
    };

    this.mousedownListener = function(e) {
        this.detach();
    };

    this.mousewheelListener = function(e) {
        this.detach();
    };

    this.goTo = function(where) {
        var row = this.popup.getRow();
        var max = this.popup.session.getLength() - 1;

        switch(where) {
            case "up": row = row <= 0 ? max : row - 1; break;
            case "down": row = row >= max ? -1 : row + 1; break;
            case "start": row = 0; break;
            case "end": row = max; break;
        }

        this.popup.setRow(row);
    };

    this.insertMatch = function(data, options) {
        if (!data)
            data = this.popup.getData(this.popup.getRow());
        if (!data)
            return false;

        if (data.completer && data.completer.insertMatch) {
            data.completer.insertMatch(this.editor, data);
        } else {
            if (this.completions.filterText) {
                var ranges = this.editor.selection.getAllRanges();
                for (var i = 0, range; range = ranges[i]; i++) {
                    range.start.column -= this.completions.filterText.length;
                    this.editor.session.remove(range);
                }
            }
            if (data.snippet)
                snippetManager.insertSnippet(this.editor, data.snippet);
            else
                this.editor.execCommand("insertstring", data.value || data);
        }
        this.detach();
    };


    this.commands = {
        "Up": function(editor) { editor.completer.goTo("up"); },
        "Down": function(editor) { editor.completer.goTo("down"); },
        "Ctrl-Up|Ctrl-Home": function(editor) { editor.completer.goTo("start"); },
        "Ctrl-Down|Ctrl-End": function(editor) { editor.completer.goTo("end"); },

        "Esc": function(editor) { editor.completer.detach(); },
        "Return": function(editor) { return editor.completer.insertMatch(); },
        "Shift-Return": function(editor) { editor.completer.insertMatch(null, {deleteSuffix: true}); },
        "Tab": function(editor) {
            var result = editor.completer.insertMatch();
            if (!result && !editor.tabstopManager)
                editor.completer.goTo("down");
            else
                return result;
        },

        "PageUp": function(editor) { editor.completer.popup.gotoPageUp(); },
        "PageDown": function(editor) { editor.completer.popup.gotoPageDown(); }
    };

    this.gatherCompletions = function(editor, callback) {
        var session = editor.getSession();
        var pos = editor.getCursorPosition();

        var line = session.getLine(pos.row);
        var prefix = util.getCompletionPrefix(editor);

        this.base = session.doc.createAnchor(pos.row, pos.column - prefix.length);
        this.base.$insertRight = true;

        var matches = [];
        var total = editor.completers.length;
        editor.completers.forEach(function(completer, i) {
            completer.getCompletions(editor, session, pos, prefix, function(err, results) {
                if (!err && results)
                    matches = matches.concat(results);
                var pos = editor.getCursorPosition();
                var line = session.getLine(pos.row);
                callback(null, {
                    prefix: prefix,
                    matches: matches,
                    finished: (--total === 0)
                });
            });
        });
        return true;
    };

    this.showPopup = function(editor) {
        if (this.editor)
            this.detach();

        this.activated = true;

        this.editor = editor;
        if (editor.completer != this) {
            if (editor.completer)
                editor.completer.detach();
            editor.completer = this;
        }

        editor.on("changeSelection", this.changeListener);
        editor.on("blur", this.blurListener);
        editor.on("mousedown", this.mousedownListener);
        editor.on("mousewheel", this.mousewheelListener);

        this.updateCompletions();
    };

    this.updateCompletions = function(keepPopupPosition) {
        if (keepPopupPosition && this.base && this.completions) {
            var pos = this.editor.getCursorPosition();
            var prefix = this.editor.session.getTextRange({start: this.base, end: pos});
            if (prefix == this.completions.filterText)
                return;
            this.completions.setFilter(prefix);
            if (!this.completions.filtered.length)
                return this.detach();
            if (this.completions.filtered.length == 1
            && this.completions.filtered[0].value == prefix
            && !this.completions.filtered[0].snippet)
                return this.detach();
            this.openPopup(this.editor, prefix, keepPopupPosition);
            return;
        }
        var _id = this.gatherCompletionsId;
        this.gatherCompletions(this.editor, function(err, results) {
            var detachIfFinished = function() {
                if (!results.finished) return;
                return this.detach();
            }.bind(this);

            var prefix = results.prefix;
            var matches = results && results.matches;

            if (!matches || !matches.length)
                return detachIfFinished();
            if (prefix.indexOf(results.prefix) !== 0 || _id != this.gatherCompletionsId)
                return;

            this.completions = new FilteredList(matches);

            if (this.exactMatch)
                this.completions.exactMatch = true;

            this.completions.setFilter(prefix);
            var filtered = this.completions.filtered;
            if (!filtered.length)
                return detachIfFinished();
            if (filtered.length == 1 && filtered[0].value == prefix && !filtered[0].snippet)
                return detachIfFinished();
            if (this.autoInsert && filtered.length == 1 && results.finished)
                return this.insertMatch(filtered[0]);

            this.openPopup(this.editor, prefix, keepPopupPosition);
        }.bind(this));
    };

    this.cancelContextMenu = function() {
        this.editor.$mouseHandler.cancelContextMenu();
    };

    this.updateDocTooltip = function() {
        var popup = this.popup;
        var all = popup.data;
        var selected = all && (all[popup.getHoveredRow()] || all[popup.getRow()]);
        var doc = null;
        if (!selected || !this.editor || !this.popup.isOpen)
            return this.hideDocTooltip();
        this.editor.completers.some(function(completer) {
            if (completer.getDocTooltip)
                doc = completer.getDocTooltip(selected);
            return doc;
        });
        if (!doc)
            doc = selected;

        if (typeof doc == "string")
            doc = {docText: doc};
        if (!doc || !(doc.docHTML || doc.docText))
            return this.hideDocTooltip();
        this.showDocTooltip(doc);
    };

    this.showDocTooltip = function(item) {
        if (!this.tooltipNode) {
            this.tooltipNode = dom.createElement("div");
            this.tooltipNode.className = "ace_tooltip ace_doc-tooltip";
            this.tooltipNode.style.margin = 0;
            this.tooltipNode.style.pointerEvents = "auto";
            this.tooltipNode.tabIndex = -1;
            this.tooltipNode.onblur = this.blurListener.bind(this);
        }

        var tooltipNode = this.tooltipNode;
        if (item.docHTML) {
            tooltipNode.innerHTML = item.docHTML;
        } else if (item.docText) {
            tooltipNode.textContent = item.docText;
        }

        if (!tooltipNode.parentNode)
            document.body.appendChild(tooltipNode);
        var popup = this.popup;
        var rect = popup.container.getBoundingClientRect();
        tooltipNode.style.top = popup.container.style.top;
        tooltipNode.style.bottom = popup.container.style.bottom;

        if (window.innerWidth - rect.right < 320) {
            tooltipNode.style.right = window.innerWidth - rect.left + "px";
            tooltipNode.style.left = "";
        } else {
            tooltipNode.style.left = (rect.right + 1) + "px";
            tooltipNode.style.right = "";
        }
        tooltipNode.style.display = "block";
    };

    this.hideDocTooltip = function() {
        this.tooltipTimer.cancel();
        if (!this.tooltipNode) return;
        var el = this.tooltipNode;
        if (!this.editor.isFocused() && document.activeElement == el)
            this.editor.focus();
        this.tooltipNode = null;
        if (el.parentNode)
            el.parentNode.removeChild(el);
    };

}).call(Autocomplete.prototype);

Autocomplete.startCommand = {
    name: "startAutocomplete",
    exec: function(editor) {
        if (!editor.completer)
            editor.completer = new Autocomplete();
        editor.completer.autoInsert = false;
        editor.completer.autoSelect = true;
        editor.completer.showPopup(editor);
        editor.completer.cancelContextMenu();
    },
    bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
};

var FilteredList = function(array, filterText) {
    this.all = array;
    this.filtered = array;
    this.filterText = filterText || "";
    this.exactMatch = false;
};
(function(){
    this.setFilter = function(str) {
        if (str.length > this.filterText && str.lastIndexOf(this.filterText, 0) === 0)
            var matches = this.filtered;
        else
            var matches = this.all;

        this.filterText = str;
        matches = this.filterCompletions(matches, this.filterText);
        matches = matches.sort(function(a, b) {
            return b.exactMatch - a.exactMatch || b.score - a.score;
        });
        var prev = null;
        matches = matches.filter(function(item){
            var caption = item.snippet || item.caption || item.value;
            if (caption === prev) return false;
            prev = caption;
            return true;
        });

        this.filtered = matches;
    };
    this.filterCompletions = function(items, needle) {
        var results = [];
        var upper = needle.toUpperCase();
        var lower = needle.toLowerCase();
        loop: for (var i = 0, item; item = items[i]; i++) {
            var caption = item.value || item.caption || item.snippet;
            if (!caption) continue;
            var lastIndex = -1;
            var matchMask = 0;
            var penalty = 0;
            var index, distance;

            if (this.exactMatch) {
                if (needle !== caption.substr(0, needle.length))
                    continue loop;
            }else{
                for (var j = 0; j < needle.length; j++) {
                    var i1 = caption.indexOf(lower[j], lastIndex + 1);
                    var i2 = caption.indexOf(upper[j], lastIndex + 1);
                    index = (i1 >= 0) ? ((i2 < 0 || i1 < i2) ? i1 : i2) : i2;
                    if (index < 0)
                        continue loop;
                    distance = index - lastIndex - 1;
                    if (distance > 0) {
                        if (lastIndex === -1)
                            penalty += 10;
                        penalty += distance;
                    }
                    matchMask = matchMask | (1 << index);
                    lastIndex = index;
                }
            }
            item.matchMask = matchMask;
            item.exactMatch = penalty ? 0 : 1;
            item.score = (item.score || 0) - penalty;
            results.push(item);
        }
        return results;
    };
}).call(FilteredList.prototype);

exports.Autocomplete = Autocomplete;
exports.FilteredList = FilteredList;

});

ace.define("ace/autocomplete/text_completer",["require","exports","module","ace/range"], function(acequire, exports, module) {
    var Range = acequire("../range").Range;
    
    var splitRegex = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;

    function getWordIndex(doc, pos) {
        var textBefore = doc.getTextRange(Range.fromPoints({row: 0, column:0}, pos));
        return textBefore.split(splitRegex).length - 1;
    }
    function wordDistance(doc, pos) {
        var prefixPos = getWordIndex(doc, pos);
        var words = doc.getValue().split(splitRegex);
        var wordScores = Object.create(null);
        
        var currentWord = words[prefixPos];

        words.forEach(function(word, idx) {
            if (!word || word === currentWord) return;

            var distance = Math.abs(prefixPos - idx);
            var score = words.length - distance;
            if (wordScores[word]) {
                wordScores[word] = Math.max(score, wordScores[word]);
            } else {
                wordScores[word] = score;
            }
        });
        return wordScores;
    }

    exports.getCompletions = function(editor, session, pos, prefix, callback) {
        var wordScore = wordDistance(session, pos, prefix);
        var wordList = Object.keys(wordScore);
        callback(null, wordList.map(function(word) {
            return {
                caption: word,
                value: word,
                score: wordScore[word],
                meta: "local"
            };
        }));
    };
});

ace.define("ace/ext/language_tools",["require","exports","module","ace/snippets","ace/autocomplete","ace/config","ace/lib/lang","ace/autocomplete/util","ace/autocomplete/text_completer","ace/editor","ace/config"], function(acequire, exports, module) {
"use strict";

var snippetManager = acequire("../snippets").snippetManager;
var Autocomplete = acequire("../autocomplete").Autocomplete;
var config = acequire("../config");
var lang = acequire("../lib/lang");
var util = acequire("../autocomplete/util");

var textCompleter = acequire("../autocomplete/text_completer");
var keyWordCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
        if (session.$mode.completer) {
            return session.$mode.completer.getCompletions(editor, session, pos, prefix, callback);
        }
        var state = editor.session.getState(pos.row);
        var completions = session.$mode.getCompletions(state, session, pos, prefix);
        callback(null, completions);
    }
};

var snippetCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
        var snippetMap = snippetManager.snippetMap;
        var completions = [];
        snippetManager.getActiveScopes(editor).forEach(function(scope) {
            var snippets = snippetMap[scope] || [];
            for (var i = snippets.length; i--;) {
                var s = snippets[i];
                var caption = s.name || s.tabTrigger;
                if (!caption)
                    continue;
                completions.push({
                    caption: caption,
                    snippet: s.content,
                    meta: s.tabTrigger && !s.name ? s.tabTrigger + "\u21E5 " : "snippet",
                    type: "snippet"
                });
            }
        }, this);
        callback(null, completions);
    },
    getDocTooltip: function(item) {
        if (item.type == "snippet" && !item.docHTML) {
            item.docHTML = [
                "<b>", lang.escapeHTML(item.caption), "</b>", "<hr></hr>",
                lang.escapeHTML(item.snippet)
            ].join("");
        }
    }
};

var completers = [snippetCompleter, textCompleter, keyWordCompleter];
exports.setCompleters = function(val) {
    completers.length = 0;
    if (val) completers.push.apply(completers, val);
};
exports.addCompleter = function(completer) {
    completers.push(completer);
};
exports.textCompleter = textCompleter;
exports.keyWordCompleter = keyWordCompleter;
exports.snippetCompleter = snippetCompleter;

var expandSnippet = {
    name: "expandSnippet",
    exec: function(editor) {
        return snippetManager.expandWithTab(editor);
    },
    bindKey: "Tab"
};

var onChangeMode = function(e, editor) {
    loadSnippetsForMode(editor.session.$mode);
};

var loadSnippetsForMode = function(mode) {
    var id = mode.$id;
    if (!snippetManager.files)
        snippetManager.files = {};
    loadSnippetFile(id);
    if (mode.modes)
        mode.modes.forEach(loadSnippetsForMode);
};

var loadSnippetFile = function(id) {
    if (!id || snippetManager.files[id])
        return;
    var snippetFilePath = id.replace("mode", "snippets");
    snippetManager.files[id] = {};
    config.loadModule(snippetFilePath, function(m) {
        if (m) {
            snippetManager.files[id] = m;
            if (!m.snippets && m.snippetText)
                m.snippets = snippetManager.parseSnippetFile(m.snippetText);
            snippetManager.register(m.snippets || [], m.scope);
            if (m.includeScopes) {
                snippetManager.snippetMap[m.scope].includeScopes = m.includeScopes;
                m.includeScopes.forEach(function(x) {
                    loadSnippetFile("ace/mode/" + x);
                });
            }
        }
    });
};

var doLiveAutocomplete = function(e) {
    var editor = e.editor;
    var hasCompleter = editor.completer && editor.completer.activated;
    if (e.command.name === "backspace") {
        if (hasCompleter && !util.getCompletionPrefix(editor))
            editor.completer.detach();
    }
    else if (e.command.name === "insertstring") {
        var prefix = util.getCompletionPrefix(editor);
        if (prefix && !hasCompleter) {
            if (!editor.completer) {
                editor.completer = new Autocomplete();
            }
            editor.completer.autoInsert = false;
            editor.completer.showPopup(editor);
        }
    }
};

var Editor = acequire("../editor").Editor;
acequire("../config").defineOptions(Editor.prototype, "editor", {
    enableBasicAutocompletion: {
        set: function(val) {
            if (val) {
                if (!this.completers)
                    this.completers = Array.isArray(val)? val: completers;
                this.commands.addCommand(Autocomplete.startCommand);
            } else {
                this.commands.removeCommand(Autocomplete.startCommand);
            }
        },
        value: false
    },
    enableLiveAutocompletion: {
        set: function(val) {
            if (val) {
                if (!this.completers)
                    this.completers = Array.isArray(val)? val: completers;
                this.commands.on('afterExec', doLiveAutocomplete);
            } else {
                this.commands.removeListener('afterExec', doLiveAutocomplete);
            }
        },
        value: false
    },
    enableSnippets: {
        set: function(val) {
            if (val) {
                this.commands.addCommand(expandSnippet);
                this.on("changeMode", onChangeMode);
                onChangeMode(null, this);
            } else {
                this.commands.removeCommand(expandSnippet);
                this.off("changeMode", onChangeMode);
            }
        },
        value: false
    }
});
});
                (function() {
                    ace.acequire(["ace/ext/language_tools"], function() {});
                })();
            

/***/ }),
/* 923 */
/***/ (function(module, exports) {

ace.define("ace/theme/textmate",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

exports.isDark = false;
exports.cssClass = "ace-tm";
exports.cssText = ".ace-tm .ace_gutter {\
background: #f0f0f0;\
color: #333;\
}\
.ace-tm .ace_print-margin {\
width: 1px;\
background: #e8e8e8;\
}\
.ace-tm .ace_fold {\
background-color: #6B72E6;\
}\
.ace-tm {\
background-color: #FFFFFF;\
color: black;\
}\
.ace-tm .ace_cursor {\
color: black;\
}\
.ace-tm .ace_invisible {\
color: rgb(191, 191, 191);\
}\
.ace-tm .ace_storage,\
.ace-tm .ace_keyword {\
color: blue;\
}\
.ace-tm .ace_constant {\
color: rgb(197, 6, 11);\
}\
.ace-tm .ace_constant.ace_buildin {\
color: rgb(88, 72, 246);\
}\
.ace-tm .ace_constant.ace_language {\
color: rgb(88, 92, 246);\
}\
.ace-tm .ace_constant.ace_library {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_invalid {\
background-color: rgba(255, 0, 0, 0.1);\
color: red;\
}\
.ace-tm .ace_support.ace_function {\
color: rgb(60, 76, 114);\
}\
.ace-tm .ace_support.ace_constant {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_support.ace_type,\
.ace-tm .ace_support.ace_class {\
color: rgb(109, 121, 222);\
}\
.ace-tm .ace_keyword.ace_operator {\
color: rgb(104, 118, 135);\
}\
.ace-tm .ace_string {\
color: rgb(3, 106, 7);\
}\
.ace-tm .ace_comment {\
color: rgb(76, 136, 107);\
}\
.ace-tm .ace_comment.ace_doc {\
color: rgb(0, 102, 255);\
}\
.ace-tm .ace_comment.ace_doc.ace_tag {\
color: rgb(128, 159, 191);\
}\
.ace-tm .ace_constant.ace_numeric {\
color: rgb(0, 0, 205);\
}\
.ace-tm .ace_variable {\
color: rgb(49, 132, 149);\
}\
.ace-tm .ace_xml-pe {\
color: rgb(104, 104, 91);\
}\
.ace-tm .ace_entity.ace_name.ace_function {\
color: #0000A2;\
}\
.ace-tm .ace_heading {\
color: rgb(12, 7, 255);\
}\
.ace-tm .ace_list {\
color:rgb(185, 6, 144);\
}\
.ace-tm .ace_meta.ace_tag {\
color:rgb(0, 22, 142);\
}\
.ace-tm .ace_string.ace_regex {\
color: rgb(255, 0, 0)\
}\
.ace-tm .ace_marker-layer .ace_selection {\
background: rgb(181, 213, 255);\
}\
.ace-tm.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px white;\
}\
.ace-tm .ace_marker-layer .ace_step {\
background: rgb(252, 255, 0);\
}\
.ace-tm .ace_marker-layer .ace_stack {\
background: rgb(164, 229, 101);\
}\
.ace-tm .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid rgb(192, 192, 192);\
}\
.ace-tm .ace_marker-layer .ace_active-line {\
background: rgba(0, 0, 0, 0.07);\
}\
.ace-tm .ace_gutter-active-line {\
background-color : #dcdcdc;\
}\
.ace-tm .ace_marker-layer .ace_selected-word {\
background: rgb(250, 250, 255);\
border: 1px solid rgb(200, 200, 250);\
}\
.ace-tm .ace_indent-guide {\
background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
}\
";

var dom = acequire("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});


/***/ }),
/* 924 */
/***/ (function(module, exports) {




/***/ }),
/* 925 */
/***/ (function(module, exports) {

ace.define("ace/snippets/text",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="text"})

/***/ }),
/* 926 */
/***/ (function(module, exports) {

ace.define("ace/mode/sql_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var SqlHighlightRules = function() {

    var keywords = (
        "select|insert|update|delete|from|where|and|or|group|by|order|limit|offset|having|as|case|" +
        "when|else|end|type|left|right|join|on|outer|desc|asc|union|create|table|primary|key|if|" +
        "foreign|not|references|default|null|inner|cross|natural|database|drop|grant"
    );

    var builtinConstants = (
        "true|false"
    );

    var builtinFunctions = (
        "avg|count|first|last|max|min|sum|ucase|lcase|mid|len|round|rank|now|format|" + 
        "coalesce|ifnull|isnull|nvl"
    );

    var dataTypes = (
        "int|numeric|decimal|date|varchar|char|bigint|float|double|bit|binary|text|set|timestamp|" +
        "money|real|number|integer"
    );

    var keywordMapper = this.createKeywordMapper({
        "support.function": builtinFunctions,
        "keyword": keywords,
        "constant.language": builtinConstants,
        "storage.type": dataTypes
    }, "identifier", true);

    this.$rules = {
        "start" : [ {
            token : "comment",
            regex : "--.*$"
        },  {
            token : "comment",
            start : "/\\*",
            end : "\\*/"
        }, {
            token : "string",           // " string
            regex : '".*?"'
        }, {
            token : "string",           // ' string
            regex : "'.*?'"
        }, {
            token : "constant.numeric", // float
            regex : "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
        }, {
            token : keywordMapper,
            regex : "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
        }, {
            token : "keyword.operator",
            regex : "\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|="
        }, {
            token : "paren.lparen",
            regex : "[\\(]"
        }, {
            token : "paren.rparen",
            regex : "[\\)]"
        }, {
            token : "text",
            regex : "\\s+"
        } ]
    };
    this.normalizeRules();
};

oop.inherits(SqlHighlightRules, TextHighlightRules);

exports.SqlHighlightRules = SqlHighlightRules;
});

ace.define("ace/mode/sql",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/sql_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var SqlHighlightRules = acequire("./sql_highlight_rules").SqlHighlightRules;

var Mode = function() {
    this.HighlightRules = SqlHighlightRules;
    this.$behaviour = this.$defaultBehaviour;
};
oop.inherits(Mode, TextMode);

(function() {

    this.lineCommentStart = "--";

    this.$id = "ace/mode/sql";
}).call(Mode.prototype);

exports.Mode = Mode;

});


/***/ }),
/* 927 */
/***/ (function(module, exports) {

ace.define("ace/snippets/sql",["require","exports","module"],function(e,t,n){"use strict";t.snippetText="snippet tbl\n	create table ${1:table} (\n		${2:columns}\n	);\nsnippet col\n	${1:name}	${2:type}	${3:default ''}	${4:not null}\nsnippet ccol\n	${1:name}	varchar2(${2:size})	${3:default ''}	${4:not null}\nsnippet ncol\n	${1:name}	number	${3:default 0}	${4:not null}\nsnippet dcol\n	${1:name}	date	${3:default sysdate}	${4:not null}\nsnippet ind\n	create index ${3:$1_$2} on ${1:table}(${2:column});\nsnippet uind\n	create unique index ${1:name} on ${2:table}(${3:column});\nsnippet tblcom\n	comment on table ${1:table} is '${2:comment}';\nsnippet colcom\n	comment on column ${1:table}.${2:column} is '${3:comment}';\nsnippet addcol\n	alter table ${1:table} add (${2:column} ${3:type});\nsnippet seq\n	create sequence ${1:name} start with ${2:1} increment by ${3:1} minvalue ${4:1};\nsnippet s*\n	select * from ${1:table}\n",t.scope="sql"})

/***/ }),
/* 928 */
/***/ (function(module, exports) {

ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var DocCommentHighlightRules = function() {
    this.$rules = {
        "start" : [ {
            token : "comment.doc.tag",
            regex : "@[\\w\\d_]+" // TODO: fix email addresses
        }, 
        DocCommentHighlightRules.getTagRule(),
        {
            defaultToken : "comment.doc",
            caseInsensitive: true
        }]
    };
};

oop.inherits(DocCommentHighlightRules, TextHighlightRules);

DocCommentHighlightRules.getTagRule = function(start) {
    return {
        token : "comment.doc.tag.storage.type",
        regex : "\\b(?:TODO|FIXME|XXX|HACK)\\b"
    };
}

DocCommentHighlightRules.getStartRule = function(start) {
    return {
        token : "comment.doc", // doc comment
        regex : "\\/\\*(?=\\*)",
        next  : start
    };
};

DocCommentHighlightRules.getEndRule = function (start) {
    return {
        token : "comment.doc", // closing comment
        regex : "\\*\\/",
        next  : start
    };
};


exports.DocCommentHighlightRules = DocCommentHighlightRules;

});

ace.define("ace/mode/sqlserver_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var SqlServerHighlightRules = function() {
    var logicalOperators = "ALL|AND|ANY|BETWEEN|EXISTS|IN|LIKE|NOT|OR|SOME";
    logicalOperators += "|NULL|IS|APPLY|INNER|OUTER|LEFT|RIGHT|JOIN|CROSS"; //SSMS colors these gray too
    

    var builtinFunctions = (
        "OPENDATASOURCE|OPENQUERY|OPENROWSET|OPENXML|" +
        "AVG|CHECKSUM_AGG|COUNT|COUNT_BIG|GROUPING|GROUPING_ID|MAX|MIN|STDEV|STDEVP|SUM|VAR|VARP|" +
        "DENSE_RANK|NTILE|RANK|ROW_NUMBER" +
        "@@DATEFIRST|@@DBTS|@@LANGID|@@LANGUAGE|@@LOCK_TIMEOUT|@@MAX_CONNECTIONS|@@MAX_PRECISION|@@NESTLEVEL|@@OPTIONS|@@REMSERVER|@@SERVERNAME|@@SERVICENAME|@@SPID|@@TEXTSIZE|@@VERSION|" +
        "CAST|CONVERT|PARSE|TRY_CAST|TRY_CONVERT|TRY_PARSE" +
        "@@CURSOR_ROWS|@@FETCH_STATUS|CURSOR_STATUS|" +
        "@@DATEFIRST|@@LANGUAGE|CURRENT_TIMESTAMP|DATEADD|DATEDIFF|DATEFROMPARTS|DATENAME|DATEPART|DATETIME2FROMPARTS|DATETIMEFROMPARTS|DATETIMEOFFSETFROMPARTS|DAY|EOMONTH|GETDATE|GETUTCDATE|ISDATE|MONTH|SET DATEFIRST|SET DATEFORMAT|SET LANGUAGE|SMALLDATETIMEFROMPARTS|SP_HELPLANGUAGE|SWITCHOFFSET|SYSDATETIME|SYSDATETIMEOFFSET|SYSUTCDATETIME|TIMEFROMPARTS|TODATETIMEOFFSET|YEAR|" +
        "CHOOSE|IIF|" +
        "ABS|ACOS|ASIN|ATAN|ATN2|CEILING|COS|COT|DEGREES|EXP|FLOOR|LOG|LOG10|PI|POWER|RADIANS|RAND|ROUND|SIGN|SIN|SQRT|SQUARE|TAN|" +
        "@@PROCID|APPLOCK_MODE|APPLOCK_TEST|APP_NAME|ASSEMBLYPROPERTY|COLUMNPROPERTY|COL_LENGTH|COL_NAME|DATABASEPROPERTYEX|DATABASE_PRINCIPAL_ID|DB_ID|DB_NAME|FILEGROUPPROPERTY|FILEGROUP_ID|FILEGROUP_NAME|FILEPROPERTY|FILE_ID|FILE_IDEX|FILE_NAME|FULLTEXTCATALOGPROPERTY|FULLTEXTSERVICEPROPERTY|INDEXKEY_PROPERTY|INDEXPROPERTY|INDEX_COL|OBJECTPROPERTY|OBJECTPROPERTYEX|OBJECT_DEFINITION|OBJECT_ID|OBJECT_NAME|OBJECT_SCHEMA_NAME|ORIGINAL_DB_NAME|PARSENAME|SCHEMA_ID|SCHEMA_NAME|SCOPE_IDENTITY|SERVERPROPERTY|STATS_DATE|TYPEPROPERTY|TYPE_ID|TYPE_NAME|" +
        "CERTENCODED|CERTPRIVATEKEY|CURRENT_USER|DATABASE_PRINCIPAL_ID|HAS_PERMS_BY_NAME|IS_MEMBER|IS_ROLEMEMBER|IS_SRVROLEMEMBER|ORIGINAL_LOGIN|PERMISSIONS|PWDCOMPARE|PWDENCRYPT|SCHEMA_ID|SCHEMA_NAME|SESSION_USER|SUSER_ID|SUSER_NAME|SUSER_SID|SUSER_SNAME|SYS.FN_BUILTIN_PERMISSIONS|SYS.FN_GET_AUDIT_FILE|SYS.FN_MY_PERMISSIONS|SYSTEM_USER|USER_ID|USER_NAME|" +
        "ASCII|CHAR|CHARINDEX|CONCAT|DIFFERENCE|FORMAT|LEN|LOWER|LTRIM|NCHAR|PATINDEX|QUOTENAME|REPLACE|REPLICATE|REVERSE|RTRIM|SOUNDEX|SPACE|STR|STUFF|SUBSTRING|UNICODE|UPPER|" +
        "$PARTITION|@@ERROR|@@IDENTITY|@@PACK_RECEIVED|@@ROWCOUNT|@@TRANCOUNT|BINARY_CHECKSUM|CHECKSUM|CONNECTIONPROPERTY|CONTEXT_INFO|CURRENT_REQUEST_ID|ERROR_LINE|ERROR_MESSAGE|ERROR_NUMBER|ERROR_PROCEDURE|ERROR_SEVERITY|ERROR_STATE|FORMATMESSAGE|GETANSINULL|GET_FILESTREAM_TRANSACTION_CONTEXT|HOST_ID|HOST_NAME|ISNULL|ISNUMERIC|MIN_ACTIVE_ROWVERSION|NEWID|NEWSEQUENTIALID|ROWCOUNT_BIG|XACT_STATE|" +
        "@@CONNECTIONS|@@CPU_BUSY|@@IDLE|@@IO_BUSY|@@PACKET_ERRORS|@@PACK_RECEIVED|@@PACK_SENT|@@TIMETICKS|@@TOTAL_ERRORS|@@TOTAL_READ|@@TOTAL_WRITE|FN_VIRTUALFILESTATS|" +
        "PATINDEX|TEXTPTR|TEXTVALID|" +
        "COALESCE|NULLIF"
    );
    var dataTypes = ("BIGINT|BINARY|BIT|CHAR|CURSOR|DATE|DATETIME|DATETIME2|DATETIMEOFFSET|DECIMAL|FLOAT|HIERARCHYID|IMAGE|INTEGER|INT|MONEY|NCHAR|NTEXT|NUMERIC|NVARCHAR|REAL|SMALLDATETIME|SMALLINT|SMALLMONEY|SQL_VARIANT|TABLE|TEXT|TIME|TIMESTAMP|TINYINT|UNIQUEIDENTIFIER|VARBINARY|VARCHAR|XML");
    var builtInStoredProcedures = "sp_addextendedproc|sp_addextendedproperty|sp_addmessage|sp_addtype|sp_addumpdevice|sp_add_data_file_recover_suspect_db|sp_add_log_file_recover_suspect_db|sp_altermessage|sp_attach_db|sp_attach_single_file_db|sp_autostats|sp_bindefault|sp_bindrule|sp_bindsession|sp_certify_removable|sp_clean_db_file_free_space|sp_clean_db_free_space|sp_configure|sp_control_plan_guide|sp_createstats|sp_create_plan_guide|sp_create_plan_guide_from_handle|sp_create_removable|sp_cycle_errorlog|sp_datatype_info|sp_dbcmptlevel|sp_dbmmonitoraddmonitoring|sp_dbmmonitorchangealert|sp_dbmmonitorchangemonitoring|sp_dbmmonitordropalert|sp_dbmmonitordropmonitoring|sp_dbmmonitorhelpalert|sp_dbmmonitorhelpmonitoring|sp_dbmmonitorresults|sp_db_increased_partitions|sp_delete_backuphistory|sp_depends|sp_describe_first_result_set|sp_describe_undeclared_parameters|sp_detach_db|sp_dropdevice|sp_dropextendedproc|sp_dropextendedproperty|sp_dropmessage|sp_droptype|sp_execute|sp_executesql|sp_getapplock|sp_getbindtoken|sp_help|sp_helpconstraint|sp_helpdb|sp_helpdevice|sp_helpextendedproc|sp_helpfile|sp_helpfilegroup|sp_helpindex|sp_helplanguage|sp_helpserver|sp_helpsort|sp_helpstats|sp_helptext|sp_helptrigger|sp_indexoption|sp_invalidate_textptr|sp_lock|sp_monitor|sp_prepare|sp_prepexec|sp_prepexecrpc|sp_procoption|sp_recompile|sp_refreshview|sp_releaseapplock|sp_rename|sp_renamedb|sp_resetstatus|sp_sequence_get_range|sp_serveroption|sp_setnetname|sp_settriggerorder|sp_spaceused|sp_tableoption|sp_unbindefault|sp_unbindrule|sp_unprepare|sp_updateextendedproperty|sp_updatestats|sp_validname|sp_who|sys.sp_merge_xtp_checkpoint_files|sys.sp_xtp_bind_db_resource_pool|sys.sp_xtp_checkpoint_force_garbage_collection|sys.sp_xtp_control_proc_exec_stats|sys.sp_xtp_control_query_exec_stats|sys.sp_xtp_unbind_db_resource_pool";
    var keywords = "ABSOLUTE|ACTION|ADA|ADD|ADMIN|AFTER|AGGREGATE|ALIAS|ALL|ALLOCATE|ALTER|AND|ANY|ARE|ARRAY|AS|ASC|ASENSITIVE|ASSERTION|ASYMMETRIC|AT|ATOMIC|AUTHORIZATION|BACKUP|BEFORE|BEGIN|BETWEEN|BIT_LENGTH|BLOB|BOOLEAN|BOTH|BREADTH|BREAK|BROWSE|BULK|BY|CALL|CALLED|CARDINALITY|CASCADE|CASCADED|CASE|CATALOG|CHARACTER|CHARACTER_LENGTH|CHAR_LENGTH|CHECK|CHECKPOINT|CLASS|CLOB|CLOSE|CLUSTERED|COALESCE|COLLATE|COLLATION|COLLECT|COLUMN|COMMIT|COMPLETION|COMPUTE|CONDITION|CONNECT|CONNECTION|CONSTRAINT|CONSTRAINTS|CONSTRUCTOR|CONTAINS|CONTAINSTABLE|CONTINUE|CORR|CORRESPONDING|COVAR_POP|COVAR_SAMP|CREATE|CROSS|CUBE|CUME_DIST|CURRENT|CURRENT_CATALOG|CURRENT_DATE|CURRENT_DEFAULT_TRANSFORM_GROUP|CURRENT_PATH|CURRENT_ROLE|CURRENT_SCHEMA|CURRENT_TIME|CURRENT_TRANSFORM_GROUP_FOR_TYPE|CYCLE|DATA|DATABASE|DBCC|DEALLOCATE|DEC|DECLARE|DEFAULT|DEFERRABLE|DEFERRED|DELETE|DENY|DEPTH|DEREF|DESC|DESCRIBE|DESCRIPTOR|DESTROY|DESTRUCTOR|DETERMINISTIC|DIAGNOSTICS|DICTIONARY|DISCONNECT|DISK|DISTINCT|DISTRIBUTED|DOMAIN|DOUBLE|DROP|DUMP|DYNAMIC|EACH|ELEMENT|ELSE|END|END-EXEC|EQUALS|ERRLVL|ESCAPE|EVERY|EXCEPT|EXCEPTION|EXEC|EXECUTE|EXISTS|EXIT|EXTERNAL|EXTRACT|FETCH|FILE|FILLFACTOR|FILTER|FIRST|FOR|FOREIGN|FORTRAN|FOUND|FREE|FREETEXT|FREETEXTTABLE|FROM|FULL|FULLTEXTTABLE|FUNCTION|FUSION|GENERAL|GET|GLOBAL|GO|GOTO|GRANT|GROUP|HAVING|HOLD|HOLDLOCK|HOST|HOUR|IDENTITY|IDENTITYCOL|IDENTITY_INSERT|IF|IGNORE|IMMEDIATE|IN|INCLUDE|INDEX|INDICATOR|INITIALIZE|INITIALLY|INNER|INOUT|INPUT|INSENSITIVE|INSERT|INTEGER|INTERSECT|INTERSECTION|INTERVAL|INTO|IS|ISOLATION|ITERATE|JOIN|KEY|KILL|LANGUAGE|LARGE|LAST|LATERAL|LEADING|LESS|LEVEL|LIKE|LIKE_REGEX|LIMIT|LINENO|LN|LOAD|LOCAL|LOCALTIME|LOCALTIMESTAMP|LOCATOR|MAP|MATCH|MEMBER|MERGE|METHOD|MINUTE|MOD|MODIFIES|MODIFY|MODULE|MULTISET|NAMES|NATIONAL|NATURAL|NCLOB|NEW|NEXT|NO|NOCHECK|NONCLUSTERED|NONE|NORMALIZE|NOT|NULL|NULLIF|OBJECT|OCCURRENCES_REGEX|OCTET_LENGTH|OF|OFF|OFFSETS|OLD|ON|ONLY|OPEN|OPERATION|OPTION|OR|ORDER|ORDINALITY|OUT|OUTER|OUTPUT|OVER|OVERLAPS|OVERLAY|PAD|PARAMETER|PARAMETERS|PARTIAL|PARTITION|PASCAL|PATH|PERCENT|PERCENTILE_CONT|PERCENTILE_DISC|PERCENT_RANK|PIVOT|PLAN|POSITION|POSITION_REGEX|POSTFIX|PRECISION|PREFIX|PREORDER|PREPARE|PRESERVE|PRIMARY|PRINT|PRIOR|PRIVILEGES|PROC|PROCEDURE|PUBLIC|RAISERROR|RANGE|READ|READS|READTEXT|RECONFIGURE|RECURSIVE|REF|REFERENCES|REFERENCING|REGR_AVGX|REGR_AVGY|REGR_COUNT|REGR_INTERCEPT|REGR_R2|REGR_SLOPE|REGR_SXX|REGR_SXY|REGR_SYY|RELATIVE|RELEASE|REPLICATION|RESTORE|RESTRICT|RESULT|RETURN|RETURNS|REVERT|REVOKE|ROLE|ROLLBACK|ROLLUP|ROUTINE|ROW|ROWCOUNT|ROWGUIDCOL|ROWS|RULE|SAVE|SAVEPOINT|SCHEMA|SCOPE|SCROLL|SEARCH|SECOND|SECTION|SECURITYAUDIT|SELECT|SEMANTICKEYPHRASETABLE|SEMANTICSIMILARITYDETAILSTABLE|SEMANTICSIMILARITYTABLE|SENSITIVE|SEQUENCE|SESSION|SET|SETS|SETUSER|SHUTDOWN|SIMILAR|SIZE|SOME|SPECIFIC|SPECIFICTYPE|SQL|SQLCA|SQLCODE|SQLERROR|SQLEXCEPTION|SQLSTATE|SQLWARNING|START|STATE|STATEMENT|STATIC|STATISTICS|STDDEV_POP|STDDEV_SAMP|STRUCTURE|SUBMULTISET|SUBSTRING_REGEX|SYMMETRIC|SYSTEM|TABLESAMPLE|TEMPORARY|TERMINATE|TEXTSIZE|THAN|THEN|TIMEZONE_HOUR|TIMEZONE_MINUTE|TO|TOP|TRAILING|TRAN|TRANSACTION|TRANSLATE|TRANSLATE_REGEX|TRANSLATION|TREAT|TRIGGER|TRIM|TRUNCATE|TSEQUAL|UESCAPE|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNPIVOT|UPDATE|UPDATETEXT|USAGE|USE|USER|USING|VALUE|VALUES|VARIABLE|VARYING|VAR_POP|VAR_SAMP|VIEW|WAITFOR|WHEN|WHENEVER|WHERE|WHILE|WIDTH_BUCKET|WINDOW|WITH|WITHIN|WITHIN GROUP|WITHOUT|WORK|WRITE|WRITETEXT|XMLAGG|XMLATTRIBUTES|XMLBINARY|XMLCAST|XMLCOMMENT|XMLCONCAT|XMLDOCUMENT|XMLELEMENT|XMLEXISTS|XMLFOREST|XMLITERATE|XMLNAMESPACES|XMLPARSE|XMLPI|XMLQUERY|XMLSERIALIZE|XMLTABLE|XMLTEXT|XMLVALIDATE|ZONE";
    keywords += "|KEEPIDENTITY|KEEPDEFAULTS|IGNORE_CONSTRAINTS|IGNORE_TRIGGERS|XLOCK|FORCESCAN|FORCESEEK|HOLDLOCK|NOLOCK|NOWAIT|PAGLOCK|READCOMMITTED|READCOMMITTEDLOCK|READPAST|READUNCOMMITTED|REPEATABLEREAD|ROWLOCK|SERIALIZABLE|SNAPSHOT|SPATIAL_WINDOW_MAX_CELLS|TABLOCK|TABLOCKX|UPDLOCK|XLOCK|IGNORE_NONCLUSTERED_COLUMNSTORE_INDEX|EXPAND|VIEWS|FAST|FORCE|KEEP|KEEPFIXED|MAXDOP|MAXRECURSION|OPTIMIZE|PARAMETERIZATION|SIMPLE|FORCED|RECOMPILE|ROBUST|PLAN|SPATIAL_WINDOW_MAX_CELLS|NOEXPAND|HINT";
    keywords += "|LOOP|HASH|MERGE|REMOTE";
    keywords += "|TRY|CATCH|THROW";
    keywords += "|TYPE";
    keywords = keywords.split('|');
    keywords = keywords.filter(function(value, index, self) {
        return logicalOperators.split('|').indexOf(value) === -1 && builtinFunctions.split('|').indexOf(value) === -1 && dataTypes.split('|').indexOf(value) === -1;
    });
    keywords = keywords.sort().join('|');
    
    
    var keywordMapper = this.createKeywordMapper({
        "constant.language": logicalOperators,
        "storage.type": dataTypes,
        "support.function": builtinFunctions,
        "support.storedprocedure": builtInStoredProcedures,
        "keyword": keywords
    }, "identifier", true);
    var setStatements = "SET ANSI_DEFAULTS|SET ANSI_NULLS|SET ANSI_NULL_DFLT_OFF|SET ANSI_NULL_DFLT_ON|SET ANSI_PADDING|SET ANSI_WARNINGS|SET ARITHABORT|SET ARITHIGNORE|SET CONCAT_NULL_YIELDS_NULL|SET CURSOR_CLOSE_ON_COMMIT|SET DATEFIRST|SET DATEFORMAT|SET DEADLOCK_PRIORITY|SET FIPS_FLAGGER|SET FMTONLY|SET FORCEPLAN|SET IDENTITY_INSERT|SET IMPLICIT_TRANSACTIONS|SET LANGUAGE|SET LOCK_TIMEOUT|SET NOCOUNT|SET NOEXEC|SET NUMERIC_ROUNDABORT|SET OFFSETS|SET PARSEONLY|SET QUERY_GOVERNOR_COST_LIMIT|SET QUOTED_IDENTIFIER|SET REMOTE_PROC_TRANSACTIONS|SET ROWCOUNT|SET SHOWPLAN_ALL|SET SHOWPLAN_TEXT|SET SHOWPLAN_XML|SET STATISTICS IO|SET STATISTICS PROFILE|SET STATISTICS TIME|SET STATISTICS XML|SET TEXTSIZE|SET XACT_ABORT".split('|');
    var isolationLevels = "READ UNCOMMITTED|READ COMMITTED|REPEATABLE READ|SNAPSHOP|SERIALIZABLE".split('|');
    for (var i = 0; i < isolationLevels.length; i++) {
        setStatements.push('SET TRANSACTION ISOLATION LEVEL ' + isolationLevels[i]);
    }
    
    
    this.$rules = {
        start: [{
            token: "string.start",
            regex: "'",
            next: [{
                token: "constant.language.escape",
                regex: /''/
            }, {
                token: "string.end",
                next: "start",
                regex: "'"
            }, {
                defaultToken: "string"
            }]
        },
        DocCommentHighlightRules.getStartRule("doc-start"), {
            token: "comment",
            regex: "--.*$"
        }, {
            token: "comment",
            start: "/\\*",
            end: "\\*/"
        }, {
            token: "constant.numeric", // float
            regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
        }, {
            token: keywordMapper,
            regex: "@{0,2}[a-zA-Z_$][a-zA-Z0-9_$]*\\b(?!])" //up to 2 @symbols for some built in functions
        }, {
            token: "constant.class",
            regex: "@@?[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
        }, {
            token: "keyword.operator",
            regex: "\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|=|\\*"
        }, {
            token: "paren.lparen",
            regex: "[\\(]"
        }, {
            token: "paren.rparen",
            regex: "[\\)]"
        }, {
            token: "punctuation",
            regex: ",|;"
        }, {
            token: "text",
            regex: "\\s+"
        }],
        comment: [
        DocCommentHighlightRules.getTagRule(), {
            token: "comment",
            regex: "\\*\\/",
            next: "no_regex"
        }, {
            defaultToken: "comment",
            caseInsensitive: true
        }]
    };
    for (var i = 0; i < setStatements.length; i++) {
        this.$rules.start.unshift({
            token: "set.statement",
            regex: setStatements[i]
        });
    }
    
    this.embedRules(DocCommentHighlightRules, "doc-", [DocCommentHighlightRules.getEndRule("start")]);
    this.normalizeRules();
    var completions = [];
    var addCompletions = function(arr, meta) {
        arr.forEach(function(v) {
            completions.push({
                name: v,
                value: v,
                score: 0,
                meta: meta
            });
        });
    };
    addCompletions(builtInStoredProcedures.split('|'), 'procedure');
    addCompletions(logicalOperators.split('|'), 'operator');
    addCompletions(builtinFunctions.split('|'), 'function');
    addCompletions(dataTypes.split('|'), 'type');
    addCompletions(setStatements, 'statement');
    addCompletions(keywords.split('|'), 'keyword');
    
    this.completions = completions;
};

oop.inherits(SqlServerHighlightRules, TextHighlightRules);

exports.SqlHighlightRules = SqlServerHighlightRules;
});

ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Range = acequire("../../range").Range;
var BaseFoldMode = acequire("./fold_mode").FoldMode;

var FoldMode = exports.FoldMode = function(commentRegex) {
    if (commentRegex) {
        this.foldingStartMarker = new RegExp(
            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
        );
        this.foldingStopMarker = new RegExp(
            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
        );
    }
};
oop.inherits(FoldMode, BaseFoldMode);

(function() {
    
    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
    this._getFoldWidgetBase = this.getFoldWidget;
    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
    
        if (this.singleLineBlockCommentRe.test(line)) {
            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
                return "";
        }
    
        var fw = this._getFoldWidgetBase(session, foldStyle, row);
    
        if (!fw && this.startRegionRe.test(line))
            return "start"; // lineCommentRegionStart
    
        return fw;
    };

    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        
        if (this.startRegionRe.test(line))
            return this.getCommentRegionBlock(session, line, row);
        
        var match = line.match(this.foldingStartMarker);
        if (match) {
            var i = match.index;

            if (match[1])
                return this.openingBracketBlock(session, match[1], row, i);
                
            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
            
            if (range && !range.isMultiLine()) {
                if (forceMultiline) {
                    range = this.getSectionRange(session, row);
                } else if (foldStyle != "all")
                    range = null;
            }
            
            return range;
        }

        if (foldStyle === "markbegin")
            return;

        var match = line.match(this.foldingStopMarker);
        if (match) {
            var i = match.index + match[0].length;

            if (match[1])
                return this.closingBracketBlock(session, match[1], row, i);

            return session.getCommentFoldRange(row, i, -1);
        }
    };
    
    this.getSectionRange = function(session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();
        while (++row < maxRow) {
            line = session.getLine(row);
            var indent = line.search(/\S/);
            if (indent === -1)
                continue;
            if  (startIndent > indent)
                break;
            var subRange = this.getFoldWidgetRange(session, "all", row);
            
            if (subRange) {
                if (subRange.start.row <= startRow) {
                    break;
                } else if (subRange.isMultiLine()) {
                    row = subRange.end.row;
                } else if (startIndent == indent) {
                    break;
                }
            }
            endRow = row;
        }
        
        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
    };
    this.getCommentRegionBlock = function(session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;
        while (++row < maxRow) {
            line = session.getLine(row);
            var m = re.exec(line);
            if (!m) continue;
            if (m[1]) depth--;
            else depth++;

            if (!depth) break;
        }

        var endRow = row;
        if (endRow > startRow) {
            return new Range(startRow, startColumn, endRow, line.length);
        }
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/folding/sqlserver",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/cstyle"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Range = acequire("../../range").Range;
var BaseFoldMode = acequire("./cstyle").FoldMode;

var FoldMode = exports.FoldMode = function() {};

oop.inherits(FoldMode, BaseFoldMode);

(function() {
    
    this.foldingStartMarker = /(\bCASE\b|\bBEGIN\b)|^\s*(\/\*)/i;
    this.startRegionRe = /^\s*(\/\*|--)#?region\b/;
    
    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
    
        if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
    
        var match = line.match(this.foldingStartMarker);
        if (match) {
            var i = match.index;
            if (match[1]) return this.getBeginEndBlock(session, row, i, match[1]);
    
            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
            if (range && !range.isMultiLine()) {
                if (forceMultiline) {
                    range = this.getSectionRange(session, row);
                }
                else if (foldStyle != "all") range = null;
            }
    
            return range;
        }
    
        if (foldStyle === "markbegin") return;
        return;
    };
    this.getBeginEndBlock = function(session, row, column, matchSequence) {
        var start = {
            row: row,
            column: column + matchSequence.length
        };
        var maxRow = session.getLength();
        var line;
    
        var depth = 1;
        var re = /(\bCASE\b|\bBEGIN\b)|(\bEND\b)/i;
        while (++row < maxRow) {
            line = session.getLine(row);
            var m = re.exec(line);
            if (!m) continue;
            if (m[1]) depth++;
            else depth--;
    
            if (!depth) break;
        }
        var endRow = row;
        if (endRow > start.row) {
            return new Range(start.row, start.column, endRow, line.length);
        }
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/sqlserver",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/sqlserver_highlight_rules","ace/mode/folding/sqlserver"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var SqlServerHighlightRules = acequire("./sqlserver_highlight_rules").SqlHighlightRules;
var SqlServerFoldMode = acequire("./folding/sqlserver").FoldMode;

var Mode = function() {
    this.HighlightRules = SqlServerHighlightRules;
    this.foldingRules = new SqlServerFoldMode();
    this.$behaviour = this.$defaultBehaviour;
};
oop.inherits(Mode, TextMode);

(function() {
    this.lineCommentStart = "--";
    this.blockComment = {start: "/*", end: "*/"};
    this.getCompletions = function(state, session, pos, prefix) {
        return session.$mode.$highlightRules.completions;
    };
    
    this.$id = "ace/mode/sql";
}).call(Mode.prototype);

exports.Mode = Mode;

});


/***/ }),
/* 929 */
/***/ (function(module, exports) {

ace.define("ace/snippets/sqlserver",["require","exports","module"],function(e,t,n){"use strict";t.snippetText="# ISNULL\nsnippet isnull\n	ISNULL(${1:check_expression}, ${2:replacement_value})\n# FORMAT\nsnippet format\n	FORMAT(${1:value}, ${2:format})\n# CAST\nsnippet cast\n	CAST(${1:expression} AS ${2:data_type})\n# CONVERT\nsnippet convert\n	CONVERT(${1:data_type}, ${2:expression})\n# DATEPART\nsnippet datepart\n	DATEPART(${1:datepart}, ${2:date})\n# DATEDIFF\nsnippet datediff\n	DATEDIFF(${1:datepart}, ${2:startdate}, ${3:enddate})\n# DATEADD\nsnippet dateadd\n	DATEADD(${1:datepart}, ${2:number}, ${3:date})\n# DATEFROMPARTS \nsnippet datefromparts\n	DATEFROMPARTS(${1:year}, ${2:month}, ${3:day})\n# OBJECT_DEFINITION\nsnippet objectdef\n	SELECT OBJECT_DEFINITION(OBJECT_ID('${1:sys.server_permissions /*object name*/}'))\n# STUFF XML\nsnippet stuffxml\n	STUFF((SELECT ', ' + ${1:ColumnName}\n		FROM ${2:TableName}\n		WHERE ${3:WhereClause}\n		FOR XML PATH('')), 1, 1, '') AS ${4:Alias}\n	${5:/*https://msdn.microsoft.com/en-us/library/ms188043.aspx*/}\n# Create Procedure\nsnippet createproc\n	-- =============================================\n	-- Author:		${1:Author}\n	-- Create date: ${2:Date}\n	-- Description:	${3:Description}\n	-- =============================================\n	CREATE PROCEDURE ${4:Procedure_Name}\n		${5:/*Add the parameters for the stored procedure here*/}\n	AS\n	BEGIN\n		-- SET NOCOUNT ON added to prevent extra result sets from interfering with SELECT statements.\n		SET NOCOUNT ON;\n		\n		${6:/*Add the T-SQL statements to compute the return value here*/}\n		\n	END\n	GO\n# Create Scalar Function\nsnippet createfn\n	-- =============================================\n	-- Author:		${1:Author}\n	-- Create date: ${2:Date}\n	-- Description:	${3:Description}\n	-- =============================================\n	CREATE FUNCTION ${4:Scalar_Function_Name}\n		-- Add the parameters for the function here\n	RETURNS ${5:Function_Data_Type}\n	AS\n	BEGIN\n		DECLARE @Result ${5:Function_Data_Type}\n		\n		${6:/*Add the T-SQL statements to compute the return value here*/}\n		\n	END\n	GO",t.scope="sqlserver"})

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var DocCommentHighlightRules = function() {
    this.$rules = {
        "start" : [ {
            token : "comment.doc.tag",
            regex : "@[\\w\\d_]+" // TODO: fix email addresses
        }, 
        DocCommentHighlightRules.getTagRule(),
        {
            defaultToken : "comment.doc",
            caseInsensitive: true
        }]
    };
};

oop.inherits(DocCommentHighlightRules, TextHighlightRules);

DocCommentHighlightRules.getTagRule = function(start) {
    return {
        token : "comment.doc.tag.storage.type",
        regex : "\\b(?:TODO|FIXME|XXX|HACK)\\b"
    };
}

DocCommentHighlightRules.getStartRule = function(start) {
    return {
        token : "comment.doc", // doc comment
        regex : "\\/\\*(?=\\*)",
        next  : start
    };
};

DocCommentHighlightRules.getEndRule = function (start) {
    return {
        token : "comment.doc", // closing comment
        regex : "\\*\\/",
        next  : start
    };
};


exports.DocCommentHighlightRules = DocCommentHighlightRules;

});

ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
var identifierRe = "[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*";

var JavaScriptHighlightRules = function(options) {
    var keywordMapper = this.createKeywordMapper({
        "variable.language":
            "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|"  + // Constructors
            "Namespace|QName|XML|XMLList|"                                             + // E4X
            "ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|"   +
            "Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|"                    +
            "Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|"   + // Errors
            "SyntaxError|TypeError|URIError|"                                          +
            "decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|" + // Non-constructor functions
            "isNaN|parseFloat|parseInt|"                                               +
            "JSON|Math|"                                                               + // Other
            "this|arguments|prototype|window|document"                                 , // Pseudo
        "keyword":
            "const|yield|import|get|set|async|await|" +
            "break|case|catch|continue|default|delete|do|else|finally|for|function|" +
            "if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|" +
            "__parent__|__count__|escape|unescape|with|__proto__|" +
            "class|enum|extends|super|export|implements|private|public|interface|package|protected|static",
        "storage.type":
            "const|let|var|function",
        "constant.language":
            "null|Infinity|NaN|undefined",
        "support.function":
            "alert",
        "constant.language.boolean": "true|false"
    }, "identifier");
    var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";

    var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
        "u[0-9a-fA-F]{4}|" + // unicode
        "u{[0-9a-fA-F]{1,6}}|" + // es6 unicode
        "[0-2][0-7]{0,2}|" + // oct
        "3[0-7][0-7]?|" + // oct
        "[4-7][0-7]?|" + //oct
        ".)";

    this.$rules = {
        "no_regex" : [
            DocCommentHighlightRules.getStartRule("doc-start"),
            comments("no_regex"),
            {
                token : "string",
                regex : "'(?=.)",
                next  : "qstring"
            }, {
                token : "string",
                regex : '"(?=.)',
                next  : "qqstring"
            }, {
                token : "constant.numeric", // hex
                regex : /0(?:[xX][0-9a-fA-F]+|[bB][01]+)\b/
            }, {
                token : "constant.numeric", // float
                regex : /[+-]?\d[\d_]*(?:(?:\.\d*)?(?:[eE][+-]?\d+)?)?\b/
            }, {
                token : [
                    "storage.type", "punctuation.operator", "support.function",
                    "punctuation.operator", "entity.name.function", "text","keyword.operator"
                ],
                regex : "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe +")(\\s*)(=)",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "entity.name.function", "text", "keyword.operator", "text", "storage.type",
                    "text", "paren.lparen"
                ],
                regex : "(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text",
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(function)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "entity.name.function", "text", "punctuation.operator",
                    "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "text", "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(:)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : "keyword",
                regex : "(?:" + kwBeforeRe + ")\\b",
                next : "start"
            }, {
                token : ["support.constant"],
                regex : /that\b/
            }, {
                token : ["storage.type", "punctuation.operator", "support.function.firebug"],
                regex : /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
            }, {
                token : keywordMapper,
                regex : identifierRe
            }, {
                token : "punctuation.operator",
                regex : /[.](?![.])/,
                next  : "property"
            }, {
                token : "keyword.operator",
                regex : /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                next  : "start"
            }, {
                token : "punctuation.operator",
                regex : /[?:,;.]/,
                next  : "start"
            }, {
                token : "paren.lparen",
                regex : /[\[({]/,
                next  : "start"
            }, {
                token : "paren.rparen",
                regex : /[\])}]/
            }, {
                token: "comment",
                regex: /^#!.*$/
            }
        ],
        property: [{
                token : "text",
                regex : "\\s+"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text",
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : "punctuation.operator",
                regex : /[.](?![.])/
            }, {
                token : "support.function",
                regex : /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
            }, {
                token : "support.function.dom",
                regex : /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
            }, {
                token :  "support.constant",
                regex : /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
            }, {
                token : "identifier",
                regex : identifierRe
            }, {
                regex: "",
                token: "empty",
                next: "no_regex"
            }
        ],
        "start": [
            DocCommentHighlightRules.getStartRule("doc-start"),
            comments("start"),
            {
                token: "string.regexp",
                regex: "\\/",
                next: "regex"
            }, {
                token : "text",
                regex : "\\s+|^$",
                next : "start"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "regex": [
            {
                token: "regexp.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "string.regexp",
                regex: "/[sxngimy]*",
                next: "no_regex"
            }, {
                token : "invalid",
                regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
            }, {
                token : "constant.language.escape",
                regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
            }, {
                token : "constant.language.delimiter",
                regex: /\|/
            }, {
                token: "constant.language.escape",
                regex: /\[\^?/,
                next: "regex_character_class"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp"
            }
        ],
        "regex_character_class": [
            {
                token: "regexp.charclass.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "constant.language.escape",
                regex: "]",
                next: "regex"
            }, {
                token: "constant.language.escape",
                regex: "-"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp.charachterclass"
            }
        ],
        "function_arguments": [
            {
                token: "variable.parameter",
                regex: identifierRe
            }, {
                token: "punctuation.operator",
                regex: "[, ]+"
            }, {
                token: "punctuation.operator",
                regex: "$"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "qqstring" : [
            {
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "string",
                regex : "\\\\$",
                next  : "qqstring"
            }, {
                token : "string",
                regex : '"|$',
                next  : "no_regex"
            }, {
                defaultToken: "string"
            }
        ],
        "qstring" : [
            {
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "string",
                regex : "\\\\$",
                next  : "qstring"
            }, {
                token : "string",
                regex : "'|$",
                next  : "no_regex"
            }, {
                defaultToken: "string"
            }
        ]
    };
    
    
    if (!options || !options.noES6) {
        this.$rules.no_regex.unshift({
            regex: "[{}]", onMatch: function(val, state, stack) {
                this.next = val == "{" ? this.nextState : "";
                if (val == "{" && stack.length) {
                    stack.unshift("start", state);
                }
                else if (val == "}" && stack.length) {
                    stack.shift();
                    this.next = stack.shift();
                    if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1)
                        return "paren.quasi.end";
                }
                return val == "{" ? "paren.lparen" : "paren.rparen";
            },
            nextState: "start"
        }, {
            token : "string.quasi.start",
            regex : /`/,
            push  : [{
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "paren.quasi.start",
                regex : /\${/,
                push  : "start"
            }, {
                token : "string.quasi.end",
                regex : /`/,
                next  : "pop"
            }, {
                defaultToken: "string.quasi"
            }]
        });
        
        if (!options || options.jsx != false)
            JSX.call(this);
    }
    
    this.embedRules(DocCommentHighlightRules, "doc-",
        [ DocCommentHighlightRules.getEndRule("no_regex") ]);
    
    this.normalizeRules();
};

oop.inherits(JavaScriptHighlightRules, TextHighlightRules);

function JSX() {
    var tagRegex = identifierRe.replace("\\d", "\\d\\-");
    var jsxTag = {
        onMatch : function(val, state, stack) {
            var offset = val.charAt(1) == "/" ? 2 : 1;
            if (offset == 1) {
                if (state != this.nextState)
                    stack.unshift(this.next, this.nextState, 0);
                else
                    stack.unshift(this.next);
                stack[2]++;
            } else if (offset == 2) {
                if (state == this.nextState) {
                    stack[1]--;
                    if (!stack[1] || stack[1] < 0) {
                        stack.shift();
                        stack.shift();
                    }
                }
            }
            return [{
                type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                value: val.slice(0, offset)
            }, {
                type: "meta.tag.tag-name.xml",
                value: val.substr(offset)
            }];
        },
        regex : "</?" + tagRegex + "",
        next: "jsxAttributes",
        nextState: "jsx"
    };
    this.$rules.start.unshift(jsxTag);
    var jsxJsRule = {
        regex: "{",
        token: "paren.quasi.start",
        push: "start"
    };
    this.$rules.jsx = [
        jsxJsRule,
        jsxTag,
        {include : "reference"},
        {defaultToken: "string"}
    ];
    this.$rules.jsxAttributes = [{
        token : "meta.tag.punctuation.tag-close.xml", 
        regex : "/?>", 
        onMatch : function(value, currentState, stack) {
            if (currentState == stack[0])
                stack.shift();
            if (value.length == 2) {
                if (stack[0] == this.nextState)
                    stack[1]--;
                if (!stack[1] || stack[1] < 0) {
                    stack.splice(0, 2);
                }
            }
            this.next = stack[0] || "start";
            return [{type: this.token, value: value}];
        },
        nextState: "jsx"
    }, 
    jsxJsRule,
    comments("jsxAttributes"),
    {
        token : "entity.other.attribute-name.xml",
        regex : tagRegex
    }, {
        token : "keyword.operator.attribute-equals.xml",
        regex : "="
    }, {
        token : "text.tag-whitespace.xml",
        regex : "\\s+"
    }, {
        token : "string.attribute-value.xml",
        regex : "'",
        stateName : "jsx_attr_q",
        push : [
            {token : "string.attribute-value.xml", regex: "'", next: "pop"},
            {include : "reference"},
            {defaultToken : "string.attribute-value.xml"}
        ]
    }, {
        token : "string.attribute-value.xml",
        regex : '"',
        stateName : "jsx_attr_qq",
        push : [
            {token : "string.attribute-value.xml", regex: '"', next: "pop"},
            {include : "reference"},
            {defaultToken : "string.attribute-value.xml"}
        ]
    },
    jsxTag
    ];
    this.$rules.reference = [{
        token : "constant.language.escape.reference.xml",
        regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
    }];
}

function comments(next) {
    return [
        {
            token : "comment", // multi line comment
            regex : /\/\*/,
            next: [
                DocCommentHighlightRules.getTagRule(),
                {token : "comment", regex : "\\*\\/", next : next || "pop"},
                {defaultToken : "comment", caseInsensitive: true}
            ]
        }, {
            token : "comment",
            regex : "\\/\\/",
            next: [
                DocCommentHighlightRules.getTagRule(),
                {token : "comment", regex : "$|^", next : next || "pop"},
                {defaultToken : "comment", caseInsensitive: true}
            ]
        }
    ];
}
exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});

ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;

var MatchingBraceOutdent = function() {};

(function() {

    this.checkOutdent = function(line, input) {
        if (! /^\s+$/.test(line))
            return false;

        return /^\s*\}/.test(input);
    };

    this.autoOutdent = function(doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);

        if (!match) return 0;

        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({row: row, column: column});

        if (!openBracePos || openBracePos.row == row) return 0;

        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column-1), indent);
    };

    this.$getIndent = function(line) {
        return line.match(/^\s*/)[0];
    };

}).call(MatchingBraceOutdent.prototype);

exports.MatchingBraceOutdent = MatchingBraceOutdent;
});

ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Range = acequire("../../range").Range;
var BaseFoldMode = acequire("./fold_mode").FoldMode;

var FoldMode = exports.FoldMode = function(commentRegex) {
    if (commentRegex) {
        this.foldingStartMarker = new RegExp(
            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
        );
        this.foldingStopMarker = new RegExp(
            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
        );
    }
};
oop.inherits(FoldMode, BaseFoldMode);

(function() {
    
    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
    this._getFoldWidgetBase = this.getFoldWidget;
    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
    
        if (this.singleLineBlockCommentRe.test(line)) {
            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
                return "";
        }
    
        var fw = this._getFoldWidgetBase(session, foldStyle, row);
    
        if (!fw && this.startRegionRe.test(line))
            return "start"; // lineCommentRegionStart
    
        return fw;
    };

    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        
        if (this.startRegionRe.test(line))
            return this.getCommentRegionBlock(session, line, row);
        
        var match = line.match(this.foldingStartMarker);
        if (match) {
            var i = match.index;

            if (match[1])
                return this.openingBracketBlock(session, match[1], row, i);
                
            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
            
            if (range && !range.isMultiLine()) {
                if (forceMultiline) {
                    range = this.getSectionRange(session, row);
                } else if (foldStyle != "all")
                    range = null;
            }
            
            return range;
        }

        if (foldStyle === "markbegin")
            return;

        var match = line.match(this.foldingStopMarker);
        if (match) {
            var i = match.index + match[0].length;

            if (match[1])
                return this.closingBracketBlock(session, match[1], row, i);

            return session.getCommentFoldRange(row, i, -1);
        }
    };
    
    this.getSectionRange = function(session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();
        while (++row < maxRow) {
            line = session.getLine(row);
            var indent = line.search(/\S/);
            if (indent === -1)
                continue;
            if  (startIndent > indent)
                break;
            var subRange = this.getFoldWidgetRange(session, "all", row);
            
            if (subRange) {
                if (subRange.start.row <= startRow) {
                    break;
                } else if (subRange.isMultiLine()) {
                    row = subRange.end.row;
                } else if (startIndent == indent) {
                    break;
                }
            }
            endRow = row;
        }
        
        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
    };
    this.getCommentRegionBlock = function(session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;
        while (++row < maxRow) {
            line = session.getLine(row);
            var m = re.exec(line);
            if (!m) continue;
            if (m[1]) depth--;
            else depth++;

            if (!depth) break;
        }

        var endRow = row;
        if (endRow > startRow) {
            return new Range(startRow, startColumn, endRow, line.length);
        }
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/javascript",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
var WorkerClient = acequire("../worker/worker_client").WorkerClient;
var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;

var Mode = function() {
    this.HighlightRules = JavaScriptHighlightRules;
    
    this.$outdent = new MatchingBraceOutdent();
    this.$behaviour = new CstyleBehaviour();
    this.foldingRules = new CStyleFoldMode();
};
oop.inherits(Mode, TextMode);

(function() {

    this.lineCommentStart = "//";
    this.blockComment = {start: "/*", end: "*/"};

    this.getNextLineIndent = function(state, line, tab) {
        var indent = this.$getIndent(line);

        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
        var tokens = tokenizedLine.tokens;
        var endState = tokenizedLine.state;

        if (tokens.length && tokens[tokens.length-1].type == "comment") {
            return indent;
        }

        if (state == "start" || state == "no_regex") {
            var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
            if (match) {
                indent += tab;
            }
        } else if (state == "doc-start") {
            if (endState == "start" || endState == "no_regex") {
                return "";
            }
            var match = line.match(/^\s*(\/?)\*/);
            if (match) {
                if (match[1]) {
                    indent += " ";
                }
                indent += "* ";
            }
        }

        return indent;
    };

    this.checkOutdent = function(state, line, input) {
        return this.$outdent.checkOutdent(line, input);
    };

    this.autoOutdent = function(state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
    };

    this.createWorker = function(session) {
        var worker = new WorkerClient(["ace"], __webpack_require__(931), "JavaScriptWorker");
        worker.attachToDocument(session.getDocument());

        worker.on("annotate", function(results) {
            session.setAnnotations(results.data);
        });

        worker.on("terminate", function() {
            session.clearAnnotations();
        });

        return worker;
    };

    this.$id = "ace/mode/javascript";
}).call(Mode.prototype);

exports.Mode = Mode;
});

ace.define("ace/mode/xml_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var XmlHighlightRules = function(normalize) {
    var tagRegex = "[_:a-zA-Z\xc0-\uffff][-_:.a-zA-Z0-9\xc0-\uffff]*";

    this.$rules = {
        start : [
            {token : "string.cdata.xml", regex : "<\\!\\[CDATA\\[", next : "cdata"},
            {
                token : ["punctuation.xml-decl.xml", "keyword.xml-decl.xml"],
                regex : "(<\\?)(xml)(?=[\\s])", next : "xml_decl", caseInsensitive: true
            },
            {
                token : ["punctuation.instruction.xml", "keyword.instruction.xml"],
                regex : "(<\\?)(" + tagRegex + ")", next : "processing_instruction"
            },
            {token : "comment.xml", regex : "<\\!--", next : "comment"},
            {
                token : ["xml-pe.doctype.xml", "xml-pe.doctype.xml"],
                regex : "(<\\!)(DOCTYPE)(?=[\\s])", next : "doctype", caseInsensitive: true
            },
            {include : "tag"},
            {token : "text.end-tag-open.xml", regex: "</"},
            {token : "text.tag-open.xml", regex: "<"},
            {include : "reference"},
            {defaultToken : "text.xml"}
        ],

        xml_decl : [{
            token : "entity.other.attribute-name.decl-attribute-name.xml",
            regex : "(?:" + tagRegex + ":)?" + tagRegex + ""
        }, {
            token : "keyword.operator.decl-attribute-equals.xml",
            regex : "="
        }, {
            include: "whitespace"
        }, {
            include: "string"
        }, {
            token : "punctuation.xml-decl.xml",
            regex : "\\?>",
            next : "start"
        }],

        processing_instruction : [
            {token : "punctuation.instruction.xml", regex : "\\?>", next : "start"},
            {defaultToken : "instruction.xml"}
        ],

        doctype : [
            {include : "whitespace"},
            {include : "string"},
            {token : "xml-pe.doctype.xml", regex : ">", next : "start"},
            {token : "xml-pe.xml", regex : "[-_a-zA-Z0-9:]+"},
            {token : "punctuation.int-subset", regex : "\\[", push : "int_subset"}
        ],

        int_subset : [{
            token : "text.xml",
            regex : "\\s+"
        }, {
            token: "punctuation.int-subset.xml",
            regex: "]",
            next: "pop"
        }, {
            token : ["punctuation.markup-decl.xml", "keyword.markup-decl.xml"],
            regex : "(<\\!)(" + tagRegex + ")",
            push : [{
                token : "text",
                regex : "\\s+"
            },
            {
                token : "punctuation.markup-decl.xml",
                regex : ">",
                next : "pop"
            },
            {include : "string"}]
        }],

        cdata : [
            {token : "string.cdata.xml", regex : "\\]\\]>", next : "start"},
            {token : "text.xml", regex : "\\s+"},
            {token : "text.xml", regex : "(?:[^\\]]|\\](?!\\]>))+"}
        ],

        comment : [
            {token : "comment.xml", regex : "-->", next : "start"},
            {defaultToken : "comment.xml"}
        ],

        reference : [{
            token : "constant.language.escape.reference.xml",
            regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
        }],

        attr_reference : [{
            token : "constant.language.escape.reference.attribute-value.xml",
            regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
        }],

        tag : [{
            token : ["meta.tag.punctuation.tag-open.xml", "meta.tag.punctuation.end-tag-open.xml", "meta.tag.tag-name.xml"],
            regex : "(?:(<)|(</))((?:" + tagRegex + ":)?" + tagRegex + ")",
            next: [
                {include : "attributes"},
                {token : "meta.tag.punctuation.tag-close.xml", regex : "/?>", next : "start"}
            ]
        }],

        tag_whitespace : [
            {token : "text.tag-whitespace.xml", regex : "\\s+"}
        ],
        whitespace : [
            {token : "text.whitespace.xml", regex : "\\s+"}
        ],
        string: [{
            token : "string.xml",
            regex : "'",
            push : [
                {token : "string.xml", regex: "'", next: "pop"},
                {defaultToken : "string.xml"}
            ]
        }, {
            token : "string.xml",
            regex : '"',
            push : [
                {token : "string.xml", regex: '"', next: "pop"},
                {defaultToken : "string.xml"}
            ]
        }],

        attributes: [{
            token : "entity.other.attribute-name.xml",
            regex : "(?:" + tagRegex + ":)?" + tagRegex + ""
        }, {
            token : "keyword.operator.attribute-equals.xml",
            regex : "="
        }, {
            include: "tag_whitespace"
        }, {
            include: "attribute_value"
        }],

        attribute_value: [{
            token : "string.attribute-value.xml",
            regex : "'",
            push : [
                {token : "string.attribute-value.xml", regex: "'", next: "pop"},
                {include : "attr_reference"},
                {defaultToken : "string.attribute-value.xml"}
            ]
        }, {
            token : "string.attribute-value.xml",
            regex : '"',
            push : [
                {token : "string.attribute-value.xml", regex: '"', next: "pop"},
                {include : "attr_reference"},
                {defaultToken : "string.attribute-value.xml"}
            ]
        }]
    };

    if (this.constructor === XmlHighlightRules)
        this.normalizeRules();
};


(function() {

    this.embedTagRules = function(HighlightRules, prefix, tag){
        this.$rules.tag.unshift({
            token : ["meta.tag.punctuation.tag-open.xml", "meta.tag." + tag + ".tag-name.xml"],
            regex : "(<)(" + tag + "(?=\\s|>|$))",
            next: [
                {include : "attributes"},
                {token : "meta.tag.punctuation.tag-close.xml", regex : "/?>", next : prefix + "start"}
            ]
        });

        this.$rules[tag + "-end"] = [
            {include : "attributes"},
            {token : "meta.tag.punctuation.tag-close.xml", regex : "/?>",  next: "start",
                onMatch : function(value, currentState, stack) {
                    stack.splice(0);
                    return this.token;
            }}
        ]

        this.embedRules(HighlightRules, prefix, [{
            token: ["meta.tag.punctuation.end-tag-open.xml", "meta.tag." + tag + ".tag-name.xml"],
            regex : "(</)(" + tag + "(?=\\s|>|$))",
            next: tag + "-end"
        }, {
            token: "string.cdata.xml",
            regex : "<\\!\\[CDATA\\["
        }, {
            token: "string.cdata.xml",
            regex : "\\]\\]>"
        }]);
    };

}).call(TextHighlightRules.prototype);

oop.inherits(XmlHighlightRules, TextHighlightRules);

exports.XmlHighlightRules = XmlHighlightRules;
});

ace.define("ace/mode/behaviour/xml",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Behaviour = acequire("../behaviour").Behaviour;
var TokenIterator = acequire("../../token_iterator").TokenIterator;
var lang = acequire("../../lib/lang");

function is(token, type) {
    return token.type.lastIndexOf(type + ".xml") > -1;
}

var XmlBehaviour = function () {

    this.add("string_dquotes", "insertion", function (state, action, editor, session, text) {
        if (text == '"' || text == "'") {
            var quote = text;
            var selected = session.doc.getTextRange(editor.getSelectionRange());
            if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) {
                return {
                    text: quote + selected + quote,
                    selection: false
                };
            }

            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();

            if (rightChar == quote && (is(token, "attribute-value") || is(token, "string"))) {
                return {
                    text: "",
                    selection: [1, 1]
                };
            }

            if (!token)
                token = iterator.stepBackward();

            if (!token)
                return;

            while (is(token, "tag-whitespace") || is(token, "whitespace")) {
                token = iterator.stepBackward();
            }
            var rightSpace = !rightChar || rightChar.match(/\s/);
            if (is(token, "attribute-equals") && (rightSpace || rightChar == '>') || (is(token, "decl-attribute-equals") && (rightSpace || rightChar == '?'))) {
                return {
                    text: quote + quote,
                    selection: [1, 1]
                };
            }
        }
    });

    this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
            if (rightChar == selected) {
                range.end.column++;
                return range;
            }
        }
    });

    this.add("autoclosing", "insertion", function (state, action, editor, session, text) {
        if (text == '>') {
            var position = editor.getSelectionRange().start;
            var iterator = new TokenIterator(session, position.row, position.column);
            var token = iterator.getCurrentToken() || iterator.stepBackward();
            if (!token || !(is(token, "tag-name") || is(token, "tag-whitespace") || is(token, "attribute-name") || is(token, "attribute-equals") || is(token, "attribute-value")))
                return;
            if (is(token, "reference.attribute-value"))
                return;
            if (is(token, "attribute-value")) {
                var firstChar = token.value.charAt(0);
                if (firstChar == '"' || firstChar == "'") {
                    var lastChar = token.value.charAt(token.value.length - 1);
                    var tokenEnd = iterator.getCurrentTokenColumn() + token.value.length;
                    if (tokenEnd > position.column || tokenEnd == position.column && firstChar != lastChar)
                        return;
                }
            }
            while (!is(token, "tag-name")) {
                token = iterator.stepBackward();
                if (token.value == "<") {
                    token = iterator.stepForward();
                    break;
                }
            }

            var tokenRow = iterator.getCurrentTokenRow();
            var tokenColumn = iterator.getCurrentTokenColumn();
            if (is(iterator.stepBackward(), "end-tag-open"))
                return;

            var element = token.value;
            if (tokenRow == position.row)
                element = element.substring(0, position.column - tokenColumn);

            if (this.voidElements.hasOwnProperty(element.toLowerCase()))
                 return;

            return {
               text: ">" + "</" + element + ">",
               selection: [1, 1]
            };
        }
    });

    this.add("autoindent", "insertion", function (state, action, editor, session, text) {
        if (text == "\n") {
            var cursor = editor.getCursorPosition();
            var line = session.getLine(cursor.row);
            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();

            if (token && token.type.indexOf("tag-close") !== -1) {
                if (token.value == "/>")
                    return;
                while (token && token.type.indexOf("tag-name") === -1) {
                    token = iterator.stepBackward();
                }

                if (!token) {
                    return;
                }

                var tag = token.value;
                var row = iterator.getCurrentTokenRow();
                token = iterator.stepBackward();
                if (!token || token.type.indexOf("end-tag") !== -1) {
                    return;
                }

                if (this.voidElements && !this.voidElements[tag]) {
                    var nextToken = session.getTokenAt(cursor.row, cursor.column+1);
                    var line = session.getLine(row);
                    var nextIndent = this.$getIndent(line);
                    var indent = nextIndent + session.getTabString();

                    if (nextToken && nextToken.value === "</") {
                        return {
                            text: "\n" + indent + "\n" + nextIndent,
                            selection: [1, indent.length, 1, indent.length]
                        };
                    } else {
                        return {
                            text: "\n" + indent
                        };
                    }
                }
            }
        }
    });

};

oop.inherits(XmlBehaviour, Behaviour);

exports.XmlBehaviour = XmlBehaviour;
});

ace.define("ace/mode/folding/xml",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/range","ace/mode/folding/fold_mode","ace/token_iterator"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var lang = acequire("../../lib/lang");
var Range = acequire("../../range").Range;
var BaseFoldMode = acequire("./fold_mode").FoldMode;
var TokenIterator = acequire("../../token_iterator").TokenIterator;

var FoldMode = exports.FoldMode = function(voidElements, optionalEndTags) {
    BaseFoldMode.call(this);
    this.voidElements = voidElements || {};
    this.optionalEndTags = oop.mixin({}, this.voidElements);
    if (optionalEndTags)
        oop.mixin(this.optionalEndTags, optionalEndTags);
    
};
oop.inherits(FoldMode, BaseFoldMode);

var Tag = function() {
    this.tagName = "";
    this.closing = false;
    this.selfClosing = false;
    this.start = {row: 0, column: 0};
    this.end = {row: 0, column: 0};
};

function is(token, type) {
    return token.type.lastIndexOf(type + ".xml") > -1;
}

(function() {

    this.getFoldWidget = function(session, foldStyle, row) {
        var tag = this._getFirstTagInLine(session, row);

        if (!tag)
            return "";

        if (tag.closing || (!tag.tagName && tag.selfClosing))
            return foldStyle == "markbeginend" ? "end" : "";

        if (!tag.tagName || tag.selfClosing || this.voidElements.hasOwnProperty(tag.tagName.toLowerCase()))
            return "";

        if (this._findEndTagInLine(session, row, tag.tagName, tag.end.column))
            return "";

        return "start";
    };
    this._getFirstTagInLine = function(session, row) {
        var tokens = session.getTokens(row);
        var tag = new Tag();

        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (is(token, "tag-open")) {
                tag.end.column = tag.start.column + token.value.length;
                tag.closing = is(token, "end-tag-open");
                token = tokens[++i];
                if (!token)
                    return null;
                tag.tagName = token.value;
                tag.end.column += token.value.length;
                for (i++; i < tokens.length; i++) {
                    token = tokens[i];
                    tag.end.column += token.value.length;
                    if (is(token, "tag-close")) {
                        tag.selfClosing = token.value == '/>';
                        break;
                    }
                }
                return tag;
            } else if (is(token, "tag-close")) {
                tag.selfClosing = token.value == '/>';
                return tag;
            }
            tag.start.column += token.value.length;
        }

        return null;
    };

    this._findEndTagInLine = function(session, row, tagName, startColumn) {
        var tokens = session.getTokens(row);
        var column = 0;
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            column += token.value.length;
            if (column < startColumn)
                continue;
            if (is(token, "end-tag-open")) {
                token = tokens[i + 1];
                if (token && token.value == tagName)
                    return true;
            }
        }
        return false;
    };
    this._readTagForward = function(iterator) {
        var token = iterator.getCurrentToken();
        if (!token)
            return null;

        var tag = new Tag();
        do {
            if (is(token, "tag-open")) {
                tag.closing = is(token, "end-tag-open");
                tag.start.row = iterator.getCurrentTokenRow();
                tag.start.column = iterator.getCurrentTokenColumn();
            } else if (is(token, "tag-name")) {
                tag.tagName = token.value;
            } else if (is(token, "tag-close")) {
                tag.selfClosing = token.value == "/>";
                tag.end.row = iterator.getCurrentTokenRow();
                tag.end.column = iterator.getCurrentTokenColumn() + token.value.length;
                iterator.stepForward();
                return tag;
            }
        } while(token = iterator.stepForward());

        return null;
    };
    
    this._readTagBackward = function(iterator) {
        var token = iterator.getCurrentToken();
        if (!token)
            return null;

        var tag = new Tag();
        do {
            if (is(token, "tag-open")) {
                tag.closing = is(token, "end-tag-open");
                tag.start.row = iterator.getCurrentTokenRow();
                tag.start.column = iterator.getCurrentTokenColumn();
                iterator.stepBackward();
                return tag;
            } else if (is(token, "tag-name")) {
                tag.tagName = token.value;
            } else if (is(token, "tag-close")) {
                tag.selfClosing = token.value == "/>";
                tag.end.row = iterator.getCurrentTokenRow();
                tag.end.column = iterator.getCurrentTokenColumn() + token.value.length;
            }
        } while(token = iterator.stepBackward());

        return null;
    };
    
    this._pop = function(stack, tag) {
        while (stack.length) {
            
            var top = stack[stack.length-1];
            if (!tag || top.tagName == tag.tagName) {
                return stack.pop();
            }
            else if (this.optionalEndTags.hasOwnProperty(top.tagName)) {
                stack.pop();
                continue;
            } else {
                return null;
            }
        }
    };
    
    this.getFoldWidgetRange = function(session, foldStyle, row) {
        var firstTag = this._getFirstTagInLine(session, row);
        
        if (!firstTag)
            return null;
        
        var isBackward = firstTag.closing || firstTag.selfClosing;
        var stack = [];
        var tag;
        
        if (!isBackward) {
            var iterator = new TokenIterator(session, row, firstTag.start.column);
            var start = {
                row: row,
                column: firstTag.start.column + firstTag.tagName.length + 2
            };
            if (firstTag.start.row == firstTag.end.row)
                start.column = firstTag.end.column;
            while (tag = this._readTagForward(iterator)) {
                if (tag.selfClosing) {
                    if (!stack.length) {
                        tag.start.column += tag.tagName.length + 2;
                        tag.end.column -= 2;
                        return Range.fromPoints(tag.start, tag.end);
                    } else
                        continue;
                }
                
                if (tag.closing) {
                    this._pop(stack, tag);
                    if (stack.length == 0)
                        return Range.fromPoints(start, tag.start);
                }
                else {
                    stack.push(tag);
                }
            }
        }
        else {
            var iterator = new TokenIterator(session, row, firstTag.end.column);
            var end = {
                row: row,
                column: firstTag.start.column
            };
            
            while (tag = this._readTagBackward(iterator)) {
                if (tag.selfClosing) {
                    if (!stack.length) {
                        tag.start.column += tag.tagName.length + 2;
                        tag.end.column -= 2;
                        return Range.fromPoints(tag.start, tag.end);
                    } else
                        continue;
                }
                
                if (!tag.closing) {
                    this._pop(stack, tag);
                    if (stack.length == 0) {
                        tag.start.column += tag.tagName.length + 2;
                        if (tag.start.row == tag.end.row && tag.start.column < tag.end.column)
                            tag.start.column = tag.end.column;
                        return Range.fromPoints(tag.start, end);
                    }
                }
                else {
                    stack.push(tag);
                }
            }
        }
        
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/xml",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text","ace/mode/xml_highlight_rules","ace/mode/behaviour/xml","ace/mode/folding/xml","ace/worker/worker_client"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var lang = acequire("../lib/lang");
var TextMode = acequire("./text").Mode;
var XmlHighlightRules = acequire("./xml_highlight_rules").XmlHighlightRules;
var XmlBehaviour = acequire("./behaviour/xml").XmlBehaviour;
var XmlFoldMode = acequire("./folding/xml").FoldMode;
var WorkerClient = acequire("../worker/worker_client").WorkerClient;

var Mode = function() {
   this.HighlightRules = XmlHighlightRules;
   this.$behaviour = new XmlBehaviour();
   this.foldingRules = new XmlFoldMode();
};

oop.inherits(Mode, TextMode);

(function() {

    this.voidElements = lang.arrayToMap([]);

    this.blockComment = {start: "<!--", end: "-->"};

    this.createWorker = function(session) {
        var worker = new WorkerClient(["ace"], __webpack_require__(932), "Worker");
        worker.attachToDocument(session.getDocument());

        worker.on("error", function(e) {
            session.setAnnotations(e.data);
        });

        worker.on("terminate", function() {
            session.clearAnnotations();
        });

        return worker;
    };
    
    this.$id = "ace/mode/xml";
}).call(Mode.prototype);

exports.Mode = Mode;
});

ace.define("ace/mode/css_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var lang = acequire("../lib/lang");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
var supportType = exports.supportType = "align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|min-height|min-width|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index";
var supportFunction = exports.supportFunction = "rgb|rgba|url|attr|counter|counters";
var supportConstant = exports.supportConstant = "absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero";
var supportConstantColor = exports.supportConstantColor = "aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow";
var supportConstantFonts = exports.supportConstantFonts = "arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace";

var numRe = exports.numRe = "\\-?(?:(?:[0-9]+)|(?:[0-9]*\\.[0-9]+))";
var pseudoElements = exports.pseudoElements = "(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b";
var pseudoClasses  = exports.pseudoClasses =  "(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|acequired|root|target|valid|visited)\\b";

var CssHighlightRules = function() {

    var keywordMapper = this.createKeywordMapper({
        "support.function": supportFunction,
        "support.constant": supportConstant,
        "support.type": supportType,
        "support.constant.color": supportConstantColor,
        "support.constant.fonts": supportConstantFonts
    }, "text", true);

    this.$rules = {
        "start" : [{
            token : "comment", // multi line comment
            regex : "\\/\\*",
            push : "comment"
        }, {
            token: "paren.lparen",
            regex: "\\{",
            push:  "ruleset"
        }, {
            token: "string",
            regex: "@.*?{",
            push:  "media"
        }, {
            token: "keyword",
            regex: "#[a-z0-9-_]+"
        }, {
            token: "variable",
            regex: "\\.[a-z0-9-_]+"
        }, {
            token: "string",
            regex: ":[a-z0-9-_]+"
        }, {
            token: "constant",
            regex: "[a-z0-9-_]+"
        }, {
            caseInsensitive: true
        }],

        "media" : [{
            token : "comment", // multi line comment
            regex : "\\/\\*",
            push : "comment"
        }, {
            token: "paren.lparen",
            regex: "\\{",
            push:  "ruleset"
        }, {
            token: "string",
            regex: "\\}",
            next:  "pop"
        }, {
            token: "keyword",
            regex: "#[a-z0-9-_]+"
        }, {
            token: "variable",
            regex: "\\.[a-z0-9-_]+"
        }, {
            token: "string",
            regex: ":[a-z0-9-_]+"
        }, {
            token: "constant",
            regex: "[a-z0-9-_]+"
        }, {
            caseInsensitive: true
        }],

        "comment" : [{
            token : "comment",
            regex : "\\*\\/",
            next : "pop"
        }, {
            defaultToken : "comment"
        }],

        "ruleset" : [
        {
            token : "paren.rparen",
            regex : "\\}",
            next:   "pop"
        }, {
            token : "comment", // multi line comment
            regex : "\\/\\*",
            push : "comment"
        }, {
            token : "string", // single line
            regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
        }, {
            token : "string", // single line
            regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
        }, {
            token : ["constant.numeric", "keyword"],
            regex : "(" + numRe + ")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vm|vw|%)"
        }, {
            token : "constant.numeric",
            regex : numRe
        }, {
            token : "constant.numeric",  // hex6 color
            regex : "#[a-f0-9]{6}"
        }, {
            token : "constant.numeric", // hex3 color
            regex : "#[a-f0-9]{3}"
        }, {
            token : ["punctuation", "entity.other.attribute-name.pseudo-element.css"],
            regex : pseudoElements
        }, {
            token : ["punctuation", "entity.other.attribute-name.pseudo-class.css"],
            regex : pseudoClasses
        }, {
            token : ["support.function", "string", "support.function"],
            regex : "(url\\()(.*)(\\))"
        }, {
            token : keywordMapper,
            regex : "\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"
        }, {
            caseInsensitive: true
        }]
    };

    this.normalizeRules();
};

oop.inherits(CssHighlightRules, TextHighlightRules);

exports.CssHighlightRules = CssHighlightRules;

});

ace.define("ace/mode/css_completions",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var propertyMap = {
    "background": {"#$0": 1},
    "background-color": {"#$0": 1, "transparent": 1, "fixed": 1},
    "background-image": {"url('/$0')": 1},
    "background-repeat": {"repeat": 1, "repeat-x": 1, "repeat-y": 1, "no-repeat": 1, "inherit": 1},
    "background-position": {"bottom":2, "center":2, "left":2, "right":2, "top":2, "inherit":2},
    "background-attachment": {"scroll": 1, "fixed": 1},
    "background-size": {"cover": 1, "contain": 1},
    "background-clip": {"border-box": 1, "padding-box": 1, "content-box": 1},
    "background-origin": {"border-box": 1, "padding-box": 1, "content-box": 1},
    "border": {"solid $0": 1, "dashed $0": 1, "dotted $0": 1, "#$0": 1},
    "border-color": {"#$0": 1},
    "border-style": {"solid":2, "dashed":2, "dotted":2, "double":2, "groove":2, "hidden":2, "inherit":2, "inset":2, "none":2, "outset":2, "ridged":2},
    "border-collapse": {"collapse": 1, "separate": 1},
    "bottom": {"px": 1, "em": 1, "%": 1},
    "clear": {"left": 1, "right": 1, "both": 1, "none": 1},
    "color": {"#$0": 1, "rgb(#$00,0,0)": 1},
    "cursor": {"default": 1, "pointer": 1, "move": 1, "text": 1, "wait": 1, "help": 1, "progress": 1, "n-resize": 1, "ne-resize": 1, "e-resize": 1, "se-resize": 1, "s-resize": 1, "sw-resize": 1, "w-resize": 1, "nw-resize": 1},
    "display": {"none": 1, "block": 1, "inline": 1, "inline-block": 1, "table-cell": 1},
    "empty-cells": {"show": 1, "hide": 1},
    "float": {"left": 1, "right": 1, "none": 1},
    "font-family": {"Arial":2,"Comic Sans MS":2,"Consolas":2,"Courier New":2,"Courier":2,"Georgia":2,"Monospace":2,"Sans-Serif":2, "Segoe UI":2,"Tahoma":2,"Times New Roman":2,"Trebuchet MS":2,"Verdana": 1},
    "font-size": {"px": 1, "em": 1, "%": 1},
    "font-weight": {"bold": 1, "normal": 1},
    "font-style": {"italic": 1, "normal": 1},
    "font-variant": {"normal": 1, "small-caps": 1},
    "height": {"px": 1, "em": 1, "%": 1},
    "left": {"px": 1, "em": 1, "%": 1},
    "letter-spacing": {"normal": 1},
    "line-height": {"normal": 1},
    "list-style-type": {"none": 1, "disc": 1, "circle": 1, "square": 1, "decimal": 1, "decimal-leading-zero": 1, "lower-roman": 1, "upper-roman": 1, "lower-greek": 1, "lower-latin": 1, "upper-latin": 1, "georgian": 1, "lower-alpha": 1, "upper-alpha": 1},
    "margin": {"px": 1, "em": 1, "%": 1},
    "margin-right": {"px": 1, "em": 1, "%": 1},
    "margin-left": {"px": 1, "em": 1, "%": 1},
    "margin-top": {"px": 1, "em": 1, "%": 1},
    "margin-bottom": {"px": 1, "em": 1, "%": 1},
    "max-height": {"px": 1, "em": 1, "%": 1},
    "max-width": {"px": 1, "em": 1, "%": 1},
    "min-height": {"px": 1, "em": 1, "%": 1},
    "min-width": {"px": 1, "em": 1, "%": 1},
    "overflow": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
    "overflow-x": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
    "overflow-y": {"hidden": 1, "visible": 1, "auto": 1, "scroll": 1},
    "padding": {"px": 1, "em": 1, "%": 1},
    "padding-top": {"px": 1, "em": 1, "%": 1},
    "padding-right": {"px": 1, "em": 1, "%": 1},
    "padding-bottom": {"px": 1, "em": 1, "%": 1},
    "padding-left": {"px": 1, "em": 1, "%": 1},
    "page-break-after": {"auto": 1, "always": 1, "avoid": 1, "left": 1, "right": 1},
    "page-break-before": {"auto": 1, "always": 1, "avoid": 1, "left": 1, "right": 1},
    "position": {"absolute": 1, "relative": 1, "fixed": 1, "static": 1},
    "right": {"px": 1, "em": 1, "%": 1},
    "table-layout": {"fixed": 1, "auto": 1},
    "text-decoration": {"none": 1, "underline": 1, "line-through": 1, "blink": 1},
    "text-align": {"left": 1, "right": 1, "center": 1, "justify": 1},
    "text-transform": {"capitalize": 1, "uppercase": 1, "lowercase": 1, "none": 1},
    "top": {"px": 1, "em": 1, "%": 1},
    "vertical-align": {"top": 1, "bottom": 1},
    "visibility": {"hidden": 1, "visible": 1},
    "white-space": {"nowrap": 1, "normal": 1, "pre": 1, "pre-line": 1, "pre-wrap": 1},
    "width": {"px": 1, "em": 1, "%": 1},
    "word-spacing": {"normal": 1},
    "filter": {"alpha(opacity=$0100)": 1},

    "text-shadow": {"$02px 2px 2px #777": 1},
    "text-overflow": {"ellipsis-word": 1, "clip": 1, "ellipsis": 1},
    "-moz-border-radius": 1,
    "-moz-border-radius-topright": 1,
    "-moz-border-radius-bottomright": 1,
    "-moz-border-radius-topleft": 1,
    "-moz-border-radius-bottomleft": 1,
    "-webkit-border-radius": 1,
    "-webkit-border-top-right-radius": 1,
    "-webkit-border-top-left-radius": 1,
    "-webkit-border-bottom-right-radius": 1,
    "-webkit-border-bottom-left-radius": 1,
    "-moz-box-shadow": 1,
    "-webkit-box-shadow": 1,
    "transform": {"rotate($00deg)": 1, "skew($00deg)": 1},
    "-moz-transform": {"rotate($00deg)": 1, "skew($00deg)": 1},
    "-webkit-transform": {"rotate($00deg)": 1, "skew($00deg)": 1 }
};

var CssCompletions = function() {

};

(function() {

    this.completionsDefined = false;

    this.defineCompletions = function() {
        if (document) {
            var style = document.createElement('c').style;

            for (var i in style) {
                if (typeof style[i] !== 'string')
                    continue;

                var name = i.replace(/[A-Z]/g, function(x) {
                    return '-' + x.toLowerCase();
                });

                if (!propertyMap.hasOwnProperty(name))
                    propertyMap[name] = 1;
            }
        }

        this.completionsDefined = true;
    }

    this.getCompletions = function(state, session, pos, prefix) {
        if (!this.completionsDefined) {
            this.defineCompletions();
        }

        var token = session.getTokenAt(pos.row, pos.column);

        if (!token)
            return [];
        if (state==='ruleset'){
            var line = session.getLine(pos.row).substr(0, pos.column);
            if (/:[^;]+$/.test(line)) {
                /([\w\-]+):[^:]*$/.test(line);

                return this.getPropertyValueCompletions(state, session, pos, prefix);
            } else {
                return this.getPropertyCompletions(state, session, pos, prefix);
            }
        }

        return [];
    };

    this.getPropertyCompletions = function(state, session, pos, prefix) {
        var properties = Object.keys(propertyMap);
        return properties.map(function(property){
            return {
                caption: property,
                snippet: property + ': $0',
                meta: "property",
                score: Number.MAX_VALUE
            };
        });
    };

    this.getPropertyValueCompletions = function(state, session, pos, prefix) {
        var line = session.getLine(pos.row).substr(0, pos.column);
        var property = (/([\w\-]+):[^:]*$/.exec(line) || {})[1];

        if (!property)
            return [];
        var values = [];
        if (property in propertyMap && typeof propertyMap[property] === "object") {
            values = Object.keys(propertyMap[property]);
        }
        return values.map(function(value){
            return {
                caption: value,
                snippet: value,
                meta: "property value",
                score: Number.MAX_VALUE
            };
        });
    };

}).call(CssCompletions.prototype);

exports.CssCompletions = CssCompletions;
});

ace.define("ace/mode/behaviour/css",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/mode/behaviour/cstyle","ace/token_iterator"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Behaviour = acequire("../behaviour").Behaviour;
var CstyleBehaviour = acequire("./cstyle").CstyleBehaviour;
var TokenIterator = acequire("../../token_iterator").TokenIterator;

var CssBehaviour = function () {

    this.inherit(CstyleBehaviour);

    this.add("colon", "insertion", function (state, action, editor, session, text) {
        if (text === ':') {
            var cursor = editor.getCursorPosition();
            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();
            if (token && token.value.match(/\s+/)) {
                token = iterator.stepBackward();
            }
            if (token && token.type === 'support.type') {
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar === ':') {
                    return {
                       text: '',
                       selection: [1, 1]
                    }
                }
                if (!line.substring(cursor.column).match(/^\s*;/)) {
                    return {
                       text: ':;',
                       selection: [1, 1]
                    }
                }
            }
        }
    });

    this.add("colon", "deletion", function (state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && selected === ':') {
            var cursor = editor.getCursorPosition();
            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();
            if (token && token.value.match(/\s+/)) {
                token = iterator.stepBackward();
            }
            if (token && token.type === 'support.type') {
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.end.column, range.end.column + 1);
                if (rightChar === ';') {
                    range.end.column ++;
                    return range;
                }
            }
        }
    });

    this.add("semicolon", "insertion", function (state, action, editor, session, text) {
        if (text === ';') {
            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar === ';') {
                return {
                   text: '',
                   selection: [1, 1]
                }
            }
        }
    });

}
oop.inherits(CssBehaviour, CstyleBehaviour);

exports.CssBehaviour = CssBehaviour;
});

ace.define("ace/mode/css",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/css_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/css_completions","ace/mode/behaviour/css","ace/mode/folding/cstyle"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var CssHighlightRules = acequire("./css_highlight_rules").CssHighlightRules;
var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
var WorkerClient = acequire("../worker/worker_client").WorkerClient;
var CssCompletions = acequire("./css_completions").CssCompletions;
var CssBehaviour = acequire("./behaviour/css").CssBehaviour;
var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;

var Mode = function() {
    this.HighlightRules = CssHighlightRules;
    this.$outdent = new MatchingBraceOutdent();
    this.$behaviour = new CssBehaviour();
    this.$completer = new CssCompletions();
    this.foldingRules = new CStyleFoldMode();
};
oop.inherits(Mode, TextMode);

(function() {

    this.foldingRules = "cStyle";
    this.blockComment = {start: "/*", end: "*/"};

    this.getNextLineIndent = function(state, line, tab) {
        var indent = this.$getIndent(line);
        var tokens = this.getTokenizer().getLineTokens(line, state).tokens;
        if (tokens.length && tokens[tokens.length-1].type == "comment") {
            return indent;
        }

        var match = line.match(/^.*\{\s*$/);
        if (match) {
            indent += tab;
        }

        return indent;
    };

    this.checkOutdent = function(state, line, input) {
        return this.$outdent.checkOutdent(line, input);
    };

    this.autoOutdent = function(state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
    };

    this.getCompletions = function(state, session, pos, prefix) {
        return this.$completer.getCompletions(state, session, pos, prefix);
    };

    this.createWorker = function(session) {
        var worker = new WorkerClient(["ace"], __webpack_require__(933), "Worker");
        worker.attachToDocument(session.getDocument());

        worker.on("annotate", function(e) {
            session.setAnnotations(e.data);
        });

        worker.on("terminate", function() {
            session.clearAnnotations();
        });

        return worker;
    };

    this.$id = "ace/mode/css";
}).call(Mode.prototype);

exports.Mode = Mode;

});

ace.define("ace/mode/html_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/css_highlight_rules","ace/mode/javascript_highlight_rules","ace/mode/xml_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var lang = acequire("../lib/lang");
var CssHighlightRules = acequire("./css_highlight_rules").CssHighlightRules;
var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
var XmlHighlightRules = acequire("./xml_highlight_rules").XmlHighlightRules;

var tagMap = lang.createMap({
    a           : 'anchor',
    button 	    : 'form',
    form        : 'form',
    img         : 'image',
    input       : 'form',
    label       : 'form',
    option      : 'form',
    script      : 'script',
    select      : 'form',
    textarea    : 'form',
    style       : 'style',
    table       : 'table',
    tbody       : 'table',
    td          : 'table',
    tfoot       : 'table',
    th          : 'table',
    tr          : 'table'
});

var HtmlHighlightRules = function() {
    XmlHighlightRules.call(this);

    this.addRules({
        attributes: [{
            include : "tag_whitespace"
        }, {
            token : "entity.other.attribute-name.xml",
            regex : "[-_a-zA-Z0-9:.]+"
        }, {
            token : "keyword.operator.attribute-equals.xml",
            regex : "=",
            push : [{
                include: "tag_whitespace"
            }, {
                token : "string.unquoted.attribute-value.html",
                regex : "[^<>='\"`\\s]+",
                next : "pop"
            }, {
                token : "empty",
                regex : "",
                next : "pop"
            }]
        }, {
            include : "attribute_value"
        }],
        tag: [{
            token : function(start, tag) {
                var group = tagMap[tag];
                return ["meta.tag.punctuation." + (start == "<" ? "" : "end-") + "tag-open.xml",
                    "meta.tag" + (group ? "." + group : "") + ".tag-name.xml"];
            },
            regex : "(</?)([-_a-zA-Z0-9:.]+)",
            next: "tag_stuff"
        }],
        tag_stuff: [
            {include : "attributes"},
            {token : "meta.tag.punctuation.tag-close.xml", regex : "/?>", next : "start"}
        ]
    });

    this.embedTagRules(CssHighlightRules, "css-", "style");
    this.embedTagRules(new JavaScriptHighlightRules({jsx: false}).getRules(), "js-", "script");

    if (this.constructor === HtmlHighlightRules)
        this.normalizeRules();
};

oop.inherits(HtmlHighlightRules, XmlHighlightRules);

exports.HtmlHighlightRules = HtmlHighlightRules;
});

ace.define("ace/mode/folding/mixed",["require","exports","module","ace/lib/oop","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var BaseFoldMode = acequire("./fold_mode").FoldMode;

var FoldMode = exports.FoldMode = function(defaultMode, subModes) {
    this.defaultMode = defaultMode;
    this.subModes = subModes;
};
oop.inherits(FoldMode, BaseFoldMode);

(function() {


    this.$getMode = function(state) {
        if (typeof state != "string") 
            state = state[0];
        for (var key in this.subModes) {
            if (state.indexOf(key) === 0)
                return this.subModes[key];
        }
        return null;
    };
    
    this.$tryMode = function(state, session, foldStyle, row) {
        var mode = this.$getMode(state);
        return (mode ? mode.getFoldWidget(session, foldStyle, row) : "");
    };

    this.getFoldWidget = function(session, foldStyle, row) {
        return (
            this.$tryMode(session.getState(row-1), session, foldStyle, row) ||
            this.$tryMode(session.getState(row), session, foldStyle, row) ||
            this.defaultMode.getFoldWidget(session, foldStyle, row)
        );
    };

    this.getFoldWidgetRange = function(session, foldStyle, row) {
        var mode = this.$getMode(session.getState(row-1));
        
        if (!mode || !mode.getFoldWidget(session, foldStyle, row))
            mode = this.$getMode(session.getState(row));
        
        if (!mode || !mode.getFoldWidget(session, foldStyle, row))
            mode = this.defaultMode;
        
        return mode.getFoldWidgetRange(session, foldStyle, row);
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/folding/html",["require","exports","module","ace/lib/oop","ace/mode/folding/mixed","ace/mode/folding/xml","ace/mode/folding/cstyle"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var MixedFoldMode = acequire("./mixed").FoldMode;
var XmlFoldMode = acequire("./xml").FoldMode;
var CStyleFoldMode = acequire("./cstyle").FoldMode;

var FoldMode = exports.FoldMode = function(voidElements, optionalTags) {
    MixedFoldMode.call(this, new XmlFoldMode(voidElements, optionalTags), {
        "js-": new CStyleFoldMode(),
        "css-": new CStyleFoldMode()
    });
};

oop.inherits(FoldMode, MixedFoldMode);

});

ace.define("ace/mode/html_completions",["require","exports","module","ace/token_iterator"], function(acequire, exports, module) {
"use strict";

var TokenIterator = acequire("../token_iterator").TokenIterator;

var commonAttributes = [
    "accesskey",
    "class",
    "contenteditable",
    "contextmenu",
    "dir",
    "draggable",
    "dropzone",
    "hidden",
    "id",
    "inert",
    "itemid",
    "itemprop",
    "itemref",
    "itemscope",
    "itemtype",
    "lang",
    "spellcheck",
    "style",
    "tabindex",
    "title",
    "translate"
];

var eventAttributes = [
    "onabort",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextmenu",
    "oncuechange",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmousedown",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onmousewheel",
    "onpause",
    "onplay",
    "onplaying",
    "onprogress",
    "onratechange",
    "onreset",
    "onscroll",
    "onseeked",
    "onseeking",
    "onselect",
    "onshow",
    "onstalled",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "onvolumechange",
    "onwaiting"
];

var globalAttributes = commonAttributes.concat(eventAttributes);

var attributeMap = {
    "html": {"manifest": 1},
    "head": {},
    "title": {},
    "base": {"href": 1, "target": 1},
    "link": {"href": 1, "hreflang": 1, "rel": {"stylesheet": 1, "icon": 1}, "media": {"all": 1, "screen": 1, "print": 1}, "type": {"text/css": 1, "image/png": 1, "image/jpeg": 1, "image/gif": 1}, "sizes": 1},
    "meta": {"http-equiv": {"content-type": 1}, "name": {"description": 1, "keywords": 1}, "content": {"text/html; charset=UTF-8": 1}, "charset": 1},
    "style": {"type": 1, "media": {"all": 1, "screen": 1, "print": 1}, "scoped": 1},
    "script": {"charset": 1, "type": {"text/javascript": 1}, "src": 1, "defer": 1, "async": 1},
    "noscript": {"href": 1},
    "body": {"onafterprint": 1, "onbeforeprint": 1, "onbeforeunload": 1, "onhashchange": 1, "onmessage": 1, "onoffline": 1, "onpopstate": 1, "onredo": 1, "onresize": 1, "onstorage": 1, "onundo": 1, "onunload": 1},
    "section": {},
    "nav": {},
    "article": {"pubdate": 1},
    "aside": {},
    "h1": {},
    "h2": {},
    "h3": {},
    "h4": {},
    "h5": {},
    "h6": {},
    "header": {},
    "footer": {},
    "address": {},
    "main": {},
    "p": {},
    "hr": {},
    "pre": {},
    "blockquote": {"cite": 1},
    "ol": {"start": 1, "reversed": 1},
    "ul": {},
    "li": {"value": 1},
    "dl": {},
    "dt": {},
    "dd": {},
    "figure": {},
    "figcaption": {},
    "div": {},
    "a": {"href": 1, "target": {"_blank": 1, "top": 1}, "ping": 1, "rel": {"nofollow": 1, "alternate": 1, "author": 1, "bookmark": 1, "help": 1, "license": 1, "next": 1, "noreferrer": 1, "prefetch": 1, "prev": 1, "search": 1, "tag": 1}, "media": 1, "hreflang": 1, "type": 1},
    "em": {},
    "strong": {},
    "small": {},
    "s": {},
    "cite": {},
    "q": {"cite": 1},
    "dfn": {},
    "abbr": {},
    "data": {},
    "time": {"datetime": 1},
    "code": {},
    "var": {},
    "samp": {},
    "kbd": {},
    "sub": {},
    "sup": {},
    "i": {},
    "b": {},
    "u": {},
    "mark": {},
    "ruby": {},
    "rt": {},
    "rp": {},
    "bdi": {},
    "bdo": {},
    "span": {},
    "br": {},
    "wbr": {},
    "ins": {"cite": 1, "datetime": 1},
    "del": {"cite": 1, "datetime": 1},
    "img": {"alt": 1, "src": 1, "height": 1, "width": 1, "usemap": 1, "ismap": 1},
    "iframe": {"name": 1, "src": 1, "height": 1, "width": 1, "sandbox": {"allow-same-origin": 1, "allow-top-navigation": 1, "allow-forms": 1, "allow-scripts": 1}, "seamless": {"seamless": 1}},
    "embed": {"src": 1, "height": 1, "width": 1, "type": 1},
    "object": {"param": 1, "data": 1, "type": 1, "height" : 1, "width": 1, "usemap": 1, "name": 1, "form": 1, "classid": 1},
    "param": {"name": 1, "value": 1},
    "video": {"src": 1, "autobuffer": 1, "autoplay": {"autoplay": 1}, "loop": {"loop": 1}, "controls": {"controls": 1}, "width": 1, "height": 1, "poster": 1, "muted": {"muted": 1}, "preload": {"auto": 1, "metadata": 1, "none": 1}},
    "audio": {"src": 1, "autobuffer": 1, "autoplay": {"autoplay": 1}, "loop": {"loop": 1}, "controls": {"controls": 1}, "muted": {"muted": 1}, "preload": {"auto": 1, "metadata": 1, "none": 1 }},
    "source": {"src": 1, "type": 1, "media": 1},
    "track": {"kind": 1, "src": 1, "srclang": 1, "label": 1, "default": 1},
    "canvas": {"width": 1, "height": 1},
    "map": {"name": 1},
    "area": {"shape": 1, "coords": 1, "href": 1, "hreflang": 1, "alt": 1, "target": 1, "media": 1, "rel": 1, "ping": 1, "type": 1},
    "svg": {},
    "math": {},
    "table": {"summary": 1},
    "caption": {},
    "colgroup": {"span": 1},
    "col": {"span": 1},
    "tbody": {},
    "thead": {},
    "tfoot": {},
    "tr": {},
    "td": {"headers": 1, "rowspan": 1, "colspan": 1},
    "th": {"headers": 1, "rowspan": 1, "colspan": 1, "scope": 1},
    "form": {"accept-charset": 1, "action": 1, "autocomplete": 1, "enctype": {"multipart/form-data": 1, "application/x-www-form-urlencoded": 1}, "method": {"get": 1, "post": 1}, "name": 1, "novalidate": 1, "target": {"_blank": 1, "top": 1}},
    "fieldset": {"disabled": 1, "form": 1, "name": 1},
    "legend": {},
    "label": {"form": 1, "for": 1},
    "input": {
        "type": {"text": 1, "password": 1, "hidden": 1, "checkbox": 1, "submit": 1, "radio": 1, "file": 1, "button": 1, "reset": 1, "image": 31, "color": 1, "date": 1, "datetime": 1, "datetime-local": 1, "email": 1, "month": 1, "number": 1, "range": 1, "search": 1, "tel": 1, "time": 1, "url": 1, "week": 1},
        "accept": 1, "alt": 1, "autocomplete": {"on": 1, "off": 1}, "autofocus": {"autofocus": 1}, "checked": {"checked": 1}, "disabled": {"disabled": 1}, "form": 1, "formaction": 1, "formenctype": {"application/x-www-form-urlencoded": 1, "multipart/form-data": 1, "text/plain": 1}, "formmethod": {"get": 1, "post": 1}, "formnovalidate": {"formnovalidate": 1}, "formtarget": {"_blank": 1, "_self": 1, "_parent": 1, "_top": 1}, "height": 1, "list": 1, "max": 1, "maxlength": 1, "min": 1, "multiple": {"multiple": 1}, "name": 1, "pattern": 1, "placeholder": 1, "readonly": {"readonly": 1}, "acequired": {"acequired": 1}, "size": 1, "src": 1, "step": 1, "width": 1, "files": 1, "value": 1},
    "button": {"autofocus": 1, "disabled": {"disabled": 1}, "form": 1, "formaction": 1, "formenctype": 1, "formmethod": 1, "formnovalidate": 1, "formtarget": 1, "name": 1, "value": 1, "type": {"button": 1, "submit": 1}},
    "select": {"autofocus": 1, "disabled": 1, "form": 1, "multiple": {"multiple": 1}, "name": 1, "size": 1, "readonly":{"readonly": 1}},
    "datalist": {},
    "optgroup": {"disabled": 1, "label": 1},
    "option": {"disabled": 1, "selected": 1, "label": 1, "value": 1},
    "textarea": {"autofocus": {"autofocus": 1}, "disabled": {"disabled": 1}, "form": 1, "maxlength": 1, "name": 1, "placeholder": 1, "readonly": {"readonly": 1}, "acequired": {"acequired": 1}, "rows": 1, "cols": 1, "wrap": {"on": 1, "off": 1, "hard": 1, "soft": 1}},
    "keygen": {"autofocus": 1, "challenge": {"challenge": 1}, "disabled": {"disabled": 1}, "form": 1, "keytype": {"rsa": 1, "dsa": 1, "ec": 1}, "name": 1},
    "output": {"for": 1, "form": 1, "name": 1},
    "progress": {"value": 1, "max": 1},
    "meter": {"value": 1, "min": 1, "max": 1, "low": 1, "high": 1, "optimum": 1},
    "details": {"open": 1},
    "summary": {},
    "command": {"type": 1, "label": 1, "icon": 1, "disabled": 1, "checked": 1, "radiogroup": 1, "command": 1},
    "menu": {"type": 1, "label": 1},
    "dialog": {"open": 1}
};

var elements = Object.keys(attributeMap);

function is(token, type) {
    return token.type.lastIndexOf(type + ".xml") > -1;
}

function findTagName(session, pos) {
    var iterator = new TokenIterator(session, pos.row, pos.column);
    var token = iterator.getCurrentToken();
    while (token && !is(token, "tag-name")){
        token = iterator.stepBackward();
    }
    if (token)
        return token.value;
}

function findAttributeName(session, pos) {
    var iterator = new TokenIterator(session, pos.row, pos.column);
    var token = iterator.getCurrentToken();
    while (token && !is(token, "attribute-name")){
        token = iterator.stepBackward();
    }
    if (token)
        return token.value;
}

var HtmlCompletions = function() {

};

(function() {

    this.getCompletions = function(state, session, pos, prefix) {
        var token = session.getTokenAt(pos.row, pos.column);

        if (!token)
            return [];
        if (is(token, "tag-name") || is(token, "tag-open") || is(token, "end-tag-open"))
            return this.getTagCompletions(state, session, pos, prefix);
        if (is(token, "tag-whitespace") || is(token, "attribute-name"))
            return this.getAttributeCompletions(state, session, pos, prefix);
        if (is(token, "attribute-value"))
            return this.getAttributeValueCompletions(state, session, pos, prefix);
        var line = session.getLine(pos.row).substr(0, pos.column);
        if (/&[a-z]*$/i.test(line))
            return this.getHTMLEntityCompletions(state, session, pos, prefix);

        return [];
    };

    this.getTagCompletions = function(state, session, pos, prefix) {
        return elements.map(function(element){
            return {
                value: element,
                meta: "tag",
                score: Number.MAX_VALUE
            };
        });
    };

    this.getAttributeCompletions = function(state, session, pos, prefix) {
        var tagName = findTagName(session, pos);
        if (!tagName)
            return [];
        var attributes = globalAttributes;
        if (tagName in attributeMap) {
            attributes = attributes.concat(Object.keys(attributeMap[tagName]));
        }
        return attributes.map(function(attribute){
            return {
                caption: attribute,
                snippet: attribute + '="$0"',
                meta: "attribute",
                score: Number.MAX_VALUE
            };
        });
    };

    this.getAttributeValueCompletions = function(state, session, pos, prefix) {
        var tagName = findTagName(session, pos);
        var attributeName = findAttributeName(session, pos);
        
        if (!tagName)
            return [];
        var values = [];
        if (tagName in attributeMap && attributeName in attributeMap[tagName] && typeof attributeMap[tagName][attributeName] === "object") {
            values = Object.keys(attributeMap[tagName][attributeName]);
        }
        return values.map(function(value){
            return {
                caption: value,
                snippet: value,
                meta: "attribute value",
                score: Number.MAX_VALUE
            };
        });
    };

    this.getHTMLEntityCompletions = function(state, session, pos, prefix) {
        var values = ['Aacute;', 'aacute;', 'Acirc;', 'acirc;', 'acute;', 'AElig;', 'aelig;', 'Agrave;', 'agrave;', 'alefsym;', 'Alpha;', 'alpha;', 'amp;', 'and;', 'ang;', 'Aring;', 'aring;', 'asymp;', 'Atilde;', 'atilde;', 'Auml;', 'auml;', 'bdquo;', 'Beta;', 'beta;', 'brvbar;', 'bull;', 'cap;', 'Ccedil;', 'ccedil;', 'cedil;', 'cent;', 'Chi;', 'chi;', 'circ;', 'clubs;', 'cong;', 'copy;', 'crarr;', 'cup;', 'curren;', 'Dagger;', 'dagger;', 'dArr;', 'darr;', 'deg;', 'Delta;', 'delta;', 'diams;', 'divide;', 'Eacute;', 'eacute;', 'Ecirc;', 'ecirc;', 'Egrave;', 'egrave;', 'empty;', 'emsp;', 'ensp;', 'Epsilon;', 'epsilon;', 'equiv;', 'Eta;', 'eta;', 'ETH;', 'eth;', 'Euml;', 'euml;', 'euro;', 'exist;', 'fnof;', 'forall;', 'frac12;', 'frac14;', 'frac34;', 'frasl;', 'Gamma;', 'gamma;', 'ge;', 'gt;', 'hArr;', 'harr;', 'hearts;', 'hellip;', 'Iacute;', 'iacute;', 'Icirc;', 'icirc;', 'iexcl;', 'Igrave;', 'igrave;', 'image;', 'infin;', 'int;', 'Iota;', 'iota;', 'iquest;', 'isin;', 'Iuml;', 'iuml;', 'Kappa;', 'kappa;', 'Lambda;', 'lambda;', 'lang;', 'laquo;', 'lArr;', 'larr;', 'lceil;', 'ldquo;', 'le;', 'lfloor;', 'lowast;', 'loz;', 'lrm;', 'lsaquo;', 'lsquo;', 'lt;', 'macr;', 'mdash;', 'micro;', 'middot;', 'minus;', 'Mu;', 'mu;', 'nabla;', 'nbsp;', 'ndash;', 'ne;', 'ni;', 'not;', 'notin;', 'nsub;', 'Ntilde;', 'ntilde;', 'Nu;', 'nu;', 'Oacute;', 'oacute;', 'Ocirc;', 'ocirc;', 'OElig;', 'oelig;', 'Ograve;', 'ograve;', 'oline;', 'Omega;', 'omega;', 'Omicron;', 'omicron;', 'oplus;', 'or;', 'ordf;', 'ordm;', 'Oslash;', 'oslash;', 'Otilde;', 'otilde;', 'otimes;', 'Ouml;', 'ouml;', 'para;', 'part;', 'permil;', 'perp;', 'Phi;', 'phi;', 'Pi;', 'pi;', 'piv;', 'plusmn;', 'pound;', 'Prime;', 'prime;', 'prod;', 'prop;', 'Psi;', 'psi;', 'quot;', 'radic;', 'rang;', 'raquo;', 'rArr;', 'rarr;', 'rceil;', 'rdquo;', 'real;', 'reg;', 'rfloor;', 'Rho;', 'rho;', 'rlm;', 'rsaquo;', 'rsquo;', 'sbquo;', 'Scaron;', 'scaron;', 'sdot;', 'sect;', 'shy;', 'Sigma;', 'sigma;', 'sigmaf;', 'sim;', 'spades;', 'sub;', 'sube;', 'sum;', 'sup;', 'sup1;', 'sup2;', 'sup3;', 'supe;', 'szlig;', 'Tau;', 'tau;', 'there4;', 'Theta;', 'theta;', 'thetasym;', 'thinsp;', 'THORN;', 'thorn;', 'tilde;', 'times;', 'trade;', 'Uacute;', 'uacute;', 'uArr;', 'uarr;', 'Ucirc;', 'ucirc;', 'Ugrave;', 'ugrave;', 'uml;', 'upsih;', 'Upsilon;', 'upsilon;', 'Uuml;', 'uuml;', 'weierp;', 'Xi;', 'xi;', 'Yacute;', 'yacute;', 'yen;', 'Yuml;', 'yuml;', 'Zeta;', 'zeta;', 'zwj;', 'zwnj;'];

        return values.map(function(value){
            return {
                caption: value,
                snippet: value,
                meta: "html entity",
                score: Number.MAX_VALUE
            };
        });
    };

}).call(HtmlCompletions.prototype);

exports.HtmlCompletions = HtmlCompletions;
});

ace.define("ace/mode/html",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text","ace/mode/javascript","ace/mode/css","ace/mode/html_highlight_rules","ace/mode/behaviour/xml","ace/mode/folding/html","ace/mode/html_completions","ace/worker/worker_client"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var lang = acequire("../lib/lang");
var TextMode = acequire("./text").Mode;
var JavaScriptMode = acequire("./javascript").Mode;
var CssMode = acequire("./css").Mode;
var HtmlHighlightRules = acequire("./html_highlight_rules").HtmlHighlightRules;
var XmlBehaviour = acequire("./behaviour/xml").XmlBehaviour;
var HtmlFoldMode = acequire("./folding/html").FoldMode;
var HtmlCompletions = acequire("./html_completions").HtmlCompletions;
var WorkerClient = acequire("../worker/worker_client").WorkerClient;
var voidElements = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "menuitem", "param", "source", "track", "wbr"];
var optionalEndTags = ["li", "dt", "dd", "p", "rt", "rp", "optgroup", "option", "colgroup", "td", "th"];

var Mode = function(options) {
    this.fragmentContext = options && options.fragmentContext;
    this.HighlightRules = HtmlHighlightRules;
    this.$behaviour = new XmlBehaviour();
    this.$completer = new HtmlCompletions();
    
    this.createModeDelegates({
        "js-": JavaScriptMode,
        "css-": CssMode
    });
    
    this.foldingRules = new HtmlFoldMode(this.voidElements, lang.arrayToMap(optionalEndTags));
};
oop.inherits(Mode, TextMode);

(function() {

    this.blockComment = {start: "<!--", end: "-->"};

    this.voidElements = lang.arrayToMap(voidElements);

    this.getNextLineIndent = function(state, line, tab) {
        return this.$getIndent(line);
    };

    this.checkOutdent = function(state, line, input) {
        return false;
    };

    this.getCompletions = function(state, session, pos, prefix) {
        return this.$completer.getCompletions(state, session, pos, prefix);
    };

    this.createWorker = function(session) {
        if (this.constructor != Mode)
            return;
        var worker = new WorkerClient(["ace"], __webpack_require__(934), "Worker");
        worker.attachToDocument(session.getDocument());

        if (this.fragmentContext)
            worker.call("setOptions", [{context: this.fragmentContext}]);

        worker.on("error", function(e) {
            session.setAnnotations(e.data);
        });

        worker.on("terminate", function() {
            session.clearAnnotations();
        });

        return worker;
    };

    this.$id = "ace/mode/html";
}).call(Mode.prototype);

exports.Mode = Mode;
});

ace.define("ace/mode/markdown_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text_highlight_rules","ace/mode/javascript_highlight_rules","ace/mode/xml_highlight_rules","ace/mode/html_highlight_rules","ace/mode/css_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var lang = acequire("../lib/lang");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
var XmlHighlightRules = acequire("./xml_highlight_rules").XmlHighlightRules;
var HtmlHighlightRules = acequire("./html_highlight_rules").HtmlHighlightRules;
var CssHighlightRules = acequire("./css_highlight_rules").CssHighlightRules;

var escaped = function(ch) {
    return "(?:[^" + lang.escapeRegExp(ch) + "\\\\]|\\\\.)*";
}

function github_embed(tag, prefix) {
    return { // Github style block
        token : "support.function",
        regex : "^\\s*```" + tag + "\\s*$",
        push  : prefix + "start"
    };
}

var MarkdownHighlightRules = function() {
    HtmlHighlightRules.call(this);

    this.$rules["start"].unshift({
        token : "empty_line",
        regex : '^$',
        next: "allowBlock"
    }, { // h1
        token: "markup.heading.1",
        regex: "^=+(?=\\s*$)"
    }, { // h2
        token: "markup.heading.2",
        regex: "^\\-+(?=\\s*$)"
    }, {
        token : function(value) {
            return "markup.heading." + value.length;
        },
        regex : /^#{1,6}(?=\s*[^ #]|\s+#.)/,
        next : "header"
    },
       github_embed("(?:javascript|js)", "jscode-"),
       github_embed("xml", "xmlcode-"),
       github_embed("html", "htmlcode-"),
       github_embed("css", "csscode-"),
    { // Github style block
        token : "support.function",
        regex : "^\\s*```\\s*\\S*(?:{.*?\\})?\\s*$",
        next  : "githubblock"
    }, { // block quote
        token : "string.blockquote",
        regex : "^\\s*>\\s*(?:[*+-]|\\d+\\.)?\\s+",
        next  : "blockquote"
    }, { // HR * - _
        token : "constant",
        regex : "^ {0,2}(?:(?: ?\\* ?){3,}|(?: ?\\- ?){3,}|(?: ?\\_ ?){3,})\\s*$",
        next: "allowBlock"
    }, { // list
        token : "markup.list",
        regex : "^\\s{0,3}(?:[*+-]|\\d+\\.)\\s+",
        next  : "listblock-start"
    }, {
        include : "basic"
    });

    this.addRules({
        "basic" : [{
            token : "constant.language.escape",
            regex : /\\[\\`*_{}\[\]()#+\-.!]/
        }, { // code span `
            token : "support.function",
            regex : "(`+)(.*?[^`])(\\1)"
        }, { // reference
            token : ["text", "constant", "text", "url", "string", "text"],
            regex : "^([ ]{0,3}\\[)([^\\]]+)(\\]:\\s*)([^ ]+)(\\s*(?:[\"][^\"]+[\"])?(\\s*))$"
        }, { // link by reference
            token : ["text", "string", "text", "constant", "text"],
            regex : "(\\[)(" + escaped("]") + ")(\\]\\s*\\[)("+ escaped("]") + ")(\\])"
        }, { // link by url
            token : ["text", "string", "text", "markup.underline", "string", "text"],
            regex : "(\\[)(" +                                        // [
                    escaped("]") +                                    // link text
                    ")(\\]\\()"+                                      // ](
                    '((?:[^\\)\\s\\\\]|\\\\.|\\s(?=[^"]))*)' +        // href
                    '(\\s*"' +  escaped('"') + '"\\s*)?' +            // "title"
                    "(\\))"                                           // )
        }, { // strong ** __
            token : "string.strong",
            regex : "([*]{2}|[_]{2}(?=\\S))(.*?\\S[*_]*)(\\1)"
        }, { // emphasis * _
            token : "string.emphasis",
            regex : "([*]|[_](?=\\S))(.*?\\S[*_]*)(\\1)"
        }, { //
            token : ["text", "url", "text"],
            regex : "(<)("+
                      "(?:https?|ftp|dict):[^'\">\\s]+"+
                      "|"+
                      "(?:mailto:)?[-.\\w]+\\@[-a-z0-9]+(?:\\.[-a-z0-9]+)*\\.[a-z]+"+
                    ")(>)"
        }],
        "allowBlock": [
            {token : "support.function", regex : "^ {4}.+", next : "allowBlock"},
            {token : "empty_line", regex : '^$', next: "allowBlock"},
            {token : "empty", regex : "", next : "start"}
        ],

        "header" : [{
            regex: "$",
            next : "start"
        }, {
            include: "basic"
        }, {
            defaultToken : "heading"
        } ],

        "listblock-start" : [{
            token : "support.variable",
            regex : /(?:\[[ x]\])?/,
            next  : "listblock"
        }],

        "listblock" : [ { // Lists only escape on completely blank lines.
            token : "empty_line",
            regex : "^$",
            next  : "start"
        }, { // list
            token : "markup.list",
            regex : "^\\s{0,3}(?:[*+-]|\\d+\\.)\\s+",
            next  : "listblock-start"
        }, {
            include : "basic", noEscape: true
        }, { // Github style block
            token : "support.function",
            regex : "^\\s*```\\s*[a-zA-Z]*(?:{.*?\\})?\\s*$",
            next  : "githubblock"
        }, {
            defaultToken : "list" //do not use markup.list to allow stling leading `*` differntly
        } ],

        "blockquote" : [ { // Blockquotes only escape on blank lines.
            token : "empty_line",
            regex : "^\\s*$",
            next  : "start"
        }, { // block quote
            token : "string.blockquote",
            regex : "^\\s*>\\s*(?:[*+-]|\\d+\\.)?\\s+",
            next  : "blockquote"
        }, {
            include : "basic", noEscape: true
        }, {
            defaultToken : "string.blockquote"
        } ],

        "githubblock" : [ {
            token : "support.function",
            regex : "^\\s*```",
            next  : "start"
        }, {
            token : "support.function",
            regex : ".+"
        } ]
    });

    this.embedRules(JavaScriptHighlightRules, "jscode-", [{
       token : "support.function",
       regex : "^\\s*```",
       next  : "pop"
    }]);

    this.embedRules(HtmlHighlightRules, "htmlcode-", [{
       token : "support.function",
       regex : "^\\s*```",
       next  : "pop"
    }]);

    this.embedRules(CssHighlightRules, "csscode-", [{
       token : "support.function",
       regex : "^\\s*```",
       next  : "pop"
    }]);

    this.embedRules(XmlHighlightRules, "xmlcode-", [{
       token : "support.function",
       regex : "^\\s*```",
       next  : "pop"
    }]);

    this.normalizeRules();
};
oop.inherits(MarkdownHighlightRules, TextHighlightRules);

exports.MarkdownHighlightRules = MarkdownHighlightRules;
});

ace.define("ace/mode/folding/markdown",["require","exports","module","ace/lib/oop","ace/mode/folding/fold_mode","ace/range"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var BaseFoldMode = acequire("./fold_mode").FoldMode;
var Range = acequire("../../range").Range;

var FoldMode = exports.FoldMode = function() {};
oop.inherits(FoldMode, BaseFoldMode);

(function() {
    this.foldingStartMarker = /^(?:[=-]+\s*$|#{1,6} |`{3})/;

    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
        if (!this.foldingStartMarker.test(line))
            return "";

        if (line[0] == "`") {
            if (session.bgTokenizer.getState(row) == "start")
                return "end";
            return "start";
        }

        return "start";
    };

    this.getFoldWidgetRange = function(session, foldStyle, row) {
        var line = session.getLine(row);
        var startColumn = line.length;
        var maxRow = session.getLength();
        var startRow = row;
        var endRow = row;
        if (!line.match(this.foldingStartMarker))
            return;

        if (line[0] == "`") {
            if (session.bgTokenizer.getState(row) !== "start") {
                while (++row < maxRow) {
                    line = session.getLine(row);
                    if (line[0] == "`" & line.substring(0, 3) == "```")
                        break;
                }
                return new Range(startRow, startColumn, row, 0);
            } else {
                while (row -- > 0) {
                    line = session.getLine(row);
                    if (line[0] == "`" & line.substring(0, 3) == "```")
                        break;
                }
                return new Range(row, line.length, startRow, 0);
            }
        }

        var token;
        function isHeading(row) {
            token = session.getTokens(row)[0];
            return token && token.type.lastIndexOf(heading, 0) === 0;
        }

        var heading = "markup.heading";
        function getLevel() {
            var ch = token.value[0];
            if (ch == "=") return 6;
            if (ch == "-") return 5;
            return 7 - token.value.search(/[^#]/);
        }

        if (isHeading(row)) {
            var startHeadingLevel = getLevel();
            while (++row < maxRow) {
                if (!isHeading(row))
                    continue;
                var level = getLevel();
                if (level >= startHeadingLevel)
                    break;
            }

            endRow = row - (!token || ["=", "-"].indexOf(token.value[0]) == -1 ? 1 : 2);

            if (endRow > startRow) {
                while (endRow > startRow && /^\s*$/.test(session.getLine(endRow)))
                    endRow--;
            }

            if (endRow > startRow) {
                var endColumn = session.getLine(endRow).length;
                return new Range(startRow, startColumn, endRow, endColumn);
            }
        }
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/markdown",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript","ace/mode/xml","ace/mode/html","ace/mode/markdown_highlight_rules","ace/mode/folding/markdown"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var JavaScriptMode = acequire("./javascript").Mode;
var XmlMode = acequire("./xml").Mode;
var HtmlMode = acequire("./html").Mode;
var MarkdownHighlightRules = acequire("./markdown_highlight_rules").MarkdownHighlightRules;
var MarkdownFoldMode = acequire("./folding/markdown").FoldMode;

var Mode = function() {
    this.HighlightRules = MarkdownHighlightRules;

    this.createModeDelegates({
        "js-": JavaScriptMode,
        "xml-": XmlMode,
        "html-": HtmlMode
    });

    this.foldingRules = new MarkdownFoldMode();
    this.$behaviour = this.$defaultBehaviour;
};
oop.inherits(Mode, TextMode);

(function() {
    this.type = "text";
    this.blockComment = {start: "<!--", end: "-->"};

    this.getNextLineIndent = function(state, line, tab) {
        if (state == "listblock") {
            var match = /^(\s*)(?:([-+*])|(\d+)\.)(\s+)/.exec(line);
            if (!match)
                return "";
            var marker = match[2];
            if (!marker)
                marker = parseInt(match[3], 10) + 1 + ".";
            return match[1] + marker + match[4];
        } else {
            return this.$getIndent(line);
        }
    };
    this.$id = "ace/mode/markdown";
}).call(Mode.prototype);

exports.Mode = Mode;
});


/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports.id = 'ace/mode/javascript_worker';
module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/javascript/jshint\",[\"require\",\"exports\",\"module\"],function(acequire,exports,module){module.exports=function outer(modules,cache,entry){function newRequire(name,jumped){if(!cache[name]){if(!modules[name]){var currentRequire=\"function\"==typeof acequire&&acequire;if(!jumped&&currentRequire)return currentRequire(name,!0);if(previousRequire)return previousRequire(name,!0);var err=Error(\"Cannot find module '\"+name+\"'\");throw err.code=\"MODULE_NOT_FOUND\",err}var m=cache[name]={exports:{}};modules[name][0].call(m.exports,function(x){var id=modules[name][1][x];return newRequire(id?id:x)},m,m.exports,outer,modules,cache,entry)}return cache[name].exports}for(var previousRequire=\"function\"==typeof acequire&&acequire,i=0;entry.length>i;i++)newRequire(entry[i]);return newRequire(entry[0])}({\"/node_modules/browserify/node_modules/events/events.js\":[function(_dereq_,module){function EventEmitter(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function isFunction(arg){return\"function\"==typeof arg}function isNumber(arg){return\"number\"==typeof arg}function isObject(arg){return\"object\"==typeof arg&&null!==arg}function isUndefined(arg){return void 0===arg}module.exports=EventEmitter,EventEmitter.EventEmitter=EventEmitter,EventEmitter.prototype._events=void 0,EventEmitter.prototype._maxListeners=void 0,EventEmitter.defaultMaxListeners=10,EventEmitter.prototype.setMaxListeners=function(n){if(!isNumber(n)||0>n||isNaN(n))throw TypeError(\"n must be a positive number\");return this._maxListeners=n,this},EventEmitter.prototype.emit=function(type){var er,handler,len,args,i,listeners;if(this._events||(this._events={}),\"error\"===type&&(!this._events.error||isObject(this._events.error)&&!this._events.error.length)){if(er=arguments[1],er instanceof Error)throw er;throw TypeError('Uncaught, unspecified \"error\" event.')}if(handler=this._events[type],isUndefined(handler))return!1;if(isFunction(handler))switch(arguments.length){case 1:handler.call(this);break;case 2:handler.call(this,arguments[1]);break;case 3:handler.call(this,arguments[1],arguments[2]);break;default:for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];handler.apply(this,args)}else if(isObject(handler)){for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];for(listeners=handler.slice(),len=listeners.length,i=0;len>i;i++)listeners[i].apply(this,args)}return!0},EventEmitter.prototype.addListener=function(type,listener){var m;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(this._events||(this._events={}),this._events.newListener&&this.emit(\"newListener\",type,isFunction(listener.listener)?listener.listener:listener),this._events[type]?isObject(this._events[type])?this._events[type].push(listener):this._events[type]=[this._events[type],listener]:this._events[type]=listener,isObject(this._events[type])&&!this._events[type].warned){var m;m=isUndefined(this._maxListeners)?EventEmitter.defaultMaxListeners:this._maxListeners,m&&m>0&&this._events[type].length>m&&(this._events[type].warned=!0,console.error(\"(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.\",this._events[type].length),\"function\"==typeof console.trace&&console.trace())}return this},EventEmitter.prototype.on=EventEmitter.prototype.addListener,EventEmitter.prototype.once=function(type,listener){function g(){this.removeListener(type,g),fired||(fired=!0,listener.apply(this,arguments))}if(!isFunction(listener))throw TypeError(\"listener must be a function\");var fired=!1;return g.listener=listener,this.on(type,g),this},EventEmitter.prototype.removeListener=function(type,listener){var list,position,length,i;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(!this._events||!this._events[type])return this;if(list=this._events[type],length=list.length,position=-1,list===listener||isFunction(list.listener)&&list.listener===listener)delete this._events[type],this._events.removeListener&&this.emit(\"removeListener\",type,listener);else if(isObject(list)){for(i=length;i-->0;)if(list[i]===listener||list[i].listener&&list[i].listener===listener){position=i;break}if(0>position)return this;1===list.length?(list.length=0,delete this._events[type]):list.splice(position,1),this._events.removeListener&&this.emit(\"removeListener\",type,listener)}return this},EventEmitter.prototype.removeAllListeners=function(type){var key,listeners;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[type]&&delete this._events[type],this;if(0===arguments.length){for(key in this._events)\"removeListener\"!==key&&this.removeAllListeners(key);return this.removeAllListeners(\"removeListener\"),this._events={},this\n}if(listeners=this._events[type],isFunction(listeners))this.removeListener(type,listeners);else for(;listeners.length;)this.removeListener(type,listeners[listeners.length-1]);return delete this._events[type],this},EventEmitter.prototype.listeners=function(type){var ret;return ret=this._events&&this._events[type]?isFunction(this._events[type])?[this._events[type]]:this._events[type].slice():[]},EventEmitter.listenerCount=function(emitter,type){var ret;return ret=emitter._events&&emitter._events[type]?isFunction(emitter._events[type])?1:emitter._events[type].length:0}},{}],\"/node_modules/jshint/data/ascii-identifier-data.js\":[function(_dereq_,module){for(var identifierStartTable=[],i=0;128>i;i++)identifierStartTable[i]=36===i||i>=65&&90>=i||95===i||i>=97&&122>=i;for(var identifierPartTable=[],i=0;128>i;i++)identifierPartTable[i]=identifierStartTable[i]||i>=48&&57>=i;module.exports={asciiIdentifierStartTable:identifierStartTable,asciiIdentifierPartTable:identifierPartTable}},{}],\"/node_modules/jshint/lodash.js\":[function(_dereq_,module,exports){(function(global){(function(){function baseFindIndex(array,predicate,fromRight){for(var length=array.length,index=fromRight?length:-1;fromRight?index--:length>++index;)if(predicate(array[index],index,array))return index;return-1}function baseIndexOf(array,value,fromIndex){if(value!==value)return indexOfNaN(array,fromIndex);for(var index=fromIndex-1,length=array.length;length>++index;)if(array[index]===value)return index;return-1}function baseIsFunction(value){return\"function\"==typeof value||!1}function baseToString(value){return\"string\"==typeof value?value:null==value?\"\":value+\"\"}function indexOfNaN(array,fromIndex,fromRight){for(var length=array.length,index=fromIndex+(fromRight?0:-1);fromRight?index--:length>++index;){var other=array[index];if(other!==other)return index}return-1}function isObjectLike(value){return!!value&&\"object\"==typeof value}function lodash(){}function arrayCopy(source,array){var index=-1,length=source.length;for(array||(array=Array(length));length>++index;)array[index]=source[index];return array}function arrayEach(array,iteratee){for(var index=-1,length=array.length;length>++index&&iteratee(array[index],index,array)!==!1;);return array}function arrayFilter(array,predicate){for(var index=-1,length=array.length,resIndex=-1,result=[];length>++index;){var value=array[index];predicate(value,index,array)&&(result[++resIndex]=value)}return result}function arrayMap(array,iteratee){for(var index=-1,length=array.length,result=Array(length);length>++index;)result[index]=iteratee(array[index],index,array);return result}function arrayMax(array){for(var index=-1,length=array.length,result=NEGATIVE_INFINITY;length>++index;){var value=array[index];value>result&&(result=value)}return result}function arraySome(array,predicate){for(var index=-1,length=array.length;length>++index;)if(predicate(array[index],index,array))return!0;return!1}function assignWith(object,source,customizer){var props=keys(source);push.apply(props,getSymbols(source));for(var index=-1,length=props.length;length>++index;){var key=props[index],value=object[key],result=customizer(value,source[key],key,object,source);(result===result?result===value:value!==value)&&(value!==undefined||key in object)||(object[key]=result)}return object}function baseCopy(source,props,object){object||(object={});for(var index=-1,length=props.length;length>++index;){var key=props[index];object[key]=source[key]}return object}function baseCallback(func,thisArg,argCount){var type=typeof func;return\"function\"==type?thisArg===undefined?func:bindCallback(func,thisArg,argCount):null==func?identity:\"object\"==type?baseMatches(func):thisArg===undefined?property(func):baseMatchesProperty(func,thisArg)}function baseClone(value,isDeep,customizer,key,object,stackA,stackB){var result;if(customizer&&(result=object?customizer(value,key,object):customizer(value)),result!==undefined)return result;if(!isObject(value))return value;var isArr=isArray(value);if(isArr){if(result=initCloneArray(value),!isDeep)return arrayCopy(value,result)}else{var tag=objToString.call(value),isFunc=tag==funcTag;if(tag!=objectTag&&tag!=argsTag&&(!isFunc||object))return cloneableTags[tag]?initCloneByTag(value,tag,isDeep):object?value:{};if(result=initCloneObject(isFunc?{}:value),!isDeep)return baseAssign(result,value)}stackA||(stackA=[]),stackB||(stackB=[]);for(var length=stackA.length;length--;)if(stackA[length]==value)return stackB[length];return stackA.push(value),stackB.push(result),(isArr?arrayEach:baseForOwn)(value,function(subValue,key){result[key]=baseClone(subValue,isDeep,customizer,key,value,stackA,stackB)}),result}function baseFilter(collection,predicate){var result=[];return baseEach(collection,function(value,index,collection){predicate(value,index,collection)&&result.push(value)}),result}function baseForIn(object,iteratee){return baseFor(object,iteratee,keysIn)}function baseForOwn(object,iteratee){return baseFor(object,iteratee,keys)}function baseGet(object,path,pathKey){if(null!=object){pathKey!==undefined&&pathKey in toObject(object)&&(path=[pathKey]);for(var index=-1,length=path.length;null!=object&&length>++index;)var result=object=object[path[index]];return result}}function baseIsEqual(value,other,customizer,isLoose,stackA,stackB){if(value===other)return 0!==value||1/value==1/other;var valType=typeof value,othType=typeof other;return\"function\"!=valType&&\"object\"!=valType&&\"function\"!=othType&&\"object\"!=othType||null==value||null==other?value!==value&&other!==other:baseIsEqualDeep(value,other,baseIsEqual,customizer,isLoose,stackA,stackB)}function baseIsEqualDeep(object,other,equalFunc,customizer,isLoose,stackA,stackB){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=arrayTag,othTag=arrayTag;objIsArr||(objTag=objToString.call(object),objTag==argsTag?objTag=objectTag:objTag!=objectTag&&(objIsArr=isTypedArray(object))),othIsArr||(othTag=objToString.call(other),othTag==argsTag?othTag=objectTag:othTag!=objectTag&&(othIsArr=isTypedArray(other)));var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&!objIsArr&&!objIsObj)return equalByTag(object,other,objTag);if(!isLoose){var valWrapped=objIsObj&&hasOwnProperty.call(object,\"__wrapped__\"),othWrapped=othIsObj&&hasOwnProperty.call(other,\"__wrapped__\");if(valWrapped||othWrapped)return equalFunc(valWrapped?object.value():object,othWrapped?other.value():other,customizer,isLoose,stackA,stackB)}if(!isSameTag)return!1;stackA||(stackA=[]),stackB||(stackB=[]);for(var length=stackA.length;length--;)if(stackA[length]==object)return stackB[length]==other;stackA.push(object),stackB.push(other);var result=(objIsArr?equalArrays:equalObjects)(object,other,equalFunc,customizer,isLoose,stackA,stackB);return stackA.pop(),stackB.pop(),result}function baseIsMatch(object,props,values,strictCompareFlags,customizer){for(var index=-1,length=props.length,noCustomizer=!customizer;length>++index;)if(noCustomizer&&strictCompareFlags[index]?values[index]!==object[props[index]]:!(props[index]in object))return!1;for(index=-1;length>++index;){var key=props[index],objValue=object[key],srcValue=values[index];if(noCustomizer&&strictCompareFlags[index])var result=objValue!==undefined||key in object;else result=customizer?customizer(objValue,srcValue,key):undefined,result===undefined&&(result=baseIsEqual(srcValue,objValue,customizer,!0));if(!result)return!1}return!0}function baseMatches(source){var props=keys(source),length=props.length;if(!length)return constant(!0);if(1==length){var key=props[0],value=source[key];if(isStrictComparable(value))return function(object){return null==object?!1:object[key]===value&&(value!==undefined||key in toObject(object))}}for(var values=Array(length),strictCompareFlags=Array(length);length--;)value=source[props[length]],values[length]=value,strictCompareFlags[length]=isStrictComparable(value);return function(object){return null!=object&&baseIsMatch(toObject(object),props,values,strictCompareFlags)}}function baseMatchesProperty(path,value){var isArr=isArray(path),isCommon=isKey(path)&&isStrictComparable(value),pathKey=path+\"\";return path=toPath(path),function(object){if(null==object)return!1;var key=pathKey;if(object=toObject(object),!(!isArr&&isCommon||key in object)){if(object=1==path.length?object:baseGet(object,baseSlice(path,0,-1)),null==object)return!1;key=last(path),object=toObject(object)}return object[key]===value?value!==undefined||key in object:baseIsEqual(value,object[key],null,!0)}}function baseMerge(object,source,customizer,stackA,stackB){if(!isObject(object))return object;var isSrcArr=isLength(source.length)&&(isArray(source)||isTypedArray(source));if(!isSrcArr){var props=keys(source);push.apply(props,getSymbols(source))}return arrayEach(props||source,function(srcValue,key){if(props&&(key=srcValue,srcValue=source[key]),isObjectLike(srcValue))stackA||(stackA=[]),stackB||(stackB=[]),baseMergeDeep(object,source,key,baseMerge,customizer,stackA,stackB);else{var value=object[key],result=customizer?customizer(value,srcValue,key,object,source):undefined,isCommon=result===undefined;isCommon&&(result=srcValue),!isSrcArr&&result===undefined||!isCommon&&(result===result?result===value:value!==value)||(object[key]=result)}}),object}function baseMergeDeep(object,source,key,mergeFunc,customizer,stackA,stackB){for(var length=stackA.length,srcValue=source[key];length--;)if(stackA[length]==srcValue)return object[key]=stackB[length],undefined;var value=object[key],result=customizer?customizer(value,srcValue,key,object,source):undefined,isCommon=result===undefined;isCommon&&(result=srcValue,isLength(srcValue.length)&&(isArray(srcValue)||isTypedArray(srcValue))?result=isArray(value)?value:getLength(value)?arrayCopy(value):[]:isPlainObject(srcValue)||isArguments(srcValue)?result=isArguments(value)?toPlainObject(value):isPlainObject(value)?value:{}:isCommon=!1),stackA.push(srcValue),stackB.push(result),isCommon?object[key]=mergeFunc(result,srcValue,customizer,stackA,stackB):(result===result?result!==value:value===value)&&(object[key]=result)}function baseProperty(key){return function(object){return null==object?undefined:object[key]}}function basePropertyDeep(path){var pathKey=path+\"\";return path=toPath(path),function(object){return baseGet(object,path,pathKey)}}function baseSlice(array,start,end){var index=-1,length=array.length;start=null==start?0:+start||0,0>start&&(start=-start>length?0:length+start),end=end===undefined||end>length?length:+end||0,0>end&&(end+=length),length=start>end?0:end-start>>>0,start>>>=0;for(var result=Array(length);length>++index;)result[index]=array[index+start];return result}function baseSome(collection,predicate){var result;return baseEach(collection,function(value,index,collection){return result=predicate(value,index,collection),!result}),!!result}function baseValues(object,props){for(var index=-1,length=props.length,result=Array(length);length>++index;)result[index]=object[props[index]];return result}function binaryIndex(array,value,retHighest){var low=0,high=array?array.length:low;if(\"number\"==typeof value&&value===value&&HALF_MAX_ARRAY_LENGTH>=high){for(;high>low;){var mid=low+high>>>1,computed=array[mid];(retHighest?value>=computed:value>computed)?low=mid+1:high=mid}return high}return binaryIndexBy(array,value,identity,retHighest)}function binaryIndexBy(array,value,iteratee,retHighest){value=iteratee(value);for(var low=0,high=array?array.length:0,valIsNaN=value!==value,valIsUndef=value===undefined;high>low;){var mid=floor((low+high)/2),computed=iteratee(array[mid]),isReflexive=computed===computed;if(valIsNaN)var setLow=isReflexive||retHighest;else setLow=valIsUndef?isReflexive&&(retHighest||computed!==undefined):retHighest?value>=computed:value>computed;setLow?low=mid+1:high=mid}return nativeMin(high,MAX_ARRAY_INDEX)}function bindCallback(func,thisArg,argCount){if(\"function\"!=typeof func)return identity;if(thisArg===undefined)return func;switch(argCount){case 1:return function(value){return func.call(thisArg,value)};case 3:return function(value,index,collection){return func.call(thisArg,value,index,collection)};case 4:return function(accumulator,value,index,collection){return func.call(thisArg,accumulator,value,index,collection)};case 5:return function(value,other,key,object,source){return func.call(thisArg,value,other,key,object,source)}}return function(){return func.apply(thisArg,arguments)}}function bufferClone(buffer){return bufferSlice.call(buffer,0)}function createAssigner(assigner){return restParam(function(object,sources){var index=-1,length=null==object?0:sources.length,customizer=length>2&&sources[length-2],guard=length>2&&sources[2],thisArg=length>1&&sources[length-1];for(\"function\"==typeof customizer?(customizer=bindCallback(customizer,thisArg,5),length-=2):(customizer=\"function\"==typeof thisArg?thisArg:null,length-=customizer?1:0),guard&&isIterateeCall(sources[0],sources[1],guard)&&(customizer=3>length?null:customizer,length=1);length>++index;){var source=sources[index];source&&assigner(object,source,customizer)}return object})}function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){var length=collection?getLength(collection):0;if(!isLength(length))return eachFunc(collection,iteratee);for(var index=fromRight?length:-1,iterable=toObject(collection);(fromRight?index--:length>++index)&&iteratee(iterable[index],index,iterable)!==!1;);return collection}}function createBaseFor(fromRight){return function(object,iteratee,keysFunc){for(var iterable=toObject(object),props=keysFunc(object),length=props.length,index=fromRight?length:-1;fromRight?index--:length>++index;){var key=props[index];if(iteratee(iterable[key],key,iterable)===!1)break}return object}}function createFindIndex(fromRight){return function(array,predicate,thisArg){return array&&array.length?(predicate=getCallback(predicate,thisArg,3),baseFindIndex(array,predicate,fromRight)):-1}}function createForEach(arrayFunc,eachFunc){return function(collection,iteratee,thisArg){return\"function\"==typeof iteratee&&thisArg===undefined&&isArray(collection)?arrayFunc(collection,iteratee):eachFunc(collection,bindCallback(iteratee,thisArg,3))}}function equalArrays(array,other,equalFunc,customizer,isLoose,stackA,stackB){var index=-1,arrLength=array.length,othLength=other.length,result=!0;if(arrLength!=othLength&&!(isLoose&&othLength>arrLength))return!1;for(;result&&arrLength>++index;){var arrValue=array[index],othValue=other[index];if(result=undefined,customizer&&(result=isLoose?customizer(othValue,arrValue,index):customizer(arrValue,othValue,index)),result===undefined)if(isLoose)for(var othIndex=othLength;othIndex--&&(othValue=other[othIndex],!(result=arrValue&&arrValue===othValue||equalFunc(arrValue,othValue,customizer,isLoose,stackA,stackB))););else result=arrValue&&arrValue===othValue||equalFunc(arrValue,othValue,customizer,isLoose,stackA,stackB)}return!!result}function equalByTag(object,other,tag){switch(tag){case boolTag:case dateTag:return+object==+other;case errorTag:return object.name==other.name&&object.message==other.message;case numberTag:return object!=+object?other!=+other:0==object?1/object==1/other:object==+other;case regexpTag:case stringTag:return object==other+\"\"}return!1}function equalObjects(object,other,equalFunc,customizer,isLoose,stackA,stackB){var objProps=keys(object),objLength=objProps.length,othProps=keys(other),othLength=othProps.length;if(objLength!=othLength&&!isLoose)return!1;for(var skipCtor=isLoose,index=-1;objLength>++index;){var key=objProps[index],result=isLoose?key in other:hasOwnProperty.call(other,key);if(result){var objValue=object[key],othValue=other[key];result=undefined,customizer&&(result=isLoose?customizer(othValue,objValue,key):customizer(objValue,othValue,key)),result===undefined&&(result=objValue&&objValue===othValue||equalFunc(objValue,othValue,customizer,isLoose,stackA,stackB))}if(!result)return!1;skipCtor||(skipCtor=\"constructor\"==key)}if(!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;if(objCtor!=othCtor&&\"constructor\"in object&&\"constructor\"in other&&!(\"function\"==typeof objCtor&&objCtor instanceof objCtor&&\"function\"==typeof othCtor&&othCtor instanceof othCtor))return!1}return!0}function getCallback(func,thisArg,argCount){var result=lodash.callback||callback;return result=result===callback?baseCallback:result,argCount?result(func,thisArg,argCount):result}function getIndexOf(collection,target,fromIndex){var result=lodash.indexOf||indexOf;return result=result===indexOf?baseIndexOf:result,collection?result(collection,target,fromIndex):result}function initCloneArray(array){var length=array.length,result=new array.constructor(length);return length&&\"string\"==typeof array[0]&&hasOwnProperty.call(array,\"index\")&&(result.index=array.index,result.input=array.input),result}function initCloneObject(object){var Ctor=object.constructor;return\"function\"==typeof Ctor&&Ctor instanceof Ctor||(Ctor=Object),new Ctor}function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return bufferClone(object);case boolTag:case dateTag:return new Ctor(+object);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:var buffer=object.buffer;return new Ctor(isDeep?bufferClone(buffer):buffer,object.byteOffset,object.length);case numberTag:case stringTag:return new Ctor(object);case regexpTag:var result=new Ctor(object.source,reFlags.exec(object));result.lastIndex=object.lastIndex}return result}function isIndex(value,length){return value=+value,length=null==length?MAX_SAFE_INTEGER:length,value>-1&&0==value%1&&length>value}function isIterateeCall(value,index,object){if(!isObject(object))return!1;var type=typeof index;if(\"number\"==type)var length=getLength(object),prereq=isLength(length)&&isIndex(index,length);else prereq=\"string\"==type&&index in object;if(prereq){var other=object[index];return value===value?value===other:other!==other}return!1}function isKey(value,object){var type=typeof value;if(\"string\"==type&&reIsPlainProp.test(value)||\"number\"==type)return!0;if(isArray(value))return!1;var result=!reIsDeepProp.test(value);return result||null!=object&&value in toObject(object)}function isLength(value){return\"number\"==typeof value&&value>-1&&0==value%1&&MAX_SAFE_INTEGER>=value}function isStrictComparable(value){return value===value&&(0===value?1/value>0:!isObject(value))}function shimIsPlainObject(value){var Ctor;if(lodash.support,!isObjectLike(value)||objToString.call(value)!=objectTag||!hasOwnProperty.call(value,\"constructor\")&&(Ctor=value.constructor,\"function\"==typeof Ctor&&!(Ctor instanceof Ctor)))return!1;var result;return baseForIn(value,function(subValue,key){result=key}),result===undefined||hasOwnProperty.call(value,result)}function shimKeys(object){for(var props=keysIn(object),propsLength=props.length,length=propsLength&&object.length,support=lodash.support,allowIndexes=length&&isLength(length)&&(isArray(object)||support.nonEnumArgs&&isArguments(object)),index=-1,result=[];propsLength>++index;){var key=props[index];(allowIndexes&&isIndex(key,length)||hasOwnProperty.call(object,key))&&result.push(key)}return result}function toObject(value){return isObject(value)?value:Object(value)}function toPath(value){if(isArray(value))return value;var result=[];return baseToString(value).replace(rePropName,function(match,number,quote,string){result.push(quote?string.replace(reEscapeChar,\"$1\"):number||match)}),result}function indexOf(array,value,fromIndex){var length=array?array.length:0;if(!length)return-1;if(\"number\"==typeof fromIndex)fromIndex=0>fromIndex?nativeMax(length+fromIndex,0):fromIndex;else if(fromIndex){var index=binaryIndex(array,value),other=array[index];return(value===value?value===other:other!==other)?index:-1}return baseIndexOf(array,value,fromIndex||0)}function last(array){var length=array?array.length:0;return length?array[length-1]:undefined}function slice(array,start,end){var length=array?array.length:0;return length?(end&&\"number\"!=typeof end&&isIterateeCall(array,start,end)&&(start=0,end=length),baseSlice(array,start,end)):[]}function unzip(array){for(var index=-1,length=(array&&array.length&&arrayMax(arrayMap(array,getLength)))>>>0,result=Array(length);length>++index;)result[index]=arrayMap(array,baseProperty(index));return result}function includes(collection,target,fromIndex,guard){var length=collection?getLength(collection):0;return isLength(length)||(collection=values(collection),length=collection.length),length?(fromIndex=\"number\"!=typeof fromIndex||guard&&isIterateeCall(target,fromIndex,guard)?0:0>fromIndex?nativeMax(length+fromIndex,0):fromIndex||0,\"string\"==typeof collection||!isArray(collection)&&isString(collection)?length>fromIndex&&collection.indexOf(target,fromIndex)>-1:getIndexOf(collection,target,fromIndex)>-1):!1}function reject(collection,predicate,thisArg){var func=isArray(collection)?arrayFilter:baseFilter;return predicate=getCallback(predicate,thisArg,3),func(collection,function(value,index,collection){return!predicate(value,index,collection)})}function some(collection,predicate,thisArg){var func=isArray(collection)?arraySome:baseSome;return thisArg&&isIterateeCall(collection,predicate,thisArg)&&(predicate=null),(\"function\"!=typeof predicate||thisArg!==undefined)&&(predicate=getCallback(predicate,thisArg,3)),func(collection,predicate)}function restParam(func,start){if(\"function\"!=typeof func)throw new TypeError(FUNC_ERROR_TEXT);return start=nativeMax(start===undefined?func.length-1:+start||0,0),function(){for(var args=arguments,index=-1,length=nativeMax(args.length-start,0),rest=Array(length);length>++index;)rest[index]=args[start+index];switch(start){case 0:return func.call(this,rest);case 1:return func.call(this,args[0],rest);case 2:return func.call(this,args[0],args[1],rest)}var otherArgs=Array(start+1);for(index=-1;start>++index;)otherArgs[index]=args[index];return otherArgs[start]=rest,func.apply(this,otherArgs)}}function clone(value,isDeep,customizer,thisArg){return isDeep&&\"boolean\"!=typeof isDeep&&isIterateeCall(value,isDeep,customizer)?isDeep=!1:\"function\"==typeof isDeep&&(thisArg=customizer,customizer=isDeep,isDeep=!1),customizer=\"function\"==typeof customizer&&bindCallback(customizer,thisArg,1),baseClone(value,isDeep,customizer)}function isArguments(value){var length=isObjectLike(value)?value.length:undefined;return isLength(length)&&objToString.call(value)==argsTag}function isEmpty(value){if(null==value)return!0;var length=getLength(value);return isLength(length)&&(isArray(value)||isString(value)||isArguments(value)||isObjectLike(value)&&isFunction(value.splice))?!length:!keys(value).length}function isObject(value){var type=typeof value;return\"function\"==type||!!value&&\"object\"==type}function isNative(value){return null==value?!1:objToString.call(value)==funcTag?reIsNative.test(fnToString.call(value)):isObjectLike(value)&&reIsHostCtor.test(value)}function isNumber(value){return\"number\"==typeof value||isObjectLike(value)&&objToString.call(value)==numberTag}function isString(value){return\"string\"==typeof value||isObjectLike(value)&&objToString.call(value)==stringTag}function isTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[objToString.call(value)]}function toPlainObject(value){return baseCopy(value,keysIn(value))}function has(object,path){if(null==object)return!1;var result=hasOwnProperty.call(object,path);return result||isKey(path)||(path=toPath(path),object=1==path.length?object:baseGet(object,baseSlice(path,0,-1)),path=last(path),result=null!=object&&hasOwnProperty.call(object,path)),result}function keysIn(object){if(null==object)return[];isObject(object)||(object=Object(object));var length=object.length;length=length&&isLength(length)&&(isArray(object)||support.nonEnumArgs&&isArguments(object))&&length||0;for(var Ctor=object.constructor,index=-1,isProto=\"function\"==typeof Ctor&&Ctor.prototype===object,result=Array(length),skipIndexes=length>0;length>++index;)result[index]=index+\"\";for(var key in object)skipIndexes&&isIndex(key,length)||\"constructor\"==key&&(isProto||!hasOwnProperty.call(object,key))||result.push(key);return result}function values(object){return baseValues(object,keys(object))}function escapeRegExp(string){return string=baseToString(string),string&&reHasRegExpChars.test(string)?string.replace(reRegExpChars,\"\\\\$&\"):string}function callback(func,thisArg,guard){return guard&&isIterateeCall(func,thisArg,guard)&&(thisArg=null),baseCallback(func,thisArg)}function constant(value){return function(){return value}}function identity(value){return value}function property(path){return isKey(path)?baseProperty(path):basePropertyDeep(path)}var undefined,VERSION=\"3.7.0\",FUNC_ERROR_TEXT=\"Expected a function\",argsTag=\"[object Arguments]\",arrayTag=\"[object Array]\",boolTag=\"[object Boolean]\",dateTag=\"[object Date]\",errorTag=\"[object Error]\",funcTag=\"[object Function]\",mapTag=\"[object Map]\",numberTag=\"[object Number]\",objectTag=\"[object Object]\",regexpTag=\"[object RegExp]\",setTag=\"[object Set]\",stringTag=\"[object String]\",weakMapTag=\"[object WeakMap]\",arrayBufferTag=\"[object ArrayBuffer]\",float32Tag=\"[object Float32Array]\",float64Tag=\"[object Float64Array]\",int8Tag=\"[object Int8Array]\",int16Tag=\"[object Int16Array]\",int32Tag=\"[object Int32Array]\",uint8Tag=\"[object Uint8Array]\",uint8ClampedTag=\"[object Uint8ClampedArray]\",uint16Tag=\"[object Uint16Array]\",uint32Tag=\"[object Uint32Array]\",reIsDeepProp=/\\.|\\[(?:[^[\\]]+|([\"'])(?:(?!\\1)[^\\n\\\\]|\\\\.)*?)\\1\\]/,reIsPlainProp=/^\\w*$/,rePropName=/[^.[\\]]+|\\[(?:(-?\\d+(?:\\.\\d+)?)|([\"'])((?:(?!\\2)[^\\n\\\\]|\\\\.)*?)\\2)\\]/g,reRegExpChars=/[.*+?^${}()|[\\]\\/\\\\]/g,reHasRegExpChars=RegExp(reRegExpChars.source),reEscapeChar=/\\\\(\\\\)?/g,reFlags=/\\w*$/,reIsHostCtor=/^\\[object .+?Constructor\\]$/,typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=!0,typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=!1;var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[stringTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=!0,cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[mapTag]=cloneableTags[setTag]=cloneableTags[weakMapTag]=!1;var objectTypes={\"function\":!0,object:!0},freeExports=objectTypes[typeof exports]&&exports&&!exports.nodeType&&exports,freeModule=objectTypes[typeof module]&&module&&!module.nodeType&&module,freeGlobal=freeExports&&freeModule&&\"object\"==typeof global&&global&&global.Object&&global,freeSelf=objectTypes[typeof self]&&self&&self.Object&&self,freeWindow=objectTypes[typeof window]&&window&&window.Object&&window,moduleExports=freeModule&&freeModule.exports===freeExports&&freeExports,root=freeGlobal||freeWindow!==(this&&this.window)&&freeWindow||freeSelf||this,arrayProto=Array.prototype,objectProto=Object.prototype,fnToString=Function.prototype.toString,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString,reIsNative=RegExp(\"^\"+escapeRegExp(objToString).replace(/toString|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,\"$1.*?\")+\"$\"),ArrayBuffer=isNative(ArrayBuffer=root.ArrayBuffer)&&ArrayBuffer,bufferSlice=isNative(bufferSlice=ArrayBuffer&&new ArrayBuffer(0).slice)&&bufferSlice,floor=Math.floor,getOwnPropertySymbols=isNative(getOwnPropertySymbols=Object.getOwnPropertySymbols)&&getOwnPropertySymbols,getPrototypeOf=isNative(getPrototypeOf=Object.getPrototypeOf)&&getPrototypeOf,push=arrayProto.push,preventExtensions=isNative(Object.preventExtensions=Object.preventExtensions)&&preventExtensions,propertyIsEnumerable=objectProto.propertyIsEnumerable,Uint8Array=isNative(Uint8Array=root.Uint8Array)&&Uint8Array,Float64Array=function(){try{var func=isNative(func=root.Float64Array)&&func,result=new func(new ArrayBuffer(10),0,1)&&func}catch(e){}return result}(),nativeAssign=function(){var object={1:0},func=preventExtensions&&isNative(func=Object.assign)&&func;try{func(preventExtensions(object),\"xo\")}catch(e){}return!object[1]&&func}(),nativeIsArray=isNative(nativeIsArray=Array.isArray)&&nativeIsArray,nativeKeys=isNative(nativeKeys=Object.keys)&&nativeKeys,nativeMax=Math.max,nativeMin=Math.min,NEGATIVE_INFINITY=Number.NEGATIVE_INFINITY,MAX_ARRAY_LENGTH=Math.pow(2,32)-1,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1,FLOAT64_BYTES_PER_ELEMENT=Float64Array?Float64Array.BYTES_PER_ELEMENT:0,MAX_SAFE_INTEGER=Math.pow(2,53)-1,support=lodash.support={};(function(x){var Ctor=function(){this.x=x},props=[];Ctor.prototype={valueOf:x,y:x};for(var key in new Ctor)props.push(key);support.funcDecomp=/\\bthis\\b/.test(function(){return this}),support.funcNames=\"string\"==typeof Function.name;try{support.nonEnumArgs=!propertyIsEnumerable.call(arguments,1)}catch(e){support.nonEnumArgs=!0}})(1,0);var baseAssign=nativeAssign||function(object,source){return null==source?object:baseCopy(source,getSymbols(source),baseCopy(source,keys(source),object))},baseEach=createBaseEach(baseForOwn),baseFor=createBaseFor();bufferSlice||(bufferClone=ArrayBuffer&&Uint8Array?function(buffer){var byteLength=buffer.byteLength,floatLength=Float64Array?floor(byteLength/FLOAT64_BYTES_PER_ELEMENT):0,offset=floatLength*FLOAT64_BYTES_PER_ELEMENT,result=new ArrayBuffer(byteLength);if(floatLength){var view=new Float64Array(result,0,floatLength);view.set(new Float64Array(buffer,0,floatLength))}return byteLength!=offset&&(view=new Uint8Array(result,offset),view.set(new Uint8Array(buffer,offset))),result}:constant(null));var getLength=baseProperty(\"length\"),getSymbols=getOwnPropertySymbols?function(object){return getOwnPropertySymbols(toObject(object))}:constant([]),findLastIndex=createFindIndex(!0),zip=restParam(unzip),forEach=createForEach(arrayEach,baseEach),isArray=nativeIsArray||function(value){return isObjectLike(value)&&isLength(value.length)&&objToString.call(value)==arrayTag},isFunction=baseIsFunction(/x/)||Uint8Array&&!baseIsFunction(Uint8Array)?function(value){return objToString.call(value)==funcTag}:baseIsFunction,isPlainObject=getPrototypeOf?function(value){if(!value||objToString.call(value)!=objectTag)return!1;var valueOf=value.valueOf,objProto=isNative(valueOf)&&(objProto=getPrototypeOf(valueOf))&&getPrototypeOf(objProto);return objProto?value==objProto||getPrototypeOf(value)==objProto:shimIsPlainObject(value)}:shimIsPlainObject,assign=createAssigner(function(object,source,customizer){return customizer?assignWith(object,source,customizer):baseAssign(object,source)}),keys=nativeKeys?function(object){if(object)var Ctor=object.constructor,length=object.length;return\"function\"==typeof Ctor&&Ctor.prototype===object||\"function\"!=typeof object&&isLength(length)?shimKeys(object):isObject(object)?nativeKeys(object):[]}:shimKeys,merge=createAssigner(baseMerge);lodash.assign=assign,lodash.callback=callback,lodash.constant=constant,lodash.forEach=forEach,lodash.keys=keys,lodash.keysIn=keysIn,lodash.merge=merge,lodash.property=property,lodash.reject=reject,lodash.restParam=restParam,lodash.slice=slice,lodash.toPlainObject=toPlainObject,lodash.unzip=unzip,lodash.values=values,lodash.zip=zip,lodash.each=forEach,lodash.extend=assign,lodash.iteratee=callback,lodash.clone=clone,lodash.escapeRegExp=escapeRegExp,lodash.findLastIndex=findLastIndex,lodash.has=has,lodash.identity=identity,lodash.includes=includes,lodash.indexOf=indexOf,lodash.isArguments=isArguments,lodash.isArray=isArray,lodash.isEmpty=isEmpty,lodash.isFunction=isFunction,lodash.isNative=isNative,lodash.isNumber=isNumber,lodash.isObject=isObject,lodash.isPlainObject=isPlainObject,lodash.isString=isString,lodash.isTypedArray=isTypedArray,lodash.last=last,lodash.some=some,lodash.any=some,lodash.contains=includes,lodash.include=includes,lodash.VERSION=VERSION,freeExports&&freeModule?moduleExports?(freeModule.exports=lodash)._=lodash:freeExports._=lodash:root._=lodash\n}).call(this)}).call(this,\"undefined\"!=typeof global?global:\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:{})},{}],\"/node_modules/jshint/src/jshint.js\":[function(_dereq_,module,exports){var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),vars=_dereq_(\"./vars.js\"),messages=_dereq_(\"./messages.js\"),Lexer=_dereq_(\"./lex.js\").Lexer,reg=_dereq_(\"./reg.js\"),state=_dereq_(\"./state.js\").state,style=_dereq_(\"./style.js\"),options=_dereq_(\"./options.js\"),scopeManager=_dereq_(\"./scope-manager.js\"),JSHINT=function(){\"use strict\";function checkOption(name,t){return name=name.trim(),/^[+-]W\\d{3}$/g.test(name)?!0:-1!==options.validNames.indexOf(name)||\"jslint\"===t.type||_.has(options.removed,name)?!0:(error(\"E001\",t,name),!1)}function isString(obj){return\"[object String]\"===Object.prototype.toString.call(obj)}function isIdentifier(tkn,value){return tkn?tkn.identifier&&tkn.value===value?!0:!1:!1}function isReserved(token){if(!token.reserved)return!1;var meta=token.meta;if(meta&&meta.isFutureReservedWord&&state.inES5()){if(!meta.es5)return!1;if(meta.strictOnly&&!state.option.strict&&!state.isStrict())return!1;if(token.isProperty)return!1}return!0}function supplant(str,data){return str.replace(/\\{([^{}]*)\\}/g,function(a,b){var r=data[b];return\"string\"==typeof r||\"number\"==typeof r?r:a})}function combine(dest,src){Object.keys(src).forEach(function(name){_.has(JSHINT.blacklist,name)||(dest[name]=src[name])})}function processenforceall(){if(state.option.enforceall){for(var enforceopt in options.bool.enforcing)void 0!==state.option[enforceopt]||options.noenforceall[enforceopt]||(state.option[enforceopt]=!0);for(var relaxopt in options.bool.relaxing)void 0===state.option[relaxopt]&&(state.option[relaxopt]=!1)}}function assume(){processenforceall(),state.option.esversion||state.option.moz||(state.option.esversion=state.option.es3?3:state.option.esnext?6:5),state.inES5()&&combine(predefined,vars.ecmaIdentifiers[5]),state.inES6()&&combine(predefined,vars.ecmaIdentifiers[6]),state.option.module&&(state.option.strict===!0&&(state.option.strict=\"global\"),state.inES6()||warning(\"W134\",state.tokens.next,\"module\",6)),state.option.couch&&combine(predefined,vars.couch),state.option.qunit&&combine(predefined,vars.qunit),state.option.rhino&&combine(predefined,vars.rhino),state.option.shelljs&&(combine(predefined,vars.shelljs),combine(predefined,vars.node)),state.option.typed&&combine(predefined,vars.typed),state.option.phantom&&(combine(predefined,vars.phantom),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.prototypejs&&combine(predefined,vars.prototypejs),state.option.node&&(combine(predefined,vars.node),combine(predefined,vars.typed),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.devel&&combine(predefined,vars.devel),state.option.dojo&&combine(predefined,vars.dojo),state.option.browser&&(combine(predefined,vars.browser),combine(predefined,vars.typed)),state.option.browserify&&(combine(predefined,vars.browser),combine(predefined,vars.typed),combine(predefined,vars.browserify),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.nonstandard&&combine(predefined,vars.nonstandard),state.option.jasmine&&combine(predefined,vars.jasmine),state.option.jquery&&combine(predefined,vars.jquery),state.option.mootools&&combine(predefined,vars.mootools),state.option.worker&&combine(predefined,vars.worker),state.option.wsh&&combine(predefined,vars.wsh),state.option.globalstrict&&state.option.strict!==!1&&(state.option.strict=\"global\"),state.option.yui&&combine(predefined,vars.yui),state.option.mocha&&combine(predefined,vars.mocha)}function quit(code,line,chr){var percentage=Math.floor(100*(line/state.lines.length)),message=messages.errors[code].desc;throw{name:\"JSHintError\",line:line,character:chr,message:message+\" (\"+percentage+\"% scanned).\",raw:message,code:code}}function removeIgnoredMessages(){var ignored=state.ignoredLines;_.isEmpty(ignored)||(JSHINT.errors=_.reject(JSHINT.errors,function(err){return ignored[err.line]}))}function warning(code,t,a,b,c,d){var ch,l,w,msg;if(/^W\\d{3}$/.test(code)){if(state.ignored[code])return;msg=messages.warnings[code]}else/E\\d{3}/.test(code)?msg=messages.errors[code]:/I\\d{3}/.test(code)&&(msg=messages.info[code]);return t=t||state.tokens.next||{},\"(end)\"===t.id&&(t=state.tokens.curr),l=t.line||0,ch=t.from||0,w={id:\"(error)\",raw:msg.desc,code:msg.code,evidence:state.lines[l-1]||\"\",line:l,character:ch,scope:JSHINT.scope,a:a,b:b,c:c,d:d},w.reason=supplant(msg.desc,w),JSHINT.errors.push(w),removeIgnoredMessages(),JSHINT.errors.length>=state.option.maxerr&&quit(\"E043\",l,ch),w}function warningAt(m,l,ch,a,b,c,d){return warning(m,{line:l,from:ch},a,b,c,d)}function error(m,t,a,b,c,d){warning(m,t,a,b,c,d)}function errorAt(m,l,ch,a,b,c,d){return error(m,{line:l,from:ch},a,b,c,d)}function addInternalSrc(elem,src){var i;return i={id:\"(internal)\",elem:elem,value:src},JSHINT.internals.push(i),i}function doOption(){var nt=state.tokens.next,body=nt.body.match(/(-\\s+)?[^\\s,:]+(?:\\s*:\\s*(-\\s+)?[^\\s,]+)?/g)||[],predef={};if(\"globals\"===nt.type){body.forEach(function(g,idx){g=g.split(\":\");var key=(g[0]||\"\").trim(),val=(g[1]||\"\").trim();if(\"-\"===key||!key.length){if(idx>0&&idx===body.length-1)return;return error(\"E002\",nt),void 0}\"-\"===key.charAt(0)?(key=key.slice(1),val=!1,JSHINT.blacklist[key]=key,delete predefined[key]):predef[key]=\"true\"===val}),combine(predefined,predef);for(var key in predef)_.has(predef,key)&&(declared[key]=nt)}\"exported\"===nt.type&&body.forEach(function(e,idx){if(!e.length){if(idx>0&&idx===body.length-1)return;return error(\"E002\",nt),void 0}state.funct[\"(scope)\"].addExported(e)}),\"members\"===nt.type&&(membersOnly=membersOnly||{},body.forEach(function(m){var ch1=m.charAt(0),ch2=m.charAt(m.length-1);ch1!==ch2||'\"'!==ch1&&\"'\"!==ch1||(m=m.substr(1,m.length-2).replace('\\\\\"','\"')),membersOnly[m]=!1}));var numvals=[\"maxstatements\",\"maxparams\",\"maxdepth\",\"maxcomplexity\",\"maxerr\",\"maxlen\",\"indent\"];(\"jshint\"===nt.type||\"jslint\"===nt.type)&&(body.forEach(function(g){g=g.split(\":\");var key=(g[0]||\"\").trim(),val=(g[1]||\"\").trim();if(checkOption(key,nt))if(numvals.indexOf(key)>=0)if(\"false\"!==val){if(val=+val,\"number\"!=typeof val||!isFinite(val)||0>=val||Math.floor(val)!==val)return error(\"E032\",nt,g[1].trim()),void 0;state.option[key]=val}else state.option[key]=\"indent\"===key?4:!1;else{if(\"validthis\"===key)return state.funct[\"(global)\"]?void error(\"E009\"):\"true\"!==val&&\"false\"!==val?void error(\"E002\",nt):(state.option.validthis=\"true\"===val,void 0);if(\"quotmark\"!==key)if(\"shadow\"!==key)if(\"unused\"!==key)if(\"latedef\"!==key)if(\"ignore\"!==key)if(\"strict\"!==key){\"module\"===key&&(hasParsedCode(state.funct)||error(\"E055\",state.tokens.next,\"module\"));var esversions={es3:3,es5:5,esnext:6};if(!_.has(esversions,key)){if(\"esversion\"===key){switch(val){case\"5\":state.inES5(!0)&&warning(\"I003\");case\"3\":case\"6\":state.option.moz=!1,state.option.esversion=+val;break;case\"2015\":state.option.moz=!1,state.option.esversion=6;break;default:error(\"E002\",nt)}return hasParsedCode(state.funct)||error(\"E055\",state.tokens.next,\"esversion\"),void 0}var match=/^([+-])(W\\d{3})$/g.exec(key);if(match)return state.ignored[match[2]]=\"-\"===match[1],void 0;var tn;return\"true\"===val||\"false\"===val?(\"jslint\"===nt.type?(tn=options.renamed[key]||key,state.option[tn]=\"true\"===val,void 0!==options.inverted[tn]&&(state.option[tn]=!state.option[tn])):state.option[key]=\"true\"===val,\"newcap\"===key&&(state.option[\"(explicitNewcap)\"]=!0),void 0):(error(\"E002\",nt),void 0)}switch(val){case\"true\":state.option.moz=!1,state.option.esversion=esversions[key];break;case\"false\":state.option.moz||(state.option.esversion=5);break;default:error(\"E002\",nt)}}else switch(val){case\"true\":state.option.strict=!0;break;case\"false\":state.option.strict=!1;break;case\"func\":case\"global\":case\"implied\":state.option.strict=val;break;default:error(\"E002\",nt)}else switch(val){case\"line\":state.ignoredLines[nt.line]=!0,removeIgnoredMessages();break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.latedef=!0;break;case\"false\":state.option.latedef=!1;break;case\"nofunc\":state.option.latedef=\"nofunc\";break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.unused=!0;break;case\"false\":state.option.unused=!1;break;case\"vars\":case\"strict\":state.option.unused=val;break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.shadow=!0;break;case\"outer\":state.option.shadow=\"outer\";break;case\"false\":case\"inner\":state.option.shadow=\"inner\";break;default:error(\"E002\",nt)}else switch(val){case\"true\":case\"false\":state.option.quotmark=\"true\"===val;break;case\"double\":case\"single\":state.option.quotmark=val;break;default:error(\"E002\",nt)}}}),assume())}function peek(p){var t,i=p||0,j=lookahead.length;if(j>i)return lookahead[i];for(;i>=j;)t=lookahead[j],t||(t=lookahead[j]=lex.token()),j+=1;return t||\"(end)\"!==state.tokens.next.id?t:state.tokens.next}function peekIgnoreEOL(){var t,i=0;do t=peek(i++);while(\"(endline)\"===t.id);return t}function advance(id,t){switch(state.tokens.curr.id){case\"(number)\":\".\"===state.tokens.next.id&&warning(\"W005\",state.tokens.curr);break;case\"-\":(\"-\"===state.tokens.next.id||\"--\"===state.tokens.next.id)&&warning(\"W006\");break;case\"+\":(\"+\"===state.tokens.next.id||\"++\"===state.tokens.next.id)&&warning(\"W007\")}for(id&&state.tokens.next.id!==id&&(t?\"(end)\"===state.tokens.next.id?error(\"E019\",t,t.id):error(\"E020\",state.tokens.next,id,t.id,t.line,state.tokens.next.value):(\"(identifier)\"!==state.tokens.next.type||state.tokens.next.value!==id)&&warning(\"W116\",state.tokens.next,id,state.tokens.next.value)),state.tokens.prev=state.tokens.curr,state.tokens.curr=state.tokens.next;;){if(state.tokens.next=lookahead.shift()||lex.token(),state.tokens.next||quit(\"E041\",state.tokens.curr.line),\"(end)\"===state.tokens.next.id||\"(error)\"===state.tokens.next.id)return;if(state.tokens.next.check&&state.tokens.next.check(),state.tokens.next.isSpecial)\"falls through\"===state.tokens.next.type?state.tokens.curr.caseFallsThrough=!0:doOption();else if(\"(endline)\"!==state.tokens.next.id)break}}function isInfix(token){return token.infix||!token.identifier&&!token.template&&!!token.led}function isEndOfExpr(){var curr=state.tokens.curr,next=state.tokens.next;return\";\"===next.id||\"}\"===next.id||\":\"===next.id?!0:isInfix(next)===isInfix(curr)||\"yield\"===curr.id&&state.inMoz()?curr.line!==startLine(next):!1}function isBeginOfExpr(prev){return!prev.left&&\"unary\"!==prev.arity}function expression(rbp,initial){var left,isArray=!1,isObject=!1,isLetExpr=!1;state.nameStack.push(),initial||\"let\"!==state.tokens.next.value||\"(\"!==peek(0).value||(state.inMoz()||warning(\"W118\",state.tokens.next,\"let expressions\"),isLetExpr=!0,state.funct[\"(scope)\"].stack(),advance(\"let\"),advance(\"(\"),state.tokens.prev.fud(),advance(\")\")),\"(end)\"===state.tokens.next.id&&error(\"E006\",state.tokens.curr);var isDangerous=state.option.asi&&state.tokens.prev.line!==startLine(state.tokens.curr)&&_.contains([\"]\",\")\"],state.tokens.prev.id)&&_.contains([\"[\",\"(\"],state.tokens.curr.id);if(isDangerous&&warning(\"W014\",state.tokens.curr,state.tokens.curr.id),advance(),initial&&(state.funct[\"(verb)\"]=state.tokens.curr.value,state.tokens.curr.beginsStmt=!0),initial===!0&&state.tokens.curr.fud)left=state.tokens.curr.fud();else for(state.tokens.curr.nud?left=state.tokens.curr.nud():error(\"E030\",state.tokens.curr,state.tokens.curr.id);(state.tokens.next.lbp>rbp||\"(template)\"===state.tokens.next.type)&&!isEndOfExpr();)isArray=\"Array\"===state.tokens.curr.value,isObject=\"Object\"===state.tokens.curr.value,left&&(left.value||left.first&&left.first.value)&&(\"new\"!==left.value||left.first&&left.first.value&&\".\"===left.first.value)&&(isArray=!1,left.value!==state.tokens.curr.value&&(isObject=!1)),advance(),isArray&&\"(\"===state.tokens.curr.id&&\")\"===state.tokens.next.id&&warning(\"W009\",state.tokens.curr),isObject&&\"(\"===state.tokens.curr.id&&\")\"===state.tokens.next.id&&warning(\"W010\",state.tokens.curr),left&&state.tokens.curr.led?left=state.tokens.curr.led(left):error(\"E033\",state.tokens.curr,state.tokens.curr.id);return isLetExpr&&state.funct[\"(scope)\"].unstack(),state.nameStack.pop(),left}function startLine(token){return token.startLine||token.line}function nobreaknonadjacent(left,right){left=left||state.tokens.curr,right=right||state.tokens.next,state.option.laxbreak||left.line===startLine(right)||warning(\"W014\",right,right.value)}function nolinebreak(t){t=t||state.tokens.curr,t.line!==startLine(state.tokens.next)&&warning(\"E022\",t,t.value)}function nobreakcomma(left,right){left.line!==startLine(right)&&(state.option.laxcomma||(comma.first&&(warning(\"I001\"),comma.first=!1),warning(\"W014\",left,right.value)))}function comma(opts){if(opts=opts||{},opts.peek?nobreakcomma(state.tokens.prev,state.tokens.curr):(nobreakcomma(state.tokens.curr,state.tokens.next),advance(\",\")),state.tokens.next.identifier&&(!opts.property||!state.inES5()))switch(state.tokens.next.value){case\"break\":case\"case\":case\"catch\":case\"continue\":case\"default\":case\"do\":case\"else\":case\"finally\":case\"for\":case\"if\":case\"in\":case\"instanceof\":case\"return\":case\"switch\":case\"throw\":case\"try\":case\"var\":case\"let\":case\"while\":case\"with\":return error(\"E024\",state.tokens.next,state.tokens.next.value),!1}if(\"(punctuator)\"===state.tokens.next.type)switch(state.tokens.next.value){case\"}\":case\"]\":case\",\":if(opts.allowTrailing)return!0;case\")\":return error(\"E024\",state.tokens.next,state.tokens.next.value),!1}return!0}function symbol(s,p){var x=state.syntax[s];return x&&\"object\"==typeof x||(state.syntax[s]=x={id:s,lbp:p,value:s}),x}function delim(s){var x=symbol(s,0);return x.delim=!0,x}function stmt(s,f){var x=delim(s);return x.identifier=x.reserved=!0,x.fud=f,x}function blockstmt(s,f){var x=stmt(s,f);return x.block=!0,x}function reserveName(x){var c=x.id.charAt(0);return(c>=\"a\"&&\"z\">=c||c>=\"A\"&&\"Z\">=c)&&(x.identifier=x.reserved=!0),x}function prefix(s,f){var x=symbol(s,150);return reserveName(x),x.nud=\"function\"==typeof f?f:function(){return this.arity=\"unary\",this.right=expression(150),(\"++\"===this.id||\"--\"===this.id)&&(state.option.plusplus?warning(\"W016\",this,this.id):!this.right||this.right.identifier&&!isReserved(this.right)||\".\"===this.right.id||\"[\"===this.right.id||warning(\"W017\",this),this.right&&this.right.isMetaProperty?error(\"E031\",this):this.right&&this.right.identifier&&state.funct[\"(scope)\"].block.modify(this.right.value,this)),this},x}function type(s,f){var x=delim(s);return x.type=s,x.nud=f,x}function reserve(name,func){var x=type(name,func);return x.identifier=!0,x.reserved=!0,x}function FutureReservedWord(name,meta){var x=type(name,meta&&meta.nud||function(){return this});return meta=meta||{},meta.isFutureReservedWord=!0,x.value=name,x.identifier=!0,x.reserved=!0,x.meta=meta,x}function reservevar(s,v){return reserve(s,function(){return\"function\"==typeof v&&v(this),this})}function infix(s,f,p,w){var x=symbol(s,p);return reserveName(x),x.infix=!0,x.led=function(left){return w||nobreaknonadjacent(state.tokens.prev,state.tokens.curr),\"in\"!==s&&\"instanceof\"!==s||\"!\"!==left.id||warning(\"W018\",left,\"!\"),\"function\"==typeof f?f(left,this):(this.left=left,this.right=expression(p),this)},x}function application(s){var x=symbol(s,42);return x.led=function(left){return nobreaknonadjacent(state.tokens.prev,state.tokens.curr),this.left=left,this.right=doFunction({type:\"arrow\",loneArg:left}),this},x}function relation(s,f){var x=symbol(s,100);return x.led=function(left){nobreaknonadjacent(state.tokens.prev,state.tokens.curr),this.left=left;var right=this.right=expression(100);return isIdentifier(left,\"NaN\")||isIdentifier(right,\"NaN\")?warning(\"W019\",this):f&&f.apply(this,[left,right]),left&&right||quit(\"E041\",state.tokens.curr.line),\"!\"===left.id&&warning(\"W018\",left,\"!\"),\"!\"===right.id&&warning(\"W018\",right,\"!\"),this},x}function isPoorRelation(node){return node&&(\"(number)\"===node.type&&0===+node.value||\"(string)\"===node.type&&\"\"===node.value||\"null\"===node.type&&!state.option.eqnull||\"true\"===node.type||\"false\"===node.type||\"undefined\"===node.type)}function isTypoTypeof(left,right,state){var values;return state.option.notypeof?!1:left&&right?(values=state.inES6()?typeofValues.es6:typeofValues.es3,\"(identifier)\"===right.type&&\"typeof\"===right.value&&\"(string)\"===left.type?!_.contains(values,left.value):!1):!1}function isGlobalEval(left,state){var isGlobal=!1;return\"this\"===left.type&&null===state.funct[\"(context)\"]?isGlobal=!0:\"(identifier)\"===left.type&&(state.option.node&&\"global\"===left.value?isGlobal=!0:!state.option.browser||\"window\"!==left.value&&\"document\"!==left.value||(isGlobal=!0)),isGlobal}function findNativePrototype(left){function walkPrototype(obj){return\"object\"==typeof obj?\"prototype\"===obj.right?obj:walkPrototype(obj.left):void 0}function walkNative(obj){for(;!obj.identifier&&\"object\"==typeof obj.left;)obj=obj.left;return obj.identifier&&natives.indexOf(obj.value)>=0?obj.value:void 0}var natives=[\"Array\",\"ArrayBuffer\",\"Boolean\",\"Collator\",\"DataView\",\"Date\",\"DateTimeFormat\",\"Error\",\"EvalError\",\"Float32Array\",\"Float64Array\",\"Function\",\"Infinity\",\"Intl\",\"Int16Array\",\"Int32Array\",\"Int8Array\",\"Iterator\",\"Number\",\"NumberFormat\",\"Object\",\"RangeError\",\"ReferenceError\",\"RegExp\",\"StopIteration\",\"String\",\"SyntaxError\",\"TypeError\",\"Uint16Array\",\"Uint32Array\",\"Uint8Array\",\"Uint8ClampedArray\",\"URIError\"],prototype=walkPrototype(left);return prototype?walkNative(prototype):void 0}function checkLeftSideAssign(left,assignToken,options){var allowDestructuring=options&&options.allowDestructuring;if(assignToken=assignToken||left,state.option.freeze){var nativeObject=findNativePrototype(left);nativeObject&&warning(\"W121\",left,nativeObject)}return left.identifier&&!left.isMetaProperty&&state.funct[\"(scope)\"].block.reassign(left.value,left),\".\"===left.id?((!left.left||\"arguments\"===left.left.value&&!state.isStrict())&&warning(\"E031\",assignToken),state.nameStack.set(state.tokens.prev),!0):\"{\"===left.id||\"[\"===left.id?(allowDestructuring&&state.tokens.curr.left.destructAssign?state.tokens.curr.left.destructAssign.forEach(function(t){t.id&&state.funct[\"(scope)\"].block.modify(t.id,t.token)}):\"{\"!==left.id&&left.left?\"arguments\"!==left.left.value||state.isStrict()||warning(\"E031\",assignToken):warning(\"E031\",assignToken),\"[\"===left.id&&state.nameStack.set(left.right),!0):left.isMetaProperty?(error(\"E031\",assignToken),!0):left.identifier&&!isReserved(left)?(\"exception\"===state.funct[\"(scope)\"].labeltype(left.value)&&warning(\"W022\",left),state.nameStack.set(left),!0):(left===state.syntax[\"function\"]&&warning(\"W023\",state.tokens.curr),!1)}function assignop(s,f,p){var x=infix(s,\"function\"==typeof f?f:function(left,that){return that.left=left,left&&checkLeftSideAssign(left,that,{allowDestructuring:!0})?(that.right=expression(10),that):(error(\"E031\",that),void 0)},p);return x.exps=!0,x.assign=!0,x}function bitwise(s,f,p){var x=symbol(s,p);return reserveName(x),x.led=\"function\"==typeof f?f:function(left){return state.option.bitwise&&warning(\"W016\",this,this.id),this.left=left,this.right=expression(p),this},x}function bitwiseassignop(s){return assignop(s,function(left,that){return state.option.bitwise&&warning(\"W016\",that,that.id),left&&checkLeftSideAssign(left,that)?(that.right=expression(10),that):(error(\"E031\",that),void 0)},20)}function suffix(s){var x=symbol(s,150);return x.led=function(left){return state.option.plusplus?warning(\"W016\",this,this.id):left.identifier&&!isReserved(left)||\".\"===left.id||\"[\"===left.id||warning(\"W017\",this),left.isMetaProperty?error(\"E031\",this):left&&left.identifier&&state.funct[\"(scope)\"].block.modify(left.value,left),this.left=left,this},x}function optionalidentifier(fnparam,prop,preserve){if(state.tokens.next.identifier){preserve||advance();var curr=state.tokens.curr,val=state.tokens.curr.value;return isReserved(curr)?prop&&state.inES5()?val:fnparam&&\"undefined\"===val?val:(warning(\"W024\",state.tokens.curr,state.tokens.curr.id),val):val}}function identifier(fnparam,prop){var i=optionalidentifier(fnparam,prop,!1);if(i)return i;if(\"...\"===state.tokens.next.value){if(state.inES6(!0)||warning(\"W119\",state.tokens.next,\"spread/rest operator\",\"6\"),advance(),checkPunctuator(state.tokens.next,\"...\"))for(warning(\"E024\",state.tokens.next,\"...\");checkPunctuator(state.tokens.next,\"...\");)advance();return state.tokens.next.identifier?identifier(fnparam,prop):(warning(\"E024\",state.tokens.curr,\"...\"),void 0)}error(\"E030\",state.tokens.next,state.tokens.next.value),\";\"!==state.tokens.next.id&&advance()}function reachable(controlToken){var t,i=0;if(\";\"===state.tokens.next.id&&!controlToken.inBracelessBlock)for(;;){do t=peek(i),i+=1;while(\"(end)\"!==t.id&&\"(comment)\"===t.id);if(t.reach)return;if(\"(endline)\"!==t.id){if(\"function\"===t.id){state.option.latedef===!0&&warning(\"W026\",t);break}warning(\"W027\",t,t.value,controlToken.value);break}}}function parseFinalSemicolon(){if(\";\"!==state.tokens.next.id){if(state.tokens.next.isUnclosed)return advance();var sameLine=startLine(state.tokens.next)===state.tokens.curr.line&&\"(end)\"!==state.tokens.next.id,blockEnd=checkPunctuator(state.tokens.next,\"}\");sameLine&&!blockEnd?errorAt(\"E058\",state.tokens.curr.line,state.tokens.curr.character):state.option.asi||(blockEnd&&!state.option.lastsemic||!sameLine)&&warningAt(\"W033\",state.tokens.curr.line,state.tokens.curr.character)}else advance(\";\")}function statement(){var r,i=indent,t=state.tokens.next,hasOwnScope=!1;if(\";\"===t.id)return advance(\";\"),void 0;var res=isReserved(t);if(res&&t.meta&&t.meta.isFutureReservedWord&&\":\"===peek().id&&(warning(\"W024\",t,t.id),res=!1),t.identifier&&!res&&\":\"===peek().id&&(advance(),advance(\":\"),hasOwnScope=!0,state.funct[\"(scope)\"].stack(),state.funct[\"(scope)\"].block.addBreakLabel(t.value,{token:state.tokens.curr}),state.tokens.next.labelled||\"{\"===state.tokens.next.value||warning(\"W028\",state.tokens.next,t.value,state.tokens.next.value),state.tokens.next.label=t.value,t=state.tokens.next),\"{\"===t.id){var iscase=\"case\"===state.funct[\"(verb)\"]&&\":\"===state.tokens.curr.value;return block(!0,!0,!1,!1,iscase),void 0}return r=expression(0,!0),!r||r.identifier&&\"function\"===r.value||\"(punctuator)\"===r.type&&r.left&&r.left.identifier&&\"function\"===r.left.value||state.isStrict()||\"global\"!==state.option.strict||warning(\"E007\"),t.block||(state.option.expr||r&&r.exps?state.option.nonew&&r&&r.left&&\"(\"===r.id&&\"new\"===r.left.id&&warning(\"W031\",t):warning(\"W030\",state.tokens.curr),parseFinalSemicolon()),indent=i,hasOwnScope&&state.funct[\"(scope)\"].unstack(),r}function statements(){for(var p,a=[];!state.tokens.next.reach&&\"(end)\"!==state.tokens.next.id;)\";\"===state.tokens.next.id?(p=peek(),(!p||\"(\"!==p.id&&\"[\"!==p.id)&&warning(\"W032\"),advance(\";\")):a.push(statement());return a}function directives(){for(var i,p,pn;\"(string)\"===state.tokens.next.id;){if(p=peek(0),\"(endline)\"===p.id){i=1;do pn=peek(i++);while(\"(endline)\"===pn.id);if(\";\"===pn.id)p=pn;else{if(\"[\"===pn.value||\".\"===pn.value)break;state.option.asi&&\"(\"!==pn.value||warning(\"W033\",state.tokens.next)}}else{if(\".\"===p.id||\"[\"===p.id)break;\";\"!==p.id&&warning(\"W033\",p)}advance();var directive=state.tokens.curr.value;(state.directive[directive]||\"use strict\"===directive&&\"implied\"===state.option.strict)&&warning(\"W034\",state.tokens.curr,directive),state.directive[directive]=!0,\";\"===p.id&&advance(\";\")}state.isStrict()&&(state.option[\"(explicitNewcap)\"]||(state.option.newcap=!0),state.option.undef=!0)}function block(ordinary,stmt,isfunc,isfatarrow,iscase){var a,m,t,line,d,b=inblock,old_indent=indent;inblock=ordinary,t=state.tokens.next;var metrics=state.funct[\"(metrics)\"];if(metrics.nestedBlockDepth+=1,metrics.verifyMaxNestedBlockDepthPerFunction(),\"{\"===state.tokens.next.id){if(advance(\"{\"),state.funct[\"(scope)\"].stack(),line=state.tokens.curr.line,\"}\"!==state.tokens.next.id){for(indent+=state.option.indent;!ordinary&&state.tokens.next.from>indent;)indent+=state.option.indent;if(isfunc){m={};for(d in state.directive)_.has(state.directive,d)&&(m[d]=state.directive[d]);directives(),state.option.strict&&state.funct[\"(context)\"][\"(global)\"]&&(m[\"use strict\"]||state.isStrict()||warning(\"E007\"))}a=statements(),metrics.statementCount+=a.length,indent-=state.option.indent}advance(\"}\",t),isfunc&&(state.funct[\"(scope)\"].validateParams(),m&&(state.directive=m)),state.funct[\"(scope)\"].unstack(),indent=old_indent}else if(ordinary)state.funct[\"(noblockscopedvar)\"]=\"for\"!==state.tokens.next.id,state.funct[\"(scope)\"].stack(),(!stmt||state.option.curly)&&warning(\"W116\",state.tokens.next,\"{\",state.tokens.next.value),state.tokens.next.inBracelessBlock=!0,indent+=state.option.indent,a=[statement()],indent-=state.option.indent,state.funct[\"(scope)\"].unstack(),delete state.funct[\"(noblockscopedvar)\"];else if(isfunc){if(state.funct[\"(scope)\"].stack(),m={},!stmt||isfatarrow||state.inMoz()||error(\"W118\",state.tokens.curr,\"function closure expressions\"),!stmt)for(d in state.directive)_.has(state.directive,d)&&(m[d]=state.directive[d]);expression(10),state.option.strict&&state.funct[\"(context)\"][\"(global)\"]&&(m[\"use strict\"]||state.isStrict()||warning(\"E007\")),state.funct[\"(scope)\"].unstack()}else error(\"E021\",state.tokens.next,\"{\",state.tokens.next.value);switch(state.funct[\"(verb)\"]){case\"break\":case\"continue\":case\"return\":case\"throw\":if(iscase)break;default:state.funct[\"(verb)\"]=null}return inblock=b,!ordinary||!state.option.noempty||a&&0!==a.length||warning(\"W035\",state.tokens.prev),metrics.nestedBlockDepth-=1,a}function countMember(m){membersOnly&&\"boolean\"!=typeof membersOnly[m]&&warning(\"W036\",state.tokens.curr,m),\"number\"==typeof member[m]?member[m]+=1:member[m]=1}function comprehensiveArrayExpression(){var res={};res.exps=!0,state.funct[\"(comparray)\"].stack();var reversed=!1;return\"for\"!==state.tokens.next.value&&(reversed=!0,state.inMoz()||warning(\"W116\",state.tokens.next,\"for\",state.tokens.next.value),state.funct[\"(comparray)\"].setState(\"use\"),res.right=expression(10)),advance(\"for\"),\"each\"===state.tokens.next.value&&(advance(\"each\"),state.inMoz()||warning(\"W118\",state.tokens.curr,\"for each\")),advance(\"(\"),state.funct[\"(comparray)\"].setState(\"define\"),res.left=expression(130),_.contains([\"in\",\"of\"],state.tokens.next.value)?advance():error(\"E045\",state.tokens.curr),state.funct[\"(comparray)\"].setState(\"generate\"),expression(10),advance(\")\"),\"if\"===state.tokens.next.value&&(advance(\"if\"),advance(\"(\"),state.funct[\"(comparray)\"].setState(\"filter\"),res.filter=expression(10),advance(\")\")),reversed||(state.funct[\"(comparray)\"].setState(\"use\"),res.right=expression(10)),advance(\"]\"),state.funct[\"(comparray)\"].unstack(),res}function isMethod(){return state.funct[\"(statement)\"]&&\"class\"===state.funct[\"(statement)\"].type||state.funct[\"(context)\"]&&\"class\"===state.funct[\"(context)\"][\"(verb)\"]}function isPropertyName(token){return token.identifier||\"(string)\"===token.id||\"(number)\"===token.id}function propertyName(preserveOrToken){var id,preserve=!0;return\"object\"==typeof preserveOrToken?id=preserveOrToken:(preserve=preserveOrToken,id=optionalidentifier(!1,!0,preserve)),id?\"object\"==typeof id&&(\"(string)\"===id.id||\"(identifier)\"===id.id?id=id.value:\"(number)\"===id.id&&(id=\"\"+id.value)):\"(string)\"===state.tokens.next.id?(id=state.tokens.next.value,preserve||advance()):\"(number)\"===state.tokens.next.id&&(id=\"\"+state.tokens.next.value,preserve||advance()),\"hasOwnProperty\"===id&&warning(\"W001\"),id}function functionparams(options){function addParam(addParamArgs){state.funct[\"(scope)\"].addParam.apply(state.funct[\"(scope)\"],addParamArgs)}var next,ident,t,paramsIds=[],tokens=[],pastDefault=!1,pastRest=!1,arity=0,loneArg=options&&options.loneArg;if(loneArg&&loneArg.identifier===!0)return state.funct[\"(scope)\"].addParam(loneArg.value,loneArg),{arity:1,params:[loneArg.value]};if(next=state.tokens.next,options&&options.parsedOpening||advance(\"(\"),\")\"===state.tokens.next.id)return advance(\")\"),void 0;for(;;){arity++;var currentParams=[];if(_.contains([\"{\",\"[\"],state.tokens.next.id)){tokens=destructuringPattern();for(t in tokens)t=tokens[t],t.id&&(paramsIds.push(t.id),currentParams.push([t.id,t.token]))}else if(checkPunctuator(state.tokens.next,\"...\")&&(pastRest=!0),ident=identifier(!0))paramsIds.push(ident),currentParams.push([ident,state.tokens.curr]);else for(;!checkPunctuators(state.tokens.next,[\",\",\")\"]);)advance();if(pastDefault&&\"=\"!==state.tokens.next.id&&error(\"W138\",state.tokens.current),\"=\"===state.tokens.next.id&&(state.inES6()||warning(\"W119\",state.tokens.next,\"default parameters\",\"6\"),advance(\"=\"),pastDefault=!0,expression(10)),currentParams.forEach(addParam),\",\"!==state.tokens.next.id)return advance(\")\",next),{arity:arity,params:paramsIds};pastRest&&warning(\"W131\",state.tokens.next),comma()}}function functor(name,token,overwrites){var funct={\"(name)\":name,\"(breakage)\":0,\"(loopage)\":0,\"(tokens)\":{},\"(properties)\":{},\"(catch)\":!1,\"(global)\":!1,\"(line)\":null,\"(character)\":null,\"(metrics)\":null,\"(statement)\":null,\"(context)\":null,\"(scope)\":null,\"(comparray)\":null,\"(generator)\":null,\"(arrow)\":null,\"(params)\":null};return token&&_.extend(funct,{\"(line)\":token.line,\"(character)\":token.character,\"(metrics)\":createMetrics(token)}),_.extend(funct,overwrites),funct[\"(context)\"]&&(funct[\"(scope)\"]=funct[\"(context)\"][\"(scope)\"],funct[\"(comparray)\"]=funct[\"(context)\"][\"(comparray)\"]),funct}function isFunctor(token){return\"(scope)\"in token}function hasParsedCode(funct){return funct[\"(global)\"]&&!funct[\"(verb)\"]}function doTemplateLiteral(left){function end(){if(state.tokens.curr.template&&state.tokens.curr.tail&&state.tokens.curr.context===ctx)return!0;var complete=state.tokens.next.template&&state.tokens.next.tail&&state.tokens.next.context===ctx;return complete&&advance(),complete||state.tokens.next.isUnclosed}var ctx=this.context,noSubst=this.noSubst,depth=this.depth;if(!noSubst)for(;!end();)!state.tokens.next.template||state.tokens.next.depth>depth?expression(0):advance();return{id:\"(template)\",type:\"(template)\",tag:left}}function doFunction(options){var f,token,name,statement,classExprBinding,isGenerator,isArrow,ignoreLoopFunc,oldOption=state.option,oldIgnored=state.ignored;options&&(name=options.name,statement=options.statement,classExprBinding=options.classExprBinding,isGenerator=\"generator\"===options.type,isArrow=\"arrow\"===options.type,ignoreLoopFunc=options.ignoreLoopFunc),state.option=Object.create(state.option),state.ignored=Object.create(state.ignored),state.funct=functor(name||state.nameStack.infer(),state.tokens.next,{\"(statement)\":statement,\"(context)\":state.funct,\"(arrow)\":isArrow,\"(generator)\":isGenerator}),f=state.funct,token=state.tokens.curr,token.funct=state.funct,functions.push(state.funct),state.funct[\"(scope)\"].stack(\"functionouter\");var internallyAccessibleName=name||classExprBinding;internallyAccessibleName&&state.funct[\"(scope)\"].block.add(internallyAccessibleName,classExprBinding?\"class\":\"function\",state.tokens.curr,!1),state.funct[\"(scope)\"].stack(\"functionparams\");var paramsInfo=functionparams(options);return paramsInfo?(state.funct[\"(params)\"]=paramsInfo.params,state.funct[\"(metrics)\"].arity=paramsInfo.arity,state.funct[\"(metrics)\"].verifyMaxParametersPerFunction()):state.funct[\"(metrics)\"].arity=0,isArrow&&(state.inES6(!0)||warning(\"W119\",state.tokens.curr,\"arrow function syntax (=>)\",\"6\"),options.loneArg||advance(\"=>\")),block(!1,!0,!0,isArrow),!state.option.noyield&&isGenerator&&\"yielded\"!==state.funct[\"(generator)\"]&&warning(\"W124\",state.tokens.curr),state.funct[\"(metrics)\"].verifyMaxStatementsPerFunction(),state.funct[\"(metrics)\"].verifyMaxComplexityPerFunction(),state.funct[\"(unusedOption)\"]=state.option.unused,state.option=oldOption,state.ignored=oldIgnored,state.funct[\"(last)\"]=state.tokens.curr.line,state.funct[\"(lastcharacter)\"]=state.tokens.curr.character,state.funct[\"(scope)\"].unstack(),state.funct[\"(scope)\"].unstack(),state.funct=state.funct[\"(context)\"],ignoreLoopFunc||state.option.loopfunc||!state.funct[\"(loopage)\"]||f[\"(isCapturing)\"]&&warning(\"W083\",token),f}function createMetrics(functionStartToken){return{statementCount:0,nestedBlockDepth:-1,ComplexityCount:1,arity:0,verifyMaxStatementsPerFunction:function(){state.option.maxstatements&&this.statementCount>state.option.maxstatements&&warning(\"W071\",functionStartToken,this.statementCount)\n},verifyMaxParametersPerFunction:function(){_.isNumber(state.option.maxparams)&&this.arity>state.option.maxparams&&warning(\"W072\",functionStartToken,this.arity)},verifyMaxNestedBlockDepthPerFunction:function(){state.option.maxdepth&&this.nestedBlockDepth>0&&this.nestedBlockDepth===state.option.maxdepth+1&&warning(\"W073\",null,this.nestedBlockDepth)},verifyMaxComplexityPerFunction:function(){var max=state.option.maxcomplexity,cc=this.ComplexityCount;max&&cc>max&&warning(\"W074\",functionStartToken,cc)}}}function increaseComplexityCount(){state.funct[\"(metrics)\"].ComplexityCount+=1}function checkCondAssignment(expr){var id,paren;switch(expr&&(id=expr.id,paren=expr.paren,\",\"===id&&(expr=expr.exprs[expr.exprs.length-1])&&(id=expr.id,paren=paren||expr.paren)),id){case\"=\":case\"+=\":case\"-=\":case\"*=\":case\"%=\":case\"&=\":case\"|=\":case\"^=\":case\"/=\":paren||state.option.boss||warning(\"W084\")}}function checkProperties(props){if(state.inES5())for(var name in props)props[name]&&props[name].setterToken&&!props[name].getterToken&&warning(\"W078\",props[name].setterToken)}function metaProperty(name,c){if(checkPunctuator(state.tokens.next,\".\")){var left=state.tokens.curr.id;advance(\".\");var id=identifier();return state.tokens.curr.isMetaProperty=!0,name!==id?error(\"E057\",state.tokens.prev,left,id):c(),state.tokens.curr}}function destructuringPattern(options){var isAssignment=options&&options.assignment;return state.inES6()||warning(\"W104\",state.tokens.curr,isAssignment?\"destructuring assignment\":\"destructuring binding\",\"6\"),destructuringPatternRecursive(options)}function destructuringPatternRecursive(options){var ids,identifiers=[],openingParsed=options&&options.openingParsed,isAssignment=options&&options.assignment,recursiveOptions=isAssignment?{assignment:isAssignment}:null,firstToken=openingParsed?state.tokens.curr:state.tokens.next,nextInnerDE=function(){var ident;if(checkPunctuators(state.tokens.next,[\"[\",\"{\"])){ids=destructuringPatternRecursive(recursiveOptions);for(var id in ids)id=ids[id],identifiers.push({id:id.id,token:id.token})}else if(checkPunctuator(state.tokens.next,\",\"))identifiers.push({id:null,token:state.tokens.curr});else{if(!checkPunctuator(state.tokens.next,\"(\")){var is_rest=checkPunctuator(state.tokens.next,\"...\");if(isAssignment){var identifierToken=is_rest?peek(0):state.tokens.next;identifierToken.identifier||warning(\"E030\",identifierToken,identifierToken.value);var assignTarget=expression(155);assignTarget&&(checkLeftSideAssign(assignTarget),assignTarget.identifier&&(ident=assignTarget.value))}else ident=identifier();return ident&&identifiers.push({id:ident,token:state.tokens.curr}),is_rest}advance(\"(\"),nextInnerDE(),advance(\")\")}return!1},assignmentProperty=function(){var id;checkPunctuator(state.tokens.next,\"[\")?(advance(\"[\"),expression(10),advance(\"]\"),advance(\":\"),nextInnerDE()):\"(string)\"===state.tokens.next.id||\"(number)\"===state.tokens.next.id?(advance(),advance(\":\"),nextInnerDE()):(id=identifier(),checkPunctuator(state.tokens.next,\":\")?(advance(\":\"),nextInnerDE()):id&&(isAssignment&&checkLeftSideAssign(state.tokens.curr),identifiers.push({id:id,token:state.tokens.curr})))};if(checkPunctuator(firstToken,\"[\")){openingParsed||advance(\"[\"),checkPunctuator(state.tokens.next,\"]\")&&warning(\"W137\",state.tokens.curr);for(var element_after_rest=!1;!checkPunctuator(state.tokens.next,\"]\");)nextInnerDE()&&!element_after_rest&&checkPunctuator(state.tokens.next,\",\")&&(warning(\"W130\",state.tokens.next),element_after_rest=!0),checkPunctuator(state.tokens.next,\"=\")&&(checkPunctuator(state.tokens.prev,\"...\")?advance(\"]\"):advance(\"=\"),\"undefined\"===state.tokens.next.id&&warning(\"W080\",state.tokens.prev,state.tokens.prev.value),expression(10)),checkPunctuator(state.tokens.next,\"]\")||advance(\",\");advance(\"]\")}else if(checkPunctuator(firstToken,\"{\")){for(openingParsed||advance(\"{\"),checkPunctuator(state.tokens.next,\"}\")&&warning(\"W137\",state.tokens.curr);!checkPunctuator(state.tokens.next,\"}\")&&(assignmentProperty(),checkPunctuator(state.tokens.next,\"=\")&&(advance(\"=\"),\"undefined\"===state.tokens.next.id&&warning(\"W080\",state.tokens.prev,state.tokens.prev.value),expression(10)),checkPunctuator(state.tokens.next,\"}\")||(advance(\",\"),!checkPunctuator(state.tokens.next,\"}\"))););advance(\"}\")}return identifiers}function destructuringPatternMatch(tokens,value){var first=value.first;first&&_.zip(tokens,Array.isArray(first)?first:[first]).forEach(function(val){var token=val[0],value=val[1];token&&value?token.first=value:token&&token.first&&!value&&warning(\"W080\",token.first,token.first.value)})}function blockVariableStatement(type,statement,context){var tokens,lone,value,letblock,prefix=context&&context.prefix,inexport=context&&context.inexport,isLet=\"let\"===type,isConst=\"const\"===type;for(state.inES6()||warning(\"W104\",state.tokens.curr,type,\"6\"),isLet&&\"(\"===state.tokens.next.value?(state.inMoz()||warning(\"W118\",state.tokens.next,\"let block\"),advance(\"(\"),state.funct[\"(scope)\"].stack(),letblock=!0):state.funct[\"(noblockscopedvar)\"]&&error(\"E048\",state.tokens.curr,isConst?\"Const\":\"Let\"),statement.first=[];;){var names=[];_.contains([\"{\",\"[\"],state.tokens.next.value)?(tokens=destructuringPattern(),lone=!1):(tokens=[{id:identifier(),token:state.tokens.curr}],lone=!0),!prefix&&isConst&&\"=\"!==state.tokens.next.id&&warning(\"E012\",state.tokens.curr,state.tokens.curr.value);for(var t in tokens)tokens.hasOwnProperty(t)&&(t=tokens[t],state.funct[\"(scope)\"].block.isGlobal()&&predefined[t.id]===!1&&warning(\"W079\",t.token,t.id),t.id&&!state.funct[\"(noblockscopedvar)\"]&&(state.funct[\"(scope)\"].addlabel(t.id,{type:type,token:t.token}),names.push(t.token),lone&&inexport&&state.funct[\"(scope)\"].setExported(t.token.value,t.token)));if(\"=\"===state.tokens.next.id&&(advance(\"=\"),prefix||\"undefined\"!==state.tokens.next.id||warning(\"W080\",state.tokens.prev,state.tokens.prev.value),!prefix&&\"=\"===peek(0).id&&state.tokens.next.identifier&&warning(\"W120\",state.tokens.next,state.tokens.next.value),value=expression(prefix?120:10),lone?tokens[0].first=value:destructuringPatternMatch(names,value)),statement.first=statement.first.concat(names),\",\"!==state.tokens.next.id)break;comma()}return letblock&&(advance(\")\"),block(!0,!0),statement.block=!0,state.funct[\"(scope)\"].unstack()),statement}function classdef(isStatement){return state.inES6()||warning(\"W104\",state.tokens.curr,\"class\",\"6\"),isStatement?(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"class\",token:state.tokens.curr})):state.tokens.next.identifier&&\"extends\"!==state.tokens.next.value?(this.name=identifier(),this.namedExpr=!0):this.name=state.nameStack.infer(),classtail(this),this}function classtail(c){var wasInClassBody=state.inClassBody;\"extends\"===state.tokens.next.value&&(advance(\"extends\"),c.heritage=expression(10)),state.inClassBody=!0,advance(\"{\"),c.body=classbody(c),advance(\"}\"),state.inClassBody=wasInClassBody}function classbody(c){for(var name,isStatic,isGenerator,getset,computed,props=Object.create(null),staticProps=Object.create(null),i=0;\"}\"!==state.tokens.next.id;++i)if(name=state.tokens.next,isStatic=!1,isGenerator=!1,getset=null,\";\"!==name.id){if(\"*\"===name.id&&(isGenerator=!0,advance(\"*\"),name=state.tokens.next),\"[\"===name.id)name=computedPropertyName(),computed=!0;else{if(!isPropertyName(name)){warning(\"W052\",state.tokens.next,state.tokens.next.value||state.tokens.next.type),advance();continue}advance(),computed=!1,name.identifier&&\"static\"===name.value&&(checkPunctuator(state.tokens.next,\"*\")&&(isGenerator=!0,advance(\"*\")),(isPropertyName(state.tokens.next)||\"[\"===state.tokens.next.id)&&(computed=\"[\"===state.tokens.next.id,isStatic=!0,name=state.tokens.next,\"[\"===state.tokens.next.id?name=computedPropertyName():advance())),!name.identifier||\"get\"!==name.value&&\"set\"!==name.value||(isPropertyName(state.tokens.next)||\"[\"===state.tokens.next.id)&&(computed=\"[\"===state.tokens.next.id,getset=name,name=state.tokens.next,\"[\"===state.tokens.next.id?name=computedPropertyName():advance())}if(!checkPunctuator(state.tokens.next,\"(\")){for(error(\"E054\",state.tokens.next,state.tokens.next.value);\"}\"!==state.tokens.next.id&&!checkPunctuator(state.tokens.next,\"(\");)advance();\"(\"!==state.tokens.next.value&&doFunction({statement:c})}if(computed||(getset?saveAccessor(getset.value,isStatic?staticProps:props,name.value,name,!0,isStatic):(\"constructor\"===name.value?state.nameStack.set(c):state.nameStack.set(name),saveProperty(isStatic?staticProps:props,name.value,name,!0,isStatic))),getset&&\"constructor\"===name.value){var propDesc=\"get\"===getset.value?\"class getter method\":\"class setter method\";error(\"E049\",name,propDesc,\"constructor\")}else\"prototype\"===name.value&&error(\"E049\",name,\"class method\",\"prototype\");propertyName(name),doFunction({statement:c,type:isGenerator?\"generator\":null,classExprBinding:c.namedExpr?c.name:null})}else warning(\"W032\"),advance(\";\");checkProperties(props)}function saveProperty(props,name,tkn,isClass,isStatic){var msg=[\"key\",\"class method\",\"static class method\"];msg=msg[(isClass||!1)+(isStatic||!1)],tkn.identifier&&(name=tkn.value),props[name]&&\"__proto__\"!==name?warning(\"W075\",state.tokens.next,msg,name):props[name]=Object.create(null),props[name].basic=!0,props[name].basictkn=tkn}function saveAccessor(accessorType,props,name,tkn,isClass,isStatic){var flagName=\"get\"===accessorType?\"getterToken\":\"setterToken\",msg=\"\";isClass?(isStatic&&(msg+=\"static \"),msg+=accessorType+\"ter method\"):msg=\"key\",state.tokens.curr.accessorType=accessorType,state.nameStack.set(tkn),props[name]?(props[name].basic||props[name][flagName])&&\"__proto__\"!==name&&warning(\"W075\",state.tokens.next,msg,name):props[name]=Object.create(null),props[name][flagName]=tkn}function computedPropertyName(){advance(\"[\"),state.inES6()||warning(\"W119\",state.tokens.curr,\"computed property names\",\"6\");var value=expression(10);return advance(\"]\"),value}function checkPunctuators(token,values){return\"(punctuator)\"===token.type?_.contains(values,token.value):!1}function checkPunctuator(token,value){return\"(punctuator)\"===token.type&&token.value===value}function destructuringAssignOrJsonValue(){var block=lookupBlockType();block.notJson?(!state.inES6()&&block.isDestAssign&&warning(\"W104\",state.tokens.curr,\"destructuring assignment\",\"6\"),statements()):(state.option.laxbreak=!0,state.jsonMode=!0,jsonValue())}function jsonValue(){function jsonObject(){var o={},t=state.tokens.next;if(advance(\"{\"),\"}\"!==state.tokens.next.id)for(;;){if(\"(end)\"===state.tokens.next.id)error(\"E026\",state.tokens.next,t.line);else{if(\"}\"===state.tokens.next.id){warning(\"W094\",state.tokens.curr);break}\",\"===state.tokens.next.id?error(\"E028\",state.tokens.next):\"(string)\"!==state.tokens.next.id&&warning(\"W095\",state.tokens.next,state.tokens.next.value)}if(o[state.tokens.next.value]===!0?warning(\"W075\",state.tokens.next,\"key\",state.tokens.next.value):\"__proto__\"===state.tokens.next.value&&!state.option.proto||\"__iterator__\"===state.tokens.next.value&&!state.option.iterator?warning(\"W096\",state.tokens.next,state.tokens.next.value):o[state.tokens.next.value]=!0,advance(),advance(\":\"),jsonValue(),\",\"!==state.tokens.next.id)break;advance(\",\")}advance(\"}\")}function jsonArray(){var t=state.tokens.next;if(advance(\"[\"),\"]\"!==state.tokens.next.id)for(;;){if(\"(end)\"===state.tokens.next.id)error(\"E027\",state.tokens.next,t.line);else{if(\"]\"===state.tokens.next.id){warning(\"W094\",state.tokens.curr);break}\",\"===state.tokens.next.id&&error(\"E028\",state.tokens.next)}if(jsonValue(),\",\"!==state.tokens.next.id)break;advance(\",\")}advance(\"]\")}switch(state.tokens.next.id){case\"{\":jsonObject();break;case\"[\":jsonArray();break;case\"true\":case\"false\":case\"null\":case\"(number)\":case\"(string)\":advance();break;case\"-\":advance(\"-\"),advance(\"(number)\");break;default:error(\"E003\",state.tokens.next)}}var api,declared,functions,inblock,indent,lookahead,lex,member,membersOnly,predefined,stack,urls,bang={\"<\":!0,\"<=\":!0,\"==\":!0,\"===\":!0,\"!==\":!0,\"!=\":!0,\">\":!0,\">=\":!0,\"+\":!0,\"-\":!0,\"*\":!0,\"/\":!0,\"%\":!0},functionicity=[\"closure\",\"exception\",\"global\",\"label\",\"outer\",\"unused\",\"var\"],extraModules=[],emitter=new events.EventEmitter,typeofValues={};typeofValues.legacy=[\"xml\",\"unknown\"],typeofValues.es3=[\"undefined\",\"boolean\",\"number\",\"string\",\"function\",\"object\"],typeofValues.es3=typeofValues.es3.concat(typeofValues.legacy),typeofValues.es6=typeofValues.es3.concat(\"symbol\"),type(\"(number)\",function(){return this}),type(\"(string)\",function(){return this}),state.syntax[\"(identifier)\"]={type:\"(identifier)\",lbp:0,identifier:!0,nud:function(){var v=this.value;return\"=>\"===state.tokens.next.id?this:(state.funct[\"(comparray)\"].check(v)||state.funct[\"(scope)\"].block.use(v,state.tokens.curr),this)},led:function(){error(\"E033\",state.tokens.next,state.tokens.next.value)}};var baseTemplateSyntax={lbp:0,identifier:!1,template:!0};state.syntax[\"(template)\"]=_.extend({type:\"(template)\",nud:doTemplateLiteral,led:doTemplateLiteral,noSubst:!1},baseTemplateSyntax),state.syntax[\"(template middle)\"]=_.extend({type:\"(template middle)\",middle:!0,noSubst:!1},baseTemplateSyntax),state.syntax[\"(template tail)\"]=_.extend({type:\"(template tail)\",tail:!0,noSubst:!1},baseTemplateSyntax),state.syntax[\"(no subst template)\"]=_.extend({type:\"(template)\",nud:doTemplateLiteral,led:doTemplateLiteral,noSubst:!0,tail:!0},baseTemplateSyntax),type(\"(regexp)\",function(){return this}),delim(\"(endline)\"),delim(\"(begin)\"),delim(\"(end)\").reach=!0,delim(\"(error)\").reach=!0,delim(\"}\").reach=!0,delim(\")\"),delim(\"]\"),delim('\"').reach=!0,delim(\"'\").reach=!0,delim(\";\"),delim(\":\").reach=!0,delim(\"#\"),reserve(\"else\"),reserve(\"case\").reach=!0,reserve(\"catch\"),reserve(\"default\").reach=!0,reserve(\"finally\"),reservevar(\"arguments\",function(x){state.isStrict()&&state.funct[\"(global)\"]&&warning(\"E008\",x)}),reservevar(\"eval\"),reservevar(\"false\"),reservevar(\"Infinity\"),reservevar(\"null\"),reservevar(\"this\",function(x){state.isStrict()&&!isMethod()&&!state.option.validthis&&(state.funct[\"(statement)\"]&&state.funct[\"(name)\"].charAt(0)>\"Z\"||state.funct[\"(global)\"])&&warning(\"W040\",x)}),reservevar(\"true\"),reservevar(\"undefined\"),assignop(\"=\",\"assign\",20),assignop(\"+=\",\"assignadd\",20),assignop(\"-=\",\"assignsub\",20),assignop(\"*=\",\"assignmult\",20),assignop(\"/=\",\"assigndiv\",20).nud=function(){error(\"E014\")},assignop(\"%=\",\"assignmod\",20),bitwiseassignop(\"&=\"),bitwiseassignop(\"|=\"),bitwiseassignop(\"^=\"),bitwiseassignop(\"<<=\"),bitwiseassignop(\">>=\"),bitwiseassignop(\">>>=\"),infix(\",\",function(left,that){var expr;if(that.exprs=[left],state.option.nocomma&&warning(\"W127\"),!comma({peek:!0}))return that;for(;;){if(!(expr=expression(10)))break;if(that.exprs.push(expr),\",\"!==state.tokens.next.value||!comma())break}return that},10,!0),infix(\"?\",function(left,that){return increaseComplexityCount(),that.left=left,that.right=expression(10),advance(\":\"),that[\"else\"]=expression(10),that},30);var orPrecendence=40;infix(\"||\",function(left,that){return increaseComplexityCount(),that.left=left,that.right=expression(orPrecendence),that},orPrecendence),infix(\"&&\",\"and\",50),bitwise(\"|\",\"bitor\",70),bitwise(\"^\",\"bitxor\",80),bitwise(\"&\",\"bitand\",90),relation(\"==\",function(left,right){var eqnull=state.option.eqnull&&(\"null\"===(left&&left.value)||\"null\"===(right&&right.value));switch(!0){case!eqnull&&state.option.eqeqeq:this.from=this.character,warning(\"W116\",this,\"===\",\"==\");break;case isPoorRelation(left):warning(\"W041\",this,\"===\",left.value);break;case isPoorRelation(right):warning(\"W041\",this,\"===\",right.value);break;case isTypoTypeof(right,left,state):warning(\"W122\",this,right.value);break;case isTypoTypeof(left,right,state):warning(\"W122\",this,left.value)}return this}),relation(\"===\",function(left,right){return isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"!=\",function(left,right){var eqnull=state.option.eqnull&&(\"null\"===(left&&left.value)||\"null\"===(right&&right.value));return!eqnull&&state.option.eqeqeq?(this.from=this.character,warning(\"W116\",this,\"!==\",\"!=\")):isPoorRelation(left)?warning(\"W041\",this,\"!==\",left.value):isPoorRelation(right)?warning(\"W041\",this,\"!==\",right.value):isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"!==\",function(left,right){return isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"<\"),relation(\">\"),relation(\"<=\"),relation(\">=\"),bitwise(\"<<\",\"shiftleft\",120),bitwise(\">>\",\"shiftright\",120),bitwise(\">>>\",\"shiftrightunsigned\",120),infix(\"in\",\"in\",120),infix(\"instanceof\",\"instanceof\",120),infix(\"+\",function(left,that){var right;return that.left=left,that.right=right=expression(130),left&&right&&\"(string)\"===left.id&&\"(string)\"===right.id?(left.value+=right.value,left.character=right.character,!state.option.scripturl&&reg.javascriptURL.test(left.value)&&warning(\"W050\",left),left):that},130),prefix(\"+\",\"num\"),prefix(\"+++\",function(){return warning(\"W007\"),this.arity=\"unary\",this.right=expression(150),this}),infix(\"+++\",function(left){return warning(\"W007\"),this.left=left,this.right=expression(130),this},130),infix(\"-\",\"sub\",130),prefix(\"-\",\"neg\"),prefix(\"---\",function(){return warning(\"W006\"),this.arity=\"unary\",this.right=expression(150),this}),infix(\"---\",function(left){return warning(\"W006\"),this.left=left,this.right=expression(130),this},130),infix(\"*\",\"mult\",140),infix(\"/\",\"div\",140),infix(\"%\",\"mod\",140),suffix(\"++\"),prefix(\"++\",\"preinc\"),state.syntax[\"++\"].exps=!0,suffix(\"--\"),prefix(\"--\",\"predec\"),state.syntax[\"--\"].exps=!0,prefix(\"delete\",function(){var p=expression(10);return p?(\".\"!==p.id&&\"[\"!==p.id&&warning(\"W051\"),this.first=p,p.identifier&&!state.isStrict()&&(p.forgiveUndef=!0),this):this}).exps=!0,prefix(\"~\",function(){return state.option.bitwise&&warning(\"W016\",this,\"~\"),this.arity=\"unary\",this.right=expression(150),this}),prefix(\"...\",function(){return state.inES6(!0)||warning(\"W119\",this,\"spread/rest operator\",\"6\"),state.tokens.next.identifier||\"(string)\"===state.tokens.next.type||checkPunctuators(state.tokens.next,[\"[\",\"(\"])||error(\"E030\",state.tokens.next,state.tokens.next.value),expression(150),this}),prefix(\"!\",function(){return this.arity=\"unary\",this.right=expression(150),this.right||quit(\"E041\",this.line||0),bang[this.right.id]===!0&&warning(\"W018\",this,\"!\"),this}),prefix(\"typeof\",function(){var p=expression(150);return this.first=this.right=p,p||quit(\"E041\",this.line||0,this.character||0),p.identifier&&(p.forgiveUndef=!0),this}),prefix(\"new\",function(){var mp=metaProperty(\"target\",function(){state.inES6(!0)||warning(\"W119\",state.tokens.prev,\"new.target\",\"6\");for(var inFunction,c=state.funct;c&&(inFunction=!c[\"(global)\"],c[\"(arrow)\"]);)c=c[\"(context)\"];inFunction||warning(\"W136\",state.tokens.prev,\"new.target\")});if(mp)return mp;var i,c=expression(155);if(c&&\"function\"!==c.id)if(c.identifier)switch(c[\"new\"]=!0,c.value){case\"Number\":case\"String\":case\"Boolean\":case\"Math\":case\"JSON\":warning(\"W053\",state.tokens.prev,c.value);break;case\"Symbol\":state.inES6()&&warning(\"W053\",state.tokens.prev,c.value);break;case\"Function\":state.option.evil||warning(\"W054\");break;case\"Date\":case\"RegExp\":case\"this\":break;default:\"function\"!==c.id&&(i=c.value.substr(0,1),state.option.newcap&&(\"A\">i||i>\"Z\")&&!state.funct[\"(scope)\"].isPredefined(c.value)&&warning(\"W055\",state.tokens.curr))}else\".\"!==c.id&&\"[\"!==c.id&&\"(\"!==c.id&&warning(\"W056\",state.tokens.curr);else state.option.supernew||warning(\"W057\",this);return\"(\"===state.tokens.next.id||state.option.supernew||warning(\"W058\",state.tokens.curr,state.tokens.curr.value),this.first=this.right=c,this}),state.syntax[\"new\"].exps=!0,prefix(\"void\").exps=!0,infix(\".\",function(left,that){var m=identifier(!1,!0);return\"string\"==typeof m&&countMember(m),that.left=left,that.right=m,m&&\"hasOwnProperty\"===m&&\"=\"===state.tokens.next.value&&warning(\"W001\"),!left||\"arguments\"!==left.value||\"callee\"!==m&&\"caller\"!==m?state.option.evil||!left||\"document\"!==left.value||\"write\"!==m&&\"writeln\"!==m||warning(\"W060\",left):state.option.noarg?warning(\"W059\",left,m):state.isStrict()&&error(\"E008\"),state.option.evil||\"eval\"!==m&&\"execScript\"!==m||isGlobalEval(left,state)&&warning(\"W061\"),that},160,!0),infix(\"(\",function(left,that){state.option.immed&&left&&!left.immed&&\"function\"===left.id&&warning(\"W062\");var n=0,p=[];if(left&&\"(identifier)\"===left.type&&left.value.match(/^[A-Z]([A-Z0-9_$]*[a-z][A-Za-z0-9_$]*)?$/)&&-1===\"Array Number String Boolean Date Object Error Symbol\".indexOf(left.value)&&(\"Math\"===left.value?warning(\"W063\",left):state.option.newcap&&warning(\"W064\",left)),\")\"!==state.tokens.next.id)for(;p[p.length]=expression(10),n+=1,\",\"===state.tokens.next.id;)comma();return advance(\")\"),\"object\"==typeof left&&(state.inES5()||\"parseInt\"!==left.value||1!==n||warning(\"W065\",state.tokens.curr),state.option.evil||(\"eval\"===left.value||\"Function\"===left.value||\"execScript\"===left.value?(warning(\"W061\",left),p[0]&&\"(string)\"===[0].id&&addInternalSrc(left,p[0].value)):!p[0]||\"(string)\"!==p[0].id||\"setTimeout\"!==left.value&&\"setInterval\"!==left.value?!p[0]||\"(string)\"!==p[0].id||\".\"!==left.value||\"window\"!==left.left.value||\"setTimeout\"!==left.right&&\"setInterval\"!==left.right||(warning(\"W066\",left),addInternalSrc(left,p[0].value)):(warning(\"W066\",left),addInternalSrc(left,p[0].value))),left.identifier||\".\"===left.id||\"[\"===left.id||\"=>\"===left.id||\"(\"===left.id||\"&&\"===left.id||\"||\"===left.id||\"?\"===left.id||state.inES6()&&left[\"(name)\"]||warning(\"W067\",that)),that.left=left,that},155,!0).exps=!0,prefix(\"(\",function(){var pn1,ret,triggerFnExpr,first,last,pn=state.tokens.next,i=-1,parens=1,opening=state.tokens.curr,preceeding=state.tokens.prev,isNecessary=!state.option.singleGroups;do\"(\"===pn.value?parens+=1:\")\"===pn.value&&(parens-=1),i+=1,pn1=pn,pn=peek(i);while((0!==parens||\")\"!==pn1.value)&&\";\"!==pn.value&&\"(end)\"!==pn.type);if(\"function\"===state.tokens.next.id&&(triggerFnExpr=state.tokens.next.immed=!0),\"=>\"===pn.value)return doFunction({type:\"arrow\",parsedOpening:!0});var exprs=[];if(\")\"!==state.tokens.next.id)for(;exprs.push(expression(10)),\",\"===state.tokens.next.id;)state.option.nocomma&&warning(\"W127\"),comma();return advance(\")\",this),state.option.immed&&exprs[0]&&\"function\"===exprs[0].id&&\"(\"!==state.tokens.next.id&&\".\"!==state.tokens.next.id&&\"[\"!==state.tokens.next.id&&warning(\"W068\",this),exprs.length?(exprs.length>1?(ret=Object.create(state.syntax[\",\"]),ret.exprs=exprs,first=exprs[0],last=exprs[exprs.length-1],isNecessary||(isNecessary=preceeding.assign||preceeding.delim)):(ret=first=last=exprs[0],isNecessary||(isNecessary=opening.beginsStmt&&(\"{\"===ret.id||triggerFnExpr||isFunctor(ret))||triggerFnExpr&&(!isEndOfExpr()||\"}\"!==state.tokens.prev.id)||isFunctor(ret)&&!isEndOfExpr()||\"{\"===ret.id&&\"=>\"===preceeding.id||\"(number)\"===ret.type&&checkPunctuator(pn,\".\")&&/^\\d+$/.test(ret.value))),ret&&(!isNecessary&&(first.left||first.right||ret.exprs)&&(isNecessary=!isBeginOfExpr(preceeding)&&first.lbp<=preceeding.lbp||!isEndOfExpr()&&last.lbp<state.tokens.next.lbp),isNecessary||warning(\"W126\",opening),ret.paren=!0),ret):void 0}),application(\"=>\"),infix(\"[\",function(left,that){var s,e=expression(10);return e&&\"(string)\"===e.type&&(state.option.evil||\"eval\"!==e.value&&\"execScript\"!==e.value||isGlobalEval(left,state)&&warning(\"W061\"),countMember(e.value),!state.option.sub&&reg.identifier.test(e.value)&&(s=state.syntax[e.value],s&&isReserved(s)||warning(\"W069\",state.tokens.prev,e.value))),advance(\"]\",that),e&&\"hasOwnProperty\"===e.value&&\"=\"===state.tokens.next.value&&warning(\"W001\"),that.left=left,that.right=e,that},160,!0),prefix(\"[\",function(){var blocktype=lookupBlockType();if(blocktype.isCompArray)return state.option.esnext||state.inMoz()||warning(\"W118\",state.tokens.curr,\"array comprehension\"),comprehensiveArrayExpression();if(blocktype.isDestAssign)return this.destructAssign=destructuringPattern({openingParsed:!0,assignment:!0}),this;var b=state.tokens.curr.line!==startLine(state.tokens.next);for(this.first=[],b&&(indent+=state.option.indent,state.tokens.next.from===indent+state.option.indent&&(indent+=state.option.indent));\"(end)\"!==state.tokens.next.id;){for(;\",\"===state.tokens.next.id;){if(!state.option.elision){if(state.inES5()){warning(\"W128\");do advance(\",\");while(\",\"===state.tokens.next.id);continue}warning(\"W070\")}advance(\",\")}if(\"]\"===state.tokens.next.id)break;if(this.first.push(expression(10)),\",\"!==state.tokens.next.id)break;if(comma({allowTrailing:!0}),\"]\"===state.tokens.next.id&&!state.inES5()){warning(\"W070\",state.tokens.curr);break}}return b&&(indent-=state.option.indent),advance(\"]\",this),this}),function(x){x.nud=function(){var b,f,i,p,t,nextVal,isGeneratorMethod=!1,props=Object.create(null);b=state.tokens.curr.line!==startLine(state.tokens.next),b&&(indent+=state.option.indent,state.tokens.next.from===indent+state.option.indent&&(indent+=state.option.indent));var blocktype=lookupBlockType();if(blocktype.isDestAssign)return this.destructAssign=destructuringPattern({openingParsed:!0,assignment:!0}),this;for(;\"}\"!==state.tokens.next.id;){if(nextVal=state.tokens.next.value,!state.tokens.next.identifier||\",\"!==peekIgnoreEOL().id&&\"}\"!==peekIgnoreEOL().id)if(\":\"===peek().id||\"get\"!==nextVal&&\"set\"!==nextVal){if(\"*\"===state.tokens.next.value&&\"(punctuator)\"===state.tokens.next.type?(state.inES6()||warning(\"W104\",state.tokens.next,\"generator functions\",\"6\"),advance(\"*\"),isGeneratorMethod=!0):isGeneratorMethod=!1,\"[\"===state.tokens.next.id)i=computedPropertyName(),state.nameStack.set(i);else if(state.nameStack.set(state.tokens.next),i=propertyName(),saveProperty(props,i,state.tokens.next),\"string\"!=typeof i)break;\"(\"===state.tokens.next.value?(state.inES6()||warning(\"W104\",state.tokens.curr,\"concise methods\",\"6\"),doFunction({type:isGeneratorMethod?\"generator\":null})):(advance(\":\"),expression(10))}else advance(nextVal),state.inES5()||error(\"E034\"),i=propertyName(),i||state.inES6()||error(\"E035\"),i&&saveAccessor(nextVal,props,i,state.tokens.curr),t=state.tokens.next,f=doFunction(),p=f[\"(params)\"],\"get\"===nextVal&&i&&p?warning(\"W076\",t,p[0],i):\"set\"!==nextVal||!i||p&&1===p.length||warning(\"W077\",t,i);else state.inES6()||warning(\"W104\",state.tokens.next,\"object short notation\",\"6\"),i=propertyName(!0),saveProperty(props,i,state.tokens.next),expression(10);if(countMember(i),\",\"!==state.tokens.next.id)break;comma({allowTrailing:!0,property:!0}),\",\"===state.tokens.next.id?warning(\"W070\",state.tokens.curr):\"}\"!==state.tokens.next.id||state.inES5()||warning(\"W070\",state.tokens.curr)}return b&&(indent-=state.option.indent),advance(\"}\",this),checkProperties(props),this},x.fud=function(){error(\"E036\",state.tokens.curr)}}(delim(\"{\"));var conststatement=stmt(\"const\",function(context){return blockVariableStatement(\"const\",this,context)});conststatement.exps=!0;var letstatement=stmt(\"let\",function(context){return blockVariableStatement(\"let\",this,context)});letstatement.exps=!0;var varstatement=stmt(\"var\",function(context){var tokens,lone,value,prefix=context&&context.prefix,inexport=context&&context.inexport,implied=context&&context.implied,report=!(context&&context.ignore);for(this.first=[];;){var names=[];_.contains([\"{\",\"[\"],state.tokens.next.value)?(tokens=destructuringPattern(),lone=!1):(tokens=[{id:identifier(),token:state.tokens.curr}],lone=!0),prefix&&implied||!report||!state.option.varstmt||warning(\"W132\",this),this.first=this.first.concat(names);for(var t in tokens)tokens.hasOwnProperty(t)&&(t=tokens[t],!implied&&state.funct[\"(global)\"]&&(predefined[t.id]===!1?warning(\"W079\",t.token,t.id):state.option.futurehostile===!1&&(!state.inES5()&&vars.ecmaIdentifiers[5][t.id]===!1||!state.inES6()&&vars.ecmaIdentifiers[6][t.id]===!1)&&warning(\"W129\",t.token,t.id)),t.id&&(\"for\"===implied?(state.funct[\"(scope)\"].has(t.id)||report&&warning(\"W088\",t.token,t.id),state.funct[\"(scope)\"].block.use(t.id,t.token)):(state.funct[\"(scope)\"].addlabel(t.id,{type:\"var\",token:t.token}),lone&&inexport&&state.funct[\"(scope)\"].setExported(t.id,t.token)),names.push(t.token)));if(\"=\"===state.tokens.next.id&&(state.nameStack.set(state.tokens.curr),advance(\"=\"),prefix||!report||state.funct[\"(loopage)\"]||\"undefined\"!==state.tokens.next.id||warning(\"W080\",state.tokens.prev,state.tokens.prev.value),\"=\"===peek(0).id&&state.tokens.next.identifier&&(!prefix&&report&&!state.funct[\"(params)\"]||-1===state.funct[\"(params)\"].indexOf(state.tokens.next.value))&&warning(\"W120\",state.tokens.next,state.tokens.next.value),value=expression(prefix?120:10),lone?tokens[0].first=value:destructuringPatternMatch(names,value)),\",\"!==state.tokens.next.id)break;comma()}return this});varstatement.exps=!0,blockstmt(\"class\",function(){return classdef.call(this,!0)}),blockstmt(\"function\",function(context){var inexport=context&&context.inexport,generator=!1;\"*\"===state.tokens.next.value&&(advance(\"*\"),state.inES6({strict:!0})?generator=!0:warning(\"W119\",state.tokens.curr,\"function*\",\"6\")),inblock&&warning(\"W082\",state.tokens.curr);var i=optionalidentifier();return state.funct[\"(scope)\"].addlabel(i,{type:\"function\",token:state.tokens.curr}),void 0===i?warning(\"W025\"):inexport&&state.funct[\"(scope)\"].setExported(i,state.tokens.prev),doFunction({name:i,statement:this,type:generator?\"generator\":null,ignoreLoopFunc:inblock}),\"(\"===state.tokens.next.id&&state.tokens.next.line===state.tokens.curr.line&&error(\"E039\"),this}),prefix(\"function\",function(){var generator=!1;\"*\"===state.tokens.next.value&&(state.inES6()||warning(\"W119\",state.tokens.curr,\"function*\",\"6\"),advance(\"*\"),generator=!0);var i=optionalidentifier();return doFunction({name:i,type:generator?\"generator\":null}),this}),blockstmt(\"if\",function(){var t=state.tokens.next;increaseComplexityCount(),state.condition=!0,advance(\"(\");var expr=expression(0);checkCondAssignment(expr);var forinifcheck=null;state.option.forin&&state.forinifcheckneeded&&(state.forinifcheckneeded=!1,forinifcheck=state.forinifchecks[state.forinifchecks.length-1],forinifcheck.type=\"(punctuator)\"===expr.type&&\"!\"===expr.value?\"(negative)\":\"(positive)\"),advance(\")\",t),state.condition=!1;var s=block(!0,!0);return forinifcheck&&\"(negative)\"===forinifcheck.type&&s&&s[0]&&\"(identifier)\"===s[0].type&&\"continue\"===s[0].value&&(forinifcheck.type=\"(negative-with-continue)\"),\"else\"===state.tokens.next.id&&(advance(\"else\"),\"if\"===state.tokens.next.id||\"switch\"===state.tokens.next.id?statement():block(!0,!0)),this}),blockstmt(\"try\",function(){function doCatch(){if(advance(\"catch\"),advance(\"(\"),state.funct[\"(scope)\"].stack(\"catchparams\"),checkPunctuators(state.tokens.next,[\"[\",\"{\"])){var tokens=destructuringPattern();_.each(tokens,function(token){token.id&&state.funct[\"(scope)\"].addParam(token.id,token,\"exception\")})}else\"(identifier)\"!==state.tokens.next.type?warning(\"E030\",state.tokens.next,state.tokens.next.value):state.funct[\"(scope)\"].addParam(identifier(),state.tokens.curr,\"exception\");\"if\"===state.tokens.next.value&&(state.inMoz()||warning(\"W118\",state.tokens.curr,\"catch filter\"),advance(\"if\"),expression(0)),advance(\")\"),block(!1),state.funct[\"(scope)\"].unstack()}var b;for(block(!0);\"catch\"===state.tokens.next.id;)increaseComplexityCount(),b&&!state.inMoz()&&warning(\"W118\",state.tokens.next,\"multiple catch blocks\"),doCatch(),b=!0;return\"finally\"===state.tokens.next.id?(advance(\"finally\"),block(!0),void 0):(b||error(\"E021\",state.tokens.next,\"catch\",state.tokens.next.value),this)}),blockstmt(\"while\",function(){var t=state.tokens.next;return state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,increaseComplexityCount(),advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),block(!0,!0),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1,this}).labelled=!0,blockstmt(\"with\",function(){var t=state.tokens.next;return state.isStrict()?error(\"E010\",state.tokens.curr):state.option.withstmt||warning(\"W085\",state.tokens.curr),advance(\"(\"),expression(0),advance(\")\",t),block(!0,!0),this}),blockstmt(\"switch\",function(){var t=state.tokens.next,g=!1,noindent=!1;\nfor(state.funct[\"(breakage)\"]+=1,advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),t=state.tokens.next,advance(\"{\"),state.tokens.next.from===indent&&(noindent=!0),noindent||(indent+=state.option.indent),this.cases=[];;)switch(state.tokens.next.id){case\"case\":switch(state.funct[\"(verb)\"]){case\"yield\":case\"break\":case\"case\":case\"continue\":case\"return\":case\"switch\":case\"throw\":break;default:state.tokens.curr.caseFallsThrough||warning(\"W086\",state.tokens.curr,\"case\")}advance(\"case\"),this.cases.push(expression(0)),increaseComplexityCount(),g=!0,advance(\":\"),state.funct[\"(verb)\"]=\"case\";break;case\"default\":switch(state.funct[\"(verb)\"]){case\"yield\":case\"break\":case\"continue\":case\"return\":case\"throw\":break;default:this.cases.length&&(state.tokens.curr.caseFallsThrough||warning(\"W086\",state.tokens.curr,\"default\"))}advance(\"default\"),g=!0,advance(\":\");break;case\"}\":return noindent||(indent-=state.option.indent),advance(\"}\",t),state.funct[\"(breakage)\"]-=1,state.funct[\"(verb)\"]=void 0,void 0;case\"(end)\":return error(\"E023\",state.tokens.next,\"}\"),void 0;default:if(indent+=state.option.indent,g)switch(state.tokens.curr.id){case\",\":return error(\"E040\"),void 0;case\":\":g=!1,statements();break;default:return error(\"E025\",state.tokens.curr),void 0}else{if(\":\"!==state.tokens.curr.id)return error(\"E021\",state.tokens.next,\"case\",state.tokens.next.value),void 0;advance(\":\"),error(\"E024\",state.tokens.curr,\":\"),statements()}indent-=state.option.indent}return this}).labelled=!0,stmt(\"debugger\",function(){return state.option.debug||warning(\"W087\",this),this}).exps=!0,function(){var x=stmt(\"do\",function(){state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,increaseComplexityCount(),this.first=block(!0,!0),advance(\"while\");var t=state.tokens.next;return advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1,this});x.labelled=!0,x.exps=!0}(),blockstmt(\"for\",function(){var s,t=state.tokens.next,letscope=!1,foreachtok=null;\"each\"===t.value&&(foreachtok=t,advance(\"each\"),state.inMoz()||warning(\"W118\",state.tokens.curr,\"for each\")),increaseComplexityCount(),advance(\"(\");var nextop,comma,initializer,i=0,inof=[\"in\",\"of\"],level=0;checkPunctuators(state.tokens.next,[\"{\",\"[\"])&&++level;do{if(nextop=peek(i),++i,checkPunctuators(nextop,[\"{\",\"[\"])?++level:checkPunctuators(nextop,[\"}\",\"]\"])&&--level,0>level)break;0===level&&(!comma&&checkPunctuator(nextop,\",\")?comma=nextop:!initializer&&checkPunctuator(nextop,\"=\")&&(initializer=nextop))}while(level>0||!_.contains(inof,nextop.value)&&\";\"!==nextop.value&&\"(end)\"!==nextop.type);if(_.contains(inof,nextop.value)){state.inES6()||\"of\"!==nextop.value||warning(\"W104\",nextop,\"for of\",\"6\");var ok=!(initializer||comma);if(initializer&&error(\"W133\",comma,nextop.value,\"initializer is forbidden\"),comma&&error(\"W133\",comma,nextop.value,\"more than one ForBinding\"),\"var\"===state.tokens.next.id?(advance(\"var\"),state.tokens.curr.fud({prefix:!0})):\"let\"===state.tokens.next.id||\"const\"===state.tokens.next.id?(advance(state.tokens.next.id),letscope=!0,state.funct[\"(scope)\"].stack(),state.tokens.curr.fud({prefix:!0})):Object.create(varstatement).fud({prefix:!0,implied:\"for\",ignore:!ok}),advance(nextop.value),expression(20),advance(\")\",t),\"in\"===nextop.value&&state.option.forin&&(state.forinifcheckneeded=!0,void 0===state.forinifchecks&&(state.forinifchecks=[]),state.forinifchecks.push({type:\"(none)\"})),state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,s=block(!0,!0),\"in\"===nextop.value&&state.option.forin){if(state.forinifchecks&&state.forinifchecks.length>0){var check=state.forinifchecks.pop();(s&&s.length>0&&(\"object\"!=typeof s[0]||\"if\"!==s[0].value)||\"(positive)\"===check.type&&s.length>1||\"(negative)\"===check.type)&&warning(\"W089\",this)}state.forinifcheckneeded=!1}state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1}else{if(foreachtok&&error(\"E045\",foreachtok),\";\"!==state.tokens.next.id)if(\"var\"===state.tokens.next.id)advance(\"var\"),state.tokens.curr.fud();else if(\"let\"===state.tokens.next.id)advance(\"let\"),letscope=!0,state.funct[\"(scope)\"].stack(),state.tokens.curr.fud();else for(;expression(0,\"for\"),\",\"===state.tokens.next.id;)comma();if(nolinebreak(state.tokens.curr),advance(\";\"),state.funct[\"(loopage)\"]+=1,\";\"!==state.tokens.next.id&&checkCondAssignment(expression(0)),nolinebreak(state.tokens.curr),advance(\";\"),\";\"===state.tokens.next.id&&error(\"E021\",state.tokens.next,\")\",\";\"),\")\"!==state.tokens.next.id)for(;expression(0,\"for\"),\",\"===state.tokens.next.id;)comma();advance(\")\",t),state.funct[\"(breakage)\"]+=1,block(!0,!0),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1}return letscope&&state.funct[\"(scope)\"].unstack(),this}).labelled=!0,stmt(\"break\",function(){var v=state.tokens.next.value;return state.option.asi||nolinebreak(this),\";\"===state.tokens.next.id||state.tokens.next.reach||state.tokens.curr.line!==startLine(state.tokens.next)?0===state.funct[\"(breakage)\"]&&warning(\"W052\",state.tokens.next,this.value):(state.funct[\"(scope)\"].funct.hasBreakLabel(v)||warning(\"W090\",state.tokens.next,v),this.first=state.tokens.next,advance()),reachable(this),this}).exps=!0,stmt(\"continue\",function(){var v=state.tokens.next.value;return 0===state.funct[\"(breakage)\"]&&warning(\"W052\",state.tokens.next,this.value),state.funct[\"(loopage)\"]||warning(\"W052\",state.tokens.next,this.value),state.option.asi||nolinebreak(this),\";\"===state.tokens.next.id||state.tokens.next.reach||state.tokens.curr.line===startLine(state.tokens.next)&&(state.funct[\"(scope)\"].funct.hasBreakLabel(v)||warning(\"W090\",state.tokens.next,v),this.first=state.tokens.next,advance()),reachable(this),this}).exps=!0,stmt(\"return\",function(){return this.line===startLine(state.tokens.next)?\";\"===state.tokens.next.id||state.tokens.next.reach||(this.first=expression(0),!this.first||\"(punctuator)\"!==this.first.type||\"=\"!==this.first.value||this.first.paren||state.option.boss||warningAt(\"W093\",this.first.line,this.first.character)):\"(punctuator)\"===state.tokens.next.type&&[\"[\",\"{\",\"+\",\"-\"].indexOf(state.tokens.next.value)>-1&&nolinebreak(this),reachable(this),this}).exps=!0,function(x){x.exps=!0,x.lbp=25}(prefix(\"yield\",function(){var prev=state.tokens.prev;state.inES6(!0)&&!state.funct[\"(generator)\"]?\"(catch)\"===state.funct[\"(name)\"]&&state.funct[\"(context)\"][\"(generator)\"]||error(\"E046\",state.tokens.curr,\"yield\"):state.inES6()||warning(\"W104\",state.tokens.curr,\"yield\",\"6\"),state.funct[\"(generator)\"]=\"yielded\";var delegatingYield=!1;return\"*\"===state.tokens.next.value&&(delegatingYield=!0,advance(\"*\")),this.line!==startLine(state.tokens.next)&&state.inMoz()?state.option.asi||nolinebreak(this):((delegatingYield||\";\"!==state.tokens.next.id&&!state.option.asi&&!state.tokens.next.reach&&state.tokens.next.nud)&&(nobreaknonadjacent(state.tokens.curr,state.tokens.next),this.first=expression(10),\"(punctuator)\"!==this.first.type||\"=\"!==this.first.value||this.first.paren||state.option.boss||warningAt(\"W093\",this.first.line,this.first.character)),state.inMoz()&&\")\"!==state.tokens.next.id&&(prev.lbp>30||!prev.assign&&!isEndOfExpr()||\"yield\"===prev.id)&&error(\"E050\",this)),this})),stmt(\"throw\",function(){return nolinebreak(this),this.first=expression(20),reachable(this),this}).exps=!0,stmt(\"import\",function(){if(state.inES6()||warning(\"W119\",state.tokens.curr,\"import\",\"6\"),\"(string)\"===state.tokens.next.type)return advance(\"(string)\"),this;if(state.tokens.next.identifier){if(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"const\",token:state.tokens.curr}),\",\"!==state.tokens.next.value)return advance(\"from\"),advance(\"(string)\"),this;advance(\",\")}if(\"*\"===state.tokens.next.id)advance(\"*\"),advance(\"as\"),state.tokens.next.identifier&&(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"const\",token:state.tokens.curr}));else for(advance(\"{\");;){if(\"}\"===state.tokens.next.value){advance(\"}\");break}var importName;if(\"default\"===state.tokens.next.type?(importName=\"default\",advance(\"default\")):importName=identifier(),\"as\"===state.tokens.next.value&&(advance(\"as\"),importName=identifier()),state.funct[\"(scope)\"].addlabel(importName,{type:\"const\",token:state.tokens.curr}),\",\"!==state.tokens.next.value){if(\"}\"===state.tokens.next.value){advance(\"}\");break}error(\"E024\",state.tokens.next,state.tokens.next.value);break}advance(\",\")}return advance(\"from\"),advance(\"(string)\"),this}).exps=!0,stmt(\"export\",function(){var token,identifier,ok=!0;if(state.inES6()||(warning(\"W119\",state.tokens.curr,\"export\",\"6\"),ok=!1),state.funct[\"(scope)\"].block.isGlobal()||(error(\"E053\",state.tokens.curr),ok=!1),\"*\"===state.tokens.next.value)return advance(\"*\"),advance(\"from\"),advance(\"(string)\"),this;if(\"default\"===state.tokens.next.type){state.nameStack.set(state.tokens.next),advance(\"default\");var exportType=state.tokens.next.id;return(\"function\"===exportType||\"class\"===exportType)&&(this.block=!0),token=peek(),expression(10),identifier=token.value,this.block&&(state.funct[\"(scope)\"].addlabel(identifier,{type:exportType,token:token}),state.funct[\"(scope)\"].setExported(identifier,token)),this}if(\"{\"===state.tokens.next.value){advance(\"{\");for(var exportedTokens=[];;){if(state.tokens.next.identifier||error(\"E030\",state.tokens.next,state.tokens.next.value),advance(),exportedTokens.push(state.tokens.curr),\"as\"===state.tokens.next.value&&(advance(\"as\"),state.tokens.next.identifier||error(\"E030\",state.tokens.next,state.tokens.next.value),advance()),\",\"!==state.tokens.next.value){if(\"}\"===state.tokens.next.value){advance(\"}\");break}error(\"E024\",state.tokens.next,state.tokens.next.value);break}advance(\",\")}return\"from\"===state.tokens.next.value?(advance(\"from\"),advance(\"(string)\")):ok&&exportedTokens.forEach(function(token){state.funct[\"(scope)\"].setExported(token.value,token)}),this}if(\"var\"===state.tokens.next.id)advance(\"var\"),state.tokens.curr.fud({inexport:!0});else if(\"let\"===state.tokens.next.id)advance(\"let\"),state.tokens.curr.fud({inexport:!0});else if(\"const\"===state.tokens.next.id)advance(\"const\"),state.tokens.curr.fud({inexport:!0});else if(\"function\"===state.tokens.next.id)this.block=!0,advance(\"function\"),state.syntax[\"function\"].fud({inexport:!0});else if(\"class\"===state.tokens.next.id){this.block=!0,advance(\"class\");var classNameToken=state.tokens.next;state.syntax[\"class\"].fud(),state.funct[\"(scope)\"].setExported(classNameToken.value,classNameToken)}else error(\"E024\",state.tokens.next,state.tokens.next.value);return this}).exps=!0,FutureReservedWord(\"abstract\"),FutureReservedWord(\"boolean\"),FutureReservedWord(\"byte\"),FutureReservedWord(\"char\"),FutureReservedWord(\"class\",{es5:!0,nud:classdef}),FutureReservedWord(\"double\"),FutureReservedWord(\"enum\",{es5:!0}),FutureReservedWord(\"export\",{es5:!0}),FutureReservedWord(\"extends\",{es5:!0}),FutureReservedWord(\"final\"),FutureReservedWord(\"float\"),FutureReservedWord(\"goto\"),FutureReservedWord(\"implements\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"import\",{es5:!0}),FutureReservedWord(\"int\"),FutureReservedWord(\"interface\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"long\"),FutureReservedWord(\"native\"),FutureReservedWord(\"package\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"private\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"protected\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"public\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"short\"),FutureReservedWord(\"static\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"super\",{es5:!0}),FutureReservedWord(\"synchronized\"),FutureReservedWord(\"transient\"),FutureReservedWord(\"volatile\");var lookupBlockType=function(){var pn,pn1,prev,i=-1,bracketStack=0,ret={};checkPunctuators(state.tokens.curr,[\"[\",\"{\"])&&(bracketStack+=1);do{if(prev=-1===i?state.tokens.curr:pn,pn=-1===i?state.tokens.next:peek(i),pn1=peek(i+1),i+=1,checkPunctuators(pn,[\"[\",\"{\"])?bracketStack+=1:checkPunctuators(pn,[\"]\",\"}\"])&&(bracketStack-=1),1===bracketStack&&pn.identifier&&\"for\"===pn.value&&!checkPunctuator(prev,\".\")){ret.isCompArray=!0,ret.notJson=!0;break}if(0===bracketStack&&checkPunctuators(pn,[\"}\",\"]\"])){if(\"=\"===pn1.value){ret.isDestAssign=!0,ret.notJson=!0;break}if(\".\"===pn1.value){ret.notJson=!0;break}}checkPunctuator(pn,\";\")&&(ret.isBlock=!0,ret.notJson=!0)}while(bracketStack>0&&\"(end)\"!==pn.id);return ret},arrayComprehension=function(){function declare(v){var l=_current.variables.filter(function(elt){return elt.value===v?(elt.undef=!1,v):void 0}).length;return 0!==l}function use(v){var l=_current.variables.filter(function(elt){return elt.value!==v||elt.undef?void 0:(elt.unused===!0&&(elt.unused=!1),v)}).length;return 0===l}var _current,CompArray=function(){this.mode=\"use\",this.variables=[]},_carrays=[];return{stack:function(){_current=new CompArray,_carrays.push(_current)},unstack:function(){_current.variables.filter(function(v){v.unused&&warning(\"W098\",v.token,v.raw_text||v.value),v.undef&&state.funct[\"(scope)\"].block.use(v.value,v.token)}),_carrays.splice(-1,1),_current=_carrays[_carrays.length-1]},setState:function(s){_.contains([\"use\",\"define\",\"generate\",\"filter\"],s)&&(_current.mode=s)},check:function(v){return _current?_current&&\"use\"===_current.mode?(use(v)&&_current.variables.push({funct:state.funct,token:state.tokens.curr,value:v,undef:!0,unused:!1}),!0):_current&&\"define\"===_current.mode?(declare(v)||_current.variables.push({funct:state.funct,token:state.tokens.curr,value:v,undef:!1,unused:!0}),!0):_current&&\"generate\"===_current.mode?(state.funct[\"(scope)\"].block.use(v,state.tokens.curr),!0):_current&&\"filter\"===_current.mode?(use(v)&&state.funct[\"(scope)\"].block.use(v,state.tokens.curr),!0):!1:void 0}}},escapeRegex=function(str){return str.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\")},itself=function(s,o,g){function each(obj,cb){obj&&(Array.isArray(obj)||\"object\"!=typeof obj||(obj=Object.keys(obj)),obj.forEach(cb))}var i,k,x,reIgnoreStr,reIgnore,optionKeys,newOptionObj={},newIgnoredObj={};o=_.clone(o),state.reset(),o&&o.scope?JSHINT.scope=o.scope:(JSHINT.errors=[],JSHINT.undefs=[],JSHINT.internals=[],JSHINT.blacklist={},JSHINT.scope=\"(main)\"),predefined=Object.create(null),combine(predefined,vars.ecmaIdentifiers[3]),combine(predefined,vars.reservedVars),combine(predefined,g||{}),declared=Object.create(null);var exported=Object.create(null);if(o)for(each(o.predef||null,function(item){var slice,prop;\"-\"===item[0]?(slice=item.slice(1),JSHINT.blacklist[slice]=slice,delete predefined[slice]):(prop=Object.getOwnPropertyDescriptor(o.predef,item),predefined[item]=prop?prop.value:!1)}),each(o.exported||null,function(item){exported[item]=!0}),delete o.predef,delete o.exported,optionKeys=Object.keys(o),x=0;optionKeys.length>x;x++)if(/^-W\\d{3}$/g.test(optionKeys[x]))newIgnoredObj[optionKeys[x].slice(1)]=!0;else{var optionKey=optionKeys[x];newOptionObj[optionKey]=o[optionKey],(\"esversion\"===optionKey&&5===o[optionKey]||\"es5\"===optionKey&&o[optionKey])&&warning(\"I003\"),\"newcap\"===optionKeys[x]&&o[optionKey]===!1&&(newOptionObj[\"(explicitNewcap)\"]=!0)}state.option=newOptionObj,state.ignored=newIgnoredObj,state.option.indent=state.option.indent||4,state.option.maxerr=state.option.maxerr||50,indent=1;var scopeManagerInst=scopeManager(state,predefined,exported,declared);if(scopeManagerInst.on(\"warning\",function(ev){warning.apply(null,[ev.code,ev.token].concat(ev.data))}),scopeManagerInst.on(\"error\",function(ev){error.apply(null,[ev.code,ev.token].concat(ev.data))}),state.funct=functor(\"(global)\",null,{\"(global)\":!0,\"(scope)\":scopeManagerInst,\"(comparray)\":arrayComprehension(),\"(metrics)\":createMetrics(state.tokens.next)}),functions=[state.funct],urls=[],stack=null,member={},membersOnly=null,inblock=!1,lookahead=[],!isString(s)&&!Array.isArray(s))return errorAt(\"E004\",0),!1;api={get isJSON(){return state.jsonMode},getOption:function(name){return state.option[name]||null},getCache:function(name){return state.cache[name]},setCache:function(name,value){state.cache[name]=value},warn:function(code,data){warningAt.apply(null,[code,data.line,data.char].concat(data.data))},on:function(names,listener){names.split(\" \").forEach(function(name){emitter.on(name,listener)}.bind(this))}},emitter.removeAllListeners(),(extraModules||[]).forEach(function(func){func(api)}),state.tokens.prev=state.tokens.curr=state.tokens.next=state.syntax[\"(begin)\"],o&&o.ignoreDelimiters&&(Array.isArray(o.ignoreDelimiters)||(o.ignoreDelimiters=[o.ignoreDelimiters]),o.ignoreDelimiters.forEach(function(delimiterPair){delimiterPair.start&&delimiterPair.end&&(reIgnoreStr=escapeRegex(delimiterPair.start)+\"[\\\\s\\\\S]*?\"+escapeRegex(delimiterPair.end),reIgnore=RegExp(reIgnoreStr,\"ig\"),s=s.replace(reIgnore,function(match){return match.replace(/./g,\" \")}))})),lex=new Lexer(s),lex.on(\"warning\",function(ev){warningAt.apply(null,[ev.code,ev.line,ev.character].concat(ev.data))}),lex.on(\"error\",function(ev){errorAt.apply(null,[ev.code,ev.line,ev.character].concat(ev.data))}),lex.on(\"fatal\",function(ev){quit(\"E041\",ev.line,ev.from)}),lex.on(\"Identifier\",function(ev){emitter.emit(\"Identifier\",ev)}),lex.on(\"String\",function(ev){emitter.emit(\"String\",ev)}),lex.on(\"Number\",function(ev){emitter.emit(\"Number\",ev)}),lex.start();for(var name in o)_.has(o,name)&&checkOption(name,state.tokens.curr);assume(),combine(predefined,g||{}),comma.first=!0;try{switch(advance(),state.tokens.next.id){case\"{\":case\"[\":destructuringAssignOrJsonValue();break;default:directives(),state.directive[\"use strict\"]&&\"global\"!==state.option.strict&&warning(\"W097\",state.tokens.prev),statements()}\"(end)\"!==state.tokens.next.id&&quit(\"E041\",state.tokens.curr.line),state.funct[\"(scope)\"].unstack()}catch(err){if(!err||\"JSHintError\"!==err.name)throw err;var nt=state.tokens.next||{};JSHINT.errors.push({scope:\"(main)\",raw:err.raw,code:err.code,reason:err.message,line:err.line||nt.line,character:err.character||nt.from},null)}if(\"(main)\"===JSHINT.scope)for(o=o||{},i=0;JSHINT.internals.length>i;i+=1)k=JSHINT.internals[i],o.scope=k.elem,itself(k.value,o,g);return 0===JSHINT.errors.length};return itself.addModule=function(func){extraModules.push(func)},itself.addModule(style.register),itself.data=function(){var fu,f,i,j,n,globals,data={functions:[],options:state.option};itself.errors.length&&(data.errors=itself.errors),state.jsonMode&&(data.json=!0);var impliedGlobals=state.funct[\"(scope)\"].getImpliedGlobals();for(impliedGlobals.length>0&&(data.implieds=impliedGlobals),urls.length>0&&(data.urls=urls),globals=state.funct[\"(scope)\"].getUsedOrDefinedGlobals(),globals.length>0&&(data.globals=globals),i=1;functions.length>i;i+=1){for(f=functions[i],fu={},j=0;functionicity.length>j;j+=1)fu[functionicity[j]]=[];for(j=0;functionicity.length>j;j+=1)0===fu[functionicity[j]].length&&delete fu[functionicity[j]];fu.name=f[\"(name)\"],fu.param=f[\"(params)\"],fu.line=f[\"(line)\"],fu.character=f[\"(character)\"],fu.last=f[\"(last)\"],fu.lastcharacter=f[\"(lastcharacter)\"],fu.metrics={complexity:f[\"(metrics)\"].ComplexityCount,parameters:f[\"(metrics)\"].arity,statements:f[\"(metrics)\"].statementCount},data.functions.push(fu)}var unuseds=state.funct[\"(scope)\"].getUnuseds();unuseds.length>0&&(data.unused=unuseds);for(n in member)if(\"number\"==typeof member[n]){data.member=member;break}return data},itself.jshint=itself,itself}();\"object\"==typeof exports&&exports&&(exports.JSHINT=JSHINT)},{\"../lodash\":\"/node_modules/jshint/lodash.js\",\"./lex.js\":\"/node_modules/jshint/src/lex.js\",\"./messages.js\":\"/node_modules/jshint/src/messages.js\",\"./options.js\":\"/node_modules/jshint/src/options.js\",\"./reg.js\":\"/node_modules/jshint/src/reg.js\",\"./scope-manager.js\":\"/node_modules/jshint/src/scope-manager.js\",\"./state.js\":\"/node_modules/jshint/src/state.js\",\"./style.js\":\"/node_modules/jshint/src/style.js\",\"./vars.js\":\"/node_modules/jshint/src/vars.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/lex.js\":[function(_dereq_,module,exports){\"use strict\";function asyncTrigger(){var _checks=[];return{push:function(fn){_checks.push(fn)},check:function(){for(var check=0;_checks.length>check;++check)_checks[check]();_checks.splice(0,_checks.length)}}}function Lexer(source){var lines=source;\"string\"==typeof lines&&(lines=lines.replace(/\\r\\n/g,\"\\n\").replace(/\\r/g,\"\\n\").split(\"\\n\")),lines[0]&&\"#!\"===lines[0].substr(0,2)&&(-1!==lines[0].indexOf(\"node\")&&(state.option.node=!0),lines[0]=\"\"),this.emitter=new events.EventEmitter,this.source=source,this.setLines(lines),this.prereg=!0,this.line=0,this.char=1,this.from=1,this.input=\"\",this.inComment=!1,this.context=[],this.templateStarts=[];for(var i=0;state.option.indent>i;i+=1)state.tab+=\" \";this.ignoreLinterErrors=!1}var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),reg=_dereq_(\"./reg.js\"),state=_dereq_(\"./state.js\").state,unicodeData=_dereq_(\"../data/ascii-identifier-data.js\"),asciiIdentifierStartTable=unicodeData.asciiIdentifierStartTable,asciiIdentifierPartTable=unicodeData.asciiIdentifierPartTable,Token={Identifier:1,Punctuator:2,NumericLiteral:3,StringLiteral:4,Comment:5,Keyword:6,NullLiteral:7,BooleanLiteral:8,RegExp:9,TemplateHead:10,TemplateMiddle:11,TemplateTail:12,NoSubstTemplate:13},Context={Block:1,Template:2};Lexer.prototype={_lines:[],inContext:function(ctxType){return this.context.length>0&&this.context[this.context.length-1].type===ctxType},pushContext:function(ctxType){this.context.push({type:ctxType})},popContext:function(){return this.context.pop()},isContext:function(context){return this.context.length>0&&this.context[this.context.length-1]===context},currentContext:function(){return this.context.length>0&&this.context[this.context.length-1]},getLines:function(){return this._lines=state.lines,this._lines},setLines:function(val){this._lines=val,state.lines=this._lines},peek:function(i){return this.input.charAt(i||0)},skip:function(i){i=i||1,this.char+=i,this.input=this.input.slice(i)},on:function(names,listener){names.split(\" \").forEach(function(name){this.emitter.on(name,listener)}.bind(this))},trigger:function(){this.emitter.emit.apply(this.emitter,Array.prototype.slice.call(arguments))},triggerAsync:function(type,args,checks,fn){checks.push(function(){fn()&&this.trigger(type,args)}.bind(this))},scanPunctuator:function(){var ch2,ch3,ch4,ch1=this.peek();switch(ch1){case\".\":if(/^[0-9]$/.test(this.peek(1)))return null;if(\".\"===this.peek(1)&&\".\"===this.peek(2))return{type:Token.Punctuator,value:\"...\"};case\"(\":case\")\":case\";\":case\",\":case\"[\":case\"]\":case\":\":case\"~\":case\"?\":return{type:Token.Punctuator,value:ch1};case\"{\":return this.pushContext(Context.Block),{type:Token.Punctuator,value:ch1};case\"}\":return this.inContext(Context.Block)&&this.popContext(),{type:Token.Punctuator,value:ch1};case\"#\":return{type:Token.Punctuator,value:ch1};case\"\":return null}return ch2=this.peek(1),ch3=this.peek(2),ch4=this.peek(3),\">\"===ch1&&\">\"===ch2&&\">\"===ch3&&\"=\"===ch4?{type:Token.Punctuator,value:\">>>=\"}:\"=\"===ch1&&\"=\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"===\"}:\"!\"===ch1&&\"=\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"!==\"}:\">\"===ch1&&\">\"===ch2&&\">\"===ch3?{type:Token.Punctuator,value:\">>>\"}:\"<\"===ch1&&\"<\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"<<=\"}:\">\"===ch1&&\">\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\">>=\"}:\"=\"===ch1&&\">\"===ch2?{type:Token.Punctuator,value:ch1+ch2}:ch1===ch2&&\"+-<>&|\".indexOf(ch1)>=0?{type:Token.Punctuator,value:ch1+ch2}:\"<>=!+-*%&|^\".indexOf(ch1)>=0?\"=\"===ch2?{type:Token.Punctuator,value:ch1+ch2}:{type:Token.Punctuator,value:ch1}:\"/\"===ch1?\"=\"===ch2?{type:Token.Punctuator,value:\"/=\"}:{type:Token.Punctuator,value:\"/\"}:null},scanComments:function(){function commentToken(label,body,opt){var special=[\"jshint\",\"jslint\",\"members\",\"member\",\"globals\",\"global\",\"exported\"],isSpecial=!1,value=label+body,commentType=\"plain\";return opt=opt||{},opt.isMultiline&&(value+=\"*/\"),body=body.replace(/\\n/g,\" \"),\"/*\"===label&&reg.fallsThrough.test(body)&&(isSpecial=!0,commentType=\"falls through\"),special.forEach(function(str){if(!isSpecial&&(\"//\"!==label||\"jshint\"===str)&&(\" \"===body.charAt(str.length)&&body.substr(0,str.length)===str&&(isSpecial=!0,label+=str,body=body.substr(str.length)),isSpecial||\" \"!==body.charAt(0)||\" \"!==body.charAt(str.length+1)||body.substr(1,str.length)!==str||(isSpecial=!0,label=label+\" \"+str,body=body.substr(str.length+1)),isSpecial))switch(str){case\"member\":commentType=\"members\";break;case\"global\":commentType=\"globals\";break;default:var options=body.split(\":\").map(function(v){return v.replace(/^\\s+/,\"\").replace(/\\s+$/,\"\")});if(2===options.length)switch(options[0]){case\"ignore\":switch(options[1]){case\"start\":self.ignoringLinterErrors=!0,isSpecial=!1;break;case\"end\":self.ignoringLinterErrors=!1,isSpecial=!1}}commentType=str}}),{type:Token.Comment,commentType:commentType,value:value,body:body,isSpecial:isSpecial,isMultiline:opt.isMultiline||!1,isMalformed:opt.isMalformed||!1}}var ch1=this.peek(),ch2=this.peek(1),rest=this.input.substr(2),startLine=this.line,startChar=this.char,self=this;if(\"*\"===ch1&&\"/\"===ch2)return this.trigger(\"error\",{code:\"E018\",line:startLine,character:startChar}),this.skip(2),null;if(\"/\"!==ch1||\"*\"!==ch2&&\"/\"!==ch2)return null;if(\"/\"===ch2)return this.skip(this.input.length),commentToken(\"//\",rest);var body=\"\";if(\"*\"===ch2){for(this.inComment=!0,this.skip(2);\"*\"!==this.peek()||\"/\"!==this.peek(1);)if(\"\"===this.peek()){if(body+=\"\\n\",!this.nextLine())return this.trigger(\"error\",{code:\"E017\",line:startLine,character:startChar}),this.inComment=!1,commentToken(\"/*\",body,{isMultiline:!0,isMalformed:!0})}else body+=this.peek(),this.skip();return this.skip(2),this.inComment=!1,commentToken(\"/*\",body,{isMultiline:!0})}},scanKeyword:function(){var result=/^[a-zA-Z_$][a-zA-Z0-9_$]*/.exec(this.input),keywords=[\"if\",\"in\",\"do\",\"var\",\"for\",\"new\",\"try\",\"let\",\"this\",\"else\",\"case\",\"void\",\"with\",\"enum\",\"while\",\"break\",\"catch\",\"throw\",\"const\",\"yield\",\"class\",\"super\",\"return\",\"typeof\",\"delete\",\"switch\",\"export\",\"import\",\"default\",\"finally\",\"extends\",\"function\",\"continue\",\"debugger\",\"instanceof\"];return result&&keywords.indexOf(result[0])>=0?{type:Token.Keyword,value:result[0]}:null},scanIdentifier:function(){function isNonAsciiIdentifierStart(code){return code>256}function isNonAsciiIdentifierPart(code){return code>256}function isHexDigit(str){return/^[0-9a-fA-F]$/.test(str)}function removeEscapeSequences(id){return id.replace(/\\\\u([0-9a-fA-F]{4})/g,function(m0,codepoint){return String.fromCharCode(parseInt(codepoint,16))})}var type,char,id=\"\",index=0,readUnicodeEscapeSequence=function(){if(index+=1,\"u\"!==this.peek(index))return null;var code,ch1=this.peek(index+1),ch2=this.peek(index+2),ch3=this.peek(index+3),ch4=this.peek(index+4);return isHexDigit(ch1)&&isHexDigit(ch2)&&isHexDigit(ch3)&&isHexDigit(ch4)?(code=parseInt(ch1+ch2+ch3+ch4,16),asciiIdentifierPartTable[code]||isNonAsciiIdentifierPart(code)?(index+=5,\"\\\\u\"+ch1+ch2+ch3+ch4):null):null}.bind(this),getIdentifierStart=function(){var chr=this.peek(index),code=chr.charCodeAt(0);return 92===code?readUnicodeEscapeSequence():128>code?asciiIdentifierStartTable[code]?(index+=1,chr):null:isNonAsciiIdentifierStart(code)?(index+=1,chr):null}.bind(this),getIdentifierPart=function(){var chr=this.peek(index),code=chr.charCodeAt(0);return 92===code?readUnicodeEscapeSequence():128>code?asciiIdentifierPartTable[code]?(index+=1,chr):null:isNonAsciiIdentifierPart(code)?(index+=1,chr):null}.bind(this);if(char=getIdentifierStart(),null===char)return null;for(id=char;char=getIdentifierPart(),null!==char;)id+=char;switch(id){case\"true\":case\"false\":type=Token.BooleanLiteral;break;case\"null\":type=Token.NullLiteral;break;default:type=Token.Identifier}return{type:type,value:removeEscapeSequences(id),text:id,tokenLength:id.length}},scanNumericLiteral:function(){function isDecimalDigit(str){return/^[0-9]$/.test(str)}function isOctalDigit(str){return/^[0-7]$/.test(str)}function isBinaryDigit(str){return/^[01]$/.test(str)}function isHexDigit(str){return/^[0-9a-fA-F]$/.test(str)}function isIdentifierStart(ch){return\"$\"===ch||\"_\"===ch||\"\\\\\"===ch||ch>=\"a\"&&\"z\">=ch||ch>=\"A\"&&\"Z\">=ch}var bad,index=0,value=\"\",length=this.input.length,char=this.peek(index),isAllowedDigit=isDecimalDigit,base=10,isLegacy=!1;if(\".\"!==char&&!isDecimalDigit(char))return null;if(\".\"!==char){for(value=this.peek(index),index+=1,char=this.peek(index),\"0\"===value&&((\"x\"===char||\"X\"===char)&&(isAllowedDigit=isHexDigit,base=16,index+=1,value+=char),(\"o\"===char||\"O\"===char)&&(isAllowedDigit=isOctalDigit,base=8,state.inES6(!0)||this.trigger(\"warning\",{code:\"W119\",line:this.line,character:this.char,data:[\"Octal integer literal\",\"6\"]}),index+=1,value+=char),(\"b\"===char||\"B\"===char)&&(isAllowedDigit=isBinaryDigit,base=2,state.inES6(!0)||this.trigger(\"warning\",{code:\"W119\",line:this.line,character:this.char,data:[\"Binary integer literal\",\"6\"]}),index+=1,value+=char),isOctalDigit(char)&&(isAllowedDigit=isOctalDigit,base=8,isLegacy=!0,bad=!1,index+=1,value+=char),!isOctalDigit(char)&&isDecimalDigit(char)&&(index+=1,value+=char));length>index;){if(char=this.peek(index),isLegacy&&isDecimalDigit(char))bad=!0;else if(!isAllowedDigit(char))break;value+=char,index+=1}if(isAllowedDigit!==isDecimalDigit)return!isLegacy&&2>=value.length?{type:Token.NumericLiteral,value:value,isMalformed:!0}:length>index&&(char=this.peek(index),isIdentifierStart(char))?null:{type:Token.NumericLiteral,value:value,base:base,isLegacy:isLegacy,isMalformed:!1}}if(\".\"===char)for(value+=char,index+=1;length>index&&(char=this.peek(index),isDecimalDigit(char));)value+=char,index+=1;if(\"e\"===char||\"E\"===char){if(value+=char,index+=1,char=this.peek(index),(\"+\"===char||\"-\"===char)&&(value+=this.peek(index),index+=1),char=this.peek(index),!isDecimalDigit(char))return null;for(value+=char,index+=1;length>index&&(char=this.peek(index),isDecimalDigit(char));)value+=char,index+=1}return length>index&&(char=this.peek(index),isIdentifierStart(char))?null:{type:Token.NumericLiteral,value:value,base:base,isMalformed:!isFinite(value)}},scanEscapeSequence:function(checks){var allowNewLine=!1,jump=1;this.skip();var char=this.peek();switch(char){case\"'\":this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\'\"]},checks,function(){return state.jsonMode});break;case\"b\":char=\"\\\\b\";break;case\"f\":char=\"\\\\f\";break;case\"n\":char=\"\\\\n\";break;case\"r\":char=\"\\\\r\";break;case\"t\":char=\"\\\\t\";break;case\"0\":char=\"\\\\0\";var n=parseInt(this.peek(1),10);this.triggerAsync(\"warning\",{code:\"W115\",line:this.line,character:this.char},checks,function(){return n>=0&&7>=n&&state.isStrict()});break;case\"u\":var hexCode=this.input.substr(1,4),code=parseInt(hexCode,16);isNaN(code)&&this.trigger(\"warning\",{code:\"W052\",line:this.line,character:this.char,data:[\"u\"+hexCode]}),char=String.fromCharCode(code),jump=5;break;case\"v\":this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\v\"]},checks,function(){return state.jsonMode}),char=\"\u000b\";break;case\"x\":var x=parseInt(this.input.substr(1,2),16);this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\x-\"]},checks,function(){return state.jsonMode}),char=String.fromCharCode(x),jump=3;break;case\"\\\\\":char=\"\\\\\\\\\";break;case'\"':char='\\\\\"';break;case\"/\":break;case\"\":allowNewLine=!0,char=\"\"}return{\"char\":char,jump:jump,allowNewLine:allowNewLine}},scanTemplateLiteral:function(checks){var tokenType,ch,value=\"\",startLine=this.line,startChar=this.char,depth=this.templateStarts.length;if(!state.inES6(!0))return null;if(\"`\"===this.peek())tokenType=Token.TemplateHead,this.templateStarts.push({line:this.line,\"char\":this.char}),depth=this.templateStarts.length,this.skip(1),this.pushContext(Context.Template);else{if(!this.inContext(Context.Template)||\"}\"!==this.peek())return null;tokenType=Token.TemplateMiddle}for(;\"`\"!==this.peek();){for(;\"\"===(ch=this.peek());)if(value+=\"\\n\",!this.nextLine()){var startPos=this.templateStarts.pop();return this.trigger(\"error\",{code:\"E052\",line:startPos.line,character:startPos.char}),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!0,depth:depth,context:this.popContext()}}if(\"$\"===ch&&\"{\"===this.peek(1))return value+=\"${\",this.skip(2),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,depth:depth,context:this.currentContext()};\nif(\"\\\\\"===ch){var escape=this.scanEscapeSequence(checks);value+=escape.char,this.skip(escape.jump)}else\"`\"!==ch&&(value+=ch,this.skip(1))}return tokenType=tokenType===Token.TemplateHead?Token.NoSubstTemplate:Token.TemplateTail,this.skip(1),this.templateStarts.pop(),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,depth:depth,context:this.popContext()}},scanStringLiteral:function(checks){var quote=this.peek();if('\"'!==quote&&\"'\"!==quote)return null;this.triggerAsync(\"warning\",{code:\"W108\",line:this.line,character:this.char},checks,function(){return state.jsonMode&&'\"'!==quote});var value=\"\",startLine=this.line,startChar=this.char,allowNewLine=!1;for(this.skip();this.peek()!==quote;)if(\"\"===this.peek()){if(allowNewLine?(allowNewLine=!1,this.triggerAsync(\"warning\",{code:\"W043\",line:this.line,character:this.char},checks,function(){return!state.option.multistr}),this.triggerAsync(\"warning\",{code:\"W042\",line:this.line,character:this.char},checks,function(){return state.jsonMode&&state.option.multistr})):this.trigger(\"warning\",{code:\"W112\",line:this.line,character:this.char}),!this.nextLine())return this.trigger(\"error\",{code:\"E029\",line:startLine,character:startChar}),{type:Token.StringLiteral,value:value,startLine:startLine,startChar:startChar,isUnclosed:!0,quote:quote}}else{allowNewLine=!1;var char=this.peek(),jump=1;if(\" \">char&&this.trigger(\"warning\",{code:\"W113\",line:this.line,character:this.char,data:[\"<non-printable>\"]}),\"\\\\\"===char){var parsed=this.scanEscapeSequence(checks);char=parsed.char,jump=parsed.jump,allowNewLine=parsed.allowNewLine}value+=char,this.skip(jump)}return this.skip(),{type:Token.StringLiteral,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,quote:quote}},scanRegExp:function(){var terminated,index=0,length=this.input.length,char=this.peek(),value=char,body=\"\",flags=[],malformed=!1,isCharSet=!1,scanUnexpectedChars=function(){\" \">char&&(malformed=!0,this.trigger(\"warning\",{code:\"W048\",line:this.line,character:this.char})),\"<\"===char&&(malformed=!0,this.trigger(\"warning\",{code:\"W049\",line:this.line,character:this.char,data:[char]}))}.bind(this);if(!this.prereg||\"/\"!==char)return null;for(index+=1,terminated=!1;length>index;)if(char=this.peek(index),value+=char,body+=char,isCharSet)\"]\"===char&&(\"\\\\\"!==this.peek(index-1)||\"\\\\\"===this.peek(index-2))&&(isCharSet=!1),\"\\\\\"===char&&(index+=1,char=this.peek(index),body+=char,value+=char,scanUnexpectedChars()),index+=1;else{if(\"\\\\\"===char){if(index+=1,char=this.peek(index),body+=char,value+=char,scanUnexpectedChars(),\"/\"===char){index+=1;continue}if(\"[\"===char){index+=1;continue}}if(\"[\"!==char){if(\"/\"===char){body=body.substr(0,body.length-1),terminated=!0,index+=1;break}index+=1}else isCharSet=!0,index+=1}if(!terminated)return this.trigger(\"error\",{code:\"E015\",line:this.line,character:this.from}),void this.trigger(\"fatal\",{line:this.line,from:this.from});for(;length>index&&(char=this.peek(index),/[gim]/.test(char));)flags.push(char),value+=char,index+=1;try{RegExp(body,flags.join(\"\"))}catch(err){malformed=!0,this.trigger(\"error\",{code:\"E016\",line:this.line,character:this.char,data:[err.message]})}return{type:Token.RegExp,value:value,flags:flags,isMalformed:malformed}},scanNonBreakingSpaces:function(){return state.option.nonbsp?this.input.search(/(\\u00A0)/):-1},scanUnsafeChars:function(){return this.input.search(reg.unsafeChars)},next:function(checks){this.from=this.char;var start;if(/\\s/.test(this.peek()))for(start=this.char;/\\s/.test(this.peek());)this.from+=1,this.skip();var match=this.scanComments()||this.scanStringLiteral(checks)||this.scanTemplateLiteral(checks);return match?match:(match=this.scanRegExp()||this.scanPunctuator()||this.scanKeyword()||this.scanIdentifier()||this.scanNumericLiteral(),match?(this.skip(match.tokenLength||match.value.length),match):null)},nextLine:function(){var char;if(this.line>=this.getLines().length)return!1;this.input=this.getLines()[this.line],this.line+=1,this.char=1,this.from=1;var inputTrimmed=this.input.trim(),startsWith=function(){return _.some(arguments,function(prefix){return 0===inputTrimmed.indexOf(prefix)})},endsWith=function(){return _.some(arguments,function(suffix){return-1!==inputTrimmed.indexOf(suffix,inputTrimmed.length-suffix.length)})};if(this.ignoringLinterErrors===!0&&(startsWith(\"/*\",\"//\")||this.inComment&&endsWith(\"*/\")||(this.input=\"\")),char=this.scanNonBreakingSpaces(),char>=0&&this.trigger(\"warning\",{code:\"W125\",line:this.line,character:char+1}),this.input=this.input.replace(/\\t/g,state.tab),char=this.scanUnsafeChars(),char>=0&&this.trigger(\"warning\",{code:\"W100\",line:this.line,character:char}),!this.ignoringLinterErrors&&state.option.maxlen&&state.option.maxlen<this.input.length){var inComment=this.inComment||startsWith.call(inputTrimmed,\"//\")||startsWith.call(inputTrimmed,\"/*\"),shouldTriggerError=!inComment||!reg.maxlenException.test(inputTrimmed);shouldTriggerError&&this.trigger(\"warning\",{code:\"W101\",line:this.line,character:this.input.length})}return!0},start:function(){this.nextLine()},token:function(){function isReserved(token,isProperty){if(!token.reserved)return!1;var meta=token.meta;if(meta&&meta.isFutureReservedWord&&state.inES5()){if(!meta.es5)return!1;if(meta.strictOnly&&!state.option.strict&&!state.isStrict())return!1;if(isProperty)return!1}return!0}for(var token,checks=asyncTrigger(),create=function(type,value,isProperty,token){var obj;if(\"(endline)\"!==type&&\"(end)\"!==type&&(this.prereg=!1),\"(punctuator)\"===type){switch(value){case\".\":case\")\":case\"~\":case\"#\":case\"]\":case\"++\":case\"--\":this.prereg=!1;break;default:this.prereg=!0}obj=Object.create(state.syntax[value]||state.syntax[\"(error)\"])}return\"(identifier)\"===type&&((\"return\"===value||\"case\"===value||\"typeof\"===value)&&(this.prereg=!0),_.has(state.syntax,value)&&(obj=Object.create(state.syntax[value]||state.syntax[\"(error)\"]),isReserved(obj,isProperty&&\"(identifier)\"===type)||(obj=null))),obj||(obj=Object.create(state.syntax[type])),obj.identifier=\"(identifier)\"===type,obj.type=obj.type||type,obj.value=value,obj.line=this.line,obj.character=this.char,obj.from=this.from,obj.identifier&&token&&(obj.raw_text=token.text||token.value),token&&token.startLine&&token.startLine!==this.line&&(obj.startLine=token.startLine),token&&token.context&&(obj.context=token.context),token&&token.depth&&(obj.depth=token.depth),token&&token.isUnclosed&&(obj.isUnclosed=token.isUnclosed),isProperty&&obj.identifier&&(obj.isProperty=isProperty),obj.check=checks.check,obj}.bind(this);;){if(!this.input.length)return this.nextLine()?create(\"(endline)\",\"\"):this.exhausted?null:(this.exhausted=!0,create(\"(end)\",\"\"));if(token=this.next(checks))switch(token.type){case Token.StringLiteral:return this.triggerAsync(\"String\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value,quote:token.quote},checks,function(){return!0}),create(\"(string)\",token.value,null,token);case Token.TemplateHead:return this.trigger(\"TemplateHead\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template)\",token.value,null,token);case Token.TemplateMiddle:return this.trigger(\"TemplateMiddle\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template middle)\",token.value,null,token);case Token.TemplateTail:return this.trigger(\"TemplateTail\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template tail)\",token.value,null,token);case Token.NoSubstTemplate:return this.trigger(\"NoSubstTemplate\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(no subst template)\",token.value,null,token);case Token.Identifier:this.triggerAsync(\"Identifier\",{line:this.line,\"char\":this.char,from:this.form,name:token.value,raw_name:token.text,isProperty:\".\"===state.tokens.curr.id},checks,function(){return!0});case Token.Keyword:case Token.NullLiteral:case Token.BooleanLiteral:return create(\"(identifier)\",token.value,\".\"===state.tokens.curr.id,token);case Token.NumericLiteral:return token.isMalformed&&this.trigger(\"warning\",{code:\"W045\",line:this.line,character:this.char,data:[token.value]}),this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"0x-\"]},checks,function(){return 16===token.base&&state.jsonMode}),this.triggerAsync(\"warning\",{code:\"W115\",line:this.line,character:this.char},checks,function(){return state.isStrict()&&8===token.base&&token.isLegacy}),this.trigger(\"Number\",{line:this.line,\"char\":this.char,from:this.from,value:token.value,base:token.base,isMalformed:token.malformed}),create(\"(number)\",token.value);case Token.RegExp:return create(\"(regexp)\",token.value);case Token.Comment:if(state.tokens.curr.comment=!0,token.isSpecial)return{id:\"(comment)\",value:token.value,body:token.body,type:token.commentType,isSpecial:token.isSpecial,line:this.line,character:this.char,from:this.from};break;case\"\":break;default:return create(\"(punctuator)\",token.value)}else this.input.length&&(this.trigger(\"error\",{code:\"E024\",line:this.line,character:this.char,data:[this.peek()]}),this.input=\"\")}}},exports.Lexer=Lexer,exports.Context=Context},{\"../data/ascii-identifier-data.js\":\"/node_modules/jshint/data/ascii-identifier-data.js\",\"../lodash\":\"/node_modules/jshint/lodash.js\",\"./reg.js\":\"/node_modules/jshint/src/reg.js\",\"./state.js\":\"/node_modules/jshint/src/state.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/messages.js\":[function(_dereq_,module,exports){\"use strict\";var _=_dereq_(\"../lodash\"),errors={E001:\"Bad option: '{a}'.\",E002:\"Bad option value.\",E003:\"Expected a JSON value.\",E004:\"Input is neither a string nor an array of strings.\",E005:\"Input is empty.\",E006:\"Unexpected early end of program.\",E007:'Missing \"use strict\" statement.',E008:\"Strict violation.\",E009:\"Option 'validthis' can't be used in a global scope.\",E010:\"'with' is not allowed in strict mode.\",E011:\"'{a}' has already been declared.\",E012:\"const '{a}' is initialized to 'undefined'.\",E013:\"Attempting to override '{a}' which is a constant.\",E014:\"A regular expression literal can be confused with '/='.\",E015:\"Unclosed regular expression.\",E016:\"Invalid regular expression.\",E017:\"Unclosed comment.\",E018:\"Unbegun comment.\",E019:\"Unmatched '{a}'.\",E020:\"Expected '{a}' to match '{b}' from line {c} and instead saw '{d}'.\",E021:\"Expected '{a}' and instead saw '{b}'.\",E022:\"Line breaking error '{a}'.\",E023:\"Missing '{a}'.\",E024:\"Unexpected '{a}'.\",E025:\"Missing ':' on a case clause.\",E026:\"Missing '}' to match '{' from line {a}.\",E027:\"Missing ']' to match '[' from line {a}.\",E028:\"Illegal comma.\",E029:\"Unclosed string.\",E030:\"Expected an identifier and instead saw '{a}'.\",E031:\"Bad assignment.\",E032:\"Expected a small integer or 'false' and instead saw '{a}'.\",E033:\"Expected an operator and instead saw '{a}'.\",E034:\"get/set are ES5 features.\",E035:\"Missing property name.\",E036:\"Expected to see a statement and instead saw a block.\",E037:null,E038:null,E039:\"Function declarations are not invocable. Wrap the whole function invocation in parens.\",E040:\"Each value should have its own case label.\",E041:\"Unrecoverable syntax error.\",E042:\"Stopping.\",E043:\"Too many errors.\",E044:null,E045:\"Invalid for each loop.\",E046:\"A yield statement shall be within a generator function (with syntax: `function*`)\",E047:null,E048:\"{a} declaration not directly within block.\",E049:\"A {a} cannot be named '{b}'.\",E050:\"Mozilla acequires the yield expression to be parenthesized here.\",E051:null,E052:\"Unclosed template literal.\",E053:\"Export declaration must be in global scope.\",E054:\"Class properties must be methods. Expected '(' but instead saw '{a}'.\",E055:\"The '{a}' option cannot be set after any executable code.\",E056:\"'{a}' was used before it was declared, which is illegal for '{b}' variables.\",E057:\"Invalid meta property: '{a}.{b}'.\",E058:\"Missing semicolon.\"},warnings={W001:\"'hasOwnProperty' is a really bad name.\",W002:\"Value of '{a}' may be overwritten in IE 8 and earlier.\",W003:\"'{a}' was used before it was defined.\",W004:\"'{a}' is already defined.\",W005:\"A dot following a number can be confused with a decimal point.\",W006:\"Confusing minuses.\",W007:\"Confusing plusses.\",W008:\"A leading decimal point can be confused with a dot: '{a}'.\",W009:\"The array literal notation [] is preferable.\",W010:\"The object literal notation {} is preferable.\",W011:null,W012:null,W013:null,W014:\"Bad line breaking before '{a}'.\",W015:null,W016:\"Unexpected use of '{a}'.\",W017:\"Bad operand.\",W018:\"Confusing use of '{a}'.\",W019:\"Use the isNaN function to compare with NaN.\",W020:\"Read only.\",W021:\"Reassignment of '{a}', which is is a {b}. Use 'var' or 'let' to declare bindings that may change.\",W022:\"Do not assign to the exception parameter.\",W023:\"Expected an identifier in an assignment and instead saw a function invocation.\",W024:\"Expected an identifier and instead saw '{a}' (a reserved word).\",W025:\"Missing name in function declaration.\",W026:\"Inner functions should be listed at the top of the outer function.\",W027:\"Unreachable '{a}' after '{b}'.\",W028:\"Label '{a}' on {b} statement.\",W030:\"Expected an assignment or function call and instead saw an expression.\",W031:\"Do not use 'new' for side effects.\",W032:\"Unnecessary semicolon.\",W033:\"Missing semicolon.\",W034:'Unnecessary directive \"{a}\".',W035:\"Empty block.\",W036:\"Unexpected /*member '{a}'.\",W037:\"'{a}' is a statement label.\",W038:\"'{a}' used out of scope.\",W039:\"'{a}' is not allowed.\",W040:\"Possible strict violation.\",W041:\"Use '{a}' to compare with '{b}'.\",W042:\"Avoid EOL escaping.\",W043:\"Bad escaping of EOL. Use option multistr if needed.\",W044:\"Bad or unnecessary escaping.\",W045:\"Bad number '{a}'.\",W046:\"Don't use extra leading zeros '{a}'.\",W047:\"A trailing decimal point can be confused with a dot: '{a}'.\",W048:\"Unexpected control character in regular expression.\",W049:\"Unexpected escaped character '{a}' in regular expression.\",W050:\"JavaScript URL.\",W051:\"Variables should not be deleted.\",W052:\"Unexpected '{a}'.\",W053:\"Do not use {a} as a constructor.\",W054:\"The Function constructor is a form of eval.\",W055:\"A constructor name should start with an uppercase letter.\",W056:\"Bad constructor.\",W057:\"Weird construction. Is 'new' necessary?\",W058:\"Missing '()' invoking a constructor.\",W059:\"Avoid arguments.{a}.\",W060:\"document.write can be a form of eval.\",W061:\"eval can be harmful.\",W062:\"Wrap an immediate function invocation in parens to assist the reader in understanding that the expression is the result of a function, and not the function itself.\",W063:\"Math is not a function.\",W064:\"Missing 'new' prefix when invoking a constructor.\",W065:\"Missing radix parameter.\",W066:\"Implied eval. Consider passing a function instead of a string.\",W067:\"Bad invocation.\",W068:\"Wrapping non-IIFE function literals in parens is unnecessary.\",W069:\"['{a}'] is better written in dot notation.\",W070:\"Extra comma. (it breaks older versions of IE)\",W071:\"This function has too many statements. ({a})\",W072:\"This function has too many parameters. ({a})\",W073:\"Blocks are nested too deeply. ({a})\",W074:\"This function's cyclomatic complexity is too high. ({a})\",W075:\"Duplicate {a} '{b}'.\",W076:\"Unexpected parameter '{a}' in get {b} function.\",W077:\"Expected a single parameter in set {a} function.\",W078:\"Setter is defined without getter.\",W079:\"Redefinition of '{a}'.\",W080:\"It's not necessary to initialize '{a}' to 'undefined'.\",W081:null,W082:\"Function declarations should not be placed in blocks. Use a function expression or move the statement to the top of the outer function.\",W083:\"Don't make functions within a loop.\",W084:\"Assignment in conditional expression\",W085:\"Don't use 'with'.\",W086:\"Expected a 'break' statement before '{a}'.\",W087:\"Forgotten 'debugger' statement?\",W088:\"Creating global 'for' variable. Should be 'for (var {a} ...'.\",W089:\"The body of a for in should be wrapped in an if statement to filter unwanted properties from the prototype.\",W090:\"'{a}' is not a statement label.\",W091:null,W093:\"Did you mean to return a conditional instead of an assignment?\",W094:\"Unexpected comma.\",W095:\"Expected a string and instead saw {a}.\",W096:\"The '{a}' key may produce unexpected results.\",W097:'Use the function form of \"use strict\".',W098:\"'{a}' is defined but never used.\",W099:null,W100:\"This character may get silently deleted by one or more browsers.\",W101:\"Line is too long.\",W102:null,W103:\"The '{a}' property is deprecated.\",W104:\"'{a}' is available in ES{b} (use 'esversion: {b}') or Mozilla JS extensions (use moz).\",W105:\"Unexpected {a} in '{b}'.\",W106:\"Identifier '{a}' is not in camel case.\",W107:\"Script URL.\",W108:\"Strings must use doublequote.\",W109:\"Strings must use singlequote.\",W110:\"Mixed double and single quotes.\",W112:\"Unclosed string.\",W113:\"Control character in string: {a}.\",W114:\"Avoid {a}.\",W115:\"Octal literals are not allowed in strict mode.\",W116:\"Expected '{a}' and instead saw '{b}'.\",W117:\"'{a}' is not defined.\",W118:\"'{a}' is only available in Mozilla JavaScript extensions (use moz option).\",W119:\"'{a}' is only available in ES{b} (use 'esversion: {b}').\",W120:\"You might be leaking a variable ({a}) here.\",W121:\"Extending prototype of native object: '{a}'.\",W122:\"Invalid typeof value '{a}'\",W123:\"'{a}' is already defined in outer scope.\",W124:\"A generator function shall contain a yield statement.\",W125:\"This line contains non-breaking spaces: http://jshint.com/doc/options/#nonbsp\",W126:\"Unnecessary grouping operator.\",W127:\"Unexpected use of a comma operator.\",W128:\"Empty array elements acequire elision=true.\",W129:\"'{a}' is defined in a future version of JavaScript. Use a different variable name to avoid migration issues.\",W130:\"Invalid element after rest element.\",W131:\"Invalid parameter after rest parameter.\",W132:\"`var` declarations are forbidden. Use `let` or `const` instead.\",W133:\"Invalid for-{a} loop left-hand-side: {b}.\",W134:\"The '{a}' option is only available when linting ECMAScript {b} code.\",W135:\"{a} may not be supported by non-browser environments.\",W136:\"'{a}' must be in function scope.\",W137:\"Empty destructuring.\",W138:\"Regular parameters should not come after default parameters.\"},info={I001:\"Comma warnings can be turned off with 'laxcomma'.\",I002:null,I003:\"ES5 option is now set per default\"};exports.errors={},exports.warnings={},exports.info={},_.each(errors,function(desc,code){exports.errors[code]={code:code,desc:desc}}),_.each(warnings,function(desc,code){exports.warnings[code]={code:code,desc:desc}}),_.each(info,function(desc,code){exports.info[code]={code:code,desc:desc}})},{\"../lodash\":\"/node_modules/jshint/lodash.js\"}],\"/node_modules/jshint/src/name-stack.js\":[function(_dereq_,module){\"use strict\";function NameStack(){this._stack=[]}Object.defineProperty(NameStack.prototype,\"length\",{get:function(){return this._stack.length}}),NameStack.prototype.push=function(){this._stack.push(null)},NameStack.prototype.pop=function(){this._stack.pop()},NameStack.prototype.set=function(token){this._stack[this.length-1]=token},NameStack.prototype.infer=function(){var type,nameToken=this._stack[this.length-1],prefix=\"\";return nameToken&&\"class\"!==nameToken.type||(nameToken=this._stack[this.length-2]),nameToken?(type=nameToken.type,\"(string)\"!==type&&\"(number)\"!==type&&\"(identifier)\"!==type&&\"default\"!==type?\"(expression)\":(nameToken.accessorType&&(prefix=nameToken.accessorType+\" \"),prefix+nameToken.value)):\"(empty)\"},module.exports=NameStack},{}],\"/node_modules/jshint/src/options.js\":[function(_dereq_,module,exports){\"use strict\";exports.bool={enforcing:{bitwise:!0,freeze:!0,camelcase:!0,curly:!0,eqeqeq:!0,futurehostile:!0,notypeof:!0,es3:!0,es5:!0,forin:!0,funcscope:!0,immed:!0,iterator:!0,newcap:!0,noarg:!0,nocomma:!0,noempty:!0,nonbsp:!0,nonew:!0,undef:!0,singleGroups:!1,varstmt:!1,enforceall:!1},relaxing:{asi:!0,multistr:!0,debug:!0,boss:!0,evil:!0,globalstrict:!0,plusplus:!0,proto:!0,scripturl:!0,sub:!0,supernew:!0,laxbreak:!0,laxcomma:!0,validthis:!0,withstmt:!0,moz:!0,noyield:!0,eqnull:!0,lastsemic:!0,loopfunc:!0,expr:!0,esnext:!0,elision:!0},environments:{mootools:!0,couch:!0,jasmine:!0,jquery:!0,node:!0,qunit:!0,rhino:!0,shelljs:!0,prototypejs:!0,yui:!0,mocha:!0,module:!0,wsh:!0,worker:!0,nonstandard:!0,browser:!0,browserify:!0,devel:!0,dojo:!0,typed:!0,phantom:!0},obsolete:{onecase:!0,regexp:!0,regexdash:!0}},exports.val={maxlen:!1,indent:!1,maxerr:!1,predef:!1,globals:!1,quotmark:!1,scope:!1,maxstatements:!1,maxdepth:!1,maxparams:!1,maxcomplexity:!1,shadow:!1,strict:!0,unused:!0,latedef:!1,ignore:!1,ignoreDelimiters:!1,esversion:5},exports.inverted={bitwise:!0,forin:!0,newcap:!0,plusplus:!0,regexp:!0,undef:!0,eqeqeq:!0,strict:!0},exports.validNames=Object.keys(exports.val).concat(Object.keys(exports.bool.relaxing)).concat(Object.keys(exports.bool.enforcing)).concat(Object.keys(exports.bool.obsolete)).concat(Object.keys(exports.bool.environments)),exports.renamed={eqeq:\"eqeqeq\",windows:\"wsh\",sloppy:\"strict\"},exports.removed={nomen:!0,onevar:!0,passfail:!0,white:!0,gcl:!0,smarttabs:!0,trailing:!0},exports.noenforceall={varstmt:!0,strict:!0}},{}],\"/node_modules/jshint/src/reg.js\":[function(_dereq_,module,exports){\"use strict\";exports.unsafeString=/@cc|<\\/?|script|\\]\\s*\\]|<\\s*!|&lt/i,exports.unsafeChars=/[\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/,exports.needEsc=/[\\u0000-\\u001f&<\"\\/\\\\\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/,exports.needEscGlobal=/[\\u0000-\\u001f&<\"\\/\\\\\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/g,exports.starSlash=/\\*\\//,exports.identifier=/^([a-zA-Z_$][a-zA-Z0-9_$]*)$/,exports.javascriptURL=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\\s*:/i,exports.fallsThrough=/^\\s*falls?\\sthrough\\s*$/,exports.maxlenException=/^(?:(?:\\/\\/|\\/\\*|\\*) ?)?[^ ]+$/},{}],\"/node_modules/jshint/src/scope-manager.js\":[function(_dereq_,module){\"use strict\";var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),marker={},scopeManager=function(state,predefined,exported,declared){function _newScope(type){_current={\"(labels)\":Object.create(null),\"(usages)\":Object.create(null),\"(breakLabels)\":Object.create(null),\"(parent)\":_current,\"(type)\":type,\"(params)\":\"functionparams\"===type||\"catchparams\"===type?[]:null},_scopeStack.push(_current)}function warning(code,token){emitter.emit(\"warning\",{code:code,token:token,data:_.slice(arguments,2)})}function error(code,token){emitter.emit(\"warning\",{code:code,token:token,data:_.slice(arguments,2)})}function _setupUsages(labelName){_current[\"(usages)\"][labelName]||(_current[\"(usages)\"][labelName]={\"(modified)\":[],\"(reassigned)\":[],\"(tokens)\":[]})}function _checkForUnused(){if(\"functionparams\"===_current[\"(type)\"])return _checkParams(),void 0;var curentLabels=_current[\"(labels)\"];for(var labelName in curentLabels)curentLabels[labelName]&&\"exception\"!==curentLabels[labelName][\"(type)\"]&&curentLabels[labelName][\"(unused)\"]&&_warnUnused(labelName,curentLabels[labelName][\"(token)\"],\"var\")}function _checkParams(){var params=_current[\"(params)\"];if(params)for(var unused_opt,param=params.pop();param;){var label=_current[\"(labels)\"][param];if(unused_opt=_getUnusedOption(state.funct[\"(unusedOption)\"]),\"undefined\"===param)return;if(label[\"(unused)\"])_warnUnused(param,label[\"(token)\"],\"param\",state.funct[\"(unusedOption)\"]);else if(\"last-param\"===unused_opt)return;param=params.pop()}}function _getLabel(labelName){for(var i=_scopeStack.length-1;i>=0;--i){var scopeLabels=_scopeStack[i][\"(labels)\"];if(scopeLabels[labelName])return scopeLabels}}function usedSoFarInCurrentFunction(labelName){for(var i=_scopeStack.length-1;i>=0;i--){var current=_scopeStack[i];if(current[\"(usages)\"][labelName])return current[\"(usages)\"][labelName];if(current===_currentFunctBody)break}return!1}function _checkOuterShadow(labelName,token){if(\"outer\"===state.option.shadow)for(var isGlobal=\"global\"===_currentFunctBody[\"(type)\"],isNewFunction=\"functionparams\"===_current[\"(type)\"],outsideCurrentFunction=!isGlobal,i=0;_scopeStack.length>i;i++){var stackItem=_scopeStack[i];isNewFunction||_scopeStack[i+1]!==_currentFunctBody||(outsideCurrentFunction=!1),outsideCurrentFunction&&stackItem[\"(labels)\"][labelName]&&warning(\"W123\",token,labelName),stackItem[\"(breakLabels)\"][labelName]&&warning(\"W123\",token,labelName)}}function _latedefWarning(type,labelName,token){state.option.latedef&&(state.option.latedef===!0&&\"function\"===type||\"function\"!==type)&&warning(\"W003\",token,labelName)}var _current,_scopeStack=[];_newScope(\"global\"),_current[\"(predefined)\"]=predefined;var _currentFunctBody=_current,usedPredefinedAndGlobals=Object.create(null),impliedGlobals=Object.create(null),unuseds=[],emitter=new events.EventEmitter,_getUnusedOption=function(unused_opt){return void 0===unused_opt&&(unused_opt=state.option.unused),unused_opt===!0&&(unused_opt=\"last-param\"),unused_opt},_warnUnused=function(name,tkn,type,unused_opt){var line=tkn.line,chr=tkn.from,raw_name=tkn.raw_text||name;unused_opt=_getUnusedOption(unused_opt);var warnable_types={vars:[\"var\"],\"last-param\":[\"var\",\"param\"],strict:[\"var\",\"param\",\"last-param\"]};unused_opt&&warnable_types[unused_opt]&&-1!==warnable_types[unused_opt].indexOf(type)&&warning(\"W098\",{line:line,from:chr},raw_name),(unused_opt||\"var\"===type)&&unuseds.push({name:name,line:line,character:chr})},scopeManagerInst={on:function(names,listener){names.split(\" \").forEach(function(name){emitter.on(name,listener)})},isPredefined:function(labelName){return!this.has(labelName)&&_.has(_scopeStack[0][\"(predefined)\"],labelName)},stack:function(type){var previousScope=_current;_newScope(type),type||\"functionparams\"!==previousScope[\"(type)\"]||(_current[\"(isFuncBody)\"]=!0,_current[\"(context)\"]=_currentFunctBody,_currentFunctBody=_current)},unstack:function(){var i,j,subScope=_scopeStack.length>1?_scopeStack[_scopeStack.length-2]:null,isUnstackingFunctionBody=_current===_currentFunctBody,isUnstackingFunctionParams=\"functionparams\"===_current[\"(type)\"],isUnstackingFunctionOuter=\"functionouter\"===_current[\"(type)\"],currentUsages=_current[\"(usages)\"],currentLabels=_current[\"(labels)\"],usedLabelNameList=Object.keys(currentUsages);for(currentUsages.__proto__&&-1===usedLabelNameList.indexOf(\"__proto__\")&&usedLabelNameList.push(\"__proto__\"),i=0;usedLabelNameList.length>i;i++){var usedLabelName=usedLabelNameList[i],usage=currentUsages[usedLabelName],usedLabel=currentLabels[usedLabelName];if(usedLabel){var usedLabelType=usedLabel[\"(type)\"];if(usedLabel[\"(useOutsideOfScope)\"]&&!state.option.funcscope){var usedTokens=usage[\"(tokens)\"];if(usedTokens)for(j=0;usedTokens.length>j;j++)usedLabel[\"(function)\"]===usedTokens[j][\"(function)\"]&&error(\"W038\",usedTokens[j],usedLabelName)}if(_current[\"(labels)\"][usedLabelName][\"(unused)\"]=!1,\"const\"===usedLabelType&&usage[\"(modified)\"])for(j=0;usage[\"(modified)\"].length>j;j++)error(\"E013\",usage[\"(modified)\"][j],usedLabelName);if((\"function\"===usedLabelType||\"class\"===usedLabelType)&&usage[\"(reassigned)\"])for(j=0;usage[\"(reassigned)\"].length>j;j++)error(\"W021\",usage[\"(reassigned)\"][j],usedLabelName,usedLabelType)}else if(isUnstackingFunctionOuter&&(state.funct[\"(isCapturing)\"]=!0),subScope)if(subScope[\"(usages)\"][usedLabelName]){var subScopeUsage=subScope[\"(usages)\"][usedLabelName];subScopeUsage[\"(modified)\"]=subScopeUsage[\"(modified)\"].concat(usage[\"(modified)\"]),subScopeUsage[\"(tokens)\"]=subScopeUsage[\"(tokens)\"].concat(usage[\"(tokens)\"]),subScopeUsage[\"(reassigned)\"]=subScopeUsage[\"(reassigned)\"].concat(usage[\"(reassigned)\"]),subScopeUsage[\"(onlyUsedSubFunction)\"]=!1}else subScope[\"(usages)\"][usedLabelName]=usage,isUnstackingFunctionBody&&(subScope[\"(usages)\"][usedLabelName][\"(onlyUsedSubFunction)\"]=!0);else if(\"boolean\"==typeof _current[\"(predefined)\"][usedLabelName]){if(delete declared[usedLabelName],usedPredefinedAndGlobals[usedLabelName]=marker,_current[\"(predefined)\"][usedLabelName]===!1&&usage[\"(reassigned)\"])for(j=0;usage[\"(reassigned)\"].length>j;j++)warning(\"W020\",usage[\"(reassigned)\"][j])}else if(usage[\"(tokens)\"])for(j=0;usage[\"(tokens)\"].length>j;j++){var undefinedToken=usage[\"(tokens)\"][j];undefinedToken.forgiveUndef||(state.option.undef&&!undefinedToken.ignoreUndef&&warning(\"W117\",undefinedToken,usedLabelName),impliedGlobals[usedLabelName]?impliedGlobals[usedLabelName].line.push(undefinedToken.line):impliedGlobals[usedLabelName]={name:usedLabelName,line:[undefinedToken.line]})}}if(subScope||Object.keys(declared).forEach(function(labelNotUsed){_warnUnused(labelNotUsed,declared[labelNotUsed],\"var\")}),subScope&&!isUnstackingFunctionBody&&!isUnstackingFunctionParams&&!isUnstackingFunctionOuter){var labelNames=Object.keys(currentLabels);for(i=0;labelNames.length>i;i++){var defLabelName=labelNames[i];currentLabels[defLabelName][\"(blockscoped)\"]||\"exception\"===currentLabels[defLabelName][\"(type)\"]||this.funct.has(defLabelName,{excludeCurrent:!0})||(subScope[\"(labels)\"][defLabelName]=currentLabels[defLabelName],\"global\"!==_currentFunctBody[\"(type)\"]&&(subScope[\"(labels)\"][defLabelName][\"(useOutsideOfScope)\"]=!0),delete currentLabels[defLabelName])}}_checkForUnused(),_scopeStack.pop(),isUnstackingFunctionBody&&(_currentFunctBody=_scopeStack[_.findLastIndex(_scopeStack,function(scope){return scope[\"(isFuncBody)\"]||\"global\"===scope[\"(type)\"]})]),_current=subScope},addParam:function(labelName,token,type){if(type=type||\"param\",\"exception\"===type){var previouslyDefinedLabelType=this.funct.labeltype(labelName);previouslyDefinedLabelType&&\"exception\"!==previouslyDefinedLabelType&&(state.option.node||warning(\"W002\",state.tokens.next,labelName))}if(_.has(_current[\"(labels)\"],labelName)?_current[\"(labels)\"][labelName].duplicated=!0:(_checkOuterShadow(labelName,token,type),_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":token,\"(unused)\":!0},_current[\"(params)\"].push(labelName)),_.has(_current[\"(usages)\"],labelName)){var usage=_current[\"(usages)\"][labelName];usage[\"(onlyUsedSubFunction)\"]?_latedefWarning(type,labelName,token):warning(\"E056\",token,labelName,type)}},validateParams:function(){if(\"global\"!==_currentFunctBody[\"(type)\"]){var isStrict=state.isStrict(),currentFunctParamScope=_currentFunctBody[\"(parent)\"];currentFunctParamScope[\"(params)\"]&&currentFunctParamScope[\"(params)\"].forEach(function(labelName){var label=currentFunctParamScope[\"(labels)\"][labelName];label&&label.duplicated&&(isStrict?warning(\"E011\",label[\"(token)\"],labelName):state.option.shadow!==!0&&warning(\"W004\",label[\"(token)\"],labelName))})}},getUsedOrDefinedGlobals:function(){var list=Object.keys(usedPredefinedAndGlobals);return usedPredefinedAndGlobals.__proto__===marker&&-1===list.indexOf(\"__proto__\")&&list.push(\"__proto__\"),list},getImpliedGlobals:function(){var values=_.values(impliedGlobals),hasProto=!1;return impliedGlobals.__proto__&&(hasProto=values.some(function(value){return\"__proto__\"===value.name}),hasProto||values.push(impliedGlobals.__proto__)),values},getUnuseds:function(){return unuseds},has:function(labelName){return Boolean(_getLabel(labelName))},labeltype:function(labelName){var scopeLabels=_getLabel(labelName);return scopeLabels?scopeLabels[labelName][\"(type)\"]:null},addExported:function(labelName){var globalLabels=_scopeStack[0][\"(labels)\"];if(_.has(declared,labelName))delete declared[labelName];else if(_.has(globalLabels,labelName))globalLabels[labelName][\"(unused)\"]=!1;else{for(var i=1;_scopeStack.length>i;i++){var scope=_scopeStack[i];if(scope[\"(type)\"])break;if(_.has(scope[\"(labels)\"],labelName)&&!scope[\"(labels)\"][labelName][\"(blockscoped)\"])return scope[\"(labels)\"][labelName][\"(unused)\"]=!1,void 0}exported[labelName]=!0}},setExported:function(labelName,token){this.block.use(labelName,token)\n},addlabel:function(labelName,opts){var type=opts.type,token=opts.token,isblockscoped=\"let\"===type||\"const\"===type||\"class\"===type,isexported=\"global\"===(isblockscoped?_current:_currentFunctBody)[\"(type)\"]&&_.has(exported,labelName);if(_checkOuterShadow(labelName,token,type),isblockscoped){var declaredInCurrentScope=_current[\"(labels)\"][labelName];if(declaredInCurrentScope||_current!==_currentFunctBody||\"global\"===_current[\"(type)\"]||(declaredInCurrentScope=!!_currentFunctBody[\"(parent)\"][\"(labels)\"][labelName]),!declaredInCurrentScope&&_current[\"(usages)\"][labelName]){var usage=_current[\"(usages)\"][labelName];usage[\"(onlyUsedSubFunction)\"]?_latedefWarning(type,labelName,token):warning(\"E056\",token,labelName,type)}declaredInCurrentScope?warning(\"E011\",token,labelName):\"outer\"===state.option.shadow&&scopeManagerInst.funct.has(labelName)&&warning(\"W004\",token,labelName),scopeManagerInst.block.add(labelName,type,token,!isexported)}else{var declaredInCurrentFunctionScope=scopeManagerInst.funct.has(labelName);!declaredInCurrentFunctionScope&&usedSoFarInCurrentFunction(labelName)&&_latedefWarning(type,labelName,token),scopeManagerInst.funct.has(labelName,{onlyBlockscoped:!0})?warning(\"E011\",token,labelName):state.option.shadow!==!0&&declaredInCurrentFunctionScope&&\"__proto__\"!==labelName&&\"global\"!==_currentFunctBody[\"(type)\"]&&warning(\"W004\",token,labelName),scopeManagerInst.funct.add(labelName,type,token,!isexported),\"global\"===_currentFunctBody[\"(type)\"]&&(usedPredefinedAndGlobals[labelName]=marker)}},funct:{labeltype:function(labelName,options){for(var onlyBlockscoped=options&&options.onlyBlockscoped,excludeParams=options&&options.excludeParams,currentScopeIndex=_scopeStack.length-(options&&options.excludeCurrent?2:1),i=currentScopeIndex;i>=0;i--){var current=_scopeStack[i];if(current[\"(labels)\"][labelName]&&(!onlyBlockscoped||current[\"(labels)\"][labelName][\"(blockscoped)\"]))return current[\"(labels)\"][labelName][\"(type)\"];var scopeCheck=excludeParams?_scopeStack[i-1]:current;if(scopeCheck&&\"functionparams\"===scopeCheck[\"(type)\"])return null}return null},hasBreakLabel:function(labelName){for(var i=_scopeStack.length-1;i>=0;i--){var current=_scopeStack[i];if(current[\"(breakLabels)\"][labelName])return!0;if(\"functionparams\"===current[\"(type)\"])return!1}return!1},has:function(labelName,options){return Boolean(this.labeltype(labelName,options))},add:function(labelName,type,tok,unused){_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":tok,\"(blockscoped)\":!1,\"(function)\":_currentFunctBody,\"(unused)\":unused}}},block:{isGlobal:function(){return\"global\"===_current[\"(type)\"]},use:function(labelName,token){var paramScope=_currentFunctBody[\"(parent)\"];paramScope&&paramScope[\"(labels)\"][labelName]&&\"param\"===paramScope[\"(labels)\"][labelName][\"(type)\"]&&(scopeManagerInst.funct.has(labelName,{excludeParams:!0,onlyBlockscoped:!0})||(paramScope[\"(labels)\"][labelName][\"(unused)\"]=!1)),token&&(state.ignored.W117||state.option.undef===!1)&&(token.ignoreUndef=!0),_setupUsages(labelName),token&&(token[\"(function)\"]=_currentFunctBody,_current[\"(usages)\"][labelName][\"(tokens)\"].push(token))},reassign:function(labelName,token){this.modify(labelName,token),_current[\"(usages)\"][labelName][\"(reassigned)\"].push(token)},modify:function(labelName,token){_setupUsages(labelName),_current[\"(usages)\"][labelName][\"(modified)\"].push(token)},add:function(labelName,type,tok,unused){_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":tok,\"(blockscoped)\":!0,\"(unused)\":unused}},addBreakLabel:function(labelName,opts){var token=opts.token;scopeManagerInst.funct.hasBreakLabel(labelName)?warning(\"E011\",token,labelName):\"outer\"===state.option.shadow&&(scopeManagerInst.funct.has(labelName)?warning(\"W004\",token,labelName):_checkOuterShadow(labelName,token)),_current[\"(breakLabels)\"][labelName]=token}}};return scopeManagerInst};module.exports=scopeManager},{\"../lodash\":\"/node_modules/jshint/lodash.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/state.js\":[function(_dereq_,module,exports){\"use strict\";var NameStack=_dereq_(\"./name-stack.js\"),state={syntax:{},isStrict:function(){return this.directive[\"use strict\"]||this.inClassBody||this.option.module||\"implied\"===this.option.strict},inMoz:function(){return this.option.moz},inES6:function(){return this.option.moz||this.option.esversion>=6},inES5:function(strict){return strict?!(this.option.esversion&&5!==this.option.esversion||this.option.moz):!this.option.esversion||this.option.esversion>=5||this.option.moz},reset:function(){this.tokens={prev:null,next:null,curr:null},this.option={},this.funct=null,this.ignored={},this.directive={},this.jsonMode=!1,this.jsonWarnings=[],this.lines=[],this.tab=\"\",this.cache={},this.ignoredLines={},this.forinifcheckneeded=!1,this.nameStack=new NameStack,this.inClassBody=!1}};exports.state=state},{\"./name-stack.js\":\"/node_modules/jshint/src/name-stack.js\"}],\"/node_modules/jshint/src/style.js\":[function(_dereq_,module,exports){\"use strict\";exports.register=function(linter){linter.on(\"Identifier\",function(data){linter.getOption(\"proto\")||\"__proto__\"===data.name&&linter.warn(\"W103\",{line:data.line,\"char\":data.char,data:[data.name,\"6\"]})}),linter.on(\"Identifier\",function(data){linter.getOption(\"iterator\")||\"__iterator__\"===data.name&&linter.warn(\"W103\",{line:data.line,\"char\":data.char,data:[data.name]})}),linter.on(\"Identifier\",function(data){linter.getOption(\"camelcase\")&&data.name.replace(/^_+|_+$/g,\"\").indexOf(\"_\")>-1&&!data.name.match(/^[A-Z0-9_]*$/)&&linter.warn(\"W106\",{line:data.line,\"char\":data.from,data:[data.name]})}),linter.on(\"String\",function(data){var code,quotmark=linter.getOption(\"quotmark\");quotmark&&(\"single\"===quotmark&&\"'\"!==data.quote&&(code=\"W109\"),\"double\"===quotmark&&'\"'!==data.quote&&(code=\"W108\"),quotmark===!0&&(linter.getCache(\"quotmark\")||linter.setCache(\"quotmark\",data.quote),linter.getCache(\"quotmark\")!==data.quote&&(code=\"W110\")),code&&linter.warn(code,{line:data.line,\"char\":data.char}))}),linter.on(\"Number\",function(data){\".\"===data.value.charAt(0)&&linter.warn(\"W008\",{line:data.line,\"char\":data.char,data:[data.value]}),\".\"===data.value.substr(data.value.length-1)&&linter.warn(\"W047\",{line:data.line,\"char\":data.char,data:[data.value]}),/^00+/.test(data.value)&&linter.warn(\"W046\",{line:data.line,\"char\":data.char,data:[data.value]})}),linter.on(\"String\",function(data){var re=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\\s*:/i;linter.getOption(\"scripturl\")||re.test(data.value)&&linter.warn(\"W107\",{line:data.line,\"char\":data.char})})}},{}],\"/node_modules/jshint/src/vars.js\":[function(_dereq_,module,exports){\"use strict\";exports.reservedVars={arguments:!1,NaN:!1},exports.ecmaIdentifiers={3:{Array:!1,Boolean:!1,Date:!1,decodeURI:!1,decodeURIComponent:!1,encodeURI:!1,encodeURIComponent:!1,Error:!1,eval:!1,EvalError:!1,Function:!1,hasOwnProperty:!1,isFinite:!1,isNaN:!1,Math:!1,Number:!1,Object:!1,parseInt:!1,parseFloat:!1,RangeError:!1,ReferenceError:!1,RegExp:!1,String:!1,SyntaxError:!1,TypeError:!1,URIError:!1},5:{JSON:!1},6:{Map:!1,Promise:!1,Proxy:!1,Reflect:!1,Set:!1,Symbol:!1,WeakMap:!1,WeakSet:!1}},exports.browser={Audio:!1,Blob:!1,addEventListener:!1,applicationCache:!1,atob:!1,blur:!1,btoa:!1,cancelAnimationFrame:!1,CanvasGradient:!1,CanvasPattern:!1,CanvasRenderingContext2D:!1,CSS:!1,clearInterval:!1,clearTimeout:!1,close:!1,closed:!1,Comment:!1,CustomEvent:!1,DOMParser:!1,defaultStatus:!1,Document:!1,document:!1,DocumentFragment:!1,Element:!1,ElementTimeControl:!1,Event:!1,event:!1,fetch:!1,FileReader:!1,FormData:!1,focus:!1,frames:!1,getComputedStyle:!1,HTMLElement:!1,HTMLAnchorElement:!1,HTMLBaseElement:!1,HTMLBlockquoteElement:!1,HTMLBodyElement:!1,HTMLBRElement:!1,HTMLButtonElement:!1,HTMLCanvasElement:!1,HTMLCollection:!1,HTMLDirectoryElement:!1,HTMLDivElement:!1,HTMLDListElement:!1,HTMLFieldSetElement:!1,HTMLFontElement:!1,HTMLFormElement:!1,HTMLFrameElement:!1,HTMLFrameSetElement:!1,HTMLHeadElement:!1,HTMLHeadingElement:!1,HTMLHRElement:!1,HTMLHtmlElement:!1,HTMLIFrameElement:!1,HTMLImageElement:!1,HTMLInputElement:!1,HTMLIsIndexElement:!1,HTMLLabelElement:!1,HTMLLayerElement:!1,HTMLLegendElement:!1,HTMLLIElement:!1,HTMLLinkElement:!1,HTMLMapElement:!1,HTMLMenuElement:!1,HTMLMetaElement:!1,HTMLModElement:!1,HTMLObjectElement:!1,HTMLOListElement:!1,HTMLOptGroupElement:!1,HTMLOptionElement:!1,HTMLParagraphElement:!1,HTMLParamElement:!1,HTMLPreElement:!1,HTMLQuoteElement:!1,HTMLScriptElement:!1,HTMLSelectElement:!1,HTMLStyleElement:!1,HTMLTableCaptionElement:!1,HTMLTableCellElement:!1,HTMLTableColElement:!1,HTMLTableElement:!1,HTMLTableRowElement:!1,HTMLTableSectionElement:!1,HTMLTemplateElement:!1,HTMLTextAreaElement:!1,HTMLTitleElement:!1,HTMLUListElement:!1,HTMLVideoElement:!1,history:!1,Image:!1,Intl:!1,length:!1,localStorage:!1,location:!1,matchMedia:!1,MessageChannel:!1,MessageEvent:!1,MessagePort:!1,MouseEvent:!1,moveBy:!1,moveTo:!1,MutationObserver:!1,name:!1,Node:!1,NodeFilter:!1,NodeList:!1,Notification:!1,navigator:!1,onbeforeunload:!0,onblur:!0,onerror:!0,onfocus:!0,onload:!0,onresize:!0,onunload:!0,open:!1,openDatabase:!1,opener:!1,Option:!1,parent:!1,performance:!1,print:!1,Range:!1,requestAnimationFrame:!1,removeEventListener:!1,resizeBy:!1,resizeTo:!1,screen:!1,scroll:!1,scrollBy:!1,scrollTo:!1,sessionStorage:!1,setInterval:!1,setTimeout:!1,SharedWorker:!1,status:!1,SVGAElement:!1,SVGAltGlyphDefElement:!1,SVGAltGlyphElement:!1,SVGAltGlyphItemElement:!1,SVGAngle:!1,SVGAnimateColorElement:!1,SVGAnimateElement:!1,SVGAnimateMotionElement:!1,SVGAnimateTransformElement:!1,SVGAnimatedAngle:!1,SVGAnimatedBoolean:!1,SVGAnimatedEnumeration:!1,SVGAnimatedInteger:!1,SVGAnimatedLength:!1,SVGAnimatedLengthList:!1,SVGAnimatedNumber:!1,SVGAnimatedNumberList:!1,SVGAnimatedPathData:!1,SVGAnimatedPoints:!1,SVGAnimatedPreserveAspectRatio:!1,SVGAnimatedRect:!1,SVGAnimatedString:!1,SVGAnimatedTransformList:!1,SVGAnimationElement:!1,SVGCSSRule:!1,SVGCircleElement:!1,SVGClipPathElement:!1,SVGColor:!1,SVGColorProfileElement:!1,SVGColorProfileRule:!1,SVGComponentTransferFunctionElement:!1,SVGCursorElement:!1,SVGDefsElement:!1,SVGDescElement:!1,SVGDocument:!1,SVGElement:!1,SVGElementInstance:!1,SVGElementInstanceList:!1,SVGEllipseElement:!1,SVGExternalResourcesRequired:!1,SVGFEBlendElement:!1,SVGFEColorMatrixElement:!1,SVGFEComponentTransferElement:!1,SVGFECompositeElement:!1,SVGFEConvolveMatrixElement:!1,SVGFEDiffuseLightingElement:!1,SVGFEDisplacementMapElement:!1,SVGFEDistantLightElement:!1,SVGFEFloodElement:!1,SVGFEFuncAElement:!1,SVGFEFuncBElement:!1,SVGFEFuncGElement:!1,SVGFEFuncRElement:!1,SVGFEGaussianBlurElement:!1,SVGFEImageElement:!1,SVGFEMergeElement:!1,SVGFEMergeNodeElement:!1,SVGFEMorphologyElement:!1,SVGFEOffsetElement:!1,SVGFEPointLightElement:!1,SVGFESpecularLightingElement:!1,SVGFESpotLightElement:!1,SVGFETileElement:!1,SVGFETurbulenceElement:!1,SVGFilterElement:!1,SVGFilterPrimitiveStandardAttributes:!1,SVGFitToViewBox:!1,SVGFontElement:!1,SVGFontFaceElement:!1,SVGFontFaceFormatElement:!1,SVGFontFaceNameElement:!1,SVGFontFaceSrcElement:!1,SVGFontFaceUriElement:!1,SVGForeignObjectElement:!1,SVGGElement:!1,SVGGlyphElement:!1,SVGGlyphRefElement:!1,SVGGradientElement:!1,SVGHKernElement:!1,SVGICCColor:!1,SVGImageElement:!1,SVGLangSpace:!1,SVGLength:!1,SVGLengthList:!1,SVGLineElement:!1,SVGLinearGradientElement:!1,SVGLocatable:!1,SVGMPathElement:!1,SVGMarkerElement:!1,SVGMaskElement:!1,SVGMatrix:!1,SVGMetadataElement:!1,SVGMissingGlyphElement:!1,SVGNumber:!1,SVGNumberList:!1,SVGPaint:!1,SVGPathElement:!1,SVGPathSeg:!1,SVGPathSegArcAbs:!1,SVGPathSegArcRel:!1,SVGPathSegClosePath:!1,SVGPathSegCurvetoCubicAbs:!1,SVGPathSegCurvetoCubicRel:!1,SVGPathSegCurvetoCubicSmoothAbs:!1,SVGPathSegCurvetoCubicSmoothRel:!1,SVGPathSegCurvetoQuadraticAbs:!1,SVGPathSegCurvetoQuadraticRel:!1,SVGPathSegCurvetoQuadraticSmoothAbs:!1,SVGPathSegCurvetoQuadraticSmoothRel:!1,SVGPathSegLinetoAbs:!1,SVGPathSegLinetoHorizontalAbs:!1,SVGPathSegLinetoHorizontalRel:!1,SVGPathSegLinetoRel:!1,SVGPathSegLinetoVerticalAbs:!1,SVGPathSegLinetoVerticalRel:!1,SVGPathSegList:!1,SVGPathSegMovetoAbs:!1,SVGPathSegMovetoRel:!1,SVGPatternElement:!1,SVGPoint:!1,SVGPointList:!1,SVGPolygonElement:!1,SVGPolylineElement:!1,SVGPreserveAspectRatio:!1,SVGRadialGradientElement:!1,SVGRect:!1,SVGRectElement:!1,SVGRenderingIntent:!1,SVGSVGElement:!1,SVGScriptElement:!1,SVGSetElement:!1,SVGStopElement:!1,SVGStringList:!1,SVGStylable:!1,SVGStyleElement:!1,SVGSwitchElement:!1,SVGSymbolElement:!1,SVGTRefElement:!1,SVGTSpanElement:!1,SVGTests:!1,SVGTextContentElement:!1,SVGTextElement:!1,SVGTextPathElement:!1,SVGTextPositioningElement:!1,SVGTitleElement:!1,SVGTransform:!1,SVGTransformList:!1,SVGTransformable:!1,SVGURIReference:!1,SVGUnitTypes:!1,SVGUseElement:!1,SVGVKernElement:!1,SVGViewElement:!1,SVGViewSpec:!1,SVGZoomAndPan:!1,Text:!1,TextDecoder:!1,TextEncoder:!1,TimeEvent:!1,top:!1,URL:!1,WebGLActiveInfo:!1,WebGLBuffer:!1,WebGLContextEvent:!1,WebGLFramebuffer:!1,WebGLProgram:!1,WebGLRenderbuffer:!1,WebGLRenderingContext:!1,WebGLShader:!1,WebGLShaderPrecisionFormat:!1,WebGLTexture:!1,WebGLUniformLocation:!1,WebSocket:!1,window:!1,Window:!1,Worker:!1,XDomainRequest:!1,XMLHttpRequest:!1,XMLSerializer:!1,XPathEvaluator:!1,XPathException:!1,XPathExpression:!1,XPathNamespace:!1,XPathNSResolver:!1,XPathResult:!1},exports.devel={alert:!1,confirm:!1,console:!1,Debug:!1,opera:!1,prompt:!1},exports.worker={importScripts:!0,postMessage:!0,self:!0,FileReaderSync:!0},exports.nonstandard={escape:!1,unescape:!1},exports.couch={require:!1,respond:!1,getRow:!1,emit:!1,send:!1,start:!1,sum:!1,log:!1,exports:!1,module:!1,provides:!1},exports.node={__filename:!1,__dirname:!1,GLOBAL:!1,global:!1,module:!1,acequire:!1,Buffer:!0,console:!0,exports:!0,process:!0,setTimeout:!0,clearTimeout:!0,setInterval:!0,clearInterval:!0,setImmediate:!0,clearImmediate:!0},exports.browserify={__filename:!1,__dirname:!1,global:!1,module:!1,acequire:!1,Buffer:!0,exports:!0,process:!0},exports.phantom={phantom:!0,acequire:!0,WebPage:!0,console:!0,exports:!0},exports.qunit={asyncTest:!1,deepEqual:!1,equal:!1,expect:!1,module:!1,notDeepEqual:!1,notEqual:!1,notPropEqual:!1,notStrictEqual:!1,ok:!1,propEqual:!1,QUnit:!1,raises:!1,start:!1,stop:!1,strictEqual:!1,test:!1,\"throws\":!1},exports.rhino={defineClass:!1,deserialize:!1,gc:!1,help:!1,importClass:!1,importPackage:!1,java:!1,load:!1,loadClass:!1,Packages:!1,print:!1,quit:!1,readFile:!1,readUrl:!1,runCommand:!1,seal:!1,serialize:!1,spawn:!1,sync:!1,toint32:!1,version:!1},exports.shelljs={target:!1,echo:!1,exit:!1,cd:!1,pwd:!1,ls:!1,find:!1,cp:!1,rm:!1,mv:!1,mkdir:!1,test:!1,cat:!1,sed:!1,grep:!1,which:!1,dirs:!1,pushd:!1,popd:!1,env:!1,exec:!1,chmod:!1,config:!1,error:!1,tempdir:!1},exports.typed={ArrayBuffer:!1,ArrayBufferView:!1,DataView:!1,Float32Array:!1,Float64Array:!1,Int16Array:!1,Int32Array:!1,Int8Array:!1,Uint16Array:!1,Uint32Array:!1,Uint8Array:!1,Uint8ClampedArray:!1},exports.wsh={ActiveXObject:!0,Enumerator:!0,GetObject:!0,ScriptEngine:!0,ScriptEngineBuildVersion:!0,ScriptEngineMajorVersion:!0,ScriptEngineMinorVersion:!0,VBArray:!0,WSH:!0,WScript:!0,XDomainRequest:!0},exports.dojo={dojo:!1,dijit:!1,dojox:!1,define:!1,require:!1},exports.jquery={$:!1,jQuery:!1},exports.mootools={$:!1,$$:!1,Asset:!1,Browser:!1,Chain:!1,Class:!1,Color:!1,Cookie:!1,Core:!1,Document:!1,DomReady:!1,DOMEvent:!1,DOMReady:!1,Drag:!1,Element:!1,Elements:!1,Event:!1,Events:!1,Fx:!1,Group:!1,Hash:!1,HtmlTable:!1,IFrame:!1,IframeShim:!1,InputValidator:!1,instanceOf:!1,Keyboard:!1,Locale:!1,Mask:!1,MooTools:!1,Native:!1,Options:!1,OverText:!1,Request:!1,Scroller:!1,Slick:!1,Slider:!1,Sortables:!1,Spinner:!1,Swiff:!1,Tips:!1,Type:!1,typeOf:!1,URI:!1,Window:!1},exports.prototypejs={$:!1,$$:!1,$A:!1,$F:!1,$H:!1,$R:!1,$break:!1,$continue:!1,$w:!1,Abstract:!1,Ajax:!1,Class:!1,Enumerable:!1,Element:!1,Event:!1,Field:!1,Form:!1,Hash:!1,Insertion:!1,ObjectRange:!1,PeriodicalExecuter:!1,Position:!1,Prototype:!1,Selector:!1,Template:!1,Toggle:!1,Try:!1,Autocompleter:!1,Builder:!1,Control:!1,Draggable:!1,Draggables:!1,Droppables:!1,Effect:!1,Sortable:!1,SortableObserver:!1,Sound:!1,Scriptaculous:!1},exports.yui={YUI:!1,Y:!1,YUI_config:!1},exports.mocha={mocha:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,context:!1,xcontext:!1,before:!1,after:!1,beforeEach:!1,afterEach:!1,suite:!1,test:!1,setup:!1,teardown:!1,suiteSetup:!1,suiteTeardown:!1},exports.jasmine={jasmine:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,beforeEach:!1,afterEach:!1,setFixtures:!1,loadFixtures:!1,spyOn:!1,expect:!1,runs:!1,waitsFor:!1,waits:!1,beforeAll:!1,afterAll:!1,fail:!1,fdescribe:!1,fit:!1,pending:!1}},{}]},{},[\"/node_modules/jshint/src/jshint.js\"])}),ace.define(\"ace/mode/javascript_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/worker/mirror\",\"ace/mode/javascript/jshint\"],function(acequire,exports,module){\"use strict\";function startRegex(arr){return RegExp(\"^(\"+arr.join(\"|\")+\")\")}var oop=acequire(\"../lib/oop\"),Mirror=acequire(\"../worker/mirror\").Mirror,lint=acequire(\"./javascript/jshint\").JSHINT,disabledWarningsRe=startRegex([\"Bad for in variable '(.+)'.\",'Missing \"use strict\"']),errorsRe=startRegex([\"Unexpected\",\"Expected \",\"Confusing (plus|minus)\",\"\\\\{a\\\\} unterminated regular expression\",\"Unclosed \",\"Unmatched \",\"Unbegun comment\",\"Bad invocation\",\"Missing space after\",\"Missing operator at\"]),infoRe=startRegex([\"Expected an assignment\",\"Bad escapement of EOL\",\"Unexpected comma\",\"Unexpected space\",\"Missing radix parameter.\",\"A leading decimal point can\",\"\\\\['{a}'\\\\] is better written in dot notation.\",\"'{a}' used out of scope\"]),JavaScriptWorker=exports.JavaScriptWorker=function(sender){Mirror.call(this,sender),this.setTimeout(500),this.setOptions()};oop.inherits(JavaScriptWorker,Mirror),function(){this.setOptions=function(options){this.options=options||{esnext:!0,moz:!0,devel:!0,browser:!0,node:!0,laxcomma:!0,laxbreak:!0,lastsemic:!0,onevar:!1,passfail:!1,maxerr:100,expr:!0,multistr:!0,globalstrict:!0},this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.changeOptions=function(newOptions){oop.mixin(this.options,newOptions),this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.isValidJS=function(str){try{eval(\"throw 0;\"+str)}catch(e){if(0===e)return!0}return!1},this.onUpdate=function(){var value=this.doc.getValue();if(value=value.replace(/^#!.*\\n/,\"\\n\"),!value)return this.sender.emit(\"annotate\",[]);var errors=[],maxErrorLevel=this.isValidJS(value)?\"warning\":\"error\";lint(value,this.options,this.options.globals);for(var results=lint.errors,errorAdded=!1,i=0;results.length>i;i++){var error=results[i];if(error){var raw=error.raw,type=\"warning\";if(\"Missing semicolon.\"==raw){var str=error.evidence.substr(error.character);str=str.charAt(str.search(/\\S/)),\"error\"==maxErrorLevel&&str&&/[\\w\\d{(['\"]/.test(str)?(error.reason='Missing \";\" before statement',type=\"error\"):type=\"info\"}else{if(disabledWarningsRe.test(raw))continue;infoRe.test(raw)?type=\"info\":errorsRe.test(raw)?(errorAdded=!0,type=maxErrorLevel):\"'{a}' is not defined.\"==raw?type=\"warning\":\"'{a}' is defined but never used.\"==raw&&(type=\"info\")}errors.push({row:error.line-1,column:error.character-1,text:error.reason,type:type,raw:raw})}}this.sender.emit(\"annotate\",errors)}}.call(JavaScriptWorker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports.id = 'ace/mode/xml_worker';
module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/xml/sax\",[\"require\",\"exports\",\"module\"],function(){function XMLReader(){}function parse(source,defaultNSMapCopy,entityMap,domBuilder,errorHandler){function fixedFromCharCode(code){if(code>65535){code-=65536;var surrogate1=55296+(code>>10),surrogate2=56320+(1023&code);return String.fromCharCode(surrogate1,surrogate2)}return String.fromCharCode(code)}function entityReplacer(a){var k=a.slice(1,-1);return k in entityMap?entityMap[k]:\"#\"===k.charAt(0)?fixedFromCharCode(parseInt(k.substr(1).replace(\"x\",\"0x\"))):(errorHandler.error(\"entity not found:\"+a),a)}function appendText(end){var xt=source.substring(start,end).replace(/&#?\\w+;/g,entityReplacer);locator&&position(start),domBuilder.characters(xt,0,end-start),start=end}function position(start,m){for(;start>=endPos&&(m=linePattern.exec(source));)startPos=m.index,endPos=startPos+m[0].length,locator.lineNumber++;locator.columnNumber=start-startPos+1}for(var startPos=0,endPos=0,linePattern=/.+(?:\\r\\n?|\\n)|.*$/g,locator=domBuilder.locator,parseStack=[{currentNSMap:defaultNSMapCopy}],closeMap={},start=0;;){var i=source.indexOf(\"<\",start);if(0>i){if(!source.substr(start).match(/^\\s*$/)){var doc=domBuilder.document,text=doc.createTextNode(source.substr(start));doc.appendChild(text),domBuilder.currentElement=text}return}switch(i>start&&appendText(i),source.charAt(i+1)){case\"/\":var config,end=source.indexOf(\">\",i+3),tagName=source.substring(i+2,end);if(!(parseStack.length>1)){errorHandler.fatalError(\"end tag name not found for: \"+tagName);break}config=parseStack.pop();var localNSMap=config.localNSMap;if(config.tagName!=tagName&&errorHandler.fatalError(\"end tag name: \"+tagName+\" does not match the current start tagName: \"+config.tagName),domBuilder.endElement(config.uri,config.localName,tagName),localNSMap)for(var prefix in localNSMap)domBuilder.endPrefixMapping(prefix);end++;break;case\"?\":locator&&position(i),end=parseInstruction(source,i,domBuilder);break;case\"!\":locator&&position(i),end=parseDCC(source,i,domBuilder,errorHandler);break;default:try{locator&&position(i);var el=new ElementAttributes,end=parseElementStartPart(source,i,el,entityReplacer,errorHandler),len=el.length;if(len&&locator){for(var backup=copyLocator(locator,{}),i=0;len>i;i++){var a=el[i];position(a.offset),a.offset=copyLocator(locator,{})}copyLocator(backup,locator)}!el.closed&&fixSelfClosed(source,end,el.tagName,closeMap)&&(el.closed=!0,entityMap.nbsp||errorHandler.warning(\"unclosed xml attribute\")),appendElement(el,domBuilder,parseStack),\"http://www.w3.org/1999/xhtml\"!==el.uri||el.closed?end++:end=parseHtmlSpecialContent(source,end,el.tagName,entityReplacer,domBuilder)}catch(e){errorHandler.error(\"element parse error: \"+e),end=-1}}0>end?appendText(i+1):start=end}}function copyLocator(f,t){return t.lineNumber=f.lineNumber,t.columnNumber=f.columnNumber,t}function parseElementStartPart(source,start,el,entityReplacer,errorHandler){for(var attrName,value,p=++start,s=S_TAG;;){var c=source.charAt(p);switch(c){case\"=\":if(s===S_ATTR)attrName=source.slice(start,p),s=S_EQ;else{if(s!==S_ATTR_S)throw Error(\"attribute equal must after attrName\");s=S_EQ}break;case\"'\":case'\"':if(s===S_EQ){if(start=p+1,p=source.indexOf(c,start),!(p>0))throw Error(\"attribute value no end '\"+c+\"' match\");value=source.slice(start,p).replace(/&#?\\w+;/g,entityReplacer),el.add(attrName,value,start-1),s=S_E}else{if(s!=S_V)throw Error('attribute value must after \"=\"');value=source.slice(start,p).replace(/&#?\\w+;/g,entityReplacer),el.add(attrName,value,start),errorHandler.warning('attribute \"'+attrName+'\" missed start quot('+c+\")!!\"),start=p+1,s=S_E}break;case\"/\":switch(s){case S_TAG:el.setTagName(source.slice(start,p));case S_E:case S_S:case S_C:s=S_C,el.closed=!0;case S_V:case S_ATTR:case S_ATTR_S:break;default:throw Error(\"attribute invalid close char('/')\")}break;case\"\":errorHandler.error(\"unexpected end of input\");case\">\":switch(s){case S_TAG:el.setTagName(source.slice(start,p));case S_E:case S_S:case S_C:break;case S_V:case S_ATTR:value=source.slice(start,p),\"/\"===value.slice(-1)&&(el.closed=!0,value=value.slice(0,-1));case S_ATTR_S:s===S_ATTR_S&&(value=attrName),s==S_V?(errorHandler.warning('attribute \"'+value+'\" missed quot(\")!!'),el.add(attrName,value.replace(/&#?\\w+;/g,entityReplacer),start)):(errorHandler.warning('attribute \"'+value+'\" missed value!! \"'+value+'\" instead!!'),el.add(value,value,start));break;case S_EQ:throw Error(\"attribute value missed!!\")}return p;case\"\":c=\" \";default:if(\" \">=c)switch(s){case S_TAG:el.setTagName(source.slice(start,p)),s=S_S;break;case S_ATTR:attrName=source.slice(start,p),s=S_ATTR_S;break;case S_V:var value=source.slice(start,p).replace(/&#?\\w+;/g,entityReplacer);errorHandler.warning('attribute \"'+value+'\" missed quot(\")!!'),el.add(attrName,value,start);case S_E:s=S_S}else switch(s){case S_ATTR_S:errorHandler.warning('attribute \"'+attrName+'\" missed value!! \"'+attrName+'\" instead!!'),el.add(attrName,attrName,start),start=p,s=S_ATTR;\nbreak;case S_E:errorHandler.warning('attribute space is acequired\"'+attrName+'\"!!');case S_S:s=S_ATTR,start=p;break;case S_EQ:s=S_V,start=p;break;case S_C:throw Error(\"elements closed character '/' and '>' must be connected to\")}}p++}}function appendElement(el,domBuilder,parseStack){for(var tagName=el.tagName,localNSMap=null,currentNSMap=parseStack[parseStack.length-1].currentNSMap,i=el.length;i--;){var a=el[i],qName=a.qName,value=a.value,nsp=qName.indexOf(\":\");if(nsp>0)var prefix=a.prefix=qName.slice(0,nsp),localName=qName.slice(nsp+1),nsPrefix=\"xmlns\"===prefix&&localName;else localName=qName,prefix=null,nsPrefix=\"xmlns\"===qName&&\"\";a.localName=localName,nsPrefix!==!1&&(null==localNSMap&&(localNSMap={},_copy(currentNSMap,currentNSMap={})),currentNSMap[nsPrefix]=localNSMap[nsPrefix]=value,a.uri=\"http://www.w3.org/2000/xmlns/\",domBuilder.startPrefixMapping(nsPrefix,value))}for(var i=el.length;i--;){a=el[i];var prefix=a.prefix;prefix&&(\"xml\"===prefix&&(a.uri=\"http://www.w3.org/XML/1998/namespace\"),\"xmlns\"!==prefix&&(a.uri=currentNSMap[prefix]))}var nsp=tagName.indexOf(\":\");nsp>0?(prefix=el.prefix=tagName.slice(0,nsp),localName=el.localName=tagName.slice(nsp+1)):(prefix=null,localName=el.localName=tagName);var ns=el.uri=currentNSMap[prefix||\"\"];if(domBuilder.startElement(ns,localName,tagName,el),el.closed){if(domBuilder.endElement(ns,localName,tagName),localNSMap)for(prefix in localNSMap)domBuilder.endPrefixMapping(prefix)}else el.currentNSMap=currentNSMap,el.localNSMap=localNSMap,parseStack.push(el)}function parseHtmlSpecialContent(source,elStartEnd,tagName,entityReplacer,domBuilder){if(/^(?:script|textarea)$/i.test(tagName)){var elEndStart=source.indexOf(\"</\"+tagName+\">\",elStartEnd),text=source.substring(elStartEnd+1,elEndStart);if(/[&<]/.test(text))return/^script$/i.test(tagName)?(domBuilder.characters(text,0,text.length),elEndStart):(text=text.replace(/&#?\\w+;/g,entityReplacer),domBuilder.characters(text,0,text.length),elEndStart)}return elStartEnd+1}function fixSelfClosed(source,elStartEnd,tagName,closeMap){var pos=closeMap[tagName];return null==pos&&(pos=closeMap[tagName]=source.lastIndexOf(\"</\"+tagName+\">\")),elStartEnd>pos}function _copy(source,target){for(var n in source)target[n]=source[n]}function parseDCC(source,start,domBuilder,errorHandler){var next=source.charAt(start+2);switch(next){case\"-\":if(\"-\"===source.charAt(start+3)){var end=source.indexOf(\"-->\",start+4);return end>start?(domBuilder.comment(source,start+4,end-start-4),end+3):(errorHandler.error(\"Unclosed comment\"),-1)}return-1;default:if(\"CDATA[\"==source.substr(start+3,6)){var end=source.indexOf(\"]]>\",start+9);return domBuilder.startCDATA(),domBuilder.characters(source,start+9,end-start-9),domBuilder.endCDATA(),end+3}var matchs=split(source,start),len=matchs.length;if(len>1&&/!doctype/i.test(matchs[0][0])){var name=matchs[1][0],pubid=len>3&&/^public$/i.test(matchs[2][0])&&matchs[3][0],sysid=len>4&&matchs[4][0],lastMatch=matchs[len-1];return domBuilder.startDTD(name,pubid&&pubid.replace(/^(['\"])(.*?)\\1$/,\"$2\"),sysid&&sysid.replace(/^(['\"])(.*?)\\1$/,\"$2\")),domBuilder.endDTD(),lastMatch.index+lastMatch[0].length}}return-1}function parseInstruction(source,start,domBuilder){var end=source.indexOf(\"?>\",start);if(end){var match=source.substring(start,end).match(/^<\\?(\\S*)\\s*([\\s\\S]*?)\\s*$/);return match?(match[0].length,domBuilder.processingInstruction(match[1],match[2]),end+2):-1}return-1}function ElementAttributes(){}function _set_proto_(thiz,parent){return thiz.__proto__=parent,thiz}function split(source,start){var match,buf=[],reg=/'[^']+'|\"[^\"]+\"|[^\\s<>\\/=]+=?|(\\/?\\s*>|<)/g;for(reg.lastIndex=start,reg.exec(source);match=reg.exec(source);)if(buf.push(match),match[1])return buf}var nameStartChar=/[A-Z_a-z\\xC0-\\xD6\\xD8-\\xF6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD]/,nameChar=RegExp(\"[\\\\-\\\\.0-9\"+nameStartChar.source.slice(1,-1)+\"·̀-ͯ\\\\ux203F-⁀]\"),tagNamePattern=RegExp(\"^\"+nameStartChar.source+nameChar.source+\"*(?::\"+nameStartChar.source+nameChar.source+\"*)?$\"),S_TAG=0,S_ATTR=1,S_ATTR_S=2,S_EQ=3,S_V=4,S_E=5,S_S=6,S_C=7;return XMLReader.prototype={parse:function(source,defaultNSMap,entityMap){var domBuilder=this.domBuilder;domBuilder.startDocument(),_copy(defaultNSMap,defaultNSMap={}),parse(source,defaultNSMap,entityMap,domBuilder,this.errorHandler),domBuilder.endDocument()}},ElementAttributes.prototype={setTagName:function(tagName){if(!tagNamePattern.test(tagName))throw Error(\"invalid tagName:\"+tagName);this.tagName=tagName},add:function(qName,value,offset){if(!tagNamePattern.test(qName))throw Error(\"invalid attribute:\"+qName);this[this.length++]={qName:qName,value:value,offset:offset}},length:0,getLocalName:function(i){return this[i].localName},getOffset:function(i){return this[i].offset},getQName:function(i){return this[i].qName},getURI:function(i){return this[i].uri},getValue:function(i){return this[i].value}},_set_proto_({},_set_proto_.prototype)instanceof _set_proto_||(_set_proto_=function(thiz,parent){function p(){}p.prototype=parent,p=new p;for(parent in thiz)p[parent]=thiz[parent];return p}),XMLReader}),ace.define(\"ace/mode/xml/dom\",[\"require\",\"exports\",\"module\"],function(){function copy(src,dest){for(var p in src)dest[p]=src[p]}function _extends(Class,Super){function t(){}var pt=Class.prototype;if(Object.create){var ppt=Object.create(Super.prototype);pt.__proto__=ppt}pt instanceof Super||(t.prototype=Super.prototype,t=new t,copy(pt,t),Class.prototype=pt=t),pt.constructor!=Class&&(\"function\"!=typeof Class&&console.error(\"unknow Class:\"+Class),pt.constructor=Class)}function DOMException(code,message){if(message instanceof Error)var error=message;else error=this,Error.call(this,ExceptionMessage[code]),this.message=ExceptionMessage[code],Error.captureStackTrace&&Error.captureStackTrace(this,DOMException);return error.code=code,message&&(this.message=this.message+\": \"+message),error}function NodeList(){}function LiveNodeList(node,refresh){this._node=node,this._refresh=refresh,_updateLiveList(this)}function _updateLiveList(list){var inc=list._node._inc||list._node.ownerDocument._inc;if(list._inc!=inc){var ls=list._refresh(list._node);__set__(list,\"length\",ls.length),copy(ls,list),list._inc=inc}}function NamedNodeMap(){}function _findNodeIndex(list,node){for(var i=list.length;i--;)if(list[i]===node)return i}function _addNamedNode(el,list,newAttr,oldAttr){if(oldAttr?list[_findNodeIndex(list,oldAttr)]=newAttr:list[list.length++]=newAttr,el){newAttr.ownerElement=el;var doc=el.ownerDocument;doc&&(oldAttr&&_onRemoveAttribute(doc,el,oldAttr),_onAddAttribute(doc,el,newAttr))}}function _removeNamedNode(el,list,attr){var i=_findNodeIndex(list,attr);if(!(i>=0))throw DOMException(NOT_FOUND_ERR,Error());for(var lastIndex=list.length-1;lastIndex>i;)list[i]=list[++i];if(list.length=lastIndex,el){var doc=el.ownerDocument;doc&&(_onRemoveAttribute(doc,el,attr),attr.ownerElement=null)}}function DOMImplementation(features){if(this._features={},features)for(var feature in features)this._features=features[feature]}function Node(){}function _xmlEncoder(c){return\"<\"==c&&\"&lt;\"||\">\"==c&&\"&gt;\"||\"&\"==c&&\"&amp;\"||'\"'==c&&\"&quot;\"||\"&#\"+c.charCodeAt()+\";\"}function _visitNode(node,callback){if(callback(node))return!0;if(node=node.firstChild)do if(_visitNode(node,callback))return!0;while(node=node.nextSibling)}function Document(){}function _onAddAttribute(doc,el,newAttr){doc&&doc._inc++;var ns=newAttr.namespaceURI;\"http://www.w3.org/2000/xmlns/\"==ns&&(el._nsMap[newAttr.prefix?newAttr.localName:\"\"]=newAttr.value)}function _onRemoveAttribute(doc,el,newAttr){doc&&doc._inc++;var ns=newAttr.namespaceURI;\"http://www.w3.org/2000/xmlns/\"==ns&&delete el._nsMap[newAttr.prefix?newAttr.localName:\"\"]}function _onUpdateChild(doc,el,newChild){if(doc&&doc._inc){doc._inc++;var cs=el.childNodes;if(newChild)cs[cs.length++]=newChild;else{for(var child=el.firstChild,i=0;child;)cs[i++]=child,child=child.nextSibling;cs.length=i}}}function _removeChild(parentNode,child){var previous=child.previousSibling,next=child.nextSibling;return previous?previous.nextSibling=next:parentNode.firstChild=next,next?next.previousSibling=previous:parentNode.lastChild=previous,_onUpdateChild(parentNode.ownerDocument,parentNode),child}function _insertBefore(parentNode,newChild,nextChild){var cp=newChild.parentNode;if(cp&&cp.removeChild(newChild),newChild.nodeType===DOCUMENT_FRAGMENT_NODE){var newFirst=newChild.firstChild;if(null==newFirst)return newChild;var newLast=newChild.lastChild}else newFirst=newLast=newChild;var pre=nextChild?nextChild.previousSibling:parentNode.lastChild;newFirst.previousSibling=pre,newLast.nextSibling=nextChild,pre?pre.nextSibling=newFirst:parentNode.firstChild=newFirst,null==nextChild?parentNode.lastChild=newLast:nextChild.previousSibling=newLast;do newFirst.parentNode=parentNode;while(newFirst!==newLast&&(newFirst=newFirst.nextSibling));return _onUpdateChild(parentNode.ownerDocument||parentNode,parentNode),newChild.nodeType==DOCUMENT_FRAGMENT_NODE&&(newChild.firstChild=newChild.lastChild=null),newChild}function _appendSingleChild(parentNode,newChild){var cp=newChild.parentNode;if(cp){var pre=parentNode.lastChild;cp.removeChild(newChild);var pre=parentNode.lastChild}var pre=parentNode.lastChild;return newChild.parentNode=parentNode,newChild.previousSibling=pre,newChild.nextSibling=null,pre?pre.nextSibling=newChild:parentNode.firstChild=newChild,parentNode.lastChild=newChild,_onUpdateChild(parentNode.ownerDocument,parentNode,newChild),newChild}function Element(){this._nsMap={}}function Attr(){}function CharacterData(){}function Text(){}function Comment(){}function CDATASection(){}function DocumentType(){}function Notation(){}function Entity(){}function EntityReference(){}function DocumentFragment(){}function ProcessingInstruction(){}function XMLSerializer(){}function serializeToString(node,buf){switch(node.nodeType){case ELEMENT_NODE:var attrs=node.attributes,len=attrs.length,child=node.firstChild,nodeName=node.tagName,isHTML=htmlns===node.namespaceURI;buf.push(\"<\",nodeName);for(var i=0;len>i;i++)serializeToString(attrs.item(i),buf,isHTML);if(child||isHTML&&!/^(?:meta|link|img|br|hr|input|button)$/i.test(nodeName)){if(buf.push(\">\"),isHTML&&/^script$/i.test(nodeName))child&&buf.push(child.data);else for(;child;)serializeToString(child,buf),child=child.nextSibling;buf.push(\"</\",nodeName,\">\")}else buf.push(\"/>\");return;case DOCUMENT_NODE:case DOCUMENT_FRAGMENT_NODE:for(var child=node.firstChild;child;)serializeToString(child,buf),child=child.nextSibling;return;case ATTRIBUTE_NODE:return buf.push(\" \",node.name,'=\"',node.value.replace(/[<&\"]/g,_xmlEncoder),'\"');case TEXT_NODE:return buf.push(node.data.replace(/[<&]/g,_xmlEncoder));case CDATA_SECTION_NODE:return buf.push(\"<![CDATA[\",node.data,\"]]>\");case COMMENT_NODE:return buf.push(\"<!--\",node.data,\"-->\");case DOCUMENT_TYPE_NODE:var pubid=node.publicId,sysid=node.systemId;if(buf.push(\"<!DOCTYPE \",node.name),pubid)buf.push(' PUBLIC \"',pubid),sysid&&\".\"!=sysid&&buf.push('\" \"',sysid),buf.push('\">');else if(sysid&&\".\"!=sysid)buf.push(' SYSTEM \"',sysid,'\">');else{var sub=node.internalSubset;sub&&buf.push(\" [\",sub,\"]\"),buf.push(\">\")}return;case PROCESSING_INSTRUCTION_NODE:return buf.push(\"<?\",node.target,\" \",node.data,\"?>\");case ENTITY_REFERENCE_NODE:return buf.push(\"&\",node.nodeName,\";\");default:buf.push(\"??\",node.nodeName)}}function importNode(doc,node,deep){var node2;switch(node.nodeType){case ELEMENT_NODE:node2=node.cloneNode(!1),node2.ownerDocument=doc;case DOCUMENT_FRAGMENT_NODE:break;case ATTRIBUTE_NODE:deep=!0}if(node2||(node2=node.cloneNode(!1)),node2.ownerDocument=doc,node2.parentNode=null,deep)for(var child=node.firstChild;child;)node2.appendChild(importNode(doc,child,deep)),child=child.nextSibling;return node2}function cloneNode(doc,node,deep){var node2=new node.constructor;for(var n in node){var v=node[n];\"object\"!=typeof v&&v!=node2[n]&&(node2[n]=v)}switch(node.childNodes&&(node2.childNodes=new NodeList),node2.ownerDocument=doc,node2.nodeType){case ELEMENT_NODE:var attrs=node.attributes,attrs2=node2.attributes=new NamedNodeMap,len=attrs.length;attrs2._ownerElement=node2;for(var i=0;len>i;i++)node2.setAttributeNode(cloneNode(doc,attrs.item(i),!0));break;case ATTRIBUTE_NODE:deep=!0}if(deep)for(var child=node.firstChild;child;)node2.appendChild(cloneNode(doc,child,deep)),child=child.nextSibling;return node2}function __set__(object,key,value){object[key]=value}function getTextContent(node){switch(node.nodeType){case 1:case 11:var buf=[];for(node=node.firstChild;node;)7!==node.nodeType&&8!==node.nodeType&&buf.push(getTextContent(node)),node=node.nextSibling;return buf.join(\"\");default:return node.nodeValue}}var htmlns=\"http://www.w3.org/1999/xhtml\",NodeType={},ELEMENT_NODE=NodeType.ELEMENT_NODE=1,ATTRIBUTE_NODE=NodeType.ATTRIBUTE_NODE=2,TEXT_NODE=NodeType.TEXT_NODE=3,CDATA_SECTION_NODE=NodeType.CDATA_SECTION_NODE=4,ENTITY_REFERENCE_NODE=NodeType.ENTITY_REFERENCE_NODE=5,ENTITY_NODE=NodeType.ENTITY_NODE=6,PROCESSING_INSTRUCTION_NODE=NodeType.PROCESSING_INSTRUCTION_NODE=7,COMMENT_NODE=NodeType.COMMENT_NODE=8,DOCUMENT_NODE=NodeType.DOCUMENT_NODE=9,DOCUMENT_TYPE_NODE=NodeType.DOCUMENT_TYPE_NODE=10,DOCUMENT_FRAGMENT_NODE=NodeType.DOCUMENT_FRAGMENT_NODE=11,NOTATION_NODE=NodeType.NOTATION_NODE=12,ExceptionCode={},ExceptionMessage={};ExceptionCode.INDEX_SIZE_ERR=(ExceptionMessage[1]=\"Index size error\",1),ExceptionCode.DOMSTRING_SIZE_ERR=(ExceptionMessage[2]=\"DOMString size error\",2),ExceptionCode.HIERARCHY_REQUEST_ERR=(ExceptionMessage[3]=\"Hierarchy request error\",3),ExceptionCode.WRONG_DOCUMENT_ERR=(ExceptionMessage[4]=\"Wrong document\",4),ExceptionCode.INVALID_CHARACTER_ERR=(ExceptionMessage[5]=\"Invalid character\",5),ExceptionCode.NO_DATA_ALLOWED_ERR=(ExceptionMessage[6]=\"No data allowed\",6),ExceptionCode.NO_MODIFICATION_ALLOWED_ERR=(ExceptionMessage[7]=\"No modification allowed\",7);var NOT_FOUND_ERR=ExceptionCode.NOT_FOUND_ERR=(ExceptionMessage[8]=\"Not found\",8);ExceptionCode.NOT_SUPPORTED_ERR=(ExceptionMessage[9]=\"Not supported\",9);var INUSE_ATTRIBUTE_ERR=ExceptionCode.INUSE_ATTRIBUTE_ERR=(ExceptionMessage[10]=\"Attribute in use\",10);ExceptionCode.INVALID_STATE_ERR=(ExceptionMessage[11]=\"Invalid state\",11),ExceptionCode.SYNTAX_ERR=(ExceptionMessage[12]=\"Syntax error\",12),ExceptionCode.INVALID_MODIFICATION_ERR=(ExceptionMessage[13]=\"Invalid modification\",13),ExceptionCode.NAMESPACE_ERR=(ExceptionMessage[14]=\"Invalid namespace\",14),ExceptionCode.INVALID_ACCESS_ERR=(ExceptionMessage[15]=\"Invalid access\",15),DOMException.prototype=Error.prototype,copy(ExceptionCode,DOMException),NodeList.prototype={length:0,item:function(index){return this[index]||null}},LiveNodeList.prototype.item=function(i){return _updateLiveList(this),this[i]},_extends(LiveNodeList,NodeList),NamedNodeMap.prototype={length:0,item:NodeList.prototype.item,getNamedItem:function(key){for(var i=this.length;i--;){var attr=this[i];if(attr.nodeName==key)return attr}},setNamedItem:function(attr){var el=attr.ownerElement;if(el&&el!=this._ownerElement)throw new DOMException(INUSE_ATTRIBUTE_ERR);var oldAttr=this.getNamedItem(attr.nodeName);return _addNamedNode(this._ownerElement,this,attr,oldAttr),oldAttr},setNamedItemNS:function(attr){var oldAttr,el=attr.ownerElement;if(el&&el!=this._ownerElement)throw new DOMException(INUSE_ATTRIBUTE_ERR);return oldAttr=this.getNamedItemNS(attr.namespaceURI,attr.localName),_addNamedNode(this._ownerElement,this,attr,oldAttr),oldAttr},removeNamedItem:function(key){var attr=this.getNamedItem(key);return _removeNamedNode(this._ownerElement,this,attr),attr},removeNamedItemNS:function(namespaceURI,localName){var attr=this.getNamedItemNS(namespaceURI,localName);return _removeNamedNode(this._ownerElement,this,attr),attr},getNamedItemNS:function(namespaceURI,localName){for(var i=this.length;i--;){var node=this[i];if(node.localName==localName&&node.namespaceURI==namespaceURI)return node}return null}},DOMImplementation.prototype={hasFeature:function(feature,version){var versions=this._features[feature.toLowerCase()];return versions&&(!version||version in versions)?!0:!1},createDocument:function(namespaceURI,qualifiedName,doctype){var doc=new Document;if(doc.implementation=this,doc.childNodes=new NodeList,doc.doctype=doctype,doctype&&doc.appendChild(doctype),qualifiedName){var root=doc.createElementNS(namespaceURI,qualifiedName);doc.appendChild(root)}return doc},createDocumentType:function(qualifiedName,publicId,systemId){var node=new DocumentType;return node.name=qualifiedName,node.nodeName=qualifiedName,node.publicId=publicId,node.systemId=systemId,node}},Node.prototype={firstChild:null,lastChild:null,previousSibling:null,nextSibling:null,attributes:null,parentNode:null,childNodes:null,ownerDocument:null,nodeValue:null,namespaceURI:null,prefix:null,localName:null,insertBefore:function(newChild,refChild){return _insertBefore(this,newChild,refChild)},replaceChild:function(newChild,oldChild){this.insertBefore(newChild,oldChild),oldChild&&this.removeChild(oldChild)},removeChild:function(oldChild){return _removeChild(this,oldChild)},appendChild:function(newChild){return this.insertBefore(newChild,null)},hasChildNodes:function(){return null!=this.firstChild},cloneNode:function(deep){return cloneNode(this.ownerDocument||this,this,deep)},normalize:function(){for(var child=this.firstChild;child;){var next=child.nextSibling;next&&next.nodeType==TEXT_NODE&&child.nodeType==TEXT_NODE?(this.removeChild(next),child.appendData(next.data)):(child.normalize(),child=next)}},isSupported:function(feature,version){return this.ownerDocument.implementation.hasFeature(feature,version)},hasAttributes:function(){return this.attributes.length>0},lookupPrefix:function(namespaceURI){for(var el=this;el;){var map=el._nsMap;if(map)for(var n in map)if(map[n]==namespaceURI)return n;el=2==el.nodeType?el.ownerDocument:el.parentNode}return null},lookupNamespaceURI:function(prefix){for(var el=this;el;){var map=el._nsMap;if(map&&prefix in map)return map[prefix];el=2==el.nodeType?el.ownerDocument:el.parentNode}return null},isDefaultNamespace:function(namespaceURI){var prefix=this.lookupPrefix(namespaceURI);return null==prefix}},copy(NodeType,Node),copy(NodeType,Node.prototype),Document.prototype={nodeName:\"#document\",nodeType:DOCUMENT_NODE,doctype:null,documentElement:null,_inc:1,insertBefore:function(newChild,refChild){if(newChild.nodeType==DOCUMENT_FRAGMENT_NODE){for(var child=newChild.firstChild;child;){var next=child.nextSibling;this.insertBefore(child,refChild),child=next}return newChild}return null==this.documentElement&&1==newChild.nodeType&&(this.documentElement=newChild),_insertBefore(this,newChild,refChild),newChild.ownerDocument=this,newChild},removeChild:function(oldChild){return this.documentElement==oldChild&&(this.documentElement=null),_removeChild(this,oldChild)},importNode:function(importedNode,deep){return importNode(this,importedNode,deep)},getElementById:function(id){var rtv=null;return _visitNode(this.documentElement,function(node){return 1==node.nodeType&&node.getAttribute(\"id\")==id?(rtv=node,!0):void 0}),rtv},createElement:function(tagName){var node=new Element;node.ownerDocument=this,node.nodeName=tagName,node.tagName=tagName,node.childNodes=new NodeList;var attrs=node.attributes=new NamedNodeMap;return attrs._ownerElement=node,node},createDocumentFragment:function(){var node=new DocumentFragment;return node.ownerDocument=this,node.childNodes=new NodeList,node},createTextNode:function(data){var node=new Text;return node.ownerDocument=this,node.appendData(data),node},createComment:function(data){var node=new Comment;return node.ownerDocument=this,node.appendData(data),node},createCDATASection:function(data){var node=new CDATASection;return node.ownerDocument=this,node.appendData(data),node},createProcessingInstruction:function(target,data){var node=new ProcessingInstruction;return node.ownerDocument=this,node.tagName=node.target=target,node.nodeValue=node.data=data,node},createAttribute:function(name){var node=new Attr;return node.ownerDocument=this,node.name=name,node.nodeName=name,node.localName=name,node.specified=!0,node},createEntityReference:function(name){var node=new EntityReference;return node.ownerDocument=this,node.nodeName=name,node},createElementNS:function(namespaceURI,qualifiedName){var node=new Element,pl=qualifiedName.split(\":\"),attrs=node.attributes=new NamedNodeMap;return node.childNodes=new NodeList,node.ownerDocument=this,node.nodeName=qualifiedName,node.tagName=qualifiedName,node.namespaceURI=namespaceURI,2==pl.length?(node.prefix=pl[0],node.localName=pl[1]):node.localName=qualifiedName,attrs._ownerElement=node,node},createAttributeNS:function(namespaceURI,qualifiedName){var node=new Attr,pl=qualifiedName.split(\":\");return node.ownerDocument=this,node.nodeName=qualifiedName,node.name=qualifiedName,node.namespaceURI=namespaceURI,node.specified=!0,2==pl.length?(node.prefix=pl[0],node.localName=pl[1]):node.localName=qualifiedName,node}},_extends(Document,Node),Element.prototype={nodeType:ELEMENT_NODE,hasAttribute:function(name){return null!=this.getAttributeNode(name)},getAttribute:function(name){var attr=this.getAttributeNode(name);return attr&&attr.value||\"\"},getAttributeNode:function(name){return this.attributes.getNamedItem(name)},setAttribute:function(name,value){var attr=this.ownerDocument.createAttribute(name);attr.value=attr.nodeValue=\"\"+value,this.setAttributeNode(attr)},removeAttribute:function(name){var attr=this.getAttributeNode(name);attr&&this.removeAttributeNode(attr)},appendChild:function(newChild){return newChild.nodeType===DOCUMENT_FRAGMENT_NODE?this.insertBefore(newChild,null):_appendSingleChild(this,newChild)},setAttributeNode:function(newAttr){return this.attributes.setNamedItem(newAttr)},setAttributeNodeNS:function(newAttr){return this.attributes.setNamedItemNS(newAttr)},removeAttributeNode:function(oldAttr){return this.attributes.removeNamedItem(oldAttr.nodeName)},removeAttributeNS:function(namespaceURI,localName){var old=this.getAttributeNodeNS(namespaceURI,localName);old&&this.removeAttributeNode(old)},hasAttributeNS:function(namespaceURI,localName){return null!=this.getAttributeNodeNS(namespaceURI,localName)},getAttributeNS:function(namespaceURI,localName){var attr=this.getAttributeNodeNS(namespaceURI,localName);return attr&&attr.value||\"\"},setAttributeNS:function(namespaceURI,qualifiedName,value){var attr=this.ownerDocument.createAttributeNS(namespaceURI,qualifiedName);attr.value=attr.nodeValue=\"\"+value,this.setAttributeNode(attr)},getAttributeNodeNS:function(namespaceURI,localName){return this.attributes.getNamedItemNS(namespaceURI,localName)},getElementsByTagName:function(tagName){return new LiveNodeList(this,function(base){var ls=[];return _visitNode(base,function(node){node===base||node.nodeType!=ELEMENT_NODE||\"*\"!==tagName&&node.tagName!=tagName||ls.push(node)}),ls})},getElementsByTagNameNS:function(namespaceURI,localName){return new LiveNodeList(this,function(base){var ls=[];return _visitNode(base,function(node){node===base||node.nodeType!==ELEMENT_NODE||\"*\"!==namespaceURI&&node.namespaceURI!==namespaceURI||\"*\"!==localName&&node.localName!=localName||ls.push(node)}),ls})}},Document.prototype.getElementsByTagName=Element.prototype.getElementsByTagName,Document.prototype.getElementsByTagNameNS=Element.prototype.getElementsByTagNameNS,_extends(Element,Node),Attr.prototype.nodeType=ATTRIBUTE_NODE,_extends(Attr,Node),CharacterData.prototype={data:\"\",substringData:function(offset,count){return this.data.substring(offset,offset+count)},appendData:function(text){text=this.data+text,this.nodeValue=this.data=text,this.length=text.length},insertData:function(offset,text){this.replaceData(offset,0,text)},appendChild:function(){throw Error(ExceptionMessage[3])},deleteData:function(offset,count){this.replaceData(offset,count,\"\")},replaceData:function(offset,count,text){var start=this.data.substring(0,offset),end=this.data.substring(offset+count);text=start+text+end,this.nodeValue=this.data=text,this.length=text.length}},_extends(CharacterData,Node),Text.prototype={nodeName:\"#text\",nodeType:TEXT_NODE,splitText:function(offset){var text=this.data,newText=text.substring(offset);text=text.substring(0,offset),this.data=this.nodeValue=text,this.length=text.length;var newNode=this.ownerDocument.createTextNode(newText);return this.parentNode&&this.parentNode.insertBefore(newNode,this.nextSibling),newNode}},_extends(Text,CharacterData),Comment.prototype={nodeName:\"#comment\",nodeType:COMMENT_NODE},_extends(Comment,CharacterData),CDATASection.prototype={nodeName:\"#cdata-section\",nodeType:CDATA_SECTION_NODE},_extends(CDATASection,CharacterData),DocumentType.prototype.nodeType=DOCUMENT_TYPE_NODE,_extends(DocumentType,Node),Notation.prototype.nodeType=NOTATION_NODE,_extends(Notation,Node),Entity.prototype.nodeType=ENTITY_NODE,_extends(Entity,Node),EntityReference.prototype.nodeType=ENTITY_REFERENCE_NODE,_extends(EntityReference,Node),DocumentFragment.prototype.nodeName=\"#document-fragment\",DocumentFragment.prototype.nodeType=DOCUMENT_FRAGMENT_NODE,_extends(DocumentFragment,Node),ProcessingInstruction.prototype.nodeType=PROCESSING_INSTRUCTION_NODE,_extends(ProcessingInstruction,Node),XMLSerializer.prototype.serializeToString=function(node){var buf=[];return serializeToString(node,buf),buf.join(\"\")},Node.prototype.toString=function(){return XMLSerializer.prototype.serializeToString(this)};try{Object.defineProperty&&(Object.defineProperty(LiveNodeList.prototype,\"length\",{get:function(){return _updateLiveList(this),this.$$length}}),Object.defineProperty(Node.prototype,\"textContent\",{get:function(){return getTextContent(this)},set:function(data){switch(this.nodeType){case 1:case 11:for(;this.firstChild;)this.removeChild(this.firstChild);(data||data+\"\")&&this.appendChild(this.ownerDocument.createTextNode(data));break;default:this.data=data,this.value=value,this.nodeValue=data}}}),__set__=function(object,key,value){object[\"$$\"+key]=value})}catch(e){}return DOMImplementation}),ace.define(\"ace/mode/xml/dom-parser\",[\"require\",\"exports\",\"module\",\"ace/mode/xml/sax\",\"ace/mode/xml/dom\"],function(acequire){\"use strict\";function DOMParser(options){this.options=options||{locator:{}}}function buildErrorHandler(errorImpl,domBuilder,locator){function build(key){var fn=errorImpl[key];if(!fn)if(isCallback)fn=2==errorImpl.length?function(msg){errorImpl(key,msg)}:errorImpl;else for(var i=arguments.length;--i&&!(fn=errorImpl[arguments[i]]););errorHandler[key]=fn&&function(msg){fn(msg+_locator(locator),msg,locator)}||function(){}}if(!errorImpl){if(domBuilder instanceof DOMHandler)return domBuilder;errorImpl=domBuilder}var errorHandler={},isCallback=errorImpl instanceof Function;return locator=locator||{},build(\"warning\",\"warn\"),build(\"error\",\"warn\",\"warning\"),build(\"fatalError\",\"warn\",\"warning\",\"error\"),errorHandler}function DOMHandler(){this.cdata=!1}function position(locator,node){node.lineNumber=locator.lineNumber,node.columnNumber=locator.columnNumber}function _locator(l){return l?\"\\n@\"+(l.systemId||\"\")+\"#[line:\"+l.lineNumber+\",col:\"+l.columnNumber+\"]\":void 0}function _toString(chars,start,length){return\"string\"==typeof chars?chars.substr(start,length):chars.length>=start+length||start?new java.lang.String(chars,start,length)+\"\":chars}function appendElement(hander,node){hander.currentElement?hander.currentElement.appendChild(node):hander.document.appendChild(node)}var XMLReader=acequire(\"./sax\"),DOMImplementation=acequire(\"./dom\");return DOMParser.prototype.parseFromString=function(source,mimeType){var options=this.options,sax=new XMLReader,domBuilder=options.domBuilder||new DOMHandler,errorHandler=options.errorHandler,locator=options.locator,defaultNSMap=options.xmlns||{},entityMap={lt:\"<\",gt:\">\",amp:\"&\",quot:'\"',apos:\"'\"};return locator&&domBuilder.setDocumentLocator(locator),sax.errorHandler=buildErrorHandler(errorHandler,domBuilder,locator),sax.domBuilder=options.domBuilder||domBuilder,/\\/x?html?$/.test(mimeType)&&(entityMap.nbsp=\" \",entityMap.copy=\"©\",defaultNSMap[\"\"]=\"http://www.w3.org/1999/xhtml\"),source?sax.parse(source,defaultNSMap,entityMap):sax.errorHandler.error(\"invalid document source\"),domBuilder.document},DOMHandler.prototype={startDocument:function(){this.document=(new DOMImplementation).createDocument(null,null,null),this.locator&&(this.document.documentURI=this.locator.systemId)},startElement:function(namespaceURI,localName,qName,attrs){var doc=this.document,el=doc.createElementNS(namespaceURI,qName||localName),len=attrs.length;appendElement(this,el),this.currentElement=el,this.locator&&position(this.locator,el);for(var i=0;len>i;i++){var namespaceURI=attrs.getURI(i),value=attrs.getValue(i),qName=attrs.getQName(i),attr=doc.createAttributeNS(namespaceURI,qName);attr.getOffset&&position(attr.getOffset(1),attr),attr.value=attr.nodeValue=value,el.setAttributeNode(attr)}},endElement:function(){var current=this.currentElement;current.tagName,this.currentElement=current.parentNode},startPrefixMapping:function(){},endPrefixMapping:function(){},processingInstruction:function(target,data){var ins=this.document.createProcessingInstruction(target,data);this.locator&&position(this.locator,ins),appendElement(this,ins)},ignorableWhitespace:function(){},characters:function(chars){if(chars=_toString.apply(this,arguments),this.currentElement&&chars){if(this.cdata){var charNode=this.document.createCDATASection(chars);this.currentElement.appendChild(charNode)}else{var charNode=this.document.createTextNode(chars);this.currentElement.appendChild(charNode)}this.locator&&position(this.locator,charNode)}},skippedEntity:function(){},endDocument:function(){this.document.normalize()},setDocumentLocator:function(locator){(this.locator=locator)&&(locator.lineNumber=0)},comment:function(chars){chars=_toString.apply(this,arguments);var comm=this.document.createComment(chars);this.locator&&position(this.locator,comm),appendElement(this,comm)},startCDATA:function(){this.cdata=!0},endCDATA:function(){this.cdata=!1},startDTD:function(name,publicId,systemId){var impl=this.document.implementation;if(impl&&impl.createDocumentType){var dt=impl.createDocumentType(name,publicId,systemId);this.locator&&position(this.locator,dt),appendElement(this,dt)}},warning:function(error){console.warn(error,_locator(this.locator))},error:function(error){console.error(error,_locator(this.locator))},fatalError:function(error){throw console.error(error,_locator(this.locator)),error}},\"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl\".replace(/\\w+/g,function(key){DOMHandler.prototype[key]=function(){return null}}),{DOMParser:DOMParser}}),ace.define(\"ace/mode/xml_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/lang\",\"ace/worker/mirror\",\"ace/mode/xml/dom-parser\"],function(acequire,exports){\"use strict\";var oop=acequire(\"../lib/oop\");acequire(\"../lib/lang\");var Mirror=acequire(\"../worker/mirror\").Mirror,DOMParser=acequire(\"./xml/dom-parser\").DOMParser,Worker=exports.Worker=function(sender){Mirror.call(this,sender),this.setTimeout(400),this.context=null};oop.inherits(Worker,Mirror),function(){this.setOptions=function(options){this.context=options.context},this.onUpdate=function(){var value=this.doc.getValue();if(value){var parser=new DOMParser,errors=[];parser.options.errorHandler={fatalError:function(fullMsg,errorMsg,locator){errors.push({row:locator.lineNumber,column:locator.columnNumber,text:errorMsg,type:\"error\"})},error:function(fullMsg,errorMsg,locator){errors.push({row:locator.lineNumber,column:locator.columnNumber,text:errorMsg,type:\"error\"})},warning:function(fullMsg,errorMsg,locator){errors.push({row:locator.lineNumber,column:locator.columnNumber,text:errorMsg,type:\"warning\"})}},parser.parseFromString(value),this.sender.emit(\"error\",errors)}}}.call(Worker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object\n}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports.id = 'ace/mode/css_worker';
module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/css/csslint\",[\"require\",\"exports\",\"module\"],function(acequire,exports,module){function objectToString(o){return Object.prototype.toString.call(o)}function clone(parent,circular,depth,prototype){function _clone(parent,depth){if(null===parent)return null;if(0==depth)return parent;var child;if(\"object\"!=typeof parent)return parent;if(util.isArray(parent))child=[];else if(util.isRegExp(parent))child=RegExp(parent.source,util.getRegExpFlags(parent)),parent.lastIndex&&(child.lastIndex=parent.lastIndex);else if(util.isDate(parent))child=new Date(parent.getTime());else{if(useBuffer&&Buffer.isBuffer(parent))return child=new Buffer(parent.length),parent.copy(child),child;child=prototype===void 0?Object.create(Object.getPrototypeOf(parent)):Object.create(prototype)}if(circular){var index=allParents.indexOf(parent);if(-1!=index)return allChildren[index];allParents.push(parent),allChildren.push(child)}for(var i in parent)child[i]=_clone(parent[i],depth-1);return child}var allParents=[],allChildren=[],useBuffer=\"undefined\"!=typeof Buffer;return circular===void 0&&(circular=!0),depth===void 0&&(depth=1/0),_clone(parent,depth)}function Reporter(lines,ruleset){this.messages=[],this.stats=[],this.lines=lines,this.ruleset=ruleset}var parserlib={};(function(){function EventTarget(){this._listeners={}}function StringReader(text){this._input=text.replace(/\\n\\r?/g,\"\\n\"),this._line=1,this._col=1,this._cursor=0}function SyntaxError(message,line,col){this.col=col,this.line=line,this.message=message}function SyntaxUnit(text,line,col,type){this.col=col,this.line=line,this.text=text,this.type=type}function TokenStreamBase(input,tokenData){this._reader=input?new StringReader(\"\"+input):null,this._token=null,this._tokenData=tokenData,this._lt=[],this._ltIndex=0,this._ltIndexCache=[]}EventTarget.prototype={constructor:EventTarget,addListener:function(type,listener){this._listeners[type]||(this._listeners[type]=[]),this._listeners[type].push(listener)},fire:function(event){if(\"string\"==typeof event&&(event={type:event}),event.target!==void 0&&(event.target=this),event.type===void 0)throw Error(\"Event object missing 'type' property.\");if(this._listeners[event.type])for(var listeners=this._listeners[event.type].concat(),i=0,len=listeners.length;len>i;i++)listeners[i].call(this,event)},removeListener:function(type,listener){if(this._listeners[type])for(var listeners=this._listeners[type],i=0,len=listeners.length;len>i;i++)if(listeners[i]===listener){listeners.splice(i,1);break}}},StringReader.prototype={constructor:StringReader,getCol:function(){return this._col},getLine:function(){return this._line},eof:function(){return this._cursor==this._input.length},peek:function(count){var c=null;return count=count===void 0?1:count,this._cursor<this._input.length&&(c=this._input.charAt(this._cursor+count-1)),c},read:function(){var c=null;return this._cursor<this._input.length&&(\"\\n\"==this._input.charAt(this._cursor)?(this._line++,this._col=1):this._col++,c=this._input.charAt(this._cursor++)),c},mark:function(){this._bookmark={cursor:this._cursor,line:this._line,col:this._col}},reset:function(){this._bookmark&&(this._cursor=this._bookmark.cursor,this._line=this._bookmark.line,this._col=this._bookmark.col,delete this._bookmark)},readTo:function(pattern){for(var c,buffer=\"\";buffer.length<pattern.length||buffer.lastIndexOf(pattern)!=buffer.length-pattern.length;){if(c=this.read(),!c)throw Error('Expected \"'+pattern+'\" at line '+this._line+\", col \"+this._col+\".\");buffer+=c}return buffer},readWhile:function(filter){for(var buffer=\"\",c=this.read();null!==c&&filter(c);)buffer+=c,c=this.read();return buffer},readMatch:function(matcher){var source=this._input.substring(this._cursor),value=null;return\"string\"==typeof matcher?0===source.indexOf(matcher)&&(value=this.readCount(matcher.length)):matcher instanceof RegExp&&matcher.test(source)&&(value=this.readCount(RegExp.lastMatch.length)),value},readCount:function(count){for(var buffer=\"\";count--;)buffer+=this.read();return buffer}},SyntaxError.prototype=Error(),SyntaxUnit.fromToken=function(token){return new SyntaxUnit(token.value,token.startLine,token.startCol)},SyntaxUnit.prototype={constructor:SyntaxUnit,valueOf:function(){return this.text},toString:function(){return this.text}},TokenStreamBase.createTokenData=function(tokens){var nameMap=[],typeMap={},tokenData=tokens.concat([]),i=0,len=tokenData.length+1;for(tokenData.UNKNOWN=-1,tokenData.unshift({name:\"EOF\"});len>i;i++)nameMap.push(tokenData[i].name),tokenData[tokenData[i].name]=i,tokenData[i].text&&(typeMap[tokenData[i].text]=i);return tokenData.name=function(tt){return nameMap[tt]},tokenData.type=function(c){return typeMap[c]},tokenData},TokenStreamBase.prototype={constructor:TokenStreamBase,match:function(tokenTypes,channel){tokenTypes instanceof Array||(tokenTypes=[tokenTypes]);\nfor(var tt=this.get(channel),i=0,len=tokenTypes.length;len>i;)if(tt==tokenTypes[i++])return!0;return this.unget(),!1},mustMatch:function(tokenTypes){var token;if(tokenTypes instanceof Array||(tokenTypes=[tokenTypes]),!this.match.apply(this,arguments))throw token=this.LT(1),new SyntaxError(\"Expected \"+this._tokenData[tokenTypes[0]].name+\" at line \"+token.startLine+\", col \"+token.startCol+\".\",token.startLine,token.startCol)},advance:function(tokenTypes,channel){for(;0!==this.LA(0)&&!this.match(tokenTypes,channel);)this.get();return this.LA(0)},get:function(channel){var token,info,tokenInfo=this._tokenData,i=(this._reader,0);if(tokenInfo.length,this._lt.length&&this._ltIndex>=0&&this._ltIndex<this._lt.length){for(i++,this._token=this._lt[this._ltIndex++],info=tokenInfo[this._token.type];void 0!==info.channel&&channel!==info.channel&&this._ltIndex<this._lt.length;)this._token=this._lt[this._ltIndex++],info=tokenInfo[this._token.type],i++;if((void 0===info.channel||channel===info.channel)&&this._ltIndex<=this._lt.length)return this._ltIndexCache.push(i),this._token.type}return token=this._getToken(),token.type>-1&&!tokenInfo[token.type].hide&&(token.channel=tokenInfo[token.type].channel,this._token=token,this._lt.push(token),this._ltIndexCache.push(this._lt.length-this._ltIndex+i),this._lt.length>5&&this._lt.shift(),this._ltIndexCache.length>5&&this._ltIndexCache.shift(),this._ltIndex=this._lt.length),info=tokenInfo[token.type],info&&(info.hide||void 0!==info.channel&&channel!==info.channel)?this.get(channel):token.type},LA:function(index){var tt,total=index;if(index>0){if(index>5)throw Error(\"Too much lookahead.\");for(;total;)tt=this.get(),total--;for(;index>total;)this.unget(),total++}else if(0>index){if(!this._lt[this._ltIndex+index])throw Error(\"Too much lookbehind.\");tt=this._lt[this._ltIndex+index].type}else tt=this._token.type;return tt},LT:function(index){return this.LA(index),this._lt[this._ltIndex+index-1]},peek:function(){return this.LA(1)},token:function(){return this._token},tokenName:function(tokenType){return 0>tokenType||tokenType>this._tokenData.length?\"UNKNOWN_TOKEN\":this._tokenData[tokenType].name},tokenType:function(tokenName){return this._tokenData[tokenName]||-1},unget:function(){if(!this._ltIndexCache.length)throw Error(\"Too much lookahead.\");this._ltIndex-=this._ltIndexCache.pop(),this._token=this._lt[this._ltIndex-1]}},parserlib.util={StringReader:StringReader,SyntaxError:SyntaxError,SyntaxUnit:SyntaxUnit,EventTarget:EventTarget,TokenStreamBase:TokenStreamBase}})(),function(){function Combinator(text,line,col){SyntaxUnit.call(this,text,line,col,Parser.COMBINATOR_TYPE),this.type=\"unknown\",/^\\s+$/.test(text)?this.type=\"descendant\":\">\"==text?this.type=\"child\":\"+\"==text?this.type=\"adjacent-sibling\":\"~\"==text&&(this.type=\"sibling\")}function MediaFeature(name,value){SyntaxUnit.call(this,\"(\"+name+(null!==value?\":\"+value:\"\")+\")\",name.startLine,name.startCol,Parser.MEDIA_FEATURE_TYPE),this.name=name,this.value=value}function MediaQuery(modifier,mediaType,features,line,col){SyntaxUnit.call(this,(modifier?modifier+\" \":\"\")+(mediaType?mediaType:\"\")+(mediaType&&features.length>0?\" and \":\"\")+features.join(\" and \"),line,col,Parser.MEDIA_QUERY_TYPE),this.modifier=modifier,this.mediaType=mediaType,this.features=features}function Parser(options){EventTarget.call(this),this.options=options||{},this._tokenStream=null}function PropertyName(text,hack,line,col){SyntaxUnit.call(this,text,line,col,Parser.PROPERTY_NAME_TYPE),this.hack=hack}function PropertyValue(parts,line,col){SyntaxUnit.call(this,parts.join(\" \"),line,col,Parser.PROPERTY_VALUE_TYPE),this.parts=parts}function PropertyValueIterator(value){this._i=0,this._parts=value.parts,this._marks=[],this.value=value}function PropertyValuePart(text,line,col){SyntaxUnit.call(this,text,line,col,Parser.PROPERTY_VALUE_PART_TYPE),this.type=\"unknown\";var temp;if(/^([+\\-]?[\\d\\.]+)([a-z]+)$/i.test(text))switch(this.type=\"dimension\",this.value=+RegExp.$1,this.units=RegExp.$2,this.units.toLowerCase()){case\"em\":case\"rem\":case\"ex\":case\"px\":case\"cm\":case\"mm\":case\"in\":case\"pt\":case\"pc\":case\"ch\":case\"vh\":case\"vw\":case\"vmax\":case\"vmin\":this.type=\"length\";break;case\"deg\":case\"rad\":case\"grad\":this.type=\"angle\";break;case\"ms\":case\"s\":this.type=\"time\";break;case\"hz\":case\"khz\":this.type=\"frequency\";break;case\"dpi\":case\"dpcm\":this.type=\"resolution\"}else/^([+\\-]?[\\d\\.]+)%$/i.test(text)?(this.type=\"percentage\",this.value=+RegExp.$1):/^([+\\-]?\\d+)$/i.test(text)?(this.type=\"integer\",this.value=+RegExp.$1):/^([+\\-]?[\\d\\.]+)$/i.test(text)?(this.type=\"number\",this.value=+RegExp.$1):/^#([a-f0-9]{3,6})/i.test(text)?(this.type=\"color\",temp=RegExp.$1,3==temp.length?(this.red=parseInt(temp.charAt(0)+temp.charAt(0),16),this.green=parseInt(temp.charAt(1)+temp.charAt(1),16),this.blue=parseInt(temp.charAt(2)+temp.charAt(2),16)):(this.red=parseInt(temp.substring(0,2),16),this.green=parseInt(temp.substring(2,4),16),this.blue=parseInt(temp.substring(4,6),16))):/^rgb\\(\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*\\)/i.test(text)?(this.type=\"color\",this.red=+RegExp.$1,this.green=+RegExp.$2,this.blue=+RegExp.$3):/^rgb\\(\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*\\)/i.test(text)?(this.type=\"color\",this.red=255*+RegExp.$1/100,this.green=255*+RegExp.$2/100,this.blue=255*+RegExp.$3/100):/^rgba\\(\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*([\\d\\.]+)\\s*\\)/i.test(text)?(this.type=\"color\",this.red=+RegExp.$1,this.green=+RegExp.$2,this.blue=+RegExp.$3,this.alpha=+RegExp.$4):/^rgba\\(\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*,\\s*([\\d\\.]+)\\s*\\)/i.test(text)?(this.type=\"color\",this.red=255*+RegExp.$1/100,this.green=255*+RegExp.$2/100,this.blue=255*+RegExp.$3/100,this.alpha=+RegExp.$4):/^hsl\\(\\s*(\\d+)\\s*,\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*\\)/i.test(text)?(this.type=\"color\",this.hue=+RegExp.$1,this.saturation=+RegExp.$2/100,this.lightness=+RegExp.$3/100):/^hsla\\(\\s*(\\d+)\\s*,\\s*(\\d+)%\\s*,\\s*(\\d+)%\\s*,\\s*([\\d\\.]+)\\s*\\)/i.test(text)?(this.type=\"color\",this.hue=+RegExp.$1,this.saturation=+RegExp.$2/100,this.lightness=+RegExp.$3/100,this.alpha=+RegExp.$4):/^url\\([\"']?([^\\)\"']+)[\"']?\\)/i.test(text)?(this.type=\"uri\",this.uri=RegExp.$1):/^([^\\(]+)\\(/i.test(text)?(this.type=\"function\",this.name=RegExp.$1,this.value=text):/^[\"'][^\"']*[\"']/.test(text)?(this.type=\"string\",this.value=eval(text)):Colors[text.toLowerCase()]?(this.type=\"color\",temp=Colors[text.toLowerCase()].substring(1),this.red=parseInt(temp.substring(0,2),16),this.green=parseInt(temp.substring(2,4),16),this.blue=parseInt(temp.substring(4,6),16)):/^[\\,\\/]$/.test(text)?(this.type=\"operator\",this.value=text):/^[a-z\\-_\\u0080-\\uFFFF][a-z0-9\\-_\\u0080-\\uFFFF]*$/i.test(text)&&(this.type=\"identifier\",this.value=text)}function Selector(parts,line,col){SyntaxUnit.call(this,parts.join(\" \"),line,col,Parser.SELECTOR_TYPE),this.parts=parts,this.specificity=Specificity.calculate(this)}function SelectorPart(elementName,modifiers,text,line,col){SyntaxUnit.call(this,text,line,col,Parser.SELECTOR_PART_TYPE),this.elementName=elementName,this.modifiers=modifiers}function SelectorSubPart(text,type,line,col){SyntaxUnit.call(this,text,line,col,Parser.SELECTOR_SUB_PART_TYPE),this.type=type,this.args=[]}function Specificity(a,b,c,d){this.a=a,this.b=b,this.c=c,this.d=d}function isHexDigit(c){return null!==c&&h.test(c)}function isDigit(c){return null!==c&&/\\d/.test(c)}function isWhitespace(c){return null!==c&&/\\s/.test(c)}function isNewLine(c){return null!==c&&nl.test(c)}function isNameStart(c){return null!==c&&/[a-z_\\u0080-\\uFFFF\\\\]/i.test(c)}function isNameChar(c){return null!==c&&(isNameStart(c)||/[0-9\\-\\\\]/.test(c))}function isIdentStart(c){return null!==c&&(isNameStart(c)||/\\-\\\\/.test(c))}function mix(receiver,supplier){for(var prop in supplier)supplier.hasOwnProperty(prop)&&(receiver[prop]=supplier[prop]);return receiver}function TokenStream(input){TokenStreamBase.call(this,input,Tokens)}function ValidationError(message,line,col){this.col=col,this.line=line,this.message=message}var EventTarget=parserlib.util.EventTarget,TokenStreamBase=parserlib.util.TokenStreamBase,StringReader=parserlib.util.StringReader,SyntaxError=parserlib.util.SyntaxError,SyntaxUnit=parserlib.util.SyntaxUnit,Colors={aliceblue:\"#f0f8ff\",antiquewhite:\"#faebd7\",aqua:\"#00ffff\",aquamarine:\"#7fffd4\",azure:\"#f0ffff\",beige:\"#f5f5dc\",bisque:\"#ffe4c4\",black:\"#000000\",blanchedalmond:\"#ffebcd\",blue:\"#0000ff\",blueviolet:\"#8a2be2\",brown:\"#a52a2a\",burlywood:\"#deb887\",cadetblue:\"#5f9ea0\",chartreuse:\"#7fff00\",chocolate:\"#d2691e\",coral:\"#ff7f50\",cornflowerblue:\"#6495ed\",cornsilk:\"#fff8dc\",crimson:\"#dc143c\",cyan:\"#00ffff\",darkblue:\"#00008b\",darkcyan:\"#008b8b\",darkgoldenrod:\"#b8860b\",darkgray:\"#a9a9a9\",darkgrey:\"#a9a9a9\",darkgreen:\"#006400\",darkkhaki:\"#bdb76b\",darkmagenta:\"#8b008b\",darkolivegreen:\"#556b2f\",darkorange:\"#ff8c00\",darkorchid:\"#9932cc\",darkred:\"#8b0000\",darksalmon:\"#e9967a\",darkseagreen:\"#8fbc8f\",darkslateblue:\"#483d8b\",darkslategray:\"#2f4f4f\",darkslategrey:\"#2f4f4f\",darkturquoise:\"#00ced1\",darkviolet:\"#9400d3\",deeppink:\"#ff1493\",deepskyblue:\"#00bfff\",dimgray:\"#696969\",dimgrey:\"#696969\",dodgerblue:\"#1e90ff\",firebrick:\"#b22222\",floralwhite:\"#fffaf0\",forestgreen:\"#228b22\",fuchsia:\"#ff00ff\",gainsboro:\"#dcdcdc\",ghostwhite:\"#f8f8ff\",gold:\"#ffd700\",goldenrod:\"#daa520\",gray:\"#808080\",grey:\"#808080\",green:\"#008000\",greenyellow:\"#adff2f\",honeydew:\"#f0fff0\",hotpink:\"#ff69b4\",indianred:\"#cd5c5c\",indigo:\"#4b0082\",ivory:\"#fffff0\",khaki:\"#f0e68c\",lavender:\"#e6e6fa\",lavenderblush:\"#fff0f5\",lawngreen:\"#7cfc00\",lemonchiffon:\"#fffacd\",lightblue:\"#add8e6\",lightcoral:\"#f08080\",lightcyan:\"#e0ffff\",lightgoldenrodyellow:\"#fafad2\",lightgray:\"#d3d3d3\",lightgrey:\"#d3d3d3\",lightgreen:\"#90ee90\",lightpink:\"#ffb6c1\",lightsalmon:\"#ffa07a\",lightseagreen:\"#20b2aa\",lightskyblue:\"#87cefa\",lightslategray:\"#778899\",lightslategrey:\"#778899\",lightsteelblue:\"#b0c4de\",lightyellow:\"#ffffe0\",lime:\"#00ff00\",limegreen:\"#32cd32\",linen:\"#faf0e6\",magenta:\"#ff00ff\",maroon:\"#800000\",mediumaquamarine:\"#66cdaa\",mediumblue:\"#0000cd\",mediumorchid:\"#ba55d3\",mediumpurple:\"#9370d8\",mediumseagreen:\"#3cb371\",mediumslateblue:\"#7b68ee\",mediumspringgreen:\"#00fa9a\",mediumturquoise:\"#48d1cc\",mediumvioletred:\"#c71585\",midnightblue:\"#191970\",mintcream:\"#f5fffa\",mistyrose:\"#ffe4e1\",moccasin:\"#ffe4b5\",navajowhite:\"#ffdead\",navy:\"#000080\",oldlace:\"#fdf5e6\",olive:\"#808000\",olivedrab:\"#6b8e23\",orange:\"#ffa500\",orangered:\"#ff4500\",orchid:\"#da70d6\",palegoldenrod:\"#eee8aa\",palegreen:\"#98fb98\",paleturquoise:\"#afeeee\",palevioletred:\"#d87093\",papayawhip:\"#ffefd5\",peachpuff:\"#ffdab9\",peru:\"#cd853f\",pink:\"#ffc0cb\",plum:\"#dda0dd\",powderblue:\"#b0e0e6\",purple:\"#800080\",red:\"#ff0000\",rosybrown:\"#bc8f8f\",royalblue:\"#4169e1\",saddlebrown:\"#8b4513\",salmon:\"#fa8072\",sandybrown:\"#f4a460\",seagreen:\"#2e8b57\",seashell:\"#fff5ee\",sienna:\"#a0522d\",silver:\"#c0c0c0\",skyblue:\"#87ceeb\",slateblue:\"#6a5acd\",slategray:\"#708090\",slategrey:\"#708090\",snow:\"#fffafa\",springgreen:\"#00ff7f\",steelblue:\"#4682b4\",tan:\"#d2b48c\",teal:\"#008080\",thistle:\"#d8bfd8\",tomato:\"#ff6347\",turquoise:\"#40e0d0\",violet:\"#ee82ee\",wheat:\"#f5deb3\",white:\"#ffffff\",whitesmoke:\"#f5f5f5\",yellow:\"#ffff00\",yellowgreen:\"#9acd32\",activeBorder:\"Active window border.\",activecaption:\"Active window caption.\",appworkspace:\"Background color of multiple document interface.\",background:\"Desktop background.\",buttonface:\"The face background color for 3-D elements that appear 3-D due to one layer of surrounding border.\",buttonhighlight:\"The color of the border facing the light source for 3-D elements that appear 3-D due to one layer of surrounding border.\",buttonshadow:\"The color of the border away from the light source for 3-D elements that appear 3-D due to one layer of surrounding border.\",buttontext:\"Text on push buttons.\",captiontext:\"Text in caption, size box, and scrollbar arrow box.\",graytext:\"Grayed (disabled) text. This color is set to #000 if the current display driver does not support a solid gray color.\",greytext:\"Greyed (disabled) text. This color is set to #000 if the current display driver does not support a solid grey color.\",highlight:\"Item(s) selected in a control.\",highlighttext:\"Text of item(s) selected in a control.\",inactiveborder:\"Inactive window border.\",inactivecaption:\"Inactive window caption.\",inactivecaptiontext:\"Color of text in an inactive caption.\",infobackground:\"Background color for tooltip controls.\",infotext:\"Text color for tooltip controls.\",menu:\"Menu background.\",menutext:\"Text in menus.\",scrollbar:\"Scroll bar gray area.\",threeddarkshadow:\"The color of the darker (generally outer) of the two borders away from the light source for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",threedface:\"The face background color for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",threedhighlight:\"The color of the lighter (generally outer) of the two borders facing the light source for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",threedlightshadow:\"The color of the darker (generally inner) of the two borders facing the light source for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",threedshadow:\"The color of the lighter (generally inner) of the two borders away from the light source for 3-D elements that appear 3-D due to two concentric layers of surrounding border.\",window:\"Window background.\",windowframe:\"Window frame.\",windowtext:\"Text in windows.\"};Combinator.prototype=new SyntaxUnit,Combinator.prototype.constructor=Combinator,MediaFeature.prototype=new SyntaxUnit,MediaFeature.prototype.constructor=MediaFeature,MediaQuery.prototype=new SyntaxUnit,MediaQuery.prototype.constructor=MediaQuery,Parser.DEFAULT_TYPE=0,Parser.COMBINATOR_TYPE=1,Parser.MEDIA_FEATURE_TYPE=2,Parser.MEDIA_QUERY_TYPE=3,Parser.PROPERTY_NAME_TYPE=4,Parser.PROPERTY_VALUE_TYPE=5,Parser.PROPERTY_VALUE_PART_TYPE=6,Parser.SELECTOR_TYPE=7,Parser.SELECTOR_PART_TYPE=8,Parser.SELECTOR_SUB_PART_TYPE=9,Parser.prototype=function(){var prop,proto=new EventTarget,additions={constructor:Parser,DEFAULT_TYPE:0,COMBINATOR_TYPE:1,MEDIA_FEATURE_TYPE:2,MEDIA_QUERY_TYPE:3,PROPERTY_NAME_TYPE:4,PROPERTY_VALUE_TYPE:5,PROPERTY_VALUE_PART_TYPE:6,SELECTOR_TYPE:7,SELECTOR_PART_TYPE:8,SELECTOR_SUB_PART_TYPE:9,_stylesheet:function(){var count,token,tt,tokenStream=this._tokenStream;for(this.fire(\"startstylesheet\"),this._charset(),this._skipCruft();tokenStream.peek()==Tokens.IMPORT_SYM;)this._import(),this._skipCruft();for(;tokenStream.peek()==Tokens.NAMESPACE_SYM;)this._namespace(),this._skipCruft();for(tt=tokenStream.peek();tt>Tokens.EOF;){try{switch(tt){case Tokens.MEDIA_SYM:this._media(),this._skipCruft();break;case Tokens.PAGE_SYM:this._page(),this._skipCruft();break;case Tokens.FONT_FACE_SYM:this._font_face(),this._skipCruft();break;case Tokens.KEYFRAMES_SYM:this._keyframes(),this._skipCruft();break;case Tokens.VIEWPORT_SYM:this._viewport(),this._skipCruft();break;case Tokens.UNKNOWN_SYM:if(tokenStream.get(),this.options.strict)throw new SyntaxError(\"Unknown @ rule.\",tokenStream.LT(0).startLine,tokenStream.LT(0).startCol);for(this.fire({type:\"error\",error:null,message:\"Unknown @ rule: \"+tokenStream.LT(0).value+\".\",line:tokenStream.LT(0).startLine,col:tokenStream.LT(0).startCol}),count=0;tokenStream.advance([Tokens.LBRACE,Tokens.RBRACE])==Tokens.LBRACE;)count++;for(;count;)tokenStream.advance([Tokens.RBRACE]),count--;break;case Tokens.S:this._readWhitespace();break;default:if(!this._ruleset())switch(tt){case Tokens.CHARSET_SYM:throw token=tokenStream.LT(1),this._charset(!1),new SyntaxError(\"@charset not allowed here.\",token.startLine,token.startCol);case Tokens.IMPORT_SYM:throw token=tokenStream.LT(1),this._import(!1),new SyntaxError(\"@import not allowed here.\",token.startLine,token.startCol);case Tokens.NAMESPACE_SYM:throw token=tokenStream.LT(1),this._namespace(!1),new SyntaxError(\"@namespace not allowed here.\",token.startLine,token.startCol);default:tokenStream.get(),this._unexpectedToken(tokenStream.token())}}}catch(ex){if(!(ex instanceof SyntaxError)||this.options.strict)throw ex;this.fire({type:\"error\",error:ex,message:ex.message,line:ex.line,col:ex.col})}tt=tokenStream.peek()}tt!=Tokens.EOF&&this._unexpectedToken(tokenStream.token()),this.fire(\"endstylesheet\")},_charset:function(emit){var charset,token,line,col,tokenStream=this._tokenStream;tokenStream.match(Tokens.CHARSET_SYM)&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),tokenStream.mustMatch(Tokens.STRING),token=tokenStream.token(),charset=token.value,this._readWhitespace(),tokenStream.mustMatch(Tokens.SEMICOLON),emit!==!1&&this.fire({type:\"charset\",charset:charset,line:line,col:col}))},_import:function(emit){var uri,importToken,tokenStream=this._tokenStream,mediaList=[];tokenStream.mustMatch(Tokens.IMPORT_SYM),importToken=tokenStream.token(),this._readWhitespace(),tokenStream.mustMatch([Tokens.STRING,Tokens.URI]),uri=tokenStream.token().value.replace(/^(?:url\\()?[\"']?([^\"']+?)[\"']?\\)?$/,\"$1\"),this._readWhitespace(),mediaList=this._media_query_list(),tokenStream.mustMatch(Tokens.SEMICOLON),this._readWhitespace(),emit!==!1&&this.fire({type:\"import\",uri:uri,media:mediaList,line:importToken.startLine,col:importToken.startCol})},_namespace:function(emit){var line,col,prefix,uri,tokenStream=this._tokenStream;tokenStream.mustMatch(Tokens.NAMESPACE_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),tokenStream.match(Tokens.IDENT)&&(prefix=tokenStream.token().value,this._readWhitespace()),tokenStream.mustMatch([Tokens.STRING,Tokens.URI]),uri=tokenStream.token().value.replace(/(?:url\\()?[\"']([^\"']+)[\"']\\)?/,\"$1\"),this._readWhitespace(),tokenStream.mustMatch(Tokens.SEMICOLON),this._readWhitespace(),emit!==!1&&this.fire({type:\"namespace\",prefix:prefix,uri:uri,line:line,col:col})},_media:function(){var line,col,mediaList,tokenStream=this._tokenStream;for(tokenStream.mustMatch(Tokens.MEDIA_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),mediaList=this._media_query_list(),tokenStream.mustMatch(Tokens.LBRACE),this._readWhitespace(),this.fire({type:\"startmedia\",media:mediaList,line:line,col:col});;)if(tokenStream.peek()==Tokens.PAGE_SYM)this._page();else if(tokenStream.peek()==Tokens.FONT_FACE_SYM)this._font_face();else if(tokenStream.peek()==Tokens.VIEWPORT_SYM)this._viewport();else if(!this._ruleset())break;tokenStream.mustMatch(Tokens.RBRACE),this._readWhitespace(),this.fire({type:\"endmedia\",media:mediaList,line:line,col:col})},_media_query_list:function(){var tokenStream=this._tokenStream,mediaList=[];for(this._readWhitespace(),(tokenStream.peek()==Tokens.IDENT||tokenStream.peek()==Tokens.LPAREN)&&mediaList.push(this._media_query());tokenStream.match(Tokens.COMMA);)this._readWhitespace(),mediaList.push(this._media_query());return mediaList},_media_query:function(){var tokenStream=this._tokenStream,type=null,ident=null,token=null,expressions=[];if(tokenStream.match(Tokens.IDENT)&&(ident=tokenStream.token().value.toLowerCase(),\"only\"!=ident&&\"not\"!=ident?(tokenStream.unget(),ident=null):token=tokenStream.token()),this._readWhitespace(),tokenStream.peek()==Tokens.IDENT?(type=this._media_type(),null===token&&(token=tokenStream.token())):tokenStream.peek()==Tokens.LPAREN&&(null===token&&(token=tokenStream.LT(1)),expressions.push(this._media_expression())),null===type&&0===expressions.length)return null;for(this._readWhitespace();tokenStream.match(Tokens.IDENT);)\"and\"!=tokenStream.token().value.toLowerCase()&&this._unexpectedToken(tokenStream.token()),this._readWhitespace(),expressions.push(this._media_expression());return new MediaQuery(ident,type,expressions,token.startLine,token.startCol)},_media_type:function(){return this._media_feature()},_media_expression:function(){var token,tokenStream=this._tokenStream,feature=null,expression=null;return tokenStream.mustMatch(Tokens.LPAREN),feature=this._media_feature(),this._readWhitespace(),tokenStream.match(Tokens.COLON)&&(this._readWhitespace(),token=tokenStream.LT(1),expression=this._expression()),tokenStream.mustMatch(Tokens.RPAREN),this._readWhitespace(),new MediaFeature(feature,expression?new SyntaxUnit(expression,token.startLine,token.startCol):null)},_media_feature:function(){var tokenStream=this._tokenStream;return tokenStream.mustMatch(Tokens.IDENT),SyntaxUnit.fromToken(tokenStream.token())},_page:function(){var line,col,tokenStream=this._tokenStream,identifier=null,pseudoPage=null;tokenStream.mustMatch(Tokens.PAGE_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),tokenStream.match(Tokens.IDENT)&&(identifier=tokenStream.token().value,\"auto\"===identifier.toLowerCase()&&this._unexpectedToken(tokenStream.token())),tokenStream.peek()==Tokens.COLON&&(pseudoPage=this._pseudo_page()),this._readWhitespace(),this.fire({type:\"startpage\",id:identifier,pseudo:pseudoPage,line:line,col:col}),this._readDeclarations(!0,!0),this.fire({type:\"endpage\",id:identifier,pseudo:pseudoPage,line:line,col:col})},_margin:function(){var line,col,tokenStream=this._tokenStream,marginSym=this._margin_sym();return marginSym?(line=tokenStream.token().startLine,col=tokenStream.token().startCol,this.fire({type:\"startpagemargin\",margin:marginSym,line:line,col:col}),this._readDeclarations(!0),this.fire({type:\"endpagemargin\",margin:marginSym,line:line,col:col}),!0):!1},_margin_sym:function(){var tokenStream=this._tokenStream;return tokenStream.match([Tokens.TOPLEFTCORNER_SYM,Tokens.TOPLEFT_SYM,Tokens.TOPCENTER_SYM,Tokens.TOPRIGHT_SYM,Tokens.TOPRIGHTCORNER_SYM,Tokens.BOTTOMLEFTCORNER_SYM,Tokens.BOTTOMLEFT_SYM,Tokens.BOTTOMCENTER_SYM,Tokens.BOTTOMRIGHT_SYM,Tokens.BOTTOMRIGHTCORNER_SYM,Tokens.LEFTTOP_SYM,Tokens.LEFTMIDDLE_SYM,Tokens.LEFTBOTTOM_SYM,Tokens.RIGHTTOP_SYM,Tokens.RIGHTMIDDLE_SYM,Tokens.RIGHTBOTTOM_SYM])?SyntaxUnit.fromToken(tokenStream.token()):null},_pseudo_page:function(){var tokenStream=this._tokenStream;return tokenStream.mustMatch(Tokens.COLON),tokenStream.mustMatch(Tokens.IDENT),tokenStream.token().value},_font_face:function(){var line,col,tokenStream=this._tokenStream;tokenStream.mustMatch(Tokens.FONT_FACE_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),this.fire({type:\"startfontface\",line:line,col:col}),this._readDeclarations(!0),this.fire({type:\"endfontface\",line:line,col:col})},_viewport:function(){var line,col,tokenStream=this._tokenStream;tokenStream.mustMatch(Tokens.VIEWPORT_SYM),line=tokenStream.token().startLine,col=tokenStream.token().startCol,this._readWhitespace(),this.fire({type:\"startviewport\",line:line,col:col}),this._readDeclarations(!0),this.fire({type:\"endviewport\",line:line,col:col})},_operator:function(inFunction){var tokenStream=this._tokenStream,token=null;return(tokenStream.match([Tokens.SLASH,Tokens.COMMA])||inFunction&&tokenStream.match([Tokens.PLUS,Tokens.STAR,Tokens.MINUS]))&&(token=tokenStream.token(),this._readWhitespace()),token?PropertyValuePart.fromToken(token):null},_combinator:function(){var token,tokenStream=this._tokenStream,value=null;return tokenStream.match([Tokens.PLUS,Tokens.GREATER,Tokens.TILDE])&&(token=tokenStream.token(),value=new Combinator(token.value,token.startLine,token.startCol),this._readWhitespace()),value},_unary_operator:function(){var tokenStream=this._tokenStream;return tokenStream.match([Tokens.MINUS,Tokens.PLUS])?tokenStream.token().value:null},_property:function(){var tokenValue,token,line,col,tokenStream=this._tokenStream,value=null,hack=null;return tokenStream.peek()==Tokens.STAR&&this.options.starHack&&(tokenStream.get(),token=tokenStream.token(),hack=token.value,line=token.startLine,col=token.startCol),tokenStream.match(Tokens.IDENT)&&(token=tokenStream.token(),tokenValue=token.value,\"_\"==tokenValue.charAt(0)&&this.options.underscoreHack&&(hack=\"_\",tokenValue=tokenValue.substring(1)),value=new PropertyName(tokenValue,hack,line||token.startLine,col||token.startCol),this._readWhitespace()),value},_ruleset:function(){var tt,selectors,tokenStream=this._tokenStream;try{selectors=this._selectors_group()}catch(ex){if(!(ex instanceof SyntaxError)||this.options.strict)throw ex;if(this.fire({type:\"error\",error:ex,message:ex.message,line:ex.line,col:ex.col}),tt=tokenStream.advance([Tokens.RBRACE]),tt!=Tokens.RBRACE)throw ex;return!0}return selectors&&(this.fire({type:\"startrule\",selectors:selectors,line:selectors[0].line,col:selectors[0].col}),this._readDeclarations(!0),this.fire({type:\"endrule\",selectors:selectors,line:selectors[0].line,col:selectors[0].col})),selectors},_selectors_group:function(){var selector,tokenStream=this._tokenStream,selectors=[];if(selector=this._selector(),null!==selector)for(selectors.push(selector);tokenStream.match(Tokens.COMMA);)this._readWhitespace(),selector=this._selector(),null!==selector?selectors.push(selector):this._unexpectedToken(tokenStream.LT(1));return selectors.length?selectors:null},_selector:function(){var tokenStream=this._tokenStream,selector=[],nextSelector=null,combinator=null,ws=null;if(nextSelector=this._simple_selector_sequence(),null===nextSelector)return null;for(selector.push(nextSelector);;)if(combinator=this._combinator(),null!==combinator)selector.push(combinator),nextSelector=this._simple_selector_sequence(),null===nextSelector?this._unexpectedToken(tokenStream.LT(1)):selector.push(nextSelector);else{if(!this._readWhitespace())break;ws=new Combinator(tokenStream.token().value,tokenStream.token().startLine,tokenStream.token().startCol),combinator=this._combinator(),nextSelector=this._simple_selector_sequence(),null===nextSelector?null!==combinator&&this._unexpectedToken(tokenStream.LT(1)):(null!==combinator?selector.push(combinator):selector.push(ws),selector.push(nextSelector))}return new Selector(selector,selector[0].line,selector[0].col)},_simple_selector_sequence:function(){var line,col,tokenStream=this._tokenStream,elementName=null,modifiers=[],selectorText=\"\",components=[function(){return tokenStream.match(Tokens.HASH)?new SelectorSubPart(tokenStream.token().value,\"id\",tokenStream.token().startLine,tokenStream.token().startCol):null},this._class,this._attrib,this._pseudo,this._negation],i=0,len=components.length,component=null;for(line=tokenStream.LT(1).startLine,col=tokenStream.LT(1).startCol,elementName=this._type_selector(),elementName||(elementName=this._universal()),null!==elementName&&(selectorText+=elementName);;){if(tokenStream.peek()===Tokens.S)break;for(;len>i&&null===component;)component=components[i++].call(this);if(null===component){if(\"\"===selectorText)return null;break}i=0,modifiers.push(component),selectorText+=\"\"+component,component=null}return\"\"!==selectorText?new SelectorPart(elementName,modifiers,selectorText,line,col):null},_type_selector:function(){var tokenStream=this._tokenStream,ns=this._namespace_prefix(),elementName=this._element_name();return elementName?(ns&&(elementName.text=ns+elementName.text,elementName.col-=ns.length),elementName):(ns&&(tokenStream.unget(),ns.length>1&&tokenStream.unget()),null)},_class:function(){var token,tokenStream=this._tokenStream;return tokenStream.match(Tokens.DOT)?(tokenStream.mustMatch(Tokens.IDENT),token=tokenStream.token(),new SelectorSubPart(\".\"+token.value,\"class\",token.startLine,token.startCol-1)):null},_element_name:function(){var token,tokenStream=this._tokenStream;return tokenStream.match(Tokens.IDENT)?(token=tokenStream.token(),new SelectorSubPart(token.value,\"elementName\",token.startLine,token.startCol)):null},_namespace_prefix:function(){var tokenStream=this._tokenStream,value=\"\";return(tokenStream.LA(1)===Tokens.PIPE||tokenStream.LA(2)===Tokens.PIPE)&&(tokenStream.match([Tokens.IDENT,Tokens.STAR])&&(value+=tokenStream.token().value),tokenStream.mustMatch(Tokens.PIPE),value+=\"|\"),value.length?value:null},_universal:function(){var ns,tokenStream=this._tokenStream,value=\"\";return ns=this._namespace_prefix(),ns&&(value+=ns),tokenStream.match(Tokens.STAR)&&(value+=\"*\"),value.length?value:null},_attrib:function(){var ns,token,tokenStream=this._tokenStream,value=null;return tokenStream.match(Tokens.LBRACKET)?(token=tokenStream.token(),value=token.value,value+=this._readWhitespace(),ns=this._namespace_prefix(),ns&&(value+=ns),tokenStream.mustMatch(Tokens.IDENT),value+=tokenStream.token().value,value+=this._readWhitespace(),tokenStream.match([Tokens.PREFIXMATCH,Tokens.SUFFIXMATCH,Tokens.SUBSTRINGMATCH,Tokens.EQUALS,Tokens.INCLUDES,Tokens.DASHMATCH])&&(value+=tokenStream.token().value,value+=this._readWhitespace(),tokenStream.mustMatch([Tokens.IDENT,Tokens.STRING]),value+=tokenStream.token().value,value+=this._readWhitespace()),tokenStream.mustMatch(Tokens.RBRACKET),new SelectorSubPart(value+\"]\",\"attribute\",token.startLine,token.startCol)):null},_pseudo:function(){var line,col,tokenStream=this._tokenStream,pseudo=null,colons=\":\";return tokenStream.match(Tokens.COLON)&&(tokenStream.match(Tokens.COLON)&&(colons+=\":\"),tokenStream.match(Tokens.IDENT)?(pseudo=tokenStream.token().value,line=tokenStream.token().startLine,col=tokenStream.token().startCol-colons.length):tokenStream.peek()==Tokens.FUNCTION&&(line=tokenStream.LT(1).startLine,col=tokenStream.LT(1).startCol-colons.length,pseudo=this._functional_pseudo()),pseudo&&(pseudo=new SelectorSubPart(colons+pseudo,\"pseudo\",line,col))),pseudo},_functional_pseudo:function(){var tokenStream=this._tokenStream,value=null;return tokenStream.match(Tokens.FUNCTION)&&(value=tokenStream.token().value,value+=this._readWhitespace(),value+=this._expression(),tokenStream.mustMatch(Tokens.RPAREN),value+=\")\"),value},_expression:function(){for(var tokenStream=this._tokenStream,value=\"\";tokenStream.match([Tokens.PLUS,Tokens.MINUS,Tokens.DIMENSION,Tokens.NUMBER,Tokens.STRING,Tokens.IDENT,Tokens.LENGTH,Tokens.FREQ,Tokens.ANGLE,Tokens.TIME,Tokens.RESOLUTION,Tokens.SLASH]);)value+=tokenStream.token().value,value+=this._readWhitespace();return value.length?value:null},_negation:function(){var line,col,arg,tokenStream=this._tokenStream,value=\"\",subpart=null;return tokenStream.match(Tokens.NOT)&&(value=tokenStream.token().value,line=tokenStream.token().startLine,col=tokenStream.token().startCol,value+=this._readWhitespace(),arg=this._negation_arg(),value+=arg,value+=this._readWhitespace(),tokenStream.match(Tokens.RPAREN),value+=tokenStream.token().value,subpart=new SelectorSubPart(value,\"not\",line,col),subpart.args.push(arg)),subpart},_negation_arg:function(){var line,col,part,tokenStream=this._tokenStream,args=[this._type_selector,this._universal,function(){return tokenStream.match(Tokens.HASH)?new SelectorSubPart(tokenStream.token().value,\"id\",tokenStream.token().startLine,tokenStream.token().startCol):null},this._class,this._attrib,this._pseudo],arg=null,i=0,len=args.length;for(line=tokenStream.LT(1).startLine,col=tokenStream.LT(1).startCol;len>i&&null===arg;)arg=args[i].call(this),i++;return null===arg&&this._unexpectedToken(tokenStream.LT(1)),part=\"elementName\"==arg.type?new SelectorPart(arg,[],\"\"+arg,line,col):new SelectorPart(null,[arg],\"\"+arg,line,col)},_declaration:function(){var tokenStream=this._tokenStream,property=null,expr=null,prio=null,invalid=null,propertyName=\"\";if(property=this._property(),null!==property){tokenStream.mustMatch(Tokens.COLON),this._readWhitespace(),expr=this._expr(),expr&&0!==expr.length||this._unexpectedToken(tokenStream.LT(1)),prio=this._prio(),propertyName=\"\"+property,(this.options.starHack&&\"*\"==property.hack||this.options.underscoreHack&&\"_\"==property.hack)&&(propertyName=property.text);try{this._validateProperty(propertyName,expr)}catch(ex){invalid=ex}return this.fire({type:\"property\",property:property,value:expr,important:prio,line:property.line,col:property.col,invalid:invalid}),!0}return!1},_prio:function(){var tokenStream=this._tokenStream,result=tokenStream.match(Tokens.IMPORTANT_SYM);return this._readWhitespace(),result},_expr:function(inFunction){var values=(this._tokenStream,[]),value=null,operator=null;if(value=this._term(inFunction),null!==value)for(values.push(value);;){if(operator=this._operator(inFunction),operator&&values.push(operator),value=this._term(inFunction),null===value)break;\nvalues.push(value)}return values.length>0?new PropertyValue(values,values[0].line,values[0].col):null},_term:function(inFunction){var token,line,col,tokenStream=this._tokenStream,unary=null,value=null,endChar=null;return unary=this._unary_operator(),null!==unary&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol),tokenStream.peek()==Tokens.IE_FUNCTION&&this.options.ieFilters?(value=this._ie_function(),null===unary&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol)):inFunction&&tokenStream.match([Tokens.LPAREN,Tokens.LBRACE,Tokens.LBRACKET])?(token=tokenStream.token(),endChar=token.endChar,value=token.value+this._expr(inFunction).text,null===unary&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol),tokenStream.mustMatch(Tokens.type(endChar)),value+=endChar,this._readWhitespace()):tokenStream.match([Tokens.NUMBER,Tokens.PERCENTAGE,Tokens.LENGTH,Tokens.ANGLE,Tokens.TIME,Tokens.FREQ,Tokens.STRING,Tokens.IDENT,Tokens.URI,Tokens.UNICODE_RANGE])?(value=tokenStream.token().value,null===unary&&(line=tokenStream.token().startLine,col=tokenStream.token().startCol),this._readWhitespace()):(token=this._hexcolor(),null===token?(null===unary&&(line=tokenStream.LT(1).startLine,col=tokenStream.LT(1).startCol),null===value&&(value=tokenStream.LA(3)==Tokens.EQUALS&&this.options.ieFilters?this._ie_function():this._function())):(value=token.value,null===unary&&(line=token.startLine,col=token.startCol))),null!==value?new PropertyValuePart(null!==unary?unary+value:value,line,col):null},_function:function(){var lt,tokenStream=this._tokenStream,functionText=null,expr=null;if(tokenStream.match(Tokens.FUNCTION)){if(functionText=tokenStream.token().value,this._readWhitespace(),expr=this._expr(!0),functionText+=expr,this.options.ieFilters&&tokenStream.peek()==Tokens.EQUALS)do for(this._readWhitespace()&&(functionText+=tokenStream.token().value),tokenStream.LA(0)==Tokens.COMMA&&(functionText+=tokenStream.token().value),tokenStream.match(Tokens.IDENT),functionText+=tokenStream.token().value,tokenStream.match(Tokens.EQUALS),functionText+=tokenStream.token().value,lt=tokenStream.peek();lt!=Tokens.COMMA&&lt!=Tokens.S&&lt!=Tokens.RPAREN;)tokenStream.get(),functionText+=tokenStream.token().value,lt=tokenStream.peek();while(tokenStream.match([Tokens.COMMA,Tokens.S]));tokenStream.match(Tokens.RPAREN),functionText+=\")\",this._readWhitespace()}return functionText},_ie_function:function(){var lt,tokenStream=this._tokenStream,functionText=null;if(tokenStream.match([Tokens.IE_FUNCTION,Tokens.FUNCTION])){functionText=tokenStream.token().value;do for(this._readWhitespace()&&(functionText+=tokenStream.token().value),tokenStream.LA(0)==Tokens.COMMA&&(functionText+=tokenStream.token().value),tokenStream.match(Tokens.IDENT),functionText+=tokenStream.token().value,tokenStream.match(Tokens.EQUALS),functionText+=tokenStream.token().value,lt=tokenStream.peek();lt!=Tokens.COMMA&&lt!=Tokens.S&&lt!=Tokens.RPAREN;)tokenStream.get(),functionText+=tokenStream.token().value,lt=tokenStream.peek();while(tokenStream.match([Tokens.COMMA,Tokens.S]));tokenStream.match(Tokens.RPAREN),functionText+=\")\",this._readWhitespace()}return functionText},_hexcolor:function(){var color,tokenStream=this._tokenStream,token=null;if(tokenStream.match(Tokens.HASH)){if(token=tokenStream.token(),color=token.value,!/#[a-f0-9]{3,6}/i.test(color))throw new SyntaxError(\"Expected a hex color but found '\"+color+\"' at line \"+token.startLine+\", col \"+token.startCol+\".\",token.startLine,token.startCol);this._readWhitespace()}return token},_keyframes:function(){var token,tt,name,tokenStream=this._tokenStream,prefix=\"\";for(tokenStream.mustMatch(Tokens.KEYFRAMES_SYM),token=tokenStream.token(),/^@\\-([^\\-]+)\\-/.test(token.value)&&(prefix=RegExp.$1),this._readWhitespace(),name=this._keyframe_name(),this._readWhitespace(),tokenStream.mustMatch(Tokens.LBRACE),this.fire({type:\"startkeyframes\",name:name,prefix:prefix,line:token.startLine,col:token.startCol}),this._readWhitespace(),tt=tokenStream.peek();tt==Tokens.IDENT||tt==Tokens.PERCENTAGE;)this._keyframe_rule(),this._readWhitespace(),tt=tokenStream.peek();this.fire({type:\"endkeyframes\",name:name,prefix:prefix,line:token.startLine,col:token.startCol}),this._readWhitespace(),tokenStream.mustMatch(Tokens.RBRACE)},_keyframe_name:function(){var tokenStream=this._tokenStream;return tokenStream.mustMatch([Tokens.IDENT,Tokens.STRING]),SyntaxUnit.fromToken(tokenStream.token())},_keyframe_rule:function(){var keyList=(this._tokenStream,this._key_list());this.fire({type:\"startkeyframerule\",keys:keyList,line:keyList[0].line,col:keyList[0].col}),this._readDeclarations(!0),this.fire({type:\"endkeyframerule\",keys:keyList,line:keyList[0].line,col:keyList[0].col})},_key_list:function(){var tokenStream=this._tokenStream,keyList=[];for(keyList.push(this._key()),this._readWhitespace();tokenStream.match(Tokens.COMMA);)this._readWhitespace(),keyList.push(this._key()),this._readWhitespace();return keyList},_key:function(){var token,tokenStream=this._tokenStream;if(tokenStream.match(Tokens.PERCENTAGE))return SyntaxUnit.fromToken(tokenStream.token());if(tokenStream.match(Tokens.IDENT)){if(token=tokenStream.token(),/from|to/i.test(token.value))return SyntaxUnit.fromToken(token);tokenStream.unget()}this._unexpectedToken(tokenStream.LT(1))},_skipCruft:function(){for(;this._tokenStream.match([Tokens.S,Tokens.CDO,Tokens.CDC]););},_readDeclarations:function(checkStart,readMargins){var tt,tokenStream=this._tokenStream;this._readWhitespace(),checkStart&&tokenStream.mustMatch(Tokens.LBRACE),this._readWhitespace();try{for(;;){if(tokenStream.match(Tokens.SEMICOLON)||readMargins&&this._margin());else{if(!this._declaration())break;if(!tokenStream.match(Tokens.SEMICOLON))break}this._readWhitespace()}tokenStream.mustMatch(Tokens.RBRACE),this._readWhitespace()}catch(ex){if(!(ex instanceof SyntaxError)||this.options.strict)throw ex;if(this.fire({type:\"error\",error:ex,message:ex.message,line:ex.line,col:ex.col}),tt=tokenStream.advance([Tokens.SEMICOLON,Tokens.RBRACE]),tt==Tokens.SEMICOLON)this._readDeclarations(!1,readMargins);else if(tt!=Tokens.RBRACE)throw ex}},_readWhitespace:function(){for(var tokenStream=this._tokenStream,ws=\"\";tokenStream.match(Tokens.S);)ws+=tokenStream.token().value;return ws},_unexpectedToken:function(token){throw new SyntaxError(\"Unexpected token '\"+token.value+\"' at line \"+token.startLine+\", col \"+token.startCol+\".\",token.startLine,token.startCol)},_verifyEnd:function(){this._tokenStream.LA(1)!=Tokens.EOF&&this._unexpectedToken(this._tokenStream.LT(1))},_validateProperty:function(property,value){Validation.validate(property,value)},parse:function(input){this._tokenStream=new TokenStream(input,Tokens),this._stylesheet()},parseStyleSheet:function(input){return this.parse(input)},parseMediaQuery:function(input){this._tokenStream=new TokenStream(input,Tokens);var result=this._media_query();return this._verifyEnd(),result},parsePropertyValue:function(input){this._tokenStream=new TokenStream(input,Tokens),this._readWhitespace();var result=this._expr();return this._readWhitespace(),this._verifyEnd(),result},parseRule:function(input){this._tokenStream=new TokenStream(input,Tokens),this._readWhitespace();var result=this._ruleset();return this._readWhitespace(),this._verifyEnd(),result},parseSelector:function(input){this._tokenStream=new TokenStream(input,Tokens),this._readWhitespace();var result=this._selector();return this._readWhitespace(),this._verifyEnd(),result},parseStyleAttribute:function(input){input+=\"}\",this._tokenStream=new TokenStream(input,Tokens),this._readDeclarations()}};for(prop in additions)additions.hasOwnProperty(prop)&&(proto[prop]=additions[prop]);return proto}();var Properties={\"align-items\":\"flex-start | flex-end | center | baseline | stretch\",\"align-content\":\"flex-start | flex-end | center | space-between | space-around | stretch\",\"align-self\":\"auto | flex-start | flex-end | center | baseline | stretch\",\"-webkit-align-items\":\"flex-start | flex-end | center | baseline | stretch\",\"-webkit-align-content\":\"flex-start | flex-end | center | space-between | space-around | stretch\",\"-webkit-align-self\":\"auto | flex-start | flex-end | center | baseline | stretch\",\"alignment-adjust\":\"auto | baseline | before-edge | text-before-edge | middle | central | after-edge | text-after-edge | ideographic | alphabetic | hanging | mathematical | <percentage> | <length>\",\"alignment-baseline\":\"baseline | use-script | before-edge | text-before-edge | after-edge | text-after-edge | central | middle | ideographic | alphabetic | hanging | mathematical\",animation:1,\"animation-delay\":{multi:\"<time>\",comma:!0},\"animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"animation-duration\":{multi:\"<time>\",comma:!0},\"animation-fill-mode\":{multi:\"none | forwards | backwards | both\",comma:!0},\"animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"animation-name\":{multi:\"none | <ident>\",comma:!0},\"animation-play-state\":{multi:\"running | paused\",comma:!0},\"animation-timing-function\":1,\"-moz-animation-delay\":{multi:\"<time>\",comma:!0},\"-moz-animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"-moz-animation-duration\":{multi:\"<time>\",comma:!0},\"-moz-animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"-moz-animation-name\":{multi:\"none | <ident>\",comma:!0},\"-moz-animation-play-state\":{multi:\"running | paused\",comma:!0},\"-ms-animation-delay\":{multi:\"<time>\",comma:!0},\"-ms-animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"-ms-animation-duration\":{multi:\"<time>\",comma:!0},\"-ms-animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"-ms-animation-name\":{multi:\"none | <ident>\",comma:!0},\"-ms-animation-play-state\":{multi:\"running | paused\",comma:!0},\"-webkit-animation-delay\":{multi:\"<time>\",comma:!0},\"-webkit-animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"-webkit-animation-duration\":{multi:\"<time>\",comma:!0},\"-webkit-animation-fill-mode\":{multi:\"none | forwards | backwards | both\",comma:!0},\"-webkit-animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"-webkit-animation-name\":{multi:\"none | <ident>\",comma:!0},\"-webkit-animation-play-state\":{multi:\"running | paused\",comma:!0},\"-o-animation-delay\":{multi:\"<time>\",comma:!0},\"-o-animation-direction\":{multi:\"normal | reverse | alternate | alternate-reverse\",comma:!0},\"-o-animation-duration\":{multi:\"<time>\",comma:!0},\"-o-animation-iteration-count\":{multi:\"<number> | infinite\",comma:!0},\"-o-animation-name\":{multi:\"none | <ident>\",comma:!0},\"-o-animation-play-state\":{multi:\"running | paused\",comma:!0},appearance:\"icon | window | desktop | workspace | document | tooltip | dialog | button | push-button | hyperlink | radio-button | checkbox | menu-item | tab | menu | menubar | pull-down-menu | pop-up-menu | list-menu | radio-group | checkbox-group | outline-tree | range | field | combo-box | signature | password | normal | none | inherit\",azimuth:function(expression){var part,simple=\"<angle> | leftwards | rightwards | inherit\",direction=\"left-side | far-left | left | center-left | center | center-right | right | far-right | right-side\",behind=!1,valid=!1;if(ValidationTypes.isAny(expression,simple)||(ValidationTypes.isAny(expression,\"behind\")&&(behind=!0,valid=!0),ValidationTypes.isAny(expression,direction)&&(valid=!0,behind||ValidationTypes.isAny(expression,\"behind\"))),expression.hasNext())throw part=expression.next(),valid?new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col):new ValidationError(\"Expected (<'azimuth'>) but found '\"+part+\"'.\",part.line,part.col)},\"backface-visibility\":\"visible | hidden\",background:1,\"background-attachment\":{multi:\"<attachment>\",comma:!0},\"background-clip\":{multi:\"<box>\",comma:!0},\"background-color\":\"<color> | inherit\",\"background-image\":{multi:\"<bg-image>\",comma:!0},\"background-origin\":{multi:\"<box>\",comma:!0},\"background-position\":{multi:\"<bg-position>\",comma:!0},\"background-repeat\":{multi:\"<repeat-style>\"},\"background-size\":{multi:\"<bg-size>\",comma:!0},\"baseline-shift\":\"baseline | sub | super | <percentage> | <length>\",behavior:1,binding:1,bleed:\"<length>\",\"bookmark-label\":\"<content> | <attr> | <string>\",\"bookmark-level\":\"none | <integer>\",\"bookmark-state\":\"open | closed\",\"bookmark-target\":\"none | <uri> | <attr>\",border:\"<border-width> || <border-style> || <color>\",\"border-bottom\":\"<border-width> || <border-style> || <color>\",\"border-bottom-color\":\"<color> | inherit\",\"border-bottom-left-radius\":\"<x-one-radius>\",\"border-bottom-right-radius\":\"<x-one-radius>\",\"border-bottom-style\":\"<border-style>\",\"border-bottom-width\":\"<border-width>\",\"border-collapse\":\"collapse | separate | inherit\",\"border-color\":{multi:\"<color> | inherit\",max:4},\"border-image\":1,\"border-image-outset\":{multi:\"<length> | <number>\",max:4},\"border-image-repeat\":{multi:\"stretch | repeat | round\",max:2},\"border-image-slice\":function(expression){var part,valid=!1,numeric=\"<number> | <percentage>\",fill=!1,count=0,max=4;for(ValidationTypes.isAny(expression,\"fill\")&&(fill=!0,valid=!0);expression.hasNext()&&max>count&&(valid=ValidationTypes.isAny(expression,numeric));)count++;if(fill?valid=!0:ValidationTypes.isAny(expression,\"fill\"),expression.hasNext())throw part=expression.next(),valid?new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col):new ValidationError(\"Expected ([<number> | <percentage>]{1,4} && fill?) but found '\"+part+\"'.\",part.line,part.col)},\"border-image-source\":\"<image> | none\",\"border-image-width\":{multi:\"<length> | <percentage> | <number> | auto\",max:4},\"border-left\":\"<border-width> || <border-style> || <color>\",\"border-left-color\":\"<color> | inherit\",\"border-left-style\":\"<border-style>\",\"border-left-width\":\"<border-width>\",\"border-radius\":function(expression){for(var part,valid=!1,simple=\"<length> | <percentage> | inherit\",slash=!1,count=0,max=8;expression.hasNext()&&max>count;){if(valid=ValidationTypes.isAny(expression,simple),!valid){if(!(\"/\"==expression.peek()&&count>0)||slash)break;slash=!0,max=count+5,expression.next()}count++}if(expression.hasNext())throw part=expression.next(),valid?new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col):new ValidationError(\"Expected (<'border-radius'>) but found '\"+part+\"'.\",part.line,part.col)},\"border-right\":\"<border-width> || <border-style> || <color>\",\"border-right-color\":\"<color> | inherit\",\"border-right-style\":\"<border-style>\",\"border-right-width\":\"<border-width>\",\"border-spacing\":{multi:\"<length> | inherit\",max:2},\"border-style\":{multi:\"<border-style>\",max:4},\"border-top\":\"<border-width> || <border-style> || <color>\",\"border-top-color\":\"<color> | inherit\",\"border-top-left-radius\":\"<x-one-radius>\",\"border-top-right-radius\":\"<x-one-radius>\",\"border-top-style\":\"<border-style>\",\"border-top-width\":\"<border-width>\",\"border-width\":{multi:\"<border-width>\",max:4},bottom:\"<margin-width> | inherit\",\"-moz-box-align\":\"start | end | center | baseline | stretch\",\"-moz-box-decoration-break\":\"slice |clone\",\"-moz-box-direction\":\"normal | reverse | inherit\",\"-moz-box-flex\":\"<number>\",\"-moz-box-flex-group\":\"<integer>\",\"-moz-box-lines\":\"single | multiple\",\"-moz-box-ordinal-group\":\"<integer>\",\"-moz-box-orient\":\"horizontal | vertical | inline-axis | block-axis | inherit\",\"-moz-box-pack\":\"start | end | center | justify\",\"-webkit-box-align\":\"start | end | center | baseline | stretch\",\"-webkit-box-decoration-break\":\"slice |clone\",\"-webkit-box-direction\":\"normal | reverse | inherit\",\"-webkit-box-flex\":\"<number>\",\"-webkit-box-flex-group\":\"<integer>\",\"-webkit-box-lines\":\"single | multiple\",\"-webkit-box-ordinal-group\":\"<integer>\",\"-webkit-box-orient\":\"horizontal | vertical | inline-axis | block-axis | inherit\",\"-webkit-box-pack\":\"start | end | center | justify\",\"box-shadow\":function(expression){var part;if(ValidationTypes.isAny(expression,\"none\")){if(expression.hasNext())throw part=expression.next(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)}else Validation.multiProperty(\"<shadow>\",expression,!0,1/0)},\"box-sizing\":\"content-box | border-box | inherit\",\"break-after\":\"auto | always | avoid | left | right | page | column | avoid-page | avoid-column\",\"break-before\":\"auto | always | avoid | left | right | page | column | avoid-page | avoid-column\",\"break-inside\":\"auto | avoid | avoid-page | avoid-column\",\"caption-side\":\"top | bottom | inherit\",clear:\"none | right | left | both | inherit\",clip:1,color:\"<color> | inherit\",\"color-profile\":1,\"column-count\":\"<integer> | auto\",\"column-fill\":\"auto | balance\",\"column-gap\":\"<length> | normal\",\"column-rule\":\"<border-width> || <border-style> || <color>\",\"column-rule-color\":\"<color>\",\"column-rule-style\":\"<border-style>\",\"column-rule-width\":\"<border-width>\",\"column-span\":\"none | all\",\"column-width\":\"<length> | auto\",columns:1,content:1,\"counter-increment\":1,\"counter-reset\":1,crop:\"<shape> | auto\",cue:\"cue-after | cue-before | inherit\",\"cue-after\":1,\"cue-before\":1,cursor:1,direction:\"ltr | rtl | inherit\",display:\"inline | block | list-item | inline-block | table | inline-table | table-row-group | table-header-group | table-footer-group | table-row | table-column-group | table-column | table-cell | table-caption | grid | inline-grid | none | inherit | -moz-box | -moz-inline-block | -moz-inline-box | -moz-inline-grid | -moz-inline-stack | -moz-inline-table | -moz-grid | -moz-grid-group | -moz-grid-line | -moz-groupbox | -moz-deck | -moz-popup | -moz-stack | -moz-marker | -webkit-box | -webkit-inline-box | -ms-flexbox | -ms-inline-flexbox | flex | -webkit-flex | inline-flex | -webkit-inline-flex\",\"dominant-baseline\":1,\"drop-initial-after-adjust\":\"central | middle | after-edge | text-after-edge | ideographic | alphabetic | mathematical | <percentage> | <length>\",\"drop-initial-after-align\":\"baseline | use-script | before-edge | text-before-edge | after-edge | text-after-edge | central | middle | ideographic | alphabetic | hanging | mathematical\",\"drop-initial-before-adjust\":\"before-edge | text-before-edge | central | middle | hanging | mathematical | <percentage> | <length>\",\"drop-initial-before-align\":\"caps-height | baseline | use-script | before-edge | text-before-edge | after-edge | text-after-edge | central | middle | ideographic | alphabetic | hanging | mathematical\",\"drop-initial-size\":\"auto | line | <length> | <percentage>\",\"drop-initial-value\":\"initial | <integer>\",elevation:\"<angle> | below | level | above | higher | lower | inherit\",\"empty-cells\":\"show | hide | inherit\",filter:1,fit:\"fill | hidden | meet | slice\",\"fit-position\":1,flex:\"<flex>\",\"flex-basis\":\"<width>\",\"flex-direction\":\"row | row-reverse | column | column-reverse\",\"flex-flow\":\"<flex-direction> || <flex-wrap>\",\"flex-grow\":\"<number>\",\"flex-shrink\":\"<number>\",\"flex-wrap\":\"nowrap | wrap | wrap-reverse\",\"-webkit-flex\":\"<flex>\",\"-webkit-flex-basis\":\"<width>\",\"-webkit-flex-direction\":\"row | row-reverse | column | column-reverse\",\"-webkit-flex-flow\":\"<flex-direction> || <flex-wrap>\",\"-webkit-flex-grow\":\"<number>\",\"-webkit-flex-shrink\":\"<number>\",\"-webkit-flex-wrap\":\"nowrap | wrap | wrap-reverse\",\"-ms-flex\":\"<flex>\",\"-ms-flex-align\":\"start | end | center | stretch | baseline\",\"-ms-flex-direction\":\"row | row-reverse | column | column-reverse | inherit\",\"-ms-flex-order\":\"<number>\",\"-ms-flex-pack\":\"start | end | center | justify\",\"-ms-flex-wrap\":\"nowrap | wrap | wrap-reverse\",\"float\":\"left | right | none | inherit\",\"float-offset\":1,font:1,\"font-family\":1,\"font-size\":\"<absolute-size> | <relative-size> | <length> | <percentage> | inherit\",\"font-size-adjust\":\"<number> | none | inherit\",\"font-stretch\":\"normal | ultra-condensed | extra-condensed | condensed | semi-condensed | semi-expanded | expanded | extra-expanded | ultra-expanded | inherit\",\"font-style\":\"normal | italic | oblique | inherit\",\"font-variant\":\"normal | small-caps | inherit\",\"font-weight\":\"normal | bold | bolder | lighter | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | inherit\",\"grid-cell-stacking\":\"columns | rows | layer\",\"grid-column\":1,\"grid-columns\":1,\"grid-column-align\":\"start | end | center | stretch\",\"grid-column-sizing\":1,\"grid-column-span\":\"<integer>\",\"grid-flow\":\"none | rows | columns\",\"grid-layer\":\"<integer>\",\"grid-row\":1,\"grid-rows\":1,\"grid-row-align\":\"start | end | center | stretch\",\"grid-row-span\":\"<integer>\",\"grid-row-sizing\":1,\"hanging-punctuation\":1,height:\"<margin-width> | <content-sizing> | inherit\",\"hyphenate-after\":\"<integer> | auto\",\"hyphenate-before\":\"<integer> | auto\",\"hyphenate-character\":\"<string> | auto\",\"hyphenate-lines\":\"no-limit | <integer>\",\"hyphenate-resource\":1,hyphens:\"none | manual | auto\",icon:1,\"image-orientation\":\"angle | auto\",\"image-rendering\":1,\"image-resolution\":1,\"inline-box-align\":\"initial | last | <integer>\",\"justify-content\":\"flex-start | flex-end | center | space-between | space-around\",\"-webkit-justify-content\":\"flex-start | flex-end | center | space-between | space-around\",left:\"<margin-width> | inherit\",\"letter-spacing\":\"<length> | normal | inherit\",\"line-height\":\"<number> | <length> | <percentage> | normal | inherit\",\"line-break\":\"auto | loose | normal | strict\",\"line-stacking\":1,\"line-stacking-ruby\":\"exclude-ruby | include-ruby\",\"line-stacking-shift\":\"consider-shifts | disregard-shifts\",\"line-stacking-strategy\":\"inline-line-height | block-line-height | max-height | grid-height\",\"list-style\":1,\"list-style-image\":\"<uri> | none | inherit\",\"list-style-position\":\"inside | outside | inherit\",\"list-style-type\":\"disc | circle | square | decimal | decimal-leading-zero | lower-roman | upper-roman | lower-greek | lower-latin | upper-latin | armenian | georgian | lower-alpha | upper-alpha | none | inherit\",margin:{multi:\"<margin-width> | inherit\",max:4},\"margin-bottom\":\"<margin-width> | inherit\",\"margin-left\":\"<margin-width> | inherit\",\"margin-right\":\"<margin-width> | inherit\",\"margin-top\":\"<margin-width> | inherit\",mark:1,\"mark-after\":1,\"mark-before\":1,marks:1,\"marquee-direction\":1,\"marquee-play-count\":1,\"marquee-speed\":1,\"marquee-style\":1,\"max-height\":\"<length> | <percentage> | <content-sizing> | none | inherit\",\"max-width\":\"<length> | <percentage> | <content-sizing> | none | inherit\",\"min-height\":\"<length> | <percentage> | <content-sizing> | contain-floats | -moz-contain-floats | -webkit-contain-floats | inherit\",\"min-width\":\"<length> | <percentage> | <content-sizing> | contain-floats | -moz-contain-floats | -webkit-contain-floats | inherit\",\"move-to\":1,\"nav-down\":1,\"nav-index\":1,\"nav-left\":1,\"nav-right\":1,\"nav-up\":1,opacity:\"<number> | inherit\",order:\"<integer>\",\"-webkit-order\":\"<integer>\",orphans:\"<integer> | inherit\",outline:1,\"outline-color\":\"<color> | invert | inherit\",\"outline-offset\":1,\"outline-style\":\"<border-style> | inherit\",\"outline-width\":\"<border-width> | inherit\",overflow:\"visible | hidden | scroll | auto | inherit\",\"overflow-style\":1,\"overflow-wrap\":\"normal | break-word\",\"overflow-x\":1,\"overflow-y\":1,padding:{multi:\"<padding-width> | inherit\",max:4},\"padding-bottom\":\"<padding-width> | inherit\",\"padding-left\":\"<padding-width> | inherit\",\"padding-right\":\"<padding-width> | inherit\",\"padding-top\":\"<padding-width> | inherit\",page:1,\"page-break-after\":\"auto | always | avoid | left | right | inherit\",\"page-break-before\":\"auto | always | avoid | left | right | inherit\",\"page-break-inside\":\"auto | avoid | inherit\",\"page-policy\":1,pause:1,\"pause-after\":1,\"pause-before\":1,perspective:1,\"perspective-origin\":1,phonemes:1,pitch:1,\"pitch-range\":1,\"play-during\":1,\"pointer-events\":\"auto | none | visiblePainted | visibleFill | visibleStroke | visible | painted | fill | stroke | all | inherit\",position:\"static | relative | absolute | fixed | inherit\",\"presentation-level\":1,\"punctuation-trim\":1,quotes:1,\"rendering-intent\":1,resize:1,rest:1,\"rest-after\":1,\"rest-before\":1,richness:1,right:\"<margin-width> | inherit\",rotation:1,\"rotation-point\":1,\"ruby-align\":1,\"ruby-overhang\":1,\"ruby-position\":1,\"ruby-span\":1,size:1,speak:\"normal | none | spell-out | inherit\",\"speak-header\":\"once | always | inherit\",\"speak-numeral\":\"digits | continuous | inherit\",\"speak-punctuation\":\"code | none | inherit\",\"speech-rate\":1,src:1,stress:1,\"string-set\":1,\"table-layout\":\"auto | fixed | inherit\",\"tab-size\":\"<integer> | <length>\",target:1,\"target-name\":1,\"target-new\":1,\"target-position\":1,\"text-align\":\"left | right | center | justify | inherit\",\"text-align-last\":1,\"text-decoration\":1,\"text-emphasis\":1,\"text-height\":1,\"text-indent\":\"<length> | <percentage> | inherit\",\"text-justify\":\"auto | none | inter-word | inter-ideograph | inter-cluster | distribute | kashida\",\"text-outline\":1,\"text-overflow\":1,\"text-rendering\":\"auto | optimizeSpeed | optimizeLegibility | geometricPrecision | inherit\",\"text-shadow\":1,\"text-transform\":\"capitalize | uppercase | lowercase | none | inherit\",\"text-wrap\":\"normal | none | avoid\",top:\"<margin-width> | inherit\",\"-ms-touch-action\":\"auto | none | pan-x | pan-y\",\"touch-action\":\"auto | none | pan-x | pan-y\",transform:1,\"transform-origin\":1,\"transform-style\":1,transition:1,\"transition-delay\":1,\"transition-duration\":1,\"transition-property\":1,\"transition-timing-function\":1,\"unicode-bidi\":\"normal | embed | isolate | bidi-override | isolate-override | plaintext | inherit\",\"user-modify\":\"read-only | read-write | write-only | inherit\",\"user-select\":\"none | text | toggle | element | elements | all | inherit\",\"vertical-align\":\"auto | use-script | baseline | sub | super | top | text-top | central | middle | bottom | text-bottom | <percentage> | <length>\",visibility:\"visible | hidden | collapse | inherit\",\"voice-balance\":1,\"voice-duration\":1,\"voice-family\":1,\"voice-pitch\":1,\"voice-pitch-range\":1,\"voice-rate\":1,\"voice-stress\":1,\"voice-volume\":1,volume:1,\"white-space\":\"normal | pre | nowrap | pre-wrap | pre-line | inherit | -pre-wrap | -o-pre-wrap | -moz-pre-wrap | -hp-pre-wrap\",\"white-space-collapse\":1,widows:\"<integer> | inherit\",width:\"<length> | <percentage> | <content-sizing> | auto | inherit\",\"word-break\":\"normal | keep-all | break-all\",\"word-spacing\":\"<length> | normal | inherit\",\"word-wrap\":\"normal | break-word\",\"writing-mode\":\"horizontal-tb | vertical-rl | vertical-lr | lr-tb | rl-tb | tb-rl | bt-rl | tb-lr | bt-lr | lr-bt | rl-bt | lr | rl | tb | inherit\",\"z-index\":\"<integer> | auto | inherit\",zoom:\"<number> | <percentage> | normal\"};PropertyName.prototype=new SyntaxUnit,PropertyName.prototype.constructor=PropertyName,PropertyName.prototype.toString=function(){return(this.hack?this.hack:\"\")+this.text},PropertyValue.prototype=new SyntaxUnit,PropertyValue.prototype.constructor=PropertyValue,PropertyValueIterator.prototype.count=function(){return this._parts.length},PropertyValueIterator.prototype.isFirst=function(){return 0===this._i},PropertyValueIterator.prototype.hasNext=function(){return this._i<this._parts.length},PropertyValueIterator.prototype.mark=function(){this._marks.push(this._i)},PropertyValueIterator.prototype.peek=function(count){return this.hasNext()?this._parts[this._i+(count||0)]:null},PropertyValueIterator.prototype.next=function(){return this.hasNext()?this._parts[this._i++]:null},PropertyValueIterator.prototype.previous=function(){return this._i>0?this._parts[--this._i]:null},PropertyValueIterator.prototype.restore=function(){this._marks.length&&(this._i=this._marks.pop())},PropertyValuePart.prototype=new SyntaxUnit,PropertyValuePart.prototype.constructor=PropertyValuePart,PropertyValuePart.fromToken=function(token){return new PropertyValuePart(token.value,token.startLine,token.startCol)};var Pseudos={\":first-letter\":1,\":first-line\":1,\":before\":1,\":after\":1};Pseudos.ELEMENT=1,Pseudos.CLASS=2,Pseudos.isElement=function(pseudo){return 0===pseudo.indexOf(\"::\")||Pseudos[pseudo.toLowerCase()]==Pseudos.ELEMENT},Selector.prototype=new SyntaxUnit,Selector.prototype.constructor=Selector,SelectorPart.prototype=new SyntaxUnit,SelectorPart.prototype.constructor=SelectorPart,SelectorSubPart.prototype=new SyntaxUnit,SelectorSubPart.prototype.constructor=SelectorSubPart,Specificity.prototype={constructor:Specificity,compare:function(other){var i,len,comps=[\"a\",\"b\",\"c\",\"d\"];for(i=0,len=comps.length;len>i;i++){if(this[comps[i]]<other[comps[i]])return-1;if(this[comps[i]]>other[comps[i]])return 1}return 0},valueOf:function(){return 1e3*this.a+100*this.b+10*this.c+this.d},toString:function(){return this.a+\",\"+this.b+\",\"+this.c+\",\"+this.d}},Specificity.calculate=function(selector){function updateValues(part){var i,j,len,num,modifier,elementName=part.elementName?part.elementName.text:\"\";for(elementName&&\"*\"!=elementName.charAt(elementName.length-1)&&d++,i=0,len=part.modifiers.length;len>i;i++)switch(modifier=part.modifiers[i],modifier.type){case\"class\":case\"attribute\":c++;break;case\"id\":b++;break;case\"pseudo\":Pseudos.isElement(modifier.text)?d++:c++;break;case\"not\":for(j=0,num=modifier.args.length;num>j;j++)updateValues(modifier.args[j])}}var i,len,part,b=0,c=0,d=0;for(i=0,len=selector.parts.length;len>i;i++)part=selector.parts[i],part instanceof SelectorPart&&updateValues(part);return new Specificity(0,b,c,d)};var h=/^[0-9a-fA-F]$/,nonascii=/^[\\u0080-\\uFFFF]$/,nl=/\\n|\\r\\n|\\r|\\f/;TokenStream.prototype=mix(new TokenStreamBase,{_getToken:function(){var c,reader=this._reader,token=null,startLine=reader.getLine(),startCol=reader.getCol();for(c=reader.read();c;){switch(c){case\"/\":token=\"*\"==reader.peek()?this.commentToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case\"|\":case\"~\":case\"^\":case\"$\":case\"*\":token=\"=\"==reader.peek()?this.comparisonToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case'\"':case\"'\":token=this.stringToken(c,startLine,startCol);break;case\"#\":token=isNameChar(reader.peek())?this.hashToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case\".\":token=isDigit(reader.peek())?this.numberToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case\"-\":token=\"-\"==reader.peek()?this.htmlCommentEndToken(c,startLine,startCol):isNameStart(reader.peek())?this.identOrFunctionToken(c,startLine,startCol):this.charToken(c,startLine,startCol);break;case\"!\":token=this.importantToken(c,startLine,startCol);break;case\"@\":token=this.atRuleToken(c,startLine,startCol);break;case\":\":token=this.notToken(c,startLine,startCol);break;case\"<\":token=this.htmlCommentStartToken(c,startLine,startCol);break;case\"U\":case\"u\":if(\"+\"==reader.peek()){token=this.unicodeRangeToken(c,startLine,startCol);break}default:token=isDigit(c)?this.numberToken(c,startLine,startCol):isWhitespace(c)?this.whitespaceToken(c,startLine,startCol):isIdentStart(c)?this.identOrFunctionToken(c,startLine,startCol):this.charToken(c,startLine,startCol)}break}return token||null!==c||(token=this.createToken(Tokens.EOF,null,startLine,startCol)),token},createToken:function(tt,value,startLine,startCol,options){var reader=this._reader;return options=options||{},{value:value,type:tt,channel:options.channel,endChar:options.endChar,hide:options.hide||!1,startLine:startLine,startCol:startCol,endLine:reader.getLine(),endCol:reader.getCol()}},atRuleToken:function(first,startLine,startCol){var ident,rule=first,reader=this._reader,tt=Tokens.CHAR;return reader.mark(),ident=this.readName(),rule=first+ident,tt=Tokens.type(rule.toLowerCase()),(tt==Tokens.CHAR||tt==Tokens.UNKNOWN)&&(rule.length>1?tt=Tokens.UNKNOWN_SYM:(tt=Tokens.CHAR,rule=first,reader.reset())),this.createToken(tt,rule,startLine,startCol)},charToken:function(c,startLine,startCol){var tt=Tokens.type(c),opts={};return-1==tt?tt=Tokens.CHAR:opts.endChar=Tokens[tt].endChar,this.createToken(tt,c,startLine,startCol,opts)},commentToken:function(first,startLine,startCol){var comment=(this._reader,this.readComment(first));return this.createToken(Tokens.COMMENT,comment,startLine,startCol)},comparisonToken:function(c,startLine,startCol){var reader=this._reader,comparison=c+reader.read(),tt=Tokens.type(comparison)||Tokens.CHAR;return this.createToken(tt,comparison,startLine,startCol)\n},hashToken:function(first,startLine,startCol){var name=(this._reader,this.readName(first));return this.createToken(Tokens.HASH,name,startLine,startCol)},htmlCommentStartToken:function(first,startLine,startCol){var reader=this._reader,text=first;return reader.mark(),text+=reader.readCount(3),\"<!--\"==text?this.createToken(Tokens.CDO,text,startLine,startCol):(reader.reset(),this.charToken(first,startLine,startCol))},htmlCommentEndToken:function(first,startLine,startCol){var reader=this._reader,text=first;return reader.mark(),text+=reader.readCount(2),\"-->\"==text?this.createToken(Tokens.CDC,text,startLine,startCol):(reader.reset(),this.charToken(first,startLine,startCol))},identOrFunctionToken:function(first,startLine,startCol){var reader=this._reader,ident=this.readName(first),tt=Tokens.IDENT;return\"(\"==reader.peek()?(ident+=reader.read(),\"url(\"==ident.toLowerCase()?(tt=Tokens.URI,ident=this.readURI(ident),\"url(\"==ident.toLowerCase()&&(tt=Tokens.FUNCTION)):tt=Tokens.FUNCTION):\":\"==reader.peek()&&\"progid\"==ident.toLowerCase()&&(ident+=reader.readTo(\"(\"),tt=Tokens.IE_FUNCTION),this.createToken(tt,ident,startLine,startCol)},importantToken:function(first,startLine,startCol){var temp,c,reader=this._reader,important=first,tt=Tokens.CHAR;for(reader.mark(),c=reader.read();c;){if(\"/\"==c){if(\"*\"!=reader.peek())break;if(temp=this.readComment(c),\"\"===temp)break}else{if(!isWhitespace(c)){if(/i/i.test(c)){temp=reader.readCount(8),/mportant/i.test(temp)&&(important+=c+temp,tt=Tokens.IMPORTANT_SYM);break}break}important+=c+this.readWhitespace()}c=reader.read()}return tt==Tokens.CHAR?(reader.reset(),this.charToken(first,startLine,startCol)):this.createToken(tt,important,startLine,startCol)},notToken:function(first,startLine,startCol){var reader=this._reader,text=first;return reader.mark(),text+=reader.readCount(4),\":not(\"==text.toLowerCase()?this.createToken(Tokens.NOT,text,startLine,startCol):(reader.reset(),this.charToken(first,startLine,startCol))},numberToken:function(first,startLine,startCol){var ident,reader=this._reader,value=this.readNumber(first),tt=Tokens.NUMBER,c=reader.peek();return isIdentStart(c)?(ident=this.readName(reader.read()),value+=ident,tt=/^em$|^ex$|^px$|^gd$|^rem$|^vw$|^vh$|^vmax$|^vmin$|^ch$|^cm$|^mm$|^in$|^pt$|^pc$/i.test(ident)?Tokens.LENGTH:/^deg|^rad$|^grad$/i.test(ident)?Tokens.ANGLE:/^ms$|^s$/i.test(ident)?Tokens.TIME:/^hz$|^khz$/i.test(ident)?Tokens.FREQ:/^dpi$|^dpcm$/i.test(ident)?Tokens.RESOLUTION:Tokens.DIMENSION):\"%\"==c&&(value+=reader.read(),tt=Tokens.PERCENTAGE),this.createToken(tt,value,startLine,startCol)},stringToken:function(first,startLine,startCol){for(var delim=first,string=first,reader=this._reader,prev=first,tt=Tokens.STRING,c=reader.read();c&&(string+=c,c!=delim||\"\\\\\"==prev);){if(isNewLine(reader.peek())&&\"\\\\\"!=c){tt=Tokens.INVALID;break}prev=c,c=reader.read()}return null===c&&(tt=Tokens.INVALID),this.createToken(tt,string,startLine,startCol)},unicodeRangeToken:function(first,startLine,startCol){var temp,reader=this._reader,value=first,tt=Tokens.CHAR;return\"+\"==reader.peek()&&(reader.mark(),value+=reader.read(),value+=this.readUnicodeRangePart(!0),2==value.length?reader.reset():(tt=Tokens.UNICODE_RANGE,-1==value.indexOf(\"?\")&&\"-\"==reader.peek()&&(reader.mark(),temp=reader.read(),temp+=this.readUnicodeRangePart(!1),1==temp.length?reader.reset():value+=temp))),this.createToken(tt,value,startLine,startCol)},whitespaceToken:function(first,startLine,startCol){var value=(this._reader,first+this.readWhitespace());return this.createToken(Tokens.S,value,startLine,startCol)},readUnicodeRangePart:function(allowQuestionMark){for(var reader=this._reader,part=\"\",c=reader.peek();isHexDigit(c)&&6>part.length;)reader.read(),part+=c,c=reader.peek();if(allowQuestionMark)for(;\"?\"==c&&6>part.length;)reader.read(),part+=c,c=reader.peek();return part},readWhitespace:function(){for(var reader=this._reader,whitespace=\"\",c=reader.peek();isWhitespace(c);)reader.read(),whitespace+=c,c=reader.peek();return whitespace},readNumber:function(first){for(var reader=this._reader,number=first,hasDot=\".\"==first,c=reader.peek();c;){if(isDigit(c))number+=reader.read();else{if(\".\"!=c)break;if(hasDot)break;hasDot=!0,number+=reader.read()}c=reader.peek()}return number},readString:function(){for(var reader=this._reader,delim=reader.read(),string=delim,prev=delim,c=reader.peek();c&&(c=reader.read(),string+=c,c!=delim||\"\\\\\"==prev);){if(isNewLine(reader.peek())&&\"\\\\\"!=c){string=\"\";break}prev=c,c=reader.peek()}return null===c&&(string=\"\"),string},readURI:function(first){var reader=this._reader,uri=first,inner=\"\",c=reader.peek();for(reader.mark();c&&isWhitespace(c);)reader.read(),c=reader.peek();for(inner=\"'\"==c||'\"'==c?this.readString():this.readURL(),c=reader.peek();c&&isWhitespace(c);)reader.read(),c=reader.peek();return\"\"===inner||\")\"!=c?(uri=first,reader.reset()):uri+=inner+reader.read(),uri},readURL:function(){for(var reader=this._reader,url=\"\",c=reader.peek();/^[!#$%&\\\\*-~]$/.test(c);)url+=reader.read(),c=reader.peek();return url},readName:function(first){for(var reader=this._reader,ident=first||\"\",c=reader.peek();;)if(\"\\\\\"==c)ident+=this.readEscape(reader.read()),c=reader.peek();else{if(!c||!isNameChar(c))break;ident+=reader.read(),c=reader.peek()}return ident},readEscape:function(first){var reader=this._reader,cssEscape=first||\"\",i=0,c=reader.peek();if(isHexDigit(c))do cssEscape+=reader.read(),c=reader.peek();while(c&&isHexDigit(c)&&6>++i);return 3==cssEscape.length&&/\\s/.test(c)||7==cssEscape.length||1==cssEscape.length?reader.read():c=\"\",cssEscape+c},readComment:function(first){var reader=this._reader,comment=first||\"\",c=reader.read();if(\"*\"==c){for(;c;){if(comment+=c,comment.length>2&&\"*\"==c&&\"/\"==reader.peek()){comment+=reader.read();break}c=reader.read()}return comment}return\"\"}});var Tokens=[{name:\"CDO\"},{name:\"CDC\"},{name:\"S\",whitespace:!0},{name:\"COMMENT\",comment:!0,hide:!0,channel:\"comment\"},{name:\"INCLUDES\",text:\"~=\"},{name:\"DASHMATCH\",text:\"|=\"},{name:\"PREFIXMATCH\",text:\"^=\"},{name:\"SUFFIXMATCH\",text:\"$=\"},{name:\"SUBSTRINGMATCH\",text:\"*=\"},{name:\"STRING\"},{name:\"IDENT\"},{name:\"HASH\"},{name:\"IMPORT_SYM\",text:\"@import\"},{name:\"PAGE_SYM\",text:\"@page\"},{name:\"MEDIA_SYM\",text:\"@media\"},{name:\"FONT_FACE_SYM\",text:\"@font-face\"},{name:\"CHARSET_SYM\",text:\"@charset\"},{name:\"NAMESPACE_SYM\",text:\"@namespace\"},{name:\"VIEWPORT_SYM\",text:[\"@viewport\",\"@-ms-viewport\"]},{name:\"UNKNOWN_SYM\"},{name:\"KEYFRAMES_SYM\",text:[\"@keyframes\",\"@-webkit-keyframes\",\"@-moz-keyframes\",\"@-o-keyframes\"]},{name:\"IMPORTANT_SYM\"},{name:\"LENGTH\"},{name:\"ANGLE\"},{name:\"TIME\"},{name:\"FREQ\"},{name:\"DIMENSION\"},{name:\"PERCENTAGE\"},{name:\"NUMBER\"},{name:\"URI\"},{name:\"FUNCTION\"},{name:\"UNICODE_RANGE\"},{name:\"INVALID\"},{name:\"PLUS\",text:\"+\"},{name:\"GREATER\",text:\">\"},{name:\"COMMA\",text:\",\"},{name:\"TILDE\",text:\"~\"},{name:\"NOT\"},{name:\"TOPLEFTCORNER_SYM\",text:\"@top-left-corner\"},{name:\"TOPLEFT_SYM\",text:\"@top-left\"},{name:\"TOPCENTER_SYM\",text:\"@top-center\"},{name:\"TOPRIGHT_SYM\",text:\"@top-right\"},{name:\"TOPRIGHTCORNER_SYM\",text:\"@top-right-corner\"},{name:\"BOTTOMLEFTCORNER_SYM\",text:\"@bottom-left-corner\"},{name:\"BOTTOMLEFT_SYM\",text:\"@bottom-left\"},{name:\"BOTTOMCENTER_SYM\",text:\"@bottom-center\"},{name:\"BOTTOMRIGHT_SYM\",text:\"@bottom-right\"},{name:\"BOTTOMRIGHTCORNER_SYM\",text:\"@bottom-right-corner\"},{name:\"LEFTTOP_SYM\",text:\"@left-top\"},{name:\"LEFTMIDDLE_SYM\",text:\"@left-middle\"},{name:\"LEFTBOTTOM_SYM\",text:\"@left-bottom\"},{name:\"RIGHTTOP_SYM\",text:\"@right-top\"},{name:\"RIGHTMIDDLE_SYM\",text:\"@right-middle\"},{name:\"RIGHTBOTTOM_SYM\",text:\"@right-bottom\"},{name:\"RESOLUTION\",state:\"media\"},{name:\"IE_FUNCTION\"},{name:\"CHAR\"},{name:\"PIPE\",text:\"|\"},{name:\"SLASH\",text:\"/\"},{name:\"MINUS\",text:\"-\"},{name:\"STAR\",text:\"*\"},{name:\"LBRACE\",endChar:\"}\",text:\"{\"},{name:\"RBRACE\",text:\"}\"},{name:\"LBRACKET\",endChar:\"]\",text:\"[\"},{name:\"RBRACKET\",text:\"]\"},{name:\"EQUALS\",text:\"=\"},{name:\"COLON\",text:\":\"},{name:\"SEMICOLON\",text:\";\"},{name:\"LPAREN\",endChar:\")\",text:\"(\"},{name:\"RPAREN\",text:\")\"},{name:\"DOT\",text:\".\"}];(function(){var nameMap=[],typeMap={};Tokens.UNKNOWN=-1,Tokens.unshift({name:\"EOF\"});for(var i=0,len=Tokens.length;len>i;i++)if(nameMap.push(Tokens[i].name),Tokens[Tokens[i].name]=i,Tokens[i].text)if(Tokens[i].text instanceof Array)for(var j=0;Tokens[i].text.length>j;j++)typeMap[Tokens[i].text[j]]=i;else typeMap[Tokens[i].text]=i;Tokens.name=function(tt){return nameMap[tt]},Tokens.type=function(c){return typeMap[c]||-1}})();var Validation={validate:function(property,value){var name=(\"\"+property).toLowerCase(),expression=(value.parts,new PropertyValueIterator(value)),spec=Properties[name];if(spec)\"number\"!=typeof spec&&(\"string\"==typeof spec?spec.indexOf(\"||\")>-1?this.groupProperty(spec,expression):this.singleProperty(spec,expression,1):spec.multi?this.multiProperty(spec.multi,expression,spec.comma,spec.max||1/0):\"function\"==typeof spec&&spec(expression));else if(0!==name.indexOf(\"-\"))throw new ValidationError(\"Unknown property '\"+property+\"'.\",property.line,property.col)},singleProperty:function(types,expression,max){for(var part,result=!1,value=expression.value,count=0;expression.hasNext()&&max>count&&(result=ValidationTypes.isAny(expression,types));)count++;if(!result)throw expression.hasNext()&&!expression.isFirst()?(part=expression.peek(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)):new ValidationError(\"Expected (\"+types+\") but found '\"+value+\"'.\",value.line,value.col);if(expression.hasNext())throw part=expression.next(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)},multiProperty:function(types,expression,comma,max){for(var part,result=!1,value=expression.value,count=0;expression.hasNext()&&!result&&max>count&&ValidationTypes.isAny(expression,types);)if(count++,expression.hasNext()){if(comma){if(\",\"!=expression.peek())break;part=expression.next()}}else result=!0;if(!result)throw expression.hasNext()&&!expression.isFirst()?(part=expression.peek(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)):(part=expression.previous(),comma&&\",\"==part?new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col):new ValidationError(\"Expected (\"+types+\") but found '\"+value+\"'.\",value.line,value.col));if(expression.hasNext())throw part=expression.next(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)},groupProperty:function(types,expression){for(var name,part,result=!1,value=expression.value,typeCount=types.split(\"||\").length,groups={count:0},partial=!1;expression.hasNext()&&!result&&(name=ValidationTypes.isAnyOfGroup(expression,types))&&!groups[name];)groups[name]=1,groups.count++,partial=!0,groups.count!=typeCount&&expression.hasNext()||(result=!0);if(!result)throw partial&&expression.hasNext()?(part=expression.peek(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)):new ValidationError(\"Expected (\"+types+\") but found '\"+value+\"'.\",value.line,value.col);if(expression.hasNext())throw part=expression.next(),new ValidationError(\"Expected end of value but found '\"+part+\"'.\",part.line,part.col)}};ValidationError.prototype=Error();var ValidationTypes={isLiteral:function(part,literals){var i,len,text=(\"\"+part.text).toLowerCase(),args=literals.split(\" | \"),found=!1;for(i=0,len=args.length;len>i&&!found;i++)text==args[i].toLowerCase()&&(found=!0);return found},isSimple:function(type){return!!this.simple[type]},isComplex:function(type){return!!this.complex[type]},isAny:function(expression,types){var i,len,args=types.split(\" | \"),found=!1;for(i=0,len=args.length;len>i&&!found&&expression.hasNext();i++)found=this.isType(expression,args[i]);return found},isAnyOfGroup:function(expression,types){var i,len,args=types.split(\" || \"),found=!1;for(i=0,len=args.length;len>i&&!found;i++)found=this.isType(expression,args[i]);return found?args[i-1]:!1},isType:function(expression,type){var part=expression.peek(),result=!1;return\"<\"!=type.charAt(0)?(result=this.isLiteral(part,type),result&&expression.next()):this.simple[type]?(result=this.simple[type](part),result&&expression.next()):result=this.complex[type](expression),result},simple:{\"<absolute-size>\":function(part){return ValidationTypes.isLiteral(part,\"xx-small | x-small | small | medium | large | x-large | xx-large\")},\"<attachment>\":function(part){return ValidationTypes.isLiteral(part,\"scroll | fixed | local\")},\"<attr>\":function(part){return\"function\"==part.type&&\"attr\"==part.name},\"<bg-image>\":function(part){return this[\"<image>\"](part)||this[\"<gradient>\"](part)||\"none\"==part},\"<gradient>\":function(part){return\"function\"==part.type&&/^(?:\\-(?:ms|moz|o|webkit)\\-)?(?:repeating\\-)?(?:radial\\-|linear\\-)?gradient/i.test(part)},\"<box>\":function(part){return ValidationTypes.isLiteral(part,\"padding-box | border-box | content-box\")},\"<content>\":function(part){return\"function\"==part.type&&\"content\"==part.name},\"<relative-size>\":function(part){return ValidationTypes.isLiteral(part,\"smaller | larger\")},\"<ident>\":function(part){return\"identifier\"==part.type},\"<length>\":function(part){return\"function\"==part.type&&/^(?:\\-(?:ms|moz|o|webkit)\\-)?calc/i.test(part)?!0:\"length\"==part.type||\"number\"==part.type||\"integer\"==part.type||\"0\"==part},\"<color>\":function(part){return\"color\"==part.type||\"transparent\"==part},\"<number>\":function(part){return\"number\"==part.type||this[\"<integer>\"](part)},\"<integer>\":function(part){return\"integer\"==part.type},\"<line>\":function(part){return\"integer\"==part.type},\"<angle>\":function(part){return\"angle\"==part.type},\"<uri>\":function(part){return\"uri\"==part.type},\"<image>\":function(part){return this[\"<uri>\"](part)},\"<percentage>\":function(part){return\"percentage\"==part.type||\"0\"==part},\"<border-width>\":function(part){return this[\"<length>\"](part)||ValidationTypes.isLiteral(part,\"thin | medium | thick\")},\"<border-style>\":function(part){return ValidationTypes.isLiteral(part,\"none | hidden | dotted | dashed | solid | double | groove | ridge | inset | outset\")},\"<content-sizing>\":function(part){return ValidationTypes.isLiteral(part,\"fill-available | -moz-available | -webkit-fill-available | max-content | -moz-max-content | -webkit-max-content | min-content | -moz-min-content | -webkit-min-content | fit-content | -moz-fit-content | -webkit-fit-content\")},\"<margin-width>\":function(part){return this[\"<length>\"](part)||this[\"<percentage>\"](part)||ValidationTypes.isLiteral(part,\"auto\")},\"<padding-width>\":function(part){return this[\"<length>\"](part)||this[\"<percentage>\"](part)},\"<shape>\":function(part){return\"function\"==part.type&&(\"rect\"==part.name||\"inset-rect\"==part.name)},\"<time>\":function(part){return\"time\"==part.type},\"<flex-grow>\":function(part){return this[\"<number>\"](part)},\"<flex-shrink>\":function(part){return this[\"<number>\"](part)},\"<width>\":function(part){return this[\"<margin-width>\"](part)},\"<flex-basis>\":function(part){return this[\"<width>\"](part)},\"<flex-direction>\":function(part){return ValidationTypes.isLiteral(part,\"row | row-reverse | column | column-reverse\")},\"<flex-wrap>\":function(part){return ValidationTypes.isLiteral(part,\"nowrap | wrap | wrap-reverse\")}},complex:{\"<bg-position>\":function(expression){for(var result=!1,numeric=\"<percentage> | <length>\",xDir=\"left | right\",yDir=\"top | bottom\",count=0;expression.peek(count)&&\",\"!=expression.peek(count);)count++;return 3>count?ValidationTypes.isAny(expression,xDir+\" | center | \"+numeric)?(result=!0,ValidationTypes.isAny(expression,yDir+\" | center | \"+numeric)):ValidationTypes.isAny(expression,yDir)&&(result=!0,ValidationTypes.isAny(expression,xDir+\" | center\")):ValidationTypes.isAny(expression,xDir)?ValidationTypes.isAny(expression,yDir)?(result=!0,ValidationTypes.isAny(expression,numeric)):ValidationTypes.isAny(expression,numeric)&&(ValidationTypes.isAny(expression,yDir)?(result=!0,ValidationTypes.isAny(expression,numeric)):ValidationTypes.isAny(expression,\"center\")&&(result=!0)):ValidationTypes.isAny(expression,yDir)?ValidationTypes.isAny(expression,xDir)?(result=!0,ValidationTypes.isAny(expression,numeric)):ValidationTypes.isAny(expression,numeric)&&(ValidationTypes.isAny(expression,xDir)?(result=!0,ValidationTypes.isAny(expression,numeric)):ValidationTypes.isAny(expression,\"center\")&&(result=!0)):ValidationTypes.isAny(expression,\"center\")&&ValidationTypes.isAny(expression,xDir+\" | \"+yDir)&&(result=!0,ValidationTypes.isAny(expression,numeric)),result},\"<bg-size>\":function(expression){var result=!1,numeric=\"<percentage> | <length> | auto\";return ValidationTypes.isAny(expression,\"cover | contain\")?result=!0:ValidationTypes.isAny(expression,numeric)&&(result=!0,ValidationTypes.isAny(expression,numeric)),result},\"<repeat-style>\":function(expression){var part,result=!1,values=\"repeat | space | round | no-repeat\";return expression.hasNext()&&(part=expression.next(),ValidationTypes.isLiteral(part,\"repeat-x | repeat-y\")?result=!0:ValidationTypes.isLiteral(part,values)&&(result=!0,expression.hasNext()&&ValidationTypes.isLiteral(expression.peek(),values)&&expression.next())),result},\"<shadow>\":function(expression){var result=!1,count=0,inset=!1,color=!1;if(expression.hasNext()){for(ValidationTypes.isAny(expression,\"inset\")&&(inset=!0),ValidationTypes.isAny(expression,\"<color>\")&&(color=!0);ValidationTypes.isAny(expression,\"<length>\")&&4>count;)count++;expression.hasNext()&&(color||ValidationTypes.isAny(expression,\"<color>\"),inset||ValidationTypes.isAny(expression,\"inset\")),result=count>=2&&4>=count}return result},\"<x-one-radius>\":function(expression){var result=!1,simple=\"<length> | <percentage> | inherit\";return ValidationTypes.isAny(expression,simple)&&(result=!0,ValidationTypes.isAny(expression,simple)),result},\"<flex>\":function(expression){var part,result=!1;if(ValidationTypes.isAny(expression,\"none | inherit\")?result=!0:ValidationTypes.isType(expression,\"<flex-grow>\")?expression.peek()?ValidationTypes.isType(expression,\"<flex-shrink>\")?result=expression.peek()?ValidationTypes.isType(expression,\"<flex-basis>\"):!0:ValidationTypes.isType(expression,\"<flex-basis>\")&&(result=null===expression.peek()):result=!0:ValidationTypes.isType(expression,\"<flex-basis>\")&&(result=!0),!result)throw part=expression.peek(),new ValidationError(\"Expected (none | [ <flex-grow> <flex-shrink>? || <flex-basis> ]) but found '\"+expression.value.text+\"'.\",part.line,part.col);return result}}};parserlib.css={Colors:Colors,Combinator:Combinator,Parser:Parser,PropertyName:PropertyName,PropertyValue:PropertyValue,PropertyValuePart:PropertyValuePart,MediaFeature:MediaFeature,MediaQuery:MediaQuery,Selector:Selector,SelectorPart:SelectorPart,SelectorSubPart:SelectorSubPart,Specificity:Specificity,TokenStream:TokenStream,Tokens:Tokens,ValidationError:ValidationError}}(),function(){for(var prop in parserlib)exports[prop]=parserlib[prop]}();var util={isArray:function(ar){return Array.isArray(ar)||\"object\"==typeof ar&&\"[object Array]\"===objectToString(ar)},isDate:function(d){return\"object\"==typeof d&&\"[object Date]\"===objectToString(d)},isRegExp:function(re){return\"object\"==typeof re&&\"[object RegExp]\"===objectToString(re)},getRegExpFlags:function(re){var flags=\"\";return re.global&&(flags+=\"g\"),re.ignoreCase&&(flags+=\"i\"),re.multiline&&(flags+=\"m\"),flags}};\"object\"==typeof module&&(module.exports=clone),clone.clonePrototype=function(parent){if(null===parent)return null;var c=function(){};return c.prototype=parent,new c};var CSSLint=function(){function applyEmbeddedRuleset(text,ruleset){var valueMap,embedded=text&&text.match(embeddedRuleset),rules=embedded&&embedded[1];return rules&&(valueMap={\"true\":2,\"\":1,\"false\":0,2:2,1:1,0:0},rules.toLowerCase().split(\",\").forEach(function(rule){var pair=rule.split(\":\"),property=pair[0]||\"\",value=pair[1]||\"\";ruleset[property.trim()]=valueMap[value.trim()]})),ruleset}var rules=[],formatters=[],embeddedRuleset=/\\/\\*csslint([^\\*]*)\\*\\//,api=new parserlib.util.EventTarget;return api.version=\"@VERSION@\",api.addRule=function(rule){rules.push(rule),rules[rule.id]=rule},api.clearRules=function(){rules=[]},api.getRules=function(){return[].concat(rules).sort(function(a,b){return a.id>b.id?1:0})},api.getRuleset=function(){for(var ruleset={},i=0,len=rules.length;len>i;)ruleset[rules[i++].id]=1;return ruleset},api.addFormatter=function(formatter){formatters[formatter.id]=formatter},api.getFormatter=function(formatId){return formatters[formatId]},api.format=function(results,filename,formatId,options){var formatter=this.getFormatter(formatId),result=null;return formatter&&(result=formatter.startFormat(),result+=formatter.formatResults(results,filename,options||{}),result+=formatter.endFormat()),result},api.hasFormat=function(formatId){return formatters.hasOwnProperty(formatId)},api.verify=function(text,ruleset){var reporter,lines,report,i=0,parser=new parserlib.css.Parser({starHack:!0,ieFilters:!0,underscoreHack:!0,strict:!1});lines=text.replace(/\\n\\r?/g,\"$split$\").split(\"$split$\"),ruleset||(ruleset=this.getRuleset()),embeddedRuleset.test(text)&&(ruleset=clone(ruleset),ruleset=applyEmbeddedRuleset(text,ruleset)),reporter=new Reporter(lines,ruleset),ruleset.errors=2;for(i in ruleset)ruleset.hasOwnProperty(i)&&ruleset[i]&&rules[i]&&rules[i].init(parser,reporter);try{parser.parse(text)}catch(ex){reporter.error(\"Fatal error, cannot continue: \"+ex.message,ex.line,ex.col,{})}return report={messages:reporter.messages,stats:reporter.stats,ruleset:reporter.ruleset},report.messages.sort(function(a,b){return a.rollup&&!b.rollup?1:!a.rollup&&b.rollup?-1:a.line-b.line}),report},api}();Reporter.prototype={constructor:Reporter,error:function(message,line,col,rule){this.messages.push({type:\"error\",line:line,col:col,message:message,evidence:this.lines[line-1],rule:rule||{}})},warn:function(message,line,col,rule){this.report(message,line,col,rule)},report:function(message,line,col,rule){this.messages.push({type:2===this.ruleset[rule.id]?\"error\":\"warning\",line:line,col:col,message:message,evidence:this.lines[line-1],rule:rule})},info:function(message,line,col,rule){this.messages.push({type:\"info\",line:line,col:col,message:message,evidence:this.lines[line-1],rule:rule})},rollupError:function(message,rule){this.messages.push({type:\"error\",rollup:!0,message:message,rule:rule})},rollupWarn:function(message,rule){this.messages.push({type:\"warning\",rollup:!0,message:message,rule:rule})},stat:function(name,value){this.stats[name]=value}},CSSLint._Reporter=Reporter,CSSLint.Util={mix:function(receiver,supplier){var prop;for(prop in supplier)supplier.hasOwnProperty(prop)&&(receiver[prop]=supplier[prop]);return prop},indexOf:function(values,value){if(values.indexOf)return values.indexOf(value);for(var i=0,len=values.length;len>i;i++)if(values[i]===value)return i;return-1},forEach:function(values,func){if(values.forEach)return values.forEach(func);for(var i=0,len=values.length;len>i;i++)func(values[i],i,values)}},CSSLint.addRule({id:\"adjoining-classes\",name:\"Disallow adjoining classes\",desc:\"Don't use adjoining classes.\",browsers:\"IE6\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,modifier,classCount,i,j,k,selectors=event.selectors;for(i=0;selectors.length>i;i++)for(selector=selectors[i],j=0;selector.parts.length>j;j++)if(part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE)for(classCount=0,k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],\"class\"===modifier.type&&classCount++,classCount>1&&reporter.report(\"Don't use adjoining classes.\",part.line,part.col,rule)})}}),CSSLint.addRule({id:\"box-model\",name:\"Beware of broken box size\",desc:\"Don't use width or height when using padding or border.\",browsers:\"All\",init:function(parser,reporter){function startRule(){properties={},boxSizing=!1}function endRule(){var prop,value;if(!boxSizing){if(properties.height)for(prop in heightProperties)heightProperties.hasOwnProperty(prop)&&properties[prop]&&(value=properties[prop].value,(\"padding\"!==prop||2!==value.parts.length||0!==value.parts[0].value)&&reporter.report(\"Using height with \"+prop+\" can sometimes make elements larger than you expect.\",properties[prop].line,properties[prop].col,rule));if(properties.width)for(prop in widthProperties)widthProperties.hasOwnProperty(prop)&&properties[prop]&&(value=properties[prop].value,(\"padding\"!==prop||2!==value.parts.length||0!==value.parts[1].value)&&reporter.report(\"Using width with \"+prop+\" can sometimes make elements larger than you expect.\",properties[prop].line,properties[prop].col,rule))}}var properties,rule=this,widthProperties={border:1,\"border-left\":1,\"border-right\":1,padding:1,\"padding-left\":1,\"padding-right\":1},heightProperties={border:1,\"border-bottom\":1,\"border-top\":1,padding:1,\"padding-bottom\":1,\"padding-top\":1},boxSizing=!1;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase();heightProperties[name]||widthProperties[name]?/^0\\S*$/.test(event.value)||\"border\"===name&&\"none\"==\"\"+event.value||(properties[name]={line:event.property.line,col:event.property.col,value:event.value}):/^(width|height)/i.test(name)&&/^(length|percentage)/.test(event.value.parts[0].type)?properties[name]=1:\"box-sizing\"===name&&(boxSizing=!0)}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule),parser.addListener(\"endpage\",endRule),parser.addListener(\"endpagemargin\",endRule),parser.addListener(\"endkeyframerule\",endRule)}}),CSSLint.addRule({id:\"box-sizing\",name:\"Disallow use of box-sizing\",desc:\"The box-sizing properties isn't supported in IE6 and IE7.\",browsers:\"IE6, IE7\",tags:[\"Compatibility\"],init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase();\"box-sizing\"===name&&reporter.report(\"The box-sizing property isn't supported in IE6 and IE7.\",event.line,event.col,rule)})}}),CSSLint.addRule({id:\"bulletproof-font-face\",name:\"Use the bulletproof @font-face syntax\",desc:\"Use the bulletproof @font-face syntax to avoid 404's in old IE (http://www.fontspring.com/blog/the-new-bulletproof-font-face-syntax).\",browsers:\"All\",init:function(parser,reporter){var line,col,rule=this,fontFaceRule=!1,firstSrc=!0,ruleFailed=!1;parser.addListener(\"startfontface\",function(){fontFaceRule=!0}),parser.addListener(\"property\",function(event){if(fontFaceRule){var propertyName=(\"\"+event.property).toLowerCase(),value=\"\"+event.value;if(line=event.line,col=event.col,\"src\"===propertyName){var regex=/^\\s?url\\(['\"].+\\.eot\\?.*['\"]\\)\\s*format\\(['\"]embedded-opentype['\"]\\).*$/i;!value.match(regex)&&firstSrc?(ruleFailed=!0,firstSrc=!1):value.match(regex)&&!firstSrc&&(ruleFailed=!1)}}}),parser.addListener(\"endfontface\",function(){fontFaceRule=!1,ruleFailed&&reporter.report(\"@font-face declaration doesn't follow the fontspring bulletproof syntax.\",line,col,rule)})}}),CSSLint.addRule({id:\"compatible-vendor-prefixes\",name:\"Require compatible vendor prefixes\",desc:\"Include all compatible vendor prefixes to reach a wider range of users.\",browsers:\"All\",init:function(parser,reporter){var compatiblePrefixes,properties,prop,variations,prefixed,i,len,rule=this,inKeyFrame=!1,arrayPush=Array.prototype.push,applyTo=[];compatiblePrefixes={animation:\"webkit moz\",\"animation-delay\":\"webkit moz\",\"animation-direction\":\"webkit moz\",\"animation-duration\":\"webkit moz\",\"animation-fill-mode\":\"webkit moz\",\"animation-iteration-count\":\"webkit moz\",\"animation-name\":\"webkit moz\",\"animation-play-state\":\"webkit moz\",\"animation-timing-function\":\"webkit moz\",appearance:\"webkit moz\",\"border-end\":\"webkit moz\",\"border-end-color\":\"webkit moz\",\"border-end-style\":\"webkit moz\",\"border-end-width\":\"webkit moz\",\"border-image\":\"webkit moz o\",\"border-radius\":\"webkit\",\"border-start\":\"webkit moz\",\"border-start-color\":\"webkit moz\",\"border-start-style\":\"webkit moz\",\"border-start-width\":\"webkit moz\",\"box-align\":\"webkit moz ms\",\"box-direction\":\"webkit moz ms\",\"box-flex\":\"webkit moz ms\",\"box-lines\":\"webkit ms\",\"box-ordinal-group\":\"webkit moz ms\",\"box-orient\":\"webkit moz ms\",\"box-pack\":\"webkit moz ms\",\"box-sizing\":\"webkit moz\",\"box-shadow\":\"webkit moz\",\"column-count\":\"webkit moz ms\",\"column-gap\":\"webkit moz ms\",\"column-rule\":\"webkit moz ms\",\"column-rule-color\":\"webkit moz ms\",\"column-rule-style\":\"webkit moz ms\",\"column-rule-width\":\"webkit moz ms\",\"column-width\":\"webkit moz ms\",hyphens:\"epub moz\",\"line-break\":\"webkit ms\",\"margin-end\":\"webkit moz\",\"margin-start\":\"webkit moz\",\"marquee-speed\":\"webkit wap\",\"marquee-style\":\"webkit wap\",\"padding-end\":\"webkit moz\",\"padding-start\":\"webkit moz\",\"tab-size\":\"moz o\",\"text-size-adjust\":\"webkit ms\",transform:\"webkit moz ms o\",\"transform-origin\":\"webkit moz ms o\",transition:\"webkit moz o\",\"transition-delay\":\"webkit moz o\",\"transition-duration\":\"webkit moz o\",\"transition-property\":\"webkit moz o\",\"transition-timing-function\":\"webkit moz o\",\"user-modify\":\"webkit moz\",\"user-select\":\"webkit moz ms\",\"word-break\":\"epub ms\",\"writing-mode\":\"epub ms\"};for(prop in compatiblePrefixes)if(compatiblePrefixes.hasOwnProperty(prop)){for(variations=[],prefixed=compatiblePrefixes[prop].split(\" \"),i=0,len=prefixed.length;len>i;i++)variations.push(\"-\"+prefixed[i]+\"-\"+prop);compatiblePrefixes[prop]=variations,arrayPush.apply(applyTo,variations)}parser.addListener(\"startrule\",function(){properties=[]}),parser.addListener(\"startkeyframes\",function(event){inKeyFrame=event.prefix||!0}),parser.addListener(\"endkeyframes\",function(){inKeyFrame=!1}),parser.addListener(\"property\",function(event){var name=event.property;CSSLint.Util.indexOf(applyTo,name.text)>-1&&(inKeyFrame&&\"string\"==typeof inKeyFrame&&0===name.text.indexOf(\"-\"+inKeyFrame+\"-\")||properties.push(name))}),parser.addListener(\"endrule\",function(){if(properties.length){var i,len,name,prop,variations,value,full,actual,item,propertiesSpecified,propertyGroups={};for(i=0,len=properties.length;len>i;i++){name=properties[i];for(prop in compatiblePrefixes)compatiblePrefixes.hasOwnProperty(prop)&&(variations=compatiblePrefixes[prop],CSSLint.Util.indexOf(variations,name.text)>-1&&(propertyGroups[prop]||(propertyGroups[prop]={full:variations.slice(0),actual:[],actualNodes:[]}),-1===CSSLint.Util.indexOf(propertyGroups[prop].actual,name.text)&&(propertyGroups[prop].actual.push(name.text),propertyGroups[prop].actualNodes.push(name))))}for(prop in propertyGroups)if(propertyGroups.hasOwnProperty(prop)&&(value=propertyGroups[prop],full=value.full,actual=value.actual,full.length>actual.length))for(i=0,len=full.length;len>i;i++)item=full[i],-1===CSSLint.Util.indexOf(actual,item)&&(propertiesSpecified=1===actual.length?actual[0]:2===actual.length?actual.join(\" and \"):actual.join(\", \"),reporter.report(\"The property \"+item+\" is compatible with \"+propertiesSpecified+\" and should be included as well.\",value.actualNodes[0].line,value.actualNodes[0].col,rule))}})}}),CSSLint.addRule({id:\"display-property-grouping\",name:\"Require properties appropriate for display\",desc:\"Certain properties shouldn't be used with certain display property values.\",browsers:\"All\",init:function(parser,reporter){function reportProperty(name,display,msg){properties[name]&&(\"string\"!=typeof propertiesToCheck[name]||properties[name].value.toLowerCase()!==propertiesToCheck[name])&&reporter.report(msg||name+\" can't be used with display: \"+display+\".\",properties[name].line,properties[name].col,rule)}function startRule(){properties={}}function endRule(){var display=properties.display?properties.display.value:null;if(display)switch(display){case\"inline\":reportProperty(\"height\",display),reportProperty(\"width\",display),reportProperty(\"margin\",display),reportProperty(\"margin-top\",display),reportProperty(\"margin-bottom\",display),reportProperty(\"float\",display,\"display:inline has no effect on floated elements (but may be used to fix the IE6 double-margin bug).\");break;case\"block\":reportProperty(\"vertical-align\",display);\nbreak;case\"inline-block\":reportProperty(\"float\",display);break;default:0===display.indexOf(\"table-\")&&(reportProperty(\"margin\",display),reportProperty(\"margin-left\",display),reportProperty(\"margin-right\",display),reportProperty(\"margin-top\",display),reportProperty(\"margin-bottom\",display),reportProperty(\"float\",display))}}var properties,rule=this,propertiesToCheck={display:1,\"float\":\"none\",height:1,width:1,margin:1,\"margin-left\":1,\"margin-right\":1,\"margin-bottom\":1,\"margin-top\":1,padding:1,\"padding-left\":1,\"padding-right\":1,\"padding-bottom\":1,\"padding-top\":1,\"vertical-align\":1};parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase();propertiesToCheck[name]&&(properties[name]={value:event.value.text,line:event.property.line,col:event.property.col})}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule),parser.addListener(\"endkeyframerule\",endRule),parser.addListener(\"endpagemargin\",endRule),parser.addListener(\"endpage\",endRule)}}),CSSLint.addRule({id:\"duplicate-background-images\",name:\"Disallow duplicate background images\",desc:\"Every background-image should be unique. Use a common class for e.g. sprites.\",browsers:\"All\",init:function(parser,reporter){var rule=this,stack={};parser.addListener(\"property\",function(event){var i,len,name=event.property.text,value=event.value;if(name.match(/background/i))for(i=0,len=value.parts.length;len>i;i++)\"uri\"===value.parts[i].type&&(stack[value.parts[i].uri]===void 0?stack[value.parts[i].uri]=event:reporter.report(\"Background image '\"+value.parts[i].uri+\"' was used multiple times, first declared at line \"+stack[value.parts[i].uri].line+\", col \"+stack[value.parts[i].uri].col+\".\",event.line,event.col,rule))})}}),CSSLint.addRule({id:\"duplicate-properties\",name:\"Disallow duplicate properties\",desc:\"Duplicate properties must appear one after the other.\",browsers:\"All\",init:function(parser,reporter){function startRule(){properties={}}var properties,lastProperty,rule=this;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var property=event.property,name=property.text.toLowerCase();!properties[name]||lastProperty===name&&properties[name]!==event.value.text||reporter.report(\"Duplicate property '\"+event.property+\"' found.\",event.line,event.col,rule),properties[name]=event.value.text,lastProperty=name})}}),CSSLint.addRule({id:\"empty-rules\",name:\"Disallow empty rules\",desc:\"Rules without any properties specified should be removed.\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"startrule\",function(){count=0}),parser.addListener(\"property\",function(){count++}),parser.addListener(\"endrule\",function(event){var selectors=event.selectors;0===count&&reporter.report(\"Rule is empty.\",selectors[0].line,selectors[0].col,rule)})}}),CSSLint.addRule({id:\"errors\",name:\"Parsing Errors\",desc:\"This rule looks for recoverable syntax errors.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"error\",function(event){reporter.error(event.message,event.line,event.col,rule)})}}),CSSLint.addRule({id:\"fallback-colors\",name:\"Require fallback colors\",desc:\"For older browsers that don't support RGBA, HSL, or HSLA, provide a fallback color.\",browsers:\"IE6,IE7,IE8\",init:function(parser,reporter){function startRule(){properties={},lastProperty=null}var lastProperty,properties,rule=this,propertiesToCheck={color:1,background:1,\"border-color\":1,\"border-top-color\":1,\"border-right-color\":1,\"border-bottom-color\":1,\"border-left-color\":1,border:1,\"border-top\":1,\"border-right\":1,\"border-bottom\":1,\"border-left\":1,\"background-color\":1};parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var property=event.property,name=property.text.toLowerCase(),parts=event.value.parts,i=0,colorType=\"\",len=parts.length;if(propertiesToCheck[name])for(;len>i;)\"color\"===parts[i].type&&(\"alpha\"in parts[i]||\"hue\"in parts[i]?(/([^\\)]+)\\(/.test(parts[i])&&(colorType=RegExp.$1.toUpperCase()),lastProperty&&lastProperty.property.text.toLowerCase()===name&&\"compat\"===lastProperty.colorType||reporter.report(\"Fallback \"+name+\" (hex or RGB) should precede \"+colorType+\" \"+name+\".\",event.line,event.col,rule)):event.colorType=\"compat\"),i++;lastProperty=event})}}),CSSLint.addRule({id:\"floats\",name:\"Disallow too many floats\",desc:\"This rule tests if the float property is used too many times\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"property\",function(event){\"float\"===event.property.text.toLowerCase()&&\"none\"!==event.value.text.toLowerCase()&&count++}),parser.addListener(\"endstylesheet\",function(){reporter.stat(\"floats\",count),count>=10&&reporter.rollupWarn(\"Too many floats (\"+count+\"), you're probably using them for layout. Consider using a grid system instead.\",rule)})}}),CSSLint.addRule({id:\"font-faces\",name:\"Don't use too many web fonts\",desc:\"Too many different web fonts in the same stylesheet.\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"startfontface\",function(){count++}),parser.addListener(\"endstylesheet\",function(){count>5&&reporter.rollupWarn(\"Too many @font-face declarations (\"+count+\").\",rule)})}}),CSSLint.addRule({id:\"font-sizes\",name:\"Disallow too many font sizes\",desc:\"Checks the number of font-size declarations.\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"property\",function(event){\"font-size\"==\"\"+event.property&&count++}),parser.addListener(\"endstylesheet\",function(){reporter.stat(\"font-sizes\",count),count>=10&&reporter.rollupWarn(\"Too many font-size declarations (\"+count+\"), abstraction needed.\",rule)})}}),CSSLint.addRule({id:\"gradients\",name:\"Require all gradient definitions\",desc:\"When using a vendor-prefixed gradient, make sure to use them all.\",browsers:\"All\",init:function(parser,reporter){var gradients,rule=this;parser.addListener(\"startrule\",function(){gradients={moz:0,webkit:0,oldWebkit:0,o:0}}),parser.addListener(\"property\",function(event){/\\-(moz|o|webkit)(?:\\-(?:linear|radial))\\-gradient/i.test(event.value)?gradients[RegExp.$1]=1:/\\-webkit\\-gradient/i.test(event.value)&&(gradients.oldWebkit=1)}),parser.addListener(\"endrule\",function(event){var missing=[];gradients.moz||missing.push(\"Firefox 3.6+\"),gradients.webkit||missing.push(\"Webkit (Safari 5+, Chrome)\"),gradients.oldWebkit||missing.push(\"Old Webkit (Safari 4+, Chrome)\"),gradients.o||missing.push(\"Opera 11.1+\"),missing.length&&4>missing.length&&reporter.report(\"Missing vendor-prefixed CSS gradients for \"+missing.join(\", \")+\".\",event.selectors[0].line,event.selectors[0].col,rule)})}}),CSSLint.addRule({id:\"ids\",name:\"Disallow IDs in selectors\",desc:\"Selectors should not contain IDs.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,modifier,idCount,i,j,k,selectors=event.selectors;for(i=0;selectors.length>i;i++){for(selector=selectors[i],idCount=0,j=0;selector.parts.length>j;j++)if(part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE)for(k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],\"id\"===modifier.type&&idCount++;1===idCount?reporter.report(\"Don't use IDs in selectors.\",selector.line,selector.col,rule):idCount>1&&reporter.report(idCount+\" IDs in the selector, really?\",selector.line,selector.col,rule)}})}}),CSSLint.addRule({id:\"import\",name:\"Disallow @import\",desc:\"Don't use @import, use <link> instead.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"import\",function(event){reporter.report(\"@import prevents parallel downloads, use <link> instead.\",event.line,event.col,rule)})}}),CSSLint.addRule({id:\"important\",name:\"Disallow !important\",desc:\"Be careful when using !important declaration\",browsers:\"All\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"property\",function(event){event.important===!0&&(count++,reporter.report(\"Use of !important\",event.line,event.col,rule))}),parser.addListener(\"endstylesheet\",function(){reporter.stat(\"important\",count),count>=10&&reporter.rollupWarn(\"Too many !important declarations (\"+count+\"), try to use less than 10 to avoid specificity issues.\",rule)})}}),CSSLint.addRule({id:\"known-properties\",name:\"Require use of known properties\",desc:\"Properties should be known (listed in CSS3 specification) or be a vendor-prefixed property.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){event.invalid&&reporter.report(event.invalid.message,event.line,event.col,rule)})}}),CSSLint.addRule({id:\"order-alphabetical\",name:\"Alphabetical order\",desc:\"Assure properties are in alphabetical order\",browsers:\"All\",init:function(parser,reporter){var properties,rule=this,startRule=function(){properties=[]};parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text,lowerCasePrefixLessName=name.toLowerCase().replace(/^-.*?-/,\"\");properties.push(lowerCasePrefixLessName)}),parser.addListener(\"endrule\",function(event){var currentProperties=properties.join(\",\"),expectedProperties=properties.sort().join(\",\");currentProperties!==expectedProperties&&reporter.report(\"Rule doesn't have all its properties in alphabetical ordered.\",event.line,event.col,rule)})}}),CSSLint.addRule({id:\"outline-none\",name:\"Disallow outline: none\",desc:\"Use of outline: none or outline: 0 should be limited to :focus rules.\",browsers:\"All\",tags:[\"Accessibility\"],init:function(parser,reporter){function startRule(event){lastRule=event.selectors?{line:event.line,col:event.col,selectors:event.selectors,propCount:0,outline:!1}:null}function endRule(){lastRule&&lastRule.outline&&(-1===(\"\"+lastRule.selectors).toLowerCase().indexOf(\":focus\")?reporter.report(\"Outlines should only be modified using :focus.\",lastRule.line,lastRule.col,rule):1===lastRule.propCount&&reporter.report(\"Outlines shouldn't be hidden unless other visual changes are made.\",lastRule.line,lastRule.col,rule))}var lastRule,rule=this;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase(),value=event.value;lastRule&&(lastRule.propCount++,\"outline\"!==name||\"none\"!=\"\"+value&&\"0\"!=\"\"+value||(lastRule.outline=!0))}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule),parser.addListener(\"endpage\",endRule),parser.addListener(\"endpagemargin\",endRule),parser.addListener(\"endkeyframerule\",endRule)}}),CSSLint.addRule({id:\"overqualified-elements\",name:\"Disallow overqualified elements\",desc:\"Don't use classes or IDs with elements (a.foo or a#foo).\",browsers:\"All\",init:function(parser,reporter){var rule=this,classes={};parser.addListener(\"startrule\",function(event){var selector,part,modifier,i,j,k,selectors=event.selectors;for(i=0;selectors.length>i;i++)for(selector=selectors[i],j=0;selector.parts.length>j;j++)if(part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE)for(k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],part.elementName&&\"id\"===modifier.type?reporter.report(\"Element (\"+part+\") is overqualified, just use \"+modifier+\" without element name.\",part.line,part.col,rule):\"class\"===modifier.type&&(classes[modifier]||(classes[modifier]=[]),classes[modifier].push({modifier:modifier,part:part}))}),parser.addListener(\"endstylesheet\",function(){var prop;for(prop in classes)classes.hasOwnProperty(prop)&&1===classes[prop].length&&classes[prop][0].part.elementName&&reporter.report(\"Element (\"+classes[prop][0].part+\") is overqualified, just use \"+classes[prop][0].modifier+\" without element name.\",classes[prop][0].part.line,classes[prop][0].part.col,rule)})}}),CSSLint.addRule({id:\"qualified-headings\",name:\"Disallow qualified headings\",desc:\"Headings should not be qualified (namespaced).\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,i,j,selectors=event.selectors;for(i=0;selectors.length>i;i++)for(selector=selectors[i],j=0;selector.parts.length>j;j++)part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE&&part.elementName&&/h[1-6]/.test(\"\"+part.elementName)&&j>0&&reporter.report(\"Heading (\"+part.elementName+\") should not be qualified.\",part.line,part.col,rule)})}}),CSSLint.addRule({id:\"regex-selectors\",name:\"Disallow selectors that look like regexs\",desc:\"Selectors that look like regular expressions are slow and should be avoided.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,modifier,i,j,k,selectors=event.selectors;for(i=0;selectors.length>i;i++)for(selector=selectors[i],j=0;selector.parts.length>j;j++)if(part=selector.parts[j],part.type===parser.SELECTOR_PART_TYPE)for(k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],\"attribute\"===modifier.type&&/([\\~\\|\\^\\$\\*]=)/.test(modifier)&&reporter.report(\"Attribute selectors with \"+RegExp.$1+\" are slow!\",modifier.line,modifier.col,rule)})}}),CSSLint.addRule({id:\"rules-count\",name:\"Rules Count\",desc:\"Track how many rules there are.\",browsers:\"All\",init:function(parser,reporter){var count=0;parser.addListener(\"startrule\",function(){count++}),parser.addListener(\"endstylesheet\",function(){reporter.stat(\"rule-count\",count)})}}),CSSLint.addRule({id:\"selector-max-approaching\",name:\"Warn when approaching the 4095 selector limit for IE\",desc:\"Will warn when selector count is >= 3800 selectors.\",browsers:\"IE\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"startrule\",function(event){count+=event.selectors.length}),parser.addListener(\"endstylesheet\",function(){count>=3800&&reporter.report(\"You have \"+count+\" selectors. Internet Explorer supports a maximum of 4095 selectors per stylesheet. Consider refactoring.\",0,0,rule)})}}),CSSLint.addRule({id:\"selector-max\",name:\"Error when past the 4095 selector limit for IE\",desc:\"Will error when selector count is > 4095.\",browsers:\"IE\",init:function(parser,reporter){var rule=this,count=0;parser.addListener(\"startrule\",function(event){count+=event.selectors.length}),parser.addListener(\"endstylesheet\",function(){count>4095&&reporter.report(\"You have \"+count+\" selectors. Internet Explorer supports a maximum of 4095 selectors per stylesheet. Consider refactoring.\",0,0,rule)})}}),CSSLint.addRule({id:\"selector-newline\",name:\"Disallow new-line characters in selectors\",desc:\"New-line characters in selectors are usually a forgotten comma and not a descendant combinator.\",browsers:\"All\",init:function(parser,reporter){function startRule(event){var i,len,selector,p,n,pLen,part,part2,type,currentLine,nextLine,selectors=event.selectors;for(i=0,len=selectors.length;len>i;i++)for(selector=selectors[i],p=0,pLen=selector.parts.length;pLen>p;p++)for(n=p+1;pLen>n;n++)part=selector.parts[p],part2=selector.parts[n],type=part.type,currentLine=part.line,nextLine=part2.line,\"descendant\"===type&&nextLine>currentLine&&reporter.report(\"newline character found in selector (forgot a comma?)\",currentLine,selectors[i].parts[0].col,rule)}var rule=this;parser.addListener(\"startrule\",startRule)}}),CSSLint.addRule({id:\"shorthand\",name:\"Require shorthand properties\",desc:\"Use shorthand properties where possible.\",browsers:\"All\",init:function(parser,reporter){function startRule(){properties={}}function endRule(event){var prop,i,len,total;for(prop in mapping)if(mapping.hasOwnProperty(prop)){for(total=0,i=0,len=mapping[prop].length;len>i;i++)total+=properties[mapping[prop][i]]?1:0;total===mapping[prop].length&&reporter.report(\"The properties \"+mapping[prop].join(\", \")+\" can be replaced by \"+prop+\".\",event.line,event.col,rule)}}var prop,i,len,properties,rule=this,propertiesToCheck={},mapping={margin:[\"margin-top\",\"margin-bottom\",\"margin-left\",\"margin-right\"],padding:[\"padding-top\",\"padding-bottom\",\"padding-left\",\"padding-right\"]};for(prop in mapping)if(mapping.hasOwnProperty(prop))for(i=0,len=mapping[prop].length;len>i;i++)propertiesToCheck[mapping[prop][i]]=prop;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"property\",function(event){var name=(\"\"+event.property).toLowerCase();propertiesToCheck[name]&&(properties[name]=1)}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule)}}),CSSLint.addRule({id:\"star-property-hack\",name:\"Disallow properties with a star prefix\",desc:\"Checks for the star property hack (targets IE6/7)\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){var property=event.property;\"*\"===property.hack&&reporter.report(\"Property with star prefix found.\",event.property.line,event.property.col,rule)})}}),CSSLint.addRule({id:\"text-indent\",name:\"Disallow negative text-indent\",desc:\"Checks for text indent less than -99px\",browsers:\"All\",init:function(parser,reporter){function startRule(){textIndent=!1,direction=\"inherit\"}function endRule(){textIndent&&\"ltr\"!==direction&&reporter.report(\"Negative text-indent doesn't work well with RTL. If you use text-indent for image replacement explicitly set direction for that item to ltr.\",textIndent.line,textIndent.col,rule)}var textIndent,direction,rule=this;parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"property\",function(event){var name=(\"\"+event.property).toLowerCase(),value=event.value;\"text-indent\"===name&&-99>value.parts[0].value?textIndent=event.property:\"direction\"===name&&\"ltr\"==\"\"+value&&(direction=\"ltr\")}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule)}}),CSSLint.addRule({id:\"underscore-property-hack\",name:\"Disallow properties with an underscore prefix\",desc:\"Checks for the underscore property hack (targets IE6)\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){var property=event.property;\"_\"===property.hack&&reporter.report(\"Property with underscore prefix found.\",event.property.line,event.property.col,rule)})}}),CSSLint.addRule({id:\"unique-headings\",name:\"Headings should only be defined once\",desc:\"Headings should be defined only once.\",browsers:\"All\",init:function(parser,reporter){var rule=this,headings={h1:0,h2:0,h3:0,h4:0,h5:0,h6:0};parser.addListener(\"startrule\",function(event){var selector,part,pseudo,i,j,selectors=event.selectors;for(i=0;selectors.length>i;i++)if(selector=selectors[i],part=selector.parts[selector.parts.length-1],part.elementName&&/(h[1-6])/i.test(\"\"+part.elementName)){for(j=0;part.modifiers.length>j;j++)if(\"pseudo\"===part.modifiers[j].type){pseudo=!0;break}pseudo||(headings[RegExp.$1]++,headings[RegExp.$1]>1&&reporter.report(\"Heading (\"+part.elementName+\") has already been defined.\",part.line,part.col,rule))}}),parser.addListener(\"endstylesheet\",function(){var prop,messages=[];for(prop in headings)headings.hasOwnProperty(prop)&&headings[prop]>1&&messages.push(headings[prop]+\" \"+prop+\"s\");messages.length&&reporter.rollupWarn(\"You have \"+messages.join(\", \")+\" defined in this stylesheet.\",rule)})}}),CSSLint.addRule({id:\"universal-selector\",name:\"Disallow universal selector\",desc:\"The universal selector (*) is known to be slow.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,i,selectors=event.selectors;for(i=0;selectors.length>i;i++)selector=selectors[i],part=selector.parts[selector.parts.length-1],\"*\"===part.elementName&&reporter.report(rule.desc,part.line,part.col,rule)})}}),CSSLint.addRule({id:\"unqualified-attributes\",name:\"Disallow unqualified attribute selectors\",desc:\"Unqualified attribute selectors are known to be slow.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"startrule\",function(event){var selector,part,modifier,i,k,selectors=event.selectors;for(i=0;selectors.length>i;i++)if(selector=selectors[i],part=selector.parts[selector.parts.length-1],part.type===parser.SELECTOR_PART_TYPE)for(k=0;part.modifiers.length>k;k++)modifier=part.modifiers[k],\"attribute\"!==modifier.type||part.elementName&&\"*\"!==part.elementName||reporter.report(rule.desc,part.line,part.col,rule)})}}),CSSLint.addRule({id:\"vendor-prefix\",name:\"Require standard property with vendor prefix\",desc:\"When using a vendor-prefixed property, make sure to include the standard one.\",browsers:\"All\",init:function(parser,reporter){function startRule(){properties={},num=1}function endRule(){var prop,i,len,needed,actual,needsStandard=[];for(prop in properties)propertiesToCheck[prop]&&needsStandard.push({actual:prop,needed:propertiesToCheck[prop]});for(i=0,len=needsStandard.length;len>i;i++)needed=needsStandard[i].needed,actual=needsStandard[i].actual,properties[needed]?properties[needed][0].pos<properties[actual][0].pos&&reporter.report(\"Standard property '\"+needed+\"' should come after vendor-prefixed property '\"+actual+\"'.\",properties[actual][0].name.line,properties[actual][0].name.col,rule):reporter.report(\"Missing standard property '\"+needed+\"' to go along with '\"+actual+\"'.\",properties[actual][0].name.line,properties[actual][0].name.col,rule)}var properties,num,rule=this,propertiesToCheck={\"-webkit-border-radius\":\"border-radius\",\"-webkit-border-top-left-radius\":\"border-top-left-radius\",\"-webkit-border-top-right-radius\":\"border-top-right-radius\",\"-webkit-border-bottom-left-radius\":\"border-bottom-left-radius\",\"-webkit-border-bottom-right-radius\":\"border-bottom-right-radius\",\"-o-border-radius\":\"border-radius\",\"-o-border-top-left-radius\":\"border-top-left-radius\",\"-o-border-top-right-radius\":\"border-top-right-radius\",\"-o-border-bottom-left-radius\":\"border-bottom-left-radius\",\"-o-border-bottom-right-radius\":\"border-bottom-right-radius\",\"-moz-border-radius\":\"border-radius\",\"-moz-border-radius-topleft\":\"border-top-left-radius\",\"-moz-border-radius-topright\":\"border-top-right-radius\",\"-moz-border-radius-bottomleft\":\"border-bottom-left-radius\",\"-moz-border-radius-bottomright\":\"border-bottom-right-radius\",\"-moz-column-count\":\"column-count\",\"-webkit-column-count\":\"column-count\",\"-moz-column-gap\":\"column-gap\",\"-webkit-column-gap\":\"column-gap\",\"-moz-column-rule\":\"column-rule\",\"-webkit-column-rule\":\"column-rule\",\"-moz-column-rule-style\":\"column-rule-style\",\"-webkit-column-rule-style\":\"column-rule-style\",\"-moz-column-rule-color\":\"column-rule-color\",\"-webkit-column-rule-color\":\"column-rule-color\",\"-moz-column-rule-width\":\"column-rule-width\",\"-webkit-column-rule-width\":\"column-rule-width\",\"-moz-column-width\":\"column-width\",\"-webkit-column-width\":\"column-width\",\"-webkit-column-span\":\"column-span\",\"-webkit-columns\":\"columns\",\"-moz-box-shadow\":\"box-shadow\",\"-webkit-box-shadow\":\"box-shadow\",\"-moz-transform\":\"transform\",\"-webkit-transform\":\"transform\",\"-o-transform\":\"transform\",\"-ms-transform\":\"transform\",\"-moz-transform-origin\":\"transform-origin\",\"-webkit-transform-origin\":\"transform-origin\",\"-o-transform-origin\":\"transform-origin\",\"-ms-transform-origin\":\"transform-origin\",\"-moz-box-sizing\":\"box-sizing\",\"-webkit-box-sizing\":\"box-sizing\"};parser.addListener(\"startrule\",startRule),parser.addListener(\"startfontface\",startRule),parser.addListener(\"startpage\",startRule),parser.addListener(\"startpagemargin\",startRule),parser.addListener(\"startkeyframerule\",startRule),parser.addListener(\"property\",function(event){var name=event.property.text.toLowerCase();properties[name]||(properties[name]=[]),properties[name].push({name:event.property,value:event.value,pos:num++})}),parser.addListener(\"endrule\",endRule),parser.addListener(\"endfontface\",endRule),parser.addListener(\"endpage\",endRule),parser.addListener(\"endpagemargin\",endRule),parser.addListener(\"endkeyframerule\",endRule)}}),CSSLint.addRule({id:\"zero-units\",name:\"Disallow units for 0 values\",desc:\"You don't need to specify units when a value is 0.\",browsers:\"All\",init:function(parser,reporter){var rule=this;parser.addListener(\"property\",function(event){for(var parts=event.value.parts,i=0,len=parts.length;len>i;)!parts[i].units&&\"percentage\"!==parts[i].type||0!==parts[i].value||\"time\"===parts[i].type||reporter.report(\"Values of 0 shouldn't have units specified.\",parts[i].line,parts[i].col,rule),i++})}}),function(){var xmlEscape=function(str){return str&&str.constructor===String?str.replace(/[\\\"&><]/g,function(match){switch(match){case'\"':return\"&quot;\";case\"&\":return\"&amp;\";case\"<\":return\"&lt;\";case\">\":return\"&gt;\"}}):\"\"};CSSLint.addFormatter({id:\"checkstyle-xml\",name:\"Checkstyle XML format\",startFormat:function(){return'<?xml version=\"1.0\" encoding=\"utf-8\"?><checkstyle>'},endFormat:function(){return\"</checkstyle>\"},readError:function(filename,message){return'<file name=\"'+xmlEscape(filename)+'\"><error line=\"0\" column=\"0\" severty=\"error\" message=\"'+xmlEscape(message)+'\"></error></file>'},formatResults:function(results,filename){var messages=results.messages,output=[],generateSource=function(rule){return rule&&\"name\"in rule?\"net.csslint.\"+rule.name.replace(/\\s/g,\"\"):\"\"};return messages.length>0&&(output.push('<file name=\"'+filename+'\">'),CSSLint.Util.forEach(messages,function(message){message.rollup||output.push('<error line=\"'+message.line+'\" column=\"'+message.col+'\" severity=\"'+message.type+'\"'+' message=\"'+xmlEscape(message.message)+'\" source=\"'+generateSource(message.rule)+'\"/>')}),output.push(\"</file>\")),output.join(\"\")}})}(),CSSLint.addFormatter({id:\"compact\",name:\"Compact, 'porcelain' format\",startFormat:function(){return\"\"},endFormat:function(){return\"\"},formatResults:function(results,filename,options){var messages=results.messages,output=\"\";options=options||{};var capitalize=function(str){return str.charAt(0).toUpperCase()+str.slice(1)};return 0===messages.length?options.quiet?\"\":filename+\": Lint Free!\":(CSSLint.Util.forEach(messages,function(message){output+=message.rollup?filename+\": \"+capitalize(message.type)+\" - \"+message.message+\"\\n\":filename+\": \"+\"line \"+message.line+\", col \"+message.col+\", \"+capitalize(message.type)+\" - \"+message.message+\" (\"+message.rule.id+\")\\n\"}),output)}}),CSSLint.addFormatter({id:\"csslint-xml\",name:\"CSSLint XML format\",startFormat:function(){return'<?xml version=\"1.0\" encoding=\"utf-8\"?><csslint>'},endFormat:function(){return\"</csslint>\"},formatResults:function(results,filename){var messages=results.messages,output=[],escapeSpecialCharacters=function(str){return str&&str.constructor===String?str.replace(/\\\"/g,\"'\").replace(/&/g,\"&amp;\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\"):\"\"};return messages.length>0&&(output.push('<file name=\"'+filename+'\">'),CSSLint.Util.forEach(messages,function(message){message.rollup?output.push('<issue severity=\"'+message.type+'\" reason=\"'+escapeSpecialCharacters(message.message)+'\" evidence=\"'+escapeSpecialCharacters(message.evidence)+'\"/>'):output.push('<issue line=\"'+message.line+'\" char=\"'+message.col+'\" severity=\"'+message.type+'\"'+' reason=\"'+escapeSpecialCharacters(message.message)+'\" evidence=\"'+escapeSpecialCharacters(message.evidence)+'\"/>')}),output.push(\"</file>\")),output.join(\"\")}}),CSSLint.addFormatter({id:\"junit-xml\",name:\"JUNIT XML format\",startFormat:function(){return'<?xml version=\"1.0\" encoding=\"utf-8\"?><testsuites>'},endFormat:function(){return\"</testsuites>\"},formatResults:function(results,filename){var messages=results.messages,output=[],tests={error:0,failure:0},generateSource=function(rule){return rule&&\"name\"in rule?\"net.csslint.\"+rule.name.replace(/\\s/g,\"\"):\"\"},escapeSpecialCharacters=function(str){return str&&str.constructor===String?str.replace(/\\\"/g,\"'\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\"):\"\"};return messages.length>0&&(messages.forEach(function(message){var type=\"warning\"===message.type?\"error\":message.type;message.rollup||(output.push('<testcase time=\"0\" name=\"'+generateSource(message.rule)+'\">'),output.push(\"<\"+type+' message=\"'+escapeSpecialCharacters(message.message)+'\"><![CDATA['+message.line+\":\"+message.col+\":\"+escapeSpecialCharacters(message.evidence)+\"]]></\"+type+\">\"),output.push(\"</testcase>\"),tests[type]+=1)}),output.unshift('<testsuite time=\"0\" tests=\"'+messages.length+'\" skipped=\"0\" errors=\"'+tests.error+'\" failures=\"'+tests.failure+'\" package=\"net.csslint\" name=\"'+filename+'\">'),output.push(\"</testsuite>\")),output.join(\"\")}}),CSSLint.addFormatter({id:\"lint-xml\",name:\"Lint XML format\",startFormat:function(){return'<?xml version=\"1.0\" encoding=\"utf-8\"?><lint>'},endFormat:function(){return\"</lint>\"},formatResults:function(results,filename){var messages=results.messages,output=[],escapeSpecialCharacters=function(str){return str&&str.constructor===String?str.replace(/\\\"/g,\"'\").replace(/&/g,\"&amp;\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\"):\"\"};return messages.length>0&&(output.push('<file name=\"'+filename+'\">'),CSSLint.Util.forEach(messages,function(message){message.rollup?output.push('<issue severity=\"'+message.type+'\" reason=\"'+escapeSpecialCharacters(message.message)+'\" evidence=\"'+escapeSpecialCharacters(message.evidence)+'\"/>'):output.push('<issue line=\"'+message.line+'\" char=\"'+message.col+'\" severity=\"'+message.type+'\"'+' reason=\"'+escapeSpecialCharacters(message.message)+'\" evidence=\"'+escapeSpecialCharacters(message.evidence)+'\"/>')}),output.push(\"</file>\")),output.join(\"\")}}),CSSLint.addFormatter({id:\"text\",name:\"Plain Text\",startFormat:function(){return\"\"},endFormat:function(){return\"\"},formatResults:function(results,filename,options){var messages=results.messages,output=\"\";if(options=options||{},0===messages.length)return options.quiet?\"\":\"\\n\\ncsslint: No errors in \"+filename+\".\";output=\"\\n\\ncsslint: There \",output+=1===messages.length?\"is 1 problem\":\"are \"+messages.length+\" problems\",output+=\" in \"+filename+\".\";var pos=filename.lastIndexOf(\"/\"),shortFilename=filename;return-1===pos&&(pos=filename.lastIndexOf(\"\\\\\")),pos>-1&&(shortFilename=filename.substring(pos+1)),CSSLint.Util.forEach(messages,function(message,i){output=output+\"\\n\\n\"+shortFilename,message.rollup?(output+=\"\\n\"+(i+1)+\": \"+message.type,output+=\"\\n\"+message.message):(output+=\"\\n\"+(i+1)+\": \"+message.type+\" at line \"+message.line+\", col \"+message.col,output+=\"\\n\"+message.message,output+=\"\\n\"+message.evidence)}),output}}),module.exports.CSSLint=CSSLint}),ace.define(\"ace/mode/css_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/lang\",\"ace/worker/mirror\",\"ace/mode/css/csslint\"],function(acequire,exports){\"use strict\";var oop=acequire(\"../lib/oop\"),lang=acequire(\"../lib/lang\"),Mirror=acequire(\"../worker/mirror\").Mirror,CSSLint=acequire(\"./css/csslint\").CSSLint,Worker=exports.Worker=function(sender){Mirror.call(this,sender),this.setTimeout(400),this.ruleset=null,this.setDisabledRules(\"ids|order-alphabetical\"),this.setInfoRules(\"adjoining-classes|qualified-headings|zero-units|gradients|import|outline-none|vendor-prefix\")};oop.inherits(Worker,Mirror),function(){this.setInfoRules=function(ruleNames){\"string\"==typeof ruleNames&&(ruleNames=ruleNames.split(\"|\")),this.infoRules=lang.arrayToMap(ruleNames),this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.setDisabledRules=function(ruleNames){if(ruleNames){\"string\"==typeof ruleNames&&(ruleNames=ruleNames.split(\"|\"));\nvar all={};CSSLint.getRules().forEach(function(x){all[x.id]=!0}),ruleNames.forEach(function(x){delete all[x]}),this.ruleset=all}else this.ruleset=null;this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.onUpdate=function(){var value=this.doc.getValue();if(!value)return this.sender.emit(\"annotate\",[]);var infoRules=this.infoRules,result=CSSLint.verify(value,this.ruleset);this.sender.emit(\"annotate\",result.messages.map(function(msg){return{row:msg.line-1,column:msg.col-1,text:msg.message,type:infoRules[msg.rule.id]?\"info\":msg.type,rule:msg.rule.name}}))}}.call(Worker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports.id = 'ace/mode/html_worker';
module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/html/saxparser\",[\"require\",\"exports\",\"module\"],function(acequire,exports,module){module.exports=function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=\"function\"==typeof acequire&&acequire;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw Error(\"Cannot find module '\"+o+\"'\")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}for(var i=\"function\"==typeof acequire&&acequire,o=0;r.length>o;o++)s(r[o]);return s}({1:[function(_dereq_,module,exports){function isScopeMarker(node){return\"http://www.w3.org/1999/xhtml\"===node.namespaceURI?\"applet\"===node.localName||\"caption\"===node.localName||\"marquee\"===node.localName||\"object\"===node.localName||\"table\"===node.localName||\"td\"===node.localName||\"th\"===node.localName:\"http://www.w3.org/1998/Math/MathML\"===node.namespaceURI?\"mi\"===node.localName||\"mo\"===node.localName||\"mn\"===node.localName||\"ms\"===node.localName||\"mtext\"===node.localName||\"annotation-xml\"===node.localName:\"http://www.w3.org/2000/svg\"===node.namespaceURI?\"foreignObject\"===node.localName||\"desc\"===node.localName||\"title\"===node.localName:void 0}function isListItemScopeMarker(node){return isScopeMarker(node)||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"ol\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"ul\"===node.localName}function isTableScopeMarker(node){return\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"table\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"html\"===node.localName}function isTableBodyScopeMarker(node){return\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"tbody\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"tfoot\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"thead\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"html\"===node.localName}function isTableRowScopeMarker(node){return\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"tr\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"html\"===node.localName}function isButtonScopeMarker(node){return isScopeMarker(node)||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"button\"===node.localName}function isSelectScopeMarker(node){return!(\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"optgroup\"===node.localName||\"http://www.w3.org/1999/xhtml\"===node.namespaceURI&&\"option\"===node.localName)}function ElementStack(){this.elements=[],this.rootNode=null,this.headElement=null,this.bodyElement=null}ElementStack.prototype._inScope=function(localName,isMarker){for(var i=this.elements.length-1;i>=0;i--){var node=this.elements[i];if(node.localName===localName)return!0;if(isMarker(node))return!1}},ElementStack.prototype.push=function(item){this.elements.push(item)},ElementStack.prototype.pushHtmlElement=function(item){this.rootNode=item.node,this.push(item)},ElementStack.prototype.pushHeadElement=function(item){this.headElement=item.node,this.push(item)},ElementStack.prototype.pushBodyElement=function(item){this.bodyElement=item.node,this.push(item)},ElementStack.prototype.pop=function(){return this.elements.pop()},ElementStack.prototype.remove=function(item){this.elements.splice(this.elements.indexOf(item),1)},ElementStack.prototype.popUntilPopped=function(localName){var element;do element=this.pop();while(element.localName!=localName)},ElementStack.prototype.popUntilTableScopeMarker=function(){for(;!isTableScopeMarker(this.top);)this.pop()},ElementStack.prototype.popUntilTableBodyScopeMarker=function(){for(;!isTableBodyScopeMarker(this.top);)this.pop()},ElementStack.prototype.popUntilTableRowScopeMarker=function(){for(;!isTableRowScopeMarker(this.top);)this.pop()},ElementStack.prototype.item=function(index){return this.elements[index]},ElementStack.prototype.contains=function(element){return-1!==this.elements.indexOf(element)},ElementStack.prototype.inScope=function(localName){return this._inScope(localName,isScopeMarker)},ElementStack.prototype.inListItemScope=function(localName){return this._inScope(localName,isListItemScopeMarker)},ElementStack.prototype.inTableScope=function(localName){return this._inScope(localName,isTableScopeMarker)},ElementStack.prototype.inButtonScope=function(localName){return this._inScope(localName,isButtonScopeMarker)},ElementStack.prototype.inSelectScope=function(localName){return this._inScope(localName,isSelectScopeMarker)},ElementStack.prototype.hasNumberedHeaderElementInScope=function(){for(var i=this.elements.length-1;i>=0;i--){var node=this.elements[i];if(node.isNumberedHeader())return!0;if(isScopeMarker(node))return!1}},ElementStack.prototype.furthestBlockForFormattingElement=function(element){for(var furthestBlock=null,i=this.elements.length-1;i>=0;i--){var node=this.elements[i];\nif(node.node===element)break;node.isSpecial()&&(furthestBlock=node)}return furthestBlock},ElementStack.prototype.findIndex=function(localName){for(var i=this.elements.length-1;i>=0;i--)if(this.elements[i].localName==localName)return i;return-1},ElementStack.prototype.remove_openElements_until=function(callback){for(var element,finished=!1;!finished;)element=this.elements.pop(),finished=callback(element);return element},Object.defineProperty(ElementStack.prototype,\"top\",{get:function(){return this.elements[this.elements.length-1]}}),Object.defineProperty(ElementStack.prototype,\"length\",{get:function(){return this.elements.length}}),exports.ElementStack=ElementStack},{}],2:[function(_dereq_,module,exports){function isAlphaNumeric(c){return c>=\"0\"&&\"9\">=c||c>=\"a\"&&\"z\">=c||c>=\"A\"&&\"Z\">=c}function isHexDigit(c){return c>=\"0\"&&\"9\">=c||c>=\"a\"&&\"f\">=c||c>=\"A\"&&\"F\">=c}function isDecimalDigit(c){return c>=\"0\"&&\"9\">=c}var entities=_dereq_(\"html5-entities\"),InputStream=_dereq_(\"./InputStream\").InputStream,namedEntityPrefixes={};Object.keys(entities).forEach(function(entityKey){for(var i=0;entityKey.length>i;i++)namedEntityPrefixes[entityKey.substring(0,i+1)]=!0});var EntityParser={};EntityParser.consumeEntity=function(buffer,tokenizer,additionalAllowedCharacter){var decodedCharacter=\"\",consumedCharacters=\"\",ch=buffer.char();if(ch===InputStream.EOF)return!1;if(consumedCharacters+=ch,\"\t\"==ch||\"\\n\"==ch||\"\u000b\"==ch||\" \"==ch||\"<\"==ch||\"&\"==ch)return buffer.unget(consumedCharacters),!1;if(additionalAllowedCharacter===ch)return buffer.unget(consumedCharacters),!1;if(\"#\"==ch){if(ch=buffer.shift(1),ch===InputStream.EOF)return tokenizer._parseError(\"expected-numeric-entity-but-got-eof\"),buffer.unget(consumedCharacters),!1;consumedCharacters+=ch;var radix=10,isDigit=isDecimalDigit;if(\"x\"==ch||\"X\"==ch){if(radix=16,isDigit=isHexDigit,ch=buffer.shift(1),ch===InputStream.EOF)return tokenizer._parseError(\"expected-numeric-entity-but-got-eof\"),buffer.unget(consumedCharacters),!1;consumedCharacters+=ch}if(isDigit(ch)){for(var code=\"\";ch!==InputStream.EOF&&isDigit(ch);)code+=ch,ch=buffer.char();code=parseInt(code,radix);var replacement=this.replaceEntityNumbers(code);if(replacement&&(tokenizer._parseError(\"invalid-numeric-entity-replaced\"),code=replacement),code>65535&&1114111>=code){code-=65536;var first=((1047552&code)>>10)+55296,second=(1023&code)+56320;decodedCharacter=String.fromCharCode(first,second)}else decodedCharacter=String.fromCharCode(code);return\";\"!==ch&&(tokenizer._parseError(\"numeric-entity-without-semicolon\"),buffer.unget(ch)),decodedCharacter}return buffer.unget(consumedCharacters),tokenizer._parseError(\"expected-numeric-entity\"),!1}if(ch>=\"a\"&&\"z\">=ch||ch>=\"A\"&&\"Z\">=ch){for(var mostRecentMatch=\"\";namedEntityPrefixes[consumedCharacters]&&(entities[consumedCharacters]&&(mostRecentMatch=consumedCharacters),\";\"!=ch)&&(ch=buffer.char(),ch!==InputStream.EOF);)consumedCharacters+=ch;return mostRecentMatch?(decodedCharacter=entities[mostRecentMatch],\";\"===ch||!additionalAllowedCharacter||!isAlphaNumeric(ch)&&\"=\"!==ch?(consumedCharacters.length>mostRecentMatch.length&&buffer.unget(consumedCharacters.substring(mostRecentMatch.length)),\";\"!==ch&&tokenizer._parseError(\"named-entity-without-semicolon\"),decodedCharacter):(buffer.unget(consumedCharacters),!1)):(tokenizer._parseError(\"expected-named-entity\"),buffer.unget(consumedCharacters),!1)}},EntityParser.replaceEntityNumbers=function(c){switch(c){case 0:return 65533;case 19:return 16;case 128:return 8364;case 129:return 129;case 130:return 8218;case 131:return 402;case 132:return 8222;case 133:return 8230;case 134:return 8224;case 135:return 8225;case 136:return 710;case 137:return 8240;case 138:return 352;case 139:return 8249;case 140:return 338;case 141:return 141;case 142:return 381;case 143:return 143;case 144:return 144;case 145:return 8216;case 146:return 8217;case 147:return 8220;case 148:return 8221;case 149:return 8226;case 150:return 8211;case 151:return 8212;case 152:return 732;case 153:return 8482;case 154:return 353;case 155:return 8250;case 156:return 339;case 157:return 157;case 158:return 382;case 159:return 376;default:if(c>=55296&&57343>=c||c>1114111)return 65533;if(c>=1&&8>=c||c>=14&&31>=c||c>=127&&159>=c||c>=64976&&65007>=c||11==c||65534==c||131070==c||3145726==c||196607==c||262142==c||262143==c||327678==c||327679==c||393214==c||393215==c||458750==c||458751==c||524286==c||524287==c||589822==c||589823==c||655358==c||655359==c||720894==c||720895==c||786430==c||786431==c||851966==c||851967==c||917502==c||917503==c||983038==c||983039==c||1048574==c||1048575==c||1114110==c||1114111==c)return c}},exports.EntityParser=EntityParser},{\"./InputStream\":3,\"html5-entities\":12}],3:[function(_dereq_,module,exports){function InputStream(){this.data=\"\",this.start=0,this.committed=0,this.eof=!1,this.lastLocation={line:0,column:0}}InputStream.EOF=-1,InputStream.DRAIN=-2,InputStream.prototype={slice:function(){if(this.start>=this.data.length){if(!this.eof)throw InputStream.DRAIN;return InputStream.EOF}return this.data.slice(this.start,this.data.length)},\"char\":function(){if(!this.eof&&this.start>=this.data.length-1)throw InputStream.DRAIN;if(this.start>=this.data.length)return InputStream.EOF;var ch=this.data[this.start++];return\"\\r\"===ch&&(ch=\"\\n\"),ch},advance:function(amount){if(this.start+=amount,this.start>=this.data.length){if(!this.eof)throw InputStream.DRAIN;return InputStream.EOF}this.committed>this.data.length/2&&(this.lastLocation=this.location(),this.data=this.data.slice(this.committed),this.start=this.start-this.committed,this.committed=0)},matchWhile:function(re){if(this.eof&&this.start>=this.data.length)return\"\";var r=RegExp(\"^\"+re+\"+\"),m=r.exec(this.slice());if(m){if(!this.eof&&m[0].length==this.data.length-this.start)throw InputStream.DRAIN;return this.advance(m[0].length),m[0]}return\"\"},matchUntil:function(re){var m,s;if(s=this.slice(),s===InputStream.EOF)return\"\";if(m=RegExp(re+(this.eof?\"|$\":\"\")).exec(s)){var t=this.data.slice(this.start,this.start+m.index);return this.advance(m.index),t.replace(/\\r/g,\"\\n\").replace(/\\n{2,}/g,\"\\n\")}throw InputStream.DRAIN},append:function(data){this.data+=data},shift:function(n){if(!this.eof&&this.start+n>=this.data.length)throw InputStream.DRAIN;if(this.eof&&this.start>=this.data.length)return InputStream.EOF;var d=\"\"+this.data.slice(this.start,this.start+n);return this.advance(Math.min(n,this.data.length-this.start)),d},peek:function(n){if(!this.eof&&this.start+n>=this.data.length)throw InputStream.DRAIN;return this.eof&&this.start>=this.data.length?InputStream.EOF:\"\"+this.data.slice(this.start,Math.min(this.start+n,this.data.length))},length:function(){return this.data.length-this.start-1},unget:function(d){d!==InputStream.EOF&&(this.start-=d.length)},undo:function(){this.start=this.committed},commit:function(){this.committed=this.start},location:function(){var lastLine=this.lastLocation.line,lastColumn=this.lastLocation.column,read=this.data.slice(0,this.committed),newlines=read.match(/\\n/g),line=newlines?lastLine+newlines.length:lastLine,column=newlines?read.length-read.lastIndexOf(\"\\n\")-1:lastColumn+read.length;return{line:line,column:column}}},exports.InputStream=InputStream},{}],4:[function(_dereq_,module,exports){function StackItem(namespaceURI,localName,attributes,node){this.localName=localName,this.namespaceURI=namespaceURI,this.attributes=attributes,this.node=node}function getAttribute(item,name){for(var i=0;item.attributes.length>i;i++)if(item.attributes[i].nodeName==name)return item.attributes[i].nodeValue;return null}var SpecialElements={\"http://www.w3.org/1999/xhtml\":[\"address\",\"applet\",\"area\",\"article\",\"aside\",\"base\",\"basefont\",\"bgsound\",\"blockquote\",\"body\",\"br\",\"button\",\"caption\",\"center\",\"col\",\"colgroup\",\"dd\",\"details\",\"dir\",\"div\",\"dl\",\"dt\",\"embed\",\"fieldset\",\"figcaption\",\"figure\",\"footer\",\"form\",\"frame\",\"frameset\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"head\",\"header\",\"hgroup\",\"hr\",\"html\",\"iframe\",\"img\",\"input\",\"isindex\",\"li\",\"link\",\"listing\",\"main\",\"marquee\",\"menu\",\"menuitem\",\"meta\",\"nav\",\"noembed\",\"noframes\",\"noscript\",\"object\",\"ol\",\"p\",\"param\",\"plaintext\",\"pre\",\"script\",\"section\",\"select\",\"source\",\"style\",\"summary\",\"table\",\"tbody\",\"td\",\"textarea\",\"tfoot\",\"th\",\"thead\",\"title\",\"tr\",\"track\",\"ul\",\"wbr\",\"xmp\"],\"http://www.w3.org/1998/Math/MathML\":[\"mi\",\"mo\",\"mn\",\"ms\",\"mtext\",\"annotation-xml\"],\"http://www.w3.org/2000/svg\":[\"foreignObject\",\"desc\",\"title\"]};StackItem.prototype.isSpecial=function(){return this.namespaceURI in SpecialElements&&SpecialElements[this.namespaceURI].indexOf(this.localName)>-1},StackItem.prototype.isFosterParenting=function(){return\"http://www.w3.org/1999/xhtml\"===this.namespaceURI?\"table\"===this.localName||\"tbody\"===this.localName||\"tfoot\"===this.localName||\"thead\"===this.localName||\"tr\"===this.localName:!1},StackItem.prototype.isNumberedHeader=function(){return\"http://www.w3.org/1999/xhtml\"===this.namespaceURI?\"h1\"===this.localName||\"h2\"===this.localName||\"h3\"===this.localName||\"h4\"===this.localName||\"h5\"===this.localName||\"h6\"===this.localName:!1},StackItem.prototype.isForeign=function(){return\"http://www.w3.org/1999/xhtml\"!=this.namespaceURI},StackItem.prototype.isHtmlIntegrationPoint=function(){if(\"http://www.w3.org/1998/Math/MathML\"===this.namespaceURI){if(\"annotation-xml\"!==this.localName)return!1;var encoding=getAttribute(this,\"encoding\");return encoding?(encoding=encoding.toLowerCase(),\"text/html\"===encoding||\"application/xhtml+xml\"===encoding):!1}return\"http://www.w3.org/2000/svg\"===this.namespaceURI?\"foreignObject\"===this.localName||\"desc\"===this.localName||\"title\"===this.localName:!1},StackItem.prototype.isMathMLTextIntegrationPoint=function(){return\"http://www.w3.org/1998/Math/MathML\"===this.namespaceURI?\"mi\"===this.localName||\"mo\"===this.localName||\"mn\"===this.localName||\"ms\"===this.localName||\"mtext\"===this.localName:!1},exports.StackItem=StackItem},{}],5:[function(_dereq_,module,exports){function isWhitespace(c){return\" \"===c||\"\\n\"===c||\"\t\"===c||\"\\r\"===c||\"\\f\"===c}function isAlpha(c){return c>=\"A\"&&\"Z\">=c||c>=\"a\"&&\"z\">=c}function Tokenizer(tokenHandler){this._tokenHandler=tokenHandler,this._state=Tokenizer.DATA,this._inputStream=new InputStream,this._currentToken=null,this._temporaryBuffer=\"\",this._additionalAllowedCharacter=\"\"}var InputStream=_dereq_(\"./InputStream\").InputStream,EntityParser=_dereq_(\"./EntityParser\").EntityParser;Tokenizer.prototype._parseError=function(code,args){this._tokenHandler.parseError(code,args)},Tokenizer.prototype._emitToken=function(token){if(\"StartTag\"===token.type)for(var i=1;token.data.length>i;i++)token.data[i].nodeName||token.data.splice(i--,1);else\"EndTag\"===token.type&&(token.selfClosing&&this._parseError(\"self-closing-flag-on-end-tag\"),0!==token.data.length&&this._parseError(\"attributes-in-end-tag\"));this._tokenHandler.processToken(token),\"StartTag\"===token.type&&token.selfClosing&&!this._tokenHandler.isSelfClosingFlagAcknowledged()&&this._parseError(\"non-void-element-with-trailing-solidus\",{name:token.name})},Tokenizer.prototype._emitCurrentToken=function(){this._state=Tokenizer.DATA,this._emitToken(this._currentToken)},Tokenizer.prototype._currentAttribute=function(){return this._currentToken.data[this._currentToken.data.length-1]},Tokenizer.prototype.setState=function(state){this._state=state},Tokenizer.prototype.tokenize=function(source){function data_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"&\"===data)tokenizer.setState(character_reference_in_data_state);else if(\"<\"===data)tokenizer.setState(tag_open_state);else if(\"\\0\"===data)tokenizer._emitToken({type:\"Characters\",data:data}),buffer.commit();else{var chars=buffer.matchUntil(\"&|<|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars}),buffer.commit()}return!0}function character_reference_in_data_state(buffer){var character=EntityParser.consumeEntity(buffer,tokenizer);return tokenizer.setState(data_state),tokenizer._emitToken({type:\"Characters\",data:character||\"&\"}),!0}function rcdata_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"&\"===data)tokenizer.setState(character_reference_in_rcdata_state);else if(\"<\"===data)tokenizer.setState(rcdata_less_than_sign_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"&|<|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars}),buffer.commit()}return!0}function character_reference_in_rcdata_state(buffer){var character=EntityParser.consumeEntity(buffer,tokenizer);return tokenizer.setState(rcdata_state),tokenizer._emitToken({type:\"Characters\",data:character||\"&\"}),!0}function rawtext_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"<\"===data)tokenizer.setState(rawtext_less_than_sign_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"<|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars})}return!0}function plaintext_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars})}return!0}function script_data_state(buffer){var data=buffer.char();if(data===InputStream.EOF)return tokenizer._emitToken({type:\"EOF\",data:null}),!1;if(\"<\"===data)tokenizer.setState(script_data_less_than_sign_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"<|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars})}return!0}function rcdata_less_than_sign_state(buffer){var data=buffer.char();return\"/\"===data?(this._temporaryBuffer=\"\",tokenizer.setState(rcdata_end_tag_open_state)):(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(rcdata_state)),!0}function rcdata_end_tag_open_state(buffer){var data=buffer.char();return isAlpha(data)?(this._temporaryBuffer+=data,tokenizer.setState(rcdata_end_tag_name_state)):(tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(rcdata_state)),!0}function rcdata_end_tag_name_state(buffer){var appropriate=tokenizer._currentToken&&tokenizer._currentToken.name===this._temporaryBuffer.toLowerCase(),data=buffer.char();return isWhitespace(data)&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer.setState(before_attribute_name_state)):\"/\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer.setState(self_closing_tag_state)):\">\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):isAlpha(data)?(this._temporaryBuffer+=data,buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:\"</\"+this._temporaryBuffer}),buffer.unget(data),tokenizer.setState(rcdata_state)),!0}function rawtext_less_than_sign_state(buffer){var data=buffer.char();return\"/\"===data?(this._temporaryBuffer=\"\",tokenizer.setState(rawtext_end_tag_open_state)):(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(rawtext_state)),!0}function rawtext_end_tag_open_state(buffer){var data=buffer.char();return isAlpha(data)?(this._temporaryBuffer+=data,tokenizer.setState(rawtext_end_tag_name_state)):(tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(rawtext_state)),!0}function rawtext_end_tag_name_state(buffer){var appropriate=tokenizer._currentToken&&tokenizer._currentToken.name===this._temporaryBuffer.toLowerCase(),data=buffer.char();return isWhitespace(data)&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer.setState(before_attribute_name_state)):\"/\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer.setState(self_closing_tag_state)):\">\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:this._temporaryBuffer,data:[],selfClosing:!1},tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):isAlpha(data)?(this._temporaryBuffer+=data,buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:\"</\"+this._temporaryBuffer}),buffer.unget(data),tokenizer.setState(rawtext_state)),!0}function script_data_less_than_sign_state(buffer){var data=buffer.char();return\"/\"===data?(this._temporaryBuffer=\"\",tokenizer.setState(script_data_end_tag_open_state)):\"!\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"<!\"}),tokenizer.setState(script_data_escape_start_state)):(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_end_tag_open_state(buffer){var data=buffer.char();return isAlpha(data)?(this._temporaryBuffer+=data,tokenizer.setState(script_data_end_tag_name_state)):(tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_end_tag_name_state(buffer){var appropriate=tokenizer._currentToken&&tokenizer._currentToken.name===this._temporaryBuffer.toLowerCase(),data=buffer.char();return isWhitespace(data)&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(before_attribute_name_state)):\"/\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(self_closing_tag_state)):\">\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer._emitCurrentToken()):isAlpha(data)?(this._temporaryBuffer+=data,buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:\"</\"+this._temporaryBuffer}),buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_escape_start_state(buffer){var data=buffer.char();return\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_escape_start_dash_state)):(buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_escape_start_dash_state(buffer){var data=buffer.char();return\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_escaped_dash_dash_state)):(buffer.unget(data),tokenizer.setState(script_data_state)),!0}function script_data_escaped_state(buffer){var data=buffer.char();if(data===InputStream.EOF)buffer.unget(data),tokenizer.setState(data_state);else if(\"-\"===data)tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_escaped_dash_state);else if(\"<\"===data)tokenizer.setState(script_data_escaped_less_then_sign_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit();else{var chars=buffer.matchUntil(\"<|-|\\0\");tokenizer._emitToken({type:\"Characters\",data:data+chars})}return!0}function script_data_escaped_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_escaped_dash_dash_state)):\"<\"===data?tokenizer.setState(script_data_escaped_less_then_sign_state):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),tokenizer.setState(script_data_escaped_state)):(tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(script_data_escaped_state)),!0}function script_data_escaped_dash_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-script\"),buffer.unget(data),tokenizer.setState(data_state)):\"<\"===data?tokenizer.setState(script_data_escaped_less_then_sign_state):\">\"===data?(tokenizer._emitToken({type:\"Characters\",data:\">\"}),tokenizer.setState(script_data_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),tokenizer.setState(script_data_escaped_state)):(tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(script_data_escaped_state)),!0}function script_data_escaped_less_then_sign_state(buffer){var data=buffer.char();return\"/\"===data?(this._temporaryBuffer=\"\",tokenizer.setState(script_data_escaped_end_tag_open_state)):isAlpha(data)?(tokenizer._emitToken({type:\"Characters\",data:\"<\"+data}),this._temporaryBuffer=data,tokenizer.setState(script_data_double_escape_start_state)):(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(script_data_escaped_state)),!0}function script_data_escaped_end_tag_open_state(buffer){var data=buffer.char();return isAlpha(data)?(this._temporaryBuffer=data,tokenizer.setState(script_data_escaped_end_tag_name_state)):(tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(script_data_escaped_state)),!0}function script_data_escaped_end_tag_name_state(buffer){var appropriate=tokenizer._currentToken&&tokenizer._currentToken.name===this._temporaryBuffer.toLowerCase(),data=buffer.char();return isWhitespace(data)&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(before_attribute_name_state)):\"/\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(self_closing_tag_state)):\">\"===data&&appropriate?(tokenizer._currentToken={type:\"EndTag\",name:\"script\",data:[],selfClosing:!1},tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isAlpha(data)?(this._temporaryBuffer+=data,buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:\"</\"+this._temporaryBuffer}),buffer.unget(data),tokenizer.setState(script_data_escaped_state)),!0}function script_data_double_escape_start_state(buffer){var data=buffer.char();return isWhitespace(data)||\"/\"===data||\">\"===data?(tokenizer._emitToken({type:\"Characters\",data:data}),\"script\"===this._temporaryBuffer.toLowerCase()?tokenizer.setState(script_data_double_escaped_state):tokenizer.setState(script_data_escaped_state)):isAlpha(data)?(tokenizer._emitToken({type:\"Characters\",data:data}),this._temporaryBuffer+=data,buffer.commit()):(buffer.unget(data),tokenizer.setState(script_data_escaped_state)),!0}function script_data_double_escaped_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-script\"),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_double_escaped_dash_state)):\"<\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),tokenizer.setState(script_data_double_escaped_less_than_sign_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),buffer.commit()):(tokenizer._emitToken({type:\"Characters\",data:data}),buffer.commit()),!0}function script_data_double_escaped_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-script\"),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),tokenizer.setState(script_data_double_escaped_dash_dash_state)):\"<\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),tokenizer.setState(script_data_double_escaped_less_than_sign_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),tokenizer.setState(script_data_double_escaped_state)):(tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(script_data_double_escaped_state)),!0}function script_data_double_escaped_dash_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-script\"),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"-\"}),buffer.commit()):\"<\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"<\"}),tokenizer.setState(script_data_double_escaped_less_than_sign_state)):\">\"===data?(tokenizer._emitToken({type:\"Characters\",data:\">\"}),tokenizer.setState(script_data_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._emitToken({type:\"Characters\",data:\"�\"}),tokenizer.setState(script_data_double_escaped_state)):(tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(script_data_double_escaped_state)),!0}function script_data_double_escaped_less_than_sign_state(buffer){var data=buffer.char();return\"/\"===data?(tokenizer._emitToken({type:\"Characters\",data:\"/\"}),this._temporaryBuffer=\"\",tokenizer.setState(script_data_double_escape_end_state)):(buffer.unget(data),tokenizer.setState(script_data_double_escaped_state)),!0}function script_data_double_escape_end_state(buffer){var data=buffer.char();return isWhitespace(data)||\"/\"===data||\">\"===data?(tokenizer._emitToken({type:\"Characters\",data:data}),\"script\"===this._temporaryBuffer.toLowerCase()?tokenizer.setState(script_data_escaped_state):tokenizer.setState(script_data_double_escaped_state)):isAlpha(data)?(tokenizer._emitToken({type:\"Characters\",data:data}),this._temporaryBuffer+=data,buffer.commit()):(buffer.unget(data),tokenizer.setState(script_data_double_escaped_state)),!0}function tag_open_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"bare-less-than-sign-at-eof\"),tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(data_state)):isAlpha(data)?(tokenizer._currentToken={type:\"StartTag\",name:data.toLowerCase(),data:[]},tokenizer.setState(tag_name_state)):\"!\"===data?tokenizer.setState(markup_declaration_open_state):\"/\"===data?tokenizer.setState(close_tag_open_state):\">\"===data?(tokenizer._parseError(\"expected-tag-name-but-got-right-bracket\"),tokenizer._emitToken({type:\"Characters\",data:\"<>\"}),tokenizer.setState(data_state)):\"?\"===data?(tokenizer._parseError(\"expected-tag-name-but-got-question-mark\"),buffer.unget(data),tokenizer.setState(bogus_comment_state)):(tokenizer._parseError(\"expected-tag-name\"),tokenizer._emitToken({type:\"Characters\",data:\"<\"}),buffer.unget(data),tokenizer.setState(data_state)),!0}function close_tag_open_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"expected-closing-tag-but-got-eof\"),tokenizer._emitToken({type:\"Characters\",data:\"</\"}),buffer.unget(data),tokenizer.setState(data_state)):isAlpha(data)?(tokenizer._currentToken={type:\"EndTag\",name:data.toLowerCase(),data:[]},tokenizer.setState(tag_name_state)):\">\"===data?(tokenizer._parseError(\"expected-closing-tag-but-got-right-bracket\"),tokenizer.setState(data_state)):(tokenizer._parseError(\"expected-closing-tag-but-got-char\",{data:data}),buffer.unget(data),tokenizer.setState(bogus_comment_state)),!0}function tag_name_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-tag-name\"),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)?tokenizer.setState(before_attribute_name_state):isAlpha(data)?tokenizer._currentToken.name+=data.toLowerCase():\">\"===data?tokenizer._emitCurrentToken():\"/\"===data?tokenizer.setState(self_closing_tag_state):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.name+=\"�\"):tokenizer._currentToken.name+=data,buffer.commit(),!0}function before_attribute_name_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"expected-attribute-name-but-got-eof\"),buffer.unget(data),tokenizer.setState(data_state);else{if(isWhitespace(data))return!0;isAlpha(data)?(tokenizer._currentToken.data.push({nodeName:data.toLowerCase(),nodeValue:\"\"}),tokenizer.setState(attribute_name_state)):\">\"===data?tokenizer._emitCurrentToken():\"/\"===data?tokenizer.setState(self_closing_tag_state):\"'\"===data||'\"'===data||\"=\"===data||\"<\"===data?(tokenizer._parseError(\"invalid-character-in-attribute-name\"),tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data.push({nodeName:\"�\",nodeValue:\"\"})):(tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state))}return!0}function attribute_name_state(buffer){var data=buffer.char(),leavingThisState=!0,shouldEmit=!1;if(data===InputStream.EOF?(tokenizer._parseError(\"eof-in-attribute-name\"),buffer.unget(data),tokenizer.setState(data_state),shouldEmit=!0):\"=\"===data?tokenizer.setState(before_attribute_value_state):isAlpha(data)?(tokenizer._currentAttribute().nodeName+=data.toLowerCase(),leavingThisState=!1):\">\"===data?shouldEmit=!0:isWhitespace(data)?tokenizer.setState(after_attribute_name_state):\"/\"===data?tokenizer.setState(self_closing_tag_state):\"'\"===data||'\"'===data?(tokenizer._parseError(\"invalid-character-in-attribute-name\"),tokenizer._currentAttribute().nodeName+=data,leavingThisState=!1):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeName+=\"�\"):(tokenizer._currentAttribute().nodeName+=data,leavingThisState=!1),leavingThisState){for(var attributes=tokenizer._currentToken.data,currentAttribute=attributes[attributes.length-1],i=attributes.length-2;i>=0;i--)if(currentAttribute.nodeName===attributes[i].nodeName){tokenizer._parseError(\"duplicate-attribute\",{name:currentAttribute.nodeName}),currentAttribute.nodeName=null;break}shouldEmit&&tokenizer._emitCurrentToken()}else buffer.commit();return!0}function after_attribute_name_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"expected-end-of-tag-but-got-eof\"),buffer.unget(data),tokenizer.setState(data_state);else{if(isWhitespace(data))return!0;\"=\"===data?tokenizer.setState(before_attribute_value_state):\">\"===data?tokenizer._emitCurrentToken():isAlpha(data)?(tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state)):\"/\"===data?tokenizer.setState(self_closing_tag_state):\"'\"===data||'\"'===data||\"<\"===data?(tokenizer._parseError(\"invalid-character-after-attribute-name\"),tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data.push({nodeName:\"�\",nodeValue:\"\"})):(tokenizer._currentToken.data.push({nodeName:data,nodeValue:\"\"}),tokenizer.setState(attribute_name_state))}return!0}function before_attribute_value_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"expected-attribute-value-but-got-eof\"),buffer.unget(data),tokenizer.setState(data_state);else{if(isWhitespace(data))return!0;'\"'===data?tokenizer.setState(attribute_value_double_quoted_state):\"&\"===data?(tokenizer.setState(attribute_value_unquoted_state),buffer.unget(data)):\"'\"===data?tokenizer.setState(attribute_value_single_quoted_state):\">\"===data?(tokenizer._parseError(\"expected-attribute-value-but-got-right-bracket\"),tokenizer._emitCurrentToken()):\"=\"===data||\"<\"===data||\"`\"===data?(tokenizer._parseError(\"unexpected-character-in-unquoted-attribute-value\"),tokenizer._currentAttribute().nodeValue+=data,tokenizer.setState(attribute_value_unquoted_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeValue+=\"�\"):(tokenizer._currentAttribute().nodeValue+=data,tokenizer.setState(attribute_value_unquoted_state))}return!0\n}function attribute_value_double_quoted_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"eof-in-attribute-value-double-quote\"),buffer.unget(data),tokenizer.setState(data_state);else if('\"'===data)tokenizer.setState(after_attribute_value_state);else if(\"&\"===data)this._additionalAllowedCharacter='\"',tokenizer.setState(character_reference_in_attribute_value_state);else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeValue+=\"�\";else{var s=buffer.matchUntil('[\\0\"&]');data+=s,tokenizer._currentAttribute().nodeValue+=data}return!0}function attribute_value_single_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-attribute-value-single-quote\"),buffer.unget(data),tokenizer.setState(data_state)):\"'\"===data?tokenizer.setState(after_attribute_value_state):\"&\"===data?(this._additionalAllowedCharacter=\"'\",tokenizer.setState(character_reference_in_attribute_value_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeValue+=\"�\"):tokenizer._currentAttribute().nodeValue+=data+buffer.matchUntil(\"\\0|['&]\"),!0}function attribute_value_unquoted_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._parseError(\"eof-after-attribute-value\"),buffer.unget(data),tokenizer.setState(data_state);else if(isWhitespace(data))tokenizer.setState(before_attribute_name_state);else if(\"&\"===data)this._additionalAllowedCharacter=\">\",tokenizer.setState(character_reference_in_attribute_value_state);else if(\">\"===data)tokenizer._emitCurrentToken();else if('\"'===data||\"'\"===data||\"=\"===data||\"`\"===data||\"<\"===data)tokenizer._parseError(\"unexpected-character-in-unquoted-attribute-value\"),tokenizer._currentAttribute().nodeValue+=data,buffer.commit();else if(\"\\0\"===data)tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentAttribute().nodeValue+=\"�\";else{var o=buffer.matchUntil(\"\\0|[\t\\n\u000b\\f \\r&<>\\\"'=`]\");o===InputStream.EOF&&(tokenizer._parseError(\"eof-in-attribute-value-no-quotes\"),tokenizer._emitCurrentToken()),buffer.commit(),tokenizer._currentAttribute().nodeValue+=data+o}return!0}function character_reference_in_attribute_value_state(buffer){var character=EntityParser.consumeEntity(buffer,tokenizer,this._additionalAllowedCharacter);return this._currentAttribute().nodeValue+=character||\"&\",'\"'===this._additionalAllowedCharacter?tokenizer.setState(attribute_value_double_quoted_state):\"'\"===this._additionalAllowedCharacter?tokenizer.setState(attribute_value_single_quoted_state):\">\"===this._additionalAllowedCharacter&&tokenizer.setState(attribute_value_unquoted_state),!0}function after_attribute_value_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-after-attribute-value\"),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)?tokenizer.setState(before_attribute_name_state):\">\"===data?(tokenizer.setState(data_state),tokenizer._emitCurrentToken()):\"/\"===data?tokenizer.setState(self_closing_tag_state):(tokenizer._parseError(\"unexpected-character-after-attribute-value\"),buffer.unget(data),tokenizer.setState(before_attribute_name_state)),!0}function self_closing_tag_state(buffer){var c=buffer.char();return c===InputStream.EOF?(tokenizer._parseError(\"unexpected-eof-after-solidus-in-tag\"),buffer.unget(c),tokenizer.setState(data_state)):\">\"===c?(tokenizer._currentToken.selfClosing=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(tokenizer._parseError(\"unexpected-character-after-solidus-in-tag\"),buffer.unget(c),tokenizer.setState(before_attribute_name_state)),!0}function bogus_comment_state(buffer){var data=buffer.matchUntil(\">\");return data=data.replace(/\\u0000/g,\"�\"),buffer.char(),tokenizer._emitToken({type:\"Comment\",data:data}),tokenizer.setState(data_state),!0}function markup_declaration_open_state(buffer){var chars=buffer.shift(2);if(\"--\"===chars)tokenizer._currentToken={type:\"Comment\",data:\"\"},tokenizer.setState(comment_start_state);else{var newchars=buffer.shift(5);if(newchars===InputStream.EOF||chars===InputStream.EOF)return tokenizer._parseError(\"expected-dashes-or-doctype\"),tokenizer.setState(bogus_comment_state),buffer.unget(chars),!0;chars+=newchars,\"DOCTYPE\"===chars.toUpperCase()?(tokenizer._currentToken={type:\"Doctype\",name:\"\",publicId:null,systemId:null,forceQuirks:!1},tokenizer.setState(doctype_state)):tokenizer._tokenHandler.isCdataSectionAllowed()&&\"[CDATA[\"===chars?tokenizer.setState(cdata_section_state):(tokenizer._parseError(\"expected-dashes-or-doctype\"),buffer.unget(chars),tokenizer.setState(bogus_comment_state))}return!0}function cdata_section_state(buffer){var data=buffer.matchUntil(\"]]>\");return buffer.shift(3),data&&tokenizer._emitToken({type:\"Characters\",data:data}),tokenizer.setState(data_state),!0}function comment_start_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?tokenizer.setState(comment_start_dash_state):\">\"===data?(tokenizer._parseError(\"incorrect-comment\"),tokenizer._emitToken(tokenizer._currentToken),tokenizer.setState(data_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"�\"):(tokenizer._currentToken.data+=data,tokenizer.setState(comment_state)),!0}function comment_start_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?tokenizer.setState(comment_end_state):\">\"===data?(tokenizer._parseError(\"incorrect-comment\"),tokenizer._emitToken(tokenizer._currentToken),tokenizer.setState(data_state)):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"�\"):(tokenizer._currentToken.data+=\"-\"+data,tokenizer.setState(comment_state)),!0}function comment_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?tokenizer.setState(comment_end_dash_state):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"�\"):(tokenizer._currentToken.data+=data,buffer.commit()),!0}function comment_end_dash_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment-end-dash\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\"-\"===data?tokenizer.setState(comment_end_state):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"-�\",tokenizer.setState(comment_state)):(tokenizer._currentToken.data+=\"-\"+data+buffer.matchUntil(\"\\0|-\"),buffer.char()),!0}function comment_end_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment-double-dash\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\">\"===data?(tokenizer._emitToken(tokenizer._currentToken),tokenizer.setState(data_state)):\"!\"===data?(tokenizer._parseError(\"unexpected-bang-after-double-dash-in-comment\"),tokenizer.setState(comment_end_bang_state)):\"-\"===data?(tokenizer._parseError(\"unexpected-dash-after-double-dash-in-comment\"),tokenizer._currentToken.data+=data):\"\\0\"===data?(tokenizer._parseError(\"invalid-codepoint\"),tokenizer._currentToken.data+=\"--�\",tokenizer.setState(comment_state)):(tokenizer._parseError(\"unexpected-char-in-comment\"),tokenizer._currentToken.data+=\"--\"+data,tokenizer.setState(comment_state)),!0}function comment_end_bang_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-comment-end-bang-state\"),tokenizer._emitToken(tokenizer._currentToken),buffer.unget(data),tokenizer.setState(data_state)):\">\"===data?(tokenizer._emitToken(tokenizer._currentToken),tokenizer.setState(data_state)):\"-\"===data?(tokenizer._currentToken.data+=\"--!\",tokenizer.setState(comment_end_dash_state)):(tokenizer._currentToken.data+=\"--!\"+data,tokenizer.setState(comment_state)),!0}function doctype_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"expected-doctype-name-but-got-eof\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)?tokenizer.setState(before_doctype_name_state):(tokenizer._parseError(\"need-space-after-doctype\"),buffer.unget(data),tokenizer.setState(before_doctype_name_state)),!0}function before_doctype_name_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"expected-doctype-name-but-got-eof\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)||(\">\"===data?(tokenizer._parseError(\"expected-doctype-name-but-got-right-bracket\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(isAlpha(data)&&(data=data.toLowerCase()),tokenizer._currentToken.name=data,tokenizer.setState(doctype_name_state))),!0}function doctype_name_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer._parseError(\"eof-in-doctype-name\"),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)?tokenizer.setState(after_doctype_name_state):\">\"===data?(tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(isAlpha(data)&&(data=data.toLowerCase()),tokenizer._currentToken.name+=data,buffer.commit()),!0}function after_doctype_name_state(buffer){var data=buffer.char();if(data===InputStream.EOF)tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer._parseError(\"eof-in-doctype\"),tokenizer.setState(data_state),tokenizer._emitCurrentToken();else if(isWhitespace(data));else if(\">\"===data)tokenizer.setState(data_state),tokenizer._emitCurrentToken();else{if([\"p\",\"P\"].indexOf(data)>-1){var expected=[[\"u\",\"U\"],[\"b\",\"B\"],[\"l\",\"L\"],[\"i\",\"I\"],[\"c\",\"C\"]],matched=expected.every(function(expected){return data=buffer.char(),expected.indexOf(data)>-1});if(matched)return tokenizer.setState(after_doctype_public_keyword_state),!0}else if([\"s\",\"S\"].indexOf(data)>-1){var expected=[[\"y\",\"Y\"],[\"s\",\"S\"],[\"t\",\"T\"],[\"e\",\"E\"],[\"m\",\"M\"]],matched=expected.every(function(expected){return data=buffer.char(),expected.indexOf(data)>-1});if(matched)return tokenizer.setState(after_doctype_system_keyword_state),!0}buffer.unget(data),tokenizer._currentToken.forceQuirks=!0,data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(tokenizer._parseError(\"expected-space-or-right-bracket-in-doctype\",{data:data}),tokenizer.setState(bogus_doctype_state))}return!0}function after_doctype_public_keyword_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)?tokenizer.setState(before_doctype_public_identifier_state):\"'\"===data||'\"'===data?(tokenizer._parseError(\"unexpected-char-in-doctype\"),buffer.unget(data),tokenizer.setState(before_doctype_public_identifier_state)):(buffer.unget(data),tokenizer.setState(before_doctype_public_identifier_state)),!0}function before_doctype_public_identifier_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):isWhitespace(data)||('\"'===data?(tokenizer._currentToken.publicId=\"\",tokenizer.setState(doctype_public_identifier_double_quoted_state)):\"'\"===data?(tokenizer._currentToken.publicId=\"\",tokenizer.setState(doctype_public_identifier_single_quoted_state)):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(bogus_doctype_state))),!0}function doctype_public_identifier_double_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):'\"'===data?tokenizer.setState(after_doctype_public_identifier_state):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):tokenizer._currentToken.publicId+=data,!0}function doctype_public_identifier_single_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,buffer.unget(data),tokenizer.setState(data_state),tokenizer._emitCurrentToken()):\"'\"===data?tokenizer.setState(after_doctype_public_identifier_state):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(data_state),tokenizer._emitCurrentToken()):tokenizer._currentToken.publicId+=data,!0}function after_doctype_public_identifier_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)?tokenizer.setState(between_doctype_public_and_system_identifiers_state):\">\"===data?(tokenizer.setState(data_state),tokenizer._emitCurrentToken()):'\"'===data?(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_double_quoted_state)):\"'\"===data?(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_single_quoted_state)):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(bogus_doctype_state)),!0}function between_doctype_public_and_system_identifiers_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)||(\">\"===data?(tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):'\"'===data?(tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_double_quoted_state)):\"'\"===data?(tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_single_quoted_state)):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(bogus_doctype_state))),!0}function after_doctype_system_keyword_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)?tokenizer.setState(before_doctype_system_identifier_state):\"'\"===data||'\"'===data?(tokenizer._parseError(\"unexpected-char-in-doctype\"),buffer.unget(data),tokenizer.setState(before_doctype_system_identifier_state)):(buffer.unget(data),tokenizer.setState(before_doctype_system_identifier_state)),!0}function before_doctype_system_identifier_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)||('\"'===data?(tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_double_quoted_state)):\"'\"===data?(tokenizer._currentToken.systemId=\"\",tokenizer.setState(doctype_system_identifier_single_quoted_state)):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer.setState(bogus_doctype_state))),!0}function doctype_system_identifier_double_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):'\"'===data?tokenizer.setState(after_doctype_system_identifier_state):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):tokenizer._currentToken.systemId+=data,!0}function doctype_system_identifier_single_quoted_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):\"'\"===data?tokenizer.setState(after_doctype_system_identifier_state):\">\"===data?(tokenizer._parseError(\"unexpected-end-of-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):tokenizer._currentToken.systemId+=data,!0}function after_doctype_system_identifier_state(buffer){var data=buffer.char();return data===InputStream.EOF?(tokenizer._parseError(\"eof-in-doctype\"),tokenizer._currentToken.forceQuirks=!0,tokenizer._emitCurrentToken(),buffer.unget(data),tokenizer.setState(data_state)):isWhitespace(data)||(\">\"===data?(tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):(tokenizer._parseError(\"unexpected-char-in-doctype\"),tokenizer.setState(bogus_doctype_state))),!0}function bogus_doctype_state(buffer){var data=buffer.char();return data===InputStream.EOF?(buffer.unget(data),tokenizer._emitCurrentToken(),tokenizer.setState(data_state)):\">\"===data&&(tokenizer._emitCurrentToken(),tokenizer.setState(data_state)),!0}Tokenizer.DATA=data_state,Tokenizer.RCDATA=rcdata_state,Tokenizer.RAWTEXT=rawtext_state,Tokenizer.SCRIPT_DATA=script_data_state,Tokenizer.PLAINTEXT=plaintext_state,this._state=Tokenizer.DATA,this._inputStream.append(source),this._tokenHandler.startTokenization(this),this._inputStream.eof=!0;for(var tokenizer=this;this._state.call(this,this._inputStream););},Object.defineProperty(Tokenizer.prototype,\"lineNumber\",{get:function(){return this._inputStream.location().line}}),Object.defineProperty(Tokenizer.prototype,\"columnNumber\",{get:function(){return this._inputStream.location().column}}),exports.Tokenizer=Tokenizer},{\"./EntityParser\":2,\"./InputStream\":3}],6:[function(_dereq_,module,exports){function isWhitespace(ch){return\" \"===ch||\"\\n\"===ch||\"\t\"===ch||\"\\r\"===ch||\"\\f\"===ch}function isWhitespaceOrReplacementCharacter(ch){return isWhitespace(ch)||\"�\"===ch}function isAllWhitespace(characters){for(var i=0;characters.length>i;i++){var ch=characters[i];if(!isWhitespace(ch))return!1}return!0}function isAllWhitespaceOrReplacementCharacters(characters){for(var i=0;characters.length>i;i++){var ch=characters[i];if(!isWhitespaceOrReplacementCharacter(ch))return!1}return!0}function getAttribute(node,name){for(var i=0;node.attributes.length>i;i++){var attribute=node.attributes[i];if(attribute.nodeName===name)return attribute}return null}function CharacterBuffer(characters){this.characters=characters,this.current=0,this.end=this.characters.length}function TreeBuilder(){this.tokenizer=null,this.errorHandler=null,this.scriptingEnabled=!1,this.document=null,this.head=null,this.form=null,this.openElements=new ElementStack,this.activeFormattingElements=[],this.insertionMode=null,this.insertionModeName=\"\",this.originalInsertionMode=\"\",this.inQuirksMode=!1,this.compatMode=\"no quirks\",this.framesetOk=!0,this.redirectAttachToFosterParent=!1,this.selfClosingFlagAcknowledged=!1,this.context=\"\",this.pendingTableCharacters=[],this.shouldSkipLeadingNewline=!1;var tree=this,modes=this.insertionModes={};modes.base={end_tag_handlers:{\"-default\":\"endTagOther\"},start_tag_handlers:{\"-default\":\"startTagOther\"},processEOF:function(){tree.generateImpliedEndTags(),tree.openElements.length>2?tree.parseError(\"expected-closing-tag-but-got-eof\"):2==tree.openElements.length&&\"body\"!=tree.openElements.item(1).localName?tree.parseError(\"expected-closing-tag-but-got-eof\"):tree.context&&tree.openElements.length>1},processComment:function(data){tree.insertComment(data,tree.currentStackItem().node)},processDoctype:function(){tree.parseError(\"unexpected-doctype\")},processStartTag:function(name,attributes,selfClosing){if(this[this.start_tag_handlers[name]])this[this.start_tag_handlers[name]](name,attributes,selfClosing);else{if(!this[this.start_tag_handlers[\"-default\"]])throw Error(\"No handler found for \"+name);this[this.start_tag_handlers[\"-default\"]](name,attributes,selfClosing)}},processEndTag:function(name){if(this[this.end_tag_handlers[name]])this[this.end_tag_handlers[name]](name);else{if(!this[this.end_tag_handlers[\"-default\"]])throw Error(\"No handler found for \"+name);this[this.end_tag_handlers[\"-default\"]](name)}},startTagHtml:function(name,attributes){modes.inBody.startTagHtml(name,attributes)}},modes.initial=Object.create(modes.base),modes.initial.processEOF=function(){tree.parseError(\"expected-doctype-but-got-eof\"),this.anythingElse(),tree.insertionMode.processEOF()},modes.initial.processComment=function(data){tree.insertComment(data,tree.document)},modes.initial.processDoctype=function(name,publicId,systemId,forceQuirks){function publicIdStartsWith(string){return 0===publicId.toLowerCase().indexOf(string)}tree.insertDoctype(name||\"\",publicId||\"\",systemId||\"\"),forceQuirks||\"html\"!=name||null!=publicId&&([\"+//silmaril//dtd html pro v0r11 19970101//\",\"-//advasoft ltd//dtd html 3.0 aswedit + extensions//\",\"-//as//dtd html 3.0 aswedit + extensions//\",\"-//ietf//dtd html 2.0 level 1//\",\"-//ietf//dtd html 2.0 level 2//\",\"-//ietf//dtd html 2.0 strict level 1//\",\"-//ietf//dtd html 2.0 strict level 2//\",\"-//ietf//dtd html 2.0 strict//\",\"-//ietf//dtd html 2.0//\",\"-//ietf//dtd html 2.1e//\",\"-//ietf//dtd html 3.0//\",\"-//ietf//dtd html 3.0//\",\"-//ietf//dtd html 3.2 final//\",\"-//ietf//dtd html 3.2//\",\"-//ietf//dtd html 3//\",\"-//ietf//dtd html level 0//\",\"-//ietf//dtd html level 0//\",\"-//ietf//dtd html level 1//\",\"-//ietf//dtd html level 1//\",\"-//ietf//dtd html level 2//\",\"-//ietf//dtd html level 2//\",\"-//ietf//dtd html level 3//\",\"-//ietf//dtd html level 3//\",\"-//ietf//dtd html strict level 0//\",\"-//ietf//dtd html strict level 0//\",\"-//ietf//dtd html strict level 1//\",\"-//ietf//dtd html strict level 1//\",\"-//ietf//dtd html strict level 2//\",\"-//ietf//dtd html strict level 2//\",\"-//ietf//dtd html strict level 3//\",\"-//ietf//dtd html strict level 3//\",\"-//ietf//dtd html strict//\",\"-//ietf//dtd html strict//\",\"-//ietf//dtd html strict//\",\"-//ietf//dtd html//\",\"-//ietf//dtd html//\",\"-//ietf//dtd html//\",\"-//metrius//dtd metrius presentational//\",\"-//microsoft//dtd internet explorer 2.0 html strict//\",\"-//microsoft//dtd internet explorer 2.0 html//\",\"-//microsoft//dtd internet explorer 2.0 tables//\",\"-//microsoft//dtd internet explorer 3.0 html strict//\",\"-//microsoft//dtd internet explorer 3.0 html//\",\"-//microsoft//dtd internet explorer 3.0 tables//\",\"-//netscape comm. corp.//dtd html//\",\"-//netscape comm. corp.//dtd strict html//\",\"-//o'reilly and associates//dtd html 2.0//\",\"-//o'reilly and associates//dtd html extended 1.0//\",\"-//spyglass//dtd html 2.0 extended//\",\"-//sq//dtd html 2.0 hotmetal + extensions//\",\"-//sun microsystems corp.//dtd hotjava html//\",\"-//sun microsystems corp.//dtd hotjava strict html//\",\"-//w3c//dtd html 3 1995-03-24//\",\"-//w3c//dtd html 3.2 draft//\",\"-//w3c//dtd html 3.2 final//\",\"-//w3c//dtd html 3.2//\",\"-//w3c//dtd html 3.2s draft//\",\"-//w3c//dtd html 4.0 frameset//\",\"-//w3c//dtd html 4.0 transitional//\",\"-//w3c//dtd html experimental 19960712//\",\"-//w3c//dtd html experimental 970421//\",\"-//w3c//dtd w3 html//\",\"-//w3o//dtd w3 html 3.0//\",\"-//webtechs//dtd mozilla html 2.0//\",\"-//webtechs//dtd mozilla html//\",\"html\"].some(publicIdStartsWith)||[\"-//w3o//dtd w3 html strict 3.0//en//\",\"-/w3c/dtd html 4.0 transitional/en\",\"html\"].indexOf(publicId.toLowerCase())>-1||null==systemId&&[\"-//w3c//dtd html 4.01 transitional//\",\"-//w3c//dtd html 4.01 frameset//\"].some(publicIdStartsWith))||null!=systemId&&\"http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd\"==systemId.toLowerCase()?(tree.compatMode=\"quirks\",tree.parseError(\"quirky-doctype\")):null!=publicId&&([\"-//w3c//dtd xhtml 1.0 transitional//\",\"-//w3c//dtd xhtml 1.0 frameset//\"].some(publicIdStartsWith)||null!=systemId&&[\"-//w3c//dtd html 4.01 transitional//\",\"-//w3c//dtd html 4.01 frameset//\"].indexOf(publicId.toLowerCase())>-1)?(tree.compatMode=\"limited quirks\",tree.parseError(\"almost-standards-doctype\")):\"-//W3C//DTD HTML 4.0//EN\"==publicId&&(null==systemId||\"http://www.w3.org/TR/REC-html40/strict.dtd\"==systemId)||\"-//W3C//DTD HTML 4.01//EN\"==publicId&&(null==systemId||\"http://www.w3.org/TR/html4/strict.dtd\"==systemId)||\"-//W3C//DTD XHTML 1.0 Strict//EN\"==publicId&&\"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd\"==systemId||\"-//W3C//DTD XHTML 1.1//EN\"==publicId&&\"http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd\"==systemId||(null!=systemId&&\"about:legacy-compat\"!=systemId||null!=publicId)&&tree.parseError(\"unknown-doctype\"),tree.setInsertionMode(\"beforeHTML\")},modes.initial.processCharacters=function(buffer){buffer.skipLeadingWhitespace(),buffer.length&&(tree.parseError(\"expected-doctype-but-got-chars\"),this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.initial.processStartTag=function(name,attributes,selfClosing){tree.parseError(\"expected-doctype-but-got-start-tag\",{name:name}),this.anythingElse(),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.initial.processEndTag=function(name){tree.parseError(\"expected-doctype-but-got-end-tag\",{name:name}),this.anythingElse(),tree.insertionMode.processEndTag(name)},modes.initial.anythingElse=function(){tree.compatMode=\"quirks\",tree.setInsertionMode(\"beforeHTML\")},modes.beforeHTML=Object.create(modes.base),modes.beforeHTML.start_tag_handlers={html:\"startTagHtml\",\"-default\":\"startTagOther\"},modes.beforeHTML.processEOF=function(){this.anythingElse(),tree.insertionMode.processEOF()},modes.beforeHTML.processComment=function(data){tree.insertComment(data,tree.document)},modes.beforeHTML.processCharacters=function(buffer){buffer.skipLeadingWhitespace(),buffer.length&&(this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.beforeHTML.startTagHtml=function(name,attributes){tree.insertHtmlElement(attributes),tree.setInsertionMode(\"beforeHead\")},modes.beforeHTML.startTagOther=function(name,attributes,selfClosing){this.anythingElse(),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.beforeHTML.processEndTag=function(name){this.anythingElse(),tree.insertionMode.processEndTag(name)},modes.beforeHTML.anythingElse=function(){tree.insertHtmlElement(),tree.setInsertionMode(\"beforeHead\")},modes.afterAfterBody=Object.create(modes.base),modes.afterAfterBody.start_tag_handlers={html:\"startTagHtml\",\"-default\":\"startTagOther\"},modes.afterAfterBody.processComment=function(data){tree.insertComment(data,tree.document)},modes.afterAfterBody.processDoctype=function(data){modes.inBody.processDoctype(data)},modes.afterAfterBody.startTagHtml=function(data,attributes){modes.inBody.startTagHtml(data,attributes)},modes.afterAfterBody.startTagOther=function(name,attributes,selfClosing){tree.parseError(\"unexpected-start-tag\",{name:name}),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.afterAfterBody.endTagOther=function(name){tree.parseError(\"unexpected-end-tag\",{name:name}),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processEndTag(name)},modes.afterAfterBody.processCharacters=function(data){return isAllWhitespace(data.characters)?(modes.inBody.processCharacters(data),void 0):(tree.parseError(\"unexpected-char-after-body\"),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processCharacters(data))},modes.afterBody=Object.create(modes.base),modes.afterBody.end_tag_handlers={html:\"endTagHtml\",\"-default\":\"endTagOther\"},modes.afterBody.processComment=function(data){tree.insertComment(data,tree.openElements.rootNode)},modes.afterBody.processCharacters=function(data){return isAllWhitespace(data.characters)?(modes.inBody.processCharacters(data),void 0):(tree.parseError(\"unexpected-char-after-body\"),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processCharacters(data))},modes.afterBody.processStartTag=function(name,attributes,selfClosing){tree.parseError(\"unexpected-start-tag-after-body\",{name:name}),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.afterBody.endTagHtml=function(){tree.context?tree.parseError(\"end-html-in-innerhtml\"):tree.setInsertionMode(\"afterAfterBody\")},modes.afterBody.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-after-body\",{name:name}),tree.setInsertionMode(\"inBody\"),tree.insertionMode.processEndTag(name)},modes.afterFrameset=Object.create(modes.base),modes.afterFrameset.start_tag_handlers={html:\"startTagHtml\",noframes:\"startTagNoframes\",\"-default\":\"startTagOther\"},modes.afterFrameset.end_tag_handlers={html:\"endTagHtml\",\"-default\":\"endTagOther\"},modes.afterFrameset.processCharacters=function(buffer){for(var characters=buffer.takeRemaining(),whitespace=\"\",i=0;characters.length>i;i++){var ch=characters[i];isWhitespace(ch)&&(whitespace+=ch)}whitespace&&tree.insertText(whitespace),whitespace.length<characters.length&&tree.parseError(\"expected-eof-but-got-char\")},modes.afterFrameset.startTagNoframes=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.afterFrameset.startTagOther=function(name){tree.parseError(\"unexpected-start-tag-after-frameset\",{name:name})},modes.afterFrameset.endTagHtml=function(){tree.setInsertionMode(\"afterAfterFrameset\")},modes.afterFrameset.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-after-frameset\",{name:name})},modes.beforeHead=Object.create(modes.base),modes.beforeHead.start_tag_handlers={html:\"startTagHtml\",head:\"startTagHead\",\"-default\":\"startTagOther\"},modes.beforeHead.end_tag_handlers={html:\"endTagImplyHead\",head:\"endTagImplyHead\",body:\"endTagImplyHead\",br:\"endTagImplyHead\",\"-default\":\"endTagOther\"},modes.beforeHead.processEOF=function(){this.startTagHead(\"head\",[]),tree.insertionMode.processEOF()},modes.beforeHead.processCharacters=function(buffer){buffer.skipLeadingWhitespace(),buffer.length&&(this.startTagHead(\"head\",[]),tree.insertionMode.processCharacters(buffer))},modes.beforeHead.startTagHead=function(name,attributes){tree.insertHeadElement(attributes),tree.setInsertionMode(\"inHead\")},modes.beforeHead.startTagOther=function(name,attributes,selfClosing){this.startTagHead(\"head\",[]),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.beforeHead.endTagImplyHead=function(name){this.startTagHead(\"head\",[]),tree.insertionMode.processEndTag(name)},modes.beforeHead.endTagOther=function(name){tree.parseError(\"end-tag-after-implied-root\",{name:name})},modes.inHead=Object.create(modes.base),modes.inHead.start_tag_handlers={html:\"startTagHtml\",head:\"startTagHead\",title:\"startTagTitle\",script:\"startTagScript\",style:\"startTagNoFramesStyle\",noscript:\"startTagNoScript\",noframes:\"startTagNoFramesStyle\",base:\"startTagBaseBasefontBgsoundLink\",basefont:\"startTagBaseBasefontBgsoundLink\",bgsound:\"startTagBaseBasefontBgsoundLink\",link:\"startTagBaseBasefontBgsoundLink\",meta:\"startTagMeta\",\"-default\":\"startTagOther\"},modes.inHead.end_tag_handlers={head:\"endTagHead\",html:\"endTagHtmlBodyBr\",body:\"endTagHtmlBodyBr\",br:\"endTagHtmlBodyBr\",\"-default\":\"endTagOther\"},modes.inHead.processEOF=function(){var name=tree.currentStackItem().localName;\n-1!=[\"title\",\"style\",\"script\"].indexOf(name)&&(tree.parseError(\"expected-named-closing-tag-but-got-eof\",{name:name}),tree.popElement()),this.anythingElse(),tree.insertionMode.processEOF()},modes.inHead.processCharacters=function(buffer){var leadingWhitespace=buffer.takeLeadingWhitespace();leadingWhitespace&&tree.insertText(leadingWhitespace),buffer.length&&(this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.inHead.startTagHtml=function(name,attributes){modes.inBody.processStartTag(name,attributes)},modes.inHead.startTagHead=function(){tree.parseError(\"two-heads-are-not-better-than-one\")},modes.inHead.startTagTitle=function(name,attributes){tree.processGenericRCDATAStartTag(name,attributes)},modes.inHead.startTagNoScript=function(name,attributes){return tree.scriptingEnabled?tree.processGenericRawTextStartTag(name,attributes):(tree.insertElement(name,attributes),tree.setInsertionMode(\"inHeadNoscript\"),void 0)},modes.inHead.startTagNoFramesStyle=function(name,attributes){tree.processGenericRawTextStartTag(name,attributes)},modes.inHead.startTagScript=function(name,attributes){tree.insertElement(name,attributes),tree.tokenizer.setState(Tokenizer.SCRIPT_DATA),tree.originalInsertionMode=tree.insertionModeName,tree.setInsertionMode(\"text\")},modes.inHead.startTagBaseBasefontBgsoundLink=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inHead.startTagMeta=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inHead.startTagOther=function(name,attributes,selfClosing){this.anythingElse(),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.inHead.endTagHead=function(){\"head\"==tree.openElements.item(tree.openElements.length-1).localName?tree.openElements.pop():tree.parseError(\"unexpected-end-tag\",{name:\"head\"}),tree.setInsertionMode(\"afterHead\")},modes.inHead.endTagHtmlBodyBr=function(name){this.anythingElse(),tree.insertionMode.processEndTag(name)},modes.inHead.endTagOther=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inHead.anythingElse=function(){this.endTagHead(\"head\")},modes.afterHead=Object.create(modes.base),modes.afterHead.start_tag_handlers={html:\"startTagHtml\",head:\"startTagHead\",body:\"startTagBody\",frameset:\"startTagFrameset\",base:\"startTagFromHead\",link:\"startTagFromHead\",meta:\"startTagFromHead\",script:\"startTagFromHead\",style:\"startTagFromHead\",title:\"startTagFromHead\",\"-default\":\"startTagOther\"},modes.afterHead.end_tag_handlers={body:\"endTagBodyHtmlBr\",html:\"endTagBodyHtmlBr\",br:\"endTagBodyHtmlBr\",\"-default\":\"endTagOther\"},modes.afterHead.processEOF=function(){this.anythingElse(),tree.insertionMode.processEOF()},modes.afterHead.processCharacters=function(buffer){var leadingWhitespace=buffer.takeLeadingWhitespace();leadingWhitespace&&tree.insertText(leadingWhitespace),buffer.length&&(this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.afterHead.startTagHtml=function(name,attributes){modes.inBody.processStartTag(name,attributes)},modes.afterHead.startTagBody=function(name,attributes){tree.framesetOk=!1,tree.insertBodyElement(attributes),tree.setInsertionMode(\"inBody\")},modes.afterHead.startTagFrameset=function(name,attributes){tree.insertElement(name,attributes),tree.setInsertionMode(\"inFrameset\")},modes.afterHead.startTagFromHead=function(name,attributes,selfClosing){tree.parseError(\"unexpected-start-tag-out-of-my-head\",{name:name}),tree.openElements.push(tree.head),modes.inHead.processStartTag(name,attributes,selfClosing),tree.openElements.remove(tree.head)},modes.afterHead.startTagHead=function(name){tree.parseError(\"unexpected-start-tag\",{name:name})},modes.afterHead.startTagOther=function(name,attributes,selfClosing){this.anythingElse(),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.afterHead.endTagBodyHtmlBr=function(name){this.anythingElse(),tree.insertionMode.processEndTag(name)},modes.afterHead.endTagOther=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.afterHead.anythingElse=function(){tree.insertBodyElement([]),tree.setInsertionMode(\"inBody\"),tree.framesetOk=!0},modes.inBody=Object.create(modes.base),modes.inBody.start_tag_handlers={html:\"startTagHtml\",head:\"startTagMisplaced\",base:\"startTagProcessInHead\",basefont:\"startTagProcessInHead\",bgsound:\"startTagProcessInHead\",link:\"startTagProcessInHead\",meta:\"startTagProcessInHead\",noframes:\"startTagProcessInHead\",script:\"startTagProcessInHead\",style:\"startTagProcessInHead\",title:\"startTagProcessInHead\",body:\"startTagBody\",form:\"startTagForm\",plaintext:\"startTagPlaintext\",a:\"startTagA\",button:\"startTagButton\",xmp:\"startTagXmp\",table:\"startTagTable\",hr:\"startTagHr\",image:\"startTagImage\",input:\"startTagInput\",textarea:\"startTagTextarea\",select:\"startTagSelect\",isindex:\"startTagIsindex\",applet:\"startTagAppletMarqueeObject\",marquee:\"startTagAppletMarqueeObject\",object:\"startTagAppletMarqueeObject\",li:\"startTagListItem\",dd:\"startTagListItem\",dt:\"startTagListItem\",address:\"startTagCloseP\",article:\"startTagCloseP\",aside:\"startTagCloseP\",blockquote:\"startTagCloseP\",center:\"startTagCloseP\",details:\"startTagCloseP\",dir:\"startTagCloseP\",div:\"startTagCloseP\",dl:\"startTagCloseP\",fieldset:\"startTagCloseP\",figcaption:\"startTagCloseP\",figure:\"startTagCloseP\",footer:\"startTagCloseP\",header:\"startTagCloseP\",hgroup:\"startTagCloseP\",main:\"startTagCloseP\",menu:\"startTagCloseP\",nav:\"startTagCloseP\",ol:\"startTagCloseP\",p:\"startTagCloseP\",section:\"startTagCloseP\",summary:\"startTagCloseP\",ul:\"startTagCloseP\",listing:\"startTagPreListing\",pre:\"startTagPreListing\",b:\"startTagFormatting\",big:\"startTagFormatting\",code:\"startTagFormatting\",em:\"startTagFormatting\",font:\"startTagFormatting\",i:\"startTagFormatting\",s:\"startTagFormatting\",small:\"startTagFormatting\",strike:\"startTagFormatting\",strong:\"startTagFormatting\",tt:\"startTagFormatting\",u:\"startTagFormatting\",nobr:\"startTagNobr\",area:\"startTagVoidFormatting\",br:\"startTagVoidFormatting\",embed:\"startTagVoidFormatting\",img:\"startTagVoidFormatting\",keygen:\"startTagVoidFormatting\",wbr:\"startTagVoidFormatting\",param:\"startTagParamSourceTrack\",source:\"startTagParamSourceTrack\",track:\"startTagParamSourceTrack\",iframe:\"startTagIFrame\",noembed:\"startTagRawText\",noscript:\"startTagRawText\",h1:\"startTagHeading\",h2:\"startTagHeading\",h3:\"startTagHeading\",h4:\"startTagHeading\",h5:\"startTagHeading\",h6:\"startTagHeading\",caption:\"startTagMisplaced\",col:\"startTagMisplaced\",colgroup:\"startTagMisplaced\",frame:\"startTagMisplaced\",frameset:\"startTagFrameset\",tbody:\"startTagMisplaced\",td:\"startTagMisplaced\",tfoot:\"startTagMisplaced\",th:\"startTagMisplaced\",thead:\"startTagMisplaced\",tr:\"startTagMisplaced\",option:\"startTagOptionOptgroup\",optgroup:\"startTagOptionOptgroup\",math:\"startTagMath\",svg:\"startTagSVG\",rt:\"startTagRpRt\",rp:\"startTagRpRt\",\"-default\":\"startTagOther\"},modes.inBody.end_tag_handlers={p:\"endTagP\",body:\"endTagBody\",html:\"endTagHtml\",address:\"endTagBlock\",article:\"endTagBlock\",aside:\"endTagBlock\",blockquote:\"endTagBlock\",button:\"endTagBlock\",center:\"endTagBlock\",details:\"endTagBlock\",dir:\"endTagBlock\",div:\"endTagBlock\",dl:\"endTagBlock\",fieldset:\"endTagBlock\",figcaption:\"endTagBlock\",figure:\"endTagBlock\",footer:\"endTagBlock\",header:\"endTagBlock\",hgroup:\"endTagBlock\",listing:\"endTagBlock\",main:\"endTagBlock\",menu:\"endTagBlock\",nav:\"endTagBlock\",ol:\"endTagBlock\",pre:\"endTagBlock\",section:\"endTagBlock\",summary:\"endTagBlock\",ul:\"endTagBlock\",form:\"endTagForm\",applet:\"endTagAppletMarqueeObject\",marquee:\"endTagAppletMarqueeObject\",object:\"endTagAppletMarqueeObject\",dd:\"endTagListItem\",dt:\"endTagListItem\",li:\"endTagListItem\",h1:\"endTagHeading\",h2:\"endTagHeading\",h3:\"endTagHeading\",h4:\"endTagHeading\",h5:\"endTagHeading\",h6:\"endTagHeading\",a:\"endTagFormatting\",b:\"endTagFormatting\",big:\"endTagFormatting\",code:\"endTagFormatting\",em:\"endTagFormatting\",font:\"endTagFormatting\",i:\"endTagFormatting\",nobr:\"endTagFormatting\",s:\"endTagFormatting\",small:\"endTagFormatting\",strike:\"endTagFormatting\",strong:\"endTagFormatting\",tt:\"endTagFormatting\",u:\"endTagFormatting\",br:\"endTagBr\",\"-default\":\"endTagOther\"},modes.inBody.processCharacters=function(buffer){tree.shouldSkipLeadingNewline&&(tree.shouldSkipLeadingNewline=!1,buffer.skipAtMostOneLeadingNewline()),tree.reconstructActiveFormattingElements();var characters=buffer.takeRemaining();characters=characters.replace(/\\u0000/g,function(){return tree.parseError(\"invalid-codepoint\"),\"\"}),characters&&(tree.insertText(characters),tree.framesetOk&&!isAllWhitespaceOrReplacementCharacters(characters)&&(tree.framesetOk=!1))},modes.inBody.startTagHtml=function(name,attributes){tree.parseError(\"non-html-root\"),tree.addAttributesToElement(tree.openElements.rootNode,attributes)},modes.inBody.startTagProcessInHead=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.inBody.startTagBody=function(name,attributes){tree.parseError(\"unexpected-start-tag\",{name:\"body\"}),1==tree.openElements.length||\"body\"!=tree.openElements.item(1).localName?assert.ok(tree.context):(tree.framesetOk=!1,tree.addAttributesToElement(tree.openElements.bodyElement,attributes))},modes.inBody.startTagFrameset=function(name,attributes){if(tree.parseError(\"unexpected-start-tag\",{name:\"frameset\"}),1==tree.openElements.length||\"body\"!=tree.openElements.item(1).localName)assert.ok(tree.context);else if(tree.framesetOk){for(tree.detachFromParent(tree.openElements.bodyElement);tree.openElements.length>1;)tree.openElements.pop();tree.insertElement(name,attributes),tree.setInsertionMode(\"inFrameset\")}},modes.inBody.startTagCloseP=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes)},modes.inBody.startTagPreListing=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes),tree.framesetOk=!1,tree.shouldSkipLeadingNewline=!0},modes.inBody.startTagForm=function(name,attributes){tree.form?tree.parseError(\"unexpected-start-tag\",{name:name}):(tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes),tree.form=tree.currentStackItem())},modes.inBody.startTagRpRt=function(name,attributes){tree.openElements.inScope(\"ruby\")&&(tree.generateImpliedEndTags(),\"ruby\"!=tree.currentStackItem().localName&&tree.parseError(\"unexpected-start-tag\",{name:name})),tree.insertElement(name,attributes)},modes.inBody.startTagListItem=function(name,attributes){for(var stopNames={li:[\"li\"],dd:[\"dd\",\"dt\"],dt:[\"dd\",\"dt\"]},stopName=stopNames[name],els=tree.openElements,i=els.length-1;i>=0;i--){var node=els.item(i);if(-1!=stopName.indexOf(node.localName)){tree.insertionMode.processEndTag(node.localName);break}if(node.isSpecial()&&\"p\"!==node.localName&&\"address\"!==node.localName&&\"div\"!==node.localName)break}tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes),tree.framesetOk=!1},modes.inBody.startTagPlaintext=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertElement(name,attributes),tree.tokenizer.setState(Tokenizer.PLAINTEXT)},modes.inBody.startTagHeading=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.currentStackItem().isNumberedHeader()&&(tree.parseError(\"unexpected-start-tag\",{name:name}),tree.popElement()),tree.insertElement(name,attributes)},modes.inBody.startTagA=function(name,attributes){var activeA=tree.elementInActiveFormattingElements(\"a\");activeA&&(tree.parseError(\"unexpected-start-tag-implies-end-tag\",{startName:\"a\",endName:\"a\"}),tree.adoptionAgencyEndTag(\"a\"),tree.openElements.contains(activeA)&&tree.openElements.remove(activeA),tree.removeElementFromActiveFormattingElements(activeA)),tree.reconstructActiveFormattingElements(),tree.insertFormattingElement(name,attributes)},modes.inBody.startTagFormatting=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertFormattingElement(name,attributes)},modes.inBody.startTagNobr=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.openElements.inScope(\"nobr\")&&(tree.parseError(\"unexpected-start-tag-implies-end-tag\",{startName:\"nobr\",endName:\"nobr\"}),this.processEndTag(\"nobr\"),tree.reconstructActiveFormattingElements()),tree.insertFormattingElement(name,attributes)},modes.inBody.startTagButton=function(name,attributes){tree.openElements.inScope(\"button\")?(tree.parseError(\"unexpected-start-tag-implies-end-tag\",{startName:\"button\",endName:\"button\"}),this.processEndTag(\"button\"),tree.insertionMode.processStartTag(name,attributes)):(tree.framesetOk=!1,tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes))},modes.inBody.startTagAppletMarqueeObject=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes),tree.activeFormattingElements.push(Marker),tree.framesetOk=!1},modes.inBody.endTagAppletMarqueeObject=function(name){tree.openElements.inScope(name)?(tree.generateImpliedEndTags(),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early\",{name:name}),tree.openElements.popUntilPopped(name),tree.clearActiveFormattingElements()):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.startTagXmp=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.processEndTag(\"p\"),tree.reconstructActiveFormattingElements(),tree.processGenericRawTextStartTag(name,attributes),tree.framesetOk=!1},modes.inBody.startTagTable=function(name,attributes){\"quirks\"!==tree.compatMode&&tree.openElements.inButtonScope(\"p\")&&this.processEndTag(\"p\"),tree.insertElement(name,attributes),tree.setInsertionMode(\"inTable\"),tree.framesetOk=!1},modes.inBody.startTagVoidFormatting=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertSelfClosingElement(name,attributes),tree.framesetOk=!1},modes.inBody.startTagParamSourceTrack=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inBody.startTagHr=function(name,attributes){tree.openElements.inButtonScope(\"p\")&&this.endTagP(\"p\"),tree.insertSelfClosingElement(name,attributes),tree.framesetOk=!1},modes.inBody.startTagImage=function(name,attributes){tree.parseError(\"unexpected-start-tag-treated-as\",{originalName:\"image\",newName:\"img\"}),this.processStartTag(\"img\",attributes)},modes.inBody.startTagInput=function(name,attributes){var currentFramesetOk=tree.framesetOk;this.startTagVoidFormatting(name,attributes);for(var key in attributes)if(\"type\"==attributes[key].nodeName){\"hidden\"==attributes[key].nodeValue.toLowerCase()&&(tree.framesetOk=currentFramesetOk);break}},modes.inBody.startTagIsindex=function(name,attributes){if(tree.parseError(\"deprecated-tag\",{name:\"isindex\"}),tree.selfClosingFlagAcknowledged=!0,!tree.form){var formAttributes=[],inputAttributes=[],prompt=\"This is a searchable index. Enter search keywords: \";for(var key in attributes)switch(attributes[key].nodeName){case\"action\":formAttributes.push({nodeName:\"action\",nodeValue:attributes[key].nodeValue});break;case\"prompt\":prompt=attributes[key].nodeValue;break;case\"name\":break;default:inputAttributes.push({nodeName:attributes[key].nodeName,nodeValue:attributes[key].nodeValue})}inputAttributes.push({nodeName:\"name\",nodeValue:\"isindex\"}),this.processStartTag(\"form\",formAttributes),this.processStartTag(\"hr\"),this.processStartTag(\"label\"),this.processCharacters(new CharacterBuffer(prompt)),this.processStartTag(\"input\",inputAttributes),this.processEndTag(\"label\"),this.processStartTag(\"hr\"),this.processEndTag(\"form\")}},modes.inBody.startTagTextarea=function(name,attributes){tree.insertElement(name,attributes),tree.tokenizer.setState(Tokenizer.RCDATA),tree.originalInsertionMode=tree.insertionModeName,tree.shouldSkipLeadingNewline=!0,tree.framesetOk=!1,tree.setInsertionMode(\"text\")},modes.inBody.startTagIFrame=function(name,attributes){tree.framesetOk=!1,this.startTagRawText(name,attributes)},modes.inBody.startTagRawText=function(name,attributes){tree.processGenericRawTextStartTag(name,attributes)},modes.inBody.startTagSelect=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes),tree.framesetOk=!1;var insertionModeName=tree.insertionModeName;\"inTable\"==insertionModeName||\"inCaption\"==insertionModeName||\"inColumnGroup\"==insertionModeName||\"inTableBody\"==insertionModeName||\"inRow\"==insertionModeName||\"inCell\"==insertionModeName?tree.setInsertionMode(\"inSelectInTable\"):tree.setInsertionMode(\"inSelect\")},modes.inBody.startTagMisplaced=function(name){tree.parseError(\"unexpected-start-tag-ignored\",{name:name})},modes.inBody.endTagMisplaced=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.endTagBr=function(name){tree.parseError(\"unexpected-end-tag-treated-as\",{originalName:\"br\",newName:\"br element\"}),tree.reconstructActiveFormattingElements(),tree.insertElement(name,[]),tree.popElement()},modes.inBody.startTagOptionOptgroup=function(name,attributes){\"option\"==tree.currentStackItem().localName&&tree.popElement(),tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes)},modes.inBody.startTagOther=function(name,attributes){tree.reconstructActiveFormattingElements(),tree.insertElement(name,attributes)},modes.inBody.endTagOther=function(name){for(var node,i=tree.openElements.length-1;i>0;i--){if(node=tree.openElements.item(i),node.localName==name){tree.generateImpliedEndTags(name),tree.currentStackItem().localName!=name&&tree.parseError(\"unexpected-end-tag\",{name:name}),tree.openElements.remove_openElements_until(function(x){return x===node});break}if(node.isSpecial()){tree.parseError(\"unexpected-end-tag\",{name:name});break}}},modes.inBody.startTagMath=function(name,attributes,selfClosing){tree.reconstructActiveFormattingElements(),attributes=tree.adjustMathMLAttributes(attributes),attributes=tree.adjustForeignAttributes(attributes),tree.insertForeignElement(name,attributes,\"http://www.w3.org/1998/Math/MathML\",selfClosing)},modes.inBody.startTagSVG=function(name,attributes,selfClosing){tree.reconstructActiveFormattingElements(),attributes=tree.adjustSVGAttributes(attributes),attributes=tree.adjustForeignAttributes(attributes),tree.insertForeignElement(name,attributes,\"http://www.w3.org/2000/svg\",selfClosing)},modes.inBody.endTagP=function(name){tree.openElements.inButtonScope(\"p\")?(tree.generateImpliedEndTags(\"p\"),\"p\"!=tree.currentStackItem().localName&&tree.parseError(\"unexpected-implied-end-tag\",{name:\"p\"}),tree.openElements.popUntilPopped(name)):(tree.parseError(\"unexpected-end-tag\",{name:\"p\"}),this.startTagCloseP(\"p\",[]),this.endTagP(\"p\"))},modes.inBody.endTagBody=function(name){return tree.openElements.inScope(\"body\")?(\"body\"!=tree.currentStackItem().localName&&tree.parseError(\"expected-one-end-tag-but-got-another\",{expectedName:tree.currentStackItem().localName,gotName:name}),tree.setInsertionMode(\"afterBody\"),void 0):(tree.parseError(\"unexpected-end-tag\",{name:name}),void 0)},modes.inBody.endTagHtml=function(name){return tree.openElements.inScope(\"body\")?(\"body\"!=tree.currentStackItem().localName&&tree.parseError(\"expected-one-end-tag-but-got-another\",{expectedName:tree.currentStackItem().localName,gotName:name}),tree.setInsertionMode(\"afterBody\"),tree.insertionMode.processEndTag(name),void 0):(tree.parseError(\"unexpected-end-tag\",{name:name}),void 0)},modes.inBody.endTagBlock=function(name){tree.openElements.inScope(name)?(tree.generateImpliedEndTags(),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early\",{name:name}),tree.openElements.popUntilPopped(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.endTagForm=function(name){var node=tree.form;tree.form=null,node&&tree.openElements.inScope(name)?(tree.generateImpliedEndTags(),tree.currentStackItem()!=node&&tree.parseError(\"end-tag-too-early-ignored\",{name:\"form\"}),tree.openElements.remove(node)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.endTagListItem=function(name){tree.openElements.inListItemScope(name)?(tree.generateImpliedEndTags(name),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early\",{name:name}),tree.openElements.popUntilPopped(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inBody.endTagHeading=function(name){return tree.openElements.hasNumberedHeaderElementInScope()?(tree.generateImpliedEndTags(),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early\",{name:name}),tree.openElements.remove_openElements_until(function(e){return e.isNumberedHeader()}),void 0):(tree.parseError(\"unexpected-end-tag\",{name:name}),void 0)},modes.inBody.endTagFormatting=function(name,attributes){tree.adoptionAgencyEndTag(name)||this.endTagOther(name,attributes)},modes.inCaption=Object.create(modes.base),modes.inCaption.start_tag_handlers={html:\"startTagHtml\",caption:\"startTagTableElement\",col:\"startTagTableElement\",colgroup:\"startTagTableElement\",tbody:\"startTagTableElement\",td:\"startTagTableElement\",tfoot:\"startTagTableElement\",thead:\"startTagTableElement\",tr:\"startTagTableElement\",\"-default\":\"startTagOther\"},modes.inCaption.end_tag_handlers={caption:\"endTagCaption\",table:\"endTagTable\",body:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",tbody:\"endTagIgnore\",td:\"endTagIgnore\",tfood:\"endTagIgnore\",thead:\"endTagIgnore\",tr:\"endTagIgnore\",\"-default\":\"endTagOther\"},modes.inCaption.processCharacters=function(data){modes.inBody.processCharacters(data)},modes.inCaption.startTagTableElement=function(name,attributes){tree.parseError(\"unexpected-end-tag\",{name:name});var ignoreEndTag=!tree.openElements.inTableScope(\"caption\");tree.insertionMode.processEndTag(\"caption\"),ignoreEndTag||tree.insertionMode.processStartTag(name,attributes)},modes.inCaption.startTagOther=function(name,attributes,selfClosing){modes.inBody.processStartTag(name,attributes,selfClosing)},modes.inCaption.endTagCaption=function(name){tree.openElements.inTableScope(\"caption\")?(tree.generateImpliedEndTags(),\"caption\"!=tree.currentStackItem().localName&&tree.parseError(\"expected-one-end-tag-but-got-another\",{gotName:\"caption\",expectedName:tree.currentStackItem().localName}),tree.openElements.popUntilPopped(\"caption\"),tree.clearActiveFormattingElements(),tree.setInsertionMode(\"inTable\")):(assert.ok(tree.context),tree.parseError(\"unexpected-end-tag\",{name:name}))},modes.inCaption.endTagTable=function(name){tree.parseError(\"unexpected-end-table-in-caption\");var ignoreEndTag=!tree.openElements.inTableScope(\"caption\");tree.insertionMode.processEndTag(\"caption\"),ignoreEndTag||tree.insertionMode.processEndTag(name)},modes.inCaption.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inCaption.endTagOther=function(name){modes.inBody.processEndTag(name)},modes.inCell=Object.create(modes.base),modes.inCell.start_tag_handlers={html:\"startTagHtml\",caption:\"startTagTableOther\",col:\"startTagTableOther\",colgroup:\"startTagTableOther\",tbody:\"startTagTableOther\",td:\"startTagTableOther\",tfoot:\"startTagTableOther\",th:\"startTagTableOther\",thead:\"startTagTableOther\",tr:\"startTagTableOther\",\"-default\":\"startTagOther\"},modes.inCell.end_tag_handlers={td:\"endTagTableCell\",th:\"endTagTableCell\",body:\"endTagIgnore\",caption:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",table:\"endTagImply\",tbody:\"endTagImply\",tfoot:\"endTagImply\",thead:\"endTagImply\",tr:\"endTagImply\",\"-default\":\"endTagOther\"},modes.inCell.processCharacters=function(data){modes.inBody.processCharacters(data)},modes.inCell.startTagTableOther=function(name,attributes,selfClosing){tree.openElements.inTableScope(\"td\")||tree.openElements.inTableScope(\"th\")?(this.closeCell(),tree.insertionMode.processStartTag(name,attributes,selfClosing)):tree.parseError(\"unexpected-start-tag\",{name:name})},modes.inCell.startTagOther=function(name,attributes,selfClosing){modes.inBody.processStartTag(name,attributes,selfClosing)},modes.inCell.endTagTableCell=function(name){tree.openElements.inTableScope(name)?(tree.generateImpliedEndTags(name),tree.currentStackItem().localName!=name.toLowerCase()?(tree.parseError(\"unexpected-cell-end-tag\",{name:name}),tree.openElements.popUntilPopped(name)):tree.popElement(),tree.clearActiveFormattingElements(),tree.setInsertionMode(\"inRow\")):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inCell.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inCell.endTagImply=function(name){tree.openElements.inTableScope(name)?(this.closeCell(),tree.insertionMode.processEndTag(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inCell.endTagOther=function(name){modes.inBody.processEndTag(name)},modes.inCell.closeCell=function(){tree.openElements.inTableScope(\"td\")?this.endTagTableCell(\"td\"):tree.openElements.inTableScope(\"th\")&&this.endTagTableCell(\"th\")},modes.inColumnGroup=Object.create(modes.base),modes.inColumnGroup.start_tag_handlers={html:\"startTagHtml\",col:\"startTagCol\",\"-default\":\"startTagOther\"},modes.inColumnGroup.end_tag_handlers={colgroup:\"endTagColgroup\",col:\"endTagCol\",\"-default\":\"endTagOther\"},modes.inColumnGroup.ignoreEndTagColgroup=function(){return\"html\"==tree.currentStackItem().localName},modes.inColumnGroup.processCharacters=function(buffer){var leadingWhitespace=buffer.takeLeadingWhitespace();if(leadingWhitespace&&tree.insertText(leadingWhitespace),buffer.length){var ignoreEndTag=this.ignoreEndTagColgroup();this.endTagColgroup(\"colgroup\"),ignoreEndTag||tree.insertionMode.processCharacters(buffer)}},modes.inColumnGroup.startTagCol=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inColumnGroup.startTagOther=function(name,attributes,selfClosing){var ignoreEndTag=this.ignoreEndTagColgroup();this.endTagColgroup(\"colgroup\"),ignoreEndTag||tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.inColumnGroup.endTagColgroup=function(name){this.ignoreEndTagColgroup()?(assert.ok(tree.context),tree.parseError(\"unexpected-end-tag\",{name:name})):(tree.popElement(),tree.setInsertionMode(\"inTable\"))},modes.inColumnGroup.endTagCol=function(){tree.parseError(\"no-end-tag\",{name:\"col\"})},modes.inColumnGroup.endTagOther=function(name){var ignoreEndTag=this.ignoreEndTagColgroup();this.endTagColgroup(\"colgroup\"),ignoreEndTag||tree.insertionMode.processEndTag(name)},modes.inForeignContent=Object.create(modes.base),modes.inForeignContent.processStartTag=function(name,attributes,selfClosing){if(-1!=[\"b\",\"big\",\"blockquote\",\"body\",\"br\",\"center\",\"code\",\"dd\",\"div\",\"dl\",\"dt\",\"em\",\"embed\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"head\",\"hr\",\"i\",\"img\",\"li\",\"listing\",\"menu\",\"meta\",\"nobr\",\"ol\",\"p\",\"pre\",\"ruby\",\"s\",\"small\",\"span\",\"strong\",\"strike\",\"sub\",\"sup\",\"table\",\"tt\",\"u\",\"ul\",\"var\"].indexOf(name)||\"font\"==name&&attributes.some(function(attr){return[\"color\",\"face\",\"size\"].indexOf(attr.nodeName)>=0})){for(tree.parseError(\"unexpected-html-element-in-foreign-content\",{name:name});tree.currentStackItem().isForeign()&&!tree.currentStackItem().isHtmlIntegrationPoint()&&!tree.currentStackItem().isMathMLTextIntegrationPoint();)tree.openElements.pop();return tree.insertionMode.processStartTag(name,attributes,selfClosing),void 0}\"http://www.w3.org/1998/Math/MathML\"==tree.currentStackItem().namespaceURI&&(attributes=tree.adjustMathMLAttributes(attributes)),\"http://www.w3.org/2000/svg\"==tree.currentStackItem().namespaceURI&&(name=tree.adjustSVGTagNameCase(name),attributes=tree.adjustSVGAttributes(attributes)),attributes=tree.adjustForeignAttributes(attributes),tree.insertForeignElement(name,attributes,tree.currentStackItem().namespaceURI,selfClosing)},modes.inForeignContent.processEndTag=function(name){var node=tree.currentStackItem(),index=tree.openElements.length-1;for(node.localName.toLowerCase()!=name&&tree.parseError(\"unexpected-end-tag\",{name:name});;){if(0===index)break;if(node.localName.toLowerCase()==name){for(;tree.openElements.pop()!=node;);break}if(index-=1,node=tree.openElements.item(index),!node.isForeign()){tree.insertionMode.processEndTag(name);break}}},modes.inForeignContent.processCharacters=function(buffer){var characters=buffer.takeRemaining();characters=characters.replace(/\\u0000/g,function(){return tree.parseError(\"invalid-codepoint\"),\"�\"}),tree.framesetOk&&!isAllWhitespaceOrReplacementCharacters(characters)&&(tree.framesetOk=!1),tree.insertText(characters)},modes.inHeadNoscript=Object.create(modes.base),modes.inHeadNoscript.start_tag_handlers={html:\"startTagHtml\",basefont:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",bgsound:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",link:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",meta:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",noframes:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",style:\"startTagBasefontBgsoundLinkMetaNoframesStyle\",head:\"startTagHeadNoscript\",noscript:\"startTagHeadNoscript\",\"-default\":\"startTagOther\"},modes.inHeadNoscript.end_tag_handlers={noscript:\"endTagNoscript\",br:\"endTagBr\",\"-default\":\"endTagOther\"},modes.inHeadNoscript.processCharacters=function(buffer){var leadingWhitespace=buffer.takeLeadingWhitespace();leadingWhitespace&&tree.insertText(leadingWhitespace),buffer.length&&(tree.parseError(\"unexpected-char-in-frameset\"),this.anythingElse(),tree.insertionMode.processCharacters(buffer))},modes.inHeadNoscript.processComment=function(data){modes.inHead.processComment(data)},modes.inHeadNoscript.startTagBasefontBgsoundLinkMetaNoframesStyle=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.inHeadNoscript.startTagHeadNoscript=function(name){tree.parseError(\"unexpected-start-tag-in-frameset\",{name:name})},modes.inHeadNoscript.startTagOther=function(name,attributes){tree.parseError(\"unexpected-start-tag-in-frameset\",{name:name}),this.anythingElse(),tree.insertionMode.processStartTag(name,attributes)},modes.inHeadNoscript.endTagBr=function(name,attributes){tree.parseError(\"unexpected-end-tag-in-frameset\",{name:name}),this.anythingElse(),tree.insertionMode.processEndTag(name,attributes)},modes.inHeadNoscript.endTagNoscript=function(){tree.popElement(),tree.setInsertionMode(\"inHead\")},modes.inHeadNoscript.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-in-frameset\",{name:name})},modes.inHeadNoscript.anythingElse=function(){tree.popElement(),tree.setInsertionMode(\"inHead\")},modes.inFrameset=Object.create(modes.base),modes.inFrameset.start_tag_handlers={html:\"startTagHtml\",frameset:\"startTagFrameset\",frame:\"startTagFrame\",noframes:\"startTagNoframes\",\"-default\":\"startTagOther\"},modes.inFrameset.end_tag_handlers={frameset:\"endTagFrameset\",noframes:\"endTagNoframes\",\"-default\":\"endTagOther\"},modes.inFrameset.processCharacters=function(){tree.parseError(\"unexpected-char-in-frameset\")},modes.inFrameset.startTagFrameset=function(name,attributes){tree.insertElement(name,attributes)},modes.inFrameset.startTagFrame=function(name,attributes){tree.insertSelfClosingElement(name,attributes)},modes.inFrameset.startTagNoframes=function(name,attributes){modes.inBody.processStartTag(name,attributes)},modes.inFrameset.startTagOther=function(name){tree.parseError(\"unexpected-start-tag-in-frameset\",{name:name})},modes.inFrameset.endTagFrameset=function(){\"html\"==tree.currentStackItem().localName?tree.parseError(\"unexpected-frameset-in-frameset-innerhtml\"):tree.popElement(),tree.context||\"frameset\"==tree.currentStackItem().localName||tree.setInsertionMode(\"afterFrameset\")},modes.inFrameset.endTagNoframes=function(name){modes.inBody.processEndTag(name)},modes.inFrameset.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-in-frameset\",{name:name})},modes.inTable=Object.create(modes.base),modes.inTable.start_tag_handlers={html:\"startTagHtml\",caption:\"startTagCaption\",colgroup:\"startTagColgroup\",col:\"startTagCol\",table:\"startTagTable\",tbody:\"startTagRowGroup\",tfoot:\"startTagRowGroup\",thead:\"startTagRowGroup\",td:\"startTagImplyTbody\",th:\"startTagImplyTbody\",tr:\"startTagImplyTbody\",style:\"startTagStyleScript\",script:\"startTagStyleScript\",input:\"startTagInput\",form:\"startTagForm\",\"-default\":\"startTagOther\"},modes.inTable.end_tag_handlers={table:\"endTagTable\",body:\"endTagIgnore\",caption:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",tbody:\"endTagIgnore\",td:\"endTagIgnore\",tfoot:\"endTagIgnore\",th:\"endTagIgnore\",thead:\"endTagIgnore\",tr:\"endTagIgnore\",\"-default\":\"endTagOther\"},modes.inTable.processCharacters=function(data){if(tree.currentStackItem().isFosterParenting()){var originalInsertionMode=tree.insertionModeName;\ntree.setInsertionMode(\"inTableText\"),tree.originalInsertionMode=originalInsertionMode,tree.insertionMode.processCharacters(data)}else tree.redirectAttachToFosterParent=!0,modes.inBody.processCharacters(data),tree.redirectAttachToFosterParent=!1},modes.inTable.startTagCaption=function(name,attributes){tree.openElements.popUntilTableScopeMarker(),tree.activeFormattingElements.push(Marker),tree.insertElement(name,attributes),tree.setInsertionMode(\"inCaption\")},modes.inTable.startTagColgroup=function(name,attributes){tree.openElements.popUntilTableScopeMarker(),tree.insertElement(name,attributes),tree.setInsertionMode(\"inColumnGroup\")},modes.inTable.startTagCol=function(name,attributes){this.startTagColgroup(\"colgroup\",[]),tree.insertionMode.processStartTag(name,attributes)},modes.inTable.startTagRowGroup=function(name,attributes){tree.openElements.popUntilTableScopeMarker(),tree.insertElement(name,attributes),tree.setInsertionMode(\"inTableBody\")},modes.inTable.startTagImplyTbody=function(name,attributes){this.startTagRowGroup(\"tbody\",[]),tree.insertionMode.processStartTag(name,attributes)},modes.inTable.startTagTable=function(name,attributes){tree.parseError(\"unexpected-start-tag-implies-end-tag\",{startName:\"table\",endName:\"table\"}),tree.insertionMode.processEndTag(\"table\"),tree.context||tree.insertionMode.processStartTag(name,attributes)},modes.inTable.startTagStyleScript=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.inTable.startTagInput=function(name,attributes){for(var key in attributes)if(\"type\"==attributes[key].nodeName.toLowerCase()){if(\"hidden\"==attributes[key].nodeValue.toLowerCase())return tree.parseError(\"unexpected-hidden-input-in-table\"),tree.insertElement(name,attributes),tree.openElements.pop(),void 0;break}this.startTagOther(name,attributes)},modes.inTable.startTagForm=function(name,attributes){tree.parseError(\"unexpected-form-in-table\"),tree.form||(tree.insertElement(name,attributes),tree.form=tree.currentStackItem(),tree.openElements.pop())},modes.inTable.startTagOther=function(name,attributes,selfClosing){tree.parseError(\"unexpected-start-tag-implies-table-voodoo\",{name:name}),tree.redirectAttachToFosterParent=!0,modes.inBody.processStartTag(name,attributes,selfClosing),tree.redirectAttachToFosterParent=!1},modes.inTable.endTagTable=function(name){tree.openElements.inTableScope(name)?(tree.generateImpliedEndTags(),tree.currentStackItem().localName!=name&&tree.parseError(\"end-tag-too-early-named\",{gotName:\"table\",expectedName:tree.currentStackItem().localName}),tree.openElements.popUntilPopped(\"table\"),tree.resetInsertionMode()):(assert.ok(tree.context),tree.parseError(\"unexpected-end-tag\",{name:name}))},modes.inTable.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inTable.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-implies-table-voodoo\",{name:name}),tree.redirectAttachToFosterParent=!0,modes.inBody.processEndTag(name),tree.redirectAttachToFosterParent=!1},modes.inTableText=Object.create(modes.base),modes.inTableText.flushCharacters=function(){var characters=tree.pendingTableCharacters.join(\"\");isAllWhitespace(characters)?tree.insertText(characters):(tree.redirectAttachToFosterParent=!0,tree.reconstructActiveFormattingElements(),tree.insertText(characters),tree.framesetOk=!1,tree.redirectAttachToFosterParent=!1),tree.pendingTableCharacters=[]},modes.inTableText.processComment=function(data){this.flushCharacters(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processComment(data)},modes.inTableText.processEOF=function(){this.flushCharacters(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processEOF()},modes.inTableText.processCharacters=function(buffer){var characters=buffer.takeRemaining();characters=characters.replace(/\\u0000/g,function(){return tree.parseError(\"invalid-codepoint\"),\"\"}),characters&&tree.pendingTableCharacters.push(characters)},modes.inTableText.processStartTag=function(name,attributes,selfClosing){this.flushCharacters(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processStartTag(name,attributes,selfClosing)},modes.inTableText.processEndTag=function(name,attributes){this.flushCharacters(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processEndTag(name,attributes)},modes.inTableBody=Object.create(modes.base),modes.inTableBody.start_tag_handlers={html:\"startTagHtml\",tr:\"startTagTr\",td:\"startTagTableCell\",th:\"startTagTableCell\",caption:\"startTagTableOther\",col:\"startTagTableOther\",colgroup:\"startTagTableOther\",tbody:\"startTagTableOther\",tfoot:\"startTagTableOther\",thead:\"startTagTableOther\",\"-default\":\"startTagOther\"},modes.inTableBody.end_tag_handlers={table:\"endTagTable\",tbody:\"endTagTableRowGroup\",tfoot:\"endTagTableRowGroup\",thead:\"endTagTableRowGroup\",body:\"endTagIgnore\",caption:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",td:\"endTagIgnore\",th:\"endTagIgnore\",tr:\"endTagIgnore\",\"-default\":\"endTagOther\"},modes.inTableBody.processCharacters=function(data){modes.inTable.processCharacters(data)},modes.inTableBody.startTagTr=function(name,attributes){tree.openElements.popUntilTableBodyScopeMarker(),tree.insertElement(name,attributes),tree.setInsertionMode(\"inRow\")},modes.inTableBody.startTagTableCell=function(name,attributes){tree.parseError(\"unexpected-cell-in-table-body\",{name:name}),this.startTagTr(\"tr\",[]),tree.insertionMode.processStartTag(name,attributes)},modes.inTableBody.startTagTableOther=function(name,attributes){tree.openElements.inTableScope(\"tbody\")||tree.openElements.inTableScope(\"thead\")||tree.openElements.inTableScope(\"tfoot\")?(tree.openElements.popUntilTableBodyScopeMarker(),this.endTagTableRowGroup(tree.currentStackItem().localName),tree.insertionMode.processStartTag(name,attributes)):tree.parseError(\"unexpected-start-tag\",{name:name})},modes.inTableBody.startTagOther=function(name,attributes){modes.inTable.processStartTag(name,attributes)},modes.inTableBody.endTagTableRowGroup=function(name){tree.openElements.inTableScope(name)?(tree.openElements.popUntilTableBodyScopeMarker(),tree.popElement(),tree.setInsertionMode(\"inTable\")):tree.parseError(\"unexpected-end-tag-in-table-body\",{name:name})},modes.inTableBody.endTagTable=function(name){tree.openElements.inTableScope(\"tbody\")||tree.openElements.inTableScope(\"thead\")||tree.openElements.inTableScope(\"tfoot\")?(tree.openElements.popUntilTableBodyScopeMarker(),this.endTagTableRowGroup(tree.currentStackItem().localName),tree.insertionMode.processEndTag(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inTableBody.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag-in-table-body\",{name:name})},modes.inTableBody.endTagOther=function(name){modes.inTable.processEndTag(name)},modes.inSelect=Object.create(modes.base),modes.inSelect.start_tag_handlers={html:\"startTagHtml\",option:\"startTagOption\",optgroup:\"startTagOptgroup\",select:\"startTagSelect\",input:\"startTagInput\",keygen:\"startTagInput\",textarea:\"startTagInput\",script:\"startTagScript\",\"-default\":\"startTagOther\"},modes.inSelect.end_tag_handlers={option:\"endTagOption\",optgroup:\"endTagOptgroup\",select:\"endTagSelect\",caption:\"endTagTableElements\",table:\"endTagTableElements\",tbody:\"endTagTableElements\",tfoot:\"endTagTableElements\",thead:\"endTagTableElements\",tr:\"endTagTableElements\",td:\"endTagTableElements\",th:\"endTagTableElements\",\"-default\":\"endTagOther\"},modes.inSelect.processCharacters=function(buffer){var data=buffer.takeRemaining();data=data.replace(/\\u0000/g,function(){return tree.parseError(\"invalid-codepoint\"),\"\"}),data&&tree.insertText(data)},modes.inSelect.startTagOption=function(name,attributes){\"option\"==tree.currentStackItem().localName&&tree.popElement(),tree.insertElement(name,attributes)},modes.inSelect.startTagOptgroup=function(name,attributes){\"option\"==tree.currentStackItem().localName&&tree.popElement(),\"optgroup\"==tree.currentStackItem().localName&&tree.popElement(),tree.insertElement(name,attributes)},modes.inSelect.endTagOption=function(name){return\"option\"!==tree.currentStackItem().localName?(tree.parseError(\"unexpected-end-tag-in-select\",{name:name}),void 0):(tree.popElement(),void 0)},modes.inSelect.endTagOptgroup=function(){\"option\"==tree.currentStackItem().localName&&\"optgroup\"==tree.openElements.item(tree.openElements.length-2).localName&&tree.popElement(),\"optgroup\"==tree.currentStackItem().localName?tree.popElement():tree.parseError(\"unexpected-end-tag-in-select\",{name:\"optgroup\"})},modes.inSelect.startTagSelect=function(){tree.parseError(\"unexpected-select-in-select\"),this.endTagSelect(\"select\")},modes.inSelect.endTagSelect=function(name){tree.openElements.inTableScope(\"select\")?(tree.openElements.popUntilPopped(\"select\"),tree.resetInsertionMode()):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inSelect.startTagInput=function(name,attributes){tree.parseError(\"unexpected-input-in-select\"),tree.openElements.inSelectScope(\"select\")&&(this.endTagSelect(\"select\"),tree.insertionMode.processStartTag(name,attributes))},modes.inSelect.startTagScript=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.inSelect.endTagTableElements=function(name){tree.parseError(\"unexpected-end-tag-in-select\",{name:name}),tree.openElements.inTableScope(name)&&(this.endTagSelect(\"select\"),tree.insertionMode.processEndTag(name))},modes.inSelect.startTagOther=function(name){tree.parseError(\"unexpected-start-tag-in-select\",{name:name})},modes.inSelect.endTagOther=function(name){tree.parseError(\"unexpected-end-tag-in-select\",{name:name})},modes.inSelectInTable=Object.create(modes.base),modes.inSelectInTable.start_tag_handlers={caption:\"startTagTable\",table:\"startTagTable\",tbody:\"startTagTable\",tfoot:\"startTagTable\",thead:\"startTagTable\",tr:\"startTagTable\",td:\"startTagTable\",th:\"startTagTable\",\"-default\":\"startTagOther\"},modes.inSelectInTable.end_tag_handlers={caption:\"endTagTable\",table:\"endTagTable\",tbody:\"endTagTable\",tfoot:\"endTagTable\",thead:\"endTagTable\",tr:\"endTagTable\",td:\"endTagTable\",th:\"endTagTable\",\"-default\":\"endTagOther\"},modes.inSelectInTable.processCharacters=function(data){modes.inSelect.processCharacters(data)},modes.inSelectInTable.startTagTable=function(name,attributes){tree.parseError(\"unexpected-table-element-start-tag-in-select-in-table\",{name:name}),this.endTagOther(\"select\"),tree.insertionMode.processStartTag(name,attributes)},modes.inSelectInTable.startTagOther=function(name,attributes,selfClosing){modes.inSelect.processStartTag(name,attributes,selfClosing)},modes.inSelectInTable.endTagTable=function(name){tree.parseError(\"unexpected-table-element-end-tag-in-select-in-table\",{name:name}),tree.openElements.inTableScope(name)&&(this.endTagOther(\"select\"),tree.insertionMode.processEndTag(name))},modes.inSelectInTable.endTagOther=function(name){modes.inSelect.processEndTag(name)},modes.inRow=Object.create(modes.base),modes.inRow.start_tag_handlers={html:\"startTagHtml\",td:\"startTagTableCell\",th:\"startTagTableCell\",caption:\"startTagTableOther\",col:\"startTagTableOther\",colgroup:\"startTagTableOther\",tbody:\"startTagTableOther\",tfoot:\"startTagTableOther\",thead:\"startTagTableOther\",tr:\"startTagTableOther\",\"-default\":\"startTagOther\"},modes.inRow.end_tag_handlers={tr:\"endTagTr\",table:\"endTagTable\",tbody:\"endTagTableRowGroup\",tfoot:\"endTagTableRowGroup\",thead:\"endTagTableRowGroup\",body:\"endTagIgnore\",caption:\"endTagIgnore\",col:\"endTagIgnore\",colgroup:\"endTagIgnore\",html:\"endTagIgnore\",td:\"endTagIgnore\",th:\"endTagIgnore\",\"-default\":\"endTagOther\"},modes.inRow.processCharacters=function(data){modes.inTable.processCharacters(data)},modes.inRow.startTagTableCell=function(name,attributes){tree.openElements.popUntilTableRowScopeMarker(),tree.insertElement(name,attributes),tree.setInsertionMode(\"inCell\"),tree.activeFormattingElements.push(Marker)},modes.inRow.startTagTableOther=function(name,attributes){var ignoreEndTag=this.ignoreEndTagTr();this.endTagTr(\"tr\"),ignoreEndTag||tree.insertionMode.processStartTag(name,attributes)},modes.inRow.startTagOther=function(name,attributes,selfClosing){modes.inTable.processStartTag(name,attributes,selfClosing)},modes.inRow.endTagTr=function(name){this.ignoreEndTagTr()?(assert.ok(tree.context),tree.parseError(\"unexpected-end-tag\",{name:name})):(tree.openElements.popUntilTableRowScopeMarker(),tree.popElement(),tree.setInsertionMode(\"inTableBody\"))},modes.inRow.endTagTable=function(name){var ignoreEndTag=this.ignoreEndTagTr();this.endTagTr(\"tr\"),ignoreEndTag||tree.insertionMode.processEndTag(name)},modes.inRow.endTagTableRowGroup=function(name){tree.openElements.inTableScope(name)?(this.endTagTr(\"tr\"),tree.insertionMode.processEndTag(name)):tree.parseError(\"unexpected-end-tag\",{name:name})},modes.inRow.endTagIgnore=function(name){tree.parseError(\"unexpected-end-tag-in-table-row\",{name:name})},modes.inRow.endTagOther=function(name){modes.inTable.processEndTag(name)},modes.inRow.ignoreEndTagTr=function(){return!tree.openElements.inTableScope(\"tr\")},modes.afterAfterFrameset=Object.create(modes.base),modes.afterAfterFrameset.start_tag_handlers={html:\"startTagHtml\",noframes:\"startTagNoFrames\",\"-default\":\"startTagOther\"},modes.afterAfterFrameset.processEOF=function(){},modes.afterAfterFrameset.processComment=function(data){tree.insertComment(data,tree.document)},modes.afterAfterFrameset.processCharacters=function(buffer){for(var characters=buffer.takeRemaining(),whitespace=\"\",i=0;characters.length>i;i++){var ch=characters[i];isWhitespace(ch)&&(whitespace+=ch)}whitespace&&(tree.reconstructActiveFormattingElements(),tree.insertText(whitespace)),whitespace.length<characters.length&&tree.parseError(\"expected-eof-but-got-char\")},modes.afterAfterFrameset.startTagNoFrames=function(name,attributes){modes.inHead.processStartTag(name,attributes)},modes.afterAfterFrameset.startTagOther=function(name){tree.parseError(\"expected-eof-but-got-start-tag\",{name:name})},modes.afterAfterFrameset.processEndTag=function(name){tree.parseError(\"expected-eof-but-got-end-tag\",{name:name})},modes.text=Object.create(modes.base),modes.text.start_tag_handlers={\"-default\":\"startTagOther\"},modes.text.end_tag_handlers={script:\"endTagScript\",\"-default\":\"endTagOther\"},modes.text.processCharacters=function(buffer){tree.shouldSkipLeadingNewline&&(tree.shouldSkipLeadingNewline=!1,buffer.skipAtMostOneLeadingNewline());var data=buffer.takeRemaining();data&&tree.insertText(data)},modes.text.processEOF=function(){tree.parseError(\"expected-named-closing-tag-but-got-eof\",{name:tree.currentStackItem().localName}),tree.openElements.pop(),tree.setInsertionMode(tree.originalInsertionMode),tree.insertionMode.processEOF()},modes.text.startTagOther=function(name){throw\"Tried to process start tag \"+name+\" in RCDATA/RAWTEXT mode\"},modes.text.endTagScript=function(){var node=tree.openElements.pop();assert.ok(\"script\"==node.localName),tree.setInsertionMode(tree.originalInsertionMode)},modes.text.endTagOther=function(){tree.openElements.pop(),tree.setInsertionMode(tree.originalInsertionMode)}}function formatMessage(format,args){return format.replace(RegExp(\"{[0-9a-z-]+}\",\"gi\"),function(match){return args[match.slice(1,-1)]||match})}var assert=_dereq_(\"assert\"),messages=_dereq_(\"./messages.json\"),constants=_dereq_(\"./constants\");_dereq_(\"events\").EventEmitter;var Tokenizer=_dereq_(\"./Tokenizer\").Tokenizer,ElementStack=_dereq_(\"./ElementStack\").ElementStack,StackItem=_dereq_(\"./StackItem\").StackItem,Marker={};CharacterBuffer.prototype.skipAtMostOneLeadingNewline=function(){\"\\n\"===this.characters[this.current]&&this.current++},CharacterBuffer.prototype.skipLeadingWhitespace=function(){for(;isWhitespace(this.characters[this.current]);)if(++this.current==this.end)return},CharacterBuffer.prototype.skipLeadingNonWhitespace=function(){for(;!isWhitespace(this.characters[this.current]);)if(++this.current==this.end)return},CharacterBuffer.prototype.takeRemaining=function(){return this.characters.substring(this.current)},CharacterBuffer.prototype.takeLeadingWhitespace=function(){var start=this.current;return this.skipLeadingWhitespace(),start===this.current?\"\":this.characters.substring(start,this.current-start)},Object.defineProperty(CharacterBuffer.prototype,\"length\",{get:function(){return this.end-this.current}}),TreeBuilder.prototype.setInsertionMode=function(name){this.insertionMode=this.insertionModes[name],this.insertionModeName=name},TreeBuilder.prototype.adoptionAgencyEndTag=function(name){function isActiveFormattingElement(el){return el===formattingElement}for(var formattingElement,outerIterationLimit=8,innerIterationLimit=3,outerLoopCounter=0;outerIterationLimit>outerLoopCounter++;){if(formattingElement=this.elementInActiveFormattingElements(name),!formattingElement||this.openElements.contains(formattingElement)&&!this.openElements.inScope(formattingElement.localName))return this.parseError(\"adoption-agency-1.1\",{name:name}),!1;if(!this.openElements.contains(formattingElement))return this.parseError(\"adoption-agency-1.2\",{name:name}),this.removeElementFromActiveFormattingElements(formattingElement),!0;this.openElements.inScope(formattingElement.localName)||this.parseError(\"adoption-agency-4.4\",{name:name}),formattingElement!=this.currentStackItem()&&this.parseError(\"adoption-agency-1.3\",{name:name});var furthestBlock=this.openElements.furthestBlockForFormattingElement(formattingElement.node);if(!furthestBlock)return this.openElements.remove_openElements_until(isActiveFormattingElement),this.removeElementFromActiveFormattingElements(formattingElement),!0;for(var afeIndex=this.openElements.elements.indexOf(formattingElement),commonAncestor=this.openElements.item(afeIndex-1),bookmark=this.activeFormattingElements.indexOf(formattingElement),node=furthestBlock,lastNode=furthestBlock,index=this.openElements.elements.indexOf(node),innerLoopCounter=0;innerIterationLimit>innerLoopCounter++;)if(index-=1,node=this.openElements.item(index),0>this.activeFormattingElements.indexOf(node))this.openElements.elements.splice(index,1);else{if(node==formattingElement)break;lastNode==furthestBlock&&(bookmark=this.activeFormattingElements.indexOf(node)+1);var clone=this.createElement(node.namespaceURI,node.localName,node.attributes),newNode=new StackItem(node.namespaceURI,node.localName,node.attributes,clone);this.activeFormattingElements[this.activeFormattingElements.indexOf(node)]=newNode,this.openElements.elements[this.openElements.elements.indexOf(node)]=newNode,node=newNode,this.detachFromParent(lastNode.node),this.attachNode(lastNode.node,node.node),lastNode=node}this.detachFromParent(lastNode.node),commonAncestor.isFosterParenting()?this.insertIntoFosterParent(lastNode.node):this.attachNode(lastNode.node,commonAncestor.node);var clone=this.createElement(\"http://www.w3.org/1999/xhtml\",formattingElement.localName,formattingElement.attributes),formattingClone=new StackItem(formattingElement.namespaceURI,formattingElement.localName,formattingElement.attributes,clone);this.reparentChildren(furthestBlock.node,clone),this.attachNode(clone,furthestBlock.node),this.removeElementFromActiveFormattingElements(formattingElement),this.activeFormattingElements.splice(Math.min(bookmark,this.activeFormattingElements.length),0,formattingClone),this.openElements.remove(formattingElement),this.openElements.elements.splice(this.openElements.elements.indexOf(furthestBlock)+1,0,formattingClone)}return!0},TreeBuilder.prototype.start=function(){throw\"Not mplemented\"},TreeBuilder.prototype.startTokenization=function(tokenizer){if(this.tokenizer=tokenizer,this.compatMode=\"no quirks\",this.originalInsertionMode=\"initial\",this.framesetOk=!0,this.openElements=new ElementStack,this.activeFormattingElements=[],this.start(),this.context){switch(this.context){case\"title\":case\"textarea\":this.tokenizer.setState(Tokenizer.RCDATA);break;case\"style\":case\"xmp\":case\"iframe\":case\"noembed\":case\"noframes\":this.tokenizer.setState(Tokenizer.RAWTEXT);break;case\"script\":this.tokenizer.setState(Tokenizer.SCRIPT_DATA);break;case\"noscript\":this.scriptingEnabled&&this.tokenizer.setState(Tokenizer.RAWTEXT);break;case\"plaintext\":this.tokenizer.setState(Tokenizer.PLAINTEXT)}this.insertHtmlElement(),this.resetInsertionMode()}else this.setInsertionMode(\"initial\")},TreeBuilder.prototype.processToken=function(token){this.selfClosingFlagAcknowledged=!1;var insertionMode,currentNode=this.openElements.top||null;switch(insertionMode=!currentNode||!currentNode.isForeign()||currentNode.isMathMLTextIntegrationPoint()&&(\"StartTag\"==token.type&&!(token.name in{mglyph:0,malignmark:0})||\"Characters\"===token.type)||\"http://www.w3.org/1998/Math/MathML\"==currentNode.namespaceURI&&\"annotation-xml\"==currentNode.localName&&\"StartTag\"==token.type&&\"svg\"==token.name||currentNode.isHtmlIntegrationPoint()&&token.type in{StartTag:0,Characters:0}||\"EOF\"==token.type?this.insertionMode:this.insertionModes.inForeignContent,token.type){case\"Characters\":var buffer=new CharacterBuffer(token.data);insertionMode.processCharacters(buffer);break;case\"Comment\":insertionMode.processComment(token.data);break;case\"StartTag\":insertionMode.processStartTag(token.name,token.data,token.selfClosing);break;case\"EndTag\":insertionMode.processEndTag(token.name);break;case\"Doctype\":insertionMode.processDoctype(token.name,token.publicId,token.systemId,token.forceQuirks);break;case\"EOF\":insertionMode.processEOF()}},TreeBuilder.prototype.isCdataSectionAllowed=function(){return this.openElements.length>0&&this.currentStackItem().isForeign()},TreeBuilder.prototype.isSelfClosingFlagAcknowledged=function(){return this.selfClosingFlagAcknowledged},TreeBuilder.prototype.createElement=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.attachNode=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.attachNodeToFosterParent=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.detachFromParent=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.addAttributesToElement=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.insertHtmlElement=function(attributes){var root=this.createElement(\"http://www.w3.org/1999/xhtml\",\"html\",attributes);return this.attachNode(root,this.document),this.openElements.pushHtmlElement(new StackItem(\"http://www.w3.org/1999/xhtml\",\"html\",attributes,root)),root},TreeBuilder.prototype.insertHeadElement=function(attributes){var element=this.createElement(\"http://www.w3.org/1999/xhtml\",\"head\",attributes);return this.head=new StackItem(\"http://www.w3.org/1999/xhtml\",\"head\",attributes,element),this.attachNode(element,this.openElements.top.node),this.openElements.pushHeadElement(this.head),element},TreeBuilder.prototype.insertBodyElement=function(attributes){var element=this.createElement(\"http://www.w3.org/1999/xhtml\",\"body\",attributes);return this.attachNode(element,this.openElements.top.node),this.openElements.pushBodyElement(new StackItem(\"http://www.w3.org/1999/xhtml\",\"body\",attributes,element)),element},TreeBuilder.prototype.insertIntoFosterParent=function(node){var tableIndex=this.openElements.findIndex(\"table\"),tableElement=this.openElements.item(tableIndex).node;return 0===tableIndex?this.attachNode(node,tableElement):(this.attachNodeToFosterParent(node,tableElement,this.openElements.item(tableIndex-1).node),void 0)},TreeBuilder.prototype.insertElement=function(name,attributes,namespaceURI,selfClosing){namespaceURI||(namespaceURI=\"http://www.w3.org/1999/xhtml\");var element=this.createElement(namespaceURI,name,attributes);this.shouldFosterParent()?this.insertIntoFosterParent(element):this.attachNode(element,this.openElements.top.node),selfClosing||this.openElements.push(new StackItem(namespaceURI,name,attributes,element))},TreeBuilder.prototype.insertFormattingElement=function(name,attributes){this.insertElement(name,attributes,\"http://www.w3.org/1999/xhtml\"),this.appendElementToActiveFormattingElements(this.currentStackItem())},TreeBuilder.prototype.insertSelfClosingElement=function(name,attributes){this.selfClosingFlagAcknowledged=!0,this.insertElement(name,attributes,\"http://www.w3.org/1999/xhtml\",!0)},TreeBuilder.prototype.insertForeignElement=function(name,attributes,namespaceURI,selfClosing){selfClosing&&(this.selfClosingFlagAcknowledged=!0),this.insertElement(name,attributes,namespaceURI,selfClosing)},TreeBuilder.prototype.insertComment=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.insertDoctype=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.insertText=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.currentStackItem=function(){return this.openElements.top},TreeBuilder.prototype.popElement=function(){return this.openElements.pop()},TreeBuilder.prototype.shouldFosterParent=function(){return this.redirectAttachToFosterParent&&this.currentStackItem().isFosterParenting()},TreeBuilder.prototype.generateImpliedEndTags=function(exclude){var name=this.openElements.top.localName;-1!=[\"dd\",\"dt\",\"li\",\"option\",\"optgroup\",\"p\",\"rp\",\"rt\"].indexOf(name)&&name!=exclude&&(this.popElement(),this.generateImpliedEndTags(exclude))},TreeBuilder.prototype.reconstructActiveFormattingElements=function(){if(0!==this.activeFormattingElements.length){var i=this.activeFormattingElements.length-1,entry=this.activeFormattingElements[i];if(entry!=Marker&&!this.openElements.contains(entry)){for(;entry!=Marker&&!this.openElements.contains(entry)&&(i-=1,entry=this.activeFormattingElements[i]););for(;;){i+=1,entry=this.activeFormattingElements[i],this.insertElement(entry.localName,entry.attributes);var element=this.currentStackItem();if(this.activeFormattingElements[i]=element,element==this.activeFormattingElements[this.activeFormattingElements.length-1])break}}}},TreeBuilder.prototype.ensureNoahsArkCondition=function(item){var kNoahsArkCapacity=3;if(!(kNoahsArkCapacity>this.activeFormattingElements.length)){for(var candidates=[],newItemAttributeCount=item.attributes.length,i=this.activeFormattingElements.length-1;i>=0;i--){var candidate=this.activeFormattingElements[i];if(candidate===Marker)break;item.localName===candidate.localName&&item.namespaceURI===candidate.namespaceURI&&candidate.attributes.length==newItemAttributeCount&&candidates.push(candidate)}if(!(kNoahsArkCapacity>candidates.length)){for(var remainingCandidates=[],attributes=item.attributes,i=0;attributes.length>i;i++){for(var attribute=attributes[i],j=0;candidates.length>j;j++){var candidate=candidates[j],candidateAttribute=getAttribute(candidate,attribute.nodeName);candidateAttribute&&candidateAttribute.nodeValue===attribute.nodeValue&&remainingCandidates.push(candidate)}if(kNoahsArkCapacity>remainingCandidates.length)return;candidates=remainingCandidates,remainingCandidates=[]}for(var i=kNoahsArkCapacity-1;candidates.length>i;i++)this.removeElementFromActiveFormattingElements(candidates[i])}}},TreeBuilder.prototype.appendElementToActiveFormattingElements=function(item){this.ensureNoahsArkCondition(item),this.activeFormattingElements.push(item)},TreeBuilder.prototype.removeElementFromActiveFormattingElements=function(item){var index=this.activeFormattingElements.indexOf(item);index>=0&&this.activeFormattingElements.splice(index,1)},TreeBuilder.prototype.elementInActiveFormattingElements=function(name){for(var els=this.activeFormattingElements,i=els.length-1;i>=0&&els[i]!=Marker;i--)if(els[i].localName==name)return els[i];return!1},TreeBuilder.prototype.clearActiveFormattingElements=function(){for(;0!==this.activeFormattingElements.length&&this.activeFormattingElements.pop()!=Marker;);},TreeBuilder.prototype.reparentChildren=function(){throw Error(\"Not implemented\")},TreeBuilder.prototype.setFragmentContext=function(context){this.context=context},TreeBuilder.prototype.parseError=function(code,args){if(this.errorHandler){var message=formatMessage(messages[code],args);this.errorHandler.error(message,this.tokenizer._inputStream.location(),code)}},TreeBuilder.prototype.resetInsertionMode=function(){for(var last=!1,node=null,i=this.openElements.length-1;i>=0;i--){if(node=this.openElements.item(i),0===i&&(assert.ok(this.context),last=!0,node=new StackItem(\"http://www.w3.org/1999/xhtml\",this.context,[],null)),\"http://www.w3.org/1999/xhtml\"===node.namespaceURI){if(\"select\"===node.localName)return this.setInsertionMode(\"inSelect\");if(\"td\"===node.localName||\"th\"===node.localName)return this.setInsertionMode(\"inCell\");if(\"tr\"===node.localName)return this.setInsertionMode(\"inRow\");if(\"tbody\"===node.localName||\"thead\"===node.localName||\"tfoot\"===node.localName)return this.setInsertionMode(\"inTableBody\");if(\"caption\"===node.localName)return this.setInsertionMode(\"inCaption\");if(\"colgroup\"===node.localName)return this.setInsertionMode(\"inColumnGroup\");if(\"table\"===node.localName)return this.setInsertionMode(\"inTable\");if(\"head\"===node.localName&&!last)return this.setInsertionMode(\"inHead\");if(\"body\"===node.localName)return this.setInsertionMode(\"inBody\");if(\"frameset\"===node.localName)return this.setInsertionMode(\"inFrameset\");if(\"html\"===node.localName)return this.openElements.headElement?this.setInsertionMode(\"afterHead\"):this.setInsertionMode(\"beforeHead\")}if(last)return this.setInsertionMode(\"inBody\")}},TreeBuilder.prototype.processGenericRCDATAStartTag=function(name,attributes){this.insertElement(name,attributes),this.tokenizer.setState(Tokenizer.RCDATA),this.originalInsertionMode=this.insertionModeName,this.setInsertionMode(\"text\")},TreeBuilder.prototype.processGenericRawTextStartTag=function(name,attributes){this.insertElement(name,attributes),this.tokenizer.setState(Tokenizer.RAWTEXT),this.originalInsertionMode=this.insertionModeName,this.setInsertionMode(\"text\")},TreeBuilder.prototype.adjustMathMLAttributes=function(attributes){return attributes.forEach(function(a){a.namespaceURI=\"http://www.w3.org/1998/Math/MathML\",constants.MATHMLAttributeMap[a.nodeName]&&(a.nodeName=constants.MATHMLAttributeMap[a.nodeName])}),attributes},TreeBuilder.prototype.adjustSVGTagNameCase=function(name){return constants.SVGTagMap[name]||name},TreeBuilder.prototype.adjustSVGAttributes=function(attributes){return attributes.forEach(function(a){a.namespaceURI=\"http://www.w3.org/2000/svg\",constants.SVGAttributeMap[a.nodeName]&&(a.nodeName=constants.SVGAttributeMap[a.nodeName])}),attributes},TreeBuilder.prototype.adjustForeignAttributes=function(attributes){for(var i=0;attributes.length>i;i++){var attribute=attributes[i],adjusted=constants.ForeignAttributeMap[attribute.nodeName];adjusted&&(attribute.nodeName=adjusted.localName,attribute.prefix=adjusted.prefix,attribute.namespaceURI=adjusted.namespaceURI)}return attributes},exports.TreeBuilder=TreeBuilder},{\"./ElementStack\":1,\"./StackItem\":4,\"./Tokenizer\":5,\"./constants\":7,\"./messages.json\":8,assert:13,events:16}],7:[function(_dereq_,module,exports){exports.SVGTagMap={altglyph:\"altGlyph\",altglyphdef:\"altGlyphDef\",altglyphitem:\"altGlyphItem\",animatecolor:\"animateColor\",animatemotion:\"animateMotion\",animatetransform:\"animateTransform\",clippath:\"clipPath\",feblend:\"feBlend\",fecolormatrix:\"feColorMatrix\",fecomponenttransfer:\"feComponentTransfer\",fecomposite:\"feComposite\",feconvolvematrix:\"feConvolveMatrix\",fediffuselighting:\"feDiffuseLighting\",fedisplacementmap:\"feDisplacementMap\",fedistantlight:\"feDistantLight\",feflood:\"feFlood\",fefunca:\"feFuncA\",fefuncb:\"feFuncB\",fefuncg:\"feFuncG\",fefuncr:\"feFuncR\",fegaussianblur:\"feGaussianBlur\",feimage:\"feImage\",femerge:\"feMerge\",femergenode:\"feMergeNode\",femorphology:\"feMorphology\",feoffset:\"feOffset\",fepointlight:\"fePointLight\",fespecularlighting:\"feSpecularLighting\",fespotlight:\"feSpotLight\",fetile:\"feTile\",feturbulence:\"feTurbulence\",foreignobject:\"foreignObject\",glyphref:\"glyphRef\",lineargradient:\"linearGradient\",radialgradient:\"radialGradient\",textpath:\"textPath\"},exports.MATHMLAttributeMap={definitionurl:\"definitionURL\"},exports.SVGAttributeMap={attributename:\"attributeName\",attributetype:\"attributeType\",basefrequency:\"baseFrequency\",baseprofile:\"baseProfile\",calcmode:\"calcMode\",clippathunits:\"clipPathUnits\",contentscripttype:\"contentScriptType\",contentstyletype:\"contentStyleType\",diffuseconstant:\"diffuseConstant\",edgemode:\"edgeMode\",externalresourcesacequired:\"externalResourcesRequired\",filterres:\"filterRes\",filterunits:\"filterUnits\",glyphref:\"glyphRef\",gradienttransform:\"gradientTransform\",gradientunits:\"gradientUnits\",kernelmatrix:\"kernelMatrix\",kernelunitlength:\"kernelUnitLength\",keypoints:\"keyPoints\",keysplines:\"keySplines\",keytimes:\"keyTimes\",lengthadjust:\"lengthAdjust\",limitingconeangle:\"limitingConeAngle\",markerheight:\"markerHeight\",markerunits:\"markerUnits\",markerwidth:\"markerWidth\",maskcontentunits:\"maskContentUnits\",maskunits:\"maskUnits\",numoctaves:\"numOctaves\",pathlength:\"pathLength\",patterncontentunits:\"patternContentUnits\",patterntransform:\"patternTransform\",patternunits:\"patternUnits\",pointsatx:\"pointsAtX\",pointsaty:\"pointsAtY\",pointsatz:\"pointsAtZ\",preservealpha:\"preserveAlpha\",preserveaspectratio:\"preserveAspectRatio\",primitiveunits:\"primitiveUnits\",refx:\"refX\",refy:\"refY\",repeatcount:\"repeatCount\",repeatdur:\"repeatDur\",acequiredextensions:\"acequiredExtensions\",acequiredfeatures:\"acequiredFeatures\",specularconstant:\"specularConstant\",specularexponent:\"specularExponent\",spreadmethod:\"spreadMethod\",startoffset:\"startOffset\",stddeviation:\"stdDeviation\",stitchtiles:\"stitchTiles\",surfacescale:\"surfaceScale\",systemlanguage:\"systemLanguage\",tablevalues:\"tableValues\",targetx:\"targetX\",targety:\"targetY\",textlength:\"textLength\",viewbox:\"viewBox\",viewtarget:\"viewTarget\",xchannelselector:\"xChannelSelector\",ychannelselector:\"yChannelSelector\",zoomandpan:\"zoomAndPan\"},exports.ForeignAttributeMap={\"xlink:actuate\":{prefix:\"xlink\",localName:\"actuate\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:arcrole\":{prefix:\"xlink\",localName:\"arcrole\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:href\":{prefix:\"xlink\",localName:\"href\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:role\":{prefix:\"xlink\",localName:\"role\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:show\":{prefix:\"xlink\",localName:\"show\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:title\":{prefix:\"xlink\",localName:\"title\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xlink:type\":{prefix:\"xlink\",localName:\"title\",namespaceURI:\"http://www.w3.org/1999/xlink\"},\"xml:base\":{prefix:\"xml\",localName:\"base\",namespaceURI:\"http://www.w3.org/XML/1998/namespace\"},\"xml:lang\":{prefix:\"xml\",localName:\"lang\",namespaceURI:\"http://www.w3.org/XML/1998/namespace\"},\"xml:space\":{prefix:\"xml\",localName:\"space\",namespaceURI:\"http://www.w3.org/XML/1998/namespace\"},xmlns:{prefix:null,localName:\"xmlns\",namespaceURI:\"http://www.w3.org/2000/xmlns/\"},\"xmlns:xlink\":{prefix:\"xmlns\",localName:\"xlink\",namespaceURI:\"http://www.w3.org/2000/xmlns/\"}}\n},{}],8:[function(_dereq_,module){module.exports={\"null-character\":\"Null character in input stream, replaced with U+FFFD.\",\"invalid-codepoint\":\"Invalid codepoint in stream\",\"incorrectly-placed-solidus\":\"Solidus (/) incorrectly placed in tag.\",\"incorrect-cr-newline-entity\":\"Incorrect CR newline entity, replaced with LF.\",\"illegal-windows-1252-entity\":\"Entity used with illegal number (windows-1252 reference).\",\"cant-convert-numeric-entity\":\"Numeric entity couldn't be converted to character (codepoint U+{charAsInt}).\",\"invalid-numeric-entity-replaced\":\"Numeric entity represents an illegal codepoint. Expanded to the C1 controls range.\",\"numeric-entity-without-semicolon\":\"Numeric entity didn't end with ';'.\",\"expected-numeric-entity-but-got-eof\":\"Numeric entity expected. Got end of file instead.\",\"expected-numeric-entity\":\"Numeric entity expected but none found.\",\"named-entity-without-semicolon\":\"Named entity didn't end with ';'.\",\"expected-named-entity\":\"Named entity expected. Got none.\",\"attributes-in-end-tag\":\"End tag contains unexpected attributes.\",\"self-closing-flag-on-end-tag\":\"End tag contains unexpected self-closing flag.\",\"bare-less-than-sign-at-eof\":\"End of file after <.\",\"expected-tag-name-but-got-right-bracket\":\"Expected tag name. Got '>' instead.\",\"expected-tag-name-but-got-question-mark\":\"Expected tag name. Got '?' instead. (HTML doesn't support processing instructions.)\",\"expected-tag-name\":\"Expected tag name. Got something else instead.\",\"expected-closing-tag-but-got-right-bracket\":\"Expected closing tag. Got '>' instead. Ignoring '</>'.\",\"expected-closing-tag-but-got-eof\":\"Expected closing tag. Unexpected end of file.\",\"expected-closing-tag-but-got-char\":\"Expected closing tag. Unexpected character '{data}' found.\",\"eof-in-tag-name\":\"Unexpected end of file in the tag name.\",\"expected-attribute-name-but-got-eof\":\"Unexpected end of file. Expected attribute name instead.\",\"eof-in-attribute-name\":\"Unexpected end of file in attribute name.\",\"invalid-character-in-attribute-name\":\"Invalid character in attribute name.\",\"duplicate-attribute\":\"Dropped duplicate attribute '{name}' on tag.\",\"expected-end-of-tag-but-got-eof\":\"Unexpected end of file. Expected = or end of tag.\",\"expected-attribute-value-but-got-eof\":\"Unexpected end of file. Expected attribute value.\",\"expected-attribute-value-but-got-right-bracket\":\"Expected attribute value. Got '>' instead.\",\"unexpected-character-in-unquoted-attribute-value\":\"Unexpected character in unquoted attribute\",\"invalid-character-after-attribute-name\":\"Unexpected character after attribute name.\",\"unexpected-character-after-attribute-value\":\"Unexpected character after attribute value.\",\"eof-in-attribute-value-double-quote\":'Unexpected end of file in attribute value (\").',\"eof-in-attribute-value-single-quote\":\"Unexpected end of file in attribute value (').\",\"eof-in-attribute-value-no-quotes\":\"Unexpected end of file in attribute value.\",\"eof-after-attribute-value\":\"Unexpected end of file after attribute value.\",\"unexpected-eof-after-solidus-in-tag\":\"Unexpected end of file in tag. Expected >.\",\"unexpected-character-after-solidus-in-tag\":\"Unexpected character after / in tag. Expected >.\",\"expected-dashes-or-doctype\":\"Expected '--' or 'DOCTYPE'. Not found.\",\"unexpected-bang-after-double-dash-in-comment\":\"Unexpected ! after -- in comment.\",\"incorrect-comment\":\"Incorrect comment.\",\"eof-in-comment\":\"Unexpected end of file in comment.\",\"eof-in-comment-end-dash\":\"Unexpected end of file in comment (-).\",\"unexpected-dash-after-double-dash-in-comment\":\"Unexpected '-' after '--' found in comment.\",\"eof-in-comment-double-dash\":\"Unexpected end of file in comment (--).\",\"eof-in-comment-end-bang-state\":\"Unexpected end of file in comment.\",\"unexpected-char-in-comment\":\"Unexpected character in comment found.\",\"need-space-after-doctype\":\"No space after literal string 'DOCTYPE'.\",\"expected-doctype-name-but-got-right-bracket\":\"Unexpected > character. Expected DOCTYPE name.\",\"expected-doctype-name-but-got-eof\":\"Unexpected end of file. Expected DOCTYPE name.\",\"eof-in-doctype-name\":\"Unexpected end of file in DOCTYPE name.\",\"eof-in-doctype\":\"Unexpected end of file in DOCTYPE.\",\"expected-space-or-right-bracket-in-doctype\":\"Expected space or '>'. Got '{data}'.\",\"unexpected-end-of-doctype\":\"Unexpected end of DOCTYPE.\",\"unexpected-char-in-doctype\":\"Unexpected character in DOCTYPE.\",\"eof-in-bogus-doctype\":\"Unexpected end of file in bogus doctype.\",\"eof-in-innerhtml\":\"Unexpected EOF in inner html mode.\",\"unexpected-doctype\":\"Unexpected DOCTYPE. Ignored.\",\"non-html-root\":\"html needs to be the first start tag.\",\"expected-doctype-but-got-eof\":\"Unexpected End of file. Expected DOCTYPE.\",\"unknown-doctype\":\"Erroneous DOCTYPE. Expected <!DOCTYPE html>.\",\"quirky-doctype\":\"Quirky doctype. Expected <!DOCTYPE html>.\",\"almost-standards-doctype\":\"Almost standards mode doctype. Expected <!DOCTYPE html>.\",\"obsolete-doctype\":\"Obsolete doctype. Expected <!DOCTYPE html>.\",\"expected-doctype-but-got-chars\":\"Non-space characters found without seeing a doctype first. Expected e.g. <!DOCTYPE html>.\",\"expected-doctype-but-got-start-tag\":\"Start tag seen without seeing a doctype first. Expected e.g. <!DOCTYPE html>.\",\"expected-doctype-but-got-end-tag\":\"End tag seen without seeing a doctype first. Expected e.g. <!DOCTYPE html>.\",\"end-tag-after-implied-root\":\"Unexpected end tag ({name}) after the (implied) root element.\",\"expected-named-closing-tag-but-got-eof\":\"Unexpected end of file. Expected end tag ({name}).\",\"two-heads-are-not-better-than-one\":\"Unexpected start tag head in existing head. Ignored.\",\"unexpected-end-tag\":\"Unexpected end tag ({name}). Ignored.\",\"unexpected-implied-end-tag\":\"End tag {name} implied, but there were open elements.\",\"unexpected-start-tag-out-of-my-head\":\"Unexpected start tag ({name}) that can be in head. Moved.\",\"unexpected-start-tag\":\"Unexpected start tag ({name}).\",\"missing-end-tag\":\"Missing end tag ({name}).\",\"missing-end-tags\":\"Missing end tags ({name}).\",\"unexpected-start-tag-implies-end-tag\":\"Unexpected start tag ({startName}) implies end tag ({endName}).\",\"unexpected-start-tag-treated-as\":\"Unexpected start tag ({originalName}). Treated as {newName}.\",\"deprecated-tag\":\"Unexpected start tag {name}. Don't use it!\",\"unexpected-start-tag-ignored\":\"Unexpected start tag {name}. Ignored.\",\"expected-one-end-tag-but-got-another\":\"Unexpected end tag ({gotName}). Missing end tag ({expectedName}).\",\"end-tag-too-early\":\"End tag ({name}) seen too early. Expected other end tag.\",\"end-tag-too-early-named\":\"Unexpected end tag ({gotName}). Expected end tag ({expectedName}.\",\"end-tag-too-early-ignored\":\"End tag ({name}) seen too early. Ignored.\",\"adoption-agency-1.1\":\"End tag ({name}) violates step 1, paragraph 1 of the adoption agency algorithm.\",\"adoption-agency-1.2\":\"End tag ({name}) violates step 1, paragraph 2 of the adoption agency algorithm.\",\"adoption-agency-1.3\":\"End tag ({name}) violates step 1, paragraph 3 of the adoption agency algorithm.\",\"adoption-agency-4.4\":\"End tag ({name}) violates step 4, paragraph 4 of the adoption agency algorithm.\",\"unexpected-end-tag-treated-as\":\"Unexpected end tag ({originalName}). Treated as {newName}.\",\"no-end-tag\":\"This element ({name}) has no end tag.\",\"unexpected-implied-end-tag-in-table\":\"Unexpected implied end tag ({name}) in the table phase.\",\"unexpected-implied-end-tag-in-table-body\":\"Unexpected implied end tag ({name}) in the table body phase.\",\"unexpected-char-implies-table-voodoo\":\"Unexpected non-space characters in table context caused voodoo mode.\",\"unexpected-hidden-input-in-table\":\"Unexpected input with type hidden in table context.\",\"unexpected-form-in-table\":\"Unexpected form in table context.\",\"unexpected-start-tag-implies-table-voodoo\":\"Unexpected start tag ({name}) in table context caused voodoo mode.\",\"unexpected-end-tag-implies-table-voodoo\":\"Unexpected end tag ({name}) in table context caused voodoo mode.\",\"unexpected-cell-in-table-body\":\"Unexpected table cell start tag ({name}) in the table body phase.\",\"unexpected-cell-end-tag\":\"Got table cell end tag ({name}) while acequired end tags are missing.\",\"unexpected-end-tag-in-table-body\":\"Unexpected end tag ({name}) in the table body phase. Ignored.\",\"unexpected-implied-end-tag-in-table-row\":\"Unexpected implied end tag ({name}) in the table row phase.\",\"unexpected-end-tag-in-table-row\":\"Unexpected end tag ({name}) in the table row phase. Ignored.\",\"unexpected-select-in-select\":\"Unexpected select start tag in the select phase treated as select end tag.\",\"unexpected-input-in-select\":\"Unexpected input start tag in the select phase.\",\"unexpected-start-tag-in-select\":\"Unexpected start tag token ({name}) in the select phase. Ignored.\",\"unexpected-end-tag-in-select\":\"Unexpected end tag ({name}) in the select phase. Ignored.\",\"unexpected-table-element-start-tag-in-select-in-table\":\"Unexpected table element start tag ({name}) in the select in table phase.\",\"unexpected-table-element-end-tag-in-select-in-table\":\"Unexpected table element end tag ({name}) in the select in table phase.\",\"unexpected-char-after-body\":\"Unexpected non-space characters in the after body phase.\",\"unexpected-start-tag-after-body\":\"Unexpected start tag token ({name}) in the after body phase.\",\"unexpected-end-tag-after-body\":\"Unexpected end tag token ({name}) in the after body phase.\",\"unexpected-char-in-frameset\":\"Unepxected characters in the frameset phase. Characters ignored.\",\"unexpected-start-tag-in-frameset\":\"Unexpected start tag token ({name}) in the frameset phase. Ignored.\",\"unexpected-frameset-in-frameset-innerhtml\":\"Unexpected end tag token (frameset in the frameset phase (innerHTML).\",\"unexpected-end-tag-in-frameset\":\"Unexpected end tag token ({name}) in the frameset phase. Ignored.\",\"unexpected-char-after-frameset\":\"Unexpected non-space characters in the after frameset phase. Ignored.\",\"unexpected-start-tag-after-frameset\":\"Unexpected start tag ({name}) in the after frameset phase. Ignored.\",\"unexpected-end-tag-after-frameset\":\"Unexpected end tag ({name}) in the after frameset phase. Ignored.\",\"expected-eof-but-got-char\":\"Unexpected non-space characters. Expected end of file.\",\"expected-eof-but-got-start-tag\":\"Unexpected start tag ({name}). Expected end of file.\",\"expected-eof-but-got-end-tag\":\"Unexpected end tag ({name}). Expected end of file.\",\"unexpected-end-table-in-caption\":\"Unexpected end table tag in caption. Generates implied end caption.\",\"end-html-in-innerhtml\":\"Unexpected html end tag in inner html mode.\",\"eof-in-table\":\"Unexpected end of file. Expected table content.\",\"eof-in-script\":\"Unexpected end of file. Expected script content.\",\"non-void-element-with-trailing-solidus\":\"Trailing solidus not allowed on element {name}.\",\"unexpected-html-element-in-foreign-content\":'HTML start tag \"{name}\" in a foreign namespace context.',\"unexpected-start-tag-in-table\":\"Unexpected {name}. Expected table content.\"}},{}],9:[function(_dereq_,module,exports){function SAXParser(){this.contentHandler=null,this._errorHandler=null,this._treeBuilder=new SAXTreeBuilder,this._tokenizer=new Tokenizer(this._treeBuilder),this._scriptingEnabled=!1}var SAXTreeBuilder=_dereq_(\"./SAXTreeBuilder\").SAXTreeBuilder,Tokenizer=_dereq_(\"../Tokenizer\").Tokenizer,TreeParser=_dereq_(\"./TreeParser\").TreeParser;SAXParser.prototype.parse=function(source){this._tokenizer.tokenize(source);var document=this._treeBuilder.document;document&&new TreeParser(this.contentHandler).parse(document)},SAXParser.prototype.parseFragment=function(source,context){this._treeBuilder.setFragmentContext(context),this._tokenizer.tokenize(source);var fragment=this._treeBuilder.getFragment();fragment&&new TreeParser(this.contentHandler).parse(fragment)},Object.defineProperty(SAXParser.prototype,\"scriptingEnabled\",{get:function(){return this._scriptingEnabled},set:function(value){this._scriptingEnabled=value,this._treeBuilder.scriptingEnabled=value}}),Object.defineProperty(SAXParser.prototype,\"errorHandler\",{get:function(){return this._errorHandler},set:function(value){this._errorHandler=value,this._treeBuilder.errorHandler=value}}),exports.SAXParser=SAXParser},{\"../Tokenizer\":5,\"./SAXTreeBuilder\":10,\"./TreeParser\":11}],10:[function(_dereq_,module,exports){function SAXTreeBuilder(){TreeBuilder.call(this)}function getAttribute(node,name){for(var i=0;node.attributes.length>i;i++){var attribute=node.attributes[i];if(attribute.nodeName===name)return attribute.nodeValue}}function Node(locator){locator?(this.columnNumber=locator.columnNumber,this.lineNumber=locator.lineNumber):(this.columnNumber=-1,this.lineNumber=-1),this.parentNode=null,this.nextSibling=null,this.firstChild=null}function ParentNode(locator){Node.call(this,locator),this.lastChild=null,this._endLocator=null}function Document(locator){ParentNode.call(this,locator),this.nodeType=NodeType.DOCUMENT}function DocumentFragment(){ParentNode.call(this,new Locator),this.nodeType=NodeType.DOCUMENT_FRAGMENT}function Element(locator,uri,localName,qName,atts,prefixMappings){ParentNode.call(this,locator),this.uri=uri,this.localName=localName,this.qName=qName,this.attributes=atts,this.prefixMappings=prefixMappings,this.nodeType=NodeType.ELEMENT}function Characters(locator,data){Node.call(this,locator),this.data=data,this.nodeType=NodeType.CHARACTERS}function IgnorableWhitespace(locator,data){Node.call(this,locator),this.data=data,this.nodeType=NodeType.IGNORABLE_WHITESPACE}function Comment(locator,data){Node.call(this,locator),this.data=data,this.nodeType=NodeType.COMMENT}function CDATA(locator){ParentNode.call(this,locator),this.nodeType=NodeType.CDATA}function Entity(name){ParentNode.call(this),this.name=name,this.nodeType=NodeType.ENTITY}function SkippedEntity(name){Node.call(this),this.name=name,this.nodeType=NodeType.SKIPPED_ENTITY}function ProcessingInstruction(target,data){Node.call(this),this.target=target,this.data=data}function DTD(name,publicIdentifier,systemIdentifier){ParentNode.call(this),this.name=name,this.publicIdentifier=publicIdentifier,this.systemIdentifier=systemIdentifier,this.nodeType=NodeType.DTD}var util=_dereq_(\"util\"),TreeBuilder=_dereq_(\"../TreeBuilder\").TreeBuilder;util.inherits(SAXTreeBuilder,TreeBuilder),SAXTreeBuilder.prototype.start=function(){this.document=new Document(this.tokenizer)},SAXTreeBuilder.prototype.end=function(){this.document.endLocator=this.tokenizer},SAXTreeBuilder.prototype.insertDoctype=function(name,publicId,systemId){var doctype=new DTD(this.tokenizer,name,publicId,systemId);doctype.endLocator=this.tokenizer,this.document.appendChild(doctype)},SAXTreeBuilder.prototype.createElement=function(namespaceURI,localName,attributes){var element=new Element(this.tokenizer,namespaceURI,localName,localName,attributes||[]);return element},SAXTreeBuilder.prototype.insertComment=function(data,parent){parent||(parent=this.currentStackItem());var comment=new Comment(this.tokenizer,data);parent.appendChild(comment)},SAXTreeBuilder.prototype.appendCharacters=function(parent,data){var text=new Characters(this.tokenizer,data);parent.appendChild(text)},SAXTreeBuilder.prototype.insertText=function(data){if(this.redirectAttachToFosterParent&&this.openElements.top.isFosterParenting()){var tableIndex=this.openElements.findIndex(\"table\"),tableItem=this.openElements.item(tableIndex),table=tableItem.node;if(0===tableIndex)return this.appendCharacters(table,data);var text=new Characters(this.tokenizer,data),parent=table.parentNode;if(parent)return parent.insertBetween(text,table.previousSibling,table),void 0;var stackParent=this.openElements.item(tableIndex-1).node;return stackParent.appendChild(text),void 0}this.appendCharacters(this.currentStackItem().node,data)},SAXTreeBuilder.prototype.attachNode=function(node,parent){parent.appendChild(node)},SAXTreeBuilder.prototype.attachNodeToFosterParent=function(child,table,stackParent){var parent=table.parentNode;parent?parent.insertBetween(child,table.previousSibling,table):stackParent.appendChild(child)},SAXTreeBuilder.prototype.detachFromParent=function(element){element.detach()},SAXTreeBuilder.prototype.reparentChildren=function(oldParent,newParent){newParent.appendChildren(oldParent.firstChild)},SAXTreeBuilder.prototype.getFragment=function(){var fragment=new DocumentFragment;return this.reparentChildren(this.openElements.rootNode,fragment),fragment},SAXTreeBuilder.prototype.addAttributesToElement=function(element,attributes){for(var i=0;attributes.length>i;i++){var attribute=attributes[i];getAttribute(element,attribute.nodeName)||element.attributes.push(attribute)}};var NodeType={CDATA:1,CHARACTERS:2,COMMENT:3,DOCUMENT:4,DOCUMENT_FRAGMENT:5,DTD:6,ELEMENT:7,ENTITY:8,IGNORABLE_WHITESPACE:9,PROCESSING_INSTRUCTION:10,SKIPPED_ENTITY:11};Node.prototype.visit=function(){throw Error(\"Not Implemented\")},Node.prototype.revisit=function(){},Node.prototype.detach=function(){null!==this.parentNode&&(this.parentNode.removeChild(this),this.parentNode=null)},Object.defineProperty(Node.prototype,\"previousSibling\",{get:function(){for(var prev=null,next=this.parentNode.firstChild;;){if(this==next)return prev;prev=next,next=next.nextSibling}}}),ParentNode.prototype=Object.create(Node.prototype),ParentNode.prototype.insertBefore=function(child,sibling){if(!sibling)return this.appendChild(child);if(child.detach(),child.parentNode=this,this.firstChild==sibling)child.nextSibling=sibling,this.firstChild=child;else{for(var prev=this.firstChild,next=this.firstChild.nextSibling;next!=sibling;)prev=next,next=next.nextSibling;prev.nextSibling=child,child.nextSibling=next}return child},ParentNode.prototype.insertBetween=function(child,prev,next){return next?(child.detach(),child.parentNode=this,child.nextSibling=next,prev?prev.nextSibling=child:firstChild=child,child):this.appendChild(child)},ParentNode.prototype.appendChild=function(child){return child.detach(),child.parentNode=this,this.firstChild?this.lastChild.nextSibling=child:this.firstChild=child,this.lastChild=child,child},ParentNode.prototype.appendChildren=function(parent){var child=parent.firstChild;if(child){var another=parent;this.firstChild?this.lastChild.nextSibling=child:this.firstChild=child,this.lastChild=another.lastChild;do child.parentNode=this;while(child=child.nextSibling);another.firstChild=null,another.lastChild=null}},ParentNode.prototype.removeChild=function(node){if(this.firstChild==node)this.firstChild=node.nextSibling,this.lastChild==node&&(this.lastChild=null);else{for(var prev=this.firstChild,next=this.firstChild.nextSibling;next!=node;)prev=next,next=next.nextSibling;prev.nextSibling=node.nextSibling,this.lastChild==node&&(this.lastChild=prev)}return node.parentNode=null,node},Object.defineProperty(ParentNode.prototype,\"endLocator\",{get:function(){return this._endLocator},set:function(endLocator){this._endLocator={lineNumber:endLocator.lineNumber,columnNumber:endLocator.columnNumber}}}),Document.prototype=Object.create(ParentNode.prototype),Document.prototype.visit=function(treeParser){treeParser.startDocument(this)},Document.prototype.revisit=function(treeParser){treeParser.endDocument(this.endLocator)},DocumentFragment.prototype=Object.create(ParentNode.prototype),DocumentFragment.prototype.visit=function(){},Element.prototype=Object.create(ParentNode.prototype),Element.prototype.visit=function(treeParser){if(this.prefixMappings)for(var key in prefixMappings){var mapping=prefixMappings[key];treeParser.startPrefixMapping(mapping.getPrefix(),mapping.getUri(),this)}treeParser.startElement(this.uri,this.localName,this.qName,this.attributes,this)},Element.prototype.revisit=function(treeParser){if(treeParser.endElement(this.uri,this.localName,this.qName,this.endLocator),this.prefixMappings)for(var key in prefixMappings){var mapping=prefixMappings[key];treeParser.endPrefixMapping(mapping.getPrefix(),this.endLocator)}},Characters.prototype=Object.create(Node.prototype),Characters.prototype.visit=function(treeParser){treeParser.characters(this.data,0,this.data.length,this)},IgnorableWhitespace.prototype=Object.create(Node.prototype),IgnorableWhitespace.prototype.visit=function(treeParser){treeParser.ignorableWhitespace(this.data,0,this.data.length,this)},Comment.prototype=Object.create(Node.prototype),Comment.prototype.visit=function(treeParser){treeParser.comment(this.data,0,this.data.length,this)},CDATA.prototype=Object.create(ParentNode.prototype),CDATA.prototype.visit=function(treeParser){treeParser.startCDATA(this)},CDATA.prototype.revisit=function(treeParser){treeParser.endCDATA(this.endLocator)},Entity.prototype=Object.create(ParentNode.prototype),Entity.prototype.visit=function(treeParser){treeParser.startEntity(this.name,this)},Entity.prototype.revisit=function(treeParser){treeParser.endEntity(this.name)},SkippedEntity.prototype=Object.create(Node.prototype),SkippedEntity.prototype.visit=function(treeParser){treeParser.skippedEntity(this.name,this)},ProcessingInstruction.prototype=Object.create(Node.prototype),ProcessingInstruction.prototype.visit=function(treeParser){treeParser.processingInstruction(this.target,this.data,this)},ProcessingInstruction.prototype.getNodeType=function(){return NodeType.PROCESSING_INSTRUCTION},DTD.prototype=Object.create(ParentNode.prototype),DTD.prototype.visit=function(treeParser){treeParser.startDTD(this.name,this.publicIdentifier,this.systemIdentifier,this)},DTD.prototype.revisit=function(treeParser){treeParser.endDTD()},exports.SAXTreeBuilder=SAXTreeBuilder},{\"../TreeBuilder\":6,util:20}],11:[function(_dereq_,module,exports){function TreeParser(contentHandler,lexicalHandler){if(this.contentHandler,this.lexicalHandler,this.locatorDelegate,!contentHandler)throw new IllegalArgumentException(\"contentHandler was null.\");this.contentHandler=contentHandler,this.lexicalHandler=lexicalHandler?lexicalHandler:new NullLexicalHandler}function NullLexicalHandler(){}TreeParser.prototype.parse=function(node){this.contentHandler.documentLocator=this;for(var next,current=node;;)if(current.visit(this),next=current.firstChild)current=next;else for(;;){if(current.revisit(this),current==node)return;if(next=current.nextSibling){current=next;break}current=current.parentNode}},TreeParser.prototype.characters=function(ch,start,length,locator){this.locatorDelegate=locator,this.contentHandler.characters(ch,start,length)},TreeParser.prototype.endDocument=function(locator){this.locatorDelegate=locator,this.contentHandler.endDocument()},TreeParser.prototype.endElement=function(uri,localName,qName,locator){this.locatorDelegate=locator,this.contentHandler.endElement(uri,localName,qName)},TreeParser.prototype.endPrefixMapping=function(prefix,locator){this.locatorDelegate=locator,this.contentHandler.endPrefixMapping(prefix)},TreeParser.prototype.ignorableWhitespace=function(ch,start,length,locator){this.locatorDelegate=locator,this.contentHandler.ignorableWhitespace(ch,start,length)},TreeParser.prototype.processingInstruction=function(target,data,locator){this.locatorDelegate=locator,this.contentHandler.processingInstruction(target,data)},TreeParser.prototype.skippedEntity=function(name,locator){this.locatorDelegate=locator,this.contentHandler.skippedEntity(name)},TreeParser.prototype.startDocument=function(locator){this.locatorDelegate=locator,this.contentHandler.startDocument()},TreeParser.prototype.startElement=function(uri,localName,qName,atts,locator){this.locatorDelegate=locator,this.contentHandler.startElement(uri,localName,qName,atts)},TreeParser.prototype.startPrefixMapping=function(prefix,uri,locator){this.locatorDelegate=locator,this.contentHandler.startPrefixMapping(prefix,uri)},TreeParser.prototype.comment=function(ch,start,length,locator){this.locatorDelegate=locator,this.lexicalHandler.comment(ch,start,length)},TreeParser.prototype.endCDATA=function(locator){this.locatorDelegate=locator,this.lexicalHandler.endCDATA()},TreeParser.prototype.endDTD=function(locator){this.locatorDelegate=locator,this.lexicalHandler.endDTD()},TreeParser.prototype.endEntity=function(name,locator){this.locatorDelegate=locator,this.lexicalHandler.endEntity(name)},TreeParser.prototype.startCDATA=function(locator){this.locatorDelegate=locator,this.lexicalHandler.startCDATA()},TreeParser.prototype.startDTD=function(name,publicId,systemId,locator){this.locatorDelegate=locator,this.lexicalHandler.startDTD(name,publicId,systemId)},TreeParser.prototype.startEntity=function(name,locator){this.locatorDelegate=locator,this.lexicalHandler.startEntity(name)},Object.defineProperty(TreeParser.prototype,\"columnNumber\",{get:function(){return this.locatorDelegate?this.locatorDelegate.columnNumber:-1}}),Object.defineProperty(TreeParser.prototype,\"lineNumber\",{get:function(){return this.locatorDelegate?this.locatorDelegate.lineNumber:-1}}),NullLexicalHandler.prototype.comment=function(){},NullLexicalHandler.prototype.endCDATA=function(){},NullLexicalHandler.prototype.endDTD=function(){},NullLexicalHandler.prototype.endEntity=function(){},NullLexicalHandler.prototype.startCDATA=function(){},NullLexicalHandler.prototype.startDTD=function(){},NullLexicalHandler.prototype.startEntity=function(){},exports.TreeParser=TreeParser},{}],12:[function(_dereq_,module){module.exports={\"Aacute;\":\"Á\",Aacute:\"Á\",\"aacute;\":\"á\",aacute:\"á\",\"Abreve;\":\"Ă\",\"abreve;\":\"ă\",\"ac;\":\"∾\",\"acd;\":\"∿\",\"acE;\":\"∾̳\",\"Acirc;\":\"Â\",Acirc:\"Â\",\"acirc;\":\"â\",acirc:\"â\",\"acute;\":\"´\",acute:\"´\",\"Acy;\":\"А\",\"acy;\":\"а\",\"AElig;\":\"Æ\",AElig:\"Æ\",\"aelig;\":\"æ\",aelig:\"æ\",\"af;\":\"⁡\",\"Afr;\":\"𝔄\",\"afr;\":\"𝔞\",\"Agrave;\":\"À\",Agrave:\"À\",\"agrave;\":\"à\",agrave:\"à\",\"alefsym;\":\"ℵ\",\"aleph;\":\"ℵ\",\"Alpha;\":\"Α\",\"alpha;\":\"α\",\"Amacr;\":\"Ā\",\"amacr;\":\"ā\",\"amalg;\":\"⨿\",\"amp;\":\"&\",amp:\"&\",\"AMP;\":\"&\",AMP:\"&\",\"andand;\":\"⩕\",\"And;\":\"⩓\",\"and;\":\"∧\",\"andd;\":\"⩜\",\"andslope;\":\"⩘\",\"andv;\":\"⩚\",\"ang;\":\"∠\",\"ange;\":\"⦤\",\"angle;\":\"∠\",\"angmsdaa;\":\"⦨\",\"angmsdab;\":\"⦩\",\"angmsdac;\":\"⦪\",\"angmsdad;\":\"⦫\",\"angmsdae;\":\"⦬\",\"angmsdaf;\":\"⦭\",\"angmsdag;\":\"⦮\",\"angmsdah;\":\"⦯\",\"angmsd;\":\"∡\",\"angrt;\":\"∟\",\"angrtvb;\":\"⊾\",\"angrtvbd;\":\"⦝\",\"angsph;\":\"∢\",\"angst;\":\"Å\",\"angzarr;\":\"⍼\",\"Aogon;\":\"Ą\",\"aogon;\":\"ą\",\"Aopf;\":\"𝔸\",\"aopf;\":\"𝕒\",\"apacir;\":\"⩯\",\"ap;\":\"≈\",\"apE;\":\"⩰\",\"ape;\":\"≊\",\"apid;\":\"≋\",\"apos;\":\"'\",\"ApplyFunction;\":\"⁡\",\"approx;\":\"≈\",\"approxeq;\":\"≊\",\"Aring;\":\"Å\",Aring:\"Å\",\"aring;\":\"å\",aring:\"å\",\"Ascr;\":\"𝒜\",\"ascr;\":\"𝒶\",\"Assign;\":\"≔\",\"ast;\":\"*\",\"asymp;\":\"≈\",\"asympeq;\":\"≍\",\"Atilde;\":\"Ã\",Atilde:\"Ã\",\"atilde;\":\"ã\",atilde:\"ã\",\"Auml;\":\"Ä\",Auml:\"Ä\",\"auml;\":\"ä\",auml:\"ä\",\"awconint;\":\"∳\",\"awint;\":\"⨑\",\"backcong;\":\"≌\",\"backepsilon;\":\"϶\",\"backprime;\":\"‵\",\"backsim;\":\"∽\",\"backsimeq;\":\"⋍\",\"Backslash;\":\"∖\",\"Barv;\":\"⫧\",\"barvee;\":\"⊽\",\"barwed;\":\"⌅\",\"Barwed;\":\"⌆\",\"barwedge;\":\"⌅\",\"bbrk;\":\"⎵\",\"bbrktbrk;\":\"⎶\",\"bcong;\":\"≌\",\"Bcy;\":\"Б\",\"bcy;\":\"б\",\"bdquo;\":\"„\",\"becaus;\":\"∵\",\"because;\":\"∵\",\"Because;\":\"∵\",\"bemptyv;\":\"⦰\",\"bepsi;\":\"϶\",\"bernou;\":\"ℬ\",\"Bernoullis;\":\"ℬ\",\"Beta;\":\"Β\",\"beta;\":\"β\",\"beth;\":\"ℶ\",\"between;\":\"≬\",\"Bfr;\":\"𝔅\",\"bfr;\":\"𝔟\",\"bigcap;\":\"⋂\",\"bigcirc;\":\"◯\",\"bigcup;\":\"⋃\",\"bigodot;\":\"⨀\",\"bigoplus;\":\"⨁\",\"bigotimes;\":\"⨂\",\"bigsqcup;\":\"⨆\",\"bigstar;\":\"★\",\"bigtriangledown;\":\"▽\",\"bigtriangleup;\":\"△\",\"biguplus;\":\"⨄\",\"bigvee;\":\"⋁\",\"bigwedge;\":\"⋀\",\"bkarow;\":\"⤍\",\"blacklozenge;\":\"⧫\",\"blacksquare;\":\"▪\",\"blacktriangle;\":\"▴\",\"blacktriangledown;\":\"▾\",\"blacktriangleleft;\":\"◂\",\"blacktriangleright;\":\"▸\",\"blank;\":\"␣\",\"blk12;\":\"▒\",\"blk14;\":\"░\",\"blk34;\":\"▓\",\"block;\":\"█\",\"bne;\":\"=⃥\",\"bnequiv;\":\"≡⃥\",\"bNot;\":\"⫭\",\"bnot;\":\"⌐\",\"Bopf;\":\"𝔹\",\"bopf;\":\"𝕓\",\"bot;\":\"⊥\",\"bottom;\":\"⊥\",\"bowtie;\":\"⋈\",\"boxbox;\":\"⧉\",\"boxdl;\":\"┐\",\"boxdL;\":\"╕\",\"boxDl;\":\"╖\",\"boxDL;\":\"╗\",\"boxdr;\":\"┌\",\"boxdR;\":\"╒\",\"boxDr;\":\"╓\",\"boxDR;\":\"╔\",\"boxh;\":\"─\",\"boxH;\":\"═\",\"boxhd;\":\"┬\",\"boxHd;\":\"╤\",\"boxhD;\":\"╥\",\"boxHD;\":\"╦\",\"boxhu;\":\"┴\",\"boxHu;\":\"╧\",\"boxhU;\":\"╨\",\"boxHU;\":\"╩\",\"boxminus;\":\"⊟\",\"boxplus;\":\"⊞\",\"boxtimes;\":\"⊠\",\"boxul;\":\"┘\",\"boxuL;\":\"╛\",\"boxUl;\":\"╜\",\"boxUL;\":\"╝\",\"boxur;\":\"└\",\"boxuR;\":\"╘\",\"boxUr;\":\"╙\",\"boxUR;\":\"╚\",\"boxv;\":\"│\",\"boxV;\":\"║\",\"boxvh;\":\"┼\",\"boxvH;\":\"╪\",\"boxVh;\":\"╫\",\"boxVH;\":\"╬\",\"boxvl;\":\"┤\",\"boxvL;\":\"╡\",\"boxVl;\":\"╢\",\"boxVL;\":\"╣\",\"boxvr;\":\"├\",\"boxvR;\":\"╞\",\"boxVr;\":\"╟\",\"boxVR;\":\"╠\",\"bprime;\":\"‵\",\"breve;\":\"˘\",\"Breve;\":\"˘\",\"brvbar;\":\"¦\",brvbar:\"¦\",\"bscr;\":\"𝒷\",\"Bscr;\":\"ℬ\",\"bsemi;\":\"⁏\",\"bsim;\":\"∽\",\"bsime;\":\"⋍\",\"bsolb;\":\"⧅\",\"bsol;\":\"\\\\\",\"bsolhsub;\":\"⟈\",\"bull;\":\"•\",\"bullet;\":\"•\",\"bump;\":\"≎\",\"bumpE;\":\"⪮\",\"bumpe;\":\"≏\",\"Bumpeq;\":\"≎\",\"bumpeq;\":\"≏\",\"Cacute;\":\"Ć\",\"cacute;\":\"ć\",\"capand;\":\"⩄\",\"capbrcup;\":\"⩉\",\"capcap;\":\"⩋\",\"cap;\":\"∩\",\"Cap;\":\"⋒\",\"capcup;\":\"⩇\",\"capdot;\":\"⩀\",\"CapitalDifferentialD;\":\"ⅅ\",\"caps;\":\"∩︀\",\"caret;\":\"⁁\",\"caron;\":\"ˇ\",\"Cayleys;\":\"ℭ\",\"ccaps;\":\"⩍\",\"Ccaron;\":\"Č\",\"ccaron;\":\"č\",\"Ccedil;\":\"Ç\",Ccedil:\"Ç\",\"ccedil;\":\"ç\",ccedil:\"ç\",\"Ccirc;\":\"Ĉ\",\"ccirc;\":\"ĉ\",\"Cconint;\":\"∰\",\"ccups;\":\"⩌\",\"ccupssm;\":\"⩐\",\"Cdot;\":\"Ċ\",\"cdot;\":\"ċ\",\"cedil;\":\"¸\",cedil:\"¸\",\"Cedilla;\":\"¸\",\"cemptyv;\":\"⦲\",\"cent;\":\"¢\",cent:\"¢\",\"centerdot;\":\"·\",\"CenterDot;\":\"·\",\"cfr;\":\"𝔠\",\"Cfr;\":\"ℭ\",\"CHcy;\":\"Ч\",\"chcy;\":\"ч\",\"check;\":\"✓\",\"checkmark;\":\"✓\",\"Chi;\":\"Χ\",\"chi;\":\"χ\",\"circ;\":\"ˆ\",\"circeq;\":\"≗\",\"circlearrowleft;\":\"↺\",\"circlearrowright;\":\"↻\",\"circledast;\":\"⊛\",\"circledcirc;\":\"⊚\",\"circleddash;\":\"⊝\",\"CircleDot;\":\"⊙\",\"circledR;\":\"®\",\"circledS;\":\"Ⓢ\",\"CircleMinus;\":\"⊖\",\"CirclePlus;\":\"⊕\",\"CircleTimes;\":\"⊗\",\"cir;\":\"○\",\"cirE;\":\"⧃\",\"cire;\":\"≗\",\"cirfnint;\":\"⨐\",\"cirmid;\":\"⫯\",\"cirscir;\":\"⧂\",\"ClockwiseContourIntegral;\":\"∲\",\"CloseCurlyDoubleQuote;\":\"”\",\"CloseCurlyQuote;\":\"’\",\"clubs;\":\"♣\",\"clubsuit;\":\"♣\",\"colon;\":\":\",\"Colon;\":\"∷\",\"Colone;\":\"⩴\",\"colone;\":\"≔\",\"coloneq;\":\"≔\",\"comma;\":\",\",\"commat;\":\"@\",\"comp;\":\"∁\",\"compfn;\":\"∘\",\"complement;\":\"∁\",\"complexes;\":\"ℂ\",\"cong;\":\"≅\",\"congdot;\":\"⩭\",\"Congruent;\":\"≡\",\"conint;\":\"∮\",\"Conint;\":\"∯\",\"ContourIntegral;\":\"∮\",\"copf;\":\"𝕔\",\"Copf;\":\"ℂ\",\"coprod;\":\"∐\",\"Coproduct;\":\"∐\",\"copy;\":\"©\",copy:\"©\",\"COPY;\":\"©\",COPY:\"©\",\"copysr;\":\"℗\",\"CounterClockwiseContourIntegral;\":\"∳\",\"crarr;\":\"↵\",\"cross;\":\"✗\",\"Cross;\":\"⨯\",\"Cscr;\":\"𝒞\",\"cscr;\":\"𝒸\",\"csub;\":\"⫏\",\"csube;\":\"⫑\",\"csup;\":\"⫐\",\"csupe;\":\"⫒\",\"ctdot;\":\"⋯\",\"cudarrl;\":\"⤸\",\"cudarrr;\":\"⤵\",\"cuepr;\":\"⋞\",\"cuesc;\":\"⋟\",\"cularr;\":\"↶\",\"cularrp;\":\"⤽\",\"cupbrcap;\":\"⩈\",\"cupcap;\":\"⩆\",\"CupCap;\":\"≍\",\"cup;\":\"∪\",\"Cup;\":\"⋓\",\"cupcup;\":\"⩊\",\"cupdot;\":\"⊍\",\"cupor;\":\"⩅\",\"cups;\":\"∪︀\",\"curarr;\":\"↷\",\"curarrm;\":\"⤼\",\"curlyeqprec;\":\"⋞\",\"curlyeqsucc;\":\"⋟\",\"curlyvee;\":\"⋎\",\"curlywedge;\":\"⋏\",\"curren;\":\"¤\",curren:\"¤\",\"curvearrowleft;\":\"↶\",\"curvearrowright;\":\"↷\",\"cuvee;\":\"⋎\",\"cuwed;\":\"⋏\",\"cwconint;\":\"∲\",\"cwint;\":\"∱\",\"cylcty;\":\"⌭\",\"dagger;\":\"†\",\"Dagger;\":\"‡\",\"daleth;\":\"ℸ\",\"darr;\":\"↓\",\"Darr;\":\"↡\",\"dArr;\":\"⇓\",\"dash;\":\"‐\",\"Dashv;\":\"⫤\",\"dashv;\":\"⊣\",\"dbkarow;\":\"⤏\",\"dblac;\":\"˝\",\"Dcaron;\":\"Ď\",\"dcaron;\":\"ď\",\"Dcy;\":\"Д\",\"dcy;\":\"д\",\"ddagger;\":\"‡\",\"ddarr;\":\"⇊\",\"DD;\":\"ⅅ\",\"dd;\":\"ⅆ\",\"DDotrahd;\":\"⤑\",\"ddotseq;\":\"⩷\",\"deg;\":\"°\",deg:\"°\",\"Del;\":\"∇\",\"Delta;\":\"Δ\",\"delta;\":\"δ\",\"demptyv;\":\"⦱\",\"dfisht;\":\"⥿\",\"Dfr;\":\"𝔇\",\"dfr;\":\"𝔡\",\"dHar;\":\"⥥\",\"dharl;\":\"⇃\",\"dharr;\":\"⇂\",\"DiacriticalAcute;\":\"´\",\"DiacriticalDot;\":\"˙\",\"DiacriticalDoubleAcute;\":\"˝\",\"DiacriticalGrave;\":\"`\",\"DiacriticalTilde;\":\"˜\",\"diam;\":\"⋄\",\"diamond;\":\"⋄\",\"Diamond;\":\"⋄\",\"diamondsuit;\":\"♦\",\"diams;\":\"♦\",\"die;\":\"¨\",\"DifferentialD;\":\"ⅆ\",\"digamma;\":\"ϝ\",\"disin;\":\"⋲\",\"div;\":\"÷\",\"divide;\":\"÷\",divide:\"÷\",\"divideontimes;\":\"⋇\",\"divonx;\":\"⋇\",\"DJcy;\":\"Ђ\",\"djcy;\":\"ђ\",\"dlcorn;\":\"⌞\",\"dlcrop;\":\"⌍\",\"dollar;\":\"$\",\"Dopf;\":\"𝔻\",\"dopf;\":\"𝕕\",\"Dot;\":\"¨\",\"dot;\":\"˙\",\"DotDot;\":\"⃜\",\"doteq;\":\"≐\",\"doteqdot;\":\"≑\",\"DotEqual;\":\"≐\",\"dotminus;\":\"∸\",\"dotplus;\":\"∔\",\"dotsquare;\":\"⊡\",\"doublebarwedge;\":\"⌆\",\"DoubleContourIntegral;\":\"∯\",\"DoubleDot;\":\"¨\",\"DoubleDownArrow;\":\"⇓\",\"DoubleLeftArrow;\":\"⇐\",\"DoubleLeftRightArrow;\":\"⇔\",\"DoubleLeftTee;\":\"⫤\",\"DoubleLongLeftArrow;\":\"⟸\",\"DoubleLongLeftRightArrow;\":\"⟺\",\"DoubleLongRightArrow;\":\"⟹\",\"DoubleRightArrow;\":\"⇒\",\"DoubleRightTee;\":\"⊨\",\"DoubleUpArrow;\":\"⇑\",\"DoubleUpDownArrow;\":\"⇕\",\"DoubleVerticalBar;\":\"∥\",\"DownArrowBar;\":\"⤓\",\"downarrow;\":\"↓\",\"DownArrow;\":\"↓\",\"Downarrow;\":\"⇓\",\"DownArrowUpArrow;\":\"⇵\",\"DownBreve;\":\"̑\",\"downdownarrows;\":\"⇊\",\"downharpoonleft;\":\"⇃\",\"downharpoonright;\":\"⇂\",\"DownLeftRightVector;\":\"⥐\",\"DownLeftTeeVector;\":\"⥞\",\"DownLeftVectorBar;\":\"⥖\",\"DownLeftVector;\":\"↽\",\"DownRightTeeVector;\":\"⥟\",\"DownRightVectorBar;\":\"⥗\",\"DownRightVector;\":\"⇁\",\"DownTeeArrow;\":\"↧\",\"DownTee;\":\"⊤\",\"drbkarow;\":\"⤐\",\"drcorn;\":\"⌟\",\"drcrop;\":\"⌌\",\"Dscr;\":\"𝒟\",\"dscr;\":\"𝒹\",\"DScy;\":\"Ѕ\",\"dscy;\":\"ѕ\",\"dsol;\":\"⧶\",\"Dstrok;\":\"Đ\",\"dstrok;\":\"đ\",\"dtdot;\":\"⋱\",\"dtri;\":\"▿\",\"dtrif;\":\"▾\",\"duarr;\":\"⇵\",\"duhar;\":\"⥯\",\"dwangle;\":\"⦦\",\"DZcy;\":\"Џ\",\"dzcy;\":\"џ\",\"dzigrarr;\":\"⟿\",\"Eacute;\":\"É\",Eacute:\"É\",\"eacute;\":\"é\",eacute:\"é\",\"easter;\":\"⩮\",\"Ecaron;\":\"Ě\",\"ecaron;\":\"ě\",\"Ecirc;\":\"Ê\",Ecirc:\"Ê\",\"ecirc;\":\"ê\",ecirc:\"ê\",\"ecir;\":\"≖\",\"ecolon;\":\"≕\",\"Ecy;\":\"Э\",\"ecy;\":\"э\",\"eDDot;\":\"⩷\",\"Edot;\":\"Ė\",\"edot;\":\"ė\",\"eDot;\":\"≑\",\"ee;\":\"ⅇ\",\"efDot;\":\"≒\",\"Efr;\":\"𝔈\",\"efr;\":\"𝔢\",\"eg;\":\"⪚\",\"Egrave;\":\"È\",Egrave:\"È\",\"egrave;\":\"è\",egrave:\"è\",\"egs;\":\"⪖\",\"egsdot;\":\"⪘\",\"el;\":\"⪙\",\"Element;\":\"∈\",\"elinters;\":\"⏧\",\"ell;\":\"ℓ\",\"els;\":\"⪕\",\"elsdot;\":\"⪗\",\"Emacr;\":\"Ē\",\"emacr;\":\"ē\",\"empty;\":\"∅\",\"emptyset;\":\"∅\",\"EmptySmallSquare;\":\"◻\",\"emptyv;\":\"∅\",\"EmptyVerySmallSquare;\":\"▫\",\"emsp13;\":\" \",\"emsp14;\":\" \",\"emsp;\":\" \",\"ENG;\":\"Ŋ\",\"eng;\":\"ŋ\",\"ensp;\":\" \",\"Eogon;\":\"Ę\",\"eogon;\":\"ę\",\"Eopf;\":\"𝔼\",\"eopf;\":\"𝕖\",\"epar;\":\"⋕\",\"eparsl;\":\"⧣\",\"eplus;\":\"⩱\",\"epsi;\":\"ε\",\"Epsilon;\":\"Ε\",\"epsilon;\":\"ε\",\"epsiv;\":\"ϵ\",\"eqcirc;\":\"≖\",\"eqcolon;\":\"≕\",\"eqsim;\":\"≂\",\"eqslantgtr;\":\"⪖\",\"eqslantless;\":\"⪕\",\"Equal;\":\"⩵\",\"equals;\":\"=\",\"EqualTilde;\":\"≂\",\"equest;\":\"≟\",\"Equilibrium;\":\"⇌\",\"equiv;\":\"≡\",\"equivDD;\":\"⩸\",\"eqvparsl;\":\"⧥\",\"erarr;\":\"⥱\",\"erDot;\":\"≓\",\"escr;\":\"ℯ\",\"Escr;\":\"ℰ\",\"esdot;\":\"≐\",\"Esim;\":\"⩳\",\"esim;\":\"≂\",\"Eta;\":\"Η\",\"eta;\":\"η\",\"ETH;\":\"Ð\",ETH:\"Ð\",\"eth;\":\"ð\",eth:\"ð\",\"Euml;\":\"Ë\",Euml:\"Ë\",\"euml;\":\"ë\",euml:\"ë\",\"euro;\":\"€\",\"excl;\":\"!\",\"exist;\":\"∃\",\"Exists;\":\"∃\",\"expectation;\":\"ℰ\",\"exponentiale;\":\"ⅇ\",\"ExponentialE;\":\"ⅇ\",\"fallingdotseq;\":\"≒\",\"Fcy;\":\"Ф\",\"fcy;\":\"ф\",\"female;\":\"♀\",\"ffilig;\":\"ﬃ\",\"fflig;\":\"ﬀ\",\"ffllig;\":\"ﬄ\",\"Ffr;\":\"𝔉\",\"ffr;\":\"𝔣\",\"filig;\":\"ﬁ\",\"FilledSmallSquare;\":\"◼\",\"FilledVerySmallSquare;\":\"▪\",\"fjlig;\":\"fj\",\"flat;\":\"♭\",\"fllig;\":\"ﬂ\",\"fltns;\":\"▱\",\"fnof;\":\"ƒ\",\"Fopf;\":\"𝔽\",\"fopf;\":\"𝕗\",\"forall;\":\"∀\",\"ForAll;\":\"∀\",\"fork;\":\"⋔\",\"forkv;\":\"⫙\",\"Fouriertrf;\":\"ℱ\",\"fpartint;\":\"⨍\",\"frac12;\":\"½\",frac12:\"½\",\"frac13;\":\"⅓\",\"frac14;\":\"¼\",frac14:\"¼\",\"frac15;\":\"⅕\",\"frac16;\":\"⅙\",\"frac18;\":\"⅛\",\"frac23;\":\"⅔\",\"frac25;\":\"⅖\",\"frac34;\":\"¾\",frac34:\"¾\",\"frac35;\":\"⅗\",\"frac38;\":\"⅜\",\"frac45;\":\"⅘\",\"frac56;\":\"⅚\",\"frac58;\":\"⅝\",\"frac78;\":\"⅞\",\"frasl;\":\"⁄\",\"frown;\":\"⌢\",\"fscr;\":\"𝒻\",\"Fscr;\":\"ℱ\",\"gacute;\":\"ǵ\",\"Gamma;\":\"Γ\",\"gamma;\":\"γ\",\"Gammad;\":\"Ϝ\",\"gammad;\":\"ϝ\",\"gap;\":\"⪆\",\"Gbreve;\":\"Ğ\",\"gbreve;\":\"ğ\",\"Gcedil;\":\"Ģ\",\"Gcirc;\":\"Ĝ\",\"gcirc;\":\"ĝ\",\"Gcy;\":\"Г\",\"gcy;\":\"г\",\"Gdot;\":\"Ġ\",\"gdot;\":\"ġ\",\"ge;\":\"≥\",\"gE;\":\"≧\",\"gEl;\":\"⪌\",\"gel;\":\"⋛\",\"geq;\":\"≥\",\"geqq;\":\"≧\",\"geqslant;\":\"⩾\",\"gescc;\":\"⪩\",\"ges;\":\"⩾\",\"gesdot;\":\"⪀\",\"gesdoto;\":\"⪂\",\"gesdotol;\":\"⪄\",\"gesl;\":\"⋛︀\",\"gesles;\":\"⪔\",\"Gfr;\":\"𝔊\",\"gfr;\":\"𝔤\",\"gg;\":\"≫\",\"Gg;\":\"⋙\",\"ggg;\":\"⋙\",\"gimel;\":\"ℷ\",\"GJcy;\":\"Ѓ\",\"gjcy;\":\"ѓ\",\"gla;\":\"⪥\",\"gl;\":\"≷\",\"glE;\":\"⪒\",\"glj;\":\"⪤\",\"gnap;\":\"⪊\",\"gnapprox;\":\"⪊\",\"gne;\":\"⪈\",\"gnE;\":\"≩\",\"gneq;\":\"⪈\",\"gneqq;\":\"≩\",\"gnsim;\":\"⋧\",\"Gopf;\":\"𝔾\",\"gopf;\":\"𝕘\",\"grave;\":\"`\",\"GreaterEqual;\":\"≥\",\"GreaterEqualLess;\":\"⋛\",\"GreaterFullEqual;\":\"≧\",\"GreaterGreater;\":\"⪢\",\"GreaterLess;\":\"≷\",\"GreaterSlantEqual;\":\"⩾\",\"GreaterTilde;\":\"≳\",\"Gscr;\":\"𝒢\",\"gscr;\":\"ℊ\",\"gsim;\":\"≳\",\"gsime;\":\"⪎\",\"gsiml;\":\"⪐\",\"gtcc;\":\"⪧\",\"gtcir;\":\"⩺\",\"gt;\":\">\",gt:\">\",\"GT;\":\">\",GT:\">\",\"Gt;\":\"≫\",\"gtdot;\":\"⋗\",\"gtlPar;\":\"⦕\",\"gtquest;\":\"⩼\",\"gtrapprox;\":\"⪆\",\"gtrarr;\":\"⥸\",\"gtrdot;\":\"⋗\",\"gtreqless;\":\"⋛\",\"gtreqqless;\":\"⪌\",\"gtrless;\":\"≷\",\"gtrsim;\":\"≳\",\"gvertneqq;\":\"≩︀\",\"gvnE;\":\"≩︀\",\"Hacek;\":\"ˇ\",\"hairsp;\":\" \",\"half;\":\"½\",\"hamilt;\":\"ℋ\",\"HARDcy;\":\"Ъ\",\"hardcy;\":\"ъ\",\"harrcir;\":\"⥈\",\"harr;\":\"↔\",\"hArr;\":\"⇔\",\"harrw;\":\"↭\",\"Hat;\":\"^\",\"hbar;\":\"ℏ\",\"Hcirc;\":\"Ĥ\",\"hcirc;\":\"ĥ\",\"hearts;\":\"♥\",\"heartsuit;\":\"♥\",\"hellip;\":\"…\",\"hercon;\":\"⊹\",\"hfr;\":\"𝔥\",\"Hfr;\":\"ℌ\",\"HilbertSpace;\":\"ℋ\",\"hksearow;\":\"⤥\",\"hkswarow;\":\"⤦\",\"hoarr;\":\"⇿\",\"homtht;\":\"∻\",\"hookleftarrow;\":\"↩\",\"hookrightarrow;\":\"↪\",\"hopf;\":\"𝕙\",\"Hopf;\":\"ℍ\",\"horbar;\":\"―\",\"HorizontalLine;\":\"─\",\"hscr;\":\"𝒽\",\"Hscr;\":\"ℋ\",\"hslash;\":\"ℏ\",\"Hstrok;\":\"Ħ\",\"hstrok;\":\"ħ\",\"HumpDownHump;\":\"≎\",\"HumpEqual;\":\"≏\",\"hybull;\":\"⁃\",\"hyphen;\":\"‐\",\"Iacute;\":\"Í\",Iacute:\"Í\",\"iacute;\":\"í\",iacute:\"í\",\"ic;\":\"⁣\",\"Icirc;\":\"Î\",Icirc:\"Î\",\"icirc;\":\"î\",icirc:\"î\",\"Icy;\":\"И\",\"icy;\":\"и\",\"Idot;\":\"İ\",\"IEcy;\":\"Е\",\"iecy;\":\"е\",\"iexcl;\":\"¡\",iexcl:\"¡\",\"iff;\":\"⇔\",\"ifr;\":\"𝔦\",\"Ifr;\":\"ℑ\",\"Igrave;\":\"Ì\",Igrave:\"Ì\",\"igrave;\":\"ì\",igrave:\"ì\",\"ii;\":\"ⅈ\",\"iiiint;\":\"⨌\",\"iiint;\":\"∭\",\"iinfin;\":\"⧜\",\"iiota;\":\"℩\",\"IJlig;\":\"Ĳ\",\"ijlig;\":\"ĳ\",\"Imacr;\":\"Ī\",\"imacr;\":\"ī\",\"image;\":\"ℑ\",\"ImaginaryI;\":\"ⅈ\",\"imagline;\":\"ℐ\",\"imagpart;\":\"ℑ\",\"imath;\":\"ı\",\"Im;\":\"ℑ\",\"imof;\":\"⊷\",\"imped;\":\"Ƶ\",\"Implies;\":\"⇒\",\"incare;\":\"℅\",\"in;\":\"∈\",\"infin;\":\"∞\",\"infintie;\":\"⧝\",\"inodot;\":\"ı\",\"intcal;\":\"⊺\",\"int;\":\"∫\",\"Int;\":\"∬\",\"integers;\":\"ℤ\",\"Integral;\":\"∫\",\"intercal;\":\"⊺\",\"Intersection;\":\"⋂\",\"intlarhk;\":\"⨗\",\"intprod;\":\"⨼\",\"InvisibleComma;\":\"⁣\",\"InvisibleTimes;\":\"⁢\",\"IOcy;\":\"Ё\",\"iocy;\":\"ё\",\"Iogon;\":\"Į\",\"iogon;\":\"į\",\"Iopf;\":\"𝕀\",\"iopf;\":\"𝕚\",\"Iota;\":\"Ι\",\"iota;\":\"ι\",\"iprod;\":\"⨼\",\"iquest;\":\"¿\",iquest:\"¿\",\"iscr;\":\"𝒾\",\"Iscr;\":\"ℐ\",\"isin;\":\"∈\",\"isindot;\":\"⋵\",\"isinE;\":\"⋹\",\"isins;\":\"⋴\",\"isinsv;\":\"⋳\",\"isinv;\":\"∈\",\"it;\":\"⁢\",\"Itilde;\":\"Ĩ\",\"itilde;\":\"ĩ\",\"Iukcy;\":\"І\",\"iukcy;\":\"і\",\"Iuml;\":\"Ï\",Iuml:\"Ï\",\"iuml;\":\"ï\",iuml:\"ï\",\"Jcirc;\":\"Ĵ\",\"jcirc;\":\"ĵ\",\"Jcy;\":\"Й\",\"jcy;\":\"й\",\"Jfr;\":\"𝔍\",\"jfr;\":\"𝔧\",\"jmath;\":\"ȷ\",\"Jopf;\":\"𝕁\",\"jopf;\":\"𝕛\",\"Jscr;\":\"𝒥\",\"jscr;\":\"𝒿\",\"Jsercy;\":\"Ј\",\"jsercy;\":\"ј\",\"Jukcy;\":\"Є\",\"jukcy;\":\"є\",\"Kappa;\":\"Κ\",\"kappa;\":\"κ\",\"kappav;\":\"ϰ\",\"Kcedil;\":\"Ķ\",\"kcedil;\":\"ķ\",\"Kcy;\":\"К\",\"kcy;\":\"к\",\"Kfr;\":\"𝔎\",\"kfr;\":\"𝔨\",\"kgreen;\":\"ĸ\",\"KHcy;\":\"Х\",\"khcy;\":\"х\",\"KJcy;\":\"Ќ\",\"kjcy;\":\"ќ\",\"Kopf;\":\"𝕂\",\"kopf;\":\"𝕜\",\"Kscr;\":\"𝒦\",\"kscr;\":\"𝓀\",\"lAarr;\":\"⇚\",\"Lacute;\":\"Ĺ\",\"lacute;\":\"ĺ\",\"laemptyv;\":\"⦴\",\"lagran;\":\"ℒ\",\"Lambda;\":\"Λ\",\"lambda;\":\"λ\",\"lang;\":\"⟨\",\"Lang;\":\"⟪\",\"langd;\":\"⦑\",\"langle;\":\"⟨\",\"lap;\":\"⪅\",\"Laplacetrf;\":\"ℒ\",\"laquo;\":\"«\",laquo:\"«\",\"larrb;\":\"⇤\",\"larrbfs;\":\"⤟\",\"larr;\":\"←\",\"Larr;\":\"↞\",\"lArr;\":\"⇐\",\"larrfs;\":\"⤝\",\"larrhk;\":\"↩\",\"larrlp;\":\"↫\",\"larrpl;\":\"⤹\",\"larrsim;\":\"⥳\",\"larrtl;\":\"↢\",\"latail;\":\"⤙\",\"lAtail;\":\"⤛\",\"lat;\":\"⪫\",\"late;\":\"⪭\",\"lates;\":\"⪭︀\",\"lbarr;\":\"⤌\",\"lBarr;\":\"⤎\",\"lbbrk;\":\"❲\",\"lbrace;\":\"{\",\"lbrack;\":\"[\",\"lbrke;\":\"⦋\",\"lbrksld;\":\"⦏\",\"lbrkslu;\":\"⦍\",\"Lcaron;\":\"Ľ\",\"lcaron;\":\"ľ\",\"Lcedil;\":\"Ļ\",\"lcedil;\":\"ļ\",\"lceil;\":\"⌈\",\"lcub;\":\"{\",\"Lcy;\":\"Л\",\"lcy;\":\"л\",\"ldca;\":\"⤶\",\"ldquo;\":\"“\",\"ldquor;\":\"„\",\"ldrdhar;\":\"⥧\",\"ldrushar;\":\"⥋\",\"ldsh;\":\"↲\",\"le;\":\"≤\",\"lE;\":\"≦\",\"LeftAngleBracket;\":\"⟨\",\"LeftArrowBar;\":\"⇤\",\"leftarrow;\":\"←\",\"LeftArrow;\":\"←\",\"Leftarrow;\":\"⇐\",\"LeftArrowRightArrow;\":\"⇆\",\"leftarrowtail;\":\"↢\",\"LeftCeiling;\":\"⌈\",\"LeftDoubleBracket;\":\"⟦\",\"LeftDownTeeVector;\":\"⥡\",\"LeftDownVectorBar;\":\"⥙\",\"LeftDownVector;\":\"⇃\",\"LeftFloor;\":\"⌊\",\"leftharpoondown;\":\"↽\",\"leftharpoonup;\":\"↼\",\"leftleftarrows;\":\"⇇\",\"leftrightarrow;\":\"↔\",\"LeftRightArrow;\":\"↔\",\"Leftrightarrow;\":\"⇔\",\"leftrightarrows;\":\"⇆\",\"leftrightharpoons;\":\"⇋\",\"leftrightsquigarrow;\":\"↭\",\"LeftRightVector;\":\"⥎\",\"LeftTeeArrow;\":\"↤\",\"LeftTee;\":\"⊣\",\"LeftTeeVector;\":\"⥚\",\"leftthreetimes;\":\"⋋\",\"LeftTriangleBar;\":\"⧏\",\"LeftTriangle;\":\"⊲\",\"LeftTriangleEqual;\":\"⊴\",\"LeftUpDownVector;\":\"⥑\",\"LeftUpTeeVector;\":\"⥠\",\"LeftUpVectorBar;\":\"⥘\",\"LeftUpVector;\":\"↿\",\"LeftVectorBar;\":\"⥒\",\"LeftVector;\":\"↼\",\"lEg;\":\"⪋\",\"leg;\":\"⋚\",\"leq;\":\"≤\",\"leqq;\":\"≦\",\"leqslant;\":\"⩽\",\"lescc;\":\"⪨\",\"les;\":\"⩽\",\"lesdot;\":\"⩿\",\"lesdoto;\":\"⪁\",\"lesdotor;\":\"⪃\",\"lesg;\":\"⋚︀\",\"lesges;\":\"⪓\",\"lessapprox;\":\"⪅\",\"lessdot;\":\"⋖\",\"lesseqgtr;\":\"⋚\",\"lesseqqgtr;\":\"⪋\",\"LessEqualGreater;\":\"⋚\",\"LessFullEqual;\":\"≦\",\"LessGreater;\":\"≶\",\"lessgtr;\":\"≶\",\"LessLess;\":\"⪡\",\"lesssim;\":\"≲\",\"LessSlantEqual;\":\"⩽\",\"LessTilde;\":\"≲\",\"lfisht;\":\"⥼\",\"lfloor;\":\"⌊\",\"Lfr;\":\"𝔏\",\"lfr;\":\"𝔩\",\"lg;\":\"≶\",\"lgE;\":\"⪑\",\"lHar;\":\"⥢\",\"lhard;\":\"↽\",\"lharu;\":\"↼\",\"lharul;\":\"⥪\",\"lhblk;\":\"▄\",\"LJcy;\":\"Љ\",\"ljcy;\":\"љ\",\"llarr;\":\"⇇\",\"ll;\":\"≪\",\"Ll;\":\"⋘\",\"llcorner;\":\"⌞\",\"Lleftarrow;\":\"⇚\",\"llhard;\":\"⥫\",\"lltri;\":\"◺\",\"Lmidot;\":\"Ŀ\",\"lmidot;\":\"ŀ\",\"lmoustache;\":\"⎰\",\"lmoust;\":\"⎰\",\"lnap;\":\"⪉\",\"lnapprox;\":\"⪉\",\"lne;\":\"⪇\",\"lnE;\":\"≨\",\"lneq;\":\"⪇\",\"lneqq;\":\"≨\",\"lnsim;\":\"⋦\",\"loang;\":\"⟬\",\"loarr;\":\"⇽\",\"lobrk;\":\"⟦\",\"longleftarrow;\":\"⟵\",\"LongLeftArrow;\":\"⟵\",\"Longleftarrow;\":\"⟸\",\"longleftrightarrow;\":\"⟷\",\"LongLeftRightArrow;\":\"⟷\",\"Longleftrightarrow;\":\"⟺\",\"longmapsto;\":\"⟼\",\"longrightarrow;\":\"⟶\",\"LongRightArrow;\":\"⟶\",\"Longrightarrow;\":\"⟹\",\"looparrowleft;\":\"↫\",\"looparrowright;\":\"↬\",\"lopar;\":\"⦅\",\"Lopf;\":\"𝕃\",\"lopf;\":\"𝕝\",\"loplus;\":\"⨭\",\"lotimes;\":\"⨴\",\"lowast;\":\"∗\",\"lowbar;\":\"_\",\"LowerLeftArrow;\":\"↙\",\"LowerRightArrow;\":\"↘\",\"loz;\":\"◊\",\"lozenge;\":\"◊\",\"lozf;\":\"⧫\",\"lpar;\":\"(\",\"lparlt;\":\"⦓\",\"lrarr;\":\"⇆\",\"lrcorner;\":\"⌟\",\"lrhar;\":\"⇋\",\"lrhard;\":\"⥭\",\"lrm;\":\"‎\",\"lrtri;\":\"⊿\",\"lsaquo;\":\"‹\",\"lscr;\":\"𝓁\",\"Lscr;\":\"ℒ\",\"lsh;\":\"↰\",\"Lsh;\":\"↰\",\"lsim;\":\"≲\",\"lsime;\":\"⪍\",\"lsimg;\":\"⪏\",\"lsqb;\":\"[\",\"lsquo;\":\"‘\",\"lsquor;\":\"‚\",\"Lstrok;\":\"Ł\",\"lstrok;\":\"ł\",\"ltcc;\":\"⪦\",\"ltcir;\":\"⩹\",\"lt;\":\"<\",lt:\"<\",\"LT;\":\"<\",LT:\"<\",\"Lt;\":\"≪\",\"ltdot;\":\"⋖\",\"lthree;\":\"⋋\",\"ltimes;\":\"⋉\",\"ltlarr;\":\"⥶\",\"ltquest;\":\"⩻\",\"ltri;\":\"◃\",\"ltrie;\":\"⊴\",\"ltrif;\":\"◂\",\"ltrPar;\":\"⦖\",\"lurdshar;\":\"⥊\",\"luruhar;\":\"⥦\",\"lvertneqq;\":\"≨︀\",\"lvnE;\":\"≨︀\",\"macr;\":\"¯\",macr:\"¯\",\"male;\":\"♂\",\"malt;\":\"✠\",\"maltese;\":\"✠\",\"Map;\":\"⤅\",\"map;\":\"↦\",\"mapsto;\":\"↦\",\"mapstodown;\":\"↧\",\"mapstoleft;\":\"↤\",\"mapstoup;\":\"↥\",\"marker;\":\"▮\",\"mcomma;\":\"⨩\",\"Mcy;\":\"М\",\"mcy;\":\"м\",\"mdash;\":\"—\",\"mDDot;\":\"∺\",\"measuredangle;\":\"∡\",\"MediumSpace;\":\" \",\"Mellintrf;\":\"ℳ\",\"Mfr;\":\"𝔐\",\"mfr;\":\"𝔪\",\"mho;\":\"℧\",\"micro;\":\"µ\",micro:\"µ\",\"midast;\":\"*\",\"midcir;\":\"⫰\",\"mid;\":\"∣\",\"middot;\":\"·\",middot:\"·\",\"minusb;\":\"⊟\",\"minus;\":\"−\",\"minusd;\":\"∸\",\"minusdu;\":\"⨪\",\"MinusPlus;\":\"∓\",\"mlcp;\":\"⫛\",\"mldr;\":\"…\",\"mnplus;\":\"∓\",\"models;\":\"⊧\",\"Mopf;\":\"𝕄\",\"mopf;\":\"𝕞\",\"mp;\":\"∓\",\"mscr;\":\"𝓂\",\"Mscr;\":\"ℳ\",\"mstpos;\":\"∾\",\"Mu;\":\"Μ\",\"mu;\":\"μ\",\"multimap;\":\"⊸\",\"mumap;\":\"⊸\",\"nabla;\":\"∇\",\"Nacute;\":\"Ń\",\"nacute;\":\"ń\",\"nang;\":\"∠⃒\",\"nap;\":\"≉\",\"napE;\":\"⩰̸\",\"napid;\":\"≋̸\",\"napos;\":\"ŉ\",\"napprox;\":\"≉\",\"natural;\":\"♮\",\"naturals;\":\"ℕ\",\"natur;\":\"♮\",\"nbsp;\":\" \",nbsp:\" \",\"nbump;\":\"≎̸\",\"nbumpe;\":\"≏̸\",\"ncap;\":\"⩃\",\"Ncaron;\":\"Ň\",\"ncaron;\":\"ň\",\"Ncedil;\":\"Ņ\",\"ncedil;\":\"ņ\",\"ncong;\":\"≇\",\"ncongdot;\":\"⩭̸\",\"ncup;\":\"⩂\",\"Ncy;\":\"Н\",\"ncy;\":\"н\",\"ndash;\":\"–\",\"nearhk;\":\"⤤\",\"nearr;\":\"↗\",\"neArr;\":\"⇗\",\"nearrow;\":\"↗\",\"ne;\":\"≠\",\"nedot;\":\"≐̸\",\"NegativeMediumSpace;\":\"​\",\"NegativeThickSpace;\":\"​\",\"NegativeThinSpace;\":\"​\",\"NegativeVeryThinSpace;\":\"​\",\"nequiv;\":\"≢\",\"nesear;\":\"⤨\",\"nesim;\":\"≂̸\",\"NestedGreaterGreater;\":\"≫\",\"NestedLessLess;\":\"≪\",\"NewLine;\":\"\\n\",\"nexist;\":\"∄\",\"nexists;\":\"∄\",\"Nfr;\":\"𝔑\",\"nfr;\":\"𝔫\",\"ngE;\":\"≧̸\",\"nge;\":\"≱\",\"ngeq;\":\"≱\",\"ngeqq;\":\"≧̸\",\"ngeqslant;\":\"⩾̸\",\"nges;\":\"⩾̸\",\"nGg;\":\"⋙̸\",\"ngsim;\":\"≵\",\"nGt;\":\"≫⃒\",\"ngt;\":\"≯\",\"ngtr;\":\"≯\",\"nGtv;\":\"≫̸\",\"nharr;\":\"↮\",\"nhArr;\":\"⇎\",\"nhpar;\":\"⫲\",\"ni;\":\"∋\",\"nis;\":\"⋼\",\"nisd;\":\"⋺\",\"niv;\":\"∋\",\"NJcy;\":\"Њ\",\"njcy;\":\"њ\",\"nlarr;\":\"↚\",\"nlArr;\":\"⇍\",\"nldr;\":\"‥\",\"nlE;\":\"≦̸\",\"nle;\":\"≰\",\"nleftarrow;\":\"↚\",\"nLeftarrow;\":\"⇍\",\"nleftrightarrow;\":\"↮\",\"nLeftrightarrow;\":\"⇎\",\"nleq;\":\"≰\",\"nleqq;\":\"≦̸\",\"nleqslant;\":\"⩽̸\",\"nles;\":\"⩽̸\",\"nless;\":\"≮\",\"nLl;\":\"⋘̸\",\"nlsim;\":\"≴\",\"nLt;\":\"≪⃒\",\"nlt;\":\"≮\",\"nltri;\":\"⋪\",\"nltrie;\":\"⋬\",\"nLtv;\":\"≪̸\",\"nmid;\":\"∤\",\"NoBreak;\":\"⁠\",\"NonBreakingSpace;\":\" \",\"nopf;\":\"𝕟\",\"Nopf;\":\"ℕ\",\"Not;\":\"⫬\",\"not;\":\"¬\",not:\"¬\",\"NotCongruent;\":\"≢\",\"NotCupCap;\":\"≭\",\"NotDoubleVerticalBar;\":\"∦\",\"NotElement;\":\"∉\",\"NotEqual;\":\"≠\",\"NotEqualTilde;\":\"≂̸\",\"NotExists;\":\"∄\",\"NotGreater;\":\"≯\",\"NotGreaterEqual;\":\"≱\",\"NotGreaterFullEqual;\":\"≧̸\",\"NotGreaterGreater;\":\"≫̸\",\"NotGreaterLess;\":\"≹\",\"NotGreaterSlantEqual;\":\"⩾̸\",\"NotGreaterTilde;\":\"≵\",\"NotHumpDownHump;\":\"≎̸\",\"NotHumpEqual;\":\"≏̸\",\"notin;\":\"∉\",\"notindot;\":\"⋵̸\",\"notinE;\":\"⋹̸\",\"notinva;\":\"∉\",\"notinvb;\":\"⋷\",\"notinvc;\":\"⋶\",\"NotLeftTriangleBar;\":\"⧏̸\",\"NotLeftTriangle;\":\"⋪\",\"NotLeftTriangleEqual;\":\"⋬\",\"NotLess;\":\"≮\",\"NotLessEqual;\":\"≰\",\"NotLessGreater;\":\"≸\",\"NotLessLess;\":\"≪̸\",\"NotLessSlantEqual;\":\"⩽̸\",\"NotLessTilde;\":\"≴\",\"NotNestedGreaterGreater;\":\"⪢̸\",\"NotNestedLessLess;\":\"⪡̸\",\"notni;\":\"∌\",\"notniva;\":\"∌\",\"notnivb;\":\"⋾\",\"notnivc;\":\"⋽\",\"NotPrecedes;\":\"⊀\",\"NotPrecedesEqual;\":\"⪯̸\",\"NotPrecedesSlantEqual;\":\"⋠\",\"NotReverseElement;\":\"∌\",\"NotRightTriangleBar;\":\"⧐̸\",\"NotRightTriangle;\":\"⋫\",\"NotRightTriangleEqual;\":\"⋭\",\"NotSquareSubset;\":\"⊏̸\",\"NotSquareSubsetEqual;\":\"⋢\",\"NotSquareSuperset;\":\"⊐̸\",\"NotSquareSupersetEqual;\":\"⋣\",\"NotSubset;\":\"⊂⃒\",\"NotSubsetEqual;\":\"⊈\",\"NotSucceeds;\":\"⊁\",\"NotSucceedsEqual;\":\"⪰̸\",\"NotSucceedsSlantEqual;\":\"⋡\",\"NotSucceedsTilde;\":\"≿̸\",\"NotSuperset;\":\"⊃⃒\",\"NotSupersetEqual;\":\"⊉\",\"NotTilde;\":\"≁\",\"NotTildeEqual;\":\"≄\",\"NotTildeFullEqual;\":\"≇\",\"NotTildeTilde;\":\"≉\",\"NotVerticalBar;\":\"∤\",\"nparallel;\":\"∦\",\"npar;\":\"∦\",\"nparsl;\":\"⫽⃥\",\"npart;\":\"∂̸\",\"npolint;\":\"⨔\",\"npr;\":\"⊀\",\"nprcue;\":\"⋠\",\"nprec;\":\"⊀\",\"npreceq;\":\"⪯̸\",\"npre;\":\"⪯̸\",\"nrarrc;\":\"⤳̸\",\"nrarr;\":\"↛\",\"nrArr;\":\"⇏\",\"nrarrw;\":\"↝̸\",\"nrightarrow;\":\"↛\",\"nRightarrow;\":\"⇏\",\"nrtri;\":\"⋫\",\"nrtrie;\":\"⋭\",\"nsc;\":\"⊁\",\"nsccue;\":\"⋡\",\"nsce;\":\"⪰̸\",\"Nscr;\":\"𝒩\",\"nscr;\":\"𝓃\",\"nshortmid;\":\"∤\",\"nshortparallel;\":\"∦\",\"nsim;\":\"≁\",\"nsime;\":\"≄\",\"nsimeq;\":\"≄\",\"nsmid;\":\"∤\",\"nspar;\":\"∦\",\"nsqsube;\":\"⋢\",\"nsqsupe;\":\"⋣\",\"nsub;\":\"⊄\",\"nsubE;\":\"⫅̸\",\"nsube;\":\"⊈\",\"nsubset;\":\"⊂⃒\",\"nsubseteq;\":\"⊈\",\"nsubseteqq;\":\"⫅̸\",\"nsucc;\":\"⊁\",\"nsucceq;\":\"⪰̸\",\"nsup;\":\"⊅\",\"nsupE;\":\"⫆̸\",\"nsupe;\":\"⊉\",\"nsupset;\":\"⊃⃒\",\"nsupseteq;\":\"⊉\",\"nsupseteqq;\":\"⫆̸\",\"ntgl;\":\"≹\",\"Ntilde;\":\"Ñ\",Ntilde:\"Ñ\",\"ntilde;\":\"ñ\",ntilde:\"ñ\",\"ntlg;\":\"≸\",\"ntriangleleft;\":\"⋪\",\"ntrianglelefteq;\":\"⋬\",\"ntriangleright;\":\"⋫\",\"ntrianglerighteq;\":\"⋭\",\"Nu;\":\"Ν\",\"nu;\":\"ν\",\"num;\":\"#\",\"numero;\":\"№\",\"numsp;\":\" \",\"nvap;\":\"≍⃒\",\"nvdash;\":\"⊬\",\"nvDash;\":\"⊭\",\"nVdash;\":\"⊮\",\"nVDash;\":\"⊯\",\"nvge;\":\"≥⃒\",\"nvgt;\":\">⃒\",\"nvHarr;\":\"⤄\",\"nvinfin;\":\"⧞\",\"nvlArr;\":\"⤂\",\"nvle;\":\"≤⃒\",\"nvlt;\":\"<⃒\",\"nvltrie;\":\"⊴⃒\",\"nvrArr;\":\"⤃\",\"nvrtrie;\":\"⊵⃒\",\"nvsim;\":\"∼⃒\",\"nwarhk;\":\"⤣\",\"nwarr;\":\"↖\",\"nwArr;\":\"⇖\",\"nwarrow;\":\"↖\",\"nwnear;\":\"⤧\",\"Oacute;\":\"Ó\",Oacute:\"Ó\",\"oacute;\":\"ó\",oacute:\"ó\",\"oast;\":\"⊛\",\"Ocirc;\":\"Ô\",Ocirc:\"Ô\",\"ocirc;\":\"ô\",ocirc:\"ô\",\"ocir;\":\"⊚\",\"Ocy;\":\"О\",\"ocy;\":\"о\",\"odash;\":\"⊝\",\"Odblac;\":\"Ő\",\"odblac;\":\"ő\",\"odiv;\":\"⨸\",\"odot;\":\"⊙\",\"odsold;\":\"⦼\",\"OElig;\":\"Œ\",\"oelig;\":\"œ\",\"ofcir;\":\"⦿\",\"Ofr;\":\"𝔒\",\"ofr;\":\"𝔬\",\"ogon;\":\"˛\",\"Ograve;\":\"Ò\",Ograve:\"Ò\",\"ograve;\":\"ò\",ograve:\"ò\",\"ogt;\":\"⧁\",\"ohbar;\":\"⦵\",\"ohm;\":\"Ω\",\"oint;\":\"∮\",\"olarr;\":\"↺\",\"olcir;\":\"⦾\",\"olcross;\":\"⦻\",\"oline;\":\"‾\",\"olt;\":\"⧀\",\"Omacr;\":\"Ō\",\"omacr;\":\"ō\",\"Omega;\":\"Ω\",\"omega;\":\"ω\",\"Omicron;\":\"Ο\",\"omicron;\":\"ο\",\"omid;\":\"⦶\",\"ominus;\":\"⊖\",\"Oopf;\":\"𝕆\",\"oopf;\":\"𝕠\",\"opar;\":\"⦷\",\"OpenCurlyDoubleQuote;\":\"“\",\"OpenCurlyQuote;\":\"‘\",\"operp;\":\"⦹\",\"oplus;\":\"⊕\",\"orarr;\":\"↻\",\"Or;\":\"⩔\",\"or;\":\"∨\",\"ord;\":\"⩝\",\"order;\":\"ℴ\",\"orderof;\":\"ℴ\",\"ordf;\":\"ª\",ordf:\"ª\",\"ordm;\":\"º\",ordm:\"º\",\"origof;\":\"⊶\",\"oror;\":\"⩖\",\"orslope;\":\"⩗\",\"orv;\":\"⩛\",\"oS;\":\"Ⓢ\",\"Oscr;\":\"𝒪\",\"oscr;\":\"ℴ\",\"Oslash;\":\"Ø\",Oslash:\"Ø\",\"oslash;\":\"ø\",oslash:\"ø\",\"osol;\":\"⊘\",\"Otilde;\":\"Õ\",Otilde:\"Õ\",\"otilde;\":\"õ\",otilde:\"õ\",\"otimesas;\":\"⨶\",\"Otimes;\":\"⨷\",\"otimes;\":\"⊗\",\"Ouml;\":\"Ö\",Ouml:\"Ö\",\"ouml;\":\"ö\",ouml:\"ö\",\"ovbar;\":\"⌽\",\"OverBar;\":\"‾\",\"OverBrace;\":\"⏞\",\"OverBracket;\":\"⎴\",\"OverParenthesis;\":\"⏜\",\"para;\":\"¶\",para:\"¶\",\"parallel;\":\"∥\",\"par;\":\"∥\",\"parsim;\":\"⫳\",\"parsl;\":\"⫽\",\"part;\":\"∂\",\"PartialD;\":\"∂\",\"Pcy;\":\"П\",\"pcy;\":\"п\",\"percnt;\":\"%\",\"period;\":\".\",\"permil;\":\"‰\",\"perp;\":\"⊥\",\"pertenk;\":\"‱\",\"Pfr;\":\"𝔓\",\"pfr;\":\"𝔭\",\"Phi;\":\"Φ\",\"phi;\":\"φ\",\"phiv;\":\"ϕ\",\"phmmat;\":\"ℳ\",\"phone;\":\"☎\",\"Pi;\":\"Π\",\"pi;\":\"π\",\"pitchfork;\":\"⋔\",\"piv;\":\"ϖ\",\"planck;\":\"ℏ\",\"planckh;\":\"ℎ\",\"plankv;\":\"ℏ\",\"plusacir;\":\"⨣\",\"plusb;\":\"⊞\",\"pluscir;\":\"⨢\",\"plus;\":\"+\",\"plusdo;\":\"∔\",\"plusdu;\":\"⨥\",\"pluse;\":\"⩲\",\"PlusMinus;\":\"±\",\"plusmn;\":\"±\",plusmn:\"±\",\"plussim;\":\"⨦\",\"plustwo;\":\"⨧\",\"pm;\":\"±\",\"Poincareplane;\":\"ℌ\",\"pointint;\":\"⨕\",\"popf;\":\"𝕡\",\"Popf;\":\"ℙ\",\"pound;\":\"£\",pound:\"£\",\"prap;\":\"⪷\",\"Pr;\":\"⪻\",\"pr;\":\"≺\",\"prcue;\":\"≼\",\"precapprox;\":\"⪷\",\"prec;\":\"≺\",\"preccurlyeq;\":\"≼\",\"Precedes;\":\"≺\",\"PrecedesEqual;\":\"⪯\",\"PrecedesSlantEqual;\":\"≼\",\"PrecedesTilde;\":\"≾\",\"preceq;\":\"⪯\",\"precnapprox;\":\"⪹\",\"precneqq;\":\"⪵\",\"precnsim;\":\"⋨\",\"pre;\":\"⪯\",\"prE;\":\"⪳\",\"precsim;\":\"≾\",\"prime;\":\"′\",\"Prime;\":\"″\",\"primes;\":\"ℙ\",\"prnap;\":\"⪹\",\"prnE;\":\"⪵\",\"prnsim;\":\"⋨\",\"prod;\":\"∏\",\"Product;\":\"∏\",\"profalar;\":\"⌮\",\"profline;\":\"⌒\",\"profsurf;\":\"⌓\",\"prop;\":\"∝\",\"Proportional;\":\"∝\",\"Proportion;\":\"∷\",\"propto;\":\"∝\",\"prsim;\":\"≾\",\"prurel;\":\"⊰\",\"Pscr;\":\"𝒫\",\"pscr;\":\"𝓅\",\"Psi;\":\"Ψ\",\"psi;\":\"ψ\",\"puncsp;\":\" \",\"Qfr;\":\"𝔔\",\"qfr;\":\"𝔮\",\"qint;\":\"⨌\",\"qopf;\":\"𝕢\",\"Qopf;\":\"ℚ\",\"qprime;\":\"⁗\",\"Qscr;\":\"𝒬\",\"qscr;\":\"𝓆\",\"quaternions;\":\"ℍ\",\"quatint;\":\"⨖\",\"quest;\":\"?\",\"questeq;\":\"≟\",\"quot;\":'\"',quot:'\"',\"QUOT;\":'\"',QUOT:'\"',\"rAarr;\":\"⇛\",\"race;\":\"∽̱\",\"Racute;\":\"Ŕ\",\"racute;\":\"ŕ\",\"radic;\":\"√\",\"raemptyv;\":\"⦳\",\"rang;\":\"⟩\",\"Rang;\":\"⟫\",\"rangd;\":\"⦒\",\"range;\":\"⦥\",\"rangle;\":\"⟩\",\"raquo;\":\"»\",raquo:\"»\",\"rarrap;\":\"⥵\",\"rarrb;\":\"⇥\",\"rarrbfs;\":\"⤠\",\"rarrc;\":\"⤳\",\"rarr;\":\"→\",\"Rarr;\":\"↠\",\"rArr;\":\"⇒\",\"rarrfs;\":\"⤞\",\"rarrhk;\":\"↪\",\"rarrlp;\":\"↬\",\"rarrpl;\":\"⥅\",\"rarrsim;\":\"⥴\",\"Rarrtl;\":\"⤖\",\"rarrtl;\":\"↣\",\"rarrw;\":\"↝\",\"ratail;\":\"⤚\",\"rAtail;\":\"⤜\",\"ratio;\":\"∶\",\"rationals;\":\"ℚ\",\"rbarr;\":\"⤍\",\"rBarr;\":\"⤏\",\"RBarr;\":\"⤐\",\"rbbrk;\":\"❳\",\"rbrace;\":\"}\",\"rbrack;\":\"]\",\"rbrke;\":\"⦌\",\"rbrksld;\":\"⦎\",\"rbrkslu;\":\"⦐\",\"Rcaron;\":\"Ř\",\"rcaron;\":\"ř\",\"Rcedil;\":\"Ŗ\",\"rcedil;\":\"ŗ\",\"rceil;\":\"⌉\",\"rcub;\":\"}\",\"Rcy;\":\"Р\",\"rcy;\":\"р\",\"rdca;\":\"⤷\",\"rdldhar;\":\"⥩\",\"rdquo;\":\"”\",\"rdquor;\":\"”\",\"rdsh;\":\"↳\",\"real;\":\"ℜ\",\"realine;\":\"ℛ\",\"realpart;\":\"ℜ\",\"reals;\":\"ℝ\",\"Re;\":\"ℜ\",\"rect;\":\"▭\",\"reg;\":\"®\",reg:\"®\",\"REG;\":\"®\",REG:\"®\",\"ReverseElement;\":\"∋\",\"ReverseEquilibrium;\":\"⇋\",\"ReverseUpEquilibrium;\":\"⥯\",\"rfisht;\":\"⥽\",\"rfloor;\":\"⌋\",\"rfr;\":\"𝔯\",\"Rfr;\":\"ℜ\",\"rHar;\":\"⥤\",\"rhard;\":\"⇁\",\"rharu;\":\"⇀\",\"rharul;\":\"⥬\",\"Rho;\":\"Ρ\",\"rho;\":\"ρ\",\"rhov;\":\"ϱ\",\"RightAngleBracket;\":\"⟩\",\"RightArrowBar;\":\"⇥\",\"rightarrow;\":\"→\",\"RightArrow;\":\"→\",\"Rightarrow;\":\"⇒\",\"RightArrowLeftArrow;\":\"⇄\",\"rightarrowtail;\":\"↣\",\"RightCeiling;\":\"⌉\",\"RightDoubleBracket;\":\"⟧\",\"RightDownTeeVector;\":\"⥝\",\"RightDownVectorBar;\":\"⥕\",\"RightDownVector;\":\"⇂\",\"RightFloor;\":\"⌋\",\"rightharpoondown;\":\"⇁\",\"rightharpoonup;\":\"⇀\",\"rightleftarrows;\":\"⇄\",\"rightleftharpoons;\":\"⇌\",\"rightrightarrows;\":\"⇉\",\"rightsquigarrow;\":\"↝\",\"RightTeeArrow;\":\"↦\",\"RightTee;\":\"⊢\",\"RightTeeVector;\":\"⥛\",\"rightthreetimes;\":\"⋌\",\"RightTriangleBar;\":\"⧐\",\"RightTriangle;\":\"⊳\",\"RightTriangleEqual;\":\"⊵\",\"RightUpDownVector;\":\"⥏\",\"RightUpTeeVector;\":\"⥜\",\"RightUpVectorBar;\":\"⥔\",\"RightUpVector;\":\"↾\",\"RightVectorBar;\":\"⥓\",\"RightVector;\":\"⇀\",\"ring;\":\"˚\",\"risingdotseq;\":\"≓\",\"rlarr;\":\"⇄\",\"rlhar;\":\"⇌\",\"rlm;\":\"‏\",\"rmoustache;\":\"⎱\",\"rmoust;\":\"⎱\",\"rnmid;\":\"⫮\",\"roang;\":\"⟭\",\"roarr;\":\"⇾\",\"robrk;\":\"⟧\",\"ropar;\":\"⦆\",\"ropf;\":\"𝕣\",\"Ropf;\":\"ℝ\",\"roplus;\":\"⨮\",\"rotimes;\":\"⨵\",\"RoundImplies;\":\"⥰\",\"rpar;\":\")\",\"rpargt;\":\"⦔\",\"rppolint;\":\"⨒\",\"rrarr;\":\"⇉\",\"Rrightarrow;\":\"⇛\",\"rsaquo;\":\"›\",\"rscr;\":\"𝓇\",\"Rscr;\":\"ℛ\",\"rsh;\":\"↱\",\"Rsh;\":\"↱\",\"rsqb;\":\"]\",\"rsquo;\":\"’\",\"rsquor;\":\"’\",\"rthree;\":\"⋌\",\"rtimes;\":\"⋊\",\"rtri;\":\"▹\",\"rtrie;\":\"⊵\",\"rtrif;\":\"▸\",\"rtriltri;\":\"⧎\",\"RuleDelayed;\":\"⧴\",\"ruluhar;\":\"⥨\",\"rx;\":\"℞\",\"Sacute;\":\"Ś\",\"sacute;\":\"ś\",\"sbquo;\":\"‚\",\"scap;\":\"⪸\",\"Scaron;\":\"Š\",\"scaron;\":\"š\",\"Sc;\":\"⪼\",\"sc;\":\"≻\",\"sccue;\":\"≽\",\"sce;\":\"⪰\",\"scE;\":\"⪴\",\"Scedil;\":\"Ş\",\"scedil;\":\"ş\",\"Scirc;\":\"Ŝ\",\"scirc;\":\"ŝ\",\"scnap;\":\"⪺\",\"scnE;\":\"⪶\",\"scnsim;\":\"⋩\",\"scpolint;\":\"⨓\",\"scsim;\":\"≿\",\"Scy;\":\"С\",\"scy;\":\"с\",\"sdotb;\":\"⊡\",\"sdot;\":\"⋅\",\"sdote;\":\"⩦\",\"searhk;\":\"⤥\",\"searr;\":\"↘\",\"seArr;\":\"⇘\",\"searrow;\":\"↘\",\"sect;\":\"§\",sect:\"§\",\"semi;\":\";\",\"seswar;\":\"⤩\",\"setminus;\":\"∖\",\"setmn;\":\"∖\",\"sext;\":\"✶\",\"Sfr;\":\"𝔖\",\"sfr;\":\"𝔰\",\"sfrown;\":\"⌢\",\"sharp;\":\"♯\",\"SHCHcy;\":\"Щ\",\"shchcy;\":\"щ\",\"SHcy;\":\"Ш\",\"shcy;\":\"ш\",\"ShortDownArrow;\":\"↓\",\"ShortLeftArrow;\":\"←\",\"shortmid;\":\"∣\",\"shortparallel;\":\"∥\",\"ShortRightArrow;\":\"→\",\"ShortUpArrow;\":\"↑\",\"shy;\":\"­\",shy:\"­\",\"Sigma;\":\"Σ\",\"sigma;\":\"σ\",\"sigmaf;\":\"ς\",\"sigmav;\":\"ς\",\"sim;\":\"∼\",\"simdot;\":\"⩪\",\"sime;\":\"≃\",\"simeq;\":\"≃\",\"simg;\":\"⪞\",\"simgE;\":\"⪠\",\"siml;\":\"⪝\",\"simlE;\":\"⪟\",\"simne;\":\"≆\",\"simplus;\":\"⨤\",\"simrarr;\":\"⥲\",\"slarr;\":\"←\",\"SmallCircle;\":\"∘\",\"smallsetminus;\":\"∖\",\"smashp;\":\"⨳\",\"smeparsl;\":\"⧤\",\"smid;\":\"∣\",\"smile;\":\"⌣\",\"smt;\":\"⪪\",\"smte;\":\"⪬\",\"smtes;\":\"⪬︀\",\"SOFTcy;\":\"Ь\",\"softcy;\":\"ь\",\"solbar;\":\"⌿\",\"solb;\":\"⧄\",\"sol;\":\"/\",\"Sopf;\":\"𝕊\",\"sopf;\":\"𝕤\",\"spades;\":\"♠\",\"spadesuit;\":\"♠\",\"spar;\":\"∥\",\"sqcap;\":\"⊓\",\"sqcaps;\":\"⊓︀\",\"sqcup;\":\"⊔\",\"sqcups;\":\"⊔︀\",\"Sqrt;\":\"√\",\"sqsub;\":\"⊏\",\"sqsube;\":\"⊑\",\"sqsubset;\":\"⊏\",\"sqsubseteq;\":\"⊑\",\"sqsup;\":\"⊐\",\"sqsupe;\":\"⊒\",\"sqsupset;\":\"⊐\",\"sqsupseteq;\":\"⊒\",\"square;\":\"□\",\"Square;\":\"□\",\"SquareIntersection;\":\"⊓\",\"SquareSubset;\":\"⊏\",\"SquareSubsetEqual;\":\"⊑\",\"SquareSuperset;\":\"⊐\",\"SquareSupersetEqual;\":\"⊒\",\"SquareUnion;\":\"⊔\",\"squarf;\":\"▪\",\"squ;\":\"□\",\"squf;\":\"▪\",\"srarr;\":\"→\",\"Sscr;\":\"𝒮\",\"sscr;\":\"𝓈\",\"ssetmn;\":\"∖\",\"ssmile;\":\"⌣\",\"sstarf;\":\"⋆\",\"Star;\":\"⋆\",\"star;\":\"☆\",\"starf;\":\"★\",\"straightepsilon;\":\"ϵ\",\"straightphi;\":\"ϕ\",\"strns;\":\"¯\",\"sub;\":\"⊂\",\"Sub;\":\"⋐\",\"subdot;\":\"⪽\",\"subE;\":\"⫅\",\"sube;\":\"⊆\",\"subedot;\":\"⫃\",\"submult;\":\"⫁\",\"subnE;\":\"⫋\",\"subne;\":\"⊊\",\"subplus;\":\"⪿\",\"subrarr;\":\"⥹\",\"subset;\":\"⊂\",\"Subset;\":\"⋐\",\"subseteq;\":\"⊆\",\"subseteqq;\":\"⫅\",\"SubsetEqual;\":\"⊆\",\"subsetneq;\":\"⊊\",\"subsetneqq;\":\"⫋\",\"subsim;\":\"⫇\",\"subsub;\":\"⫕\",\"subsup;\":\"⫓\",\"succapprox;\":\"⪸\",\"succ;\":\"≻\",\"succcurlyeq;\":\"≽\",\"Succeeds;\":\"≻\",\"SucceedsEqual;\":\"⪰\",\"SucceedsSlantEqual;\":\"≽\",\"SucceedsTilde;\":\"≿\",\"succeq;\":\"⪰\",\"succnapprox;\":\"⪺\",\"succneqq;\":\"⪶\",\"succnsim;\":\"⋩\",\"succsim;\":\"≿\",\"SuchThat;\":\"∋\",\"sum;\":\"∑\",\"Sum;\":\"∑\",\"sung;\":\"♪\",\"sup1;\":\"¹\",sup1:\"¹\",\"sup2;\":\"²\",sup2:\"²\",\"sup3;\":\"³\",sup3:\"³\",\"sup;\":\"⊃\",\"Sup;\":\"⋑\",\"supdot;\":\"⪾\",\"supdsub;\":\"⫘\",\"supE;\":\"⫆\",\"supe;\":\"⊇\",\"supedot;\":\"⫄\",\"Superset;\":\"⊃\",\"SupersetEqual;\":\"⊇\",\"suphsol;\":\"⟉\",\"suphsub;\":\"⫗\",\"suplarr;\":\"⥻\",\"supmult;\":\"⫂\",\"supnE;\":\"⫌\",\"supne;\":\"⊋\",\"supplus;\":\"⫀\",\"supset;\":\"⊃\",\"Supset;\":\"⋑\",\"supseteq;\":\"⊇\",\"supseteqq;\":\"⫆\",\"supsetneq;\":\"⊋\",\"supsetneqq;\":\"⫌\",\"supsim;\":\"⫈\",\"supsub;\":\"⫔\",\"supsup;\":\"⫖\",\"swarhk;\":\"⤦\",\"swarr;\":\"↙\",\"swArr;\":\"⇙\",\"swarrow;\":\"↙\",\"swnwar;\":\"⤪\",\"szlig;\":\"ß\",szlig:\"ß\",\"Tab;\":\"\t\",\"target;\":\"⌖\",\"Tau;\":\"Τ\",\"tau;\":\"τ\",\"tbrk;\":\"⎴\",\"Tcaron;\":\"Ť\",\"tcaron;\":\"ť\",\"Tcedil;\":\"Ţ\",\"tcedil;\":\"ţ\",\"Tcy;\":\"Т\",\"tcy;\":\"т\",\"tdot;\":\"⃛\",\"telrec;\":\"⌕\",\"Tfr;\":\"𝔗\",\"tfr;\":\"𝔱\",\"there4;\":\"∴\",\"therefore;\":\"∴\",\"Therefore;\":\"∴\",\"Theta;\":\"Θ\",\"theta;\":\"θ\",\"thetasym;\":\"ϑ\",\"thetav;\":\"ϑ\",\"thickapprox;\":\"≈\",\"thicksim;\":\"∼\",\"ThickSpace;\":\"  \",\"ThinSpace;\":\" \",\"thinsp;\":\" \",\"thkap;\":\"≈\",\"thksim;\":\"∼\",\"THORN;\":\"Þ\",THORN:\"Þ\",\"thorn;\":\"þ\",thorn:\"þ\",\"tilde;\":\"˜\",\"Tilde;\":\"∼\",\"TildeEqual;\":\"≃\",\"TildeFullEqual;\":\"≅\",\"TildeTilde;\":\"≈\",\"timesbar;\":\"⨱\",\"timesb;\":\"⊠\",\"times;\":\"×\",times:\"×\",\"timesd;\":\"⨰\",\"tint;\":\"∭\",\"toea;\":\"⤨\",\"topbot;\":\"⌶\",\"topcir;\":\"⫱\",\"top;\":\"⊤\",\"Topf;\":\"𝕋\",\"topf;\":\"𝕥\",\"topfork;\":\"⫚\",\"tosa;\":\"⤩\",\"tprime;\":\"‴\",\"trade;\":\"™\",\"TRADE;\":\"™\",\"triangle;\":\"▵\",\"triangledown;\":\"▿\",\"triangleleft;\":\"◃\",\"trianglelefteq;\":\"⊴\",\"triangleq;\":\"≜\",\"triangleright;\":\"▹\",\"trianglerighteq;\":\"⊵\",\"tridot;\":\"◬\",\"trie;\":\"≜\",\"triminus;\":\"⨺\",\"TripleDot;\":\"⃛\",\"triplus;\":\"⨹\",\"trisb;\":\"⧍\",\"tritime;\":\"⨻\",\"trpezium;\":\"⏢\",\"Tscr;\":\"𝒯\",\"tscr;\":\"𝓉\",\"TScy;\":\"Ц\",\"tscy;\":\"ц\",\"TSHcy;\":\"Ћ\",\"tshcy;\":\"ћ\",\"Tstrok;\":\"Ŧ\",\"tstrok;\":\"ŧ\",\"twixt;\":\"≬\",\"twoheadleftarrow;\":\"↞\",\"twoheadrightarrow;\":\"↠\",\"Uacute;\":\"Ú\",Uacute:\"Ú\",\"uacute;\":\"ú\",uacute:\"ú\",\"uarr;\":\"↑\",\"Uarr;\":\"↟\",\"uArr;\":\"⇑\",\"Uarrocir;\":\"⥉\",\"Ubrcy;\":\"Ў\",\"ubrcy;\":\"ў\",\"Ubreve;\":\"Ŭ\",\"ubreve;\":\"ŭ\",\"Ucirc;\":\"Û\",Ucirc:\"Û\",\"ucirc;\":\"û\",ucirc:\"û\",\"Ucy;\":\"У\",\"ucy;\":\"у\",\"udarr;\":\"⇅\",\"Udblac;\":\"Ű\",\"udblac;\":\"ű\",\"udhar;\":\"⥮\",\"ufisht;\":\"⥾\",\"Ufr;\":\"𝔘\",\"ufr;\":\"𝔲\",\"Ugrave;\":\"Ù\",Ugrave:\"Ù\",\"ugrave;\":\"ù\",ugrave:\"ù\",\"uHar;\":\"⥣\",\"uharl;\":\"↿\",\"uharr;\":\"↾\",\"uhblk;\":\"▀\",\"ulcorn;\":\"⌜\",\"ulcorner;\":\"⌜\",\"ulcrop;\":\"⌏\",\"ultri;\":\"◸\",\"Umacr;\":\"Ū\",\"umacr;\":\"ū\",\"uml;\":\"¨\",uml:\"¨\",\"UnderBar;\":\"_\",\"UnderBrace;\":\"⏟\",\"UnderBracket;\":\"⎵\",\"UnderParenthesis;\":\"⏝\",\"Union;\":\"⋃\",\"UnionPlus;\":\"⊎\",\"Uogon;\":\"Ų\",\"uogon;\":\"ų\",\"Uopf;\":\"𝕌\",\"uopf;\":\"𝕦\",\"UpArrowBar;\":\"⤒\",\"uparrow;\":\"↑\",\"UpArrow;\":\"↑\",\"Uparrow;\":\"⇑\",\"UpArrowDownArrow;\":\"⇅\",\"updownarrow;\":\"↕\",\"UpDownArrow;\":\"↕\",\"Updownarrow;\":\"⇕\",\"UpEquilibrium;\":\"⥮\",\"upharpoonleft;\":\"↿\",\"upharpoonright;\":\"↾\",\"uplus;\":\"⊎\",\"UpperLeftArrow;\":\"↖\",\"UpperRightArrow;\":\"↗\",\"upsi;\":\"υ\",\"Upsi;\":\"ϒ\",\"upsih;\":\"ϒ\",\"Upsilon;\":\"Υ\",\"upsilon;\":\"υ\",\"UpTeeArrow;\":\"↥\",\"UpTee;\":\"⊥\",\"upuparrows;\":\"⇈\",\"urcorn;\":\"⌝\",\"urcorner;\":\"⌝\",\"urcrop;\":\"⌎\",\"Uring;\":\"Ů\",\"uring;\":\"ů\",\"urtri;\":\"◹\",\"Uscr;\":\"𝒰\",\"uscr;\":\"𝓊\",\"utdot;\":\"⋰\",\"Utilde;\":\"Ũ\",\"utilde;\":\"ũ\",\"utri;\":\"▵\",\"utrif;\":\"▴\",\"uuarr;\":\"⇈\",\"Uuml;\":\"Ü\",Uuml:\"Ü\",\"uuml;\":\"ü\",uuml:\"ü\",\"uwangle;\":\"⦧\",\"vangrt;\":\"⦜\",\"varepsilon;\":\"ϵ\",\"varkappa;\":\"ϰ\",\"varnothing;\":\"∅\",\"varphi;\":\"ϕ\",\"varpi;\":\"ϖ\",\"varpropto;\":\"∝\",\"varr;\":\"↕\",\"vArr;\":\"⇕\",\"varrho;\":\"ϱ\",\"varsigma;\":\"ς\",\"varsubsetneq;\":\"⊊︀\",\"varsubsetneqq;\":\"⫋︀\",\"varsupsetneq;\":\"⊋︀\",\"varsupsetneqq;\":\"⫌︀\",\"vartheta;\":\"ϑ\",\"vartriangleleft;\":\"⊲\",\"vartriangleright;\":\"⊳\",\"vBar;\":\"⫨\",\"Vbar;\":\"⫫\",\"vBarv;\":\"⫩\",\"Vcy;\":\"В\",\"vcy;\":\"в\",\"vdash;\":\"⊢\",\"vDash;\":\"⊨\",\"Vdash;\":\"⊩\",\"VDash;\":\"⊫\",\"Vdashl;\":\"⫦\",\"veebar;\":\"⊻\",\"vee;\":\"∨\",\"Vee;\":\"⋁\",\"veeeq;\":\"≚\",\"vellip;\":\"⋮\",\"verbar;\":\"|\",\"Verbar;\":\"‖\",\"vert;\":\"|\",\"Vert;\":\"‖\",\"VerticalBar;\":\"∣\",\"VerticalLine;\":\"|\",\"VerticalSeparator;\":\"❘\",\"VerticalTilde;\":\"≀\",\"VeryThinSpace;\":\" \",\"Vfr;\":\"𝔙\",\"vfr;\":\"𝔳\",\"vltri;\":\"⊲\",\"vnsub;\":\"⊂⃒\",\"vnsup;\":\"⊃⃒\",\"Vopf;\":\"𝕍\",\"vopf;\":\"𝕧\",\"vprop;\":\"∝\",\"vrtri;\":\"⊳\",\"Vscr;\":\"𝒱\",\"vscr;\":\"𝓋\",\"vsubnE;\":\"⫋︀\",\"vsubne;\":\"⊊︀\",\"vsupnE;\":\"⫌︀\",\"vsupne;\":\"⊋︀\",\"Vvdash;\":\"⊪\",\"vzigzag;\":\"⦚\",\"Wcirc;\":\"Ŵ\",\"wcirc;\":\"ŵ\",\"wedbar;\":\"⩟\",\"wedge;\":\"∧\",\"Wedge;\":\"⋀\",\"wedgeq;\":\"≙\",\"weierp;\":\"℘\",\"Wfr;\":\"𝔚\",\"wfr;\":\"𝔴\",\"Wopf;\":\"𝕎\",\"wopf;\":\"𝕨\",\"wp;\":\"℘\",\"wr;\":\"≀\",\"wreath;\":\"≀\",\"Wscr;\":\"𝒲\",\"wscr;\":\"𝓌\",\"xcap;\":\"⋂\",\"xcirc;\":\"◯\",\"xcup;\":\"⋃\",\"xdtri;\":\"▽\",\"Xfr;\":\"𝔛\",\"xfr;\":\"𝔵\",\"xharr;\":\"⟷\",\"xhArr;\":\"⟺\",\"Xi;\":\"Ξ\",\"xi;\":\"ξ\",\"xlarr;\":\"⟵\",\"xlArr;\":\"⟸\",\"xmap;\":\"⟼\",\"xnis;\":\"⋻\",\"xodot;\":\"⨀\",\"Xopf;\":\"𝕏\",\"xopf;\":\"𝕩\",\"xoplus;\":\"⨁\",\"xotime;\":\"⨂\",\"xrarr;\":\"⟶\",\"xrArr;\":\"⟹\",\"Xscr;\":\"𝒳\",\"xscr;\":\"𝓍\",\"xsqcup;\":\"⨆\",\"xuplus;\":\"⨄\",\"xutri;\":\"△\",\"xvee;\":\"⋁\",\"xwedge;\":\"⋀\",\"Yacute;\":\"Ý\",Yacute:\"Ý\",\"yacute;\":\"ý\",yacute:\"ý\",\"YAcy;\":\"Я\",\"yacy;\":\"я\",\"Ycirc;\":\"Ŷ\",\"ycirc;\":\"ŷ\",\"Ycy;\":\"Ы\",\"ycy;\":\"ы\",\"yen;\":\"¥\",yen:\"¥\",\"Yfr;\":\"𝔜\",\"yfr;\":\"𝔶\",\"YIcy;\":\"Ї\",\"yicy;\":\"ї\",\"Yopf;\":\"𝕐\",\"yopf;\":\"𝕪\",\"Yscr;\":\"𝒴\",\"yscr;\":\"𝓎\",\"YUcy;\":\"Ю\",\"yucy;\":\"ю\",\"yuml;\":\"ÿ\",yuml:\"ÿ\",\"Yuml;\":\"Ÿ\",\"Zacute;\":\"Ź\",\"zacute;\":\"ź\",\"Zcaron;\":\"Ž\",\"zcaron;\":\"ž\",\"Zcy;\":\"З\",\"zcy;\":\"з\",\"Zdot;\":\"Ż\",\"zdot;\":\"ż\",\"zeetrf;\":\"ℨ\",\"ZeroWidthSpace;\":\"​\",\"Zeta;\":\"Ζ\",\"zeta;\":\"ζ\",\"zfr;\":\"𝔷\",\"Zfr;\":\"ℨ\",\"ZHcy;\":\"Ж\",\"zhcy;\":\"ж\",\"zigrarr;\":\"⇝\",\"zopf;\":\"𝕫\",\"Zopf;\":\"ℤ\",\"Zscr;\":\"𝒵\",\"zscr;\":\"𝓏\",\"zwj;\":\"‍\",\"zwnj;\":\"‌\"}\n},{}],13:[function(_dereq_,module){function replacer(key,value){return util.isUndefined(value)?\"\"+value:!util.isNumber(value)||!isNaN(value)&&isFinite(value)?util.isFunction(value)||util.isRegExp(value)?\"\"+value:value:\"\"+value}function truncate(s,n){return util.isString(s)?n>s.length?s:s.slice(0,n):s}function getMessage(self){return truncate(JSON.stringify(self.actual,replacer),128)+\" \"+self.operator+\" \"+truncate(JSON.stringify(self.expected,replacer),128)}function fail(actual,expected,message,operator,stackStartFunction){throw new assert.AssertionError({message:message,actual:actual,expected:expected,operator:operator,stackStartFunction:stackStartFunction})}function ok(value,message){value||fail(value,!0,message,\"==\",assert.ok)}function _deepEqual(actual,expected){if(actual===expected)return!0;if(util.isBuffer(actual)&&util.isBuffer(expected)){if(actual.length!=expected.length)return!1;for(var i=0;actual.length>i;i++)if(actual[i]!==expected[i])return!1;return!0}return util.isDate(actual)&&util.isDate(expected)?actual.getTime()===expected.getTime():util.isRegExp(actual)&&util.isRegExp(expected)?actual.source===expected.source&&actual.global===expected.global&&actual.multiline===expected.multiline&&actual.lastIndex===expected.lastIndex&&actual.ignoreCase===expected.ignoreCase:util.isObject(actual)||util.isObject(expected)?objEquiv(actual,expected):actual==expected}function isArguments(object){return\"[object Arguments]\"==Object.prototype.toString.call(object)}function objEquiv(a,b){if(util.isNullOrUndefined(a)||util.isNullOrUndefined(b))return!1;if(a.prototype!==b.prototype)return!1;if(isArguments(a))return isArguments(b)?(a=pSlice.call(a),b=pSlice.call(b),_deepEqual(a,b)):!1;try{var key,i,ka=objectKeys(a),kb=objectKeys(b)}catch(e){return!1}if(ka.length!=kb.length)return!1;for(ka.sort(),kb.sort(),i=ka.length-1;i>=0;i--)if(ka[i]!=kb[i])return!1;for(i=ka.length-1;i>=0;i--)if(key=ka[i],!_deepEqual(a[key],b[key]))return!1;return!0}function expectedException(actual,expected){return actual&&expected?\"[object RegExp]\"==Object.prototype.toString.call(expected)?expected.test(actual):actual instanceof expected?!0:expected.call({},actual)===!0?!0:!1:!1}function _throws(shouldThrow,block,expected,message){var actual;util.isString(expected)&&(message=expected,expected=null);try{block()}catch(e){actual=e}if(message=(expected&&expected.name?\" (\"+expected.name+\").\":\".\")+(message?\" \"+message:\".\"),shouldThrow&&!actual&&fail(actual,expected,\"Missing expected exception\"+message),!shouldThrow&&expectedException(actual,expected)&&fail(actual,expected,\"Got unwanted exception\"+message),shouldThrow&&actual&&expected&&!expectedException(actual,expected)||!shouldThrow&&actual)throw actual}var util=_dereq_(\"util/\"),pSlice=Array.prototype.slice,hasOwn=Object.prototype.hasOwnProperty,assert=module.exports=ok;assert.AssertionError=function(options){this.name=\"AssertionError\",this.actual=options.actual,this.expected=options.expected,this.operator=options.operator,options.message?(this.message=options.message,this.generatedMessage=!1):(this.message=getMessage(this),this.generatedMessage=!0);var stackStartFunction=options.stackStartFunction||fail;if(Error.captureStackTrace)Error.captureStackTrace(this,stackStartFunction);else{var err=Error();if(err.stack){var out=err.stack,fn_name=stackStartFunction.name,idx=out.indexOf(\"\\n\"+fn_name);if(idx>=0){var next_line=out.indexOf(\"\\n\",idx+1);out=out.substring(next_line+1)}this.stack=out}}},util.inherits(assert.AssertionError,Error),assert.fail=fail,assert.ok=ok,assert.equal=function(actual,expected,message){actual!=expected&&fail(actual,expected,message,\"==\",assert.equal)},assert.notEqual=function(actual,expected,message){actual==expected&&fail(actual,expected,message,\"!=\",assert.notEqual)},assert.deepEqual=function(actual,expected,message){_deepEqual(actual,expected)||fail(actual,expected,message,\"deepEqual\",assert.deepEqual)},assert.notDeepEqual=function(actual,expected,message){_deepEqual(actual,expected)&&fail(actual,expected,message,\"notDeepEqual\",assert.notDeepEqual)},assert.strictEqual=function(actual,expected,message){actual!==expected&&fail(actual,expected,message,\"===\",assert.strictEqual)},assert.notStrictEqual=function(actual,expected,message){actual===expected&&fail(actual,expected,message,\"!==\",assert.notStrictEqual)},assert.throws=function(){_throws.apply(this,[!0].concat(pSlice.call(arguments)))},assert.doesNotThrow=function(){_throws.apply(this,[!1].concat(pSlice.call(arguments)))},assert.ifError=function(err){if(err)throw err};var objectKeys=Object.keys||function(obj){var keys=[];for(var key in obj)hasOwn.call(obj,key)&&keys.push(key);return keys}},{\"util/\":15}],14:[function(_dereq_,module){module.exports=function(arg){return arg&&\"object\"==typeof arg&&\"function\"==typeof arg.copy&&\"function\"==typeof arg.fill&&\"function\"==typeof arg.readUInt8}},{}],15:[function(_dereq_,module,exports){(function(process,global){function inspect(obj,opts){var ctx={seen:[],stylize:stylizeNoColor};return arguments.length>=3&&(ctx.depth=arguments[2]),arguments.length>=4&&(ctx.colors=arguments[3]),isBoolean(opts)?ctx.showHidden=opts:opts&&exports._extend(ctx,opts),isUndefined(ctx.showHidden)&&(ctx.showHidden=!1),isUndefined(ctx.depth)&&(ctx.depth=2),isUndefined(ctx.colors)&&(ctx.colors=!1),isUndefined(ctx.customInspect)&&(ctx.customInspect=!0),ctx.colors&&(ctx.stylize=stylizeWithColor),formatValue(ctx,obj,ctx.depth)}function stylizeWithColor(str,styleType){var style=inspect.styles[styleType];return style?\"\u001b[\"+inspect.colors[style][0]+\"m\"+str+\"\u001b[\"+inspect.colors[style][1]+\"m\":str}function stylizeNoColor(str){return str}function arrayToHash(array){var hash={};return array.forEach(function(val){hash[val]=!0}),hash}function formatValue(ctx,value,recurseTimes){if(ctx.customInspect&&value&&isFunction(value.inspect)&&value.inspect!==exports.inspect&&(!value.constructor||value.constructor.prototype!==value)){var ret=value.inspect(recurseTimes,ctx);return isString(ret)||(ret=formatValue(ctx,ret,recurseTimes)),ret}var primitive=formatPrimitive(ctx,value);if(primitive)return primitive;var keys=Object.keys(value),visibleKeys=arrayToHash(keys);if(ctx.showHidden&&(keys=Object.getOwnPropertyNames(value)),isError(value)&&(keys.indexOf(\"message\")>=0||keys.indexOf(\"description\")>=0))return formatError(value);if(0===keys.length){if(isFunction(value)){var name=value.name?\": \"+value.name:\"\";return ctx.stylize(\"[Function\"+name+\"]\",\"special\")}if(isRegExp(value))return ctx.stylize(RegExp.prototype.toString.call(value),\"regexp\");if(isDate(value))return ctx.stylize(Date.prototype.toString.call(value),\"date\");if(isError(value))return formatError(value)}var base=\"\",array=!1,braces=[\"{\",\"}\"];if(isArray(value)&&(array=!0,braces=[\"[\",\"]\"]),isFunction(value)){var n=value.name?\": \"+value.name:\"\";base=\" [Function\"+n+\"]\"}if(isRegExp(value)&&(base=\" \"+RegExp.prototype.toString.call(value)),isDate(value)&&(base=\" \"+Date.prototype.toUTCString.call(value)),isError(value)&&(base=\" \"+formatError(value)),0===keys.length&&(!array||0==value.length))return braces[0]+base+braces[1];if(0>recurseTimes)return isRegExp(value)?ctx.stylize(RegExp.prototype.toString.call(value),\"regexp\"):ctx.stylize(\"[Object]\",\"special\");ctx.seen.push(value);var output;return output=array?formatArray(ctx,value,recurseTimes,visibleKeys,keys):keys.map(function(key){return formatProperty(ctx,value,recurseTimes,visibleKeys,key,array)}),ctx.seen.pop(),reduceToSingleString(output,base,braces)}function formatPrimitive(ctx,value){if(isUndefined(value))return ctx.stylize(\"undefined\",\"undefined\");if(isString(value)){var simple=\"'\"+JSON.stringify(value).replace(/^\"|\"$/g,\"\").replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"')+\"'\";return ctx.stylize(simple,\"string\")}return isNumber(value)?ctx.stylize(\"\"+value,\"number\"):isBoolean(value)?ctx.stylize(\"\"+value,\"boolean\"):isNull(value)?ctx.stylize(\"null\",\"null\"):void 0}function formatError(value){return\"[\"+Error.prototype.toString.call(value)+\"]\"}function formatArray(ctx,value,recurseTimes,visibleKeys,keys){for(var output=[],i=0,l=value.length;l>i;++i)hasOwnProperty(value,i+\"\")?output.push(formatProperty(ctx,value,recurseTimes,visibleKeys,i+\"\",!0)):output.push(\"\");return keys.forEach(function(key){key.match(/^\\d+$/)||output.push(formatProperty(ctx,value,recurseTimes,visibleKeys,key,!0))}),output}function formatProperty(ctx,value,recurseTimes,visibleKeys,key,array){var name,str,desc;if(desc=Object.getOwnPropertyDescriptor(value,key)||{value:value[key]},desc.get?str=desc.set?ctx.stylize(\"[Getter/Setter]\",\"special\"):ctx.stylize(\"[Getter]\",\"special\"):desc.set&&(str=ctx.stylize(\"[Setter]\",\"special\")),hasOwnProperty(visibleKeys,key)||(name=\"[\"+key+\"]\"),str||(0>ctx.seen.indexOf(desc.value)?(str=isNull(recurseTimes)?formatValue(ctx,desc.value,null):formatValue(ctx,desc.value,recurseTimes-1),str.indexOf(\"\\n\")>-1&&(str=array?str.split(\"\\n\").map(function(line){return\"  \"+line}).join(\"\\n\").substr(2):\"\\n\"+str.split(\"\\n\").map(function(line){return\"   \"+line}).join(\"\\n\"))):str=ctx.stylize(\"[Circular]\",\"special\")),isUndefined(name)){if(array&&key.match(/^\\d+$/))return str;name=JSON.stringify(\"\"+key),name.match(/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?(name=name.substr(1,name.length-2),name=ctx.stylize(name,\"name\")):(name=name.replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"').replace(/(^\"|\"$)/g,\"'\"),name=ctx.stylize(name,\"string\"))}return name+\": \"+str}function reduceToSingleString(output,base,braces){var numLinesEst=0,length=output.reduce(function(prev,cur){return numLinesEst++,cur.indexOf(\"\\n\")>=0&&numLinesEst++,prev+cur.replace(/\\u001b\\[\\d\\d?m/g,\"\").length+1},0);return length>60?braces[0]+(\"\"===base?\"\":base+\"\\n \")+\" \"+output.join(\",\\n  \")+\" \"+braces[1]:braces[0]+base+\" \"+output.join(\", \")+\" \"+braces[1]}function isArray(ar){return Array.isArray(ar)}function isBoolean(arg){return\"boolean\"==typeof arg}function isNull(arg){return null===arg}function isNullOrUndefined(arg){return null==arg}function isNumber(arg){return\"number\"==typeof arg}function isString(arg){return\"string\"==typeof arg}function isSymbol(arg){return\"symbol\"==typeof arg}function isUndefined(arg){return void 0===arg}function isRegExp(re){return isObject(re)&&\"[object RegExp]\"===objectToString(re)}function isObject(arg){return\"object\"==typeof arg&&null!==arg}function isDate(d){return isObject(d)&&\"[object Date]\"===objectToString(d)}function isError(e){return isObject(e)&&(\"[object Error]\"===objectToString(e)||e instanceof Error)}function isFunction(arg){return\"function\"==typeof arg}function isPrimitive(arg){return null===arg||\"boolean\"==typeof arg||\"number\"==typeof arg||\"string\"==typeof arg||\"symbol\"==typeof arg||arg===void 0}function objectToString(o){return Object.prototype.toString.call(o)}function pad(n){return 10>n?\"0\"+n.toString(10):n.toString(10)}function timestamp(){var d=new Date,time=[pad(d.getHours()),pad(d.getMinutes()),pad(d.getSeconds())].join(\":\");return[d.getDate(),months[d.getMonth()],time].join(\" \")}function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop)}var formatRegExp=/%[sdj%]/g;exports.format=function(f){if(!isString(f)){for(var objects=[],i=0;arguments.length>i;i++)objects.push(inspect(arguments[i]));return objects.join(\" \")}for(var i=1,args=arguments,len=args.length,str=(f+\"\").replace(formatRegExp,function(x){if(\"%%\"===x)return\"%\";if(i>=len)return x;switch(x){case\"%s\":return args[i++]+\"\";case\"%d\":return Number(args[i++]);case\"%j\":try{return JSON.stringify(args[i++])}catch(_){return\"[Circular]\"}default:return x}}),x=args[i];len>i;x=args[++i])str+=isNull(x)||!isObject(x)?\" \"+x:\" \"+inspect(x);return str},exports.deprecate=function(fn,msg){function deprecated(){if(!warned){if(process.throwDeprecation)throw Error(msg);process.traceDeprecation?console.trace(msg):console.error(msg),warned=!0}return fn.apply(this,arguments)}if(isUndefined(global.process))return function(){return exports.deprecate(fn,msg).apply(this,arguments)};if(process.noDeprecation===!0)return fn;var warned=!1;return deprecated};var debugEnviron,debugs={};exports.debuglog=function(set){if(isUndefined(debugEnviron)&&(debugEnviron=process.env.NODE_DEBUG||\"\"),set=set.toUpperCase(),!debugs[set])if(RegExp(\"\\\\b\"+set+\"\\\\b\",\"i\").test(debugEnviron)){var pid=process.pid;debugs[set]=function(){var msg=exports.format.apply(exports,arguments);console.error(\"%s %d: %s\",set,pid,msg)}}else debugs[set]=function(){};return debugs[set]},exports.inspect=inspect,inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},inspect.styles={special:\"cyan\",number:\"yellow\",\"boolean\":\"yellow\",undefined:\"grey\",\"null\":\"bold\",string:\"green\",date:\"magenta\",regexp:\"red\"},exports.isArray=isArray,exports.isBoolean=isBoolean,exports.isNull=isNull,exports.isNullOrUndefined=isNullOrUndefined,exports.isNumber=isNumber,exports.isString=isString,exports.isSymbol=isSymbol,exports.isUndefined=isUndefined,exports.isRegExp=isRegExp,exports.isObject=isObject,exports.isDate=isDate,exports.isError=isError,exports.isFunction=isFunction,exports.isPrimitive=isPrimitive,exports.isBuffer=_dereq_(\"./support/isBuffer\");var months=[\"Jan\",\"Feb\",\"Mar\",\"Apr\",\"May\",\"Jun\",\"Jul\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"];exports.log=function(){console.log(\"%s - %s\",timestamp(),exports.format.apply(exports,arguments))},exports.inherits=_dereq_(\"inherits\"),exports._extend=function(origin,add){if(!add||!isObject(add))return origin;for(var keys=Object.keys(add),i=keys.length;i--;)origin[keys[i]]=add[keys[i]];return origin}}).call(this,_dereq_(\"/usr/local/lib/node_modules/browserify/node_modules/insert-module-globals/node_modules/process/browser.js\"),\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:{})},{\"./support/isBuffer\":14,\"/usr/local/lib/node_modules/browserify/node_modules/insert-module-globals/node_modules/process/browser.js\":18,inherits:17}],16:[function(_dereq_,module){function EventEmitter(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function isFunction(arg){return\"function\"==typeof arg}function isNumber(arg){return\"number\"==typeof arg}function isObject(arg){return\"object\"==typeof arg&&null!==arg}function isUndefined(arg){return void 0===arg}module.exports=EventEmitter,EventEmitter.EventEmitter=EventEmitter,EventEmitter.prototype._events=void 0,EventEmitter.prototype._maxListeners=void 0,EventEmitter.defaultMaxListeners=10,EventEmitter.prototype.setMaxListeners=function(n){if(!isNumber(n)||0>n||isNaN(n))throw TypeError(\"n must be a positive number\");return this._maxListeners=n,this},EventEmitter.prototype.emit=function(type){var er,handler,len,args,i,listeners;if(this._events||(this._events={}),\"error\"===type&&(!this._events.error||isObject(this._events.error)&&!this._events.error.length))throw er=arguments[1],er instanceof Error?er:TypeError('Uncaught, unspecified \"error\" event.');if(handler=this._events[type],isUndefined(handler))return!1;if(isFunction(handler))switch(arguments.length){case 1:handler.call(this);break;case 2:handler.call(this,arguments[1]);break;case 3:handler.call(this,arguments[1],arguments[2]);break;default:for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];handler.apply(this,args)}else if(isObject(handler)){for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];for(listeners=handler.slice(),len=listeners.length,i=0;len>i;i++)listeners[i].apply(this,args)}return!0},EventEmitter.prototype.addListener=function(type,listener){var m;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(this._events||(this._events={}),this._events.newListener&&this.emit(\"newListener\",type,isFunction(listener.listener)?listener.listener:listener),this._events[type]?isObject(this._events[type])?this._events[type].push(listener):this._events[type]=[this._events[type],listener]:this._events[type]=listener,isObject(this._events[type])&&!this._events[type].warned){var m;m=isUndefined(this._maxListeners)?EventEmitter.defaultMaxListeners:this._maxListeners,m&&m>0&&this._events[type].length>m&&(this._events[type].warned=!0,console.error(\"(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.\",this._events[type].length),console.trace())}return this},EventEmitter.prototype.on=EventEmitter.prototype.addListener,EventEmitter.prototype.once=function(type,listener){function g(){this.removeListener(type,g),fired||(fired=!0,listener.apply(this,arguments))}if(!isFunction(listener))throw TypeError(\"listener must be a function\");var fired=!1;return g.listener=listener,this.on(type,g),this},EventEmitter.prototype.removeListener=function(type,listener){var list,position,length,i;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(!this._events||!this._events[type])return this;if(list=this._events[type],length=list.length,position=-1,list===listener||isFunction(list.listener)&&list.listener===listener)delete this._events[type],this._events.removeListener&&this.emit(\"removeListener\",type,listener);else if(isObject(list)){for(i=length;i-->0;)if(list[i]===listener||list[i].listener&&list[i].listener===listener){position=i;break}if(0>position)return this;1===list.length?(list.length=0,delete this._events[type]):list.splice(position,1),this._events.removeListener&&this.emit(\"removeListener\",type,listener)}return this},EventEmitter.prototype.removeAllListeners=function(type){var key,listeners;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[type]&&delete this._events[type],this;if(0===arguments.length){for(key in this._events)\"removeListener\"!==key&&this.removeAllListeners(key);return this.removeAllListeners(\"removeListener\"),this._events={},this}if(listeners=this._events[type],isFunction(listeners))this.removeListener(type,listeners);else for(;listeners.length;)this.removeListener(type,listeners[listeners.length-1]);return delete this._events[type],this},EventEmitter.prototype.listeners=function(type){var ret;return ret=this._events&&this._events[type]?isFunction(this._events[type])?[this._events[type]]:this._events[type].slice():[]},EventEmitter.listenerCount=function(emitter,type){var ret;return ret=emitter._events&&emitter._events[type]?isFunction(emitter._events[type])?1:emitter._events[type].length:0}},{}],17:[function(_dereq_,module){module.exports=\"function\"==typeof Object.create?function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})}:function(ctor,superCtor){ctor.super_=superCtor;var TempCtor=function(){};TempCtor.prototype=superCtor.prototype,ctor.prototype=new TempCtor,ctor.prototype.constructor=ctor}},{}],18:[function(_dereq_,module){function noop(){}var process=module.exports={};process.nextTick=function(){var canSetImmediate=\"undefined\"!=typeof window&&window.setImmediate,canPost=\"undefined\"!=typeof window&&window.postMessage&&window.addEventListener;if(canSetImmediate)return function(f){return window.setImmediate(f)};if(canPost){var queue=[];return window.addEventListener(\"message\",function(ev){var source=ev.source;if((source===window||null===source)&&\"process-tick\"===ev.data&&(ev.stopPropagation(),queue.length>0)){var fn=queue.shift();fn()}},!0),function(fn){queue.push(fn),window.postMessage(\"process-tick\",\"*\")}}return function(fn){setTimeout(fn,0)}}(),process.title=\"browser\",process.browser=!0,process.env={},process.argv=[],process.on=noop,process.once=noop,process.off=noop,process.emit=noop,process.binding=function(){throw Error(\"process.binding is not supported\")},process.cwd=function(){return\"/\"},process.chdir=function(){throw Error(\"process.chdir is not supported\")}},{}],19:[function(_dereq_,module){module.exports=_dereq_(14)},{}],20:[function(_dereq_,module){module.exports=_dereq_(15)},{\"./support/isBuffer\":19,\"/usr/local/lib/node_modules/browserify/node_modules/insert-module-globals/node_modules/process/browser.js\":18,inherits:17}]},{},[9])(9)}),ace.define(\"ace/mode/html_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/lang\",\"ace/worker/mirror\",\"ace/mode/html/saxparser\"],function(acequire,exports){\"use strict\";var oop=acequire(\"../lib/oop\");acequire(\"../lib/lang\");var Mirror=acequire(\"../worker/mirror\").Mirror,SAXParser=acequire(\"./html/saxparser\").SAXParser,errorTypes={\"expected-doctype-but-got-start-tag\":\"info\",\"expected-doctype-but-got-chars\":\"info\",\"non-html-root\":\"info\"},Worker=exports.Worker=function(sender){Mirror.call(this,sender),this.setTimeout(400),this.context=null};oop.inherits(Worker,Mirror),function(){this.setOptions=function(options){this.context=options.context},this.onUpdate=function(){var value=this.doc.getValue();if(value){var parser=new SAXParser,errors=[],noop=function(){};parser.contentHandler={startDocument:noop,endDocument:noop,startElement:noop,endElement:noop,characters:noop},parser.errorHandler={error:function(message,location,code){errors.push({row:location.line,column:location.column,text:message,type:errorTypes[code]||\"error\"})}},this.context?parser.parseFragment(value,this.context):parser.parse(value),this.sender.emit(\"error\",errors)}}}.call(Worker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object\n});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 935 */
/***/ (function(module, exports) {

ace.define("ace/snippets/markdown",["require","exports","module"],function(e,t,n){"use strict";t.snippetText='# Markdown\n\n# Includes octopress (http://octopress.org/) snippets\n\nsnippet [\n	[${1:text}](http://${2:address} "${3:title}")\nsnippet [*\n	[${1:link}](${2:`@*`} "${3:title}")${4}\n\nsnippet [:\n	[${1:id}]: http://${2:url} "${3:title}"\nsnippet [:*\n	[${1:id}]: ${2:`@*`} "${3:title}"\n\nsnippet ![\n	![${1:alttext}](${2:/images/image.jpg} "${3:title}")\nsnippet ![*\n	![${1:alt}](${2:`@*`} "${3:title}")${4}\n\nsnippet ![:\n	![${1:id}]: ${2:url} "${3:title}"\nsnippet ![:*\n	![${1:id}]: ${2:`@*`} "${3:title}"\n\nsnippet ===\nregex /^/=+/=*//\n	${PREV_LINE/./=/g}\n	\n	${0}\nsnippet ---\nregex /^/-+/-*//\n	${PREV_LINE/./-/g}\n	\n	${0}\nsnippet blockquote\n	{% blockquote %}\n	${1:quote}\n	{% endblockquote %}\n\nsnippet blockquote-author\n	{% blockquote ${1:author}, ${2:title} %}\n	${3:quote}\n	{% endblockquote %}\n\nsnippet blockquote-link\n	{% blockquote ${1:author} ${2:URL} ${3:link_text} %}\n	${4:quote}\n	{% endblockquote %}\n\nsnippet bt-codeblock-short\n	```\n	${1:code_snippet}\n	```\n\nsnippet bt-codeblock-full\n	``` ${1:language} ${2:title} ${3:URL} ${4:link_text}\n	${5:code_snippet}\n	```\n\nsnippet codeblock-short\n	{% codeblock %}\n	${1:code_snippet}\n	{% endcodeblock %}\n\nsnippet codeblock-full\n	{% codeblock ${1:title} lang:${2:language} ${3:URL} ${4:link_text} %}\n	${5:code_snippet}\n	{% endcodeblock %}\n\nsnippet gist-full\n	{% gist ${1:gist_id} ${2:filename} %}\n\nsnippet gist-short\n	{% gist ${1:gist_id} %}\n\nsnippet img\n	{% img ${1:class} ${2:URL} ${3:width} ${4:height} ${5:title_text} ${6:alt_text} %}\n\nsnippet youtube\n	{% youtube ${1:video_id} %}\n\n# The quote should appear only once in the text. It is inherently part of it.\n# See http://octopress.org/docs/plugins/pullquote/ for more info.\n\nsnippet pullquote\n	{% pullquote %}\n	${1:text} {" ${2:quote} "} ${3:text}\n	{% endpullquote %}\n',t.scope="markdown"})

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

ace.define("ace/mode/json_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var JsonHighlightRules = function() {
    this.$rules = {
        "start" : [
            {
                token : "variable", // single line
                regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'
            }, {
                token : "string", // single line
                regex : '"',
                next  : "string"
            }, {
                token : "constant.numeric", // hex
                regex : "0[xX][0-9a-fA-F]+\\b"
            }, {
                token : "constant.numeric", // float
                regex : "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
            }, {
                token : "constant.language.boolean",
                regex : "(?:true|false)\\b"
            }, {
                token : "invalid.illegal", // single quoted strings are not allowed
                regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
            }, {
                token : "invalid.illegal", // comments are not allowed
                regex : "\\/\\/.*$"
            }, {
                token : "paren.lparen",
                regex : "[[({]"
            }, {
                token : "paren.rparen",
                regex : "[\\])}]"
            }, {
                token : "text",
                regex : "\\s+"
            }
        ],
        "string" : [
            {
                token : "constant.language.escape",
                regex : /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
            }, {
                token : "string",
                regex : '[^"\\\\]+'
            }, {
                token : "string",
                regex : '"',
                next  : "start"
            }, {
                token : "string",
                regex : "",
                next  : "start"
            }
        ]
    };
    
};

oop.inherits(JsonHighlightRules, TextHighlightRules);

exports.JsonHighlightRules = JsonHighlightRules;
});

ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;

var MatchingBraceOutdent = function() {};

(function() {

    this.checkOutdent = function(line, input) {
        if (! /^\s+$/.test(line))
            return false;

        return /^\s*\}/.test(input);
    };

    this.autoOutdent = function(doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);

        if (!match) return 0;

        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({row: row, column: column});

        if (!openBracePos || openBracePos.row == row) return 0;

        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column-1), indent);
    };

    this.$getIndent = function(line) {
        return line.match(/^\s*/)[0];
    };

}).call(MatchingBraceOutdent.prototype);

exports.MatchingBraceOutdent = MatchingBraceOutdent;
});

ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Range = acequire("../../range").Range;
var BaseFoldMode = acequire("./fold_mode").FoldMode;

var FoldMode = exports.FoldMode = function(commentRegex) {
    if (commentRegex) {
        this.foldingStartMarker = new RegExp(
            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
        );
        this.foldingStopMarker = new RegExp(
            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
        );
    }
};
oop.inherits(FoldMode, BaseFoldMode);

(function() {
    
    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
    this._getFoldWidgetBase = this.getFoldWidget;
    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
    
        if (this.singleLineBlockCommentRe.test(line)) {
            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
                return "";
        }
    
        var fw = this._getFoldWidgetBase(session, foldStyle, row);
    
        if (!fw && this.startRegionRe.test(line))
            return "start"; // lineCommentRegionStart
    
        return fw;
    };

    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        
        if (this.startRegionRe.test(line))
            return this.getCommentRegionBlock(session, line, row);
        
        var match = line.match(this.foldingStartMarker);
        if (match) {
            var i = match.index;

            if (match[1])
                return this.openingBracketBlock(session, match[1], row, i);
                
            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
            
            if (range && !range.isMultiLine()) {
                if (forceMultiline) {
                    range = this.getSectionRange(session, row);
                } else if (foldStyle != "all")
                    range = null;
            }
            
            return range;
        }

        if (foldStyle === "markbegin")
            return;

        var match = line.match(this.foldingStopMarker);
        if (match) {
            var i = match.index + match[0].length;

            if (match[1])
                return this.closingBracketBlock(session, match[1], row, i);

            return session.getCommentFoldRange(row, i, -1);
        }
    };
    
    this.getSectionRange = function(session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();
        while (++row < maxRow) {
            line = session.getLine(row);
            var indent = line.search(/\S/);
            if (indent === -1)
                continue;
            if  (startIndent > indent)
                break;
            var subRange = this.getFoldWidgetRange(session, "all", row);
            
            if (subRange) {
                if (subRange.start.row <= startRow) {
                    break;
                } else if (subRange.isMultiLine()) {
                    row = subRange.end.row;
                } else if (startIndent == indent) {
                    break;
                }
            }
            endRow = row;
        }
        
        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
    };
    this.getCommentRegionBlock = function(session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;
        while (++row < maxRow) {
            line = session.getLine(row);
            var m = re.exec(line);
            if (!m) continue;
            if (m[1]) depth--;
            else depth++;

            if (!depth) break;
        }

        var endRow = row;
        if (endRow > startRow) {
            return new Range(startRow, startColumn, endRow, line.length);
        }
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/json",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/json_highlight_rules","ace/mode/matching_brace_outdent","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle","ace/worker/worker_client"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var HighlightRules = acequire("./json_highlight_rules").JsonHighlightRules;
var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;
var WorkerClient = acequire("../worker/worker_client").WorkerClient;

var Mode = function() {
    this.HighlightRules = HighlightRules;
    this.$outdent = new MatchingBraceOutdent();
    this.$behaviour = new CstyleBehaviour();
    this.foldingRules = new CStyleFoldMode();
};
oop.inherits(Mode, TextMode);

(function() {

    this.getNextLineIndent = function(state, line, tab) {
        var indent = this.$getIndent(line);

        if (state == "start") {
            var match = line.match(/^.*[\{\(\[]\s*$/);
            if (match) {
                indent += tab;
            }
        }

        return indent;
    };

    this.checkOutdent = function(state, line, input) {
        return this.$outdent.checkOutdent(line, input);
    };

    this.autoOutdent = function(state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
    };

    this.createWorker = function(session) {
        var worker = new WorkerClient(["ace"], __webpack_require__(937), "JsonWorker");
        worker.attachToDocument(session.getDocument());

        worker.on("annotate", function(e) {
            session.setAnnotations(e.data);
        });

        worker.on("terminate", function() {
            session.clearAnnotations();
        });

        return worker;
    };


    this.$id = "ace/mode/json";
}).call(Mode.prototype);

exports.Mode = Mode;
});


/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports.id = 'ace/mode/json_worker';
module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/json/json_parse\",[\"require\",\"exports\",\"module\"],function(){\"use strict\";var at,ch,text,value,escapee={'\"':'\"',\"\\\\\":\"\\\\\",\"/\":\"/\",b:\"\\b\",f:\"\\f\",n:\"\\n\",r:\"\\r\",t:\"\t\"},error=function(m){throw{name:\"SyntaxError\",message:m,at:at,text:text}},next=function(c){return c&&c!==ch&&error(\"Expected '\"+c+\"' instead of '\"+ch+\"'\"),ch=text.charAt(at),at+=1,ch},number=function(){var number,string=\"\";for(\"-\"===ch&&(string=\"-\",next(\"-\"));ch>=\"0\"&&\"9\">=ch;)string+=ch,next();if(\".\"===ch)for(string+=\".\";next()&&ch>=\"0\"&&\"9\">=ch;)string+=ch;if(\"e\"===ch||\"E\"===ch)for(string+=ch,next(),(\"-\"===ch||\"+\"===ch)&&(string+=ch,next());ch>=\"0\"&&\"9\">=ch;)string+=ch,next();return number=+string,isNaN(number)?(error(\"Bad number\"),void 0):number},string=function(){var hex,i,uffff,string=\"\";if('\"'===ch)for(;next();){if('\"'===ch)return next(),string;if(\"\\\\\"===ch)if(next(),\"u\"===ch){for(uffff=0,i=0;4>i&&(hex=parseInt(next(),16),isFinite(hex));i+=1)uffff=16*uffff+hex;string+=String.fromCharCode(uffff)}else{if(\"string\"!=typeof escapee[ch])break;string+=escapee[ch]}else string+=ch}error(\"Bad string\")},white=function(){for(;ch&&\" \">=ch;)next()},word=function(){switch(ch){case\"t\":return next(\"t\"),next(\"r\"),next(\"u\"),next(\"e\"),!0;case\"f\":return next(\"f\"),next(\"a\"),next(\"l\"),next(\"s\"),next(\"e\"),!1;case\"n\":return next(\"n\"),next(\"u\"),next(\"l\"),next(\"l\"),null}error(\"Unexpected '\"+ch+\"'\")},array=function(){var array=[];if(\"[\"===ch){if(next(\"[\"),white(),\"]\"===ch)return next(\"]\"),array;for(;ch;){if(array.push(value()),white(),\"]\"===ch)return next(\"]\"),array;next(\",\"),white()}}error(\"Bad array\")},object=function(){var key,object={};if(\"{\"===ch){if(next(\"{\"),white(),\"}\"===ch)return next(\"}\"),object;for(;ch;){if(key=string(),white(),next(\":\"),Object.hasOwnProperty.call(object,key)&&error('Duplicate key \"'+key+'\"'),object[key]=value(),white(),\"}\"===ch)return next(\"}\"),object;next(\",\"),white()}}error(\"Bad object\")};return value=function(){switch(white(),ch){case\"{\":return object();case\"[\":return array();case'\"':return string();case\"-\":return number();default:return ch>=\"0\"&&\"9\">=ch?number():word()}},function(source,reviver){var result;return text=source,at=0,ch=\" \",result=value(),white(),ch&&error(\"Syntax error\"),\"function\"==typeof reviver?function walk(holder,key){var k,v,value=holder[key];if(value&&\"object\"==typeof value)for(k in value)Object.hasOwnProperty.call(value,k)&&(v=walk(value,k),void 0!==v?value[k]=v:delete value[k]);return reviver.call(holder,key,value)}({\"\":result},\"\"):result}}),ace.define(\"ace/mode/json_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/worker/mirror\",\"ace/mode/json/json_parse\"],function(acequire,exports){\"use strict\";var oop=acequire(\"../lib/oop\"),Mirror=acequire(\"../worker/mirror\").Mirror,parse=acequire(\"./json/json_parse\"),JsonWorker=exports.JsonWorker=function(sender){Mirror.call(this,sender),this.setTimeout(200)};oop.inherits(JsonWorker,Mirror),function(){this.onUpdate=function(){var value=this.doc.getValue(),errors=[];try{value&&parse(value)}catch(e){var pos=this.doc.indexToPosition(e.at-1);errors.push({row:pos.row,column:pos.column,text:e.message,type:\"error\"})}this.sender.emit(\"annotate\",errors)}}.call(JsonWorker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0\n}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 938 */
/***/ (function(module, exports) {

ace.define("ace/snippets/json",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="json"})

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// based on http://www.paciellogroup.com/blog/2012/04/how-to-remove-css-outlines-in-an-accessible-manner/
function outlineFixer() {
    var d = document;
    var style_element = d.createElement('STYLE');
    var dom_events = 'addEventListener' in d;
    var add_event_listener = function (type, callback) {
        // Basic cross-browser event handling
        if (dom_events) {
            d.addEventListener(type, callback);
        }
        else {
            d.attachEvent('on' + type, callback);
        }
    };
    var set_css = function (css_text) {
        // Handle setting of <style> element contents in IE8
        !!style_element.styleSheet ? (style_element.styleSheet.cssText = css_text) : (style_element.innerHTML = css_text);
    };
    d.getElementsByTagName('HEAD')[0].appendChild(style_element);
    // Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
    add_event_listener('mousedown', function () {
        set_css(':focus{outline:0 !important}::-moz-focus-inner{border:0;}');
    });
    add_event_listener('keydown', function () {
        set_css('');
    });
}
outlineFixer();


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tether_drop__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tether_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tether_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorPickerPopover__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_utils_react2angular__ = __webpack_require__(147);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.openColorPicker = _this.openColorPicker.bind(_this);
        _this.closeColorPicker = _this.closeColorPicker.bind(_this);
        _this.setPickerElem = _this.setPickerElem.bind(_this);
        _this.onColorSelect = _this.onColorSelect.bind(_this);
        return _this;
    }
    ColorPicker.prototype.setPickerElem = function (elem) {
        this.pickerElem = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(elem);
    };
    ColorPicker.prototype.openColorPicker = function () {
        var dropContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ColorPickerPopover__["a" /* ColorPickerPopover */], { color: this.props.color, onColorSelect: this.onColorSelect });
        var dropContentElem = document.createElement('div');
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(dropContent, dropContentElem);
        var drop = new __WEBPACK_IMPORTED_MODULE_3_tether_drop___default.a({
            target: this.pickerElem[0],
            content: dropContentElem,
            position: 'top center',
            classes: 'drop-popover',
            openOn: 'click',
            hoverCloseDelay: 200,
            tetherOptions: {
                constraints: [{ to: 'scrollParent', attachment: 'none both' }],
            },
        });
        drop.on('close', this.closeColorPicker);
        this.colorPickerDrop = drop;
        this.colorPickerDrop.open();
    };
    ColorPicker.prototype.closeColorPicker = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.colorPickerDrop && _this.colorPickerDrop.tether) {
                _this.colorPickerDrop.destroy();
            }
        }, 100);
    };
    ColorPicker.prototype.onColorSelect = function (color) {
        this.props.onChange(color);
    };
    ColorPicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sp-replacer sp-light", onClick: this.openColorPicker, ref: this.setPickerElem },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sp-preview" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sp-preview-inner", style: { backgroundColor: this.props.color } }))));
    };
    return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

Object(__WEBPACK_IMPORTED_MODULE_5_app_core_utils_react2angular__["a" /* react2AngularDirective */])('colorPicker', ColorPicker, [
    'color',
    ['onChange', { watchDepth: 'reference', wrapApply: true }],
]);


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_utils_colors__ = __webpack_require__(108);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ColorPalette = /** @class */ (function (_super) {
    __extends(ColorPalette, _super);
    function ColorPalette(props) {
        var _this = _super.call(this, props) || this;
        _this.paletteColors = __WEBPACK_IMPORTED_MODULE_1_app_core_utils_colors__["g" /* sortedColors */];
        _this.onColorSelect = _this.onColorSelect.bind(_this);
        return _this;
    }
    ColorPalette.prototype.onColorSelect = function (color) {
        var _this = this;
        return function () {
            _this.props.onColorSelect(color);
        };
    };
    ColorPalette.prototype.render = function () {
        var _this = this;
        var colorPaletteItems = this.paletteColors.map(function (paletteColor) {
            var cssClass = paletteColor.toLowerCase() === _this.props.color.toLowerCase() ? 'fa-circle-o' : 'fa-circle';
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { key: paletteColor, className: 'pointer fa ' + cssClass, style: { color: paletteColor }, onClick: _this.onColorSelect(paletteColor) }, "\u00A0"));
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "graph-legend-popover" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "m-b-0" }, colorPaletteItems)));
    };
    return ColorPalette;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpectrumPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendor_spectrum__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendor_spectrum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vendor_spectrum__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SpectrumPicker = /** @class */ (function (_super) {
    __extends(SpectrumPicker, _super);
    function SpectrumPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.onSpectrumMove = _this.onSpectrumMove.bind(_this);
        _this.setComponentElem = _this.setComponentElem.bind(_this);
        return _this;
    }
    SpectrumPicker.prototype.setComponentElem = function (elem) {
        this.elem = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(elem);
    };
    SpectrumPicker.prototype.onSpectrumMove = function (color) {
        this.isMoving = true;
        this.props.onColorSelect(color);
    };
    SpectrumPicker.prototype.componentDidMount = function () {
        var spectrumOptions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.assignIn({
            flat: true,
            showAlpha: true,
            showButtons: false,
            color: this.props.color,
            appendTo: this.elem,
            move: this.onSpectrumMove,
        }, this.props.options);
        this.elem.spectrum(spectrumOptions);
        this.elem.spectrum('show');
        this.elem.spectrum('set', this.props.color);
    };
    SpectrumPicker.prototype.componentWillUpdate = function (nextProps) {
        // If user move pointer over spectrum field this produce 'move' event and component
        // may update props.color. We don't want to update spectrum color in this case, so we can use
        // isMoving flag for tracking moving state. Flag should be cleared in componentDidUpdate() which
        // is called after updating occurs (when user finished moving).
        if (!this.isMoving) {
            this.elem.spectrum('set', nextProps.color);
        }
    };
    SpectrumPicker.prototype.componentDidUpdate = function () {
        if (this.isMoving) {
            this.isMoving = false;
        }
    };
    SpectrumPicker.prototype.componentWillUnmount = function () {
        this.elem.spectrum('destroy');
    };
    SpectrumPicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "spectrum-container", ref: this.setComponentElem }));
    };
    return SpectrumPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Spectrum Colorpicker v1.7.0
// https://github.com/bgrins/spectrum
// Author: Brian Grinstead
// License: MIT

(function (factory) {
    "use strict";

    if (true) { // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof exports == "object" && typeof module == "object") { // CommonJS
        module.exports = factory;
    }
    else { // Browser
        factory(jQuery);
    }
})(function($, undefined) {
    "use strict";

    var defaultOpts = {

        // Callbacks
        beforeShow: noop,
        move: noop,
        change: noop,
        show: noop,
        hide: noop,

        // Options
        color: false,
        flat: false,
        showInput: false,
        allowEmpty: false,
        showButtons: true,
        clickoutFiresChange: true,
        showInitial: false,
        showPalette: false,
        showPaletteOnly: false,
        hideAfterPaletteSelect: false,
        togglePaletteOnly: false,
        showSelectionPalette: true,
        localStorageKey: false,
        appendTo: "body",
        maxSelectionSize: 7,
        cancelText: "cancel",
        chooseText: "choose",
        togglePaletteMoreText: "more",
        togglePaletteLessText: "less",
        clearText: "Clear Color Selection",
        noColorSelectedText: "No Color Selected",
        preferredFormat: false,
        className: "", // Deprecated - use containerClassName and replacerClassName instead.
        containerClassName: "",
        replacerClassName: "",
        showAlpha: false,
        theme: "sp-light",
        palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
        selectionPalette: [],
        disabled: false,
        offset: null
    },
    spectrums = [],
    IE = !!/msie/i.exec( window.navigator.userAgent ),
    rgbaSupport = (function() {
        function contains( str, substr ) {
            return !!~('' + str).indexOf(substr);
        }

        var elem = document.createElement('div');
        var style = elem.style;
        style.cssText = 'background-color:rgba(0,0,0,.5)';
        return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
    })(),
    replaceInput = [
        "<div class='sp-replacer'>",
            "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
            "<div class='sp-dd'>&#9660;</div>",
        "</div>"
    ].join(''),
    markup = (function () {

        // IE does not support gradients with multiple stops, so we need to simulate
        //  that for the rainbow slider with 8 divs that each have a single gradient
        var gradientFix = "";
        if (IE) {
            for (var i = 1; i <= 6; i++) {
                gradientFix += "<div class='sp-" + i + "'></div>";
            }
        }

        return [
            "<div class='sp-container sp-hidden'>",
                "<div class='sp-palette-container'>",
                    "<div class='sp-palette sp-thumb sp-cf'></div>",
                    "<div class='sp-palette-button-container sp-cf'>",
                        "<button type='button' class='sp-palette-toggle'></button>",
                    "</div>",
                "</div>",
                "<div class='sp-picker-container'>",
                    "<div class='sp-top sp-cf'>",
                        "<div class='sp-fill'></div>",
                        "<div class='sp-top-inner'>",
                            "<div class='sp-color'>",
                                "<div class='sp-sat'>",
                                    "<div class='sp-val'>",
                                        "<div class='sp-dragger'></div>",
                                    "</div>",
                                "</div>",
                            "</div>",
                            "<div class='sp-clear sp-clear-display'>",
                            "</div>",
                            "<div class='sp-hue'>",
                                "<div class='sp-slider'></div>",
                                gradientFix,
                            "</div>",
                        "</div>",
                        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
                    "</div>",
                    "<div class='sp-input-container sp-cf'>",
                        "<input class='sp-input' type='text' spellcheck='false'  />",
                    "</div>",
                    "<div class='sp-initial sp-thumb sp-cf'></div>",
                    "<div class='sp-button-container sp-cf'>",
                        "<a class='sp-cancel' href='#'></a>",
                        "<button type='button' class='sp-choose'></button>",
                    "</div>",
                "</div>",
            "</div>"
        ].join("");
    })();

    function paletteTemplate (p, color, className, opts) {
        var html = [];
        for (var i = 0; i < p.length; i++) {
            var current = p[i];
            if(current) {
                var tiny = tinycolor(current);
                var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
                c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";
                var formattedString = tiny.toString(opts.preferredFormat || "rgb");
                var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
                html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';" /></span>');
            } else {
                var cls = 'sp-clear-display';
                html.push($('<div />')
                    .append($('<span data-color="" style="background-color:transparent;" class="' + cls + '"></span>')
                        .attr('title', opts.noColorSelectedText)
                    )
                    .html()
                );
            }
        }
        return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
    }

    function hideAll() {
        for (var i = 0; i < spectrums.length; i++) {
            if (spectrums[i]) {
                spectrums[i].hide();
            }
        }
    }

    function instanceOptions(o, callbackContext) {
        var opts = $.extend({}, defaultOpts, o);
        opts.callbacks = {
            'move': bind(opts.move, callbackContext),
            'change': bind(opts.change, callbackContext),
            'show': bind(opts.show, callbackContext),
            'hide': bind(opts.hide, callbackContext),
            'beforeShow': bind(opts.beforeShow, callbackContext)
        };

        return opts;
    }

    function spectrum(element, o) {

        var opts = instanceOptions(o, element),
            flat = opts.flat,
            showSelectionPalette = opts.showSelectionPalette,
            localStorageKey = opts.localStorageKey,
            theme = opts.theme,
            callbacks = opts.callbacks,
            resize = throttle(reflow, 10),
            visible = false,
            isDragging = false,
            dragWidth = 0,
            dragHeight = 0,
            dragHelperHeight = 0,
            slideHeight = 0,
            slideWidth = 0,
            alphaWidth = 0,
            alphaSlideHelperWidth = 0,
            slideHelperHeight = 0,
            currentHue = 0,
            currentSaturation = 0,
            currentValue = 0,
            currentAlpha = 1,
            palette = [],
            paletteArray = [],
            paletteLookup = {},
            selectionPalette = opts.selectionPalette.slice(0),
            maxSelectionSize = opts.maxSelectionSize,
            draggingClass = "sp-dragging",
            shiftMovementDirection = null;

        var doc = element.ownerDocument,
            body = doc.body,
            boundElement = $(element),
            disabled = false,
            container = $(markup, doc).addClass(theme),
            pickerContainer = container.find(".sp-picker-container"),
            dragger = container.find(".sp-color"),
            dragHelper = container.find(".sp-dragger"),
            slider = container.find(".sp-hue"),
            slideHelper = container.find(".sp-slider"),
            alphaSliderInner = container.find(".sp-alpha-inner"),
            alphaSlider = container.find(".sp-alpha"),
            alphaSlideHelper = container.find(".sp-alpha-handle"),
            textInput = container.find(".sp-input"),
            paletteContainer = container.find(".sp-palette"),
            initialColorContainer = container.find(".sp-initial"),
            cancelButton = container.find(".sp-cancel"),
            clearButton = container.find(".sp-clear"),
            chooseButton = container.find(".sp-choose"),
            toggleButton = container.find(".sp-palette-toggle"),
            isInput = boundElement.is("input"),
            isInputTypeColor = isInput && boundElement.attr("type") === "color" && inputTypeColorSupport(),
            shouldReplace = isInput && !flat,
            replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
            offsetElement = (shouldReplace) ? replacer : boundElement,
            previewElement = replacer.find(".sp-preview-inner"),
            initialColor = opts.color || (isInput && boundElement.val()),
            colorOnShow = false,
            preferredFormat = opts.preferredFormat,
            currentPreferredFormat = preferredFormat,
            clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
            isEmpty = !initialColor,
            allowEmpty = opts.allowEmpty && !isInputTypeColor;

        function applyOptions() {

            if (opts.showPaletteOnly) {
                opts.showPalette = true;
            }

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);

            if (opts.palette) {
                palette = opts.palette.slice(0);
                paletteArray = $.isArray(palette[0]) ? palette : [palette];
                paletteLookup = {};
                for (var i = 0; i < paletteArray.length; i++) {
                    for (var j = 0; j < paletteArray[i].length; j++) {
                        var rgb = tinycolor(paletteArray[i][j]).toRgbString();
                        paletteLookup[rgb] = true;
                    }
                }
            }

            container.toggleClass("sp-flat", flat);
            container.toggleClass("sp-input-disabled", !opts.showInput);
            container.toggleClass("sp-alpha-enabled", opts.showAlpha);
            container.toggleClass("sp-clear-enabled", allowEmpty);
            container.toggleClass("sp-buttons-disabled", !opts.showButtons);
            container.toggleClass("sp-palette-buttons-disabled", !opts.togglePaletteOnly);
            container.toggleClass("sp-palette-disabled", !opts.showPalette);
            container.toggleClass("sp-palette-only", opts.showPaletteOnly);
            container.toggleClass("sp-initial-disabled", !opts.showInitial);
            container.addClass(opts.className).addClass(opts.containerClassName);

            reflow();
        }

        function initialize() {

            if (IE) {
                container.find("*:not(input)").attr("unselectable", "on");
            }

            applyOptions();

            if (shouldReplace) {
                boundElement.after(replacer).hide();
            }

            if (!allowEmpty) {
                clearButton.hide();
            }

            if (flat) {
                boundElement.after(container).hide();
            }
            else {

                var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
                if (appendTo.length !== 1) {
                    appendTo = $("body");
                }

                appendTo.append(container);
            }

            updateSelectionPaletteFromStorage();

            offsetElement.bind("click.spectrum touchstart.spectrum", function (e) {
                if (!disabled) {
                    toggle();
                }

                e.stopPropagation();

                if (!$(e.target).is("input")) {
                    e.preventDefault();
                }
            });

            if(boundElement.is(":disabled") || (opts.disabled === true)) {
                disable();
            }

            // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
            container.click(stopPropagation);

            // Handle user typed input
            textInput.change(setFromTextInput);
            textInput.bind("paste", function () {
                setTimeout(setFromTextInput, 1);
            });
            textInput.keydown(function (e) { if (e.keyCode == 13) { setFromTextInput(); } });

            cancelButton.text(opts.cancelText);
            cancelButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                revert();
                hide();
            });

            clearButton.attr("title", opts.clearText);
            clearButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                isEmpty = true;
                move();

                if(flat) {
                    //for the flat style, this is a change event
                    updateOriginalInput(true);
                }
            });

            chooseButton.text(opts.chooseText);
            chooseButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                if (IE && textInput.is(":focus")) {
                    textInput.trigger('change');
                }

                if (isValid()) {
                    updateOriginalInput(true);
                    hide();
                }
            });

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
            toggleButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                opts.showPaletteOnly = !opts.showPaletteOnly;

                // To make sure the Picker area is drawn on the right, next to the
                // Palette area (and not below the palette), first move the Palette
                // to the left to make space for the picker, plus 5px extra.
                // The 'applyOptions' function puts the whole container back into place
                // and takes care of the button-text and the sp-palette-only CSS class.
                if (!opts.showPaletteOnly && !flat) {
                    container.css('left', '-=' + (pickerContainer.outerWidth(true) + 5));
                }
                applyOptions();
            });

            draggable(alphaSlider, function (dragX, dragY, e) {
                currentAlpha = (dragX / alphaWidth);
                isEmpty = false;
                if (e.shiftKey) {
                    currentAlpha = Math.round(currentAlpha * 10) / 10;
                }

                move();
            }, dragStart, dragStop);

            draggable(slider, function (dragX, dragY) {
                currentHue = parseFloat(dragY / slideHeight);
                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }
                move();
            }, dragStart, dragStop);

            draggable(dragger, function (dragX, dragY, e) {

                // shift+drag should snap the movement to either the x or y axis.
                if (!e.shiftKey) {
                    shiftMovementDirection = null;
                }
                else if (!shiftMovementDirection) {
                    var oldDragX = currentSaturation * dragWidth;
                    var oldDragY = dragHeight - (currentValue * dragHeight);
                    var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);

                    shiftMovementDirection = furtherFromX ? "x" : "y";
                }

                var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
                var setValue = !shiftMovementDirection || shiftMovementDirection === "y";

                if (setSaturation) {
                    currentSaturation = parseFloat(dragX / dragWidth);
                }
                if (setValue) {
                    currentValue = parseFloat((dragHeight - dragY) / dragHeight);
                }

                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }

                move();

            }, dragStart, dragStop);

            if (!!initialColor) {
                set(initialColor);

                // In case color was black - update the preview UI and set the format
                // since the set function will not run (default color is black).
                updateUI();
                currentPreferredFormat = preferredFormat || tinycolor(initialColor).format;

                addColorToSelectionPalette(initialColor);
            }
            else {
                updateUI();
            }

            if (flat) {
                show();
            }

            function paletteElementClick(e) {
                if (e.data && e.data.ignore) {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                }
                else {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                    updateOriginalInput(true);
                    if (opts.hideAfterPaletteSelect) {
                      hide();
                    }
                }

                return false;
            }

            var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
            paletteContainer.delegate(".sp-thumb-el", paletteEvent, paletteElementClick);
            initialColorContainer.delegate(".sp-thumb-el:nth-child(1)", paletteEvent, { ignore: true }, paletteElementClick);
        }

        function updateSelectionPaletteFromStorage() {

            if (localStorageKey && window.localStorage) {

                // Migrate old palettes over to new format.  May want to remove this eventually.
                try {
                    var oldPalette = window.localStorage[localStorageKey].split(",#");
                    if (oldPalette.length > 1) {
                        delete window.localStorage[localStorageKey];
                        $.each(oldPalette, function(i, c) {
                             addColorToSelectionPalette(c);
                        });
                    }
                }
                catch(e) { }

                try {
                    selectionPalette = window.localStorage[localStorageKey].split(";");
                }
                catch (e) { }
            }
        }

        function addColorToSelectionPalette(color) {
            if (showSelectionPalette) {
                var rgb = tinycolor(color).toRgbString();
                if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
                    selectionPalette.push(rgb);
                    while(selectionPalette.length > maxSelectionSize) {
                        selectionPalette.shift();
                    }
                }

                if (localStorageKey && window.localStorage) {
                    try {
                        window.localStorage[localStorageKey] = selectionPalette.join(";");
                    }
                    catch(e) { }
                }
            }
        }

        function getUniqueSelectionPalette() {
            var unique = [];
            if (opts.showPalette) {
                for (var i = 0; i < selectionPalette.length; i++) {
                    var rgb = tinycolor(selectionPalette[i]).toRgbString();

                    if (!paletteLookup[rgb]) {
                        unique.push(selectionPalette[i]);
                    }
                }
            }

            return unique.reverse().slice(0, opts.maxSelectionSize);
        }

        function drawPalette() {

            var currentColor = get();

            var html = $.map(paletteArray, function (palette, i) {
                return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts);
            });

            updateSelectionPaletteFromStorage();

            if (selectionPalette) {
                html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts));
            }

            paletteContainer.html(html.join(""));
        }

        function drawInitial() {
            if (opts.showInitial) {
                var initial = colorOnShow;
                var current = get();
                initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts));
            }
        }

        function dragStart() {
            if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
                reflow();
            }
            isDragging = true;
            container.addClass(draggingClass);
            shiftMovementDirection = null;
            boundElement.trigger('dragstart.spectrum', [ get() ]);
        }

        function dragStop() {
            isDragging = false;
            container.removeClass(draggingClass);
            boundElement.trigger('dragstop.spectrum', [ get() ]);
        }

        function setFromTextInput() {

            var value = textInput.val();

            if ((value === null || value === "") && allowEmpty) {
                set(null);
                updateOriginalInput(true);
            }
            else {
                var tiny = tinycolor(value);
                if (tiny.isValid()) {
                    set(tiny);
                    updateOriginalInput(true);
                }
                else {
                    textInput.addClass("sp-validation-error");
                }
            }
        }

        function toggle() {
            if (visible) {
                hide();
            }
            else {
                show();
            }
        }

        function show() {
            var event = $.Event('beforeShow.spectrum');

            if (visible) {
                reflow();
                return;
            }

            boundElement.trigger(event, [ get() ]);

            if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
                return;
            }

            hideAll();
            visible = true;

            $(doc).bind("keydown.spectrum", onkeydown);
            $(doc).bind("click.spectrum", clickout);
            $(window).bind("resize.spectrum", resize);
            replacer.addClass("sp-active");
            container.removeClass("sp-hidden");

            reflow();
            updateUI();

            colorOnShow = get();

            drawInitial();
            callbacks.show(colorOnShow);
            boundElement.trigger('show.spectrum', [ colorOnShow ]);
        }

        function onkeydown(e) {
            // Close on ESC
            if (e.keyCode === 27) {
                hide();
            }
        }

        function clickout(e) {
            // Return on right click.
            if (e.button == 2) { return; }

            // If a drag event was happening during the mouseup, don't hide
            // on click.
            if (isDragging) { return; }

            if (clickoutFiresChange) {
                updateOriginalInput(true);
            }
            else {
                revert();
            }
            hide();
        }

        function hide() {
            // Return if hiding is unnecessary
            if (!visible || flat) { return; }
            visible = false;

            $(doc).unbind("keydown.spectrum", onkeydown);
            $(doc).unbind("click.spectrum", clickout);
            $(window).unbind("resize.spectrum", resize);

            replacer.removeClass("sp-active");
            container.addClass("sp-hidden");

            callbacks.hide(get());
            boundElement.trigger('hide.spectrum', [ get() ]);
        }

        function revert() {
            set(colorOnShow, true);
        }

        function set(color, ignoreFormatChange) {
            if (tinycolor.equals(color, get())) {
                // Update UI just in case a validation error needs
                // to be cleared.
                updateUI();
                return;
            }

            var newColor, newHsv;
            if (!color && allowEmpty) {
                isEmpty = true;
            } else {
                isEmpty = false;
                newColor = tinycolor(color);
                newHsv = newColor.toHsv();

                currentHue = (newHsv.h % 360) / 360;
                currentSaturation = newHsv.s;
                currentValue = newHsv.v;
                currentAlpha = newHsv.a;
            }
            updateUI();

            if (newColor && newColor.isValid() && !ignoreFormatChange) {
                currentPreferredFormat = preferredFormat || newColor.getFormat();
            }
        }

        function get(opts) {
            opts = opts || { };

            if (allowEmpty && isEmpty) {
                return null;
            }

            return tinycolor.fromRatio({
                h: currentHue,
                s: currentSaturation,
                v: currentValue,
                a: Math.round(currentAlpha * 100) / 100
            }, { format: opts.format || currentPreferredFormat });
        }

        function isValid() {
            return !textInput.hasClass("sp-validation-error");
        }

        function move() {
            updateUI();

            callbacks.move(get());
            boundElement.trigger('move.spectrum', [ get() ]);
        }

        function updateUI() {

            textInput.removeClass("sp-validation-error");

            updateHelperLocations();

            // Update dragger background color (gradients take care of saturation and value).
            var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
            dragger.css("background-color", flatColor.toHexString());

            // Get a format that alpha will be included in (hex and names ignore alpha)
            var format = currentPreferredFormat;
            if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
                if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
                    format = "rgb";
                }
            }

            var realColor = get({ format: format }),
                displayColor = '';

             //reset background info for preview element
            previewElement.removeClass("sp-clear-display");
            previewElement.css('background-color', 'transparent');

            if (!realColor && allowEmpty) {
                // Update the replaced elements background with icon indicating no color selection
                previewElement.addClass("sp-clear-display");
            }
            else {
                var realHex = realColor.toHexString(),
                    realRgb = realColor.toRgbString();

                // Update the replaced elements background color (with actual selected color)
                if (rgbaSupport || realColor.alpha === 1) {
                    previewElement.css("background-color", realRgb);
                }
                else {
                    previewElement.css("background-color", "transparent");
                    previewElement.css("filter", realColor.toFilter());
                }

                if (opts.showAlpha) {
                    var rgb = realColor.toRgb();
                    rgb.a = 0;
                    var realAlpha = tinycolor(rgb).toRgbString();
                    var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";

                    if (IE) {
                        alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
                    }
                    else {
                        alphaSliderInner.css("background", "-webkit-" + gradient);
                        alphaSliderInner.css("background", "-moz-" + gradient);
                        alphaSliderInner.css("background", "-ms-" + gradient);
                        // Use current syntax gradient on unprefixed property.
                        alphaSliderInner.css("background",
                            "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
                    }
                }

                displayColor = realColor.toString(format);
            }

            // Update the text entry input as it changes happen
            if (opts.showInput) {
                textInput.val(displayColor);
            }

            if (opts.showPalette) {
                drawPalette();
            }

            drawInitial();
        }

        function updateHelperLocations() {
            var s = currentSaturation;
            var v = currentValue;

            if(allowEmpty && isEmpty) {
                //if selected color is empty, hide the helpers
                alphaSlideHelper.hide();
                slideHelper.hide();
                dragHelper.hide();
            }
            else {
                //make sure helpers are visible
                alphaSlideHelper.show();
                slideHelper.show();
                dragHelper.show();

                // Where to show the little circle in that displays your current selected color
                var dragX = s * dragWidth;
                var dragY = dragHeight - (v * dragHeight);
                dragX = Math.max(
                    -dragHelperHeight,
                    Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
                );
                dragY = Math.max(
                    -dragHelperHeight,
                    Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
                );
                dragHelper.css({
                    "top": dragY + "px",
                    "left": dragX + "px"
                });

                var alphaX = currentAlpha * alphaWidth;
                alphaSlideHelper.css({
                    "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
                });

                // Where to show the bar that displays your current selected hue
                var slideY = (currentHue) * slideHeight;
                slideHelper.css({
                    "top": (slideY - slideHelperHeight) + "px"
                });
            }
        }

        function updateOriginalInput(fireCallback) {
            var color = get(),
                displayColor = '',
                hasChanged = !tinycolor.equals(color, colorOnShow);

            if (color) {
                displayColor = color.toString(currentPreferredFormat);
                // Update the selection palette with the current color
                addColorToSelectionPalette(color);
            }

            if (isInput) {
                boundElement.val(displayColor);
            }

            if (fireCallback && hasChanged) {
                callbacks.change(color);
                boundElement.trigger('change', [ color ]);
            }
        }

        function reflow() {
            dragWidth = dragger.width();
            dragHeight = dragger.height();
            dragHelperHeight = dragHelper.height();
            slideWidth = slider.width();
            slideHeight = slider.height();
            slideHelperHeight = slideHelper.height();
            alphaWidth = alphaSlider.width();
            alphaSlideHelperWidth = alphaSlideHelper.width();

            if (!flat) {
                container.css("position", "absolute");
                if (opts.offset) {
                    container.offset(opts.offset);
                } else {
                    container.offset(getOffset(container, offsetElement));
                }
            }

            updateHelperLocations();

            if (opts.showPalette) {
                drawPalette();
            }

            boundElement.trigger('reflow.spectrum');
        }

        function destroy() {
            boundElement.show();
            offsetElement.unbind("click.spectrum touchstart.spectrum");
            container.remove();
            replacer.remove();
            spectrums[spect.id] = null;
        }

        function option(optionName, optionValue) {
            if (optionName === undefined) {
                return $.extend({}, opts);
            }
            if (optionValue === undefined) {
                return opts[optionName];
            }

            opts[optionName] = optionValue;
            applyOptions();
        }

        function enable() {
            disabled = false;
            boundElement.attr("disabled", false);
            offsetElement.removeClass("sp-disabled");
        }

        function disable() {
            hide();
            disabled = true;
            boundElement.attr("disabled", true);
            offsetElement.addClass("sp-disabled");
        }

        function setOffset(coord) {
            opts.offset = coord;
            reflow();
        }

        initialize();

        var spect = {
            show: show,
            hide: hide,
            toggle: toggle,
            reflow: reflow,
            option: option,
            enable: enable,
            disable: disable,
            offset: setOffset,
            set: function (c) {
                set(c);
                updateOriginalInput();
            },
            get: get,
            destroy: destroy,
            container: container
        };

        spect.id = spectrums.push(spect) - 1;

        return spect;
    }

    /**
    * checkOffset - get the offset below/above and left/right element depending on screen position
    * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
    */
    function getOffset(picker, input) {
        var extraY = 0;
        var dpWidth = picker.outerWidth();
        var dpHeight = picker.outerHeight();
        var inputHeight = input.outerHeight();
        var doc = picker[0].ownerDocument;
        var docElem = doc.documentElement;
        var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
        var viewHeight = docElem.clientHeight + $(doc).scrollTop();
        var offset = input.offset();
        offset.top += inputHeight;

        offset.left -=
            Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
            Math.abs(offset.left + dpWidth - viewWidth) : 0);

        offset.top -=
            Math.min(offset.top, ((offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
            Math.abs(dpHeight + inputHeight - extraY) : extraY));

        return offset;
    }

    /**
    * noop - do nothing
    */
    function noop() {

    }

    /**
    * stopPropagation - makes the code only doing this a little easier to read in line
    */
    function stopPropagation(e) {
        e.stopPropagation();
    }

    /**
    * Create a function bound to a given object
    * Thanks to underscore.js
    */
    function bind(func, obj) {
        var slice = Array.prototype.slice;
        var args = slice.call(arguments, 2);
        return function () {
            return func.apply(obj, args.concat(slice.call(arguments)));
        };
    }

    /**
    * Lightweight drag helper.  Handles containment within the element, so that
    * when dragging, the x is within [0,element.width] and y is within [0,element.height]
    */
    function draggable(element, onmove, onstart, onstop) {
        onmove = onmove || function () { };
        onstart = onstart || function () { };
        onstop = onstop || function () { };
        var doc = document;
        var dragging = false;
        var offset = {};
        var maxHeight = 0;
        var maxWidth = 0;
        var hasTouch = ('ontouchstart' in window);

        var duringDragEvents = {};
        duringDragEvents["selectstart"] = prevent;
        duringDragEvents["dragstart"] = prevent;
        duringDragEvents["touchmove mousemove"] = move;
        duringDragEvents["touchend mouseup"] = stop;

        function prevent(e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.returnValue = false;
        }

        function move(e) {
            if (dragging) {
                // Mouseup happened outside of window
                if (IE && doc.documentMode < 9 && !e.button) {
                    return stop();
                }

                var t0 = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
                var pageX = t0 && t0.pageX || e.pageX;
                var pageY = t0 && t0.pageY || e.pageY;

                var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
                var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));

                if (hasTouch) {
                    // Stop scrolling in iOS
                    prevent(e);
                }

                onmove.apply(element, [dragX, dragY, e]);
            }
        }

        function start(e) {
            var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);

            if (!rightclick && !dragging) {
                if (onstart.apply(element, arguments) !== false) {
                    dragging = true;
                    maxHeight = $(element).height();
                    maxWidth = $(element).width();
                    offset = $(element).offset();

                    $(doc).bind(duringDragEvents);
                    $(doc.body).addClass("sp-dragging");

                    move(e);

                    prevent(e);
                }
            }
        }

        function stop() {
            if (dragging) {
                $(doc).unbind(duringDragEvents);
                $(doc.body).removeClass("sp-dragging");

                // Wait a tick before notifying observers to allow the click event
                // to fire in Chrome.
                setTimeout(function() {
                    onstop.apply(element, arguments);
                }, 0);
            }
            dragging = false;
        }

        $(element).bind("touchstart mousedown", start);
    }

    function throttle(func, wait, debounce) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var throttler = function () {
                timeout = null;
                func.apply(context, args);
            };
            if (debounce) clearTimeout(timeout);
            if (debounce || !timeout) timeout = setTimeout(throttler, wait);
        };
    }

    function inputTypeColorSupport() {
        return $.fn.spectrum.inputTypeColorSupport();
    }

    /**
    * Define a jQuery plugin
    */
    var dataID = "spectrum.id";
    $.fn.spectrum = function (opts, extra) {

        if (typeof opts == "string") {

            var returnValue = this;
            var args = Array.prototype.slice.call( arguments, 1 );

            this.each(function () {
                var spect = spectrums[$(this).data(dataID)];
                if (spect) {
                    var method = spect[opts];
                    if (!method) {
                        throw new Error( "Spectrum: no such method: '" + opts + "'" );
                    }

                    if (opts == "get") {
                        returnValue = spect.get();
                    }
                    else if (opts == "container") {
                        returnValue = spect.container;
                    }
                    else if (opts == "option") {
                        returnValue = spect.option.apply(spect, args);
                    }
                    else if (opts == "destroy") {
                        spect.destroy();
                        $(this).removeData(dataID);
                    }
                    else {
                        method.apply(spect, args);
                    }
                }
            });

            return returnValue;
        }

        // Initializing a new instance of spectrum
        return this.spectrum("destroy").each(function () {
            var options = $.extend({}, opts, $(this).data());
            var spect = spectrum(this, options);
            $(this).data(dataID, spect.id);
        });
    };

    $.fn.spectrum.load = true;
    $.fn.spectrum.loadOpts = {};
    $.fn.spectrum.draggable = draggable;
    $.fn.spectrum.defaults = defaultOpts;
    $.fn.spectrum.inputTypeColorSupport = function inputTypeColorSupport() {
        if (typeof inputTypeColorSupport._cachedResult === "undefined") {
            var colorInput = $("<input type='color' value='!' />")[0];
            inputTypeColorSupport._cachedResult = colorInput.type === "color" && colorInput.value !== "!";
        }
        return inputTypeColorSupport._cachedResult;
    };

    $.spectrum = { };
    $.spectrum.localization = { };
    $.spectrum.palettes = { };

    $.fn.spectrum.processNativeColorInputs = function () {
        var colorInputs = $("input[type=color]");
        if (colorInputs.length && !inputTypeColorSupport()) {
            colorInputs.spectrum({
                preferredFormat: "hex6"
            });
        }
    };

    // TinyColor v1.1.2
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License

    (function() {

    var trimLeft = /^[\s,#]+/,
        trimRight = /\s+$/,
        tinyCounter = 0,
        math = Math,
        mathRound = math.round,
        mathMin = math.min,
        mathMax = math.max,
        mathRandom = math.random;

    var tinycolor = function(color, opts) {

        color = (color) ? color : '';
        opts = opts || { };

        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) {
           return color;
        }
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) {
            return new tinycolor(color, opts);
        }

        var rgb = inputToRGB(color);
        this._originalInput = color,
        this._r = rgb.r,
        this._g = rgb.g,
        this._b = rgb.b,
        this._a = rgb.a,
        this._roundA = mathRound(100*this._a) / 100,
        this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;

        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) { this._r = mathRound(this._r); }
        if (this._g < 1) { this._g = mathRound(this._g); }
        if (this._b < 1) { this._b = mathRound(this._b); }

        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    };

    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
          return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100*this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return (this._a == 1) ?
              "hsv("  + h + ", " + s + "%, " + v + "%)" :
              "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return (this._a == 1) ?
              "hsl("  + h + ", " + s + "%, " + l + "%)" :
              "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return '#' + this.toHex(allow3Char);
        },
        toHex8: function() {
            return rgbaToHex(this._r, this._g, this._b, this._a);
        },
        toHex8String: function() {
            return '#' + this.toHex8();
        },
        toRgb: function() {
            return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
        },
        toRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
              "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
        },
        toPercentageRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
              "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) {
                return "transparent";
            }

            if (this._a < 1) {
                return false;
            }

            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";

            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = s.toHex8String();
            }

            return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;

            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");

            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) {
                    return this.toName();
                }
                return this.toRgbString();
            }
            if (format === "rgb") {
                formattedString = this.toRgbString();
            }
            if (format === "prgb") {
                formattedString = this.toPercentageRgbString();
            }
            if (format === "hex" || format === "hex6") {
                formattedString = this.toHexString();
            }
            if (format === "hex3") {
                formattedString = this.toHexString(true);
            }
            if (format === "hex8") {
                formattedString = this.toHex8String();
            }
            if (format === "name") {
                formattedString = this.toName();
            }
            if (format === "hsl") {
                formattedString = this.toHslString();
            }
            if (format === "hsv") {
                formattedString = this.toHsvString();
            }

            return formattedString || this.toHexString();
        },

        _applyModification: function(fn, args) {
            var color = fn.apply(null, [this].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },

        _applyCombination: function(fn, args) {
            return fn.apply(null, [this].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };

    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for (var i in color) {
                if (color.hasOwnProperty(i)) {
                    if (i === "a") {
                        newColor[i] = color[i];
                    }
                    else {
                        newColor[i] = convertToPercentage(color[i]);
                    }
                }
            }
            color = newColor;
        }

        return tinycolor(color, opts);
    };

    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {

        var rgb = { r: 0, g: 0, b: 0 };
        var a = 1;
        var ok = false;
        var format = false;

        if (typeof color == "string") {
            color = stringInputToObject(color);
        }

        if (typeof color == "object") {
            if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
                color.s = convertToPercentage(color.s);
                color.v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, color.s, color.v);
                ok = true;
                format = "hsv";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
                color.s = convertToPercentage(color.s);
                color.l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, color.s, color.l);
                ok = true;
                format = "hsl";
            }

            if (color.hasOwnProperty("a")) {
                a = color.a;
            }
        }

        a = boundAlpha(a);

        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }


    // Conversion Functions
    // --------------------

    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b){
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }

    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min) {
            h = s = 0; // achromatic
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }

            h /= 6;
        }

        return { h: h, s: s, l: l };
    }

    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;

        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);

        function hue2rgb(p, q, t) {
            if(t < 0) t += 1;
            if(t > 1) t -= 1;
            if(t < 1/6) return p + (q - p) * 6 * t;
            if(t < 1/2) return q;
            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        }

        if(s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;

        var d = max - min;
        s = max === 0 ? 0 : d / max;

        if(max == min) {
            h = 0; // achromatic
        }
        else {
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return { h: h, s: s, v: v };
    }

    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
     function hsvToRgb(h, s, v) {

        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);

        var i = math.floor(h),
            f = h - i,
            p = v * (1 - s),
            q = v * (1 - f * s),
            t = v * (1 - (1 - f) * s),
            mod = i % 6,
            r = [v, q, p, p, t, v][mod],
            g = [t, v, v, q, p, p][mod],
            b = [p, p, t, v, v, q][mod];

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {

        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];

        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        }

        return hex.join("");
    }
        // `rgbaToHex`
        // Converts an RGBA color plus alpha transparency to hex
        // Assumes r, g, b and a are contained in the set [0, 255]
        // Returns an 8 character hex
        function rgbaToHex(r, g, b, a) {

            var hex = [
                pad2(convertDecimalToHex(a)),
                pad2(mathRound(r).toString(16)),
                pad2(mathRound(g).toString(16)),
                pad2(mathRound(b).toString(16))
            ];

            return hex.join("");
        }

    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function (color1, color2) {
        if (!color1 || !color2) { return false; }
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };


    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

    function desaturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function saturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }

    function lighten (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    function brighten(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
        return tinycolor(rgb);
    }

    function darken (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (mathRound(hsl.h) + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }

    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }

    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
        ];
    }

    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;

        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [tinycolor(color)];

        for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }

    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;

        while (results--) {
            ret.push(tinycolor({ h: h, s: s, v: v}));
            v = (v + modification) % 1;
        }

        return ret;
    }

    // Utility Functions
    // ---------------------

    tinycolor.mix = function(color1, color2, amount) {
        amount = (amount === 0) ? 0 : (amount || 50);

        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();

        var p = amount / 100;
        var w = p * 2 - 1;
        var a = rgb2.a - rgb1.a;

        var w1;

        if (w * a == -1) {
            w1 = w;
        } else {
            w1 = (w + a) / (1 + w * a);
        }

        w1 = (w1 + 1) / 2;

        var w2 = 1 - w1;

        var rgba = {
            r: rgb2.r * w1 + rgb1.r * w2,
            g: rgb2.g * w1 + rgb1.g * w2,
            b: rgb2.b * w1 + rgb1.b * w2,
            a: rgb2.a * p  + rgb1.a * (1 - p)
        };

        return tinycolor(rgba);
    };


    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/AERT#color-contrast>

    // `readability`
    // Analyze the 2 colors and returns an object with the following properties:
    //    `brightness`: difference in brightness between the two colors
    //    `color`: difference in color/hue between the two colors
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        var rgb1 = c1.toRgb();
        var rgb2 = c2.toRgb();
        var brightnessA = c1.getBrightness();
        var brightnessB = c2.getBrightness();
        var colorDiff = (
            Math.max(rgb1.r, rgb2.r) - Math.min(rgb1.r, rgb2.r) +
            Math.max(rgb1.g, rgb2.g) - Math.min(rgb1.g, rgb2.g) +
            Math.max(rgb1.b, rgb2.b) - Math.min(rgb1.b, rgb2.b)
        );

        return {
            brightness: Math.abs(brightnessA - brightnessB),
            color: colorDiff
        };
    };

    // `readable`
    // http://www.w3.org/TR/AERT#color-contrast
    // Ensure that foreground and background color combinations provide sufficient contrast.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    tinycolor.isReadable = function(color1, color2) {
        var readability = tinycolor.readability(color1, color2);
        return readability.brightness > 125 && readability.color > 500;
    };

    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // *Example*
    //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
    tinycolor.mostReadable = function(baseColor, colorList) {
        var bestColor = null;
        var bestScore = 0;
        var bestIsReadable = false;
        for (var i=0; i < colorList.length; i++) {

            // We normalize both around the "acceptable" breaking point,
            // but rank brightness constrast higher than hue.

            var readability = tinycolor.readability(baseColor, colorList[i]);
            var readable = readability.brightness > 125 && readability.color > 500;
            var score = 3 * (readability.brightness / 125) + (readability.color / 500);

            if ((readable && ! bestIsReadable) ||
                (readable && bestIsReadable && score > bestScore) ||
                ((! readable) && (! bestIsReadable) && score > bestScore)) {
                bestIsReadable = readable;
                bestScore = score;
                bestColor = tinycolor(colorList[i]);
            }
        }
        return bestColor;
    };


    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };

    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);


    // Utilities
    // ---------

    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = { };
        for (var i in o) {
            if (o.hasOwnProperty(i)) {
                flipped[o[i]] = i;
            }
        }
        return flipped;
    }

    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);

        if (isNaN(a) || a < 0 || a > 1) {
            a = 1;
        }

        return a;
    }

    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) { n = "100%"; }

        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));

        // Automatically convert percentage into number
        if (processPercent) {
            n = parseInt(n * max, 10) / 100;
        }

        // Handle floating point rounding errors
        if ((math.abs(n - max) < 0.000001)) {
            return 1;
        }

        // Convert into [0, 1] range if it isn't already
        return (n % max) / parseFloat(max);
    }

    // Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }

    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }

    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }

    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf('%') != -1;
    }

    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? '0' + c : '' + c;
    }

    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) {
            n = (n * 100) + "%";
        }

        return n;
    }

    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return (parseIntFromHex(h) / 255);
    }

    var matchers = (function() {

        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";

        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

        return {
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    })();

    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {

        color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        }
        else if (color == 'transparent') {
            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
        }

        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if ((match = matchers.rgb.exec(color))) {
            return { r: match[1], g: match[2], b: match[3] };
        }
        if ((match = matchers.rgba.exec(color))) {
            return { r: match[1], g: match[2], b: match[3], a: match[4] };
        }
        if ((match = matchers.hsl.exec(color))) {
            return { h: match[1], s: match[2], l: match[3] };
        }
        if ((match = matchers.hsla.exec(color))) {
            return { h: match[1], s: match[2], l: match[3], a: match[4] };
        }
        if ((match = matchers.hsv.exec(color))) {
            return { h: match[1], s: match[2], v: match[3] };
        }
        if ((match = matchers.hsva.exec(color))) {
            return { h: match[1], s: match[2], v: match[3], a: match[4] };
        }
        if ((match = matchers.hex8.exec(color))) {
            return {
                a: convertHexToDecimal(match[1]),
                r: parseIntFromHex(match[2]),
                g: parseIntFromHex(match[3]),
                b: parseIntFromHex(match[4]),
                format: named ? "name" : "hex8"
            };
        }
        if ((match = matchers.hex6.exec(color))) {
            return {
                r: parseIntFromHex(match[1]),
                g: parseIntFromHex(match[2]),
                b: parseIntFromHex(match[3]),
                format: named ? "name" : "hex"
            };
        }
        if ((match = matchers.hex3.exec(color))) {
            return {
                r: parseIntFromHex(match[1] + '' + match[1]),
                g: parseIntFromHex(match[2] + '' + match[2]),
                b: parseIntFromHex(match[3] + '' + match[3]),
                format: named ? "name" : "hex"
            };
        }

        return false;
    }

    window.tinycolor = tinycolor;
    })();

    $(function () {
        if ($.fn.spectrum.load) {
            $.fn.spectrum.processNativeColorInputs();
        }
    });

});


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SeriesColorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPickerPopover__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_utils_react2angular__ = __webpack_require__(147);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var SeriesColorPicker = /** @class */ (function (_super) {
    __extends(SeriesColorPicker, _super);
    function SeriesColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.onColorChange = _this.onColorChange.bind(_this);
        _this.onToggleAxis = _this.onToggleAxis.bind(_this);
        return _this;
    }
    SeriesColorPicker.prototype.onColorChange = function (color) {
        this.props.onColorChange(color);
    };
    SeriesColorPicker.prototype.onToggleAxis = function () {
        this.props.onToggleAxis();
    };
    SeriesColorPicker.prototype.renderAxisSelection = function () {
        var leftButtonClass = this.props.series.yaxis === 1 ? 'btn-success' : 'btn-inverse';
        var rightButtonClass = this.props.series.yaxis === 2 ? 'btn-success' : 'btn-inverse';
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "p-b-1" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "small p-r-1" }, "Y Axis:"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onClick: this.onToggleAxis, className: 'btn btn-small ' + leftButtonClass }, "Left"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onClick: this.onToggleAxis, className: 'btn btn-small ' + rightButtonClass }, "Right")));
    };
    SeriesColorPicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "graph-legend-popover" },
            this.props.series.yaxis && this.renderAxisSelection(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ColorPickerPopover__["a" /* ColorPickerPopover */], { color: this.props.series.color, onColorSelect: this.onColorChange })));
    };
    return SeriesColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

Object(__WEBPACK_IMPORTED_MODULE_2_app_core_utils_react2angular__["a" /* react2AngularDirective */])('seriesColorPicker', SeriesColorPicker, ['series', 'onColorChange', 'onToggleAxis']);


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export spectrumPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(3);
/**
 * Wrapper for the new ngReact <color-picker> directive for backward compatibility.
 * Allows remaining <spectrum-picker> untouched in outdated plugins.
 * Technically, it's just a wrapper for react component with two-way data binding support.
 */

/** @ngInject */
function spectrumPicker() {
    return {
        restrict: 'E',
        require: 'ngModel',
        scope: true,
        replace: true,
        template: '<color-picker color="ngModel.$viewValue" onChange="onColorChange"></color-picker>',
        link: function (scope, element, attrs, ngModel) {
            scope.ngModel = ngModel;
            scope.onColorChange = function (color) {
                ngModel.$setViewValue(color);
            };
        },
    };
}
__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].directive('spectrumPicker', spectrumPicker);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_services_impression_srv__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_store__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_services_context_srv__ = __webpack_require__(82);





var SearchSrv = /** @class */ (function () {
    /** @ngInject */
    SearchSrv.$inject = ["backendSrv", "$q"];
    function SearchSrv(backendSrv, $q) {
        this.backendSrv = backendSrv;
        this.$q = $q;
        this.recentIsOpen = __WEBPACK_IMPORTED_MODULE_3_app_core_store__["a" /* default */].getBool('search.sections.recent', true);
        this.starredIsOpen = __WEBPACK_IMPORTED_MODULE_3_app_core_store__["a" /* default */].getBool('search.sections.starred', true);
    }
    SearchSrv.prototype.getRecentDashboards = function (sections) {
        var _this = this;
        return this.queryForRecentDashboards().then(function (result) {
            if (result.length > 0) {
                sections['recent'] = {
                    title: 'Recent',
                    icon: 'fa fa-clock-o',
                    score: -1,
                    removable: true,
                    expanded: _this.recentIsOpen,
                    toggle: _this.toggleRecent.bind(_this),
                    items: result,
                };
            }
        });
    };
    SearchSrv.prototype.queryForRecentDashboards = function () {
        var dashIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.take(__WEBPACK_IMPORTED_MODULE_2_app_core_services_impression_srv__["a" /* default */].getDashboardOpened(), 5);
        if (dashIds.length === 0) {
            return Promise.resolve([]);
        }
        return this.backendSrv.search({ dashboardIds: dashIds }).then(function (result) {
            return dashIds
                .map(function (orderId) {
                return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(result, { id: orderId });
            })
                .filter(function (hit) { return hit && !hit.isStarred; });
        });
    };
    SearchSrv.prototype.toggleRecent = function (section) {
        this.recentIsOpen = section.expanded = !section.expanded;
        __WEBPACK_IMPORTED_MODULE_3_app_core_store__["a" /* default */].set('search.sections.recent', this.recentIsOpen);
        if (!section.expanded || section.items.length) {
            return Promise.resolve(section);
        }
        return this.queryForRecentDashboards().then(function (result) {
            section.items = result;
            return Promise.resolve(section);
        });
    };
    SearchSrv.prototype.toggleStarred = function (section) {
        this.starredIsOpen = section.expanded = !section.expanded;
        __WEBPACK_IMPORTED_MODULE_3_app_core_store__["a" /* default */].set('search.sections.starred', this.starredIsOpen);
        return Promise.resolve(section);
    };
    SearchSrv.prototype.getStarred = function (sections) {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_4_app_core_services_context_srv__["a" /* contextSrv */].isSignedIn) {
            return Promise.resolve();
        }
        return this.backendSrv.search({ starred: true, limit: 5 }).then(function (result) {
            if (result.length > 0) {
                sections['starred'] = {
                    title: 'Starred',
                    icon: 'fa fa-star-o',
                    score: -2,
                    expanded: _this.starredIsOpen,
                    toggle: _this.toggleStarred.bind(_this),
                    items: result,
                };
            }
        });
    };
    SearchSrv.prototype.search = function (options) {
        var _this = this;
        var sections = {};
        var promises = [];
        var query = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(options);
        var hasFilters = options.query ||
            (options.tag && options.tag.length > 0) ||
            options.starred ||
            (options.folderIds && options.folderIds.length > 0);
        if (!options.skipRecent && !hasFilters) {
            promises.push(this.getRecentDashboards(sections));
        }
        if (!options.skipStarred && !hasFilters) {
            promises.push(this.getStarred(sections));
        }
        query.folderIds = query.folderIds || [];
        if (!hasFilters) {
            query.folderIds = [0];
        }
        promises.push(this.backendSrv.search(query).then(function (results) {
            return _this.handleSearchResult(sections, results);
        }));
        return this.$q.all(promises).then(function () {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.values(sections), 'score');
        });
    };
    SearchSrv.prototype.handleSearchResult = function (sections, results) {
        if (results.length === 0) {
            return sections;
        }
        // create folder index
        for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
            var hit = results_1[_i];
            if (hit.type === 'dash-folder') {
                sections[hit.id] = {
                    id: hit.id,
                    uid: hit.uid,
                    title: hit.title,
                    expanded: false,
                    items: [],
                    toggle: this.toggleFolder.bind(this),
                    url: hit.url,
                    icon: 'fa fa-folder',
                    score: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(sections).length,
                };
            }
        }
        for (var _a = 0, results_2 = results; _a < results_2.length; _a++) {
            var hit = results_2[_a];
            if (hit.type === 'dash-folder') {
                continue;
            }
            var section = sections[hit.folderId || 0];
            if (!section) {
                if (hit.folderId) {
                    section = {
                        id: hit.folderId,
                        uid: hit.folderUid,
                        title: hit.folderTitle,
                        url: hit.folderUrl,
                        items: [],
                        icon: 'fa fa-folder-open',
                        toggle: this.toggleFolder.bind(this),
                        score: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(sections).length,
                    };
                }
                else {
                    section = {
                        id: 0,
                        title: 'General',
                        items: [],
                        icon: 'fa fa-folder-open',
                        toggle: this.toggleFolder.bind(this),
                        score: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(sections).length,
                    };
                }
                // add section
                sections[hit.folderId || 0] = section;
            }
            section.expanded = true;
            section.items.push(hit);
        }
    };
    SearchSrv.prototype.toggleFolder = function (section) {
        section.expanded = !section.expanded;
        section.icon = section.expanded ? 'fa fa-folder-open' : 'fa fa-folder';
        if (section.items.length) {
            return Promise.resolve(section);
        }
        var query = {
            folderIds: [section.id],
        };
        return this.backendSrv.search(query).then(function (results) {
            section.items = results;
            return Promise.resolve(section);
        });
    };
    SearchSrv.prototype.getDashboardTags = function () {
        return this.backendSrv.get('/api/dashboards/tags');
    };
    return SearchSrv;
}());

__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].service('searchSrv', SearchSrv);


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular__);
//
// This is using ng-react with this PR applied https://github.com/ngReact/ngReact/pull/199
//
// # ngReact
// ### Use React Components inside of your Angular applications
//
// Composed of
// - reactComponent (generic directive for delegating off to React Components)
// - reactDirective (factory for creating specific directives that correspond to reactComponent directives)



// get a react component from name (components can be an angular injectable e.g. value, factory or
// available on window
function getReactComponent(name, $injector) {
    // if name is a function assume it is component and return it
    if (__WEBPACK_IMPORTED_MODULE_2_angular___default.a.isFunction(name)) {
        return name;
    }
    // a React component name must be specified
    if (!name) {
        throw new Error('ReactComponent name attribute must be specified');
    }
    // ensure the specified React component is accessible, and fail fast if it's not
    var reactComponent;
    try {
        reactComponent = $injector.get(name);
    }
    catch (e) { }
    if (!reactComponent) {
        try {
            reactComponent = name.split('.').reduce(function (current, namePart) {
                return current[namePart];
            }, window);
        }
        catch (e) { }
    }
    if (!reactComponent) {
        throw Error('Cannot find react component ' + name);
    }
    return reactComponent;
}
// wraps a function with scope.$apply, if already applied just return
function applied(fn, scope) {
    if (fn.wrappedInApply) {
        return fn;
    }
    var wrapped = function () {
        var args = arguments;
        var phase = scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            return fn.apply(null, args);
        }
        else {
            return scope.$apply(function () {
                return fn.apply(null, args);
            });
        }
    };
    wrapped.wrappedInApply = true;
    return wrapped;
}
/**
 * wraps functions on obj in scope.$apply
 *
 * keeps backwards compatibility, as if propsConfig is not passed, it will
 * work as before, wrapping all functions and won't wrap only when specified.
 *
 * @version 0.4.1
 * @param obj react component props
 * @param scope current scope
 * @param propsConfig configuration object for all properties
 * @returns {Object} props with the functions wrapped in scope.$apply
 */
function applyFunctions(obj, scope, propsConfig) {
    return Object.keys(obj || {}).reduce(function (prev, key) {
        var value = obj[key];
        var config = (propsConfig || {})[key] || {};
        /**
         * wrap functions in a function that ensures they are scope.$applied
         * ensures that when function is called from a React component
         * the Angular digest cycle is run
         */
        prev[key] = __WEBPACK_IMPORTED_MODULE_2_angular___default.a.isFunction(value) && config.wrapApply !== false ? applied(value, scope) : value;
        return prev;
    }, {});
}
/**
 *
 * @param watchDepth (value of HTML watch-depth attribute)
 * @param scope (angular scope)
 *
 * Uses the watchDepth attribute to determine how to watch props on scope.
 * If watchDepth attribute is NOT reference or collection, watchDepth defaults to deep watching by value
 */
function watchProps(watchDepth, scope, watchExpressions, listener) {
    var supportsWatchCollection = __WEBPACK_IMPORTED_MODULE_2_angular___default.a.isFunction(scope.$watchCollection);
    var supportsWatchGroup = __WEBPACK_IMPORTED_MODULE_2_angular___default.a.isFunction(scope.$watchGroup);
    var watchGroupExpressions = [];
    watchExpressions.forEach(function (expr) {
        var actualExpr = getPropExpression(expr);
        var exprWatchDepth = getPropWatchDepth(watchDepth, expr);
        if (exprWatchDepth === 'collection' && supportsWatchCollection) {
            scope.$watchCollection(actualExpr, listener);
        }
        else if (exprWatchDepth === 'reference' && supportsWatchGroup) {
            watchGroupExpressions.push(actualExpr);
        }
        else if (exprWatchDepth === 'one-time') {
            //do nothing because we handle our one time bindings after this
        }
        else {
            scope.$watch(actualExpr, listener, exprWatchDepth !== 'reference');
        }
    });
    if (watchDepth === 'one-time') {
        listener();
    }
    if (watchGroupExpressions.length) {
        scope.$watchGroup(watchGroupExpressions, listener);
    }
}
// render React component, with scope[attrs.props] being passed in as the component props
function renderComponent(component, props, scope, elem) {
    scope.$evalAsync(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(component, props), elem[0]);
    });
}
// get prop name from prop (string or array)
function getPropName(prop) {
    return Array.isArray(prop) ? prop[0] : prop;
}
// get prop name from prop (string or array)
function getPropConfig(prop) {
    return Array.isArray(prop) ? prop[1] : {};
}
// get prop expression from prop (string or array)
function getPropExpression(prop) {
    return Array.isArray(prop) ? prop[0] : prop;
}
// find the normalized attribute knowing that React props accept any type of capitalization
function findAttribute(attrs, propName) {
    var index = Object.keys(attrs).filter(function (attr) {
        return attr.toLowerCase() === propName.toLowerCase();
    })[0];
    return attrs[index];
}
// get watch depth of prop (string or array)
function getPropWatchDepth(defaultWatch, prop) {
    var customWatchDepth = Array.isArray(prop) && __WEBPACK_IMPORTED_MODULE_2_angular___default.a.isObject(prop[1]) && prop[1].watchDepth;
    return customWatchDepth || defaultWatch;
}
// # reactComponent
// Directive that allows React components to be used in Angular templates.
//
// Usage:
//     <react-component name="Hello" props="name"/>
//
// This requires that there exists an injectable or globally available 'Hello' React component.
// The 'props' attribute is optional and is passed to the component.
//
// The following would would create and register the component:
//
//     var module = angular.module('ace.react.components');
//     module.value('Hello', React.createClass({
//         render: function() {
//             return <div>Hello {this.props.name}</div>;
//         }
//     }));
//
var reactComponent = function ($injector) {
    return {
        restrict: 'E',
        replace: true,
        link: function (scope, elem, attrs) {
            var reactComponent = getReactComponent(attrs.name, $injector);
            var renderMyComponent = function () {
                var scopeProps = scope.$eval(attrs.props);
                var props = applyFunctions(scopeProps, scope);
                renderComponent(reactComponent, props, scope, elem);
            };
            // If there are props, re-render when they change
            attrs.props ? watchProps(attrs.watchDepth, scope, [attrs.props], renderMyComponent) : renderMyComponent();
            // cleanup when scope is destroyed
            scope.$on('$destroy', function () {
                if (!attrs.onScopeDestroy) {
                    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(elem[0]);
                }
                else {
                    scope.$eval(attrs.onScopeDestroy, {
                        unmountComponent: __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode.bind(this, elem[0]),
                    });
                }
            });
        },
    };
};
// # reactDirective
// Factory function to create directives for React components.
//
// With a component like this:
//
//     var module = angular.module('ace.react.components');
//     module.value('Hello', React.createClass({
//         render: function() {
//             return <div>Hello {this.props.name}</div>;
//         }
//     }));
//
// A directive can be created and registered with:
//
//     module.directive('hello', function(reactDirective) {
//         return reactDirective('Hello', ['name']);
//     });
//
// Where the first argument is the injectable or globally accessible name of the React component
// and the second argument is an array of property names to be watched and passed to the React component
// as props.
//
// This directive can then be used like this:
//
//     <hello name="name"/>
//
var reactDirective = function ($injector) {
    return function (reactComponentName, props, conf, injectableProps) {
        var directive = {
            restrict: 'E',
            replace: true,
            link: function (scope, elem, attrs) {
                var reactComponent = getReactComponent(reactComponentName, $injector);
                // if props is not defined, fall back to use the React component's propTypes if present
                props = props || Object.keys(reactComponent.propTypes || {});
                // for each of the properties, get their scope value and set it to scope.props
                var renderMyComponent = function () {
                    var scopeProps = {}, config = {};
                    props.forEach(function (prop) {
                        var propName = getPropName(prop);
                        scopeProps[propName] = scope.$eval(findAttribute(attrs, propName));
                        config[propName] = getPropConfig(prop);
                    });
                    scopeProps = applyFunctions(scopeProps, scope, config);
                    scopeProps = __WEBPACK_IMPORTED_MODULE_2_angular___default.a.extend({}, scopeProps, injectableProps);
                    renderComponent(reactComponent, scopeProps, scope, elem);
                };
                // watch each property name and trigger an update whenever something changes,
                // to update scope.props with new values
                var propExpressions = props.map(function (prop) {
                    return Array.isArray(prop) ? [attrs[getPropName(prop)], getPropConfig(prop)] : attrs[prop];
                });
                // If we don't have any props, then our watch statement won't fire.
                props.length ? watchProps(attrs.watchDepth, scope, propExpressions, renderMyComponent) : renderMyComponent();
                // cleanup when scope is destroyed
                scope.$on('$destroy', function () {
                    if (!attrs.onScopeDestroy) {
                        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(elem[0]);
                    }
                    else {
                        scope.$eval(attrs.onScopeDestroy, {
                            unmountComponent: __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode.bind(this, elem[0]),
                        });
                    }
                });
            },
        };
        return __WEBPACK_IMPORTED_MODULE_2_angular___default.a.extend(directive, conf);
    };
};
var ngModule = __WEBPACK_IMPORTED_MODULE_2_angular___default.a.module('react', []);
ngModule.directive('reactComponent', ['$injector', reactComponent]);
ngModule.factory('reactDirective', ['$injector', reactDirective]);


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GrafanaCtrl */
/* unused harmony export grafanaAppDirective */
/* harmony import */ 
grafanaAppDirective.$inject = ["playlistSrv", "contextSrv", "$timeout", "$rootScope", "$location"];var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_profiler__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tether_drop__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tether_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tether_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_stores_store__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_core_utils_colors__ = __webpack_require__(108);









var GrafanaCtrl = /** @class */ (function () {
    /** @ngInject */
    GrafanaCtrl.$inject = ["$scope", "alertSrv", "utilSrv", "$rootScope", "$controller", "contextSrv", "bridgeSrv", "backendSrv"];
    function GrafanaCtrl($scope, alertSrv, utilSrv, $rootScope, $controller, contextSrv, bridgeSrv, backendSrv) {
        Object(__WEBPACK_IMPORTED_MODULE_7_app_stores_store__["a" /* createStore */])(backendSrv);
        $scope.init = function () {
            $scope.contextSrv = contextSrv;
            $scope.appSubUrl = __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].appSubUrl;
            $scope._ = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a;
            __WEBPACK_IMPORTED_MODULE_4_app_core_profiler__["a" /* profiler */].init(__WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */], $rootScope);
            alertSrv.init();
            utilSrv.init();
            bridgeSrv.init();
            $scope.dashAlerts = alertSrv;
        };
        $rootScope.colors = __WEBPACK_IMPORTED_MODULE_8_app_core_utils_colors__["f" /* default */];
        $scope.initDashboard = function (dashboardData, viewScope) {
            $scope.appEvent('dashboard-fetch-end', dashboardData);
            $controller('DashboardCtrl', { $scope: viewScope }).init(dashboardData);
        };
        $rootScope.onAppEvent = function (name, callback, localScope) {
            var unbind = $rootScope.$on(name, callback);
            var callerScope = this;
            if (callerScope.$id === 1 && !localScope) {
                console.log('warning rootScope onAppEvent called without localscope');
            }
            if (localScope) {
                callerScope = localScope;
            }
            callerScope.$on('$destroy', unbind);
        };
        $rootScope.appEvent = function (name, payload) {
            $rootScope.$emit(name, payload);
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit(name, payload);
        };
        $scope.init();
    }
    return GrafanaCtrl;
}());

/** @ngInject */
function grafanaAppDirective(playlistSrv, contextSrv, $timeout, $rootScope, $location) {
    return {
        restrict: 'E',
        controller: GrafanaCtrl,
        link: function (scope, elem) {
            var sidemenuOpen;
            var body = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body');
            // see https://github.com/zenorocha/clipboard.js/issues/155
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.fn.modal.Constructor.prototype.enforceFocus = function () { };
            sidemenuOpen = scope.contextSrv.sidemenu;
            body.toggleClass('sidemenu-open', sidemenuOpen);
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].on('toggle-sidemenu', function () {
                sidemenuOpen = scope.contextSrv.sidemenu;
                body.toggleClass('sidemenu-open');
            });
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].on('toggle-sidemenu-mobile', function () {
                body.toggleClass('sidemenu-open--xs');
            });
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].on('toggle-sidemenu-hidden', function () {
                body.toggleClass('sidemenu-hidden');
            });
            scope.$watch(function () { return playlistSrv.isPlaying; }, function (newValue) {
                elem.toggleClass('playlist-active', newValue === true);
            });
            // check if we are in server side render
            if (document.cookie.indexOf('renderKey') !== -1) {
                body.addClass('body--phantomjs');
            }
            // tooltip removal fix
            // manage page classes
            var pageClass;
            scope.$on('$routeChangeSuccess', function (evt, data) {
                if (pageClass) {
                    body.removeClass(pageClass);
                }
                if (data.$$route) {
                    pageClass = data.$$route.pageClass;
                    if (pageClass) {
                        body.addClass(pageClass);
                    }
                }
                // clear body class sidemenu states
                body.removeClass('sidemenu-open--xs');
                __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#tooltip, .tooltip').remove();
                // check for kiosk url param
                if (data.params.kiosk) {
                    __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('toggle-kiosk-mode');
                }
                // check for 'inactive' url param for clean looks like kiosk, but with title
                if (data.params.inactive) {
                    body.addClass('user-activity-low');
                    // for some reason, with this class it looks cleanest
                    body.addClass('sidemenu-open');
                }
                // close all drops
                for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_6_tether_drop___default.a.drops; _i < _a.length; _i++) {
                    var drop = _a[_i];
                    drop.destroy();
                }
            });
            // handle kiosk mode
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].on('toggle-kiosk-mode', function () {
                body.toggleClass('page-kiosk-mode');
            });
            // handle in active view state class
            var lastActivity = new Date().getTime();
            var activeUser = true;
            var inActiveTimeLimit = 60 * 1000;
            var sidemenuHidden = false;
            function checkForInActiveUser() {
                if (!activeUser) {
                    return;
                }
                // only go to activity low mode on dashboard page
                if (!body.hasClass('page-dashboard')) {
                    return;
                }
                if (new Date().getTime() - lastActivity > inActiveTimeLimit) {
                    activeUser = false;
                    body.addClass('user-activity-low');
                    // hide sidemenu
                    if (sidemenuOpen) {
                        sidemenuHidden = true;
                        body.removeClass('sidemenu-open');
                        $timeout(function () {
                            $rootScope.$broadcast('render');
                        }, 100);
                    }
                }
            }
            function userActivityDetected() {
                lastActivity = new Date().getTime();
                if (!activeUser) {
                    activeUser = true;
                    body.removeClass('user-activity-low');
                    // restore sidemenu
                    if (sidemenuHidden) {
                        sidemenuHidden = false;
                        body.addClass('sidemenu-open');
                        __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('toggle-inactive-mode');
                        $timeout(function () {
                            $rootScope.$broadcast('render');
                        }, 100);
                    }
                }
            }
            // mouse and keyboard is user activity
            body.mousemove(userActivityDetected);
            body.keydown(userActivityDetected);
            // set useCapture = true to catch event here
            document.addEventListener('wheel', userActivityDetected, true);
            // treat tab change as activity
            document.addEventListener('visibilitychange', userActivityDetected);
            // check every 2 seconds
            setInterval(checkForInActiveUser, 2000);
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].on('toggle-view-mode', function () {
                lastActivity = 0;
                checkForInActiveUser();
            });
            // handle document clicks that should hide things
            body.click(function (evt) {
                var target = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(evt.target);
                if (target.parents().length === 0) {
                    return;
                }
                // for stuff that animates, slides out etc, clicking it needs to
                // hide it right away
                var clickAutoHide = target.closest('[data-click-hide]');
                if (clickAutoHide.length) {
                    var clickAutoHideParent = clickAutoHide.parent();
                    clickAutoHide.detach();
                    setTimeout(function () {
                        clickAutoHideParent.append(clickAutoHide);
                    }, 100);
                }
                if (target.parents('.navbar-buttons--playlist').length === 0) {
                    playlistSrv.stop();
                }
                // hide search
                if (body.find('.search-container').length > 0) {
                    if (target.parents('.search-results-container, .search-field-wrapper').length === 0) {
                        scope.$apply(function () {
                            scope.appEvent('hide-dash-search');
                        });
                    }
                }
                // hide popovers
                var popover = elem.find('.popover');
                if (popover.length > 0 && target.parents('.graph-legend').length === 0) {
                    popover.hide();
                }
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_3_app_core_core_module__["a" /* default */].directive('grafanaApp', grafanaAppDirective);


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RootStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchStore_SearchStore__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ServerStatsStore_ServerStatsStore__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavStore_NavStore__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlertListStore_AlertListStore__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewStore_ViewStore__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FolderStore_FolderStore__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PermissionsStore_PermissionsStore__ = __webpack_require__(92);








var RootStore = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].model({
    search: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_1__SearchStore_SearchStore__["a" /* SearchStore */], {
        sections: [],
    }),
    serverStats: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_2__ServerStatsStore_ServerStatsStore__["a" /* ServerStatsStore */], {
        stats: [],
    }),
    nav: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_3__NavStore_NavStore__["a" /* NavStore */], {}),
    alertList: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_4__AlertListStore_AlertListStore__["a" /* AlertListStore */], {
        rules: [],
    }),
    permissions: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_7__PermissionsStore_PermissionsStore__["a" /* PermissionsStore */], {
        fetching: false,
        items: [],
    }),
    view: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_5__ViewStore_ViewStore__["a" /* ViewStore */], {
        path: '',
        query: {},
        routeParams: {},
    }),
    folder: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_6__FolderStore_FolderStore__["a" /* FolderStore */], {}),
});


/***/ }),
/* 950 */,
/* 951 */,
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchResultSection__ = __webpack_require__(953);


var SearchStore = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('SearchStore', {
    sections: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(__WEBPACK_IMPORTED_MODULE_1__SearchResultSection__["a" /* SearchResultSection */]),
})
    .actions(function (self) { return ({
    query: function () {
        for (var i = 0; i < 100; i++) {
            self.sections.push(__WEBPACK_IMPORTED_MODULE_1__SearchResultSection__["a" /* SearchResultSection */].create({
                id: 'starred' + i,
                title: 'starred',
                icon: 'fa fa-fw fa-star-o',
                expanded: false,
                items: [],
            }));
        }
    },
}); });


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchResultSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResultItem__ = __webpack_require__(954);


var SearchResultSection = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('SearchResultSection', {
    id: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].identifier(),
    title: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    icon: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    expanded: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean,
    items: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(__WEBPACK_IMPORTED_MODULE_1__ResultItem__["a" /* ResultItem */]),
})
    .actions(function (self) { return ({
    toggle: function () {
        self.expanded = !self.expanded;
        for (var i = 0; i < 100; i++) {
            self.items.push(__WEBPACK_IMPORTED_MODULE_1__ResultItem__["a" /* ResultItem */].create({
                id: i,
                title: 'Dashboard ' + self.items.length,
                icon: 'gicon gicon-dashboard',
                url: 'asd',
            }));
        }
    },
}); });


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);

var ResultItem = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].model('ResultItem', {
    id: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].identifier(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number),
    folderId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number, 0),
    title: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    url: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    icon: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    folderTitle: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
});


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerStatsStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServerStat__ = __webpack_require__(956);
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var ServerStatsStore = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('ServerStatsStore', {
    stats: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */]),
    error: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
})
    .actions(function (self) { return ({
    load: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function load() {
        var backendSrv, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    backendSrv = Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["getEnv"])(self).backendSrv;
                    return [4 /*yield*/, backendSrv.get('/api/admin/stats')];
                case 1:
                    res = _a.sent();
                    self.stats.clear();
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Total dashboards', value: res.dashboards }));
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Total users', value: res.users }));
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Active users (seen last 30 days)', value: res.activeUsers }));
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Total orgs', value: res.orgs }));
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Total playlists', value: res.playlists }));
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Total snapshots', value: res.snapshots }));
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Total dashboard tags', value: res.tags }));
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Total starred dashboards', value: res.stars }));
                    self.stats.push(__WEBPACK_IMPORTED_MODULE_1__ServerStat__["a" /* ServerStat */].create({ name: 'Total alerts', value: res.alerts }));
                    return [2 /*return*/];
            }
        });
    }),
}); });


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerStat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);

var ServerStat = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].model('ServerStat', {
    name: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    value: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number, 0),
});


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavItem__ = __webpack_require__(958);



var NavStore = __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["types"]
    .model('NavStore', {
    main: __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_2__NavItem__["a" /* NavItem */]),
    node: __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_2__NavItem__["a" /* NavItem */]),
})
    .actions(function (self) { return ({
    load: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var children = Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["getEnv"])(self).navTree;
        var main, node;
        var parents = [];
        var _loop_1 = function (id) {
            node = children.find(function (el) { return el.id === id; });
            if (!node) {
                throw new Error("NavItem with id " + id + " not found");
            }
            children = node.children;
            parents.push(node);
        };
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var id = args_1[_a];
            _loop_1(id);
        }
        main = parents[parents.length - 2];
        if (main.children) {
            for (var _b = 0, _c = main.children; _b < _c.length; _b++) {
                var item = _c[_b];
                item.active = false;
                if (item.url === node.url) {
                    item.active = true;
                }
            }
        }
        self.main = __WEBPACK_IMPORTED_MODULE_2__NavItem__["a" /* NavItem */].create(main);
        self.node = __WEBPACK_IMPORTED_MODULE_2__NavItem__["a" /* NavItem */].create(node);
    },
    initFolderNav: function (folder, activeChildId) {
        var main = {
            icon: 'fa fa-folder-open',
            id: 'manage-folder',
            subTitle: 'Manage folder dashboards & permissions',
            url: '',
            text: folder.title,
            breadcrumbs: [{ title: 'Dashboards', url: 'dashboards' }],
            children: [
                {
                    active: activeChildId === 'manage-folder-dashboards',
                    icon: 'fa fa-fw fa-th-large',
                    id: 'manage-folder-dashboards',
                    text: 'Dashboards',
                    url: folder.url,
                },
                {
                    active: activeChildId === 'manage-folder-permissions',
                    icon: 'fa fa-fw fa-lock',
                    id: 'manage-folder-permissions',
                    text: 'Permissions',
                    url: folder.url + "/permissions",
                },
                {
                    active: activeChildId === 'manage-folder-settings',
                    icon: 'fa fa-fw fa-cog',
                    id: 'manage-folder-settings',
                    text: 'Settings',
                    url: folder.url + "/settings",
                },
            ],
        };
        self.main = __WEBPACK_IMPORTED_MODULE_2__NavItem__["a" /* NavItem */].create(main);
    },
    initDatasourceEditNav: function (ds, plugin, currentPage) {
        var title = 'New';
        var subTitle = "Type: " + plugin.name;
        if (ds.id) {
            title = ds.name;
        }
        var main = {
            img: plugin.info.logos.large,
            id: 'ds-edit-' + plugin.id,
            subTitle: subTitle,
            url: '',
            text: title,
            breadcrumbs: [{ title: 'Data Sources', url: 'datasources' }],
            children: [
                {
                    active: currentPage === 'datasource-settings',
                    icon: 'fa fa-fw fa-sliders',
                    id: 'datasource-settings',
                    text: 'Settings',
                    url: "datasources/edit/" + ds.id,
                },
            ],
        };
        var hasDashboards = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(plugin.includes, { type: 'dashboard' }) !== undefined;
        if (hasDashboards && ds.id) {
            main.children.push({
                active: currentPage === 'datasource-dashboards',
                icon: 'fa fa-fw fa-th-large',
                id: 'datasource-dashboards',
                text: 'Dashboards',
                url: "datasources/edit/" + ds.id + "/dashboards",
            });
        }
        self.main = __WEBPACK_IMPORTED_MODULE_2__NavItem__["a" /* NavItem */].create(main);
    },
}); });


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavItem; });
/* unused harmony export Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);

var NavItem = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].model('NavItem', {
    id: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].identifier(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    text: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    url: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
    subTitle: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
    icon: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
    img: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
    active: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean, false),
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].late(function () { return Breadcrumb; })), []),
    children: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].late(function () { return NavItem; })), []),
});
var Breadcrumb = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].model('Breadcrumb', {
    title: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    url: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
});


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertListStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AlertRule__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(400);
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var AlertListStore = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('AlertListStore', {
    rules: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(__WEBPACK_IMPORTED_MODULE_1__AlertRule__["a" /* AlertRule */]),
    stateFilter: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, 'all'),
    search: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
})
    .views(function (self) { return ({
    get filteredRules() {
        var regex = new RegExp(self.search, 'i');
        return self.rules.filter(function (alert) {
            return regex.test(alert.name) || regex.test(alert.stateText) || regex.test(alert.info);
        });
    },
}); })
    .actions(function (self) { return ({
    loadRules: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function load(filters) {
        var backendSrv, apiRules, _i, apiRules_1, rule;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    backendSrv = Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["getEnv"])(self).backendSrv;
                    self.stateFilter = filters.state; // store state filter used in api query
                    return [4 /*yield*/, backendSrv.get('/api/alerts', filters)];
                case 1:
                    apiRules = _a.sent();
                    self.rules.clear();
                    for (_i = 0, apiRules_1 = apiRules; _i < apiRules_1.length; _i++) {
                        rule = apiRules_1[_i];
                        Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* setStateFields */])(rule, rule.state);
                        if (rule.state !== 'paused') {
                            if (rule.executionError) {
                                rule.info = 'Execution Error: ' + rule.executionError;
                            }
                            if (rule.evalData && rule.evalData.noData) {
                                rule.info = 'Query returned no data';
                            }
                        }
                        self.rules.push(__WEBPACK_IMPORTED_MODULE_1__AlertRule__["a" /* AlertRule */].create(rule));
                    }
                    return [2 /*return*/];
            }
        });
    }),
    setSearchQuery: function (query) {
        self.search = query;
    },
}); });


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertRule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(400);
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var AlertRule = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('AlertRule', {
    id: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].identifier(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number),
    dashboardId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number,
    panelId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number,
    name: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    state: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    stateText: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    stateIcon: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    stateClass: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    stateAge: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    info: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
    url: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
})
    .views(function (self) { return ({
    get isPaused() {
        return self.state === 'paused';
    },
}); })
    .actions(function (self) { return ({
    /**
     * will toggle alert rule paused state
     */
    togglePaused: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function togglePaused() {
        var backendSrv, payload, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    backendSrv = Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["getEnv"])(self).backendSrv;
                    payload = { paused: !self.isPaused };
                    return [4 /*yield*/, backendSrv.post("/api/alerts/" + self.id + "/pause", payload)];
                case 1:
                    res = _a.sent();
                    Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* setStateFields */])(self, res.state);
                    self.info = '';
                    return [2 /*return*/];
            }
        });
    }),
}); });


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_utils_url__ = __webpack_require__(962);



var QueryInnerValueType = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].union(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean, __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number);
var QueryValueType = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].union(QueryInnerValueType, __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].array(QueryInnerValueType));
var ViewStore = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model({
    path: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    query: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].map(QueryValueType),
    routeParams: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].map(QueryValueType),
})
    .views(function (self) { return ({
    get currentUrl() {
        var path = self.path;
        if (self.query.size) {
            path += '?' + Object(__WEBPACK_IMPORTED_MODULE_2_app_core_utils_url__["a" /* toUrlParams */])(Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(self.query));
        }
        return path;
    },
}); })
    .actions(function (self) {
    // querystring only
    function updateQuery(query) {
        self.query.clear();
        for (var _i = 0, _a = Object.keys(query); _i < _a.length; _i++) {
            var key = _a[_i];
            if (query[key]) {
                self.query.set(key, query[key]);
            }
        }
    }
    // needed to get route parameters like slug from the url
    function updateRouteParams(routeParams) {
        self.routeParams.clear();
        for (var _i = 0, _a = Object.keys(routeParams); _i < _a.length; _i++) {
            var key = _a[_i];
            if (routeParams[key]) {
                self.routeParams.set(key, routeParams[key]);
            }
        }
    }
    function updatePathAndQuery(path, query, routeParams) {
        self.path = path;
        updateQuery(query);
        updateRouteParams(routeParams);
    }
    return {
        updateQuery: updateQuery,
        updatePathAndQuery: updatePathAndQuery,
    };
});


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toUrlParams;
/**
 * @preserve jquery-param (c) 2015 KNOWLEDGECODE | MIT
 */
function toUrlParams(a) {
    var s = [];
    var rbracket = /\[\]$/;
    var isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    var add = function (k, v) {
        v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
        if (typeof v !== 'boolean') {
            s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
        }
        else {
            s[s.length] = encodeURIComponent(k);
        }
    };
    var buildParams = function (prefix, obj) {
        var i, len, key;
        if (prefix) {
            if (isArray(obj)) {
                for (i = 0, len = obj.length; i < len; i++) {
                    if (rbracket.test(prefix)) {
                        add(prefix, obj[i]);
                    }
                    else {
                        buildParams(prefix, obj[i]);
                    }
                }
            }
            else if (obj && String(obj) === '[object Object]') {
                for (key in obj) {
                    buildParams(prefix + '[' + key + ']', obj[key]);
                }
            }
            else {
                add(prefix, obj);
            }
        }
        else if (isArray(obj)) {
            for (i = 0, len = obj.length; i < len; i++) {
                add(obj[i].name, obj[i].value);
            }
        }
        else {
            for (key in obj) {
                buildParams(key, obj[key]);
            }
        }
        return s;
    };
    return buildParams('', a)
        .join('&')
        .replace(/%20/g, '+');
}


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Folder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FolderStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var Folder = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].model('Folder', {
    id: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].identifier(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number),
    uid: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    url: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string,
    canSave: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean,
    hasChanged: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean,
    version: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number,
});
var FolderStore = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('FolderStore', {
    folder: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(Folder),
})
    .actions(function (self) { return ({
    load: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function load(uid) {
        var backendSrv, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // clear folder state
                    if (self.folder && self.folder.uid !== uid) {
                        self.folder = null;
                    }
                    backendSrv = Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["getEnv"])(self).backendSrv;
                    return [4 /*yield*/, backendSrv.getFolderByUid(uid)];
                case 1:
                    res = _a.sent();
                    self.folder = Folder.create({
                        id: res.id,
                        uid: res.uid,
                        title: res.title,
                        url: res.url,
                        canSave: res.canSave,
                        hasChanged: false,
                        version: res.version,
                    });
                    return [2 /*return*/, res];
            }
        });
    }),
    setTitle: function (originalTitle, title) {
        self.folder.title = title;
        self.folder.hasChanged = originalTitle.toLowerCase() !== title.trim().toLowerCase() && title.trim().length > 0;
    },
    saveFolder: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function saveFolder(options) {
        var backendSrv, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    backendSrv = Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["getEnv"])(self).backendSrv;
                    self.folder.title = self.folder.title.trim();
                    return [4 /*yield*/, backendSrv.updateFolder(self.folder, options)];
                case 1:
                    res = _a.sent();
                    self.folder.url = res.url;
                    self.folder.version = res.version;
                    return [2 /*return*/, self.folder.url + "/settings"];
            }
        });
    }),
    deleteFolder: Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["flow"])(function deleteFolder() {
        var backendSrv;
        return __generator(this, function (_a) {
            backendSrv = Object(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["getEnv"])(self).backendSrv;
            return [2 /*return*/, backendSrv.deleteFolder(self.folder.uid)];
        });
    }),
}); });


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermissionsStoreItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(23);

var PermissionsStoreItem = __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"]
    .model('PermissionsStoreItem', {
    dashboardId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number, -1),
    permission: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number,
    permissionName: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    role: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    team: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
    teamId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number, 0),
    userEmail: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
    userId: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number, 0),
    userLogin: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].optional(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string, ''),
    inherited: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].boolean),
    sortRank: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].number),
    icon: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    name: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    teamAvatarUrl: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
    userAvatarUrl: __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["types"].string),
})
    .actions(function (self) { return ({
    updateRole: function (role) {
        self.role = role;
    },
    updatePermission: function (permission, permissionName) {
        self.permission = permission;
        self.permissionName = permissionName;
    },
}); });


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SideMenuCtrl */
/* unused harmony export sideMenuDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_app_events__ = __webpack_require__(17);





var SideMenuCtrl = /** @class */ (function () {
    /** @ngInject */
    SideMenuCtrl.$inject = ["$scope", "$rootScope", "$location", "contextSrv", "$timeout"];
    function SideMenuCtrl($scope, $rootScope, $location, contextSrv, $timeout) {
        var _this = this;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.contextSrv = contextSrv;
        this.$timeout = $timeout;
        this.isSignedIn = contextSrv.isSignedIn;
        this.user = contextSrv.user;
        var navTree = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_1_app_core_config__["a" /* default */].bootData.navTree);
        this.mainLinks = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(navTree, function (item) { return !item.hideFromMenu; });
        this.bottomNav = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(navTree, function (item) { return item.hideFromMenu; });
        this.loginUrl = 'login?redirect=' + encodeURIComponent(this.$location.path());
        if (contextSrv.user.orgCount > 1) {
            var profileNode = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.bottomNav, { id: 'profile' });
            if (profileNode) {
                profileNode.showOrgSwitcher = true;
            }
        }
        this.$scope.$on('$routeChangeSuccess', function () {
            _this.loginUrl = 'login?redirect=' + encodeURIComponent(_this.$location.path());
        });
    }
    SideMenuCtrl.prototype.toggleSideMenu = function () {
        var _this = this;
        this.contextSrv.toggleSideMenu();
        __WEBPACK_IMPORTED_MODULE_4_app_core_app_events__["a" /* default */].emit('toggle-sidemenu');
        this.$timeout(function () {
            _this.$rootScope.$broadcast('render');
        });
    };
    SideMenuCtrl.prototype.toggleSideMenuSmallBreakpoint = function () {
        __WEBPACK_IMPORTED_MODULE_4_app_core_app_events__["a" /* default */].emit('toggle-sidemenu-mobile');
    };
    SideMenuCtrl.prototype.switchOrg = function () {
        this.$rootScope.appEvent('show-modal', {
            templateHtml: '<org-switcher dismiss="dismiss()"></org-switcher>',
        });
    };
    SideMenuCtrl.prototype.itemClicked = function (item, evt) {
        if (item.url === '/shortcuts') {
            __WEBPACK_IMPORTED_MODULE_4_app_core_app_events__["a" /* default */].emit('show-modal', {
                templateHtml: '<help-modal></help-modal>',
            });
            evt.preventDefault();
        }
    };
    return SideMenuCtrl;
}());

function sideMenuDirective() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/sidemenu/sidemenu.html',
        controller: SideMenuCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {},
        link: function (scope, elem) {
            // hack to hide dropdown menu
            elem.on('click.dropdown', '.dropdown-menu a', function (evt) {
                var menu = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(evt.target).parents('.dropdown-menu');
                var parent = menu.parent();
                menu.detach();
                setTimeout(function () {
                    parent.append(menu);
                }, 100);
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_3__core_module__["a" /* default */].directive('sidemenu', sideMenuDirective);


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchCtrl */
/* unused harmony export searchDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_services_context_srv__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__ = __webpack_require__(17);




var SearchCtrl = /** @class */ (function () {
    /** @ngInject */
    SearchCtrl.$inject = ["$scope", "$location", "$timeout", "searchSrv"];
    function SearchCtrl($scope, $location, $timeout, searchSrv) {
        this.$location = $location;
        this.$timeout = $timeout;
        this.searchSrv = searchSrv;
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('show-dash-search', this.openSearch.bind(this), $scope);
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('hide-dash-search', this.closeSearch.bind(this), $scope);
        this.initialFolderFilterTitle = 'All';
        this.getTags = this.getTags.bind(this);
        this.onTagSelect = this.onTagSelect.bind(this);
        this.isEditor = __WEBPACK_IMPORTED_MODULE_2_app_core_services_context_srv__["a" /* contextSrv */].isEditor;
    }
    SearchCtrl.prototype.closeSearch = function () {
        this.isOpen = this.ignoreClose;
    };
    SearchCtrl.prototype.openSearch = function (evt, payload) {
        var _this = this;
        if (this.isOpen) {
            this.closeSearch();
            return;
        }
        this.isOpen = true;
        this.giveSearchFocus = 0;
        this.selectedIndex = -1;
        this.results = [];
        this.query = { query: '', tag: [], starred: false };
        this.currentSearchId = 0;
        this.ignoreClose = true;
        this.isLoading = true;
        if (payload && payload.starred) {
            this.query.starred = true;
        }
        this.$timeout(function () {
            _this.ignoreClose = false;
            _this.giveSearchFocus = _this.giveSearchFocus + 1;
            _this.search();
        }, 100);
    };
    SearchCtrl.prototype.keyDown = function (evt) {
        if (evt.keyCode === 27) {
            this.closeSearch();
        }
        if (evt.keyCode === 40) {
            this.moveSelection(1);
        }
        if (evt.keyCode === 38) {
            this.moveSelection(-1);
        }
        if (evt.keyCode === 13) {
            var flattenedResult = this.getFlattenedResultForNavigation();
            var currentItem = flattenedResult[this.selectedIndex];
            if (currentItem) {
                if (currentItem.dashboardIndex !== undefined) {
                    var selectedDash = this.results[currentItem.folderIndex].items[currentItem.dashboardIndex];
                    if (selectedDash) {
                        this.$location.search({});
                        this.$location.path(selectedDash.url);
                        this.closeSearch();
                    }
                }
                else {
                    var selectedFolder = this.results[currentItem.folderIndex];
                    if (selectedFolder) {
                        selectedFolder.toggle(selectedFolder);
                    }
                }
            }
        }
    };
    SearchCtrl.prototype.onFilterboxClick = function () {
        this.giveSearchFocus = 0;
        this.preventClose();
    };
    SearchCtrl.prototype.preventClose = function () {
        var _this = this;
        this.ignoreClose = true;
        this.$timeout(function () {
            _this.ignoreClose = false;
        }, 100);
    };
    SearchCtrl.prototype.moveSelection = function (direction) {
        if (this.results.length === 0) {
            return;
        }
        var flattenedResult = this.getFlattenedResultForNavigation();
        var currentItem = flattenedResult[this.selectedIndex];
        if (currentItem) {
            if (currentItem.dashboardIndex !== undefined) {
                this.results[currentItem.folderIndex].items[currentItem.dashboardIndex].selected = false;
            }
            else {
                this.results[currentItem.folderIndex].selected = false;
            }
        }
        if (direction === 0) {
            this.selectedIndex = -1;
            return;
        }
        var max = flattenedResult.length;
        var newIndex = this.selectedIndex + direction;
        this.selectedIndex = (newIndex %= max) < 0 ? newIndex + max : newIndex;
        var selectedItem = flattenedResult[this.selectedIndex];
        if (selectedItem.dashboardIndex === undefined && this.results[selectedItem.folderIndex].id === 0) {
            this.moveSelection(direction);
            return;
        }
        if (selectedItem.dashboardIndex !== undefined) {
            if (!this.results[selectedItem.folderIndex].expanded) {
                this.moveSelection(direction);
                return;
            }
            this.results[selectedItem.folderIndex].items[selectedItem.dashboardIndex].selected = true;
            return;
        }
        if (this.results[selectedItem.folderIndex].hideHeader) {
            this.moveSelection(direction);
            return;
        }
        this.results[selectedItem.folderIndex].selected = true;
    };
    SearchCtrl.prototype.searchDashboards = function () {
        var _this = this;
        this.currentSearchId = this.currentSearchId + 1;
        var localSearchId = this.currentSearchId;
        return this.searchSrv.search(this.query).then(function (results) {
            if (localSearchId < _this.currentSearchId) {
                return;
            }
            _this.results = results || [];
            _this.isLoading = false;
            _this.moveSelection(1);
        });
    };
    SearchCtrl.prototype.queryHasNoFilters = function () {
        var query = this.query;
        return query.query === '' && query.starred === false && query.tag.length === 0;
    };
    SearchCtrl.prototype.filterByTag = function (tag) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.indexOf(this.query.tag, tag) === -1) {
            this.query.tag.push(tag);
            this.search();
        }
    };
    SearchCtrl.prototype.removeTag = function (tag, evt) {
        this.query.tag = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.without(this.query.tag, tag);
        this.search();
        this.giveSearchFocus = this.giveSearchFocus + 1;
        evt.stopPropagation();
        evt.preventDefault();
    };
    SearchCtrl.prototype.getTags = function () {
        return this.searchSrv.getDashboardTags();
    };
    SearchCtrl.prototype.onTagSelect = function (newTags) {
        this.query.tag = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(newTags, function (tag) { return tag.value; });
        this.search();
    };
    SearchCtrl.prototype.clearSearchFilter = function () {
        this.query.tag = [];
        this.search();
    };
    SearchCtrl.prototype.showStarred = function () {
        this.query.starred = !this.query.starred;
        this.giveSearchFocus = this.giveSearchFocus + 1;
        this.search();
    };
    SearchCtrl.prototype.search = function () {
        this.showImport = false;
        this.selectedIndex = -1;
        this.searchDashboards();
    };
    SearchCtrl.prototype.folderExpanding = function () {
        this.moveSelection(0);
    };
    SearchCtrl.prototype.getFlattenedResultForNavigation = function () {
        var folderIndex = 0;
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatMap(this.results, function (s) {
            var result = [];
            result.push({
                folderIndex: folderIndex,
            });
            var dashboardIndex = 0;
            result = result.concat(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(s.items || [], function (i) {
                return {
                    folderIndex: folderIndex,
                    dashboardIndex: dashboardIndex++,
                };
            }));
            folderIndex++;
            return result;
        });
    };
    return SearchCtrl;
}());

function searchDirective() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/search/search.html',
        controller: SearchCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {},
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive('dashboardSearch', searchDirective);


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export infoPopover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether_drop__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tether_drop__);



function infoPopover() {
    return {
        restrict: 'E',
        template: '<i class="fa fa-info-circle"></i>',
        transclude: true,
        link: function (scope, elem, attrs, ctrl, transclude) {
            var offset = attrs.offset || '0 -10px';
            var position = attrs.position || 'right middle';
            var classes = 'drop-help drop-hide-out-of-bounds';
            var openOn = 'hover';
            elem.addClass('gf-form-help-icon');
            if (attrs.wide) {
                classes += ' drop-wide';
            }
            if (attrs.mode) {
                elem.addClass('gf-form-help-icon--' + attrs.mode);
            }
            transclude(function (clone, newScope) {
                var content = document.createElement('div');
                content.className = 'markdown-html';
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(clone, function (node) {
                    content.appendChild(node);
                });
                var dropOptions = {
                    target: elem[0],
                    content: content,
                    position: position,
                    classes: classes,
                    openOn: openOn,
                    hoverOpenDelay: 400,
                    tetherOptions: {
                        offset: offset,
                        constraints: [
                            {
                                to: 'window',
                                attachment: 'together',
                                pin: true,
                            },
                        ],
                    },
                };
                // Create drop in next digest after directive content is rendered.
                scope.$applyAsync(function () {
                    var drop = new __WEBPACK_IMPORTED_MODULE_2_tether_drop___default.a(dropOptions);
                    var unbind = scope.$on('$destroy', function () {
                        drop.destroy();
                        unbind();
                    });
                });
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].directive('infoPopover', infoPopover);


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavbarCtrl */
/* unused harmony export navbarDirective */
/* unused harmony export pageH1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__ = __webpack_require__(17);


var NavbarCtrl = /** @class */ (function () {
    /** @ngInject */
    function NavbarCtrl() {
    }
    NavbarCtrl.prototype.showSearch = function () {
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].emit('show-dash-search');
    };
    NavbarCtrl.prototype.navItemClicked = function (navItem, evt) {
        if (navItem.clickHandler) {
            navItem.clickHandler();
            evt.preventDefault();
        }
    };
    return NavbarCtrl;
}());

function navbarDirective() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/navbar/navbar.html',
        controller: NavbarCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {
            model: '=',
        },
        link: function (scope, elem) { },
    };
}
function pageH1() {
    return {
        restrict: 'E',
        template: "\n    <h1 class=\"page-header__title\">\n      <i class=\"page-header__icon {{::model.header.icon}}\" ng-if=\"::model.header.icon\"></i>\n      <img class=\"page-header__img\" ng-src=\"{{::model.header.img}}\" ng-if=\"::model.header.img\"></i>\n      {{model.header.text}}\n    </h1>\n    ",
        scope: {
            model: '=',
        },
    };
}
__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].directive('pageH1', pageH1);
__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].directive('navbar', navbarDirective);


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arrayJoin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


function arrayJoin() {
    'use strict';
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ngModel) {
            function split_array(text) {
                return (text || '').split(',');
            }
            function join_array(text) {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(text)) {
                    return (text || '').join(',');
                }
                else {
                    return text;
                }
            }
            ngModel.$parsers.push(split_array);
            ngModel.$formatters.push(join_array);
        },
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive('arrayJoin', arrayJoin);


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LiveSrv */
/* unused harmony export liveSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);



var LiveSrv = /** @class */ (function () {
    function LiveSrv() {
        this.observers = {};
    }
    LiveSrv.prototype.getWebSocketUrl = function () {
        var l = window.location;
        return (l.protocol === 'https:' ? 'wss://' : 'ws://') + l.host + __WEBPACK_IMPORTED_MODULE_1_app_core_config__["a" /* default */].appSubUrl + '/ws';
    };
    LiveSrv.prototype.getConnection = function () {
        var _this = this;
        if (this.initPromise) {
            return this.initPromise;
        }
        if (this.conn && this.conn.readyState === 1) {
            return Promise.resolve(this.conn);
        }
        this.initPromise = new Promise(function (resolve, reject) {
            console.log('Live: connecting...');
            _this.conn = new WebSocket(_this.getWebSocketUrl());
            _this.conn.onclose = function (evt) {
                console.log('Live: websocket onclose', evt);
                reject({ message: 'Connection closed' });
                _this.initPromise = null;
                setTimeout(_this.reconnect.bind(_this), 2000);
            };
            _this.conn.onmessage = function (evt) {
                _this.handleMessage(evt.data);
            };
            _this.conn.onerror = function (evt) {
                _this.initPromise = null;
                reject({ message: 'Connection error' });
                console.log('Live: websocket error', evt);
            };
            _this.conn.onopen = function (evt) {
                console.log('opened');
                _this.initPromise = null;
                resolve(_this.conn);
            };
        });
        return this.initPromise;
    };
    LiveSrv.prototype.handleMessage = function (message) {
        message = JSON.parse(message);
        if (!message.stream) {
            console.log('Error: stream message without stream!', message);
            return;
        }
        var observer = this.observers[message.stream];
        if (!observer) {
            this.removeObserver(message.stream, null);
            return;
        }
        observer.next(message);
    };
    LiveSrv.prototype.reconnect = function () {
        var _this = this;
        // no need to reconnect if no one cares
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(this.observers).length === 0) {
            return;
        }
        console.log('LiveSrv: Reconnecting');
        this.getConnection().then(function (conn) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this.observers, function (value, key) {
                _this.send({ action: 'subscribe', stream: key });
            });
        });
    };
    LiveSrv.prototype.send = function (data) {
        this.conn.send(JSON.stringify(data));
    };
    LiveSrv.prototype.addObserver = function (stream, observer) {
        var _this = this;
        this.observers[stream] = observer;
        this.getConnection().then(function (conn) {
            _this.send({ action: 'subscribe', stream: stream });
        });
    };
    LiveSrv.prototype.removeObserver = function (stream, observer) {
        var _this = this;
        console.log('unsubscribe', stream);
        delete this.observers[stream];
        this.getConnection().then(function (conn) {
            _this.send({ action: 'unsubscribe', stream: stream });
        });
    };
    LiveSrv.prototype.subscribe = function (streamName) {
        var _this = this;
        console.log('LiveSrv.subscribe: ' + streamName);
        return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].create(function (observer) {
            _this.addObserver(streamName, observer);
            return function () {
                _this.removeObserver(streamName, observer);
            };
        });
        // return this.init().then(() =>  {
        //   this.send({action: 'subscribe', stream: name});
        // });
    };
    return LiveSrv;
}());

var instance = new LiveSrv();



/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__(513);
var rxSubscriber_1 = __webpack_require__(230);
var Observer_1 = __webpack_require__(403);
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__(402);
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var noop_1 = __webpack_require__(975);
/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i - 0] = arguments[_i];
    }
    return pipeFromArray(fns);
}
exports.pipe = pipe;
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return noop_1.noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
exports.pipeFromArray = pipeFromArray;
//# sourceMappingURL=pipe.js.map

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LayoutSelectorCtrl */
/* unused harmony export layoutSelector */
/* unused harmony export layoutMode */
/* harmony import */ 
layoutMode.$inject = ["$rootScope"];var __WEBPACK_IMPORTED_MODULE_0_app_core_store__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(3);


var template = "\n<div class=\"layout-selector\">\n  <button ng-click=\"ctrl.listView()\" ng-class=\"{active: ctrl.mode === 'list'}\">\n    <i class=\"fa fa-list\"></i>\n  </button>\n  <button ng-click=\"ctrl.gridView()\" ng-class=\"{active: ctrl.mode === 'grid'}\">\n    <i class=\"fa fa-th\"></i>\n  </button>\n</div>\n";
var LayoutSelectorCtrl = /** @class */ (function () {
    /** @ngInject **/
    LayoutSelectorCtrl.$inject = ["$rootScope"];
    function LayoutSelectorCtrl($rootScope) {
        this.$rootScope = $rootScope;
        this.mode = __WEBPACK_IMPORTED_MODULE_0_app_core_store__["a" /* default */].get('grafana.list.layout.mode') || 'grid';
    }
    LayoutSelectorCtrl.prototype.listView = function () {
        this.mode = 'list';
        __WEBPACK_IMPORTED_MODULE_0_app_core_store__["a" /* default */].set('grafana.list.layout.mode', 'list');
        this.$rootScope.appEvent('layout-mode-changed', 'list');
    };
    LayoutSelectorCtrl.prototype.gridView = function () {
        this.mode = 'grid';
        __WEBPACK_IMPORTED_MODULE_0_app_core_store__["a" /* default */].set('grafana.list.layout.mode', 'grid');
        this.$rootScope.appEvent('layout-mode-changed', 'grid');
    };
    return LayoutSelectorCtrl;
}());

/** @ngInject **/
function layoutSelector() {
    return {
        restrict: 'E',
        controller: LayoutSelectorCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {},
        template: template,
    };
}
/** @ngInject **/
function layoutMode($rootScope) {
    return {
        restrict: 'A',
        scope: {},
        link: function (scope, elem) {
            var layout = __WEBPACK_IMPORTED_MODULE_0_app_core_store__["a" /* default */].get('grafana.list.layout.mode') || 'grid';
            var className = 'card-list-layout-' + layout;
            elem.addClass(className);
            $rootScope.onAppEvent('layout-mode-changed', function (evt, newLayout) {
                elem.removeClass(className);
                className = 'card-list-layout-' + newLayout;
                elem.addClass(className);
            }, scope);
        },
    };
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].directive('layoutSelector', layoutSelector);
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].directive('layoutMode', layoutMode);


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SwitchCtrl */
/* unused harmony export switchDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);

var template = "\n<label for=\"check-{{ctrl.id}}\" class=\"gf-form-label {{ctrl.labelClass}} pointer\" ng-show=\"ctrl.label\">\n  {{ctrl.label}}\n  <info-popover mode=\"right-normal\" ng-if=\"ctrl.tooltip\" position=\"top center\">\n    {{ctrl.tooltip}}\n  </info-popover>\n</label>\n<div class=\"gf-form-switch {{ctrl.switchClass}}\" ng-if=\"ctrl.show\">\n  <input id=\"check-{{ctrl.id}}\" type=\"checkbox\" ng-model=\"ctrl.checked\" ng-change=\"ctrl.internalOnChange()\">\n  <label for=\"check-{{ctrl.id}}\" data-on=\"Yes\" data-off=\"No\"></label>\n</div>\n";
var SwitchCtrl = /** @class */ (function () {
    /** @ngInject */
    SwitchCtrl.$inject = ["$scope", "$timeout"];
    function SwitchCtrl($scope, $timeout) {
        this.$timeout = $timeout;
        this.show = true;
        this.id = $scope.$id;
    }
    SwitchCtrl.prototype.internalOnChange = function () {
        var _this = this;
        return this.$timeout(function () {
            return _this.onChange();
        });
    };
    return SwitchCtrl;
}());

function switchDirective() {
    return {
        restrict: 'E',
        controller: SwitchCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        scope: {
            checked: '=',
            label: '@',
            labelClass: '@',
            tooltip: '@',
            switchClass: '@',
            onChange: '&',
        },
        template: template,
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('gfFormSwitch', switchDirective);


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DashboardSelectorCtrl */
/* unused harmony export dashboardSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);

var template = "\n<select class=\"gf-form-input\" ng-model=\"ctrl.model\" ng-options=\"f.value as f.text for f in ctrl.options\"></select>\n";
var DashboardSelectorCtrl = /** @class */ (function () {
    /** @ngInject */
    DashboardSelectorCtrl.$inject = ["backendSrv"];
    function DashboardSelectorCtrl(backendSrv) {
        this.backendSrv = backendSrv;
    }
    DashboardSelectorCtrl.prototype.$onInit = function () {
        var _this = this;
        this.options = [{ value: 0, text: 'Default' }];
        return this.backendSrv.search({ starred: true }).then(function (res) {
            res.forEach(function (dash) {
                _this.options.push({ value: dash.id, text: dash.title });
            });
        });
    };
    return DashboardSelectorCtrl;
}());

function dashboardSelector() {
    return {
        restrict: 'E',
        controller: DashboardSelectorCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        template: template,
        scope: {
            model: '=',
        },
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('dashboardSelector', dashboardSelector);


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export queryPartEditorDirective */
/* harmony import */ 
queryPartEditorDirective.$inject = ["$compile", "templateSrv"];var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(3);



var template = "\n<div class=\"dropdown cascade-open\">\n<a ng-click=\"showActionsMenu()\" class=\"query-part-name pointer dropdown-toggle\" data-toggle=\"dropdown\">{{part.def.type}}</a>\n<span>(</span><span class=\"query-part-parameters\"></span><span>)</span>\n<ul class=\"dropdown-menu\">\n  <li ng-repeat=\"action in partActions\">\n    <a ng-click=\"triggerPartAction(action)\">{{action.text}}</a>\n  </li>\n</ul>\n";
/** @ngInject */
function queryPartEditorDirective($compile, templateSrv) {
    var paramTemplate = '<input type="text" class="hide input-mini tight-form-func-param"></input>';
    return {
        restrict: 'E',
        template: template,
        scope: {
            part: '=',
            handleEvent: '&',
            debounce: '@',
        },
        link: function postLink($scope, elem) {
            var part = $scope.part;
            var partDef = part.def;
            var $paramsContainer = elem.find('.query-part-parameters');
            var debounceLookup = $scope.debounce;
            $scope.partActions = [];
            function clickFuncParam(paramIndex) {
                /*jshint validthis:true */
                var $link = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
                var $input = $link.next();
                $input.val(part.params[paramIndex]);
                $input.css('width', $link.width() + 16 + 'px');
                $link.hide();
                $input.show();
                $input.focus();
                $input.select();
                var typeahead = $input.data('typeahead');
                if (typeahead) {
                    $input.val('');
                    typeahead.lookup();
                }
            }
            function inputBlur(paramIndex) {
                /*jshint validthis:true */
                var $input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
                var $link = $input.prev();
                var newValue = $input.val();
                if (newValue !== '' || part.def.params[paramIndex].optional) {
                    $link.html(templateSrv.highlightVariablesAsHtml(newValue));
                    part.updateParam($input.val(), paramIndex);
                    $scope.$apply(function () {
                        $scope.handleEvent({ $event: { name: 'part-param-changed' } });
                    });
                }
                $input.hide();
                $link.show();
            }
            function inputKeyPress(paramIndex, e) {
                /*jshint validthis:true */
                if (e.which === 13) {
                    inputBlur.call(this, paramIndex);
                }
            }
            function inputKeyDown() {
                /*jshint validthis:true */
                this.style.width = (3 + this.value.length) * 8 + 'px';
            }
            function addTypeahead($input, param, paramIndex) {
                if (!param.options && !param.dynamicLookup) {
                    return;
                }
                var typeaheadSource = function (query, callback) {
                    if (param.options) {
                        var options = param.options;
                        if (param.type === 'int') {
                            options = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(options, function (val) {
                                return val.toString();
                            });
                        }
                        return options;
                    }
                    $scope.$apply(function () {
                        $scope.handleEvent({ $event: { name: 'get-param-options' } }).then(function (result) {
                            var dynamicOptions = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(result, function (op) {
                                return op.value;
                            });
                            callback(dynamicOptions);
                        });
                    });
                };
                $input.attr('data-provide', 'typeahead');
                $input.typeahead({
                    source: typeaheadSource,
                    minLength: 0,
                    items: 1000,
                    updater: function (value) {
                        setTimeout(function () {
                            inputBlur.call($input[0], paramIndex);
                        }, 0);
                        return value;
                    },
                });
                var typeahead = $input.data('typeahead');
                typeahead.lookup = function () {
                    this.query = this.$element.val() || '';
                    var items = this.source(this.query, __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.proxy(this.process, this));
                    return items ? this.process(items) : items;
                };
                if (debounceLookup) {
                    typeahead.lookup = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(typeahead.lookup, 500, { leading: true });
                }
            }
            $scope.showActionsMenu = function () {
                $scope.handleEvent({ $event: { name: 'get-part-actions' } }).then(function (res) {
                    $scope.partActions = res;
                });
            };
            $scope.triggerPartAction = function (action) {
                $scope.handleEvent({ $event: { name: 'action', action: action } });
            };
            function addElementsAndCompile() {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(partDef.params, function (param, index) {
                    if (param.optional && part.params.length <= index) {
                        return;
                    }
                    if (index > 0) {
                        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<span>, </span>').appendTo($paramsContainer);
                    }
                    var paramValue = templateSrv.highlightVariablesAsHtml(part.params[index]);
                    var $paramLink = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<a class="graphite-func-param-link pointer">' + paramValue + '</a>');
                    var $input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(paramTemplate);
                    $paramLink.appendTo($paramsContainer);
                    $input.appendTo($paramsContainer);
                    $input.blur(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.partial(inputBlur, index));
                    $input.keyup(inputKeyDown);
                    $input.keypress(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.partial(inputKeyPress, index));
                    $paramLink.click(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.partial(clickFuncParam, index));
                    addTypeahead($input, param, index);
                });
            }
            function relink() {
                $paramsContainer.empty();
                addElementsAndCompile();
            }
            relink();
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["a" /* default */].directive('queryPartEditor', queryPartEditorDirective);


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormDropdownCtrl */
/* unused harmony export formDropdownDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


function typeaheadMatcher(item) {
    var str = this.query;
    if (str === '') {
        return true;
    }
    if (str[0] === '/') {
        str = str.substring(1);
    }
    if (str[str.length - 1] === '/') {
        str = str.substring(0, str.length - 1);
    }
    return item.toLowerCase().match(str.toLowerCase());
}
var FormDropdownCtrl = /** @class */ (function () {
    /** @ngInject **/
    FormDropdownCtrl.$inject = ["$scope", "$element", "$sce", "templateSrv", "$q"];
    function FormDropdownCtrl($scope, $element, $sce, templateSrv, $q) {
        var _this = this;
        this.$scope = $scope;
        this.$sce = $sce;
        this.templateSrv = templateSrv;
        this.$q = $q;
        this.inputElement = $element.find('input').first();
        this.linkElement = $element.find('a').first();
        this.linkMode = true;
        this.cancelBlur = null;
        // listen to model changes
        $scope.$watch('ctrl.model', this.modelChanged.bind(this));
        if (this.labelMode) {
            this.cssClasses = 'gf-form-label ' + this.cssClass;
        }
        else {
            this.cssClasses = 'gf-form-input gf-form-input--dropdown ' + this.cssClass;
        }
        if (this.placeholder) {
            this.inputElement.attr('placeholder', this.placeholder);
        }
        this.inputElement.attr('data-provide', 'typeahead');
        this.inputElement.typeahead({
            source: this.typeaheadSource.bind(this),
            minLength: 0,
            items: 10000,
            updater: this.typeaheadUpdater.bind(this),
            matcher: typeaheadMatcher,
        });
        // modify typeahead lookup
        // this = typeahead
        var typeahead = this.inputElement.data('typeahead');
        typeahead.lookup = function () {
            this.query = this.$element.val() || '';
            this.source(this.query, this.process.bind(this));
        };
        if (this.debounce) {
            typeahead.lookup = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(typeahead.lookup, 500, { leading: true });
        }
        this.linkElement.keydown(function (evt) {
            // trigger typeahead on down arrow or enter key
            if (evt.keyCode === 40 || evt.keyCode === 13) {
                _this.linkElement.click();
            }
        });
        this.inputElement.keydown(function (evt) {
            if (evt.keyCode === 13) {
                setTimeout(function () {
                    _this.inputElement.blur();
                }, 100);
            }
        });
        this.inputElement.blur(this.inputBlur.bind(this));
        if (this.startOpen) {
            setTimeout(this.open.bind(this), 0);
        }
    }
    FormDropdownCtrl.prototype.getOptionsInternal = function (query) {
        var result = this.getOptions({ $query: query });
        if (this.isPromiseLike(result)) {
            return result;
        }
        return this.$q.when(result);
    };
    FormDropdownCtrl.prototype.isPromiseLike = function (obj) {
        return obj && typeof obj.then === 'function';
    };
    FormDropdownCtrl.prototype.modelChanged = function () {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(this.model)) {
            this.updateDisplay(this.model.text);
        }
        else {
            // if we have text use it
            if (this.lookupText) {
                this.getOptionsInternal('').then(function (options) {
                    var item = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(options, { value: _this.model });
                    _this.updateDisplay(item ? item.text : _this.model);
                });
            }
            else {
                this.updateDisplay(this.model);
            }
        }
    };
    FormDropdownCtrl.prototype.typeaheadSource = function (query, callback) {
        var _this = this;
        this.getOptionsInternal(query).then(function (options) {
            _this.optionCache = options;
            // extract texts
            var optionTexts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(options, function (op) {
                return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.escape(op.text);
            });
            // add custom values
            if (_this.allowCustom && _this.text !== '') {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.indexOf(optionTexts, _this.text) === -1) {
                    optionTexts.unshift(_this.text);
                }
            }
            callback(optionTexts);
        });
    };
    FormDropdownCtrl.prototype.typeaheadUpdater = function (text) {
        if (text === this.text) {
            clearTimeout(this.cancelBlur);
            this.inputElement.focus();
            return text;
        }
        this.inputElement.val(text);
        this.switchToLink(true);
        return text;
    };
    FormDropdownCtrl.prototype.switchToLink = function (fromClick) {
        if (this.linkMode && !fromClick) {
            return;
        }
        clearTimeout(this.cancelBlur);
        this.cancelBlur = null;
        this.linkMode = true;
        this.inputElement.hide();
        this.linkElement.show();
        this.updateValue(this.inputElement.val());
    };
    FormDropdownCtrl.prototype.inputBlur = function () {
        // happens long before the click event on the typeahead options
        // need to have long delay because the blur
        this.cancelBlur = setTimeout(this.switchToLink.bind(this), 200);
    };
    FormDropdownCtrl.prototype.updateValue = function (text) {
        var _this = this;
        text = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.unescape(text);
        if (text === '' || this.text === text) {
            return;
        }
        this.$scope.$apply(function () {
            var option = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(_this.optionCache, { text: text });
            if (option) {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(_this.model)) {
                    _this.model = option;
                }
                else {
                    _this.model = option.value;
                }
                _this.text = option.text;
            }
            else if (_this.allowCustom) {
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(_this.model)) {
                    _this.model.text = _this.model.value = text;
                }
                else {
                    _this.model = text;
                }
                _this.text = text;
            }
            // needs to call this after digest so
            // property is synced with outerscope
            _this.$scope.$$postDigest(function () {
                _this.$scope.$apply(function () {
                    _this.onChange({ $option: option });
                });
            });
        });
    };
    FormDropdownCtrl.prototype.updateDisplay = function (text) {
        this.text = text;
        this.display = this.$sce.trustAsHtml(this.templateSrv.highlightVariablesAsHtml(text));
    };
    FormDropdownCtrl.prototype.open = function () {
        this.inputElement.css('width', Math.max(this.linkElement.width(), 80) + 16 + 'px');
        this.inputElement.show();
        this.inputElement.focus();
        this.linkElement.hide();
        this.linkMode = false;
        var typeahead = this.inputElement.data('typeahead');
        if (typeahead) {
            this.inputElement.val('');
            typeahead.lookup();
        }
    };
    return FormDropdownCtrl;
}());

var template = "\n<input type=\"text\"\n  data-provide=\"typeahead\"\n  class=\"gf-form-input\"\n  spellcheck=\"false\"\n  style=\"display:none\">\n</input>\n<a ng-class=\"ctrl.cssClasses\"\n   tabindex=\"1\"\n   ng-click=\"ctrl.open()\"\n   give-focus=\"ctrl.focus\"\n   ng-bind-html=\"ctrl.display || '&nbsp;'\">\n</a>\n";
function formDropdownDirective() {
    return {
        restrict: 'E',
        template: template,
        controller: FormDropdownCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {
            model: '=',
            getOptions: '&',
            onChange: '&',
            cssClass: '@',
            allowCustom: '@',
            labelMode: '@',
            lookupText: '@',
            placeholder: '@',
            startOpen: '@',
            debounce: '@',
        },
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive('gfFormDropdown', formDropdownDirective);


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspect_ctrl__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_editor_ctrl__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_ctrl__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__invited_ctrl__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__signup_ctrl__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reset_password_ctrl__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_ctrl__ = __webpack_require__(988);









/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InspectCtrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_module__ = __webpack_require__(3);




var InspectCtrl = /** @class */ (function () {
    /** @ngInject */
    InspectCtrl.$inject = ["$scope", "$sanitize"];
    function InspectCtrl($scope, $sanitize) {
        var model = $scope.inspector;
        $scope.init = function () {
            $scope.editor = { index: 0 };
            if (!model.error) {
                return;
            }
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isString(model.error.data)) {
                $scope.response = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<div>' + model.error.data + '</div>').text();
            }
            else if (model.error.data) {
                if (model.error.data.response) {
                    $scope.response = $sanitize(model.error.data.response);
                }
                else {
                    $scope.response = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.toJson(model.error.data, true);
                }
            }
            else if (model.error.message) {
                $scope.message = model.error.message;
            }
            if (model.error.config && model.error.config.params) {
                $scope.request_parameters = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(model.error.config.params, function (value, key) {
                    return { key: key, value: value };
                });
            }
            if (model.error.stack) {
                $scope.editor.index = 3;
                $scope.stack_trace = model.error.stack;
                $scope.message = model.error.message;
            }
            if (model.error.config && model.error.config.data) {
                $scope.editor.index = 2;
                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isString(model.error.config.data)) {
                    $scope.request_parameters = this.getParametersFromQueryString(model.error.config.data);
                }
                else {
                    $scope.request_parameters = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(model.error.config.data, function (value, key) {
                        return { key: key, value: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.toJson(value, true) };
                    });
                }
            }
        };
    }
    InspectCtrl.prototype.getParametersFromQueryString = function (queryString) {
        var result = [];
        var parameters = queryString.split('&');
        for (var i = 0; i < parameters.length; i++) {
            var keyValue = parameters[i].split('=');
            if (keyValue[1].length > 0) {
                result.push({
                    key: keyValue[0],
                    value: window.unescape(keyValue[1]),
                });
            }
        }
        return result;
    };
    return InspectCtrl;
}());

__WEBPACK_IMPORTED_MODULE_3__core_module__["a" /* default */].controller('InspectCtrl', InspectCtrl);


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export JsonEditorCtrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


var JsonEditorCtrl = /** @class */ (function () {
    /** @ngInject */
    JsonEditorCtrl.$inject = ["$scope"];
    function JsonEditorCtrl($scope) {
        $scope.json = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.toJson($scope.object, true);
        $scope.canUpdate = $scope.updateHandler !== void 0 && $scope.contextSrv.isEditor;
        $scope.canCopy = $scope.enableCopy;
        $scope.update = function () {
            var newObject = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.fromJson($scope.json);
            $scope.updateHandler(newObject, $scope.object);
        };
        $scope.getContentForClipboard = function () { return $scope.json; };
    }
    return JsonEditorCtrl;
}());

__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].controller('JsonEditorCtrl', JsonEditorCtrl);


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoginCtrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_config__ = __webpack_require__(22);



var LoginCtrl = /** @class */ (function () {
    /** @ngInject */
    LoginCtrl.$inject = ["$scope", "backendSrv", "contextSrv", "$location"];
    function LoginCtrl($scope, backendSrv, contextSrv, $location) {
        $scope.formModel = {
            user: '',
            email: '',
            password: '',
        };
        contextSrv.sidemenu = false;
        $scope.oauth = __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].oauth;
        $scope.oauthEnabled = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].oauth).length > 0;
        $scope.disableLoginForm = __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].disableLoginForm;
        $scope.disableUserSignUp = __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].disableUserSignUp;
        $scope.loginHint = __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].loginHint;
        $scope.loginMode = true;
        $scope.submitBtnText = 'Log in';
        $scope.init = function () {
            $scope.$watch('loginMode', $scope.loginModeChanged);
            if (__WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].loginError) {
                $scope.appEvent('alert-warning', ['Login Failed', __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].loginError]);
            }
        };
        $scope.submit = function () {
            if ($scope.loginMode) {
                $scope.login();
            }
            else {
                $scope.signUp();
            }
        };
        $scope.loginModeChanged = function (newValue) {
            $scope.submitBtnText = newValue ? 'Log in' : 'Sign up';
        };
        $scope.signUp = function () {
            if (!$scope.loginForm.$valid) {
                return;
            }
            backendSrv.post('/api/user/signup', $scope.formModel).then(function (result) {
                if (result.status === 'SignUpCreated') {
                    $location.path('/signup').search({ email: $scope.formModel.email });
                }
                else {
                    window.location.href = __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].appSubUrl + '/';
                }
            });
        };
        $scope.login = function () {
            delete $scope.loginError;
            if (!$scope.loginForm.$valid) {
                return;
            }
            backendSrv.post('/login', $scope.formModel).then(function (result) {
                var params = $location.search();
                if (params.redirect && params.redirect[0] === '/') {
                    window.location.href = __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].appSubUrl + params.redirect;
                }
                else if (result.redirectUrl) {
                    window.location.href = result.redirectUrl;
                }
                else {
                    window.location.href = __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].appSubUrl + '/';
                }
            });
        };
        $scope.init();
    }
    return LoginCtrl;
}());

__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].controller('LoginCtrl', LoginCtrl);


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InvitedCtrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config__ = __webpack_require__(22);


var InvitedCtrl = /** @class */ (function () {
    /** @ngInject */
    InvitedCtrl.$inject = ["$scope", "$routeParams", "contextSrv", "backendSrv"];
    function InvitedCtrl($scope, $routeParams, contextSrv, backendSrv) {
        contextSrv.sidemenu = false;
        $scope.formModel = {};
        $scope.navModel = {
            main: {
                icon: 'gicon gicon-branding',
                text: 'Invite',
                subTitle: 'Register your Grafana account',
                breadcrumbs: [{ title: 'Login', url: 'login' }],
            },
        };
        $scope.init = function () {
            backendSrv.get('/api/user/invite/' + $routeParams.code).then(function (invite) {
                $scope.formModel.name = invite.name;
                $scope.formModel.email = invite.email;
                $scope.formModel.username = invite.email;
                $scope.formModel.inviteCode = $routeParams.code;
                $scope.greeting = invite.name || invite.email || invite.username;
                $scope.invitedBy = invite.invitedBy;
            });
        };
        $scope.submit = function () {
            if (!$scope.inviteForm.$valid) {
                return;
            }
            backendSrv.post('/api/user/invite/complete', $scope.formModel).then(function () {
                window.location.href = __WEBPACK_IMPORTED_MODULE_1_app_core_config__["a" /* default */].appSubUrl + '/';
            });
        };
        $scope.init();
    }
    return InvitedCtrl;
}());

__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].controller('InvitedCtrl', InvitedCtrl);


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SignUpCtrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


var SignUpCtrl = /** @class */ (function () {
    /** @ngInject */
    SignUpCtrl.$inject = ["$scope", "backendSrv", "$location", "contextSrv"];
    function SignUpCtrl($scope, backendSrv, $location, contextSrv) {
        this.$scope = $scope;
        this.backendSrv = backendSrv;
        contextSrv.sidemenu = false;
        $scope.ctrl = this;
        $scope.formModel = {};
        var params = $location.search();
        // validate email is semi ok
        if (params.email && !params.email.match(/^\S+@\S+$/)) {
            console.log('invalid email');
            return;
        }
        $scope.formModel.orgName = params.email;
        $scope.formModel.email = params.email;
        $scope.formModel.username = params.email;
        $scope.formModel.code = params.code;
        $scope.verifyEmailEnabled = false;
        $scope.autoAssignOrg = false;
        $scope.navModel = {
            main: {
                icon: 'gicon gicon-branding',
                text: 'Sign Up',
                subTitle: 'Register your Grafana account',
                breadcrumbs: [{ title: 'Login', url: 'login' }],
            },
        };
        backendSrv.get('/api/user/signup/options').then(function (options) {
            $scope.verifyEmailEnabled = options.verifyEmailEnabled;
            $scope.autoAssignOrg = options.autoAssignOrg;
        });
    }
    SignUpCtrl.prototype.submit = function () {
        if (!this.$scope.signUpForm.$valid) {
            return;
        }
        this.backendSrv.post('/api/user/signup/step2', this.$scope.formModel).then(function (rsp) {
            if (rsp.code === 'redirect-to-select-org') {
                window.location.href = __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].appSubUrl + '/profile/select-org?signup=1';
            }
            else {
                window.location.href = __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].appSubUrl + '/';
            }
        });
    };
    return SignUpCtrl;
}());

__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].controller('SignUpCtrl', SignUpCtrl);


/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ResetPasswordCtrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(3);

var ResetPasswordCtrl = /** @class */ (function () {
    /** @ngInject */
    ResetPasswordCtrl.$inject = ["$scope", "contextSrv", "backendSrv", "$location"];
    function ResetPasswordCtrl($scope, contextSrv, backendSrv, $location) {
        contextSrv.sidemenu = false;
        $scope.formModel = {};
        $scope.mode = 'send';
        var params = $location.search();
        if (params.code) {
            $scope.mode = 'reset';
            $scope.formModel.code = params.code;
        }
        $scope.navModel = {
            main: {
                icon: 'gicon gicon-branding',
                text: 'Reset Password',
                subTitle: 'Reset your Grafana password',
                breadcrumbs: [{ title: 'Login', url: 'login' }],
            },
        };
        $scope.sendResetEmail = function () {
            if (!$scope.sendResetForm.$valid) {
                return;
            }
            backendSrv.post('/api/user/password/send-reset-email', $scope.formModel).then(function () {
                $scope.mode = 'email-sent';
            });
        };
        $scope.submitReset = function () {
            if (!$scope.resetForm.$valid) {
                return;
            }
            if ($scope.formModel.newPassword !== $scope.formModel.confirmPassword) {
                $scope.appEvent('alert-warning', ['New passwords do not match', '']);
                return;
            }
            backendSrv.post('/api/user/password/reset', $scope.formModel).then(function () {
                $location.path('login');
            });
        };
    }
    return ResetPasswordCtrl;
}());

__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].controller('ResetPasswordCtrl', ResetPasswordCtrl);


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorCtrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__ = __webpack_require__(17);



var ErrorCtrl = /** @class */ (function () {
    /** @ngInject */
    ErrorCtrl.$inject = ["$scope", "contextSrv", "navModelSrv"];
    function ErrorCtrl($scope, contextSrv, navModelSrv) {
        $scope.navModel = navModelSrv.getNotFoundNav();
        $scope.appSubUrl = __WEBPACK_IMPORTED_MODULE_0_app_core_config__["a" /* default */].appSubUrl;
        if (!contextSrv.isSignedIn) {
            __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('toggle-sidemenu-hidden');
        }
        $scope.$on('destroy', function () {
            if (!contextSrv.isSignedIn) {
                __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('toggle-sidemenu-hidden');
            }
        });
    }
    return ErrorCtrl;
}());

__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].controller('ErrorCtrl', ErrorCtrl);


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert_srv__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_srv__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_srv__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timer__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__popover_srv__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__segment_srv__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__backend_srv__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dynamic_directive_srv__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bridge_srv__ = __webpack_require__(1000);












/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AlertSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__ = __webpack_require__(17);




var AlertSrv = /** @class */ (function () {
    /** @ngInject */
    AlertSrv.$inject = ["$timeout", "$rootScope"];
    function AlertSrv($timeout, $rootScope) {
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.list = [];
    }
    AlertSrv.prototype.init = function () {
        var _this = this;
        this.$rootScope.onAppEvent('alert-error', function (e, alert) {
            _this.set(alert[0], alert[1], 'error', 12000);
        }, this.$rootScope);
        this.$rootScope.onAppEvent('alert-warning', function (e, alert) {
            _this.set(alert[0], alert[1], 'warning', 5000);
        }, this.$rootScope);
        this.$rootScope.onAppEvent('alert-success', function (e, alert) {
            _this.set(alert[0], alert[1], 'success', 3000);
        }, this.$rootScope);
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('alert-warning', function (options) { return _this.set(options[0], options[1], 'warning', 5000); });
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('alert-success', function (options) { return _this.set(options[0], options[1], 'success', 3000); });
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('alert-error', function (options) { return _this.set(options[0], options[1], 'error', 7000); });
    };
    AlertSrv.prototype.getIconForSeverity = function (severity) {
        switch (severity) {
            case 'success':
                return 'fa fa-check';
            case 'error':
                return 'fa fa-exclamation-triangle';
            default:
                return 'fa fa-exclamation';
        }
    };
    AlertSrv.prototype.set = function (title, text, severity, timeout) {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(text)) {
            console.log('alert error', text);
            if (text.statusText) {
                text = "HTTP Error (" + text.status + ") " + text.statusText;
            }
        }
        var newAlert = {
            title: title || '',
            text: text || '',
            severity: severity || 'info',
            icon: this.getIconForSeverity(severity),
        };
        var newAlertJson = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.toJson(newAlert);
        // remove same alert if it already exists
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(this.list, function (value) {
            return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.toJson(value) === newAlertJson;
        });
        this.list.push(newAlert);
        if (timeout > 0) {
            this.$timeout(function () {
                _this.list = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.without(_this.list, newAlert);
            }, timeout);
        }
        if (!this.$rootScope.$$phase) {
            this.$rootScope.$digest();
        }
        return newAlert;
    };
    AlertSrv.prototype.clear = function (alert) {
        this.list = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.without(this.list, alert);
    };
    AlertSrv.prototype.clearAll = function () {
        this.list = [];
    };
    return AlertSrv;
}());

__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["a" /* default */].service('alertSrv', AlertSrv);


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UtilSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__ = __webpack_require__(17);


var UtilSrv = /** @class */ (function () {
    /** @ngInject */
    UtilSrv.$inject = ["$rootScope", "$modal"];
    function UtilSrv($rootScope, $modal) {
        this.$rootScope = $rootScope;
        this.$modal = $modal;
    }
    UtilSrv.prototype.init = function () {
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].on('show-modal', this.showModal.bind(this), this.$rootScope);
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].on('hide-modal', this.hideModal.bind(this), this.$rootScope);
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].on('confirm-modal', this.showConfirmModal.bind(this), this.$rootScope);
    };
    UtilSrv.prototype.hideModal = function () {
        if (this.modalScope && this.modalScope.dismiss) {
            this.modalScope.dismiss();
        }
    };
    UtilSrv.prototype.showModal = function (options) {
        if (this.modalScope && this.modalScope.dismiss) {
            this.modalScope.dismiss();
        }
        this.modalScope = options.scope;
        if (options.model) {
            this.modalScope = this.$rootScope.$new();
            this.modalScope.model = options.model;
        }
        else if (!this.modalScope) {
            this.modalScope = this.$rootScope.$new();
        }
        var modal = this.$modal({
            modalClass: options.modalClass,
            template: options.src,
            templateHtml: options.templateHtml,
            persist: false,
            show: false,
            scope: this.modalScope,
            keyboard: false,
            backdrop: options.backdrop,
        });
        Promise.resolve(modal).then(function (modalEl) {
            modalEl.modal('show');
        });
    };
    UtilSrv.prototype.showConfirmModal = function (payload) {
        var scope = this.$rootScope.$new();
        scope.onConfirm = function () {
            payload.onConfirm();
            scope.dismiss();
        };
        scope.updateConfirmText = function (value) {
            scope.confirmTextValid = payload.confirmText.toLowerCase() === value.toLowerCase();
        };
        scope.title = payload.title;
        scope.text = payload.text;
        scope.text2 = payload.text2;
        scope.confirmText = payload.confirmText;
        scope.onConfirm = payload.onConfirm;
        scope.onAltAction = payload.onAltAction;
        scope.altActionText = payload.altActionText;
        scope.icon = payload.icon || 'fa-check';
        scope.yesText = payload.yesText || 'Yes';
        scope.noText = payload.noText || 'Cancel';
        scope.confirmTextValid = scope.confirmText ? false : true;
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].emit('show-modal', {
            src: 'public/app/partials/confirm_modal.html',
            scope: scope,
            modalClass: 'confirm-modal',
        });
    };
    return UtilSrv;
}());

__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].service('utilSrv', UtilSrv);


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Timer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(3);


// This service really just tracks a list of $timeout promises to give us a
// method for cancelling them all when we need to
var Timer = /** @class */ (function () {
    /** @ngInject */
    Timer.$inject = ["$timeout"];
    function Timer($timeout) {
        this.$timeout = $timeout;
        this.timers = [];
    }
    Timer.prototype.register = function (promise) {
        this.timers.push(promise);
        return promise;
    };
    Timer.prototype.cancel = function (promise) {
        this.timers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.without(this.timers, promise);
        this.$timeout.cancel(promise);
    };
    Timer.prototype.cancelAll = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.timers, function (t) {
            _this.$timeout.cancel(t);
        });
        this.timers = [];
    };
    return Timer;
}());

__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].service('timer', Timer);


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Analytics */
/* harmony import */ 
startAnalytics.$inject = ["googleAnalyticsSrv"];var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_config__ = __webpack_require__(22);



var Analytics = /** @class */ (function () {
    /** @ngInject */
    Analytics.$inject = ["$rootScope", "$location"];
    function Analytics($rootScope, $location) {
        this.$rootScope = $rootScope;
        this.$location = $location;
    }
    Analytics.prototype.gaInit = function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: 'https://www.google-analytics.com/analytics.js',
            dataType: 'script',
            cache: true,
        });
        var ga = (window.ga =
            window.ga ||
                function () {
                    (ga.q = ga.q || []).push(arguments);
                });
        ga.l = +new Date();
        ga('create', __WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].googleAnalyticsId, 'auto');
        ga('set', 'anonymizeIp', true);
        return ga;
    };
    Analytics.prototype.init = function () {
        var _this = this;
        this.$rootScope.$on('$viewContentLoaded', function () {
            var track = { page: _this.$location.url() };
            var ga = window.ga || _this.gaInit();
            ga('set', track);
            ga('send', 'pageview');
        });
    };
    return Analytics;
}());

/** @ngInject */
function startAnalytics(googleAnalyticsSrv) {
    if (__WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].googleAnalyticsId) {
        googleAnalyticsSrv.init();
    }
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].service('googleAnalyticsSrv', Analytics).run(startAnalytics);


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ 
popoverSrv.$inject = ["$compile", "$rootScope", "$timeout"];var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether_drop__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tether_drop__);



/** @ngInject **/
function popoverSrv($compile, $rootScope, $timeout) {
    var openDrop = null;
    this.close = function () {
        if (openDrop) {
            openDrop.close();
        }
    };
    this.show = function (options) {
        if (openDrop) {
            openDrop.close();
            openDrop = null;
        }
        var scope = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.extend($rootScope.$new(true), options.model);
        var drop;
        var cleanUp = function () {
            setTimeout(function () {
                scope.$destroy();
                if (drop.tether) {
                    drop.destroy();
                }
                if (options.onClose) {
                    options.onClose();
                }
            });
            openDrop = null;
        };
        scope.dismiss = function () {
            drop.close();
        };
        var contentElement = document.createElement('div');
        contentElement.innerHTML = options.template;
        $compile(contentElement)(scope);
        $timeout(function () {
            drop = new __WEBPACK_IMPORTED_MODULE_2_tether_drop___default.a({
                target: options.element,
                content: contentElement,
                position: options.position,
                classes: options.classNames || 'drop-popover',
                openOn: options.openOn,
                hoverCloseDelay: 200,
                tetherOptions: {
                    constraints: [{ to: 'scrollParent', attachment: 'together' }],
                },
            });
            drop.on('close', function () {
                cleanUp();
            });
            openDrop = drop;
            openDrop.open();
        }, 100);
        // return close function
        return function () {
            if (drop) {
                drop.close();
            }
        };
    };
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].service('popoverSrv', popoverSrv);


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export uiSegmentSrv */
/* harmony import */ 
uiSegmentSrv.$inject = ["$sce", "templateSrv"];var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


/** @ngInject */
function uiSegmentSrv($sce, templateSrv) {
    var self = this;
    function MetricSegment(options) {
        if (options === '*' || options.value === '*') {
            this.value = '*';
            this.html = $sce.trustAsHtml('<i class="fa fa-asterisk"><i>');
            this.type = options.type;
            this.expandable = true;
            return;
        }
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(options)) {
            this.value = options;
            this.html = $sce.trustAsHtml(templateSrv.highlightVariablesAsHtml(this.value));
            return;
        }
        // temp hack to work around legacy inconsistency in segment model
        this.text = options.value;
        this.cssClass = options.cssClass;
        this.custom = options.custom;
        this.type = options.type;
        this.fake = options.fake;
        this.value = options.value;
        this.selectMode = options.selectMode;
        this.type = options.type;
        this.expandable = options.expandable;
        this.html = options.html || $sce.trustAsHtml(templateSrv.highlightVariablesAsHtml(this.value));
    }
    this.getSegmentForValue = function (value, fallbackText) {
        if (value) {
            return this.newSegment(value);
        }
        else {
            return this.newSegment({ value: fallbackText, fake: true });
        }
    };
    this.newSelectMeasurement = function () {
        return new MetricSegment({ value: 'select measurement', fake: true });
    };
    this.newFake = function (text, type, cssClass) {
        return new MetricSegment({ value: text, fake: true, type: type, cssClass: cssClass });
    };
    this.newSegment = function (options) {
        return new MetricSegment(options);
    };
    this.newKey = function (key) {
        return new MetricSegment({ value: key, type: 'key', cssClass: 'query-segment-key' });
    };
    this.newKeyValue = function (value) {
        return new MetricSegment({ value: value, type: 'value', cssClass: 'query-segment-value' });
    };
    this.newCondition = function (condition) {
        return new MetricSegment({ value: condition, type: 'condition', cssClass: 'query-keyword' });
    };
    this.newOperator = function (op) {
        return new MetricSegment({ value: op, type: 'operator', cssClass: 'query-segment-operator' });
    };
    this.newOperators = function (ops) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(ops, function (op) {
            return new MetricSegment({ value: op, type: 'operator', cssClass: 'query-segment-operator' });
        });
    };
    this.transformToSegments = function (addTemplateVars, variableTypeFilter) {
        return function (results) {
            var segments = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(results, function (segment) {
                return self.newSegment({ value: segment.text, expandable: segment.expandable });
            });
            if (addTemplateVars) {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(templateSrv.variables, function (variable) {
                    if (variableTypeFilter === void 0 || variableTypeFilter === variable.type) {
                        segments.unshift(self.newSegment({ type: 'value', value: '$' + variable.name, expandable: true }));
                    }
                });
            }
            return segments;
        };
    };
    this.newSelectMetric = function () {
        return new MetricSegment({ value: 'select metric', fake: true });
    };
    this.newPlusButton = function () {
        return new MetricSegment({
            fake: true,
            html: '<i class="fa fa-plus "></i>',
            type: 'plus-button',
            cssClass: 'query-part',
        });
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].service('uiSegmentSrv', uiSegmentSrv);


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BackendSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_features_dashboard_dashboard_model__ = __webpack_require__(524);




var BackendSrv = /** @class */ (function () {
    /** @ngInject */
    BackendSrv.$inject = ["$http", "alertSrv", "$q", "$timeout", "contextSrv"];
    function BackendSrv($http, alertSrv, $q, $timeout, contextSrv) {
        this.$http = $http;
        this.alertSrv = alertSrv;
        this.$q = $q;
        this.$timeout = $timeout;
        this.contextSrv = contextSrv;
        this.inFlightRequests = {};
        this.HTTP_REQUEST_CANCELLED = -1;
    }
    BackendSrv.prototype.get = function (url, params) {
        return this.request({ method: 'GET', url: url, params: params });
    };
    BackendSrv.prototype.delete = function (url) {
        return this.request({ method: 'DELETE', url: url });
    };
    BackendSrv.prototype.post = function (url, data) {
        return this.request({ method: 'POST', url: url, data: data });
    };
    BackendSrv.prototype.patch = function (url, data) {
        return this.request({ method: 'PATCH', url: url, data: data });
    };
    BackendSrv.prototype.put = function (url, data) {
        return this.request({ method: 'PUT', url: url, data: data });
    };
    BackendSrv.prototype.withNoBackendCache = function (callback) {
        var _this = this;
        this.noBackendCache = true;
        return callback().finally(function () {
            _this.noBackendCache = false;
        });
    };
    BackendSrv.prototype.requestErrorHandler = function (err) {
        if (err.isHandled) {
            return;
        }
        var data = err.data || { message: 'Unexpected error' };
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(data)) {
            data = { message: data };
        }
        if (err.status === 422) {
            this.alertSrv.set('Validation failed', data.message, 'warning', 4000);
            throw data;
        }
        data.severity = 'error';
        if (err.status < 500) {
            data.severity = 'warning';
        }
        if (data.message) {
            var description = '';
            var message = data.message;
            if (message.length > 80) {
                description = message;
                message = 'Error';
            }
            this.alertSrv.set(message, description, data.severity, 10000);
        }
        throw data;
    };
    BackendSrv.prototype.request = function (options) {
        var _this = this;
        options.retry = options.retry || 0;
        var requestIsLocal = !options.url.match(/^http/);
        var firstAttempt = options.retry === 0;
        if (requestIsLocal) {
            if (this.contextSrv.user && this.contextSrv.user.orgId) {
                options.headers = options.headers || {};
                options.headers['X-Grafana-Org-Id'] = this.contextSrv.user.orgId;
            }
            if (options.url.indexOf('/') === 0) {
                options.url = options.url.substring(1);
            }
        }
        return this.$http(options).then(function (results) {
            if (options.method !== 'GET') {
                if (results && results.data.message) {
                    if (options.showSuccessAlert !== false) {
                        _this.alertSrv.set(results.data.message, '', 'success', 3000);
                    }
                }
            }
            return results.data;
        }, function (err) {
            // handle unauthorized
            var isRemembered = document.cookie.indexOf('grafana_remember') !== -1;
            if (err.status === 401 && _this.contextSrv.user.isSignedIn && firstAttempt && isRemembered) {
                return _this.loginPing().then(function () {
                    options.retry = 1;
                    return _this.request(options);
                });
            }
            _this.$timeout(_this.requestErrorHandler.bind(_this, err), 50);
            throw err;
        });
    };
    BackendSrv.prototype.addCanceler = function (requestId, canceler) {
        if (requestId in this.inFlightRequests) {
            this.inFlightRequests[requestId].push(canceler);
        }
        else {
            this.inFlightRequests[requestId] = [canceler];
        }
    };
    BackendSrv.prototype.resolveCancelerIfExists = function (requestId) {
        var cancelers = this.inFlightRequests[requestId];
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isUndefined(cancelers) && cancelers.length) {
            cancelers[0].resolve();
        }
    };
    BackendSrv.prototype.datasourceRequest = function (options) {
        var _this = this;
        options.retry = options.retry || 0;
        // A requestID is provided by the datasource as a unique identifier for a
        // particular query. If the requestID exists, the promise it is keyed to
        // is canceled, canceling the previous datasource request if it is still
        // in-flight.
        var requestId = options.requestId;
        if (requestId) {
            this.resolveCancelerIfExists(requestId);
            // create new canceler
            var canceler = this.$q.defer();
            options.timeout = canceler.promise;
            this.addCanceler(requestId, canceler);
        }
        var requestIsLocal = !options.url.match(/^http/);
        var firstAttempt = options.retry === 0;
        if (requestIsLocal) {
            if (this.contextSrv.user && this.contextSrv.user.orgId) {
                options.headers = options.headers || {};
                options.headers['X-Grafana-Org-Id'] = this.contextSrv.user.orgId;
            }
            if (options.url.indexOf('/') === 0) {
                options.url = options.url.substring(1);
            }
            if (options.headers && options.headers.Authorization) {
                options.headers['X-DS-Authorization'] = options.headers.Authorization;
                delete options.headers.Authorization;
            }
            if (this.noBackendCache) {
                options.headers['X-Grafana-NoCache'] = 'true';
            }
        }
        return this.$http(options)
            .then(function (response) {
            if (!options.silent) {
                __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('ds-request-response', response);
            }
            return response;
        })
            .catch(function (err) {
            if (err.status === _this.HTTP_REQUEST_CANCELLED) {
                throw { err: err, cancelled: true };
            }
            // handle unauthorized for backend requests
            var isRemembered = document.cookie.indexOf('grafana_remember') !== -1;
            if (requestIsLocal && firstAttempt && err.status === 401 && isRemembered) {
                return _this.loginPing().then(function () {
                    options.retry = 1;
                    if (canceler) {
                        canceler.resolve();
                    }
                    return _this.datasourceRequest(options);
                });
            }
            // populate error obj on Internal Error
            if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(err.data) && err.status === 500) {
                err.data = {
                    error: err.statusText,
                    response: err.data,
                };
            }
            // for Prometheus
            if (err.data && !err.data.message && __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(err.data.error)) {
                err.data.message = err.data.error;
            }
            if (!options.silent) {
                __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('ds-request-error', err);
            }
            throw err;
        })
            .finally(function () {
            // clean up
            if (options.requestId) {
                _this.inFlightRequests[options.requestId].shift();
            }
        });
    };
    BackendSrv.prototype.loginPing = function () {
        return this.request({ url: '/api/login/ping', method: 'GET', retry: 1 });
    };
    BackendSrv.prototype.search = function (query) {
        return this.get('/api/search', query);
    };
    BackendSrv.prototype.getDashboardBySlug = function (slug) {
        return this.get("/api/dashboards/db/" + slug);
    };
    BackendSrv.prototype.getDashboardByUid = function (uid) {
        return this.get("/api/dashboards/uid/" + uid);
    };
    BackendSrv.prototype.getFolderByUid = function (uid) {
        return this.get("/api/folders/" + uid);
    };
    BackendSrv.prototype.saveDashboard = function (dash, options) {
        options = options || {};
        return this.post('/api/dashboards/db/', {
            dashboard: dash,
            folderId: options.folderId,
            overwrite: options.overwrite === true,
            message: options.message || '',
        });
    };
    BackendSrv.prototype.createFolder = function (payload) {
        return this.post('/api/folders', payload);
    };
    BackendSrv.prototype.updateFolder = function (folder, options) {
        options = options || {};
        return this.put("/api/folders/" + folder.uid, {
            title: folder.title,
            version: folder.version,
            overwrite: options.overwrite === true,
        });
    };
    BackendSrv.prototype.deleteFolder = function (uid, showSuccessAlert) {
        return this.request({ method: 'DELETE', url: "/api/folders/" + uid, showSuccessAlert: showSuccessAlert === true });
    };
    BackendSrv.prototype.deleteDashboard = function (uid, showSuccessAlert) {
        return this.request({
            method: 'DELETE',
            url: "/api/dashboards/uid/" + uid,
            showSuccessAlert: showSuccessAlert === true,
        });
    };
    BackendSrv.prototype.deleteFoldersAndDashboards = function (folderUids, dashboardUids) {
        var tasks = [];
        for (var _i = 0, folderUids_1 = folderUids; _i < folderUids_1.length; _i++) {
            var folderUid = folderUids_1[_i];
            tasks.push(this.createTask(this.deleteFolder.bind(this), true, folderUid, true));
        }
        for (var _a = 0, dashboardUids_1 = dashboardUids; _a < dashboardUids_1.length; _a++) {
            var dashboardUid = dashboardUids_1[_a];
            tasks.push(this.createTask(this.deleteDashboard.bind(this), true, dashboardUid, true));
        }
        return this.executeInOrder(tasks, []);
    };
    BackendSrv.prototype.moveDashboards = function (dashboardUids, toFolder) {
        var tasks = [];
        for (var _i = 0, dashboardUids_2 = dashboardUids; _i < dashboardUids_2.length; _i++) {
            var uid = dashboardUids_2[_i];
            tasks.push(this.createTask(this.moveDashboard.bind(this), true, uid, toFolder));
        }
        return this.executeInOrder(tasks, []).then(function (result) {
            return {
                totalCount: result.length,
                successCount: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(result, { succeeded: true }).length,
                alreadyInFolderCount: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(result, { alreadyInFolder: true }).length,
            };
        });
    };
    BackendSrv.prototype.moveDashboard = function (uid, toFolder) {
        var _this = this;
        var deferred = this.$q.defer();
        this.getDashboardByUid(uid).then(function (fullDash) {
            var model = new __WEBPACK_IMPORTED_MODULE_3_app_features_dashboard_dashboard_model__["a" /* DashboardModel */](fullDash.dashboard, fullDash.meta);
            if ((!fullDash.meta.folderId && toFolder.id === 0) || fullDash.meta.folderId === toFolder.id) {
                deferred.resolve({ alreadyInFolder: true });
                return;
            }
            var clone = model.getSaveModelClone();
            var options = {
                folderId: toFolder.id,
                overwrite: false,
            };
            _this.saveDashboard(clone, options)
                .then(function () {
                deferred.resolve({ succeeded: true });
            })
                .catch(function (err) {
                if (err.data && err.data.status === 'plugin-dashboard') {
                    err.isHandled = true;
                    options.overwrite = true;
                    _this.saveDashboard(clone, options)
                        .then(function () {
                        deferred.resolve({ succeeded: true });
                    })
                        .catch(function (err) {
                        deferred.resolve({ succeeded: false });
                    });
                }
                else {
                    deferred.resolve({ succeeded: false });
                }
            });
        });
        return deferred.promise;
    };
    BackendSrv.prototype.createTask = function (fn, ignoreRejections) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return function (result) {
            return fn
                .apply(null, args)
                .then(function (res) {
                return Array.prototype.concat(result, [res]);
            })
                .catch(function (err) {
                if (ignoreRejections) {
                    return result;
                }
                throw err;
            });
        };
    };
    BackendSrv.prototype.executeInOrder = function (tasks, initialValue) {
        return tasks.reduce(this.$q.when, initialValue);
    };
    return BackendSrv;
}());

__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].service('backendSrv', BackendSrv);


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortByKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

function sortByKeys(input) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(input)) {
        return input.map(sortByKeys);
    }
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isPlainObject(input)) {
        var sortedObject = {};
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(input).sort(); _i < _a.length; _i++) {
            var key = _a[_i];
            sortedObject[key] = sortByKeys(input[key]);
        }
        return sortedObject;
    }
    return input;
}


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardMigrator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_constants__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__panel_model__ = __webpack_require__(231);



var DashboardMigrator = /** @class */ (function () {
    function DashboardMigrator(dashboardModel) {
        this.dashboard = dashboardModel;
    }
    DashboardMigrator.prototype.updateSchema = function (old) {
        var i, j, k, n;
        var oldVersion = this.dashboard.schemaVersion;
        var panelUpgrades = [];
        this.dashboard.schemaVersion = 16;
        if (oldVersion === this.dashboard.schemaVersion) {
            return;
        }
        // version 2 schema changes
        if (oldVersion < 2) {
            if (old.services) {
                if (old.services.filter) {
                    this.dashboard.time = old.services.filter.time;
                    this.dashboard.templating.list = old.services.filter.list || [];
                }
            }
            panelUpgrades.push(function (panel) {
                // rename panel type
                if (panel.type === 'graphite') {
                    panel.type = 'graph';
                }
                if (panel.type !== 'graph') {
                    return;
                }
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isBoolean(panel.legend)) {
                    panel.legend = { show: panel.legend };
                }
                if (panel.grid) {
                    if (panel.grid.min) {
                        panel.grid.leftMin = panel.grid.min;
                        delete panel.grid.min;
                    }
                    if (panel.grid.max) {
                        panel.grid.leftMax = panel.grid.max;
                        delete panel.grid.max;
                    }
                }
                if (panel.y_format) {
                    if (!panel.y_formats) {
                        panel.y_formats = [];
                    }
                    panel.y_formats[0] = panel.y_format;
                    delete panel.y_format;
                }
                if (panel.y2_format) {
                    if (!panel.y_formats) {
                        panel.y_formats = [];
                    }
                    panel.y_formats[1] = panel.y2_format;
                    delete panel.y2_format;
                }
            });
        }
        // schema version 3 changes
        if (oldVersion < 3) {
            // ensure panel ids
            var maxId = this.dashboard.getNextPanelId();
            panelUpgrades.push(function (panel) {
                if (!panel.id) {
                    panel.id = maxId;
                    maxId += 1;
                }
            });
        }
        // schema version 4 changes
        if (oldVersion < 4) {
            // move aliasYAxis changes
            panelUpgrades.push(function (panel) {
                if (panel.type !== 'graph') {
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(panel.aliasYAxis, function (value, key) {
                    panel.seriesOverrides = [{ alias: key, yaxis: value }];
                });
                delete panel.aliasYAxis;
            });
        }
        if (oldVersion < 6) {
            // move pulldowns to new schema
            var annotations = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(old.pulldowns, { type: 'annotations' });
            if (annotations) {
                this.dashboard.annotations = {
                    list: annotations.annotations || [],
                };
            }
            // update template variables
            for (i = 0; i < this.dashboard.templating.list.length; i++) {
                var variable = this.dashboard.templating.list[i];
                if (variable.datasource === void 0) {
                    variable.datasource = null;
                }
                if (variable.type === 'filter') {
                    variable.type = 'query';
                }
                if (variable.type === void 0) {
                    variable.type = 'query';
                }
                if (variable.allFormat === void 0) {
                    variable.allFormat = 'glob';
                }
            }
        }
        if (oldVersion < 7) {
            if (old.nav && old.nav.length) {
                this.dashboard.timepicker = old.nav[0];
            }
            // ensure query refIds
            panelUpgrades.push(function (panel) {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(panel.targets, function (target) {
                    if (!target.refId) {
                        target.refId = this.dashboard.getNextQueryLetter(panel);
                    }
                }.bind(this));
            });
        }
        if (oldVersion < 8) {
            panelUpgrades.push(function (panel) {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(panel.targets, function (target) {
                    // update old influxdb query schema
                    if (target.fields && target.tags && target.groupBy) {
                        if (target.rawQuery) {
                            delete target.fields;
                            delete target.fill;
                        }
                        else {
                            target.select = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(target.fields, function (field) {
                                var parts = [];
                                parts.push({ type: 'field', params: [field.name] });
                                parts.push({ type: field.func, params: [] });
                                if (field.mathExpr) {
                                    parts.push({ type: 'math', params: [field.mathExpr] });
                                }
                                if (field.asExpr) {
                                    parts.push({ type: 'alias', params: [field.asExpr] });
                                }
                                return parts;
                            });
                            delete target.fields;
                            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(target.groupBy, function (part) {
                                if (part.type === 'time' && part.interval) {
                                    part.params = [part.interval];
                                    delete part.interval;
                                }
                                if (part.type === 'tag' && part.key) {
                                    part.params = [part.key];
                                    delete part.key;
                                }
                            });
                            if (target.fill) {
                                target.groupBy.push({ type: 'fill', params: [target.fill] });
                                delete target.fill;
                            }
                        }
                    }
                });
            });
        }
        // schema version 9 changes
        if (oldVersion < 9) {
            // move aliasYAxis changes
            panelUpgrades.push(function (panel) {
                if (panel.type !== 'singlestat' && panel.thresholds !== '') {
                    return;
                }
                if (panel.thresholds) {
                    var k = panel.thresholds.split(',');
                    if (k.length >= 3) {
                        k.shift();
                        panel.thresholds = k.join(',');
                    }
                }
            });
        }
        // schema version 10 changes
        if (oldVersion < 10) {
            // move aliasYAxis changes
            panelUpgrades.push(function (panel) {
                if (panel.type !== 'table') {
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(panel.styles, function (style) {
                    if (style.thresholds && style.thresholds.length >= 3) {
                        var k = style.thresholds;
                        k.shift();
                        style.thresholds = k;
                    }
                });
            });
        }
        if (oldVersion < 12) {
            // update template variables
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.dashboard.templating.list, function (templateVariable) {
                if (templateVariable.refresh) {
                    templateVariable.refresh = 1;
                }
                if (!templateVariable.refresh) {
                    templateVariable.refresh = 0;
                }
                if (templateVariable.hideVariable) {
                    templateVariable.hide = 2;
                }
                else if (templateVariable.hideLabel) {
                    templateVariable.hide = 1;
                }
            });
        }
        if (oldVersion < 12) {
            // update graph yaxes changes
            panelUpgrades.push(function (panel) {
                if (panel.type !== 'graph') {
                    return;
                }
                if (!panel.grid) {
                    return;
                }
                if (!panel.yaxes) {
                    panel.yaxes = [
                        {
                            show: panel['y-axis'],
                            min: panel.grid.leftMin,
                            max: panel.grid.leftMax,
                            logBase: panel.grid.leftLogBase,
                            format: panel.y_formats[0],
                            label: panel.leftYAxisLabel,
                        },
                        {
                            show: panel['y-axis'],
                            min: panel.grid.rightMin,
                            max: panel.grid.rightMax,
                            logBase: panel.grid.rightLogBase,
                            format: panel.y_formats[1],
                            label: panel.rightYAxisLabel,
                        },
                    ];
                    panel.xaxis = {
                        show: panel['x-axis'],
                    };
                    delete panel.grid.leftMin;
                    delete panel.grid.leftMax;
                    delete panel.grid.leftLogBase;
                    delete panel.grid.rightMin;
                    delete panel.grid.rightMax;
                    delete panel.grid.rightLogBase;
                    delete panel.y_formats;
                    delete panel.leftYAxisLabel;
                    delete panel.rightYAxisLabel;
                    delete panel['y-axis'];
                    delete panel['x-axis'];
                }
            });
        }
        if (oldVersion < 13) {
            // update graph yaxes changes
            panelUpgrades.push(function (panel) {
                if (panel.type !== 'graph') {
                    return;
                }
                if (!panel.grid) {
                    return;
                }
                panel.thresholds = [];
                var t1 = {}, t2 = {};
                if (panel.grid.threshold1 !== null) {
                    t1.value = panel.grid.threshold1;
                    if (panel.grid.thresholdLine) {
                        t1.line = true;
                        t1.lineColor = panel.grid.threshold1Color;
                        t1.colorMode = 'custom';
                    }
                    else {
                        t1.fill = true;
                        t1.fillColor = panel.grid.threshold1Color;
                        t1.colorMode = 'custom';
                    }
                }
                if (panel.grid.threshold2 !== null) {
                    t2.value = panel.grid.threshold2;
                    if (panel.grid.thresholdLine) {
                        t2.line = true;
                        t2.lineColor = panel.grid.threshold2Color;
                        t2.colorMode = 'custom';
                    }
                    else {
                        t2.fill = true;
                        t2.fillColor = panel.grid.threshold2Color;
                        t2.colorMode = 'custom';
                    }
                }
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(t1.value)) {
                    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(t2.value)) {
                        if (t1.value > t2.value) {
                            t1.op = t2.op = 'lt';
                            panel.thresholds.push(t1);
                            panel.thresholds.push(t2);
                        }
                        else {
                            t1.op = t2.op = 'gt';
                            panel.thresholds.push(t1);
                            panel.thresholds.push(t2);
                        }
                    }
                    else {
                        t1.op = 'gt';
                        panel.thresholds.push(t1);
                    }
                }
                delete panel.grid.threshold1;
                delete panel.grid.threshold1Color;
                delete panel.grid.threshold2;
                delete panel.grid.threshold2Color;
                delete panel.grid.thresholdLine;
            });
        }
        if (oldVersion < 14) {
            this.dashboard.graphTooltip = old.sharedCrosshair ? 1 : 0;
        }
        if (oldVersion < 16) {
            this.upgradeToGridLayout(old);
        }
        if (panelUpgrades.length === 0) {
            return;
        }
        for (j = 0; j < this.dashboard.panels.length; j++) {
            for (k = 0; k < panelUpgrades.length; k++) {
                panelUpgrades[k].call(this, this.dashboard.panels[j]);
                if (this.dashboard.panels[j].panels) {
                    for (n = 0; n < this.dashboard.panels[j].panels.length; n++) {
                        panelUpgrades[k].call(this, this.dashboard.panels[j].panels[n]);
                    }
                }
            }
        }
    };
    DashboardMigrator.prototype.upgradeToGridLayout = function (old) {
        var yPos = 0;
        var widthFactor = __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["e" /* GRID_COLUMN_COUNT */] / 12;
        var maxPanelId = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.max(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flattenDeep(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(old.rows, function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(row.panels, 'id');
        })));
        var nextRowId = maxPanelId + 1;
        if (!old.rows) {
            return;
        }
        // Add special "row" panels if even one row is collapsed, repeated or has visible title
        var showRows = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.some(old.rows, function (row) { return row.collapse || row.showTitle || row.repeat; });
        for (var _i = 0, _a = old.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            if (row.repeatIteration) {
                continue;
            }
            var height = row.height || __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["b" /* DEFAULT_ROW_HEIGHT */];
            var rowGridHeight = getGridHeight(height);
            var rowPanel = {};
            var rowPanelModel = void 0;
            if (showRows) {
                // add special row panel
                rowPanel.id = nextRowId;
                rowPanel.type = 'row';
                rowPanel.title = row.title;
                rowPanel.collapsed = row.collapse;
                rowPanel.repeat = row.repeat;
                rowPanel.panels = [];
                rowPanel.gridPos = {
                    x: 0,
                    y: yPos,
                    w: __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["e" /* GRID_COLUMN_COUNT */],
                    h: rowGridHeight,
                };
                rowPanelModel = new __WEBPACK_IMPORTED_MODULE_2__panel_model__["a" /* PanelModel */](rowPanel);
                nextRowId++;
                yPos++;
            }
            var rowArea = new RowArea(rowGridHeight, __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["e" /* GRID_COLUMN_COUNT */], yPos);
            for (var _b = 0, _c = row.panels; _b < _c.length; _b++) {
                var panel = _c[_b];
                panel.span = panel.span || __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["a" /* DEFAULT_PANEL_SPAN */];
                if (panel.minSpan) {
                    panel.minSpan = Math.min(__WEBPACK_IMPORTED_MODULE_1_app_core_constants__["e" /* GRID_COLUMN_COUNT */], __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["e" /* GRID_COLUMN_COUNT */] / 12 * panel.minSpan);
                }
                var panelWidth = Math.floor(panel.span) * widthFactor;
                var panelHeight = panel.height ? getGridHeight(panel.height) : rowGridHeight;
                var panelPos = rowArea.getPanelPosition(panelHeight, panelWidth);
                yPos = rowArea.yPos;
                panel.gridPos = {
                    x: panelPos.x,
                    y: yPos + panelPos.y,
                    w: panelWidth,
                    h: panelHeight,
                };
                rowArea.addPanel(panel.gridPos);
                delete panel.span;
                if (rowPanelModel && rowPanel.collapsed) {
                    rowPanelModel.panels.push(panel);
                }
                else {
                    this.dashboard.panels.push(new __WEBPACK_IMPORTED_MODULE_2__panel_model__["a" /* PanelModel */](panel));
                }
            }
            if (rowPanelModel) {
                this.dashboard.panels.push(rowPanelModel);
            }
            if (!(rowPanelModel && rowPanel.collapsed)) {
                yPos += rowGridHeight;
            }
        }
    };
    return DashboardMigrator;
}());

function getGridHeight(height) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(height)) {
        height = parseInt(height.replace('px', ''), 10);
    }
    if (height < __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["g" /* MIN_PANEL_HEIGHT */]) {
        height = __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["g" /* MIN_PANEL_HEIGHT */];
    }
    var gridHeight = Math.ceil(height / (__WEBPACK_IMPORTED_MODULE_1_app_core_constants__["c" /* GRID_CELL_HEIGHT */] + __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["d" /* GRID_CELL_VMARGIN */]));
    return gridHeight;
}
/**
 * RowArea represents dashboard row filled by panels
 * area is an array of numbers represented filled column's cells like
 *  -----------------------
 * |******** ****
 * |******** ****
 * |********
 *  -----------------------
 *  33333333 2222 00000 ...
 */
var RowArea = /** @class */ (function () {
    function RowArea(height, width, rowYPos) {
        if (width === void 0) { width = __WEBPACK_IMPORTED_MODULE_1_app_core_constants__["e" /* GRID_COLUMN_COUNT */]; }
        if (rowYPos === void 0) { rowYPos = 0; }
        this.area = new Array(width).fill(0);
        this.yPos = rowYPos;
        this.height = height;
    }
    RowArea.prototype.reset = function () {
        this.area.fill(0);
    };
    /**
     * Update area after adding the panel.
     */
    RowArea.prototype.addPanel = function (gridPos) {
        for (var i = gridPos.x; i < gridPos.x + gridPos.w; i++) {
            if (!this.area[i] || gridPos.y + gridPos.h - this.yPos > this.area[i]) {
                this.area[i] = gridPos.y + gridPos.h - this.yPos;
            }
        }
        return this.area;
    };
    /**
     * Calculate position for the new panel in the row.
     */
    RowArea.prototype.getPanelPosition = function (panelHeight, panelWidth, callOnce) {
        if (callOnce === void 0) { callOnce = false; }
        var startPlace, endPlace;
        var place;
        for (var i = this.area.length - 1; i >= 0; i--) {
            if (this.height - this.area[i] > 0) {
                if (endPlace === undefined) {
                    endPlace = i;
                }
                else {
                    if (i < this.area.length - 1 && this.area[i] <= this.area[i + 1]) {
                        startPlace = i;
                    }
                    else {
                        break;
                    }
                }
            }
            else {
                break;
            }
        }
        if (startPlace !== undefined && endPlace !== undefined && endPlace - startPlace >= panelWidth - 1) {
            var yPos = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.max(this.area.slice(startPlace));
            place = {
                x: startPlace,
                y: yPos,
            };
        }
        else if (!callOnce) {
            // wrap to next row
            this.yPos += this.height;
            this.reset();
            return this.getPanelPosition(panelHeight, panelWidth, true);
        }
        else {
            return null;
        }
        return place;
    };
    return RowArea;
}());


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);


var DynamicDirectiveSrv = /** @class */ (function () {
    /** @ngInject */
    DynamicDirectiveSrv.$inject = ["$compile", "$rootScope"];
    function DynamicDirectiveSrv($compile, $rootScope) {
        this.$compile = $compile;
        this.$rootScope = $rootScope;
    }
    DynamicDirectiveSrv.prototype.addDirective = function (element, name, scope) {
        var child = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(document.createElement(name));
        this.$compile(child)(scope);
        element.empty();
        element.append(child);
    };
    DynamicDirectiveSrv.prototype.link = function (scope, elem, attrs, options) {
        var _this = this;
        options
            .directive(scope)
            .then(function (directiveInfo) {
            if (!directiveInfo || !directiveInfo.fn) {
                elem.empty();
                return;
            }
            if (!directiveInfo.fn.registered) {
                __WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive(attrs.$normalize(directiveInfo.name), directiveInfo.fn);
                directiveInfo.fn.registered = true;
            }
            _this.addDirective(elem, directiveInfo.name, scope);
        })
            .catch(function (err) {
            console.log('Plugin load:', err);
            _this.$rootScope.appEvent('alert-error', ['Plugin error', err.toString()]);
        });
    };
    DynamicDirectiveSrv.prototype.create = function (options) {
        var _this = this;
        var directiveDef = {
            restrict: 'E',
            scope: options.scope,
            link: function (scope, elem, attrs) {
                if (options.watchPath) {
                    var childScope_1 = null;
                    scope.$watch(options.watchPath, function () {
                        if (childScope_1) {
                            childScope_1.$destroy();
                        }
                        childScope_1 = scope.$new();
                        _this.link(childScope_1, elem, attrs, options);
                    });
                }
                else {
                    _this.link(scope, elem, attrs, options);
                }
            },
        };
        return directiveDef;
    };
    return DynamicDirectiveSrv;
}());
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].service('dynamicDirectiveSrv', DynamicDirectiveSrv);


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BridgeSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_store__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_utils_location_util__ = __webpack_require__(226);





// Services that handles angular -> mobx store sync & other react <-> angular sync
var BridgeSrv = /** @class */ (function () {
    /** @ngInject */
    BridgeSrv.$inject = ["$location", "$timeout", "$window", "$rootScope", "$route"];
    function BridgeSrv($location, $timeout, $window, $rootScope, $route) {
        this.$location = $location;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.$route = $route;
        this.fullPageReloadRoutes = ['/logout'];
    }
    BridgeSrv.prototype.init = function () {
        var _this = this;
        this.$rootScope.$on('$routeUpdate', function (evt, data) {
            var angularUrl = _this.$location.url();
            if (__WEBPACK_IMPORTED_MODULE_2_app_stores_store__["b" /* store */].view.currentUrl !== angularUrl) {
                __WEBPACK_IMPORTED_MODULE_2_app_stores_store__["b" /* store */].view.updatePathAndQuery(_this.$location.path(), _this.$location.search(), _this.$route.current.params);
            }
        });
        this.$rootScope.$on('$routeChangeSuccess', function (evt, data) {
            __WEBPACK_IMPORTED_MODULE_2_app_stores_store__["b" /* store */].view.updatePathAndQuery(_this.$location.path(), _this.$location.search(), _this.$route.current.params);
        });
        Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["reaction"])(function () { return __WEBPACK_IMPORTED_MODULE_2_app_stores_store__["b" /* store */].view.currentUrl; }, function (currentUrl) {
            var angularUrl = _this.$location.url();
            var url = __WEBPACK_IMPORTED_MODULE_4_app_core_utils_location_util__["a" /* default */].stripBaseFromUrl(currentUrl);
            if (angularUrl !== url) {
                _this.$timeout(function () {
                    _this.$location.url(url);
                });
                console.log('store updating angular $location.url', url);
            }
        });
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].on('location-change', function (payload) {
            var urlWithoutBase = __WEBPACK_IMPORTED_MODULE_4_app_core_utils_location_util__["a" /* default */].stripBaseFromUrl(payload.href);
            if (_this.fullPageReloadRoutes.indexOf(urlWithoutBase) > -1) {
                _this.$window.location.href = payload.href;
                return;
            }
            _this.$timeout(function () {
                // A hack to use timeout when we're changing things (in this case the url) from outside of Angular.
                _this.$location.url(urlWithoutBase);
            });
        });
    };
    return BridgeSrv;
}());

__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].service('bridgeSrv', BridgeSrv);


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ 
interpolateTemplateVars.$inject = ["templateSrv"];var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_module__ = __webpack_require__(3);




__WEBPACK_IMPORTED_MODULE_3__core_module__["a" /* default */].filter('stringSort', function () {
    return function (input) {
        return input.sort();
    };
});
__WEBPACK_IMPORTED_MODULE_3__core_module__["a" /* default */].filter('slice', function () {
    return function (arr, start, end) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isUndefined(arr)) {
            return arr.slice(start, end);
        }
    };
});
__WEBPACK_IMPORTED_MODULE_3__core_module__["a" /* default */].filter('stringify', function () {
    return function (arr) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(arr) && !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(arr)) {
            return __WEBPACK_IMPORTED_MODULE_1_angular___default.a.toJson(arr);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNull(arr) ? null : arr.toString();
        }
    };
});
__WEBPACK_IMPORTED_MODULE_3__core_module__["a" /* default */].filter('moment', function () {
    return function (date, mode) {
        switch (mode) {
            case 'ago':
                return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).fromNow();
        }
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).fromNow();
    };
});
__WEBPACK_IMPORTED_MODULE_3__core_module__["a" /* default */].filter('noXml', function () {
    var noXml = function (text) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(text)
            ? text
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/'/g, '&#39;')
                .replace(/"/g, '&quot;')
            : text;
    };
    return function (text) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(text) ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(text, noXml) : noXml(text);
    };
});
/** @ngInject */
function interpolateTemplateVars(templateSrv) {
    var filterFunc = function (text, scope) {
        var scopedVars;
        if (scope.ctrl) {
            scopedVars = (scope.ctrl.panel || scope.ctrl.row).scopedVars;
        }
        else {
            scopedVars = scope.row.scopedVars;
        }
        return templateSrv.replaceWithText(text, scopedVars);
    };
    filterFunc.$stateful = true;
    return filterFunc;
}
__WEBPACK_IMPORTED_MODULE_3__core_module__["a" /* default */].filter('interpolateTemplateVars', interpolateTemplateVars);
/* unused harmony default export */ var _unused_webpack_default_export = ({});


/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KeybindingSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mousetrap__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mousetrap_global_bind__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mousetrap_global_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mousetrap_global_bind__);






var KeybindingSrv = /** @class */ (function () {
    /** @ngInject */
    KeybindingSrv.$inject = ["$rootScope", "$location"];
    function KeybindingSrv($rootScope, $location) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.modalOpen = false;
        this.timepickerOpen = false;
        // clear out all shortcuts on route change
        $rootScope.$on('$routeChangeSuccess', function () {
            __WEBPACK_IMPORTED_MODULE_4_mousetrap___default.a.reset();
            // rebind global shortcuts
            _this.setupGlobal();
        });
        this.setupGlobal();
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('show-modal', function () { return (_this.modalOpen = true); });
        $rootScope.onAppEvent('timepickerOpen', function () { return (_this.timepickerOpen = true); });
        $rootScope.onAppEvent('timepickerClosed', function () { return (_this.timepickerOpen = false); });
    }
    KeybindingSrv.prototype.setupGlobal = function () {
        this.bind(['?', 'h'], this.showHelpModal);
        this.bind('g h', this.goToHome);
        this.bind('g a', this.openAlerting);
        this.bind('g p', this.goToProfile);
        this.bind('s s', this.openSearchStarred);
        this.bind('s o', this.openSearch);
        this.bind('s t', this.openSearchTags);
        this.bind('f', this.openSearch);
        this.bindGlobal('esc', this.exit);
    };
    KeybindingSrv.prototype.openSearchStarred = function () {
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('show-dash-search', { starred: true });
    };
    KeybindingSrv.prototype.openSearchTags = function () {
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('show-dash-search', { tagsMode: true });
    };
    KeybindingSrv.prototype.openSearch = function () {
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('show-dash-search');
    };
    KeybindingSrv.prototype.openAlerting = function () {
        this.$location.url('/alerting');
    };
    KeybindingSrv.prototype.goToHome = function () {
        this.$location.url('/');
    };
    KeybindingSrv.prototype.goToProfile = function () {
        this.$location.url('/profile');
    };
    KeybindingSrv.prototype.showHelpModal = function () {
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('show-modal', { templateHtml: '<help-modal></help-modal>' });
    };
    KeybindingSrv.prototype.exit = function () {
        var popups = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.popover.in');
        if (popups.length > 0) {
            return;
        }
        __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('hide-modal');
        if (!this.modalOpen) {
            if (this.timepickerOpen) {
                this.$rootScope.appEvent('closeTimepicker');
                this.timepickerOpen = false;
            }
            else {
                this.$rootScope.appEvent('panel-change-view', { fullscreen: false, edit: false });
            }
        }
        else {
            this.modalOpen = false;
        }
        // close settings view
        var search = this.$location.search();
        if (search.editview) {
            delete search.editview;
            this.$location.search(search);
        }
    };
    KeybindingSrv.prototype.bind = function (keyArg, fn) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4_mousetrap___default.a.bind(keyArg, function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            evt.returnValue = false;
            return _this.$rootScope.$apply(fn.bind(_this));
        }, 'keydown');
    };
    KeybindingSrv.prototype.bindGlobal = function (keyArg, fn) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4_mousetrap___default.a.bindGlobal(keyArg, function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            evt.returnValue = false;
            return _this.$rootScope.$apply(fn.bind(_this));
        }, 'keydown');
    };
    KeybindingSrv.prototype.showDashEditView = function () {
        var search = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.extend(this.$location.search(), { editview: 'settings' });
        this.$location.search(search);
    };
    KeybindingSrv.prototype.setupDashboardBindings = function (scope, dashboard) {
        var _this = this;
        this.bind('mod+o', function () {
            dashboard.graphTooltip = (dashboard.graphTooltip + 1) % 3;
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('graph-hover-clear');
            _this.$rootScope.$broadcast('refresh');
        });
        this.bind('mod+s', function (e) {
            scope.appEvent('save-dashboard');
        });
        this.bind('t z', function () {
            scope.appEvent('zoom-out', 2);
        });
        this.bind('ctrl+z', function () {
            scope.appEvent('zoom-out', 2);
        });
        this.bind('t left', function () {
            scope.appEvent('shift-time-backward');
        });
        this.bind('t right', function () {
            scope.appEvent('shift-time-forward');
        });
        // edit panel
        this.bind('e', function () {
            if (dashboard.meta.focusPanelId && dashboard.meta.canEdit) {
                _this.$rootScope.appEvent('panel-change-view', {
                    fullscreen: true,
                    edit: true,
                    panelId: dashboard.meta.focusPanelId,
                    toggle: true,
                });
            }
        });
        // view panel
        this.bind('v', function () {
            if (dashboard.meta.focusPanelId) {
                _this.$rootScope.appEvent('panel-change-view', {
                    fullscreen: true,
                    edit: null,
                    panelId: dashboard.meta.focusPanelId,
                    toggle: true,
                });
            }
        });
        // delete panel
        this.bind('p r', function () {
            if (dashboard.meta.focusPanelId && dashboard.meta.canEdit) {
                _this.$rootScope.appEvent('panel-remove', {
                    panelId: dashboard.meta.focusPanelId,
                });
                dashboard.meta.focusPanelId = 0;
            }
        });
        // duplicate panel
        this.bind('p d', function () {
            if (dashboard.meta.focusPanelId && dashboard.meta.canEdit) {
                var panelIndex = dashboard.getPanelInfoById(dashboard.meta.focusPanelId).index;
                dashboard.duplicatePanel(dashboard.panels[panelIndex]);
            }
        });
        // share panel
        this.bind('p s', function () {
            if (dashboard.meta.focusPanelId) {
                var shareScope = scope.$new();
                var panelInfo = dashboard.getPanelInfoById(dashboard.meta.focusPanelId);
                shareScope.panel = panelInfo.panel;
                shareScope.dashboard = dashboard;
                __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('show-modal', {
                    src: 'public/app/features/dashboard/partials/shareModal.html',
                    scope: shareScope,
                });
            }
        });
        // collapse all rows
        this.bind('d shift+c', function () {
            dashboard.collapseRows();
        });
        // expand all rows
        this.bind('d shift+e', function () {
            dashboard.expandRows();
        });
        this.bind('d n', function (e) {
            _this.$location.url('/dashboard/new');
        });
        this.bind('d r', function () {
            _this.$rootScope.$broadcast('refresh');
        });
        this.bind('d s', function () {
            _this.showDashEditView();
        });
        this.bind('d k', function () {
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('toggle-kiosk-mode');
        });
        this.bind('d v', function () {
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].emit('toggle-view-mode');
        });
    };
    return KeybindingSrv;
}());

__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["a" /* default */].service('keybindingSrv', KeybindingSrv);


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HelpCtrl */
/* unused harmony export helpModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__ = __webpack_require__(17);


var HelpCtrl = /** @class */ (function () {
    /** @ngInject */
    function HelpCtrl() {
        this.tabIndex = 0;
        this.shortcuts = {
            Global: [
                { keys: ['g', 'h'], description: 'Go to Home Dashboard' },
                { keys: ['g', 'p'], description: 'Go to Profile' },
                { keys: ['s', 'o'], description: 'Open search' },
                { keys: ['s', 's'], description: 'Open search with starred filter' },
                { keys: ['s', 't'], description: 'Open search in tags view' },
                { keys: ['esc'], description: 'Exit edit/setting views' },
            ],
            Dashboard: [
                { keys: ['mod+s'], description: 'Save dashboard' },
                { keys: ['d', 'r'], description: 'Refresh all panels' },
                { keys: ['d', 's'], description: 'Dashboard settings' },
                { keys: ['d', 'v'], description: 'Toggle in-active / view mode' },
                { keys: ['d', 'k'], description: 'Toggle kiosk mode (hides top nav)' },
                { keys: ['d', 'E'], description: 'Expand all rows' },
                { keys: ['d', 'C'], description: 'Collapse all rows' },
                { keys: ['mod+o'], description: 'Toggle shared graph crosshair' },
            ],
            'Focused Panel': [
                { keys: ['e'], description: 'Toggle panel edit view' },
                { keys: ['v'], description: 'Toggle panel fullscreen view' },
                { keys: ['p', 's'], description: 'Open Panel Share Modal' },
                { keys: ['p', 'd'], description: 'Duplicate Panel' },
                { keys: ['p', 'r'], description: 'Remove Panel' },
            ],
            'Time Range': [
                { keys: ['t', 'z'], description: 'Zoom out time range' },
                {
                    keys: ['t', '<i class="fa fa-long-arrow-left"></i>'],
                    description: 'Move time range back',
                },
                {
                    keys: ['t', '<i class="fa fa-long-arrow-right"></i>'],
                    description: 'Move time range forward',
                },
            ],
        };
    }
    HelpCtrl.prototype.dismiss = function () {
        __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].emit('hide-modal');
    };
    return HelpCtrl;
}());

function helpModal() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/help/help.html',
        controller: HelpCtrl,
        bindToController: true,
        transclude: true,
        controllerAs: 'ctrl',
        scope: {},
    };
}
__WEBPACK_IMPORTED_MODULE_0__core_module__["a" /* default */].directive('helpModal', helpModal);


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavModel */
/* unused harmony export NavModelSrv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_config__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);



var NavModel = /** @class */ (function () {
    function NavModel() {
        this.breadcrumbs = [];
    }
    return NavModel;
}());

var NavModelSrv = /** @class */ (function () {
    /** @ngInject */
    function NavModelSrv() {
        this.navItems = __WEBPACK_IMPORTED_MODULE_1_app_core_config__["a" /* default */].bootData.navTree;
    }
    NavModelSrv.prototype.getCfgNode = function () {
        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.navItems, { id: 'cfg' });
    };
    NavModelSrv.prototype.getNav = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var children = this.navItems;
        var nav = new NavModel();
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var id = args_1[_a];
            // if its a number then it's the index to use for main
            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNumber(id)) {
                nav.main = nav.breadcrumbs[id];
                break;
            }
            var node = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(children, { id: id });
            nav.breadcrumbs.push(node);
            nav.node = node;
            nav.main = node;
            children = node.children;
        }
        if (nav.main.children) {
            for (var _b = 0, _c = nav.main.children; _b < _c.length; _b++) {
                var item = _c[_b];
                item.active = false;
                if (item.url === nav.node.url) {
                    item.active = true;
                }
            }
        }
        return nav;
    };
    NavModelSrv.prototype.getNotFoundNav = function () {
        var node = {
            text: 'Page not found',
            icon: 'fa fa-fw fa-warning',
            subTitle: '404 Error',
        };
        return {
            breadcrumbs: [node],
            node: node,
            main: node,
        };
    };
    return NavModelSrv;
}());

__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].service('navModelSrv', NavModelSrv);


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserPickerCtrl */
/* unused harmony export userPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);


var template = "\n<div class=\"dropdown\">\n  <gf-form-dropdown model=\"ctrl.user\"\n                    get-options=\"ctrl.debouncedSearchUsers($query)\"\n                    css-class=\"gf-size-auto\"\n                    on-change=\"ctrl.onChange($option)\"\n  </gf-form-dropdown>\n</div>\n";
var UserPickerCtrl = /** @class */ (function () {
    /** @ngInject */
    UserPickerCtrl.$inject = ["backendSrv"];
    function UserPickerCtrl(backendSrv) {
        this.backendSrv = backendSrv;
        this.reset();
        this.debouncedSearchUsers = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(this.searchUsers, 500, {
            leading: true,
            trailing: false,
        });
    }
    UserPickerCtrl.prototype.searchUsers = function (query) {
        return Promise.resolve(this.backendSrv.get('/api/users/search?perpage=10&page=1&query=' + query).then(function (result) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(result.users, function (user) {
                return { text: user.login + ' -  ' + user.email, value: user };
            });
        }));
    };
    UserPickerCtrl.prototype.onChange = function (option) {
        this.userPicked({ $user: option.value });
    };
    UserPickerCtrl.prototype.reset = function () {
        this.user = { text: 'Choose', value: null };
    };
    return UserPickerCtrl;
}());

function userPicker() {
    return {
        restrict: 'E',
        template: template,
        controller: UserPickerCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {
            userPicked: '&',
        },
        link: function (scope, elem, attrs, ctrl) {
            scope.$on('user-picker-reset', function () {
                ctrl.reset();
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('userPicker', userPicker);


/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TeamPickerCtrl */
/* unused harmony export teamPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);


var template = "\n<div class=\"dropdown\">\n  <gf-form-dropdown model=\"ctrl.group\"\n                    get-options=\"ctrl.debouncedSearchGroups($query)\"\n                    css-class=\"gf-size-auto\"\n                    on-change=\"ctrl.onChange($option)\"\n  </gf-form-dropdown>\n</div>\n";
var TeamPickerCtrl = /** @class */ (function () {
    /** @ngInject */
    TeamPickerCtrl.$inject = ["backendSrv"];
    function TeamPickerCtrl(backendSrv) {
        this.backendSrv = backendSrv;
        this.debouncedSearchGroups = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(this.searchGroups, 500, {
            leading: true,
            trailing: false,
        });
        this.reset();
    }
    TeamPickerCtrl.prototype.reset = function () {
        this.group = { text: 'Choose', value: null };
    };
    TeamPickerCtrl.prototype.searchGroups = function (query) {
        return Promise.resolve(this.backendSrv.get('/api/teams/search?perpage=10&page=1&query=' + query).then(function (result) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(result.teams, function (ug) {
                return { text: ug.name, value: ug };
            });
        }));
    };
    TeamPickerCtrl.prototype.onChange = function (option) {
        this.teamPicked({ $group: option.value });
    };
    return TeamPickerCtrl;
}());

function teamPicker() {
    return {
        restrict: 'E',
        template: template,
        controller: TeamPickerCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {
            teamPicked: '&',
        },
        link: function (scope, elem, attrs, ctrl) {
            scope.$on('team-picker-reset', function () {
                ctrl.reset();
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('teamPicker', teamPicker);


/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export geminiScrollbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_baron__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_baron___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_baron__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__ = __webpack_require__(17);




var scrollBarHTML = "\n<div class=\"baron__track\">\n  <div class=\"baron__bar\"></div>\n</div>\n";
var scrollRootClass = 'baron baron__root';
var scrollerClass = 'baron__scroller';
function geminiScrollbar() {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            var scrollRoot = elem.parent();
            var scroller = elem;
            if (attrs.grafanaScrollbar && attrs.grafanaScrollbar === 'scrollonroot') {
                scrollRoot = scroller;
            }
            scrollRoot.addClass(scrollRootClass);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(scrollBarHTML).appendTo(scrollRoot);
            elem.addClass(scrollerClass);
            var scrollParams = {
                root: scrollRoot[0],
                scroller: scroller[0],
                bar: '.baron__bar',
                barOnCls: '_scrollbar',
                scrollingCls: '_scrolling',
                track: '.baron__track',
                direction: 'v',
            };
            var scrollbar = __WEBPACK_IMPORTED_MODULE_1_baron___default()(scrollParams);
            var lastPos = 0;
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('dash-scroll', function (evt) {
                if (evt.restore) {
                    elem[0].scrollTop = lastPos;
                    return;
                }
                lastPos = elem[0].scrollTop;
                if (evt.animate) {
                    elem.animate({ scrollTop: evt.pos }, 500);
                }
                else {
                    elem[0].scrollTop = evt.pos;
                }
            }, scope);
            // force updating dashboard width
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('toggle-sidemenu', forceUpdate, scope);
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('toggle-sidemenu-hidden', forceUpdate, scope);
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('toggle-view-mode', forceUpdate, scope);
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('toggle-kiosk-mode', forceUpdate, scope);
            __WEBPACK_IMPORTED_MODULE_3_app_core_app_events__["a" /* default */].on('toggle-inactive-mode', forceUpdate, scope);
            function forceUpdate() {
                scrollbar.scroll();
            }
            scope.$on('$routeChangeSuccess', function () {
                lastPos = 0;
                elem[0].scrollTop = 0;
            });
            scope.$on('$destroy', function () {
                scrollbar.dispose();
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["a" /* default */].directive('grafanaScrollbar', geminiScrollbar);


/***/ }),
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pageScrollbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__ = __webpack_require__(17);


function pageScrollbar() {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            var lastPos = 0;
            __WEBPACK_IMPORTED_MODULE_1_app_core_app_events__["a" /* default */].on('dash-scroll', function (evt) {
                if (evt.restore) {
                    elem[0].scrollTop = lastPos;
                    return;
                }
                lastPos = elem[0].scrollTop;
                if (evt.animate) {
                    elem.animate({ scrollTop: evt.pos }, 500);
                }
                else {
                    elem[0].scrollTop = evt.pos;
                }
            }, scope);
            scope.$on('$routeChangeSuccess', function () {
                lastPos = 0;
                elem[0].scrollTop = 0;
                elem[0].focus();
            });
            elem[0].tabIndex = -1;
            elem[0].focus();
        },
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('pageScrollbar', pageScrollbar);


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gfPageDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);

var template = "\n<div class=\"scroll-canvas\">\n  <navbar model=\"model\"></navbar>\n   <div class=\"page-container\">\n\t\t<div class=\"page-header\">\n      <h1>\n         <i class=\"{{::model.node.icon}}\" ng-if=\"::model.node.icon\"></i>\n         <img ng-src=\"{{::model.node.img}}\" ng-if=\"::model.node.img\"></i>\n         {{::model.node.text}}\n       </h1>\n\n      <div class=\"page-header__actions\" ng-transclude=\"header\"></div>\n\t\t</div>\n\n    <div class=\"page-body\" ng-transclude=\"body\">\n    </div>\n  </div>\n</div>\n";
function gfPageDirective() {
    return {
        restrict: 'E',
        template: template,
        scope: {
            model: '=',
        },
        transclude: {
            header: '?gfPageHeader',
            body: 'gfPageBody',
        },
        link: function (scope, elem, attrs) {
            console.log(scope);
        },
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('gfPage', gfPageDirective);


/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrgSwitchCtrl */
/* unused harmony export orgSwitcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_services_context_srv__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_config__ = __webpack_require__(22);



var template = "\n<div class=\"modal-body\">\n\t<div class=\"modal-header\">\n\t\t<h2 class=\"modal-header-title\">\n\t\t\t<i class=\"fa fa-random\"></i>\n\t\t\t<span class=\"p-l-1\">Switch Organization</span>\n\t\t</h2>\n\n\t\t<a class=\"modal-header-close\" ng-click=\"ctrl.dismiss();\">\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</a>\n\t</div>\n\n  <div class=\"modal-content modal-content--has-scroll\" grafana-scrollbar>\n    <table class=\"filter-table form-inline\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Name</th>\n\t\t\t\t\t<th>Role</th>\n\t\t\t\t\t<th></th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"org in ctrl.orgs\">\n\t\t\t\t\t<td>{{org.name}}</td>\n\t\t\t\t\t<td>{{org.role}}</td>\n\t\t\t\t\t<td class=\"text-right\">\n\t\t\t\t\t\t<span class=\"btn btn-primary btn-mini\" ng-show=\"org.orgId === ctrl.currentOrgId\">\n\t\t\t\t\t\t\tCurrent\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<a ng-click=\"ctrl.setUsingOrg(org)\" class=\"btn btn-inverse btn-mini\" ng-show=\"org.orgId !== ctrl.currentOrgId\">\n\t\t\t\t\t\t\tSwitch to\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n</div>";
var OrgSwitchCtrl = /** @class */ (function () {
    /** @ngInject */
    OrgSwitchCtrl.$inject = ["backendSrv"];
    function OrgSwitchCtrl(backendSrv) {
        this.backendSrv = backendSrv;
        this.currentOrgId = __WEBPACK_IMPORTED_MODULE_1_app_core_services_context_srv__["a" /* contextSrv */].user.orgId;
        this.getUserOrgs();
    }
    OrgSwitchCtrl.prototype.getUserOrgs = function () {
        var _this = this;
        this.backendSrv.get('/api/user/orgs').then(function (orgs) {
            _this.orgs = orgs;
        });
    };
    OrgSwitchCtrl.prototype.setUsingOrg = function (org) {
        var _this = this;
        return this.backendSrv.post('/api/user/using/' + org.orgId).then(function () {
            _this.setWindowLocation(__WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].appSubUrl + (__WEBPACK_IMPORTED_MODULE_2_app_core_config__["a" /* default */].appSubUrl.endsWith('/') ? '' : '/') + '?orgId=' + org.orgId);
        });
    };
    OrgSwitchCtrl.prototype.setWindowLocation = function (href) {
        window.location.href = href;
    };
    return OrgSwitchCtrl;
}());

function orgSwitcher() {
    return {
        restrict: 'E',
        template: template,
        controller: OrgSwitchCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: { dismiss: '&' },
    };
}
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].directive('orgSwitcher', orgSwitcher);


/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerAngularDirectives;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PasswordStrength__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader_PageHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EmptyListCTA_EmptyListCTA__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_LoginBackground__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_search_SearchResult__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TagFilter_TagFilter__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Picker_UserPicker__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Permissions_DashboardPermissions__ = __webpack_require__(1027);









function registerAngularDirectives() {
    Object(__WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__["a" /* react2AngularDirective */])('passwordStrength', __WEBPACK_IMPORTED_MODULE_1__components_PasswordStrength__["a" /* PasswordStrength */], ['password']);
    Object(__WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__["a" /* react2AngularDirective */])('pageHeader', __WEBPACK_IMPORTED_MODULE_2__components_PageHeader_PageHeader__["a" /* default */], ['model', 'noTabs']);
    Object(__WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__["a" /* react2AngularDirective */])('emptyListCta', __WEBPACK_IMPORTED_MODULE_3__components_EmptyListCTA_EmptyListCTA__["a" /* default */], ['model']);
    Object(__WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__["a" /* react2AngularDirective */])('loginBackground', __WEBPACK_IMPORTED_MODULE_4__components_Login_LoginBackground__["a" /* default */], []);
    Object(__WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__["a" /* react2AngularDirective */])('searchResult', __WEBPACK_IMPORTED_MODULE_5__components_search_SearchResult__["a" /* SearchResult */], []);
    Object(__WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__["a" /* react2AngularDirective */])('tagFilter', __WEBPACK_IMPORTED_MODULE_6__components_TagFilter_TagFilter__["a" /* TagFilter */], [
        'tags',
        ['onSelect', { watchDepth: 'reference' }],
        ['tagOptions', { watchDepth: 'reference' }],
    ]);
    Object(__WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__["a" /* react2AngularDirective */])('selectUserPicker', __WEBPACK_IMPORTED_MODULE_7__components_Picker_UserPicker__["a" /* default */], ['backendSrv', 'handlePicked']);
    Object(__WEBPACK_IMPORTED_MODULE_0_app_core_utils_react2angular__["a" /* react2AngularDirective */])('dashboardPermissions', __WEBPACK_IMPORTED_MODULE_8__components_Permissions_DashboardPermissions__["a" /* default */], ['backendSrv', 'dashboardId', 'folder']);
}


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordStrength; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PasswordStrength = /** @class */ (function (_super) {
    __extends(PasswordStrength, _super);
    function PasswordStrength(props) {
        return _super.call(this, props) || this;
    }
    PasswordStrength.prototype.render = function () {
        var password = this.props.password;
        var strengthText = "strength: strong like a bull.";
        var strengthClass = "password-strength-good";
        if (!password) {
            return null;
        }
        if (password.length <= 8) {
            strengthText = "strength: you can do better.";
            strengthClass = "password-strength-ok";
        }
        if (password.length < 4) {
            strengthText = "strength: weak sauce.";
            strengthClass = "password-strength-bad";
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "password-strength small " + strengthClass },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, strengthText)));
    };
    return PasswordStrength;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EmptyListCTA = /** @class */ (function (_super) {
    __extends(EmptyListCTA, _super);
    function EmptyListCTA() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyListCTA.prototype.render = function () {
        var _a = this.props.model, title = _a.title, buttonIcon = _a.buttonIcon, buttonLink = _a.buttonLink, buttonTitle = _a.buttonTitle, proTip = _a.proTip, proTipLink = _a.proTipLink, proTipLinkTitle = _a.proTipLinkTitle, proTipTarget = _a.proTipTarget;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "empty-list-cta" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "empty-list-cta__title" }, title),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: buttonLink, className: "empty-list-cta__button btn btn-xlarge btn-success" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: buttonIcon }),
                buttonTitle),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "empty-list-cta__pro-tip" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-rocket" }),
                " ProTip: ",
                proTip,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "text-link empty-list-cta__pro-tip-link", href: proTipLink, target: proTipTarget }, proTipLinkTitle))));
    };
    return EmptyListCTA;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (EmptyListCTA);


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var xCount = 50;
var yCount = 50;
function Cell(_a) {
    var x = _a.x, y = _a.y, flipIndex = _a.flipIndex;
    var index = (y * xCount) + x;
    var bgColor1 = getColor(x, y);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "login-bg__item " + (flipIndex === index ? 'login-bg-flip' : ''), key: index, style: { background: bgColor1 } }));
}
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}
var LoginBackground = /** @class */ (function (_super) {
    __extends(LoginBackground, _super);
    function LoginBackground(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            flipIndex: null,
        };
        _this.flipElements = _this.flipElements.bind(_this);
        return _this;
    }
    LoginBackground.prototype.flipElements = function () {
        var elementIndexToFlip = getRandomInt(0, (xCount * yCount) - 1);
        this.setState(function (prevState) {
            return __assign({}, prevState, { flipIndex: elementIndexToFlip });
        });
    };
    LoginBackground.prototype.componentWillMount = function () {
        this.cancelInterval = setInterval(this.flipElements, 3000);
    };
    LoginBackground.prototype.componentWillUnmount = function () {
        clearInterval(this.cancelInterval);
    };
    LoginBackground.prototype.render = function () {
        var _this = this;
        console.log('re-render!', this.state.flipIndex);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "login-bg" }, Array.from(Array(yCount)).map(function (el, y) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "login-bg__row" }, Array.from(Array(xCount)).map(function (el2, x) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Cell, { y: y, x: x, flipIndex: _this.state.flipIndex }));
            })));
        })));
    };
    return LoginBackground;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LoginBackground);
function getColor(x, y) {
    var colors = [
        '#14161A',
        '#111920',
        '#121E27',
        '#13212B',
        '#122029',
        '#101C24',
        '#0F1B23',
        '#0F1B22',
        '#111C24',
        '#101A22',
        '#101A21',
        '#111D25',
        '#101E27',
        '#101D26',
        '#101B23',
        '#11191E',
        '#131519',
        '#131518',
        '#101B21',
        '#121F29',
        '#10232D',
        '#11212B',
        '#0E1C25',
        '#0E1C24',
        '#111F29',
        '#11222B',
        '#101E28',
        '#102028',
        '#111F2A',
        '#11202A',
        '#11191F',
        '#121417',
        '#12191D',
        '#101D25',
        '#11212C',
        '#10242F',
        '#0F212B',
        '#0F1E27',
        '#0F1D26',
        '#0F1F29',
        '#0F2029',
        '#11232E',
        '#10212B',
        '#10222C',
        '#0F202A',
        '#112530',
        '#10252F',
        '#0F242E',
        '#10222D',
        '#10202A',
        '#0F1C24',
        '#0F1E28',
        '#0F212A',
        '#0F222B',
        '#14171A',
        '#0F1A20',
        '#0F1C25',
        '#10232E',
        '#0E202A',
        '#0E1E27',
        '#0E1D26',
        '#0F202B',
        '#11232F',
        '#102632',
        '#102530',
        '#122430',
        '#0F1B21',
        '#0F212C',
        '#0E1F29',
        '#112531',
        '#0F2734',
        '#0F2835',
        '#0D1B23',
        '#0F1A21',
        '#0F1A23',
        '#0F1D27',
        '#0F222D',
        '#102430',
        '#102531',
        '#10222E',
        '#0F232D',
        '#0E2633',
        '#0E2734',
        '#0F2834',
        '#0E2835',
        '#0F2633',
        '#0F2532',
        '#0E1A22',
        '#0D1C24',
        '#0F2735',
        '#0F2937',
        '#102A38',
        '#112938',
        '#102A39',
        '#0F2A38',
        '#102836',
        '#0E1B23',
        '#0F2938',
        '#102A3A',
        '#102D3D',
        '#0F3040',
        '#102D3E',
        '#0F2E3E',
        '#112C3B',
        '#102B3B',
        '#102B3A',
        '#102D3C',
        '#0F2A39',
        '#0F2634',
        '#0E2029',
        '#0E1A21',
        '#0F2B39',
        '#0F2D3D',
        '#0F2F40',
        '#0E3142',
        '#113445',
        '#122431',
        '#102E3E',
        '#0F3345',
        '#0E2F40',
        '#0F3143',
        '#102C3C',
        '#0F2B3A',
        '#0F1F28',
        '#0F3344',
        '#113548',
        '#113C51',
        '#144258',
        '#103A4E',
        '#103A4F',
        '#103547',
        '#10364A',
        '#103649',
        '#0F3448',
        '#102C3A',
        '#0F2836',
        '#103447',
        '#0F384C',
        '#123F55',
        '#15445A',
        '#133F55',
        '#103B50',
        '#113E54',
        '#103446',
        '#0F3A4F',
        '#0F3548',
        '#0D3142',
        '#102C3B',
        '#0E2937',
        '#103D52',
        '#0E3544',
        '#184C65',
        '#154760',
        '#14435B',
        '#15465F',
        '#124159',
        '#0F3D53',
        '#103C51',
        '#0F3447',
        '#0E3243',
        '#113143',
        '#113D53',
        '#184B64',
        '#184D67',
        '#184C66',
        '#174A63',
        '#15455C',
        '#13425A',
        '#14445A',
        '#10384C',
        '#0E3446',
        '#10181E',
        '#103243',
        '#0F384D',
        '#14455C',
        '#164761',
        '#164C66',
        '#1D627D',
        '#12425A',
        '#164A63',
        '#14465D',
        '#13435A',
        '#0A2B38',
        '#0F3446',
        '#0D2F40',
        '#0D2F3F',
        '#0F2531',
        '#102937',
        '#10384B',
        '#0F3649',
        '#184E68',
        '#1A5472',
        '#184D68',
        '#154A63',
        '#19506B',
        '#19536F',
        '#1A4F69',
        '#144760',
        '#114058',
        '#0E3A4F',
        '#0E3547',
        '#0C3042',
        '#0E1B24',
        '#11222C',
        '#154C65',
        '#1A5776',
        '#1B5675',
        '#113847',
        '#1A5371',
        '#194E68',
        '#0E2D3D',
        '#112D3B',
        '#113D52',
        '#18516D',
        '#1A5979',
        '#1B5878',
        '#19526E',
        '#1A526E',
        '#13435B',
        '#0F3E55',
        '#0B374C',
        '#0E3448',
        '#0D2E3F',
        '#0F2B3B',
        '#112E3E',
        '#113B50',
        '#15465D',
        '#1A526F',
        '#1E5E81',
        '#1D5B7B',
        '#1A5777',
        '#154456',
        '#113949',
        '#0D394E',
        '#0F3549',
        '#0F2C3B',
        '#0E2733',
        '#112E3D',
        '#123D52',
        '#10394C',
        '#1B5674',
        '#1A5370',
        '#144861',
        '#104058',
        '#104159',
        '#0E384C',
        '#0D2D3D',
        '#0E2533',
        '#112C3A',
        '#1B5979',
        '#1B5C7D',
        '#1A5675',
        '#104057',
        '#0F3C51',
        '#11425A',
        '#0E394D',
        '#0C3243',
        '#0E2735',
        '#112F3E',
        '#134158',
        '#1D5E7F',
        '#1D6083',
        '#1C5877',
        '#1A5573',
        '#184D66',
        '#164962',
        '#0F3D54',
        '#0E3D53',
        '#0E3447',
        '#0F2A3A',
        '#0F2936',
        '#101F28',
        '#103040',
        '#124056',
        '#164E69',
        '#144B64',
        '#164D66',
        '#0F3E54',
        '#0E3B51',
        '#0D3346',
        '#0E1F27',
        '#124158',
        '#164961',
        '#0E3C52',
        '#19506C',
        '#0F2C3C',
        '#0E3244',
        '#0E2A39',
        '#0E2938',
        '#113040',
        '#134057',
        '#1A5471',
        '#154B63',
        '#1C597A',
        '#164760',
        '#10374B',
        '#0E374C',
        '#0E384D',
        '#11242F',
        '#10394D',
        '#18526E',
        '#154B65',
        '#103F55',
        '#0D3345',
        '#102532',
        '#102029',
        '#113142',
        '#1B5973',
        '#1A516B',
        '#1C5979',
        '#1C5A7A',
        '#184A65',
        '#164C65',
        '#0D3041',
        '#123142',
        '#123E54',
        '#1B5877',
        '#1A5574',
        '#1C5878',
        '#13435C',
        '#0F374B',
        '#0C3143',
        '#112F40',
        '#123C51',
        '#174E68',
        '#1D5C7D',
        '#14465F',
        '#0F3F56',
        '#0B3041',
        '#123243',
        '#15435B',
        '#19516D',
        '#1D5D7E',
        '#1C5C7D',
        '#184F69',
        '#11374B',
        '#103E54',
        '#0E3143',
        '#0F2D3C',
        '#11242E',
        '#133445',
        '#1A5674',
        '#1D6184',
        '#1F658B',
        '#0D3A50',
        '#0C374B',
        '#154862',
        '#164B64',
        '#154961',
        '#0D384D',
        '#102631',
        '#113242',
        '#134259',
        '#185270',
        '#1D6386',
        '#1E678C',
        '#1C5978',
        '#0D3549',
        '#0F2632',
        '#184961',
        '#1D5E80',
        '#1E6488',
        '#1F678D',
        '#1E5B7C',
        '#164862',
        '#19526D',
        '#113C52',
        '#15455E',
        '#0F2F3F',
        '#144259',
        '#194D67',
        '#1D6991',
        '#195777',
        '#19516C',
        '#103F56',
        '#144660',
        '#0D2E3E',
        '#10212A',
        '#113141',
        '#16455C',
        '#1D5B7C',
        '#1F6589',
        '#1E668C',
        '#1E5F81',
        '#0F3B50',
        '#0D3244',
        '#164A64',
        '#184E69',
        '#0E364A',
        '#0E2E3E',
        '#10222B',
        '#19475E',
        '#1B5A7B',
        '#1E5D7F',
        '#1E678D',
        '#1E6184',
        '#19506A',
        '#1B5370',
        '#1B5573',
        '#0E3041',
        '#122E3E',
        '#16455B',
        '#195370',
        '#1D6489',
        '#1D6B93',
        '#164A65',
        '#154A64',
        '#1A5572',
        '#1D6082',
        '#1F6286',
        '#1D6C94',
        '#1E709A',
        '#174A65',
        '#1B526F',
        '#1E6589',
        '#1D6384',
        '#0D3143',
        '#0E2F3F',
        '#174760',
        '#1F6487',
        '#1D668C',
        '#0D2F41',
        '#103B4F',
        '#1C5C7E',
        '#1F688F',
        '#1C5B7C',
        '#164D68',
        '#1D6285',
        '#0D364A',
        '#1D5A7A',
        '#1E6990',
        '#1D6488',
        '#18516B',
        '#1A506B',
        '#0E3B50',
        '#0E3548',
        '#124259',
        '#13455C',
        '#14485F',
        '#1E5C7D',
        '#122D3C',
        '#1E6E98',
        '#1E6A91',
        '#1E6286',
        '#1E6C95',
        '#1D6990',
        '#101F29',
        '#174A62',
        '#10394E',
        '#1D6D96',
        '#1E688E',
        '#1D6E97',
        '#1E6C94',
        '#0E394E',
        '#112B39',
        '#195270',
        '#1E668B',
        '#1E6386',
        '#1D6385',
        '#0C3142',
        '#1E6083',
        '#1E729C',
        '#1F709A',
        '#1E6F98',
        '#1D5F81',
        '#1F688D',
        '#1C6488',
        '#1D6588',
        '#1C6A93',
        '#1E658B',
        '#1F6C95',
        '#0D3C52',
        '#1C6385',
        '#1E5F82',
        '#0E3D54',
        '#0F3244',
        '#18485F',
        '#1E6991',
        '#1C5B7B',
        '#1F6082',
        '#0F3346',
        '#18536F',
        '#114056',
        '#1D6B92',
        '#1B5776',
        '#0F3C52',
        '#1E6890',
        '#1F688E',
        '#0C394E',
        '#0F1D25',
        '#1F6386',
        '#1E688D',
        '#1F6488',
        '#20668C',
        '#1D5978',
        '#0F3D52',
        '#0F1E26',
        '#13465F',
        '#0D374C',
        '#1B5C7C',
        '#0E1A23',
        '#0F374A',
        '#1B5574',
        '#0F394C',
        '#0E2A38',
        '#102A37',
        '#18506B',
        '#1E5A7A',
        '#0F3245',
        '#0E2E3F',
        '#1E678E',
        '#1C5D7E',
        '#1A5A7A',
        '#0E2837',
        '#102733',
        '#0F3B51',
        '#15475E',
        '#1E6B93',
        '#1E648A',
        '#194961',
        '#0F3A4E',
        '#0E1D25',
        '#194F69',
        '#103345',
        '#0F394D',
        '#102B39',
        '#103E55',
        '#1B5572',
        '#164861',
        '#174861',
        '#113B4F',
        '#102936',
        '#0F3041',
        '#174961',
        '#113E53',
        '#134056',
        '#124057',
        '#194B63',
        '#0E364B',
        '#15445B',
        '#16475E',
        '#102F3F',
        '#16485F',
        '#0F2E3D',
        '#101920',
        '#12222C',
        '#122C3B',
        '#144157',
        '#123B50',
        '#16465D',
        '#184960',
        '#112B3A',
        '#12232F',
        '#132430',
        '#113344',
        '#11394C',
        '#113649',
        '#11364A',
        '#133F56',
        '#121D25',
        '#112733',
        '#112A38',
        '#0F1F2A',
        '#113447',
        '#113A4E',
        '#0F222C',
        '#13222B',
        '#112836',
        '#102F3E',
        '#113243',
        '#123445',
        '#12374B',
        '#121E26',
        '#122531',
        '#11303F',
        '#0D1D25',
        '#102835',
        '#112834',
        '#101C23',
        '#111C23',
        '#12212B',
        '#11222D',
        '#0E1B22',
        '#0E1D27',
        '#121C22',
        '#12202A',
        '#101A20',
        '#13191E',
        '#111E28',
        '#11212D',
        '#0F1B24',
        '#0F1C23',
        '#13181D',
        '#15171A',
        '#121D23',
        '#121F27',
        '#111E27',
        '#101B22',
        '#121F28',
        '#111E26',
        '#101D24',
        '#111C22',
        '#12161E',
        '#101925',
        '#121E2D',
        '#112033',
        '#111E2F',
        '#0F1B29',
        '#0F1A28',
        '#101B2A',
        '#0E1A27',
        '#101C2B',
        '#111D2D',
        '#111D2B',
        '#0F1B28',
        '#101923',
        '#13161D',
        '#13161C',
        '#0F1A26',
        '#101E2F',
        '#112235',
        '#102031',
        '#0F1B2A',
        '#112031',
        '#102032',
        '#101D2E',
        '#121F2F',
        '#112133',
        '#101E30',
        '#101F30',
        '#102336',
        '#101B2C',
        '#0F1C2B',
        '#111E2E',
        '#0F2134',
        '#102236',
        '#0F2133',
        '#101F31',
        '#0F2438',
        '#102337',
        '#102235',
        '#102133',
        '#11171E',
        '#101F2F',
        '#102030',
        '#102234',
        '#102132',
        '#12181F',
        '#0F1A25',
        '#0F2135',
        '#0F1F30',
        '#0F1C2D',
        '#101D2C',
        '#0F2033',
        '#0E2338',
        '#0F2237',
        '#0F2236',
        '#0B243B',
        '#0D2338',
        '#0E1A26',
        '#0F1D2E',
        '#0F2032',
        '#0D2339',
        '#0B253F',
        '#0A253F',
        '#0A253E',
        '#0C2439',
        '#0E1925',
        '#0E2135',
        '#0F2235',
        '#0A243A',
        '#08253E',
        '#09253E',
        '#0A263F',
        '#0A243C',
        '#0B233B',
        '#0E1A28',
        '#0D1A26',
        '#09253F',
        '#0A2743',
        '#0B2844',
        '#0B2641',
        '#0A2744',
        '#0A2844',
        '#0B2743',
        '#092745',
        '#0F2337',
        '#101D2D',
        '#092743',
        '#092846',
        '#0E2B4C',
        '#102E4F',
        '#0E2C4D',
        '#0B2A49',
        '#082947',
        '#0D2B4B',
        '#0C2A4A',
        '#092946',
        '#082845',
        '#0C2B4B',
        '#0F2D4E',
        '#103051',
        '#133257',
        '#0E2D4E',
        '#143156',
        '#112F51',
        '#0B243A',
        '#082744',
        '#092844',
        '#123054',
        '#143359',
        '#173A64',
        '#183F6E',
        '#173F6D',
        '#153961',
        '#163962',
        '#133358',
        '#15345B',
        '#14345A',
        '#102F50',
        '#0A2948',
        '#082844',
        '#092641',
        '#16375F',
        '#193C69',
        '#174170',
        '#173E6B',
        '#163A63',
        '#173D69',
        '#183D6A',
        '#15365E',
        '#112E50',
        '#0A2A49',
        '#082743',
        '#0E1927',
        '#173C68',
        '#13487E',
        '#164476',
        '#174375',
        '#193F6F',
        '#173B66',
        '#163B65',
        '#082A48',
        '#0A2641',
        '#09243C',
        '#174171',
        '#14477C',
        '#124980',
        '#14487F',
        '#174374',
        '#15467B',
        '#184172',
        '#17406F',
        '#184070',
        '#163C67',
        '#16355D',
        '#123256',
        '#0E1B29',
        '#0F1923',
        '#113052',
        '#184274',
        '#164579',
        '#13477C',
        '#193E6D',
        '#0A243E',
        '#0B233A',
        '#0D1A29',
        '#0B2742',
        '#17365E',
        '#163860',
        '#124A84',
        '#095191',
        '#114A83',
        '#0D4D8A',
        '#0C4D8C',
        '#104B85',
        '#15477E',
        '#174477',
        '#183862',
        '#0A233A',
        '#092947',
        '#09243D',
        '#173963',
        '#194173',
        '#085396',
        '#085394',
        '#114B87',
        '#144983',
        '#094F8E',
        '#075090',
        '#0F4C89',
        '#215287',
        '#0E1A29',
        '#184376',
        '#0C4D8B',
        '#07549A',
        '#0A4E8D',
        '#0F4C88',
        '#0A4E8C',
        '#174273',
        '#193C6A',
        '#0B2948',
        '#0B2C4B',
        '#0C4E8D',
        '#1259A4',
        '#0C579E',
        '#0D4D8B',
        '#095397',
        '#085397',
        '#085295',
        '#144880',
        '#173861',
        '#15335A',
        '#0F2C4D',
        '#0C2949',
        '#0B4E8D',
        '#08559C',
        '#07508F',
        '#154578',
        '#17365F',
        '#122F53',
        '#111D2C',
        '#092A48',
        '#08559D',
        '#08559E',
        '#0C56A1',
        '#164271',
        '#163E6A',
        '#194071',
        '#082642',
        '#0F1E30',
        '#0D2D4D',
        '#114C87',
        '#0E59A3',
        '#135BA6',
        '#085498',
        '#085497',
        '#095192',
        '#0E4D8B',
        '#0C4E8A',
        '#134982',
        '#17457B',
        '#121F2E',
        '#183E6C',
        '#153E69',
        '#07508E',
        '#173F6C',
        '#193D6B',
        '#112D4F',
        '#0A243B',
        '#072946',
        '#111E2D',
        '#0B2740',
        '#10497F',
        '#17406E',
        '#084F8D',
        '#104A80',
        '#0E2E4F',
        '#143358',
        '#16365D',
        '#0A2742',
        '#13477B',
        '#154474',
        '#104C86',
        '#095291',
        '#0B4F8E',
        '#114A80',
        '#095090',
        '#075296',
        '#163760',
        '#2D6DB5',
        '#0C2843',
        '#0C233A',
        '#153A62',
        '#14467A',
        '#075498',
        '#085293',
        '#09263F',
        '#122030',
        '#09559D',
        '#0F4B83',
        '#08549A',
        '#14375D',
        '#085499',
        '#075499',
        '#0A243D',
        '#143E68',
        '#10497E',
        '#074F8E',
        '#085496',
        '#0C58A3',
        '#065499',
        '#085190',
        '#0A2B4A',
        '#104C88',
        '#0D4F8E',
        '#0F58A2',
        '#0B569B',
        '#0D58A1',
        '#134A81',
        '#09559C',
        '#0A5293',
        '#114B86',
        '#0D2C4C',
        '#103255',
        '#16457A',
        '#074F8C',
        '#07559C',
        '#185DA9',
        '#1D61AD',
        '#175CA8',
        '#16406D',
        '#153C65',
        '#0E243A',
        '#144679',
        '#085192',
        '#1A5EAC',
        '#1D61AE',
        '#11497F',
        '#12487E',
        '#0C243C',
        '#123155',
        '#0F59A3',
        '#1B5FAB',
        '#1E61AD',
        '#145CA4',
        '#0E599F',
        '#11497E',
        '#094F8D',
        '#15345A',
        '#134A85',
        '#165CA8',
        '#2263AF',
        '#124466',
        '#0A518F',
        '#08569D',
        '#16416F',
        '#0B2B4A',
        '#124A83',
        '#0C57A2',
        '#1E60AD',
        '#1E62AE',
        '#165DA8',
        '#1059A4',
        '#15406C',
        '#0A4F8E',
        '#12365A',
        '#0A5191',
        '#16355C',
        '#1C5EAB',
        '#155CA7',
        '#085292',
        '#174478',
        '#153258',
        '#111F2F',
        '#174272',
        '#1159A5',
        '#1C5EAC',
        '#2F74BB',
        '#0C58A2',
        '#0D59A3',
        '#14477D',
        '#132F53',
        '#155BA6',
        '#195FAA',
        '#2366B1',
        '#2967B2',
        '#14477E',
        '#1B5EAB',
        '#175DA8',
        '#0F4C86',
        '#065090',
        '#1C5FAC',
        '#185CA8',
        '#0D58A3',
        '#0C4E8C',
        '#134981',
        '#14416D',
        '#0F5AA5',
        '#1F63AF',
        '#114B88',
        '#09508E',
        '#0A569D',
        '#195DAA',
        '#0F1D2F',
        '#1059A2',
        '#0E599E',
        '#2063AF',
        '#1F63AE',
        '#1A5EAA',
        '#0C57A0',
        '#195EAA',
        '#1A5EA9',
        '#0E4E8A',
        '#12487D',
        '#185DAA',
        '#175EAA',
        '#0A508E',
        '#1559A6',
        '#0E58A3',
        '#095399',
        '#0B4E8B',
        '#0B569F',
        '#0C57A1',
        '#2967B1',
        '#2365B0',
        '#2163AE',
        '#1A5DAA',
        '#195EAB',
        '#1E5FAC',
        '#2564AF',
        '#2767B1',
        '#2766B1',
        '#0D5A9F',
        '#2062AE',
        '#1F61AD',
        '#195FAB',
        '#0D4E8D',
        '#173760',
        '#111D2E',
        '#09518F',
        '#1A5FAC',
        '#135BA7',
        '#085291',
        '#183761',
        '#0B2845',
        '#113457',
        '#075393',
        '#185EA9',
        '#2B69B3',
        '#2A67B2',
        '#2867B1',
        '#155DA8',
        '#135CA6',
        '#135AA5',
        '#114980',
        '#2566B1',
        '#2064AF',
        '#2364AF',
        '#13365B',
        '#154475',
        '#08549B',
        '#164373',
        '#085392',
        '#144576',
        '#12497E',
        '#0E5392',
        '#135BA3',
        '#0C5395',
        '#0C5291',
        '#0E579C',
        '#0E5290',
        '#134C83',
        '#2163AC',
        '#195CA6',
        '#0D4E8C',
        '#082945',
        '#133256',
        '#0E2F50',
        '#105AA6',
        '#134677',
        '#144475',
        '#145BA7',
        '#154270',
        '#1D60AD',
        '#09569B',
        '#09243E',
        '#134A86',
        '#0E59A4',
        '#0A4E8B',
        '#0E4B83',
        '#1D5EAC',
        '#101C2A',
        '#134A84',
        '#0E518F',
        '#145CA7',
        '#0E5699',
        '#145BA5',
        '#095292',
        '#15416E',
        '#153D67',
        '#153F6B',
        '#125AA5',
        '#16406E',
        '#0E1B27',
        '#0D4F8C',
        '#0F58A3',
        '#114A82',
        '#09569C',
        '#0C2339',
        '#0E1B28',
        '#0D59A4',
        '#07559D',
        '#08569E',
        '#095190',
        '#0B253E',
        '#0C2B49',
        '#2264AF',
        '#09549A',
        '#09569F',
        '#163D68',
        '#0C263F',
        '#143960',
        '#183A65',
        '#075496',
        '#0C579F',
        '#085191',
        '#102438',
        '#075295',
        '#082946',
        '#102437',
        '#0C2642',
        '#101C29',
        '#0C253E',
        '#15355C',
        '#0B2E4D',
        '#0F3253',
        '#154577',
        '#16335B',
        '#0F1925',
        '#0C2742',
        '#0B2946',
        '#0E2C4B',
        '#0E2B48',
        '#0E2237',
        '#102237',
        '#0B253D',
        '#0A2946',
        '#0C2841',
        '#0D2A47',
        '#0C2C4A',
        '#08253F',
        '#08243D',
        '#111C2B',
        '#0C2844',
        '#0C2945',
        '#0D243A',
        '#122134',
        '#0B2642',
        '#113154',
        '#113255',
        '#0A2642',
        '#0A2945',
        '#0B263F',
        '#0D2E4E',
        '#0F1E2E',
        '#0A2845',
        '#0D2439',
        '#0F1A29',
        '#101C2E',
        '#111923',
        '#13181F',
        '#111D2F',
        '#111F30',
        '#121E30',
        '#121E2E',
        '#101B27',
        '#101A27',
        '#13171F',
    ];
    // let randX = getRandomInt(0, x);
    // let randY = getRandomInt(0, y);
    // let randIndex = randY * xCount + randX;
    return colors[(y * xCount + x) % colors.length];
}


/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchResult; });
/* unused harmony export SearchResultSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_store__ = __webpack_require__(88);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var SearchResult = /** @class */ (function (_super) {
    __extends(SearchResult, _super);
    function SearchResult(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            search: __WEBPACK_IMPORTED_MODULE_3_app_stores_store__["b" /* store */].search,
        };
        __WEBPACK_IMPORTED_MODULE_3_app_stores_store__["b" /* store */].search.query();
        return _this;
    }
    SearchResult.prototype.render = function () {
        return this.state.search.sections.map(function (section) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchResultSection, { section: section, key: section.id });
        });
    };
    SearchResult = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], SearchResult);
    return SearchResult;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var SearchResultSection = /** @class */ (function (_super) {
    __extends(SearchResultSection, _super);
    function SearchResultSection(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleSection = function () {
            _this.props.section.toggle();
        };
        return _this;
    }
    SearchResultSection.prototype.renderItem = function (item) {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "search-item", href: item.url, key: item.id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "search-item__icon" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-th-large" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "search-item__body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "search-item__body-title" }, item.title))));
    };
    SearchResultSection.prototype.render = function () {
        var collapseClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
            fa: true,
            'fa-plus': !this.props.section.expanded,
            'fa-minus': this.props.section.expanded,
            'search-section__header__toggle': true,
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "search-section", key: this.props.section.id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "search-section__header" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('search-section__header__icon', this.props.section.icon) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "search-section__header__text" }, this.props.section.title),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: collapseClassNames, onClick: this.toggleSection })),
            this.props.section.expanded && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "search-section__items" }, this.props.section.items.map(this.renderItem)))));
    };
    SearchResultSection = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], SearchResultSection);
    return SearchResultSection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TagValue__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagOption__ = __webpack_require__(1026);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var TagFilter = /** @class */ (function (_super) {
    __extends(TagFilter, _super);
    function TagFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.searchTags = _this.searchTags.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onTagRemove = _this.onTagRemove.bind(_this);
        return _this;
    }
    TagFilter.prototype.searchTags = function (query) {
        return this.props.tagOptions().then(function (options) {
            var tags = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(options, function (tagOption) {
                return { value: tagOption.term, label: tagOption.term, count: tagOption.count };
            });
            return { options: tags };
        });
    };
    TagFilter.prototype.onChange = function (newTags) {
        this.props.onSelect(newTags);
    };
    TagFilter.prototype.onTagRemove = function (tag) {
        var newTags = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.without(this.props.tags, tag.label);
        newTags = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(newTags, function (tag) {
            return { value: tag };
        });
        this.props.onSelect(newTags);
    };
    TagFilter.prototype.render = function () {
        var selectOptions = {
            loadOptions: this.searchTags,
            onChange: this.onChange,
            value: this.props.tags,
            multi: true,
            className: 'gf-form-input gf-form-input--form-dropdown',
            placeholder: 'Tags',
            loadingPlaceholder: 'Loading...',
            noResultsText: 'No tags found',
            optionComponent: __WEBPACK_IMPORTED_MODULE_4__TagOption__["a" /* TagOption */],
        };
        selectOptions['valueComponent'] = __WEBPACK_IMPORTED_MODULE_3__TagValue__["a" /* TagValue */];
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "gf-form gf-form--has-input-icon gf-form--grow" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "tag-filter" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["Async"], __assign({}, selectOptions))),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i", { className: "gf-form-input-icon fa fa-tag" })));
    };
    return TagFilter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component));



/***/ }),
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TagBadge__ = __webpack_require__(406);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var TagValue = /** @class */ (function (_super) {
    __extends(TagValue, _super);
    function TagValue(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    TagValue.prototype.onClick = function (event) {
        this.props.onRemove(this.props.value, event);
    };
    TagValue.prototype.render = function () {
        var value = this.props.value;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TagBadge__["a" /* TagBadge */], { label: value.label, removeIcon: true, count: 0, onClick: this.onClick });
    };
    return TagValue;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TagBadge__ = __webpack_require__(406);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var TagOption = /** @class */ (function (_super) {
    __extends(TagOption, _super);
    function TagOption(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        return _this;
    }
    TagOption.prototype.handleMouseDown = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    };
    TagOption.prototype.handleMouseEnter = function (event) {
        this.props.onFocus(this.props.option, event);
    };
    TagOption.prototype.handleMouseMove = function (event) {
        if (this.props.isFocused) {
            return;
        }
        this.props.onFocus(this.props.option, event);
    };
    TagOption.prototype.render = function () {
        var _a = this.props, option = _a.option, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onMouseDown: this.handleMouseDown, onMouseEnter: this.handleMouseEnter, onMouseMove: this.handleMouseMove, title: option.title, className: "tag-filter-option btn btn-link " + (className || '') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TagBadge__["a" /* TagBadge */], { label: option.label, removeIcon: false, count: option.count, onClick: this.handleMouseDown })));
    };
    return TagOption;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_store__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_components_Permissions_Permissions__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_components_Tooltip_Tooltip__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_components_Permissions_PermissionsInfo__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_core_components_Permissions_AddPermissions__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_core_components_Animations_SlideDown__ = __webpack_require__(414);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var DashboardPermissions = /** @class */ (function (_super) {
    __extends(DashboardPermissions, _super);
    function DashboardPermissions(props) {
        var _this = _super.call(this, props) || this;
        _this.handleAddPermission = _this.handleAddPermission.bind(_this);
        _this.permissions = __WEBPACK_IMPORTED_MODULE_2_app_stores_store__["b" /* store */].permissions;
        return _this;
    }
    DashboardPermissions.prototype.handleAddPermission = function () {
        this.permissions.toggleAddPermissions();
    };
    DashboardPermissions.prototype.componentWillUnmount = function () {
        this.permissions.hideAddPermissions();
    };
    DashboardPermissions.prototype.render = function () {
        var _a = this.props, dashboardId = _a.dashboardId, folder = _a.folder, backendSrv = _a.backendSrv;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dashboard-settings__header" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-action-bar" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", { className: "d-inline-block" }, "Permissions"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_core_components_Tooltip_Tooltip__["a" /* default */], { className: "page-sub-heading-icon", placement: "auto", content: __WEBPACK_IMPORTED_MODULE_5_app_core_components_Permissions_PermissionsInfo__["a" /* default */] },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "gicon gicon-question gicon--has-hover" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-action-bar__spacer" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "btn btn-success pull-right", onClick: this.handleAddPermission, disabled: this.permissions.isAddPermissionsVisible },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus" }),
                        " Add Permission"))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_core_components_Animations_SlideDown__["a" /* default */], { in: this.permissions.isAddPermissionsVisible },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_core_components_Permissions_AddPermissions__["a" /* default */], { permissions: this.permissions, backendSrv: backendSrv })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_core_components_Permissions_Permissions__["a" /* default */], { permissions: this.permissions, isFolder: false, dashboardId: dashboardId, folderInfo: folder, backendSrv: backendSrv })));
    };
    DashboardPermissions = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DashboardPermissions);
    return DashboardPermissions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DashboardPermissions);


/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PermissionsListItem__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisabledPermissionsListItem__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(32);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var PermissionsList = /** @class */ (function (_super) {
    __extends(PermissionsList, _super);
    function PermissionsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PermissionsList.prototype.render = function () {
        var _a = this.props, permissions = _a.permissions, removeItem = _a.removeItem, permissionChanged = _a.permissionChanged, fetching = _a.fetching, folderInfo = _a.folderInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "filter-table gf-form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DisabledPermissionsListItem__["a" /* default */], { key: 0, item: {
                        name: 'Admin',
                        permission: 4,
                        icon: 'fa fa-fw fa-street-view',
                    } }),
                permissions.map(function (item, idx) {
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PermissionsListItem__["a" /* default */], { key: idx + 1, item: item, itemIndex: idx, removeItem: removeItem, permissionChanged: permissionChanged, folderInfo: folderInfo }));
                }),
                fetching === true && permissions.length < 1 ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { colSpan: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "Loading permissions...")))) : null,
                fetching === false && permissions.length < 1 ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { colSpan: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null, "No permissions are set. Will only be accessible by admins.")))) : null)));
    };
    PermissionsList = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], PermissionsList);
    return PermissionsList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PermissionsList);


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_components_Picker_DescriptionPicker__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_PermissionsStore_PermissionsStore__ = __webpack_require__(92);




var setClassNameHelper = function (inherited) {
    return inherited ? 'gf-form-disabled' : '';
};
function ItemAvatar(_a) {
    var item = _a.item;
    if (item.userAvatarUrl) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "filter-table__avatar", src: item.userAvatarUrl });
    }
    if (item.teamAvatarUrl) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "filter-table__avatar", src: item.teamAvatarUrl });
    }
    if (item.role === 'Editor') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { width: '25px', height: '25px' }, className: "gicon gicon-editor" });
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { width: '25px', height: '25px' }, className: "gicon gicon-viewer" });
}
function ItemDescription(_a) {
    var item = _a.item;
    if (item.userId) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "filter-table__weak-italic" }, "(User)");
    }
    if (item.teamId) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "filter-table__weak-italic" }, "(Team)");
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "filter-table__weak-italic" }, "(Role)");
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (_a) {
    var item = _a.item, removeItem = _a.removeItem, permissionChanged = _a.permissionChanged, itemIndex = _a.itemIndex, folderInfo = _a.folderInfo;
    var handleRemoveItem = function (evt) {
        evt.preventDefault();
        removeItem(itemIndex);
    };
    var handleChangePermission = function (permissionOption) {
        permissionChanged(itemIndex, permissionOption.value, permissionOption.label);
    };
    var inheritedFromRoot = item.dashboardId === -1 && !item.inherited;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { className: setClassNameHelper(item.inherited) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '1%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemAvatar, { item: item })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '90%' } },
            item.name,
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemDescription, { item: item })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
            item.inherited &&
                folderInfo && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", { className: "muted no-wrap" },
                "Inherited from folder",
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "text-link", href: folderInfo.url + "/permissions" }, folderInfo.title),
                ' ')),
            inheritedFromRoot && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", { className: "muted no-wrap" }, "Default Permission")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { className: "query-keyword" }, "Can"),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_core_components_Picker_DescriptionPicker__["a" /* default */], { optionsWithDesc: __WEBPACK_IMPORTED_MODULE_3_app_stores_PermissionsStore_PermissionsStore__["c" /* permissionOptions */], handlePicked: handleChangePermission, value: item.permission, disabled: item.inherited, className: 'gf-form-input--form-dropdown-right' }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null, !item.inherited ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "btn btn-danger btn-small", onClick: handleRemoveItem },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-remove" }))) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "btn btn-inverse btn-small" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lock" }))))));
}));


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var DescriptionOption = /** @class */ (function (_super) {
    __extends(DescriptionOption, _super);
    function DescriptionOption(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        return _this;
    }
    DescriptionOption.prototype.handleMouseDown = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    };
    DescriptionOption.prototype.handleMouseEnter = function (event) {
        this.props.onFocus(this.props.option, event);
    };
    DescriptionOption.prototype.handleMouseMove = function (event) {
        if (this.props.isFocused) {
            return;
        }
        this.props.onFocus(this.props.option, event);
    };
    DescriptionOption.prototype.render = function () {
        var _a = this.props, option = _a.option, children = _a.children, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onMouseDown: this.handleMouseDown, onMouseEnter: this.handleMouseEnter, onMouseMove: this.handleMouseMove, title: option.title, className: "description-picker-option__button btn btn-link " + className + " width-19" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" }, children),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "muted width-17" }, option.description),
                className.indexOf('is-selected') > -1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check", "aria-hidden": "true" }))));
    };
    return DescriptionOption;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DescriptionOption);


/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_components_Picker_DescriptionPicker__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_stores_PermissionsStore_PermissionsStore__ = __webpack_require__(92);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var DisabledPermissionListItem = /** @class */ (function (_super) {
    __extends(DisabledPermissionListItem, _super);
    function DisabledPermissionListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisabledPermissionListItem.prototype.render = function () {
        var item = this.props.item;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { className: "gf-form-disabled" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '1%' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { width: '25px', height: '25px' }, className: "gicon gicon-shield" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { width: '90%' } },
                item.name,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "filter-table__weak-italic" }, " (Role)")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { className: "query-keyword" }, "Can"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_core_components_Picker_DescriptionPicker__["a" /* default */], { optionsWithDesc: __WEBPACK_IMPORTED_MODULE_2_app_stores_PermissionsStore_PermissionsStore__["c" /* permissionOptions */], handlePicked: function () { }, value: item.permission, disabled: true, className: 'gf-form-input--form-dropdown-right' }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "btn btn-inverse btn-small" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lock" })))));
    };
    return DisabledPermissionListItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DisabledPermissionListItem);


/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_popper__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


function withTooltip(WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.setState = _this.setState.bind(_this);
            _this.state = {
                placement: _this.props.placement || 'auto',
                show: false,
            };
            return _this;
        }
        class_1.prototype.componentWillReceiveProps = function (nextProps) {
            if (nextProps.placement && nextProps.placement !== this.state.placement) {
                this.setState(function (prevState) {
                    return __assign({}, prevState, { placement: nextProps.placement });
                });
            }
        };
        class_1.prototype.renderContent = function (content) {
            if (typeof content === 'function') {
                // If it's a function we assume it's a React component
                var ReactComponent = content;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReactComponent, null);
            }
            return content;
        };
        class_1.prototype.render = function () {
            var _a = this.props, content = _a.content, className = _a.className;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Manager"], { className: "popper__manager " + (className || '') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, __assign({}, this.props, { tooltipSetState: this.setState })),
                this.state.show ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Popper"], { placement: this.state.placement, className: "popper" },
                    this.renderContent(content),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Arrow"], { className: "popper__arrow" }))) : null));
        };
        return class_1;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
}


/***/ }),
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PickerOption__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withPicker__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TeamPicker = /** @class */ (function (_super) {
    __extends(TeamPicker, _super);
    function TeamPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.search = _this.search.bind(_this);
        _this.debouncedSearch = Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["debounce"])(_this.search, 300, {
            leading: true,
            trailing: false,
        });
        return _this;
    }
    TeamPicker.prototype.search = function (query) {
        var _a = this.props, toggleLoading = _a.toggleLoading, backendSrv = _a.backendSrv;
        toggleLoading(true);
        return backendSrv.get("/api/teams/search?perpage=10&page=1&query=" + query).then(function (result) {
            var teams = result.teams.map(function (team) {
                return {
                    id: team.id,
                    label: team.name,
                    name: team.name,
                    avatarUrl: team.avatarUrl,
                };
            });
            toggleLoading(false);
            return { options: teams };
        });
    };
    TeamPicker.prototype.render = function () {
        var AsyncComponent = this.state.creatable ? __WEBPACK_IMPORTED_MODULE_1_react_select__["default"].AsyncCreatable : __WEBPACK_IMPORTED_MODULE_1_react_select__["default"].Async;
        var _a = this.props, isLoading = _a.isLoading, handlePicked = _a.handlePicked, value = _a.value, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "user-picker" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AsyncComponent, { valueKey: "id", multi: false, labelKey: "label", cache: false, isLoading: isLoading, loadOptions: this.debouncedSearch, loadingPlaceholder: "Loading...", noResultsText: "No teams found", onChange: handlePicked, className: "gf-form-input gf-form-input--form-dropdown " + (className || ''), optionComponent: __WEBPACK_IMPORTED_MODULE_2__PickerOption__["a" /* default */], placeholder: "Choose", value: value, autosize: true })));
    };
    return TeamPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__withPicker__["a" /* default */])(TeamPicker));


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchResultsCtrl */
/* unused harmony export searchResultsDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__ = __webpack_require__(17);



var SearchResultsCtrl = /** @class */ (function () {
    /** @ngInject */
    SearchResultsCtrl.$inject = ["$location"];
    function SearchResultsCtrl($location) {
        this.$location = $location;
    }
    SearchResultsCtrl.prototype.toggleFolderExpand = function (section) {
        var _this = this;
        if (section.toggle) {
            if (!section.expanded && this.onFolderExpanding) {
                this.onFolderExpanding();
            }
            section.toggle(section).then(function (f) {
                if (_this.editable && f.expanded) {
                    if (f.items) {
                        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(f.items, function (i) {
                            i.checked = f.checked;
                        });
                        if (_this.onSelectionChanged) {
                            _this.onSelectionChanged();
                        }
                    }
                }
            });
        }
    };
    SearchResultsCtrl.prototype.navigateToFolder = function (section, evt) {
        this.$location.path(section.url);
        if (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    };
    SearchResultsCtrl.prototype.toggleSelection = function (item, evt) {
        item.checked = !item.checked;
        if (item.items) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(item.items, function (i) {
                i.checked = item.checked;
            });
        }
        if (this.onSelectionChanged) {
            this.onSelectionChanged();
        }
        if (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    };
    SearchResultsCtrl.prototype.onItemClick = function (item) {
        if (this.$location.path().indexOf(item.url) > -1) {
            __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('hide-dash-search');
        }
    };
    SearchResultsCtrl.prototype.selectTag = function (tag, evt) {
        if (this.onTagSelected) {
            this.onTagSelected({ $tag: tag });
        }
        if (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    };
    return SearchResultsCtrl;
}());

function searchResultsDirective() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/search/search_results.html',
        controller: SearchResultsCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {
            editable: '@',
            results: '=',
            onSelectionChanged: '&',
            onTagSelected: '&',
            onFolderExpanding: '&',
        },
    };
}
__WEBPACK_IMPORTED_MODULE_1__core_module__["a" /* default */].directive('dashboardSearchResults', searchResultsDirective);


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ManageDashboardsCtrl */
/* unused harmony export manageDashboardsDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__ = __webpack_require__(17);



var Query = /** @class */ (function () {
    function Query() {
    }
    return Query;
}());
var ManageDashboardsCtrl = /** @class */ (function () {
    /** @ngInject */
    ManageDashboardsCtrl.$inject = ["backendSrv", "navModelSrv", "searchSrv", "contextSrv"];
    function ManageDashboardsCtrl(backendSrv, navModelSrv, searchSrv, contextSrv) {
        var _this = this;
        this.backendSrv = backendSrv;
        this.searchSrv = searchSrv;
        this.contextSrv = contextSrv;
        this.selectAllChecked = false;
        // enable/disable actions depending on the folders or dashboards selected
        this.canDelete = false;
        this.canMove = false;
        // filter variables
        this.hasFilters = false;
        this.starredFilterOptions = [{ text: 'Filter by Starred', disabled: true }, { text: 'Yes' }, { text: 'No' }];
        // if user can add new folders and/or add new dashboards
        this.canSave = false;
        this.isEditor = this.contextSrv.isEditor;
        this.query = {
            query: '',
            mode: 'tree',
            tag: [],
            starred: false,
            skipRecent: true,
            skipStarred: true,
            folderIds: [],
        };
        if (this.folderId) {
            this.query.folderIds = [this.folderId];
        }
        this.selectedStarredFilter = this.starredFilterOptions[0];
        this.refreshList().then(function () {
            _this.initTagFilter();
        });
    }
    ManageDashboardsCtrl.prototype.refreshList = function () {
        var _this = this;
        return this.searchSrv
            .search(this.query)
            .then(function (result) {
            return _this.initDashboardList(result);
        })
            .then(function () {
            if (!_this.folderUid) {
                return;
            }
            return _this.backendSrv.getFolderByUid(_this.folderUid).then(function (folder) {
                _this.canSave = folder.canSave;
            });
        });
    };
    ManageDashboardsCtrl.prototype.initDashboardList = function (result) {
        this.canMove = false;
        this.canDelete = false;
        this.selectAllChecked = false;
        this.hasFilters = this.query.query.length > 0 || this.query.tag.length > 0 || this.query.starred;
        if (!result) {
            this.sections = [];
            return;
        }
        this.sections = result;
        for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
            var section = _a[_i];
            section.checked = false;
            for (var _b = 0, _c = section.items; _b < _c.length; _b++) {
                var dashboard = _c[_b];
                dashboard.checked = false;
            }
        }
        if (this.folderId && this.sections.length > 0) {
            this.sections[0].hideHeader = true;
        }
    };
    ManageDashboardsCtrl.prototype.selectionChanged = function () {
        var selectedDashboards = 0;
        for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
            var section = _a[_i];
            selectedDashboards += __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(section.items, { checked: true }).length;
        }
        var selectedFolders = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.sections, { checked: true }).length;
        this.canMove = selectedDashboards > 0;
        this.canDelete = selectedDashboards > 0 || selectedFolders > 0;
    };
    ManageDashboardsCtrl.prototype.getFoldersAndDashboardsToDelete = function () {
        var selectedDashboards = {
            folders: [],
            dashboards: [],
        };
        for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
            var section = _a[_i];
            if (section.checked && section.id !== 0) {
                selectedDashboards.folders.push(section.uid);
            }
            else {
                var selected = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(section.items, { checked: true });
                (_b = selectedDashboards.dashboards).push.apply(_b, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(selected, 'uid'));
            }
        }
        return selectedDashboards;
        var _b;
    };
    ManageDashboardsCtrl.prototype.getFolderIds = function (sections) {
        var ids = [];
        for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
            var s = sections_1[_i];
            if (s.checked) {
                ids.push(s.id);
            }
        }
        return ids;
    };
    ManageDashboardsCtrl.prototype.delete = function () {
        var _this = this;
        var data = this.getFoldersAndDashboardsToDelete();
        var folderCount = data.folders.length;
        var dashCount = data.dashboards.length;
        var text = 'Do you want to delete the ';
        var text2;
        if (folderCount > 0 && dashCount > 0) {
            text += "selected folder" + (folderCount === 1 ? '' : 's') + " and dashboard" + (dashCount === 1 ? '' : 's') + "?";
            text2 = "All dashboards of the selected folder" + (folderCount === 1 ? '' : 's') + " will also be deleted";
        }
        else if (folderCount > 0) {
            text += "selected folder" + (folderCount === 1 ? '' : 's') + " and all its dashboards?";
        }
        else {
            text += "selected dashboard" + (dashCount === 1 ? '' : 's') + "?";
        }
        __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('confirm-modal', {
            title: 'Delete',
            text: text,
            text2: text2,
            icon: 'fa-trash',
            yesText: 'Delete',
            onConfirm: function () {
                _this.deleteFoldersAndDashboards(data.folders, data.dashboards);
            },
        });
    };
    ManageDashboardsCtrl.prototype.deleteFoldersAndDashboards = function (folderUids, dashboardUids) {
        var _this = this;
        this.backendSrv.deleteFoldersAndDashboards(folderUids, dashboardUids).then(function () {
            _this.refreshList();
        });
    };
    ManageDashboardsCtrl.prototype.getDashboardsToMove = function () {
        var selectedDashboards = [];
        for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
            var section = _a[_i];
            var selected = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(section.items, { checked: true });
            selectedDashboards.push.apply(selectedDashboards, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(selected, 'uid'));
        }
        return selectedDashboards;
    };
    ManageDashboardsCtrl.prototype.moveTo = function () {
        var selectedDashboards = this.getDashboardsToMove();
        var template = '<move-to-folder-modal dismiss="dismiss()" ' +
            'dashboards="model.dashboards" after-save="model.afterSave()">' +
            '</move-to-folder-modal>`';
        __WEBPACK_IMPORTED_MODULE_2_app_core_app_events__["a" /* default */].emit('show-modal', {
            templateHtml: template,
            modalClass: 'modal--narrow',
            model: {
                dashboards: selectedDashboards,
                afterSave: this.refreshList.bind(this),
            },
        });
    };
    ManageDashboardsCtrl.prototype.initTagFilter = function () {
        var _this = this;
        return this.searchSrv.getDashboardTags().then(function (results) {
            _this.tagFilterOptions = [{ term: 'Filter By Tag', disabled: true }].concat(results);
            _this.selectedTagFilter = _this.tagFilterOptions[0];
        });
    };
    ManageDashboardsCtrl.prototype.filterByTag = function (tag) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.indexOf(this.query.tag, tag) === -1) {
            this.query.tag.push(tag);
        }
        return this.refreshList();
    };
    ManageDashboardsCtrl.prototype.onQueryChange = function () {
        return this.refreshList();
    };
    ManageDashboardsCtrl.prototype.onTagFilterChange = function () {
        var res = this.filterByTag(this.selectedTagFilter.term);
        this.selectedTagFilter = this.tagFilterOptions[0];
        return res;
    };
    ManageDashboardsCtrl.prototype.removeTag = function (tag, evt) {
        this.query.tag = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.without(this.query.tag, tag);
        this.refreshList();
        if (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    };
    ManageDashboardsCtrl.prototype.removeStarred = function () {
        this.query.starred = false;
        return this.refreshList();
    };
    ManageDashboardsCtrl.prototype.onStarredFilterChange = function () {
        this.query.starred = this.selectedStarredFilter.text === 'Yes';
        this.selectedStarredFilter = this.starredFilterOptions[0];
        return this.refreshList();
    };
    ManageDashboardsCtrl.prototype.onSelectAllChanged = function () {
        var _this = this;
        for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
            var section = _a[_i];
            if (!section.hideHeader) {
                section.checked = this.selectAllChecked;
            }
            section.items = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(section.items, function (item) {
                item.checked = _this.selectAllChecked;
                return item;
            });
        }
        this.selectionChanged();
    };
    ManageDashboardsCtrl.prototype.clearFilters = function () {
        this.query.query = '';
        this.query.tag = [];
        this.query.starred = false;
        this.refreshList();
    };
    ManageDashboardsCtrl.prototype.createDashboardUrl = function () {
        var url = 'dashboard/new';
        if (this.folderId) {
            url += "?folderId=" + this.folderId;
        }
        return url;
    };
    return ManageDashboardsCtrl;
}());

function manageDashboardsDirective() {
    return {
        restrict: 'E',
        templateUrl: 'public/app/core/components/manage_dashboards/manage_dashboards.html',
        controller: ManageDashboardsCtrl,
        bindToController: true,
        controllerAs: 'ctrl',
        scope: {
            folderId: '=',
            folderUid: '=',
        },
    };
}
__WEBPACK_IMPORTED_MODULE_1_app_core_core_module__["a" /* default */].directive('manageDashboards', manageDashboardsDirective);


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ 
setupAngularRoutes.$inject = ["$routeProvider", "$locationProvider"];__webpack_exports__["a"] = setupAngularRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_loaders__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReactContainer__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_containers_ServerStats_ServerStats__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_containers_AlertRuleList_AlertRuleList__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_containers_ManageDashboards_FolderSettings__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_containers_ManageDashboards_FolderPermissions__ = __webpack_require__(1047);






/** @ngInject **/
function setupAngularRoutes($routeProvider, $locationProvider) {
    $locationProvider.html5Mode(true);
    $routeProvider
        .when('/', {
        templateUrl: 'public/app/partials/dashboard.html',
        controller: 'LoadDashboardCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/d/:uid/:slug', {
        templateUrl: 'public/app/partials/dashboard.html',
        controller: 'LoadDashboardCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/d/:uid', {
        templateUrl: 'public/app/partials/dashboard.html',
        controller: 'LoadDashboardCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/dashboard/:type/:slug', {
        templateUrl: 'public/app/partials/dashboard.html',
        controller: 'LoadDashboardCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/d-solo/:uid/:slug', {
        templateUrl: 'public/app/features/panel/partials/soloPanel.html',
        controller: 'SoloPanelCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/dashboard-solo/:type/:slug', {
        templateUrl: 'public/app/features/panel/partials/soloPanel.html',
        controller: 'SoloPanelCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/dashboard/new', {
        templateUrl: 'public/app/partials/dashboard.html',
        controller: 'NewDashboardCtrl',
        reloadOnSearch: false,
        pageClass: 'page-dashboard',
    })
        .when('/dashboard/import', {
        templateUrl: 'public/app/features/dashboard/partials/dashboard_import.html',
        controller: 'DashboardImportCtrl',
        controllerAs: 'ctrl',
    })
        .when('/datasources', {
        templateUrl: 'public/app/features/plugins/partials/ds_list.html',
        controller: 'DataSourcesCtrl',
        controllerAs: 'ctrl',
    })
        .when('/datasources/edit/:id', {
        templateUrl: 'public/app/features/plugins/partials/ds_edit.html',
        controller: 'DataSourceEditCtrl',
        controllerAs: 'ctrl',
    })
        .when('/datasources/edit/:id/dashboards', {
        templateUrl: 'public/app/features/plugins/partials/ds_dashboards.html',
        controller: 'DataSourceDashboardsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/datasources/new', {
        templateUrl: 'public/app/features/plugins/partials/ds_edit.html',
        controller: 'DataSourceEditCtrl',
        controllerAs: 'ctrl',
    })
        .when('/dashboards', {
        templateUrl: 'public/app/features/dashboard/partials/dashboard_list.html',
        controller: 'DashboardListCtrl',
        controllerAs: 'ctrl',
    })
        .when('/dashboards/folder/new', {
        templateUrl: 'public/app/features/dashboard/partials/create_folder.html',
        controller: 'CreateFolderCtrl',
        controllerAs: 'ctrl',
    })
        .when('/dashboards/f/:uid/:slug/permissions', {
        template: '<react-container />',
        resolve: {
            component: function () { return __WEBPACK_IMPORTED_MODULE_5_app_containers_ManageDashboards_FolderPermissions__["a" /* FolderPermissions */]; },
        },
    })
        .when('/dashboards/f/:uid/:slug/settings', {
        template: '<react-container />',
        resolve: {
            component: function () { return __WEBPACK_IMPORTED_MODULE_4_app_containers_ManageDashboards_FolderSettings__["a" /* FolderSettings */]; },
        },
    })
        .when('/dashboards/f/:uid/:slug', {
        templateUrl: 'public/app/features/dashboard/partials/folder_dashboards.html',
        controller: 'FolderDashboardsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/dashboards/f/:uid', {
        templateUrl: 'public/app/features/dashboard/partials/folder_dashboards.html',
        controller: 'FolderDashboardsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/org', {
        templateUrl: 'public/app/features/org/partials/orgDetails.html',
        controller: 'OrgDetailsCtrl',
    })
        .when('/org/new', {
        templateUrl: 'public/app/features/org/partials/newOrg.html',
        controller: 'NewOrgCtrl',
    })
        .when('/org/users', {
        templateUrl: 'public/app/features/org/partials/orgUsers.html',
        controller: 'OrgUsersCtrl',
        controllerAs: 'ctrl',
    })
        .when('/org/users/invite', {
        templateUrl: 'public/app/features/org/partials/invite.html',
        controller: 'UserInviteCtrl',
        controllerAs: 'ctrl',
    })
        .when('/org/apikeys', {
        templateUrl: 'public/app/features/org/partials/orgApiKeys.html',
        controller: 'OrgApiKeysCtrl',
    })
        .when('/org/teams', {
        templateUrl: 'public/app/features/org/partials/teams.html',
        controller: 'TeamsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/org/teams/new', {
        templateUrl: 'public/app/features/org/partials/create_team.html',
        controller: 'CreateTeamCtrl',
        controllerAs: 'ctrl',
    })
        .when('/org/teams/edit/:id', {
        templateUrl: 'public/app/features/org/partials/team_details.html',
        controller: 'TeamDetailsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/profile', {
        templateUrl: 'public/app/features/org/partials/profile.html',
        controller: 'ProfileCtrl',
        controllerAs: 'ctrl',
    })
        .when('/profile/password', {
        templateUrl: 'public/app/features/org/partials/change_password.html',
        controller: 'ChangePasswordCtrl',
    })
        .when('/profile/select-org', {
        templateUrl: 'public/app/features/org/partials/select_org.html',
        controller: 'SelectOrgCtrl',
    })
        .when('/admin', {
        templateUrl: 'public/app/features/admin/partials/admin_home.html',
        controller: 'AdminHomeCtrl',
        controllerAs: 'ctrl',
    })
        .when('/admin/settings', {
        templateUrl: 'public/app/features/admin/partials/settings.html',
        controller: 'AdminSettingsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/admin/users', {
        templateUrl: 'public/app/features/admin/partials/users.html',
        controller: 'AdminListUsersCtrl',
        controllerAs: 'ctrl',
    })
        .when('/admin/users/create', {
        templateUrl: 'public/app/features/admin/partials/new_user.html',
        controller: 'AdminEditUserCtrl',
    })
        .when('/admin/users/edit/:id', {
        templateUrl: 'public/app/features/admin/partials/edit_user.html',
        controller: 'AdminEditUserCtrl',
    })
        .when('/admin/orgs', {
        templateUrl: 'public/app/features/admin/partials/orgs.html',
        controller: 'AdminListOrgsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/admin/orgs/edit/:id', {
        templateUrl: 'public/app/features/admin/partials/edit_org.html',
        controller: 'AdminEditOrgCtrl',
        controllerAs: 'ctrl',
    })
        .when('/admin/stats', {
        template: '<react-container />',
        resolve: {
            component: function () { return __WEBPACK_IMPORTED_MODULE_2_app_containers_ServerStats_ServerStats__["a" /* ServerStats */]; },
        },
    })
        .when('/login', {
        templateUrl: 'public/app/partials/login.html',
        controller: 'LoginCtrl',
        pageClass: 'login-page sidemenu-hidden',
    })
        .when('/invite/:code', {
        templateUrl: 'public/app/partials/signup_invited.html',
        controller: 'InvitedCtrl',
        pageClass: 'sidemenu-hidden',
    })
        .when('/signup', {
        templateUrl: 'public/app/partials/signup_step2.html',
        controller: 'SignUpCtrl',
        pageClass: 'sidemenu-hidden',
    })
        .when('/user/password/send-reset-email', {
        templateUrl: 'public/app/partials/reset_password.html',
        controller: 'ResetPasswordCtrl',
        pageClass: 'sidemenu-hidden',
    })
        .when('/user/password/reset', {
        templateUrl: 'public/app/partials/reset_password.html',
        controller: 'ResetPasswordCtrl',
        pageClass: 'sidemenu-hidden',
    })
        .when('/dashboard/snapshots', {
        templateUrl: 'public/app/features/snapshot/partials/snapshots.html',
        controller: 'SnapshotsCtrl',
        controllerAs: 'ctrl',
    })
        .when('/plugins', {
        templateUrl: 'public/app/features/plugins/partials/plugin_list.html',
        controller: 'PluginListCtrl',
        controllerAs: 'ctrl',
    })
        .when('/plugins/:pluginId/edit', {
        templateUrl: 'public/app/features/plugins/partials/plugin_edit.html',
        controller: 'PluginEditCtrl',
        controllerAs: 'ctrl',
    })
        .when('/plugins/:pluginId/page/:slug', {
        templateUrl: 'public/app/features/plugins/partials/plugin_page.html',
        controller: 'AppPageCtrl',
        controllerAs: 'ctrl',
    })
        .when('/styleguide/:page?', {
        controller: 'StyleGuideCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'public/app/features/styleguide/styleguide.html',
    })
        .when('/alerting', {
        redirectTo: '/alerting/list',
    })
        .when('/alerting/list', {
        templateUrl: 'public/app/features/alerting/partials/alert_list.html',
        controller: 'AlertListCtrl',
        controllerAs: 'ctrl',
    })
        .when('/alerting/list', {
        template: '<react-container />',
        reloadOnSearch: false,
        resolve: {
            component: function () { return __WEBPACK_IMPORTED_MODULE_3_app_containers_AlertRuleList_AlertRuleList__["a" /* AlertRuleList */]; },
        },
    })
        .when('/alerting/notifications', {
        templateUrl: 'public/app/features/alerting/partials/notifications_list.html',
        controller: 'AlertNotificationsListCtrl',
        controllerAs: 'ctrl',
    })
        .when('/alerting/notification/new', {
        templateUrl: 'public/app/features/alerting/partials/notification_edit.html',
        controller: 'AlertNotificationEditCtrl',
        controllerAs: 'ctrl',
    })
        .when('/alerting/notification/:id/edit', {
        templateUrl: 'public/app/features/alerting/partials/notification_edit.html',
        controller: 'AlertNotificationEditCtrl',
        controllerAs: 'ctrl',
    })
        .otherwise({
        templateUrl: 'public/app/partials/error.html',
        controller: 'ErrorCtrl',
    });
}


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoadDashboardCtrl */
/* unused harmony export NewDashboardCtrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_core_utils_location_util__ = __webpack_require__(226);


var LoadDashboardCtrl = /** @class */ (function () {
    /** @ngInject */
    LoadDashboardCtrl.$inject = ["$scope", "$routeParams", "dashboardLoaderSrv", "backendSrv", "$location", "$browser"];
    function LoadDashboardCtrl($scope, $routeParams, dashboardLoaderSrv, backendSrv, $location, $browser) {
        $scope.appEvent('dashboard-fetch-start');
        if (!$routeParams.uid && !$routeParams.slug) {
            backendSrv.get('/api/dashboards/home').then(function (homeDash) {
                if (homeDash.redirectUri) {
                    $location.path(homeDash.redirectUri);
                }
                else {
                    var meta = homeDash.meta;
                    meta.canSave = meta.canShare = meta.canStar = false;
                    $scope.initDashboard(homeDash, $scope);
                }
            });
            return;
        }
        // if no uid, redirect to new route based on slug
        if (!($routeParams.type === 'script' || $routeParams.type === 'snapshot') && !$routeParams.uid) {
            backendSrv.getDashboardBySlug($routeParams.slug).then(function (res) {
                if (res) {
                    $location.path(__WEBPACK_IMPORTED_MODULE_1_app_core_utils_location_util__["a" /* default */].stripBaseFromUrl(res.meta.url)).replace();
                }
            });
            return;
        }
        dashboardLoaderSrv.loadDashboard($routeParams.type, $routeParams.slug, $routeParams.uid).then(function (result) {
            if (result.meta.url) {
                var url = __WEBPACK_IMPORTED_MODULE_1_app_core_utils_location_util__["a" /* default */].stripBaseFromUrl(result.meta.url);
                if (url !== $location.path()) {
                    $location.path(url).replace();
                }
            }
            if ($routeParams.keepRows) {
                result.meta.keepRows = true;
            }
            $scope.initDashboard(result, $scope);
        });
    }
    return LoadDashboardCtrl;
}());

var NewDashboardCtrl = /** @class */ (function () {
    /** @ngInject */
    NewDashboardCtrl.$inject = ["$scope", "$routeParams"];
    function NewDashboardCtrl($scope, $routeParams) {
        $scope.initDashboard({
            meta: {
                canStar: false,
                canShare: false,
                isNew: true,
                folderId: Number($routeParams.folderId),
            },
            dashboard: {
                title: 'New dashboard',
                panels: [
                    {
                        type: 'add-panel',
                        gridPos: { x: 0, y: 0, w: 12, h: 9 },
                        title: 'Panel Title',
                    },
                ],
            },
        }, $scope);
    }
    return NewDashboardCtrl;
}());

__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].controller('LoadDashboardCtrl', LoadDashboardCtrl);
__WEBPACK_IMPORTED_MODULE_0_app_core_core_module__["a" /* default */].controller('NewDashboardCtrl', NewDashboardCtrl);


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reactContainer */
/* harmony import */ 
reactContainer.$inject = ["$route", "$location", "backendSrv"];var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_core_module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_stores_store__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(32);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





function WrapInProvider(store, Component, props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["Provider"], __assign({}, store),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, __assign({}, props))));
}
/** @ngInject */
function reactContainer($route, $location, backendSrv) {
    return {
        restrict: 'E',
        template: '',
        link: function (scope, elem) {
            var component = $route.current.locals.component;
            var props = {
                backendSrv: backendSrv,
            };
            __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(WrapInProvider(__WEBPACK_IMPORTED_MODULE_3_app_stores_store__["b" /* store */], component, props), elem[0]);
            scope.$on('$destroy', function () {
                __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(elem[0]);
            });
        },
    };
}
__WEBPACK_IMPORTED_MODULE_2_app_core_core_module__["a" /* default */].directive('reactContainer', reactContainer);


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerStats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_core_components_PageHeader_PageHeader__ = __webpack_require__(93);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ServerStats = /** @class */ (function (_super) {
    __extends(ServerStats, _super);
    function ServerStats(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, nav = _a.nav, serverStats = _a.serverStats;
        nav.load('cfg', 'admin', 'server-stats');
        serverStats.load();
        return _this;
    }
    ServerStats.prototype.render = function () {
        var _a = this.props, nav = _a.nav, serverStats = _a.serverStats;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_core_components_PageHeader_PageHeader__["a" /* default */], { model: nav }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-container page-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "filter-table form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null, "Name"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null, "Value"))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, serverStats.stats.map(StatItem))))));
    };
    ServerStats = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('nav', 'serverStats'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ServerStats);
    return ServerStats;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

function StatItem(stat) {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { key: stat.name },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null, stat.name),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null, stat.value)));
}


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertRuleList; });
/* unused harmony export AlertRuleItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_components_PageHeader_PageHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_app_events__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_highlight_words__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_highlight_words___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_highlight_words__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var AlertRuleList = /** @class */ (function (_super) {
    __extends(AlertRuleList, _super);
    function AlertRuleList(props) {
        var _this = _super.call(this, props) || this;
        _this.stateFilters = [
            { text: 'All', value: 'all' },
            { text: 'OK', value: 'ok' },
            { text: 'Not OK', value: 'not_ok' },
            { text: 'Alerting', value: 'alerting' },
            { text: 'No Data', value: 'no_data' },
            { text: 'Paused', value: 'paused' },
        ];
        _this.onStateFilterChanged = function (evt) {
            _this.props.view.updateQuery({ state: evt.target.value });
            _this.fetchRules();
        };
        _this.onOpenHowTo = function () {
            __WEBPACK_IMPORTED_MODULE_4_app_core_app_events__["a" /* default */].emit('show-modal', {
                src: 'public/app/features/alerting/partials/alert_howto.html',
                modalClass: 'confirm-modal',
                model: {},
            });
        };
        _this.onSearchQueryChange = function (evt) {
            _this.props.alertList.setSearchQuery(evt.target.value);
        };
        _this.props.nav.load('alerting', 'alert-list');
        _this.fetchRules();
        return _this;
    }
    AlertRuleList.prototype.fetchRules = function () {
        this.props.alertList.loadRules({
            state: this.props.view.query.get('state') || 'all',
        });
    };
    AlertRuleList.prototype.render = function () {
        var _a = this.props, nav = _a.nav, alertList = _a.alertList;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_core_components_PageHeader_PageHeader__["a" /* default */], { model: nav }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-container page-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-action-bar" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form gf-form--grow" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "gf-form--has-input-icon gf-form--grow" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text", className: "gf-form-input", placeholder: "Search alerts", value: alertList.search, onChange: this.onSearchQueryChange }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "gf-form-input-icon fa fa-search" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "gf-form-label" }, "States"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form-select-wrapper width-13" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", { className: "gf-form-input", onChange: this.onStateFilterChanged, value: alertList.stateFilter }, this.stateFilters.map(AlertStateFilterOption)))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-action-bar__spacer" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "btn btn-secondary", onClick: this.onOpenHowTo },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-info-circle" }),
                        " How to add an alert")),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", { className: "alert-rule-list" }, alertList.filteredRules.map(function (rule) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AlertRuleItem, { rule: rule, key: rule.id, search: alertList.search })); }))))));
    };
    AlertRuleList = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('view', 'nav', 'alertList'),
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], AlertRuleList);
    return AlertRuleList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

function AlertStateFilterOption(_a) {
    var text = _a.text, value = _a.value;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: value, value: value }, text));
}
var AlertRuleItem = /** @class */ (function (_super) {
    __extends(AlertRuleItem, _super);
    function AlertRuleItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleState = function () {
            _this.props.rule.togglePaused();
        };
        return _this;
    }
    AlertRuleItem.prototype.renderText = function (text) {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_highlight_words___default.a, { highlightClassName: "highlight-search-match", textToHighlight: text, searchWords: [this.props.search] }));
    };
    AlertRuleItem.prototype.render = function () {
        var rule = this.props.rule;
        var stateClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
            fa: true,
            'fa-play': rule.isPaused,
            'fa-pause': !rule.isPaused,
        });
        var ruleUrl = rule.url + "?panelId=" + rule.panelId + "&fullscreen=true&edit=true&tab=alert";
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "alert-rule-item" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "alert-rule-item__icon " + rule.stateClass },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: rule.stateIcon })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "alert-rule-item__body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "alert-rule-item__header" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "alert-rule-item__name" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: ruleUrl }, this.renderText(rule.name))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "alert-rule-item__text" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "" + rule.stateClass }, this.renderText(rule.stateText)),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "alert-rule-item__time" },
                            " for ",
                            rule.stateAge))),
                rule.info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "small muted alert-rule-item__info" }, this.renderText(rule.info))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "alert-rule-item__actions" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "btn btn-small btn-inverse alert-list__btn width-2", title: "Pausing an alert rule prevents it from executing", onClick: this.toggleState },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: stateClass })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "btn btn-small btn-inverse alert-list__btn width-2", href: ruleUrl, title: "Edit alert rule" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-gf icon-gf-settings" })))));
    };
    AlertRuleItem = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], AlertRuleItem);
    return AlertRuleItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FolderSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_components_PageHeader_PageHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_state_tree__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__ = __webpack_require__(17);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var FolderSettings = /** @class */ (function (_super) {
    __extends(FolderSettings, _super);
    function FolderSettings(props) {
        var _this = _super.call(this, props) || this;
        _this.loadStore();
        return _this;
    }
    FolderSettings.prototype.loadStore = function () {
        var _this = this;
        var _a = this.props, nav = _a.nav, folder = _a.folder, view = _a.view;
        return folder.load(view.routeParams.get('uid')).then(function (res) {
            _this.formSnapshot = Object(__WEBPACK_IMPORTED_MODULE_4_mobx_state_tree__["getSnapshot"])(folder);
            view.updatePathAndQuery(res.url + "/settings", {}, {});
            return nav.initFolderNav(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(folder.folder), 'manage-folder-settings');
        });
    };
    FolderSettings.prototype.onTitleChange = function (evt) {
        this.props.folder.setTitle(this.getFormSnapshot().folder.title, evt.target.value);
    };
    FolderSettings.prototype.getFormSnapshot = function () {
        if (!this.formSnapshot) {
            this.formSnapshot = Object(__WEBPACK_IMPORTED_MODULE_4_mobx_state_tree__["getSnapshot"])(this.props.folder);
        }
        return this.formSnapshot;
    };
    FolderSettings.prototype.save = function (evt) {
        if (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
        var _a = this.props, nav = _a.nav, folder = _a.folder, view = _a.view;
        folder
            .saveFolder({ overwrite: false })
            .then(function (newUrl) {
            view.updatePathAndQuery(newUrl, {}, {});
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('dashboard-saved');
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('alert-success', ['Folder saved']);
        })
            .then(function () {
            return nav.initFolderNav(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(folder.folder), 'manage-folder-settings');
        })
            .catch(this.handleSaveFolderError.bind(this));
    };
    FolderSettings.prototype.delete = function (evt) {
        if (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
        var _a = this.props, folder = _a.folder, view = _a.view;
        var title = folder.folder.title;
        __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('confirm-modal', {
            title: 'Delete',
            text: "Do you want to delete this folder and all its dashboards?",
            icon: 'fa-trash',
            yesText: 'Delete',
            onConfirm: function () {
                return folder.deleteFolder().then(function () {
                    __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('alert-success', ['Folder Deleted', title + " has been deleted"]);
                    view.updatePathAndQuery('dashboards', '', '');
                });
            },
        });
    };
    FolderSettings.prototype.handleSaveFolderError = function (err) {
        if (err.data && err.data.status === 'version-mismatch') {
            err.isHandled = true;
            var _a = this.props, nav_1 = _a.nav, folder_1 = _a.folder, view_1 = _a.view;
            __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('confirm-modal', {
                title: 'Conflict',
                text: 'Someone else has updated this folder.',
                text2: 'Would you still like to save this folder?',
                yesText: 'Save & Overwrite',
                icon: 'fa-warning',
                onConfirm: function () {
                    folder_1
                        .saveFolder({ overwrite: true })
                        .then(function (newUrl) {
                        view_1.updatePathAndQuery(newUrl, {}, {});
                        __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('dashboard-saved');
                        __WEBPACK_IMPORTED_MODULE_5_app_core_app_events__["a" /* default */].emit('alert-success', ['Folder saved']);
                    })
                        .then(function () {
                        return nav_1.initFolderNav(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(folder_1.folder), 'manage-folder-settings');
                    });
                },
            });
        }
    };
    FolderSettings.prototype.render = function () {
        var _a = this.props, nav = _a.nav, folder = _a.folder;
        if (!folder.folder || !nav.main) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, "Loading");
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_core_components_PageHeader_PageHeader__["a" /* default */], { model: nav }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-container page-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "page-sub-heading" }, "Folder Settings"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "section gf-form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", { name: "folderSettingsForm", onSubmit: this.save.bind(this) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: "gf-form-label width-7" }, "Name"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text", className: "gf-form-input width-30", value: folder.folder.title, onChange: this.onTitleChange.bind(this) })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "gf-form-button-row" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "submit", className: "btn btn-success", disabled: !folder.folder.canSave || !folder.folder.hasChanged },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-save" }),
                                " Save"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "btn btn-danger", onClick: this.delete.bind(this), disabled: !folder.folder.canSave },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-trash" }),
                                " Delete")))))));
    };
    FolderSettings = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('nav', 'folder', 'view'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], FolderSettings);
    return FolderSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FolderPermissions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_core_components_PageHeader_PageHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_core_components_Permissions_Permissions__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_core_components_Tooltip_Tooltip__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_core_components_Permissions_PermissionsInfo__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_core_components_Permissions_AddPermissions__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_core_components_Animations_SlideDown__ = __webpack_require__(414);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var FolderPermissions = /** @class */ (function (_super) {
    __extends(FolderPermissions, _super);
    function FolderPermissions(props) {
        var _this = _super.call(this, props) || this;
        _this.handleAddPermission = _this.handleAddPermission.bind(_this);
        _this.loadStore();
        return _this;
    }
    FolderPermissions.prototype.componentWillUnmount = function () {
        var permissions = this.props.permissions;
        permissions.hideAddPermissions();
    };
    FolderPermissions.prototype.loadStore = function () {
        var _a = this.props, nav = _a.nav, folder = _a.folder, view = _a.view;
        return folder.load(view.routeParams.get('uid')).then(function (res) {
            view.updatePathAndQuery(res.url + "/permissions", {}, {});
            return nav.initFolderNav(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(folder.folder), 'manage-folder-permissions');
        });
    };
    FolderPermissions.prototype.handleAddPermission = function () {
        var permissions = this.props.permissions;
        permissions.toggleAddPermissions();
    };
    FolderPermissions.prototype.render = function () {
        var _a = this.props, nav = _a.nav, folder = _a.folder, permissions = _a.permissions, backendSrv = _a.backendSrv;
        if (!folder.folder || !nav.main) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, "Loading");
        }
        var dashboardId = folder.folder.id;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_core_components_PageHeader_PageHeader__["a" /* default */], { model: nav }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-container page-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-action-bar" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", { className: "d-inline-block" }, "Folder Permissions"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_core_components_Tooltip_Tooltip__["a" /* default */], { className: "page-sub-heading-icon", placement: "auto", content: __WEBPACK_IMPORTED_MODULE_6_app_core_components_Permissions_PermissionsInfo__["a" /* default */] },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "gicon gicon-question gicon--has-hover" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "page-action-bar__spacer" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "btn btn-success pull-right", onClick: this.handleAddPermission, disabled: permissions.isAddPermissionsVisible },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plus" }),
                        " Add Permission")),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_core_components_Animations_SlideDown__["a" /* default */], { in: permissions.isAddPermissionsVisible },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_core_components_Permissions_AddPermissions__["a" /* default */], { permissions: permissions, backendSrv: backendSrv })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_core_components_Permissions_Permissions__["a" /* default */], { permissions: permissions, isFolder: true, dashboardId: dashboardId, backendSrv: backendSrv }))));
    };
    FolderPermissions = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('nav', 'folder', 'view', 'permissions'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], FolderPermissions);
    return FolderPermissions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ })
],[532]);


// WEBPACK FOOTER //
// app.32d778fca11798dc12d7.js